
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("iFcSu", function(module, exports) {
$parcel$export(module.exports, "provideHealthcheck", () => $29f2fb3db4268e56$export$90dcee7ddb8a0c0c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $29f2fb3db4268e56$var$globalObj = window || $parcel$global;
const $29f2fb3db4268e56$var$defaultHealthcheck = (callback)=>callback({
        isSuccess: true
    });
const $29f2fb3db4268e56$export$90dcee7ddb8a0c0c = (healthcheck = $29f2fb3db4268e56$var$defaultHealthcheck)=>{
    $29f2fb3db4268e56$var$globalObj.performHealthcheck = healthcheck;
};

});

parcelRegister("1sMLb", function(module, exports) {
$parcel$export(module.exports, "default", () => $3393fd2c2482a1e4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $hOqkw = parcelRequire("hOqkw");

var $ebwYJ = parcelRequire("ebwYJ");
const $3393fd2c2482a1e4$var$globalInstall = {
    install: (args)=>{
        // @ts-expect-error - TS2322 - Type '{ flags?: boolean | undefined; navigation?: boolean | undefined; renderNavigation: (() => any) | (() => void); upflow?: boolean | undefined; heartbeat?: boolean | undefined; profileCardNextLegacy?: boolean | undefined; ... 4 more ...; searchDwellTimeComponent?: boolean | undefined; }' is not assignable to type 'GlobalArgs'.
        const argsWithDefaults = {
            renderNavigation: $ebwYJ.default,
            ...args
        };
        (0, $hOqkw.default).install(argsWithDefaults);
    }
};
var $3393fd2c2482a1e4$export$2e2bcd8739ae039 = $3393fd2c2482a1e4$var$globalInstall;

});
parcelRegister("hOqkw", function(module, exports) {
$parcel$export(module.exports, "default", () => $df530b87e84e2ad8$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $l28YB = parcelRequire("l28YB");

var $glqvt = parcelRequire("glqvt");

var $6bEm8 = parcelRequire("6bEm8");

var $l0Kxm = parcelRequire("l0Kxm");

var $qpL8u = parcelRequire("qpL8u");

const $df530b87e84e2ad8$var$renderEngagementMessages = ()=>{
    (parcelRequire("4oQaN"));
};

const $df530b87e84e2ad8$var$renderProfileCardNextLegacy = ()=>{
    (parcelRequire("dQ6mx"));
};

const $df530b87e84e2ad8$var$renderHeartbeat = ()=>{
    (parcelRequire("jNdkm"));
};

const $df530b87e84e2ad8$var$loadUpFlowAPI = ()=>(parcelRequire("e5Vme"));

const $df530b87e84e2ad8$var$installConnectModules = ()=>(parcelRequire("8yNAF"));
const $df530b87e84e2ad8$var$markSafeForAnalytics = (str)=>str || null;
const $df530b87e84e2ad8$var$renderSearchDwellTimeComponent = ()=>{
    const searchSessionId = (0, $6bEm8.default)('ajs-search-session-id');
    const containerId = (0, $6bEm8.default)('ajs-search-container-id');
    const objectId = (0, $6bEm8.default)('ajs-search-object-id');
    const objectType = (0, $6bEm8.default)('ajs-search-content-type');
    (0, $glqvt.default)([
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ]);
    (0, $qpL8u.default)('search-dwell-time', $df530b87e84e2ad8$var$markSafeForAnalytics(searchSessionId), {
        containerId: $df530b87e84e2ad8$var$markSafeForAnalytics(containerId),
        objectId: $df530b87e84e2ad8$var$markSafeForAnalytics(objectId),
        objectType: $df530b87e84e2ad8$var$markSafeForAnalytics(objectType),
        actionSubject: $df530b87e84e2ad8$var$markSafeForAnalytics(objectType),
        source: $df530b87e84e2ad8$var$markSafeForAnalytics(objectType)
    });
};
const $df530b87e84e2ad8$var$installHighPriorityApps = (args)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'JiraContextContainer'.
    const priorityApps = [];
    if (args.flags) priorityApps.push((0, $l0Kxm.renderFlags)());
    if (args.navigation) priorityApps.push(args.renderNavigation());
    return priorityApps;
};
const $df530b87e84e2ad8$var$installLowPriorityApps = (args)=>{
    if (args.upflow) $df530b87e84e2ad8$var$loadUpFlowAPI();
    if (args.profileCardNextLegacy) $df530b87e84e2ad8$var$renderProfileCardNextLegacy();
    if (args.connectModules) $df530b87e84e2ad8$var$installConnectModules();
    $df530b87e84e2ad8$var$renderEngagementMessages();
    if (args.heartbeat) $df530b87e84e2ad8$var$renderHeartbeat();
    if (args.searchDwellTimeComponent) $df530b87e84e2ad8$var$renderSearchDwellTimeComponent();
};
const $df530b87e84e2ad8$var$installAppsWithPriorityOrder = async (args)=>{
    await Promise.all($df530b87e84e2ad8$var$installHighPriorityApps({
        flags: args.flags,
        navigation: args.navigation,
        renderNavigation: args.renderNavigation
    }));
    $df530b87e84e2ad8$var$installLowPriorityApps((0, (/*@__PURE__*/$parcel$interopDefault($l28YB)))(args, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
};
const $df530b87e84e2ad8$var$defaultArgs = {
    flags: true,
    navigation: true,
    upflow: true,
    profileCardNextLegacy: true,
    heartbeat: true,
    connectModules: true,
    engagementMessages: true,
    searchDwellTimeComponent: true,
    renderNavigation: ()=>null
};
const $df530b87e84e2ad8$var$globalCore = {
    install: (args)=>{
        const argsWithDefaults = {
            ...$df530b87e84e2ad8$var$defaultArgs,
            ...args
        };
        // @ts-expect-error - TS2345 - Argument of type '{ flags: boolean; navigation: boolean; renderNavigation: (() => any) | (() => null); upflow: boolean; heartbeat: boolean; profileCardNextLegacy: boolean; connectModules: boolean; originTracing?: boolean | undefined; engagementMessages: boolean; searchDwellTimeComponent: boolean; }' is not assignable to parameter of type 'GlobalArgs'.
        $df530b87e84e2ad8$var$installAppsWithPriorityOrder(argsWithDefaults);
    },
    installHighPriorityApps: (args)=>{
        const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
            ...$df530b87e84e2ad8$var$defaultArgs,
            ...args
        };
        $df530b87e84e2ad8$var$installHighPriorityApps({
            flags: flags,
            navigation: navigation,
            renderNavigation: renderNavigation
        });
    },
    installLowPriorityApps: (args)=>{
        const installArgs = (0, (/*@__PURE__*/$parcel$interopDefault($l28YB)))({
            ...$df530b87e84e2ad8$var$defaultArgs,
            ...args
        }, [
            'flags',
            'navigation',
            'renderNavigation'
        ]);
        $df530b87e84e2ad8$var$installLowPriorityApps(installArgs);
    }
};
var $df530b87e84e2ad8$export$2e2bcd8739ae039 = $df530b87e84e2ad8$var$globalCore;

});
parcelRegister("glqvt", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ed1cd4fdaf1a867$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5BjZr = parcelRequire("5BjZr");

var $l28YB = parcelRequire("l28YB");
/**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */ const $7ed1cd4fdaf1a867$var$stripQueryParams = (paramsToStrip)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($5BjZr))).parse(window.location.href, true);
        const strippedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($l28YB)))(parsedUrl.query || {}, paramsToStrip);
        let strippedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($5BjZr))).format({
            ...parsedUrl,
            search: undefined,
            query: strippedQuery
        });
        // we don't want to encode : to %3A in connect project pages
        const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.search);
        if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.history.replaceState({}, '', strippedUrl);
    } catch (e) {
    /* uri might be malformed */ }
};
var $7ed1cd4fdaf1a867$export$2e2bcd8739ae039 = $7ed1cd4fdaf1a867$var$stripQueryParams;

});

parcelRegister("l0Kxm", function(module, exports) {
$parcel$export(module.exports, "renderFlags", () => $c095eb607bfa2ece$export$b6228dc14c5adf51);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $6CfY5 = parcelRequire("6CfY5");

var $j4o2W = parcelRequire("j4o2W");

var $bafqJ = parcelRequire("bafqJ");

var $b3oW6 = parcelRequire("b3oW6");

var $l8G1z = parcelRequire("l8G1z");
const $c095eb607bfa2ece$var$throwError = (message)=>{
    const error = new Error(message);
    (0, $6CfY5.default).safeErrorWithoutCustomerData('flags.entry', message, error);
    throw error;
};
const $c095eb607bfa2ece$var$getContainer = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let container = document.getElementById('flags');
    if (container == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        container = document.createElement('div');
        container.id = 'flags';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.appendChild(container);
        else $c095eb607bfa2ece$var$throwError('document.body was not found whilst trying to create the flags container');
    }
    return container;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c095eb607bfa2ece$var$Flags = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("gA1xy")), {
    ssr: false,
    moduleId: "./src/packages/platform/flag-app/src/main.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c095eb607bfa2ece$var$AfterPaintFlags = (0, $l8G1z.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("gA1xy")), {
    ssr: false,
    moduleId: "./src/packages/platform/flag-app/src/main.tsx"
});
const $c095eb607bfa2ece$export$b6228dc14c5adf51 = ()=>(0, $85XPu.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b3oW6.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j4o2W.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: "flags-entry"
    }, __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c095eb607bfa2ece$var$AfterPaintFlags, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c095eb607bfa2ece$var$Flags, null)))), $c095eb607bfa2ece$var$getContainer());

});
parcelRegister("j4o2W", function(module, exports) {
$parcel$export(module.exports, "JiraContextContainer", () => $4208828f37a11f38$export$6f7845cc5e693f16);
/* eslint-disable import/order */ 
var $euxye = parcelRequire("euxye");

var $978hs = parcelRequire("978hs");

var $8w5ez = parcelRequire("8w5ez");

var $lPmfV = parcelRequire("lPmfV");

var $6Tr1c = parcelRequire("6Tr1c");

var $6bEm8 = parcelRequire("6bEm8");

var $8ByCr = parcelRequire("8ByCr");

var $72IzE = parcelRequire("72IzE");

var $h3795 = parcelRequire("h3795");

var $aZMdt = parcelRequire("aZMdt");

var $55cpN = parcelRequire("55cpN");

var $6zTYs = parcelRequire("6zTYs");

var $eijVy = parcelRequire("eijVy");

var $ixtp6 = parcelRequire("ixtp6");
const $4208828f37a11f38$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        attributes: (0, $h3795.routeAnalyticsAttributes)
    }, children);
$4208828f37a11f38$var$ContextualAnalyticsDataFeatureFlagged.displayName = "ContextualAnalyticsDataFeatureFlagged";

const $4208828f37a11f38$export$6f7845cc5e693f16 = (props)=>{
    const state = {
        // oxlint-disable typescript/no-var-requires
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        messages: (parcelRequire("cK8QE"))
    };
    const { data: orgId } = (0, $6zTYs.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($4208828f37a11f38$var$ContextualAnalyticsDataFeatureFlagged, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eijVy.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $6bEm8.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eijVy.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8ByCr.IntlProvider), {
            messages: state.messages,
            locale: (0, $978hs.standardizeLocale)(tenantContext.locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8w5ez.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lPmfV.default), {
            orgId: orgId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Tr1c.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $55cpN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $72IzE.ModalContextProvider), null, props.children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ixtp6.LoadingPhaseManager), null));
};
$4208828f37a11f38$export$6f7845cc5e693f16.displayName = "JiraContextContainer";

});
parcelRegister("6Tr1c", function(module, exports) {
$parcel$export(module.exports, "ExperienceTrackerProvider", () => $ad1e06b40f93cef7$export$6f49c95a810d59fa);

var $euxye = parcelRequire("euxye");

var $6Zzi4 = parcelRequire("6Zzi4");
var $3QaCr = parcelRequire("3QaCr");

var $hqy3Z = parcelRequire("hqy3Z");
// eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
const $ad1e06b40f93cef7$var$useUnmount = (callback)=>(0, $euxye.useEffect)(()=>callback, [
        callback
    ]);
const $ad1e06b40f93cef7$export$6f49c95a810d59fa = ({ children: children })=>{
    const [experienceTracker] = (0, $euxye.useState)(new (0, $6Zzi4.ExperienceTracker)());
    const [cleanupSliSub] = (0, $euxye.useState)(()=>experienceTracker.subscribe((0, $hqy3Z.sliSubscriber)));
    const cleanup = (0, $euxye.useCallback)(()=>{
        cleanupSliSub();
    }, [
        cleanupSliSub
    ]);
    $ad1e06b40f93cef7$var$useUnmount(cleanup);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3QaCr.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, children);
};
$ad1e06b40f93cef7$export$6f49c95a810d59fa.displayName = "ExperienceTrackerProvider";

});
parcelRegister("hqy3Z", function(module, exports) {
$parcel$export(module.exports, "sliSubscriber", () => $1ed18236d30324f4$export$db0b99fe17114899);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");

var $hJL79 = parcelRequire("hJL79");

var $6Kdw4 = parcelRequire("6Kdw4");

const $1ed18236d30324f4$var$transformApplication = (application)=>{
    switch(application){
        case 0, $hJL79.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $hJL79.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $hJL79.JIRA_CORE:
            return 'jira-core';
        case 0, $hJL79.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $hJL79.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $1ed18236d30324f4$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $d8LhJ.FREE_EDITION:
            return 'jedi';
        case 0, $d8LhJ.STANDARD_EDITION:
            return 'standard';
        case 0, $d8LhJ.PREMIUM_EDITION:
            return 'premium';
        case 0, $d8LhJ.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $1ed18236d30324f4$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: action,
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            // any attribute on top of this is overridable by any tracker
            task: experience,
            reason: location,
            analyticsSource: analyticsSource,
            application: $1ed18236d30324f4$var$transformApplication(application),
            edition: $1ed18236d30324f4$var$transformEdition(edition),
            ...errorMessage && {
                errorMessage: errorMessage
            }
        }
    });
const $1ed18236d30324f4$var$reportSli = (experienceDescription)=>{
    (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $1ed18236d30324f4$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
const $1ed18236d30324f4$export$db0b99fe17114899 = (event)=>{
    const { name: name, action: action } = event;
    // @ts-expect-error - TS2339 - Property 'disableSli' does not exist on type '{}'. | TS2339 - Property 'analyticsSource' does not exist on type '{}'. | TS2339 - Property 'application' does not exist on type '{}'. | TS2339 - Property 'edition' does not exist on type '{}'. | TS2339 - Property 'location' does not exist on type '{}'.
    const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
    if (disableSli) return;
    switch(action){
        case 0, $a196702bd494009a$export$627ef4c1ed2d7a9a:
            $1ed18236d30324f4$var$reportSli({
                experience: name,
                action: (0, $a196702bd494009a$export$627ef4c1ed2d7a9a),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $a196702bd494009a$export$b48b3d1872522384:
            $1ed18236d30324f4$var$reportSli({
                experience: name,
                action: (0, $a196702bd494009a$export$b48b3d1872522384),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                ...event.error && {
                    errorMessage: String(event.error)
                },
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $a196702bd494009a$export$aeeb00d0845d24d8:
            $1ed18236d30324f4$var$reportSli({
                experience: name,
                action: (0, $a196702bd494009a$export$aeeb00d0845d24d8),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                additionalAttributes: additionalAttributes
            });
            break;
        default:
    }
};

});
/* eslint-disable jira/filename-case */ const $a196702bd494009a$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $a196702bd494009a$export$b48b3d1872522384 = 'taskFail';
const $a196702bd494009a$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("8ByCr", function(module, exports) {
$parcel$export(module.exports, "IntlProvider", () => $fbab5fb96bc4669e$export$480518999dfc4151);
// eslint-disable-next-line jira/filename-case, jira/restricted/react-component-props

var $euxye = parcelRequire("euxye");

var $5KKyn = parcelRequire("5KKyn");
const $fbab5fb96bc4669e$export$480518999dfc4151 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5KKyn.default), {
        ...props,
        defaultLocale: props.locale
    }, children);
$fbab5fb96bc4669e$export$480518999dfc4151.displayName = "IntlProvider";

});

parcelRegister("72IzE", function(module, exports) {
$parcel$export(module.exports, "ModalContextProvider", () => $08a56e03c9af09f7$export$7c9538f5f3c365e9);

var $euxye = parcelRequire("euxye");

var $9imxF = parcelRequire("9imxF");

var $b5Dgx = parcelRequire("b5Dgx");
const $08a56e03c9af09f7$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $euxye.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $euxye.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
$08a56e03c9af09f7$var$RenderModal.displayName = "RenderModal";
function $08a56e03c9af09f7$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $euxye.useRef)(1);
    const [modals, setModals] = (0, $euxye.useState)([]);
    const modalContext = (0, $euxye.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b5Dgx.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9imxF.default), null, modals.map((modal)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($08a56e03c9af09f7$var$RenderModal, {
            key: modal.key,
            modal: modal
        });
    })));
}
$08a56e03c9af09f7$export$7c9538f5f3c365e9.displayName = "ModalContextProvider";

});
parcelRegister("b5Dgx", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $be587d49087fe790$export$ab57792b9b6974a6);

var $euxye = parcelRequire("euxye");
const $be587d49087fe790$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $euxye.createContext)({
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openModal: ()=>{}
});

});


parcelRegister("h3795", function(module, exports) {
$parcel$export(module.exports, "routeAnalyticsAttributes", () => $43b26033de7d45c9$export$c71778b3a4356b04);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $41zzZ = parcelRequire("41zzZ");

var $lpBPi = parcelRequire("lpBPi");

var $kGsgY = parcelRequire("kGsgY");
const $43b26033de7d45c9$export$c71778b3a4356b04 = Object.defineProperties({}, {
    routeName: {
        enumerable: true,
        get: (0, $41zzZ.getRouteName)
    },
    userLocation: {
        enumerable: true,
        get: (0, $41zzZ.getUserLocation)
    },
    previousSubProduct: {
        enumerable: true,
        get: (0, $41zzZ.getPreviousSubProduct)
    },
    isProjectAdmin: {
        enumerable: true,
        get: (0, $lpBPi.getIsProjectAdmin)
    },
    bifrostGroup: {
        enumerable: true,
        get: (0, $41zzZ.getBifrostGroup)
    },
    ufoName: {
        enumerable: true,
        get: (0, $41zzZ.getUfoName)
    },
    isIframe: {
        enumerable: true,
        get: (0, $kGsgY.getIsIframe)
    }
});

});
parcelRegister("lpBPi", function(module, exports) {
$parcel$export(module.exports, "getIsProjectAdmin", () => $32b051f0f25deea4$export$34ff06260ad17f2b);
$parcel$export(module.exports, "setIsProjectAdmin", () => $32b051f0f25deea4$export$d53e6d79d3fa5f31);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ let $32b051f0f25deea4$var$projectAdmin = null;
const $32b051f0f25deea4$export$34ff06260ad17f2b = ()=>{
    // Initialised as null, this likely means we aren't in a
    // project route and the listener hasn't been rendered
    if ($32b051f0f25deea4$var$projectAdmin == null || !$32b051f0f25deea4$var$projectAdmin.loading && $32b051f0f25deea4$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
    if ($32b051f0f25deea4$var$projectAdmin.loading === true) return 'LOADING';
    return Boolean($32b051f0f25deea4$var$projectAdmin.isProjectAdmin);
};
const $32b051f0f25deea4$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
    $32b051f0f25deea4$var$projectAdmin = projectAdminState;
};

});

parcelRegister("kGsgY", function(module, exports) {
$parcel$export(module.exports, "getIsIframe", () => $8400342778f55869$export$fc717e37ed2e7b6e);
const $8400342778f55869$export$fc717e37ed2e7b6e = ()=>{
    try {
        return typeof window !== 'undefined' && window.self !== window.top;
    } catch (e) {
        // Accessing window.top can throw a SecurityError in cross‑origin cases
        return true; // If we can't access top, we *are* in an iframe
    }
};

});


parcelRegister("55cpN", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1d03da419c09832$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useJiraRelayEnvironmentProvider", () => $c1d03da419c09832$export$83fb48644dee72f0);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $n67Vb = parcelRequire("n67Vb");

var $aI7em = parcelRequire("aI7em");
function $c1d03da419c09832$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $n67Vb.RelayEnvironmentProvider), {
        environment: (0, $aI7em.default)()
    }, children);
}
$c1d03da419c09832$export$2e2bcd8739ae039.displayName = "JiraRelayEnvironmentProvider";
function $c1d03da419c09832$export$83fb48644dee72f0() {
    const environment = (0, $n67Vb.useRelayEnvironment)();
    return (0, $euxye.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("aI7em", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e88d98d95dc8978$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2CHGS = parcelRequire("2CHGS");

var $67QWT = parcelRequire("67QWT");

var $edGGR = parcelRequire("edGGR");
const $2e88d98d95dc8978$var$sharedRelayEnvironmentConfig = {
    log: (0, $67QWT.default),
    relayFieldLogger: (0, $67QWT.requiredFieldLogger),
    networkOptions: (0, $2CHGS.getNetworkOptions)()
};
const $2e88d98d95dc8978$var$platformRelayEnvironment = (0, $edGGR.createRelayEnvironment)($2e88d98d95dc8978$var$sharedRelayEnvironmentConfig);
function $2e88d98d95dc8978$var$getPlatformRelayEnvironment() {
    return $2e88d98d95dc8978$var$platformRelayEnvironment;
}
var $2e88d98d95dc8978$export$2e2bcd8739ae039 = $2e88d98d95dc8978$var$getPlatformRelayEnvironment;

});
parcelRegister("2CHGS", function(module, exports) {
$parcel$export(module.exports, "getNetworkOptions", () => $b1656aadbf408383$export$6e239ba29de50840);

var $75sVW = parcelRequire("75sVW");

var $h2wCv = parcelRequire("h2wCv");

var $jVTHL = parcelRequire("jVTHL");

var $lMoch = parcelRequire("lMoch");

var $eaO9F = parcelRequire("eaO9F");

var $8yIUg = parcelRequire("8yIUg");

var $gXtG2 = parcelRequire("gXtG2");

var $5ToWk = parcelRequire("5ToWk");

var $1p9Al = parcelRequire("1p9Al");

var $cGqKz = parcelRequire("cGqKz");
function $b1656aadbf408383$var$validateResponse(request, response) {
    const errors = 'errors' in response ? response.errors : undefined;
    if (errors != null) {
        const requestId = response?.extensions?.gateway?.request_id;
        if (!(0, $cGqKz.blocklist).includes(request.name)) (0, $1p9Al.getLoggingAndMetricsHelper)({
            queryName: request.name,
            operationKind: request.operationKind
        }).logNonBreakingErrors(errors, requestId);
        // @ts-expect-error -- AGGError.path has a type of `string[]`, whereas PayloadError.path has a type of `(string | number)[]`
        (0, $lMoch.captureErrors)(errors, {
            operationName: request.name,
            requestId: requestId
        });
        // @ts-expect-error -- AGGError.path has a type of `string[]`, whereas PayloadError.path has a type of `(string | number)[]`
        if ((0, $lMoch.isUnauthenticated)(errors)) return false;
    }
    return true;
}
function $b1656aadbf408383$var$onInvalidResponse(request, _response) {
    //  Short circuit operation and handle the unauthorized errors.
    (0, $5ToWk.showUnauthenticatedFlag)(request.name);
}
/**
 * @deprecated Use getHeaders instead.
 */ function $b1656aadbf408383$var$setOptions({ endpoint: endpoint, options: options }) {
    return (0, $cGqKz.generateOptions)(options, endpoint);
}
function $b1656aadbf408383$var$getHeaders({ endpoint: endpoint, options: options }) {
    const generatedOptions = (0, $cGqKz.generateOptions)(options, endpoint);
    return generatedOptions.headers || {};
}
function $b1656aadbf408383$var$didPreflightAuthenticationCheckTriggerRedirect(_request, _variables, _cacheConfig) {
    // `checkAuthentication` returns true when Jira is already redirecting or when it detects an
    // unauthenticated user and starts the login redirect. Relay-fetch uses that true result to skip
    // the network request and leave the observable pending while navigation takes over.
    return (0, $cGqKz.checkAuthentication)();
}
const $b1656aadbf408383$var$earlyScriptPromise = (request, variables)=>!false && (0, $8yIUg.claimEarlyScriptPromise)((0, $8yIUg.getEarlyScriptPromiseKey)(request, variables)) || undefined;
const $b1656aadbf408383$var$handleAbort = (request, reason)=>{
    // We didn't receive everything!
    const err = new (0, $75sVW.default)(424, `Incomplete handover for relay fetch: ${reason}`);
    err.name = 'ServerToClientError';
    (0, $1p9Al.getLoggingAndMetricsHelper)({
        queryName: request.name,
        operationKind: request.operationKind
    }).logError(err);
};
let $b1656aadbf408383$var$abortSignal = null;
const $b1656aadbf408383$export$18207bd33202e4f6 = (newAbortSignal)=>{
    $b1656aadbf408383$var$abortSignal = newAbortSignal;
};
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $b1656aadbf408383$var$abortSignal = null;
});
const $b1656aadbf408383$export$6e239ba29de50840 = ()=>({
        withErrorHandling: $h2wCv.withErrorHandling,
        getLoggingAndMetricsHelper: $1p9Al.getLoggingAndMetricsHelper,
        setEndpoint: (0, $jVTHL.getReroutableURL),
        didPreflightAuthenticationCheckTriggerRedirect: $b1656aadbf408383$var$didPreflightAuthenticationCheckTriggerRedirect,
        validateResponse: $b1656aadbf408383$var$validateResponse,
        onInvalidResponse: $b1656aadbf408383$var$onInvalidResponse,
        setOptions: // @deprecated Use getHeaders instead
        $b1656aadbf408383$var$setOptions,
        getHeaders: $b1656aadbf408383$var$getHeaders,
        earlyScriptPromise: $b1656aadbf408383$var$earlyScriptPromise,
        handleAbort: $b1656aadbf408383$var$handleAbort,
        queryResponseCache: (0, $eaO9F.getQueryResponseCache)(),
        getAbortSignal: ()=>$b1656aadbf408383$var$abortSignal,
        isServer: false
    });

});
parcelRegister("h2wCv", function(module, exports) {
$parcel$export(module.exports, "transformValidationErrorFromServer", () => $e4328c75419adf57$export$8e9baed7697e4959);
$parcel$export(module.exports, "withErrorHandling", () => $e4328c75419adf57$export$c874c20f7c9f97c);
$parcel$export(module.exports, "performGetRequest", () => $e4328c75419adf57$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $e4328c75419adf57$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $e4328c75419adf57$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $e4328c75419adf57$export$8ef51cba9d28f819);
$parcel$export(module.exports, "performPatchRequest", () => $e4328c75419adf57$export$52be6ab13d7e758d);
$parcel$export(module.exports, "performGetRequestWithRetry", () => $e4328c75419adf57$export$659b5ee69e6eb976);
$parcel$export(module.exports, "performPutRequestWithRetry", () => $e4328c75419adf57$export$d7b48b2904a5d812);
$parcel$export(module.exports, "performPostRequestWithRetry", () => $e4328c75419adf57$export$a5717cbee13f28b7);
$parcel$export(module.exports, "performDeleteRequestWithRetry", () => $e4328c75419adf57$export$6d01bf1146815b9b);
$parcel$export(module.exports, "performPatchRequestWithRetry", () => $e4328c75419adf57$export$560989ee94ad2a20);
/* eslint-disable jira/filename-case */ // Stryker disable all


var $k11SN = parcelRequire("k11SN");

var $atcQv = parcelRequire("atcQv");

var $ff8AH = parcelRequire("ff8AH");

var $75sVW = parcelRequire("75sVW");

var $jVTHL = parcelRequire("jVTHL");

var $5cVSt = parcelRequire("5cVSt");

var $xhPWB = parcelRequire("xhPWB");
/**
 * Transform object with field errors from JIRA to an array of FieldValidationErrors
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e4328c75419adf57$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
            field: field,
            error: fieldErrors[field]
        }));
const $e4328c75419adf57$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
    const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
    const fieldErrorsJson = json.errors ?? json.fieldErrors;
    const fieldErrors = fieldErrorsJson ? $e4328c75419adf57$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
    return new (0, $75sVW.ValidationError)(message, fieldErrors, statusCode, traceId, json);
};
const $e4328c75419adf57$var$putOptions = {
    ...(0, $ff8AH.defaultOptions),
    method: 'PUT'
};
const $e4328c75419adf57$var$postOptions = {
    ...(0, $ff8AH.defaultOptions),
    method: 'POST'
};
const $e4328c75419adf57$var$deleteOptions = {
    ...(0, $ff8AH.defaultOptions),
    method: 'DELETE'
};
const $e4328c75419adf57$var$patchOptions = {
    ...(0, $ff8AH.defaultOptions),
    method: 'PATCH'
};
function $e4328c75419adf57$export$c874c20f7c9f97c(source) {
    return source.then($e4328c75419adf57$export$1e36de371b2e3d5a).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
}
const $e4328c75419adf57$export$b47ad9bdf9122b88 = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
const $e4328c75419adf57$export$1e36de371b2e3d5a = (response)=>{
    const traceId = (0, $xhPWB.getTraceId)(response);
    // CONTENT_TOO_LARGE errorMessage is used for Hard Limits and, we don't want to override the error message
    if ((0, $8f860a533cc71fca$export$9de493bcd9b1d977) === response.status || (0, $8f860a533cc71fca$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
        throw $e4328c75419adf57$export$8e9baed7697e4959(errorContent, response.status, traceId);
    });
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) throw new (0, $75sVW.default)(response.status, `Error server response: ${response.status}`, traceId, response);
        else throw new (0, $75sVW.default)(response.status, `Error server response: ${response.status}`, undefined, response);
    }
    return response;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e4328c75419adf57$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $8f860a533cc71fca$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $e4328c75419adf57$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($e4328c75419adf57$export$1e36de371b2e3d5a).then($e4328c75419adf57$var$processResponseFromServer).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
const $e4328c75419adf57$export$22411cbfb09a5c5c = (url, options)=>{
    const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
    const executeRequest = ()=>$e4328c75419adf57$export$e174dc943a170ff(fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, requestOptions)));
    if ((0, $k11SN.default)('platform_fetch_retries')) return executeRequest();
    return (0, $atcQv.retryOnError)(executeRequest, {
        retryFunc: executeRequest,
        retryPredicate: retryPredicate,
        retryAttempts: retryAttempts,
        onRetry: onRetry
    });
};
const $e4328c75419adf57$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, {
        ...(0, $ff8AH.defaultOptions),
        ...options
    })).then($e4328c75419adf57$export$1e36de371b2e3d5a).then($e4328c75419adf57$var$processResponseFromServer).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
const $e4328c75419adf57$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, {
        ...$e4328c75419adf57$var$putOptions,
        ...options
    })).then($e4328c75419adf57$export$1e36de371b2e3d5a).then($e4328c75419adf57$var$processResponseFromServer).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
const $e4328c75419adf57$export$692a4d9808143175 = (url, options = {})=>fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, {
        ...$e4328c75419adf57$var$postOptions,
        ...options
    })).then($e4328c75419adf57$export$1e36de371b2e3d5a).then($e4328c75419adf57$var$processResponseFromServer).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
const $e4328c75419adf57$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, {
        ...$e4328c75419adf57$var$deleteOptions,
        ...options
    })).then($e4328c75419adf57$export$1e36de371b2e3d5a).then($e4328c75419adf57$var$processResponseFromServer).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
const $e4328c75419adf57$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, {
        ...$e4328c75419adf57$var$patchOptions,
        ...options
    })).then($e4328c75419adf57$export$1e36de371b2e3d5a).then($e4328c75419adf57$var$processResponseFromServer).catch($e4328c75419adf57$export$b47ad9bdf9122b88);
const $e4328c75419adf57$export$659b5ee69e6eb976 = (url, options)=>$e4328c75419adf57$export$22411cbfb09a5c5c(url, {
        ...(0, $ff8AH.defaultOptions),
        ...options
    });
const $e4328c75419adf57$export$d7b48b2904a5d812 = (url, options)=>$e4328c75419adf57$export$22411cbfb09a5c5c(url, {
        ...$e4328c75419adf57$var$putOptions,
        ...options
    });
const $e4328c75419adf57$export$a5717cbee13f28b7 = (url, options)=>$e4328c75419adf57$export$22411cbfb09a5c5c(url, {
        ...$e4328c75419adf57$var$postOptions,
        ...options
    });
const $e4328c75419adf57$export$6d01bf1146815b9b = (url, options)=>$e4328c75419adf57$export$22411cbfb09a5c5c(url, {
        ...$e4328c75419adf57$var$deleteOptions,
        ...options
    });
const $e4328c75419adf57$export$560989ee94ad2a20 = (url, options)=>$e4328c75419adf57$export$22411cbfb09a5c5c(url, {
        ...$e4328c75419adf57$var$patchOptions,
        ...options
    }); /* eslint-enable @typescript-eslint/no-unnecessary-type-constraint */ 

});
/* eslint-disable jira/filename-case */ const $8f860a533cc71fca$export$ff39ebd4bb12b718 = 201;
const $8f860a533cc71fca$export$3288b14b6745c572 = 204;
const $8f860a533cc71fca$export$9de493bcd9b1d977 = 400;
const $8f860a533cc71fca$export$67d19e9a991baa07 = 401;
const $8f860a533cc71fca$export$a3269a3914b007e3 = 403;
const $8f860a533cc71fca$export$8bca792d963eb0ef = 404;
const $8f860a533cc71fca$export$4a3cb39801694eee = 407;
const $8f860a533cc71fca$export$fa405bbf47d510e2 = 408;
const $8f860a533cc71fca$export$c09e7ea0fc79f34f = 409;
const $8f860a533cc71fca$export$5244030134e99 = 412;
const $8f860a533cc71fca$export$f90ac1df0b60853d = 413;
const $8f860a533cc71fca$export$a447d0a965e16776 = 422;
const $8f860a533cc71fca$export$3b48aba8957000cd = 426;
const $8f860a533cc71fca$export$6763168a631449a2 = 429;
const $8f860a533cc71fca$export$e813cd7045fcc98d = 500;
const $8f860a533cc71fca$export$2ce38d41a306034e = 502;
const $8f860a533cc71fca$export$974c37534b0191b1 = 503;
const $8f860a533cc71fca$export$5400e8dddac3fcf3 = 504;

parcelRegister("jVTHL", function(module, exports) {
$parcel$export(module.exports, "getReroutableURL", () => $4a7a8e9de9f4b016$export$23769875e8eebaf6);
/* eslint-disable jira/filename-case */ 
var $8BCi4 = parcelRequire("8BCi4");

var $dJ3NQ = parcelRequire("dJ3NQ");
function $4a7a8e9de9f4b016$export$23769875e8eebaf6(pathOrURL) {
    // For local development environment only, otherwise removed during the bundling process
    if (false ? (0, $dJ3NQ.default)() : false) try {
        const localUrl = new URL((0, $8BCi4.getLocalUrl)());
        const u = new URL(pathOrURL, localUrl.href);
        u.host = localUrl.host;
        u.protocol = localUrl.protocol;
        return u.href;
    } catch (e) {
        // When the URL constructor has `base` set, and `pathOrUrl` is always a string,
        // no string can trigger this catch block.
        // Just in case, log the error to help with debugging.
        // eslint-disable-next-line no-console
        console.error('Failed to parse URL: ', pathOrURL, e);
    }
    return pathOrURL;
}

});
parcelRegister("8BCi4", function(module, exports) {
$parcel$export(module.exports, "getLocalUrl", () => $47790d2a63d67da2$export$e049a61beee18f8c);
/* eslint-disable jira/filename-case */ 
var $4g6Ut = parcelRequire("4g6Ut");

var $fA7uA = parcelRequire("fA7uA");

var $7Il9x = parcelRequire("7Il9x");

var $aFXYr = parcelRequire("aFXYr");
/**
 * Get the hostname for the Pillar development server.
 *
 * In the always-on RDE, it will have a proper DNS name. In local development, it
 * will default to `localhost`.
 *
 * @returns The hostname for the development server.
 */ function $47790d2a63d67da2$var$getDevHostname() {
    const envDns = false ? (0, $fA7uA.default)() : undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
}
function $47790d2a63d67da2$var$getProxyServerPort() {
    const serverPort = false ? (0, $4g6Ut.default)() : undefined;
    return serverPort ? parseInt(serverPort, 10) : 9000;
}
function $47790d2a63d67da2$export$e049a61beee18f8c() {
    if (false) {
        const overridden = (0, $aFXYr.default)();
        return overridden ?? `${(0, $7Il9x.default)() ? 'https' : 'http'}://${$47790d2a63d67da2$var$getDevHostname()}:${$47790d2a63d67da2$var$getProxyServerPort()}`;
    }
    return `${'http'}://${$47790d2a63d67da2$var$getDevHostname()}:${$47790d2a63d67da2$var$getProxyServerPort()}`;
}

});
parcelRegister("4g6Ut", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd40f3f086af816a$export$2e2bcd8739ae039);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - process.env types are cursed
const $dd40f3f086af816a$var$proxyServerPort = undefined;
function $dd40f3f086af816a$export$2e2bcd8739ae039() {
    return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    globalThis.localDevContext?.__PILLAR_PROXY_SERVER_PORT ?? $dd40f3f086af816a$var$proxyServerPort);
}

});

parcelRegister("fA7uA", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae9a4f923335faba$export$2e2bcd8739ae039);
function $ae9a4f923335faba$export$2e2bcd8739ae039() {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return globalThis.localDevContext?.RDE_DNS;
}

});

parcelRegister("aFXYr", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6863d638a96e4b7$export$2e2bcd8739ae039);
function $e6863d638a96e4b7$export$2e2bcd8739ae039() {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return globalThis.localDevContext?.LOCAL_URL_OVERRIDE;
}

});



parcelRegister("xhPWB", function(module, exports) {
$parcel$export(module.exports, "getTraceId", () => $d14322710f49cbc9$export$e88cb5bfb57ce9c4);
$parcel$export(module.exports, "getTraceIdJq", () => $d14322710f49cbc9$export$b569b31eebca952d);
/* eslint-disable jira/filename-case */ 
var $hnaxl = parcelRequire("hnaxl");
const $d14322710f49cbc9$export$e88cb5bfb57ce9c4 = (response)=>{
    const traceIdHeader = (0, $hnaxl.KNOWN_TRACE_ID_HEADERS).find((header)=>response.headers.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
const $d14322710f49cbc9$export$b569b31eebca952d = (jqxhr)=>{
    if (!jqxhr || !jqxhr.getResponseHeader) // prefer a silent fail, so we don't accidentally swallow the original error being built
    return undefined;
    const traceIdHeader = (0, $hnaxl.KNOWN_TRACE_ID_HEADERS).find((header)=>jqxhr.getResponseHeader(header) != null);
    return traceIdHeader === undefined ? undefined : jqxhr.getResponseHeader(traceIdHeader);
};

});
parcelRegister("hnaxl", function(module, exports) {
$parcel$export(module.exports, "TRACE_ID_HEADER", () => $aaa0bbd80c4e5899$export$4b69438fb7c7b9b2);
$parcel$export(module.exports, "KNOWN_TRACE_ID_HEADERS", () => $aaa0bbd80c4e5899$export$830a89e935012abe);
/* eslint-disable jira/filename-case */ const $aaa0bbd80c4e5899$export$4b69438fb7c7b9b2 = 'atl-traceid';
const $aaa0bbd80c4e5899$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $aaa0bbd80c4e5899$export$830a89e935012abe = [
    $aaa0bbd80c4e5899$export$4b69438fb7c7b9b2,
    $aaa0bbd80c4e5899$var$TRACE_ID_HEADER_MICROS
];

});



parcelRegister("lMoch", function(module, exports) {
$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $26acccd61b6ebb30$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $26acccd61b6ebb30$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $26acccd61b6ebb30$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $26acccd61b6ebb30$export$1724ecfee73c4768);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Utility methods to capture GraphQl errors and expose them to the frontend for reporting.
 * ```
 * Sample usage:
 * const id = startErrorCapture();
 * ...
 * const errors = stopErrorCapture(id);
 * ```
 */ 
var $7TA2J = parcelRequire("7TA2J");

var $gXtG2 = parcelRequire("gXtG2");
const $26acccd61b6ebb30$var$errorCollector = new Map();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $26acccd61b6ebb30$var$errorCollector.clear();
});
const $26acccd61b6ebb30$export$da396ad2a542b095 = 120000; // 2min
const $26acccd61b6ebb30$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $26acccd61b6ebb30$var$errorCollector.delete(key);
    }, $26acccd61b6ebb30$export$da396ad2a542b095);
};
const $26acccd61b6ebb30$export$c211170518c6d0f6 = (key = (0, $7TA2J.v4)())=>{
    $26acccd61b6ebb30$var$errorCollector.set(key, []);
    $26acccd61b6ebb30$var$scheduleCleanup(key);
    return key;
};
const $26acccd61b6ebb30$export$e0491a0d974dadfa = (key)=>{
    const errors = $26acccd61b6ebb30$var$errorCollector.get(key);
    $26acccd61b6ebb30$var$errorCollector.delete(key);
    return errors || [];
};
const $26acccd61b6ebb30$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $26acccd61b6ebb30$var$errorCollector.forEach((value, key)=>{
        $26acccd61b6ebb30$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $26acccd61b6ebb30$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("eaO9F", function(module, exports) {
$parcel$export(module.exports, "getQueryResponseCache", () => $17b7348dd2090005$export$3233e692a93c0cfd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $srxic = parcelRequire("srxic");

var $cY22M = parcelRequire("cY22M");

var $emCaV = parcelRequire("emCaV");

var $lIGkE = parcelRequire("lIGkE");

var $6CfY5 = parcelRequire("6CfY5");

var $75sVW = parcelRequire("75sVW");

var $icLG0 = parcelRequire("icLG0");
function $17b7348dd2090005$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $lIGkE.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $17b7348dd2090005$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
const $17b7348dd2090005$export$da2711d74cd28aed = [
    'doFetchWithGraphQLErrorsTrackingQuery'
];
class $17b7348dd2090005$export$be21c283b097d175 extends (0, $lIGkE.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!false) setTimeout(()=>{
            this.logUnusedPayloadErrors();
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    logUnusedPayloadErrors() {
        const loggedQueries = new Set();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'. | TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
        this._responses.forEach((_response, key)=>{
            const queryID = $17b7348dd2090005$export$1e65e863cf3a0f21(key);
            const metadata = this.requestMetadata.get(queryID);
            const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                queryName: 'unknown',
                operationKind: 'unknown'
            };
            if (!loggedQueries.has(queryName) && !$17b7348dd2090005$export$da2711d74cd28aed.includes(queryName)) {
                loggedQueries.add(queryName);
                const error = new (0, $icLG0.UnusedRelayResponseError)(queryID);
                const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $75sVW.default) ? 'network' : 'unknown';
                // Log any errors even in SSR
                (0, $6CfY5.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                    message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($srxic)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
                        'name'
                    ], null)
                });
            }
        });
    }
    /**
	 * @deprecated only sets a single response; does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Stores a GraphQLRepsonse along with metadata about the call.
	 * If called multiple times (such as when incremental payloads are received),
	 * will update the stored response to be an array of GraphQLSingularResponse objects,
	 * which Relay is happy to handle.
	 * @deprecated works, but does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
	 */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $17b7348dd2090005$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
$17b7348dd2090005$export$be21c283b097d175.displayName = "SSRQueryResponseCache";
const $17b7348dd2090005$export$3233e692a93c0cfd = (0, $emCaV.default)(()=>{
    return new $17b7348dd2090005$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    });
});
const $17b7348dd2090005$export$94e535e06b7ade61 = ()=>$17b7348dd2090005$export$3233e692a93c0cfd().serialize();

});
parcelRegister("icLG0", function(module, exports) {
$parcel$export(module.exports, "UnusedRelayResponseError", () => $b9250ea1829886a6$export$8431e42d062de453);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ class $b9250ea1829886a6$export$8431e42d062de453 extends Error {
    constructor(queryID){
        super(`Relay Query ${queryID} was made during SSR but never used in the browser`), this.name = 'UnusedRelayResponseError';
    }
}
$b9250ea1829886a6$export$8431e42d062de453.displayName = "UnusedRelayResponseError";

});


parcelRegister("8yIUg", function(module, exports) {
$parcel$export(module.exports, "EarlyScriptQueryPromisesMap", () => $5ebbaf7b8ee8ccbd$export$6d670d323806bb37);
$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $5ebbaf7b8ee8ccbd$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $5ebbaf7b8ee8ccbd$export$828ac0325bce4536);
$parcel$export(module.exports, "putEarlyScriptPromise", () => $5ebbaf7b8ee8ccbd$export$e1336d32be02faf4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $5ebbaf7b8ee8ccbd$export$b5fbc1430cbfd6e1 = (value)=>value;
const $5ebbaf7b8ee8ccbd$export$6d670d323806bb37 = new Map();
const $5ebbaf7b8ee8ccbd$export$1102c06c7da91223 = (params, variables)=>{
    if (params.name === 'mainIssueAggQuery') return `${params.name}|${params.id}|${variables?.cloudId}|${variables?.issueKey}`;
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $5ebbaf7b8ee8ccbd$export$828ac0325bce4536 = (key)=>{
    const result = $5ebbaf7b8ee8ccbd$export$6d670d323806bb37.get(key);
    if (result != null) $5ebbaf7b8ee8ccbd$export$6d670d323806bb37.delete(key);
    return result;
};
const $5ebbaf7b8ee8ccbd$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$5ebbaf7b8ee8ccbd$export$6d670d323806bb37.has(key)) $5ebbaf7b8ee8ccbd$export$6d670d323806bb37.set(key, promise);
};

});

parcelRegister("5ToWk", function(module, exports) {
$parcel$export(module.exports, "showUnauthenticatedFlag", () => $c118599c7904f5bf$export$758fcc357484571e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $iQPOZ = parcelRequire("iQPOZ");

var $6Kdw4 = parcelRequire("6Kdw4");

var $7eNDO = parcelRequire("7eNDO");
const $c118599c7904f5bf$var$title = (0, $7eNDO.defineMessage)({
    id: "relay-fetch.services.error-flags.title",
    defaultMessage: "Something's gone wrong"
});
const $c118599c7904f5bf$var$description = (0, $7eNDO.defineMessage)({
    id: "relay-fetch.services.error-flags.description",
    defaultMessage: "Looks like you've been signed out. Try logging in again. "
});
const $c118599c7904f5bf$var$login = (0, $7eNDO.defineMessage)({
    id: "relay-fetch.services.error-flags.login",
    defaultMessage: "Log in"
});
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $c118599c7904f5bf$var$reloadPage = ()=>window.location.reload();
const $c118599c7904f5bf$var$sendAnalyticEvent = (operationName)=>{
    (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'showed',
            actionSubject: 'unauthorizedFlag',
            attributes: {
                operation: operationName
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $c118599c7904f5bf$var$sendLoginClickEvent = (operationName)=>{
    (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'loginButton',
            attributes: {
                operation: operationName,
                source: globalThis.window?.location?.pathname ?? '',
                referrer: globalThis.document?.referrer ?? '',
                timestamp: new Date().toISOString(),
                userAgent: globalThis.navigator?.userAgent ?? ''
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $c118599c7904f5bf$export$758fcc357484571e = (operationName)=>{
    (0, $iQPOZ.showFlag)({
        type: 'error',
        title: $c118599c7904f5bf$var$title,
        description: $c118599c7904f5bf$var$description,
        // eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
        messageId: 'relay-fetch.services.error-flags.show-flag.error.show-unauthenticated-flag',
        messageType: 'transactional',
        actions: [
            {
                content: $c118599c7904f5bf$var$login,
                onClick: ()=>{
                    $c118599c7904f5bf$var$sendLoginClickEvent(operationName);
                    $c118599c7904f5bf$var$reloadPage();
                }
            }
        ]
    });
    $c118599c7904f5bf$var$sendAnalyticEvent(operationName);
};

});
parcelRegister("iQPOZ", function(module, exports) {
$parcel$export(module.exports, "showFlag", () => $c715a3c03f6bb33e$export$e12b2cc6b75b006b);
$parcel$export(module.exports, "dismissFlag", () => $c715a3c03f6bb33e$export$900a08a292ad23cd);
$parcel$export(module.exports, "flagService", () => $c715a3c03f6bb33e$export$dbb055af53fd81a0);
$parcel$export(module.exports, "useFlagsService", () => $c715a3c03f6bb33e$export$eee61a1aafe3884);
$parcel$export(module.exports, "useFlagService", () => $c715a3c03f6bb33e$export$dc4f8132c3090b32);
$parcel$export(module.exports, "isDismissFlag", () => $c715a3c03f6bb33e$export$14b1864d9cf0809f);
$parcel$export(module.exports, "isFlagComponent", () => $c715a3c03f6bb33e$export$d84ce5adcee46025);
$parcel$export(module.exports, "isBatchAction", () => $c715a3c03f6bb33e$export$c126d8b307b8ab86);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d7Utd = parcelRequire("d7Utd");

var $iIEGg = parcelRequire("iIEGg");

var $cSP6q = parcelRequire("cSP6q");

var $acwzf = parcelRequire("acwzf");
const $c715a3c03f6bb33e$export$e12b2cc6b75b006b = (0, $iIEGg.default)((0, $cSP6q.store).dispatch);
const $c715a3c03f6bb33e$export$900a08a292ad23cd = (0, $d7Utd.default)((0, $cSP6q.store).dispatch);
const $c715a3c03f6bb33e$var$dismissFlagById = (id)=>{
    $c715a3c03f6bb33e$export$900a08a292ad23cd((0, $d7Utd.dismissFlag)(id));
};
const $c715a3c03f6bb33e$var$hasFlag = (id)=>Boolean((0, $cSP6q.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
const $c715a3c03f6bb33e$export$dbb055af53fd81a0 = {
    showFlag: $c715a3c03f6bb33e$export$e12b2cc6b75b006b,
    dismissFlag: $c715a3c03f6bb33e$export$900a08a292ad23cd
};
const $c715a3c03f6bb33e$export$eee61a1aafe3884 = ()=>({
        showFlag: $c715a3c03f6bb33e$export$e12b2cc6b75b006b,
        dismissFlag: $c715a3c03f6bb33e$var$dismissFlagById,
        hasFlag: $c715a3c03f6bb33e$var$hasFlag
    });
const $c715a3c03f6bb33e$export$dc4f8132c3090b32 = ()=>$c715a3c03f6bb33e$export$dbb055af53fd81a0;
const $c715a3c03f6bb33e$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $acwzf.DISMISS_COMMAND);
const $c715a3c03f6bb33e$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
const $c715a3c03f6bb33e$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
const $c715a3c03f6bb33e$export$63ffd7d99470afd4 = (flag)=>!$c715a3c03f6bb33e$export$14b1864d9cf0809f(flag) && !$c715a3c03f6bb33e$export$d84ce5adcee46025(flag) && !$c715a3c03f6bb33e$export$cd5f9f2b991b82d9(flag);
const $c715a3c03f6bb33e$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);

});
parcelRegister("d7Utd", function(module, exports) {
$parcel$export(module.exports, "dismissFlag", () => $d7bad03e6e860bfc$export$900a08a292ad23cd);
$parcel$export(module.exports, "default", () => $d7bad03e6e860bfc$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux

var $1BZNH = parcelRequire("1BZNH");

var $acwzf = parcelRequire("acwzf");
const $d7bad03e6e860bfc$export$900a08a292ad23cd = (flagId)=>({
        command: (0, $acwzf.DISMISS_COMMAND),
        id: flagId
    });
const $d7bad03e6e860bfc$var$dismissFlagService = (dispatch)=>(action)=>{
        dispatch((0, $1BZNH.dismissFlagAction)(action.id));
    };
var $d7bad03e6e860bfc$export$2e2bcd8739ae039 = $d7bad03e6e860bfc$var$dismissFlagService;

});
parcelRegister("1BZNH", function(module, exports) {
$parcel$export(module.exports, "SHOW", () => $3730007a671a8090$export$9d04158a25ce4cd);
$parcel$export(module.exports, "show", () => $3730007a671a8090$export$57bf213be019eeb0);
$parcel$export(module.exports, "DISMISS_INSTANCE", () => $3730007a671a8090$export$b31a07d2e6382678);
$parcel$export(module.exports, "dismiss", () => $3730007a671a8090$export$abf286bbe7073aba);
$parcel$export(module.exports, "DISMISS_FLAG", () => $3730007a671a8090$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlagAction", () => $3730007a671a8090$export$4818b3c52448050d);
$parcel$export(module.exports, "RESET", () => $3730007a671a8090$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $3730007a671a8090$export$aad8462122ac592b);
/* eslint-disable jira/filename-case */ const $3730007a671a8090$export$9d04158a25ce4cd = 'state.SHOW';
const $3730007a671a8090$export$57bf213be019eeb0 = (payload)=>({
        type: $3730007a671a8090$export$9d04158a25ce4cd,
        payload: payload
    });
const $3730007a671a8090$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
const $3730007a671a8090$export$abf286bbe7073aba = (payload)=>({
        type: $3730007a671a8090$export$b31a07d2e6382678,
        payload: payload
    });
const $3730007a671a8090$export$1eb56620df104bf = 'state.DISMISS_FLAG';
const $3730007a671a8090$export$4818b3c52448050d = (payload)=>({
        type: $3730007a671a8090$export$1eb56620df104bf,
        payload: payload
    });
const $3730007a671a8090$export$4a991c87e640ef77 = 'state.RESET';
const $3730007a671a8090$export$aad8462122ac592b = ()=>({
        type: $3730007a671a8090$export$4a991c87e640ef77
    });

});

parcelRegister("acwzf", function(module, exports) {
$parcel$export(module.exports, "DISMISS_COMMAND", () => $4cfc2e0cc9b4c567$export$e705274c5e156b93);
$parcel$export(module.exports, "toFlagId", () => $4cfc2e0cc9b4c567$export$8184bc29de2aea90);
$parcel$export(module.exports, "fromFlagId", () => $4cfc2e0cc9b4c567$export$188cdb77b72629d7);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
const $4cfc2e0cc9b4c567$export$e705274c5e156b93 = 'DISMISS';
const $4cfc2e0cc9b4c567$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
const $4cfc2e0cc9b4c567$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();

});


parcelRegister("iIEGg", function(module, exports) {
$parcel$export(module.exports, "default", () => $294c1084b02a9c27$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux

var $7TA2J = parcelRequire("7TA2J");

var $hIRki = parcelRequire("hIRki");

var $i860n = parcelRequire("i860n");

var $1BZNH = parcelRequire("1BZNH");

var $acwzf = parcelRequire("acwzf");
const $294c1084b02a9c27$var$showFlagService = (dispatch)=>(flag)=>{
        if ((0, $hIRki.isStableUIEnabledForTests)() && (0, $i860n.fg)('jpx-870-stable-ui-for-criterion')) return undefined;
        // Flag is of type FlagComponent
        if (typeof flag === 'function') {
            dispatch((0, $1BZNH.show)(flag));
            return undefined;
        }
        const flagId = flag.id || (0, $acwzf.toFlagId)((0, $7TA2J.v4)());
        const newFlag = {
            ...flag,
            id: flagId
        };
        dispatch((0, $1BZNH.show)(newFlag));
        return flagId;
    };
var $294c1084b02a9c27$export$2e2bcd8739ae039 = $294c1084b02a9c27$var$showFlagService;

});
parcelRegister("hIRki", function(module, exports) {
$parcel$export(module.exports, "isStableUIEnabledForTests", () => $8acfc2aa9431b148$export$c0b9078f666b1acf);

var $i860n = parcelRequire("i860n");

var $k11SN = parcelRequire("k11SN");

var $cX0n9 = parcelRequire("cX0n9");
const $8acfc2aa9431b148$export$c0b9078f666b1acf = ()=>{
    if (!(0, $i860n.fg)('jpx-870-stable-ui-for-criterion')) return false;
    if ((0, $k11SN.default)('jira_stable_ui_for_tests')) return false;
    return (0, $cX0n9.getLocationSearch)().includes('stableUI=1');
};

});
parcelRegister("cX0n9", function(module, exports) {
$parcel$export(module.exports, "getLocationSearch", () => $9489181b1a13707e$export$c0166938e4a3a33f);
const $9489181b1a13707e$export$c0166938e4a3a33f = ()=>{
    if (typeof globalThis?.location?.search !== 'string') return '';
    return globalThis.location.search;
};

});



parcelRegister("cSP6q", function(module, exports) {
$parcel$export(module.exports, "store", () => $a767f88668de071f$export$6f57813fe9f31bf9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jKB1k = parcelRequire("jKB1k");
const $a767f88668de071f$export$6f57813fe9f31bf9 = (0, $jKB1k.createStore)();

});
parcelRegister("jKB1k", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $e28a517437b973ed$export$f51a9068ac82ea43);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6772o = parcelRequire("6772o");

var $40Cu7 = parcelRequire("40Cu7");
const $e28a517437b973ed$export$f51a9068ac82ea43 = (rootEpic)=>(0, $6772o.default)({
        appName: 'flags',
        rootReducer: $40Cu7.default,
        rootEpic: rootEpic
    });

});
parcelRegister("6772o", function(module, exports) {
$parcel$export(module.exports, "default", () => $206aba5680d8b56f$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ /// <reference types="node" />

var $euxye = parcelRequire("euxye");

var $13ZYC = parcelRequire("13ZYC");

var $bnMP4 = parcelRequire("bnMP4");

var $esROC = parcelRequire("esROC");

var $itL0K = parcelRequire("itL0K");

var $h1n3S = parcelRequire("h1n3S");

var $hqEQV = parcelRequire("hqEQV");

/**
 * Initializes a Redux store with configurations for state management and middleware integration.
 * It addresses serialization challenges with non-serializable entities and enhances debugging capabilities.
 * The custom action listener middleware offers additional control over action dispatches.
 */ const $206aba5680d8b56f$var$initiateStore = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
    const actionListenerMiddleware = new (0, $hqEQV.default)();
    middlewares.push(actionListenerMiddleware.perform);
    if ((0, $itL0K.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("cuwfX"));
        middlewares.push(logger);
    }
    if (rootEpic) middlewares.push((0, $esROC.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
        dependencies: rootEpicDependencies
    } : undefined));
    const store = (0, $13ZYC.createStore)((0, $bnMP4.enableBatching)(rootReducer), initialState, (0, $h1n3S.default)({
        name: appName,
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; serialize: { replacer: (key: any, value: any) => any; }; }' is not assignable to parameter of type 'DevtoolsConfig'.
        serialize: {
            // Replacer function is necessary to fix redux-devtools because some actions and state are React Elements
            // and the default serialization gets into a loop in a circular dependency somewhere in internal React properties.
            // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
            // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
            replacer: (key, value)=>{
                if (/*#__PURE__*/ (0, $euxye.isValidElement)(value)) {
                    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    if (value.type && value.type.displayName) // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    return `React Element <${value.type.displayName}>`;
                    return 'React Element';
                }
                // The benefit of using React + Redux + declarative API is that there is no more need to save DOM elements in store!
                // ... yet we still do. So when that happens, Redux devtools sometimes crashes because it tries to serialize circular DOM structure.
                if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                return value;
            }
        }
    })((0, $13ZYC.compose)(...enhancers, (0, $13ZYC.applyMiddleware)(...middlewares))));
    store.addActionListener = actionListenerMiddleware.add;
    store.removeActionListener = actionListenerMiddleware.remove;
    return store;
};
var $206aba5680d8b56f$export$2e2bcd8739ae039 = $206aba5680d8b56f$var$initiateStore;

});
parcelRegister("itL0K", function(module, exports) {
$parcel$export(module.exports, "debugEnabled", () => $7bf95b7e5c6147de$export$342c99cc1e9bc5c6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $7bf95b7e5c6147de$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);

});

parcelRegister("h1n3S", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c7c11ba70b1a486$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux

var $13ZYC = parcelRequire("13ZYC");
// An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9c7c11ba70b1a486$var$composeWithDevtools = (devtoolsConfig = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const config = {
        ...devtoolsConfig
    };
    if (config.name != null && config.instanceId == null) config.instanceId = config.name;
    return 0, $13ZYC.compose;
};
var $9c7c11ba70b1a486$export$2e2bcd8739ae039 = $9c7c11ba70b1a486$var$composeWithDevtools;

});

parcelRegister("hqEQV", function(module, exports) {
$parcel$export(module.exports, "default", () => $8aad5e8fcb03b108$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
class $8aad5e8fcb03b108$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = [];
        this.add = (listener)=>{
            this.listeners.push(listener);
        };
        this.remove = (listener)=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
        // @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
        this.perform = (api)=>(next)=>(action)=>{
                    const result = next(action);
                    this.listeners.forEach((listener)=>listener(action, api.getState()));
                    return result;
                };
    }
}
$8aad5e8fcb03b108$export$2e2bcd8739ae039.displayName = "ActionListenerMiddleware";

});


parcelRegister("40Cu7", function(module, exports) {
$parcel$export(module.exports, "default", () => $b840c6258163f263$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hTfsm = parcelRequire("hTfsm");

var $7TA2J = parcelRequire("7TA2J");

var $1BZNH = parcelRequire("1BZNH");
const $b840c6258163f263$var$defaultState = {
    flags: []
};
/**
 * Manages the state transitions of a notification system by handling actions such as showing
 * new notifications, dismissing notifications (either individually or by type), and
 * resetting to the default state. It uniquely prioritizes high-priority notifications,
 * ensuring they are displayed before low-priority ones, enhancing the user's
 * attention to critical alerts.
 */ const $b840c6258163f263$var$rootReducer = (state = $b840c6258163f263$var$defaultState, action)=>{
    switch(action.type){
        case 0, $1BZNH.SHOW:
            {
                // If flag is of type FlagComponent, it is treated as high priority
                const [lowPriorityFlags, highPriorityFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($hTfsm)))([
                    {
                        id: (0, $7TA2J.v4)(),
                        flag: action.payload
                    },
                    ...state.flags
                ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                const flags = [
                    ...highPriorityFlags,
                    ...lowPriorityFlags
                ];
                return {
                    ...state,
                    flags: flags
                };
            }
        case 0, $1BZNH.DISMISS_INSTANCE:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                };
            }
        case 0, $1BZNH.DISMISS_FLAG:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>{
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        if (flagInstance.flag.id) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        return flagInstance.flag.id !== id;
                        return true;
                    })
                };
            }
        case 0, $1BZNH.RESET:
            return $b840c6258163f263$var$defaultState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $b840c6258163f263$export$2e2bcd8739ae039 = $b840c6258163f263$var$rootReducer;

});





parcelRegister("1p9Al", function(module, exports) {
$parcel$export(module.exports, "getLoggingAndMetricsHelper", () => $1498db7084b1b1bc$export$726e1df8186bb981);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $srxic = parcelRequire("srxic");

var $cY22M = parcelRequire("cY22M");

var $WqSvO = parcelRequire("WqSvO");

var $6CfY5 = parcelRequire("6CfY5");

var $75sVW = parcelRequire("75sVW");

var $6ZLJT = parcelRequire("6ZLJT");

var $i860n = parcelRequire("i860n");
const $1498db7084b1b1bc$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
const $1498db7084b1b1bc$var$LOG_NAMESPACE_INFO = 'relay.AGG.info.logQueryFallbackToPost';
const $1498db7084b1b1bc$var$errorLogFn = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jira_relay_fetch_use_log_unsafe'), (0, $6CfY5.default).unsafeErrorWithCustomerData, (0, $6CfY5.default).safeErrorWithoutCustomerData);
const $1498db7084b1b1bc$export$726e1df8186bb981 = (graphqlDetails)=>{
    const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
    const logErrorRetry = (error, retryAttempt)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
            'statusCode'
        ], null);
        const errorType = error instanceof (0, $75sVW.default) ? 'network' : 'unknown';
        // Log any errors even in SSR
        $1498db7084b1b1bc$var$errorLogFn($1498db7084b1b1bc$var$LOG_NAMESPACE, `[${errorType} error]`, {
            message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($srxic)))(errorType)} error]: ${error?.message ?? ''}`,
            errorType: errorType,
            statusCode: statusCode,
            queryName: queryName,
            operationKind: operationKind,
            errorName: (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(error, [
                'name'
            ], null),
            retryAttempt: retryAttempt
        });
    };
    return {
        logNonBreakingErrors: (errors, requestId)=>{
            if (false || (0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(errors) || !Array.isArray(errors)) return;
            errors.forEach((error)=>{
                error && $1498db7084b1b1bc$var$errorLogFn($1498db7084b1b1bc$var$LOG_NAMESPACE, '[graphql error]', {
                    queryName: queryName,
                    operationKind: operationKind,
                    errorType: 'graphql',
                    message: error.message,
                    requestId: requestId
                });
            });
        },
        logError: logErrorRetry,
        logErrorRetry: logErrorRetry,
        logQueryFallbackToPost: (reason)=>{
            if (false && reason === 'SSR') return;
            (0, $6CfY5.default).safeInfoWithoutCustomerData($1498db7084b1b1bc$var$LOG_NAMESPACE_INFO, 'logQueryFallbackToPost', {
                queryName: queryName,
                operationKind: operationKind,
                reason: reason
            });
        }
    };
};

});

parcelRegister("cGqKz", function(module, exports) {
$parcel$export(module.exports, "checkAuthentication", () => $fcad345e0835e49b$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "blocklist", () => $fcad345e0835e49b$export$c5c28c9e707bcda1);
$parcel$export(module.exports, "generateOptions", () => $fcad345e0835e49b$export$c21133b4499f5374);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $WqSvO = parcelRequire("WqSvO");

var $6Fltw = parcelRequire("6Fltw");

var $5H1E5 = parcelRequire("5H1E5");

var $i8gMT = parcelRequire("i8gMT");

var $75sVW = parcelRequire("75sVW");

var $ff8AH = parcelRequire("ff8AH");

var $atcQv = parcelRequire("atcQv");

var $9CNRl = parcelRequire("9CNRl");

var $8nMDY = parcelRequire("8nMDY");

var $6bEm8 = parcelRequire("6bEm8");

var $2zU0a = parcelRequire("2zU0a");
let $fcad345e0835e49b$var$redirecting = false;
const $fcad345e0835e49b$export$ae8f795c4c44d494 = ()=>{
    $fcad345e0835e49b$var$redirecting = false;
};
const $fcad345e0835e49b$var$markAsRedirecting = ()=>{
    $fcad345e0835e49b$var$redirecting = true;
};
if (typeof window !== 'undefined') // Mark as redirecting, when we're unloading the page to prevent double/unwatend redirection.
window.addEventListener('beforeunload', ()=>{
    $fcad345e0835e49b$var$markAsRedirecting();
});
const $fcad345e0835e49b$var$redirect = ()=>{
    const identity = (0, $5H1E5.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href)}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = redirectUrl;
};
const $fcad345e0835e49b$export$b8dbb7d6029c5413 = ()=>{
    if (!false && !$fcad345e0835e49b$var$redirecting) {
        const heartbeatService = (0, $i8gMT.getInstance)();
        if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
            if (!$fcad345e0835e49b$var$redirecting) $fcad345e0835e49b$var$redirect();
            // Set flag to prevent multiple redirects
            $fcad345e0835e49b$var$markAsRedirecting();
        }
    }
    return $fcad345e0835e49b$var$redirecting;
};
const $fcad345e0835e49b$export$c5c28c9e707bcda1 = [
    'issueAggQuery'
];
const $fcad345e0835e49b$export$9dec0f42cc67f6ab = (_queryName, operationKind)=>{
    if (operationKind === 'query') return 0, $atcQv.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
const $fcad345e0835e49b$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.trace_id;
    return undefined;
};
const $fcad345e0835e49b$export$c21133b4499f5374 = (options = {}, url = null)=>{
    // the token fetcher returns undefined if no cookie value was found, also in SSR cookies are unavailable
    const csrfToken = !false ? (0, $9CNRl.default)() : undefined;
    // If we don't get a token, there is no point trying to add the csrf header
    const csrfTokenHeader = (0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(csrfToken) ? {} : {
        'atl-xsrf-token': csrfToken
    };
    const cloudId = (0, $6bEm8.default)('ajs-cloud-id');
    const activationId = (0, $6bEm8.default)('ajs-activation-id');
    const atlWorkspaceId = `ari:cloud:jira:${cloudId}:workspace/${activationId}`;
    const atlAttribution = {
        atlWorkspaceId: atlWorkspaceId,
        tenantId: cloudId,
        product: 'Atlassian Jira',
        service: 'afm-frontend'
    };
    const siteAri = cloudId ? (0, $2zU0a.createAri)({
        resourceOwner: 'platform',
        resourceType: 'site',
        resourceId: cloudId
    }) : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))({}, {
        // We have to provide general options here or the headers we provide will override the default ones found
        // here /src/packages/platform/fetch/src/utils/requests.js due to a shallow merge
        ...(0, $ff8AH.getDefaultOptions)(url),
        ...options
    }, {
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $8nMDY.getRelayExperimentalApis)().join(','),
            'atl-attribution': JSON.stringify(atlAttribution),
            // required for Unified Graph Store requests
            'X-Query-Context': siteAri,
            ...csrfTokenHeader
        }
    });
};
const $fcad345e0835e49b$export$7bfea3c3d460ecd8 = (error)=>{
    if (error instanceof (0, $75sVW.default)) return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};

});
parcelRegister("2zU0a", function(module, exports) {
$parcel$export(module.exports, "isAri", () => $a7f581f6cd190f0d$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $a7f581f6cd190f0d$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $a7f581f6cd190f0d$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $a7f581f6cd190f0d$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $a7f581f6cd190f0d$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $a7f581f6cd190f0d$export$3d8d7031a11613fd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $a7f581f6cd190f0d$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $a7f581f6cd190f0d$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $a7f581f6cd190f0d$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $a7f581f6cd190f0d$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $a7f581f6cd190f0d$export$8e68286aef4c3a8b = (ari)=>$a7f581f6cd190f0d$var$ARI_REG_EXP.test(ari) || $a7f581f6cd190f0d$var$ARI_REG_EXP_WORKSPACE.test(ari) || $a7f581f6cd190f0d$var$ARI_REG_EXP_ACTIVATION.test(ari) || $a7f581f6cd190f0d$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $a7f581f6cd190f0d$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $a7f581f6cd190f0d$export$24b47820a324e614 = (ari)=>{
    if ($a7f581f6cd190f0d$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $a7f581f6cd190f0d$export$e2789192113e8b07 = (ari, defaultValue = '')=>$a7f581f6cd190f0d$export$24b47820a324e614(ari) ?? defaultValue;
const $a7f581f6cd190f0d$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($a7f581f6cd190f0d$export$8e68286aef4c3a8b(ari)) {
        const parts = $a7f581f6cd190f0d$var$ARI_REG_EXP.exec(ari) || $a7f581f6cd190f0d$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $a7f581f6cd190f0d$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $a7f581f6cd190f0d$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $a7f581f6cd190f0d$export$3d8d7031a11613fd = (ari)=>{
    const config = $a7f581f6cd190f0d$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});



parcelRegister("67QWT", function(module, exports) {
$parcel$export(module.exports, "requiredFieldLogger", () => $2c00263bfcdf66fa$export$1ab8b98d209afe85);
$parcel$export(module.exports, "default", () => $2c00263bfcdf66fa$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $siTdT = parcelRequire("siTdT");

var $6CfY5 = parcelRequire("6CfY5");

var $k11SN = parcelRequire("k11SN");
const $2c00263bfcdf66fa$var$RELAY_CLIENT_ID = 'AGG';
const $2c00263bfcdf66fa$var$LOG_NAMESPACE = `relay.${$2c00263bfcdf66fa$var$RELAY_CLIENT_ID}.error.graphql`;
const $2c00263bfcdf66fa$var$requests = {};
const $2c00263bfcdf66fa$var$queries = {};
const $2c00263bfcdf66fa$var$resources = {};
const $2c00263bfcdf66fa$var$executes = {};
const $2c00263bfcdf66fa$var$CLEANUP_TIMEOUT = 300000; // 5 minutes
const $2c00263bfcdf66fa$export$1ab8b98d209afe85 = (event)=>{
    (0, $6CfY5.default).safeErrorWithoutCustomerData($2c00263bfcdf66fa$var$LOG_NAMESPACE, '[relay required field error]', {
        kind: event.kind,
        owner: event.owner,
        fieldPath: event.fieldPath,
        message: event.kind === 'relay_resolver.error' ? event.error?.message : null
    });
};
const $2c00263bfcdf66fa$var$getResponseSize = (resp)=>{
    if (resp.data === undefined) return 0;
    try {
        return JSON.stringify(resp.data).length;
    } catch (e) {
        return 0;
    }
};
function $2c00263bfcdf66fa$export$2e2bcd8739ae039(event) {
    if ((0, $k11SN.default)('relay_log')) return;
    switch(event.name){
        // NETWORK
        case 'network.start':
            {
                const networkStart = performance.now();
                const { networkRequestId: networkRequestId } = event;
                const { name: name } = event.params;
                const requestInfo = $2c00263bfcdf66fa$var$requests[networkRequestId];
                if (requestInfo == null) {
                    const newRequestInfo = {
                        name: name,
                        flushes: [],
                        start: networkStart,
                        networkStart: networkStart
                    };
                    $2c00263bfcdf66fa$var$queries[name] = newRequestInfo;
                    $2c00263bfcdf66fa$var$requests[networkRequestId] = newRequestInfo;
                    setTimeout(()=>{
                        delete $2c00263bfcdf66fa$var$requests[networkRequestId];
                        delete $2c00263bfcdf66fa$var$queries[name];
                    }, $2c00263bfcdf66fa$var$CLEANUP_TIMEOUT);
                } else requestInfo.networkStart = networkStart;
                break;
            }
        case 'network.next':
            {
                const requestInfo = $2c00263bfcdf66fa$var$requests[event.networkRequestId];
                if (requestInfo != null) {
                    const { response: response } = event;
                    const addFlush = (resp)=>{
                        if (resp.data !== null) {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const res = resp;
                            const flush = {
                                label: res.label != null ? res.label : 'root',
                                time: performance.now(),
                                size: $2c00263bfcdf66fa$var$getResponseSize(res)
                            };
                            requestInfo.flushes?.push(flush);
                        }
                    };
                    Array.isArray(response) ? response.forEach(addFlush) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    addFlush(response);
                }
                break;
            }
        case 'network.error':
            {
                const info = $2c00263bfcdf66fa$var$requests[event.networkRequestId];
                if (info != null) info.error = event.error;
                break;
            }
        case 'network.info':
            break;
        case 'network.complete':
            {
                const requestInfo = $2c00263bfcdf66fa$var$requests[event.networkRequestId];
                const networkComplete = performance.now();
                if (requestInfo != null) {
                    const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                    requestInfo.size = size;
                    requestInfo.networkComplete = networkComplete;
                    requestInfo.flushes = [];
                    (0, $siTdT.addSpanToAll)('relay', requestInfo.name, [
                        {
                            name: 'network'
                        }
                    ], requestInfo.start, requestInfo.networkComplete, size);
                }
                break;
            }
        case 'network.unsubscribe':
            break;
        // SUSPENSE
        case 'suspense.fragment':
            break;
        case 'suspense.query':
            break;
        // QUERY
        case 'queryresource.fetch':
            {
                const { node: node } = event.operation.root;
                const fetchStart = performance.now();
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                if (node.name != null) {
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                    const { name: name } = node;
                    const requestInfo = $2c00263bfcdf66fa$var$queries[name];
                    if (requestInfo != null) {
                        requestInfo.fetchStart = fetchStart;
                        $2c00263bfcdf66fa$var$resources[event.resourceID] = requestInfo;
                    } else {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: fetchStart,
                            fetchStart: fetchStart
                        };
                        $2c00263bfcdf66fa$var$queries[name] = newRequestInfo;
                        $2c00263bfcdf66fa$var$resources[event.resourceID] = newRequestInfo;
                        setTimeout(()=>{
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                            delete $2c00263bfcdf66fa$var$queries[node.name];
                        }, $2c00263bfcdf66fa$var$CLEANUP_TIMEOUT);
                    }
                    setTimeout(()=>{
                        delete $2c00263bfcdf66fa$var$resources[event.resourceID];
                    }, $2c00263bfcdf66fa$var$CLEANUP_TIMEOUT);
                }
                break;
            }
        case 'queryresource.retain':
            {
                const requestInfo = $2c00263bfcdf66fa$var$resources[event.resourceID];
                if (requestInfo != null && event.profilerContext != null) {
                    requestInfo.end = performance.now();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const context = event.profilerContext;
                    context?.retainQuery?.(requestInfo);
                }
                break;
            }
        // EXECUTE
        case 'execute.start':
            $2c00263bfcdf66fa$var$executes[event.executeId] = {
                name: event.params.name,
                kind: event.params.operationKind,
                start: performance.now(),
                duration: 0
            };
            break;
        case 'execute.next.start':
            $2c00263bfcdf66fa$var$executes[event.executeId].start = performance.now();
            break;
        case 'execute.next.end':
            {
                const now = performance.now();
                const duration = now - $2c00263bfcdf66fa$var$executes[event.executeId].start;
                $2c00263bfcdf66fa$var$executes[event.executeId].end = now;
                $2c00263bfcdf66fa$var$executes[event.executeId].duration = duration;
                break;
            }
        case 'execute.async.module':
            break;
        case 'execute.error':
            delete $2c00263bfcdf66fa$var$executes[event.executeId];
            break;
        case 'execute.complete':
            {
                const op = $2c00263bfcdf66fa$var$executes[event.executeId];
                if (op != null) {
                    op.end = performance.now();
                    delete $2c00263bfcdf66fa$var$executes[event.executeId];
                }
                break;
            }
        // STORE
        case 'store.publish':
            break;
        case 'store.snapshot':
            break;
        case 'store.restore':
            break;
        case 'store.gc.start':
            break;
        case 'store.gc.end':
            break;
        case 'store.gc.interrupted':
            break;
        // FLUSH
        case 'store.notify.start':
            break;
        case 'store.notify.complete':
            break;
        case 'store.notify.subscription':
            break;
        // ENTRYPOINT
        case 'entrypoint.root.consume':
            break;
        default:
            break;
    }
}

});



parcelRegister("ixtp6", function(module, exports) {
$parcel$export(module.exports, "LoadingPhaseManager", () => $aca98d45a5fca3e2$export$6e4bfef9e80c7eb0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $2OUOK = parcelRequire("2OUOK");
const $aca98d45a5fca3e2$export$6e4bfef9e80c7eb0 = ()=>{
    const { startNextPhase: startNextPhase } = (0, $2OUOK.useLazyPhase)();
    (0, $euxye.useEffect)(()=>{
        /**
     * Only start next phase if we are not in the SPA, because there is a second
     * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
     * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
     * bundles too early.
     */ if (__SPA__) return;
        /* Outside the SPA, we don't currently have a good proxy for page loads.
     * So for now we start the "after paint" phase a few seconds after mounting.
     */ setTimeout(()=>{
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        }, 2000);
    }, [
        startNextPhase
    ]);
    return null;
};
$aca98d45a5fca3e2$export$6e4bfef9e80c7eb0.displayName = "LoadingPhaseManager";

});

parcelRegister("cK8QE", function(module, exports) {
module.exports = __LANG;

});


parcelRegister("bafqJ", function(module, exports) {
$parcel$export(module.exports, "FlagsBoundary", () => $eecc65a0424ab243$export$8b4a0fffcddd96f4);

var $euxye = parcelRequire("euxye");

var $cCE2Z = parcelRequire("cCE2Z");

var $a8EUd = parcelRequire("a8EUd");
const $eecc65a0424ab243$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName, teamName: teamName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cCE2Z.default), {
        id: "flags",
        packageName: packageName,
        teamName: teamName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null)
    }, children));
$eecc65a0424ab243$export$8b4a0fffcddd96f4.displayName = "FlagsBoundary";

});

parcelRegister("b3oW6", function(module, exports) {
$parcel$export(module.exports, "StrictMode", () => $7165b90451d2d91f$export$5f8d39834fd61797);

var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");
const $7165b90451d2d91f$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = !(0, $i860n.fg)('jira-enable-strict-mode');
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled by default
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).StrictMode, null, children);
};
$7165b90451d2d91f$export$5f8d39834fd61797.displayName = "StrictMode";

});

parcelRegister("gA1xy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("30XWp").then(()=>parcelRequire('7Natd'));

});


parcelRegister("qpL8u", function(module, exports) {
$parcel$export(module.exports, "default", () => $99f0d5538b9426e8$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $9ObL1 = parcelRequire("9ObL1");

var $b3oW6 = parcelRequire("b3oW6");
const $99f0d5538b9426e8$var$getPlaceholder = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const existingPlaceholder = document.getElementById(placeholderId);
    if (existingPlaceholder) return existingPlaceholder;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const div = document.createElement('div');
    div.id = placeholderId;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body.appendChild(div);
    else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
    return div;
};
const $99f0d5538b9426e8$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
    if (placeholder && sessionId) (0, $85XPu.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b3oW6.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ObL1.default), {
        sessionId: sessionId,
        data: data
    })), $99f0d5538b9426e8$var$getPlaceholder(placeholder));
};
var $99f0d5538b9426e8$export$2e2bcd8739ae039 = $99f0d5538b9426e8$var$renderDwellTimeComponent;

});
parcelRegister("9ObL1", function(module, exports) {
$parcel$export(module.exports, "default", () => $332991cc62459752$export$2e2bcd8739ae039);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4B1S7 = parcelRequire("4B1S7");

var $bx8kK = parcelRequire("bx8kK");

var $4aWLY = parcelRequire("4aWLY");


var $5ZjZ2 = parcelRequire("5ZjZ2");
const $332991cc62459752$var$defaultSource = 'dwellComponent';
const $332991cc62459752$var$defaultActionSubject = 'dwellComponent';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $332991cc62459752$var$getDwellComponent = (source, actionSubject)=>(0, (/*@__PURE__*/$parcel$interopDefault($4B1S7)))((0, $bx8kK.AnalyticsSubject)(actionSubject || $332991cc62459752$var$defaultActionSubject), (0, $bx8kK.AnalyticsSource)(source || $332991cc62459752$var$defaultSource, (0, $46f069e6c968f461$export$f636b5b56f1d624a)))((0, $5ZjZ2.default));
class $332991cc62459752$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    static getDerivedStateFromProps(props) {
        const { data: data } = props;
        return {
            DwellTimeComponent: $332991cc62459752$var$getDwellComponent(data.source, data.actionSubject)
        };
    }
    constructor(props){
        super(props);
        this.state = {
            DwellTimeComponent: null
        };
    }
    render() {
        const { sessionId: sessionId, data: data } = this.props;
        const { DwellTimeComponent: DwellTimeComponent } = this.state;
        const enrichedData = {
            ...data,
            source: data && data.source || $332991cc62459752$var$defaultSource,
            actionSubject: data && data.actionSubject || $332991cc62459752$var$defaultActionSubject
        };
        if (sessionId && DwellTimeComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4aWLY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(DwellTimeComponent, {
            sessionId: sessionId,
            data: enrichedData
        }));
        return null;
    }
}
$332991cc62459752$export$2e2bcd8739ae039.displayName = "DwellWrapper";

});
parcelRegister("4B1S7", function(module, exports) {

var $hH4fr = parcelRequire("hH4fr");
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */ var $358c11d1f0aa447e$var$flow = $hH4fr();
module.exports = $358c11d1f0aa447e$var$flow;

});
parcelRegister("hH4fr", function(module, exports) {

var $gg5in = parcelRequire("gg5in");

var $5skZT = parcelRequire("5skZT");

var $cMGSd = parcelRequire("cMGSd");

var $kAHSq = parcelRequire("kAHSq");

var $jOlpf = parcelRequire("jOlpf");

var $lvBLI = parcelRequire("lvBLI");
/** Error message constants. */ var $ce19bf6af86e6704$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $ce19bf6af86e6704$var$WRAP_CURRY_FLAG = 8, $ce19bf6af86e6704$var$WRAP_PARTIAL_FLAG = 32, $ce19bf6af86e6704$var$WRAP_ARY_FLAG = 128, $ce19bf6af86e6704$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function $ce19bf6af86e6704$var$createFlow(fromRight) {
    return $5skZT(function(funcs) {
        var length = funcs.length, index = length, prereq = $gg5in.prototype.thru;
        if (fromRight) funcs.reverse();
        while(index--){
            var func = funcs[index];
            if (typeof func != 'function') throw new TypeError($ce19bf6af86e6704$var$FUNC_ERROR_TEXT);
            if (prereq && !wrapper && $kAHSq(func) == 'wrapper') var wrapper = new $gg5in([], true);
        }
        index = wrapper ? index : length;
        while(++index < length){
            func = funcs[index];
            var funcName = $kAHSq(func), data = funcName == 'wrapper' ? $cMGSd(func) : undefined;
            if (data && $lvBLI(data[0]) && data[1] == ($ce19bf6af86e6704$var$WRAP_ARY_FLAG | $ce19bf6af86e6704$var$WRAP_CURRY_FLAG | $ce19bf6af86e6704$var$WRAP_PARTIAL_FLAG | $ce19bf6af86e6704$var$WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[$kAHSq(data[0])].apply(wrapper, data[3]);
            else wrapper = func.length == 1 && $lvBLI(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
        return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && $jOlpf(value)) return wrapper.plant(value).value();
            var index = 0, result = length ? funcs[index].apply(this, args) : value;
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
module.exports = $ce19bf6af86e6704$var$createFlow;

});
parcelRegister("gg5in", function(module, exports) {

var $1R5h4 = parcelRequire("1R5h4");

var $jSocY = parcelRequire("jSocY");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $bd623f8a4c43550d$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$bd623f8a4c43550d$var$LodashWrapper.prototype = $1R5h4($jSocY.prototype);
$bd623f8a4c43550d$var$LodashWrapper.prototype.constructor = $bd623f8a4c43550d$var$LodashWrapper;
module.exports = $bd623f8a4c43550d$var$LodashWrapper;

});
parcelRegister("jSocY", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $e785d6bca43b2222$var$baseLodash() {
// No operation performed.
}
module.exports = $e785d6bca43b2222$var$baseLodash;

});


parcelRegister("cMGSd", function(module, exports) {

var $emNji = parcelRequire("emNji");

var $fcq2N = parcelRequire("fcq2N");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $94eb3985a0e670cb$var$getData = !$emNji ? $fcq2N : function(func) {
    return $emNji.get(func);
};
module.exports = $94eb3985a0e670cb$var$getData;

});
parcelRegister("emNji", function(module, exports) {

var $j0H8z = parcelRequire("j0H8z");
/** Used to store function metadata. */ var $a7595eb8f9ce4fa2$var$metaMap = $j0H8z && new $j0H8z;
module.exports = $a7595eb8f9ce4fa2$var$metaMap;

});


parcelRegister("kAHSq", function(module, exports) {

var $pl2zd = parcelRequire("pl2zd");
/** Used for built-in method references. */ var $efd9347aa48ca91c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $efd9347aa48ca91c$var$hasOwnProperty = $efd9347aa48ca91c$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $efd9347aa48ca91c$var$getFuncName(func) {
    var result = func.name + '', array = $pl2zd[result], length = $efd9347aa48ca91c$var$hasOwnProperty.call($pl2zd, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $efd9347aa48ca91c$var$getFuncName;

});
parcelRegister("pl2zd", function(module, exports) {
/** Used to lookup unminified function names. */ var $04c2a81983f98d0c$var$realNames = {};
module.exports = $04c2a81983f98d0c$var$realNames;

});


parcelRegister("lvBLI", function(module, exports) {

var $ataFk = parcelRequire("ataFk");

var $cMGSd = parcelRequire("cMGSd");

var $kAHSq = parcelRequire("kAHSq");

var $jcJQ5 = parcelRequire("jcJQ5");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $fa89ca427c9f68d4$var$isLaziable(func) {
    var funcName = $kAHSq(func), other = $jcJQ5[funcName];
    if (typeof other != 'function' || !(funcName in $ataFk.prototype)) return false;
    if (func === other) return true;
    var data = $cMGSd(other);
    return !!data && func === data[0];
}
module.exports = $fa89ca427c9f68d4$var$isLaziable;

});
parcelRegister("ataFk", function(module, exports) {

var $1R5h4 = parcelRequire("1R5h4");

var $jSocY = parcelRequire("jSocY");
/** Used as references for the maximum length and index of an array. */ var $79f4e2c2d1aadef1$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $79f4e2c2d1aadef1$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $79f4e2c2d1aadef1$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$79f4e2c2d1aadef1$var$LazyWrapper.prototype = $1R5h4($jSocY.prototype);
$79f4e2c2d1aadef1$var$LazyWrapper.prototype.constructor = $79f4e2c2d1aadef1$var$LazyWrapper;
module.exports = $79f4e2c2d1aadef1$var$LazyWrapper;

});

parcelRegister("jcJQ5", function(module, exports) {

var $ataFk = parcelRequire("ataFk");

var $gg5in = parcelRequire("gg5in");

var $jSocY = parcelRequire("jSocY");

var $jOlpf = parcelRequire("jOlpf");

var $czB45 = parcelRequire("czB45");

var $p0kcc = parcelRequire("p0kcc");
/** Used for built-in method references. */ var $dfb2b2023e398cfa$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dfb2b2023e398cfa$var$hasOwnProperty = $dfb2b2023e398cfa$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $dfb2b2023e398cfa$var$lodash(value) {
    if ($czB45(value) && !$jOlpf(value) && !(value instanceof $ataFk)) {
        if (value instanceof $gg5in) return value;
        if ($dfb2b2023e398cfa$var$hasOwnProperty.call(value, '__wrapped__')) return $p0kcc(value);
    }
    return new $gg5in(value);
}
// Ensure wrappers are instances of `baseLodash`.
$dfb2b2023e398cfa$var$lodash.prototype = $jSocY.prototype;
$dfb2b2023e398cfa$var$lodash.prototype.constructor = $dfb2b2023e398cfa$var$lodash;
module.exports = $dfb2b2023e398cfa$var$lodash;

});
parcelRegister("p0kcc", function(module, exports) {

var $ataFk = parcelRequire("ataFk");

var $gg5in = parcelRequire("gg5in");

var $iM6Ha = parcelRequire("iM6Ha");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $04b296667d7ea8bc$var$wrapperClone(wrapper) {
    if (wrapper instanceof $ataFk) return wrapper.clone();
    var result = new $gg5in(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $iM6Ha(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $04b296667d7ea8bc$var$wrapperClone;

});





parcelRegister("bx8kK", function(module, exports) {
$parcel$export(module.exports, "AnalyticsSource", () => $a1dff6dfccfc5381$export$6890652a1aff7d1c);
$parcel$export(module.exports, "AnalyticsSubject", () => $a1dff6dfccfc5381$export$ec9f54bd4341ceb);
/* eslint-disable jira/filename-case */ 
var $kY2zM = parcelRequire("kY2zM");
const $a1dff6dfccfc5381$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $kY2zM.default)({
            source: `${name}${type}`
        })(WrappedComponent);
const $a1dff6dfccfc5381$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, $kY2zM.default)({
            actionSubject: name,
            attributes: attributes
        })(WrappedComponent);

});

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("5ZjZ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fd962bee3079abf$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bnIXS = parcelRequire("bnIXS");

var $lpTWz = parcelRequire("lpTWz");

var $foz8X = parcelRequire("foz8X");
class $1fd962bee3079abf$export$1c7ccff61c195c75 extends (0, $euxye.Component) {
    componentDidMount() {
        const { data: data, sessionId: sessionId } = this.props;
        // @ts-expect-error - TS2741 - Property 'prototype' is missing in type 'DwellTimeHelper' but required in type 'typeof DwellTimeHelper'.
        this.dwellHelper = new (0, $bnIXS.default)(this.sendDwellEvent, data, sessionId);
        // @ts-expect-error - TS2339 - Property 'start' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.start();
    }
    componentDidUpdate(oldProps) {
        if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) // @ts-expect-error - TS2339 - Property 'newPage' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.newPage(this.props.data, this.props.sessionId);
    }
    componentWillUnmount() {
        if (this.dwellHelper) {
            // @ts-expect-error - TS2339 - Property 'stop' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.stop();
            // @ts-expect-error - TS2339 - Property 'destroy' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.destroy();
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, this.props.children);
    }
    constructor(...args){
        super(...args), this.sendDwellEvent = (payload)=>(0, $foz8X.fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
    }
}
$1fd962bee3079abf$export$1c7ccff61c195c75.displayName = "DwellTime";
const $1fd962bee3079abf$var$ExportedComponent = (0, $lpTWz.default)('dwellTime', {
    onDwell: 'dwelled'
})($1fd962bee3079abf$export$1c7ccff61c195c75);
var $1fd962bee3079abf$export$2e2bcd8739ae039 = $1fd962bee3079abf$var$ExportedComponent;

});
parcelRegister("lpTWz", function(module, exports) {
$parcel$export(module.exports, "default", () => $8322f485796824b9$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/js/no-reduce-accumulator-spread */ 
var $kTviw = parcelRequire("kTviw");

var $kY2zM = parcelRequire("kY2zM");
const $8322f485796824b9$export$871de8747c9eaa88 = (props)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            ...result,
            [key]: {
                action: props[key]
            }
        }), {});
/**
 * Augments component's callbacks with analytics event as the last attribute, but does fires them
 * @example
 * ```tsx
 * // adds componentName into AnalyticsContext and adds pre-backed 'clicked' event to onClick arguments
 *  const componentWithAnalytics('FooComponent', { onClick: 'clicked' })(Foo)
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8322f485796824b9$var$componentWithAnalytics(componentName, eventActions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(WrappedComponent) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $kY2zM.default)({
            componentName: componentName
        })((0, $kTviw.default)($8322f485796824b9$export$871de8747c9eaa88(eventActions))(WrappedComponent));
    };
}
var $8322f485796824b9$export$2e2bcd8739ae039 = $8322f485796824b9$var$componentWithAnalytics;

});

parcelRegister("foz8X", function(module, exports) {
$parcel$export(module.exports, "fireTrackAnalytics", () => $76becd6a06e03f70$export$13990ad4625571ed);
/* eslint-disable jira/filename-case */ 
var $dAmGh = parcelRequire("dAmGh");

var $7iRBQ = parcelRequire("7iRBQ");

var $g6Mb9 = parcelRequire("g6Mb9");
const $76becd6a06e03f70$var$isNotUndefined = (a)=>a !== undefined;
const $76becd6a06e03f70$var$mapPayload = (payload)=>{
    const context = (0, $g6Mb9.default)(payload);
    const { action: action, actionSubjectId: actionSubjectId } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dAmGh)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        action: action,
        actionSubjectId: actionSubjectId
    }, $76becd6a06e03f70$var$isNotUndefined);
};
const $76becd6a06e03f70$export$13990ad4625571ed = (event, payload)=>{
    event.update({
        ...$76becd6a06e03f70$var$mapPayload(payload),
        analyticsType: (0, $7iRBQ.TRACK_EVENT_TYPE)
    }).fire();
};

});
parcelRegister("g6Mb9", function(module, exports) {
$parcel$export(module.exports, "default", () => $4389a520086d49d1$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $808aL = parcelRequire("808aL");

var $3irVK = parcelRequire("3irVK");
// AnalyticsDataPayload is cast to inexact type so that it can also accept subtypes
const $4389a520086d49d1$var$mapPayload = (payload)=>{
    const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($3irVK)))({
        tags: tags,
        containerId: containerId,
        containers: containers,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($808aL))));
};
var $4389a520086d49d1$export$2e2bcd8739ae039 = $4389a520086d49d1$var$mapPayload;

});





parcelRegister("4oQaN", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("8LqMl")
]).then(()=>parcelRequire('9yBjx'));

});

parcelRegister("dQ6mx", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("5qC72"),
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("9GhR0")
]).then(()=>parcelRequire('55cld'));

});

parcelRegister("jNdkm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eW3ny").then(()=>parcelRequire('8JpbK'));

});

parcelRegister("e5Vme", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9ACBj").then(()=>parcelRequire('iBuex'));

});

parcelRegister("8yNAF", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("6cbjx").then(()=>parcelRequire('lpchM'));

});


parcelRegister("ebwYJ", function(module, exports) {
$parcel$export(module.exports, "renderPageContainer", () => $61d5682b63d28101$export$53746a9158b8b9c8);
$parcel$export(module.exports, "default", () => $61d5682b63d28101$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $2HuOR = parcelRequire("2HuOR");

var $8xoxE = parcelRequire("8xoxE");

var $fy2Lt = parcelRequire("fy2Lt");

var $6bEm8 = parcelRequire("6bEm8");
parcelRequire("1ADnd");

var $41zzZ = parcelRequire("41zzZ");

var $b3oW6 = parcelRequire("b3oW6");

var $lFOLo = parcelRequire("lFOLo");

var $8ne6A = parcelRequire("8ne6A");

var $1Kz0I = parcelRequire("1Kz0I");

var $6FMwd = parcelRequire("6FMwd");

var $4yT7h = parcelRequire("4yT7h");

var $gxyIZ = parcelRequire("gxyIZ");

var $655tw = parcelRequire("655tw");
var $fJ5g0 = parcelRequire("fJ5g0");

// Trigger async import asap, no need for RLL as SSR renders without too
const $61d5682b63d28101$var$pageContainerImport = (parcelRequire("6PkDY"));

var $cK8QE = parcelRequire("cK8QE");
const $61d5682b63d28101$export$53746a9158b8b9c8 = async ({ App: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'ComponentType<any>'.
App = null, containerId: containerId = 'navigation-app', onLoad: onLoad, pageType: pageType = 'legacy-page' } = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById(containerId);
    if (container) {
        const { default: PageContainerV2 } = await $61d5682b63d28101$var$pageContainerImport;
        (0, $gxyIZ.LooselyLazy).init({
            mode: 'RENDER',
            crossOrigin: 'anonymous'
        });
        const tenantContext = (0, $2HuOR.getTenantContext_DEPRECATED_DO_NOT_USE)();
        $parcel$global.__NAV_VERSION__ = '3.0.0';
        (0, $fy2Lt.initPlatformFeatureFlags)((0, $4yT7h.visualRefreshResolverOverride));
        const history = (0, $655tw.createLegacyHistory)();
        const routes = (0, $1Kz0I.getLegacyRoutes)();
        const matchedRoute = (0, $fJ5g0.default)(routes, // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.pathname, // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.search, '');
        (0, $41zzZ.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        const resourceContext = (0, $6FMwd.getSpaRouterContext)({
            tenantContext: tenantContext
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resourceData = window.SKELETON_NAVIGATION;
        const LegacyRouter = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8ne6A.Router), {
                history: history,
                routes: routes,
                resourceContext: resourceContext,
                resourceData: resourceData
            }, children);
        // no need for a hydration check here because legacy never has hydration, it always static fallbacks
        const pageContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(PageContainerV2, {
            id: "jira.entry.legacy",
            locale: tenantContext.locale,
            messages: $cK8QE,
            onLoad: onLoad,
            Router: LegacyRouter,
            routerLinkComponent: (0, $lFOLo.JiraRouterLinkConfiguration),
            pageType: pageType
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8xoxE.ErrorBoundaryFlag), {
            id: "jira.route-app.legacy-bootstrap"
        }, App ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(App, null) : null));
        (0, $85XPu.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $b3oW6.StrictMode), null, pageContent), container);
    }
};
const $61d5682b63d28101$var$navigationLegacy = ()=>{
    const isGlobalSidebarEnabled = (0, $6bEm8.default)('ajs-global-sidebar-enabled') === 'true';
    if (!isGlobalSidebarEnabled) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.getElementById('navigation-app')) $61d5682b63d28101$export$53746a9158b8b9c8();
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.addEventListener('DOMContentLoaded', ()=>$61d5682b63d28101$export$53746a9158b8b9c8());
};
var $61d5682b63d28101$export$2e2bcd8739ae039 = $61d5682b63d28101$var$navigationLegacy;

});
parcelRegister("fy2Lt", function(module, exports) {
$parcel$export(module.exports, "initPlatformFeatureFlags", () => $93776aad67dd2395$export$2d291317456ada16);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $egspI = parcelRequire("egspI");

var $i860n = parcelRequire("i860n");
const $93776aad67dd2395$export$2d291317456ada16 = ([isOverride, resolver])=>{
    (0, $egspI.setBooleanFeatureFlagResolver)((flagKey)=>// disable existence check as platform feature >flags< might not be gates
        (0, $i860n.withoutFeatureExistenceCheck)(()=>isOverride(flagKey) ? resolver(flagKey) : (0, $i860n.fg)(flagKey)));
};

});

parcelRegister("1ADnd", function(module, exports) {
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6s4F0 = parcelRequire("6s4F0");

if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("7wBWJ"));
    const isDevMode = false;
    (0, $6s4F0.default).devtools = isDevMode && (()=>({
            serialize: {
                // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
                replacer: (key, value)=>value instanceof HTMLElement ? {
                        data: {
                            tagName: value.tagName,
                            className: value.className,
                            id: value.id,
                            __SANITIZED__: true
                        },
                        __serializedType__: 'HTMLElement'
                    } : value
            }
        }));
    (0, $6s4F0.default).batchUpdates = !false;
    Object.freeze((0, $6s4F0.default));
    $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
}

});
parcelRegister("7wBWJ", function(module, exports) {
const $57a8f4eb12418915$var$style = document.createElement('style');
$57a8f4eb12418915$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body,[data-subtree-theme]{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif)}body{-ms-overflow-style:-ms-autohiding-scrollbar;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-focused,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-focused,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ul style:first-child~*+ul,ol ul:not(:first-child),ol style:first-child~*+ul,ul ol:not(:first-child),ul style:first-child~*+ol,ol ol:not(:first-child),ol style:first-child~*+ol{margin-top:var(--ds-space-050,4px)}p:first-child,style:first-child+p,ul:first-child,style:first-child+ul,ol:first-child,style:first-child+ol,dl:first-child,style:first-child+dl,h1:first-child,style:first-child+h1,h2:first-child,style:first-child+h2,h3:first-child,style:first-child+h3,h4:first-child,style:first-child+h4,h5:first-child,style:first-child+h5,h6:first-child,style:first-child+h6,blockquote:first-child,style:first-child+blockquote,pre:first-child,style:first-child+pre,form:first-child,style:first-child+form,table:first-child,style:first-child+table{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,ui-monospace,Menlo,"Segoe UI Mono","Ubuntu Mono",monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:var(--ds-border-width,1px)var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{color-scheme:light}[data-color-mode=dark]{color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:var(--ds-border-width-selected,2px)solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,style:first-child+td,th:first-child,style:first-child+th{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
document.querySelector('head').appendChild($57a8f4eb12418915$var$style);

});


parcelRegister("lFOLo", function(module, exports) {
$parcel$export(module.exports, "JiraRouterLinkConfiguration", () => $96fd18521dfe2a87$export$a580704a2f3cfca);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eMmmd = parcelRequire("eMmmd");

var $jpPNt = parcelRequire("jpPNt");

var $i860n = parcelRequire("i860n");
const $96fd18521dfe2a87$export$a580704a2f3cfca = /*#__PURE__*/ (0, $euxye.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    const isEmbedMode = (0, $eMmmd.useIsEmbedMode)();
    if (// Links can be initially rendered with `href` not defined in some cases
    !href || typeof href === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jpPNt.Link), {
        ref: ref,
        href: (0, $i860n.fg)('jira-remove-default-character-for-undefined-hrefs') ? href : href || '#',
        ...rest,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jpPNt.Link), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        params: href.params,
        query: href.query,
        prefetch: href.prefetch,
        ...rest,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
});

});
parcelRegister("eMmmd", function(module, exports) {
$parcel$export(module.exports, "useIsEmbedMode", () => $87ce5ae4f0fdde2a$export$1b3c1ba6ee047da9);

var $euxye = parcelRequire("euxye");

var $3CqKW = parcelRequire("3CqKW");
const $87ce5ae4f0fdde2a$export$1b3c1ba6ee047da9 = ()=>{
    return (0, $euxye.useContext)((0, $3CqKW.EmbedModeContext));
};

});
parcelRegister("3CqKW", function(module, exports) {
$parcel$export(module.exports, "EmbedModeContext", () => $8f87f3d27d989091$export$5eb07b3c7c0b0771);
$parcel$export(module.exports, "EmbedModeProvider", () => $8f87f3d27d989091$export$9daaf42d62e1c430);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");
const $8f87f3d27d989091$export$5eb07b3c7c0b0771 = /*#__PURE__*/ (0, $euxye.createContext)(false);
const { Provider: $8f87f3d27d989091$var$Provider } = $8f87f3d27d989091$export$5eb07b3c7c0b0771;
const $8f87f3d27d989091$var$handleEmbedLinkClick = (e)=>{
    if (e.target instanceof Element) {
        const anchor = e.target.closest('a'); // Find closest parent anchor (including the target itself)
        if (anchor && anchor.target !== '_blank') // link
        anchor.target = '_blank';
    }
};
// When issue view is loaded within an iframe, it needs to follow the proper
// element elevation principles, found here: https://hello.atlassian.net/wiki/spaces/~460573267/pages/2355983526/Jira+Dark+Mode+-+UI+Guidelines#Element-elevation-basics
// Unfortunately the current elevation is set in the global-container, which is loaded before this Provider so
// we have to override the overrider to ensure that the proper elevation is set
const $8f87f3d27d989091$var$DarkModeMonolithStyleOverride = ()=>{
    const $ = (0, $e7boj.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: "\n                    #jira-frontend {\n                        background: var(--ds-surface-overlay, #FFFFFF);\n                    }\n                "
            }
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
$8f87f3d27d989091$var$DarkModeMonolithStyleOverride.displayName = "DarkModeMonolithStyleOverride";
const $8f87f3d27d989091$export$9daaf42d62e1c430 = (t0)=>{
    const $ = (0, $e7boj.c)(4);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    (0, $euxye.useEffect)($8f87f3d27d989091$var$_temp2, t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8f87f3d27d989091$var$DarkModeMonolithStyleOverride, null);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8f87f3d27d989091$var$Provider, {
            value: true
        }, children));
        $[2] = children;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
};
$8f87f3d27d989091$export$9daaf42d62e1c430.displayName = "EmbedModeProvider";
function $8f87f3d27d989091$var$_temp() {
    window.removeEventListener("click", $8f87f3d27d989091$var$handleEmbedLinkClick);
}
function $8f87f3d27d989091$var$_temp2() {
    window.addEventListener("click", $8f87f3d27d989091$var$handleEmbedLinkClick, true);
    return $8f87f3d27d989091$var$_temp;
}

});



parcelRegister("8ne6A", function(module, exports) {
$parcel$export(module.exports, "Router", () => $89f56c251895bdf8$export$55185c17a0fcbe46);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dR379 = parcelRequire("dR379");

var $9cDER = parcelRequire("9cDER");
const $89f56c251895bdf8$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    const pluginsWithOverride = (0, $9cDER.usePlugins)({
        resourceContext: props.resourceContext,
        resourceData: props.resourceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dR379.Router), {
        plugins: pluginsWithOverride,
        ...props
    }, children);
};
$89f56c251895bdf8$export$55185c17a0fcbe46.displayName = "Router";

});
parcelRegister("9cDER", function(module, exports) {
$parcel$export(module.exports, "usePlugins", () => $2403592aa26c874d$export$c41e96fd89bc6106);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $bI4rf = parcelRequire("bI4rf");

var $aI7em = parcelRequire("aI7em");

var $eijVy = parcelRequire("eijVy");

var $hM8aL = parcelRequire("hM8aL");
const $2403592aa26c874d$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    // make sure "plugins" are created only once, ignore prop change/rerender
    const [pluginsWithOverride] = (0, $euxye.useState)(()=>{
        const jiraPlugins = [];
        const resourcesPlugin = (0, $hM8aL.createResourcesPlugin)({
            context: resourceContext,
            resourceData: resourceData
        });
        jiraPlugins.push(resourcesPlugin);
        jiraPlugins.push((0, $bI4rf.createEntryPointsPlugin)({
            environment: (0, $aI7em.default)(),
            entryPointParams: {
                tenantContext: tenantContext
            }
        }));
        return jiraPlugins;
    });
    return pluginsWithOverride;
};

});
parcelRegister("bI4rf", function(module, exports) {
$parcel$export(module.exports, "createEntryPointsPlugin", () => $1c0afdbdcbb8293a$export$33586718f82f356f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $n67Vb = parcelRequire("n67Vb");

var $5banw = parcelRequire("5banw");

var $69eDJ = parcelRequire("69eDJ");

var $a2zOP = parcelRequire("a2zOP");

var $3nTxb = parcelRequire("3nTxb");

var $9Elv0 = parcelRequire("9Elv0");
const $1c0afdbdcbb8293a$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams, noRootQueries: noRootQueries = false })=>({
        id: 'entry-points-plugin',
        routeLoad: ({ context: context })=>{
            const entryPoint = context.route.entryPoint?.();
            const prefetchingRoute = (0, $69eDJ.getPrefetchingRoute)();
            let entryPointReference = null;
            if (entryPoint) {
                // check if route EntryPoint is already prefetched right before being loaded
                if (prefetchingRoute && (0, $5banw.isSameRouteMatch)({
                    prevContextMatch: prefetchingRoute.routerContext.match,
                    nextContextMatch: context.match
                }) && !(0, $5banw.isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                else {
                    const entryPointParamsWithContext = {
                        context: context,
                        ...entryPointParams
                    };
                    if (false && noRootQueries) {
                        // we can reassign here because SSR has a fresh context for every request
                        const previousGetPreloadProps = entryPoint.getPreloadProps;
                        const getPreloadProps = (params)=>{
                            const preloadProps = previousGetPreloadProps(params);
                            // @ts-expect-error The operand of a 'delete' operator cannot be a read-only property.ts(2704)
                            delete preloadProps.queries;
                            return preloadProps;
                        };
                        // @ts-expect-error Cannot assign to 'getPreloadProps' because it is a read-only property.ts(2540)
                        entryPoint.getPreloadProps = getPreloadProps;
                    }
                    const loadEntryPointsWithContext = ()=>(0, $n67Vb.loadEntryPoint)({
                            getEnvironment: ()=>environment
                        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        entryPoint, entryPointParamsWithContext);
                    entryPointReference = false ? (0, $9Elv0.default)(entryPoint, entryPointParamsWithContext, loadEntryPointsWithContext) : loadEntryPointsWithContext();
                }
            }
            // saving entryPointReference helps to prevent cases when same EntryPoint is fetched multiple times
            // important when fetchPolicy=network-only is used
            (0, $69eDJ.getEntryPointsStore)().actions.setLastLoadedRoute({
                route: context.route,
                entryPointReference: entryPointReference
            });
            return {
                entryPoint: entryPointReference
            };
        },
        routePrefetch: ({ nextContext: nextContext })=>{
            const entryPoint = nextContext.route.entryPoint?.();
            if (entryPoint) {
                const prevPrefetchingRoute = (0, $69eDJ.getPrefetchingRoute)();
                // check if EntryPoint is already prefetched and not expired
                if (prevPrefetchingRoute && (0, $5banw.isSameRouteMatch)({
                    prevContextMatch: prevPrefetchingRoute.routerContext.match,
                    nextContextMatch: nextContext.match
                }) && !(0, $5banw.isExpired)(prevPrefetchingRoute.expiresAt)) return;
                const entryPointReference = (0, $n67Vb.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                entryPoint, {
                    context: nextContext,
                    ...entryPointParams
                });
                (0, $69eDJ.getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: (0, $5banw.getExpiresAt)(),
                    entryPointReference: entryPointReference
                });
            } else (0, $69eDJ.getEntryPointsStore)().actions.setPrefetchingRoute({
                routerContext: nextContext,
                expiresAt: 0,
                entryPointReference: null
            });
        },
        waitForEntryPoint: ()=>{
            const lastLoadedRoute = (0, $69eDJ.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $a2zOP.waitForEntryPoint)(entryPointReference);
            return Promise.resolve();
        },
        getStats: async ()=>{
            const lastLoadedRoute = (0, $69eDJ.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $3nTxb.getEntryPointStats)(entryPointReference);
            return [];
        }
    });

});
parcelRegister("5banw", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $fcd3e27631fd8251$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "isExpired", () => $fcd3e27631fd8251$export$57947cfd429801a2);
$parcel$export(module.exports, "isSameRouteMatch", () => $fcd3e27631fd8251$export$5997e70fc4543270);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $fcd3e27631fd8251$export$37d3126be6549b13 = 10000;
const $fcd3e27631fd8251$export$b65d7ba7fbf150f1 = ()=>$fcd3e27631fd8251$export$37d3126be6549b13 + Date.now();
const $fcd3e27631fd8251$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
const $fcd3e27631fd8251$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $fcd3e27631fd8251$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $fcd3e27631fd8251$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $fcd3e27631fd8251$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});

parcelRegister("69eDJ", function(module, exports) {
$parcel$export(module.exports, "useLastLoadedRoute", () => $a2327206acecff45$export$895238443fc3eae4);
$parcel$export(module.exports, "getEntryPointsStore", () => $a2327206acecff45$export$fe654a734624d17f);
$parcel$export(module.exports, "getLastLoadedRoute", () => $a2327206acecff45$export$5763b2305b3056df);
$parcel$export(module.exports, "getPrefetchingRoute", () => $a2327206acecff45$export$7e18f3e3cbd04326);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
var $ciIbx = parcelRequire("ciIbx");
const $a2327206acecff45$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
        setState({
            lastLoadedRoute: {
                route: route,
                entryPointReference: entryPointReference
            }
        });
    };
const $a2327206acecff45$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
        setState({
            prefetchingRoute: {
                routerContext: routerContext,
                expiresAt: expiresAt,
                entryPointReference: entryPointReference
            }
        });
    };
const $a2327206acecff45$var$actions = {
    setLastLoadedRoute: $a2327206acecff45$export$1cec83a23d40a9fa,
    setPrefetchingRoute: $a2327206acecff45$export$bb3dc9c55f78173e
};
const $a2327206acecff45$var$EntryPointsStore = (0, $5QDqc.createStore)({
    initialState: {
        lastLoadedRoute: null,
        prefetchingRoute: null
    },
    actions: $a2327206acecff45$var$actions,
    name: 'react-resource-router/entry-points'
});
const $a2327206acecff45$export$895238443fc3eae4 = (0, $3h1FP.createHook)($a2327206acecff45$var$EntryPointsStore, {
    selector: (state)=>state.lastLoadedRoute
});
const $a2327206acecff45$export$fe654a734624d17f = ()=>(0, $ciIbx.defaultRegistry).getStore($a2327206acecff45$var$EntryPointsStore);
const $a2327206acecff45$export$b28ecd0e4705f6b7 = ()=>$a2327206acecff45$export$fe654a734624d17f().storeState.getState();
const $a2327206acecff45$export$5763b2305b3056df = ()=>$a2327206acecff45$export$b28ecd0e4705f6b7().lastLoadedRoute;
const $a2327206acecff45$export$7e18f3e3cbd04326 = ()=>$a2327206acecff45$export$b28ecd0e4705f6b7().prefetchingRoute;

});

parcelRegister("a2zOP", function(module, exports) {
$parcel$export(module.exports, "waitForEntryPoint", () => $8df42773236d6d88$export$944f853f194e5dd5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5SJ3N = parcelRequire("5SJ3N");
const $8df42773236d6d88$export$944f853f194e5dd5 = (entryPointConfig)=>{
    const promises = [];
    try {
        entryPointConfig.getComponent();
    } catch (err) {
        if (err instanceof Promise) promises.push(err);
        else throw err;
    }
    const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
    if (queries) Object.keys(queries).forEach((key)=>{
        if (queries[key].id) {
            const queryPromise = (0, $5SJ3N.QueryPromisesMap).get(String(queries[key].id));
            if (queryPromise) promises.push(queryPromise);
        }
    });
    if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
        const nestedEntryPointPromise = $8df42773236d6d88$export$944f853f194e5dd5(entryPoints[key]);
        promises.push(nestedEntryPointPromise);
    });
    return Promise.allSettled(promises);
};

});

parcelRegister("3nTxb", function(module, exports) {
$parcel$export(module.exports, "getEntryPointStats", () => $d26d0a3f3186f214$export$ee016802bdebb378);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5SJ3N = parcelRequire("5SJ3N");
const $d26d0a3f3186f214$export$14ba46fa7bd4c0a9 = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    new Promise((resolve)=>setTimeout(resolve, 0));
const $d26d0a3f3186f214$export$982a0a12103fb99f = async (promise)=>{
    if (!promise) return 'resolved';
    try {
        if (await Promise.race([
            promise,
            Promise.resolve('timeout')
        ]) === 'timeout') return 'pending';
        return 'resolved';
    } catch (e) {
        return 'rejected';
    }
};
const $d26d0a3f3186f214$var$getEntrypointQueryState = async (queryId)=>{
    const queryPromise = (0, $5SJ3N.QueryPromisesMap).get(queryId);
    return {
        queryId: queryId,
        status: await $d26d0a3f3186f214$export$982a0a12103fb99f(queryPromise)
    };
};
const $d26d0a3f3186f214$export$ee016802bdebb378 = (entryPointConfig)=>{
    const result = [];
    const analyseEntrypoint = ({ queries: queries, entryPoints: entryPoints })=>{
        if (queries) Object.keys(queries).forEach((key)=>{
            if (queries[key].id) result.push($d26d0a3f3186f214$var$getEntrypointQueryState(String(queries[key].id)));
        });
        if (entryPoints) Object.entries(entryPoints).forEach(([, entryPoint])=>{
            analyseEntrypoint(entryPoint);
        });
    };
    analyseEntrypoint(entryPointConfig);
    return Promise.all(result);
};

});

parcelRegister("9Elv0", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a2e2140daf3bfbb$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $b3tU7 = parcelRequire("b3tU7");

var $8gHzK = parcelRequire("8gHzK");

var $23nGH = parcelRequire("23nGH");

const $0a2e2140daf3bfbb$var$DummyAsyncModule = (0, $b3tU7.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("23nGH"))), {
    moduleId: "a510115a",
    moduleName: "ReactFragment",
    priority: "userVisible",
    // using a real async import to make the js-resource transformers/babel-plugins happy
    entryFsSsrLiftImportToModule: true
});
$0a2e2140daf3bfbb$var$DummyAsyncModule.getModuleIfRequired = ()=>(0, $23nGH.default); // prevent attempts to fetch the module async at all
/**
 * Run a given loadEntryPoint function without loading the entrypoint modules, then load them right afterwards.
 *
 * This is to prevent triggering the loading of entrypoints modules inline with the data fetching.
 * When JS modules are inline-required (such as in SSR when async modules are converted to inline-requires)
 * this leads to inline-evaluating all dependencies for large component modules before kicking off the data for them.
 * This causes a measurable performance hit (~20-80ms in many cases) before we even kick off critical data fetches.
 *
 * Deferring the module loading until after the data fetching allows the module execution to occur in the less critical
 * idle time while waiting for data fetches to return.
 */ function $0a2e2140daf3bfbb$var$loadEntryPointDataThenModules(entryPoint, entryPointParams, loadEntryPointCallback) {
    const originalModulesByEntrypointRef = new Map();
    (0, $8gHzK.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
        originalModulesByEntrypointRef.set(loopingEntryPoint, loopingEntryPoint.root);
        // eslint-disable-next-line no-param-reassign
        loopingEntryPoint.root = $0a2e2140daf3bfbb$var$DummyAsyncModule;
    });
    try {
        return loadEntryPointCallback();
    } finally{
        (0, $8gHzK.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
            const originalModule = originalModulesByEntrypointRef.get(loopingEntryPoint);
            if (!originalModule) throw new Error('Original module not found for entrypoint');
            // eslint-disable-next-line no-param-reassign
            loopingEntryPoint.root = originalModule;
        });
        // Kicks off the loading of the original modules as they would have, but after the data fetches have been started
        // Without this, entrypoints may have trouble rendering
        // Wrap it in a promise to prevent it from affecting timers that start synchronously after this function
        Promise.resolve().then(()=>originalModulesByEntrypointRef.forEach((entryPointModule)=>{
                const jsModule = entryPointModule.getModuleIfRequired();
                if (jsModule != null) return;
                entryPointModule.load();
            }));
    }
}
var $0a2e2140daf3bfbb$export$2e2bcd8739ae039 = $0a2e2140daf3bfbb$var$loadEntryPointDataThenModules;

});
parcelRegister("b3tU7", function(module, exports) {
$parcel$export(module.exports, "JSResourceForUserVisible", () => $6fd5d7caa3883d90$export$58f934f3d33a84b6);

var $jW8UK = parcelRequire("jW8UK");

var $hkiLZ = parcelRequire("hkiLZ");

var $bCiN9 = parcelRequire("bCiN9");
const $6fd5d7caa3883d90$var$cache = (0, $jW8UK.createCache)(new Map());
/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */ const $6fd5d7caa3883d90$var$RUNTIME_STRING_ERROR = "JSResourceForUserVisible was called with a string path at runtime. Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.";
function $6fd5d7caa3883d90$export$58f934f3d33a84b6(loaderOrPath, opts) {
    if (typeof loaderOrPath === 'string') throw new Error(`${$6fd5d7caa3883d90$var$RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
    return $6fd5d7caa3883d90$var$cache.get(opts.moduleId, ()=>(0, $hkiLZ.PreloadableJSResource)(()=>(0, $bCiN9.postTask)(loaderOrPath, {
                priority: 'user-blocking'
            }), opts));
}

});

parcelRegister("8gHzK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b648c0a015e31293$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Recursively run through all nested entrypoints with a given callback
 */ function $b648c0a015e31293$var$forAllEntryPoints(entryPoint, entryPointParams, callback) {
    callback(entryPoint);
    const preloadProps = entryPoint.getPreloadProps(entryPointParams);
    const entryPoints = preloadProps.entryPoints;
    if (!entryPoints) return;
    Object.values(entryPoints).forEach(({ entryPoint: nestedEntryPoint, entryPointParams: nestedParams })=>{
        if (nestedEntryPoint) $b648c0a015e31293$var$forAllEntryPoints(nestedEntryPoint, nestedParams, callback);
    });
}
var $b648c0a015e31293$export$2e2bcd8739ae039 = $b648c0a015e31293$var$forAllEntryPoints;

});

parcelRegister("23nGH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1cc81fbc357f5ee3$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
const $1cc81fbc357f5ee3$var$ReactFragment = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null);
$1cc81fbc357f5ee3$var$ReactFragment.displayName = "ReactFragment";
var $1cc81fbc357f5ee3$export$2e2bcd8739ae039 = $1cc81fbc357f5ee3$var$ReactFragment;

});



parcelRegister("hM8aL", function(module, exports) {
$parcel$export(module.exports, "createResourcesPlugin", () => $273d9c029e146c66$export$23ed892c481a96fe);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $bYonX = parcelRequire("bYonX");

var $ekivV = parcelRequire("ekivV");
const $273d9c029e146c66$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $273d9c029e146c66$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $bYonX.getResourceStore)().actions;
    const nextResources = (0, $ekivV.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $273d9c029e146c66$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $bYonX.getResourceStore)().actions;
    const nextResources = (0, $ekivV.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $273d9c029e146c66$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout, abortSignal: abortSignal, onlyGetCritical: onlyGetCritical })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $bYonX.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $273d9c029e146c66$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $273d9c029e146c66$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $273d9c029e146c66$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $bYonX.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout,
                abortSignal: abortSignal,
                onlyGetCritical: onlyGetCritical
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $bYonX.getResourceStore)().actions;
            const nextResources = (0, $ekivV.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $bYonX.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("ekivV", function(module, exports) {
$parcel$export(module.exports, "getResourcesForNextLocation", () => $30236f8b2f95a6c0$export$7cbbc763e2f3d65d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $8JUHb = parcelRequire("8JUHb");

var $5sk5x = parcelRequire("5sk5x");
const $30236f8b2f95a6c0$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $5sk5x.routeHasResources)(nextRoute)) return [];
    if ((0, $5sk5x.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $8JUHb.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $8JUHb.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("8JUHb", function(module, exports) {
$parcel$export(module.exports, "getResourceIdentifier", () => $90221f3be83f58aa$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $90221f3be83f58aa$export$cd7fbe7e979df558);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $90221f3be83f58aa$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $90221f3be83f58aa$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$90221f3be83f58aa$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("5sk5x", function(module, exports) {
$parcel$export(module.exports, "routeHasResources", () => $989fd0f28e4f2c5d$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $989fd0f28e4f2c5d$export$221027ff1aa38f82);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $989fd0f28e4f2c5d$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $989fd0f28e4f2c5d$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});





parcelRegister("1Kz0I", function(module, exports) {
$parcel$export(module.exports, "getLegacyRoutes", () => $305ea17d94078fd5$export$26f94fc240f0d1ea);

var $jgKgn = parcelRequire("jgKgn");

var $dUAVJ = parcelRequire("dUAVJ");

var $3nqiL = parcelRequire("3nqiL");

var $gqz9K = parcelRequire("gqz9K");

var $7JnwO = parcelRequire("7JnwO");

var $lFlms = parcelRequire("lFlms");

var $ajwdo = parcelRequire("ajwdo");

var $auoLG = parcelRequire("auoLG");

var $8O1VY = parcelRequire("8O1VY");

var $78ijD = parcelRequire("78ijD");

var $1qUc0 = parcelRequire("1qUc0");

var $1opJ9 = parcelRequire("1opJ9");

var $hrL3w = parcelRequire("hrL3w");

var $7fPuI = parcelRequire("7fPuI");

var $eJtkZ = parcelRequire("eJtkZ");

var $5Naso = parcelRequire("5Naso");

var $fY8eK = parcelRequire("fY8eK");

var $kTa4D = parcelRequire("kTa4D");

var $f1oFM = parcelRequire("f1oFM");

var $fLdFG = parcelRequire("fLdFG");

var $cD61N = parcelRequire("cD61N");

var $ckOZs = parcelRequire("ckOZs");

var $jzdNk = parcelRequire("jzdNk");

var $3v29r = parcelRequire("3v29r");

var $doQ2O = parcelRequire("doQ2O");

var $caU9k = parcelRequire("caU9k");

var $3LYK3 = parcelRequire("3LYK3");

var $htiWf = parcelRequire("htiWf");

var $6ID3Q = parcelRequire("6ID3Q");

var $5bE97 = parcelRequire("5bE97");

var $6gNBE = parcelRequire("6gNBE");

var $3zWky = parcelRequire("3zWky");

var $30rWu = parcelRequire("30rWu");

var $dTFMY = parcelRequire("dTFMY");

var $gJID9 = parcelRequire("gJID9");

var $efN9m = parcelRequire("efN9m");

var $kBLya = parcelRequire("kBLya");

var $cMINT = parcelRequire("cMINT");

var $3sRzJ = parcelRequire("3sRzJ");

var $1ltG6 = parcelRequire("1ltG6");

var $7u3Zl = parcelRequire("7u3Zl");

var $hu3le = parcelRequire("hu3le");

var $ifpKr = parcelRequire("ifpKr");

var $U4h2T = parcelRequire("U4h2T");

var $2HqSW = parcelRequire("2HqSW");

var $loTvH = parcelRequire("loTvH");

var $lUAuS = parcelRequire("lUAuS");

var $eBZvu = parcelRequire("eBZvu");

var $jbRqn = parcelRequire("jbRqn");

var $1ZysQ = parcelRequire("1ZysQ");

var $co3sd = parcelRequire("co3sd");

var $eI6YQ = parcelRequire("eI6YQ");

var $cGjN7 = parcelRequire("cGjN7");

var $kemwP = parcelRequire("kemwP");

var $hTsSv = parcelRequire("hTsSv");

var $eGsYp = parcelRequire("eGsYp");

var $g1dQr = parcelRequire("g1dQr");

var $fUhId = parcelRequire("fUhId");

var $kykBP = parcelRequire("kykBP");

var $aReKf = parcelRequire("aReKf");

var $fTKsQ = parcelRequire("fTKsQ");

var $laSUo = parcelRequire("laSUo");

var $bPBIG = parcelRequire("bPBIG");

var $2AMNJ = parcelRequire("2AMNJ");

var $i2RxH = parcelRequire("i2RxH");

var $hNa9g = parcelRequire("hNa9g");

var $2grim = parcelRequire("2grim");

var $5AfrI = parcelRequire("5AfrI");

var $1wNrH = parcelRequire("1wNrH");

var $hYZCI = parcelRequire("hYZCI");

var $jAJHa = parcelRequire("jAJHa");

var $3y2tU = parcelRequire("3y2tU");

var $3t2Qp = parcelRequire("3t2Qp");

var $cZVSE = parcelRequire("cZVSE");

var $baP9D = parcelRequire("baP9D");

var $6PNEb = parcelRequire("6PNEb");

var $jiZlp = parcelRequire("jiZlp");

var $5fmu9 = parcelRequire("5fmu9");

var $9B1Cv = parcelRequire("9B1Cv");

var $geED8 = parcelRequire("geED8");

var $iNCEc = parcelRequire("iNCEc");

var $iXdWk = parcelRequire("iXdWk");

var $hbUuC = parcelRequire("hbUuC");

var $9P9Xc = parcelRequire("9P9Xc");

var $joziY = parcelRequire("joziY");

var $3rsEg = parcelRequire("3rsEg");

var $9GNI6 = parcelRequire("9GNI6");

var $exF2p = parcelRequire("exF2p");

var $39LMV = parcelRequire("39LMV");

var $4sZGX = parcelRequire("4sZGX");

var $95Slt = parcelRequire("95Slt");

var $1ZCfi = parcelRequire("1ZCfi");

var $asNKg = parcelRequire("asNKg");

var $b41Q3 = parcelRequire("b41Q3");

var $evO77 = parcelRequire("evO77");

var $kSZwk = parcelRequire("kSZwk");

var $cqiXy = parcelRequire("cqiXy");

var $aRDx7 = parcelRequire("aRDx7");

var $3lXoH = parcelRequire("3lXoH");

var $2g3Yz = parcelRequire("2g3Yz");

var $8f6PB = parcelRequire("8f6PB");

var $29YCR = parcelRequire("29YCR");

var $n1WJ6 = parcelRequire("n1WJ6");

var $5BBN1 = parcelRequire("5BBN1");

var $7rO2n = parcelRequire("7rO2n");

var $4jrXk = parcelRequire("4jrXk");

var $esz7A = parcelRequire("esz7A");

var $jY3PM = parcelRequire("jY3PM");

var $eQs3z = parcelRequire("eQs3z");

var $9YCF1 = parcelRequire("9YCF1");

var $dq2pp = parcelRequire("dq2pp");

var $fyGsD = parcelRequire("fyGsD");

var $768jg = parcelRequire("768jg");

var $lezMn = parcelRequire("lezMn");

var $9mbEK = parcelRequire("9mbEK");

var $cciGB = parcelRequire("cciGB");

var $jZqzF = parcelRequire("jZqzF");

var $kUjbH = parcelRequire("kUjbH");

var $elDq0 = parcelRequire("elDq0");

var $eaR7Y = parcelRequire("eaR7Y");

var $ebPIX = parcelRequire("ebPIX");

var $aY5o9 = parcelRequire("aY5o9");

var $hP5Qs = parcelRequire("hP5Qs");

var $e9m2Q = parcelRequire("e9m2Q");

var $io0Bj = parcelRequire("io0Bj");

var $hDa1Q = parcelRequire("hDa1Q");

var $dmLxe = parcelRequire("dmLxe");

var $9XJ7h = parcelRequire("9XJ7h");

var $3jgZv = parcelRequire("3jgZv");

var $8P2o9 = parcelRequire("8P2o9");

var $asISc = parcelRequire("asISc");

var $8ITOT = parcelRequire("8ITOT");

var $7HddY = parcelRequire("7HddY");

var $2pSk9 = parcelRequire("2pSk9");

var $fabUY = parcelRequire("fabUY");

var $kocek = parcelRequire("kocek");

var $6j327 = parcelRequire("6j327");

var $1jjv8 = parcelRequire("1jjv8");

var $aL1PW = parcelRequire("aL1PW");

var $1QN9p = parcelRequire("1QN9p");

var $95uPH = parcelRequire("95uPH");

var $2tcJe = parcelRequire("2tcJe");

var $bFG83 = parcelRequire("bFG83");

var $5Mdex = parcelRequire("5Mdex");

var $2O9uH = parcelRequire("2O9uH");

var $11URR = parcelRequire("11URR");

var $bFK7A = parcelRequire("bFK7A");

var $2Au8F = parcelRequire("2Au8F");

var $d4mwq = parcelRequire("d4mwq");

var $jTFD9 = parcelRequire("jTFD9");

var $9fUdF = parcelRequire("9fUdF");

var $cv4YG = parcelRequire("cv4YG");

var $8XBBM = parcelRequire("8XBBM");

var $8EnHk = parcelRequire("8EnHk");

var $7RK2U = parcelRequire("7RK2U");

var $55mKT = parcelRequire("55mKT");

var $2GqiU = parcelRequire("2GqiU");

var $e6oMB = parcelRequire("e6oMB");

var $eG5Le = parcelRequire("eG5Le");

var $dYuJK = parcelRequire("dYuJK");

var $aaX32 = parcelRequire("aaX32");

var $gdNuu = parcelRequire("gdNuu");

var $8Kxny = parcelRequire("8Kxny");

var $aPF7E = parcelRequire("aPF7E");

var $fMd2L = parcelRequire("fMd2L");

var $lMDYc = parcelRequire("lMDYc");

var $i2zMv = parcelRequire("i2zMv");

var $aRQu2 = parcelRequire("aRQu2");

var $iYaRr = parcelRequire("iYaRr");

var $laFWx = parcelRequire("laFWx");

var $duH5l = parcelRequire("duH5l");

var $2ukJV = parcelRequire("2ukJV");

var $gaJih = parcelRequire("gaJih");

var $kLjoD = parcelRequire("kLjoD");

var $cUhcT = parcelRequire("cUhcT");

var $4tNmK = parcelRequire("4tNmK");

var $h8xRL = parcelRequire("h8xRL");

var $1ucf9 = parcelRequire("1ucf9");

var $eARLQ = parcelRequire("eARLQ");

var $YOorc = parcelRequire("YOorc");

var $adSUz = parcelRequire("adSUz");

var $fvZgQ = parcelRequire("fvZgQ");

var $7jqZS = parcelRequire("7jqZS");

var $8s72u = parcelRequire("8s72u");

var $ubzD2 = parcelRequire("ubzD2");

var $db4nQ = parcelRequire("db4nQ");

var $fF15b = parcelRequire("fF15b");

var $3QYIv = parcelRequire("3QYIv");

var $9uPfN = parcelRequire("9uPfN");

var $45iTN = parcelRequire("45iTN");

var $JzqF5 = parcelRequire("JzqF5");

var $94CbD = parcelRequire("94CbD");

var $6bddx = parcelRequire("6bddx");

var $j8wld = parcelRequire("j8wld");

var $2FaMe = parcelRequire("2FaMe");

var $k1iFS = parcelRequire("k1iFS");

var $61E30 = parcelRequire("61E30");

var $hs0xZ = parcelRequire("hs0xZ");

var $aAm2A = parcelRequire("aAm2A");

var $7qJ0o = parcelRequire("7qJ0o");

var $7f3Kh = parcelRequire("7f3Kh");

var $6aBi2 = parcelRequire("6aBi2");

var $aDxZo = parcelRequire("aDxZo");

var $eEZR5 = parcelRequire("eEZR5");

var $cP32J = parcelRequire("cP32J");

var $6uqex = parcelRequire("6uqex");

var $dpTws = parcelRequire("dpTws");

var $73adx = parcelRequire("73adx");

var $83ssL = parcelRequire("83ssL");

var $bOoZ2 = parcelRequire("bOoZ2");

var $7zjhm = parcelRequire("7zjhm");

var $idrEX = parcelRequire("idrEX");

var $8878Q = parcelRequire("8878Q");

var $gyLf0 = parcelRequire("gyLf0");

var $c4S0u = parcelRequire("c4S0u");

var $4sniJ = parcelRequire("4sniJ");

var $49rDJ = parcelRequire("49rDJ");

var $cU02I = parcelRequire("cU02I");

var $1mijV = parcelRequire("1mijV");

var $1MtFP = parcelRequire("1MtFP");

var $dLDM6 = parcelRequire("dLDM6");

var $61QLs = parcelRequire("61QLs");

var $9t5jK = parcelRequire("9t5jK");

var $fk68B = parcelRequire("fk68B");

var $1AwwG = parcelRequire("1AwwG");

var $04283 = parcelRequire("04283");

var $1reFg = parcelRequire("1reFg");

var $7ZJjr = parcelRequire("7ZJjr");

var $c60M9 = parcelRequire("c60M9");

var $6IKVr = parcelRequire("6IKVr");

var $5cBHj = parcelRequire("5cBHj");

var $2FJmX = parcelRequire("2FJmX");

var $dj99j = parcelRequire("dj99j");

var $iGXIF = parcelRequire("iGXIF");

var $4qVxm = parcelRequire("4qVxm");

var $csmia = parcelRequire("csmia");

var $2yJmz = parcelRequire("2yJmz");

var $867Dv = parcelRequire("867Dv");

var $irpl4 = parcelRequire("irpl4");

var $4GDGP = parcelRequire("4GDGP");

var $c6bw5 = parcelRequire("c6bw5");

var $4gpLH = parcelRequire("4gpLH");

var $ijqNS = parcelRequire("ijqNS");

var $9T0hP = parcelRequire("9T0hP");

var $ejYph = parcelRequire("ejYph");

var $cZi34 = parcelRequire("cZi34");

var $gIdlD = parcelRequire("gIdlD");

var $l5KMO = parcelRequire("l5KMO");

var $2JHo8 = parcelRequire("2JHo8");

var $dlYaD = parcelRequire("dlYaD");

var $1t5M5 = parcelRequire("1t5M5");

var $jA4Aa = parcelRequire("jA4Aa");

var $3AkRh = parcelRequire("3AkRh");

var $5MNay = parcelRequire("5MNay");
const $305ea17d94078fd5$export$d47aca795954578 = ()=>[
        (0, $61E30.legacyJsdGettingStartedRouteEntry),
        (0, $k1iFS.legacyJsdCustomersRouteEntry),
        (0, $aAm2A.legacyJsdKnowledgeRouteEntry),
        (0, $7f3Kh.legacyJsdQueuesManageRouteEntry),
        (0, $7qJ0o.legacyJsdQueuesRouteEntry),
        (0, $6aBi2.legacyJsdReportsCustomRouteEntry),
        (0, $aDxZo.legacyJsdReportsRouteEntry),
        (0, $cP32J.legacyJsdSettingsLanguageRouteEntry),
        (0, $6uqex.legacyJsdSettingsLanguagePagesRouteEntry),
        (0, $hs0xZ.legacyJsdJiraAutomationRouteEntry),
        (0, $dpTws.legacyJsdWidgetsRouteEntry),
        (0, $eEZR5.legacyJsdSettingsFallbackRouteEntry),
        (0, $1qUc0.legacyCustomReportRouteEntry),
        (0, $lFlms.legacyBacklogRouteEntry),
        (0, $ajwdo.legacyBoardRapidViewRouteEntry),
        (0, $auoLG.legacyBoardRouteEntry),
        (0, $7JnwO.legacyAllReportsRouteEntry),
        (0, $efN9m.globalIssueNavigatorRouteEntry),
        (0, $dTFMY.globalIssueNavigatorBrowseRouteEntry),
        (0, $gJID9.globalIssueNavigatorRedirectRouteEntry),
        (0, $2FaMe.legacyIssueRouteEntry),
        (0, $83ssL.legacyPinRouteEntry),
        (0, $8878Q.legacyProjectReleasesRouteEntry),
        (0, $c4S0u.legacyProjectReleasesNoteRouteEntry),
        (0, $gyLf0.legacyProjectReleasesNoteConfigRouteEntry),
        (0, $idrEX.legacyProjectReleasesBambooRouteEntry),
        (0, $c6bw5.legacyReportsAverageAgeRouteEntry),
        (0, $ijqNS.legacyReportsCreatedVsResolvedRouteEntry),
        (0, $ejYph.legacyReportsPieRouteEntry),
        (0, $cZi34.legacyReportsRecentlyCreatedRouteEntry),
        (0, $gIdlD.legacyReportsResolutionTimeRouteEntry),
        (0, $l5KMO.legacyReportsSingleLevelGroupByRouteEntry),
        (0, $2JHo8.legacyReportsTimeSinceRouteEntry),
        (0, $dlYaD.legacyReportsTimeTrackingReportRouteEntry),
        (0, $9T0hP.legacyReportsDeveloperWorkloadRouteEntry),
        (0, $1t5M5.legacyReportsVersionWorkloadRouteEntry),
        (0, $jA4Aa.legacyReportsWorkloadPieRouteEntry),
        (0, $4gpLH.legacyReportsConfigRouteEntry),
        (0, $78ijD.legacyConnectProjectRouteEntry),
        (0, $iGXIF.legacyProjectSettingsPeopleRouteEntry),
        (0, $867Dv.legacyProjectSettingsSummaryRouteEntry),
        (0, $6IKVr.legacyProjectSettingsIssueTypesRouteEntry),
        (0, $c60M9.legacyProjectSettingsIssueTypesAssociateRouteEntry),
        (0, $04283.legacyProjectSettingsIssueLayoutRouteEntry),
        (0, $4GDGP.legacyProjectSettingsWorkflowsRouteEntry),
        (0, $irpl4.legacyProjectSettingsWorkflowsAssociateRouteEntry),
        (0, $2yJmz.legacyProjectSettingsScreensRouteEntry),
        (0, $csmia.legacyProjectSettingsScreensAssociateRouteEntry),
        (0, $1AwwG.legacyProjectSettingsFieldsRouteEntry),
        (0, $fk68B.legacyProjectSettingsFieldsAssociateRouteEntry),
        (0, $dj99j.legacyProjectSettingsOpsgenieRouteEntry),
        (0, $4qVxm.legacyProjectSettingsPermissionsRouteEntry),
        (0, $7ZJjr.legacyProjectSettingsIssueSecurityRouteEntry),
        (0, $1reFg.legacyProjectSettingsIssueSecurityAssociateRouteEntry),
        (0, $2FJmX.legacyProjectSettingsNotificationsRouteEntry),
        (0, $5cBHj.legacyProjectSettingsNotificationsAssociateRouteEntry),
        (0, $1MtFP.legacyProjectSettingsConfigRouteEntry),
        (0, $9t5jK.legacyProjectSettingsEditRouteEntry),
        (0, $dLDM6.legacyProjectSettingsDeleteRouteEntry),
        (0, $49rDJ.legacyProjectSettingsCollectorsRouteEntry),
        (0, $4sniJ.legacyProjectSettingsCollectorsAddRouteEntry),
        (0, $cU02I.legacyProjectSettingsCollectorsHelpRouteEntry),
        (0, $1mijV.legacyProjectSettingsCollectorsViewRouteEntry),
        (0, $61QLs.legacyProjectSettingsDevRouteEntry),
        (0, $hrL3w.legacyDashboardsConfigureRouteEntry),
        (0, $eJtkZ.dashboardsDirectoryRouteEntry),
        (0, $1opJ9.legacyDashboardsAddRouteEntry),
        (0, $5Naso.legacyDashboardsEditRouteEntry),
        (0, $7fPuI.legacyDashboardsDeleteRouteEntry),
        (0, $fY8eK.legacyDashboardsRestoreRouteEntry),
        (0, $htiWf.legacyGinManageRouteEntry),
        (0, $cD61N.legacyGinBulkeditRouteEntry),
        (0, $fLdFG.legacyGinBulkRouteEntry),
        (0, $3LYK3.legacyGinIssueMoveRouteEntry),
        (0, $6gNBE.legacyGinSubtaskActionRouteEntry),
        (0, $jzdNk.legacyGinIssueCloneRouteEntry),
        (0, $ckOZs.legacyGinIssueAssignRouteEntry),
        (0, $doQ2O.legacyGinIssueCreateRouteEntry),
        (0, $3v29r.legacyGinIssueConvertRouteEntry),
        (0, $caU9k.legacyGinIssueEditRouteEntry),
        (0, $3zWky.legacyGinWatchersIssueRouteEntry),
        (0, $f1oFM.legacyGinActionRouteEntry),
        (0, $5bE97.legacyGinSubscriptionsRouteEntry),
        (0, $6ID3Q.legacyGinSubscriptionEditRouteEntry),
        (0, $bOoZ2.legacyPortfolioPagesRouteEntry),
        (0, $7zjhm.legacyPortfolioTeamRouteEntry),
        (0, $d4mwq.globalSettingsSystemApplicationViewRouteEntry),
        (0, $bFK7A.globalSettingsSystemApplicationAdvancedRouteEntry),
        (0, $2Au8F.globalSettingsSystemApplicationEditRouteEntry),
        (0, $9fUdF.globalSettingsSystemAuditingRouteEntry),
        (0, $3QYIv.globalSettingsSystemRolesViewRouteEntry),
        (0, $fF15b.globalSettingsSystemRolesUsageRouteEntry),
        (0, $fvZgQ.globalSettingsSystemRolesActorsRouteEntry),
        (0, $7jqZS.globalSettingsSystemRolesActorsGroupsRouteEntry),
        (0, $8s72u.globalSettingsSystemRolesActorsUsersRouteEntry),
        (0, $db4nQ.globalSettingsSystemRolesEditRouteEntry),
        (0, $ubzD2.globalSettingsSystemRolesDeleteRouteEntry),
        (0, $YOorc.globalSettingsSystemProjectDeleteRouteEntry),
        (0, $eARLQ.globalSettingsSystemProjectAssignSecurityRouteEntry),
        (0, $1ucf9.globalSettingsSystemPermissionsRouteEntry),
        (0, $cv4YG.globalSettingsSystemCollectorsRouteEntry),
        (0, $8XBBM.globalSettingsSystemDefaultSettingsRouteEntry),
        (0, $laFWx.globalSettingsSystemLookRouteEntry),
        (0, $e6oMB.globalSettingsSystemExportRouteEntry),
        (0, $eG5Le.globalSettingsSystemGlobalPermissionsRouteEntry),
        (0, $fMd2L.globalSettingsSystemImportExternalRouteEntry),
        (0, $lMDYc.globalSettingsSystemImportExternalPagesRouteEntry),
        (0, $aPF7E.globalSettingsSystemImportCsvRouteEntry),
        (0, $i2zMv.globalSettingsSystemImportJsonRouteEntry),
        (0, $aRQu2.globalSettingsSystemImportTrelloRouteEntry),
        (0, $8Kxny.globalSettingsSystemImportCloudRouteEntry),
        (0, $gdNuu.globalSettingsSystemImportBulkRouteEntry),
        (0, $30rWu.globalAutomationRouteEntry),
        (0, $4tNmK.globalSettingsSystemMailSettingsRouteEntry),
        (0, $kLjoD.globalSettingsSystemMailOutgoingRouteEntry),
        (0, $2ukJV.globalSettingsSystemMailDeleteMailHandlerRouteEntry),
        (0, $gaJih.globalSettingsSystemMailIncomingRouteEntry),
        (0, $duH5l.globalSettingsSystemMailAddRouteEntry),
        (0, $h8xRL.globalSettingsSystemMailVerifyRouteEntry),
        (0, $cUhcT.globalSettingsSystemMailSendRouteEntry),
        (0, $aaX32.globalSettingsSystemHelperPermissionRouteEntry),
        (0, $dYuJK.globalSettingsSystemHelperNotificationRouteEntry),
        (0, $JzqF5.globalSettingsSystemSharedFiltersRouteEntry),
        (0, $45iTN.globalSettingsSystemSharedDashboardsRouteEntry),
        (0, $jTFD9.globalSettingsSystemAttachmentsRouteEntry),
        (0, $2GqiU.globalSettingsSystemEventsRouteEntry),
        (0, $8EnHk.globalSettingsSystemEventsAddRouteEntry),
        (0, $7RK2U.globalSettingsSystemEventsDeleteRouteEntry),
        (0, $55mKT.globalSettingsSystemEventsEditRouteEntry),
        (0, $94CbD.globalSettingsSystemUserInterfaceDashboardEditRouteEntry),
        (0, $6bddx.globalSettingsSystemUserInterfacePreferencesRouteEntry),
        (0, $j8wld.globalSettingsSystemWebhooksRouteEntry),
        (0, $9uPfN.globalSettingsSystemServicesRouteEntry),
        (0, $iYaRr.globalSettingsSystemLexorankRouteEntry),
        (0, $fabUY.globalSettingsProductsAccessRouteEntry),
        (0, $bFG83.globalSettingsProductsSoftwareConfigRouteEntry),
        (0, $kocek.globalSettingsProductsAdvancedRoadmapsHierarchyRouteEntry),
        (0, $95uPH.globalSettingsProductsSdconfigRouteEntry),
        (0, $2tcJe.globalSettingsProductsSdmailRouteEntry),
        (0, $6j327.globalSettingsProductsApplinksRouteEntry),
        (0, $aL1PW.globalSettingsProductsDvcsRouteEntry),
        (0, $1jjv8.globalSettingsProductsDvcsBitbucketRouteEntry),
        (0, $1QN9p.globalSettingsProductsJsdStatusRouteEntry),
        (0, $11URR.globalSettingsProjectsCategoriesViewRouteEntry),
        (0, $2O9uH.globalSettingsProjectsCategoriesEditRouteEntry),
        (0, $5Mdex.globalSettingsProjectsCategoriesDeleteRouteEntry),
        (0, $elDq0.globalSettingsIssuesTypesEditRouteEntry),
        (0, $kUjbH.globalSettingsIssuesTypesDeleteRouteEntry),
        (0, $eaR7Y.globalSettingsIssuesTypesMigrateRouteEntry),
        (0, $8P2o9.globalSettingsIssuesTypesTranslationsRouteEntry),
        (0, $e9m2Q.globalSettingsIssuesTypesSchemesOptionRouteEntry),
        (0, $ebPIX.globalSettingsIssuesTypesSchemesAssociateDefaultRouteEntry),
        (0, $aY5o9.globalSettingsIssuesTypesSchemesAssociateRouteEntry),
        (0, $hP5Qs.globalSettingsIssuesTypesSchemesOptionDeleteRouteEntry),
        (0, $ifpKr.globalSettingsIssueSubtasksRouteEntry),
        (0, $9mbEK.globalSettingsIssuesSubtasksDisableRouteEntry),
        (0, $cciGB.globalSettingsIssuesSubtasksEditRouteEntry),
        (0, $jZqzF.globalSettingsIssuesSubtasksTranlationsRouteEntry),
        (0, $3AkRh.workflowDesignerRouteEntry),
        (0, $2HqSW.globalSettingsIssueWorkflowRouteEntry),
        (0, $8ITOT.globalSettingsIssuesWorkflowTransitionRouteEntry),
        (0, $asISc.globalSettingsIssuesWorkflowTransitionMetaAttributesRouteEntry),
        (0, $7HddY.globalSettingsIssuesWorkflowsImportRouteEntry),
        (0, $loTvH.globalSettingsIssueWorkflowSchemesRouteEntry),
        (0, $2pSk9.globalSettingsIssuesWorkflowsSchemesEditRouteEntry),
        (0, $i2RxH.globalSettingsIssuesFieldViewRouteEntry),
        (0, $cGjN7.globalSettingsIssuesFieldAddRouteEntry),
        (0, $hTsSv.globalSettingsIssuesFieldConfigureRouteEntry),
        (0, $kemwP.globalSettingsIssuesFieldConfigureEditRouteEntry),
        (0, $fUhId.globalSettingsIssuesFieldEditRouteEntry),
        (0, $eGsYp.globalSettingsIssuesFieldCopyRouteEntry),
        (0, $g1dQr.globalSettingsIssuesFieldDeleteRouteEntry),
        (0, $kykBP.globalSettingsIssuesFieldSchemesAddRouteEntry),
        (0, $aReKf.globalSettingsIssuesFieldSchemesConfigureRouteEntry),
        (0, $bPBIG.globalSettingsIssuesFieldSchemesEditRouteEntry),
        (0, $2AMNJ.globalSettingsIssuesFieldSchemesEditItemRouteEntry),
        (0, $fTKsQ.globalSettingsIssuesFieldSchemesCopyRouteEntry),
        (0, $laSUo.globalSettingsIssuesFieldSchemesDeleteRouteEntry),
        (0, $io0Bj.globalSettingsIssuesTypesScreenSchemesConfigureRouteEntry),
        (0, $3jgZv.globalSettingsIssuesTypesScreenSchemesEntityRouteEntry),
        (0, $9XJ7h.globalSettingsIssuesTypesScreenSchemesEditRouteEntry),
        (0, $hDa1Q.globalSettingsIssuesTypesScreenSchemesCopyRouteEntry),
        (0, $dmLxe.globalSettingsIssuesTypesScreenSchemesDeleteRouteEntry),
        (0, $1ltG6.globalSettingsCustomFieldsRouteEntry),
        (0, $eBZvu.globalSettingsIssuesCustomFieldsConfigRouteEntry),
        (0, $1ZysQ.globalSettingsIssuesCustomFieldsEditRouteEntry),
        (0, $eI6YQ.globalSettingsIssuesCustomFieldsTranslateRouteEntry),
        (0, $jbRqn.globalSettingsIssuesCustomFieldsDeleteRouteEntry),
        (0, $co3sd.globalSettingsIssuesCustomFieldsManageRouteEntry),
        (0, $lUAuS.globalSettingsIssuesCustomFieldsAssociateRouteEntry),
        (0, $3nqiL.globalSettingsIssuesExplicitFieldAssociationRouteEntry),
        (0, $hu3le.globalSettingsFieldLayoutsRouteEntry),
        (0, $hNa9g.globalSettingsIssuesFieldlayoutsConfigRouteEntry),
        (0, $baP9D.globalSettingsIssuesFieldviewRouteEntry),
        (0, $2grim.globalSettingsIssuesFieldlayoutsCopyRouteEntry),
        (0, $1wNrH.globalSettingsIssuesFieldlayoutsEditRouteEntry),
        (0, $5AfrI.globalSettingsIssuesFieldlayoutsDeleteRouteEntry),
        (0, $7u3Zl.globalSettingsFieldLayoutSchemesRouteEntry),
        (0, $hYZCI.globalSettingsIssuesFieldlayoutsSchemesConfigRouteEntry),
        (0, $cZVSE.globalSettingsIssuesFieldlayoutsSchemesEntityRouteEntry),
        (0, $jAJHa.globalSettingsIssuesFieldlayoutsSchemesCopyRouteEntry),
        (0, $3t2Qp.globalSettingsIssuesFieldlayoutsSchemesEditRouteEntry),
        (0, $3y2tU.globalSettingsIssuesFieldlayoutsSchemesDeleteRouteEntry),
        (0, $U4h2T.globalSettingsIssueTimeTrackingRouteEntry),
        (0, $9B1Cv.globalSettingsIssuesLinkTypesRouteEntry),
        (0, $jiZlp.globalSettingsIssuesLinkTypesActivateRouteEntry),
        (0, $5fmu9.globalSettingsIssuesLinkTypesDeactivateRouteEntry),
        (0, $iNCEc.globalSettingsIssuesLinktypesEditRouteEntry),
        (0, $geED8.globalSettingsIssuesLinktypesDeleteRouteEntry),
        (0, $768jg.globalSettingsIssuesStatusesRouteEntry),
        (0, $lezMn.globalSettingsIssuesStatusesTranslationsRouteEntry),
        (0, $n1WJ6.globalSettingsIssuesResolutionsRouteEntry),
        (0, $5BBN1.globalSettingsIssuesResolutionsTranslationsRouteEntry),
        (0, $2g3Yz.globalSettingsIssuesResolutionsDefaultRouteEntry),
        (0, $29YCR.globalSettingsIssuesResolutionsEditRouteEntry),
        (0, $8f6PB.globalSettingsIssuesResolutionsDeleteRouteEntry),
        (0, $aRDx7.globalSettingsIssuesPrioritiesRouteEntry),
        (0, $3lXoH.globalSettingsIssuesPrioritiesTranslationsRouteEntry),
        (0, $6PNEb.globalSettingsIssuesGeneralTranslationsRouteEntry),
        (0, $cqiXy.globalSettingsIssuesPrioritiesEditRouteEntry),
        (0, $kSZwk.globalSettingsIssuesPrioritiesDeleteRouteEntry),
        (0, $evO77.globalSettingsIssuesPrioritiesDefaultRouteEntry),
        (0, $fyGsD.globalSettingsIssuesSecuritySchemesRouteEntry),
        (0, $7rO2n.globalSettingsIssuesSecurityEditRouteEntry),
        (0, $4jrXk.globalSettingsIssuesSecurityLevelAddRouteEntry),
        (0, $jY3PM.globalSettingsIssuesSecurityLevelEditRouteEntry),
        (0, $esz7A.globalSettingsIssuesSecurityLevelDeleteRouteEntry),
        (0, $eQs3z.globalSettingsIssuesSecuritySchemesAddRouteEntry),
        (0, $dq2pp.globalSettingsIssuesSecuritySchemesEditRouteEntry),
        (0, $9YCF1.globalSettingsIssuesSecuritySchemesDeleteRouteEntry),
        (0, $exF2p.globalSettingsIssuesNotificationViewRouteEntry),
        (0, $joziY.globalSettingsIssuesNotificationSchemeAddRouteEntry),
        (0, $9GNI6.globalSettingsIssuesNotificationSchemeEditRouteEntry),
        (0, $3rsEg.globalSettingsIssuesNotificationSchemeDeleteRouteEntry),
        (0, $iXdWk.globalSettingsIssuesNotificationAddRouteEntry),
        (0, $9P9Xc.globalSettingsIssuesNotificationEditRouteEntry),
        (0, $hbUuC.globalSettingsIssuesNotificationDeleteRouteEntry),
        (0, $asNKg.globalSettingsIssuesPermissionsSchemesRouteEntry),
        (0, $4sZGX.globalSettingsIssuesPermissionsSchemesAddRouteEntry),
        (0, $39LMV.globalSettingsIssuesPermissionsEditRouteEntry),
        (0, $1ZCfi.globalSettingsIssuesPermissionsSchemesEditRouteEntry),
        (0, $b41Q3.globalSettingsIssuesPermissionsSchemesProjectRouteEntry),
        (0, $95Slt.globalSettingsIssuesPermissionsSchemesDeleteRouteEntry),
        (0, $gqz9K.addonsEmceePublicRouteEntry),
        (0, $cMINT.emceeAppRouteEntry),
        (0, $3sRzJ.manageAppsRouteEntry),
        (0, $kBLya.globalSettingsAddonsOauthRouteEntry),
        (0, $adSUz.globalSettingsSystemProjectSelectRouteEntry),
        (0, $73adx.legacyPersonalSettingsAccessTokensRouteEntry),
        (0, $8O1VY.legacyConnectGeneralRouteEntry),
        (0, $kTa4D.legacyFallbackRouteEntry)
    ];
const $305ea17d94078fd5$export$26f94fc240f0d1ea = ()=>$305ea17d94078fd5$export$d47aca795954578().map((0, $5MNay.default)).map((route)=>({
            ...route,
            group: 'legacy',
            component: route.component || (0, $jgKgn.LegacyPage),
            resources: [
                ...new Set([
                    ...(0, $dUAVJ.getNavigationResources)(),
                    ...route.resources ? route.resources : []
                ])
            ]
        }));

});
parcelRegister("jgKgn", function(module, exports) {
$parcel$export(module.exports, "LegacyPage", () => $cecd977aa6c578c3$export$273311ee2c946a58);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $ccFO3 = parcelRequire("ccFO3");
const $cecd977aa6c578c3$export$273311ee2c946a58 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ccFO3.SpaStateResetPage), {
        match: props.match,
        action: props.action,
        route: props.route,
        isSpa: false
    }));
$cecd977aa6c578c3$export$273311ee2c946a58.displayName = "LegacyPage";
var $cecd977aa6c578c3$export$2e2bcd8739ae039 = $cecd977aa6c578c3$export$273311ee2c946a58;

});
parcelRegister("ccFO3", function(module, exports) {
$parcel$export(module.exports, "SpaStateResetPage", () => $8bdbd0297ad44b85$export$560b6ed340766c4b);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $fcq2N = parcelRequire("fcq2N");

var $iGu4q = parcelRequire("iGu4q");

var $6Bw3S = parcelRequire("6Bw3S");

var $f7hYg = parcelRequire("f7hYg");

var $9H3WG = parcelRequire("9H3WG");
const $8bdbd0297ad44b85$export$3dfa91988c213fbc = (0, $iGu4q.createSubscriber)((0, $6Bw3S.default), {
    selector: null
});
class $8bdbd0297ad44b85$export$560b6ed340766c4b extends (0, $euxye.Component) {
    shouldComponentUpdate(nextProps) {
        const cleanMatch = (0, $f7hYg.getApdexMatchObject)(this.props.match, this.props.route);
        const cleanNextMatch = (0, $f7hYg.getApdexMatchObject)(nextProps.match, nextProps.route);
        return !(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(cleanMatch, cleanNextMatch);
    }
    render() {
        const { action: action, match: match, route: route, isSpa: isSpa } = this.props;
        const shouldNotUpdate = action === 'REPLACE' && (!isSpa || route.name === 'issue-navigator');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8bdbd0297ad44b85$export$3dfa91988c213fbc, null, (_, { resetCurrentPage: resetCurrentPage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9H3WG.default), {
                resetCurrentPage: shouldNotUpdate ? (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))) : resetCurrentPage,
                match: (0, $f7hYg.getApdexMatchObject)(match, route),
                route: route
            }));
    }
}
$8bdbd0297ad44b85$export$560b6ed340766c4b.displayName = "SpaStateResetPage";

});
parcelRegister("6Bw3S", function(module, exports) {
$parcel$export(module.exports, "default", () => $4833019c6808a1a6$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $7TA2J = parcelRequire("7TA2J");

var $5QDqc = parcelRequire("5QDqc");

var $44S8S = parcelRequire("44S8S");
const $4833019c6808a1a6$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: false ? '' : (0, $7TA2J.v4)(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $4833019c6808a1a6$var$store = (0, $5QDqc.createStore)({
    name: 'spa-state',
    initialState: $4833019c6808a1a6$export$d4c72bab9d6cc13a,
    actions: $44S8S
});
var $4833019c6808a1a6$export$2e2bcd8739ae039 = $4833019c6808a1a6$var$store;

});
parcelRegister("44S8S", function(module, exports) {
$parcel$export(module.exports, "setAppStart", () => (parcelRequire("eRZzB")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("eRZzB")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("eRZzB")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("eRZzB")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("eRZzB")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("eRZzB")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("eRZzB")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("eRZzB")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("eRZzB")).setResourceMetrics);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $eRZzB = parcelRequire("eRZzB");

});
parcelRegister("eRZzB", function(module, exports) {
$parcel$export(module.exports, "resetCurrentPage", () => $c773413dc6d09e62$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $c773413dc6d09e62$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $c773413dc6d09e62$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $c773413dc6d09e62$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $c773413dc6d09e62$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $c773413dc6d09e62$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $c773413dc6d09e62$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $c773413dc6d09e62$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $c773413dc6d09e62$export$8ad155d489dcf34d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7TA2J = parcelRequire("7TA2J");

var $1pIYN = parcelRequire("1pIYN");

var $9yf7o = parcelRequire("9yf7o");

var $41zzZ = parcelRequire("41zzZ");

var $ehOO1 = parcelRequire("ehOO1");
const $c773413dc6d09e62$export$7bd623b29ec8e1eb = 10000;
const $c773413dc6d09e62$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $9yf7o.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $1pIYN.default)(nextRouteUfoName, nextRouteName);
        (0, $ehOO1.GlobalPageLoadExperience).abort({
            force: true
        });
        (0, $ehOO1.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, $7TA2J.v4)(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $c773413dc6d09e62$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $c773413dc6d09e62$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($c773413dc6d09e62$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $c773413dc6d09e62$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($c773413dc6d09e62$export$8a98548dad2fa97b(appId));
            }, $c773413dc6d09e62$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $41zzZ.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $c773413dc6d09e62$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($c773413dc6d09e62$export$9d528722f2ff2999(appId, startTime));
    };
const $c773413dc6d09e62$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $c773413dc6d09e62$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($c773413dc6d09e62$export$6a25429a42d30f9a(appId, endTime));
    };
const $c773413dc6d09e62$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $c773413dc6d09e62$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});



parcelRegister("f7hYg", function(module, exports) {
$parcel$export(module.exports, "calcRapidBoardResetState", () => $e60900dd4335933d$export$2350ed3ff6c1a082);
$parcel$export(module.exports, "getApdexMatchObject", () => $e60900dd4335933d$export$47e434f08768932b);
$parcel$export(module.exports, "calcRapidBoardResetStateV2", () => $e60900dd4335933d$export$dbd9185166d0d04c);
$parcel$export(module.exports, "isValidRoute", () => $e60900dd4335933d$export$9f3e656a7f6a3adc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $e60900dd4335933d$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [
                'browse-project-redirect'
            ];
            resetDone = true;
            break;
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-backlog':
        case 'rapidboard-report':
            if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                resetDone = false;
                break;
            }
            if (!useStoredSettings && rapidBoardPaths.indexOf('browse-project-redirect') > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
            rapidBoardPaths = [];
            break;
        default:
            resetDone = false;
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $e60900dd4335933d$export$47e434f08768932b = (match, route)=>{
    let cleanMatch = {
        ...match,
        params: {
            ...match.params
        },
        query: {
            ...match.query
        }
    };
    if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
        const { params: params, query: query } = match;
        const paramKeys = params && Object.keys(params);
        const queryKeys = query && Object.keys(query);
        const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
        const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
        if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
        if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
    });
    if (match.query && match.query.view && match.query.view === 'detail') // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
    cleanMatch.query.view = undefined;
    if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
    cleanMatch = {
        ...cleanMatch,
        url: ''
    };
    return cleanMatch;
};
const $e60900dd4335933d$export$dbd9185166d0d04c = (boardPaths, useStoredSettings, routeName)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [];
            resetDone = true;
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-board':
        case 'rapidboard-report':
            // use search to navigate to board
            if (rapidBoardPaths.includes('browse-project-redirect') || rapidBoardPaths.includes('useStoredSettings')) {
                resetDone = true;
                rapidBoardPaths = [];
                break;
            } else if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                break;
            } else {
                rapidBoardPaths = [];
                break;
            }
        default:
            if (rapidBoardPaths.includes('browse-project-redirect')) {
                resetDone = true;
                rapidBoardPaths = [];
            }
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $e60900dd4335933d$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
    if (state) {
        const { currentPage: currentPage, visitedPages: visitedPages } = state;
        const visitedPageLength = visitedPages.length;
        if (currentPage && currentPage.apps[appId]) return true;
        if (visitedPageLength === 0 || searchDepth <= 0) return false;
        for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
            if (visitedPages[visitedPageLength - i].apps[appId]) return true;
        }
    }
    return false;
};
const $e60900dd4335933d$export$9f3e656a7f6a3adc = (routeToCheck)=>{
    switch(routeToCheck.name){
        case 'issue':
        case 'issue-embed':
        case 'issue-navigator':
        case 'issue-navigator-classic':
        case 'issue-navigator-core':
        case 'servicedesk-issues':
            return true;
        default:
            return false;
    }
};

});

parcelRegister("9H3WG", function(module, exports) {
$parcel$export(module.exports, "default", () => $4eb3f2731f782a78$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $f7hYg = parcelRequire("f7hYg");
class $4eb3f2731f782a78$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    constructor(props){
        super(props), this.resetDone = true, this.rapidBoardPaths = [];
        const [paths] = (0, $f7hYg.calcRapidBoardResetState)(this.rapidBoardPaths, this.props.route.name, !!this.props.match.query.useStoredSettings);
        this.rapidBoardPaths = paths;
    }
    shouldComponentUpdate(nextProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(this.props.match, nextProps.match)) {
            // RapidboardPaths is being persisted here.
            // resetDone boolean is calculated in the util function.
            const [paths, resetBoolean] = (0, $f7hYg.calcRapidBoardResetState)(this.rapidBoardPaths, nextProps.route.name, !!nextProps.match.query.useStoredSettings);
            this.rapidBoardPaths = paths;
            this.resetDone = resetBoolean;
        }
        return true;
    }
    componentDidUpdate() {
        if (!this.resetDone) {
            if (!__SPA__) {
                this.resetDone = true;
                return;
            }
            this.props.resetCurrentPage();
            this.resetDone = true;
        }
    }
    render() {
        return null;
    }
}
$4eb3f2731f782a78$export$2e2bcd8739ae039.displayName = "CustomTrigger";

});



parcelRegister("dUAVJ", function(module, exports) {
$parcel$export(module.exports, "getModernIssueTransitionResources", () => $be6d40025d6de0a0$export$e1afa08027b1e44b);
$parcel$export(module.exports, "getNavigationResources", () => $be6d40025d6de0a0$export$75cffd1aaecf4a2c);
$parcel$export(module.exports, "getUserBoardNavigationResources", () => $be6d40025d6de0a0$export$c57dc1ea7f76f91f);
$parcel$export(module.exports, "getNavigationSidebarPlanResources", () => $be6d40025d6de0a0$export$af2259a87f79645d);
$parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", () => $be6d40025d6de0a0$export$a103e99ad51f7bc3);
$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $be6d40025d6de0a0$export$808691f5a412afa3);
$parcel$export(module.exports, "getNavigationResourcesForWorkItem", () => $be6d40025d6de0a0$export$6fbb399465b8a47f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* eslint-disable import/order, jira/import-whitelist */ 
var $chlbQ = parcelRequire("chlbQ");

var $jyhod = parcelRequire("jyhod");

var $eDOWT = parcelRequire("eDOWT");

var $6RSCO = parcelRequire("6RSCO");

var $hB5dG = parcelRequire("hB5dG");

var $6UbAk = parcelRequire("6UbAk");

var $kJ9Q0 = parcelRequire("kJ9Q0");

var $dQd0z = parcelRequire("dQd0z");

var $fdMbz = parcelRequire("fdMbz");

var $45Itd = parcelRequire("45Itd");

var $i4Cir = parcelRequire("i4Cir");

var $gjifS = parcelRequire("gjifS");

var $edf7u = parcelRequire("edf7u");

var $8Uubk = parcelRequire("8Uubk");

var $ecGij = parcelRequire("ecGij");

var $2NAMr = parcelRequire("2NAMr");

var $6bGyp = parcelRequire("6bGyp");

var $kmdD8 = parcelRequire("kmdD8");

var $8HUuJ = parcelRequire("8HUuJ");

var $35eqr = parcelRequire("35eqr");

var $fjAPO = parcelRequire("fjAPO");

var $4B518 = parcelRequire("4B518");

var $eFqFr = parcelRequire("eFqFr");

var $1IUl9 = parcelRequire("1IUl9");

var $56F5E = parcelRequire("56F5E");

var $3tHVQ = parcelRequire("3tHVQ");

var $iFmc7 = parcelRequire("iFmc7");

var $hEjfV = parcelRequire("hEjfV");

var $5mMCG = parcelRequire("5mMCG");

var $hFYSn = parcelRequire("hFYSn");

var $i860n = parcelRequire("i860n");

var $2700E = parcelRequire("2700E");

var $9O6SX = parcelRequire("9O6SX");

var $lxP6a = parcelRequire("lxP6a");
const $be6d40025d6de0a0$var$conditionalPostOfficeJiraSideNav4Resource = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('post_office_ssr_jira_side_nav_enabled'), (0, $35eqr.postOfficeJiraSideNavResource));
const $be6d40025d6de0a0$var$conditionalPostOfficeJiraSideNav4ProjectsSectionResource = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('enable_ssr_recommendations_in_nav4'), (0, $35eqr.postOfficeNav4ProjectsSectionResource));
const $be6d40025d6de0a0$var$isModernIssueTransitionSettingEnabled = ()=>{
    return (0, $2700E.expVal)('jira_issue_transition_screen_modernisation_toggle', 'value', 'OFF') !== 'OFF';
};
const $be6d40025d6de0a0$var$conditionalGicOptInStatusResource = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('render_modern_global_issue_create_modal_experience'), (0, $6UbAk.gicOptInStatusResources));
const $be6d40025d6de0a0$var$conditionalIssueTransitionOptInStatusResource = (0, $8HUuJ.resourceWithCondition)($be6d40025d6de0a0$var$isModernIssueTransitionSettingEnabled, (0, $dQd0z.issueTransitionOptInStatusResource));
const $be6d40025d6de0a0$export$e1afa08027b1e44b = ()=>[
        $be6d40025d6de0a0$var$conditionalIssueTransitionOptInStatusResource,
        (0, $kJ9Q0.issueTransitionChangeboardingPreferencesResource)
    ];
const $be6d40025d6de0a0$var$getOperationsJiraSideNavResource = ()=>(0, $6RSCO.getConsolidationStateResource)();
// There is a best effort duplicate removal in the `getRoutes` function but it
// only works if the resources have the same instance. b/c resourceWithCondition
// will create a new reference each time it is run, by keeping this outside the
// route factory, we can ensure that the duplicate removal works when it is used
// in multiple places.
const $be6d40025d6de0a0$var$getDedupableConditionalResources = (isUsingSidebarEntrypoint)=>{
    const resources = [
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('navx-global-side-nav'), (0, $9O6SX.navPlatformRootStateResource)),
        (0, $3tHVQ.sidebarEntryUiStateResource),
        (0, $1IUl9.topNav4UIStateResource),
        $be6d40025d6de0a0$var$getOperationsJiraSideNavResource()
    ];
    if (isUsingSidebarEntrypoint) // We don't want sidebarNav4Resource/navPlatformSidebarResource loaded for entrypoints otherwise
    // we end up with a client side api call when we don't need it as SSR will have loaded the data already.
    return resources;
    resources.push((0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('navx-global-side-nav'), (0, $56F5E.navPlatformSidebarResource), (0, $3tHVQ.sidebarNav4Resource)));
    return resources;
};
const $be6d40025d6de0a0$export$75cffd1aaecf4a2c = ({ isUsingSidebarEntrypoint: isUsingSidebarEntrypoint } = {})=>[
        ...(0, $4B518.jiraSpaResources)(),
        (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('navx-global-side-nav'), (0, $i4Cir.navigationUiStateResource)),
        (0, $eFqFr.navigationPlansVisibilityResource),
        (0, $kmdD8.userHomepageResource),
        $be6d40025d6de0a0$var$conditionalGicOptInStatusResource,
        (0, $eDOWT.consolidationUserStateResource),
        ...$be6d40025d6de0a0$var$getDedupableConditionalResources(isUsingSidebarEntrypoint),
        ...$be6d40025d6de0a0$export$e1afa08027b1e44b(),
        (0, $gjifS.persistentIssueCreateModalViewResource),
        (0, $hB5dG.gicSmartFieldsFeatureResource),
        (0, $6bGyp.rovoEntitlementResource),
        (0, $2NAMr.jpdRecommendationDismissedResource),
        (0, $ecGij.fetchSiteUserTraitsResource),
        (0, $8Uubk.fetchSiteTraitsResource),
        $be6d40025d6de0a0$var$conditionalPostOfficeJiraSideNav4Resource,
        $be6d40025d6de0a0$var$conditionalPostOfficeJiraSideNav4ProjectsSectionResource,
        ...(0, $lxP6a.getBannerResources)(),
        (0, $fjAPO.previewPanelStateResource)
    ];
const $be6d40025d6de0a0$export$c57dc1ea7f76f91f = ()=>[
        (0, $5mMCG.staticJSWUserBoardSidebarNavigationResource)
    ];
const $be6d40025d6de0a0$export$af2259a87f79645d = ()=>[
        (0, $hEjfV.staticPlanSidebarNavigationResource)
    ];
const $be6d40025d6de0a0$export$a103e99ad51f7bc3 = ()=>[
        (0, $45Itd.navigationSidebarGlobalResource),
        (0, $6RSCO.getConsolidationStateResource)(),
        (0, $jyhod.checkApiKeyManagementKeysResource)(),
        (0, $chlbQ.nav4SidebarGlobalProductsSettingsResource)
    ];
const $be6d40025d6de0a0$export$808691f5a412afa3 = ()=>[
        (0, $fdMbz.navigationSidebarAutomationLegacyEnabledResource),
        (0, $edf7u.projectContextResourceWithCache),
        (0, $hFYSn.forgeProjectSettingsModuleResource),
        (0, $iFmc7.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];
const $be6d40025d6de0a0$export$6fbb399465b8a47f = ()=>[
        ...(0, $4B518.jiraSpaResources)(),
        // Checks if the Plans menu should appear in the sidebar
        (0, $eFqFr.navigationPlansVisibilityResource),
        // check if we can render the global issue create modal when clicking the Create button.
        $be6d40025d6de0a0$var$conditionalGicOptInStatusResource,
        // ConversationAssistant component on the TopNav
        (0, $6bGyp.rovoEntitlementResource),
        // used in Nav4JiraSideNavRecommendation
        $be6d40025d6de0a0$var$conditionalPostOfficeJiraSideNav4Resource,
        $be6d40025d6de0a0$var$conditionalPostOfficeJiraSideNav4ProjectsSectionResource,
        // used in glance panel.
        (0, $fjAPO.previewPanelStateResource),
        // issues related resources -> issue-create modal
        (0, $gjifS.persistentIssueCreateModalViewResource),
        (0, $hB5dG.gicSmartFieldsFeatureResource),
        ...$be6d40025d6de0a0$export$e1afa08027b1e44b(),
        ...$be6d40025d6de0a0$var$getDedupableConditionalResources(false),
        ...(0, $lxP6a.getConditionalBannerResources)()
    ];

});
parcelRegister("chlbQ", function(module, exports) {
$parcel$export(module.exports, "nav4SidebarGlobalProductsSettingsResource", () => $3d231041127fbc86$export$48318c24101869b4);

var $htsFl = parcelRequire("htsFl");

var $i860n = parcelRequire("i860n");

var $cCjMO = parcelRequire("cCjMO");
const $3d231041127fbc86$var$RESOURCE_TYPE_GLOBAL_PRODUCTS_SETTINGS_SIDEBAR = 'GLOBAL_PRODUCTS_SETTINGS_SIDEBAR';
const $3d231041127fbc86$export$48318c24101869b4 = (0, $htsFl.createRelayResource)({
    type: $3d231041127fbc86$var$RESOURCE_TYPE_GLOBAL_PRODUCTS_SETTINGS_SIDEBAR,
    getQuery: (_, { tenantContext: { cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin } })=>({
            parameters: (0, $cCjMO.default),
            variables: {
                cloudId: cloudId,
                // We can skip the permission check when:
                // 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
                // 2. Upsell is enabled (because upsell is only available to admins), or
                // 3. The main custom onboarding hub gate is disabled (because the custom onboarding feature won't be visible to anyone)
                skipDelegatedAdminCheck: isAdmin || appEditions?.software !== 'PREMIUM_EDITION' || !(0, $i860n.fg)('jira-onboarding-hub-gate')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    captureErrors: true,
    isCritical: true
});

});
parcelRegister("htsFl", function(module, exports) {
$parcel$export(module.exports, "RELAY_RESOURCE_TYPE", () => $0e4716a5c6288b83$export$c6c8c12c0f1d8e54);
$parcel$export(module.exports, "createRelayResource", () => $0e4716a5c6288b83$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $0e4716a5c6288b83$export$42ca7b248c7aaee);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $n67Vb = parcelRequire("n67Vb");

var $lIGkE = parcelRequire("lIGkE");

var $6xuJS = parcelRequire("6xuJS");

var $aI7em = parcelRequire("aI7em");

var $lMoch = parcelRequire("lMoch");

var $5SJ3N = parcelRequire("5SJ3N");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $511Fu = parcelRequire("511Fu");
const $0e4716a5c6288b83$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $0e4716a5c6288b83$var$getData = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds, skip: skip })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $6xuJS.setMark)(startMark);
    // If the resource has opted out via the `skip` predicate, short-circuit
    // before invoking `getQuery` / `loadQuery` so no network request is made.
    if (skip?.(routerContext, customContext)) {
        (0, $6xuJS.setMark)(endMark);
        (0, $6xuJS.setMeasure)(measureName, startMark, endMark);
        return null;
    }
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $6xuJS.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $n67Vb.loadQuery)((0, $aI7em.default)(), parameters, variables || {}, options));
    if (false && queryReference.id != null) {
        const promise = (0, $5SJ3N.QueryPromisesMap).get(queryReference.id);
        if (promise) return promise.then(()=>{
            (0, $6xuJS.setMark)(endMark);
            (0, $6xuJS.setMeasure)(measureName, startMark, endMark);
            /**
				 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
				 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
				 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
				 * as well as subsequent fetches made by route transitions between spa-apps.
				 */ if (captureErrors) (0, $lMoch.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $511Fu.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        });
    }
    if (queryReference.id != null) (0, $5SJ3N.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $6xuJS.setMark)(endMark);
        (0, $6xuJS.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $lMoch.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $511Fu.startCapturingTraceIds)(queryReference.name);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return queryReference;
};
const $0e4716a5c6288b83$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false, isCritical: isCritical = false, skip: skip })=>(0, $7edbf.createResource)({
        type: `${$0e4716a5c6288b83$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            // When skipped, use a stable sentinel key so all skipped invocations
            // dedupe to a single cache slot and never invoke `getQuery`.
            if (skip?.(routerContext, customContext)) return '__skipped__';
            const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $lIGkE.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            return $0e4716a5c6288b83$var$getData({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds,
                skip: skip
            });
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly,
        isCritical: isCritical
    });
const $0e4716a5c6288b83$export$1cc887c62079ea32 = $0e4716a5c6288b83$var$createRelayResourceImpl;
const $0e4716a5c6288b83$export$bbe949b85c06f763 = $0e4716a5c6288b83$var$createRelayResourceImpl;
const $0e4716a5c6288b83$export$42ca7b248c7aaee = (resource, options)=>{
    const { data: queryReference, loading: loading, promise: promise } = (0, $k6ufm.useResource)(resource);
    if (options?.suspendWhenLoading && loading) throw promise;
    return {
        queryReference: queryReference
    };
};

});

parcelRegister("cCjMO", function(module, exports) {
$parcel$export(module.exports, "default", () => $3becb4ba570e876e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<460ae515ec604d041c0c11de895516a7>>
 * @relayHash 3776d7755b12b1e91d9b17c5a3915dff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f77087de9d62f3b981bbd1fa090358d49e27008b2b350334b902f0a164bc151a

var $lIGkE = parcelRequire("lIGkE");
const $3becb4ba570e876e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipDelegatedAdminCheck"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalProductsSettingsSidebarQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "skipDelegatedAdminCheck",
                            "variableName": "skipDelegatedAdminCheck"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "DelegatedAdminJiraSection"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalProductsSettingsSidebarQuery",
            "selections": [
                {
                    "condition": "skipDelegatedAdminCheck",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "canManageCustomOnboarding",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "MANAGE_CUSTOM_ONBOARDING"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPermission"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f77087de9d62f3b981bbd1fa090358d49e27008b2b350334b902f0a164bc151a",
            "metadata": {},
            "name": "GlobalProductsSettingsSidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3becb4ba570e876e$var$node.hash = "9fba8d87d361bd5696daedb53c760b9b";
(0, $lIGkE.PreloadableQueryRegistry).set($3becb4ba570e876e$var$node.params.id, $3becb4ba570e876e$var$node);
var $3becb4ba570e876e$export$2e2bcd8739ae039 = $3becb4ba570e876e$var$node;

});


parcelRegister("jyhod", function(module, exports) {
$parcel$export(module.exports, "checkApiKeyManagementKeysResource", () => $d130c15da436f240$export$b16eaa5246afc9b6);
/* eslint-disable jira/import-whitelist */ // eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.

var $hG5S4 = parcelRequire("hG5S4");

var $i860n = parcelRequire("i860n");

var $jOrx3 = parcelRequire("jOrx3");

var $7edbf = parcelRequire("7edbf");
const $d130c15da436f240$var$ConsolidationState = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};
const $d130c15da436f240$var$CONSOLIDATION_STATE_RESOURCE_TYPE = 'EOC_TENANT';
const $d130c15da436f240$var$CHECK_API_KEY_RESOURCE_TYPE = 'EOC_CHECK_API_KEY';
const $d130c15da436f240$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, opsEnabled, appPermissions)=>{
    if (!opsEnabled || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
    return (0, $hG5S4.eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
};
// eslint-disable-next-line jira/router/no-daisy-chaining-resources
const $d130c15da436f240$var$resource = (0, $7edbf.createResource)({
    type: $d130c15da436f240$var$CHECK_API_KEY_RESOURCE_TYPE,
    getKey: ()=>'check-api-key-management-keys',
    getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const tenantInfo = await dependencies[$d130c15da436f240$var$CONSOLIDATION_STATE_RESOURCE_TYPE]?.promise;
        const opsEnabled = (0, $jOrx3.checkIsTransitioning)(tenantInfo) || (0, $jOrx3.checkIsTransitioned)(tenantInfo) && (0, $i860n.fg)('api_key_management_open_for_transitioned_users');
        return $d130c15da436f240$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, opsEnabled, appPermissions);
    },
    maxAge: Infinity,
    isBrowserOnly: true,
    depends: [
        $d130c15da436f240$var$CONSOLIDATION_STATE_RESOURCE_TYPE
    ],
    isCritical: true
});
const $d130c15da436f240$export$b16eaa5246afc9b6 = ()=>$d130c15da436f240$var$resource;

});
parcelRegister("hG5S4", function(module, exports) {
$parcel$export(module.exports, "eocFetch", () => $fd54832073eb5503$export$212b9c60150b5a0a);

var $egspI = parcelRequire("egspI");

var $anDmR = parcelRequire("anDmR");

var $siTdT = parcelRequire("siTdT");

var $6LoxL = parcelRequire("6LoxL");

var $7nxyA = parcelRequire("7nxyA");
const $fd54832073eb5503$export$212b9c60150b5a0a = (input, init)=>{
    let headers = init?.headers ?? {};
    let body = init?.body;
    // If there is no Content-Type we should add application/json
    // and if the body is not in the BodyInit format we should stringify it
    // Native fetch accepts headers as [['key1','value1'],['key2', 'value2']] so we don't want to modify header or body in this case
    if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
        body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
    }
    if (typeof input === 'string') {
        input = (0, $7nxyA.withPrefix)(input, init);
        if ((0, $egspI.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $anDmR.getActiveTraceHttpRequestHeaders)(input),
            ...headers
        };
    } else {
        input = {
            ...input,
            url: (0, $7nxyA.withPrefix)(input.url, init)
        };
        if ((0, $egspI.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $anDmR.getActiveTraceHttpRequestHeaders)(input.url),
            ...headers
        };
    }
    const errorTransformer = init?.errorTransformer ?? (0, $7nxyA.defaultErrorTransformer);
    const startTime = performance.now();
    return fetch(input, {
        headers: headers,
        ...init,
        body: body
    }).catch((error)=>{
        throw new (0, $6LoxL.NetworkError)(error.name, error);
    }).then((response)=>{
        if (!response.ok) throw new (0, $6LoxL.HTTPError)(response);
        const sanitizedUrl = (0, $7nxyA.sanitizeUrlString)((0, $7nxyA.getRequestUrl)(input));
        (0, $siTdT.addSpanToAll)('fetch', sanitizedUrl, [
            {
                name: 'network'
            }
        ], startTime, performance.now());
        switch(init?.responseType){
            case undefined:
            case 'json':
                return response.json();
            case 'blob':
                return response.blob();
            case 'text':
                return response.text();
            case 'headers':
                return response;
        }
    }).catch((error)=>{
        if ((0, $6LoxL.isNetworkError)(error)) {
            // Put it through the transformer and throw it when ready. Note that
            // it is still safe to throw in the transformer, it will just chain up
            // on the following handlers as usual.
            const transformerResult = errorTransformer(error);
            if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                throw finalError;
            });
            else throw transformerResult;
        }
        throw error;
    });
};

});
parcelRegister("6LoxL", function(module, exports) {
$parcel$export(module.exports, "NetworkError", () => $f6240e1fe220a54e$export$bae979e68e4dc802);
$parcel$export(module.exports, "HTTPError", () => $f6240e1fe220a54e$export$aa9d629c530f62a7);
$parcel$export(module.exports, "StreamedHTTPError", () => $f6240e1fe220a54e$export$c30b5b02747d791c);
$parcel$export(module.exports, "isHTTPError", () => $f6240e1fe220a54e$export$6b7a49ce9c98a2f);
$parcel$export(module.exports, "isNetworkError", () => $f6240e1fe220a54e$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isStreamedHTTPError", () => $f6240e1fe220a54e$export$4f52fcea95c8f97d);

var $kMCB5 = parcelRequire("kMCB5");
class $f6240e1fe220a54e$export$bae979e68e4dc802 extends Error {
    constructor(name, cause){
        super('Network Error!'), this.name = name, this.cause = cause;
    }
}
class $f6240e1fe220a54e$export$aa9d629c530f62a7 extends $f6240e1fe220a54e$export$bae979e68e4dc802 {
    constructor(response){
        // It is important to note that this can be shown to the user if the
        // default transformer is not used for some reason and the thrown error's
        // message is left as is.
        super((0, $kMCB5.ERROR_NAMES).HTTPError);
        this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
        this.response = response;
    }
}
class $f6240e1fe220a54e$export$c30b5b02747d791c extends $f6240e1fe220a54e$export$aa9d629c530f62a7 {
    constructor(cause, data, message){
        super(cause.response), this.cause = cause, this.data = data, this.message = message;
        this.message = message;
        this.name = (0, $kMCB5.ERROR_NAMES).StreamedHTTPError;
    }
}
const $f6240e1fe220a54e$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $f6240e1fe220a54e$export$aa9d629c530f62a7 || [
        (0, $kMCB5.ERROR_NAMES).HTTPError,
        (0, $kMCB5.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $f6240e1fe220a54e$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $f6240e1fe220a54e$export$bae979e68e4dc802 || [
        (0, $kMCB5.ERROR_NAMES).NetworkError,
        (0, $kMCB5.ERROR_NAMES).HTTPError,
        (0, $kMCB5.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $f6240e1fe220a54e$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $f6240e1fe220a54e$export$c30b5b02747d791c || candidate?.name === (0, $kMCB5.ERROR_NAMES).StreamedHTTPError;

});
parcelRegister("kMCB5", function(module, exports) {
$parcel$export(module.exports, "ERROR_NAMES", () => $3f6f47ddf966e40e$export$daceac3b97803ce1);
var $3f6f47ddf966e40e$export$daceac3b97803ce1 = /*#__PURE__*/ function(ERROR_NAMES) {
    ERROR_NAMES["HTTPError"] = "HTTPError";
    ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
    ERROR_NAMES["NetworkError"] = "NetworkError";
    return ERROR_NAMES;
}({});

});


parcelRegister("7nxyA", function(module, exports) {
$parcel$export(module.exports, "getMeta", () => $59452b36ca7b4501$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "withPrefix", () => $59452b36ca7b4501$export$44188c5f179c4553);
$parcel$export(module.exports, "defaultErrorTransformer", () => $59452b36ca7b4501$export$270fcc0e5df09fdd);
$parcel$export(module.exports, "jsmErrorTransformer", () => $59452b36ca7b4501$export$994cc82144d28ded);
$parcel$export(module.exports, "getRequestUrl", () => $59452b36ca7b4501$export$14619c0eed01a470);
$parcel$export(module.exports, "sanitizeUrlString", () => $59452b36ca7b4501$export$ceb09b958e605eff);

var $1eOxf = parcelRequire("1eOxf");

var $6LoxL = parcelRequire("6LoxL");

let $59452b36ca7b4501$var$metaCloudId;
let $59452b36ca7b4501$var$isJSMAvailable = true;
function $59452b36ca7b4501$export$c47913ca32a5c6f7(name) {
    const globalVariable = window ?? $parcel$global;
    if ((0, $1eOxf.isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
    if ($59452b36ca7b4501$var$metaCloudId) return $59452b36ca7b4501$var$metaCloudId;
    if ($59452b36ca7b4501$var$isJSMAvailable) {
        const element = document.querySelector(`meta[name="${name}"]`);
        $59452b36ca7b4501$var$metaCloudId = element?.getAttribute('content') ?? undefined;
        $59452b36ca7b4501$var$isJSMAvailable = !!$59452b36ca7b4501$var$metaCloudId;
    }
    return $59452b36ca7b4501$var$metaCloudId;
}
function $59452b36ca7b4501$export$5a75f4aeb58ba80f(id) {
    $59452b36ca7b4501$var$metaCloudId = id;
}
function $59452b36ca7b4501$export$44188c5f179c4553(input, init) {
    if (init?.exactUrl) return input;
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = $59452b36ca7b4501$export$c47913ca32a5c6f7('ajs-cloud-id');
    if (cloudId) return (0, $af3634021fc4cc54$export$3414665826fa030e) + cloudId + input;
    return input;
}
// https://www.rfc-editor.org/rfc/rfc9110.html#section-8.3
// This is not a full implementation, but should skip any unknown parameters
// and match the charset if it exists. In case there are multiple (which shouldn't) we still
// match the first occurence. If only application/json is returned, utf-8 is
// assumed as we will try to parse it as utf-8 json. This is probably our best
// guess without too much effort here.
const $59452b36ca7b4501$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
const $59452b36ca7b4501$export$270fcc0e5df09fdd = (e)=>{
    if (e instanceof (0, $6LoxL.HTTPError)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $59452b36ca7b4501$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $6LoxL.StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $6LoxL.StreamedHTTPError)(e, message, message));
    }
    return e;
};
const $59452b36ca7b4501$export$994cc82144d28ded = (error)=>{
    if (error instanceof (0, $6LoxL.HTTPError)) {
        const contentType = error.response.headers.get('Content-Type');
        if (contentType && $59452b36ca7b4501$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, $6LoxL.StreamedHTTPError)(error, data, data.errorMessages.join(',')));
        return error.response.text().then((message)=>new (0, $6LoxL.StreamedHTTPError)(error, message, message));
    }
    return error;
};
const $59452b36ca7b4501$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
const $59452b36ca7b4501$export$ceb09b958e605eff = (url)=>{
    const urlWithoutQueryParams = url.replace(/\?.*$/, '');
    const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
    return urlWithoutUUIDs;
};

});
parcelRegister("1eOxf", function(module, exports) {
$parcel$export(module.exports, "isServer", () => $c1f03e55d377e243$export$6acf61af03e62db);
const $c1f03e55d377e243$export$6acf61af03e62db = ()=>{
    try {
        //@ts-ignore: It defined from webpack on the Jira
        return false;
    } catch (error) {
        return globalThis.false ?? false;
    }
};

});

const $af3634021fc4cc54$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';



parcelRegister("jOrx3", function(module, exports) {
$parcel$export(module.exports, "checkShouldUseJSM", () => $0334a769fc74f9a3$export$5e0f3a0d8463fa21);
$parcel$export(module.exports, "checkIsTransitioning", () => $0334a769fc74f9a3$export$d2f281fd4bf10855);
$parcel$export(module.exports, "checkIsConsolidated", () => $0334a769fc74f9a3$export$57f75aebff17dd1e);
$parcel$export(module.exports, "checkIsTransitioned", () => $0334a769fc74f9a3$export$b6461b23ee0e1471);
$parcel$export(module.exports, "checkIsTransitionEligible", () => $0334a769fc74f9a3$export$24040115cac5fdc3);
$parcel$export(module.exports, "checkShouldAccessUnlockOperations", () => $0334a769fc74f9a3$export$cd227238525e8d57);
$parcel$export(module.exports, "checkIsOpsAdmin", () => $0334a769fc74f9a3$export$66a96ac2f07f6730);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4Hqzm = parcelRequire("4Hqzm");

const $0334a769fc74f9a3$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $4Hqzm.ConsolidationState).NOT_CONSOLIDATED;
};
const $0334a769fc74f9a3$export$d2f281fd4bf10855 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $4Hqzm.ConsolidationState).TRANSITIONING;
};
const $0334a769fc74f9a3$export$57f75aebff17dd1e = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $4Hqzm.ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, $4Hqzm.ConsolidationState).CONSOLIDATED;
};
const $0334a769fc74f9a3$export$b6461b23ee0e1471 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $4Hqzm.ConsolidationState).TRANSITIONED;
};
const $0334a769fc74f9a3$export$24040115cac5fdc3 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $4Hqzm.ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $22af9b38fb39bbda$export$650f6934db1290c1);
};
const $0334a769fc74f9a3$export$cd227238525e8d57 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $4Hqzm.ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $22af9b38fb39bbda$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $22af9b38fb39bbda$export$a101f3562b5f0742));
};
const $0334a769fc74f9a3$export$66a96ac2f07f6730 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? false : Boolean(tenantInfo.isAdmin);
};

});
parcelRegister("4Hqzm", function(module, exports) {
$parcel$export(module.exports, "ConsolidationState", () => $f7bb6fc78fe3f4fe$export$9ef498b0a11fd37d);
/* eslint-disable jira/filename-case */ const $f7bb6fc78fe3f4fe$export$9ef498b0a11fd37d = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};

});

/* eslint-disable jira/filename-case */ const $22af9b38fb39bbda$export$650f6934db1290c1 = 'cohort3';
const $22af9b38fb39bbda$export$a101f3562b5f0742 = 'cohort3.5';



parcelRegister("eDOWT", function(module, exports) {
$parcel$export(module.exports, "consolidationUserStateResource", () => $7ca33878ff27a3ca$export$4b870505c49999ef);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $7edbf = parcelRequire("7edbf");

var $kJh74 = parcelRequire("kJh74");
const $7ca33878ff27a3ca$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
const $7ca33878ff27a3ca$export$4b870505c49999ef = (0, $7edbf.createResource)({
    type: $7ca33878ff27a3ca$var$RESOURCE_KEY,
    getKey: ()=>$7ca33878ff27a3ca$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, $kJh74.getOgConsolidationUserState)(accountId).catch((error)=>{
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'consolidationUserStateResource',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }),
    maxAge: Infinity,
    isCritical: true
});

});
parcelRegister("kJh74", function(module, exports) {
$parcel$export(module.exports, "getOgConsolidationUserState", () => $cbf353c609a4e7a4$export$df7594d56c9ebe57);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");

var $75sVW = parcelRequire("75sVW");

var $5hdVX = parcelRequire("5hdVX");
const $cbf353c609a4e7a4$export$df7594d56c9ebe57 = (accountId)=>{
    if (!accountId) return Promise.resolve((0, $5hdVX.ERROR_CONSOLIDATION_USER_STATE));
    return (0, $kM0go.getUserProperty)(accountId, (0, $5hdVX.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
        if (!val || typeof val !== 'object') {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: new (0, $75sVW.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                sendToPrivacyUnsafeSplunk: true
            });
            return 0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE;
        }
        if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
            ...(0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE),
            ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE), key)))
        };
        if (!Object.keys((0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) // Missing properties will happen when adding new properties to the type,
        // we are making sure they are filled in from the defaults
        return {
            ...(0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE),
            ...val
        };
        return val;
    }).catch((error)=>{
        // Property not saved yet, so we return the default values
        if (error instanceof (0, $75sVW.default) && error.statusCode === 404) return 0, $5hdVX.DEFAULT_CONSOLIDATION_USER_STATE;
        throw error;
    });
};

});
parcelRegister("kM0go", function(module, exports) {
$parcel$export(module.exports, "getUserPropertiesUrl", () => $a798a89cb8e924a7$export$f474e53c8191800a);
$parcel$export(module.exports, "setUserProperties", () => $a798a89cb8e924a7$export$d0e176862bf869b8);
$parcel$export(module.exports, "getUserProperty", () => $a798a89cb8e924a7$export$b3126db2ef6e34ed);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $75sVW = parcelRequire("75sVW");

var $5xrGf = parcelRequire("5xrGf");

var $jVTHL = parcelRequire("jVTHL");
const $a798a89cb8e924a7$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $a798a89cb8e924a7$var$getUserPropertiesUrlWithReroute = (accountId, propertyKey)=>{
    const path = $a798a89cb8e924a7$export$f474e53c8191800a(accountId, propertyKey);
    return (0, $jVTHL.getReroutableURL)(path);
};
const $a798a89cb8e924a7$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>{
    const url = $a798a89cb8e924a7$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, {
        ...(0, $5xrGf.getDefaultOptions)(url),
        method: 'PUT',
        body: data
    });
};
const $a798a89cb8e924a7$export$b3126db2ef6e34ed = (accountId, propertyKey)=>{
    const url = $a798a89cb8e924a7$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, (0, $5xrGf.getDefaultOptions)(url)).then((res)=>{
        if (!res) throw new (0, $75sVW.default)(0, 'Fetch returned an undefined response');
        if (res.status === 200) return res.json();
        return res.text().then((errResp)=>{
            throw new (0, $75sVW.default)(res.status, errResp);
        });
    }).then((data)=>data.value);
};
const $a798a89cb8e924a7$export$4c4183b491dea321 = (accountId, propertyKey)=>{
    const url = $a798a89cb8e924a7$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, {
        ...(0, $5xrGf.getDefaultOptions)(url),
        method: 'DELETE'
    });
};

});
parcelRegister("5xrGf", function(module, exports) {
$parcel$export(module.exports, "getDefaultOptions", () => $caeae6ff53216f59$export$430a3269e24b912e);
/* eslint-disable jira/filename-case */ 
var $5cVSt = parcelRequire("5cVSt");

var $99tc1 = parcelRequire("99tc1");
function $caeae6ff53216f59$export$430a3269e24b912e(url) {
    let options = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-force-account-id': 'true',
            // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ],
            ...false ? {
                // Needed for call to monolith
                'x-ssr-asap-audience': 'jira'
            } : {}
        }
    };
    options = url ? (0, $5cVSt.applyObservabilityHeaders)(url, options) : options;
    if (false) options = (0, $99tc1.applySsrFetchConfigOverrideHeaders)(options);
    return options;
}
const $caeae6ff53216f59$export$ba43bf67f3d48107 = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'x-atlassian-force-account-id': 'true',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ],
        ...false ? {
            // Needed for call to monolith
            'x-ssr-asap-audience': 'jira'
        } : {}
    }
};

});


parcelRegister("5hdVX", function(module, exports) {
$parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", () => $7ab74033cbcc03fb$export$1980758e2622af02);
$parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", () => $7ab74033cbcc03fb$export$51d9907e9d716d);
$parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", () => $7ab74033cbcc03fb$export$23da4710c3a29eae);
/* eslint-disable jira/filename-case */ const $7ab74033cbcc03fb$export$1980758e2622af02 = 'eoc_consolidation_user_state';
const $7ab74033cbcc03fb$export$51d9907e9d716d = {
    isPromotionBannerDismissed: false,
    isWelcomeModalDisplayed: false,
    isTransitionHomeHidden: false,
    isTransitionBannerDismissed: false,
    isBroadcastWidgetDismissed: false,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: false
};
const $7ab74033cbcc03fb$export$23da4710c3a29eae = {
    isPromotionBannerDismissed: true,
    isWelcomeModalDisplayed: true,
    isTransitionHomeHidden: true,
    isTransitionBannerDismissed: true,
    isBroadcastWidgetDismissed: true,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: true
};

});



parcelRegister("6RSCO", function(module, exports) {
$parcel$export(module.exports, "getConsolidationStateResource", () => $d107e0eee5bae101$export$a6cf5054d4f9f5dd);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.

var $dJ3NQ = parcelRequire("dJ3NQ");

var $hG5S4 = parcelRequire("hG5S4");

var $7edbf = parcelRequire("7edbf");

var $jVTHL = parcelRequire("jVTHL");

var $4Hqzm = parcelRequire("4Hqzm");

const $d107e0eee5bae101$export$de6c19ae237c1eb9 = (cloudId, atlassianAccountId, isAnonymous, appPermissions)=>{
    let url = '/internal/v1/users/ops-user-info';
    if (cloudId) url = `${url}/${cloudId}`;
    else throw new Error('No tenant info exists.');
    let promise;
    if (appPermissions && appPermissions.hasServiceDeskAccess === false || isAnonymous) {
        promise = new Promise((resolve)=>{
            resolve({
                consolidationState: (0, $4Hqzm.ConsolidationState).NOT_CONSOLIDATED,
                isAdmin: false
            });
        });
        return promise;
    }
    url = `${url}/${atlassianAccountId}`;
    if (false && !(0, $dJ3NQ.default)()) promise = (0, $hG5S4.eocFetch)(url, {
        exactUrl: true,
        headers: {
            'x-ssr-service-name': 'og-apps-user-int-api'
        }
    });
    else {
        const clientUrl = '/v1/users/ops-user-info';
        promise = (0, $hG5S4.eocFetch)((0, $jVTHL.getReroutableURL)(`/gateway/api/jsm/ops/web/${cloudId}${clientUrl}`), {
            exactUrl: true
        }).then(({ data: data })=>data);
    }
    return promise;
};
const $d107e0eee5bae101$var$getConsolidationStateResourceFactory = (forceBrowser = false)=>(0, $7edbf.createResource)({
        type: (0, $3ec8eeeab0e63d24$export$25ee35b01de9d734),
        getKey: ()=>'tenantInformation',
        getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>$d107e0eee5bae101$export$de6c19ae237c1eb9(cloudId, atlassianAccountId, isAnonymous, appPermissions),
        maxAge: Infinity,
        isBrowserOnly: forceBrowser,
        isCritical: true
    });
const $d107e0eee5bae101$var$consolidationResourceForceBrowser = $d107e0eee5bae101$var$getConsolidationStateResourceFactory(true);
const $d107e0eee5bae101$var$consolidationResourceDontForceBrowser = $d107e0eee5bae101$var$getConsolidationStateResourceFactory(false);
const $d107e0eee5bae101$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>{
    /**
	 * This needs to return the same resource instance each time (based on args) or else we end up with many unnecessary re-renders
	 */ return forceBrowser ? $d107e0eee5bae101$var$consolidationResourceForceBrowser : $d107e0eee5bae101$var$consolidationResourceDontForceBrowser;
};

});
/* eslint-disable jira/filename-case */ const $3ec8eeeab0e63d24$export$25ee35b01de9d734 = 'EOC_TENANT';


parcelRegister("hB5dG", function(module, exports) {
$parcel$export(module.exports, "gicSmartFieldsFeatureResource", () => $dafecd381926ee5b$export$ee94bb1f59b07e35);
$parcel$export(module.exports, "useIsSmartFieldsOptIn", () => $dafecd381926ee5b$export$3870b1ff1b155c73);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $fNXFu = parcelRequire("fNXFu");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

const $dafecd381926ee5b$export$ee94bb1f59b07e35 = (0, $7edbf.createResource)({
    type: (0, $d80bd56b7b683e61$export$6f0555de4f60e84e),
    getKey: ()=>(0, $d80bd56b7b683e61$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            const data = await (0, $fNXFu.userPreferenceAPI).get((0, $d80bd56b7b683e61$export$b94951a11282ae6a));
            if (!data) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            };
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If value has never been set, we expect a 404
            if (error.statusCode === 404) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            };
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'gicSmartFieldsFeatureResource',
                    packageName: (0, $d80bd56b7b683e61$export$b8b9d90f9e5bd72b),
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            hasUserOptedOut: false,
            hasUserDismissedReadMore: false,
            hasUserDismissedGicOnboarding: false
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
const $dafecd381926ee5b$export$3870b1ff1b155c73 = ()=>{
    const { data: data, update: update, loading: loading } = (0, $k6ufm.useResource)($dafecd381926ee5b$export$ee94bb1f59b07e35);
    const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
    const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
    const currentDismissedGicOnboarding = typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false;
    const dismissReadMore = (0, $euxye.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                hasUserDismissedReadMore: true,
                ...previousData?.hasUserDismissedGicOnboarding ? {
                    hasUserDismissedGicOnboarding: previousData.hasUserDismissedGicOnboarding
                } : {
                    hasUserDismissedGicOnboarding: false
                }
            }));
    }, [
        update
    ]);
    const dismissGicOnboarding = (0, $euxye.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                ...previousData?.hasUserDismissedReadMore ? {
                    hasUserDismissedReadMore: previousData.hasUserDismissedReadMore
                } : {
                    hasUserDismissedReadMore: false
                },
                hasUserDismissedGicOnboarding: true
            }));
    }, [
        update
    ]);
    return {
        isSmartFieldsOptIn: loading ? null : currentOptInStatus,
        isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
        isSmartFieldsGicOnboardingDismissed: loading ? null : currentDismissedGicOnboarding,
        dismissReadMore: dismissReadMore,
        dismissGicOnboarding: dismissGicOnboarding,
        loading: loading
    };
};

});
parcelRegister("fNXFu", function(module, exports) {
$parcel$export(module.exports, "userPreferenceAPI", () => $cb7161d45afb1952$export$4f7929ca6b50a436);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $h2wCv = parcelRequire("h2wCv");
const $cb7161d45afb1952$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
const $cb7161d45afb1952$var$get = async (key)=>{
    try {
        const result = await (0, $h2wCv.performGetRequest)($cb7161d45afb1952$var$url(key));
        return result?.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === (0, $8f860a533cc71fca$export$8bca792d963eb0ef)) return null;
        throw error;
    }
};
const $cb7161d45afb1952$var$set = (key, value)=>(0, $h2wCv.performPutRequest)($cb7161d45afb1952$var$url(key), {
        body: JSON.stringify({
            value: value
        })
    });
const $cb7161d45afb1952$var$remove = (key)=>(0, $h2wCv.performDeleteRequest)($cb7161d45afb1952$var$url(key));
const $cb7161d45afb1952$export$4f7929ca6b50a436 = {
    get: $cb7161d45afb1952$var$get,
    set: $cb7161d45afb1952$var$set,
    remove: $cb7161d45afb1952$var$remove
};

});

/* eslint-disable jira/filename-case */ const $d80bd56b7b683e61$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $d80bd56b7b683e61$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key'; // value is global for user
const $d80bd56b7b683e61$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $d80bd56b7b683e61$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';


parcelRegister("6UbAk", function(module, exports) {
$parcel$export(module.exports, "gicOptInStatusResources", () => $27f8bb0fea4e185b$export$14c89b6b6a261524);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6CfY5 = parcelRequire("6CfY5");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");

var $i860n = parcelRequire("i860n");

const $27f8bb0fea4e185b$export$14c89b6b6a261524 = (0, $7edbf.createResource)({
    type: (0, $18427a9ed43dc52e$export$fe522736b61f6709),
    getKey: ()=>'gic_optin_status',
    getData: async ()=>{
        let gicOptInStatus = null;
        try {
            if ((0, $i860n.fg)('issue-create-stop-using-preference-api')) gicOptInStatus = {
                isEnabled: true
            };
            else gicOptInStatus = await (0, $h2wCv.performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.statusCode !== 404) (0, $6CfY5.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
        }
        return {
            gicOptInStatus: gicOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
/* eslint-disable jira/filename-case */ const $18427a9ed43dc52e$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';


parcelRegister("kJ9Q0", function(module, exports) {
$parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", () => $7cbd1f9e6e076c91$export$1b6468a6eb7d9b09);
$parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", () => $7cbd1f9e6e076c91$export$e21c345b2538e96e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $6Tcej = parcelRequire("6Tcej");

var $hFtK7 = parcelRequire("hFtK7");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $adi4M = parcelRequire("adi4M");
const $7cbd1f9e6e076c91$export$1b6468a6eb7d9b09 = (0, $7edbf.createResource)({
    type: (0, $adi4M.RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
    getKey: ()=>(0, $adi4M.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
    getData: async ()=>{
        let modalViewCount = 0;
        try {
            const apiResult = await (0, $h2wCv.performGetRequest)((0, $adi4M.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
            if ((0, $i860n.fg)('modern_issue_transition_enable_benefits_modal')) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(apiResult, 'value') || !(0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(apiResult, 'benefitsModalValue')) {
                    const error = new Error('Invalid preference value');
                    (0, $hFtK7.fireErrorAnalytics)({
                        meta: {
                            id: 'issueTransitionChangeboardingPreferencesResource',
                            packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
                return {
                    numberOfTimesUserHasSeenChangeboarding: Number(apiResult.value) || 0,
                    benefitsModal: {
                        isDisabled: apiResult?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: apiResult?.benefitsModal?.nextDateToShowBenefitsModal || null
                    }
                };
            }
            if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($6Tcej)))(apiResult, 'value')) {
                const error = new Error('Invalid preference value');
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } else {
                modalViewCount = Number(apiResult.value);
                return {
                    numberOfTimesUserHasSeenChangeboarding: modalViewCount
                };
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) {
                if ((0, $i860n.fg)('modern_issue_transition_enable_benefits_modal')) return {
                    numberOfTimesUserHasSeenChangeboarding: 0,
                    benefitsModal: {
                        isDisabled: false,
                        nextDateToShowBenefitsModal: null
                    }
                };
                return {
                    numberOfTimesUserHasSeenChangeboarding: 0
                };
            }
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesResource',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            numberOfTimesUserHasSeenChangeboarding: modalViewCount,
            benefitsModal: {
                isDisabled: true,
                nextDateToShowBenefitsModal: null
            }
        };
    },
    isCritical: true
});
const $7cbd1f9e6e076c91$export$e21c345b2538e96e = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $k6ufm.useResource)($7cbd1f9e6e076c91$export$1b6468a6eb7d9b09);
    const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $euxye.useState)(()=>{
        if ((0, $i860n.fg)('modern_issue_transition_enable_benefits_modal')) return {
            numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
            benefitsModal: {
                isDisabled: Boolean(data?.benefitsModal?.isDisabled),
                nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
            }
        };
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
        return 0, $adi4M.USER_SEEN_CARDINALITY_UNKNOWN;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $euxye.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $euxye.useState)('not started');
    const updateIssueTranstitionChangeboardingPreferences = (0, $euxye.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        const body = typeof updates !== 'number' && (0, $i860n.fg)('modern_issue_transition_enable_benefits_modal') ? {
            value: updates?.numberOfTimesUserHasSeenChangeboarding,
            benefitsModal: {
                isDisabled: updates?.benefitsModal?.isDisabled,
                nextDateToShowBenefitsModal: updates?.benefitsModal?.nextDateToShowBenefitsModal
            }
        } : {
            value: updates
        };
        try {
            await (0, $h2wCv.performPutRequest)((0, $adi4M.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                body: JSON.stringify(body)
            });
            setResponseStatusPut('success');
            let updateData;
            if (typeof updates !== 'number' && (0, $i860n.fg)('modern_issue_transition_enable_benefits_modal')) updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates?.numberOfTimesUserHasSeenChangeboarding,
                benefitsModal: {
                    isDisabled: updates?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(updates?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            };
            if (typeof updates === 'number') updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates
            };
            update(()=>updateData);
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $euxye.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if ((0, $i860n.fg)('modern_issue_transition_enable_benefits_modal')) {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference({
                numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                benefitsModal: {
                    isDisabled: data?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            });
            return;
        }
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.numberOfTimesUserHasSeenChangeboarding,
        data?.benefitsModal?.isDisabled,
        data?.benefitsModal?.nextDateToShowBenefitsModal
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionChangeboardingPreference
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTranstitionChangeboardingPreferences
        }
    };
};

});
parcelRegister("6Tcej", function(module, exports) {

var $lpdoW = parcelRequire("lpdoW");

var $kLB1e = parcelRequire("kLB1e");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $50415db9cad4fc4c$var$has(object, path) {
    return object != null && $kLB1e(object, path, $lpdoW);
}
module.exports = $50415db9cad4fc4c$var$has;

});
parcelRegister("lpdoW", function(module, exports) {
/** Used for built-in method references. */ var $f95653fd27b3c347$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f95653fd27b3c347$var$hasOwnProperty = $f95653fd27b3c347$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f95653fd27b3c347$var$baseHas(object, key) {
    return object != null && $f95653fd27b3c347$var$hasOwnProperty.call(object, key);
}
module.exports = $f95653fd27b3c347$var$baseHas;

});


parcelRegister("adi4M", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", () => $781fbaa1009107c7$export$d66d4b761db3d20f);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", () => $781fbaa1009107c7$export$79fd70b908f71ddd);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", () => $781fbaa1009107c7$export$e5007258addba8aa);
$parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", () => $781fbaa1009107c7$export$91880069e7e73b18);
$parcel$export(module.exports, "DURATION_IN_DAYS_DEFAULT", () => $781fbaa1009107c7$export$9ccdfd91f2512a27);
/* eslint-disable jira/filename-case */ const $781fbaa1009107c7$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
const $781fbaa1009107c7$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
const $781fbaa1009107c7$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
const $781fbaa1009107c7$export$91880069e7e73b18 = -1;
const $781fbaa1009107c7$export$9ccdfd91f2512a27 = 14;

});


parcelRegister("dQd0z", function(module, exports) {
$parcel$export(module.exports, "issueTransitionOptInStatusResource", () => $587b61a739f479c7$export$5fbcf4d7a6d9c477);
$parcel$export(module.exports, "useIssueTransitionLabsOptIn", () => $587b61a739f479c7$export$bc11d4816053db5c);

var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $41FAq = parcelRequire("41FAq");

var $l1vE2 = parcelRequire("l1vE2");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");


var $6AvEG = parcelRequire("6AvEG");
/*
 * API Contract: https://hello.atlassian.net/wiki/spaces/JIE/pages/2983777277/Issue+Transition+Jira+Labs+Toggle+for+Legacy+Experience+Backend+API#API-Contract
 */ const $587b61a739f479c7$var$fetchGetIssueTransitionOptInState = async ()=>(0, $h2wCv.performGetRequest)((0, $38435de89b8286ba$export$466b1c60da56c8ca));
const $587b61a739f479c7$export$5fbcf4d7a6d9c477 = (0, $7edbf.createResource)({
    type: (0, $38435de89b8286ba$export$eb01e12fc3db65c0),
    getKey: ()=>(0, $38435de89b8286ba$export$a964df7bc15d81e),
    getData: async ()=>{
        let issueTransitionOptInStatus = null;
        const isFedRampSrbFallback = (0, $i860n.fg)('aem_migration_jira') ? !(0, $41FAq.isFeatureEnabled)('jira', 'issue-transition-customisation-for-srb') : (0, $l1vE2.isFedRamp)();
        const isModernIssueTransitionSRBCohort = (0, $i860n.fg)('issue-transition-customisation-for-srb') || isFedRampSrbFallback;
        if (!(0, $i860n.fg)('render-modern-issue-transition')) return {
            issueTransitionOptInStatus: {
                isEnabled: false,
                expiryTime: -1
            }
        };
        if (isModernIssueTransitionSRBCohort) return {
            issueTransitionOptInStatus: {
                isEnabled: true
            }
        };
        try {
            issueTransitionOptInStatus = await $587b61a739f479c7$var$fetchGetIssueTransitionOptInState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'issueTransitionOptInStatusResource',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, $6AvEG.default)()
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
const $587b61a739f479c7$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, $h2wCv.performPutRequest)((0, $38435de89b8286ba$export$466b1c60da56c8ca), {
        body: JSON.stringify(payload)
    });
const $587b61a739f479c7$export$bc11d4816053db5c = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $k6ufm.useResource)($587b61a739f479c7$export$5fbcf4d7a6d9c477);
    const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $euxye.useState)(()=>{
        if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
        return (0, $6AvEG.default)();
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $euxye.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $euxye.useState)('not started');
    const updateIssueTransitionOptInStatus = (0, $euxye.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            const updatedPreferences = await $587b61a739f479c7$var$fetchModifyIssueTransitionOptInState(updates);
            setResponseStatusPut('success');
            update(()=>({
                    issueTransitionOptInStatus: updatedPreferences
                }));
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $hFtK7.fireErrorAnalytics)({
                error: err,
                meta: {
                    id: 'issueTransitionOptInStatusUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $euxye.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.issueTransitionOptInStatus) {
            setResponseStatusGet('success');
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
            setIssueTransitionOptInState(data.issueTransitionOptInStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.issueTransitionOptInStatus
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionLabsOptInState
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTransitionOptInStatus
        }
    };
};

});
/* eslint-disable jira/filename-case */ const $38435de89b8286ba$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $38435de89b8286ba$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $38435de89b8286ba$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $38435de89b8286ba$export$880a78695d76498e = 8;

parcelRegister("6AvEG", function(module, exports) {
$parcel$export(module.exports, "default", () => $eac7de0d6a604131$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud

var $l1vE2 = parcelRequire("l1vE2");

var $41FAq = parcelRequire("41FAq");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");
const $eac7de0d6a604131$var$getDefaultIssueTransitionLabsOptInState = ()=>{
    if (!(0, $i860n.fg)('render-modern-issue-transition')) return {
        isEnabled: false,
        expiryTime: -1
    };
    const isFedRampSrbFallback = (0, $i860n.fg)('aem_migration_jira') ? !(0, $41FAq.isFeatureEnabled)('jira', 'issue-transition-customisation-for-srb') : (0, $l1vE2.isFedRamp)();
    const isModernIssueTransitionSRBCohort = (0, $i860n.fg)('issue-transition-customisation-for-srb') || isFedRampSrbFallback;
    if (isModernIssueTransitionSRBCohort) return {
        isEnabled: true
    };
    return (0, $2700E.expValEquals)('jira_issue_transition_screen_modernisation_toggle', 'value', 'BY_DEFAULT_USER_OPT_OUT') ? {
        isEnabled: false,
        expiryTime: -1
    } : {
        isEnabled: true
    };
};
var $eac7de0d6a604131$export$2e2bcd8739ae039 = $eac7de0d6a604131$var$getDefaultIssueTransitionLabsOptInState;

});
parcelRegister("2700E", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $5174c3419b46017c$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValEquals", () => $5174c3419b46017c$export$45abdb3f977b5b14);
$parcel$export(module.exports, "UNSAFE_noExposureExp", () => $5174c3419b46017c$export$677f9fa2e1ae6fec);
/* eslint-disable jira/filename-case, max-classes-per-file, jira/naming/disallow-filenames */ 
var $4LDqh = parcelRequire("4LDqh");
var $j3gY5 = parcelRequire("j3gY5");

var $hbvZL = parcelRequire("hbvZL");

var $fEmTm = parcelRequire("fEmTm");

var $hjhet = parcelRequire("hjhet");

var $gXtG2 = parcelRequire("gXtG2");
class $5174c3419b46017c$var$ErrorPointingUp extends Error {
    constructor(message){
        super(message);
        if (this.stack) {
            const stackLines = this.stack.split('\n');
            // 1 - checkIfExperimentExists
            // 2 - a caller
            this.stack = [
                ...stackLines.slice(2)
            ].join('\n');
        }
    }
}
$5174c3419b46017c$var$ErrorPointingUp.displayName = "ErrorPointingUp";
const $5174c3419b46017c$var$checkedExperiments = new Set();
const $5174c3419b46017c$var$checkIfExperimentExists = (experimentName)=>{
    // perform early exist to minimize performance impact
    if ($5174c3419b46017c$var$checkedExperiments.has(experimentName)) return;
    $5174c3419b46017c$var$checkedExperiments.add(experimentName);
    if ((0, $4LDqh.default).checkGate('jfp_magma_jira-report-incorrect-experiments', {
        fireGateExposure: false
    })) {
        if (!(0, $4LDqh.default).isExperimentExists(experimentName)) {
            const error = new $5174c3419b46017c$var$ErrorPointingUp(`Experiment ${experimentName} does not exist`);
            (0, $fEmTm.captureException)('FeatureGates.isExperimentExists', error);
            // eslint-disable-next-line no-console
            console.error(`Experiment ${experimentName} does not exist`);
        }
    }
};
function $5174c3419b46017c$var$readExpVal(experimentName, param, defaultValue) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    /**
	 * On server: These overrides are set by the server-side code in jira/src/entry-fs
	 * On client: Check SSR overrides on client-side for shareable debug URLs
	 */ if (globalVar?.__SSR_STATSIG_OVERRIDES__?.configs?.[experimentName]?.[param] !== undefined) {
        const value = globalVar.__SSR_STATSIG_OVERRIDES__.configs[experimentName][param];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
    if (false) {
        if (globalVar?.__SSR_STATSIG_OVERRIDES__?.allExpValTrue) {
            if (param === 'isEnabled' && typeof defaultValue === 'boolean') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return true;
        }
        if (typeof globalVar.__SSR_SYNC_READ_EXP_VAL__ === 'function' && // if global variable is ready, then don't reach out to native
        // API, stay within js runtime is faster
        !globalVar._statsigValuesReady) try {
            const value = globalVar.__SSR_SYNC_READ_EXP_VAL__(experimentName, param, defaultValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return value;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(JSON.stringify({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                message: error.message,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                stack: error.stack
            }));
        }
    }
    // Check if the CRITERION override mechanism is available
    if (typeof globalThis?.window?.__CRITERION__?.getExperimentValueOverride === 'function') {
        const overrideValue = globalThis.window.__CRITERION__.getExperimentValueOverride(experimentName, param);
        if (overrideValue !== undefined && overrideValue !== null) {
            (0, $hbvZL.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
    }
    // Handle vendorless scripts use of gates
    (0, $hjhet.UNSAFE_initIfNeeded)();
    const value = (0, $4LDqh.default).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hbvZL.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $5174c3419b46017c$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    const experiment = $5174c3419b46017c$var$readExpVal(experimentName, param, defaultValue);
    $5174c3419b46017c$var$checkIfExperimentExists(experimentName);
    return experiment;
}
function $5174c3419b46017c$export$45abdb3f977b5b14(experimentName, param, comparatorValue, defaultValue = null) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (false) {
        if (globalVar?.__SSR_STATSIG_OVERRIDES__?.allExpValTrue) return defaultValue !== comparatorValue;
    }
    const experiment = $5174c3419b46017c$var$readExpVal(experimentName, param, defaultValue);
    $5174c3419b46017c$var$checkIfExperimentExists(experimentName);
    return experiment === comparatorValue;
}
class $5174c3419b46017c$var$ExperimentConfig {
    constructor(experimentName, config){
        this._experimentName = experimentName;
        this._config = config;
    }
    get(key, defaultValue, typeGuard) {
        // Check if the CRITERION override mechanism is available
        if (typeof globalThis?.window?.__CRITERION__?.getExperimentValueOverride === 'function') {
            const overrideValue = globalThis.window.__CRITERION__.getExperimentValueOverride(this._experimentName, key);
            if (overrideValue !== undefined && overrideValue !== null) {
                (0, $hbvZL.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, overrideValue);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return overrideValue;
            }
        }
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $hbvZL.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
}
$5174c3419b46017c$var$ExperimentConfig.displayName = "ExperimentConfig";
const $5174c3419b46017c$var$cache = new Map();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $5174c3419b46017c$var$checkedExperiments.clear();
    $5174c3419b46017c$var$cache.clear();
});
function $5174c3419b46017c$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $5174c3419b46017c$var$cache.get(experimentName);
    const fireExposure = ()=>(0, $4LDqh.default).manuallyLogExperimentExposure(experimentName);
    if (instance == null) {
        if (false) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const globalVar = typeof window !== 'undefined' ? window : globalThis;
            if (typeof globalVar.__SSR_SYNC_DYNAMIC_CONFIG_VALUE__ === 'function' && // if global variable is ready, then don't reach out to native
            // API, stay within js runtime is faster
            !globalVar._statsigValuesReady) // Handle vendorless scripts use of gates
            try {
                const config = globalVar.__SSR_SYNC_DYNAMIC_CONFIG_VALUE__(experimentName);
                if (typeof config !== 'undefined') {
                    config.get = (key)=>{
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        const value = config.value[key];
                        return value;
                    };
                    instance = [
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        new $5174c3419b46017c$var$ExperimentConfig(experimentName, (0, $j3gY5.DynamicConfig).fromExperiment(config)),
                        fireExposure
                    ];
                    $5174c3419b46017c$var$cache.set(experimentName, instance);
                    return instance;
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(JSON.stringify({
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    message: error.message,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    stack: error.stack
                }));
            }
        }
        (0, $hjhet.UNSAFE_initIfNeeded)();
        const config = (0, $4LDqh.default).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        instance = [
            new $5174c3419b46017c$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $5174c3419b46017c$var$cache.set(experimentName, instance);
    }
    return instance;
}

});



parcelRegister("fdMbz", function(module, exports) {
$parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", () => $f3deef9fd00ecd22$export$fa191d7d71460a98);

var $2HuOR = parcelRequire("2HuOR");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
const $f3deef9fd00ecd22$var$RESOURCE_TYPE_AUTOMATION_IS_LEGACY_ENABLED = 'AUTOMATION_IS_LEGACY_ENABLED';
const $f3deef9fd00ecd22$export$fa191d7d71460a98 = (0, $7edbf.createResource)({
    type: $f3deef9fd00ecd22$var$RESOURCE_TYPE_AUTOMATION_IS_LEGACY_ENABLED,
    getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
    getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
        const defaultValue = {
            enabled: true
        };
        if (!licensedProducts || !licensedProducts[(0, $2HuOR.LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
        const { enabled: enabled } = await (0, $h2wCv.performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
        return {
            enabled: enabled
        };
    },
    maxAge: Infinity,
    isCritical: true
});

});

parcelRegister("45Itd", function(module, exports) {
$parcel$export(module.exports, "navigationSidebarGlobalResource", () => $f202873aee649285$export$44e7ad3c66a3f25f);

var $5lH6b = parcelRequire("5lH6b");

var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");
const $f202873aee649285$var$RESOURCE_TYPE_NAVIGATION_SIDEBAR_GLOBAL = 'NAVIGATION_SIDEBAR_GLOBAL';
const $f202873aee649285$export$44e7ad3c66a3f25f = (0, $7edbf.createResource)({
    type: $f202873aee649285$var$RESOURCE_TYPE_NAVIGATION_SIDEBAR_GLOBAL,
    getKey: ({ match: match, query: query })=>{
        // Refresh the data if the project key or id changes
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        return projectKey || projectId || '__state';
    },
    getData: async ({ match: match, query: query }, _storeContext)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        const scope = {
            projectKey: projectKey,
            projectId: projectId
        };
        const response = await (0, $5lH6b.fetchSidebarConfig)(scope);
        return {
            response: response,
            scope: scope
        };
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("5lH6b", function(module, exports) {
$parcel$export(module.exports, "fetchSidebarConfig", () => $c3c8b844bc55a7ef$export$d1d13c4b972a22f1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4fhEY = parcelRequire("4fhEY");
const $c3c8b844bc55a7ef$export$94e808b2557f52e = (requestQuery, version = '2', queryParams)=>{
    const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
    const params = {
        exclude: [
            'webItems.reports',
            'webItems.home',
            'webItems.gin',
            exclude
        ].filter(Boolean).join(',')
    };
    let path = '';
    if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
    else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
    else if (identifierValue != null) path = `project/${identifierValue}`;
    else {
        path = 'product';
        const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
        // Connect apps rely on project context even for the global/product scoped webItems
        const projectIdOrKey = projectId || projectKey;
        if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
    }
    const queryString = [
        new URLSearchParams(params).toString(),
        queryParams
    ].filter(Boolean).join('&');
    return `/rest/navigation/${version}/${path}?${queryString}`;
};
const $c3c8b844bc55a7ef$export$d1d13c4b972a22f1 = async (requestQuery, queryParams)=>{
    const sidebarUrl = $c3c8b844bc55a7ef$export$94e808b2557f52e(requestQuery, undefined, queryParams);
    return (0, $4fhEY.default)(sidebarUrl);
};

});
parcelRegister("4fhEY", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab6fbefc5abd05ec$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $eRSGV = parcelRequire("eRSGV");

var $ff8AH = parcelRequire("ff8AH");

var $75sVW = parcelRequire("75sVW");

var $jVTHL = parcelRequire("jVTHL");

var $5cVSt = parcelRequire("5cVSt");

var $xhPWB = parcelRequire("xhPWB");
/**
 * Fetch from the given URL, returning the json response.
 * <p>
 * If there are any HTTP errors the promise is rejected with a {@link FetchError}.
 *
 * @param url - to fetch the JSON from
 * @param options - for the fetch call
 * @returns promise containing the JSON
 * @throws {@link FetchError} if there was an HTTP Error. This will reject the promise.
 */ // the `@typescript-eslint/no-unnecessary-type-constraint` rule is disabled because otherwise syntax highlighting breaks with a trailing comma,
// other rules should be fixed ideally.
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unnecessary-type-constraint
const $ab6fbefc5abd05ec$var$fetchJson = (url, options = {})=>fetch((0, $jVTHL.getReroutableURL)(url), (0, $5cVSt.applyObservabilityHeaders)(url, (0, $eRSGV.merge)((0, $ff8AH.defaultOptions), options))).then((response)=>{
        if (!response.ok) {
            const traceId = (0, $xhPWB.getTraceId)(response);
            if (traceId !== undefined && traceId.length > 0) throw new (0, $75sVW.default)(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new (0, $75sVW.default)(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.json();
    });
var $ab6fbefc5abd05ec$export$2e2bcd8739ae039 = $ab6fbefc5abd05ec$var$fetchJson;

});


parcelRegister("i0CFV", function(module, exports) {
$parcel$export(module.exports, "getProjectKeyFromProjectOrIssueKey", () => $503014fd6157231b$export$b8279232e05563cb);
$parcel$export(module.exports, "getProjectKey", () => $503014fd6157231b$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectIdOrKey", () => $503014fd6157231b$export$c072f183553fb7ea);
$parcel$export(module.exports, "getProjectKeyId", () => $503014fd6157231b$export$1f7213d0f9054f06);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i860n = parcelRequire("i860n");
const $503014fd6157231b$export$89040d072f281f85 = (query)=>query?.selectedProjectId || query?.pid || query?.projectId || query?.['project.id'];
const $503014fd6157231b$export$b8279232e05563cb = (projectKey, issueKey)=>projectKey || (issueKey || '').split('-')[0];
const $503014fd6157231b$export$667f2a0f99c75faa = (match, query)=>$503014fd6157231b$export$b8279232e05563cb(match?.params.projectKey || query?.projectKey || query?.['project.key'], (match.params?.issueKey || '').split('-')[0] || ((0, $i860n.fg)('handle_context_panel_issue_navigator_path') ? query?.selectedIssue?.split('-')[0] : ''));
const $503014fd6157231b$export$c072f183553fb7ea = (match, query)=>$503014fd6157231b$export$89040d072f281f85(query) || $503014fd6157231b$export$667f2a0f99c75faa(match, query);
const $503014fd6157231b$export$1f7213d0f9054f06 = (match, query)=>{
    // handle reports legacy url or project settings details
    const projectId = $503014fd6157231b$export$89040d072f281f85(query);
    const projectKey = $503014fd6157231b$export$667f2a0f99c75faa(match, query);
    return {
        projectKey: projectKey,
        projectId: projectId
    };
};

});


parcelRegister("i4Cir", function(module, exports) {
$parcel$export(module.exports, "navigationUiStateResource", () => $870b9559cf95db3f$export$14c178691841b423);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $emCaV = parcelRequire("emCaV");

var $7edbf = parcelRequire("7edbf");

var $1xJGF = parcelRequire("1xJGF");
const $870b9559cf95db3f$var$getNavigationUiStateMemoized = (0, $emCaV.default)((atlassianAccountId)=>(0, $1xJGF.getNavigationUiState)({
        tenantContext: {
            atlassianAccountId: atlassianAccountId
        }
    }));
const $870b9559cf95db3f$export$14c178691841b423 = (0, $7edbf.createResource)({
    type: 'RESOURCE_TYPE_NAVIGATION_UI',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$870b9559cf95db3f$var$getNavigationUiStateMemoized(atlassianAccountId),
    maxAge: Infinity,
    isCritical: true
});

});
parcelRegister("1xJGF", function(module, exports) {
$parcel$export(module.exports, "getNavigationUiState", () => $b34201b711a82cf4$export$29999268b070c9bd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $kM0go = parcelRequire("kM0go");


var $k0465 = parcelRequire("k0465");
const $b34201b711a82cf4$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
    const { atlassianAccountId: accountId } = tenantContext;
    let uiState = await (0, $k0465.queryLocalStorage)();
    if (uiState || !accountId) return uiState;
    try {
        uiState = await (0, $kM0go.getUserProperty)(accountId, (0, $8ae9cd5461c89f8d$export$3e8fc5ba7287b4a8));
        // @ts-expect-error - TS2345 - Argument of type 'UIControllerShape | undefined' is not assignable to parameter of type 'UIControllerShape'.
        (0, $k0465.updateLocalStorageData)(uiState);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // Don't log the error on purpose. This is very frequent for some reason :(
    }
    return uiState;
};

});
/* eslint-disable jira/filename-case */ const $8ae9cd5461c89f8d$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $8ae9cd5461c89f8d$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';

parcelRegister("k0465", function(module, exports) {
$parcel$export(module.exports, "queryLocalStorage", () => $80d7db7658a30aa0$export$e192dcb908272d5);
$parcel$export(module.exports, "updateLocalStorageData", () => $80d7db7658a30aa0$export$ec13c725e067146a);
/* eslint-disable jira/filename-case, jira/import-whitelist, jira/naming/disallow-filenames */ 
var $fcq2N = parcelRequire("fcq2N");

var $4fPPi = parcelRequire("4fPPi");

var $i860n = parcelRequire("i860n");

var $6CfY5 = parcelRequire("6CfY5");

const $80d7db7658a30aa0$export$e7db3fa51c63bc5c = ()=>{
    // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    return window.localStorage;
    return {
        setItem: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        getItem: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
    };
};
const $80d7db7658a30aa0$var$queryLocalStorageSync = ()=>{
    const localStorage = $80d7db7658a30aa0$export$e7db3fa51c63bc5c();
    const item = (0, $i860n.fg)('jfp-vulcan-browser-storage-migration') ? (0, $4fPPi.AtlBrowserStorageLocal).getItem((0, $8ae9cd5461c89f8d$export$3e8fc5ba7287b4a8)) : localStorage.getItem((0, $8ae9cd5461c89f8d$export$3e8fc5ba7287b4a8));
    if (!false && item) try {
        return JSON.parse(item);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData((0, $8ae9cd5461c89f8d$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
    }
};
const $80d7db7658a30aa0$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
        const item = $80d7db7658a30aa0$var$queryLocalStorageSync();
        resolve(item);
    });
const $80d7db7658a30aa0$export$ec13c725e067146a = (data)=>{
    const localStorage = $80d7db7658a30aa0$export$e7db3fa51c63bc5c();
    if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) // @browser-storage setter
    (0, $4fPPi.AtlBrowserStorageLocal).setStrictlyNecessaryItem((0, $8ae9cd5461c89f8d$export$3e8fc5ba7287b4a8), JSON.stringify(data));
    else // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    localStorage.setItem((0, $8ae9cd5461c89f8d$export$3e8fc5ba7287b4a8), JSON.stringify(data));
};

});



parcelRegister("gjifS", function(module, exports) {
$parcel$export(module.exports, "persistentIssueCreateModalViewResource", () => $d56cf720cf78b9c9$export$266a039a005e8314);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");


const $d56cf720cf78b9c9$export$266a039a005e8314 = (0, $7edbf.createResource)({
    type: (0, $197033e503119526$export$f658cfd591eb583e),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("fQJPW")),
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
/* eslint-disable jira/filename-case */ const $197033e503119526$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $197033e503119526$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $197033e503119526$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';

parcelRegister("fQJPW", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eGZYW").then(()=>parcelRequire('gM3Bu'));

});


parcelRegister("edf7u", function(module, exports) {
$parcel$export(module.exports, "projectContextResource", () => $a8df5aa948631878$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $a8df5aa948631878$export$d75816e37af81473);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");


const $a8df5aa948631878$export$27ad0d75c619be68 = (0, $7edbf.createResource)({
    type: (0, $feef523243843e2f$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>(0, $i0CFV.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getDataLoader: ()=>(parcelRequire("lmISU")),
    maxAge: 1800000,
    isCritical: true
});
const $a8df5aa948631878$export$d75816e37af81473 = $a8df5aa948631878$export$27ad0d75c619be68;

});
/* eslint-disable jira/filename-case */ const $feef523243843e2f$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("lmISU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("eYRct").then(()=>parcelRequire('KPhmg'));

});


parcelRegister("8Uubk", function(module, exports) {
$parcel$export(module.exports, "fetchSiteTraitsResource", () => $a8c0f468fea1f6bc$export$379923e7c903a55d);
$parcel$export(module.exports, "useFetchSiteTraitsResource", () => $a8c0f468fea1f6bc$export$2a942e8a56081cd7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $g3pW6 = parcelRequire("g3pW6");


const $a8c0f468fea1f6bc$var$getData = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}`;
        const response = false ? (await (0, $h2wCv.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $g3pW6.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: (0, $54cbde7df2381fb0$export$7f111648ca05f056),
                packageName: (0, $13b17fb956c06fec$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $a8c0f468fea1f6bc$export$379923e7c903a55d = (0, $7edbf.createResource)({
    type: (0, $54cbde7df2381fb0$export$6f0555de4f60e84e),
    getKey: ()=>(0, $54cbde7df2381fb0$export$7e7d7930e22ba39f),
    getData: $a8c0f468fea1f6bc$var$getData,
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
function $a8c0f468fea1f6bc$export$2a942e8a56081cd7() {
    return (0, $k6ufm.useResource)($a8c0f468fea1f6bc$export$379923e7c903a55d);
}

});
parcelRegister("g3pW6", function(module, exports) {
$parcel$export(module.exports, "memoizedFetchSitePersonalization", () => $dde7ec78fa02f90d$export$671fb03be30194c3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $emCaV = parcelRequire("emCaV");

var $5pyRb = parcelRequire("5pyRb");

var $4fhEY = parcelRequire("4fhEY");
const $dde7ec78fa02f90d$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $dde7ec78fa02f90d$export$ddf4964d2a406b6a = async ({ cloudId: cloudId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    const { attributes: attributes } = await (0, $4fhEY.default)($dde7ec78fa02f90d$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $dde7ec78fa02f90d$export$671fb03be30194c3 = (0, $emCaV.default)($dde7ec78fa02f90d$export$ddf4964d2a406b6a, ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>newCloudId === lastCloudId);
const $dde7ec78fa02f90d$export$58982988039b926f = ()=>(0, $5pyRb.useService)($dde7ec78fa02f90d$export$671fb03be30194c3);

});
parcelRegister("5pyRb", function(module, exports) {
$parcel$export(module.exports, "useService", () => $a2ef56181771ca79$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $a2ef56181771ca79$export$c963713a27525aaf);

var $euxye = parcelRequire("euxye");
const $a2ef56181771ca79$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $euxye.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $euxye.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $a2ef56181771ca79$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $euxye.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $a2ef56181771ca79$export$6de4685a6c88b4e9(request, initialState);
    (0, $euxye.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


/* eslint-disable jira/filename-case */ const $13b17fb956c06fec$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGrowthRecommendations';

/* eslint-disable jira/filename-case */ const $54cbde7df2381fb0$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_SITE_TRAITS';
const $54cbde7df2381fb0$export$7e7d7930e22ba39f = 'recommendations-fetch-site-traits-resource-key';
const $54cbde7df2381fb0$export$7f111648ca05f056 = 'useResource.fetchRecommendationsSiteTraits';


parcelRegister("ecGij", function(module, exports) {
$parcel$export(module.exports, "fetchSiteUserTraitsResource", () => $b881a5733320634d$export$2d7b0f7f663da130);
$parcel$export(module.exports, "useFetchSiteUserTraitsResource", () => $b881a5733320634d$export$4264f22c98fde8ba);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $kTLO3 = parcelRequire("kTLO3");


const $b881a5733320634d$var$getData = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const accountId = tenantContext.atlassianAccountId ?? '';
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const response = false ? (await (0, $h2wCv.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $kTLO3.memoizedFetchSiteUserPersonalization)({
            cloudId: cloudId,
            userId: accountId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: (0, $70cc2ca928ae0bf3$export$7f111648ca05f056),
                packageName: (0, $13b17fb956c06fec$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $b881a5733320634d$export$2d7b0f7f663da130 = (0, $7edbf.createResource)({
    type: (0, $70cc2ca928ae0bf3$export$6f0555de4f60e84e),
    getKey: ()=>(0, $70cc2ca928ae0bf3$export$7e7d7930e22ba39f),
    getData: $b881a5733320634d$var$getData,
    maxAge: Number.MAX_VALUE,
    isCritical: true
});
function $b881a5733320634d$export$4264f22c98fde8ba() {
    return (0, $k6ufm.useResource)($b881a5733320634d$export$2d7b0f7f663da130);
}

});
parcelRegister("kTLO3", function(module, exports) {
$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $cb54ea9751a408c2$export$de93ec54b11be450);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $emCaV = parcelRequire("emCaV");

var $5pyRb = parcelRequire("5pyRb");

var $4fhEY = parcelRequire("4fhEY");
const $cb54ea9751a408c2$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $cb54ea9751a408c2$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $4fhEY.default)($cb54ea9751a408c2$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $cb54ea9751a408c2$export$de93ec54b11be450 = (0, $emCaV.default)($cb54ea9751a408c2$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $cb54ea9751a408c2$export$8dc79ff315095801 = ()=>(0, $5pyRb.useService)($cb54ea9751a408c2$export$de93ec54b11be450);

});

/* eslint-disable jira/filename-case */ const $70cc2ca928ae0bf3$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_USER_TRAITS';
const $70cc2ca928ae0bf3$export$7e7d7930e22ba39f = 'recommendations-fetch-traits-resource-key';
const $70cc2ca928ae0bf3$export$7f111648ca05f056 = 'useResource.fetchRecommendationsUserTraits';


parcelRegister("2NAMr", function(module, exports) {
$parcel$export(module.exports, "jpdRecommendationDismissedResource", () => $f1a0a032bbf40d1b$export$5db7c4562b672f52);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");


const $f1a0a032bbf40d1b$export$5db7c4562b672f52 = (0, $7edbf.createResource)({
    type: (0, $5cb5bfd5d2ee8d50$export$6f0555de4f60e84e),
    getKey: ()=>(0, $5cb5bfd5d2ee8d50$export$7e7d7930e22ba39f),
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return {
                hasDismissed: true
            };
            const accountId = tenantContext.atlassianAccountId;
            const response = await (0, $h2wCv.performGetRequest)(`/rest/api/latest/user/properties/JpdRecommendationDismissed?accountId=${accountId}`);
            return {
                hasDismissed: response?.value ?? false
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
					 * If the user has never set the preference, they have never dismissed.
					 */ return {
                hasDismissed: false
            };
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: (0, $5cb5bfd5d2ee8d50$export$7f111648ca05f056),
                    packageName: (0, $13b17fb956c06fec$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return true - this ensures we don't show the recommendation if we don't know if they have dismissed */ return {
            hasDismissed: true
        };
    },
    maxAge: Number.MAX_VALUE,
    isCritical: true
});

});
/* eslint-disable jira/filename-case */ const $5cb5bfd5d2ee8d50$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_DISMISSED_JPD';
const $5cb5bfd5d2ee8d50$export$7e7d7930e22ba39f = 'recommendations-dismissed-jpd-resource-key';
const $5cb5bfd5d2ee8d50$export$7f111648ca05f056 = 'useResource.fetchRecommendationsDismissedJpd';


parcelRegister("6bGyp", function(module, exports) {
$parcel$export(module.exports, "rovoEntitlementResource", () => $60791d78ff843db9$export$a0974cf24d16bc5d);
$parcel$export(module.exports, "useRovoEntitlementResource", () => $60791d78ff843db9$export$b9cee3799212b85a);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

const $60791d78ff843db9$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
const $60791d78ff843db9$var$fetchRovoEntitlement = async (cloudId)=>{
    try {
        const response = await (0, $h2wCv.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $74cc6705a5fdb0de$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    shouldIncludeBetaAiFeatures: true
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        // handle GraphQL errors
        if (response.errors) (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
            sendToPrivacyUnsafeSplunk: true
        });
        const isRovoEnabled = response.data?.jira?.isRovoEnabled ?? null;
        const isRovoLLMEnabled = response.data?.jira_isRovoLLMEnabled ?? null;
        const isBetaAiFeaturesEnabled = response.data?.jira_isBetaAiFeaturesEnabled ?? null;
        return {
            isRovoEnabled: isRovoEnabled,
            isRovoLLMEnabled: isRovoLLMEnabled,
            isBetaAiFeaturesEnabled: isBetaAiFeaturesEnabled
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        isRovoEnabled: null,
        isRovoLLMEnabled: undefined,
        isBetaAiFeaturesEnabled: undefined
    };
};
const $60791d78ff843db9$export$a0974cf24d16bc5d = (0, $7edbf.createResource)({
    type: $60791d78ff843db9$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getKey: ()=>$60791d78ff843db9$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$60791d78ff843db9$var$fetchRovoEntitlement(cloudId),
    maxAge: Infinity,
    isCritical: true
});
const $60791d78ff843db9$export$b9cee3799212b85a = ()=>(0, $k6ufm.useResource)($60791d78ff843db9$export$a0974cf24d16bc5d);

});
/* eslint-disable jira/filename-case */ const $74cc6705a5fdb0de$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldIncludeBetaAiFeatures: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	jira_isBetaAiFeaturesEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldIncludeBetaAiFeatures)
}
`;


parcelRegister("kmdD8", function(module, exports) {
$parcel$export(module.exports, "userHomepageResource", () => $f61e9d6e1a88b6b8$export$16320dd0d1e6c145);

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
const $f61e9d6e1a88b6b8$var$RESOURCE_TYPE_USER_HOMEPAGE = 'USER_HOMEPAGE';
const $f61e9d6e1a88b6b8$export$16320dd0d1e6c145 = (0, $7edbf.createResource)({
    type: $f61e9d6e1a88b6b8$var$RESOURCE_TYPE_USER_HOMEPAGE,
    getKey: ()=>'state',
    getData: async (_dataContext, _storeContext)=>{
        const { homepagePreference: homepagePreference } = await (0, $h2wCv.performGetRequest)('/rest/internal/3/homepage/');
        return {
            homepagePreference: homepagePreference
        };
    },
    maxAge: Infinity,
    isCritical: true
});

});

parcelRegister("8HUuJ", function(module, exports) {
$parcel$export(module.exports, "safeCloneResource", () => $bcffcdc520e6a229$export$fbf6681b373be4c4);
$parcel$export(module.exports, "resourceWithCondition", () => $bcffcdc520e6a229$export$cac04afc5a06c544);
$parcel$export(module.exports, "browserOnlyResourceWithCondition", () => $bcffcdc520e6a229$export$5284559c6d2f1a7b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $bcffcdc520e6a229$export$fbf6681b373be4c4 = (resource, amendments = {})=>// @ts-expect-error - TS2322 - Type 'Partial<RouteResource<any>>' is not assignable to type 'RouteResource<any>'.
    resource && // IMPORTANT - resources can be falsy in SSR "routes" build
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.defineProperties({}, {
        ...Object.getOwnPropertyDescriptors(resource),
        ...Object.getOwnPropertyDescriptors(amendments)
    });
const $bcffcdc520e6a229$export$cac04afc5a06c544 = (conditionGetter, itemTrue, itemFalse = $bcffcdc520e6a229$export$fbf6681b373be4c4(itemTrue, {
    getKey: ()=>'DEGENERATE_KEY',
    getData: ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER
}))=>// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'RouteResource<any>': type, getKey, maxAge, getData, and 3 more.
    itemTrue && // IMPORTANT - resources can be falsy in SSR "routes" build
    Object.defineProperties({}, Object.fromEntries([
        ...Object.keys(itemTrue),
        ...Object.keys(itemFalse)
    ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
            key,
            {
                configurable: false,
                enumerable: true,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'.
                get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
            }
        ])));
const $bcffcdc520e6a229$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
        ...resource,
        get isBrowserOnly () {
            return !!conditionGetter();
        }
    };

});

parcelRegister("35eqr", function(module, exports) {
$parcel$export(module.exports, "postOfficeJiraSideNavResource", () => $6b7332bba9d080f0$export$5fd5ab86e70497f7);
$parcel$export(module.exports, "postOfficeJiraYourWorkResource", () => $6b7332bba9d080f0$export$5969dfe9b3b29cd3);
$parcel$export(module.exports, "postOfficeJiraTopBannerResource", () => $6b7332bba9d080f0$export$af242b8c8ffaab42);
$parcel$export(module.exports, "conditionalPostOfficeJiraTopBannerResource", () => $6b7332bba9d080f0$export$d1df0b3b482d298d);
$parcel$export(module.exports, "postOfficeNav4ProjectsSectionResource", () => $6b7332bba9d080f0$export$3f8e412b85cb402b);
$parcel$export(module.exports, "postOfficeAssetsMenuItemFreeUsersPlacementResource", () => $6b7332bba9d080f0$export$b3f8f7e30d409756);
$parcel$export(module.exports, "postOfficeAssetsSideNavUpsellDashboardsPlacementResource", () => $6b7332bba9d080f0$export$c3cdc6310ca9e561);
$parcel$export(module.exports, "postOfficeAssetsSideNavUpsellDataManagerPlacementResource", () => $6b7332bba9d080f0$export$60d00956f847a);
/* eslint-disable jira/import-whitelist */ 
var $8HUuJ = parcelRequire("8HUuJ");

var $cr9yX = parcelRequire("cr9yX");

var $7edbf = parcelRequire("7edbf");

var $i860n = parcelRequire("i860n");
const $6b7332bba9d080f0$export$fd097948b42db8d3 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__SCREEN_SPACE_FLAGS',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('screen-space-flags', tenantContext);
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$export$5fd5ab86e70497f7 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_SIDE_NAV',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('jira-side-nav', tenantContext);
    },
    maxAge: Infinity,
    isCritical: true
});
const $6b7332bba9d080f0$export$5969dfe9b3b29cd3 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_YOUR_WORK',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('jira-your-work', tenantContext);
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$export$af242b8c8ffaab42 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_TOP_BANNER',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isSiteAdmin: isSiteAdmin } = tenantContext;
        if (isSiteAdmin) return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('jira-top-banner', tenantContext);
        return null;
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$export$d1df0b3b482d298d = (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jira-issue-term-refresh-banner'), $6b7332bba9d080f0$export$af242b8c8ffaab42);
const $6b7332bba9d080f0$export$1d4ef0f14729d528 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__NAV_4_SECTION',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('nav-4-section', tenantContext);
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$var$nav4ProjectsSectionEnabledGroup = new Set([
    'classic-business',
    'classic-software',
    'home',
    'issue',
    'issue-navigator',
    'legacy',
    'polaris',
    'servicedesk',
    'software',
    'software-reports-boardless'
]);
const $6b7332bba9d080f0$export$3f8e412b85cb402b = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__NAV_4_PROJECTS_SECTION',
    getKey: ()=>'state',
    getData: async ({ route: { group: group } }, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        if (!group || !$6b7332bba9d080f0$var$nav4ProjectsSectionEnabledGroup.has(group)) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('nav-4-projects-section', tenantContext);
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$var$FREE_EDITION = 'FREE_EDITION';
const $6b7332bba9d080f0$export$b3f8f7e30d409756 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__ASSETS_MENU_ITEM_FREE_USERS_PLACEMENT',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { appEditions: appEditions, isSiteAdmin: isSiteAdmin } = tenantContext;
        if (!isSiteAdmin || appEditions?.serviceDesk !== $6b7332bba9d080f0$var$FREE_EDITION) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('jira-navbar-assets-app-section', tenantContext);
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$var$STANDARD_EDITION = 'STANDARD_EDITION';
const $6b7332bba9d080f0$export$c3cdc6310ca9e561 = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__ASSETS_SIDE_NAV_UPSELL_DASHBOARDS_PLACEMENT',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isSiteAdmin: isSiteAdmin, appEditions: appEditions } = tenantContext;
        if (!isSiteAdmin || appEditions?.serviceDesk !== $6b7332bba9d080f0$var$STANDARD_EDITION) return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('jsm-assets-app-navbar-dashboards-section', tenantContext);
    },
    maxAge: Infinity
});
const $6b7332bba9d080f0$export$60d00956f847a = (0, $7edbf.createResource)({
    type: 'POST_OFFICE_PLACEMENT__ASSETS_SIDE_NAV_UPSELL_DATA_MANAGER_PLACEMENT',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isSiteAdmin: isSiteAdmin, appEditions: appEditions } = tenantContext;
        if (!isSiteAdmin || appEditions?.serviceDesk !== 'STANDARD_EDITION') return null;
        return (0, $cr9yX.preloadPostOfficePlacementWithTenantContext)('jsm-assets-app-navbar-data-manager-section', tenantContext);
    },
    maxAge: Infinity
});

});
parcelRegister("cr9yX", function(module, exports) {
$parcel$export(module.exports, "usePlacementSSRFetch", () => $0ec44b4e01b4dba6$export$420f2f91a928b3b6);
$parcel$export(module.exports, "usePlacementPreloadedData", () => $0ec44b4e01b4dba6$export$17b92961ead3f211);
$parcel$export(module.exports, "preloadPostOfficePlacementWithTenantContext", () => $0ec44b4e01b4dba6$export$65b5eab182e1ca6f);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $dJ3NQ = parcelRequire("dJ3NQ");

var $hIRki = parcelRequire("hIRki");

var $h2wCv = parcelRequire("h2wCv");

var $2yTew = parcelRequire("2yTew");

var $3MAu1 = parcelRequire("3MAu1");

var $k6ufm = parcelRequire("k6ufm");

var $i860n = parcelRequire("i860n");

var $aYGh8 = parcelRequire("aYGh8");
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $0ec44b4e01b4dba6$var$preloadPostOfficePlacement = async (placementId, contextOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    const jiraFetcherWithS2SHeaders = async (url)=>{
        let hostEnv = 'prod';
        if (environment.currentEnv !== 'production') hostEnv = 'staging';
        const fetchHeaders = {
            'x-ssr-service-name': 'post-office',
            'x-ssr-service-env': hostEnv
        };
        return (0, $h2wCv.performGetRequest)(url.replace('gateway/api/post-office/', ''), {
            headers: fetchHeaders
        });
    };
    return (0, $3MAu1.requestInitialData)(placementId, postOfficeContext, false && !(0, $dJ3NQ.default)() ? jiraFetcherWithS2SHeaders : (0, $h2wCv.performGetRequest), (0, $2yTew.buildBasePath)(environment.currentEnv, environment.envConfigs));
};
const $0ec44b4e01b4dba6$export$420f2f91a928b3b6 = (resource)=>{
    const { data: data } = (0, $k6ufm.useResource)(resource);
    return (0, $euxye.useCallback)(()=>{
        if (data) {
            /**
			 * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
			 * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
			 */ const init = {
                status: 200,
                statusText: 'ok!'
            };
            return Promise.resolve(new Response(JSON.stringify(data), init));
        }
    }, [
        data
    ]);
};
const $0ec44b4e01b4dba6$export$17b92961ead3f211 = (resource)=>{
    const { data: data, clear: clear } = (0, $k6ufm.useResource)(resource);
    return [
        data,
        clear
    ];
};
const $0ec44b4e01b4dba6$export$65b5eab182e1ca6f = async (placementId, preloadedTenantContext)=>{
    if ((0, $i860n.fg)('jpx-870-stable-ui-for-criterion')) {
        if ((0, $hIRki.isStableUIEnabledForTests)()) return Promise.resolve(null);
    }
    return $0ec44b4e01b4dba6$var$preloadPostOfficePlacement(placementId, {
        postOfficeContext: (0, $aYGh8.tenantToPostOfficeContext)(preloadedTenantContext),
        environment: {
            currentEnv: (0, $aYGh8.transformJiraEnvToPostOfficeEnvironment)(preloadedTenantContext.environment)
        }
    });
};

});
parcelRegister("2yTew", function(module, exports) {
$parcel$export(module.exports, "buildBasePath", () => $4bd74d1d620d3a33$export$e8b30f9c4a80230f);


var $fgdQf = parcelRequire("fgdQf");
const $4bd74d1d620d3a33$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $fgdQf.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $da770e4947af19bb$export$d4fe3482c88e73a8);
    return {
        baseUrl: baseUrl,
        path: path
    };
};

});
const $da770e4947af19bb$export$5ca004be156a127a = 'http://localhost:4224';
const $da770e4947af19bb$export$a5c5394c951a9848 = '/gateway/api/post-office/api/v1/placements/';
const $da770e4947af19bb$export$1e9fed4c0197724c = 'http://localhost:8081';
const $da770e4947af19bb$export$919a9569bce66f17 = '/api/v1/placements/';
const $da770e4947af19bb$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $da770e4947af19bb$export$67be2569ef5d7666 = 'http://localhost:9009';
const $da770e4947af19bb$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $da770e4947af19bb$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';
const $da770e4947af19bb$export$a2ac4fea250cfcb6 = 'https://post-office-rml-frontend.stg.frontend.cdn.atlassian-us-gov-mod.com';
const $da770e4947af19bb$export$4db578e7ea13bd1b = 'https://post-office-rml-frontend.frontend.cdn.atlassian-us-gov-mod.com';

parcelRegister("fgdQf", function(module, exports) {
$parcel$export(module.exports, "buildDefaultEnvironmentValues", () => $2e77d01e0cd0ee89$export$5dba87a2097d7fb2);
$parcel$export(module.exports, "defaultEnvironmentValues", () => $2e77d01e0cd0ee89$export$b4ede87479bfcf09);
$parcel$export(module.exports, "PostOfficeEnvironmentProvider", () => $2e77d01e0cd0ee89$export$604607f913ef367c);
$parcel$export(module.exports, "usePostOfficeEnvironment", () => $2e77d01e0cd0ee89$export$877b97169cc75e8b);

var $euxye = parcelRequire("euxye");

const $2e77d01e0cd0ee89$export$5dba87a2097d7fb2 = (isFedRampCompliantUrlsEnabled = false)=>{
    return {
        currentEnv: 'local',
        envConfigs: {
            'test-server': {
                remoteModule: {
                    origin: (0, $da770e4947af19bb$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $da770e4947af19bb$export$5ca004be156a127a),
                    pathname: (0, $da770e4947af19bb$export$5ca004be156a127a),
                    searchParams: undefined
                }
            },
            test: {
                remoteModule: {
                    origin: (0, $da770e4947af19bb$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $da770e4947af19bb$export$1e9fed4c0197724c),
                    pathname: (0, $da770e4947af19bb$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            local: {
                remoteModule: {
                    origin: (0, $da770e4947af19bb$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $da770e4947af19bb$export$1e9fed4c0197724c),
                    pathname: (0, $da770e4947af19bb$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            dev: {
                remoteModule: {
                    origin: (0, $da770e4947af19bb$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $da770e4947af19bb$export$1e9fed4c0197724c),
                    pathname: (0, $da770e4947af19bb$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            staging: {
                remoteModule: {
                    origin: (0, $da770e4947af19bb$export$b49738b89db261cd),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $da770e4947af19bb$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            'stg-fedm-east': {
                remoteModule: {
                    origin: isFedRampCompliantUrlsEnabled ? (0, $da770e4947af19bb$export$a2ac4fea250cfcb6) : (0, $da770e4947af19bb$export$b49738b89db261cd),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $da770e4947af19bb$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            production: {
                remoteModule: {
                    origin: (0, $da770e4947af19bb$export$bbd96cd490b0df63),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $da770e4947af19bb$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            'prod-fedm-east': {
                remoteModule: {
                    origin: isFedRampCompliantUrlsEnabled ? (0, $da770e4947af19bb$export$4db578e7ea13bd1b) : (0, $da770e4947af19bb$export$bbd96cd490b0df63),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $da770e4947af19bb$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            }
        }
    };
};
const $2e77d01e0cd0ee89$export$b4ede87479bfcf09 = $2e77d01e0cd0ee89$export$5dba87a2097d7fb2();
const $2e77d01e0cd0ee89$export$fceca2c399b32565 = (0, $euxye.createContext)($2e77d01e0cd0ee89$export$b4ede87479bfcf09);
const $2e77d01e0cd0ee89$export$604607f913ef367c = $2e77d01e0cd0ee89$export$fceca2c399b32565.Provider;
const $2e77d01e0cd0ee89$export$877b97169cc75e8b = ()=>(0, $euxye.useContext)($2e77d01e0cd0ee89$export$fceca2c399b32565);

});


parcelRegister("3MAu1", function(module, exports) {
$parcel$export(module.exports, "requestInitialData", () => $7289bb8c05aa9759$export$c4c39037cc4b06ab);
const $7289bb8c05aa9759$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $7289bb8c05aa9759$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $7289bb8c05aa9759$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};

});

parcelRegister("aYGh8", function(module, exports) {
$parcel$export(module.exports, "tenantToPostOfficeContext", () => $657335a6a5ada935$export$d8f2c334a0924146);
$parcel$export(module.exports, "subproductToEdition", () => $657335a6a5ada935$export$2d690d13b91ea44f);
$parcel$export(module.exports, "transformJiraEnvToPostOfficeEnvironment", () => $657335a6a5ada935$export$cfacfecb20987ff1);
$parcel$export(module.exports, "useSubproduct", () => $657335a6a5ada935$export$9554712c4f0a714e);
/* eslint-disable jira/filename-case */ 
var $hIRki = parcelRequire("hIRki");

var $fDVI0 = parcelRequire("fDVI0");

var $i860n = parcelRequire("i860n");

var $f2wVS = parcelRequire("f2wVS");

var $7EMaG = parcelRequire("7EMaG");

var $2700E = parcelRequire("2700E");
const $657335a6a5ada935$var$JIRA_PRODUCT = 'jira';
const $657335a6a5ada935$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $657335a6a5ada935$var$JIRA_PRODUCT,
    locale: 'en'
};
const $657335a6a5ada935$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return (0, $fDVI0.JiraWorkspaceAri).create({
        activationId: activationId,
        siteId: cloudId
    }).toString();
};
const $657335a6a5ada935$export$d8f2c334a0924146 = (tenantData)=>{
    const { activationId: activationId, cloudId: cloudId, isSiteAdmin: isSiteAdmin, locale: locale, isAdmin: isAdmin } = tenantData;
    const workspaceAri = $657335a6a5ada935$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$657335a6a5ada935$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        isSiteAdmin: isSiteAdmin,
        tenantId: cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        isAdmin: isAdmin,
        orgId: undefined,
        subproduct: undefined,
        productEdition: undefined,
        disableAllPlacements: (0, $hIRki.isStableUIEnabledForTests)() && (0, $i860n.fg)('jpx-870-stable-ui-for-criterion') ? true : undefined
    };
};
const $657335a6a5ada935$export$2d690d13b91ea44f = (subproduct, editions)=>{
    switch(subproduct){
        case 'core':
            return editions.core;
        case 'software':
            return editions.software;
        case 'customerService':
            return editions.customerService;
        case 'service_desk':
        case 'serviceDesk':
            return editions.serviceDesk;
        default:
            undefined;
    }
};
const $657335a6a5ada935$export$cfacfecb20987ff1 = (environment)=>{
    switch(environment){
        case 'dev':
        case 'staging':
            return 'staging';
        case 'prod':
            return 'production';
        case 'local':
            return 'local';
        default:
            return 'local';
    }
};
const $657335a6a5ada935$export$9554712c4f0a714e = (projectType)=>{
    const isOpsRoute = (0, $f2wVS.useIsActiveRoute)((0, $7EMaG.operationsConverter).routes);
    const [jsmgrowth466Star] = (0, $2700E.UNSAFE_noExposureExp)('jsmgrowth466_star');
    return projectType ?? (isOpsRoute && jsmgrowth466Star.get('cohort', 'not-enrolled') === 'variation' ? 'service_desk' : undefined);
};

});
parcelRegister("7EMaG", function(module, exports) {
$parcel$export(module.exports, "operationsConverter", () => $70dac5b32a6b6f77$export$7fc92455d5020e1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $70dac5b32a6b6f77$var$routes = new Set([
    'eoc-automations',
    'eoc-custom-roles',
    'eoc-global-alerts',
    'eoc-global-alerts-redirect',
    'eoc-global-alert-detail',
    'eoc-global-group-detail',
    'eoc-global-reports',
    'eoc-global-report-dashboard',
    'eoc-group-policy',
    'eoc-heartbeats',
    'eoc-global-heartbeats',
    'eoc-maintenance',
    'eoc-on-call',
    'eoc-on-call-redirect',
    'eoc-overview',
    'eoc-overview-all-teams',
    'eoc-permissions',
    'eoc-reports',
    'eoc-reports-team',
    'eoc-reports-unsubscribe',
    'eoc-schedules',
    'eoc-team-alerts',
    'eoc-team-alert-detail',
    'eoc-team-alert-issue-syncing',
    'eoc-team-alert-issue-syncing-create',
    'eoc-team-alert-issue-syncing-detail',
    'eoc-team-group-detail',
    'eoc-team-integrations',
    'eoc-team-integration-create',
    'eoc-team-integration-detail',
    'eoc-team-integration-list',
    'eoc-team-integration-log',
    'eoc-team-policies',
    'eoc-who-is-on-call',
    'eoc-global-escalations',
    'communications-status-page',
    'communications-status-page-configuration',
    'communications-status-page-create',
    'communications-status-page-details',
    'communications-status-page-preview',
    'communications-stakeholder-groups',
    'communications-stakeholders',
    'eoc-merge-teams',
    'servicedesk-service-list',
    'eoc-changes',
    'eoc-incidents'
]);
function $70dac5b32a6b6f77$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_OPERATIONS)
    ];
    return $70dac5b32a6b6f77$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $70dac5b32a6b6f77$var$convertNew(args) {
    const { routeName: routeName, query: query } = args;
    const path = [
        (0, $5IkoH.MENU_ID_OPERATIONS)
    ];
    return $70dac5b32a6b6f77$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $70dac5b32a6b6f77$var$convertRouteToPath(args) {
    const { routeName: routeName, query: query, path: path } = args;
    switch(routeName){
        case 'eoc-who-is-on-call':
            path.push((0, $5IkoH.MENU_ID_OPS_ON_CALL));
            break;
        case 'eoc-changes':
            path.push((0, $5IkoH.MENU_ID_OPS_CHANGES));
            break;
        case 'eoc-incidents':
            path.push((0, $5IkoH.MENU_ID_OPS_INCIDENTS));
            break;
        case 'eoc-global-alerts':
        case 'eoc-global-alerts-redirect':
        case 'eoc-global-alert-detail':
            {
                path.push((0, $5IkoH.MENU_ID_OPS_ALERTS));
                const { query: alarmQueue = '', view: view, filter: savedSearchId } = query;
                view && path.push((0, $5IkoH.ENTITY_ID).ALARM_QUEUE(savedSearchId || alarmQueue));
                break;
            }
        case 'eoc-global-reports':
        case 'eoc-global-report-dashboard':
        case 'eoc-reports-unsubscribe':
            path.push((0, $5IkoH.MENU_ID_OPS_REPORTS));
            break;
        case 'communications-status-page':
        case 'communications-status-page-configuration':
        case 'communications-status-page-create':
        case 'communications-status-page-details':
            path.push((0, $5IkoH.MENU_ID_OPS_STATUS_PAGES));
            break;
        case 'eoc-automations':
        case 'eoc-global-group-detail':
        case 'eoc-group-policy':
        case 'eoc-heartbeats':
        case 'eoc-maintenance':
        case 'eoc-permissions':
        case 'eoc-on-call':
        case 'eoc-on-call-redirect':
        case 'eoc-overview':
        case 'eoc-overview-all-teams':
        case 'eoc-reports':
        case 'eoc-reports-team':
        case 'eoc-schedules':
        case 'eoc-team-group-detail':
        case 'eoc-team-alerts':
        case 'eoc-team-alert-detail':
        case 'eoc-team-policies':
        case 'eoc-team-alert-issue-syncing':
        case 'eoc-team-alert-issue-syncing-create':
        case 'eoc-team-alert-issue-syncing-detail':
        case 'eoc-team-integrations':
        case 'eoc-team-integration-create':
        case 'eoc-team-integration-detail':
        case 'eoc-team-integration-list':
        case 'eoc-team-integration-log':
            path.push((0, $5IkoH.MENU_ID_OPS_OVERVIEW));
            break;
        case 'communications-stakeholder-groups':
            path.push((0, $5IkoH.MENU_ID_COMMUNICATIONS_STAKEHOLDERS));
            break;
        case 'communications-stakeholders':
            path.push((0, $5IkoH.MENU_ID_COMMUNICATIONS_STAKEHOLDERS));
            break;
        case 'servicedesk-service-list':
            path.push((0, $5IkoH.MENU_ID_OPS_SERVICES));
            break;
        default:
            break;
    }
    return path;
}
const $70dac5b32a6b6f77$export$7fc92455d5020e1 = {
    routes: $70dac5b32a6b6f77$var$routes,
    convert: $70dac5b32a6b6f77$var$convert,
    convertNew: $70dac5b32a6b6f77$var$convertNew
};

});
parcelRegister("5IkoH", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_APP_MENU_ID", () => $1115372cb5af13eb$export$1bb3d16bc95080e3);
$parcel$export(module.exports, "GLOBAL_APP_MENU_ID_TO_APS_KEY", () => $1115372cb5af13eb$export$3b4ca8d4d769a311);
$parcel$export(module.exports, "CONFIGURABLE_MENU_ID", () => $1115372cb5af13eb$export$7838b734e4cd5e8d);
$parcel$export(module.exports, "ENTITY_ID", () => $1115372cb5af13eb$export$103ff18fe29ee1b);
$parcel$export(module.exports, "MENU_ID_APPS", () => $1115372cb5af13eb$export$441cd608ea3204f4);
$parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", () => $1115372cb5af13eb$export$5baa9c2e3c3931c5);
$parcel$export(module.exports, "MENU_ID_ASSETS", () => $1115372cb5af13eb$export$75c65bfc98b3a6e1);
$parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", () => $1115372cb5af13eb$export$8a0af92d49f1d13d);
$parcel$export(module.exports, "MENU_ID_ASSETS_FOR_YOU", () => $1115372cb5af13eb$export$5115ccb493164b9);
$parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", () => $1115372cb5af13eb$export$a09300d15acc958a);
$parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", () => $1115372cb5af13eb$export$4d718fbd418eef5c);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS", () => $1115372cb5af13eb$export$dd009509c2dabb5e);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", () => $1115372cb5af13eb$export$d3da0455b4200fb2);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", () => $1115372cb5af13eb$export$b9dd2b5309d19763);
$parcel$export(module.exports, "MENU_ID_FILTERS", () => $1115372cb5af13eb$export$3d81af172a8e3c57);
$parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", () => $1115372cb5af13eb$export$1e2599eaf0039a97);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", () => $1115372cb5af13eb$export$53d274d993c9d5b5);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", () => $1115372cb5af13eb$export$7661ea763be69cfa);
$parcel$export(module.exports, "MENU_ID_GOALS", () => $1115372cb5af13eb$export$47c6ce6a83a59eab);
$parcel$export(module.exports, "MENU_ID_OPERATIONS", () => $1115372cb5af13eb$export$ef89639b7d9c162a);
$parcel$export(module.exports, "MENU_ID_OPS_ALERTS", () => $1115372cb5af13eb$export$af4ab6d4e920522a);
$parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", () => $1115372cb5af13eb$export$25c40acb2c53a294);
$parcel$export(module.exports, "MENU_ID_OPS_REPORTS", () => $1115372cb5af13eb$export$c7d8892f1628b844);
$parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", () => $1115372cb5af13eb$export$bb19a52e3df99541);
$parcel$export(module.exports, "MENU_ID_OPS_SERVICES", () => $1115372cb5af13eb$export$846b10f022fceb32);
$parcel$export(module.exports, "MENU_ID_OPS_CHANGES", () => $1115372cb5af13eb$export$775e96337e8fc123);
$parcel$export(module.exports, "MENU_ID_OPS_INCIDENTS", () => $1115372cb5af13eb$export$cd895f354efca243);
$parcel$export(module.exports, "MENU_ID_PLANS", () => $1115372cb5af13eb$export$f2533da33c749933);
$parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", () => $1115372cb5af13eb$export$8468c5b6648f4f1f);
$parcel$export(module.exports, "MENU_ID_PROJECT_APPS", () => $1115372cb5af13eb$export$fed17b4c0866b97d);
$parcel$export(module.exports, "MENU_ID_PROJECTS", () => $1115372cb5af13eb$export$9c5278bd360a285);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", () => $1115372cb5af13eb$export$85389c606bb641dd);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", () => $1115372cb5af13eb$export$4a1974b63c858e9c);
$parcel$export(module.exports, "MENU_ID_RECENT", () => $1115372cb5af13eb$export$692b796030a796f3);
$parcel$export(module.exports, "MENU_ID_ROADMAPS", () => $1115372cb5af13eb$export$cdc80d4b5ce0c6a);
$parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", () => $1115372cb5af13eb$export$7606c0134aabf3d7);
$parcel$export(module.exports, "MENU_ID_STARRED", () => $1115372cb5af13eb$export$5637ca42a4d77f32);
$parcel$export(module.exports, "MENU_ID_TEAMS", () => $1115372cb5af13eb$export$d4f6fcf571f9c50);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE", () => $1115372cb5af13eb$export$11fcdf33179ef88e);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE_ANALYTICS", () => $1115372cb5af13eb$export$1d260f51eeaab73d);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_EXPERIENCES_VIEW_ALL", () => $1115372cb5af13eb$export$6350780de45cdb54);
$parcel$export(module.exports, "MENU_ID_CUSTOMERS", () => $1115372cb5af13eb$export$7ded421b1395251e);
$parcel$export(module.exports, "MENU_ID_ITAM", () => $1115372cb5af13eb$export$bd6aaea9c871e469);
$parcel$export(module.exports, "MENU_ID_FOR_YOU", () => $1115372cb5af13eb$export$c68b73f0d8c14f41);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_ASSETS", () => $1115372cb5af13eb$export$5aa3e4dd37f372d5);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_GOALS", () => $1115372cb5af13eb$export$7986b535c183c592);
$parcel$export(module.exports, "MENU_ID_COMMUNICATIONS_STAKEHOLDERS", () => $1115372cb5af13eb$export$784c436fb3f51c19);
$parcel$export(module.exports, "MENU_ID_OPS_STATUS_PAGES", () => $1115372cb5af13eb$export$151c003f483b38);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_CONFLUENCE", () => $1115372cb5af13eb$export$c093b87743053085);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_LOOM", () => $1115372cb5af13eb$export$e316a54b33dbe500);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_PROJECTS", () => $1115372cb5af13eb$export$8ceb414d866f12fc);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_TEAMS", () => $1115372cb5af13eb$export$804187987544d0f8);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_OPSGENIE", () => $1115372cb5af13eb$export$83352ab9064f1723);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", () => $1115372cb5af13eb$export$79c15668ed799a1b);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", () => $1115372cb5af13eb$export$e299bb06c4370c0d);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_QUEUES", () => $1115372cb5af13eb$export$761304893631082c);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", () => $1115372cb5af13eb$export$713b9b0a69a79cf9);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", () => $1115372cb5af13eb$export$f1d9c0f27216aa1c);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", () => $1115372cb5af13eb$export$45763fa331781074);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", () => $1115372cb5af13eb$export$6ee20c845dbab3e3);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", () => $1115372cb5af13eb$export$b3815dd180ce5e61);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", () => $1115372cb5af13eb$export$100a1a639a0db980);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_WORKFORCE_OPTIMIZATION", () => $1115372cb5af13eb$export$5325154bd81736de);
/* eslint-disable jira/filename-case */ const $1115372cb5af13eb$export$1bb3d16bc95080e3 = {
    GLOBAL_APP_GOALS: 'jira.sidebar.globalApp.goals',
    GLOBAL_APP_ASSETS: 'jira.sidebar.globalApp.assets',
    // Global App Shortcuts for Platform Component
    GLOBAL_APP_CONFLUENCE: 'jira.sidebar.globalApp.confluence',
    GLOBAL_APP_LOOM: 'jira.sidebar.globalApp.loom',
    GLOBAL_APP_PROJECTS: 'jira.sidebar.globalApp.projects',
    GLOBAL_APP_TEAMS: 'jira.sidebar.globalApp.teams',
    GLOBAL_APP_OPSGENIE: 'jira.sidebar.globalApp.opsgenie'
};
const $1115372cb5af13eb$export$3b4ca8d4d769a311 = {
    [$1115372cb5af13eb$export$1bb3d16bc95080e3.GLOBAL_APP_CONFLUENCE]: 'CONFLUENCE',
    [$1115372cb5af13eb$export$1bb3d16bc95080e3.GLOBAL_APP_LOOM]: 'LOOM',
    [$1115372cb5af13eb$export$1bb3d16bc95080e3.GLOBAL_APP_GOALS]: 'GOALS',
    [$1115372cb5af13eb$export$1bb3d16bc95080e3.GLOBAL_APP_PROJECTS]: 'PROJECTS',
    [$1115372cb5af13eb$export$1bb3d16bc95080e3.GLOBAL_APP_TEAMS]: 'TEAMS',
    [$1115372cb5af13eb$export$1bb3d16bc95080e3.GLOBAL_APP_OPSGENIE]: 'OPSGENIE'
};
const $1115372cb5af13eb$export$7838b734e4cd5e8d = {
    APPS: 'jira.sidebar.apps',
    ASSETS: 'jira.sidebar.assets',
    DASHBOARDS: 'jira.sidebar.dashboards',
    FILTERS: 'jira.sidebar.filters',
    GOALS: 'jira.sidebar.goals',
    OPERATIONS: 'jira.sidebar.operations',
    PLANS: 'jira.sidebar.plans',
    PROJECTS: 'jira.sidebar.projects',
    RECENT: 'jira.sidebar.recent',
    STARRED: 'jira.sidebar.starred',
    TEAMS: 'jira.sidebar.teams',
    ROADMAPS: 'jira.sidebar.roadmaps',
    CUSTOMER_SERVICE: 'jira.sidebar.customerService',
    CUSTOMER_SERVICE_ANALYTICS: 'jira.sidebar.customerServiceAnalytics',
    CUSTOMERS: 'jira.sidebar.customers',
    ITAM: 'jira.sidebar.itam',
    ...$1115372cb5af13eb$export$1bb3d16bc95080e3
};
const $1115372cb5af13eb$export$103ff18fe29ee1b = {
    ALARM_QUEUE: (id)=>`alrm_${id}`,
    APP: (id)=>`app_${id}`,
    BOARD: (id)=>`boar_${id}`,
    DASHBOARD: (id)=>`dash_${id}`,
    FILTER: (id)=>`filt_${id}`,
    FORM: (id)=>`form_${id}`,
    OVERVIEW: (id)=>`over_${id}`,
    PLAN: (id)=>`plan_${id}`,
    PROJECT: (id)=>`proj_${id}`,
    PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
    PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
    PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
    PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
    PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
    PROJECT_WORKFORCE_OPTIMIZATION: (projectKey)=>`proj-${projectKey}-workforce-optimization`,
    PROJECT_WORKFORCE_OPTIMIZATION_SCHEDULES: (projectKey)=>`proj-${projectKey}-wfo-schedules`,
    PROJECT_WORKFORCE_OPTIMIZATION_CAPACITY: (projectKey)=>`proj-${projectKey}-wfo-capacity`,
    PROJECT_WORKFORCE_OPTIMIZATION_AVAILABILITY: (projectKey)=>`proj-${projectKey}-wfo-availability`,
    PROJECT_WORKFORCE_OPTIMIZATION_SKILLS: (projectKey)=>`proj-${projectKey}-wfo-skills`,
    PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
    PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
    PROJECT_JCS_GET_STARTED: (projectKey)=>`proj-${projectKey}-jcs-gtst`,
    PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
    PROJECT_OPERATIONS: (projectKey)=>`proj-${projectKey}-ops`,
    PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
    PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
    PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
    PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
    PROJECT_CHANNELS: (projectKey)=>`proj-${projectKey}-channels`,
    PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
    PROJECT_DASHBOARDS: (projectKey)=>`proj-${projectKey}-dashboards`,
    PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
    PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
    SURVEYS: (projectKey)=>`proj-${projectKey}-surveys`,
    PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
    PROJECT_LIVE_CHAT: (projectKey)=>`proj-${projectKey}-live-chat`,
    ROADMAP: (id)=>`roadmap_${id}`,
    QUEUE: (id)=>`queu_${id}`,
    SUBSPACE: (id)=>`subspace_${id}`,
    ISSUE: (id)=>`issue_${id}`,
    ARCHIVED_WORK_ITEMS: (id)=>`archived_work_items_${id}`,
    PROJECT_ROVO_AGENT: (projectKey)=>`proj-${projectKey}-rovo-agent`,
    PROJECT_JOURNEYS: (projectKey)=>`proj-${projectKey}-journeys`,
    PROJECT_LIVE_CONVERSATIONS: (projectKey)=>`proj-${projectKey}-live-conversations`,
    CUSTOMER_EXPERIENCE: (projectKey)=>`customer-experiences-${projectKey}`,
    CUSTOMER_EXPERIENCES_CHANNELS: (projectKey)=>`customer-experiences-channels-${projectKey}`,
    CUSTOMER_EXPERIENCE_MENU_ITEM: (helpCenterId, itemName)=>`customer-experiences-${helpCenterId}-${itemName}`,
    CHANGE: (id)=>`chng_${id}`,
    INCIDENT: (id)=>`incd_${id}`
}; // We MUST use the same IDs for the same components, otherwise we run into trouble (especially with peeking / more-menu)
const $1115372cb5af13eb$export$441cd608ea3204f4 = $1115372cb5af13eb$export$7838b734e4cd5e8d.APPS;
const $1115372cb5af13eb$export$5baa9c2e3c3931c5 = 'app_mrkt';
const $1115372cb5af13eb$export$75c65bfc98b3a6e1 = $1115372cb5af13eb$export$7838b734e4cd5e8d.ASSETS;
const $1115372cb5af13eb$export$8a0af92d49f1d13d = 'asst_schm';
const $1115372cb5af13eb$export$5115ccb493164b9 = 'asst_for_you';
const $1115372cb5af13eb$export$a09300d15acc958a = 'asst_rprt';
const $1115372cb5af13eb$export$4d718fbd418eef5c = 'board-view-all';
const $1115372cb5af13eb$export$dd009509c2dabb5e = $1115372cb5af13eb$export$7838b734e4cd5e8d.DASHBOARDS;
const $1115372cb5af13eb$export$d3da0455b4200fb2 = 'dash-view';
const $1115372cb5af13eb$export$b9dd2b5309d19763 = 'dash-view-starred';
const $1115372cb5af13eb$export$3d81af172a8e3c57 = $1115372cb5af13eb$export$7838b734e4cd5e8d.FILTERS;
const $1115372cb5af13eb$export$1e2599eaf0039a97 = 'filt-search';
const $1115372cb5af13eb$export$53d274d993c9d5b5 = 'filt-view-all';
const $1115372cb5af13eb$export$7661ea763be69cfa = 'filt-view-starred';
const $1115372cb5af13eb$export$47c6ce6a83a59eab = $1115372cb5af13eb$export$7838b734e4cd5e8d.GOALS;
const $1115372cb5af13eb$export$ef89639b7d9c162a = $1115372cb5af13eb$export$7838b734e4cd5e8d.OPERATIONS;
const $1115372cb5af13eb$export$af4ab6d4e920522a = 'ops-alrt';
const $1115372cb5af13eb$export$25c40acb2c53a294 = 'ops-over';
const $1115372cb5af13eb$export$c7d8892f1628b844 = 'ops-rprt';
const $1115372cb5af13eb$export$bb19a52e3df99541 = 'ops-oncl';
const $1115372cb5af13eb$export$846b10f022fceb32 = 'ops-srvc';
const $1115372cb5af13eb$export$775e96337e8fc123 = 'ops-chng';
const $1115372cb5af13eb$export$cd895f354efca243 = 'ops-incd';
const $1115372cb5af13eb$export$f2533da33c749933 = $1115372cb5af13eb$export$7838b734e4cd5e8d.PLANS;
const $1115372cb5af13eb$export$8468c5b6648f4f1f = 'plan-view-all';
const $1115372cb5af13eb$export$fed17b4c0866b97d = 'proj-app';
const $1115372cb5af13eb$export$9c5278bd360a285 = $1115372cb5af13eb$export$7838b734e4cd5e8d.PROJECTS;
const $1115372cb5af13eb$export$85389c606bb641dd = 'proj-view-all';
const $1115372cb5af13eb$export$4a1974b63c858e9c = 'proj-view-starred';
const $1115372cb5af13eb$export$692b796030a796f3 = $1115372cb5af13eb$export$7838b734e4cd5e8d.RECENT;
const $1115372cb5af13eb$export$cdc80d4b5ce0c6a = $1115372cb5af13eb$export$7838b734e4cd5e8d.ROADMAPS;
const $1115372cb5af13eb$export$7606c0134aabf3d7 = 'roadmaps-view-all';
const $1115372cb5af13eb$export$5637ca42a4d77f32 = $1115372cb5af13eb$export$7838b734e4cd5e8d.STARRED;
const $1115372cb5af13eb$export$d4f6fcf571f9c50 = $1115372cb5af13eb$export$7838b734e4cd5e8d.TEAMS;
const $1115372cb5af13eb$export$11fcdf33179ef88e = $1115372cb5af13eb$export$7838b734e4cd5e8d.CUSTOMER_SERVICE;
const $1115372cb5af13eb$export$1d260f51eeaab73d = $1115372cb5af13eb$export$7838b734e4cd5e8d.CUSTOMER_SERVICE_ANALYTICS;
const $1115372cb5af13eb$export$6350780de45cdb54 = 'customer-experiences-view-all';
const $1115372cb5af13eb$export$7ded421b1395251e = $1115372cb5af13eb$export$7838b734e4cd5e8d.CUSTOMERS;
const $1115372cb5af13eb$export$bd6aaea9c871e469 = $1115372cb5af13eb$export$7838b734e4cd5e8d.ITAM;
const $1115372cb5af13eb$export$c68b73f0d8c14f41 = 'for-you';
const $1115372cb5af13eb$export$5aa3e4dd37f372d5 = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_ASSETS;
const $1115372cb5af13eb$export$7986b535c183c592 = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_GOALS;
const $1115372cb5af13eb$export$b3b2df3daae04417 = 'comm';
const $1115372cb5af13eb$export$784c436fb3f51c19 = 'comm-stkhldr';
const $1115372cb5af13eb$export$205988f610130417 = 'comm-stkhldr-grp';
const $1115372cb5af13eb$export$151c003f483b38 = 'ops-status-pages';
const $1115372cb5af13eb$export$c093b87743053085 = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_CONFLUENCE;
const $1115372cb5af13eb$export$e316a54b33dbe500 = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_LOOM;
const $1115372cb5af13eb$export$8ceb414d866f12fc = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_PROJECTS;
const $1115372cb5af13eb$export$804187987544d0f8 = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_TEAMS;
const $1115372cb5af13eb$export$83352ab9064f1723 = $1115372cb5af13eb$export$7838b734e4cd5e8d.GLOBAL_APP_OPSGENIE;
const $1115372cb5af13eb$export$79c15668ed799a1b = 'sd-sett-acc';
const $1115372cb5af13eb$export$e299bb06c4370c0d = 'sd-sett-req-man';
const $1115372cb5af13eb$export$761304893631082c = 'sd-sett-queues';
const $1115372cb5af13eb$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
const $1115372cb5af13eb$export$f1d9c0f27216aa1c = 'sd-sett-aut';
const $1115372cb5af13eb$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
const $1115372cb5af13eb$export$6ee20c845dbab3e3 = 'sd-sett-not';
const $1115372cb5af13eb$export$b3815dd180ce5e61 = 'sd-sett-apps';
const $1115372cb5af13eb$export$100a1a639a0db980 = 'sd-sett-ops';
const $1115372cb5af13eb$export$5325154bd81736de = 'sd-sett-wfo';

});





parcelRegister("fjAPO", function(module, exports) {
$parcel$export(module.exports, "previewPanelStateResource", () => $e3b0fba53e715ea5$export$c2ef0c3db4ecdea3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $htsFl = parcelRequire("htsFl");

var $3rR8c = parcelRequire("3rR8c");
const $e3b0fba53e715ea5$export$c2ef0c3db4ecdea3 = (0, $htsFl.createRelayResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_PREVIEW_PANEL`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $3rR8c.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true,
    isBrowserOnly: false
});

});
parcelRegister("3rR8c", function(module, exports) {
$parcel$export(module.exports, "default", () => $5aed9609d88e567f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<13a67e098546aefb12c81c3e0e532bef>>
 * @relayHash b395f613968319e8a511c65e3f1ee5fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0bd19038110f3e5bb601e887eb92c999d5f1bd367631b389e79e2bc34a42c0a2
const $5aed9609d88e567f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "concreteType": "JiraPreviewPanelState",
        "kind": "LinkedField",
        "name": "previewPanel",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "width"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0bd19038110f3e5bb601e887eb92c999d5f1bd367631b389e79e2bc34a42c0a2",
            "metadata": {},
            "name": "PreviewPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5aed9609d88e567f$var$node.hash = "7327e4b44435e860a8ce1fbd4e39a463";
var $5aed9609d88e567f$export$2e2bcd8739ae039 = $5aed9609d88e567f$var$node;

});


parcelRegister("4B518", function(module, exports) {
$parcel$export(module.exports, "jiraSpaResources", () => $6e55983249e4938b$export$f242b830889fd508);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $8HUuJ = parcelRequire("8HUuJ");

var $7Zyu5 = parcelRequire("7Zyu5");

var $i860n = parcelRequire("i860n");

var $9Q50z = parcelRequire("9Q50z");
const $6e55983249e4938b$export$f242b830889fd508 = ()=>[
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jpx-463-spa-relay-query'), (0, $9Q50z.jiraSpaPageContainerResource)),
        (0, $7Zyu5.themePreferenceResource)
    ];

});
parcelRegister("7Zyu5", function(module, exports) {
$parcel$export(module.exports, "themePreferenceResource", () => $5198e2436cb830c2$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $5198e2436cb830c2$export$3416635c8aeb5bab);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $6ZLJT = parcelRequire("6ZLJT");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $8I8y6 = parcelRequire("8I8y6");

var $CXcYw = parcelRequire("CXcYw");

var $1M80L = parcelRequire("1M80L");

const $5198e2436cb830c2$export$e5a423d1eb1cf1d0 = (0, $7edbf.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("ilTfh")),
    maxAge: 300000,
    isCritical: true
});
// TODO (DST): Should be deleted along with shared-user-preferences cleanup
/**
 * Original implementation of useThemePreference (pre shared-user-preferences feature)
 */ const $5198e2436cb830c2$var$useThemePreferenceOld = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $k6ufm.useResource)($5198e2436cb830c2$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $euxye.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $8I8y6.THEME_PREFERENCES_ANALYTICS_ACTION),
            actionSubject: (0, $8I8y6.THEME_PREFERENCES_ANALYTICS_SUBJECT)
        });
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $euxye.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $CXcYw.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};
const $5198e2436cb830c2$var$useThemePreferenceCombined = (0, $6ZLJT.functionUnionWithCondition)(()=>(0, $i860n.fg)('shared-user-preferences'), ()=>(0, $1M80L.useThemePreference)($5198e2436cb830c2$export$e5a423d1eb1cf1d0), $5198e2436cb830c2$var$useThemePreferenceOld);
const $5198e2436cb830c2$export$3416635c8aeb5bab = ()=>{
    return $5198e2436cb830c2$var$useThemePreferenceCombined();
};

});
parcelRegister("8I8y6", function(module, exports) {
$parcel$export(module.exports, "THEME_PREFERENCE_KEY", () => $022db685d19a6057$export$40bd77e1c9f49c27);
$parcel$export(module.exports, "THEME_PREFERENCES_ANALYTICS_SUBJECT", () => $022db685d19a6057$export$9e2cc65718a61846);
$parcel$export(module.exports, "THEME_PREFERENCES_ANALYTICS_ACTION", () => $022db685d19a6057$export$89c5cf64ad15c3ea);
$parcel$export(module.exports, "themeColorModes", () => $022db685d19a6057$export$83993de8eb66733);
$parcel$export(module.exports, "DEFAULT_COLOR_MODE", () => $022db685d19a6057$export$854b45b62d1eb6d4);
/* eslint-disable jira/filename-case */ const $022db685d19a6057$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $022db685d19a6057$export$9e2cc65718a61846 = 'themePreference';
const $022db685d19a6057$export$89c5cf64ad15c3ea = 'changed';
const $022db685d19a6057$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $022db685d19a6057$export$854b45b62d1eb6d4 = 'auto';

});

parcelRegister("CXcYw", function(module, exports) {
$parcel$export(module.exports, "setThemePreference", () => $0d65de2975f04394$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $0d65de2975f04394$export$2f7a12048d96237);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $fNXFu = parcelRequire("fNXFu");

var $gfzbQ = parcelRequire("gfzbQ");

var $8I8y6 = parcelRequire("8I8y6");
const $0d65de2975f04394$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $fNXFu.userPreferenceAPI).set((0, $8I8y6.THEME_PREFERENCE_KEY), theme);
    promise.catch((error)=>{
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $0d65de2975f04394$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $fNXFu.userPreferenceAPI).get((0, $8I8y6.THEME_PREFERENCE_KEY));
    promise.catch((error)=>{
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $gfzbQ.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $gfzbQ.ThemeOptions).includes(theme) ? theme : undefined;
};

});
parcelRegister("gfzbQ", function(module, exports) {
$parcel$export(module.exports, "ThemeOptions", () => $bb4e6cab7a7e53ed$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $bb4e6cab7a7e53ed$export$2faeed762aac6741);
/* eslint-disable jira/filename-case */ // This type inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $bb4e6cab7a7e53ed$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $bb4e6cab7a7e53ed$export$2faeed762aac6741 = 'light';

});


parcelRegister("1M80L", function(module, exports) {
$parcel$export(module.exports, "useThemePreference", () => $3b5dab09f64a4178$export$3416635c8aeb5bab);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $k6ufm = parcelRequire("k6ufm");

var $kt86l = parcelRequire("kt86l");

var $h3LJR = parcelRequire("h3LJR");

var $3GN2r = parcelRequire("3GN2r");

var $8I8y6 = parcelRequire("8I8y6");

var $eHBZS = parcelRequire("eHBZS");
const $3b5dab09f64a4178$export$3416635c8aeb5bab = (themePreferenceResource)=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $k6ufm.useResource)(themePreferenceResource);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    // Get tenant context using hooks
    const cloudId = (0, $kt86l.useCloudId)();
    const activationId = (0, $h3LJR.useActivationId)();
    const accountId = (0, $3GN2r.useAccountId)();
    const fireThemeAnalytics = (0, $euxye.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $8I8y6.THEME_PREFERENCES_ANALYTICS_ACTION),
            actionSubject: (0, $8I8y6.THEME_PREFERENCES_ANALYTICS_SUBJECT)
        });
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $euxye.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $eHBZS.setThemePreference)(theme, cloudId, activationId, accountId);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics,
        cloudId,
        activationId,
        accountId
    ]);
    return {
        theme: data?.theme ?? (0, $8I8y6.DEFAULT_COLOR_MODE),
        setTheme: setTheme
    };
};

});
parcelRegister("kt86l", function(module, exports) {
$parcel$export(module.exports, "useCloudId", () => $2bfc45038d77637a$export$9da0f7c65f28ed16);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $2bfc45038d77637a$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("h3LJR", function(module, exports) {
$parcel$export(module.exports, "useActivationId", () => $c2dc38b8355b1878$export$43686faa787c943);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $c2dc38b8355b1878$export$43686faa787c943 = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.activationId;
};

});

parcelRegister("3GN2r", function(module, exports) {
$parcel$export(module.exports, "useAccountId", () => $9f2e6f8168ebe10a$export$e72033e0f5baa3e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $9f2e6f8168ebe10a$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});

parcelRegister("eHBZS", function(module, exports) {
$parcel$export(module.exports, "setThemePreference", () => $9c2360be3f5e8123$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $9c2360be3f5e8123$export$2f7a12048d96237);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $fDVI0 = parcelRequire("fDVI0");

var $aI7em = parcelRequire("aI7em");

var $iCK9i = parcelRequire("iCK9i");

var $8I8y6 = parcelRequire("8I8y6");
const $9c2360be3f5e8123$var$handleThemePreferenceError = (error, operation, additionalAttributes)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const err = error;
    (0, $hFtK7.fireErrorAnalytics)({
        meta: {
            id: 'ThemePreferenceCRUD',
            packageName: 'jiraRouterResourcesThemePreference'
        },
        error: err,
        attributes: {
            op: operation,
            errName: String(err.name),
            statusCode: err.statusCode,
            ...additionalAttributes
        }
    });
};
const $9c2360be3f5e8123$export$a6b84eebd33787e2 = async (colorMode, cloudId, activationId, accountId)=>{
    try {
        // Create workspace ARI only when feature flag is enabled
        const workspaceAri = (0, $fDVI0.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        if (!accountId) // Shared theming is supported for logged in users only
        return;
        // Use platform package for GraphQL operations
        await (0, $iCK9i.updateWorkspaceThemePreference)((0, $aI7em.default)(), workspaceAri, accountId, {
            colorMode: colorMode
        });
    } catch (error) {
        $9c2360be3f5e8123$var$handleThemePreferenceError(error, 'put', {
            param: `to:${colorMode}`
        });
        throw error;
    }
};
const $9c2360be3f5e8123$export$2f7a12048d96237 = async (cloudId, activationId, accountId)=>{
    if (!cloudId || !activationId || !accountId) // Shared theming is supported for logged in users only. CloudId and ActicationId should be always present but are left nullable to simplify the caller function
    return 0, $8I8y6.DEFAULT_COLOR_MODE;
    try {
        let colorMode;
        // Create workspace ARI only when feature flag is enabled
        const workspaceAri = (0, $fDVI0.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        // Use platform package for GraphQL operations
        const themeState = await (0, $iCK9i.getWorkspaceThemePreference)((0, $aI7em.default)(), workspaceAri, accountId);
        colorMode = themeState?.colorMode;
        // Validate theme value
        if (colorMode && !(0, $8I8y6.themeColorModes).includes(colorMode)) {
            // very unlikely but…
            $9c2360be3f5e8123$var$handleThemePreferenceError(new Error('Unrecognized theme!'), 'get', {
                theme: colorMode,
                errName: 'unrecognized value!'
            });
            colorMode = (0, $8I8y6.DEFAULT_COLOR_MODE);
        }
        return colorMode ?? (0, $8I8y6.DEFAULT_COLOR_MODE);
    } catch (error) {
        $9c2360be3f5e8123$var$handleThemePreferenceError(error, 'get');
        throw error;
    }
};

});


parcelRegister("ilTfh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8Oynj").then(()=>parcelRequire('gRoWq'));

});


parcelRegister("9Q50z", function(module, exports) {
$parcel$export(module.exports, "jiraSpaPageContainerResource", () => $4c91d9061e775812$export$880427900755c3d5);

var $htsFl = parcelRequire("htsFl");

var $6IHMU = parcelRequire("6IHMU");
const $4c91d9061e775812$export$880427900755c3d5 = (0, $htsFl.createRelayResource)({
    type: 'JIRA_SPA_STATE_RELAY',
    getQuery: (_, context)=>{
        const cloudId = context?.tenantContext?.cloudId || '';
        return {
            parameters: (0, $6IHMU.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    },
    captureErrors: true,
    isCritical: true
});

});
parcelRegister("6IHMU", function(module, exports) {
$parcel$export(module.exports, "default", () => $64ed0f2f29414fc4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cb86f40cb9ec373ce03deb26cdd56c35>>
 * @relayHash dfb8a56cb6bf7f448615bac64cc13c22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ebcccb4cd5d124ada89e8ba11ea688ce56de3e8b071234c3a906fd227ca73030

var $39Kem = parcelRequire("39Kem");

var $lIGkE = parcelRequire("lIGkE");
const $64ed0f2f29414fc4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JiraSpaPageContainerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "BannerContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "JiraSpaPageContainerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraAnnouncementBanner",
                                    "kind": "LinkedField",
                                    "name": "announcementBanner",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDismissible"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "visibility"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ebcccb4cd5d124ada89e8ba11ea688ce56de3e8b071234c3a906fd227ca73030",
            "metadata": {},
            "name": "JiraSpaPageContainerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcbannerannouncementviasparelayprovider": (0, $39Kem.default)
            }
        }
    };
}();
$64ed0f2f29414fc4$var$node.hash = "cceab149c27c13616adc23f0556d61ac";
(0, $lIGkE.PreloadableQueryRegistry).set($64ed0f2f29414fc4$var$node.params.id, $64ed0f2f29414fc4$var$node);
var $64ed0f2f29414fc4$export$2e2bcd8739ae039 = $64ed0f2f29414fc4$var$node;

});
parcelRegister("39Kem", function(module, exports) {
$parcel$export(module.exports, "default", () => $95173fdc313f5e23$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $95173fdc313f5e23$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jpx-459-announcement-banner-via-spa-query');
    }
};

});




parcelRegister("eFqFr", function(module, exports) {
$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $c2a7fa4ff8044e80$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $c2a7fa4ff8044e80$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $c2a7fa4ff8044e80$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $c2a7fa4ff8044e80$export$525db876ed776e0d);

var $6CfY5 = parcelRequire("6CfY5");

var $4fhEY = parcelRequire("4fhEY");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $c2a7fa4ff8044e80$var$RESOURCE_TYPE_NAVIGATION_PLANS_VISIBILITY = 'NAVIGATION_PLANS_VISIBILITY';
const $c2a7fa4ff8044e80$var$LOCATION = 'portfolio.services.plan-item-visibility';
const $c2a7fa4ff8044e80$export$fa475a9581133779 = (0, $7edbf.createResource)({
    type: $c2a7fa4ff8044e80$var$RESOURCE_TYPE_NAVIGATION_PLANS_VISIBILITY,
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $4fhEY.default)('/rest/jpo/1.0/navigation/simple');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $6CfY5.default).safeErrorWithoutCustomerData($c2a7fa4ff8044e80$var$LOCATION, 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity,
    isCritical: true
});
const $c2a7fa4ff8044e80$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $k6ufm.useResource)($c2a7fa4ff8044e80$export$fa475a9581133779);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    return [
        isVisible
    ];
};
const $c2a7fa4ff8044e80$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $k6ufm.useResource)($c2a7fa4ff8044e80$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $c2a7fa4ff8044e80$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $k6ufm.useResource)($c2a7fa4ff8044e80$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $c2a7fa4ff8044e80$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $k6ufm.useResource)($c2a7fa4ff8044e80$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});

parcelRegister("1IUl9", function(module, exports) {
$parcel$export(module.exports, "topNav4UIStateResource", () => $c8cf71c84b45b52e$export$2d81c2e40eea9fba);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");

var $fLTsc = parcelRequire("fLTsc");

var $izdWD = parcelRequire("izdWD");

var $i860n = parcelRequire("i860n");

var $htsFl = parcelRequire("htsFl");

var $2700E = parcelRequire("2700E");

var $9xzYB = parcelRequire("9xzYB");
const $c8cf71c84b45b52e$var$hasOnlyJSMAndCSMAccess = (appPermissions)=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess, hasCustomerServiceAccess: hasCustomerServiceAccess, hasSoftwareAccess: hasSoftwareAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = appPermissions;
    return hasServiceDeskAccess && hasCustomerServiceAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess;
};
const $c8cf71c84b45b52e$export$2d81c2e40eea9fba = (0, $htsFl.createRelayResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_TOPNAV_UI_STATE_RELAY`,
    getQuery: ({ match: match, route: route }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous, atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, appEditions: appEditions } })=>{
        const collabContextRoutingAri = (0, $i860n.fg)('post-office_enable_routing_workspace_id_prop') ? (0, $9xzYB.PlatformSiteAri).create({
            siteId: cloudId
        }).toString() : undefined;
        const issueKey = match.params.issueKey ?? '';
        const projectKey = match.params.projectKey ?? '';
        const projectIdOrKey = (0, $fLTsc.getProjectKeyOrId)(match);
        const isLiveConversationsRoute = match.path.startsWith('/jira/helpcenter') || match.path.startsWith('/jira/customer-service') || Boolean(projectIdOrKey);
        return {
            parameters: (0, $izdWD.default),
            variables: {
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                atlassianAccountId: atlassianAccountId ?? '',
                isNavStateQuerySkipped: isAnonymous || (0, $i860n.fg)('navx-global-side-nav') || (0, $2700E.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false),
                issueKey: issueKey ?? '',
                shouldCheckProjectTypeForIssue: route.group === 'issue' && Boolean(issueKey) && $c8cf71c84b45b52e$var$hasOnlyJSMAndCSMAccess(appPermissions),
                projectKey: projectKey ?? '',
                shouldCheckProjectType: Boolean(projectKey) && $c8cf71c84b45b52e$var$hasOnlyJSMAndCSMAccess(appPermissions),
                projectIdOrKey: projectIdOrKey,
                shouldFetchProjectTypeForSettingsAndEA: Boolean(projectIdOrKey),
                shouldFetchProjectType: Boolean(projectIdOrKey) && (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget'),
                shouldFetchCSMLiveChatAgent: appPermissions.hasCustomerServiceAccess && appEditions.customerService === (0, $d8LhJ.PREMIUM_EDITION) && isLiveConversationsRoute && (0, $i860n.fg)('csm-omni-channel-live-chat-in-widget'),
                skipHelpButtonRelayRead: isAnonymous || !(0, $i860n.fg)('blu-9240_help_button_relay_migration'),
                collabContextRoutingAri: collabContextRoutingAri
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    },
    isCritical: true
});

});
parcelRegister("fLTsc", function(module, exports) {
$parcel$export(module.exports, "getProjectKeyOrId", () => $f82a43c9ed6457bf$export$43cde151f667c69e);
$parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", () => $f82a43c9ed6457bf$export$b87af5b274141bd6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");
const $f82a43c9ed6457bf$export$43cde151f667c69e = (match)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, match.query);
    return projectKey || projectId || '';
};
const $f82a43c9ed6457bf$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};

});

parcelRegister("izdWD", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ab27db49fc92476$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2e4359ab0301056db647e2a962c7e932>>
 * @relayHash cfca8027e5dff9887d1f5bf769ef37ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 324427ce3fa522fce879a869ec1fff3ee2854200bd427f108d10cdf26d29c9f7
const $8ab27db49fc92476$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianAccountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collabContextRoutingAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isNavStateQuerySkipped"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckProjectType"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckProjectTypeForIssue"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldFetchCSMLiveChatAgent"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldFetchProjectType"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldFetchProjectTypeForSettingsAndEA"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipHelpButtonRelayRead"
    }, v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v17 = [
        {
            "kind": "Variable",
            "name": "collabContextRoutingAri",
            "variableName": "collabContextRoutingAri"
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "atlassianAccountId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v21 = [
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        v18 /*: any*/ 
    ], v22 = [
        {
            "args": [
                v14 /*: any*/ ,
                {
                    "kind": "Variable",
                    "name": "idOrKey",
                    "variableName": "projectIdOrKey"
                }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": v21 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TopNavigationQuery",
            "selections": [
                {
                    "condition": "isNavStateQuerySkipped",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ProfileNew"
                        },
                        {
                            "args": v17 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "Nav4NotificationsData"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ProductHomeWithQuery"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "EditionAwareness_query"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SettingsAction_query"
                },
                {
                    "condition": "skipHelpButtonRelayRead",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "HelpButtonUserProperty_query"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v9 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ ,
                v12 /*: any*/ ,
                v11 /*: any*/ ,
                v10 /*: any*/ ,
                v13 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TopNavigationQuery",
            "selections": [
                {
                    "condition": "isNavStateQuerySkipped",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v18 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                v19 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "email"
                                        }
                                    ],
                                    "type": "AtlassianAccountUser"
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "shouldFetchProjectType",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": v22 /*: any*/ 
                        },
                        {
                            "condition": "shouldFetchCSMLiveChatAgent",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v19 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ],
                                    "kind": "LinkedField",
                                    "name": "csm_liveChatAgent",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "liveChatActivity"
                                                },
                                                {
                                                    "concreteType": "CustomerServiceSpaceLiveChatActivitiesConnection",
                                                    "kind": "LinkedField",
                                                    "name": "liveChatActivitiesBySpace",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceSpaceLiveChatActivityEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "concreteType": "CustomerServiceSpaceLiveChatActivity",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "activityStatus"
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "CustomerServiceLiveChatAgent"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "identifier"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCode"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "InfluentsNotificationQuery",
                            "kind": "LinkedField",
                            "name": "notifications",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v17 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "unseenNotificationCount"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "shouldCheckProjectTypeForIssue",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "key",
                                            "variableName": "issueKey"
                                        }
                                    ],
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issueByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectField",
                                            "kind": "LinkedField",
                                            "name": "projectField",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": v21 /*: any*/ 
                                                },
                                                v18 /*: any*/ 
                                            ]
                                        },
                                        v18 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldCheckProjectType",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "key",
                                            "variableName": "projectKey"
                                        }
                                    ],
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v21 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldFetchProjectTypeForSettingsAndEA",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": v22 /*: any*/ 
                },
                {
                    "condition": "skipHelpButtonRelayRead",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "propertyKey",
                                            "value": "help_button_ui_state"
                                        }
                                    ],
                                    "concreteType": "JiraEntityPropertyJSON",
                                    "kind": "LinkedField",
                                    "name": "jsonUserProperty",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "jsonValue"
                                        },
                                        v18 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "324427ce3fa522fce879a869ec1fff3ee2854200bd427f108d10cdf26d29c9f7",
            "metadata": {},
            "name": "TopNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8ab27db49fc92476$var$node.hash = "dc8153f923b9c46dab724112d3410d51";
var $8ab27db49fc92476$export$2e2bcd8739ae039 = $8ab27db49fc92476$var$node;

});


parcelRegister("56F5E", function(module, exports) {
$parcel$export(module.exports, "navPlatformSidebarResource", () => $a875254d4baa2f3a$export$b22e51bad3fbae1b);

var $5IkoH = parcelRequire("5IkoH");

var $bkBsT = parcelRequire("bkBsT");

var $aK5Al = parcelRequire("aK5Al");

var $htsFl = parcelRequire("htsFl");

var $bZhC2 = parcelRequire("bZhC2");

var $2NSbF = parcelRequire("2NSbF");

var $fDVI0 = parcelRequire("fDVI0");

var $1hxzM = parcelRequire("1hxzM");

var $c1zHX = parcelRequire("c1zHX");

var $i860n = parcelRequire("i860n");
const $a875254d4baa2f3a$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM = 'RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM';
const $a875254d4baa2f3a$export$b22e51bad3fbae1b = (0, $htsFl.createRelayResource)({
    type: $a875254d4baa2f3a$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM,
    // Anonymous users must not trigger this GSN GraphQL query. Use the
    // resource-level `skip` predicate so `loadQuery` is never invoked for them —
    // `getQuery` will not run when `skip` returns `true`.
    skip: (_, { tenantContext: { isAnonymous: isAnonymous } })=>{
        return isAnonymous;
    },
    getQuery: (routerContext, { tenantContext: { activationId: activationId, atlassianAccountId: atlassianAccountId, cloudId: cloudId } })=>{
        const initialSelectedPath = (0, $bkBsT.getInitialSelectedPath)(routerContext);
        const ownerAri = atlassianAccountId && (0, $2NSbF.IdentityUserAri).create({
            userId: atlassianAccountId
        }).toString();
        const fetchPolicy = 'store-or-network';
        return {
            parameters: (0, $c1zHX.default),
            variables: {
                cloudId: cloudId,
                entityAriApps: (0, $bZhC2.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'apps'
                }).toString(),
                entityAriFilters: (0, $bZhC2.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'filters'
                }).toString(),
                entityAriPlans: (0, $bZhC2.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'plans'
                }).toString(),
                entityAriUserSideNavSettings: (0, $fDVI0.JiraWorkspaceAri).create({
                    siteId: cloudId,
                    activationId: activationId
                }).toString(),
                isAppsExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_APPS)),
                isFiltersExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_OPERATIONS)),
                navPlatMenuDataEntityAri: (0, $1hxzM.buildNavigationAriForMenuData)({
                    activationId: activationId,
                    firstPartyApp: 'jira',
                    siteId: cloudId
                }),
                navPlatSidebarDataEntityAri: (0, $1hxzM.buildNavigationAriForSidebarData)({
                    activationId: activationId,
                    firstPartyApp: 'jira',
                    siteId: cloudId
                }),
                ownerAri: ownerAri,
                isRoadmapUpsellEnabled: (0, $i860n.fg)('jpd-roadmaps-in-jira'),
                fetchGlobalShortcutsAvailableProducts: Boolean(cloudId && ownerAri && (0, $i860n.fg)('navx-4515-jira-gsn-gas-ssr'))
            },
            options: {
                fetchPolicy: fetchPolicy
            }
        };
    },
    isCritical: true
});

});
parcelRegister("bkBsT", function(module, exports) {
$parcel$export(module.exports, "getInitialSelectedPath", () => $41c914737e98669c$export$39f409bc5f59c5e);
/**
 * Why do we need the initialSelectedPath? It all stems from the workaround that Nav4 uses
 * to SSR the initial sidebar semi-correctly, while pretending to lazy-load everything else.
 *
 * Ideally we would be able to pre-load entrypoints that we know we need to load, and lazy-load
 * the rest. This would support SSR and be performant.
 * Unfortunately, unless all of the Jira routes are loaded via entry-points, we cannot use this approach.
 *
 * The workaround is to use Relay variables to tell Relay what data to preload, and then load
 * the corresponding UI component directly (not via an entrypoint) when we have the data for it.
 * When we don't have the preloaded data, we lazy load __the same component via an entrypoint__.
 * In other words, we sacrifice bundle size (by directly including the component for the data-available
 * case), in order to get SSR benefits.
 *
 * A consequence of this approach is we have two versions of the top-level menu item components - the
 * regular version (called *Landing) and the entrypoint version (called *Default). When navigating,
 * the router's state would change, causing the components to switch around. In the UI, this would
 * cause ExpandableMenuItem components to collapse, when they were open before navigating.
 *
 * To work around THIS problem, we store a computed-version of the initial state of the router, and
 * then query this value when deciding which component to show (the *Landing or the *Default). Because if
 * the initial state doesn't change, our components won't switch around after the first render.
 */ 
var $5vPx9 = parcelRequire("5vPx9");

var $k0Ro9 = parcelRequire("k0Ro9");
const $41c914737e98669c$export$39f409bc5f59c5e = (0, (/*@__PURE__*/$parcel$interopDefault($5vPx9)))((0, $k0Ro9.routeToSelectedPath));

});
parcelRegister("k0Ro9", function(module, exports) {
$parcel$export(module.exports, "routeToSelectedPath", () => $65eaef1c7bb4857f$export$a92474c098a1fd13);
$parcel$export(module.exports, "useRouteToSelectedPath", () => $65eaef1c7bb4857f$export$a086f1986cac3253);

var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $i860n = parcelRequire("i860n");

var $f2wVS = parcelRequire("f2wVS");

var $dc42p = parcelRequire("dc42p");

var $51yTx = parcelRequire("51yTx");

var $k6Eu2 = parcelRequire("k6Eu2");

var $9hmST = parcelRequire("9hmST");

var $g9lLz = parcelRequire("g9lLz");

var $7EMaG = parcelRequire("7EMaG");

var $aYgRR = parcelRequire("aYgRR");

var $6A53W = parcelRequire("6A53W");

var $lK3fV = parcelRequire("lK3fV");

var $eHCSD = parcelRequire("eHCSD");

var $6vVvT = parcelRequire("6vVvT");

var $hw9Bj = parcelRequire("hw9Bj");

var $cCvQD = parcelRequire("cCvQD");
function $65eaef1c7bb4857f$export$a92474c098a1fd13(routeContext) {
    const routeName = routeContext.route.name;
    if ((0, $aYgRR.topLevelConverter).routes.has(routeName)) return (0, $aYgRR.topLevelConverter).convert(routeContext);
    if ((0, $dc42p.appsConverter).routes.has(routeName)) return (0, $dc42p.appsConverter).convert(routeContext);
    if ((0, $51yTx.assetsConverter).routes.has(routeName)) return (0, $51yTx.assetsConverter).convert(routeContext);
    if ((0, $k6Eu2.dashboardsConverter).routes.has(routeName)) return (0, $k6Eu2.dashboardsConverter).convert(routeContext);
    if ((0, $9hmST.filtersConverter).routes.has(routeName)) return (0, $9hmST.filtersConverter).convert(routeContext);
    if ((0, $g9lLz.itamConverter).routes.has(routeName) && (0, $i860n.fg)('itam_ftw')) return (0, $g9lLz.itamConverter).convert(routeContext);
    if ((0, $7EMaG.operationsConverter).routes.has(routeName)) return (0, $7EMaG.operationsConverter).convert(routeContext);
    if ((0, $6A53W.plansConverter).routes.has(routeName)) return (0, $6A53W.plansConverter).convert(routeContext);
    if ((0, $lK3fV.projectsConverter).routes.has(routeName)) return (0, $lK3fV.projectsConverter).convert(routeContext);
    if ((0, $eHCSD.roadmapsConverter).routes.has(routeName)) return (0, $eHCSD.roadmapsConverter).convert(routeContext);
    if ((0, $6vVvT.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $6vVvT.serviceManagementProjectSettingsConverter).convert(routeContext);
    if ((0, $i860n.fg)('jcs_master_flag')) {
        if ((0, $hw9Bj.customerServiceConverter).routes.has(routeName)) return (0, $hw9Bj.customerServiceConverter).convert(routeContext);
        if ((0, $cCvQD.customerExperiencesConverter).routes.has(routeName)) return (0, $cCvQD.customerExperiencesConverter).convert(routeContext);
    }
    return [];
}
function $65eaef1c7bb4857f$export$216c13b87ae41e0b(state) {
    const routeName = state.route.name;
    const match = state.match;
    const query = state.query;
    if ((0, $aYgRR.topLevelConverter).routes.has(routeName)) return (0, $aYgRR.topLevelConverter).convertNew({
        routeName: routeName
    });
    if ((0, $dc42p.appsConverter).routes.has(routeName)) return (0, $dc42p.appsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $51yTx.assetsConverter).routes.has(routeName)) return (0, $51yTx.assetsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $k6Eu2.dashboardsConverter).routes.has(routeName)) return (0, $k6Eu2.dashboardsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $9hmST.filtersConverter).routes.has(routeName)) return (0, $9hmST.filtersConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $g9lLz.itamConverter).routes.has(routeName) && (0, $i860n.fg)('itam_ftw')) return (0, $g9lLz.itamConverter).convertNew({
        routeName: routeName
    });
    if ((0, $7EMaG.operationsConverter).routes.has(routeName)) return (0, $7EMaG.operationsConverter).convertNew({
        routeName: routeName,
        query: query
    });
    if ((0, $6A53W.plansConverter).routes.has(routeName)) return (0, $6A53W.plansConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $lK3fV.projectsConverter).routes.has(routeName)) return (0, $lK3fV.projectsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $eHCSD.roadmapsConverter).routes.has(routeName)) return (0, $eHCSD.roadmapsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $6vVvT.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $6vVvT.serviceManagementProjectSettingsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $i860n.fg)('jcs_master_flag')) {
        if ((0, $hw9Bj.customerServiceConverter).routes.has(routeName)) return (0, $hw9Bj.customerServiceConverter).convertNew({
            routeName: routeName
        });
    }
    if ((0, $cCvQD.customerExperiencesConverter).routes.has(routeName)) return (0, $cCvQD.customerExperiencesConverter).convertNew({
        routeName: routeName,
        match: match
    });
    return [];
}
function $65eaef1c7bb4857f$export$8eb45058a3aef67f() {
    return (0, $euxye.useState)(()=>{
        const selectedPath = $65eaef1c7bb4857f$export$216c13b87ae41e0b((0, $f2wVS.getRouterState)());
        return {
            initialSelectedPath: selectedPath,
            selectedPath: selectedPath
        };
    });
}
function $65eaef1c7bb4857f$export$a086f1986cac3253() {
    const [selectedPathData, setSelectedPathData] = $65eaef1c7bb4857f$export$8eb45058a3aef67f();
    (0, $euxye.useEffect)(()=>(0, $f2wVS.addRouteListener)((state)=>{
            const nextSelectedPath = $65eaef1c7bb4857f$export$216c13b87ae41e0b(state);
            setSelectedPathData((prev)=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(nextSelectedPath, prev.selectedPath)) return prev;
                return {
                    initialSelectedPath: prev.initialSelectedPath,
                    selectedPath: nextSelectedPath
                };
            });
        }), // addRouteListener is a stable module-level function and setSelectedPathData
    // is the stable React useState setter — neither ever changes, so this effect
    // runs exactly once on mount and unsubscribes on unmount.
    [
        setSelectedPathData
    ]);
    return selectedPathData;
}

});
parcelRegister("dc42p", function(module, exports) {
$parcel$export(module.exports, "appsConverter", () => $cf96724268377701$export$d017a63045c88c47);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
// TODO: verify these routes
const $cf96724268377701$var$UNCERTAIN_APPS_SECTION_ROUTES = [
    'connect-general',
    'connect-general-invalid',
    'legacy-connect-general',
    'legacy-connect-project',
    /**
	 * This one tricky, and I wish it was documented somewhere, so here you go:
	 * Among different Connect app types, there are global Connect apps and JSM Connect apps (project apps).
	 * The URL of the global app looks like this:
	 *   `/plugins/servlet/ac/catlassian/catlassian-page?project.key=IP&project.id=10154`
	 * The URL of the JSM project app looks like this (there is also another URL pattern, but it is not relevant to this case):
	 *   `/plugins/servlet/ac/catlassian/catlassian-page-A?project.key=IP&project.id=10154&servicedesk.serviceDeskId=31`
	 * They have different route names and differ only by the `servicedesk.serviceDeskId` query parameter.
	 * But here's the catch: the global app URL can also contain a `servicedesk.serviceDeskId` query parameter,
	 * it is enough for the user to navigate to a specific JSM route in order for that JSM project to be saved as the most recent project,
	 * and it looks like Connect adds that most recent project context to the URL.
	 * Once that happens, the global app route is no longer matched, the JSM one is, which brings a lot of confusion since at this point
	 * we have no idea whether the "Apps" section should be expanded or the "Projects" one, since it is possible the app lives in either of those.
	 * You can navigate to the JSW project in order to override the JSM one and that query param will disappear from the global app URL.
	 * So what we are doing here? We are adding the route to the list of global Connect apps (just like its route name suggests) and potentially return a false positive value.
	 * Later on in the code we are going to check whether the app is global or not based on the data we have (the list of apps) and fix that.
	 */ 'connect-general-service-desk-project',
    'connect-project'
];
const $cf96724268377701$var$CERTAIN_APPS_SECTION_ROUTES = [
    'forge-spa-global',
    'marketplace-index',
    'forge-spa-personal-settings'
];
const $cf96724268377701$export$66b32f6f30eb4b4 = new Set([
    ...$cf96724268377701$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$cf96724268377701$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $cf96724268377701$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_APPS)
    ];
    return $cf96724268377701$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $cf96724268377701$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $5IkoH.MENU_ID_APPS)
    ];
    return $cf96724268377701$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $cf96724268377701$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'marketplace-index':
            path.push((0, $5IkoH.MENU_ID_APP_MARKETPLACE_DISCOVER));
            break;
        case 'connect-general':
        case 'connect-general-invalid':
        case 'forge-spa-global':
        case 'forge-spa-personal-settings':
        case 'legacy-connect-general':
            path.push((0, $5IkoH.ENTITY_ID).APP(match.url.replace(/\/$/, '')));
            break;
        case 'connect-project':
        case 'legacy-connect-project':
            {
                const { projectKey: projectKey } = match.params;
                return [
                    (0, $5IkoH.MENU_ID_PROJECTS),
                    (0, $5IkoH.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        case 'connect-general-service-desk-project':
            {
                const { projectKey: projectKey } = query;
                return [
                    (0, $5IkoH.MENU_ID_PROJECTS),
                    (0, $5IkoH.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        default:
            break;
    }
    return path;
}
const $cf96724268377701$export$d017a63045c88c47 = {
    routes: $cf96724268377701$export$66b32f6f30eb4b4,
    convert: $cf96724268377701$var$convert,
    convertNew: $cf96724268377701$var$convertNew
};

});

parcelRegister("51yTx", function(module, exports) {
$parcel$export(module.exports, "assetsConverter", () => $022e9e869b8d8a84$export$6cfeba0849032a84);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $022e9e869b8d8a84$var$routes = new Set([
    'assets',
    'assets-configure',
    'assets-data-manager-getting-started',
    'assets-data-manager-object-classes',
    'assets-data-manager-object-classes-settings',
    'assets-data-manager-object-class-settings',
    'assets-data-manager-data-dictionary-group',
    'assets-data-manager-data-source',
    'assets-data-manager-object-class-view',
    'assets-data-manager-object-detail-view',
    'assets-data-manager-data-dictionary-issues',
    'assets-data-manager-discover',
    'assets-object',
    'assets-schema',
    'assets-for-you',
    'assets-schema-configuration',
    'assets-object-type-configuration',
    'assets-reports',
    'assets-reports-default-redirect',
    'assets-reports-unsubscribe',
    'assets-analytics-data-view-create',
    'assets-analytics-data-view-details',
    'assets-analytics-data-view-list',
    'assets-dashboards',
    'assets-dashboards-detail',
    'servicedesk-cmdb-assets',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration',
    'servicedesk-cmdb-assets-reports',
    'servicedesk-cmdb-assets-reports-default-redirect',
    'servicedesk-cmdb-assets-reports-unsubscribe',
    'servicedesk-cmdb-insight',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration',
    'servicedesk-cmdb-assets-analytics-data-view-create',
    'servicedesk-cmdb-assets-analytics-data-view-details',
    'servicedesk-cmdb-assets-analytics-data-view-list',
    'servicedesk-cmdb-assets-dashboards',
    'servicedesk-cmdb-assets-dashboards-detail'
]);
function $022e9e869b8d8a84$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [
        (0, $5IkoH.MENU_ID_ASSETS)
    ];
    return $022e9e869b8d8a84$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $022e9e869b8d8a84$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [
        (0, $5IkoH.MENU_ID_ASSETS)
    ];
    return $022e9e869b8d8a84$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $022e9e869b8d8a84$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'assets-for-you':
            path.push((0, $5IkoH.MENU_ID_ASSETS_FOR_YOU));
            break;
        case 'servicedesk-cmdb-assets':
        case 'servicedesk-cmdb-object':
        case 'servicedesk-cmdb-object-schema':
        case 'servicedesk-cmdb-object-schema-configuration':
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $5IkoH.MENU_ID_ASSETS_SCHEMAS));
            break;
        // Duplicate route-names of the above routes
        // eslint-disable-next-line no-duplicate-case
        case 'servicedesk-cmdb-object':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema-configuration':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $5IkoH.MENU_ID_ASSETS_SCHEMAS));
            break;
        case 'servicedesk-cmdb-assets-reports':
        case 'servicedesk-cmdb-assets-reports-default-redirect':
        case 'servicedesk-cmdb-assets-reports-unsubscribe':
        case 'servicedesk-cmdb-assets-analytics-data-view-create':
        case 'servicedesk-cmdb-assets-analytics-data-view-details':
        case 'servicedesk-cmdb-assets-analytics-data-view-list':
        case 'servicedesk-cmdb-assets-dashboards':
        case 'servicedesk-cmdb-assets-dashboards-detail':
            path.push((0, $5IkoH.MENU_ID_ASSETS_REPORTS));
            break;
        default:
            break;
    }
    return path;
}
const $022e9e869b8d8a84$export$6cfeba0849032a84 = {
    routes: $022e9e869b8d8a84$var$routes,
    convert: $022e9e869b8d8a84$var$convert,
    convertNew: $022e9e869b8d8a84$var$convertNew
};

});

parcelRegister("k6Eu2", function(module, exports) {
$parcel$export(module.exports, "dashboardsConverter", () => $b4de285fedbbc6ad$export$6468819b4be328b1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $b4de285fedbbc6ad$var$routes = new Set([
    'dashboards-directory',
    'dashboard-edit',
    'dashboard-view',
    'dashboard-wallboard'
]);
function $b4de285fedbbc6ad$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_DASHBOARDS)
    ];
    return $b4de285fedbbc6ad$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $b4de285fedbbc6ad$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $5IkoH.MENU_ID_DASHBOARDS)
    ];
    return $b4de285fedbbc6ad$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $b4de285fedbbc6ad$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'dashboards-directory':
            path.push((0, $5IkoH.MENU_ID_DASHBOARDS_VIEW_ALL));
            break;
        case 'dashboard-wallboard':
            query.dashboardId && path.push((0, $5IkoH.ENTITY_ID).DASHBOARD(query.dashboardId));
            break;
        default:
            {
                const dashboardId = match.params.dashboardId;
                if (dashboardId === 'last-visited') // This is not really correct. The problem is we cannot tell what the true dashboardId is in this case.
                path.push((0, $5IkoH.MENU_ID_DASHBOARDS_VIEW_ALL));
                else dashboardId && path.push((0, $5IkoH.ENTITY_ID).DASHBOARD(dashboardId));
                break;
            }
    }
    return path;
}
const $b4de285fedbbc6ad$export$6468819b4be328b1 = {
    routes: $b4de285fedbbc6ad$var$routes,
    convert: $b4de285fedbbc6ad$var$convert,
    convertNew: $b4de285fedbbc6ad$var$convertNew
};

});

parcelRegister("9hmST", function(module, exports) {
$parcel$export(module.exports, "filtersConverter", () => $0c1d282f44306910$export$6e91331b5debb7c8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $0c1d282f44306910$var$routes = new Set([
    'filters-directory',
    'global-issue-navigator',
    'global-issue-navigator-browse-issue-redirect',
    'issue',
    'legacy-gin',
    'legacy-gin-issue',
    'legacy-gin-subscriptions',
    'work-item'
]);
function $0c1d282f44306910$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query, match: match } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_FILTERS)
    ];
    return $0c1d282f44306910$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $0c1d282f44306910$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $5IkoH.MENU_ID_FILTERS)
    ];
    return $0c1d282f44306910$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $0c1d282f44306910$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'filters-directory':
            path.push((0, $5IkoH.MENU_ID_FILTERS_VIEW_ALL));
            break;
        case 'work-item':
        case 'issue':
            {
                const filterId = query.filter || query.filterId;
                if (filterId) path.push((0, $5IkoH.ENTITY_ID).FILTER(filterId));
                else if (match.params?.issueKey) {
                    const [projectKey] = (match.params?.issueKey || '').split('-'); // For this route to match, the issueKey will never be blank
                    return [
                        (0, $5IkoH.MENU_ID_PROJECTS),
                        (0, $5IkoH.ENTITY_ID).PROJECT(projectKey)
                    ];
                }
                break;
            }
        default:
            {
                const filterId = query.filter || query.filterId;
                // Search filters URL
                if (filterId === undefined) path.push((0, $5IkoH.MENU_ID_FILTERS_SEARCH));
                else // The rest of the URLs are using a filter ID.
                // Test this case: https://buglow-jsw.jira-dev.com/secure/ViewSubscriptions.jspa?filterId=10007
                path.push((0, $5IkoH.ENTITY_ID).FILTER(filterId));
                break;
            }
    }
    return path;
}
const $0c1d282f44306910$export$6e91331b5debb7c8 = {
    routes: $0c1d282f44306910$var$routes,
    convert: $0c1d282f44306910$var$convert,
    convertNew: $0c1d282f44306910$var$convertNew
};

});

parcelRegister("g9lLz", function(module, exports) {
$parcel$export(module.exports, "itamConverter", () => $e1fb2e0e8309ffcf$export$3421e67b06fa0e65);

var $5IkoH = parcelRequire("5IkoH");
const $e1fb2e0e8309ffcf$var$routes = new Set([
    'itam',
    'itam-ai-insights-preview',
    'itam-settings'
]);
function $e1fb2e0e8309ffcf$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $e1fb2e0e8309ffcf$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $e1fb2e0e8309ffcf$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $e1fb2e0e8309ffcf$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $e1fb2e0e8309ffcf$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'itam':
        case 'itam-ai-insights-preview':
        case 'itam-settings':
            path.push((0, $5IkoH.MENU_ID_ITAM));
            break;
        default:
    }
    return path;
}
const $e1fb2e0e8309ffcf$export$3421e67b06fa0e65 = {
    routes: $e1fb2e0e8309ffcf$var$routes,
    convert: $e1fb2e0e8309ffcf$var$convert,
    convertNew: $e1fb2e0e8309ffcf$var$convertNew
};

});

parcelRegister("aYgRR", function(module, exports) {
$parcel$export(module.exports, "topLevelConverter", () => $cb5a78336a6e45ec$export$a33f2d74a674bf8a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2700E = parcelRequire("2700E");

var $5IkoH = parcelRequire("5IkoH");
const $cb5a78336a6e45ec$var$routes = new Set([
    'for-you',
    'people-index'
]);
function $cb5a78336a6e45ec$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $cb5a78336a6e45ec$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $cb5a78336a6e45ec$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $cb5a78336a6e45ec$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $cb5a78336a6e45ec$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'for-you':
            path.push((0, $5IkoH.MENU_ID_FOR_YOU));
            if ((0, $2700E.expVal)('uxissue-1664-autoexpand-spaces', 'isEnabled', false)) {
                path.push((0, $5IkoH.MENU_ID_PROJECTS));
                path.push((0, $5IkoH.MENU_ID_PROJECTS_VIEW_ALL));
            }
            break;
        case 'people-index':
            path.push((0, $5IkoH.MENU_ID_TEAMS));
            break;
        default:
    }
    return path;
}
const $cb5a78336a6e45ec$export$a33f2d74a674bf8a = {
    routes: $cb5a78336a6e45ec$var$routes,
    convert: $cb5a78336a6e45ec$var$convert,
    convertNew: $cb5a78336a6e45ec$var$convertNew
};

});

parcelRegister("6A53W", function(module, exports) {
$parcel$export(module.exports, "plansConverter", () => $6125d8bf7da84098$export$3bde637b58016d1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $6125d8bf7da84098$var$routes = new Set([
    'plans-directory',
    'software-advanced-roadmaps',
    'software-advanced-roadmaps-getting-started-redirect',
    'software-advanced-roadmaps-setup',
    'software-plan-calendar',
    'software-plan-dependencies',
    'software-plan-increment',
    'software-plan-increments',
    'software-plan-releases',
    'software-plan-summary',
    'software-plan-teams',
    'software-plan-timeline',
    'trashed-plan-direct-link'
]);
function $6125d8bf7da84098$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_PLANS)
    ];
    return $6125d8bf7da84098$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $6125d8bf7da84098$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $5IkoH.MENU_ID_PLANS)
    ];
    return $6125d8bf7da84098$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $6125d8bf7da84098$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'plans-directory':
        case 'software-advanced-roadmaps-getting-started-redirect':
            path.push((0, $5IkoH.MENU_ID_PLANS_VIEW_ALL));
            break;
        case 'trashed-plan-direct-link':
            break;
        default:
            {
                const { planId: planId } = match.params;
                planId && path.push((0, $5IkoH.ENTITY_ID).PLAN(planId));
            }
    }
    return path;
}
const $6125d8bf7da84098$export$3bde637b58016d1 = {
    routes: $6125d8bf7da84098$var$routes,
    convert: $6125d8bf7da84098$var$convert,
    convertNew: $6125d8bf7da84098$var$convertNew
};

});

parcelRegister("lK3fV", function(module, exports) {
$parcel$export(module.exports, "projectsConverter", () => $e140d91e9c549f73$export$c41b724886e5872b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aJDWs = parcelRequire("aJDWs");

var $i860n = parcelRequire("i860n");

var $5IkoH = parcelRequire("5IkoH");
const $e140d91e9c549f73$var$routes = new Set([
    'browse-project-redirect',
    'legacy-all-reports',
    'projects-directory',
    'issue-navigator',
    'issue-navigator-core',
    'project-components',
    'project-not-found',
    'project-versions',
    'software-version-detail',
    'software-version-detail-no-tab-path',
    'forge-spa-project',
    'forge-spa-project-servicedesk',
    'forge-spa-servicedesk-queue',
    'polaris-ideas',
    'polaris-onboarding',
    'opsgenie-schedule',
    'issue-navigator-classic',
    'project-pages',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-report',
    'software-backlog',
    'software-ai-planning',
    'software-ai-planning-classic',
    'software-boards',
    'software-calendar',
    'software-calendar-classic',
    'software-capacity',
    'software-capacity-classic',
    'software-capacity-people-embed',
    'software-capacity-work-embed',
    'software-capacity-classic-people-embed',
    'software-capacity-classic-work-embed',
    'classic-software-proforma-issue-forms-direct',
    'software-code',
    'software-code-classic',
    'software-deployments',
    'software-deployments-classic',
    'software-form',
    'software-form-classic',
    'software-form-builder',
    'software-form-builder-classic',
    'software-form-submit',
    'software-form-submit-classic',
    'software-form-submit-embed',
    'software-form-submit-public',
    'software-form-submit-classic-embed',
    'software-form-submit-classic-public',
    'software-goals',
    'software-goals-classic',
    'software-incidents',
    'software-incidents-classic',
    'software-issue-navigator',
    'software-list',
    'software-list-classic',
    'software-periscope',
    'software-periscope-classic',
    'software-reports',
    'software-reports-boardless',
    'software-reports-burndown',
    'software-reports-burnup',
    'software-reports-control',
    'software-reports-cumulative',
    'software-reports-cycle-time',
    'software-reports-cycle-time-classic',
    'software-reports-deployment-frequency',
    'software-reports-deployment-frequency-classic',
    'software-reports-velocity',
    'software-reports-velocity-cmp',
    'software-reports-average-issue-age-cmp',
    'software-reports-average-issue-age-cmp-boardless',
    'software-reports-created-vs-resolved-cmp',
    'software-reports-created-vs-resolved-cmp-boardless',
    'software-reports-recently-created-cmp',
    'software-reports-recently-created-cmp-boardless',
    'software-security',
    'software-security-classic',
    'software-summary',
    'software-summary-embed',
    'software-summary-classic',
    'software-summary-classic-embed',
    'software-timeline',
    'software-timeline-classic',
    'software-view-not-found',
    'software-view-not-found-classic',
    'software-board-view-not-found',
    'software-board-view-not-found-classic',
    'knowledge-hub-all-articles',
    'kb-article-embed-editor',
    'knowledge-hub-article-in-category',
    'knowledge-hub-browse-all-articles',
    'knowledge-hub-browse-all-categories',
    'knowledge-hub-browse-view-article',
    'knowledge-hub-category',
    'knowledge-hub-category-page',
    'knowledge-hub-drafts',
    'knowledge-hub-suggested-topics',
    'knowledge-hub-landing',
    'knowledge-hub-search',
    'knowledge-hub-setup',
    'notification-logs',
    'servicedesk-atlassian-analytics',
    'servicedesk-boards',
    'servicedesk-calendar',
    'servicedesk-project-summary',
    'servicedesk-surveys',
    'servicedesk-change-calendar',
    'servicedesk-channels',
    'servicedesk-connect-project',
    'servicedesk-customers-v2',
    'servicedesk-customer-details',
    'servicedesk-customer-service-escalations',
    'servicedesk-customer-service-products',
    'servicedesk-getting-started-page',
    'servicedesk-getting-started-queue-create',
    'servicedesk-getting-started-queue-edit',
    'servicedesk-getting-started-queues',
    'servicedesk-getting-started-request-types',
    'servicedesk-getting-started-request-form',
    'servicedesk-getting-started-sla',
    'servicedesk-getting-started-sla-new',
    'servicedesk-getting-started-sla-view',
    'servicedesk-getting-started-sla-edit',
    'servicedesk-getting-started-rovo-service-agent-self-service-setup',
    'jsm-work-item',
    'jsm-work-item-incident',
    'jsm-work-item-prevention-center',
    'jsm-work-item-service-request',
    'jsm-work-item-example-pillar',
    'servicedesk-issue',
    'servicedesk-issues',
    'journeys',
    'journey-type',
    'jsm-journeys-list',
    'jsm-list-nin',
    'servicedesk-list',
    'servicedesk-availability',
    'servicedesk-capacity',
    'servicedesk-schedules',
    'servicedesk-skills',
    'servicedesk-workforce-optimization',
    'servicedesk-kb-requests-reports',
    'servicedesk-kb-requests-reports-time-scale-issue',
    'servicedesk-kb-requests-reports-time-scale',
    'servicedesk-oncall-schedule',
    'servicedesk-live-chat-my-chats',
    'servicedesk-organizations',
    'servicedesk-organization-details',
    'servicedesk-organization_v2',
    'servicedesk-queues-practice-custom-board',
    'servicedesk-queues-practice-custom-calendar',
    'servicedesk-practice-custom-and-issue',
    'servicedesk-practice-edit',
    'servicedesk-practice-issue',
    'servicedesk-practice-landing',
    'servicedesk-practice-manage-view',
    'servicedesk-practice-new',
    'servicedesk-queues-addon',
    'servicedesk-queues-custom-board',
    'servicedesk-queues-custom-calendar',
    'servicedesk-queues-custom-view',
    'servicedesk-queues-custom-issue-detail',
    'servicedesk-queues-edit',
    'servicedesk-practice-views-config',
    'servicedesk-queues-views-config',
    'servicedesk-queues-issue',
    'servicedesk-queues-manage-view',
    'servicedesk-queues-new',
    'servicedesk-reports',
    'servicedesk-reports-custom',
    'servicedesk-reports-custom-create',
    'servicedesk-reports-custom-edit',
    'servicedesk-reports-custom-time-scale-issue',
    'servicedesk-reports-custom-time-scale',
    'servicedesk-reports-satisfaction',
    'servicedesk-reports-satisfaction-time-scale-issue',
    'servicedesk-reports-satisfaction-time-scale',
    'servicedesk-reports-type',
    'servicedesk-reports-workload',
    'servicedesk-services',
    'servicedesk-service-details',
    'servicedesk-rca-investigation',
    'customer-service-get-started',
    'customer-service-live-conversations',
    'classic-business-approvals',
    'classic-business-ai-planning',
    'classic-business-attachments',
    'classic-business-board',
    'classic-business-calendar',
    'classic-business-capacity',
    'classic-business-capacity-people-embed',
    'classic-business-capacity-work-embed',
    'classic-business-form',
    'classic-business-form-builder',
    'classic-business-form-submit',
    'classic-business-form-submit-public',
    'classic-business-list',
    'classic-business-shortcut',
    'classic-business-summary',
    'classic-business-timeline',
    'classic-business-view-not-found',
    'classic-business-redirect',
    'subspace-list',
    'inbox',
    'inbox-classic',
    'archived-issues-directory',
    'classic-business-archived-work-items',
    'servicedesk-archived-work-items',
    'software-archived-work-items-classic',
    'software-archived-work-items'
]);
// TODO remove routes from routes when cleaning up jsm_manage_queues_in_space_settings
const $e140d91e9c549f73$var$routesNoManageQueuesRoute = new Set($e140d91e9c549f73$var$routes);
$e140d91e9c549f73$var$routesNoManageQueuesRoute.delete('servicedesk-practice-manage-view');
$e140d91e9c549f73$var$routesNoManageQueuesRoute.delete('servicedesk-queues-manage-view');
function $e140d91e9c549f73$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_PROJECTS)
    ];
    return $e140d91e9c549f73$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $e140d91e9c549f73$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $5IkoH.MENU_ID_PROJECTS)
    ];
    return $e140d91e9c549f73$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $e140d91e9c549f73$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'polaris-onboarding':
            break;
        case 'projects-directory':
            path.push((0, $5IkoH.MENU_ID_PROJECTS_VIEW_ALL));
            break;
        case 'forge-spa-project':
        case 'forge-spa-project-servicedesk':
        case 'forge-spa-servicedesk-queue':
            {
                const { projectKey: projectKey, appId: appId } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $5IkoH.MENU_ID_PROJECT_APPS));
                appId && path.push((0, $5IkoH.ENTITY_ID).APP(appId));
                break;
            }
        case 'knowledge-hub-all-articles':
        case 'kb-article-embed-editor':
        case 'knowledge-hub-article-in-category':
        case 'knowledge-hub-browse-all-articles':
        case 'knowledge-hub-browse-all-categories':
        case 'knowledge-hub-browse-view-article':
        case 'knowledge-hub-category':
        case 'knowledge-hub-category-page':
        case 'knowledge-hub-drafts':
        case 'knowledge-hub-suggested-topics':
        case 'knowledge-hub-landing':
        case 'knowledge-hub-search':
        case 'knowledge-hub-setup':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                break;
            }
        case 'servicedesk-getting-started-page':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                break;
            }
        case 'servicedesk-getting-started-request-types':
        case 'servicedesk-getting-started-request-form':
        case 'servicedesk-getting-started-queue-create':
        case 'servicedesk-getting-started-queue-edit':
        case 'servicedesk-getting-started-queues':
        case 'servicedesk-getting-started-sla':
        case 'servicedesk-getting-started-sla-new':
        case 'servicedesk-getting-started-sla-view':
        case 'servicedesk-getting-started-sla-edit':
        case 'servicedesk-getting-started-rovo-service-agent-self-service-setup':
            if ((0, $i860n.fg)('solution_composer_master')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
            }
            break;
        case 'customer-service-get-started':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_JCS_GET_STARTED(projectKey));
                break;
            }
        case 'customer-service-live-conversations':
            if ((0, $i860n.fg)('csm-omni-channel-live-chat-in-widget')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_LIVE_CONVERSATIONS(projectKey));
            }
            break;
        case 'notification-logs':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                break;
            }
        case 'servicedesk-project-summary':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_SUMMARY(projectKey));
                break;
            }
        case 'servicedesk-surveys':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).SURVEYS(projectKey));
                break;
            }
        case 'servicedesk-boards':
            {
                const { projectKey: projectKey, boardId: boardId } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_VIEWS(projectKey));
                boardId && path.push((0, $5IkoH.ENTITY_ID).BOARD(boardId));
                break;
            }
        case 'servicedesk-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_VIEWS(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-list':
            if ((0, $i860n.fg)('jsm_list_view_milestone_1')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_VIEWS(projectKey));
            }
            break;
        case 'servicedesk-workforce-optimization':
            if ((0, $i860n.fg)('jsm_workforce_optimization_main')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION(projectKey));
            }
            break;
        case 'servicedesk-schedules':
            if ((0, $i860n.fg)('jsm_workforce_optimization_main')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION_SCHEDULES(projectKey));
            }
            break;
        case 'servicedesk-capacity':
            if ((0, $i860n.fg)('jsm_workforce_optimization_main')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION_CAPACITY(projectKey));
            }
            break;
        case 'servicedesk-availability':
            if ((0, $i860n.fg)('jsm_workforce_optimization_main')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION_AVAILABILITY(projectKey));
            }
            break;
        case 'servicedesk-skills':
            if ((0, $i860n.fg)('jsm_workforce_optimization_main')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_WORKFORCE_OPTIMIZATION_SKILLS(projectKey));
            }
            break;
        case 'servicedesk-change-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-channels':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_CHANNELS(projectKey));
                break;
            }
        case 'servicedesk-organizations':
        case 'servicedesk-organization-details':
        case 'servicedesk-organization_v2':
        case 'servicedesk-customers-v2':
        case 'servicedesk-customer-details':
        case 'servicedesk-customer-service-products':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                break;
            }
        case 'servicedesk-customer-service-escalations':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                break;
            }
        case 'servicedesk-kb-requests-reports':
        case 'servicedesk-kb-requests-reports-time-scale-issue':
        case 'servicedesk-kb-requests-reports-time-scale':
        case 'servicedesk-reports':
        case 'servicedesk-reports-custom':
        case 'servicedesk-reports-custom-create':
        case 'servicedesk-reports-custom-edit':
        case 'servicedesk-reports-custom-time-scale-issue':
        case 'servicedesk-reports-custom-time-scale':
        case 'servicedesk-reports-satisfaction':
        case 'servicedesk-reports-satisfaction-time-scale-issue':
        case 'servicedesk-reports-satisfaction-time-scale':
        case 'servicedesk-reports-type':
        case 'servicedesk-reports-workload':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_REPORTS(projectKey));
                break;
            }
        case 'journeys':
        case 'journey-type':
        case 'jsm-journeys-list':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_JOURNEYS(projectKey));
                break;
            }
        case 'servicedesk-oncall-schedule':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                break;
            }
        case 'servicedesk-live-chat-my-chats':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_LIVE_CHAT(projectKey));
                break;
            }
        case 'servicedesk-issues':
            {
                const { projectKey: projectKey } = match.params;
                const filterId = query.filter || query.filterId;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                if (projectKey && filterId) {
                    path.push((0, $5IkoH.ENTITY_ID).PROJECT_FILTERS(projectKey));
                    path.push((0, $5IkoH.ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                }
                break;
            }
        case 'servicedesk-queues-practice-custom-board':
        case 'servicedesk-queues-practice-custom-calendar':
        case 'servicedesk-practice-custom-and-issue':
        case 'servicedesk-practice-edit':
        case 'servicedesk-practice-issue':
        case 'servicedesk-practice-landing':
        case 'servicedesk-practice-manage-view':
        case 'servicedesk-practice-views-config':
        case 'servicedesk-practice-new':
            {
                // TODO remove servicedesk-practice-manage-view case when cleaning up jsm_manage_queues_in_space_settings
                const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && practiceType && path.push((0, $5IkoH.ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                queueId && path.push((0, $5IkoH.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-rca-investigation':
            if ((0, $i860n.fg)('aiops_rca_v2_ui')) {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, 'incidents'));
            }
            break;
        case 'servicedesk-queues-addon':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-custom-calendar':
        case 'servicedesk-queues-custom-view':
        case 'servicedesk-queues-edit':
        case 'servicedesk-queues-issue':
        case 'servicedesk-queues-manage-view':
        case 'servicedesk-queues-views-config':
        case 'servicedesk-queues-new':
            {
                // TODO remove servicedesk-queues-manage-view case when cleaning up jsm_manage_queues_in_space_settings
                const { projectKey: projectKey, queueId: queueId } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $5IkoH.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-custom-issue-detail':
            {
                const { projectKey: projectKey, queueId: queueId, issueKey: issueKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $5IkoH.ENTITY_ID).QUEUE(queueId));
                issueKey && path.push((0, $5IkoH.ENTITY_ID).ISSUE(issueKey));
                break;
            }
        case 'servicedesk-services':
        case 'servicedesk-service-details':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT_SERVICES(projectKey));
                break;
            }
        default:
            {
                const { projectKey: projectKey, formId: formId, subspaceId: subspaceId } = match.params;
                let { boardId: boardId } = match.params;
                const rapidViewBoard = query.rapidView ? query.rapidView : null;
                boardId = rapidViewBoard || boardId || null;
                projectKey && path.push((0, $5IkoH.ENTITY_ID).PROJECT(projectKey));
                if ((0, $aJDWs.isProjectsInJiraM2Enabled)()) subspaceId && path.push((0, $5IkoH.ENTITY_ID).SUBSPACE(subspaceId));
                boardId && path.push((0, $5IkoH.ENTITY_ID).BOARD(boardId));
                formId && path.push((0, $5IkoH.ENTITY_ID).FORM(formId));
            }
    }
    const { projectKey: projectKey } = match.params;
    if ((routeName === 'servicedesk-change-calendar' || routeName === 'servicedesk-services' || routeName === 'servicedesk-service-details') && projectKey) path.push((0, $5IkoH.ENTITY_ID).PROJECT_OPERATIONS(projectKey));
    return path;
}
const $e140d91e9c549f73$export$c41b724886e5872b = {
    get routes () {
        if ((0, $i860n.fg)('jsm_manage_queues_in_space_settings')) return $e140d91e9c549f73$var$routesNoManageQueuesRoute;
        return $e140d91e9c549f73$var$routes;
    },
    convert: $e140d91e9c549f73$var$convert,
    convertNew: $e140d91e9c549f73$var$convertNew
};

});
parcelRegister("aJDWs", function(module, exports) {
$parcel$export(module.exports, "isProjectsInJiraM0Enabled", () => $bd5c8689a51d6499$export$94631b1b0fb7667a);
$parcel$export(module.exports, "isProjectsInJiraM1Enabled", () => $bd5c8689a51d6499$export$c9b7b1f678a7708a);
$parcel$export(module.exports, "isProjectsInJiraM2Enabled", () => $bd5c8689a51d6499$export$b9aea93c53bbd03c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2700E = parcelRequire("2700E");
const $bd5c8689a51d6499$export$94631b1b0fb7667a = ()=>{
    if ((0, $2700E.expVal)('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 0) return true;
    return false;
};
const $bd5c8689a51d6499$export$c9b7b1f678a7708a = ()=>{
    if ((0, $2700E.expVal)('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 1) return true;
    return false;
};
const $bd5c8689a51d6499$export$b9aea93c53bbd03c = ()=>{
    if ((0, $2700E.expVal)('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 2) return true;
    return false;
};

});


parcelRegister("eHCSD", function(module, exports) {
$parcel$export(module.exports, "roadmapsConverter", () => $fb325acae8a0428a$export$5761942b1e0c2dd0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $fb325acae8a0428a$var$routes = new Set([
    'polaris-collections'
]);
function $fb325acae8a0428a$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $5IkoH.MENU_ID_ROADMAPS)
    ];
    return $fb325acae8a0428a$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $fb325acae8a0428a$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $5IkoH.MENU_ID_ROADMAPS)
    ];
    return $fb325acae8a0428a$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $fb325acae8a0428a$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'polaris-collections':
            {
                const collectionId = match.params.collectionUUID;
                if (collectionId) path.push((0, $5IkoH.ENTITY_ID).ROADMAP(collectionId));
                else path.push((0, $5IkoH.MENU_ID_ROADMAPS_VIEW_ALL));
                break;
            }
        default:
    }
    return path;
}
const $fb325acae8a0428a$export$5761942b1e0c2dd0 = {
    routes: $fb325acae8a0428a$var$routes,
    convert: $fb325acae8a0428a$var$convert,
    convertNew: $fb325acae8a0428a$var$convertNew
};

});

parcelRegister("6vVvT", function(module, exports) {
$parcel$export(module.exports, "serviceManagementProjectSettingsConverter", () => $855c1b653e8e8eef$export$dd307ede503fe0e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h0W3N = parcelRequire("h0W3N");

var $g8IkD = parcelRequire("g8IkD");

var $3KBxc = parcelRequire("3KBxc");

var $ftcBv = parcelRequire("ftcBv");

var $bdBcq = parcelRequire("bdBcq");

var $bpTrq = parcelRequire("bpTrq");

var $7jmvy = parcelRequire("7jmvy");

var $6YA1Z = parcelRequire("6YA1Z");

var $jPEBm = parcelRequire("jPEBm");

var $lNLqY = parcelRequire("lNLqY");

var $78BYB = parcelRequire("78BYB");

var $9pf2j = parcelRequire("9pf2j");

var $90PZX = parcelRequire("90PZX");

var $jMKPe = parcelRequire("jMKPe");

var $828bw = parcelRequire("828bw");

var $oAUzG = parcelRequire("oAUzG");

var $82QrG = parcelRequire("82QrG");

var $2FyRg = parcelRequire("2FyRg");

var $cjgSr = parcelRequire("cjgSr");

var $8zrjl = parcelRequire("8zrjl");

var $7Xo5b = parcelRequire("7Xo5b");

var $bMs72 = parcelRequire("bMs72");

var $gALT7 = parcelRequire("gALT7");

var $gHXQv = parcelRequire("gHXQv");

var $ljzmU = parcelRequire("ljzmU");

var $bDLxo = parcelRequire("bDLxo");

var $anfeT = parcelRequire("anfeT");

var $e4hT2 = parcelRequire("e4hT2");

var $rCDsK = parcelRequire("rCDsK");

var $9xkF6 = parcelRequire("9xkF6");

var $7e9U7 = parcelRequire("7e9U7");

var $6YTGM = parcelRequire("6YTGM");

var $e4x7w = parcelRequire("e4x7w");

var $hwLlH = parcelRequire("hwLlH");

var $ffvhw = parcelRequire("ffvhw");

var $1DnrG = parcelRequire("1DnrG");

var $49hTN = parcelRequire("49hTN");

var $7sodi = parcelRequire("7sodi");

var $iCRAQ = parcelRequire("iCRAQ");

var $c5IPX = parcelRequire("c5IPX");

var $az1fH = parcelRequire("az1fH");

var $lkngp = parcelRequire("lkngp");

var $5yfEX = parcelRequire("5yfEX");

var $aPX9C = parcelRequire("aPX9C");

var $7GKTa = parcelRequire("7GKTa");

var $i860n = parcelRequire("i860n");

var $5IkoH = parcelRequire("5IkoH");
const $855c1b653e8e8eef$var$routes = new Set([
    'legacy-project-settings-fields',
    'legacy-project-settings-issue-security',
    'legacy-project-settings-issue-types',
    'legacy-project-settings-notifications',
    'legacy-project-settings-people',
    'legacy-project-settings-permissions',
    'legacy-project-settings-screens',
    'legacy-project-settings-workflows',
    'legacy-project-settings-workflows-associate',
    'project-settings-automation',
    'project-settings-servicedesk-rovo-ops',
    'project-settings-servicedesk-rovo',
    'project-settings-servicedesk-rovo-service-agent',
    (0, $lkngp.projectSettingsServicedeskWorkforceOptimizationRoute).name,
    'project-settings-servicedesk-employee-onboarding-configuration',
    'project-setting-servicedesk-resolution-management',
    'project-setting-servicedesk-rovo-service',
    'project-setting-servicedesk-self-service-setup',
    'servicedesk-sla-settings',
    (0, $bdBcq.projectSettingsServicedeskAutomationSummaryRoute).name,
    (0, $bpTrq.projectSettingsServicedeskAccessRoute).name,
    (0, $lNLqY.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
    (0, $828bw.projectSettingsServicedeskCustomerPermissionsRoute).name,
    (0, $2FyRg.projectSettingsServicedeskFeedbackRoute).name,
    (0, $cjgSr.projectSettingsServicedeskFieldsRoute).name,
    (0, $anfeT.projectSettingsServicedeskProformaProjectFormsRoute).name,
    (0, $e4hT2.projectSettingsServicedeskItsmTicketTypesConfigRoute).name,
    (0, $90PZX.projectSettingsServicedeskChatRoute).name,
    (0, $oAUzG.projectSettingsServicedeskEmailRoute).name,
    (0, $82QrG.projectSettingsServicedeskExternalLinksRoute).name,
    (0, $bDLxo.projectSettingsServicedeskPortalSettingsRoute).name,
    (0, $rCDsK.projectSettingsServicedeskWidgetRoute).name,
    (0, $6YA1Z.projectSettingsServicedeskChangeManagementRoute).name,
    (0, $8zrjl.projectSettingsServicedeskIncidentManagementRoute).name,
    (0, $jMKPe.projectSettingsServicedeskClassicAppsRoute).name,
    (0, $jPEBm.projectSettingsServicedeskChannelsChatRoute).name,
    (0, $9pf2j.projectSettingsServicedeskChannelsWidgetRoute).name,
    (0, $3KBxc.projectSettingsServicedeskNotificationsEmailRoute).name,
    (0, $ftcBv.projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
    (0, $ljzmU.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
    (0, $7jmvy.projectSettingsServicedeskAppsFieldsRoute).name,
    (0, $7sodi.projectSettingsServicedeskCustomerNotificationsRoute).name,
    (0, $iCRAQ.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
    (0, $c5IPX.projectSettingsServicedeskKbRoute).name,
    (0, $5yfEX.projectSettingsServicedeskTicketTypesConfigRoute).name,
    (0, $aPX9C.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
    (0, $7GKTa.servicedeskWorkflowConfigRoute).name,
    (0, $gHXQv.projectSettingsServicedeskIssuetypesRoute).name,
    (0, $78BYB.projectSettingsServicedeskChannelsPortalRoute).name,
    (0, $g8IkD.projectSettingsServicedeskAutomationRoute).name,
    (0, $az1fH.servicedeskSlaSettingsRoute).name,
    (0, $gALT7.projectSettingsServicedeskInternalNotificationsNextGenRoute).name,
    (0, $7e9U7.landingPageRoute).name,
    (0, $6YTGM.browseConversationsRoute).name,
    (0, $e4x7w.browseIntentsRoute).name,
    (0, $hwLlH.browseStandardFlowsRoute).name,
    (0, $9xkF6.virtualAgentSettingsRoute).name,
    (0, $h0W3N.projectSettingsServicedeskLiveChatRoute).name
]);
// TODO move routes to routes when cleaning up jsm_manage_queues_in_space_settings
const $855c1b653e8e8eef$var$routesWithManageQueuesRoute = new Set($855c1b653e8e8eef$var$routes);
$855c1b653e8e8eef$var$routesWithManageQueuesRoute.add((0, $7Xo5b.servicedeskQueuesManageViewRoute).name).add((0, $bMs72.servicedeskPracticeManageViewRoute).name);
function $855c1b653e8e8eef$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $855c1b653e8e8eef$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $855c1b653e8e8eef$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $855c1b653e8e8eef$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $855c1b653e8e8eef$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        // Access Menu
        case 'legacy-project-settings-people':
        case (0, $bpTrq.projectSettingsServicedeskAccessRoute).name:
        case (0, $828bw.projectSettingsServicedeskCustomerPermissionsRoute).name:
        case (0, $lNLqY.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
        case 'legacy-project-settings-permissions':
        case 'legacy-project-settings-issue-security':
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_ACCESS));
            break;
        // Request Management -> Request types menu
        case (0, $e4hT2.projectSettingsServicedeskItsmTicketTypesConfigRoute).name:
        case (0, $aPX9C.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, $5IkoH.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
            break;
        // Request Management -> Queues menu
        case (0, $7Xo5b.servicedeskQueuesManageViewRoute).name:
        case (0, $bMs72.servicedeskPracticeManageViewRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, $5IkoH.MENU_ID_SD_SETTINGS_QUEUES));
            break;
        // Request Management
        case (0, $5yfEX.projectSettingsServicedeskTicketTypesConfigRoute).name:
        case (0, $anfeT.projectSettingsServicedeskProformaProjectFormsRoute).name:
        case 'legacy-project-settings-workflows':
        case (0, $7GKTa.servicedeskWorkflowConfigRoute).name:
        case 'legacy-project-settings-workflows-associate':
        case 'servicedesk-sla-settings':
        case (0, $az1fH.servicedeskSlaSettingsRoute).name:
        case (0, $2FyRg.projectSettingsServicedeskFeedbackRoute).name:
        case 'legacy-project-settings-issue-types':
        case (0, $gHXQv.projectSettingsServicedeskIssuetypesRoute).name:
        case 'legacy-project-settings-fields':
        case (0, $cjgSr.projectSettingsServicedeskFieldsRoute).name:
        case 'legacy-project-settings-screens':
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
            break;
        // Workforce Optimization
        case (0, $lkngp.projectSettingsServicedeskWorkforceOptimizationRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_WORKFORCE_OPTIMIZATION));
            break;
        // Automation
        case 'project-settings-automation':
        case (0, $bdBcq.projectSettingsServicedeskAutomationSummaryRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_AUTOMATION));
            break;
        // Channels and self-service
        case (0, $bDLxo.projectSettingsServicedeskPortalSettingsRoute).name:
        case (0, $78BYB.projectSettingsServicedeskChannelsPortalRoute).name:
        case (0, $oAUzG.projectSettingsServicedeskEmailRoute).name:
        case (0, $h0W3N.projectSettingsServicedeskLiveChatRoute).name:
        case (0, $90PZX.projectSettingsServicedeskChatRoute).name:
        case (0, $rCDsK.projectSettingsServicedeskWidgetRoute).name:
        case (0, $c5IPX.projectSettingsServicedeskKbRoute).name:
        case (0, $82QrG.projectSettingsServicedeskExternalLinksRoute).name:
        case (0, $jPEBm.projectSettingsServicedeskChannelsChatRoute).name:
        case (0, $9pf2j.projectSettingsServicedeskChannelsWidgetRoute).name:
        case (0, $9xkF6.virtualAgentSettingsRoute).name:
        case (0, $7e9U7.landingPageRoute).name:
        case (0, $6YTGM.browseConversationsRoute).name:
        case (0, $e4x7w.browseIntentsRoute).name:
        case (0, $hwLlH.browseStandardFlowsRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
            break;
        // Operations
        case (0, $6YA1Z.projectSettingsServicedeskChangeManagementRoute).name:
        case (0, $8zrjl.projectSettingsServicedeskIncidentManagementRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_OPERATIONS));
            break;
        // Notifications
        case 'legacy-project-settings-notifications':
        case (0, $7sodi.projectSettingsServicedeskCustomerNotificationsRoute).name:
        case (0, $ljzmU.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
        case (0, $iCRAQ.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
        case (0, $3KBxc.projectSettingsServicedeskNotificationsEmailRoute).name:
        case (0, $ftcBv.projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
        case (0, $gALT7.projectSettingsServicedeskInternalNotificationsNextGenRoute).name:
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_NOTIFICATIONS));
            break;
        // Apps
        case (0, $jMKPe.projectSettingsServicedeskClassicAppsRoute).name:
        case (0, $7jmvy.projectSettingsServicedeskAppsFieldsRoute).name:
        case 'project-settings-servicedesk-rovo-ops':
        case 'project-settings-servicedesk-rovo':
        case 'project-settings-servicedesk-rovo-service-agent':
        case 'project-settings-servicedesk-employee-onboarding-configuration':
        case (0, $ffvhw.projectSettingServicedeskResolutionManagementRoute).name:
        case (0, $1DnrG.projectSettingServicedeskRovoServiceRoute).name:
        case (0, $49hTN.projectSettingServicedeskSelfServiceSetupRoute).name:
            // ADD rest of the apps here
            path.push((0, $5IkoH.MENU_ID_SD_SETTINGS_APPS));
            break;
        default:
            break;
    }
    return path;
}
const $855c1b653e8e8eef$export$dd307ede503fe0e = {
    get routes () {
        return (0, $i860n.fg)('jsm_manage_queues_in_space_settings') ? $855c1b653e8e8eef$var$routesWithManageQueuesRoute : $855c1b653e8e8eef$var$routes;
    },
    convert: $855c1b653e8e8eef$var$convert,
    convertNew: $855c1b653e8e8eef$var$convertNew
};

});
parcelRegister("h0W3N", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskLiveChatRoute", () => $1ec9c7b521d5ec45$export$ed8d8807e3f83d4c);
const $1ec9c7b521d5ec45$export$ed8d8807e3f83d4c = {
    name: 'project-settings-servicedesk-live-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/live-chat',
    exact: true
};

});

parcelRegister("g8IkD", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", () => $e87f87f46d80b9a9$export$1a2228d5e07202a0);
const $e87f87f46d80b9a9$export$1a2228d5e07202a0 = {
    name: 'project-settings-automation',
    path: '/jira/servicedesk/projects/:projectKey/settings/automate'
};

});

parcelRegister("3KBxc", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", () => $9d6e4047ee25b2a4$export$1f37a1aff4f594af);
const $9d6e4047ee25b2a4$export$1f37a1aff4f594af = {
    name: 'project-settings-servicedesk-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notification-email',
    exact: true
};

});

parcelRegister("ftcBv", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", () => $8e0747872c1b44d6$export$40539cb16771014e);
const $8e0747872c1b44d6$export$40539cb16771014e = {
    name: 'project-settings-servicedesk-notifications-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("bdBcq", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRoute", () => $13cbc92acf6654b8$export$165d82a2618e4d99);
const $13cbc92acf6654b8$export$165d82a2618e4d99 = {
    name: 'project-settings-servicedesk-automation-summary',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation'
};

});

parcelRegister("bpTrq", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAccessRoute", () => $d4558d478f4c25ec$export$6473a81f1ee460ef);
const $d4558d478f4c25ec$export$6473a81f1ee460ef = {
    name: 'project-settings-servicedesk-access',
    path: '/jira/servicedesk/projects/:projectKey/settings/access',
    exact: true
};

});

parcelRegister("7jmvy", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRoute", () => $1c69b3ec9e1db0cb$export$bb46672b3fb14eec);
const $1c69b3ec9e1db0cb$export$bb46672b3fb14eec = {
    name: 'project-settings-servicedesk-apps-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("6YA1Z", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRoute", () => $ff1316a6705eab0a$export$1444ee3eb63a2ffc);
const $ff1316a6705eab0a$export$1444ee3eb63a2ffc = {
    name: 'project-settings-servicedesk-change-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/change-management',
    exact: true
};

});

parcelRegister("jPEBm", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRoute", () => $2628352749c18a68$export$be5ad475040cd044);
const $2628352749c18a68$export$be5ad475040cd044 = {
    name: 'project-settings-servicedesk-channels-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/chat',
    exact: true
};

});

parcelRegister("lNLqY", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRoute", () => $60d1d10040e6c21d$export$5fb39a9d3820886c);
const $60d1d10040e6c21d$export$5fb39a9d3820886c = {
    name: 'project-settings-servicedesk-channels-permissions-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/customer-permissions',
    exact: true
};

});

parcelRegister("78BYB", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRoute", () => $cc0dafb4d740950d$export$8f4234e4e79e03);
const $cc0dafb4d740950d$export$8f4234e4e79e03 = {
    name: 'project-settings-servicedesk-channels-portal',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/portal-settings',
    exact: true
};

});

parcelRegister("9pf2j", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRoute", () => $9a519c2e7e29cacd$export$c66db54872d3b51c);
const $9a519c2e7e29cacd$export$c66db54872d3b51c = {
    name: 'project-settings-servicedesk-channels-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/widget',
    exact: true
};

});

parcelRegister("90PZX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskChatRoute", () => $a832dcfc2b1eb687$export$b22ac188582d1dbd);
const $a832dcfc2b1eb687$export$b22ac188582d1dbd = {
    name: 'project-settings-servicedesk-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/chat',
    exact: true
};

});

parcelRegister("jMKPe", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskClassicAppsRoute", () => $c84d3153a1e74023$export$2b65324bb87228c5);
const $c84d3153a1e74023$export$2b65324bb87228c5 = {
    name: 'project-settings-servicedesk-classic-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps',
    exact: true
};

});

parcelRegister("828bw", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRoute", () => $9149a4dba45e82f4$export$d8ed4a1eb0c01b5a);
const $9149a4dba45e82f4$export$d8ed4a1eb0c01b5a = {
    name: 'project-settings-servicedesk-customer-permissions',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-permissions',
    exact: true
};

});

parcelRegister("oAUzG", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskEmailRoute", () => $653e75b9d48efbca$export$d7d111417bfcd900);
const $653e75b9d48efbca$export$d7d111417bfcd900 = {
    name: 'project-settings-servicedesk-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/email',
    exact: true
};

});

parcelRegister("82QrG", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRoute", () => $e5ef12d58499b5a2$export$2ec1a0d49a1f6ac2);
const $e5ef12d58499b5a2$export$2ec1a0d49a1f6ac2 = {
    name: 'project-settings-servicedesk-external-links',
    path: '/jira/servicedesk/projects/:projectKey/settings/external-links',
    exact: true
};

});

parcelRegister("2FyRg", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRoute", () => $ef0d67a57199590c$export$f21485e31d7839aa);
const $ef0d67a57199590c$export$f21485e31d7839aa = {
    name: 'project-settings-servicedesk-feedback',
    path: '/jira/servicedesk/projects/:projectKey/settings/feedback-settings'
};

});

parcelRegister("cjgSr", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskFieldsRoute", () => $72f52d1fa9e60c8f$export$44f665a50373c681);
const $72f52d1fa9e60c8f$export$44f665a50373c681 = {
    name: 'project-settings-servicedesk-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("8zrjl", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRoute", () => $45d4bcb9785fe43c$export$f91bd0bb0d4783ff);
const $45d4bcb9785fe43c$export$f91bd0bb0d4783ff = {
    name: 'project-settings-servicedesk-incident-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/incident-management',
    exact: true
};

});

parcelRegister("7Xo5b", function(module, exports) {
$parcel$export(module.exports, "servicedeskQueuesManageViewRoute", () => $0be0acf66c593668$export$7f30d40b906894c5);
const $0be0acf66c593668$export$7f30d40b906894c5 = {
    name: 'servicedesk-queues-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/queue-settings',
    exact: true
};

});

parcelRegister("bMs72", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticeManageViewRoute", () => $96ddb2a4bcdfb780$export$125e0ab662806584);
const $96ddb2a4bcdfb780$export$125e0ab662806584 = {
    name: 'servicedesk-practice-manage-view',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/queue-settings',
    exact: true
};

});

parcelRegister("gALT7", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRoute", () => $7460d6964c53f3e0$export$5db62792327950b4);
const $7460d6964c53f3e0$export$5db62792327950b4 = {
    name: 'project-settings-servicedesk-internal-notifications-nextGen',
    path: '/jira/servicedesk/projects/:projectKey/settings/internal-notifications'
};

});

parcelRegister("gHXQv", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRoute", () => $ba0f03999f2ba336$export$2ffcb2e92bb4950b);
const $ba0f03999f2ba336$export$2ffcb2e92bb4950b = {
    name: 'project-settings-servicedesk-issuetypes',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("ljzmU", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRoute", () => $20eee863412a1b1c$export$5108e41f558ecf03);
const $20eee863412a1b1c$export$5108e41f558ecf03 = {
    name: 'project-settings-servicedesk-notifications-internal-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/internal-notifications'
};

});

parcelRegister("bDLxo", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRoute", () => $4aac91bc975986d6$export$7593a7e4a6fc0aaf);
const $4aac91bc975986d6$export$7593a7e4a6fc0aaf = {
    name: 'project-settings-servicedesk-portal-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/portal-settings/:subPath(portal-groups)?',
    exact: true
};

});

parcelRegister("anfeT", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRoute", () => $9b8fd8515700a332$export$ee87e5f9754e3600);
const $9b8fd8515700a332$export$ee87e5f9754e3600 = {
    name: 'project-settings-servicedesk-proforma-project-forms',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("e4hT2", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRoute", () => $3dd8cbad4a398945$export$52596d9b432829c);
const $3dd8cbad4a398945$export$52596d9b432829c = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice'
};

});

parcelRegister("rCDsK", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskWidgetRoute", () => $a387b39e2ad52e33$export$ac674ffd39608325);
const $a387b39e2ad52e33$export$ac674ffd39608325 = {
    name: 'project-settings-servicedesk-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/widget',
    exact: true
};

});

parcelRegister("9xkF6", function(module, exports) {
$parcel$export(module.exports, "virtualAgentSettingsRoute", () => $f93f7db6dd1a58a8$export$80422a49e17dfd6b);
const $f93f7db6dd1a58a8$export$80422a49e17dfd6b = {
    name: 'project-settings-servicedesk-virtual-agent-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings',
    exact: true
};

});

parcelRegister("7e9U7", function(module, exports) {
$parcel$export(module.exports, "landingPageRoute", () => $304a31532c3cf664$export$8c051c399fd812a5);
const $304a31532c3cf664$export$8c051c399fd812a5 = {
    // We name this virtualagentonboarding without the "-" as otherwise it would trigger
    // the nesting stack, which we don't want for onboarding
    name: 'project-settings-servicedesk-virtualagentonboarding',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent'
};

});

parcelRegister("6YTGM", function(module, exports) {
$parcel$export(module.exports, "browseConversationsRoute", () => $94fa863326d7b1ca$export$c8ff4cf64e5540ec);
const $94fa863326d7b1ca$export$c8ff4cf64e5540ec = {
    name: 'project-settings-servicedesk-virtualagent-browseconversations',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations'
};

});

parcelRegister("e4x7w", function(module, exports) {
$parcel$export(module.exports, "browseIntentsRoute", () => $b8fddeb865707c03$export$3e227412713bc57f);
const $b8fddeb865707c03$export$3e227412713bc57f = {
    name: 'project-settings-servicedesk-virtualagent-browse-intents',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents'
};

});

parcelRegister("hwLlH", function(module, exports) {
$parcel$export(module.exports, "browseStandardFlowsRoute", () => $9ebf2def4c3a1609$export$fd091ba8fa858397);
const $9ebf2def4c3a1609$export$fd091ba8fa858397 = {
    name: 'project-settings-servicedesk-virtualagent-standard-flows',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows'
};

});

parcelRegister("ffvhw", function(module, exports) {
$parcel$export(module.exports, "projectSettingServicedeskResolutionManagementRoute", () => $a4ad1e4aee51f882$export$4958935819dc764d);
const $a4ad1e4aee51f882$export$4958935819dc764d = {
    name: 'project-setting-servicedesk-resolution-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/rovo-service-agent/resolution-management',
    exact: true
};

});

parcelRegister("1DnrG", function(module, exports) {
$parcel$export(module.exports, "projectSettingServicedeskRovoServiceRoute", () => $a824e30eaf8de69f$export$c4284c089f2e0f05);
const $a824e30eaf8de69f$export$c4284c089f2e0f05 = {
    name: 'project-setting-servicedesk-rovo-service',
    path: '/jira/servicedesk/projects/:projectKey/settings/rovo/rovo-service',
    exact: true
};

});

parcelRegister("49hTN", function(module, exports) {
$parcel$export(module.exports, "projectSettingServicedeskSelfServiceSetupRoute", () => $3d5f0381c579ec0d$export$5fed0d3d970ca29f);
const $3d5f0381c579ec0d$export$5fed0d3d970ca29f = {
    name: 'project-setting-servicedesk-self-service-setup',
    path: '/jira/servicedesk/projects/:projectKey/settings/rovo-service-agent/self-service-setup',
    exact: true
};

});

parcelRegister("7sodi", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRoute", () => $5cf05f327f941ccf$export$176d388c5b23978e);
const $5cf05f327f941ccf$export$176d388c5b23978e = {
    name: 'project-settings-servicedesk-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-notifications'
};

});

parcelRegister("iCRAQ", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRoute", () => $4f115c221cac3a9f$export$6ce57d409e1934f2);
const $4f115c221cac3a9f$export$6ce57d409e1934f2 = {
    name: 'project-settings-servicedesk-notifications-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/customer-notifications'
};

});

parcelRegister("c5IPX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskKbRoute", () => $03db0fa48f58f2c8$export$725fadff9ae82302);
const $03db0fa48f58f2c8$export$725fadff9ae82302 = {
    name: 'project-settings-servicedesk-kb',
    path: '/jira/servicedesk/projects/:projectKey/settings/confluence-kb',
    exact: true
};

});

parcelRegister("az1fH", function(module, exports) {
$parcel$export(module.exports, "servicedeskSlaSettingsRoute", () => $3d3fe9e19d19729f$export$bfbf66468910573e);
const $3d3fe9e19d19729f$export$bfbf66468910573e = {
    name: 'servicedesk-sla-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
};

});

parcelRegister("lkngp", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskWorkforceOptimizationRoute", () => $c907fb9f11bbff11$export$466c28184167cc6);
const $c907fb9f11bbff11$export$466c28184167cc6 = {
    name: 'project-settings-servicedesk-workforce-optimization',
    path: '/jira/servicedesk/projects/:projectKey/settings/workforce-optimization',
    exact: true
};

});

parcelRegister("5yfEX", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRoute", () => $722120a4eb65adfa$export$31f95ad4356ce017);
const $722120a4eb65adfa$export$31f95ad4356ce017 = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types'
};

});

parcelRegister("aPX9C", function(module, exports) {
$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRoute", () => $94355b7214644a8d$export$8c897f53ff36fa6b);
const $94355b7214644a8d$export$8c897f53ff36fa6b = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned'
};

});

parcelRegister("7GKTa", function(module, exports) {
$parcel$export(module.exports, "servicedeskWorkflowConfigRoute", () => $89ccab8a4d079211$export$ecc771c0ee86ccb8);
const $89ccab8a4d079211$export$ecc771c0ee86ccb8 = {
    name: 'project-settings-servicedesk-workflow-scheme-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
    exact: true
};

});


parcelRegister("hw9Bj", function(module, exports) {
$parcel$export(module.exports, "customerServiceConverter", () => $990e5978b0b2e12a$export$8e632ccd3e33c9f1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5IkoH = parcelRequire("5IkoH");
const $990e5978b0b2e12a$var$routes = new Set([
    'customer-service-helpcenter',
    'customer-service-helpcenter-analytics',
    'customer-service-customers',
    'customer-service-customer-details',
    'customer-service-organizations',
    'customer-service-organization-details',
    'customer-service-products'
]);
function $990e5978b0b2e12a$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $990e5978b0b2e12a$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $990e5978b0b2e12a$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $990e5978b0b2e12a$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $990e5978b0b2e12a$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'customer-service-helpcenter':
            path.push((0, $5IkoH.MENU_ID_CUSTOMER_SERVICE));
            path.push((0, $5IkoH.MENU_ID_CUSTOMER_EXPERIENCES_VIEW_ALL));
            break;
        case 'customer-service-helpcenter-analytics':
            // Analytics appears nested under dashboards
            path.push((0, $5IkoH.MENU_ID_DASHBOARDS));
            path.push((0, $5IkoH.MENU_ID_CUSTOMER_SERVICE_ANALYTICS));
            break;
        case 'customer-service-customers':
        case 'customer-service-customer-details':
        case 'customer-service-organizations':
        case 'customer-service-organization-details':
        case 'customer-service-products':
            path.push((0, $5IkoH.MENU_ID_CUSTOMERS));
            break;
        default:
    }
    return path;
}
const $990e5978b0b2e12a$export$8e632ccd3e33c9f1 = {
    routes: $990e5978b0b2e12a$var$routes,
    convert: $990e5978b0b2e12a$var$convert,
    convertNew: $990e5978b0b2e12a$var$convertNew
};

});

parcelRegister("cCvQD", function(module, exports) {
$parcel$export(module.exports, "customerExperiencesConverter", () => $01f0a9f56570bcd5$export$2b9c03d8ca92d1a1);
/* eslint-disable jira/filename-case */ 
var $5IkoH = parcelRequire("5IkoH");
const $01f0a9f56570bcd5$var$routes = new Set([
    'helpcenter-settings-get-started',
    'helpcenter-settings-details',
    'helpcenter-settings-forms',
    'helpcenter-settings-form-edit',
    'helpcenter-settings-articles',
    'helpcenter-settings-articles-view-article',
    'helpcenter-settings-create-article',
    'helpcenter-settings-branding',
    'helpcenter-settings-support-website-details-edit',
    'helpcenter-settings-support-website-details-overview',
    'helpcenter-settings-support-website-details-pages',
    'helpcenter-settings-email',
    'helpcenter-settings-widget-configuration-customize',
    'helpcenter-settings-widget-configuration-install',
    'helpcenter-settings-embedded-widgets',
    'helpcenter-settings-phone-configuration',
    'helpcenter-settings-chat-configuration',
    'helpcenter-settings-customer-access',
    'helpcenter-settings-agent-studio',
    'helpcenter-settings-customer-notifications'
]);
function $01f0a9f56570bcd5$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [
        (0, $5IkoH.MENU_ID_CUSTOMER_SERVICE)
    ];
    return $01f0a9f56570bcd5$var$convertRouteToPath({
        routeName: routeName,
        path: path,
        match: routeContext.match
    });
}
function $01f0a9f56570bcd5$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $5IkoH.MENU_ID_CUSTOMER_SERVICE)
    ];
    return $01f0a9f56570bcd5$var$convertRouteToPath({
        routeName: routeName,
        path: path,
        match: match
    });
}
function $01f0a9f56570bcd5$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    const { projectKey: projectKey } = match.params;
    projectKey && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE(projectKey));
    switch(routeName){
        case 'helpcenter-settings-get-started':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'get-started'));
                break;
            }
        case 'helpcenter-settings-details':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'details'));
                break;
            }
        case 'helpcenter-settings-forms':
        case 'helpcenter-settings-form-edit':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'forms'));
                break;
            }
        case 'helpcenter-settings-articles':
        case 'helpcenter-settings-articles-view-article':
        case 'helpcenter-settings-create-article':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'articles'));
                break;
            }
        case 'helpcenter-settings-branding':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'branding'));
                break;
            }
        case 'helpcenter-settings-support-website-details-edit':
        case 'helpcenter-settings-support-website-details-overview':
        case 'helpcenter-settings-support-website-details-pages':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCES_CHANNELS(helpCenterId));
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'support-website'));
                break;
            }
        case 'helpcenter-settings-email':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCES_CHANNELS(helpCenterId));
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'email'));
                break;
            }
        case 'helpcenter-settings-widget-configuration-customize':
        case 'helpcenter-settings-widget-configuration-install':
        case 'helpcenter-settings-embedded-widgets':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCES_CHANNELS(helpCenterId));
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'embed'));
                break;
            }
        case 'helpcenter-settings-phone-configuration':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCES_CHANNELS(helpCenterId));
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'phone'));
                break;
            }
        case 'helpcenter-settings-chat-configuration':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'chat'));
                break;
            }
        case 'helpcenter-settings-customer-access':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'customer-access'));
                break;
            }
        case 'helpcenter-settings-agent-studio':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'agent'));
                break;
            }
        case 'helpcenter-settings-customer-notifications':
            {
                const { helpCenterId: helpCenterId } = match.params;
                helpCenterId && path.push((0, $5IkoH.ENTITY_ID).CUSTOMER_EXPERIENCE_MENU_ITEM(helpCenterId, 'customer-notifications'));
                break;
            }
        default:
    }
    return path;
}
const $01f0a9f56570bcd5$export$2b9c03d8ca92d1a1 = {
    routes: $01f0a9f56570bcd5$var$routes,
    convert: $01f0a9f56570bcd5$var$convert,
    convertNew: $01f0a9f56570bcd5$var$convertNew
};

});



parcelRegister("aK5Al", function(module, exports) {
$parcel$export(module.exports, "isSelectedPath", () => $6ad0eae82bb762d0$export$cdcd6885320eec31);

var $1xxzH = parcelRequire("1xxzH");
function $6ad0eae82bb762d0$export$cdcd6885320eec31(path, ...args) {
    const next = (menuId)=>{
        return (0, $1xxzH.isMenuIdList)(menuId) ? (0, $1xxzH.toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
    };
    if (args.length === 0) return next;
    return next(args[0]);
}

});
parcelRegister("1xxzH", function(module, exports) {
$parcel$export(module.exports, "toMenuIdFromMenuIdList", () => $4f2c6c86923061dd$export$253323efd0c41e72);
$parcel$export(module.exports, "isMenuIdList", () => $4f2c6c86923061dd$export$abdb8aa7ce9ed1ed);
$parcel$export(module.exports, "toMenuIdList", () => $4f2c6c86923061dd$export$d8e017f58178e379);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $4f2c6c86923061dd$var$MENU_ID_DELIM = '   '; // Three spaces
function $4f2c6c86923061dd$export$253323efd0c41e72(menuIds) {
    return menuIds.join($4f2c6c86923061dd$var$MENU_ID_DELIM);
}
function $4f2c6c86923061dd$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
    return maybeMenuIdList.indexOf($4f2c6c86923061dd$var$MENU_ID_DELIM) !== -1;
}
function $4f2c6c86923061dd$export$d8e017f58178e379(menuIdList) {
    return menuIdList.split($4f2c6c86923061dd$var$MENU_ID_DELIM);
}

});


parcelRegister("bZhC2", function(module, exports) {
$parcel$export(module.exports, "JiraNavigationSettingsAri", () => $8ba30daed24b906b$export$d53f27b41a9a02bb);

var $1kWQk = parcelRequire("1kWQk");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/navigation-settings/manifest.ts
var $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1kWQk.JiraNavigationSettingsAriResourceOwner),
    resourceType: (0, $1kWQk.JiraNavigationSettingsAriResourceType),
    resourceIdSlug: "activation/{activationId}/{navigationSettingScope}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        navigationSettingScope: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/navigation-settings/index.ts
var $8ba30daed24b906b$export$d53f27b41a9a02bb = class _JiraNavigationSettingsAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._navigationSettingScope = opts.resourceIdSegmentValues.navigationSettingScope;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get navigationSettingScope() {
        return this._navigationSettingScope;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts.qualifier,
            platformQualifier: $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts.resourceOwner,
            resourceType: $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.navigationSettingScope}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                navigationSettingScope: opts.navigationSettingScope
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $8ba30daed24b906b$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            navigationSettingScope: this.navigationSettingScope
        };
    }
};

});
parcelRegister("1kWQk", function(module, exports) {
$parcel$export(module.exports, "JiraNavigationSettingsAriResourceOwner", () => $0f954db24823d60e$export$a71eb7f052c3a8f1);
$parcel$export(module.exports, "JiraNavigationSettingsAriResourceType", () => $0f954db24823d60e$export$8c9eb6c30d1db6dc);
// src/jira/navigation-settings/types.ts
var $0f954db24823d60e$export$a71eb7f052c3a8f1 = "jira", $0f954db24823d60e$export$8c9eb6c30d1db6dc = "navigation-settings";

});


parcelRegister("2NSbF", function(module, exports) {
$parcel$export(module.exports, "IdentityUserAri", () => $20aa30d2bf848e8f$export$1e9d09c2be53e55e);

var $200Ah = parcelRequire("200Ah");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/identity/user/manifest.ts
var $20aa30d2bf848e8f$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $200Ah.IdentityUserAriResourceOwner),
    resourceType: (0, $200Ah.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $20aa30d2bf848e8f$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $20aa30d2bf848e8f$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $20aa30d2bf848e8f$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $20aa30d2bf848e8f$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $20aa30d2bf848e8f$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $20aa30d2bf848e8f$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $20aa30d2bf848e8f$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
};

});
parcelRegister("200Ah", function(module, exports) {
$parcel$export(module.exports, "IdentityUserAriResourceOwner", () => $174c08d8cfa575c4$export$b4c14c54282a779d);
$parcel$export(module.exports, "IdentityUserAriResourceType", () => $174c08d8cfa575c4$export$e9b50e20f4fbfb71);
// src/identity/user/types.ts
var $174c08d8cfa575c4$export$b4c14c54282a779d = "identity", $174c08d8cfa575c4$export$e9b50e20f4fbfb71 = "user";

});


parcelRegister("c1zHX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e7f49666e75cd13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f6abfec882b166694a9a58cca2805fac>>
 * @relayHash 6f28435697c6420b8630a60eea85a360
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ffb3000ca942c2dbfcd21a03bdac842f0b83ca3857486d7b45a6db27f0104c57

var $e8Yi7 = parcelRequire("e8Yi7");

var $8Rago = parcelRequire("8Rago");

var $5zovE = parcelRequire("5zovE");

var $6wCoM = parcelRequire("6wCoM");
const $9e7f49666e75cd13$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriApps"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriFilters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriPlans"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriUserSideNavSettings"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchGlobalShortcutsAvailableProducts"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRoadmapUpsellEnabled"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "navPlatMenuDataEntityAri"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "navPlatSidebarDataEntityAri"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v15 = {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
    }, v16 = [
        {
            "concreteType": "SettingsMenuItem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "menuId"
                },
                {
                    "kind": "ScalarField",
                    "name": "visible"
                }
            ]
        }
    ], v17 = {
        "concreteType": "SettingsMenuItemConnection",
        "kind": "LinkedField",
        "name": "sidebar",
        "plural": false,
        "selections": v16 /*: any*/ 
    }, v18 = [
        {
            "concreteType": "SettingsDisplayProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "id"
    }, v20 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "__relay_internal__pv__getpagesizevaluerelayproviderts"
        }
    ], v21 = [
        {
            "args": v20 /*: any*/ ,
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": v16 /*: any*/ 
        },
        {
            "args": v20 /*: any*/ ,
            "concreteType": "SettingsDisplayPropertyConnection",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": v18 /*: any*/ 
        },
        v19 /*: any*/ 
    ], v22 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v23 = [
        v22 /*: any*/ 
    ], v24 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v26 = {
        "kind": "ScalarField",
        "name": "label"
    }, v27 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v28 = {
        "kind": "ScalarField",
        "name": "url"
    }, v29 = {
        "order": "DESC"
    }, v30 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v31 = {
        "kind": "ScalarField",
        "name": "title"
    }, v32 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v33 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v34 = {
        "kind": "InlineFragment",
        "selections": [
            v19 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v35 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v25 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v19 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "collectionId"
                        },
                        v31 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "emoji"
                        },
                        v33 /*: any*/ 
                    ],
                    "type": "JiraProductDiscoveryCollection"
                },
                v34 /*: any*/ 
            ]
        }
    ], v36 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v37 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v38 = {
        "kind": "ScalarField",
        "name": "productType"
    }, v39 = [
        v17 /*: any*/ ,
        v19 /*: any*/ 
    ], v40 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v41 = {
        "kind": "ScalarField",
        "name": "name"
    }, v42 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v19 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v43 = [
        v19 /*: any*/ ,
        v41 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ], v44 = [
        v28 /*: any*/ 
    ], v45 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v25 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v19 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        v31 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        v33 /*: any*/ ,
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v19 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v25 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v44 /*: any*/ ,
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v34 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v34 /*: any*/ 
            ]
        }
    ], v46 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v47 = {
        "kind": "ScalarField",
        "name": "status"
    }, v48 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v49 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v50 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v51 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v44 /*: any*/ ,
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v34 /*: any*/ 
        ]
    }, v52 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v53 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v54 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v55 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v56 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": "subspaceCount",
                        "kind": "ScalarField",
                        "name": "subspaceCount_cse"
                    }
                ]
            }
        ]
    }, v57 = [
        v19 /*: any*/ ,
        v46 /*: any*/ ,
        v47 /*: any*/ ,
        v48 /*: any*/ ,
        v49 /*: any*/ ,
        v41 /*: any*/ ,
        v50 /*: any*/ ,
        v32 /*: any*/ ,
        v51 /*: any*/ ,
        v52 /*: any*/ ,
        v53 /*: any*/ ,
        v54 /*: any*/ ,
        v55 /*: any*/ ,
        v56 /*: any*/ 
    ], v58 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v57 /*: any*/ 
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GSNQueryPreloaderQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "GSNForContentSidebarEntryPoint"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "GSNForOtherSidebars"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v8 /*: any*/ ,
                v13 /*: any*/ ,
                v12 /*: any*/ ,
                v14 /*: any*/ ,
                v11 /*: any*/ ,
                v5 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__getpagesizevaluerelayproviderts"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "GSNQueryPreloaderQuery",
            "selections": [
                {
                    "alias": "userSideNavSettings",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAriUserSideNavSettings"
                        },
                        v15 /*: any*/ 
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        {
                            "concreteType": "SettingsDisplayPropertyConnection",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v18 /*: any*/ 
                        },
                        v19 /*: any*/ 
                    ]
                },
                {
                    "alias": "navPlatL1MenuData",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "navPlatMenuDataEntityAri"
                        },
                        v15 /*: any*/ 
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "alias": "navPlatSidebarData",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "navPlatSidebarDataEntityAri"
                        },
                        v15 /*: any*/ 
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v23 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "globalAppNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v26 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "envLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppSection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v26 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v26 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v27 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "settingsUrl"
                                                                },
                                                                v28 /*: any*/ 
                                                            ],
                                                            "type": "JiraAppNavigationItem"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isFiltersExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsFiltersExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "condition": "isProjectsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsProjectsExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v22 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "shouldDisplay",
                                    "args": [
                                        v22 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "VIEW_PROJECT_CREATION_ENTRY"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        },
                        {
                            "alias": "roadmapFavourites",
                            "args": [
                                v22 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": v29 /*: any*/ ,
                                        "type": "JPD_COLLECTION"
                                    }
                                },
                                v30 /*: any*/ 
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v35 /*: any*/ 
                                },
                                v36 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "roadmapRecents",
                            "args": [
                                v22 /*: any*/ ,
                                v37 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "JPD_COLLECTION"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v35 /*: any*/ 
                                },
                                v36 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isPlansExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsPlansExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "args": v23 /*: any*/ ,
                            "concreteType": "JiraAdvancedRoadmapsNavigation",
                            "kind": "LinkedField",
                            "name": "advancedRoadmapsNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasEditPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCreateSamplePlanPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPlansAdminPermissions"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isRoadmapUpsellEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "accountId",
                                            "variableName": "ownerAri"
                                        },
                                        v22 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "propertyKey",
                                            "value": "jpd-roadmaps-upsell.dismissed"
                                        }
                                    ],
                                    "concreteType": "JiraEntityPropertyString",
                                    "kind": "LinkedField",
                                    "name": "stringUserProperty",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "stringValue"
                                        },
                                        v19 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "fetchGlobalShortcutsAvailableProducts",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v23 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "appSwitcher_availableProductsBySite",
                            "plural": false,
                            "selections": [
                                v25 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "products",
                                            "plural": true,
                                            "selections": [
                                                v25 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        v28 /*: any*/ 
                                                    ],
                                                    "type": "AppSwitcherSingleUrlProduct"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        {
                                                            "concreteType": "AppSwitcherProductSite",
                                                            "kind": "LinkedField",
                                                            "name": "sites",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "siteId"
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "AppSwitcherSiteScopedProduct"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "AppSwitcherAvailableProductsBySite"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isAppsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "appsOrder",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "entityAri",
                                    "variableName": "entityAriApps"
                                },
                                v15 /*: any*/ 
                            ],
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": v39 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v22 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v29 /*: any*/ ,
                                                "type": "FILTER"
                                            }
                                        },
                                        v30 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v40 /*: any*/ ,
                                                                v41 /*: any*/ ,
                                                                v32 /*: any*/ ,
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v34 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v36 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentFilters",
                                    "args": [
                                        v22 /*: any*/ ,
                                        v37 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "FILTER"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v40 /*: any*/ ,
                                                                v19 /*: any*/ ,
                                                                v41 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v32 /*: any*/ ,
                                                                        v42 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        },
                                                        v34 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v36 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v23 /*: any*/ ,
                                    "concreteType": "JiraSystemFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "systemFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v41 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v32 /*: any*/ ,
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "filtersOrder",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "entityAri",
                                    "variableName": "entityAriFilters"
                                },
                                v15 /*: any*/ 
                            ],
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": v39 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "isOperationsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "OpsgenieQuery",
                            "kind": "LinkedField",
                            "name": "opsgenie",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v23 /*: any*/ ,
                                    "concreteType": "OpsgenieSavedSearches",
                                    "kind": "LinkedField",
                                    "name": "savedSearches",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "starred",
                                            "plural": true,
                                            "selections": v43 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v43 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v43 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v22 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v29 /*: any*/ ,
                                                "type": "PLAN"
                                            }
                                        },
                                        v30 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v45 /*: any*/ 
                                        },
                                        v36 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentPlans",
                                    "args": [
                                        v22 /*: any*/ ,
                                        v37 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v45 /*: any*/ 
                                        },
                                        v36 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "plansOrder",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "entityAri",
                                    "variableName": "entityAriPlans"
                                },
                                v15 /*: any*/ 
                            ],
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": v39 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v23 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementLicensing",
                                    "kind": "LinkedField",
                                    "name": "jwmLicensing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentUserSeatEdition"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v23 /*: any*/ ,
                            "concreteType": "JiraProjectsSidebarMenu",
                            "kind": "LinkedField",
                            "name": "jira_projectsSidebarMenu",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecent",
                                    "plural": false,
                                    "selections": v57 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "mostRecentFromHistory",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        v46 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v47 /*: any*/ ,
                                        v48 /*: any*/ ,
                                        v49 /*: any*/ ,
                                        v41 /*: any*/ ,
                                        v50 /*: any*/ ,
                                        v51 /*: any*/ ,
                                        v52 /*: any*/ ,
                                        v53 /*: any*/ ,
                                        v54 /*: any*/ ,
                                        v55 /*: any*/ ,
                                        v56 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        v30 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v58 /*: any*/ ,
                                        v36 /*: any*/ 
                                    ],
                                    "storageKey": "favourites(first:15)"
                                },
                                {
                                    "args": [
                                        v37 /*: any*/ 
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "recents",
                                    "plural": false,
                                    "selections": [
                                        v58 /*: any*/ ,
                                        v36 /*: any*/ 
                                    ],
                                    "storageKey": "recents(first:20)"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "favouriteLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "recentLimit"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayMode"
                                },
                                v19 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ffb3000ca942c2dbfcd21a03bdac842f0b83ca3857486d7b45a6db27f0104c57",
            "metadata": {},
            "name": "GSNQueryPreloaderQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__getpagesizevaluerelayproviderts": (0, $e8Yi7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $5zovE.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationm2relayprovider": (0, $8Rago.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $6wCoM.default)
            }
        }
    };
}();
$9e7f49666e75cd13$var$node.hash = "49df8ab2140b3cdbfa77edff48597e76";
var $9e7f49666e75cd13$export$2e2bcd8739ae039 = $9e7f49666e75cd13$var$node;

});
parcelRegister("e8Yi7", function(module, exports) {
$parcel$export(module.exports, "default", () => $da7ed56708de7e8b$export$2e2bcd8739ae039);
// Query page size for navigation items
// This is a COPY of packages/navigation/global-side-navigation/src/common/constants.ts
const $da7ed56708de7e8b$export$5716e8bcb003888d = 100;
var $da7ed56708de7e8b$export$2e2bcd8739ae039 = {
    get () {
        return $da7ed56708de7e8b$export$5716e8bcb003888d;
    }
};

});

parcelRegister("8Rago", function(module, exports) {
$parcel$export(module.exports, "default", () => $94643f17f54d7a93$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $aJDWs = parcelRequire("aJDWs");
var $94643f17f54d7a93$export$2e2bcd8739ae039 = {
    get () {
        return (0, $aJDWs.isProjectsInJiraM2Enabled)();
    }
};

});

parcelRegister("5zovE", function(module, exports) {
$parcel$export(module.exports, "default", () => $381176e26c9636dd$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $381176e26c9636dd$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('allow_end_users_to_access_custom_templates');
    }
};

});

parcelRegister("6wCoM", function(module, exports) {
$parcel$export(module.exports, "default", () => $d59a67f8bc3af4a7$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $d59a67f8bc3af4a7$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jsm_aiiy_for_nav_item_sidebar');
    }
};

});



parcelRegister("3tHVQ", function(module, exports) {
$parcel$export(module.exports, "sidebarNav4Resource", () => $8e10782b8905f14f$export$7648dc6f76f4f83d);
$parcel$export(module.exports, "sidebarEntryUiStateResource", () => $8e10782b8905f14f$export$b1f2e154e7288dba);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $kZ1Cr = parcelRequire("kZ1Cr");

var $5IkoH = parcelRequire("5IkoH");

var $bkBsT = parcelRequire("bkBsT");

var $aK5Al = parcelRequire("aK5Al");

var $htsFl = parcelRequire("htsFl");

var $bZhC2 = parcelRequire("bZhC2");

var $2NSbF = parcelRequire("2NSbF");

var $i860n = parcelRequire("i860n");

var $7Cxzw = parcelRequire("7Cxzw");
const $8e10782b8905f14f$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
const $8e10782b8905f14f$export$7648dc6f76f4f83d = (0, $htsFl.createRelayResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_${$8e10782b8905f14f$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const initialSelectedPath = (0, $bkBsT.getInitialSelectedPath)(routerContext);
        return {
            parameters: (0, $7Cxzw.default),
            variables: {
                cloudId: cloudId,
                isAppsExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_APPS)),
                isFiltersExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $aK5Al.isSelectedPath)(initialSelectedPath, (0, $5IkoH.MENU_ID_OPERATIONS)),
                entityAriFilters: (0, $bZhC2.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'filters'
                }).toString(),
                entityAriApps: (0, $bZhC2.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'apps'
                }).toString(),
                entityAriPlans: (0, $bZhC2.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'plans'
                }).toString(),
                ownerAri: atlassianAccountId && (0, $2NSbF.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString(),
                isAnonymous: isAnonymous,
                isRoadmapUpsellEnabled: (0, $i860n.fg)('jpd-roadmaps-in-jira')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    },
    isCritical: true
});
const $8e10782b8905f14f$export$b1f2e154e7288dba = (0, $htsFl.createRelayResource)({
    type: `${(0, $htsFl.RELAY_RESOURCE_TYPE)}_SIDEBAR_ENTRY_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $kZ1Cr.default),
            variables: {
                cloudId: cloudId,
                isSkipped: (0, $i860n.fg)('navx-global-side-nav')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isCritical: true
});

});
parcelRegister("kZ1Cr", function(module, exports) {
$parcel$export(module.exports, "default", () => $af4e608c01d24387$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<df8975edc6a95699766c219153934e33>>
 * @relayHash 9009ab4bb003c0459c2cba07315e1bc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4bb284ff808561eda6128044dee841ec03fef5f2c5d2d899e6db8b5360e3d04e
const $af4e608c01d24387$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSkipped"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "leftSidebarWidth"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SidebarEntryNavigationUIStateQuery",
            "selections": [
                {
                    "condition": "isSkipped",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SidebarEntryNavigationUIStateQuery",
            "selections": [
                {
                    "condition": "isSkipped",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4bb284ff808561eda6128044dee841ec03fef5f2c5d2d899e6db8b5360e3d04e",
            "metadata": {},
            "name": "SidebarEntryNavigationUIStateQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$af4e608c01d24387$var$node.hash = "4d82a3dc44121fcaa8a9d81d1eb197ad";
var $af4e608c01d24387$export$2e2bcd8739ae039 = $af4e608c01d24387$var$node;

});

parcelRegister("7Cxzw", function(module, exports) {
$parcel$export(module.exports, "default", () => $5472bed1609a0601$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c8db6aa2102ea5807368ad3698463f8e>>
 * @relayHash 69fb974715421103f4460b382b90a6b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 45051c26a591137186ac37b5b5203b14e7ffd598b387eb741f38827bc152f4a6

var $8Rago = parcelRequire("8Rago");

var $5zovE = parcelRequire("5zovE");

var $6wCoM = parcelRequire("6wCoM");
const $5472bed1609a0601$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriApps"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriFilters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriPlans"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRoadmapUpsellEnabled"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v12 = {
        "kind": "ScalarField",
        "name": "menuId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "label"
    }, v19 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v20 = {
        "kind": "ScalarField",
        "name": "url"
    }, v21 = {
        "order": "DESC"
    }, v22 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v23 = {
        "kind": "ScalarField",
        "name": "title"
    }, v24 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v25 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            v13 /*: any*/ 
        ]
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v27 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v17 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v13 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "collectionId"
                        },
                        v23 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "emoji"
                        },
                        v25 /*: any*/ 
                    ],
                    "type": "JiraProductDiscoveryCollection"
                },
                v26 /*: any*/ 
            ]
        }
    ], v28 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v29 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v30 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v31 = {
        "kind": "ScalarField",
        "name": "status"
    }, v32 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v33 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "name"
    }, v35 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v36 = [
        v20 /*: any*/ 
    ], v37 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v36 /*: any*/ ,
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v26 /*: any*/ 
        ]
    }, v38 = {
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v39 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v40 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v41 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v42 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": "subspaceCount",
                        "kind": "ScalarField",
                        "name": "subspaceCount_cse"
                    }
                ]
            }
        ]
    }, v43 = [
        v13 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ ,
        v32 /*: any*/ ,
        v33 /*: any*/ ,
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v24 /*: any*/ ,
        v37 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v41 /*: any*/ ,
        v42 /*: any*/ 
    ], v44 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v43 /*: any*/ 
            }
        ]
    }, v45 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v46 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v17 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v13 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v47 = {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
    }, v48 = [
        {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SettingsMenuItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "visible"
                        }
                    ]
                }
            ]
        },
        v13 /*: any*/ 
    ], v49 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v17 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v13 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        v23 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        v25 /*: any*/ ,
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v13 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v36 /*: any*/ ,
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v26 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v26 /*: any*/ 
            ]
        }
    ], v50 = [
        v13 /*: any*/ ,
        v34 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ConfigurableMenuItems"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v7 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v11 /*: any*/ ,
                v4 /*: any*/ ,
                v10 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudID",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "navKey",
                                            "value": "NAV_SIDEBAR"
                                        }
                                    ],
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraConfigurableNavigationItem",
                                            "kind": "LinkedField",
                                            "name": "navItems",
                                            "plural": true,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isVisible"
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isProjectsExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsProjectsExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canCreateProject",
                                    "args": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_PROJECT"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "shouldDisplay",
                                            "args": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "VIEW_PROJECT_CREATION_ENTRY"
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isFiltersExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsFiltersExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isAppsExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v15 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "globalAppNavigationItems",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v18 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appType"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v19 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        v20 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "settingsUrl"
                                                                        },
                                                                        v20 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "roadmapFavourites",
                                    "args": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v21 /*: any*/ ,
                                                "type": "JPD_COLLECTION"
                                            }
                                        },
                                        v22 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v27 /*: any*/ 
                                        },
                                        v28 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "roadmapRecents",
                                    "args": [
                                        v14 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "JPD_COLLECTION"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v27 /*: any*/ 
                                        },
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isPlansExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsPlansExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraAdvancedRoadmapsNavigation",
                                    "kind": "LinkedField",
                                    "name": "advancedRoadmapsNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasEditPermissions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasCreateSamplePlanPermissions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasGlobalPlansAdminPermissions"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v15 /*: any*/ ,
                                            "concreteType": "JiraWorkManagementLicensing",
                                            "kind": "LinkedField",
                                            "name": "jwmLicensing",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "currentUserSeatEdition"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraProjectsSidebarMenu",
                                    "kind": "LinkedField",
                                    "name": "jira_projectsSidebarMenu",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecent",
                                            "plural": false,
                                            "selections": v43 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecentFromHistory",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v42 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v22 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v44 /*: any*/ ,
                                                v28 /*: any*/ 
                                            ],
                                            "storageKey": "favourites(first:15)"
                                        },
                                        {
                                            "args": [
                                                v29 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recents",
                                            "plural": false,
                                            "selections": [
                                                v44 /*: any*/ ,
                                                v28 /*: any*/ 
                                            ],
                                            "storageKey": "recents(first:20)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "favouriteLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "recentLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayMode"
                                        },
                                        v13 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isFiltersExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": "favouriteFilters",
                                            "args": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v21 /*: any*/ ,
                                                        "type": "FILTER"
                                                    }
                                                },
                                                v22 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        v45 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v46 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v28 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "recentFilters",
                                            "args": [
                                                v14 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "types",
                                                    "value": [
                                                        "FILTER"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraSearchableEntityConnection",
                                            "kind": "LinkedField",
                                            "name": "recentItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSearchableEntityEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v45 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v24 /*: any*/ ,
                                                                                v46 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraFilter",
                                                                            "abstractKey": "__isJiraFilter"
                                                                        }
                                                                    ],
                                                                    "type": "JiraCustomFilter"
                                                                },
                                                                v26 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v28 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v15 /*: any*/ ,
                                            "concreteType": "JiraSystemFilterConnection",
                                            "kind": "LinkedField",
                                            "name": "systemFilters",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilterEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSystemFilter",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v34 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v46 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "filtersOrder",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriFilters"
                                        },
                                        v47 /*: any*/ 
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": v48 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "isPlansExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": "favouritePlans",
                                            "args": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v21 /*: any*/ ,
                                                        "type": "PLAN"
                                                    }
                                                },
                                                v22 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v49 /*: any*/ 
                                                },
                                                v28 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "recentPlans",
                                            "args": [
                                                v14 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "types",
                                                    "value": [
                                                        "PLAN"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraSearchableEntityConnection",
                                            "kind": "LinkedField",
                                            "name": "recentItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSearchableEntityEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v49 /*: any*/ 
                                                },
                                                v28 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "plansOrder",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriPlans"
                                        },
                                        v47 /*: any*/ 
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": v48 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "appsOrder",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "entityAri",
                                            "variableName": "entityAriApps"
                                        },
                                        v47 /*: any*/ 
                                    ],
                                    "concreteType": "SettingsNavigationCustomisation",
                                    "kind": "LinkedField",
                                    "name": "settings_navigationCustomisation",
                                    "plural": false,
                                    "selections": v48 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "isOperationsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "OpsgenieQuery",
                                    "kind": "LinkedField",
                                    "name": "opsgenie",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v15 /*: any*/ ,
                                            "concreteType": "OpsgenieSavedSearches",
                                            "kind": "LinkedField",
                                            "name": "savedSearches",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "OpsgenieSavedSearch",
                                                    "kind": "LinkedField",
                                                    "name": "starred",
                                                    "plural": true,
                                                    "selections": v50 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "OpsgenieSavedSearch",
                                                    "kind": "LinkedField",
                                                    "name": "sharedWithMe",
                                                    "plural": true,
                                                    "selections": v50 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "OpsgenieSavedSearch",
                                                    "kind": "LinkedField",
                                                    "name": "createdByMe",
                                                    "plural": true,
                                                    "selections": v50 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isRoadmapUpsellEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "accountId",
                                                    "variableName": "ownerAri"
                                                },
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "propertyKey",
                                                    "value": "jpd-roadmaps-upsell.dismissed"
                                                }
                                            ],
                                            "concreteType": "JiraEntityPropertyString",
                                            "kind": "LinkedField",
                                            "name": "stringUserProperty",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "stringValue"
                                                },
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "45051c26a591137186ac37b5b5203b14e7ffd598b387eb741f38827bc152f4a6",
            "metadata": {},
            "name": "L1MenuItemsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $5zovE.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationm2relayprovider": (0, $8Rago.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $6wCoM.default)
            }
        }
    };
}();
$5472bed1609a0601$var$node.hash = "81003b54ce89d01024f55a09499a220e";
var $5472bed1609a0601$export$2e2bcd8739ae039 = $5472bed1609a0601$var$node;

});


parcelRegister("iFmc7", function(module, exports) {
$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $f2b28d7a7c984760$export$e4bf33528101348c);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", () => $f2b28d7a7c984760$export$2d5a704ae6f6b050);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $fpjIq = parcelRequire("fpjIq");
const $f2b28d7a7c984760$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $f2b28d7a7c984760$export$e4bf33528101348c = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$f2b28d7a7c984760$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $f2b28d7a7c984760$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $fpjIq.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000,
    isCritical: true
});
const $f2b28d7a7c984760$export$2d5a704ae6f6b050 = ()=>(0, $k6ufm.useResource)($f2b28d7a7c984760$export$e4bf33528101348c);

});
parcelRegister("fpjIq", function(module, exports) {
$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $99d66a22d26a4061$export$b15f9f5cf6db359e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $99d66a22d26a4061$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $h2wCv.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});


parcelRegister("hEjfV", function(module, exports) {
$parcel$export(module.exports, "staticPlanSidebarNavigationResource", () => $6069c1dca9b3f6f8$export$e7e6c1b9d8d5ea7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $7edbf = parcelRequire("7edbf");

var $gOgV5 = parcelRequire("gOgV5");
const $6069c1dca9b3f6f8$var$getRouterKey = (match)=>{
    if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
    return 'none';
};
const $6069c1dca9b3f6f8$export$e7e6c1b9d8d5ea7 = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
    getKey: ({ match: match })=>$6069c1dca9b3f6f8$var$getRouterKey(match),
    getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
        if (planId == null || scenarioId == null) return null;
        return (0, $gOgV5.fetchPlanSidebarNavInfo)(planId, scenarioId);
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("gOgV5", function(module, exports) {
$parcel$export(module.exports, "fetchPlanSidebarNavInfo", () => $b9a4d9dc2df27da7$export$a49729698cfc5310);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $b9a4d9dc2df27da7$var$requestSideBarInfo = (planId, scenarioId)=>(0, $h2wCv.performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
const $b9a4d9dc2df27da7$export$a49729698cfc5310 = (planId, scenarioId)=>{
    if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
    if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
    return $b9a4d9dc2df27da7$var$requestSideBarInfo(planId, scenarioId);
};

});


parcelRegister("5mMCG", function(module, exports) {
$parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", () => $cb2692bab8e860db$export$5839dd8142de842e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $8S1Gc = parcelRequire("8S1Gc");

var $6CfY5 = parcelRequire("6CfY5");

var $7edbf = parcelRequire("7edbf");

var $89zJM = parcelRequire("89zJM");
const $cb2692bab8e860db$export$5839dd8142de842e = (0, $7edbf.createResource)({
    type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $8S1Gc.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $8S1Gc.getBoardId)(match, query);
        if (boardId == null) return null;
        try {
            const response = await (0, $89zJM.fetchUserBoardNavigationData)(boardId);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $6CfY5.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
            return null;
        }
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("8S1Gc", function(module, exports) {
$parcel$export(module.exports, "getBoardId", () => $03960f7c3aed5593$export$557c2f222778cea6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $03960f7c3aed5593$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];

});

parcelRegister("89zJM", function(module, exports) {
$parcel$export(module.exports, "fetchUserBoardNavigationData", () => $a053a2773fabb588$export$306fb49fca60b34);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $a053a2773fabb588$export$306fb49fca60b34 = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $h2wCv.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
};

});


parcelRegister("hFYSn", function(module, exports) {
$parcel$export(module.exports, "forgeAdminModuleResource", () => $df04ebf59eda0adf$export$b9489d8c5c5e3626);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $df04ebf59eda0adf$export$dcc98f4b36ce9223);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $df04ebf59eda0adf$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeBacklogModuleResource", () => $df04ebf59eda0adf$export$7523db37432ba090);
$parcel$export(module.exports, "forgeBoardModuleResource", () => $df04ebf59eda0adf$export$cfd99f451b423d3a);
$parcel$export(module.exports, "forgeSprintModuleResource", () => $df04ebf59eda0adf$export$7b639f33f086f9f1);
$parcel$export(module.exports, "forgePersonalSettingsPageModuleResource", () => $df04ebf59eda0adf$export$8a5aed164e925eb6);
$parcel$export(module.exports, "getNavigationForgePersonalSettingsPageResources", () => $df04ebf59eda0adf$export$ec3265610584f9ce);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $df04ebf59eda0adf$export$7a928d209faf75f);
$parcel$export(module.exports, "useForgeProjectSettingsModuleResource", () => $df04ebf59eda0adf$export$e81e11bbc3239153);
$parcel$export(module.exports, "forgeGlobalModuleResource", () => $df04ebf59eda0adf$export$97b0827022fdafe3);
$parcel$export(module.exports, "getNavigationForgeGlobalPageResources", () => $df04ebf59eda0adf$export$80b2f91dabb3dd65);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $df04ebf59eda0adf$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $df04ebf59eda0adf$export$e6be2f0ca0849869);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fLTsc = parcelRequire("fLTsc");

var $kIxv5 = parcelRequire("kIxv5");

var $aHmTX = parcelRequire("aHmTX");

var $A82xh = parcelRequire("A82xh");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $aaubd = parcelRequire("aaubd");
const $df04ebf59eda0adf$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $aHmTX.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $aHmTX.CUSTOMER_SERVICE_MANAGEMENT_QUEUE_PAGE_MODULE),
        (0, $aHmTX.PROJECT_PAGE_MODULE),
        (0, $aHmTX.PROJECT_SETTINGS_PAGE_MODULE)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $fLTsc.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $df04ebf59eda0adf$export$b9489d8c5c5e3626 = (0, $7edbf.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.ADMIN_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $aHmTX.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.ADMIN_PAGE_MODULE], (0, $aaubd.adminPageFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$dcc98f4b36ce9223 = ()=>[
        $df04ebf59eda0adf$export$b9489d8c5c5e3626
    ];
const $df04ebf59eda0adf$export$72db683c2914a65e = (0, $7edbf.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fLTsc.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.PROJECT_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fLTsc.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $aHmTX.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.PROJECT_PAGE_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER,
    isCritical: true
});
const $df04ebf59eda0adf$export$7523db37432ba090 = (0, $7edbf.createResource)({
    type: 'FORGE_BACKLOG_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fLTsc.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.BACKLOG_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fLTsc.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $aHmTX.SOURCE_ROUTER)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.BACKLOG_ACTION_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$cfd99f451b423d3a = (0, $7edbf.createResource)({
    type: 'FORGE_BOARD_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fLTsc.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.BOARD_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fLTsc.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $aHmTX.SOURCE_ROUTER)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.BOARD_ACTION_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$7b639f33f086f9f1 = (0, $7edbf.createResource)({
    type: 'FORGE_SPRINT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fLTsc.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.SPRINT_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fLTsc.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $aHmTX.SOURCE_ROUTER)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.SPRINT_ACTION_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$8a5aed164e925eb6 = (0, $7edbf.createResource)({
    type: 'FORGE_PERSONAL_SETTINGS_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.PERSONAL_SETTINGS_PAGE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $aHmTX.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.PERSONAL_SETTINGS_PAGE_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$ec3265610584f9ce = ()=>[
        $df04ebf59eda0adf$export$8a5aed164e925eb6
    ];
const $df04ebf59eda0adf$export$7a928d209faf75f = (0, $7edbf.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fLTsc.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.PROJECT_SETTINGS_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fLTsc.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $aHmTX.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.PROJECT_SETTINGS_PAGE_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER,
    isCritical: true
});
const $df04ebf59eda0adf$export$e81e11bbc3239153 = ()=>(0, $k6ufm.useResource)($df04ebf59eda0adf$export$7a928d209faf75f);
const $df04ebf59eda0adf$export$97b0827022fdafe3 = (0, $7edbf.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.GLOBAL_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $aHmTX.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.GLOBAL_PAGE_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$80b2f91dabb3dd65 = ()=>[
        $df04ebf59eda0adf$export$97b0827022fdafe3
    ];
const $df04ebf59eda0adf$export$ebf5369e4dcfad00 = (0, $7edbf.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fLTsc.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.SERVICEDESK_QUEUE_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fLTsc.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $aHmTX.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$df04ebf59eda0adf$var$normalizeModules(modules[0, $aHmTX.SERVICEDESK_QUEUE_PAGE_MODULE], (0, $aaubd.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $df04ebf59eda0adf$export$e6be2f0ca0849869 = (0, $7edbf.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $A82xh.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $aHmTX.CUSTOM_FIELD_TYPE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $aHmTX.SOURCE_NAVIGATION)
        }).then(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (modules)=>modules[0, $aHmTX.CUSTOM_FIELD_TYPE_MODULE]),
    maxAge: Number.MAX_SAFE_INTEGER
});
/**
 * Makes sure modules are filtered out depending on the predicate and sorted alphabetically by title.
 */ function $df04ebf59eda0adf$var$normalizeModules(modules, filter) {
    return filter(modules).sort((a, b)=>(0, $kIxv5.alphabeticalSort)(a.properties.title, b.properties.title));
}

});
parcelRegister("kIxv5", function(module, exports) {
$parcel$export(module.exports, "alphabeticalSort", () => $613bd8b41bbd57c4$export$89a1f01f2a7cb2a1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6CfY5 = parcelRequire("6CfY5");
const $613bd8b41bbd57c4$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $6CfY5.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("aHmTX", function(module, exports) {
$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $ff63b09d5a67ee89$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $ff63b09d5a67ee89$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $ff63b09d5a67ee89$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "BACKLOG_ACTION_MODULE", () => $ff63b09d5a67ee89$export$516a8fb49ad5d50e);
$parcel$export(module.exports, "BOARD_ACTION_MODULE", () => $ff63b09d5a67ee89$export$6cc3a1f2111dee11);
$parcel$export(module.exports, "SPRINT_ACTION_MODULE", () => $ff63b09d5a67ee89$export$cfb15d127f20a01f);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $ff63b09d5a67ee89$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "COMMAND_PALETTE_MODULE", () => $ff63b09d5a67ee89$export$65ebd2e1f63d2992);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $ff63b09d5a67ee89$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $ff63b09d5a67ee89$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $ff63b09d5a67ee89$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_ACTION_MODULE", () => $ff63b09d5a67ee89$export$7e2136b4285d29f5);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $ff63b09d5a67ee89$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $ff63b09d5a67ee89$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $ff63b09d5a67ee89$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $ff63b09d5a67ee89$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $ff63b09d5a67ee89$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $ff63b09d5a67ee89$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PERSONAL_SETTINGS_PAGE_MODULE", () => $ff63b09d5a67ee89$export$a8cd23a3cbda9d58);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $ff63b09d5a67ee89$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $ff63b09d5a67ee89$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $ff63b09d5a67ee89$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $ff63b09d5a67ee89$export$353acf28daa75c79);
$parcel$export(module.exports, "GLOBAL_BACKGROUND_SCRIPT_MODULE", () => $ff63b09d5a67ee89$export$4384c2fafce7b6f1);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $ff63b09d5a67ee89$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $ff63b09d5a67ee89$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $ff63b09d5a67ee89$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $ff63b09d5a67ee89$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $ff63b09d5a67ee89$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $ff63b09d5a67ee89$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $ff63b09d5a67ee89$export$842eb4236828ac9);
$parcel$export(module.exports, "CUSTOMER_SERVICE_MANAGEMENT_QUEUE_PAGE_MODULE", () => $ff63b09d5a67ee89$export$b900a1f2aedd7046);
$parcel$export(module.exports, "CUSTOMER_SERVICE_MANAGEMENT_CRM_IMPORT_MODULE", () => $ff63b09d5a67ee89$export$f9b837fd8b10f776);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $ff63b09d5a67ee89$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $ff63b09d5a67ee89$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $ff63b09d5a67ee89$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $ff63b09d5a67ee89$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $ff63b09d5a67ee89$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $ff63b09d5a67ee89$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $ff63b09d5a67ee89$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $ff63b09d5a67ee89$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $ff63b09d5a67ee89$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $ff63b09d5a67ee89$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $ff63b09d5a67ee89$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $ff63b09d5a67ee89$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $ff63b09d5a67ee89$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $ff63b09d5a67ee89$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $ff63b09d5a67ee89$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $ff63b09d5a67ee89$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $ff63b09d5a67ee89$export$4346e4e240c84319);
$parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", () => $ff63b09d5a67ee89$export$d719bb340dc354e4);
$parcel$export(module.exports, "SOURCE_GLOBAL_EXTENSIONS", () => $ff63b09d5a67ee89$export$e29a293ebc8123e3);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $ff63b09d5a67ee89$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $ff63b09d5a67ee89$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $ff63b09d5a67ee89$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CSM", () => $ff63b09d5a67ee89$export$3b981417f94a136f);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $ff63b09d5a67ee89$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $ff63b09d5a67ee89$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $ff63b09d5a67ee89$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $ff63b09d5a67ee89$export$51ab2784839ce348);
/* eslint-disable jira/filename-case */ const $ff63b09d5a67ee89$export$9af0088c49bdedb = 'PRODUCTION';
const $ff63b09d5a67ee89$export$71acbd662c478c42 = 'STAGING';
const $ff63b09d5a67ee89$export$978072fd3fd149 = 'DEVELOPMENT';
const $ff63b09d5a67ee89$export$ebc15d9cebfd6063 = 'default';
const $ff63b09d5a67ee89$export$516a8fb49ad5d50e = 'jira:backlogAction';
const $ff63b09d5a67ee89$export$6cc3a1f2111dee11 = 'jira:boardAction';
const $ff63b09d5a67ee89$export$cfb15d127f20a01f = 'jira:sprintAction';
const $ff63b09d5a67ee89$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $ff63b09d5a67ee89$export$65ebd2e1f63d2992 = 'jira:command';
const $ff63b09d5a67ee89$export$259bab989b0129d0 = 'jira:issueGlance';
const $ff63b09d5a67ee89$export$75f224942f595e13 = 'jira:issueContext';
const $ff63b09d5a67ee89$export$ba0968f9752844 = 'jira:issuePanel';
const $ff63b09d5a67ee89$export$7e2136b4285d29f5 = 'jira:issueNavigatorAction';
const $ff63b09d5a67ee89$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $ff63b09d5a67ee89$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $ff63b09d5a67ee89$export$811b7f067a43b422 = 'jira:uiModifications';
const $ff63b09d5a67ee89$export$e3887d6bafe8a17 = 'jira:customField';
const $ff63b09d5a67ee89$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $ff63b09d5a67ee89$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $ff63b09d5a67ee89$export$a8cd23a3cbda9d58 = 'jira:personalSettingsPage';
const $ff63b09d5a67ee89$export$151b03356f566603 = 'jira:projectPage';
const $ff63b09d5a67ee89$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $ff63b09d5a67ee89$export$31ac745ab2add7cc = 'jira:globalPage';
const $ff63b09d5a67ee89$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $ff63b09d5a67ee89$export$4384c2fafce7b6f1 = 'jira:globalBackgroundScript';
const $ff63b09d5a67ee89$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $ff63b09d5a67ee89$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $ff63b09d5a67ee89$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $ff63b09d5a67ee89$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $ff63b09d5a67ee89$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $ff63b09d5a67ee89$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $ff63b09d5a67ee89$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $ff63b09d5a67ee89$export$b900a1f2aedd7046 = 'customerServiceManagement:queuePage';
const $ff63b09d5a67ee89$export$f9b837fd8b10f776 = 'customerServiceManagement:crmImport';
const $ff63b09d5a67ee89$export$9b1a91242ce2a1b7 = [
    $ff63b09d5a67ee89$export$516a8fb49ad5d50e,
    $ff63b09d5a67ee89$export$65ebd2e1f63d2992,
    $ff63b09d5a67ee89$export$6cc3a1f2111dee11,
    $ff63b09d5a67ee89$export$cfb15d127f20a01f,
    $ff63b09d5a67ee89$export$fcc4a18f46f80f16,
    $ff63b09d5a67ee89$export$259bab989b0129d0,
    $ff63b09d5a67ee89$export$75f224942f595e13,
    $ff63b09d5a67ee89$export$7e2136b4285d29f5,
    $ff63b09d5a67ee89$export$ba0968f9752844,
    $ff63b09d5a67ee89$export$cc20a5638825fbb0,
    $ff63b09d5a67ee89$export$9069d4b945c3d532,
    $ff63b09d5a67ee89$export$811b7f067a43b422,
    $ff63b09d5a67ee89$export$e3887d6bafe8a17,
    $ff63b09d5a67ee89$export$7b7866c04a2ad947,
    $ff63b09d5a67ee89$export$52e4945e96bd2aa0,
    $ff63b09d5a67ee89$export$a8cd23a3cbda9d58,
    $ff63b09d5a67ee89$export$151b03356f566603,
    $ff63b09d5a67ee89$export$ea0d6ac082b0d636,
    $ff63b09d5a67ee89$export$31ac745ab2add7cc,
    $ff63b09d5a67ee89$export$353acf28daa75c79,
    $ff63b09d5a67ee89$export$25627f012b21b0b9,
    $ff63b09d5a67ee89$export$8af4cb794979f60d,
    $ff63b09d5a67ee89$export$b900a1f2aedd7046,
    $ff63b09d5a67ee89$export$f9b837fd8b10f776,
    $ff63b09d5a67ee89$export$5592ab836d562168,
    $ff63b09d5a67ee89$export$842eb4236828ac9,
    $ff63b09d5a67ee89$export$42d6a8740fd42e58,
    $ff63b09d5a67ee89$export$a7186e5a73395db4,
    $ff63b09d5a67ee89$export$8fbcfe84dc845d17,
    $ff63b09d5a67ee89$export$4384c2fafce7b6f1
];
const $ff63b09d5a67ee89$export$2b8aeda236486576 = 'edit';
const $ff63b09d5a67ee89$export$c41ce1ec1ea6e73d = 'view';
const $ff63b09d5a67ee89$export$b37d58c3ed77c139 = 'create';
const $ff63b09d5a67ee89$export$ab94dbd1d02ac251 = 'contextConfig';
const $ff63b09d5a67ee89$export$b6a67a3131c6c48d = 'none';
const $ff63b09d5a67ee89$export$b75dc2bfd20898fe = 5;
const $ff63b09d5a67ee89$export$8e96118a698216cb = 'native';
const $ff63b09d5a67ee89$export$9b72a8e9b92658fb = 'basic';
const $ff63b09d5a67ee89$export$2d6539e7d0553ae7 = 'blank';
const $ff63b09d5a67ee89$export$ecbd7135d66cb322 = 'unknownSource';
const $ff63b09d5a67ee89$export$61d882aa7aba51c = 'global-issue-create';
const $ff63b09d5a67ee89$export$46cb92762d68a048 = 'issue-view';
const $ff63b09d5a67ee89$export$fe90e46aea58e30b = 'navigation';
const $ff63b09d5a67ee89$export$c5ccbdb9893f2a6a = 'full-page-app';
const $ff63b09d5a67ee89$export$eae46a3c13473a8d = 'router';
const $ff63b09d5a67ee89$export$ac11ee191d09688f = 'legacy';
const $ff63b09d5a67ee89$export$4346e4e240c84319 = 'organization-panel';
const $ff63b09d5a67ee89$export$d719bb340dc354e4 = 'assets-import-type';
const $ff63b09d5a67ee89$export$e29a293ebc8123e3 = 'global-extensions';
const $ff63b09d5a67ee89$export$4b6228758e800433 = 'jira';
const $ff63b09d5a67ee89$export$70495c8cc141a7a4 = 'jsm';
const $ff63b09d5a67ee89$export$bc3d408418fdf9d2 = 'cmdb';
const $ff63b09d5a67ee89$export$3b981417f94a136f = 'csm';
const $ff63b09d5a67ee89$export$a48dade1864725a = {
    jiraBacklogAction: [],
    jiraBoardAction: [],
    jiraSprintAction: [],
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueNavigatorAction: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraPersonalSettingsPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    customerServiceManagementQueuePage: [],
    customerServiceManagementCrmImport: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: [],
    jiraCommand: [],
    jiraGlobalBackgroundScript: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $ff63b09d5a67ee89$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$ff63b09d5a67ee89$export$a48dade1864725a
};
const $ff63b09d5a67ee89$export$218a328f66b86f7d = ()=>({
        ...$ff63b09d5a67ee89$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $ff63b09d5a67ee89$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $ff63b09d5a67ee89$export$df7774a415710cce = 'com.atlassian.forge:';
const $ff63b09d5a67ee89$export$51ab2784839ce348 = `${$ff63b09d5a67ee89$export$df7774a415710cce}${$ff63b09d5a67ee89$export$3193d714ab54ee26}`;

});

parcelRegister("A82xh", function(module, exports) {
$parcel$export(module.exports, "fetchModules", () => $e5591989ed7509da$export$24d8e11b15325c53);

var $7BEjM = parcelRequire("7BEjM");

var $n67Vb = parcelRequire("n67Vb");

var $0Us5k = parcelRequire("0Us5k");

var $l64dz = parcelRequire("l64dz");

var $lz4O3 = parcelRequire("lz4O3");

var $5iMdl = parcelRequire("5iMdl");

var $aHmTX = parcelRequire("aHmTX");

var $aI7em = parcelRequire("aI7em");

var $4wDMb = parcelRequire("4wDMb");

var $5UxXz = parcelRequire("5UxXz");

var $bh8EG = parcelRequire("bh8EG");
const $e5591989ed7509da$export$24d8e11b15325c53 = async (params)=>{
    const { types: types, cloudId: cloudId, isAnonymous: isAnonymous, source: source = (0, $aHmTX.SOURCE_UNKNOWN) } = params;
    if (!(0, $4wDMb.canFetchForgeModules)({
        cloudId: cloudId,
        isAnonymous: isAnonymous
    })) return (0, $5UxXz.toMappedExtensions)(types, []);
    try {
        const extensions = await (0, $l64dz.measureExecutionTimeMetrics)(()=>$e5591989ed7509da$export$9f9fdbce0829073d(params));
        if (Math.random() * 100 < (0, $lz4O3.FORGE_SAMPLING_RATE)) (0, $5iMdl.fireInitializationFetchFinishedEvent)(source);
        return (0, $5UxXz.toMappedExtensions)(types, extensions);
    } catch (error) {
        const errorType = (0, $0Us5k.getErrorType)(error);
        (0, $5iMdl.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        if ($e5591989ed7509da$export$458cbcb6374269d2.includes(errorType)) return (0, $5UxXz.toMappedExtensions)(types, []);
        throw error;
    }
};
function $e5591989ed7509da$export$9f9fdbce0829073d(props) {
    // includeScopes is true by default to enable decoupling scopes from forge app
    const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = true } = props;
    if (types.length === 0) throw new Error('No modules to fetch provided');
    const operationName = (0, $7BEjM.default).params.name;
    const { stopGraphQLErrorTracking: stopGraphQLErrorTracking, getGraphQLError: getGraphQLError } = (0, $bh8EG.trackGraphQLErrors)(operationName);
    let extensions;
    return new Promise((resolve, reject)=>{
        const subscription = (0, $n67Vb.fetchQuery)((0, $aI7em.default)(), /* eslint-disable @atlassian/relay/unused-fields */ (0, $7BEjM.default), /* eslint-enable @atlassian/relay/unused-fields */ {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden,
            includeScopes: includeScopes
        }).subscribe({
            next: (response)=>{
                stopGraphQLErrorTracking();
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const responseExtensions = response.jira?.forge?.extensions;
                extensions = responseExtensions?.concat().map((ext)=>({
                        ...ext,
                        moduleId: ext.moduleId ?? null
                    })) || null;
            },
            error: (error)=>{
                stopGraphQLErrorTracking();
                reject(error);
                subscription.unsubscribe();
            },
            complete: ()=>{
                // If there is a GraphQL error and extensions are `null`, it means a critical error has happened, and we have to reject the promise.
                // However, if the list of extensions is present in the response, it shouldn't be considered an error.
                const graphQLError = getGraphQLError();
                if (graphQLError) extensions != null ? resolve(extensions || []) : reject(graphQLError);
                else resolve(extensions || []);
                subscription.unsubscribe();
            }
        });
    });
}
const $e5591989ed7509da$export$458cbcb6374269d2 = [
    (0, $0Us5k.FAILED_TO_FETCH),
    (0, $0Us5k.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $0Us5k.DATA_CLASSIFICATION_NO_ACCESS)
];

});
parcelRegister("7BEjM", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c405c00ed2ad545$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9cb9fc7f62f506f9cf4cd4db01ae3f8>>
 * @relayHash 8383cbbd005e5e1490a936a0bd3be323
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ad70478e3f5086c7ec25ad7789c1120e0d47807a62ed2bf0cd99feab932f4845
const $6c405c00ed2ad545$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeHidden"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeScopes"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "types"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraForgeQuery",
                    "kind": "LinkedField",
                    "name": "forge",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "context"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeHidden",
                                    "variableName": "includeHidden"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "types",
                                    "variableName": "types"
                                }
                            ],
                            "concreteType": "JiraForgeExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                {
                                    "condition": "includeHidden",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeScopes",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        }
                                    ]
                                },
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "installationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "appVersion"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "consentUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "properties"
                                },
                                {
                                    "concreteType": "JiraUserAppAccess",
                                    "kind": "LinkedField",
                                    "name": "userAccess",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasAccess"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeAppEgressDeclaration",
                                    "kind": "LinkedField",
                                    "name": "egress",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "addresses"
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "inScopeEUD"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeInstallationConfigExtension",
                                    "kind": "LinkedField",
                                    "name": "installationConfig",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeExtensionLicense",
                                    "kind": "LinkedField",
                                    "name": "license",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "active"
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "supportEntitlementNumber"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "trialEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "subscriptionEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEvaluation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "billingPeriod"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementSlug"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "capabilitySet"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "doFetchWithGraphQLErrorsTrackingQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "doFetchWithGraphQLErrorsTrackingQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "id": "ad70478e3f5086c7ec25ad7789c1120e0d47807a62ed2bf0cd99feab932f4845",
            "metadata": {},
            "name": "doFetchWithGraphQLErrorsTrackingQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6c405c00ed2ad545$var$node.hash = "288e42a4ff5a1ea53eaacf3efbacf31a";
var $6c405c00ed2ad545$export$2e2bcd8739ae039 = $6c405c00ed2ad545$var$node;

});

parcelRegister("0Us5k", function(module, exports) {
$parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", () => $cce82b8ad97a481b$export$23de3198bfe70090);
$parcel$export(module.exports, "FAILED_TO_FETCH", () => $cce82b8ad97a481b$export$f52aa41ccd776f01);
$parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", () => $cce82b8ad97a481b$export$31d2ab0be67934f0);
$parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", () => $cce82b8ad97a481b$export$89a175d4190df42e);
$parcel$export(module.exports, "userConsentErrorRegex", () => $cce82b8ad97a481b$export$dddade71b333c01d);
$parcel$export(module.exports, "getErrorType", () => $cce82b8ad97a481b$export$e19f9f08a6d79fd2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $lCetP = parcelRequire("lCetP");

var $flXCN = parcelRequire("flXCN");

var $8dImz = parcelRequire("8dImz");
const $cce82b8ad97a481b$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $cce82b8ad97a481b$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $cce82b8ad97a481b$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $cce82b8ad97a481b$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $cce82b8ad97a481b$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $cce82b8ad97a481b$export$89a175d4190df42e = 'Invoke value functions failed:';
const $cce82b8ad97a481b$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $cce82b8ad97a481b$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if ((0, $8dImz.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $cce82b8ad97a481b$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $cce82b8ad97a481b$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    // Tracked GraphQL errors contain useful info about internal errors like status codes
    // We want to categorize them more precisely, because some error types aren't SLO critical.
    if (error instanceof (0, $flXCN.TrackedGraphQLError)) {
        if (error.statusCode && error.statusCode >= 400) return error.statusCode === 429 ? $cce82b8ad97a481b$export$7a1bd8c001e7e9c : `ERROR_SERVER_RESPONSE_${error.statusCode}`;
        return 'TRACKED_GRAPHQL_ERROR';
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $cce82b8ad97a481b$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.') || /Extension ".*" could not be invoked as it does not reference a function or an endpoint/i.test(message)) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($cce82b8ad97a481b$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($cce82b8ad97a481b$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $8f860a533cc71fca$export$9de493bcd9b1d977);
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $8f860a533cc71fca$export$fa405bbf47d510e2);
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
   * 	Whole message:
   *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
   */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
   * 	Whole message:
   *	Invoke value functions failed: Error server response: 429
   */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $cce82b8ad97a481b$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($cce82b8ad97a481b$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    if (isTimeoutError('NAVIGATION_SIDEBAR_JIRA_PROJECT')) return 'TIMEOUT_NAVIGATION_SIDEBAR_JIRA_PROJECT';
    const entry = Object.entries($cce82b8ad97a481b$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $lCetP.isClientFetchError)(error)) return $cce82b8ad97a481b$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("flXCN", function(module, exports) {
$parcel$export(module.exports, "TrackedGraphQLError", () => $c42fe2021078d22a$export$f2062ad173e74c75);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ class $c42fe2021078d22a$export$f2062ad173e74c75 extends Error {
    constructor(errorMessage, errors, traceIds){
        super(errorMessage), this.errorMessage = errorMessage, this.errors = errors, this.traceIds = traceIds;
        this.errors = errors;
        // Get first trace id
        this.traceId = traceIds?.[0];
        // Get first status code
        this.statusCode = errors?.map((graphQLError)=>graphQLError && 'extensions' in graphQLError ? graphQLError?.extensions?.statusCode : null).filter(Boolean)?.[0];
        // Combine error messages
        this.message = errors?.map((graphQLError)=>graphQLError?.message).filter(Boolean).join('; ') ?? errorMessage;
    }
}
$c42fe2021078d22a$export$f2062ad173e74c75.displayName = "TrackedGraphQLError";

});


parcelRegister("l64dz", function(module, exports) {
$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $f21e4601dfeeea0e$export$a859f6866f4653e0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7TA2J = parcelRequire("7TA2J");

var $lz4O3 = parcelRequire("lz4O3");

var $82B9c = parcelRequire("82B9c");
const $f21e4601dfeeea0e$export$a859f6866f4653e0 = async (action)=>{
    const concurrentId = (0, $7TA2J.v4)();
    const shouldSendTimeMetric = Math.random() * 100 < (0, $lz4O3.FORGE_SAMPLING_RATE);
    try {
        if (shouldSendTimeMetric) (0, $82B9c.forgeModulesConcurrentFetchTime)(concurrentId).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $82B9c.forgeModulesConcurrentFetchTime)(concurrentId).stop({
            stopTime: performance.now()
        });
        return result;
    } catch (error) {
        if (shouldSendTimeMetric) (0, $82B9c.forgeModulesConcurrentFetchTime)(concurrentId).cancel();
        throw error;
    }
};

});
parcelRegister("lz4O3", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $4c397319c2eeae2d$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_TRIGGER", () => $4c397319c2eeae2d$export$ed63b053e04e26df);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $4c397319c2eeae2d$export$725bacc669333eef);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $4c397319c2eeae2d$export$d920cee73ec094d0);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $4c397319c2eeae2d$export$f048d91ccaf92408);
$parcel$export(module.exports, "UI_ACTIONS", () => $4c397319c2eeae2d$export$2b7367f125154866);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $4c397319c2eeae2d$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $4c397319c2eeae2d$export$2af0438304d7c4b2);
/* eslint-disable jira/filename-case */ // TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
const $4c397319c2eeae2d$export$f892f621fb508154 = 'jiraForgeUi';
const $4c397319c2eeae2d$export$273f5980517336e2 = 'jiraforgeui';
const $4c397319c2eeae2d$export$ed63b053e04e26df = 'trigger';
const $4c397319c2eeae2d$export$725bacc669333eef = 'extension';
const $4c397319c2eeae2d$export$d920cee73ec094d0 = 10;
const $4c397319c2eeae2d$export$f048d91ccaf92408 = {
    FORGE_MODULES: {
        FETCH_TIME: `${$4c397319c2eeae2d$export$273f5980517336e2}.forge-modules.fetch-time`,
        LOAD_TIME: `${$4c397319c2eeae2d$export$273f5980517336e2}.forge-modules.load-time`
    },
    REAL_TIME_ISSUE_EVENTS: {
        INVOKE_TIME: `${$4c397319c2eeae2d$export$273f5980517336e2}.real-time-issue-events.invoke-time`
    },
    MARKS: {
        TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
        TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
    }
};
const $4c397319c2eeae2d$export$2b7367f125154866 = {
    CLICKED: 'clicked',
    SELECTED: 'selected',
    CANCELED: 'canceled',
    ACTION_CLICKED: 'action clicked',
    COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
    PIN_UNPIN_CLICKED: 'pin-unpin clicked',
    REMOVE_CLICKED: 'remove clicked'
};
const $4c397319c2eeae2d$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    SUCCEEDED: 'succeeded',
    CALLED: 'called',
    INITIALIZED: 'initialized',
    EDIT_FAILED: 'edit failed',
    ACTION_FAILED: 'action failed',
    SAVE_FAILED: 'save failed',
    REMOVE_FAILED: 'remove failed',
    UPDATE_FAILED: 'update failed'
};
const $4c397319c2eeae2d$export$2af0438304d7c4b2 = {
    EDITED: 'edited',
    SAVED: 'saved',
    REMOVED: 'removed',
    ACTION_SUCCEED: 'action succeed',
    UPDATE_SUCCEED: 'update succeed'
};

});

parcelRegister("82B9c", function(module, exports) {
$parcel$export(module.exports, "forgeModulesConcurrentFetchTime", () => $3864647873529089$export$c3d8833fbea3e976);
$parcel$export(module.exports, "forgeModulesConcurrentLoadTime", () => $3864647873529089$export$292f3b557281044f);
$parcel$export(module.exports, "realTimeIssueEventInvokeTime", () => $3864647873529089$export$89ace7e2bb7d7685);
$parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", () => $3864647873529089$export$94f65f3b2556df23);
$parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", () => $3864647873529089$export$116d5e25caf0018d);
$parcel$export(module.exports, "customFieldPageSegmentLoadMetric", () => $3864647873529089$export$3bd38623c2543fc0);
$parcel$export(module.exports, "customFieldInteractionMetric", () => $3864647873529089$export$a318f99472db73c8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jvGCa = parcelRequire("jvGCa");

var $fDxFn = parcelRequire("fDxFn");

var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");

var $lz4O3 = parcelRequire("lz4O3");
const $3864647873529089$export$c3d8833fbea3e976 = (0, $jvGCa.metrics).concurrent.custom({
    key: (0, $lz4O3.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $3864647873529089$export$292f3b557281044f = (0, $jvGCa.metrics).concurrent.custom({
    key: (0, $lz4O3.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $3864647873529089$export$89ace7e2bb7d7685 = new (0, $jkqqC.UFOExperience)((0, $lz4O3.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
    type: (0, $ipvkO.ExperienceTypes).Experience,
    performanceType: (0, $ipvkO.ExperiencePerformanceTypes).InlineResult
});
async function $3864647873529089$export$94f65f3b2556df23(startMark, endMark, fn) {
    if (false || (0, $fDxFn.default).getEntriesByName(startMark).length > 0 || (0, $fDxFn.default).getEntriesByName(endMark).length > 0) return fn();
    (0, $fDxFn.default).mark(startMark);
    const result = await fn();
    (0, $fDxFn.default).mark(endMark);
    return result;
}
const $3864647873529089$export$116d5e25caf0018d = (metric, additionalTimings)=>{
    additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
            ...(0, $fDxFn.default).getEntriesByName(startMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: cleanStart,
                    cleanEnd: undefined
                })),
            ...(0, $fDxFn.default).getEntriesByName(endMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: undefined,
                    cleanEnd: cleanEnd
                }))
        ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
        metric.mark(name, startTime);
        if (cleanStart || cleanEnd) (0, $fDxFn.default).clearMarks(name);
    });
};
const $3864647873529089$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $jvGCa.metrics).pageSegmentLoad({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings,
            {
                key: 'tti',
                startMark: (0, $lz4O3.PERFORMANCE_KEYS).MARKS.TTI_START,
                endMark: (0, $lz4O3.PERFORMANCE_KEYS).MARKS.TTI_END
            }
        ]
    });
const $3864647873529089$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $jvGCa.metrics).interaction({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings
        ]
    });

});


parcelRegister("5iMdl", function(module, exports) {
$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $4049f1dfc8f58584$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $4049f1dfc8f58584$export$b5ca88b1053f1ad0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aoZbr = parcelRequire("aoZbr");

var $cXwmT = parcelRequire("cXwmT");
const $4049f1dfc8f58584$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $4049f1dfc8f58584$export$917d0643b0111a02 = (0, $aoZbr.toEventId)('issueViewInitialization');
const $4049f1dfc8f58584$export$43e875fd63e64525 = (0, $aoZbr.toEventId)('fetchModulesInitialization');
const $4049f1dfc8f58584$export$132ca822850e455f = (source, attributes)=>(0, $cXwmT.fireInitializationEvent)($4049f1dfc8f58584$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $4049f1dfc8f58584$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $4049f1dfc8f58584$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $cXwmT.fireInitializationEvent)($4049f1dfc8f58584$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $4049f1dfc8f58584$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $4049f1dfc8f58584$export$e914f7df1e4ad79b = (source, attributes)=>(0, $cXwmT.fireInitializationEvent)($4049f1dfc8f58584$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $4049f1dfc8f58584$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $4049f1dfc8f58584$export$b274c658390b491b = (source, attributes)=>(0, $cXwmT.fireInitializationEvent)($4049f1dfc8f58584$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $4049f1dfc8f58584$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});
parcelRegister("aoZbr", function(module, exports) {
$parcel$export(module.exports, "toEventId", () => $4bc9fc24c90d436b$export$75e84ef5a3771f9a);
/* eslint-disable jira/filename-case */ const $4bc9fc24c90d436b$export$75e84ef5a3771f9a = (value)=>value;

});

parcelRegister("cXwmT", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $9426bcbfbb8cc76e$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireUiEvent", () => $9426bcbfbb8cc76e$export$bed7f228c94e5f2a);
$parcel$export(module.exports, "fireTrackEvent", () => $9426bcbfbb8cc76e$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $9426bcbfbb8cc76e$export$390a62413962e4f0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6Kdw4 = parcelRequire("6Kdw4");

var $lz4O3 = parcelRequire("lz4O3");

var $9x0Ea = parcelRequire("9x0Ea");

var $4gbkQ = parcelRequire("4gbkQ");

var $3gu1w = parcelRequire("3gu1w");
const $9426bcbfbb8cc76e$var$createAnalyticsProps = ({ id: id, source: // Since source is required in sendOperationalEvent and sendUIEvent we need to pass here a fallback
// in case source is not provided
source = 'unknownSource', action: action, attributes: attributes })=>({
        actionSubject: `${0, $lz4O3.PACKAGE_NAME_GASV3}.${id}`,
        attributes: (0, $9x0Ea.createAttributes)(attributes),
        source: source,
        action: action
    });
const $9426bcbfbb8cc76e$var$getAnalyticsClient = async ()=>(await (0, $6Kdw4.getAnalyticsWebClientPromise)()).getInstance();
const $9426bcbfbb8cc76e$var$sendOperationalEvent = async (props)=>(await $9426bcbfbb8cc76e$var$getAnalyticsClient()).sendOperationalEvent($9426bcbfbb8cc76e$var$createAnalyticsProps(props));
const $9426bcbfbb8cc76e$var$sendUiEvent = async (props)=>(await $9426bcbfbb8cc76e$var$getAnalyticsClient()).sendUIEvent($9426bcbfbb8cc76e$var$createAnalyticsProps(props));
const $9426bcbfbb8cc76e$var$sendTrackEvent = async (props)=>(await $9426bcbfbb8cc76e$var$getAnalyticsClient()).sendTrackEvent($9426bcbfbb8cc76e$var$createAnalyticsProps(props));
const $9426bcbfbb8cc76e$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$9426bcbfbb8cc76e$var$sendOperationalEvent({
        ...eventProps,
        source: (0, $9x0Ea.parseSource)(source),
        action: action
    });
const $9426bcbfbb8cc76e$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$9426bcbfbb8cc76e$var$sendUiEvent({
        ...eventProps,
        source: (0, $9x0Ea.parseSource)(source),
        action: action
    });
const $9426bcbfbb8cc76e$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$9426bcbfbb8cc76e$var$sendTrackEvent({
        ...eventProps,
        source: (0, $9x0Ea.parseSource)(source),
        action: action
    });
const $9426bcbfbb8cc76e$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
        $9426bcbfbb8cc76e$export$a1fb57756f0de62b(action, {
            id: id,
            attributes: attributes,
            source: source
        }),
        attributes?.error && (0, $4gbkQ.logError)((0, $4gbkQ.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $3gu1w.isSynthetic)().toString()}, id=${id}, source=${(0, $9x0Ea.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
    ]);

});
parcelRegister("9x0Ea", function(module, exports) {
$parcel$export(module.exports, "parseSource", () => $cff89dbd60a53710$export$e98201ef9a88ba70);
$parcel$export(module.exports, "createAttributes", () => $cff89dbd60a53710$export$c7c9603a6b1fd815);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5dNz8 = parcelRequire("5dNz8");

var $6bEm8 = parcelRequire("6bEm8");

var $7YQ9C = parcelRequire("7YQ9C");

var $0Us5k = parcelRequire("0Us5k");

var $3gu1w = parcelRequire("3gu1w");
const $cff89dbd60a53710$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
const $cff89dbd60a53710$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $cff89dbd60a53710$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: (0, $3gu1w.isSynthetic)(),
        isOverridingFragments: (0, $7YQ9C.isOverridingFragments)(),
        isSSR: false,
        shard: (0, $6bEm8.default)('ajs-shard') || '',
        region: (0, $6bEm8.default)('ajs-region') || ''
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = $cff89dbd60a53710$export$e98201ef9a88ba70(source);
        if (error) {
            attributes.error = $cff89dbd60a53710$export$78c6267359db7e73(error);
            attributes.errorType = (0, $0Us5k.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($5dNz8)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});
parcelRegister("5dNz8", function(module, exports) {

var $3zZZC = parcelRequire("3zZZC");

var $czB45 = parcelRequire("czB45");
/** `Object#toString` result references. */ var $3cd49d585e6c4841$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $3cd49d585e6c4841$var$isBoolean(value) {
    return value === true || value === false || $czB45(value) && $3zZZC(value) == $3cd49d585e6c4841$var$boolTag;
}
module.exports = $3cd49d585e6c4841$var$isBoolean;

});

parcelRegister("7YQ9C", function(module, exports) {
$parcel$export(module.exports, "isOverridingFragments", () => $be4c523d0fe4caf2$export$1d1321d2b374d697);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $be4c523d0fe4caf2$export$1d1321d2b374d697 = ()=>{
    const re = /^(JF-TEST|MRJF-BB(\d+)?-\d+)$/;
    const buildKey = typeof window !== 'undefined' ? window?.BUILD_KEY : globalThis?.BUILD_KEY;
    return buildKey ? re.test(buildKey) : false;
};

});

parcelRegister("3gu1w", function(module, exports) {
$parcel$export(module.exports, "isSynthetic", () => $4e277eb3950a6435$export$947749d756ccb0a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i860n = parcelRequire("i860n");

var $6bEm8 = parcelRequire("6bEm8");
const $4e277eb3950a6435$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $6bEm8.default)('ajs-is-synthetic') === 'true' || (0, $i860n.fg)('forge_ui_synthetic_check');

});


parcelRegister("4gbkQ", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_UTIL", () => $653d8bdb0a683163$export$d1e4f308040bb0d5);
$parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", () => $653d8bdb0a683163$export$36f315a5c6daf40b);
$parcel$export(module.exports, "logError", () => $653d8bdb0a683163$export$58da9968c3170cb1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6CfY5 = parcelRequire("6CfY5");

var $lz4O3 = parcelRequire("lz4O3");
const $653d8bdb0a683163$export$e31edcd35abe3bb1 = 'environment-mapping';
const $653d8bdb0a683163$export$d1e4f308040bb0d5 = 'analytics';
const $653d8bdb0a683163$export$36f315a5c6daf40b = 'custom-field-object-type';
const $653d8bdb0a683163$export$6ee8198f29fffdb4 = {
    [$653d8bdb0a683163$export$d1e4f308040bb0d5]: `${(0, $lz4O3.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
    [$653d8bdb0a683163$export$e31edcd35abe3bb1]: `${(0, $lz4O3.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
    [$653d8bdb0a683163$export$36f315a5c6daf40b]: `${(0, $lz4O3.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
};
const $653d8bdb0a683163$export$58da9968c3170cb1 = (key, message, event)=>{
    (0, $6CfY5.default).safeErrorWithoutCustomerData($653d8bdb0a683163$export$6ee8198f29fffdb4[key], message, event);
};

});



parcelRegister("4wDMb", function(module, exports) {
$parcel$export(module.exports, "canFetchForgeModules", () => $2ca4c69ee06ae886$export$bb3a4a3b8e654c08);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i860n = parcelRequire("i860n");
const $2ca4c69ee06ae886$export$bb3a4a3b8e654c08 = ({ isAnonymous: isAnonymous, cloudId: cloudId })=>{
    /**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */ if (String(cloudId) === 'bob') return false;
    /**
	 * Similarly to the `bob` tenant situation above, we don't want to fetch Forge modules on monolith webdriver tests,
	 * that are also started with `./jmake run ci`, but this time with a valid `cloudId`.
	 * The reason for that is the heartbeat service that is not available in there, which leads to the login page redirects.
	 */ if (!false && $2ca4c69ee06ae886$export$489a82a1efc4cd04().endsWith('.atl-test.space')) return false;
    // Allow anonymous access for Forge modules when the respective feature gate is enabled
    if (isAnonymous && ((0, $i860n.fg)('forge_anonymous_access_for_jira_custom_fields') || (0, $i860n.fg)('forge_anonymous_access_for_jira_issue_panels'))) return true;
    // There is no anonymous access for now
    return !isAnonymous;
};
const $2ca4c69ee06ae886$export$489a82a1efc4cd04 = ()=>window.location.hostname;

});

parcelRegister("5UxXz", function(module, exports) {
$parcel$export(module.exports, "toMappedExtensions", () => $b01c395d3d666b25$export$e073e0c0d1c23345);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ function $b01c395d3d666b25$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
    const result = Object.fromEntries(requestedModules.map((type)=>[
            type,
            []
        ]));
    const extensions = $b01c395d3d666b25$export$acd8ca2c14bd2aa4(returnedExtensions);
    extensions.forEach((extension)=>{
        result[extension.type]?.push(extension);
    });
    // There is no better way to work this out and preserve a generic object response
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return result;
}
function $b01c395d3d666b25$export$acd8ca2c14bd2aa4(extensions) {
    return extensions.map(({ moduleId: moduleId, ...rest })=>({
            ...rest,
            id: moduleId ?? rest.id.replace(/-+\d+$/, ''),
            moduleId: moduleId
        }));
}

});

parcelRegister("bh8EG", function(module, exports) {
$parcel$export(module.exports, "trackGraphQLErrors", () => $62ec1cd3678f149b$export$a5c00ff206a4c88b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lMoch = parcelRequire("lMoch");

var $flXCN = parcelRequire("flXCN");

var $511Fu = parcelRequire("511Fu");
function $62ec1cd3678f149b$export$a5c00ff206a4c88b(operationName) {
    const queryId = (0, $lMoch.startCaptureGraphQlErrors)();
    (0, $511Fu.startCapturingTraceIds)(operationName);
    return {
        stopGraphQLErrorTracking: ()=>(0, $511Fu.stopCapturingTraceIds)(operationName),
        getGraphQLError: ()=>$62ec1cd3678f149b$var$getGraphQLError(queryId, operationName)
    };
}
function $62ec1cd3678f149b$var$getGraphQLError(key, operationName) {
    const errors = (0, $lMoch.stopCaptureGraphQlErrors)(key).filter((errorWrapper)=>errorWrapper.meta.operationName === operationName).flatMap((errorWrapper)=>errorWrapper.errors);
    if (errors.length) return new (0, $flXCN.TrackedGraphQLError)(`Query ${operationName} had graphql errors`, errors, (0, $511Fu.getTraceIds)(operationName));
    return undefined;
}

});


parcelRegister("aaubd", function(module, exports) {
$parcel$export(module.exports, "uniqueExtensionsFilter", () => $c54033b9af986964$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $c54033b9af986964$export$1eefd1d9cde49fd5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $gpG7K = parcelRequire("gpG7K");

var $awsUf = parcelRequire("awsUf");
const $c54033b9af986964$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($gpG7K)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $awsUf.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $c54033b9af986964$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    return [
        ...$c54033b9af986964$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
        ...$c54033b9af986964$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
        ...$c54033b9af986964$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
    ];
};

});
parcelRegister("gpG7K", function(module, exports) {

var $9JUaE = parcelRequire("9JUaE");

var $8pFpK = parcelRequire("8pFpK");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $bf2fa8141aa269a6$var$uniqBy(array, iteratee) {
    return array && array.length ? $8pFpK(array, $9JUaE(iteratee, 2)) : [];
}
module.exports = $bf2fa8141aa269a6$var$uniqBy;

});

parcelRegister("awsUf", function(module, exports) {
$parcel$export(module.exports, "parseExtensionId", () => $c9f84a4e2699e41c$export$bae42cbaf7fa3e1b);
$parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", () => $c9f84a4e2699e41c$export$a92b17288693d366);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $c9f84a4e2699e41c$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const [, appId, envId] = extensionId.split('/');
    return {
        appId: appId,
        envId: envId
    };
};
const $c9f84a4e2699e41c$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');

});



parcelRegister("9O6SX", function(module, exports) {
$parcel$export(module.exports, "navPlatformRootStateResource", () => $d4b8ce19e56fdc95$export$68f863693687087c);

var $htsFl = parcelRequire("htsFl");

var $2NSbF = parcelRequire("2NSbF");

var $1hxzM = parcelRequire("1hxzM");

var $2tave = parcelRequire("2tave");
const $d4b8ce19e56fdc95$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM = 'NAV_PLATFORM_SIDEBAR_UI_STATE';
const $d4b8ce19e56fdc95$export$68f863693687087c = (0, $htsFl.createRelayResource)({
    type: $d4b8ce19e56fdc95$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM,
    // Anonymous users must not trigger this GSN GraphQL query. Use the
    // resource-level `skip` predicate so `loadQuery` is never invoked for them —
    // `getQuery` will not run when `skip` returns `true`.
    skip: (_, { tenantContext: { isAnonymous: isAnonymous } })=>{
        return isAnonymous;
    },
    getQuery: (_, { tenantContext: { activationId: activationId, atlassianAccountId: atlassianAccountId, cloudId: cloudId } })=>{
        return {
            parameters: (0, $2tave.default),
            variables: {
                navPlatSidebarDataEntityAri: (0, $1hxzM.buildNavigationAriForSidebarData)({
                    activationId: activationId,
                    firstPartyApp: 'jira',
                    siteId: cloudId
                }),
                ownerAri: atlassianAccountId && (0, $2NSbF.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString(),
                isAnonymous: false
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    },
    isCritical: true
});

});
parcelRegister("2tave", function(module, exports) {
$parcel$export(module.exports, "default", () => $41ac12933a01fd94$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e5ef89a2a2823b6f1e3708daa8547fe2>>
 * @relayHash e24a74e08fc090b4efa5675eb1650a9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29370c9da22d47da3e920ab70da55f287e06357d65fcb8cfbf0e1674d867cd4d
const $41ac12933a01fd94$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "navPlatSidebarDataEntityAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "navPlatSidebarDataEntityAri"
        },
        {
            "kind": "Variable",
            "name": "ownerAri",
            "variableName": "ownerAri"
        }
    ], v4 = {
        "concreteType": "SettingsDisplayPropertyConnection",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsDisplayProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "LayoutManagerQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "navPlatSidebarData",
                            "args": v3 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "LayoutManagerQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": "navPlatSidebarData",
                            "args": v3 /*: any*/ ,
                            "concreteType": "SettingsNavigationCustomisation",
                            "kind": "LinkedField",
                            "name": "settings_navigationCustomisation",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "29370c9da22d47da3e920ab70da55f287e06357d65fcb8cfbf0e1674d867cd4d",
            "metadata": {},
            "name": "LayoutManagerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$41ac12933a01fd94$var$node.hash = "461831cc5edab2101d4bf2283d2c5fcf";
var $41ac12933a01fd94$export$2e2bcd8739ae039 = $41ac12933a01fd94$var$node;

});


parcelRegister("lxP6a", function(module, exports) {
$parcel$export(module.exports, "getBannerResources", () => $80f1fc445c8fc0b5$export$cc6a6a8372f2ef22);
$parcel$export(module.exports, "getConditionalBannerResources", () => $80f1fc445c8fc0b5$export$9f10648ed76ae7f9);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import-whitelist

var $iV0kf = parcelRequire("iV0kf");

var $hDZQt = parcelRequire("hDZQt");

var $2VqX7 = parcelRequire("2VqX7");

var $8HUuJ = parcelRequire("8HUuJ");

var $i860n = parcelRequire("i860n");
const $80f1fc445c8fc0b5$export$cc6a6a8372f2ef22 = ()=>[
        (0, $hDZQt.getConsentBannerUserPreferencesResource)(),
        (0, $iV0kf.announcementBannerSettingsV4Resource),
        (0, $2VqX7.incomingMailServerExpiryStatusResource)
    ];
const $80f1fc445c8fc0b5$export$9f10648ed76ae7f9 = ()=>[
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('wi2-perf-banner-route-resource'), (0, $hDZQt.getConsentBannerUserPreferencesResource)()),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('wi2-perf-banner-route-resource'), (0, $iV0kf.announcementBannerSettingsV4Resource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('wi2-perf-banner-route-resource'), (0, $2VqX7.incomingMailServerExpiryStatusResource))
    ];

});
parcelRegister("iV0kf", function(module, exports) {
$parcel$export(module.exports, "announcementBannerSettingsV4Resource", () => $db114ff901bcaf1d$export$8fbe7f8de07afffd);
$parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", () => $db114ff901bcaf1d$export$6fb72f4a0c177494);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $hVpdC = parcelRequire("hVpdC");

var $ae0dQ = parcelRequire("ae0dQ");

var $bgRsZ = parcelRequire("bgRsZ");
function $db114ff901bcaf1d$export$190f48575cfcbb2e(isAnonymous, settings, hashIdLastDimissed) {
    if (isAnonymous || !settings?.isDismissable) return false;
    return settings?.hashId === hashIdLastDimissed;
}
const $db114ff901bcaf1d$var$announcementBannerSettingsResource = (0, $7edbf.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $ae0dQ.get)(),
            (0, $bgRsZ.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: $db114ff901bcaf1d$export$190f48575cfcbb2e(isAnonymous, settings, hashIdLastDimissed)
        };
    },
    maxAge: 900000
});
const $db114ff901bcaf1d$export$8fbe7f8de07afffd = (0, $7edbf.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $hVpdC.get)(),
            (0, $bgRsZ.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: $db114ff901bcaf1d$export$190f48575cfcbb2e(isAnonymous, settings, hashIdLastDimissed)
        };
    },
    maxAge: 900000,
    isCritical: true
});
const $db114ff901bcaf1d$export$43d4950a3e443fd3 = ()=>(0, $k6ufm.useResource)($db114ff901bcaf1d$var$announcementBannerSettingsResource);
const $db114ff901bcaf1d$export$6fb72f4a0c177494 = ()=>(0, $k6ufm.useResource)($db114ff901bcaf1d$export$8fbe7f8de07afffd);

});
parcelRegister("hVpdC", function(module, exports) {
$parcel$export(module.exports, "get", () => $d05f272c339b4774$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $d05f272c339b4774$export$adaa4cf7ef1b65be);

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");
const $d05f272c339b4774$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $h2wCv.performGetRequest)('/rest/internal/4/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            content: '',
            bgColor: 'grey',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'settingsV4Get',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $d05f272c339b4774$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $h2wCv.performPostRequest)('/rest/internal/4/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'settingsV4Set',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $d05f272c339b4774$export$4eb85e00a747e2c7 = {
    get: $d05f272c339b4774$export$3988ae62b71be9a3,
    set: $d05f272c339b4774$export$adaa4cf7ef1b65be
};

});

parcelRegister("ae0dQ", function(module, exports) {
$parcel$export(module.exports, "get", () => $e91d3062d0235a0d$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e91d3062d0235a0d$export$adaa4cf7ef1b65be);
/* eslint-disable jira/filename-case */ 
var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

const $e91d3062d0235a0d$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $h2wCv.performGetRequest)('/rest/internal/3/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            message: '',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $hFtK7.trackFetchErrors)({
            error: error,
            id: 'settingsGet',
            packageName: (0, $dfdeaef3480c99cf$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $e91d3062d0235a0d$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $h2wCv.performPostRequest)('/rest/internal/3/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.trackFetchErrors)({
            error: error,
            id: 'settingsSet',
            packageName: (0, $dfdeaef3480c99cf$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
const $dfdeaef3480c99cf$export$b8b9d90f9e5bd72b = '@jira/admin-pages__system-announcement-banner-resources';
const $dfdeaef3480c99cf$export$5e0c0e8c940630f8 = 'private';
const $dfdeaef3480c99cf$export$1d5a5b6462188eb3 = 'public';


parcelRegister("bgRsZ", function(module, exports) {
$parcel$export(module.exports, "get", () => $0116657701f3a327$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $0116657701f3a327$export$adaa4cf7ef1b65be);

var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");

const $0116657701f3a327$var$key = 'announcementBannerDismissedLast';
const $0116657701f3a327$export$3988ae62b71be9a3 = async (accoundId)=>{
    try {
        return accoundId != null ? (await (0, $kM0go.getUserProperty)(accoundId, $0116657701f3a327$var$key)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $hFtK7.trackFetchErrors)({
            error: error,
            id: 'userDismissGet',
            packageName: (0, $dfdeaef3480c99cf$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $0116657701f3a327$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
    try {
        return await (0, $kM0go.setUserProperties)(accoundId, $0116657701f3a327$var$key, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.trackFetchErrors)({
            error: error,
            id: 'userDismissSet',
            packageName: (0, $dfdeaef3480c99cf$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $0116657701f3a327$export$acb5b4af626ec776 = {
    get: $0116657701f3a327$export$3988ae62b71be9a3,
    set: $0116657701f3a327$export$adaa4cf7ef1b65be
};

});


parcelRegister("hDZQt", function(module, exports) {
$parcel$export(module.exports, "getConsentBannerUserPreferencesResource", () => $ef0eb8708b9f84a6$export$a40d52e504d1db7c);
$parcel$export(module.exports, "useConsentBannerUserPreferencesResource", () => $ef0eb8708b9f84a6$export$5bc7e83e85567fb4);

var $dJ3NQ = parcelRequire("dJ3NQ");

var $41FAq = parcelRequire("41FAq");

var $jOWFe = parcelRequire("jOWFe");

var $gXrrn = parcelRequire("gXrrn");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $2HuOR = parcelRequire("2HuOR");

const $ef0eb8708b9f84a6$var$consentBannerUserPreferencesResource = (0, $7edbf.createResource)({
    type: (0, $493cfa73c2f8856e$export$f0cdd7d2fbfd00ff),
    getKey: ()=>(0, $493cfa73c2f8856e$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $gXrrn.getCookie)((0, $jOWFe.ATLASSIAN_CONSENT_COOKIE_KEY), true);
        const fallbackConsentToken = (0, $gXrrn.getCookie)((0, $jOWFe.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), true);
        const shouldShowBannerBit = (0, $gXrrn.getCookie)((0, $jOWFe.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), true);
        const shouldShowBanner = shouldShowBannerBit !== undefined && shouldShowBannerBit !== null ? !!Number(shouldShowBannerBit) : undefined;
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if (consentToken) return {
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken,
            shouldShowBanner: shouldShowBanner
        };
        if (!(0, $41FAq.isFeatureEnabled)('consent-platform', 'consenthub')) return {};
        /**
		 * On server we need to request the api using a server to server api (atl-preferences-center-elb)
		 * otherwise the request will not be authenticated correctly.
		 *
		 * However Pillar does not support ASAP, so we need to use the client side api call in local development.
		 *
		 * See https://atlassian.slack.com/archives/C017Y3EPAQ4/p1754626460768439?thread_ts=1754601759.549879&cid=C017Y3EPAQ4
		 */ if (false && !(0, $dJ3NQ.default)()) {
            const userId = (0, $2HuOR.getAtlassianAccountId)();
            if (userId) {
                const data = await (0, $h2wCv.performGetRequest)(`/rest/user/${userId}/consents/cookies`, {
                    credentials: 'include',
                    headers: {
                        'x-ssr-service-name': 'atl-preferences-center'
                    }
                });
                return data;
            }
        }
        const data = await (0, $h2wCv.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: false,
    isCritical: true
});
const $ef0eb8708b9f84a6$export$a40d52e504d1db7c = ()=>$ef0eb8708b9f84a6$var$consentBannerUserPreferencesResource;
const $ef0eb8708b9f84a6$export$5bc7e83e85567fb4 = ()=>(0, $k6ufm.useResource)($ef0eb8708b9f84a6$export$a40d52e504d1db7c());

});
parcelRegister("gXrrn", function(module, exports) {
$parcel$export(module.exports, "getCookie", () => $24384ab96ef9de88$export$4be65e66cfa2648a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $37LBQ = parcelRequire("37LBQ");

var $gToGk = parcelRequire("gToGk");
function $24384ab96ef9de88$export$4be65e66cfa2648a(key, ssr) {
    if (false) {
        if (ssr) {
            if ((0, $gToGk.getSsrStatus)() === 'static') return key ? (0, $37LBQ.getCookie)(key) : undefined;
            // Defined here jira/src/entry-fs/utils/single-spa-route.tsx
            return globalThis?.__GET_COOKIE__?.(key);
        }
        return;
    }
    return key ? (0, $37LBQ.getCookie)(key) : (0, $37LBQ.getCookie)();
}

});

/* eslint-disable jira/filename-case */ const $493cfa73c2f8856e$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $493cfa73c2f8856e$export$f0cdd7d2fbfd00ff = 'CONSENT_BANNER_USER_PREFERENCES_SSR';
const $493cfa73c2f8856e$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';


parcelRegister("2VqX7", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_RESPONSE", () => $0477c8ac2607811a$export$32d9db53927095d3);
$parcel$export(module.exports, "incomingMailServerExpiryStatusResource", () => $0477c8ac2607811a$export$369caf52ed1ad2b1);
$parcel$export(module.exports, "useIncomingMailExpiryStatus", () => $0477c8ac2607811a$export$283aa034b7d4e2a0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

const $0477c8ac2607811a$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, $h2wCv.performGetRequest)((0, $319c00148020036c$export$5bf8eb915287f5f4));
const $0477c8ac2607811a$export$32d9db53927095d3 = {
    isAdmin: false,
    showBanner: true,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $0477c8ac2607811a$export$369caf52ed1ad2b1 = (0, $7edbf.createResource)({
    type: (0, $319c00148020036c$export$3b9494e0dfc4de09),
    getKey: ()=>(0, $319c00148020036c$export$f2f2f265ccc09f82),
    getData: async ()=>{
        let incomingMailServerExpiryStatus = null;
        try {
            incomingMailServerExpiryStatus = await $0477c8ac2607811a$var$fetchGetIncomingMailServerExpiryStatus();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'incomingMailServerExpiryStatus',
                    packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                    teamName: 'thor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $0477c8ac2607811a$export$32d9db53927095d3
        };
    },
    maxAge: 3600000,
    isCritical: true
});
const $0477c8ac2607811a$export$283aa034b7d4e2a0 = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $k6ufm.useResource)($0477c8ac2607811a$export$369caf52ed1ad2b1);
    const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $euxye.useState)(()=>{
        if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
        return $0477c8ac2607811a$export$32d9db53927095d3;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $euxye.useState)('not started');
    (0, $euxye.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.incomingMailServerExpiryStatus) {
            setResponseStatusGet('success');
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
            setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.incomingMailServerExpiryStatus
    ]);
    return {
        responseStatus: responseStatusGet,
        state: incomingMailServerExpiryStatus
    };
};

});
/* eslint-disable jira/filename-case */ const $319c00148020036c$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $319c00148020036c$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $319c00148020036c$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';




parcelRegister("3nqiL", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", () => $0aef75d81ac8a962$export$5519b86c9ea602e1);
/* eslint-disable import/order */ 

var $jEYuY = parcelRequire("jEYuY");

var $ju22D = parcelRequire("ju22D");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $gc1my = parcelRequire("gc1my");

var $iIyfF = parcelRequire("iIyfF");
const $0aef75d81ac8a962$export$5519b86c9ea602e1 = (0, $fdS54.createEntry)((0, $gc1my.globalSettingsIssuesExplicitFieldAssociationRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $iIyfF.LazyExplicitFieldsProjectListPage),
        forPaint: [
            (0, $jEYuY.LazyAtlassianNavigation),
            (0, $iIyfF.LazyExplicitFieldsProjectListPromise)
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
const $bffa4babd84e5355$export$f298f3c8b46adbeb = 'GLOBAL_ISSUES_SETTINGS';

parcelRegister("jEYuY", function(module, exports) {
$parcel$export(module.exports, "LazyAtlassianNavigation", () => $50d63b4e483e128d$export$4caed23aa0274abb);
/* eslint-disable jira/filename-case */ 
var $lhWE3 = parcelRequire("lhWE3");

var $iLktG = parcelRequire("iLktG");

var $l8G1z = parcelRequire("l8G1z");

const $50d63b4e483e128d$export$4caed23aa0274abb = (0, $l8G1z.lazyForPaint)(()=>{
    const bundleReady = (parcelRequire("e5otd")).then(({ TopNavigation: TopNavigation })=>TopNavigation);
    if (!false) bundleReady.then(()=>{
        (0, $iLktG.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $lhWE3.JS_EVAL_START))) {
            (0, $iLktG.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/TopNavigation.tsx"
});

});
parcelRegister("iLktG", function(module, exports) {
$parcel$export(module.exports, "setInitialPageLoadTimingFromPerformanceMarks", () => $68817ce7e8900032$export$15ca6669ae356831);
$parcel$export(module.exports, "stopInitialPageLoadTimingFromPerformanceMarkStart", () => $68817ce7e8900032$export$ab75d59423c060f4);
$parcel$export(module.exports, "measureInitialPageLoadTiming", () => $68817ce7e8900032$export$e18462760bac553c);
$parcel$export(module.exports, "setProductBundleReadyForInitialRender", () => $68817ce7e8900032$export$de1b4cf109d9ab65);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $9dSZE = parcelRequire("9dSZE");

var $9yf7o = parcelRequire("9yf7o");
/**
 * `performance.measure` will throw if start/stop aren't set.
 *
 * This call sets a user-timing on the profiler timelines so we can see sections of the load.
 */ const $68817ce7e8900032$var$safeMeasure = (name, start, stop)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.measure(name, start, stop);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
    } catch (_err) {}
};
const $68817ce7e8900032$export$15ca6669ae356831 = (name, start, stop, cleanStart = false, cleanStop = false)=>{
    if (false) return;
    $68817ce7e8900032$var$safeMeasure(name, start, stop);
    (0, $9yf7o.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stop);
    (0, $9dSZE.addTimingFromPerformanceMark)(name, start, stop, cleanStart, cleanStop);
};
const $68817ce7e8900032$export$ab75d59423c060f4 = (name, start, cleanStart = false)=>{
    if (false) return;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(stopMark);
    $68817ce7e8900032$var$safeMeasure(name, start, stopMark);
    (0, $9yf7o.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stopMark);
    (0, $9dSZE.addTimingFromPerformanceMark)(name, start, stopMark, cleanStart, true);
};
const $68817ce7e8900032$export$e18462760bac553c = (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = fn();
    performance.mark(stopMark);
    $68817ce7e8900032$var$safeMeasure(name, startMark, stopMark);
    (0, $9yf7o.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $9dSZE.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $68817ce7e8900032$export$53038a2e9d597818 = async (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = await fn();
    performance.mark(stopMark);
    (0, $9yf7o.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $9dSZE.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $68817ce7e8900032$export$de1b4cf109d9ab65 = ()=>{
    if (false) return;
    $68817ce7e8900032$export$ab75d59423c060f4('product.bundle-ready', 'jira-spa.js:eval-stop');
};

});
parcelRegister("9dSZE", function(module, exports) {
$parcel$export(module.exports, "addTimingFromPerformanceMark", () => $a40b4fb087d923e9$export$758b9a33800fa436);
$parcel$export(module.exports, "getTimings", () => $a40b4fb087d923e9$export$6d488733a547304);
const $a40b4fb087d923e9$var$timings = [];
function $a40b4fb087d923e9$export$758b9a33800fa436(name, startMark, stopMark, cleanStart = false, cleanStop = false) {
    $a40b4fb087d923e9$var$timings.push({
        name: name,
        startMark: startMark,
        stopMark: stopMark,
        cleanStart: cleanStart,
        cleanStop: cleanStop
    });
}
function $a40b4fb087d923e9$export$6d488733a547304() {
    const reportedTimingsObj = {};
    $a40b4fb087d923e9$var$timings.forEach(({ name: name, startMark: startMark, stopMark: stopMark, cleanStart: cleanStart, cleanStop: cleanStop })=>{
        const startEntryList = performance.getEntriesByName(startMark);
        const stopEntryList = performance.getEntriesByName(stopMark);
        if (startEntryList?.length > 0 && stopEntryList?.length > 0) {
            const startEntry = startEntryList[startEntryList.length - 1];
            const stopEntry = stopEntryList[stopEntryList.length - 1];
            const { startTime: startTime } = startEntry;
            const duration = stopEntry.startTime - startTime;
            const timing = {
                startTime: Math.round(startTime),
                duration: Math.round(duration)
            };
            reportedTimingsObj[name] = timing;
        }
        if (cleanStart) performance.clearMarks(startMark);
        if (cleanStop) performance.clearMarks(stopMark);
    });
    return reportedTimingsObj;
}

});


parcelRegister("e5otd", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");

module.exports = Promise.all([
    (parcelRequire("gZgW8"))('navx_onboarding_universal_create_in_jira', function() {
        return Promise.all([
            $4cvLQ("27fFF")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("hJyTq")
        ]);
    }),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("1CBXu")
]).then(()=>parcelRequire('gCmql'));

});
parcelRegister("gZgW8", function(module, exports) {
"use strict";

var $li7pP = parcelRequire("li7pP");
var $c5df7b177d94760d$require$getBundleURL = $li7pP.getBundleURL;

var $96thM = parcelRequire("96thM");
var $c5df7b177d94760d$require$resolve = $96thM.resolve;
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            globalThis.__ATLASPACK_ERRORS = globalThis.__ATLASPACK_ERRORS || [];
            globalThis.__ATLASPACK_ERRORS.push(new Error(`Sync dependency fallback triggered for condition "${cond}": ${err.message}`));
            for (const id of fallback.i)fallback.l(new URL($c5df7b177d94760d$require$resolve(id), $c5df7b177d94760d$require$getBundleURL(id)).toString());
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});
parcelRegister("li7pP", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", () => $f80107ff082ec675$export$bdfd709ae4826697, (v) => $f80107ff082ec675$export$bdfd709ae4826697 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $f80107ff082ec675$export$5a759dc7a1cfb72a;
var $f80107ff082ec675$export$bdfd709ae4826697;
var $f80107ff082ec675$export$c9e73fbda7da57b6;
"use strict";
const $f80107ff082ec675$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $f80107ff082ec675$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $f80107ff082ec675$var$getBundleURLCached(id, inputError) {
    let value = $f80107ff082ec675$var$bundleURL[id];
    if (!value) {
        value = $f80107ff082ec675$var$getBundleURL(inputError);
        $f80107ff082ec675$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $f80107ff082ec675$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $f80107ff082ec675$var$getBundleURL(inputError) {
    try {
        throw inputError ?? new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($f80107ff082ec675$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $f80107ff082ec675$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $f80107ff082ec675$var$getOrigin(url) {
    return new URL(url).origin;
}
$f80107ff082ec675$export$5a759dc7a1cfb72a = $f80107ff082ec675$var$getOrigin;
$f80107ff082ec675$export$bdfd709ae4826697 = $f80107ff082ec675$var$getBundleURLCached;
$f80107ff082ec675$export$c9e73fbda7da57b6 = $f80107ff082ec675$var$getBaseURL;

});




parcelRegister("ju22D", function(module, exports) {
$parcel$export(module.exports, "globalSettingsLayout", () => $ee169f5a4b3d1877$export$e6aef6083548e882);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2tgz = parcelRequire("h2tgz");

var $QhQu4 = parcelRequire("QhQu4");
const $ee169f5a4b3d1877$export$e6aef6083548e882 = (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout));

});
parcelRegister("h2tgz", function(module, exports) {
$parcel$export(module.exports, "globalLayout", () => $35899f3de8992888$export$929cb72e7acb7fd9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $QhQu4 = parcelRequire("QhQu4");
const $35899f3de8992888$var$rightSidebars = ()=>[];
const $35899f3de8992888$export$929cb72e7acb7fd9 = (0, $QhQu4.createLayout)({
    rightSidebars: $35899f3de8992888$var$rightSidebars()
});

});
parcelRegister("QhQu4", function(module, exports) {
$parcel$export(module.exports, "renderGlobalComponents", () => $b6e10e5d03aa726e$export$fc28c9563350e5b8);
$parcel$export(module.exports, "createLayout", () => $b6e10e5d03aa726e$export$3dd437ade36ede40);
$parcel$export(module.exports, "preloadComponents", () => $b6e10e5d03aa726e$export$6ae808826fa58f6d);
$parcel$export(module.exports, "composeLayouts", () => $b6e10e5d03aa726e$export$6c041b39c370853f);
$parcel$export(module.exports, "withProjectContext", () => $b6e10e5d03aa726e$export$e97a7da67a5b8ce4);

var $euxye = parcelRequire("euxye");

var $dQn1l = parcelRequire("dQn1l");

var $XssJM = parcelRequire("XssJM");

var $a8EUd = parcelRequire("a8EUd");

var $bKPo4 = parcelRequire("bKPo4");
/**
 * @deprecated Unneeded, and complicates code readability as it's not a standard language method and therefore is unknown to most of developers.
 * Use `str || str2` instead of `coalesce(str) ?? str2`
 */ const $b6e10e5d03aa726e$var$coalesce = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
const $b6e10e5d03aa726e$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
        const { displayName: displayName, name: name } = Component;
        const placeholderName = ($b6e10e5d03aa726e$var$coalesce(displayName) ?? $b6e10e5d03aa726e$var$coalesce(name) ?? String(i)).replaceAll('/', '_');
        const key = (0, $dQn1l.uid)(Component);
        return(// TODO Only add suspense if lazy component, otherwise add suspense within component array
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
            name: String(placeholderName),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null),
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, null)));
    });
const $b6e10e5d03aa726e$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], preloadComponents: preloadComponents, isChromeless: isChromeless = false } = {})=>{
    const layout = {
        isChromeless: isChromeless,
        globalComponents: Array.from(new Set(globalComponents)),
        rightSidebars: Array.from(new Set(rightSidebars)),
        preloadComponents: Array.from(new Set(preloadComponents))
    };
    return layout;
};
const $b6e10e5d03aa726e$export$6ae808826fa58f6d = (layout)=>{
    layout.preloadComponents?.forEach((component)=>{
        component.preload?.();
    });
};
const $b6e10e5d03aa726e$export$6c041b39c370853f = (...layouts)=>{
    if (layouts.length === 1) return $b6e10e5d03aa726e$export$3dd437ade36ede40(layouts[0]);
    const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
            isChromeless: isChromeless,
            globalComponents: [
                ...l.globalComponents,
                ...globalComponents
            ],
            rightSidebars: [
                ...l.rightSidebars,
                ...rightSidebars
            ]
        }), {
        globalComponents: [],
        rightSidebars: [],
        isChromeless: false
    });
    return $b6e10e5d03aa726e$export$3dd437ade36ede40(layout);
};
const $b6e10e5d03aa726e$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $b6e10e5d03aa726e$var$formatPrefix = (style, type)=>{
    if (!style && !type) return 'Empty';
    if (style === 'any' && type === 'any') return 'Any';
    const formattedStyle = $b6e10e5d03aa726e$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
    if (type === 'any') return formattedStyle;
    const formattedType = $b6e10e5d03aa726e$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
    if (style === 'any') return formattedType;
    return `${formattedStyle}${formattedType}`;
};
const $b6e10e5d03aa726e$export$e97a7da67a5b8ce4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
Component, options)=>{
    const { project: expectedProject } = options;
    const ScopedComponent = ()=>{
        const { data: project, loading: loading } = (0, $XssJM.useProject)();
        if (loading) return null;
        if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, null);
    };
    const name = $b6e10e5d03aa726e$var$coalesce(Component.displayName) ?? $b6e10e5d03aa726e$var$coalesce(Component.name) ?? 'Component';
    const prefix = $b6e10e5d03aa726e$var$formatPrefix(expectedProject?.style, expectedProject?.type);
    ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
    return ScopedComponent;
};

});
parcelRegister("dQn1l", function(module, exports) {
$parcel$export(module.exports, "uid", () => $a141fd23a492e6bd$export$e2a22331486dcca0);
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $a141fd23a492e6bd$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-" + index : "val-" + item;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $a141fd23a492e6bd$export$e2a22331486dcca0 = $a141fd23a492e6bd$export$bdbb4cbb3078e58d();

});

parcelRegister("XssJM", function(module, exports) {
$parcel$export(module.exports, "useProject", () => $0efca82aea2045c9$export$51b1383ef8844a7);

var $e7boj = parcelRequire("e7boj");

var $4bRaD = parcelRequire("4bRaD");

var $8ANUF = parcelRequire("8ANUF");
const $0efca82aea2045c9$export$51b1383ef8844a7 = (customContext)=>{
    const $ = (0, $e7boj.c)(6);
    const { data: data, loading: loading, error: error } = (0, $8ANUF.useProjectSidebarNavigation)(customContext);
    let t0;
    if ($[0] !== data) {
        t0 = data && (0, $4bRaD.extractData)(data);
        $[0] = data;
        $[1] = t0;
    } else t0 = $[1];
    const project = t0;
    let t1;
    if ($[2] !== error || $[3] !== loading || $[4] !== project) {
        t1 = {
            data: project,
            loading: loading,
            error: error
        };
        $[2] = error;
        $[3] = loading;
        $[4] = project;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};

});
parcelRegister("4bRaD", function(module, exports) {
$parcel$export(module.exports, "getStyle", () => $2473348817a5d097$export$3d2f074408bd1b82);
$parcel$export(module.exports, "extractData", () => $2473348817a5d097$export$9df5fa0a366163d2);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");

var $i860n = parcelRequire("i860n");
const $2473348817a5d097$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $f99M0.ProjectStyle).NEXT_GEN : (0, $f99M0.ProjectStyle).CLASSIC;
const $2473348817a5d097$var$getProject = (project)=>({
        avatarUrl: project.avatarUrls['48x48'],
        id: Number(project.id),
        isSimplified: project.simplified,
        key: project.key,
        name: project.name,
        style: $2473348817a5d097$export$3d2f074408bd1b82(project.simplified),
        type: project.projectTypeKey,
        ...typeof project.isLiveTemplate === 'boolean' && (0, $i860n.fg)('jira_custom_templates_ux') && {
            isLiveTemplate: project.isLiveTemplate
        }
    });
const $2473348817a5d097$export$9df5fa0a366163d2 = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.project ? $2473348817a5d097$var$getProject(jiraWorkManagementNavData.project) : null;
        case 'jira_software':
            return jiraSoftwareNavData?.project ? $2473348817a5d097$var$getProject(jiraSoftwareNavData.project) : null;
        case 'jira_service_management':
        case 'jira_customer_service':
            return jiraServiceManagementNavData?.project ? $2473348817a5d097$var$getProject(jiraServiceManagementNavData.project) : null;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.project ? $2473348817a5d097$var$getProject(jiraProductDiscoveryNavData.project) : null;
        case null:
        default:
            return null;
    }
};

});
parcelRegister("f99M0", function(module, exports) {
$parcel$export(module.exports, "CORE_PROJECT", () => $d446c821a6c23064$export$4b79f735ed858abe);
$parcel$export(module.exports, "SOFTWARE_PROJECT", () => $d446c821a6c23064$export$417275bac62d38d2);
$parcel$export(module.exports, "SERVICE_DESK_PROJECT", () => $d446c821a6c23064$export$9c9c9eaf8c092006);
$parcel$export(module.exports, "CUSTOMER_SERVICE_PROJECT", () => $d446c821a6c23064$export$320625d747692f94);
$parcel$export(module.exports, "SERVICE_DESK_PROJECT_ANALYTICS", () => $d446c821a6c23064$export$d579a2a17bd742af);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_PROJECT", () => $d446c821a6c23064$export$e9fe9a39cc7f5103);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_CORE_PROJECT", () => $d446c821a6c23064$export$490d3686b662c315);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_SOFTWARE_PROJECT", () => $d446c821a6c23064$export$1242aa4e670b910e);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_SERVICE_DESK_PROJECT", () => $d446c821a6c23064$export$bb467c3bc8f8620e);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_CUSTOMER_SERVICE_PROJECT", () => $d446c821a6c23064$export$610dddac4d185bf8);
$parcel$export(module.exports, "JIRA_PROJECT_TYPE_PRODUCT_DISCOVERY_PROJECT", () => $d446c821a6c23064$export$76412127fb3089d6);
$parcel$export(module.exports, "JIRA_PROJECT_STATUS_ARCHIVED", () => $d446c821a6c23064$export$c02e05d1bee347e5);
$parcel$export(module.exports, "COMPANY_MANAGED_PROJECT", () => $d446c821a6c23064$export$6933c64814be01d9);
$parcel$export(module.exports, "TEAM_MANAGED_PROJECT", () => $d446c821a6c23064$export$e569d8a168a85f48);
$parcel$export(module.exports, "JIRA_PROJECT_TYPES", () => $d446c821a6c23064$export$be0978435d251eb);
$parcel$export(module.exports, "JIRA_PROJECT_STYLES", () => $d446c821a6c23064$export$caed6d9b39712cc7);
$parcel$export(module.exports, "ProjectStyle", () => $d446c821a6c23064$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "ProjectStyleCmpNotation", () => $d446c821a6c23064$export$bde8ccac2f23fd0f);
$parcel$export(module.exports, "PROJECT_TYPES", () => $d446c821a6c23064$export$9482030bf1904b0);
$parcel$export(module.exports, "toProjectType", () => $d446c821a6c23064$export$cfdcd9ead66e4329);
$parcel$export(module.exports, "convertToProjectType", () => $d446c821a6c23064$export$aa8444e79de3a8b6);
$parcel$export(module.exports, "convertToJiraProjectType", () => $d446c821a6c23064$export$5a8b6164d1baba87);
$parcel$export(module.exports, "toAnalyticsProjectType", () => $d446c821a6c23064$export$5afb6f76b5af0167);
$parcel$export(module.exports, "projectTypeToCanonicalId", () => $d446c821a6c23064$export$e25a1ee2478a61d6);
/* eslint-disable jira/filename-case */ 
var $74oEx = parcelRequire("74oEx");

var $8HVfB = parcelRequire("8HVfB");
const $d446c821a6c23064$export$4b79f735ed858abe = 'business';
const $d446c821a6c23064$export$417275bac62d38d2 = 'software';
const $d446c821a6c23064$export$9c9c9eaf8c092006 = 'service_desk';
const $d446c821a6c23064$export$320625d747692f94 = 'customer_service';
const $d446c821a6c23064$export$d579a2a17bd742af = 'serviceDesk';
const $d446c821a6c23064$export$e9fe9a39cc7f5103 = 'product_discovery';
const $d446c821a6c23064$export$490d3686b662c315 = 'BUSINESS';
const $d446c821a6c23064$export$1242aa4e670b910e = 'SOFTWARE';
const $d446c821a6c23064$export$bb467c3bc8f8620e = 'SERVICE_DESK';
const $d446c821a6c23064$export$610dddac4d185bf8 = 'CUSTOMER_SERVICE';
const $d446c821a6c23064$export$76412127fb3089d6 = 'PRODUCT_DISCOVERY';
const $d446c821a6c23064$export$1b784afd50592d26 = 'ACTIVE';
const $d446c821a6c23064$export$c02e05d1bee347e5 = 'ARCHIVED';
const $d446c821a6c23064$export$8b2d8efe30253ab3 = 'DELETED';
const $d446c821a6c23064$export$6933c64814be01d9 = 'COMPANY_MANAGED_PROJECT';
const $d446c821a6c23064$export$e569d8a168a85f48 = 'TEAM_MANAGED_PROJECT';
const $d446c821a6c23064$export$be0978435d251eb = {
    [$d446c821a6c23064$export$490d3686b662c315]: $d446c821a6c23064$export$490d3686b662c315,
    [$d446c821a6c23064$export$1242aa4e670b910e]: $d446c821a6c23064$export$1242aa4e670b910e,
    [$d446c821a6c23064$export$bb467c3bc8f8620e]: $d446c821a6c23064$export$bb467c3bc8f8620e,
    [$d446c821a6c23064$export$610dddac4d185bf8]: $d446c821a6c23064$export$610dddac4d185bf8,
    [$d446c821a6c23064$export$76412127fb3089d6]: $d446c821a6c23064$export$76412127fb3089d6
};
const $d446c821a6c23064$export$caed6d9b39712cc7 = {
    COMPANY_MANAGED_PROJECT: $d446c821a6c23064$export$6933c64814be01d9,
    TEAM_MANAGED_PROJECT: $d446c821a6c23064$export$e569d8a168a85f48
};
const $d446c821a6c23064$export$1f66f9f05afa05a8 = {
    CLASSIC: 'classic',
    NEXT_GEN: 'next-gen'
};
const $d446c821a6c23064$export$bde8ccac2f23fd0f = {
    COMPANY_MANAGED: 'companyManaged',
    TEAM_MANAGED: 'teamManaged'
};
const $d446c821a6c23064$export$9482030bf1904b0 = [
    $d446c821a6c23064$export$4b79f735ed858abe,
    $d446c821a6c23064$export$417275bac62d38d2,
    $d446c821a6c23064$export$9c9c9eaf8c092006,
    $d446c821a6c23064$export$320625d747692f94,
    $d446c821a6c23064$export$e9fe9a39cc7f5103
];
const $d446c821a6c23064$export$cfdcd9ead66e4329 = (value)=>$d446c821a6c23064$export$9482030bf1904b0.find((projectType)=>projectType === value);
function $d446c821a6c23064$export$aa8444e79de3a8b6(jiraProjectType) {
    switch(jiraProjectType){
        case $d446c821a6c23064$export$490d3686b662c315:
            return $d446c821a6c23064$export$4b79f735ed858abe;
        case $d446c821a6c23064$export$1242aa4e670b910e:
            return $d446c821a6c23064$export$417275bac62d38d2;
        case $d446c821a6c23064$export$bb467c3bc8f8620e:
            return $d446c821a6c23064$export$9c9c9eaf8c092006;
        case $d446c821a6c23064$export$610dddac4d185bf8:
            return $d446c821a6c23064$export$320625d747692f94;
        case $d446c821a6c23064$export$76412127fb3089d6:
            return $d446c821a6c23064$export$e9fe9a39cc7f5103;
        default:
            throw new Error(`Invalid JiraProjectType: ${jiraProjectType}`);
    }
}
function $d446c821a6c23064$export$959e77de8f16519c(jiraProjectType) {
    const convertedProjectType = $d446c821a6c23064$export$aa8444e79de3a8b6(jiraProjectType);
    if (convertedProjectType === $d446c821a6c23064$export$9c9c9eaf8c092006) // 'Service Desk' is old branding
    return (0, (/*@__PURE__*/$parcel$interopDefault($8HVfB)))('Service Management');
    return (0, (/*@__PURE__*/$parcel$interopDefault($8HVfB)))(convertedProjectType);
}
const $d446c821a6c23064$export$5a8b6164d1baba87 = (projectType)=>{
    switch(projectType){
        case $d446c821a6c23064$export$417275bac62d38d2:
            return $d446c821a6c23064$export$1242aa4e670b910e;
        case $d446c821a6c23064$export$9c9c9eaf8c092006:
            return $d446c821a6c23064$export$bb467c3bc8f8620e;
        case $d446c821a6c23064$export$320625d747692f94:
            return $d446c821a6c23064$export$610dddac4d185bf8;
        case $d446c821a6c23064$export$4b79f735ed858abe:
            return $d446c821a6c23064$export$490d3686b662c315;
        case $d446c821a6c23064$export$e9fe9a39cc7f5103:
            return $d446c821a6c23064$export$76412127fb3089d6;
        default:
            throw new Error(`Invalid ProjectType: ${projectType}`);
    }
};
const $d446c821a6c23064$export$5afb6f76b5af0167 = (projectType)=>{
    switch(projectType){
        case $d446c821a6c23064$export$9c9c9eaf8c092006:
            return $d446c821a6c23064$export$d579a2a17bd742af;
        case $d446c821a6c23064$export$320625d747692f94:
            return $d446c821a6c23064$export$320625d747692f94;
        case $d446c821a6c23064$export$417275bac62d38d2:
            return $d446c821a6c23064$export$417275bac62d38d2;
        case $d446c821a6c23064$export$e9fe9a39cc7f5103:
            return $d446c821a6c23064$export$e9fe9a39cc7f5103;
        case $d446c821a6c23064$export$4b79f735ed858abe:
            return $d446c821a6c23064$export$4b79f735ed858abe;
        default:
            return undefined;
    }
};
const $d446c821a6c23064$var$getFullProjectTypeKey = (style, projectType)=>(0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))(`${style}_${projectType}`);
const $d446c821a6c23064$export$241adb8e9255b93c = $d446c821a6c23064$var$getFullProjectTypeKey($d446c821a6c23064$export$1f66f9f05afa05a8.CLASSIC, $d446c821a6c23064$export$4b79f735ed858abe);
const $d446c821a6c23064$export$e932928a4bf564b7 = $d446c821a6c23064$var$getFullProjectTypeKey($d446c821a6c23064$export$1f66f9f05afa05a8.NEXT_GEN, $d446c821a6c23064$export$417275bac62d38d2);
const $d446c821a6c23064$export$e25a1ee2478a61d6 = (projectType)=>{
    switch(projectType){
        case $d446c821a6c23064$export$4b79f735ed858abe:
            return 'jira-core';
        case $d446c821a6c23064$export$417275bac62d38d2:
            return 'jira-software';
        case $d446c821a6c23064$export$9c9c9eaf8c092006:
            return 'jira-servicedesk';
        case $d446c821a6c23064$export$320625d747692f94:
            return 'jira-customer-service';
        case $d446c821a6c23064$export$e9fe9a39cc7f5103:
            return 'jira-product-discovery';
        default:
            return 'jira';
    }
};

});


parcelRegister("8ANUF", function(module, exports) {
$parcel$export(module.exports, "useProjectSidebarNavigation", () => $7c539f48b5e422bb$export$5a85006c180fb373);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $7c539f48b5e422bb$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $7c539f48b5e422bb$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $7c539f48b5e422bb$export$5cf90b625d0e1248);

var $e7boj = parcelRequire("e7boj");

var $g1yQ7 = parcelRequire("g1yQ7");

var $4Rvd7 = parcelRequire("4Rvd7");

var $ihrBs = parcelRequire("ihrBs");

var $iFmc7 = parcelRequire("iFmc7");

var $idDnR = parcelRequire("idDnR");

var $d7dm3 = parcelRequire("d7dm3");

var $k6ufm = parcelRequire("k6ufm");

var $36bRl = parcelRequire("36bRl");
const $7c539f48b5e422bb$export$5a85006c180fb373 = (customContext)=>{
    const $ = (0, $e7boj.c)(14);
    const t0 = (0, $d7dm3.useResourceWithCustomRouterContext)((0, $idDnR.staticProjectSidebarNavigationResource), customContext);
    let clearAll;
    let error;
    let loading;
    let navResponse;
    let refresh;
    let rest;
    if ($[0] !== t0) {
        ({ data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = t0);
        $[0] = t0;
        $[1] = clearAll;
        $[2] = error;
        $[3] = loading;
        $[4] = navResponse;
        $[5] = refresh;
        $[6] = rest;
    } else {
        clearAll = $[1];
        error = $[2];
        loading = $[3];
        navResponse = $[4];
        refresh = $[5];
        rest = $[6];
    }
    const memoizedResponse = navResponse;
    (0, $36bRl.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    const t1 = memoizedResponse != null ? false : loading;
    let t2;
    if ($[7] !== clearAll || $[8] !== error || $[9] !== memoizedResponse || $[10] !== refresh || $[11] !== rest || $[12] !== t1) {
        t2 = {
            data: memoizedResponse,
            loading: t1,
            refresh: refresh,
            clearAll: clearAll,
            error: error,
            ...rest
        };
        $[7] = clearAll;
        $[8] = error;
        $[9] = memoizedResponse;
        $[10] = refresh;
        $[11] = rest;
        $[12] = t1;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
};
const $7c539f48b5e422bb$export$2bed15cd7d167db5 = ()=>{
    return (0, $k6ufm.useResource)((0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource));
};
const $7c539f48b5e422bb$export$a9d05fc2c1d94895 = ()=>{
    return (0, $k6ufm.useResource)((0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource));
};
const $7c539f48b5e422bb$export$d48e3c3556894533 = ()=>{
    return (0, $k6ufm.useResource)((0, $iFmc7.staticProjectSettingsSidebarConnectAddonsNavigationResource));
};
const $7c539f48b5e422bb$export$24a781cd863077aa = ()=>{
    return (0, $k6ufm.useResource)((0, $g1yQ7.staticJSMProjectConnectAddonsNavigationResource));
};
const $7c539f48b5e422bb$export$e16ecd2512eb0dc7 = ()=>{
    const $ = (0, $e7boj.c)(6);
    const t0 = $7c539f48b5e422bb$export$5a85006c180fb373();
    let data;
    let rest;
    if ($[0] !== t0) {
        ({ data: data, ...rest } = t0);
        $[0] = t0;
        $[1] = data;
        $[2] = rest;
    } else {
        data = $[1];
        rest = $[2];
    }
    const response = data?.jiraWorkManagementNavData || null;
    let t1;
    if ($[3] !== response || $[4] !== rest) {
        t1 = {
            data: response,
            ...rest
        };
        $[3] = response;
        $[4] = rest;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $7c539f48b5e422bb$export$68dc0ecbea8211d2 = ()=>{
    const $ = (0, $e7boj.c)(6);
    const t0 = $7c539f48b5e422bb$export$5a85006c180fb373();
    let data;
    let rest;
    if ($[0] !== t0) {
        ({ data: data, ...rest } = t0);
        $[0] = t0;
        $[1] = data;
        $[2] = rest;
    } else {
        data = $[1];
        rest = $[2];
    }
    const response = data?.jiraSoftwareNavData || null;
    let t1;
    if ($[3] !== response || $[4] !== rest) {
        t1 = {
            data: response,
            ...rest
        };
        $[3] = response;
        $[4] = rest;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $7c539f48b5e422bb$export$5cf90b625d0e1248 = (customContext)=>{
    const $ = (0, $e7boj.c)(6);
    const t0 = $7c539f48b5e422bb$export$5a85006c180fb373(customContext);
    let data;
    let rest;
    if ($[0] !== t0) {
        ({ data: data, ...rest } = t0);
        $[0] = t0;
        $[1] = data;
        $[2] = rest;
    } else {
        data = $[1];
        rest = $[2];
    }
    const response = data?.jiraServiceManagementNavData || null;
    let t1;
    if ($[3] !== response || $[4] !== rest) {
        t1 = {
            data: response,
            ...rest
        };
        $[3] = response;
        $[4] = rest;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $7c539f48b5e422bb$export$d63d92edebe543d9 = ()=>{
    const $ = (0, $e7boj.c)(6);
    const t0 = $7c539f48b5e422bb$export$5a85006c180fb373();
    let data;
    let rest;
    if ($[0] !== t0) {
        ({ data: data, ...rest } = t0);
        $[0] = t0;
        $[1] = data;
        $[2] = rest;
    } else {
        data = $[1];
        rest = $[2];
    }
    const response = data?.jiraProductDiscoveryNavData || null;
    let t1;
    if ($[3] !== response || $[4] !== rest) {
        t1 = {
            data: response,
            ...rest
        };
        $[3] = response;
        $[4] = rest;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};

});
parcelRegister("g1yQ7", function(module, exports) {
$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $952a23c1938fab53$export$fab84295e18e9246);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $fpjIq = parcelRequire("fpjIq");
const $952a23c1938fab53$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $952a23c1938fab53$export$fab84295e18e9246 = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    getKey: ({ match: match, query: query })=>$952a23c1938fab53$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $952a23c1938fab53$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $fpjIq.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("4Rvd7", function(module, exports) {
$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $ac8ba5e1522d5931$export$b8c6e2666f12f4bb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $fpjIq = parcelRequire("fpjIq");
const $ac8ba5e1522d5931$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $ac8ba5e1522d5931$export$b8c6e2666f12f4bb = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$ac8ba5e1522d5931$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $ac8ba5e1522d5931$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $fpjIq.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000,
    isCritical: true
});

});

parcelRegister("ihrBs", function(module, exports) {
$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $6df5bc03c65a4784$export$b662f3f877add30d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $fpjIq = parcelRequire("fpjIq");
const $6df5bc03c65a4784$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $6df5bc03c65a4784$export$b662f3f877add30d = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$6df5bc03c65a4784$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $6df5bc03c65a4784$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $fpjIq.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("idDnR", function(module, exports) {
$parcel$export(module.exports, "getIdentifier", () => $8505ad5439e8eb76$export$adb27ddab077e944);
$parcel$export(module.exports, "staticProjectSidebarNavigationResource", () => $8505ad5439e8eb76$export$f2dfc0f7b2d92691);
$parcel$export(module.exports, "useSidebarNavigationResource", () => $8505ad5439e8eb76$export$b692cfadccf4e047);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $8S1Gc = parcelRequire("8S1Gc");

var $i0CFV = parcelRequire("i0CFV");

var $i860n = parcelRequire("i860n");

var $dBdbP = parcelRequire("dBdbP");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $41moy = parcelRequire("41moy");
const $8505ad5439e8eb76$export$adb27ddab077e944 = (routeName, match, query)=>{
    /**
	 * `boardId` as an identifier should not be returned for JSM boards route,
	 * skip boards on `SERVICEDESK_BOARDS` or `SERVICEDESK_CALENDAR` route.
	 */ if (routeName === 'servicedesk-boards' || routeName === 'servicedesk-calendar' || query['servicedesk.serviceDeskId'] || (routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-custom-calendar' || routeName === 'servicedesk-queues-practice-custom-board' || routeName === 'servicedesk-queues-practice-custom-calendar' || routeName === 'servicedesk-queues-views-config' || routeName === 'servicedesk-practice-views-config') && (0, $i860n.fg)('jsm_views_inside_queues_-_main_flag') || routeName === 'servicedesk-list' && (0, $i860n.fg)('jsm_list_view_milestone_1')) {
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        return (0, $dBdbP.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
    }
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    const boardId = (0, $8S1Gc.getBoardId)(match, query);
    return (0, $dBdbP.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
};
const $8505ad5439e8eb76$var$getRouterKey = (routeName, match, query)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = $8505ad5439e8eb76$export$adb27ddab077e944(routeName, match, query);
    // Next-Gen software projects contain only one board. Hence, using the project key itself
    if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
    return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
};
const $8505ad5439e8eb76$export$f2dfc0f7b2d92691 = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    getKey: ({ match: match, query: query, route: { name: name } })=>$8505ad5439e8eb76$var$getRouterKey(name, match, query),
    /**
		 * is called on resource's init fetch, or .refresh()
		 */ getData: async ({ match: match, query: query, route: { name: name } })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const scopeIdentifier = $8505ad5439e8eb76$export$adb27ddab077e944(name, match, query);
        if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
        const navInfo = await (0, $41moy.fetchProjectSidebarNavInfo)(scopeIdentifier);
        return navInfo;
    },
    maxAge: 300000,
    isCritical: true
});
const $8505ad5439e8eb76$export$b692cfadccf4e047 = ()=>(0, $k6ufm.useResource)($8505ad5439e8eb76$export$f2dfc0f7b2d92691);

});
parcelRegister("dBdbP", function(module, exports) {
$parcel$export(module.exports, "getScopeIdentifier", () => $53cd72122149125e$export$68278f7cf66944f9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
const $53cd72122149125e$export$68278f7cf66944f9 = (scope)=>{
    // We check for identifiers in order of specificity first. A board ID is more specific than a project key and so on
    const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
    let identifierType = null;
    if (scope.boardId) identifierType = (0, $f0e9a194674bc930$export$929d50f83189406c);
    else if (scope.projectKey) identifierType = (0, $f0e9a194674bc930$export$b5a308a17bc991f3);
    else if (scope.projectId) identifierType = (0, $f0e9a194674bc930$export$da6f46390e1a426f);
    return {
        identifierValue: identifierValue,
        identifierType: identifierType
    };
};

});
/* eslint-disable jira/filename-case */ const $f0e9a194674bc930$export$b5a308a17bc991f3 = 'projectKey';
const $f0e9a194674bc930$export$929d50f83189406c = 'boardId';
const $f0e9a194674bc930$export$da6f46390e1a426f = 'projectId';


parcelRegister("41moy", function(module, exports) {
$parcel$export(module.exports, "fetchProjectSidebarNavInfo", () => $95a3ae077b1371df$export$8a51470472777e11);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $2700E = parcelRequire("2700E");

var $h2wCv = parcelRequire("h2wCv");
const $95a3ae077b1371df$export$8a51470472777e11 = (scopeIdentifier)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
    if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
    if ((0, $2700E.expVal)('frontier-guided-autonomy-eap', 'isEnabled', false)) {
        const params = new URLSearchParams();
        switch(identifierType){
            case 'boardId':
                params.set('boardId', identifierValue);
                break;
            case 'projectKey':
            case 'projectId':
                params.set('projectIdOrKey', identifierValue);
                break;
            default:
                break;
        }
        params.set('includePolicyStatus', 'true');
        return (0, $h2wCv.performGetRequest)(`/rest/navigation/4/sidebar?${params.toString()}`);
    }
    let queryParam = '';
    switch(identifierType){
        case 'boardId':
            queryParam = `boardId=${identifierValue}`;
            break;
        case 'projectKey':
        case 'projectId':
            queryParam = `projectIdOrKey=${identifierValue}`;
            break;
        default:
            break;
    }
    return (0, $h2wCv.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
};

});


parcelRegister("d7dm3", function(module, exports) {
$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $4a636ba60d80a383$export$61dad767cf446185);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7bJ0J = parcelRequire("7bJ0J");
var $k6ufm = parcelRequire("k6ufm");

var $1zsZc = parcelRequire("1zsZc");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * Jfyi, createProjectRouteRouterContext() function in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
 */ const $4a636ba60d80a383$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
function $4a636ba60d80a383$export$61dad767cf446185(resource, customRouterContext, options = {}) {
    let resourceOptions;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $4a636ba60d80a383$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
            routerContext: (0, $7bJ0J.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const { shouldPrefetch: shouldPrefetch } = options;
    const resourceResponse = (0, $k6ufm.useResource)(resource, resourceOptions);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $1zsZc.usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
    return resourceResponse;
}

});
parcelRegister("1zsZc", function(module, exports) {
$parcel$export(module.exports, "usePrefetchableResource", () => $36801649fdfaecae$export$99f17ace416cfe75);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
function $36801649fdfaecae$export$99f17ace416cfe75(resource, shouldPrefetch) {
    (0, $euxye.useEffect)(()=>{
        if (!shouldPrefetch) return;
        // "false" is a valid value for data here. We only want to trigger a refresh if data is null or undefined.
        if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("36bRl", function(module, exports) {
$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $3f1d8c84de71c48d$export$780174995da89d60);

var $e7boj = parcelRequire("e7boj");

var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $idDnR = parcelRequire("idDnR");

var $7bJ0J = parcelRequire("7bJ0J");
var $f2wVS = parcelRequire("f2wVS");
var $k6ufm = parcelRequire("k6ufm");
const $3f1d8c84de71c48d$export$90dbde7e33e6e21 = ()=>null;
const $3f1d8c84de71c48d$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $7bJ0J.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $3f1d8c84de71c48d$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $3f1d8c84de71c48d$export$19001bab9e4b7f8f = (projectKey)=>{
    const $ = (0, $e7boj.c)(7);
    let t0;
    if ($[0] !== projectKey) {
        t0 = $3f1d8c84de71c48d$export$d647718555c2fdd8(projectKey);
        $[0] = projectKey;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = {
            routerContext: t0
        };
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    const { data: data, update: update } = (0, $k6ufm.useResource)((0, $idDnR.staticProjectSidebarNavigationResource), t1);
    let t2;
    if ($[4] !== data || $[5] !== update) {
        t2 = {
            data: data,
            update: update
        };
        $[4] = data;
        $[5] = update;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $3f1d8c84de71c48d$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $7bJ0J.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $3f1d8c84de71c48d$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $3f1d8c84de71c48d$export$e2bb7877e6cec3eb = (boardId)=>{
    const $ = (0, $e7boj.c)(7);
    let t0;
    if ($[0] !== boardId) {
        t0 = $3f1d8c84de71c48d$export$23dc6491016cabdc(boardId);
        $[0] = boardId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = {
            routerContext: t0
        };
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    const { data: data, update: update } = (0, $k6ufm.useResource)((0, $idDnR.staticProjectSidebarNavigationResource), t1);
    let t2;
    if ($[4] !== data || $[5] !== update) {
        t2 = {
            data: data,
            update: update
        };
        $[4] = data;
        $[5] = update;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $3f1d8c84de71c48d$var$useIsOnBoardBasedRoute = (0, $f2wVS.createRouterSelector)(({ route: route, query: query, match: match })=>(0, $idDnR.getIdentifier)(route.name, match, query)?.identifierType === 'boardId');
const $3f1d8c84de71c48d$export$780174995da89d60 = (latestNavInfo)=>{
    const $ = (0, $e7boj.c)(9);
    const isOnBoardBasedRoute = $3f1d8c84de71c48d$var$useIsOnBoardBasedRoute();
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $3f1d8c84de71c48d$export$19001bab9e4b7f8f(pKey);
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $3f1d8c84de71c48d$export$e2bb7877e6cec3eb(boardId);
    let t0;
    let t1;
    if ($[0] !== boardRouteNavInfo || $[1] !== isOnBoardBasedRoute || $[2] !== isSoftwareCMP || $[3] !== latestNavInfo || $[4] !== projectRouteNavInfo || $[5] !== updateBoardRoute || $[6] !== updateProjectRoute) {
        t0 = ()=>{
            if (latestNavInfo != null && isSoftwareCMP) {
                if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
                else if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
            }
        };
        t1 = [
            isOnBoardBasedRoute,
            latestNavInfo,
            updateProjectRoute,
            updateBoardRoute,
            projectRouteNavInfo,
            boardRouteNavInfo,
            isSoftwareCMP
        ];
        $[0] = boardRouteNavInfo;
        $[1] = isOnBoardBasedRoute;
        $[2] = isSoftwareCMP;
        $[3] = latestNavInfo;
        $[4] = projectRouteNavInfo;
        $[5] = updateBoardRoute;
        $[6] = updateProjectRoute;
        $[7] = t0;
        $[8] = t1;
    } else {
        t0 = $[7];
        t1 = $[8];
    }
    (0, $euxye.useEffect)(t0, t1);
};

});



parcelRegister("bKPo4", function(module, exports) {
$parcel$export(module.exports, "layoutWithCondition", () => $ec1fd26b8d3c8821$export$c5db53e93ba35c0f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $ec1fd26b8d3c8821$export$c5db53e93ba35c0f = (conditionGetter, itemTrue, itemFalse)=>({
        get isChromeless () {
            return conditionGetter() ? itemTrue.isChromeless : itemFalse.isChromeless;
        },
        get globalComponents () {
            return conditionGetter() ? itemTrue.globalComponents : itemFalse.globalComponents;
        },
        get rightSidebars () {
            return conditionGetter() ? itemTrue.rightSidebars : itemFalse.rightSidebars;
        }
    });

});




parcelRegister("fdS54", function(module, exports) {
$parcel$export(module.exports, "createEntry", () => $03ea87c69fa8acf1$export$344b9c9ab5e66c9a);

var $4s81o = parcelRequire("4s81o");
const $03ea87c69fa8acf1$export$344b9c9ab5e66c9a = (0, $4s81o.createRouteEntry);

});
parcelRegister("4s81o", function(module, exports) {
$parcel$export(module.exports, "createRouteEntry", () => $b039d3173ab8f298$export$136cc45b1cabb43);
/**
 * Create route entry with entrypoint, resources, etc. override
 *
 * @param baseRoute Base route object that contains matching info
 * @param opts Route definition to fill and override
 */ function $b039d3173ab8f298$export$136cc45b1cabb43(baseRoute, opts) {
    // @ts-expect-error Re-using baseRoute to become the full route Object allows us to optimize
    // route transitions as RRR can directly use the route instead of comparing a separate InvariantRoute
    // against the full route list
    // eslint-disable-next-line no-param-reassign
    baseRoute.lazyOpts = opts;
    // @ts-expect-error TODO
    return baseRoute;
}

});


parcelRegister("gc1my", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", () => $e4959b1d9e9a86be$export$4f2c2d125c2b811a);
const $e4959b1d9e9a86be$export$4f2c2d125c2b811a = {
    name: 'global-settings-issues-explicit-field-association-project-list',
    path: '/jira/settings/issues/explicit-field-association'
};

});

parcelRegister("iIyfF", function(module, exports) {
$parcel$export(module.exports, "LazyExplicitFieldsProjectListPromise", () => $56b6898274494e17$export$7b11685155ada84d);
$parcel$export(module.exports, "LazyExplicitFieldsProjectListPage", () => $56b6898274494e17$export$e81c180c4f4833e);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $l8G1z = parcelRequire("l8G1z");

var $8bf4L = parcelRequire("8bf4L");

const $56b6898274494e17$export$7b11685155ada84d = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("grAIU")), {
    moduleId: "./src/packages/spa-apps/error-pages-not-found/src/ErrorPagesNotFoundPage.tsx"
});
const $56b6898274494e17$export$e81c180c4f4833e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8bf4L.LazyPage), {
        Page: $56b6898274494e17$export$7b11685155ada84d,
        pageId: "errors-404",
        shouldShowSpinner: false
    });
$56b6898274494e17$export$e81c180c4f4833e.displayName = "LazyExplicitFieldsProjectListPage";

});
parcelRegister("8bf4L", function(module, exports) {
$parcel$export(module.exports, "LazyPage", () => $92108d58e2529401$export$a18c9c3dd309b8e6);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $6DfNt = parcelRequire("6DfNt");

var $6CfY5 = parcelRequire("6CfY5");

var $a8EUd = parcelRequire("a8EUd");

var $4Onaa = parcelRequire("4Onaa");

var $E85Qr = parcelRequire("E85Qr");

var $f99wD = parcelRequire("f99wD");

var $bzSUP = parcelRequire("bzSUP");
const $92108d58e2529401$var$LOCATION = 'lazy-page';
const $92108d58e2529401$export$fb85bbdbfb3e6869 = ()=>null;
const $92108d58e2529401$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
    const route = (0, $4Onaa.useCurrentRoute)();
    const Skeleton = route.skeleton || (shouldShowSpinner ? (0, $6DfNt.default) : $92108d58e2529401$export$fb85bbdbfb3e6869);
    (0, $euxye.useEffect)(()=>{
        if (route.isRedirect) (0, $6CfY5.default).safeWarnWithoutCustomerData($92108d58e2529401$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, route.bifrost?.bifrostGroup !== 'shell-only' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bzSUP.ReportSSRFailOnUse), {
        pageId: pageId,
        fallbackId: "LazyPage",
        ignoreWhenCircuitOpen: true,
        displayErrorInStaging: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Skeleton, null));
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "lazy_page_redirect",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $E85Qr.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f99wD.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f99wD.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "lazy_page",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bzSUP.DisableSSRFailDetection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Page, null)))));
};
$92108d58e2529401$export$a18c9c3dd309b8e6.displayName = "LazyPage";

});
parcelRegister("6DfNt", function(module, exports) {
$parcel$export(module.exports, "default", () => $0463e7c2a383a946$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2D2gW = parcelRequire("2D2gW");

var $abhF2 = parcelRequire("abhF2");
function $0463e7c2a383a946$export$2e2bcd8739ae039({ testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2D2gW.default), {
        name: "legacy-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0463e7c2a383a946$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0463e7c2a383a946$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
        size: "large",
        testId: testId
    }))));
}
$0463e7c2a383a946$export$2e2bcd8739ae039.displayName = "Spinner";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0463e7c2a383a946$var$Container = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $0463e7c2a383a946$var$Wrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1wpz1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4Onaa", function(module, exports) {
$parcel$export(module.exports, "useCurrentRoute", () => $7cf4e26bcc1acd8b$export$c4b7ea2942f2d0e);
$parcel$export(module.exports, "useRouteByName", () => $7cf4e26bcc1acd8b$export$d69a946e2d0a1c12);
$parcel$export(module.exports, "usePreviousRouterState", () => $7cf4e26bcc1acd8b$export$1e5fb68306bd0b92);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f2wVS = parcelRequire("f2wVS");
var $bc9Gj = parcelRequire("bc9Gj");

var $41zzZ = parcelRequire("41zzZ");
const $7cf4e26bcc1acd8b$export$c4b7ea2942f2d0e = (0, $f2wVS.createRouterSelector)((state)=>state.route);
const $7cf4e26bcc1acd8b$export$d69a946e2d0a1c12 = (0, $f2wVS.createRouterSelector)((state, routeName)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.routes.find(({ name: name })=>name === routeName) ?? null);
const $7cf4e26bcc1acd8b$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
        name: name,
        path: path,
        query: query,
        exact: exact
    });
const $7cf4e26bcc1acd8b$export$1e5fb68306bd0b92 = ()=>{
    // Force updates whenever the current route changes
    (0, $bc9Gj.useRouter)();
    return (0, $41zzZ.getPreviousRouterState)();
};

});

parcelRegister("E85Qr", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4e5512e8682cc52$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $7jZTu = parcelRequire("7jZTu");

var $6xuJS = parcelRequire("6xuJS");

var $gp4ma = parcelRequire("gp4ma");

var $lCfDe = parcelRequire("lCfDe");

var $cYVlc = parcelRequire("cYVlc");


var $5BIfJ = parcelRequire("5BIfJ");

var $jgUTL = parcelRequire("jgUTL");
class $b4e5512e8682cc52$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    render() {
        const { children: children, pageId: pageId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BIfJ.default).Provider, {
            // @ts-expect-error - TS2322 - Type '{ pageId: string; onReady: (metricKeyForInitialRender: string, metricKeyForTransition: string, extra: { [key: string]: string | number | boolean; } | undefined, metric: BM3Metric) => void; onCustomMark: (markName: string) => void; }' is not assignable to type 'string'.
            value: {
                pageId: pageId,
                onReady: this.onReady,
                onCustomMark: this.onCustomMark
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gp4ma.default), {
            op: this.onStart,
            args: [
                pageId
            ]
        }), children));
    }
    constructor(...args){
        super(...args), this.customMarks = [], this.onStart = ()=>{
            (0, $7jZTu.default)((0, $07aa4ba62fd6dab4$export$56940a9488e85199));
            (0, $6xuJS.setMark)((0, $07aa4ba62fd6dab4$export$45c4b6bf7935c69a));
        }, this.onCustomMark = (markName)=>{
            (0, $6xuJS.setMark)((0, $jgUTL.getPrefixedMarkName)(markName));
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
            this.customMarks.push(markName);
        }, this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
            metric.stop({
                customData: extra
            });
            if ((0, $cYVlc.isAutomaticExposureCollectionEnabled)()) (0, $lCfDe.stopLowPriorityEventDelay)();
        };
    }
}
$b4e5512e8682cc52$export$2e2bcd8739ae039.displayName = "Provider";

});
parcelRegister("7jZTu", function(module, exports) {
$parcel$export(module.exports, "default", () => $659c9fba925216f6$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $fDxFn = parcelRequire("fDxFn");
/*
 * This utility finds all performance entries that is prefixed
 * with the `prefix` and does clearMarks on each entry.
 * All the entries that are cleared will be returned
 */ const $659c9fba925216f6$var$clearMarksWithPrefix = (prefix)=>{
    if ((0, $fDxFn.default) && (0, $fDxFn.default).getEntries && (0, $fDxFn.default).clearMarks) return (0, $fDxFn.default).getEntries().filter((mark)=>mark.name.startsWith(prefix)).map((mark)=>{
        (0, $fDxFn.default).clearMarks(mark.name);
        return mark;
    });
    return [];
};
var $659c9fba925216f6$export$2e2bcd8739ae039 = $659c9fba925216f6$var$clearMarksWithPrefix;

});

parcelRegister("gp4ma", function(module, exports) {
$parcel$export(module.exports, "default", () => $34327f454b0f147e$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");
// eslint-disable-next-line jira/react/no-class-components
class $34327f454b0f147e$var$OpTrigger extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(this.props.args, nextProps.args);
    }
    componentDidUpdate() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
$34327f454b0f147e$var$OpTrigger.displayName = "OpTrigger";
var $34327f454b0f147e$export$2e2bcd8739ae039 = $34327f454b0f147e$var$OpTrigger;

});

parcelRegister("lCfDe", function(module, exports) {
$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $9709dda8586372c0$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $9709dda8586372c0$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $9709dda8586372c0$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $7jZTu = parcelRequire("7jZTu");

var $6xuJS = parcelRequire("6xuJS");

var $WLMyp = parcelRequire("WLMyp");

var $6Kdw4 = parcelRequire("6Kdw4");

var $kPvQe = parcelRequire("kPvQe");

var $cYVlc = parcelRequire("cYVlc");

const $9709dda8586372c0$var$STOP_DELAY_TIMEOUT = 10000;
let $9709dda8586372c0$var$stopDelayTimeout;
let $9709dda8586372c0$var$lastDelayActionPromise = (0, $6Kdw4.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $9709dda8586372c0$export$a928755af449867 = ()=>{
    $9709dda8586372c0$var$lastDelayActionPromise = $9709dda8586372c0$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $WLMyp.isEventDelayActive)()) return client;
        clearTimeout($9709dda8586372c0$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $6xuJS.setMark)((0, $0c827fe198b93e52$export$2d91d3eed1108e72));
        (0, $WLMyp.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $9709dda8586372c0$export$8bb8df5a93e9525 = ()=>{
    $9709dda8586372c0$var$lastDelayActionPromise = $9709dda8586372c0$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $WLMyp.isEventDelayActive)()) {
            (0, $7jZTu.default)((0, $0c827fe198b93e52$export$358721a9d6125914));
            (0, $6xuJS.setMark)((0, $0c827fe198b93e52$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $WLMyp.setEventDelayActive)(true);
        clearTimeout($9709dda8586372c0$var$stopDelayTimeout);
        $9709dda8586372c0$var$stopDelayTimeout = setTimeout($9709dda8586372c0$export$a928755af449867, $9709dda8586372c0$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $9709dda8586372c0$export$778ebe2a4fab1ba7 = ()=>$9709dda8586372c0$var$lastDelayActionPromise;
const $9709dda8586372c0$var$EventDelayController = ()=>{
    const [loadedState] = (0, $kPvQe.default)();
    (0, $euxye.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $cYVlc.isAutomaticExposureCollectionEnabled)()) $9709dda8586372c0$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
$9709dda8586372c0$var$EventDelayController.displayName = "EventDelayController";
var $9709dda8586372c0$export$2e2bcd8739ae039 = $9709dda8586372c0$var$EventDelayController;

});
parcelRegister("WLMyp", function(module, exports) {
$parcel$export(module.exports, "setEventDelayActive", () => $d63f81c93066405d$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $d63f81c93066405d$export$3536b0184fa98d19);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ let $d63f81c93066405d$var$eventDelayActive = false;
const $d63f81c93066405d$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $d63f81c93066405d$var$eventDelayActive = isEventDelayActive;
};
const $d63f81c93066405d$export$3536b0184fa98d19 = ()=>$d63f81c93066405d$var$eventDelayActive;

});

parcelRegister("kPvQe", function(module, exports) {
$parcel$export(module.exports, "default", () => $fba6ab5a4776495b$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");


var $6Bw3S = parcelRequire("6Bw3S");
const $fba6ab5a4776495b$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $70e36d23224a09de$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $70e36d23224a09de$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $fba6ab5a4776495b$var$usePageLoadedSubscriber = (0, $3h1FP.createHook)((0, $6Bw3S.default), {
    selector: $fba6ab5a4776495b$export$4a361c7505f72f5c
});
var $fba6ab5a4776495b$export$2e2bcd8739ae039 = $fba6ab5a4776495b$var$usePageLoadedSubscriber;

});
/* eslint-disable jira/filename-case */ const $70e36d23224a09de$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $70e36d23224a09de$export$2ee9e5a3556c1e43 = 'SIDEBAR';


parcelRegister("cYVlc", function(module, exports) {
$parcel$export(module.exports, "isAutomaticExposureCollectionEnabled", () => $9545f666dfc9ddc1$export$cf2aaf3c58e46848);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // code-reaper-ignore - file is referenced as "browser" entry in package.json
// eslint-disable-next-line jira/jira-ssr/no-server-variable
const $9545f666dfc9ddc1$export$c9c75778ebadb3f1 = ()=>false ? 0 : 100;
const $9545f666dfc9ddc1$export$cf2aaf3c58e46848 = ()=>!false;

});

/* eslint-disable jira/filename-case */ const $0c827fe198b93e52$export$358721a9d6125914 = 'event-delay-controller.';
const $0c827fe198b93e52$export$b2122dce85a27912 = `${$0c827fe198b93e52$export$358721a9d6125914}start`;
const $0c827fe198b93e52$export$2d91d3eed1108e72 = `${$0c827fe198b93e52$export$358721a9d6125914}end`;


/* eslint-disable jira/filename-case */ const $07aa4ba62fd6dab4$export$56940a9488e85199 = 'jira.fe.spa-';
const $07aa4ba62fd6dab4$export$45c4b6bf7935c69a = `${$07aa4ba62fd6dab4$export$56940a9488e85199}start`;
const $07aa4ba62fd6dab4$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $07aa4ba62fd6dab4$export$ff834eccc35b9089 = 'appBundleReady';
const $07aa4ba62fd6dab4$export$86b05e34d462ead8 = 'prefetchApiReady';
const $07aa4ba62fd6dab4$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $07aa4ba62fd6dab4$export$3ae43cc1782d058f = 'jswRenderStart';
const $07aa4ba62fd6dab4$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $07aa4ba62fd6dab4$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $07aa4ba62fd6dab4$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $07aa4ba62fd6dab4$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $07aa4ba62fd6dab4$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $07aa4ba62fd6dab4$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $07aa4ba62fd6dab4$export$99c08ec92759c71c = 'tti-raf-mark';
const $07aa4ba62fd6dab4$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("5BIfJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $459c9aef7d8e5f61$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");
const $459c9aef7d8e5f61$var$contextName = 'SpaApdexAnalytics';
const $459c9aef7d8e5f61$var$spaApdexAnalyticsContext = /*#__PURE__*/ (0, $euxye.createContext)($459c9aef7d8e5f61$var$contextName);
var $459c9aef7d8e5f61$export$2e2bcd8739ae039 = $459c9aef7d8e5f61$var$spaApdexAnalyticsContext;

});

parcelRegister("jgUTL", function(module, exports) {
$parcel$export(module.exports, "getPrefixedMarkName", () => $2df815ffc6a1236e$export$c8f0e9837e7e9425);
/* eslint-disable jira/filename-case */ 
const $2df815ffc6a1236e$export$c8f0e9837e7e9425 = (name)=>`${0, $07aa4ba62fd6dab4$export$56940a9488e85199}${name}`;

});


parcelRegister("f99wD", function(module, exports) {
$parcel$export(module.exports, "SpaStateContainer", () => $9f40a6f98028a48e$export$e9a92b877fe80e80);
$parcel$export(module.exports, "SpaStateAppStart", () => $9f40a6f98028a48e$export$d18dd27183a635c);
$parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", () => $9f40a6f98028a48e$export$95a2912d76fb5433);
$parcel$export(module.exports, "SpaStatePageReady", () => $9f40a6f98028a48e$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $9f40a6f98028a48e$export$41e70078eeddaddc);
$parcel$export(module.exports, "SpaStatePageErrorReady", () => $9f40a6f98028a48e$export$2583aa269898885c);
$parcel$export(module.exports, "getSpaStateLastUserLocation", () => $9f40a6f98028a48e$export$6e9ab893e97cccef);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $f2wVS = parcelRequire("f2wVS");

var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $ciIbx = parcelRequire("ciIbx");

var $OPiBr = parcelRequire("OPiBr");

var $6Bw3S = parcelRequire("6Bw3S");
const $9f40a6f98028a48e$export$e9a92b877fe80e80 = (0, $dB6ay.createContainer)((0, $6Bw3S.default));
const $9f40a6f98028a48e$export$d18dd27183a635c = ()=>{
    const startRef = (0, $euxye.useRef)(Date.now());
    const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, $OPiBr.useSpaState)();
    (0, $euxye.useMemo)(()=>{
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visitedPages
    ]);
    (0, $euxye.useLayoutEffect)(()=>{
        setAppStart(startRef.current);
    }, [
        setAppStart,
        visitedPages
    ]);
    return null;
};
$9f40a6f98028a48e$export$d18dd27183a635c.displayName = "SpaStateAppStart";
const $9f40a6f98028a48e$var$useRouterMatchSelector = (0, $f2wVS.createRouterSelector)((state)=>state.match);
const $9f40a6f98028a48e$var$useSpaStatePagesCount = (0, $3h1FP.createHook)((0, $6Bw3S.default), {
    selector: ({ visitedPages: visitedPages })=>visitedPages.length
});
const $9f40a6f98028a48e$export$95a2912d76fb5433 = ()=>{
    const match = $9f40a6f98028a48e$var$useRouterMatchSelector();
    const [count, { setAppStart: setAppStart }] = $9f40a6f98028a48e$var$useSpaStatePagesCount();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9f40a6f98028a48e$export$ada7e0ec445851a2, {
        visitedPagesLength: count,
        onSetAppStart: setAppStart,
        match: match
    });
};
$9f40a6f98028a48e$export$95a2912d76fb5433.displayName = "SpaStateAppStartWithMatchCheck";
function $9f40a6f98028a48e$export$c34439f945fccbdf() {
    const { setAppReady: setAppReady } = (0, $OPiBr.useSpaStateActions)();
    (0, $euxye.useEffect)(()=>{
        setAppReady();
    }, [
        setAppReady
    ]);
    return null;
}
$9f40a6f98028a48e$export$c34439f945fccbdf.displayName = "SpaStatePageReady";
function $9f40a6f98028a48e$export$41e70078eeddaddc({ updateKey: updateKey }) {
    const { setAppReady: setAppReady } = (0, $OPiBr.useSpaStateActions)();
    (0, $euxye.useEffect)(()=>{
        setAppReady();
    }, [
        setAppReady,
        updateKey
    ]);
    return null;
}
$9f40a6f98028a48e$export$41e70078eeddaddc.displayName = "SpaStatePageReadyOnUpdate";
function $9f40a6f98028a48e$export$2583aa269898885c() {
    const { setAppErrorReady: setAppErrorReady } = (0, $OPiBr.useSpaStateActions)();
    (0, $euxye.useEffect)(()=>{
        setAppErrorReady();
    }, [
        setAppErrorReady
    ]);
    return null;
}
$9f40a6f98028a48e$export$2583aa269898885c.displayName = "SpaStatePageErrorReady";
class $9f40a6f98028a48e$export$ada7e0ec445851a2 extends (0, $euxye.Component) {
    static getDerivedStateFromProps(props, state) {
        const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
        const matchHasChanged = props.match !== state.match;
        const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
        if (setAppStart) props.onSetAppStart(Date.now());
        // On transition visitedPageLength will always change before match, the only exception is when there is page
        // ids (e.g. issue types). When redirecting, the length doesn't change while the match changes (from issuetype to issuetype/xxxxx).
        // so if match changed without visitedPageLength changing, cache the new match and wait for both to update.
        if (setAppStart || !visitedPageLengthHasChanged) return {
            started: true,
            visitedPagesLength: props.visitedPagesLength,
            match: props.match
        };
        // if visitedPageLength changed, ignore and wait for update in match (which will trigger setAppStart next)
        return state;
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args), /** so the challenge we are facing is that, we need to reset page when there's a visitedPagesLength change and a route change,
	 * but they don't always happen at the the same time during the current spa router situation. The following code does this:
	 *
	 * if first render: set app start
	 *
	 * if subsequently render with only visitedPagesLength change, ignore this updates, cache the old visitedPagesLength,
	 * wait for incoming match change
	 *
	 * if subsequently render with only match change, ignore this updates, cache the old match, wait for incoming
	 * visitedPagesLength change
	 *
	 *  if incoming changes contain both route and length change, we update state and start app
	 *
	 */ this.state = {
            visitedPagesLength: 0,
            started: false,
            match: null
        };
    }
}
$9f40a6f98028a48e$export$ada7e0ec445851a2.displayName = "SpaStateAppStartChild";
const $9f40a6f98028a48e$export$6e9ab893e97cccef = ()=>{
    const { visitedPages: visitedPages } = (0, $ciIbx.defaultRegistry).getStore((0, $6Bw3S.default)).storeState.getState();
    return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
};

});
parcelRegister("OPiBr", function(module, exports) {
$parcel$export(module.exports, "useSpaState", () => $445053e25dd421f1$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $445053e25dd421f1$export$b134752525935b78);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");

var $6Bw3S = parcelRequire("6Bw3S");
const $445053e25dd421f1$export$a57865516f6345d1 = (0, $3h1FP.createHook)((0, $6Bw3S.default));
const $445053e25dd421f1$export$b134752525935b78 = (0, $3h1FP.createActionsHook)((0, $6Bw3S.default));

});


parcelRegister("bzSUP", function(module, exports) {
$parcel$export(module.exports, "ReportSSRFailOnUse", () => $6627cacbaaf3d1be$export$daa3f09a96683b19);
$parcel$export(module.exports, "DisableSSRFailDetection", () => $6627cacbaaf3d1be$export$420f5a45dbda6a67);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $ed8N8 = parcelRequire("ed8N8");

var $ldgHZ = parcelRequire("ldgHZ");

var $f2wVS = parcelRequire("f2wVS");

var $hNjtc = parcelRequire("hNjtc");

var $2qS33 = parcelRequire("2qS33");

var $aMROb = parcelRequire("aMROb");
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
const $6627cacbaaf3d1be$export$c35f8a10548d98f7 = (0, $f2wVS.createRouterSelector)((state)=>state.route?.bifrost?.circuitBreakerConfig);
const $6627cacbaaf3d1be$export$daa3f09a96683b19 = ({ ignoreWhenCircuitOpen: ignoreWhenCircuitOpen, pageId: pageId, UNSAFE__forceReporting: UNSAFE__forceReporting = false, reportToSlackChannel: reportToSlackChannel, fallbackId: fallbackId, displayErrorInStaging: displayErrorInStaging })=>{
    const circuitBreakerConfig = $6627cacbaaf3d1be$export$c35f8a10548d98f7();
    const isCircuitOpenValue = (0, $ed8N8.isCircuitOpen)(circuitBreakerConfig);
    const isCookieCircuitBreakerOpen = ignoreWhenCircuitOpen && isCircuitOpenValue && circuitBreakerConfig?.isCircuitBreakerEnabled;
    const isIgnored = isCookieCircuitBreakerOpen || (0, $ldgHZ.isStreamingEnabled)();
    const shouldReport = (0, $euxye.useContext)((0, $aMROb.detectionBoundary)) || UNSAFE__forceReporting;
    (0, $euxye.useMemo)(()=>{
        if (!false) // This component only reports in SSR
        return;
        // do not report when cb is open and this failure is to do with the resources not being loaded.
        // However, still show circuit breaker message when appropriate
        if (isIgnored) return;
        if (shouldReport) {
            // eslint-disable-next-line no-console
            console.error({
                error: `SSR ended rendering a fallback (${fallbackId}) on page ${pageId}`,
                message: 'Top level suspense boundary was triggered. This is not expected to happen',
                pageId: pageId
            });
            (0, $hNjtc.markSSRFailure)(fallbackId);
        } else // eslint-disable-next-line no-console
        console.warn(`SSR ended rendering a non-top-level fallback (${fallbackId}) on page ${pageId}`);
    }, [
        isIgnored,
        shouldReport,
        fallbackId,
        pageId
    ]);
    if (isIgnored && !isCookieCircuitBreakerOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2qS33.FallbackIndicator), {
        reportToSlackChannel: reportToSlackChannel,
        fallbackId: fallbackId,
        displayErrorInStaging: displayErrorInStaging,
        isCookieCircuitBreakerFailure: isCookieCircuitBreakerOpen,
        cookieKey: circuitBreakerConfig?.cookieKey
    });
};
$6627cacbaaf3d1be$export$daa3f09a96683b19.displayName = "ReportSSRFailOnUse";
const $6627cacbaaf3d1be$export$420f5a45dbda6a67 = ({ children: children })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aMROb.detectionBoundary).Provider, {
        value: false
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
$6627cacbaaf3d1be$export$420f5a45dbda6a67.displayName = "DisableSSRFailDetection";

});
parcelRegister("ed8N8", function(module, exports) {
$parcel$export(module.exports, "isCircuitOpen", () => $7b3174e9f3dd0826$export$f528a0ba25e4d432);
/* eslint-disable jira/filename-case */ 
var $gQale = parcelRequire("gQale");
function $7b3174e9f3dd0826$export$f528a0ba25e4d432(config) {
    // circuit will never be open if isSetCookieEnabled is false
    if (config?.isSetCookieEnabled) {
        const circuitBreaker = (0, $gQale.getCookieCircuitBreaker)(config);
        return circuitBreaker?.getState().state === 'OPEN';
    }
    return false;
}

});
parcelRegister("gQale", function(module, exports) {
$parcel$export(module.exports, "getCookieCircuitBreaker", () => $b1286dc2cfd79bf4$export$c696b1ba9d4ab97);
/* eslint-disable jira/filename-case */ 
var $3Nfah = parcelRequire("3Nfah");
let $b1286dc2cfd79bf4$var$circuitBreaker;
function $b1286dc2cfd79bf4$export$c696b1ba9d4ab97(config) {
    if (config?.isSetCookieEnabled) {
        if ($b1286dc2cfd79bf4$var$circuitBreaker) return $b1286dc2cfd79bf4$var$circuitBreaker;
        $b1286dc2cfd79bf4$var$circuitBreaker = new (0, $3Nfah.CookieCircuitBreaker)(config);
        return $b1286dc2cfd79bf4$var$circuitBreaker;
    }
}

});
parcelRegister("3Nfah", function(module, exports) {
$parcel$export(module.exports, "CookieCircuitBreaker", () => $7fb7b9ad2c8cd2b3$export$e15350ade5fb9457);
/* eslint-disable jira/filename-case */ 
var $fg6Qq = parcelRequire("fg6Qq");
var $cyWbF = parcelRequire("cyWbF");

var $gXrrn = parcelRequire("gXrrn");
class $7fb7b9ad2c8cd2b3$export$e15350ade5fb9457 {
    constructor({ cookieKey: cookieKey, windowSize: windowSize = 15, threshold: threshold = 0.1, keepOpenCount: keepOpenCount = 100, halfOpenForCount: halfOpenForCount = 10, version: // version is only required when setting the cookie (i.e client side)
    version = 0 }){
        this.cookieKey = cookieKey;
        this.windowSize = windowSize > 29 ? 29 : windowSize;
        // eslint-disable-next-line no-bitwise
        this.windowMask = (1 << this.windowSize) - 1;
        this.threshold = threshold;
        this.halfOpenForCount = halfOpenForCount;
        this.keepOpenCount = keepOpenCount;
        this.version = version;
        const existingCookie = (0, $gXrrn.getCookie)(`cb_${cookieKey}`, true);
        if (existingCookie) this.cookieData = this.parseCookieData(existingCookie);
        else this.cookieData = {
            numberRepresentation: 0,
            counter: 0,
            windowLength: 0,
            version: version
        };
    }
    parseCookieData(cookieValue) {
        try {
            const [encodedWindow, stringWindowLength, stringCount, stringVersion] = cookieValue.split('|');
            const parsedNumberRepresentation = Number.parseInt(encodedWindow ?? '', 36);
            const numberRepresentation = !Number.isNaN(parsedNumberRepresentation) ? parsedNumberRepresentation : 0;
            const parsedCounter = Number.parseInt(stringCount ?? '', 36);
            const counter = !Number.isNaN(parsedCounter) ? parsedCounter : 0;
            const parsedWindowLength = Number.parseInt(stringWindowLength ?? '', 36);
            const windowLength = !Number.isNaN(parsedWindowLength) ? parsedWindowLength : 0;
            const parsedVersion = Number.parseInt(stringVersion ?? '', 36);
            const version = !Number.isNaN(parsedVersion) ? parsedVersion : 0;
            return {
                numberRepresentation: numberRepresentation,
                counter: counter,
                windowLength: windowLength,
                version: version
            };
        } catch (error) {
            // Return default data if parsing fails
            return {
                numberRepresentation: 0,
                counter: 0,
                windowLength: 0,
                version: this.version
            };
        }
    }
    serializeForCookie() {
        const encodedWindow = this.cookieData.numberRepresentation.toString(36);
        const stringCount = this.cookieData.counter.toString(36);
        const windowLength = this.cookieData.windowLength.toString(36);
        const version = this.cookieData.version.toString(36);
        return `${encodedWindow}|${windowLength}|${stringCount}|${version}`;
    }
    saveToCookie() {
        (0, $cyWbF.setStrictlyNecessaryCookie)(`cb_${this.cookieKey}`, this.serializeForCookie(), {
            expires: 14,
            secure: true,
            sameSite: 'strict'
        });
    }
    resetCookieIfVersionMismatch() {
        if (this.cookieData.version !== this.version) {
            (0, $fg6Qq.deleteCookie)(`cb_${this.cookieKey}`);
            this.cookieData = {
                numberRepresentation: 0,
                counter: 0,
                windowLength: 0,
                version: this.version
            };
            return true;
        }
        return false;
    }
    addResultToWindow(result) {
        // eslint-disable-next-line no-bitwise
        this.cookieData.numberRepresentation <<= 1; // Shift left by 1
        /**
		 * For PASS, we bitwise OR with 1 to "add" 1 to the least-significant bit
		 * For FAIL, we bitwise OR with 0 which will be no-op - the LSB will already be 0 after the shift left above
		 */ // eslint-disable-next-line no-bitwise
        this.cookieData.numberRepresentation |= result === 'PASS' ? 1 : 0;
        /**
		 * Truncate to the window size using bitwise AND
		 *
		 * This is the equivalent operation to this (if it was an array):
		 *
		 * ```
		 * if (numberRepresentationAsArray.length > this.windowSize) {
		 * 	   // in this analogy, the end of the array is the most significant bit.
		 *     numberRepresentationAsArray.pop();
		 * }
		 * ```
		 */ // eslint-disable-next-line no-bitwise
        this.cookieData.numberRepresentation &= this.windowMask;
        /**
		 * Only increase the windowLength if it is under the windowSize
		 *
		 * We don't increase when it is equal because the truncation we just did above
		 * will keep it at windowLength = windowSize.
		 *
		 * We need to keep track of windowLength separately because we cannot derive it
		 * from the numberRepresentation when the oldest value in the window is 0.
		 * i.e the numeric representation of 00000001 is the same as 1 - but they have a different
		 * meaning here.
		 */ if (this.cookieData.windowLength < this.windowSize) this.cookieData.windowLength++;
        else this.cookieData.windowLength = this.windowSize;
    }
    incrementOrResetOpenCounter() {
        if (this.cookieData.counter >= this.keepOpenCount + this.halfOpenForCount) this.cookieData.counter = 0;
        else this.cookieData.counter++;
    }
    recordFailure() {
        return this.recordResult('FAIL');
    }
    recordPass() {
        return this.recordResult('PASS');
    }
    recordResult(result) {
        const state = this.getState();
        switch(state.state){
            case 'CLOSED':
                this.addResultToWindow(result);
                // reset the counter when circuit is closed
                this.cookieData.counter = 0;
                break;
            case 'OPEN':
                this.cookieData.counter++;
                break;
            case 'HALF_OPEN':
                this.incrementOrResetOpenCounter();
                this.addResultToWindow(result);
                break;
            default:
                throw new Error(`Unknown state: ${state}`);
        }
        this.saveToCookie();
        return state;
    }
    getWindowSize() {
        return this.windowSize;
    }
    getKey() {
        return this.cookieKey;
    }
    isAtWindowSize() {
        return this.cookieData.windowLength === this.windowSize;
    }
    getState() {
        /**
		 * To count the number of passes, we convert the number to a base 2 string and count the number of 1s.
		 *
		 * This is a simple way of doing it, and should be pretty quick because it uses a regexp literal
		 * it is only called once per page load regardless.
		 */ const onesAndZeroes = this.cookieData.numberRepresentation.toString(2);
        const pass = onesAndZeroes.match(/1/g)?.length ?? 0;
        const fail = this.cookieData.windowLength - pass;
        const ratio = this.cookieData.windowLength > 0 ? pass / this.cookieData.windowLength : 1;
        let state = 'CLOSED';
        if (this.isAtWindowSize() && ratio < 1 - this.threshold) {
            if (this.cookieData.counter > this.keepOpenCount && this.cookieData.counter <= this.keepOpenCount + this.halfOpenForCount) state = 'HALF_OPEN';
            else state = 'OPEN';
        }
        return {
            state: state,
            pass: pass,
            fail: fail,
            ratio: ratio,
            count: this.cookieData.counter,
            version: this.cookieData.version
        };
    }
}
$7fb7b9ad2c8cd2b3$export$e15350ade5fb9457.displayName = "CookieCircuitBreaker";

});
parcelRegister("fg6Qq", function(module, exports) {
$parcel$export(module.exports, "deleteCookie", () => $53fa58ab0b608b2e$export$b43e45590305ffaa);

var $8BEEb = parcelRequire("8BEEb");

var $egspI = parcelRequire("egspI");

var $2rFtA = parcelRequire("2rFtA");

var $j1sAG = parcelRequire("j1sAG");
const $53fa58ab0b608b2e$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $egspI.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($8BEEb))).remove(key, attributes);
    else try {
        (0, $2rFtA.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8BEEb))).remove(key, attributes);
    } catch (e) {
        (0, $j1sAG.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
    }
};

});




parcelRegister("hNjtc", function(module, exports) {
$parcel$export(module.exports, "markSSRFailure", () => $147ae87059e38260$export$d4ee68e1ba090b4a);
/* eslint-disable jira/filename-case */ 
var $gXtG2 = parcelRequire("gXtG2");
let $147ae87059e38260$var$ssrFailedMarker = false;
let $147ae87059e38260$var$failedMarkers = new Set();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $147ae87059e38260$var$ssrFailedMarker = false;
    $147ae87059e38260$var$failedMarkers = new Set();
});
const $147ae87059e38260$export$d4ee68e1ba090b4a = (fallbackId)=>{
    $147ae87059e38260$var$ssrFailedMarker = true;
    if (fallbackId != null) $147ae87059e38260$var$failedMarkers.add(fallbackId);
};
const $147ae87059e38260$export$cd0770bef9153db4 = ()=>$147ae87059e38260$var$ssrFailedMarker;
const $147ae87059e38260$export$72a2677536e2f0c1 = ()=>$147ae87059e38260$var$failedMarkers;

});

parcelRegister("2qS33", function(module, exports) {
$parcel$export(module.exports, "FallbackIndicator", () => $436e5bc4aaa0ed33$export$e975518239643357);

var $k5P9q = parcelRequire("k5P9q");

var $1fGeu = parcelRequire("1fGeu");
const $436e5bc4aaa0ed33$export$e975518239643357 = ({ reportToSlackChannel: reportToSlackChannel, fallbackId: fallbackId, displayErrorInStaging: displayErrorInStaging, isCookieCircuitBreakerFailure: isCookieCircuitBreakerFailure, cookieKey: cookieKey })=>{
    const isStagingOrDevOrLocal = (0, $k5P9q.useIsStagingOrDevOrLocal)();
    if (false) {
        if (displayErrorInStaging && isStagingOrDevOrLocal) (0, $1fGeu.pushSSRFailureDisplay)({
            reportToSlackChannel: reportToSlackChannel,
            fallbackId: fallbackId,
            displayErrorInStaging: displayErrorInStaging,
            isCookieCircuitBreakerFailure: isCookieCircuitBreakerFailure,
            cookieKey: cookieKey
        });
    }
    return null;
};
$436e5bc4aaa0ed33$export$e975518239643357.displayName = "FallbackIndicator";
$436e5bc4aaa0ed33$export$e975518239643357.displayName = 'FallbackIndicator';

});
parcelRegister("k5P9q", function(module, exports) {
$parcel$export(module.exports, "useEnvironment", () => $cf4e80e005198d32$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $cf4e80e005198d32$export$b0d8f74f433a09c9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $cf4e80e005198d32$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $cf4e80e005198d32$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext?.environment || $cf4e80e005198d32$var$ENVIRONMENT.PROD;
};
const $cf4e80e005198d32$export$b0d8f74f433a09c9 = ()=>{
    const env = $cf4e80e005198d32$export$ea7ed2425832167d();
    return env === $cf4e80e005198d32$var$ENVIRONMENT.STAGING || env === $cf4e80e005198d32$var$ENVIRONMENT.DEV || env === $cf4e80e005198d32$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("1fGeu", function(module, exports) {
$parcel$export(module.exports, "pushSSRFailureDisplay", () => $bbdf60648954b795$export$b6724ee8b0fffc36);
$parcel$export(module.exports, "useServerEventsSSRFailureDisplays", () => $bbdf60648954b795$export$bd8e8aad41319c32);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $b8Dvw = parcelRequire("b8Dvw");

var $hfZ0x = parcelRequire("hfZ0x");
const $bbdf60648954b795$var$SSR_EVENT = 'ssr-failure-display';
const $bbdf60648954b795$export$b6724ee8b0fffc36 = (failureProps)=>{
    (0, $b8Dvw.registerEvent)({
        id: $bbdf60648954b795$var$SSR_EVENT,
        name: 'onSSRFailureDisplay',
        args: [
            failureProps
        ]
    });
};
const $bbdf60648954b795$export$bd8e8aad41319c32 = ()=>{
    const [ssrFailureDisplays, setSSRFailureDisplays] = (0, $euxye.useState)(new Map());
    const onSSRFailureDisplay = (0, $euxye.useCallback)((failureProps)=>{
        setSSRFailureDisplays((prev)=>{
            if (failureProps.fallbackId) {
                const newMap = new Map(prev);
                newMap.set(failureProps.fallbackId, failureProps);
                return newMap;
            }
            return prev;
        });
    }, []);
    (0, $euxye.useEffect)(()=>{
        (0, $hfZ0x.getClientDispatcher)().register($bbdf60648954b795$var$SSR_EVENT, onSSRFailureDisplay);
        return ()=>{
            (0, $hfZ0x.getClientDispatcher)().unregister($bbdf60648954b795$var$SSR_EVENT);
        };
    }, [
        onSSRFailureDisplay
    ]);
    return ssrFailureDisplays;
};

});


parcelRegister("aMROb", function(module, exports) {
$parcel$export(module.exports, "detectionBoundary", () => $85ef9244b61a3095$export$1b1634ba80d39e40);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");
const $85ef9244b61a3095$export$1b1634ba80d39e40 = /*#__PURE__*/ (0, $euxye.createContext)(true);

});



parcelRegister("grAIU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("iBVaq")
]).then(()=>parcelRequire('98cNG'));

});



parcelRegister("gqz9K", function(module, exports) {
$parcel$export(module.exports, "addonsEmceePublicRouteEntry", () => $bd3b1833a67dc3be$export$7922e0b87a833c8e);
/* eslint-disable import/order */ 


var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $hFYSn = parcelRequire("hFYSn");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $gV7Ha = parcelRequire("gV7Ha");
const $bd3b1833a67dc3be$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $bd3b1833a67dc3be$export$7922e0b87a833c8e = (0, $g1GqA.createLegacyEntry)((0, $gV7Ha.addonsEmceePublicRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0),
            menuId: (0, $2ab82cb6568ef9ea$export$e20d1bc819761c4c)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            ...(0, $hFYSn.getNavigationSidebarGlobalSettingsResources)()
        ],
        entryPoint: ()=>$bd3b1833a67dc3be$var$pageEntryPoint
    }));

});
const $2ab82cb6568ef9ea$export$e20d1bc819761c4c = 'ADDONS';

const $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0 = 'GLOBAL_APPS_SETTINGS';

parcelRegister("l8oxB", function(module, exports) {
$parcel$export(module.exports, "legacyPageEntrypoint", () => $97f76f93b02ff698$export$940b6ffb7ea59cb);

var $fiVog = parcelRequire("fiVog");

var $b3tU7 = parcelRequire("b3tU7");

const $97f76f93b02ff698$export$940b6ffb7ea59cb = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("lejuw")), {
        moduleId: "c50a245f",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lejuw", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("cOhj3").then(()=>parcelRequire('8nFHS'));

});


parcelRegister("dTa0V", function(module, exports) {
$parcel$export(module.exports, "createChromelessEntryPoint", () => $fcf73773d0f21be7$export$56ea489e9d4bfa04);
$parcel$export(module.exports, "createPageEntryPoint", () => $fcf73773d0f21be7$export$955a7619d2679b4c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6kcj4 = parcelRequire("6kcj4");


var $i860n = parcelRequire("i860n");

var $53DCS = parcelRequire("53DCS");
const $fcf73773d0f21be7$export$56ea489e9d4bfa04 = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    ...(0, $i860n.fg)('jpx-463-spa-relay-query') ? {
                        [(0, $b666e36d39b806ff$export$22ce74854c620e75)]: {
                            entryPoint: (0, $6kcj4.spaEntryPoint),
                            entryPointParams: entryPointParams,
                            options: {
                                fetchPolicy: 'store-or-network'
                            }
                        }
                    } : undefined,
                    [(0, $b666e36d39b806ff$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    }
                }
            }),
        toString: ()=>'ChromelessEntryPoint'
    });
const $fcf73773d0f21be7$export$955a7619d2679b4c = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    ...(0, $i860n.fg)('jpx-463-spa-relay-query') ? {
                        [(0, $b666e36d39b806ff$export$22ce74854c620e75)]: {
                            entryPoint: (0, $6kcj4.spaEntryPoint),
                            entryPointParams: entryPointParams,
                            options: {
                                fetchPolicy: 'store-or-network'
                            }
                        }
                    } : undefined,
                    [(0, $b666e36d39b806ff$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    },
                    [(0, $b666e36d39b806ff$export$bec6dca2e63de4ae)]: {
                        entryPoint: (0, $53DCS.topNavEntryPoint),
                        entryPointParams: entryPointParams
                    },
                    ...page.leftSidebar ? {
                        [(0, $b666e36d39b806ff$export$50ea883ba6f28ff5)]: {
                            entryPoint: page.leftSidebar.sidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                entryPoints: {
                                    ...page.leftSidebar.entryPoints ? $fcf73773d0f21be7$var$injectEntryPointParams(page.leftSidebar.entryPoints, entryPointParams) : undefined
                                },
                                isAppsExpanded: page.leftSidebar.isAppsExpanded ?? false,
                                isFiltersExpanded: page.leftSidebar.isFiltersExpanded ?? false,
                                isPlansExpanded: page.leftSidebar.isPlansExpanded ?? false,
                                isProjectsExpanded: page.leftSidebar.isProjectsExpanded ?? false,
                                isOperationsExpanded: page.leftSidebar.isOperationsExpanded ?? false
                            }
                        }
                    } : undefined,
                    ...page.previewPanel && (0, $i860n.fg)('nin_glance_panel_technical_changes') ? {
                        [(0, $b666e36d39b806ff$export$a9102b57dfd6b2a3)]: {
                            entryPoint: page.previewPanel,
                            entryPointParams: entryPointParams
                        }
                    } : undefined,
                    ...page.horizontalNavigation ? {
                        [(0, $b666e36d39b806ff$export$948d4d345566aed3)]: {
                            entryPoint: page.horizontalNavigation,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.horizontalNavigationFallback
                            }
                        }
                    } : undefined,
                    ...page.rightSidebar ? {
                        [(0, $b666e36d39b806ff$export$7bf43119a6b49ddb)]: {
                            entryPoint: page.rightSidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.rightSidebarFallback
                            }
                        }
                    } : undefined,
                    ...page.redirect ? {
                        [(0, $b666e36d39b806ff$export$5ef29550cd5a8266)]: {
                            entryPoint: page.redirect,
                            entryPointParams: entryPointParams
                        }
                    } : undefined
                }
            }),
        toString: ()=>'PageEntryPoint'
    });
function $fcf73773d0f21be7$var$injectEntryPointParams(obj, entryPointParams) {
    const newParams = {};
    // https://stackoverflow.com/a/16735184
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) newParams[prop] = {
        entryPoint: obj[prop].entryPoint,
        entryPointParams: entryPointParams
    };
    return newParams;
}

});
parcelRegister("6kcj4", function(module, exports) {
$parcel$export(module.exports, "spaEntryPoint", () => $6a052eb4040a0840$export$e280f2842b7ca512);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $6IHMU = parcelRequire("6IHMU");

const $6a052eb4040a0840$export$e280f2842b7ca512 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("8oBMU")), {
        moduleId: "78c6e385",
        moduleName: "JiraSpaPageContainerEntry",
        priority: "userVisible",
        /* eslint-disable-line jira/entry-fs/restrict-shell-only-to-navigation-apps */ includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: (props)=>({
            queries: {
                queryReference: {
                    parameters: (0, $6IHMU.default),
                    variables: {
                        cloudId: props?.tenantContext?.cloudId
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("8oBMU", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");


module.exports = Promise.all([
    (parcelRequire("gZgW8"))('navx_onboarding_universal_create_in_jira', function() {
        return Promise.all([
            $4cvLQ("27fFF")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("hJyTq")
        ]);
    }),
    (parcelRequire("gZgW8"))('navx-global-side-nav', function() {
        return Promise.all([
            $4cvLQ("7FBcr"),
            $4cvLQ("4Smn9"),
            $4cvLQ("hc93Z")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("54wGu"),
            $4cvLQ("4Smn9"),
            $4cvLQ("hc93Z")
        ]);
    }),
    $4cvLQ("a36Wj"),
    $4cvLQ("elvlF"),
    $4cvLQ("5qC72"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("laS8v")
]).then(()=>parcelRequire('29s1c'));

});


/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $b666e36d39b806ff$export$a9102b57dfd6b2a3 = '__pageLayoutPreviewPanel';
const $b666e36d39b806ff$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $b666e36d39b806ff$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $b666e36d39b806ff$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $b666e36d39b806ff$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $b666e36d39b806ff$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';
const $b666e36d39b806ff$export$5ef29550cd5a8266 = '___pageLayoutRedirect';
const $b666e36d39b806ff$export$22ce74854c620e75 = '__pageLayoutSpaContent';

parcelRegister("53DCS", function(module, exports) {
$parcel$export(module.exports, "topNavEntryPoint", () => $d7b4c25e134b447c$export$461b9b579186dbbc);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $d7b4c25e134b447c$export$461b9b579186dbbc = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("e5otd")), {
        moduleId: "36cb82fe",
        moduleName: "TopNavigation",
        priority: "userVisible",
        includeInShellOnlySsrBundle: true,
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("g1GqA", function(module, exports) {
$parcel$export(module.exports, "createLegacyEntry", () => $e7ba3df3141db787$export$3ee7de8548f88c5f);

var $4s81o = parcelRequire("4s81o");
const $e7ba3df3141db787$export$3ee7de8548f88c5f = (0, $4s81o.createRouteEntry);

});

parcelRegister("gV7Ha", function(module, exports) {
$parcel$export(module.exports, "addonsEmceePublicRoute", () => $5f22a8cd5a3d42e7$export$9f7bcf70c66ebed0);
const $5f22a8cd5a3d42e7$export$9f7bcf70c66ebed0 = {
    name: 'addons-emcee-public',
    path: '/plugins/servlet/ac/com.atlassian.jira.emcee/enduser-discover'
};

});


parcelRegister("7JnwO", function(module, exports) {
$parcel$export(module.exports, "legacyAllReportsRouteEntry", () => $d59da962ff35cde0$export$b8ab848c3f170ed4);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $g7VL7 = parcelRequire("g7VL7");

var $dTa0V = parcelRequire("dTa0V");

var $3KSG6 = parcelRequire("3KSG6");

var $l8oxB = parcelRequire("l8oxB");

var $aBfKq = parcelRequire("aBfKq");
const $d59da962ff35cde0$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $d59da962ff35cde0$export$b8ab848c3f170ed4 = (0, $g1GqA.createLegacyEntry)((0, $g7VL7.legacyAllReportsRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $aBfKq.getReportsCommonResource)()
        ],
        entryPoint: ()=>$d59da962ff35cde0$var$pageEntryPoint
    }));

});
const $0c5c27da6f710ef9$export$8f36d687159615f5 = 'PROJECTS';

parcelRegister("hdZjx", function(module, exports) {
$parcel$export(module.exports, "getBusinessProjectResources", () => $2c831c72ad088c3f$export$20e8c2951e444b08);
$parcel$export(module.exports, "getProjectViewResources", () => $2c831c72ad088c3f$export$fcbe882e18ee4a35);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $9T5Cr = parcelRequire("9T5Cr");

var $oXLtZ = parcelRequire("oXLtZ");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $gZWlI = parcelRequire("gZWlI");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");
const $2c831c72ad088c3f$export$20e8c2951e444b08 = ()=>[
        // eslint-disable-next-line camelcase
        (0, $oXLtZ.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $gZWlI.projectThemeResource)
    ];
const $2c831c72ad088c3f$export$fcbe882e18ee4a35 = ()=>[
        ...$2c831c72ad088c3f$export$20e8c2951e444b08(),
        ...(0, $dUAVJ.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
        // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
        (0, $edf7u.projectContextResource),
        (0, $hFYSn.forgeProjectModuleResource),
        (0, $idDnR.staticProjectSidebarNavigationResource),
        (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $9T5Cr.fieldsResource)
    ];

});
parcelRegister("9T5Cr", function(module, exports) {
$parcel$export(module.exports, "fieldsResource", () => $6ec3c8291a3541e9$export$8bca6c1954ae9308);
$parcel$export(module.exports, "useFieldsResource", () => $6ec3c8291a3541e9$export$c0cd85886917fe89);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* eslint-disable jira/import/no-restricted-import */ 
var $i0CFV = parcelRequire("i0CFV");

var $StYCc = parcelRequire("StYCc");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");


var $6O5rx = parcelRequire("6O5rx");

var $ljreg = parcelRequire("ljreg");
const $6ec3c8291a3541e9$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6ec3c8291a3541e9$var$handleProjectResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, $StYCc.GraphQLErrors)(response.errors);
    return (0, $ljreg.transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
};
const $6ec3c8291a3541e9$export$8bca6c1954ae9308 = (0, $7edbf.createResource)({
    type: $6ec3c8291a3541e9$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$6ec3c8291a3541e9$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        return (0, $6O5rx.fetchFields)((0, $4a700be398578a7a$export$4d41378da3f70f0f), $6ec3c8291a3541e9$var$handleProjectResponse, {
            cloudId: cloudId,
            jqlContext: `project = '${projectIdOrKey}'`
        });
    },
    maxAge: 3600000
});
const $6ec3c8291a3541e9$export$c0cd85886917fe89 = ()=>(0, $k6ufm.useResource)($6ec3c8291a3541e9$export$8bca6c1954ae9308);

});
parcelRegister("StYCc", function(module, exports) {
$parcel$export(module.exports, "GraphQLErrors", () => $0e4f05b41870975b$export$89c202e66b2de2b6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $ejbxN = parcelRequire("ejbxN");

var $jOlpf = parcelRequire("jOlpf");
// Sets the error message on this error according to the
// the GraphQL errors that are present.
const $0e4f05b41870975b$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($jOlpf)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `${errorMessage}\n`;
    });
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $0e4f05b41870975b$export$89c202e66b2de2b6 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = graphQLErrors != null ? (0, (/*@__PURE__*/$parcel$interopDefault($ejbxN)))(graphQLErrors) : [];
        this.message = $0e4f05b41870975b$var$generateErrorMessage(this);
        this.cause = this.graphQLErrors?.[0];
        this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
        this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
    }
}
$0e4f05b41870975b$export$89c202e66b2de2b6.displayName = "GraphQLErrors";

});
parcelRegister("ejbxN", function(module, exports) {

var $jOlpf = parcelRequire("jOlpf");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $a6abcb72a26c180b$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $jOlpf(value) ? value : [
        value
    ];
}
module.exports = $a6abcb72a26c180b$var$castArray;

});


/* eslint-disable jira/filename-case */ const $4a700be398578a7a$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;

parcelRegister("6O5rx", function(module, exports) {
$parcel$export(module.exports, "fetchFields", () => $37fc9d6c8898476b$export$f3ddd735c360919);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $6CfY5 = parcelRequire("6CfY5");

var $h2wCv = parcelRequire("h2wCv");
const $37fc9d6c8898476b$var$PAGE_SIZE = 100;
const $37fc9d6c8898476b$export$f3ddd735c360919 = async (query, handler, params)=>{
    try {
        const promise = (0, $h2wCv.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: $37fc9d6c8898476b$var$PAGE_SIZE,
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return await handler(promise);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'fieldsResource',
                packageName: 'jiraRouterResourcesBusinessFields',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});

parcelRegister("ljreg", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $b9069189a034716d$export$3ceb62baab058c6b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $b9069189a034716d$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);

});


parcelRegister("oXLtZ", function(module, exports) {
$parcel$export(module.exports, "DEPRECATED_DO_NOT_USE_projectDetailsResource", () => $9ed210e74349df1f$export$ced53bf9d9551fef);
$parcel$export(module.exports, "useProject_DEPRECATED_DO_NOT_USE", () => $9ed210e74349df1f$export$97def3841413167f);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/filename-case, camelcase, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $aPBUo = parcelRequire("aPBUo");
const $9ed210e74349df1f$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $9ed210e74349df1f$export$ced53bf9d9551fef = (0, $7edbf.createResource)({
    type: $9ed210e74349df1f$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$9ed210e74349df1f$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        return (0, $aPBUo.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $9ed210e74349df1f$export$97def3841413167f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $k6ufm.useResource)($9ed210e74349df1f$export$ced53bf9d9551fef);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};

});
parcelRegister("aPBUo", function(module, exports) {
$parcel$export(module.exports, "fetchProjectDetails", () => $38f4592832348c19$export$78aa221476efa1c6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $i8BNs = parcelRequire("i8BNs");

var $6CfY5 = parcelRequire("6CfY5");

var $h2wCv = parcelRequire("h2wCv");


var $1X0iD = parcelRequire("1X0iD");
const $38f4592832348c19$var$EMPTY_VALUE = {};
const $38f4592832348c19$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $h2wCv.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $2f87a16051755ba2$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $i8BNs.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: projectId
                    }).toString() : ''
                }
            })
        });
        return (0, $1X0iD.transformData)(response.data, projectIdOrKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $38f4592832348c19$var$EMPTY_VALUE;
};

});
parcelRegister("i8BNs", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAri", () => $d3464af9cca8b706$export$75a0a0a7cb0a58ae);

var $9HGCW = parcelRequire("9HGCW");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/project/manifest.ts
var $d3464af9cca8b706$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $9HGCW.JiraProjectAriResourceOwner),
    resourceType: (0, $9HGCW.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $d3464af9cca8b706$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d3464af9cca8b706$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $d3464af9cca8b706$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d3464af9cca8b706$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $d3464af9cca8b706$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $d3464af9cca8b706$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $d3464af9cca8b706$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("9HGCW", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $71093215bbc1f5db$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $71093215bbc1f5db$export$736763838d3aa22e);
// src/jira/project/types.ts
var $71093215bbc1f5db$export$99d538a3b04916b1 = "jira", $71093215bbc1f5db$export$736763838d3aa22e = "project";

});


/* eslint-disable jira/filename-case */ const $2f87a16051755ba2$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $2f87a16051755ba2$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
  }
}
${$2f87a16051755ba2$var$PROJECT_FRAGMENT}
`;

parcelRegister("1X0iD", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $72b2cffcecf8972c$export$3ceb62baab058c6b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $72b2cffcecf8972c$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $72b2cffcecf8972c$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        currentProject: $72b2cffcecf8972c$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $72b2cffcecf8972c$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey
    });

});



parcelRegister("gZWlI", function(module, exports) {
$parcel$export(module.exports, "projectThemeResource", () => $cadcc0cfdcafdb09$export$84730adce8987203);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5mxNm = parcelRequire("5mxNm");

var $i0CFV = parcelRequire("i0CFV");

var $i860n = parcelRequire("i860n");

var $htsFl = parcelRequire("htsFl");

var $53aLO = parcelRequire("53aLO");
const $cadcc0cfdcafdb09$export$84730adce8987203 = (0, $53aLO.withGiraAggAnonSsrFix)((0, $htsFl.createRelayResource)({
    type: 'JIRA_PROJECT_THEME',
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $5mxNm.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectKey ?? projectId ?? '',
                withHarmonisedTheme: true,
                withPersistDominantColor: (0, $i860n.fg)('th-102-persist-dominant-colour')
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    },
    isCritical: true
}));

});
parcelRegister("5mxNm", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f82fed8c2a50914$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5fa9992cab44f0fc8e848a4649e15211>>
 * @relayHash 911f7e6475259ca9226b417ce1d7a171
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73217ad492b967e01ebeed7cedf9991eec990162d13ac0a42beb8f9526209dd7

var $lIGkE = parcelRequire("lIGkE");
const $7f82fed8c2a50914$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "withHarmonisedTheme"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "withPersistDominantColor"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaClientId"
            },
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaExternalEndpointUrl"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "harmonisedTheme",
            "variableName": "withHarmonisedTheme"
        }
    ], v8 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v9 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v10 = {
        "alias": "canEditProjectConfig",
        "args": v8 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "condition": "withPersistDominantColor",
                "kind": "Condition",
                "passingValue": true,
                "selections": v9 /*: any*/ 
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ThemeSetterQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v3 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ThemeSetterBackground"
                                }
                            ]
                        },
                        {
                            "condition": "withPersistDominantColor",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "DominantColorPersister_project"
                                }
                            ]
                        },
                        v10 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ThemeSetterQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorValue"
                                        }
                                    ],
                                    "type": "JiraColorBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "gradientValue"
                                        }
                                    ],
                                    "type": "JiraGradientBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraCustomBackground",
                                            "kind": "LinkedField",
                                            "name": "customBackground",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaApiFileId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "durationInSeconds",
                                                            "value": 900
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "mediaReadToken",
                                                    "storageKey": "mediaReadToken(durationInSeconds:900)"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceIdentifier"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "altText"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "dominantColor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "brightness"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraMediaBackground"
                                }
                            ]
                        },
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "condition": "withPersistDominantColor",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": v9 /*: any*/ ,
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "73217ad492b967e01ebeed7cedf9991eec990162d13ac0a42beb8f9526209dd7",
            "metadata": {},
            "name": "ThemeSetterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7f82fed8c2a50914$var$node.hash = "101c6f15c07b63a71c2001f02f0e684a";
(0, $lIGkE.PreloadableQueryRegistry).set($7f82fed8c2a50914$var$node.params.id, $7f82fed8c2a50914$var$node);
var $7f82fed8c2a50914$export$2e2bcd8739ae039 = $7f82fed8c2a50914$var$node;

});

parcelRegister("53aLO", function(module, exports) {
$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $2346aa5a6a39a249$export$f4b29e78f4c0a526);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $2346aa5a6a39a249$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});



parcelRegister("dvtoW", function(module, exports) {
$parcel$export(module.exports, "genericProjectLayout", () => $eabeda6c7471a15b$export$85dad8e9886563f6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $fU8CV = parcelRequire("fU8CV");

var $QhQu4 = parcelRequire("QhQu4");

var $74h93 = parcelRequire("74h93");

var $3eysO = parcelRequire("3eysO");

var $dSYOQ = parcelRequire("dSYOQ");
const $eabeda6c7471a15b$export$85dad8e9886563f6 = (0, $QhQu4.composeLayouts)((0, $3eysO.classicSoftwareProjectLayout), (0, $fU8CV.coreProjectLayout), (0, $74h93.serviceProjectLayout), (0, $3eysO.softwareProjectLayout), (0, $dSYOQ.userBoardLayout));

});
parcelRegister("fU8CV", function(module, exports) {
$parcel$export(module.exports, "coreProjectLayout", () => $4e7c66a3c5f62ad5$export$3c06ced9943ca671);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lVzKq = parcelRequire("lVzKq");

var $QhQu4 = parcelRequire("QhQu4");
const $4e7c66a3c5f62ad5$export$3c06ced9943ca671 = (0, $QhQu4.composeLayouts)((0, $lVzKq.projectLayout));

});
parcelRegister("lVzKq", function(module, exports) {
$parcel$export(module.exports, "projectLayout", () => $d5aa3103333b69ed$export$204149bac601d20c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $gBYjj = parcelRequire("gBYjj");

var $QhQu4 = parcelRequire("QhQu4");

var $l8G1z = parcelRequire("l8G1z");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d5aa3103333b69ed$var$withAnyProjectContext = (Component)=>(0, $QhQu4.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: 'any'
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d5aa3103333b69ed$var$ProjectTrackers = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("khWHB")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-project-layout/src/ui/trackers/index.tsx"
});
const $d5aa3103333b69ed$var$rightSidebars = ()=>[];
const $d5aa3103333b69ed$var$globalComponents = [
    $d5aa3103333b69ed$var$withAnyProjectContext($d5aa3103333b69ed$var$ProjectTrackers),
    $d5aa3103333b69ed$var$withAnyProjectContext((0, $gBYjj.ProjectRouteListener))
];
const $d5aa3103333b69ed$export$204149bac601d20c = (0, $QhQu4.createLayout)({
    globalComponents: $d5aa3103333b69ed$var$globalComponents,
    rightSidebars: $d5aa3103333b69ed$var$rightSidebars()
});

});
parcelRegister("gBYjj", function(module, exports) {
$parcel$export(module.exports, "ProjectRouteListener", () => $0e06a4aa3ba79161$export$159f09d701320911);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $edf7u = parcelRequire("edf7u");

var $fNgVF = parcelRequire("fNgVF");

var $k6ufm = parcelRequire("k6ufm");

var $lpBPi = parcelRequire("lpBPi");
const $0e06a4aa3ba79161$export$159f09d701320911 = ()=>{
    const isSiteAdmin = (0, $fNgVF.useIsAdmin)();
    const { data: data, loading: loading } = (0, $k6ufm.useResource)((0, $edf7u.projectContextResource));
    (0, $euxye.useEffect)(()=>{
        if (isSiteAdmin) (0, $lpBPi.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: true
        });
        else if (data != null) (0, $lpBPi.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: data.isProjectAdmin
        });
        else (0, $lpBPi.setIsProjectAdmin)({
            loading: loading,
            isProjectAdmin: null
        });
    }, [
        data,
        loading,
        isSiteAdmin
    ]);
    // Cleanup when component is unmounted. This means we are no longer in a project route
    (0, $euxye.useEffect)(()=>()=>(0, $lpBPi.setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: null
            }), []);
    return null;
};
$0e06a4aa3ba79161$export$159f09d701320911.displayName = "ProjectRouteListener";

});
parcelRegister("fNgVF", function(module, exports) {
$parcel$export(module.exports, "useIsAdmin", () => $dd6cfe4a659f4b74$export$99a5e4bc80d231ca);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eijVy = parcelRequire("eijVy");
const $dd6cfe4a659f4b74$export$99a5e4bc80d231ca = ()=>{
    const tenantContext = (0, $eijVy.useTenantContext)();
    return tenantContext && tenantContext.isAdmin || false;
};

});


parcelRegister("khWHB", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i1n0f").then(()=>parcelRequire('8FSF0'));

});



parcelRegister("74h93", function(module, exports) {
$parcel$export(module.exports, "serviceProjectLayout", () => $44fa6fd16185f126$export$e321cb31c875d1ba);
$parcel$export(module.exports, "rightSidebarsLayout", () => $44fa6fd16185f126$export$820f9bb834280408);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $i860n = parcelRequire("i860n");

var $aWliK = parcelRequire("aWliK");

var $h2tgz = parcelRequire("h2tgz");

var $dllN1 = parcelRequire("dllN1");

var $2HVE2 = parcelRequire("2HVE2");

var $lVzKq = parcelRequire("lVzKq");

var $QhQu4 = parcelRequire("QhQu4");

var $l8G1z = parcelRequire("l8G1z");

var $jepRN = parcelRequire("jepRN");

var $2GQ8g = parcelRequire("2GQ8g");

var $lp24J = parcelRequire("lp24J");

var $geeJ4 = parcelRequire("geeJ4");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $44fa6fd16185f126$var$withServiceProjectContext = (Component)=>(0, $QhQu4.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $f99M0.SERVICE_DESK_PROJECT)
        }
    });
const $44fa6fd16185f126$var$AdaptiveLanguageGlobalGated = (0, $jepRN.componentWithFG)('jsm_adaptive_language_enabled', $44fa6fd16185f126$var$withServiceProjectContext((0, $2HVE2.AdaptiveLanguageGlobal)), ()=>null);
$44fa6fd16185f126$var$AdaptiveLanguageGlobalGated.displayName = 'AdaptiveLanguageGlobalGated';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $44fa6fd16185f126$var$ProjectBuilder = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("4CmB9")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-service-project-layout/src/ui/project-builder/ProjectBuilderWithQueryParam.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $44fa6fd16185f126$var$HrSpaceProjectOverlay = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("5gqRZ")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-service-project-layout/src/ui/hr-space-overlay/HrSpaceOverlay.tsx"
});
const $44fa6fd16185f126$var$HrSpaceProjectOverlayWhenGateOff = ()=>null;
$44fa6fd16185f126$var$HrSpaceProjectOverlayWhenGateOff.displayName = 'HrSpaceProjectOverlayWhenGateOff';
const $44fa6fd16185f126$var$GatedHrSpaceProjectOverlay = (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('is-hrsm-space-enabled'), $44fa6fd16185f126$var$withServiceProjectContext($44fa6fd16185f126$var$HrSpaceProjectOverlay), $44fa6fd16185f126$var$HrSpaceProjectOverlayWhenGateOff);
$44fa6fd16185f126$var$GatedHrSpaceProjectOverlay.displayName = 'GatedHrSpaceProjectOverlay';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $44fa6fd16185f126$var$Onboarding = (0, $l8G1z.lazy)(()=>(parcelRequire("9ZZ9z")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-service-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $44fa6fd16185f126$var$RightSidebars = (0, $l8G1z.lazy)(()=>(parcelRequire("4lLiV")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-service-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $44fa6fd16185f126$var$OnboardingWithPreload = ()=>{
    const shouldRender = (0, $lp24J.useOnboardingPreload)($44fa6fd16185f126$var$Onboarding);
    return shouldRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($44fa6fd16185f126$var$Onboarding, null) : null;
};
$44fa6fd16185f126$var$OnboardingWithPreload.displayName = "OnboardingWithPreload";
const $44fa6fd16185f126$var$OnboardingWithStatus = (0, $jepRN.componentWithFG)('servicedesk_onboarding_quickstart_enabled', $44fa6fd16185f126$var$OnboardingWithPreload, $44fa6fd16185f126$var$Onboarding);
$44fa6fd16185f126$var$OnboardingWithStatus.displayName = 'Lazy(ui/onboarding/index.tsx)';
const $44fa6fd16185f126$var$RightSidebarsWithPreload = ()=>{
    const shouldRender = (0, $geeJ4.useJsmRightSidebarsPreload)($44fa6fd16185f126$var$RightSidebars);
    return shouldRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($44fa6fd16185f126$var$RightSidebars, null) : null;
};
$44fa6fd16185f126$var$RightSidebarsWithPreload.displayName = "RightSidebarsWithPreload";
const $44fa6fd16185f126$var$RightSidebarsWithStatus = (0, $jepRN.componentWithFG)('servicedesk_onboarding_quickstart_enabled', $44fa6fd16185f126$var$RightSidebarsWithPreload, $44fa6fd16185f126$var$RightSidebars);
$44fa6fd16185f126$var$RightSidebarsWithStatus.displayName = 'Lazy(ui/right-sidebars/RightSidebars.tsx)';
const $44fa6fd16185f126$export$e321cb31c875d1ba = (0, $QhQu4.composeLayouts)((0, $lVzKq.projectLayout), {
    globalComponents: [
        $44fa6fd16185f126$var$withServiceProjectContext($44fa6fd16185f126$var$OnboardingWithStatus),
        $44fa6fd16185f126$var$withServiceProjectContext((0, $dllN1.AsyncJsmCustomDomainChangeBoardingFlag)),
        $44fa6fd16185f126$var$ProjectBuilder,
        (0, $2GQ8g.default),
        $44fa6fd16185f126$var$GatedHrSpaceProjectOverlay,
        $44fa6fd16185f126$var$AdaptiveLanguageGlobalGated
    ],
    rightSidebars: [
        $44fa6fd16185f126$var$withServiceProjectContext($44fa6fd16185f126$var$RightSidebarsWithStatus)
    ]
});
const $44fa6fd16185f126$export$820f9bb834280408 = (0, $QhQu4.composeLayouts)((0, $h2tgz.globalLayout), {
    rightSidebars: [
        $44fa6fd16185f126$var$RightSidebars
    ]
});

});
parcelRegister("dllN1", function(module, exports) {
$parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", () => $b6730699956f1b3a$export$b1ef5e3da6e1959d);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $gDou3 = parcelRequire("gDou3");

var $jWDKp = parcelRequire("jWDKp");

var $h8QGu = parcelRequire("h8QGu");

var $i860n = parcelRequire("i860n");

var $aWliK = parcelRequire("aWliK");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

var $Jpr33 = parcelRequire("Jpr33");

const $b6730699956f1b3a$var$LazyJsmCustomDomainChangeBoardingFlag = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("gqr8X")), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/JsmCustomDomainChangeBoardingFlag.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b6730699956f1b3a$var$LazyJsmCustomDomainChangeBoardingFlagNew = (0, $l8G1z.lazy)(()=>(parcelRequire("gqr8X")).then((exportedModule)=>exportedModule.JsmCustomDomainChangeBoardingFlagNew), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/JsmCustomDomainChangeBoardingFlag.tsx"
});
const $b6730699956f1b3a$var$MILLISECONDS_IN_A_DAY = 1440000;
const $b6730699956f1b3a$var$AsyncJsmCustomDomainChangeBoardingFlagOld = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b6730699956f1b3a$var$LazyJsmCustomDomainChangeBoardingFlag, null)));
};
$b6730699956f1b3a$var$AsyncJsmCustomDomainChangeBoardingFlagOld.displayName = "AsyncJsmCustomDomainChangeBoardingFlagOld";
const $b6730699956f1b3a$var$AsyncJsmCustomDomainChangeBoardingFlagNew = ()=>{
    const currentTime = Date.now();
    const [{ userSeenFlagDate: userSeenFlagDate, showFlagUpdateStartDate: showFlagUpdateStartDate, helpCenterUrls: helpCenterUrls, customDomainStatus: customDomainStatus }, { updateUserProperty: updateUserProperty, fetchApplicationProperty: fetchApplicationProperty, fetchSeenFlagDateProperty: fetchSeenFlagDateProperty }] = (0, $Jpr33.useProperties)();
    const fetchPropertiesRef = (0, $euxye.useRef)(()=>Promise.resolve([]));
    (0, $euxye.useEffect)(()=>{
        fetchPropertiesRef.current = ()=>Promise.all([
                fetchApplicationProperty(),
                fetchSeenFlagDateProperty()
            ]);
    }, [
        fetchApplicationProperty,
        fetchSeenFlagDateProperty
    ]);
    (0, $euxye.useEffect)(()=>{
        const fetchProperties = ()=>{
            Promise.resolve(fetchPropertiesRef.current()).catch(()=>undefined);
        };
        fetchProperties();
        const pollInterval = setInterval(fetchProperties, $b6730699956f1b3a$var$MILLISECONDS_IN_A_DAY);
        return ()=>clearInterval(pollInterval);
    }, []);
    if (helpCenterUrls === undefined || customDomainStatus === undefined) return null;
    if (userSeenFlagDate === (0, $Jpr33.NOT_LOADED) || showFlagUpdateStartDate === (0, $Jpr33.NOT_LOADED)) return null;
    if (showFlagUpdateStartDate === (0, $Jpr33.NO_VALUE)) return null;
    if ((0, $jWDKp.default)(new Date(currentTime), new Date(showFlagUpdateStartDate))) return null;
    if (userSeenFlagDate !== (0, $Jpr33.NO_VALUE) && (0, $gDou3.default)(new Date(userSeenFlagDate), new Date(showFlagUpdateStartDate))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($b6730699956f1b3a$var$LazyJsmCustomDomainChangeBoardingFlagNew, {
        helpCenterUrls: helpCenterUrls,
        customDomainStatus: customDomainStatus,
        onUpdateUserProperty: updateUserProperty
    })));
};
$b6730699956f1b3a$var$AsyncJsmCustomDomainChangeBoardingFlagNew.displayName = "AsyncJsmCustomDomainChangeBoardingFlagNew";
const $b6730699956f1b3a$export$b1ef5e3da6e1959d = (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)('ttai_fix_jsm_custom_domain_change_boarding_flag'), $b6730699956f1b3a$var$AsyncJsmCustomDomainChangeBoardingFlagNew, $b6730699956f1b3a$var$AsyncJsmCustomDomainChangeBoardingFlagOld);

});
parcelRegister("Jpr33", function(module, exports) {
$parcel$export(module.exports, "NOT_LOADED", () => $c01a0696a0f882e4$export$256d135b6d6cdabe);
$parcel$export(module.exports, "NO_VALUE", () => $c01a0696a0f882e4$export$d5a265bcf7e0ecc1);
$parcel$export(module.exports, "useProperties", () => $c01a0696a0f882e4$export$b003fb77901c7fe3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $siTdT = parcelRequire("siTdT");

var $kM0go = parcelRequire("kM0go");

var $h2wCv = parcelRequire("h2wCv");

var $eijVy = parcelRequire("eijVy");
const $c01a0696a0f882e4$var$USER_SEEN_FLAG_PROPERTY_KEY = 'jsm.custom.domain.flag.seen.date';
const $c01a0696a0f882e4$var$PACKAGE_NAME = 'jiraHelpCenterCustomDomainChangeBoarding';
const $c01a0696a0f882e4$var$TEAM_NAME = 'jsm-banana';
const $c01a0696a0f882e4$var$FETCH_USER_PROPERTY_ERROR_ID = 'fetchUserProperty';
const $c01a0696a0f882e4$var$UPDATE_USER_PROPERTY_ERROR_ID = 'updateUserProperty';
const $c01a0696a0f882e4$var$GET_SHOW_FLAG_DATE_ERROR_ID = 'getShowFlagDate';
const $c01a0696a0f882e4$export$256d135b6d6cdabe = 'NOT_LOADED';
const $c01a0696a0f882e4$export$d5a265bcf7e0ecc1 = 'NO_VALUE';
const $c01a0696a0f882e4$var$EXPECTED_ERROR_STATUS = [
    403,
    404
];
const $c01a0696a0f882e4$export$b003fb77901c7fe3 = ()=>{
    const currentTime = Date.now();
    const [loading, setLoading] = (0, $euxye.useState)(false);
    const [error, setError] = (0, $euxye.useState)(null);
    const [showFlagUpdateStartDate, setShowFlagUpdateStartDate] = (0, $euxye.useState)($c01a0696a0f882e4$export$256d135b6d6cdabe);
    const [helpCenterUrls, setHelpcenterUrls] = (0, $euxye.useState)(undefined);
    const [customDomainStatus, setCustomDomainStatus] = (0, $euxye.useState)(undefined);
    const [userSeenFlagDate, setUserSeenFlagDate] = (0, $euxye.useState)($c01a0696a0f882e4$export$256d135b6d6cdabe);
    const { atlassianAccountId: atlassianAccountId } = (0, $eijVy.useTenantContext)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleErrorLogging = (0, $euxye.useCallback)((operation, e)=>{
        setLoading(false);
        if (e.name === 'FetchError' && !$c01a0696a0f882e4$var$EXPECTED_ERROR_STATUS.includes(e.statusCode)) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: operation,
                    packageName: $c01a0696a0f882e4$var$PACKAGE_NAME,
                    teamName: $c01a0696a0f882e4$var$TEAM_NAME
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
            setError(e);
        }
    }, []);
    const fetchSeenFlagDateProperty = (0, $euxye.useCallback)(async ()=>{
        if (loading) return;
        if (atlassianAccountId && userSeenFlagDate === $c01a0696a0f882e4$export$256d135b6d6cdabe) {
            setLoading(true);
            try {
                const response = await (0, $kM0go.getUserProperty)(atlassianAccountId, $c01a0696a0f882e4$var$USER_SEEN_FLAG_PROPERTY_KEY);
                setLoading(false);
                setUserSeenFlagDate(Number(response));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                setUserSeenFlagDate($c01a0696a0f882e4$export$d5a265bcf7e0ecc1);
                handleErrorLogging($c01a0696a0f882e4$var$FETCH_USER_PROPERTY_ERROR_ID, e);
            }
        }
    }, [
        atlassianAccountId,
        handleErrorLogging,
        loading,
        userSeenFlagDate
    ]);
    const updateUserProperty = (0, $euxye.useCallback)(async ()=>{
        if (loading) return;
        if (atlassianAccountId) {
            setLoading(true);
            try {
                await (0, $kM0go.setUserProperties)(atlassianAccountId, $c01a0696a0f882e4$var$USER_SEEN_FLAG_PROPERTY_KEY, currentTime.toString());
                setLoading(false);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                handleErrorLogging($c01a0696a0f882e4$var$UPDATE_USER_PROPERTY_ERROR_ID, e);
            }
        }
    }, [
        atlassianAccountId,
        currentTime,
        handleErrorLogging,
        loading
    ]);
    const fetchApplicationProperty = (0, $euxye.useCallback)(async ()=>{
        if (loading) return;
        setLoading(true);
        try {
            const fetchStartTime = performance.now();
            const response = await (0, $h2wCv.performGetRequest)('/rest/servicedesk/1/customdomain');
            (0, $siTdT.addSpanToAll)('fetch', 'rest/servicedesk/1/customdomain', [
                {
                    name: 'network'
                }
            ], fetchStartTime, performance.now());
            const { startDate: startDate, newUrl: newUrl, oldUrl: oldUrl, status: status } = response;
            setLoading(false);
            setShowFlagUpdateStartDate(startDate);
            setHelpcenterUrls({
                newUrl: newUrl,
                oldUrl: oldUrl
            });
            setCustomDomainStatus(status);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            setShowFlagUpdateStartDate($c01a0696a0f882e4$export$d5a265bcf7e0ecc1);
            handleErrorLogging($c01a0696a0f882e4$var$GET_SHOW_FLAG_DATE_ERROR_ID, e);
        }
    }, [
        handleErrorLogging,
        loading
    ]);
    const memoisedData = (0, $euxye.useMemo)(()=>({
            userSeenFlagDate: userSeenFlagDate,
            showFlagUpdateStartDate: showFlagUpdateStartDate,
            helpCenterUrls: helpCenterUrls,
            customDomainStatus: customDomainStatus,
            loading: loading,
            error: error
        }), [
        userSeenFlagDate,
        showFlagUpdateStartDate,
        loading,
        error,
        helpCenterUrls,
        customDomainStatus
    ]);
    return [
        memoisedData,
        {
            fetchSeenFlagDateProperty: fetchSeenFlagDateProperty,
            updateUserProperty: updateUserProperty,
            fetchApplicationProperty: fetchApplicationProperty
        }
    ];
};

});

parcelRegister("gqr8X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("Rnxvl")
]).then(()=>parcelRequire('eEuZo'));

});


parcelRegister("2HVE2", function(module, exports) {
$parcel$export(module.exports, "AdaptiveLanguageGlobal", () => $e6d544b71691d628$export$55c0af67636fff35);

var $euxye = parcelRequire("euxye");

var $h2wCv = parcelRequire("h2wCv");

var $kt86l = parcelRequire("kt86l");

var $2b39L = parcelRequire("2b39L");

var $ggu1H = parcelRequire("ggu1H");
const $e6d544b71691d628$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $e6d544b71691d628$var$GLOSSARY_QUERY = `
  query jsmAdaptiveLanguageGlossary($projectAri: ID!) {
    jsmAdaptiveLanguage {
      glossaryForProject(projectAri: $projectAri) {
        glossary {
          domainId
          compiledGlossary
        }
      }
    }
  }
`;
function $e6d544b71691d628$export$55c0af67636fff35() {
    const cloudId = (0, $kt86l.useCloudId)();
    const { data: projectContext } = (0, $2b39L.useProjectContext)();
    const projectId = projectContext?.projectId;
    const abortRef = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        if (!projectId || !cloudId) {
            (0, $ggu1H.adaptiveLanguageStore).reset();
            return;
        }
        // Abort any in-flight request from previous project navigation
        abortRef.current?.abort();
        const controller = new AbortController();
        abortRef.current = controller;
        const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
        (0, $ggu1H.adaptiveLanguageStore).setState({
            domain: null,
            glossary: null,
            status: 'loading'
        });
        (0, $h2wCv.performPostRequest)($e6d544b71691d628$var$GRAPHQL_ENDPOINT, {
            body: JSON.stringify({
                query: $e6d544b71691d628$var$GLOSSARY_QUERY,
                variables: {
                    projectAri: projectAri
                }
            }),
            signal: controller.signal
        }).then((json)=>{
            const glossaryData = json.data?.jsmAdaptiveLanguage?.glossaryForProject?.glossary;
            if (!glossaryData?.domainId) {
                (0, $ggu1H.adaptiveLanguageStore).setState({
                    domain: null,
                    glossary: null,
                    status: 'ready'
                });
                return;
            }
            let glossary = null;
            try {
                glossary = glossaryData.compiledGlossary ? JSON.parse(glossaryData.compiledGlossary) : null;
            } catch  {
                glossary = null;
            }
            (0, $ggu1H.adaptiveLanguageStore).setState({
                domain: glossaryData.domainId,
                glossary: glossary,
                status: 'ready'
            });
        }).catch((err)=>{
            if (err.name === 'AbortError') return;
            (0, $ggu1H.adaptiveLanguageStore).setState({
                domain: null,
                glossary: null,
                status: 'error'
            });
        });
        return ()=>{
            controller.abort();
        };
    }, [
        projectId,
        cloudId
    ]);
    // Headless — renders nothing
    return null;
}
$e6d544b71691d628$export$55c0af67636fff35.displayName = "AdaptiveLanguageGlobal";

});
parcelRegister("2b39L", function(module, exports) {
$parcel$export(module.exports, "useProjectContext", () => $0f8c1b9d3f2c872d$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $0f8c1b9d3f2c872d$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $0f8c1b9d3f2c872d$export$a85f6b5857d2176);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $d7dm3 = parcelRequire("d7dm3");

var $edf7u = parcelRequire("edf7u");
const $0f8c1b9d3f2c872d$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $d7dm3.useResourceWithCustomRouterContext)((0, $edf7u.projectContextResourceWithCache), customContext);
    const updateCache = (0, $euxye.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $0f8c1b9d3f2c872d$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $0f8c1b9d3f2c872d$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $0f8c1b9d3f2c872d$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $0f8c1b9d3f2c872d$export$8f31c2503e1efa93();
    return children(projectContext);
};
$0f8c1b9d3f2c872d$export$a85f6b5857d2176.displayName = "ProjectContextProvider";

});

parcelRegister("ggu1H", function(module, exports) {
$parcel$export(module.exports, "adaptiveLanguageStore", () => $a1ee7a551cc7d14b$export$d5fa697e09a2cf83);

var $euxye = parcelRequire("euxye");

var $gXtG2 = parcelRequire("gXtG2");
const $a1ee7a551cc7d14b$var$DEFAULT_STATE = {
    domain: null,
    glossary: null,
    status: 'idle'
};
let $a1ee7a551cc7d14b$var$state = $a1ee7a551cc7d14b$var$DEFAULT_STATE;
const $a1ee7a551cc7d14b$var$listeners = new Set();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $a1ee7a551cc7d14b$var$state = $a1ee7a551cc7d14b$var$DEFAULT_STATE;
    $a1ee7a551cc7d14b$var$listeners.clear();
});
function $a1ee7a551cc7d14b$var$emitChange() {
    $a1ee7a551cc7d14b$var$listeners.forEach((listener)=>listener());
}
const $a1ee7a551cc7d14b$export$d5fa697e09a2cf83 = {
    getState () {
        return $a1ee7a551cc7d14b$var$state;
    },
    setState (next) {
        $a1ee7a551cc7d14b$var$state = next;
        $a1ee7a551cc7d14b$var$emitChange();
    },
    reset () {
        $a1ee7a551cc7d14b$var$state = $a1ee7a551cc7d14b$var$DEFAULT_STATE;
        $a1ee7a551cc7d14b$var$emitChange();
    },
    subscribe (listener) {
        $a1ee7a551cc7d14b$var$listeners.add(listener);
        return ()=>$a1ee7a551cc7d14b$var$listeners.delete(listener);
    }
};
function $a1ee7a551cc7d14b$export$6eed6b0c7ec891c3() {
    const [, forceUpdate] = (0, $euxye.useReducer)((x)=>x + 1, 0);
    (0, $euxye.useEffect)(()=>{
        // Re-subscribe on mount, unsubscribe on unmount
        return $a1ee7a551cc7d14b$export$d5fa697e09a2cf83.subscribe(forceUpdate);
    }, []);
    return $a1ee7a551cc7d14b$export$d5fa697e09a2cf83.getState();
}

});


parcelRegister("jepRN", function(module, exports) {
$parcel$export(module.exports, "componentWithFG", () => $efd2d875c00406ea$export$cf56d0f54cfcce4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aWliK = parcelRequire("aWliK");

var $i860n = parcelRequire("i860n");
const $efd2d875c00406ea$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>// eslint-disable-next-line jira/ff/static-feature-flags
    (0, $aWliK.componentWithCondition)(()=>(0, $i860n.fg)(gateName), ComponentTrue, ComponentFalse);

});

parcelRegister("2GQ8g", function(module, exports) {
$parcel$export(module.exports, "default", () => $eba9e48bd1147a92$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $2700E = parcelRequire("2700E");

var $2ffUK = parcelRequire("2ffUK");
var $bc9Gj = parcelRequire("bc9Gj");

var $fAcHb = parcelRequire("fAcHb");
const $eba9e48bd1147a92$var$CROSS_FLOW_SOURCE_QUERY_PARAM = 'source';
const $eba9e48bd1147a92$var$CROSS_FLOW_SOURCE_VALUE = 'cross-flow';
const $eba9e48bd1147a92$var$ProjectBuilderCrossFlowSourceTrigger = ()=>{
    const [sourceQueryParam, setSourceQueryParam] = (0, $2ffUK.useQueryParam)($eba9e48bd1147a92$var$CROSS_FLOW_SOURCE_QUERY_PARAM);
    const [{ route: route }] = (0, $bc9Gj.useRouter)();
    const [, actions] = (0, $fAcHb.useProjectBuilder)();
    (0, $euxye.useEffect)(()=>{
        if (sourceQueryParam === $eba9e48bd1147a92$var$CROSS_FLOW_SOURCE_VALUE && (route.name === 'servicedesk-queues-landing' || route.name === 'servicedesk-getting-started-page')) {
            if ((0, $2700E.expVal)('sequoia_jsmgrowth-219_bring_forwaed_request_types', 'isEnabled', false)) actions.showProjectBuilder();
            setSourceQueryParam(undefined);
        }
    }, [
        actions,
        sourceQueryParam,
        route.name,
        setSourceQueryParam
    ]);
    return null;
};
$eba9e48bd1147a92$var$ProjectBuilderCrossFlowSourceTrigger.displayName = "ProjectBuilderCrossFlowSourceTrigger";
var $eba9e48bd1147a92$export$2e2bcd8739ae039 = $eba9e48bd1147a92$var$ProjectBuilderCrossFlowSourceTrigger;

});
parcelRegister("fAcHb", function(module, exports) {
$parcel$export(module.exports, "useProjectBuilder", () => $1a0de1ec2fcd4675$export$5891129c2551a3c0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
const $1a0de1ec2fcd4675$var$ProjectBuilderStore = (0, $5QDqc.createStore)({
    initialState: {
        isProjectBuilderOpen: false
    },
    actions: {
        hideProjectBuilder: ()=>({ setState: setState })=>{
                setState({
                    isProjectBuilderOpen: false
                });
            },
        showProjectBuilder: ()=>({ setState: setState })=>{
                setState({
                    isProjectBuilderOpen: true
                });
            }
    },
    name: 'projectBuilder'
});
const $1a0de1ec2fcd4675$export$5891129c2551a3c0 = (0, $3h1FP.createHook)($1a0de1ec2fcd4675$var$ProjectBuilderStore);

});


parcelRegister("lp24J", function(module, exports) {
$parcel$export(module.exports, "useOnboardingPreload", () => $139f17533551418f$export$6d623864be1040dc);

var $euxye = parcelRequire("euxye");

var $4zvW4 = parcelRequire("4zvW4");

var $2b39L = parcelRequire("2b39L");
const $139f17533551418f$export$6d623864be1040dc = (target)=>{
    const hasPreloadedRef = (0, $euxye.useRef)(false);
    const projectContext = (0, $2b39L.useProjectContext)();
    const projectContextData = projectContext?.data;
    const canShowExperience = (0, $4zvW4.useQuickstart)(projectContextData);
    (0, $euxye.useEffect)(()=>{
        if (canShowExperience && !hasPreloadedRef.current) {
            target.preload?.();
            hasPreloadedRef.current = true;
        }
    }, [
        canShowExperience,
        target
    ]);
    return canShowExperience;
};

});
parcelRegister("4zvW4", function(module, exports) {
$parcel$export(module.exports, "useQuickstart", () => $64e694f2185347b8$export$eee715064db7b785);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $gapGE = parcelRequire("gapGE");


var $eki8y = parcelRequire("eki8y");

var $62Xqf = parcelRequire("62Xqf");

var $4hGfa = parcelRequire("4hGfa");

var $i860n = parcelRequire("i860n");
const $64e694f2185347b8$export$eee715064db7b785 = (projectContextData, containerType = 'project')=>{
    const [{ data: containerContext }] = (0, $gapGE.useContainerContext)();
    const spaStatePageReady = (0, $62Xqf.useSpaStatePageReady)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $eki8y.useJsmOnboardingType)();
    const [projectState] = (0, $4hGfa.useProjectState)();
    const projectId = projectContextData?.projectId ?? projectState?.projectId;
    const projectType = projectContextData?.projectType ?? projectState?.projectType;
    (0, $euxye.useEffect)(()=>{
        fetchOnboardingType(projectId, projectType);
    }, [
        jsmOnboardingData,
        fetchOnboardingType,
        projectId,
        projectType
    ]);
    if (containerType === 'project' && projectType != null && projectType !== (0, $f99M0.SOFTWARE_PROJECT) && projectType !== (0, $f99M0.CORE_PROJECT) && projectType !== (0, $f99M0.SERVICE_DESK_PROJECT)) // If containerType is project and projectContext is present and it is not software, core or service management, don't render
    return false;
    // Scope Type in classic -- scrum/kanban/undefined(non-scrum/kanban) & next-gen -- simple
    const isProjectScopeAvailable = containerContext && containerContext.scope && containerContext.scope.type;
    const isProjectScopeAndSpaPageReady = Boolean(isProjectScopeAvailable) && spaStatePageReady;
    const showJswExperience = (0, $i860n.fg)('jira-fix-quickstart-not-showing') ? containerType === 'project' && projectType === (0, $f99M0.SOFTWARE_PROJECT) && spaStatePageReady : isProjectScopeAndSpaPageReady;
    const showJwmExperience = (0, $i860n.fg)('jira-fix-quickstart-not-showing') ? containerType === 'project' && projectType === (0, $f99M0.CORE_PROJECT) : containerContext?.contextType === 'project' && projectType === (0, $f99M0.CORE_PROJECT);
    const showJsmExperience = (0, $i860n.fg)('jira-fix-quickstart-not-showing') ? containerType === 'project' && projectType === (0, $f99M0.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $77d3ca58d1d4a14f$export$6f454e69bce3a691) : containerContext?.contextType === 'project' && projectType === (0, $f99M0.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $77d3ca58d1d4a14f$export$6f454e69bce3a691);
    const showPlanExperience = containerType === 'plan';
    const canShowExperience = showJwmExperience || showJsmExperience || showJswExperience || showPlanExperience;
    return canShowExperience;
};

});
parcelRegister("gapGE", function(module, exports) {
$parcel$export(module.exports, "useContainerContext", () => $55966eaed0cd6835$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $55966eaed0cd6835$export$5b87a78c45d5dd17);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $5mMCG = parcelRequire("5mMCG");

var $idDnR = parcelRequire("idDnR");

var $k6ufm = parcelRequire("k6ufm");

var $dLrrn = parcelRequire("dLrrn");
const $55966eaed0cd6835$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $k6ufm.useResource)((0, $idDnR.staticProjectSidebarNavigationResource));
    const projectContext = (0, $euxye.useMemo)(()=>data && (0, $dLrrn.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $55966eaed0cd6835$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $k6ufm.useResource)((0, $5mMCG.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $euxye.useMemo)(()=>data && (0, $dLrrn.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $55966eaed0cd6835$export$c7066c2d215990cf = ()=>{
    const projectContext = $55966eaed0cd6835$var$useProjectContext();
    const userBoardContext = $55966eaed0cd6835$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $55966eaed0cd6835$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $55966eaed0cd6835$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$55966eaed0cd6835$export$5b87a78c45d5dd17.displayName = "ContainerContextSubscriber";
$55966eaed0cd6835$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("dLrrn", function(module, exports) {
$parcel$export(module.exports, "getUserContext", () => $b2705ab280d68d72$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $b2705ab280d68d72$export$d17fffd59c7b3c60);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");

var $4bRaD = parcelRequire("4bRaD");
const $b2705ab280d68d72$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $b2705ab280d68d72$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $b2705ab280d68d72$var$getProjectType = (projectType)=>{
    switch(projectType){
        case 'business':
            return 0, $f99M0.CORE_PROJECT;
        case 'software':
            return 0, $f99M0.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $f99M0.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $f99M0.PRODUCT_DISCOVERY_PROJECT;
        case 'customer_service':
            return 0, $f99M0.CUSTOMER_SERVICE_PROJECT;
        default:
            return null;
    }
};
const $b2705ab280d68d72$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $4bRaD.extractData)(projectNavInfo);
    const scope = $b2705ab280d68d72$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $b2705ab280d68d72$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $4bRaD.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});


/* eslint-disable jira/filename-case */ const $77d3ca58d1d4a14f$export$6f454e69bce3a691 = 'business';
const $77d3ca58d1d4a14f$export$e6952b12ade67489 = 'default';

parcelRegister("eki8y", function(module, exports) {
$parcel$export(module.exports, "useJsmOnboardingType", () => $3a3e5b3f8c56a77c$export$5daaa68c3a578af9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");

var $gFlri = parcelRequire("gFlri");
const $3a3e5b3f8c56a77c$export$d4c72bab9d6cc13a = {
    projectId: undefined,
    data: undefined,
    error: undefined,
    isLoading: false
};
const $3a3e5b3f8c56a77c$var$Store = (0, $5QDqc.createStore)({
    initialState: $3a3e5b3f8c56a77c$export$d4c72bab9d6cc13a,
    actions: $gFlri.actions,
    name: 'JSMOnboardingType'
});
const $3a3e5b3f8c56a77c$export$5daaa68c3a578af9 = (0, $3h1FP.createHook)($3a3e5b3f8c56a77c$var$Store);

});
parcelRegister("gFlri", function(module, exports) {
$parcel$export(module.exports, "actions", () => $918af6075d609ea1$export$e324594224ef24da);
/* eslint-disable jira/filename-case */ /* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $wrNtr = parcelRequire("wrNtr");
const $918af6075d609ea1$export$e324594224ef24da = {
    fetchOnboardingType: $wrNtr.fetchOnboardingType
};

});
parcelRegister("wrNtr", function(module, exports) {
$parcel$export(module.exports, "fetchOnboardingType", () => $7608fb574ec31e5c$export$ea62467635172b55);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");

var $4fhEY = parcelRequire("4fhEY");
const $7608fb574ec31e5c$var$getOnboardingTypeUrl = (projectId)=>`/rest/servicedesk/onboarding/1/onboarding-type/project/${projectId}`;
const $7608fb574ec31e5c$export$ea62467635172b55 = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(projectId, projectType)=>async ({ getState: getState, setState: setState })=>{
        if (!projectId || projectType !== (0, $f99M0.SERVICE_DESK_PROJECT)) return;
        const { data: data, isLoading: isLoading, projectId: oldProjectId } = getState();
        if (projectId !== oldProjectId) setState({
            data: undefined,
            projectId: undefined
        });
        if (data || isLoading) return;
        setState({
            projectId: projectId,
            isLoading: true,
            error: undefined
        });
        try {
            const onboardingTypeResponse = await (0, $4fhEY.default)($7608fb574ec31e5c$var$getOnboardingTypeUrl(String(projectId)));
            setState({
                isLoading: false,
                data: onboardingTypeResponse
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isLoading: false,
                error: error
            });
        }
    };

});



parcelRegister("62Xqf", function(module, exports) {
$parcel$export(module.exports, "useSpaStatePageReady", () => $07d52b79c17de633$export$ea2491906b753456);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");

var $b9Jox = parcelRequire("b9Jox");

var $6Bw3S = parcelRequire("6Bw3S");
const $07d52b79c17de633$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    return {
        isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
    };
};
const $07d52b79c17de633$var$useSpaStatePageReadyStateHook = (0, $3h1FP.createHook)((0, $6Bw3S.default), {
    selector: $07d52b79c17de633$export$e6897aa59ee7aee5
});
function $07d52b79c17de633$export$ea2491906b753456() {
    const isClientReady = (0, $b9Jox.useIsClientReady)();
    const [{ isReady: isReady }] = $07d52b79c17de633$var$useSpaStatePageReadyStateHook();
    return isClientReady && isReady;
}

});
parcelRegister("b9Jox", function(module, exports) {
$parcel$export(module.exports, "useIsClientReady", () => $5a808a6751bb4871$export$d2ab98824add97fa);
// eslint-disable-next-line jira/filename-case, jira/restricted/react-18

var $euxye = parcelRequire("euxye");
const $5a808a6751bb4871$export$d2ab98824add97fa = ()=>(0, $euxye.useSyncExternalStore)(()=>()=>{
        // empty
        }, ()=>true, ()=>false);

});


parcelRegister("4hGfa", function(module, exports) {
$parcel$export(module.exports, "useJswOnboarding", () => $6a01d2fc90f5432a$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $6a01d2fc90f5432a$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $6a01d2fc90f5432a$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $6a01d2fc90f5432a$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $6a01d2fc90f5432a$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useInviteToProject", () => $6a01d2fc90f5432a$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $6a01d2fc90f5432a$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $6a01d2fc90f5432a$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $6a01d2fc90f5432a$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $6a01d2fc90f5432a$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $6a01d2fc90f5432a$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $6a01d2fc90f5432a$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $6a01d2fc90f5432a$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $6a01d2fc90f5432a$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $6a01d2fc90f5432a$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $6a01d2fc90f5432a$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $6a01d2fc90f5432a$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useHasNudgeActive", () => $6a01d2fc90f5432a$export$521909e3dc7ab811);
$parcel$export(module.exports, "useIsOpenedViaButton", () => $6a01d2fc90f5432a$export$2317d3c684b416ec);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("5ZtCQ")).QUICKSTART_UI_STATUS);
/* eslint-disable @typescript-eslint/no-explicit-any, jira/filename-case, jira/naming/disallow-filenames */ 
var $dB6ay = parcelRequire("dB6ay");
var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
var $iGu4q = parcelRequire("iGu4q");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $lc0xf = parcelRequire("lc0xf");

var $8ZIK8 = parcelRequire("8ZIK8");

var $ia7JZ = parcelRequire("ia7JZ");

var $1n5q3 = parcelRequire("1n5q3");

var $1DyW0 = parcelRequire("1DyW0");
const $6a01d2fc90f5432a$export$390f32400eaf98c9 = (0, $5QDqc.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $ia7JZ.initialState,
    actions: $lc0xf.actions
});
const $6a01d2fc90f5432a$export$1cbc60d8dd921852 = (0, $iGu4q.createSubscriber)($6a01d2fc90f5432a$export$390f32400eaf98c9);
const $6a01d2fc90f5432a$export$7d91c0af4772787a = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9);
const $6a01d2fc90f5432a$export$638bfcfce1254bb8 = (0, $dB6ay.createContainer)($6a01d2fc90f5432a$export$390f32400eaf98c9, {});
const $6a01d2fc90f5432a$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $1n5q3.getQuickstartTypeSelector)(state)] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $6a01d2fc90f5432a$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $6a01d2fc90f5432a$export$594f006fa6a1b2e5 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: $6a01d2fc90f5432a$export$ea14030920a5d8e6
});
const $6a01d2fc90f5432a$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $6a01d2fc90f5432a$export$c5e63e44ad178ae8 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: $6a01d2fc90f5432a$export$a943afa434e9487a
});
const $6a01d2fc90f5432a$export$2c3cd14fff9d6e43 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: null
});
const $6a01d2fc90f5432a$export$b0db7e46e369e1d9 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: $6a01d2fc90f5432a$export$9d731f44f82af09f
});
const $6a01d2fc90f5432a$export$71de79653346a1ea = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $6a01d2fc90f5432a$export$61185a9266f1f57a = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $8ZIK8.USER_ROLE).JIRA_ADMIN || userRole === (0, $8ZIK8.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $6a01d2fc90f5432a$export$ef4747ba36826d6a = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $6a01d2fc90f5432a$export$522993b46d9f8266 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $1DyW0.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $6a01d2fc90f5432a$export$aa4ba29241532382 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $6a01d2fc90f5432a$export$ed5c755b733bf2b1 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $6a01d2fc90f5432a$export$35fe0366802512dd = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $1n5q3.getQuickstartTypeSelector)(state)];
        return visibility === (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED;
    }
});
const $6a01d2fc90f5432a$export$a41ee0d3b6938099 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $6a01d2fc90f5432a$export$4ae7b465b076be9 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $6a01d2fc90f5432a$export$bf6e646c0476acad = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $6a01d2fc90f5432a$export$6b706bff94798d11 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $6a01d2fc90f5432a$export$c98db656edc5b3e1 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $6a01d2fc90f5432a$export$521909e3dc7ab811 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $6a01d2fc90f5432a$export$f4a2be940259bf95 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});
const $6a01d2fc90f5432a$export$6db1f59c8ab54061 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.quickstartButtonRef
});
const $6a01d2fc90f5432a$export$2317d3c684b416ec = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.isOpenedViaButton
});
const $6a01d2fc90f5432a$export$a57f80e92714bb45 = (0, $3h1FP.createHook)($6a01d2fc90f5432a$export$390f32400eaf98c9, {
    selector: (state)=>state.containerType
});

});
parcelRegister("5ZtCQ", function(module, exports) {
$parcel$export(module.exports, "PACKAGE_NAME", () => $e9ca6c00748e0698$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $e9ca6c00748e0698$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $e9ca6c00748e0698$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $e9ca6c00748e0698$export$b580da85daad7757);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $e9ca6c00748e0698$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $e9ca6c00748e0698$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $e9ca6c00748e0698$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $e9ca6c00748e0698$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $e9ca6c00748e0698$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $e9ca6c00748e0698$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $e9ca6c00748e0698$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $e9ca6c00748e0698$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $e9ca6c00748e0698$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $e9ca6c00748e0698$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $e9ca6c00748e0698$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $e9ca6c00748e0698$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $e9ca6c00748e0698$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "PLAN_TEAM_CAPACITY_TASK", () => $e9ca6c00748e0698$export$d324bd587f924f18);
$parcel$export(module.exports, "PLAN_PROGRAM_BOARD_TASK", () => $e9ca6c00748e0698$export$a253dd77ea687e0a);
$parcel$export(module.exports, "PLAN_RELEASE_MANAGEMENT_TASK", () => $e9ca6c00748e0698$export$bffdfa5c4de9d4b);
$parcel$export(module.exports, "PLAN_DEPENDENCY_TRACKING_TASK", () => $e9ca6c00748e0698$export$31928f71f777342f);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $e9ca6c00748e0698$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $e9ca6c00748e0698$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $e9ca6c00748e0698$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $e9ca6c00748e0698$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $e9ca6c00748e0698$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $e9ca6c00748e0698$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $e9ca6c00748e0698$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $e9ca6c00748e0698$export$3380e677209260fe);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $e9ca6c00748e0698$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $e9ca6c00748e0698$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $e9ca6c00748e0698$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $e9ca6c00748e0698$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $e9ca6c00748e0698$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $e9ca6c00748e0698$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $e9ca6c00748e0698$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $e9ca6c00748e0698$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $e9ca6c00748e0698$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $e9ca6c00748e0698$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $e9ca6c00748e0698$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $e9ca6c00748e0698$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $e9ca6c00748e0698$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $e9ca6c00748e0698$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $e9ca6c00748e0698$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $e9ca6c00748e0698$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $e9ca6c00748e0698$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $e9ca6c00748e0698$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $e9ca6c00748e0698$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $e9ca6c00748e0698$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $e9ca6c00748e0698$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $e9ca6c00748e0698$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $e9ca6c00748e0698$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $e9ca6c00748e0698$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $e9ca6c00748e0698$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $e9ca6c00748e0698$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $e9ca6c00748e0698$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $e9ca6c00748e0698$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $e9ca6c00748e0698$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $e9ca6c00748e0698$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $e9ca6c00748e0698$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $e9ca6c00748e0698$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $e9ca6c00748e0698$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $e9ca6c00748e0698$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $e9ca6c00748e0698$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $e9ca6c00748e0698$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $e9ca6c00748e0698$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $e9ca6c00748e0698$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $e9ca6c00748e0698$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $e9ca6c00748e0698$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $e9ca6c00748e0698$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $e9ca6c00748e0698$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $e9ca6c00748e0698$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $e9ca6c00748e0698$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $e9ca6c00748e0698$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $e9ca6c00748e0698$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $e9ca6c00748e0698$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $e9ca6c00748e0698$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $e9ca6c00748e0698$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $e9ca6c00748e0698$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $e9ca6c00748e0698$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $e9ca6c00748e0698$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $e9ca6c00748e0698$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $e9ca6c00748e0698$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $e9ca6c00748e0698$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $e9ca6c00748e0698$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $e9ca6c00748e0698$export$1de5766b7e640d6b);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $e9ca6c00748e0698$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $e9ca6c00748e0698$export$c8ab6996f562d0db);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $e9ca6c00748e0698$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $e9ca6c00748e0698$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $e9ca6c00748e0698$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $e9ca6c00748e0698$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $e9ca6c00748e0698$export$7578902c7f420a3);
$parcel$export(module.exports, "SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON", () => $e9ca6c00748e0698$export$5980f41aa657f9c7);
/* eslint-disable jira/filename-case */ const $e9ca6c00748e0698$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$var$completePlanTaskName = (taskId)=>`plan-onboarding-checklist.${taskId}`;
const $e9ca6c00748e0698$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $e9ca6c00748e0698$export$2b3151a089bc8780 = 'jlove-makkuro';
const $e9ca6c00748e0698$export$6826d33e9a2c0119 = 320;
const $e9ca6c00748e0698$export$b580da85daad7757 = 'root';
const $e9ca6c00748e0698$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $e9ca6c00748e0698$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $e9ca6c00748e0698$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $e9ca6c00748e0698$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $e9ca6c00748e0698$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $e9ca6c00748e0698$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $e9ca6c00748e0698$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $e9ca6c00748e0698$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $e9ca6c00748e0698$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $e9ca6c00748e0698$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $e9ca6c00748e0698$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $e9ca6c00748e0698$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $e9ca6c00748e0698$export$63b0e55f9c6454ac = $e9ca6c00748e0698$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $e9ca6c00748e0698$export$d324bd587f924f18 = $e9ca6c00748e0698$var$completePlanTaskName('team-capacity-task');
const $e9ca6c00748e0698$export$a253dd77ea687e0a = $e9ca6c00748e0698$var$completePlanTaskName('program-board-task');
const $e9ca6c00748e0698$export$bffdfa5c4de9d4b = $e9ca6c00748e0698$var$completePlanTaskName('release-management-task');
const $e9ca6c00748e0698$export$31928f71f777342f = $e9ca6c00748e0698$var$completePlanTaskName('dependency-tracking-task');
const $e9ca6c00748e0698$export$77071b77e2801b18 = $e9ca6c00748e0698$var$completeJwmTaskName('jwm-create-project-task');
const $e9ca6c00748e0698$export$d37415ffddcf2142 = $e9ca6c00748e0698$var$completeJwmTaskName('build-form-task');
const $e9ca6c00748e0698$export$2aa6e7b6e24a04f5 = $e9ca6c00748e0698$var$completeJwmTaskName('calendar-task');
const $e9ca6c00748e0698$export$f3b53199b07af2a1 = $e9ca6c00748e0698$var$completeJwmTaskName('timeline-task');
const $e9ca6c00748e0698$export$b52a7c936684cfc5 = $e9ca6c00748e0698$var$completeJwmTaskName('trello-crossflow-import');
const $e9ca6c00748e0698$export$b5555f24061f9fb = $e9ca6c00748e0698$var$completeJwmTaskName('summary-and-reports-task');
const $e9ca6c00748e0698$export$ff25449f34b8abf = $e9ca6c00748e0698$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $e9ca6c00748e0698$export$3380e677209260fe = $e9ca6c00748e0698$var$completeJwmTaskName('trello-crossflow-key-differences');
const $e9ca6c00748e0698$export$da23b72d32bfad9e = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $e9ca6c00748e0698$export$4b064659282e0238 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $e9ca6c00748e0698$export$3ab51851f6d823e = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $e9ca6c00748e0698$export$e4a1a37a9a1350ad = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $e9ca6c00748e0698$export$b7f7da5e795f0327 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $e9ca6c00748e0698$export$80a401c1aa47a377 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $e9ca6c00748e0698$export$934ac7a251b26dc7 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $e9ca6c00748e0698$export$4634f6395df3ebbe = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $e9ca6c00748e0698$export$768fb41107a1e8d7 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $e9ca6c00748e0698$export$d797a81bace17184 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $e9ca6c00748e0698$export$746102c94db9df1f = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $e9ca6c00748e0698$export$5f1efd797d65e349 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $e9ca6c00748e0698$export$cccc812ccafbf11f = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $e9ca6c00748e0698$export$64822db87abd8a47 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $e9ca6c00748e0698$export$64f764d8be495c82 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $e9ca6c00748e0698$export$24eae23dc1c68bbd = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $e9ca6c00748e0698$export$50fa92eba6f82feb = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $e9ca6c00748e0698$export$4155d22fe3f14cd6 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $e9ca6c00748e0698$export$76813cbead887191 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $e9ca6c00748e0698$export$90aab2ff89daf770 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $e9ca6c00748e0698$export$a2bc0cbad2e6e605 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $e9ca6c00748e0698$export$f90872a1280728bb = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $e9ca6c00748e0698$export$bce644e96518cbd2 = $e9ca6c00748e0698$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $e9ca6c00748e0698$export$241aaebffac0a3e5 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $e9ca6c00748e0698$export$f9dfc43b5b31c4b7 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $e9ca6c00748e0698$export$79759e9e62fb9312 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $e9ca6c00748e0698$export$992d1e0dce255d19 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $e9ca6c00748e0698$export$d28c1b0e5b3e768 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $e9ca6c00748e0698$export$ca714ee197bed4ec = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $e9ca6c00748e0698$export$faae55ceea4b6073 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $e9ca6c00748e0698$export$200bc24cd120667e = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $e9ca6c00748e0698$export$a0d784a48b4e886c = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $e9ca6c00748e0698$export$baf5bd09b4b33b8a = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $e9ca6c00748e0698$export$4702007eedbca8ab = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $e9ca6c00748e0698$export$aa9d2d635ea63898 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $e9ca6c00748e0698$export$2ea449225c1f6cac = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $e9ca6c00748e0698$export$deb8b557e735e26a = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $e9ca6c00748e0698$export$d45754df44e4c309 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $e9ca6c00748e0698$export$78b2913b550edbb = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $e9ca6c00748e0698$export$71243272608c58ab = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $e9ca6c00748e0698$export$39a08f215c33bc39 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $e9ca6c00748e0698$export$d2377f6a6fa3b49c = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $e9ca6c00748e0698$export$befa8f6533309779 = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $e9ca6c00748e0698$export$736b40db8701ba6c = $e9ca6c00748e0698$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $e9ca6c00748e0698$export$11eff6ae2f70b67b = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $e9ca6c00748e0698$export$fb2d23e5315a67a9 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $e9ca6c00748e0698$export$32e794bb49d60b6 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $e9ca6c00748e0698$export$fed256238b27db06 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $e9ca6c00748e0698$export$132eecb4d35a590d = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $e9ca6c00748e0698$export$2579c51cadd45eca = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $e9ca6c00748e0698$export$4b1a0cefa966ea0 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $e9ca6c00748e0698$export$f6558daacc312a65 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $e9ca6c00748e0698$export$925efa2e24e86b88 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $e9ca6c00748e0698$export$40454d3e062dcd44 = $e9ca6c00748e0698$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $e9ca6c00748e0698$export$99b0e09ff6f00490 = $e9ca6c00748e0698$var$completeJsmTaskName('customize-your-request-types-task');
const $e9ca6c00748e0698$export$2a82344eb273eeff = $e9ca6c00748e0698$var$completeJsmTaskName('review-your-channels-task');
const $e9ca6c00748e0698$export$1de5766b7e640d6b = $e9ca6c00748e0698$var$completeJsmTaskName('invite-your-team-task');
const $e9ca6c00748e0698$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $e9ca6c00748e0698$export$c8ab6996f562d0db = 'accountId';
const $e9ca6c00748e0698$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $e9ca6c00748e0698$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $e9ca6c00748e0698$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $e9ca6c00748e0698$export$38fbac7a5bf4aa33 = [
    $e9ca6c00748e0698$export$2a82344eb273eeff,
    $e9ca6c00748e0698$export$99b0e09ff6f00490,
    $e9ca6c00748e0698$export$1de5766b7e640d6b
];
const $e9ca6c00748e0698$export$7578902c7f420a3 = [
    $e9ca6c00748e0698$export$63b0e55f9c6454ac,
    $e9ca6c00748e0698$export$77071b77e2801b18,
    $e9ca6c00748e0698$export$d37415ffddcf2142,
    $e9ca6c00748e0698$export$b52a7c936684cfc5,
    $e9ca6c00748e0698$export$b5555f24061f9fb,
    $e9ca6c00748e0698$export$ff25449f34b8abf,
    $e9ca6c00748e0698$export$3380e677209260fe,
    $e9ca6c00748e0698$export$da23b72d32bfad9e,
    $e9ca6c00748e0698$export$4b064659282e0238,
    $e9ca6c00748e0698$export$3ab51851f6d823e,
    $e9ca6c00748e0698$export$e4a1a37a9a1350ad,
    $e9ca6c00748e0698$export$b7f7da5e795f0327,
    $e9ca6c00748e0698$export$80a401c1aa47a377,
    $e9ca6c00748e0698$export$934ac7a251b26dc7,
    $e9ca6c00748e0698$export$4634f6395df3ebbe,
    $e9ca6c00748e0698$export$768fb41107a1e8d7,
    $e9ca6c00748e0698$export$d797a81bace17184,
    $e9ca6c00748e0698$export$746102c94db9df1f,
    $e9ca6c00748e0698$export$5f1efd797d65e349,
    $e9ca6c00748e0698$export$cccc812ccafbf11f,
    $e9ca6c00748e0698$export$64822db87abd8a47,
    $e9ca6c00748e0698$export$64f764d8be495c82,
    $e9ca6c00748e0698$export$24eae23dc1c68bbd,
    $e9ca6c00748e0698$export$50fa92eba6f82feb,
    $e9ca6c00748e0698$export$4155d22fe3f14cd6,
    $e9ca6c00748e0698$export$76813cbead887191,
    $e9ca6c00748e0698$export$90aab2ff89daf770,
    $e9ca6c00748e0698$export$a2bc0cbad2e6e605,
    $e9ca6c00748e0698$export$f90872a1280728bb,
    $e9ca6c00748e0698$export$bce644e96518cbd2,
    $e9ca6c00748e0698$export$241aaebffac0a3e5,
    $e9ca6c00748e0698$export$f9dfc43b5b31c4b7,
    $e9ca6c00748e0698$export$79759e9e62fb9312,
    $e9ca6c00748e0698$export$992d1e0dce255d19,
    $e9ca6c00748e0698$export$d28c1b0e5b3e768,
    $e9ca6c00748e0698$export$ca714ee197bed4ec,
    $e9ca6c00748e0698$export$faae55ceea4b6073,
    $e9ca6c00748e0698$export$200bc24cd120667e,
    $e9ca6c00748e0698$export$a0d784a48b4e886c,
    $e9ca6c00748e0698$export$baf5bd09b4b33b8a,
    $e9ca6c00748e0698$export$4702007eedbca8ab,
    $e9ca6c00748e0698$export$aa9d2d635ea63898,
    $e9ca6c00748e0698$export$2ea449225c1f6cac,
    $e9ca6c00748e0698$export$deb8b557e735e26a,
    $e9ca6c00748e0698$export$d45754df44e4c309,
    $e9ca6c00748e0698$export$78b2913b550edbb,
    $e9ca6c00748e0698$export$71243272608c58ab,
    $e9ca6c00748e0698$export$39a08f215c33bc39,
    $e9ca6c00748e0698$export$d2377f6a6fa3b49c,
    $e9ca6c00748e0698$export$befa8f6533309779,
    $e9ca6c00748e0698$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $e9ca6c00748e0698$export$11eff6ae2f70b67b,
    $e9ca6c00748e0698$export$fb2d23e5315a67a9,
    $e9ca6c00748e0698$export$32e794bb49d60b6,
    $e9ca6c00748e0698$export$fed256238b27db06,
    $e9ca6c00748e0698$export$132eecb4d35a590d,
    $e9ca6c00748e0698$export$2579c51cadd45eca,
    $e9ca6c00748e0698$export$4b1a0cefa966ea0,
    $e9ca6c00748e0698$export$f6558daacc312a65,
    $e9ca6c00748e0698$export$925efa2e24e86b88,
    $e9ca6c00748e0698$export$40454d3e062dcd44
];
const $e9ca6c00748e0698$export$5980f41aa657f9c7 = [
    'SAM1'
];

});

parcelRegister("lc0xf", function(module, exports) {
$parcel$export(module.exports, "actions", () => $95098241613986c7$export$e324594224ef24da);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $lshfi = parcelRequire("lshfi");

var $eahz5 = parcelRequire("eahz5");

var $4sdAq = parcelRequire("4sdAq");

var $k2hbg = parcelRequire("k2hbg");

var $2viaa = parcelRequire("2viaa");

var $agR3I = parcelRequire("agR3I");

var $3riN6 = parcelRequire("3riN6");

var $2yI5h = parcelRequire("2yI5h");

var $7925l = parcelRequire("7925l");

var $2eU4H = parcelRequire("2eU4H");

var $6zJVJ = parcelRequire("6zJVJ");

var $8qaqK = parcelRequire("8qaqK");

var $4BoSU = parcelRequire("4BoSU");

var $gJ2q6 = parcelRequire("gJ2q6");

var $agOGQ = parcelRequire("agOGQ");

var $ljq2N = parcelRequire("ljq2N");

var $2wjIB = parcelRequire("2wjIB");

var $1XEDt = parcelRequire("1XEDt");

var $lhMTU = parcelRequire("lhMTU");

var $ktOmH = parcelRequire("ktOmH");

var $3slnW = parcelRequire("3slnW");

var $hOXkl = parcelRequire("hOXkl");

var $jJY2t = parcelRequire("jJY2t");

var $bNXf6 = parcelRequire("bNXf6");

var $2D5ku = parcelRequire("2D5ku");

var $adLxs = parcelRequire("adLxs");
const $95098241613986c7$export$e324594224ef24da = {
    changeTaskGroupParent: $lshfi.nextChangeTaskGroupParent,
    goBackToPreviousTaskGroup: $lshfi.nextGoBackToPreviousTaskGroup,
    setIsOpen: $eahz5.setIsOpen,
    refreshAppState: $4sdAq.refreshAppState,
    setNudgeStep: $k2hbg.setNudgeStep,
    addMountedNudge: $2viaa.addMountedNudge,
    removeMountedNudge: $2viaa.removeMountedNudge,
    setShouldRenderComponent: $agR3I.setShouldRenderComponent,
    setProjectState: $3riN6.setProjectState,
    setHasNudgeActive: $2yI5h.setHasNudgeActive,
    forceHideNudge: $7925l.forceHideNudge,
    setHasEverSeenRoute: $2eU4H.setHasEverSeenRoute,
    setRoadmapIsCreateEnabled: $6zJVJ.setRoadmapIsCreateEnabled,
    setRoadmapIsListEmpty: $6zJVJ.setRoadmapIsListEmpty,
    openNextTask: $8qaqK.openNextTask,
    resetIsQuickstartLoaded: $4BoSU.resetIsQuickstartLoaded,
    refreshAppStateUiStatusOnly: $gJ2q6.refreshAppStateUiStatusOnly,
    nextMarkAsCompletedTask: $agOGQ.nextMarkAsCompletedTask,
    nextSetChecklistItemSeen: $ljq2N.nextSetChecklistItemSeen,
    nextSetChecklistIsDismissed: $2wjIB.nextSetChecklistIsDismissed,
    nextSetChecklistIsOpen: $1XEDt.nextSetChecklistIsOpen,
    nextOpenTask: $lhMTU.nextOpenTask,
    nextAutoExpand: $ktOmH.nextAutoExpand,
    nextShouldShowNudgeAfterNavigation: $3slnW.nextShouldShowNudgeAfterNavigation,
    nextGetTasks: $hOXkl.nextGetTasks,
    syncVisibilityWithLocal: $jJY2t.syncVisibilityWithLocal,
    universalDispatch: $bNXf6.universalDispatch,
    setContainerType: $2D5ku.setContainerType,
    setQuickstartButtonRef: $adLxs.setQuickstartButtonRef,
    setIsOpenedViaButton: $adLxs.setIsOpenedViaButton,
    focusQuickstartButton: $adLxs.focusQuickstartButton
};

});
parcelRegister("lshfi", function(module, exports) {
$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $daa1afacdb588798$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $daa1afacdb588798$export$57534cbc400a434c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");
const $daa1afacdb588798$var$setTaskGroup = (taskGroup, openTask)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: openTask || ''
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $daa1afacdb588798$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($daa1afacdb588798$var$setTaskGroup(taskGroup));
    };
const $daa1afacdb588798$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;
        const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $5ZtCQ.ROOT_TASK) : previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];
        const newPreviousTaskGroupParents = previousTaskGroupParents.slice(0, lastIndexOfPreviousTaskGroupParents);
        const taskGroup = {
            previousTaskGroupParents: newPreviousTaskGroupParents,
            currentTaskGroupParent: newTaskGroupParent
        };
        dispatch($daa1afacdb588798$var$setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
    };

});
parcelRegister("kRAaT", function(module, exports) {
$parcel$export(module.exports, "pushToBackend", () => $fe5c7f55be2b2016$export$583b2d2422a6757f);
/* eslint-disable jira/filename-case */ 
var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");

var $2HuOR = parcelRequire("2HuOR");

var $75sVW = parcelRequire("75sVW");
const $fe5c7f55be2b2016$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $2HuOR.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $fe5c7f55be2b2016$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $kM0go.setUserProperties)($fe5c7f55be2b2016$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $75sVW.default)(response.status, response.statusText);
    });
const $fe5c7f55be2b2016$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $fe5c7f55be2b2016$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $fe5c7f55be2b2016$export$583b2d2422a6757f = async (props)=>{
    const success = await $fe5c7f55be2b2016$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $fe5c7f55be2b2016$var$trySetUserProperties(props, 2);
};

});


parcelRegister("eahz5", function(module, exports) {
$parcel$export(module.exports, "setIsOpen", () => $08569e867f217dd5$export$dcf23146e0a40195);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");

var $1n5q3 = parcelRequire("1n5q3");
const $08569e867f217dd5$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN : (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_OPEN),
            value: isOpen
        });
    };
var $08569e867f217dd5$export$2e2bcd8739ae039 = $08569e867f217dd5$export$dcf23146e0a40195;

});
parcelRegister("1n5q3", function(module, exports) {
$parcel$export(module.exports, "getQuickstartTypeSelector", () => $9ce6b193d3030c6f$export$eae834ce0286017a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $9ce6b193d3030c6f$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $f99M0.SERVICE_DESK_PROJECT);
const $9ce6b193d3030c6f$export$eae834ce0286017a = (state)=>{
    if ($9ce6b193d3030c6f$export$6f17f2cb816105eb(state)) return (0, $5ZtCQ.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $5ZtCQ.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("4sdAq", function(module, exports) {
$parcel$export(module.exports, "refreshAppState", () => $09503d60e1c07774$export$797c35e2e1d0d014);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $d8LhJ = parcelRequire("d8LhJ");


var $5ZtCQ = parcelRequire("5ZtCQ");

var $cXK8c = parcelRequire("cXK8c");

var $3gWPd = parcelRequire("3gWPd");

var $j4vHl = parcelRequire("j4vHl");

var $7rCTA = parcelRequire("7rCTA");

var $1DyW0 = parcelRequire("1DyW0");

var $2wjIB = parcelRequire("2wjIB");
const $09503d60e1c07774$var$allTasks = [
    ...(0, $5ZtCQ.allTasksExcludingJSMBusinessTasks),
    ...(0, $5ZtCQ.JSM_BUSINESS_TASKS)
];
const $09503d60e1c07774$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType, containerType: containerType = 'project' })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        updatedState.containerType = containerType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).map((type)=>(0, $5ZtCQ.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $5ZtCQ.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $cXK8c.pollBackend)({
            keys: [
                (0, $5ZtCQ.KEY_OPEN),
                (0, $5ZtCQ.KEY_DISMISSED),
                (0, $5ZtCQ.KEY_OPEN_TASK),
                (0, $5ZtCQ.KEY_TASK_GROUP),
                (0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $5ZtCQ.KEY_JSW_ONBOARDING),
                (0, $5ZtCQ.KEY_PREMIUM_TRIAL_REOPENED),
                ...$09503d60e1c07774$var$allTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $5ZtCQ.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $5ZtCQ.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $5ZtCQ.getBackendVisibilityKey)(type)];
                else if ((0, $5ZtCQ.KEY_DISMISSED) in backendState && backendState[0, $5ZtCQ.KEY_DISMISSED]) updatedState.visibility[type] = (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $5ZtCQ.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $5ZtCQ.KEY_OPEN] ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN : (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
                (0, $1DyW0.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $5ZtCQ.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $5ZtCQ.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $5ZtCQ.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $5ZtCQ.KEY_OPEN];
            if ((0, $5ZtCQ.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $5ZtCQ.KEY_OPEN_TASK];
            if ((0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $5ZtCQ.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $5ZtCQ.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $5ZtCQ.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $5ZtCQ.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING] !== null && (0, $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe) in backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING][0, $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $5ZtCQ.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $7rCTA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $2wjIB.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3gWPd.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $j4vHl.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $d8LhJ.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
/* eslint-disable jira/filename-case */ // Session storage constants used between going through initial onboarding screens
// and landing in JIRA
const $99cb2e6a234d7a1f$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $99cb2e6a234d7a1f$export$e3884212029f7bef = 'should-show-welcome-modal';
const $99cb2e6a234d7a1f$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $99cb2e6a234d7a1f$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $99cb2e6a234d7a1f$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $99cb2e6a234d7a1f$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $99cb2e6a234d7a1f$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $99cb2e6a234d7a1f$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $99cb2e6a234d7a1f$export$6e69f8dc03075ef8 = 'team-type';
const $99cb2e6a234d7a1f$export$c06666264cd35603 = 'team-type-shorthand';
const $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $99cb2e6a234d7a1f$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $99cb2e6a234d7a1f$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $99cb2e6a234d7a1f$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $99cb2e6a234d7a1f$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $99cb2e6a234d7a1f$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $99cb2e6a234d7a1f$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $99cb2e6a234d7a1f$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $99cb2e6a234d7a1f$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $99cb2e6a234d7a1f$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $99cb2e6a234d7a1f$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $99cb2e6a234d7a1f$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $99cb2e6a234d7a1f$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99cb2e6a234d7a1f$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $99cb2e6a234d7a1f$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99cb2e6a234d7a1f$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $99cb2e6a234d7a1f$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $99cb2e6a234d7a1f$export$468488291ccd988 = 'timelineAddItemNudge';
const $99cb2e6a234d7a1f$export$7a33548109ac931d = 'createFormNudge';
const $99cb2e6a234d7a1f$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $99cb2e6a234d7a1f$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $99cb2e6a234d7a1f$export$594d3436316492be = 'summaryViewNudge';
const $99cb2e6a234d7a1f$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $99cb2e6a234d7a1f$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99cb2e6a234d7a1f$export$699265ec8ad9a740 = 'Software Development';
const $99cb2e6a234d7a1f$export$e07d1fa2da8ed874 = 'Customer Service';
const $99cb2e6a234d7a1f$export$76dcec3f438d9e56 = 'IT Support';
const $99cb2e6a234d7a1f$export$9a574c301f67ba30 = 'Human Resources';
const $99cb2e6a234d7a1f$export$363ec144a94029c8 = 'Finance';
const $99cb2e6a234d7a1f$export$df0fb32d68ae1e78 = 'Legal';
const $99cb2e6a234d7a1f$export$d9c0e3e59442fb4 = 'Marketing';
const $99cb2e6a234d7a1f$export$27dbc7d7ce66e6e3 = 'Operations';
const $99cb2e6a234d7a1f$export$a5dce388adf922bd = 'Sales';
const $99cb2e6a234d7a1f$export$e1473b31a257caff = 'Data Science';
const $99cb2e6a234d7a1f$export$85657457db93c2c2 = 'Product Management';
const $99cb2e6a234d7a1f$export$c0c2d1dfaeba89dd = 'Project Management';
const $99cb2e6a234d7a1f$export$2e6a7ad3ab9c82a3 = 'Design';
const $99cb2e6a234d7a1f$export$7b60378c3b4372e9 = 'Other or Personal';
const $99cb2e6a234d7a1f$export$572242e58bd07594 = 'CS';
const $99cb2e6a234d7a1f$export$d7de553940261eba = 'ITS';
const $99cb2e6a234d7a1f$export$4c29d0d04c15e55d = 'HR';
const $99cb2e6a234d7a1f$export$3950f7f841bf94b6 = 'FNC';
const $99cb2e6a234d7a1f$export$881249b988b6030f = 'LGL';
const $99cb2e6a234d7a1f$export$e4824f74b9879164 = 'MKT';
const $99cb2e6a234d7a1f$export$4f3cb0844009af52 = 'OPS';
const $99cb2e6a234d7a1f$export$1a65d50c4a641bb4 = 'SAL';
const $99cb2e6a234d7a1f$export$9ee64e8fbd8b03a2 = 'DS';
const $99cb2e6a234d7a1f$export$b8b1ac856ba1434b = 'DEV';
const $99cb2e6a234d7a1f$export$4f54a09a24fd1d74 = 'PDM';
const $99cb2e6a234d7a1f$export$79685802e8ff1098 = 'PJM';
const $99cb2e6a234d7a1f$export$e5c438b7501b5a24 = 'DES';
const $99cb2e6a234d7a1f$export$cbc0e551d91a692d = 'OTR';

parcelRegister("cXK8c", function(module, exports) {
$parcel$export(module.exports, "pollBackend", () => $ce9f9ff38f6815c9$export$8420ef0cee98de);
/* eslint-disable jira/filename-case */ 
var $kklcL = parcelRequire("kklcL");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $ce9f9ff38f6815c9$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $kklcL.get)({
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $5ZtCQ.PACKAGE_NAME),
            teamName: (0, $5ZtCQ.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("kklcL", function(module, exports) {
$parcel$export(module.exports, "get", () => $564bc4e4a83234d6$export$3988ae62b71be9a3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cZa0l = parcelRequire("cZa0l");

var $dTOvG = parcelRequire("dTOvG");

var $hFtK7 = parcelRequire("hFtK7");

var $lCetP = parcelRequire("lCetP");

var $h2wCv = parcelRequire("h2wCv");

var $6Kdw4 = parcelRequire("6Kdw4");

var $ipvkO = parcelRequire("ipvkO");
var $jkqqC = parcelRequire("jkqqC");
let $564bc4e4a83234d6$var$ufoExperiencesMap = {};
const $564bc4e4a83234d6$var$getUfoExperience = (key)=>{
    if (!$564bc4e4a83234d6$var$ufoExperiencesMap[key]) $564bc4e4a83234d6$var$ufoExperiencesMap[key] = new (0, $jkqqC.UFOExperience)(key, {
        type: (0, $ipvkO.ExperienceTypes).Operation,
        performanceType: (0, $ipvkO.ExperiencePerformanceTypes).Custom
    });
    return $564bc4e4a83234d6$var$ufoExperiencesMap[key];
};
const $564bc4e4a83234d6$export$c907f169d33b2e25 = ()=>{
    $564bc4e4a83234d6$var$ufoExperiencesMap = {};
};
const $564bc4e4a83234d6$export$a5b7a8c3b1c6e775 = ({ userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $564bc4e4a83234d6$var$patchProperties = (response, propertiesPath)=>response && (0, (/*@__PURE__*/$parcel$interopDefault($cZa0l)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $564bc4e4a83234d6$export$3988ae62b71be9a3 = async (options)=>{
    const ufoExperience = $564bc4e4a83234d6$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($dTOvG)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($dTOvG)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $564bc4e4a83234d6$export$a5b7a8c3b1c6e775(options);
        const response = await (0, $h2wCv.performGetRequest)(url);
        if (response === null) (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'succeeded',
                actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                source: 'frontendConfigProperties',
                attributes: {
                    package: consumerMeta.packageName,
                    id: consumerMeta.id,
                    isNullResponse: true
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        $564bc4e4a83234d6$var$patchProperties(response, 'user');
        $564bc4e4a83234d6$var$patchProperties(response, 'instance');
        $564bc4e4a83234d6$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return response || {
            user: {},
            instance: {},
            project: {}
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $lCetP.isClientFetchError)(error) && (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});
parcelRegister("cZa0l", function(module, exports) {

var $27HF8 = parcelRequire("27HF8");

var $73ZOi = parcelRequire("73ZOi");

var $kqlzk = parcelRequire("kqlzk");

var $jOlpf = parcelRequire("jOlpf");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $9742f1375e9cf33c$var$forEach(collection, iteratee) {
    var func = $jOlpf(collection) ? $27HF8 : $73ZOi;
    return func(collection, $kqlzk(iteratee));
}
module.exports = $9742f1375e9cf33c$var$forEach;

});
parcelRegister("kqlzk", function(module, exports) {

var $eSVkV = parcelRequire("eSVkV");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $03d64e5056515773$var$castFunction(value) {
    return typeof value == 'function' ? value : $eSVkV;
}
module.exports = $03d64e5056515773$var$castFunction;

});


parcelRegister("dTOvG", function(module, exports) {

var $f6GKc = parcelRequire("f6GKc");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $a1e797a3f8950159$var$kebabCase = $f6GKc(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $a1e797a3f8950159$var$kebabCase;

});



parcelRegister("3gWPd", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $65a2bdf7de0b5c67$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $65a2bdf7de0b5c67$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $65a2bdf7de0b5c67$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $65a2bdf7de0b5c67$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $65a2bdf7de0b5c67$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $65a2bdf7de0b5c67$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $65a2bdf7de0b5c67$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $65a2bdf7de0b5c67$export$6ccbe54cd3a5a12);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $aJ81Y = parcelRequire("aJ81Y");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $e1PBH = parcelRequire("e1PBH");
const $65a2bdf7de0b5c67$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $5ZtCQ.ACTION_SUBJECT_ID), attributes);
};
const $65a2bdf7de0b5c67$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $65a2bdf7de0b5c67$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $65a2bdf7de0b5c67$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $5ZtCQ.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $65a2bdf7de0b5c67$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $aJ81Y.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $e1PBH.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $65a2bdf7de0b5c67$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $hFtK7.fireErrorAnalytics)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $65a2bdf7de0b5c67$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $5ZtCQ.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $65a2bdf7de0b5c67$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $5ZtCQ.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("e1PBH", function(module, exports) {
$parcel$export(module.exports, "getProductType", () => $f6fc132b152c4d81$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $f6fc132b152c4d81$export$3b914201960fa7a6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $74oEx = parcelRequire("74oEx");

var $f99M0 = parcelRequire("f99M0");
const $f6fc132b152c4d81$export$d64a7dd8c7cd80e0 = {
    [(0, $f99M0.CORE_PROJECT)]: 'workManagement',
    [(0, $f99M0.SOFTWARE_PROJECT)]: 'software',
    [(0, $f99M0.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $f6fc132b152c4d81$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $f6fc132b152c4d81$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))(projectType);
    return null;
};
const $f6fc132b152c4d81$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($74oEx)))(taskId.split('.').pop());
};

});


parcelRegister("j4vHl", function(module, exports) {
$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $85be8d50a9cdd4b5$export$7f2186c37a3d095d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $i860n = parcelRequire("i860n");

var $h2wCv = parcelRequire("h2wCv");

var $aJ81Y = parcelRequire("aJ81Y");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $rNOHK = parcelRequire("rNOHK");
const $85be8d50a9cdd4b5$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $85be8d50a9cdd4b5$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $85be8d50a9cdd4b5$var$ONE_DAY = 86400000;
const $85be8d50a9cdd4b5$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$85be8d50a9cdd4b5$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $h2wCv.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $i860n.fg)('is_synthetic_tenant')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $5ZtCQ.PACKAGE_NAME),
                teamName: (0, $5ZtCQ.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $i860n.fg)('is_synthetic_tenant')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $85be8d50a9cdd4b5$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $rNOHK.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $85be8d50a9cdd4b5$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $aJ81Y.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $i860n.fg)('is_synthetic_tenant')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $85be8d50a9cdd4b5$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $85be8d50a9cdd4b5$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("rNOHK", function(module, exports) {
$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $ff998122ab90c822$export$99f3e48748c2a8c3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cBnIS = parcelRequire("cBnIS");

const $ff998122ab90c822$var$crossProjectBoardTraitSessionProvider = (0, $cBnIS.createSessionExpirableStorageProvider)((0, $cf3747d320ece5f0$export$fac14ff24e5b1e7a));
const $ff998122ab90c822$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        // @browser-storage setter
        $ff998122ab90c822$var$crossProjectBoardTraitSessionProvider.set((0, $cf3747d320ece5f0$export$fac14ff24e5b1e7a), toPersist);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const get = ()=>$ff998122ab90c822$var$crossProjectBoardTraitSessionProvider.get((0, $cf3747d320ece5f0$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
parcelRegister("cBnIS", function(module, exports) {
$parcel$export(module.exports, "createSessionStorageProvider", () => $7db48d4913ef2f1f$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $7db48d4913ef2f1f$export$e0a2e9a062c6a695);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aUPBc = parcelRequire("aUPBc");

var $71vEP = parcelRequire("71vEP");

var $aAuyI = parcelRequire("aAuyI");

var $j0I8T = parcelRequire("j0I8T");

var $563ld = parcelRequire("563ld");
const $7db48d4913ef2f1f$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($aUPBc)))((appPrefix)=>(0, $aAuyI.createStorageProvider)((0, $j0I8T.WebStorageType).SessionStorage, appPrefix, (0, $563ld.makeSessionStore)()));
const $7db48d4913ef2f1f$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($aUPBc)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    return (0, $71vEP.createExpirableStorageProvider)((0, $j0I8T.WebStorageType).SessionStorage, appPrefix, (0, $563ld.makeSessionExpirableStore)());
});

});
parcelRegister("71vEP", function(module, exports) {
$parcel$export(module.exports, "createExpirableStorageProvider", () => $97afd86ad436cf65$export$b793a81cf479272a);

var $4fPPi = parcelRequire("4fPPi");

var $i860n = parcelRequire("i860n");

var $36m40 = parcelRequire("36m40");

var $j0I8T = parcelRequire("j0I8T");

var $2xgrt = parcelRequire("2xgrt");
const $97afd86ad436cf65$export$b793a81cf479272a = (storageType, appPrefix, // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const namespacedStore = store.namespace(appPrefix);
    // Uses the same key format as store.js: '__storejs_' + namespace + '_' + key
    const getKeyWithPrefix = (key)=>`${0, $36m40.STOREJS_KEY_PREFIX}${appPrefix}_${key}`;
    // Uses the same expiration key format as store.js expirePlugin:
    // Sub-store namespace = __storejs_{appPrefix}_expire_mixin
    // Sub-store prefix = __storejs_ + sub-store namespace + _ = __storejs___storejs_{appPrefix}_expire_mixin_
    const getExpireKeyWithPrefix = (key)=>`${0, $36m40.STOREJS_KEY_PREFIX}${0, $36m40.STOREJS_KEY_PREFIX}${appPrefix}_expire_mixin_${key}`;
    const storageAPI = storageType === (0, $j0I8T.WebStorageType).LocalStorage ? (0, $4fPPi.AtlBrowserStorageLocal) : (0, $4fPPi.AtlBrowserStorageSession);
    const browserStorage = storageType === (0, $j0I8T.WebStorageType).LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    const remove = (key)=>{
        try {
            if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                    // eslint-disable-next-line no-console
                    console.warn(`${storageType} is unavailable (e.g. SSR). Failed to remove item ${key}`);
                    return;
                }
                storageAPI.removeItem(getKeyWithPrefix(key));
                storageAPI.removeItem(getExpireKeyWithPrefix(key));
            }
            // Remove from old store as well, or the only store if FG is off
            namespacedStore.remove(key);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error removing item with key=${key}:`, error);
        }
    };
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value, expiration)=>{
            try {
                // Matches store.js behavior: set(key, undefined) calls remove(key)
                if (value === undefined) return remove(key);
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                        // eslint-disable-next-line no-console
                        console.warn(`${storageType} is unavailable (e.g. SSR). Failed to set item ${key}`);
                        return;
                    }
                    const prefixedKey = getKeyWithPrefix(key);
                    const expireKey = getExpireKeyWithPrefix(key);
                    storageAPI.setItem(prefixedKey, JSON.stringify(value)).then((setItemResult)=>{
                        if (setItemResult.status !== 'SUCCESS') {
                            storageAPI.removeItem(expireKey);
                            return;
                        }
                        // Matches store.js: set(key, val) without expiration clears any existing expiration
                        if (expiration !== undefined) storageAPI.setStrictlyNecessaryItem(expireKey, JSON.stringify(expiration));
                        else storageAPI.removeItem(expireKey);
                    }, (error)=>{
                        // eslint-disable-next-line no-console
                        console.error(`Error setting item with key=${key}:`, error);
                    });
                } else namespacedStore.set(key, value, expiration);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setAsync: async (key, value, expiration)=>{
            try {
                if (value === undefined) return remove(key);
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                        // eslint-disable-next-line no-console
                        console.warn(`${storageType} is unavailable (e.g. SSR). Failed to set item ${key}`);
                        return;
                    }
                    const prefixedKey = getKeyWithPrefix(key);
                    const setItemResult = await storageAPI.setItem(prefixedKey, JSON.stringify(value));
                    if (setItemResult !== undefined) {
                        if (setItemResult.status === 'BLOCKED') {
                            storageAPI.removeItem(prefixedKey);
                            throw new Error('write was blocked by storage or consent preferences.');
                        }
                        if (setItemResult.status !== 'SUCCESS') throw new Error('write failed');
                    }
                    const expireKey = getExpireKeyWithPrefix(key);
                    if (expiration !== undefined) storageAPI.setStrictlyNecessaryItem(expireKey, JSON.stringify(expiration));
                    else storageAPI.removeItem(expireKey);
                } else namespacedStore.set(key, value, expiration);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
                throw error;
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value, expiration)=>{
            try {
                // Matches store.js behavior: set(key, undefined) calls remove(key)
                if (value === undefined) return remove(key);
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                        // eslint-disable-next-line no-console
                        console.warn(`${storageType} is unavailable (e.g. SSR). Failed to set strictly necessary item ${key}`);
                        return;
                    }
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.setStrictlyNecessaryItem(prefixedKey, JSON.stringify(value));
                    // Matches store.js: set(key, val) without expiration clears any existing expiration
                    const expireKey = getExpireKeyWithPrefix(key);
                    if (expiration !== undefined) storageAPI.setStrictlyNecessaryItem(expireKey, JSON.stringify(expiration));
                    else storageAPI.removeItem(expireKey);
                } else // this has to be done when setStrictlyNecessaryItem comes into usage, and it should have a fallback when FG is turned off
                namespacedStore.set(key, value, expiration);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                        // eslint-disable-next-line no-console
                        console.warn(`${storageType} is unavailable (e.g. SSR). Failed to get item ${key}`);
                        return undefined;
                    }
                    // Matches store.js expirePlugin: check expiration before reading value
                    const expireKey = getExpireKeyWithPrefix(key);
                    const expirationStr = storageAPI.getItem(expireKey);
                    if (expirationStr) {
                        const expiration = JSON.parse(expirationStr);
                        if (expiration < Date.now()) {
                            // Expired: remove both value and expiration keys
                            storageAPI.removeItem(getKeyWithPrefix(key));
                            storageAPI.removeItem(expireKey);
                            return;
                        }
                    }
                    const prefixedKey = getKeyWithPrefix(key);
                    const itemStr = storageAPI.getItem(prefixedKey);
                    if (typeof itemStr === 'string') return JSON.parse(itemStr);
                } else return namespacedStore.get(key);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting item with key=${key}:`, error);
            }
        },
        getExpiration: (key)=>{
            try {
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                        // eslint-disable-next-line no-console
                        console.warn(`${storageType} is unavailable (e.g. SSR). Failed to get expiration for item ${key}`);
                        return undefined;
                    }
                    // Matches store.js expirePlugin: expirations.get(key) — returns raw timestamp
                    const expireKey = getExpireKeyWithPrefix(key);
                    const expirationStr = storageAPI.getItem(expireKey);
                    if (typeof expirationStr === 'string') return JSON.parse(expirationStr);
                    return undefined;
                }
                return namespacedStore.getExpiration(key);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting expiration for item with key=${key}:`, error);
                return undefined;
            }
        },
        remove: remove,
        removeExpiredKeys: ()=>{
            try {
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                        // eslint-disable-next-line no-console
                        console.warn(`${storageType} is unavailable (e.g. SSR). Failed to remove expired keys`);
                        return;
                    }
                    const expirePrefix = `${(0, $36m40.STOREJS_KEY_PREFIX)}${(0, $36m40.STOREJS_KEY_PREFIX)}`;
                    const expireSuffix = '_expire_mixin_';
                    for(let i = storageAPI.length() - 1; i >= 0; i--){
                        const storageKey = storageAPI.key(i);
                        const suffixIndex = storageKey ? storageKey.indexOf(expireSuffix) : -1;
                        if (storageKey && storageKey.startsWith(expirePrefix) && suffixIndex !== -1) {
                            const expirationStr = storageAPI.getItem(storageKey);
                            if (expirationStr) {
                                const expiration = JSON.parse(expirationStr);
                                if (expiration < Date.now()) {
                                    // Derive the value key: __storejs_ + namespace + _ + originalKey
                                    const namespace = storageKey.substring(expirePrefix.length, suffixIndex);
                                    const originalKey = storageKey.substring(suffixIndex + expireSuffix.length);
                                    const valueKey = `${(0, $36m40.STOREJS_KEY_PREFIX)}${namespace}_${originalKey}`;
                                    storageAPI.removeItem(valueKey);
                                    storageAPI.removeItem(storageKey);
                                }
                            }
                        }
                    }
                    namespacedStore.removeExpiredKeys(); // clean up old keys too
                } else namespacedStore.removeExpiredKeys();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error removing expired keys:', error);
            }
        },
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                        // eslint-disable-next-line no-console
                        console.warn(`${storageType} is unavailable (e.g. SSR). Failed to clear storage`);
                        return;
                    }
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                    // eslint-disable-next-line no-console
                    console.warn(`${storageType} is unavailable (e.g. SSR). Failed to get storage length`);
                    return 0;
                }
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
                return 0;
            }
        },
        key: (index)=>{
            try {
                if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                    // eslint-disable-next-line no-console
                    console.warn(`${storageType} is unavailable (e.g. SSR). Failed to get key at index ${index}`);
                    return null;
                }
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.key(index);
                return browserStorage?.key(index) ?? null;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting key at index:', err);
                return null;
            }
        }
    };
};

});
parcelRegister("36m40", function(module, exports) {
$parcel$export(module.exports, "STOREJS_KEY_PREFIX", () => $e8eb94185a42a3fe$export$d9143877213d8e0a);
$parcel$export(module.exports, "NAMESPACE", () => $e8eb94185a42a3fe$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $e8eb94185a42a3fe$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $e8eb94185a42a3fe$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $e8eb94185a42a3fe$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $e8eb94185a42a3fe$export$ea28dfd9333cda2d);
/* eslint-disable jira/filename-case */ /** Same prefix as store.js namespaced keys: `__storejs_` + namespace + `_` + key */ const $e8eb94185a42a3fe$export$d9143877213d8e0a = '__storejs_';
const $e8eb94185a42a3fe$export$6aad947bda0f3f46 = 'timestamps';
const $e8eb94185a42a3fe$export$8187f416f1cc43d8 = 604800000;
const $e8eb94185a42a3fe$export$6e952fa7d47190cf = 4 * $e8eb94185a42a3fe$export$8187f416f1cc43d8;
const $e8eb94185a42a3fe$export$da99ebca8f453abd = 22;
const $e8eb94185a42a3fe$export$ea28dfd9333cda2d = 1014;

});

parcelRegister("j0I8T", function(module, exports) {
$parcel$export(module.exports, "WebStorageType", () => $5029131229abdad6$export$259e3a861f28589b);
/* eslint-disable jira/filename-case */ const $5029131229abdad6$export$259e3a861f28589b = {
    LocalStorage: 'LocalStorage',
    SessionStorage: 'SessionStorage'
};

});

parcelRegister("2xgrt", function(module, exports) {
$parcel$export(module.exports, "isStorageAPIAvailable", () => $1933fc72e1f9c1bd$export$cec05f68a314ce01);
/**
 * Checks if window and storage APIs are available (e.g. not in SSR).
 * Similar to @atlassian/browser-storage-controls isSSR + isStorageAvailable logic.
 * Returns false when window/document are undefined or storage throws (SSR, private browsing).
 */ const $1933fc72e1f9c1bd$export$cec05f68a314ce01 = ()=>{
    try {
        const isMissingBrowserUtils = typeof globalThis.document === 'undefined' || typeof globalThis.window === 'undefined' || typeof document === 'undefined' || typeof window === 'undefined' || typeof globalThis.localStorage === 'undefined' || typeof globalThis.sessionStorage === 'undefined' || typeof localStorage === 'undefined' || typeof sessionStorage === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
        if (isMissingBrowserUtils) return false;
        return true;
    } catch  {
        return false;
    }
};

});


parcelRegister("aAuyI", function(module, exports) {
$parcel$export(module.exports, "createStorageProvider", () => $91bd9b44433364f9$export$8441605555fbd60c);

var $4fPPi = parcelRequire("4fPPi");

var $i860n = parcelRequire("i860n");

var $36m40 = parcelRequire("36m40");

var $j0I8T = parcelRequire("j0I8T");

var $2xgrt = parcelRequire("2xgrt");
const $91bd9b44433364f9$export$8441605555fbd60c = (storageType, appPrefix = '', // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>{
    const namespacedStore = store.namespace(appPrefix);
    // Uses the same key format as store.js: namespace ? '__storejs_' + namespace + '_' + key : key
    const getKeyWithPrefix = (key)=>appPrefix?.trim().length ? `${0, $36m40.STOREJS_KEY_PREFIX}${appPrefix}_${key}` : key;
    const storageAPI = storageType === (0, $j0I8T.WebStorageType).LocalStorage ? (0, $4fPPi.AtlBrowserStorageLocal) : (0, $4fPPi.AtlBrowserStorageSession);
    const browserStorage = storageType === (0, $j0I8T.WebStorageType).LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    const remove = (key)=>{
        try {
            if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                    // eslint-disable-next-line no-console
                    console.warn(`${storageType} is unavailable (e.g. SSR). Failed to remove item ${key}`);
                    return;
                }
                const prefixedKey = getKeyWithPrefix(key);
                storageAPI.removeItem(prefixedKey); // remove data from new store
                namespacedStore.remove(key); // remove data from old store as well
            } else namespacedStore.remove(key);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Error removing item with key=${key}:`, err);
        }
    };
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value)=>{
            try {
                // Matches store.js behavior: set(key, undefined) calls remove(key)
                if (value === undefined) return remove(key);
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                        // eslint-disable-next-line no-console
                        console.warn(`${storageType} is unavailable (e.g. SSR). Failed to set item ${key}`);
                        return;
                    }
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.setItem(prefixedKey, JSON.stringify(value)).then((setItemResult)=>{
                        if (setItemResult?.status === 'BLOCKED') storageAPI.removeItem(prefixedKey);
                    });
                } else namespacedStore.set(key, value);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setAsync: async (key, value)=>{
            try {
                if (value === undefined) return remove(key);
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                        // eslint-disable-next-line no-console
                        console.warn(`${storageType} is unavailable (e.g. SSR). Failed to set item ${key}`);
                        return;
                    }
                    const prefixedKey = getKeyWithPrefix(key);
                    const setItemResult = await storageAPI.setItem(prefixedKey, JSON.stringify(value));
                    if (setItemResult !== undefined) {
                        if (setItemResult.status === 'BLOCKED') {
                            storageAPI.removeItem(prefixedKey);
                            throw new Error('write was blocked by storage or consent preferences.');
                        }
                        if (setItemResult.status !== 'SUCCESS') throw new Error('write failed');
                    }
                } else namespacedStore.set(key, value);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, err);
                throw err;
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value)=>{
            try {
                // Matches store.js behavior: set(key, undefined) calls remove(key)
                if (value === undefined) return remove(key);
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                        // eslint-disable-next-line no-console
                        console.warn(`${storageType} is unavailable (e.g. SSR). Failed to set strictly necessary item ${key}`);
                        return;
                    }
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.setStrictlyNecessaryItem(prefixedKey, JSON.stringify(value));
                } else // this has to be done when setStrictlyNecessaryItem comes into usage, and it should have a fallback when FG is turned off
                namespacedStore.set(key, value);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                        // eslint-disable-next-line no-console
                        console.warn(`${storageType} is unavailable (e.g. SSR). Failed to get item ${key}`);
                        return undefined;
                    }
                    const prefixedKey = getKeyWithPrefix(key);
                    const item = storageAPI.getItem(prefixedKey);
                    if (typeof item === 'string') return JSON.parse(item);
                } else return namespacedStore.get(key);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Error getting item with key=${key}:`, err);
            }
        },
        remove: remove,
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) {
                    if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                        // eslint-disable-next-line no-console
                        console.warn(`${storageType} is unavailable (e.g. SSR). Failed to clear storage`);
                        return;
                    }
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                    // eslint-disable-next-line no-console
                    console.warn(`${storageType} is unavailable (e.g. SSR). Failed to get storage length`);
                    return 0;
                }
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
                return 0;
            }
        },
        key: (index)=>{
            try {
                if (!(0, $2xgrt.isStorageAPIAvailable)()) {
                    // eslint-disable-next-line no-console
                    console.warn(`${storageType} is unavailable (e.g. SSR). Failed to get key at index ${index}`);
                    return null;
                }
                if ((0, $i860n.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.key(index);
                return browserStorage?.key(index) ?? null;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting key at index:', err);
                return null;
            }
        }
    };
};

});

parcelRegister("563ld", function(module, exports) {
$parcel$export(module.exports, "makeSessionStore", () => $7e4ef50df9165a25$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $7e4ef50df9165a25$export$a8f626c8ded9a06c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /// <reference path="../../store.d.ts" />

var $jvDG2 = parcelRequire("jvDG2");

var $jd9DX = parcelRequire("jd9DX");

var $ef3Gs = parcelRequire("ef3Gs");

var $5oLFf = parcelRequire("5oLFf");

var $c7VES = parcelRequire("c7VES");

var $i860n = parcelRequire("i860n");

var $6ZLJT = parcelRequire("6ZLJT");

var $5l7hq = parcelRequire("5l7hq");
const $7e4ef50df9165a25$var$getPluginsWithCondition = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jfp-vulcan-browser-storage-disable-auto-cleanup'), ()=>[
        (0, (/*@__PURE__*/$parcel$interopDefault($jvDG2)))
    ], ()=>[
        (0, (/*@__PURE__*/$parcel$interopDefault($jvDG2))),
        (0, $5l7hq.default)
    ]);
const $7e4ef50df9165a25$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ef3Gs))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c7VES))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5oLFf)))
    ], $7e4ef50df9165a25$var$getPluginsWithCondition());
const $7e4ef50df9165a25$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ef3Gs))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($c7VES))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5oLFf)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($jvDG2))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jd9DX)))
    ]);

});
parcelRegister("5l7hq", function(module, exports) {
$parcel$export(module.exports, "default", () => $f665d84c6e161163$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $36m40 = parcelRequire("36m40");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f665d84c6e161163$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $36m40.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $36m40.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $36m40.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $36m40.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e,
                    skipSentry: true
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $36m40.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $36m40.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $36m40.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $36m40.ONE_WEEK) >= (0, $36m40.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $36m40.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $f665d84c6e161163$export$2e2bcd8739ae039 = $f665d84c6e161163$var$cleanUpPlugin;

});



/* eslint-disable jira/filename-case */ const $cf3747d320ece5f0$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("7rCTA", function(module, exports) {
$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $a2d25f665e97755b$export$980c26b6f100081d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $a2d25f665e97755b$export$980c26b6f100081d = ()=>(0, $h2wCv.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("1DyW0", function(module, exports) {
$parcel$export(module.exports, "getNextNonCompleteTask", () => $c23f851187752075$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $c23f851187752075$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $c23f851187752075$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $c23f851187752075$export$93d719890ad66653);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $iXN50 = parcelRequire("iXN50");

var $b10Xz = parcelRequire("b10Xz");
const $c23f851187752075$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $b10Xz.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $c23f851187752075$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $b10Xz.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $c23f851187752075$var$store = (0, $iXN50.createLocalStorageProvider)('quickstart');
const $c23f851187752075$export$5aa524d86254b4f = (key, value)=>{
    // @browser-storage setter
    $c23f851187752075$var$store.set(key, value);
};
const $c23f851187752075$export$93d719890ad66653 = (key)=>$c23f851187752075$var$store.get(key);

});
parcelRegister("iXN50", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageProvider", () => $4e87a16ccd12b673$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $4e87a16ccd12b673$export$59acef2b3ab1df90);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aUPBc = parcelRequire("aUPBc");

var $71vEP = parcelRequire("71vEP");

var $aAuyI = parcelRequire("aAuyI");

var $j0I8T = parcelRequire("j0I8T");

var $fMHoz = parcelRequire("fMHoz");
const $4e87a16ccd12b673$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($aUPBc)))((appPrefix)=>(0, $aAuyI.createStorageProvider)((0, $j0I8T.WebStorageType).LocalStorage, appPrefix, (0, $fMHoz.makeLocalStore)()));
const $4e87a16ccd12b673$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($aUPBc)))((appPrefix)=>{
    return (0, $71vEP.createExpirableStorageProvider)((0, $j0I8T.WebStorageType).LocalStorage, appPrefix, (0, $fMHoz.makeLocalExpirableStore)());
});

});
parcelRegister("fMHoz", function(module, exports) {
$parcel$export(module.exports, "makeLocalStore", () => $d4a9fcb144d0bbbc$export$b2631085fe8db7af);
$parcel$export(module.exports, "isLocalStorageAvailable", () => $d4a9fcb144d0bbbc$export$117a30df0da2af20);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $d4a9fcb144d0bbbc$export$cf816b43e73de947);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /// <reference path="../../store.d.ts" />

var $jvDG2 = parcelRequire("jvDG2");

var $jd9DX = parcelRequire("jd9DX");

var $ef3Gs = parcelRequire("ef3Gs");

var $byYuq = parcelRequire("byYuq");

var $5oLFf = parcelRequire("5oLFf");

var $i860n = parcelRequire("i860n");

var $6ZLJT = parcelRequire("6ZLJT");

var $5l7hq = parcelRequire("5l7hq");
const $d4a9fcb144d0bbbc$var$getPluginsWithCondition = (0, $6ZLJT.functionWithCondition)(()=>(0, $i860n.fg)('jfp-vulcan-browser-storage-disable-auto-cleanup'), ()=>[
        (0, (/*@__PURE__*/$parcel$interopDefault($jvDG2)))
    ], ()=>[
        (0, (/*@__PURE__*/$parcel$interopDefault($jvDG2))),
        (0, $5l7hq.default)
    ]);
const $d4a9fcb144d0bbbc$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ef3Gs))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($byYuq))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5oLFf)))
    ], $d4a9fcb144d0bbbc$var$getPluginsWithCondition());
const $d4a9fcb144d0bbbc$export$117a30df0da2af20 = ()=>typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
const $d4a9fcb144d0bbbc$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ef3Gs))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($byYuq))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5oLFf)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($jvDG2))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jd9DX)))
    ]);

});


parcelRegister("b10Xz", function(module, exports) {
$parcel$export(module.exports, "getTaskIndex", () => $1c91ec05f437a692$export$9ba3adcb1954c00);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $1c91ec05f437a692$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};

});


parcelRegister("2wjIB", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $b10962e0ec92b529$export$f24c05f83b880547);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");

var $1n5q3 = parcelRequire("1n5q3");

var $1DyW0 = parcelRequire("1DyW0");
const $b10962e0ec92b529$export$f24c05f83b880547 = (isDismissed)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED : (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
        await (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $1DyW0.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
    };

});


parcelRegister("k2hbg", function(module, exports) {
$parcel$export(module.exports, "setNudgeStep", () => $f2eed325adbc91e3$export$4debc323813b6997);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f2eed325adbc91e3$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $f2eed325adbc91e3$export$2e2bcd8739ae039 = $f2eed325adbc91e3$export$4debc323813b6997;

});

parcelRegister("2viaa", function(module, exports) {
$parcel$export(module.exports, "addMountedNudge", () => $181780d386438a22$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $181780d386438a22$export$748f4cda8ab98c91);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $181780d386438a22$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $181780d386438a22$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("agR3I", function(module, exports) {
$parcel$export(module.exports, "setShouldRenderComponent", () => $21faee8cd07c7826$export$1f9c6770ed938b6e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $21faee8cd07c7826$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $21faee8cd07c7826$export$2e2bcd8739ae039 = $21faee8cd07c7826$export$1f9c6770ed938b6e;

});

parcelRegister("3riN6", function(module, exports) {
$parcel$export(module.exports, "setProjectState", () => $8be844875c197b4c$export$1ba498e440c0a1e4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $8be844875c197b4c$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $8be844875c197b4c$export$2e2bcd8739ae039 = $8be844875c197b4c$export$1ba498e440c0a1e4;

});

parcelRegister("2yI5h", function(module, exports) {
$parcel$export(module.exports, "setHasNudgeActive", () => $cb36e2a712e94de8$export$497c281e6eb0786e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $cb36e2a712e94de8$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $cb36e2a712e94de8$export$2e2bcd8739ae039 = $cb36e2a712e94de8$export$497c281e6eb0786e;

});

parcelRegister("7925l", function(module, exports) {
$parcel$export(module.exports, "forceHideNudge", () => $27c0283352888859$export$6d1ed97b83a62e8e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
// We use this action in cases where we want to hide the nudge no matter what.
const $27c0283352888859$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("2eU4H", function(module, exports) {
$parcel$export(module.exports, "setHasEverSeenRoute", () => $eed870853487f8ba$export$28e0a4314a1ce52f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");
const $eed870853487f8ba$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $eed870853487f8ba$export$2e2bcd8739ae039 = $eed870853487f8ba$export$28e0a4314a1ce52f;

});

parcelRegister("6zJVJ", function(module, exports) {
$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $2924f9407820ccff$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $2924f9407820ccff$export$932967764e7a0b31);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2924f9407820ccff$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $2924f9407820ccff$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("8qaqK", function(module, exports) {
$parcel$export(module.exports, "openNextTask", () => $828ec87dd11f6c94$export$867dbb6d61569ae9);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1DyW0 = parcelRequire("1DyW0");

var $lhMTU = parcelRequire("lhMTU");
const $828ec87dd11f6c94$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $1DyW0.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $lhMTU.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("lhMTU", function(module, exports) {
$parcel$export(module.exports, "nextOpenTask", () => $5acbe4b4d2edaa6b$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $5acbe4b4d2edaa6b$export$cc5f3544a6cb2922);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");

var $k2hbg = parcelRequire("k2hbg");

var $2yI5h = parcelRequire("2yI5h");
const $5acbe4b4d2edaa6b$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $5acbe4b4d2edaa6b$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($5acbe4b4d2edaa6b$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $2yI5h.setHasNudgeActive)(false, taskId));
        else dispatch((0, $2yI5h.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        dispatch((0, $k2hbg.setNudgeStep)(''));
    };
const $5acbe4b4d2edaa6b$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($5acbe4b4d2edaa6b$var$openTask(taskId));
        dispatch((0, $2yI5h.setHasNudgeActive)(false, taskId));
        dispatch((0, $k2hbg.setNudgeStep)(''));
    };

});


parcelRegister("4BoSU", function(module, exports) {
$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $9832d8441f0ceec4$export$bda085a823763e5a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $1n5q3 = parcelRequire("1n5q3");
const $9832d8441f0ceec4$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("gJ2q6", function(module, exports) {
$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $b3410c869ae99198$export$87fe8079a4ed9766);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $5ZtCQ = parcelRequire("5ZtCQ");

var $cXK8c = parcelRequire("cXK8c");

var $3gWPd = parcelRequire("3gWPd");

var $7rCTA = parcelRequire("7rCTA");

var $2wjIB = parcelRequire("2wjIB");
const $b3410c869ae99198$export$87fe8079a4ed9766 = ({ taskList: taskList, containerType: containerType = 'project' })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        updatedState.containerType = containerType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).map((type)=>(0, $5ZtCQ.getBackendVisibilityKey)(type));
        const backendState = await (0, $cXK8c.pollBackend)({
            keys: [
                (0, $5ZtCQ.KEY_OPEN),
                (0, $5ZtCQ.KEY_DISMISSED),
                (0, $5ZtCQ.KEY_OPEN_TASK),
                (0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $5ZtCQ.KEY_JSW_ONBOARDING),
                ...(0, $5ZtCQ.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $5ZtCQ.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $5ZtCQ.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $5ZtCQ.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $5ZtCQ.getBackendVisibilityKey)(type)];
                else if ((0, $5ZtCQ.KEY_DISMISSED) in backendState && backendState[0, $5ZtCQ.KEY_DISMISSED]) updatedState.visibility[type] = (0, $5ZtCQ.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $5ZtCQ.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $5ZtCQ.KEY_OPEN] ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN : (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $5ZtCQ.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $5ZtCQ.KEY_DISMISSED];
            if ((0, $5ZtCQ.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $5ZtCQ.KEY_OPEN];
            if ((0, $5ZtCQ.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $5ZtCQ.KEY_OPEN_TASK];
            if ((0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $5ZtCQ.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $5ZtCQ.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $5ZtCQ.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $5ZtCQ.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $5ZtCQ.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING] !== null && (0, $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe) in backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $5ZtCQ.KEY_JSW_ONBOARDING][0, $99cb2e6a234d7a1f$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $5ZtCQ.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $7rCTA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $2wjIB.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3gWPd.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("agOGQ", function(module, exports) {
$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $8ffbc9dfb3f298b8$export$d6628d41a3bec42d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $kRAaT = parcelRequire("kRAaT");
const $8ffbc9dfb3f298b8$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $kRAaT.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});

parcelRegister("ljq2N", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $4dc8711b425ff774$export$4eac017dcde0be8f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");
const $4dc8711b425ff774$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $5ZtCQ.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("1XEDt", function(module, exports) {
$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $0532a026145990a5$export$4249eabbb34e2e69);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $kRAaT = parcelRequire("kRAaT");

var $1n5q3 = parcelRequire("1n5q3");

var $1DyW0 = parcelRequire("1DyW0");
const $0532a026145990a5$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $5ZtCQ.QUICKSTART_UI_STATUS).OPEN : (0, $5ZtCQ.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $1DyW0.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $kRAaT.pushToBackend)({
            key: (0, $5ZtCQ.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("ktOmH", function(module, exports) {
$parcel$export(module.exports, "nextAutoExpand", () => $a4785549688c9665$export$3d24e97d30cfd09e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $wtuZr = parcelRequire("wtuZr");

var $1DyW0 = parcelRequire("1DyW0");

var $lhMTU = parcelRequire("lhMTU");
const $a4785549688c9665$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $wtuZr.localStorageProvider)().get({
            accountId: (0, $5ZtCQ.ACCOUNT_ID),
            key: (0, $5ZtCQ.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $1DyW0.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        // If the openTask is the same as the currentTriggerForTaskGroupParent, we just returned back from a sub menu and don't need to auto open the next task
        if (openTask === currentTriggerForTaskGroupParent) return;
        dispatch((0, $lhMTU.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("wtuZr", function(module, exports) {
$parcel$export(module.exports, "localStorageProvider", () => $65ddfd76edbdbdc9$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $65ddfd76edbdbdc9$export$f2666fae743fa5f);
/* eslint-disable jira/filename-case */ 
var $hFtK7 = parcelRequire("hFtK7");

var $cBnIS = parcelRequire("cBnIS");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $65ddfd76edbdbdc9$var$DAYS_BEFORE_EXPIRY = 1;
const $65ddfd76edbdbdc9$var$DAY = 86400000;
const $65ddfd76edbdbdc9$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $65ddfd76edbdbdc9$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $65ddfd76edbdbdc9$var$DAYS_BEFORE_EXPIRY * $65ddfd76edbdbdc9$var$DAY;
};
let $65ddfd76edbdbdc9$var$localStorage;
const $65ddfd76edbdbdc9$export$aa821bfb3308a1f5 = ()=>{
    if ($65ddfd76edbdbdc9$var$localStorage) // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    return $65ddfd76edbdbdc9$var$localStorage;
    const provider = (0, $cBnIS.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($65ddfd76edbdbdc9$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>// @browser-storage setter
        provider.set($65ddfd76edbdbdc9$var$getKey({
            accountId: accountId,
            key: key
        }), value, $65ddfd76edbdbdc9$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($65ddfd76edbdbdc9$var$getKey({
            accountId: accountId,
            key: key
        }));
    $65ddfd76edbdbdc9$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    // eslint-disable-next-line jira/web-storage/no-direct-web-storage-usage
    return $65ddfd76edbdbdc9$var$localStorage;
};
const $65ddfd76edbdbdc9$export$f2666fae743fa5f = (value)=>{
    $65ddfd76edbdbdc9$export$aa821bfb3308a1f5().set({
        accountId: (0, $5ZtCQ.ACCOUNT_ID),
        key: (0, $5ZtCQ.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("3slnW", function(module, exports) {
$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $990f321ad1af71ae$export$6f336ccb6432fcd0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $5ZtCQ = parcelRequire("5ZtCQ");

var $wtuZr = parcelRequire("wtuZr");

var $2yI5h = parcelRequire("2yI5h");
const $990f321ad1af71ae$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $5ZtCQ.ACCOUNT_ID),
            key: (0, $5ZtCQ.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $wtuZr.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $2yI5h.setHasNudgeActive)(true));
            (0, $wtuZr.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("hOXkl", function(module, exports) {
$parcel$export(module.exports, "nextGetTasks", () => $bb46770c873ac15c$export$15d877e1f3abf489);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $kApfL = parcelRequire("kApfL");

var $lhMTU = parcelRequire("lhMTU");
const $bb46770c873ac15c$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { taskList: taskList, completedTaskList: completedTaskList, openTask: openTask, isQuickstartLoaded: isQuickstartLoaded } = getState();
        const tasks = (0, $kApfL.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
        // Auto-open the first incomplete task if no task is currently open
        // Note: nextGetTasks and refreshAppState can in theory happen in any order
        // Only do this if the quickstart is fully loaded (isQuickstartLoaded = true)
        // This ensures backend state has been restored before we auto-open
        if (tasks?.items && tasks.items.length > 0 && isQuickstartLoaded) {
            const firstIncompleteTask = tasks.items.find((taskId)=>!completedTaskList.includes(taskId));
            // If we found a first incomplete task and no task is currently open, open it
            if (firstIncompleteTask && !openTask) dispatch((0, $lhMTU.nextOpenTask)(firstIncompleteTask));
        }
    };

});
parcelRegister("kApfL", function(module, exports) {
$parcel$export(module.exports, "getAllTasks", () => $22017e3d8b39c720$export$d1f442602a91e7cc);

var $41FAq = parcelRequire("41FAq");

var $lG3WD = parcelRequire("lG3WD");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $8ZIK8 = parcelRequire("8ZIK8");

var $9URGr = parcelRequire("9URGr");

var $jrlyX = parcelRequire("jrlyX");

var $cBvJ0 = parcelRequire("cBvJ0");

var $er8Op = parcelRequire("er8Op");

var $dX7f5 = parcelRequire("dX7f5");

var $gehxg = parcelRequire("gehxg");

var $dvbnR = parcelRequire("dvbnR");

var $jXUhc = parcelRequire("jXUhc");
const $22017e3d8b39c720$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    // Removed jira_rt_quickstart_m1 feature flag - serving true case (no reverse trial task list)
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $5ZtCQ.ROOT_TASK];
    return {
        title: title,
        items: (0, $er8Op.getTasks)(variants, taskVariants, items)
    };
};
const $22017e3d8b39c720$var$createJwmTasks = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList, teamType: teamType })=>{
    return $22017e3d8b39c720$export$568bd601466cd235({
        taskGroupParent: taskGroupParent,
        teamType: teamType,
        projectState: projectState,
        taskList: taskList
    });
};
const $22017e3d8b39c720$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $9URGr.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $9URGr.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $8ZIK8.USER_ROLE).JIRA_ADMIN) variants.push((0, $9URGr.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $8ZIK8.USER_ROLE).SITE_ADMIN) variants.push((0, $9URGr.JSM).userRole.siteAdmin);
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $9URGr.JSM).taskVariants,
        taskList: (0, $9URGr.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$var$createPlanTasks = (taskGroupParent, features)=>{
    const variants = [];
    if (features?.hasPlanDependencies) variants.push((0, $dvbnR.Feature).hasPlanDependencies);
    if (features?.hasPlanProgram) variants.push((0, $dvbnR.Feature).hasPlanProgram);
    if (features?.hasPlanReleases) variants.push((0, $dvbnR.Feature).hasPlanReleases);
    if (features?.hasPlanTeams) variants.push((0, $dvbnR.Feature).hasPlanTeams);
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $cBvJ0.PLAN).taskVariants,
        taskList: (0, $cBvJ0.PLAN).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$export$d9d83c8e96505820 = (taskGroupParent, teamType, features, permissions)=>{
    const variants = [];
    if (features?.hasBacklog) variants.push((0, $dvbnR.Feature).hasBacklog);
    if (features?.hasSprint) variants.push((0, $dvbnR.Feature).hasSprint);
    if (features?.hasSummaryPage) variants.push((0, $dvbnR.Feature).hasSummaryPage);
    if (features?.hasRoadmap) variants.push((0, $dvbnR.Feature).hasRoadmap);
    if (features?.hasList) variants.push((0, $dvbnR.Feature).hasList);
    if (features?.hasCalendar) variants.push((0, $dvbnR.Feature).hasCalendar);
    if ((0, $2700E.expVal)('jira_hide_connect_your_code_in_isolated_cloud', 'isEnabled', false) ? (0, $41FAq.isFeatureEnabled)('jira', 'jira-development-tab') && features?.hasCode : features?.hasCode) variants.push((0, $dvbnR.Feature).hasCode);
    if (features?.hasForms) variants.push((0, $dvbnR.Feature).hasForms);
    if (features?.hasPages) variants.push((0, $dvbnR.Feature).hasPages);
    if ((0, $i860n.fg)('remove_pages_nudge_in_fedramp_environment') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-quickstart-pages') : false) variants.push((0, $dvbnR.Experience).fedRamp);
    if (permissions?.canCreateIssue) variants.push((0, $dvbnR.Permissions).canCreateIssue);
    variants.push((0, $dvbnR.FeatureGate).removeInitialProjectTemplateName);
    if (teamType && (0, $lG3WD.isTailoredOnboardingTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $gehxg.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariants,
        taskList: (0, $gehxg.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$export$e21b96de210942 = ({ taskGroupParent: taskGroupParent, teamType: teamType })=>{
    const variants = [];
    if (teamType && (0, $lG3WD.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    if ((0, $i860n.fg)('remove_pages_nudge_in_fedramp_environment') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-quickstart-pages') : false) variants.push((0, $dvbnR.Experience).fedRamp);
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $gehxg.TAILORED_ONBOARDING_M2P5).getM2P5TaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $gehxg.TAILORED_ONBOARDING_M2P5).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$export$568bd601466cd235 = ({ taskGroupParent: taskGroupParent, teamType: teamType, projectState: projectState, taskList: taskList })=>{
    const variants = [];
    // When cleaning up M2 and consolidating configs, this team type check should just be updated to include MKT & OPS
    if (teamType && (0, $lG3WD.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    if (projectState?.isTrelloCrossflow) variants.push((0, $jrlyX.JWM).experiments.trelloCrossflow);
    if (projectState?.userRole === (0, $8ZIK8.USER_ROLE).SITE_ADMIN) variants.push((0, $jrlyX.JWM).userRole.siteAdmin);
    if ((0, $i860n.fg)('remove_pages_nudge_in_fedramp_environment') ? !(0, $41FAq.isFeatureEnabled)('jira', 'jira-quickstart-pages') : false) variants.push((0, $dvbnR.Experience).fedRamp);
    return $22017e3d8b39c720$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $jXUhc.TAILORED_ONBOARDING_BUSINESS_CONFIG),
        // This should be cleaned up when M2 is cleaned up. Currently it's like this because M2 populates taskList via the BE
        // and then the FE uses it here, ideally M2 cards are in the business config following conventions so they don't get extra priority bypassing other stuff in the config
        // For now there is also an extra check here to show the trello task list for Trello Crossflow users over M2 https://atlassian.slack.com/archives/C082QR7B16Z/p1755066367960509?thread_ts=1755064885.015779&cid=C082QR7B16Z
        taskList: !projectState?.isTrelloCrossflow && taskList ? taskList : (0, $gehxg.TAILORED_ONBOARDING_BUSINESS).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $22017e3d8b39c720$export$d1f442602a91e7cc = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5, features: features, containerType: containerType, permissions: permissions })=>{
    if (containerType === 'plan') return $22017e3d8b39c720$var$createPlanTasks(taskGroupParent, features);
    if ((0, $dX7f5.isJwmProject)(projectState)) return $22017e3d8b39c720$var$createJwmTasks({
        projectState: projectState,
        taskGroupParent: taskGroupParent,
        taskList: taskList,
        teamType: teamType,
        isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5
    });
    if ((0, $dX7f5.isJsmProject)(projectState)) return $22017e3d8b39c720$var$createJsmTasks(projectState, taskGroupParent);
    // Implicitly JSW
    const tailoredOnboardingTasks = $22017e3d8b39c720$export$d9d83c8e96505820(taskGroupParent, teamType, features, permissions);
    return tailoredOnboardingTasks;
};

});
parcelRegister("lG3WD", function(module, exports) {
$parcel$export(module.exports, "isTailoredOnboardingTeamType", () => $d75906a9b0d008ac$export$b924c0b3ec4d268e);
$parcel$export(module.exports, "isTailoredOnboardingM2P5TailoredTeamType", () => $d75906a9b0d008ac$export$26c385918d734203);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $9tKPh = parcelRequire("9tKPh");
const $d75906a9b0d008ac$export$b924c0b3ec4d268e = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $9tKPh.tailoredTeamTypes).includes(teamType);
};
const $d75906a9b0d008ac$export$26c385918d734203 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $9tKPh.tailoredM2P5TeamTypes).includes(teamType);
};

});
parcelRegister("9tKPh", function(module, exports) {
$parcel$export(module.exports, "tailoredTeamTypes", () => $55524e5bf5684c10$export$a1fbb7d965e15a39);
$parcel$export(module.exports, "tailoredM2P5TeamTypes", () => $55524e5bf5684c10$export$52c5394d6e6cfcf3);
/* eslint-disable jira/filename-case */ 
const $55524e5bf5684c10$export$a1fbb7d965e15a39 = [
    (0, $99cb2e6a234d7a1f$export$e5c438b7501b5a24),
    (0, $99cb2e6a234d7a1f$export$d7de553940261eba),
    (0, $99cb2e6a234d7a1f$export$e4824f74b9879164),
    (0, $99cb2e6a234d7a1f$export$4f3cb0844009af52),
    (0, $99cb2e6a234d7a1f$export$cbc0e551d91a692d),
    (0, $99cb2e6a234d7a1f$export$4f54a09a24fd1d74),
    (0, $99cb2e6a234d7a1f$export$79685802e8ff1098),
    (0, $99cb2e6a234d7a1f$export$b8b1ac856ba1434b)
];
const $55524e5bf5684c10$export$52c5394d6e6cfcf3 = [
    (0, $99cb2e6a234d7a1f$export$e5c438b7501b5a24),
    (0, $99cb2e6a234d7a1f$export$d7de553940261eba),
    (0, $99cb2e6a234d7a1f$export$cbc0e551d91a692d),
    (0, $99cb2e6a234d7a1f$export$4f54a09a24fd1d74),
    (0, $99cb2e6a234d7a1f$export$79685802e8ff1098),
    (0, $99cb2e6a234d7a1f$export$b8b1ac856ba1434b)
];

});


parcelRegister("8ZIK8", function(module, exports) {
$parcel$export(module.exports, "USER_ROLE", () => $00acda1fb13631fd$export$8eeb199b23203523);
/* eslint-disable jira/filename-case */ const $00acda1fb13631fd$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("9URGr", function(module, exports) {
$parcel$export(module.exports, "JSM", () => $964fea8378454aec$export$63f289f2da861d35);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $jvANo = parcelRequire("jvANo");
const $964fea8378454aec$export$63f289f2da861d35 = {
    taskList: (0, $jvANo.JSM_TASK_LIST),
    taskVariants: (0, $jvANo.JSM_TASK_VARIANTS),
    userRole: (0, $jvANo.UserRole),
    experiments: (0, $jvANo.Experiments)
};

});
parcelRegister("jvANo", function(module, exports) {
$parcel$export(module.exports, "JSM_TASK_LIST", () => $330594c6136585e6$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $330594c6136585e6$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $330594c6136585e6$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $330594c6136585e6$export$5b68aef408c932d9);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");

var $5ZtCQ = parcelRequire("5ZtCQ");
const $330594c6136585e6$var$rootTitle = (0, $7eNDO.defineMessage)({
    id: "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
    defaultMessage: "Quickstart"
});
const $330594c6136585e6$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: $330594c6136585e6$var$rootTitle,
        items: [
            (0, $5ZtCQ.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $5ZtCQ.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $5ZtCQ.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $330594c6136585e6$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $330594c6136585e6$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $330594c6136585e6$export$5b68aef408c932d9 = {
    [(0, $5ZtCQ.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $5ZtCQ.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $5ZtCQ.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});


parcelRegister("jrlyX", function(module, exports) {
$parcel$export(module.exports, "JWM", () => $7467b6c089b3897b$export$3ff26c80cb588e12);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5gtk6 = parcelRequire("5gtk6");

var $eFRe9 = parcelRequire("eFRe9");

var $fWmos = parcelRequire("fWmos");
const $7467b6c089b3897b$export$3ff26c80cb588e12 = {
    taskList: (0, $5gtk6.TASK_LIST),
    taskVariants: (0, $5gtk6.TASK_VARIANTS),
    userRole: (0, $fWmos.UserRole),
    experiments: (0, $eFRe9.Experiments)
};

});
parcelRegister("5gtk6", function(module, exports) {
$parcel$export(module.exports, "TASK_LIST", () => $2beaab971a6492fd$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "OPS_TAILORED_ONBOARDING_TASK_VARIANTS", () => $2beaab971a6492fd$export$db06b8e338ba9c65);
$parcel$export(module.exports, "MKT_TAILORED_ONBOARDING_TASK_VARIANTS", () => $2beaab971a6492fd$export$bda7075f98246874);
$parcel$export(module.exports, "TASK_VARIANTS", () => $2beaab971a6492fd$export$36f4d47dfe11b613);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");

var $eFRe9 = parcelRequire("eFRe9");

var $fWmos = parcelRequire("fWmos");
const $2beaab971a6492fd$var$rootTitle = (0, $7eNDO.defineMessage)({
    id: "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
    defaultMessage: "Quickstart"
});
const $2beaab971a6492fd$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: $2beaab971a6492fd$var$rootTitle,
        items: [
            (0, $5ZtCQ.JWM_CREATE_PROJECT_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $5ZtCQ.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)
        ]
    }
});
const $2beaab971a6492fd$export$db06b8e338ba9c65 = {
    [(0, $5ZtCQ.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $5ZtCQ.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $2beaab971a6492fd$export$bda7075f98246874 = {
    [(0, $5ZtCQ.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $5ZtCQ.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $2beaab971a6492fd$export$36f4d47dfe11b613 = {
    ...$2beaab971a6492fd$export$db06b8e338ba9c65,
    ...$2beaab971a6492fd$export$bda7075f98246874,
    [(0, $5ZtCQ.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isNotSampleProject,
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isNotSampleProject,
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isNotSampleProject,
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).isNotSampleProject,
                        (0, $eFRe9.Experiments).trelloCrossflow,
                        (0, $fWmos.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("dvbnR", function(module, exports) {
$parcel$export(module.exports, "TeamType", () => $885860f3e92ee151$export$26bc40b960693765);
$parcel$export(module.exports, "Feature", () => $885860f3e92ee151$export$6e91cf7616333d5);
$parcel$export(module.exports, "FeatureGate", () => $885860f3e92ee151$export$d4ba9a3e7000cca8);
$parcel$export(module.exports, "Permissions", () => $885860f3e92ee151$export$2d41982586bbb6be);
$parcel$export(module.exports, "Experience", () => $885860f3e92ee151$export$c90b54e658fc4d7c);
/* eslint-disable jira/filename-case */ 
const $885860f3e92ee151$export$26bc40b960693765 = {
    productManagement: `teamType.${(0, $99cb2e6a234d7a1f$export$4f54a09a24fd1d74)}`,
    projectManagement: `teamType.${(0, $99cb2e6a234d7a1f$export$79685802e8ff1098)}`,
    design: `teamType.${(0, $99cb2e6a234d7a1f$export$e5c438b7501b5a24)}`,
    itSupport: `teamType.${(0, $99cb2e6a234d7a1f$export$d7de553940261eba)}`,
    otherPersonal: `teamType.${(0, $99cb2e6a234d7a1f$export$cbc0e551d91a692d)}`,
    marketing: `teamType.${(0, $99cb2e6a234d7a1f$export$e4824f74b9879164)}`,
    operations: `teamType.${(0, $99cb2e6a234d7a1f$export$4f3cb0844009af52)}`,
    software: `teamType.${(0, $99cb2e6a234d7a1f$export$b8b1ac856ba1434b)}`,
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'teamType.everythingElse'
};
const $885860f3e92ee151$export$6e91cf7616333d5 = {
    hasBacklog: 'feature.hasBacklog',
    hasSprint: 'feature.hasSprint',
    hasSummaryPage: 'feature.hasSummaryPage',
    hasRoadmap: 'feature.hasRoadmap',
    hasList: 'feature.hasList',
    hasCalendar: 'feature.hasCalendar',
    hasCode: 'feature.hasCode',
    hasForms: 'feature.hasForms',
    hasPages: 'feature.hasPages',
    hasPlanDependencies: 'feature.hasPlanDependencies',
    hasPlanProgram: 'feature.hasPlanProgram',
    hasPlanReleases: 'feature.hasPlanReleases',
    hasPlanTeams: 'feature.hasPlanTeams'
};
const $885860f3e92ee151$export$d4ba9a3e7000cca8 = {
    removeInitialProjectTemplateName: 'to-cleanup-remove-initial-project-template-name'
};
const $885860f3e92ee151$export$2d41982586bbb6be = {
    canCreateIssue: 'permissions.canCreateIssue'
};
const $885860f3e92ee151$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    tailoredOnboardingScrumAndSoftwareKanbanEligible: 'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible'
};
const $885860f3e92ee151$export$c90b54e658fc4d7c = {
    fedRamp: 'experience.fedRamp'
};

});

parcelRegister("eFRe9", function(module, exports) {
$parcel$export(module.exports, "Experiments", () => $f67fafb607dbc7c0$export$c8d6ffd15214553a);
/* eslint-disable jira/filename-case */ const $f67fafb607dbc7c0$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow'
};

});

parcelRegister("fWmos", function(module, exports) {
$parcel$export(module.exports, "UserRole", () => $17521fafdbc867e0$export$eb3485a690c2f0b8);
/* eslint-disable jira/filename-case */ const $17521fafdbc867e0$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("cBvJ0", function(module, exports) {
$parcel$export(module.exports, "PLAN", () => $bfac3d2456178e37$export$c303e491e026ebc6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i6G5g = parcelRequire("i6G5g");
const $bfac3d2456178e37$export$c303e491e026ebc6 = {
    taskList: (0, $i6G5g.PLAN_TASK_LIST),
    taskVariants: (0, $i6G5g.PLAN_TASK_VARIANTS)
};

});
parcelRegister("i6G5g", function(module, exports) {
$parcel$export(module.exports, "PLAN_TASK_LIST", () => $1ab7c646a72e5fed$export$6ddf1195a65583de);
$parcel$export(module.exports, "PLAN_TASK_VARIANTS", () => $1ab7c646a72e5fed$export$73c2f09f0994be4f);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $1ab7c646a72e5fed$var$rootTitle = (0, $7eNDO.defineMessage)({
    id: "onboarding-quickstart-core.services.tasks.config.plan.root-title",
    defaultMessage: "Quickstart"
});
const $1ab7c646a72e5fed$export$6ddf1195a65583de = Object.freeze({
    root: {
        title: $1ab7c646a72e5fed$var$rootTitle,
        items: [
            (0, $5ZtCQ.PLAN_TEAM_CAPACITY_TASK),
            (0, $5ZtCQ.PLAN_PROGRAM_BOARD_TASK),
            (0, $5ZtCQ.PLAN_RELEASE_MANAGEMENT_TASK),
            (0, $5ZtCQ.PLAN_DEPENDENCY_TRACKING_TASK)
        ]
    }
});
const $1ab7c646a72e5fed$export$73c2f09f0994be4f = {
    [(0, $5ZtCQ.PLAN_TEAM_CAPACITY_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasPlanTeams
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.PLAN_PROGRAM_BOARD_TASK)]: {
        position: {
            default: 10
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasPlanProgram
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.PLAN_RELEASE_MANAGEMENT_TASK)]: {
        position: {
            default: 20
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasPlanReleases
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.PLAN_DEPENDENCY_TRACKING_TASK)]: {
        position: {
            default: 30
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasPlanDependencies
                    ],
                    value: true
                }
            ]
        }
    }
};

});


parcelRegister("er8Op", function(module, exports) {
$parcel$export(module.exports, "getTasks", () => $078ea27c308f9d74$export$20b82b4a32771893);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $akVgl = parcelRequire("akVgl");
const $078ea27c308f9d74$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $akVgl.getConditional)(visibility, variants) : true;
const $078ea27c308f9d74$var$getTaskPosition = (variants, position)=>(0, $akVgl.getConditional)(position, variants);
const $078ea27c308f9d74$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$078ea27c308f9d74$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$078ea27c308f9d74$var$getTaskPosition(variants, taskVariants[taskA].position) - $078ea27c308f9d74$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("akVgl", function(module, exports) {
$parcel$export(module.exports, "getConditional", () => $eb2f3313899aa233$export$fe3161cde0106bba);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $eb2f3313899aa233$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("dX7f5", function(module, exports) {
$parcel$export(module.exports, "isJwmProject", () => $9eb7081466bad82f$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $9eb7081466bad82f$export$a972ed853ed1d469);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f99M0 = parcelRequire("f99M0");
const $9eb7081466bad82f$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $f99M0.CORE_PROJECT);
const $9eb7081466bad82f$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $f99M0.SERVICE_DESK_PROJECT);

});

parcelRegister("gehxg", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_WITH_SINGLE_CONFIG", () => $781ea1b3868534c8$export$83849aa73c0a20db);
$parcel$export(module.exports, "TAILORED_ONBOARDING_M2P5", () => $781ea1b3868534c8$export$eb17ad7838835d2a);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BUSINESS", () => $781ea1b3868534c8$export$fe6b8880a507b306);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 

var $7eNDO = parcelRequire("7eNDO");

var $5ZtCQ = parcelRequire("5ZtCQ");

var $hsVn2 = parcelRequire("hsVn2");

var $9W3eX = parcelRequire("9W3eX");

var $eyABc = parcelRequire("eyABc");

var $cHxES = parcelRequire("cHxES");

var $foPEo = parcelRequire("foPEo");

var $aTf9A = parcelRequire("aTf9A");

var $cPgA9 = parcelRequire("cPgA9");

var $kF6m8 = parcelRequire("kF6m8");
const $781ea1b3868534c8$var$rootTitle = (0, $7eNDO.defineMessage)({
    id: "software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate",
    defaultMessage: "Quickstart"
});
const $781ea1b3868534c8$export$2757f7b23d120b9b = Object.freeze({
    root: {
        title: $781ea1b3868534c8$var$rootTitle,
        items: [
            (0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY),
            (0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR),
            (0, $5ZtCQ.TAILORED_ONBOARDING_LIST),
            (0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_PAGES),
            (0, $5ZtCQ.TAILORED_ONBOARDING_FORM),
            (0, $5ZtCQ.TAILORED_ONBOARDING_INVITE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_BOARD),
            (0, $5ZtCQ.TAILORED_ONBOARDING_BACKLOG),
            (0, $5ZtCQ.TAILORED_ONBOARDING_CODE)
        ]
    }
});
const $781ea1b3868534c8$export$83849aa73c0a20db = {
    taskList: $781ea1b3868534c8$export$2757f7b23d120b9b,
    taskVariants: (0, $kF6m8.TAILORED_ONBOARDING_SINGLE_CONFIG)
};
const $781ea1b3868534c8$export$fd94bb9b6d992528 = Object.freeze({
    root: {
        title: $781ea1b3868534c8$var$rootTitle,
        items: [
            (0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY),
            (0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR),
            (0, $5ZtCQ.TAILORED_ONBOARDING_LIST),
            (0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_PAGES),
            (0, $5ZtCQ.TAILORED_ONBOARDING_FORM),
            (0, $5ZtCQ.TAILORED_ONBOARDING_INVITE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $781ea1b3868534c8$export$3c409334669aec75 = (teamType)=>{
    switch(teamType){
        case 0, $99cb2e6a234d7a1f$export$4f54a09a24fd1d74:
            return 0, $9W3eX.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$79685802e8ff1098:
            return 0, $hsVn2.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$e5c438b7501b5a24:
            return 0, $eyABc.DESIGN_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$d7de553940261eba:
            return 0, $cHxES.IT_SUPPORT_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$cbc0e551d91a692d:
            return 0, $foPEo.OTHER_PERSONAL_VARIANTS;
        case 0, $99cb2e6a234d7a1f$export$b8b1ac856ba1434b:
            return 0, $cPgA9.SOFTWARE_VARIANTS;
        default:
            return 0, $aTf9A.EVERYTHING_ELSE_VARIANTS;
    }
};
const $781ea1b3868534c8$export$cb2285c4be67df48 = Object.freeze({
    root: {
        title: $781ea1b3868534c8$var$rootTitle,
        items: [
            // JWM Trello Crossflow Tasks
            (0, $5ZtCQ.JWM_CREATE_PROJECT_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $5ZtCQ.JWM_BUILD_FORM_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $5ZtCQ.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            // JSW Tailored Onboarding Tasks
            (0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY),
            (0, $5ZtCQ.TAILORED_ONBOARDING_LIST),
            (0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE),
            (0, $5ZtCQ.TAILORED_ONBOARDING_BOARD),
            (0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR),
            (0, $5ZtCQ.TAILORED_ONBOARDING_PAGES),
            (0, $5ZtCQ.TAILORED_ONBOARDING_FORM),
            (0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)
        ]
    }
});
const $781ea1b3868534c8$export$eb17ad7838835d2a = {
    taskList: $781ea1b3868534c8$export$fd94bb9b6d992528,
    getM2P5TaskVariants: $781ea1b3868534c8$export$3c409334669aec75
};
const $781ea1b3868534c8$export$fe6b8880a507b306 = {
    taskList: $781ea1b3868534c8$export$cb2285c4be67df48
};

});
parcelRegister("hsVn2", function(module, exports) {
$parcel$export(module.exports, "PROJECT_MANAGEMENT_VARIANTS", () => $56d54c062d4173ad$export$bdd338c80f8962df);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $56d54c062d4173ad$export$bdd338c80f8962df = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("9W3eX", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_MANAGEMENT_VARIANTS", () => $39f1fbf4259ebcca$export$b07ea6a2d29f9c08);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $39f1fbf4259ebcca$export$b07ea6a2d29f9c08 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("eyABc", function(module, exports) {
$parcel$export(module.exports, "DESIGN_VARIANTS", () => $a7a546fbc840a986$export$a3c4cd8e420f13a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $a7a546fbc840a986$export$a3c4cd8e420f13a = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("cHxES", function(module, exports) {
$parcel$export(module.exports, "IT_SUPPORT_VARIANTS", () => $8453a6ca22fbb130$export$a25e809b52945082);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $8453a6ca22fbb130$export$a25e809b52945082 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("foPEo", function(module, exports) {
$parcel$export(module.exports, "OTHER_PERSONAL_VARIANTS", () => $eb4ebd50ad83e801$export$916be3c140ae8c0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $eb4ebd50ad83e801$export$916be3c140ae8c0 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("aTf9A", function(module, exports) {
$parcel$export(module.exports, "EVERYTHING_ELSE_VARIANTS", () => $f40aa275376d9c93$export$7a0daeb069f34de3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $f40aa275376d9c93$export$7a0daeb069f34de3 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("cPgA9", function(module, exports) {
$parcel$export(module.exports, "SOFTWARE_VARIANTS", () => $609157f95a04c4bd$export$76a143792cc73994);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $609157f95a04c4bd$export$76a143792cc73994 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("kF6m8", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $bd1d4f54dcaf47e5$export$64855550cee11b78);
/* eslint-disable jira/filename-case */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");
const $bd1d4f54dcaf47e5$export$64855550cee11b78 = {
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasSummaryPage,
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasSummaryPage,
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasSummaryPage,
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasSummaryPage,
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Permissions).canCreateIssue
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasCalendar
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasCode
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasPages
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse,
                        (0, $dvbnR.Feature).hasForms
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Feature).hasBacklog,
                        (0, $dvbnR.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});


parcelRegister("jXUhc", function(module, exports) {
$parcel$export(module.exports, "TAILORED_ONBOARDING_BUSINESS_CONFIG", () => $c62fd069dca23e40$export$474323a35aa36586);
/* eslint-disable jira/filename-case */ 
var $5ZtCQ = parcelRequire("5ZtCQ");

var $dvbnR = parcelRequire("dvbnR");

var $eFRe9 = parcelRequire("eFRe9");

var $fWmos = parcelRequire("fWmos");

var $5gtk6 = parcelRequire("5gtk6");
const $c62fd069dca23e40$export$474323a35aa36586 = {
    ...(0, $5gtk6.OPS_TAILORED_ONBOARDING_TASK_VARIANTS),
    ...(0, $5gtk6.MKT_TAILORED_ONBOARDING_TASK_VARIANTS),
    // Trello Crossflow Cards - These take priority when trelloCrossflow experiment is active
    [(0, $5ZtCQ.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 10
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow,
                        (0, $fWmos.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    // Regular Tailored Onboarding Cards - These are hidden when trelloCrossflow is active
    [(0, $5ZtCQ.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.Experience).fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $5ZtCQ.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eFRe9.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $dvbnR.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});



parcelRegister("jJY2t", function(module, exports) {
$parcel$export(module.exports, "syncVisibilityWithLocal", () => $6da4c253db4092e5$export$4aab9a98fc53b894);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1n5q3 = parcelRequire("1n5q3");

var $1DyW0 = parcelRequire("1DyW0");
const $6da4c253db4092e5$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $1n5q3.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $1DyW0.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});

parcelRegister("bNXf6", function(module, exports) {
$parcel$export(module.exports, "universalDispatch", () => $e4798fb7ab0be54b$export$efe980271ca9cc08);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e4798fb7ab0be54b$export$efe980271ca9cc08 = ({ fn: fn })=>({ dispatch: dispatch })=>{
        dispatch(fn());
    };

});

parcelRegister("2D5ku", function(module, exports) {
$parcel$export(module.exports, "setContainerType", () => $11a6776765b237a2$export$24889c6c4e904da4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $11a6776765b237a2$export$24889c6c4e904da4 = (containerType)=>({ getState: getState, setState: setState })=>{
        const { containerType: currentContainerType } = getState();
        if (containerType === currentContainerType) // if state has not been updated we just return
        return;
        setState({
            containerType: containerType
        });
    };
var $11a6776765b237a2$export$2e2bcd8739ae039 = $11a6776765b237a2$export$24889c6c4e904da4;

});

parcelRegister("adLxs", function(module, exports) {
$parcel$export(module.exports, "setQuickstartButtonRef", () => $9773b9b971c00e4a$export$8119a14b79738a24);
$parcel$export(module.exports, "setIsOpenedViaButton", () => $9773b9b971c00e4a$export$8b7fa399fb8c07f);
$parcel$export(module.exports, "focusQuickstartButton", () => $9773b9b971c00e4a$export$8f1aa3f8d2941465);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $9773b9b971c00e4a$export$8119a14b79738a24 = (quickstartButtonRef)=>({ setState: setState })=>{
        setState({
            quickstartButtonRef: quickstartButtonRef
        });
    };
const $9773b9b971c00e4a$export$8b7fa399fb8c07f = (isOpenedViaButton)=>({ setState: setState })=>{
        setState({
            isOpenedViaButton: isOpenedViaButton
        });
    };
// Since the button is visible after 220ms and requestAnimationFrame is called 60 times per second,
// to be safe we can wait for 15 frames (220/1000 * 60)
const $9773b9b971c00e4a$var$MAX_FOCUS_RETRIES = 15;
const $9773b9b971c00e4a$export$8f1aa3f8d2941465 = ()=>({ setState: setState, getState: getState })=>{
        let retryCount = 0;
        const tryFocus = ()=>{
            const { quickstartButtonRef: quickstartButtonRef, isOpenedViaButton: isOpenedViaButton } = getState();
            if (quickstartButtonRef && isOpenedViaButton) {
                quickstartButtonRef.focus({
                    preventScroll: true
                });
                setState({
                    isOpenedViaButton: false
                });
            } else if (!quickstartButtonRef && retryCount < $9773b9b971c00e4a$var$MAX_FOCUS_RETRIES) {
                // If ref not available yet due to button animation delay, try again
                retryCount++;
                requestAnimationFrame(tryFocus);
            }
        };
        // Uses requestAnimationFrame to wait until the ref is available
        requestAnimationFrame(tryFocus);
    };

});


parcelRegister("ia7JZ", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $d4bfa53efccc0000$export$d4c72bab9d6cc13a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5ZtCQ = parcelRequire("5ZtCQ");
const $d4bfa53efccc0000$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $5ZtCQ.ROOT_TASK),
    currentTriggerForTaskGroupParent: '',
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $5ZtCQ.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $5ZtCQ.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $5ZtCQ.QUICKSTART_UI_STATUS).NOT_LOADED
    },
    quickstartButtonRef: null,
    isOpenedViaButton: false
};

});




parcelRegister("geeJ4", function(module, exports) {
$parcel$export(module.exports, "useJsmRightSidebarsPreload", () => $394ada2765c94604$export$6b7fcb392555b342);

var $euxye = parcelRequire("euxye");

var $2b39L = parcelRequire("2b39L");


var $eki8y = parcelRequire("eki8y");

var $4Onaa = parcelRequire("4Onaa");

var $9mRNC = parcelRequire("9mRNC");
const $394ada2765c94604$export$6b7fcb392555b342 = (target)=>{
    const hasPreloadedRef = (0, $euxye.useRef)(false);
    const projectContext = (0, $2b39L.useProjectContext)();
    const projectContextData = projectContext?.data;
    const route = (0, $4Onaa.useCurrentRoute)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $eki8y.useJsmOnboardingType)();
    (0, $euxye.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData
    ]);
    const shouldRender = jsmOnboardingData?.onboardingType === (0, $77d3ca58d1d4a14f$export$6f454e69bce3a691) && (0, $9mRNC.shouldRouteShowQuickstartOnboarding)(route.name) || (0, $9mRNC.shouldRenderRequestTypesTableViewSettings)(route.name);
    (0, $euxye.useEffect)(()=>{
        if (shouldRender && !hasPreloadedRef.current) {
            target.preload?.();
            hasPreloadedRef.current = true;
        }
    }, [
        shouldRender,
        target
    ]);
    return shouldRender;
};

});
parcelRegister("9mRNC", function(module, exports) {
$parcel$export(module.exports, "shouldRouteShowQuickstartOnboarding", () => $eb01f8499a125646$export$25ddf6cfdf6af9c5);
$parcel$export(module.exports, "shouldRenderRequestTypesTableViewSettings", () => $eb01f8499a125646$export$2b8029e8db91a531);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7Odw0 = parcelRequire("7Odw0");

var $5yfEX = parcelRequire("5yfEX");

var $e4hT2 = parcelRequire("e4hT2");

var $aPX9C = parcelRequire("aPX9C");

var $73kzk = parcelRequire("73kzk");
const $eb01f8499a125646$var$REQUEST_TYPE_PAGE_ROUTES = [
    (0, $5yfEX.projectSettingsServicedeskTicketTypesConfigRoute).name,
    (0, $e4hT2.projectSettingsServicedeskItsmTicketTypesConfigRoute).name,
    (0, $aPX9C.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
    (0, $73kzk.servicedeskGettingStartedRequestTypesRoute).name
];
const $eb01f8499a125646$export$25ddf6cfdf6af9c5 = (routeName)=>{
    if ((0, $7Odw0.isSupportedUserAgent)()) return false;
    const allowedRoutes = [
        'servicedesk-queues-landing',
        'servicedesk-queues-custom-view',
        'legacy-project-settings-edit',
        'legacy-project-settings-people',
        'project-settings-servicedesk-customer-notifications',
        'project-settings-servicedesk-email',
        'project-settings-servicedesk-portal-settings',
        'project-settings-servicedesk-ticket-types-config',
        'project-settings-servicedesk-chat'
    ];
    return allowedRoutes.includes(routeName);
};
const $eb01f8499a125646$export$2b8029e8db91a531 = (routeName)=>$eb01f8499a125646$var$REQUEST_TYPE_PAGE_ROUTES.includes(routeName);

});
parcelRegister("73kzk", function(module, exports) {
$parcel$export(module.exports, "servicedeskGettingStartedRequestTypesRoute", () => $9254de181856af95$export$efc8e94c428c4dc3);
const $9254de181856af95$export$efc8e94c428c4dc3 = {
    name: 'servicedesk-getting-started-request-types',
    path: '/jira/servicedesk/projects/:projectKey/getting-started/request-types',
    exact: true
};

});



parcelRegister("4CmB9", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bHeRd").then(()=>parcelRequire('klUPL'));

});

parcelRegister("5gqRZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("jXORD")
]).then(()=>parcelRequire('kZHqX'));

});

parcelRegister("9ZZ9z", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("8Ugzq")
]).then(()=>parcelRequire('dEtEX'));

});

parcelRegister("4lLiV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("7pJmj")
]).then(()=>parcelRequire('lgpDF'));

});


parcelRegister("3eysO", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareProjectLayout", () => $d9a9eeef91e81aaf$export$3791efdd32024063);
$parcel$export(module.exports, "softwareProjectLayout", () => $d9a9eeef91e81aaf$export$9a918616afa3328c);
$parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", () => $d9a9eeef91e81aaf$export$ada52b1309832862);
$parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", () => $d9a9eeef91e81aaf$export$6c1958653c44ba37);
$parcel$export(module.exports, "softwareProjectLayoutCode", () => $d9a9eeef91e81aaf$export$ab7e607e8441dc61);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $f99M0 = parcelRequire("f99M0");

var $lVzKq = parcelRequire("lVzKq");

var $QhQu4 = parcelRequire("QhQu4");

var $l8G1z = parcelRequire("l8G1z");

var $jepRN = parcelRequire("jepRN");
// TODO Remove this whenever all software project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d9a9eeef91e81aaf$var$withAnySoftwareProjectContext = (Component)=>(0, $QhQu4.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $f99M0.SOFTWARE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d9a9eeef91e81aaf$var$Onboarding = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("1xvlQ")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-software-project-layout/src/ui/onboarding/index.tsx"
});
$d9a9eeef91e81aaf$var$Onboarding.displayName = 'Lazy(ui/onboarding/index.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d9a9eeef91e81aaf$var$OnboardingCode = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("fg5CY")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-software-project-layout/src/ui/onboarding-code/OnboardingCode.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d9a9eeef91e81aaf$var$RightSidebars = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("kB97o")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
$d9a9eeef91e81aaf$var$RightSidebars.displayName = 'Lazy(ui/right-sidebars/RightSidebars.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d9a9eeef91e81aaf$var$RightSidebarsCode = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("4eVAt")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-software-project-layout/src/ui/right-sidebars-code/RightSidebarsCode.tsx"
});
const $d9a9eeef91e81aaf$var$OnboardingWithSoftwareAsExpectedProjectType = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d9a9eeef91e81aaf$var$Onboarding, {
        ...props,
        expectedProjectType: (0, $f99M0.SOFTWARE_PROJECT)
    });
$d9a9eeef91e81aaf$var$OnboardingWithSoftwareAsExpectedProjectType.displayName = "OnboardingWithSoftwareAsExpectedProjectType";
const $d9a9eeef91e81aaf$var$OnboardingCodeWithSoftwareAsExpectedProjectType = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d9a9eeef91e81aaf$var$OnboardingCode, {
        ...props,
        expectedProjectType: (0, $f99M0.SOFTWARE_PROJECT)
    });
$d9a9eeef91e81aaf$var$OnboardingCodeWithSoftwareAsExpectedProjectType.displayName = "OnboardingCodeWithSoftwareAsExpectedProjectType";
const $d9a9eeef91e81aaf$var$SoftWareOnboarding = (0, $jepRN.componentWithFG)('jira-fix-quickstart-not-showing', $d9a9eeef91e81aaf$var$OnboardingWithSoftwareAsExpectedProjectType, $d9a9eeef91e81aaf$var$withAnySoftwareProjectContext($d9a9eeef91e81aaf$var$Onboarding));
const $d9a9eeef91e81aaf$var$SoftWareOnboardingCode = (0, $jepRN.componentWithFG)('jira-fix-quickstart-not-showing', $d9a9eeef91e81aaf$var$OnboardingCodeWithSoftwareAsExpectedProjectType, $d9a9eeef91e81aaf$var$withAnySoftwareProjectContext($d9a9eeef91e81aaf$var$OnboardingCode));
const $d9a9eeef91e81aaf$var$nonSettingsRightSidebar = (0, $jepRN.componentWithFG)('jira-fix-quickstart-not-showing', $d9a9eeef91e81aaf$var$RightSidebars, $d9a9eeef91e81aaf$var$withAnySoftwareProjectContext($d9a9eeef91e81aaf$var$RightSidebars));
$d9a9eeef91e81aaf$var$nonSettingsRightSidebar.displayName = 'NonSettingsRightSidebar';
const $d9a9eeef91e81aaf$var$nonSettingsRightSidebarCode = (0, $jepRN.componentWithFG)('jira-fix-quickstart-not-showing', $d9a9eeef91e81aaf$var$RightSidebarsCode, $d9a9eeef91e81aaf$var$withAnySoftwareProjectContext($d9a9eeef91e81aaf$var$RightSidebarsCode));
const $d9a9eeef91e81aaf$var$sharedSoftwareProjectLayout = (0, $QhQu4.composeLayouts)((0, $lVzKq.projectLayout), {});
const $d9a9eeef91e81aaf$export$3791efdd32024063 = (0, $QhQu4.composeLayouts)($d9a9eeef91e81aaf$var$sharedSoftwareProjectLayout, {
    rightSidebars: [
        $d9a9eeef91e81aaf$var$nonSettingsRightSidebar
    ],
    globalComponents: [
        $d9a9eeef91e81aaf$var$SoftWareOnboarding
    ]
});
const $d9a9eeef91e81aaf$export$9a918616afa3328c = (0, $QhQu4.composeLayouts)($d9a9eeef91e81aaf$var$sharedSoftwareProjectLayout, {
    rightSidebars: [
        $d9a9eeef91e81aaf$var$nonSettingsRightSidebar
    ],
    globalComponents: [
        $d9a9eeef91e81aaf$var$SoftWareOnboarding
    ]
});
const $d9a9eeef91e81aaf$export$ada52b1309832862 = (0, $QhQu4.composeLayouts)($d9a9eeef91e81aaf$var$sharedSoftwareProjectLayout);
const $d9a9eeef91e81aaf$export$6c1958653c44ba37 = (0, $QhQu4.composeLayouts)($d9a9eeef91e81aaf$var$sharedSoftwareProjectLayout);
const $d9a9eeef91e81aaf$export$ab7e607e8441dc61 = (0, $QhQu4.composeLayouts)($d9a9eeef91e81aaf$var$sharedSoftwareProjectLayout, {
    rightSidebars: [
        $d9a9eeef91e81aaf$var$nonSettingsRightSidebarCode
    ],
    globalComponents: [
        $d9a9eeef91e81aaf$var$SoftWareOnboardingCode
    ]
});

});
parcelRegister("1xvlQ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("bHghB")
]).then(()=>parcelRequire('636b7'));

});

parcelRegister("fg5CY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("1QNkz")
]).then(()=>parcelRequire('hKXnV'));

});

parcelRegister("kB97o", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("kFYzw")
]).then(()=>parcelRequire('MzwZm'));

});

parcelRegister("4eVAt", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("7ccwi")
]).then(()=>parcelRequire('5wMW2'));

});


parcelRegister("dSYOQ", function(module, exports) {
$parcel$export(module.exports, "userBoardLayout", () => $a536ebd15e092fda$export$7092b4ee86ae0b71);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $QhQu4 = parcelRequire("QhQu4");
const $a536ebd15e092fda$export$7092b4ee86ae0b71 = (0, $QhQu4.createLayout)();

});


/* eslint-disable jira/filename-case */ /**
 * @deprecated sharing routes between products leads to over-fetching resources. Please define
 * routes per-product and only define the resources + navigation components required for that product instead.
 */ const $156b0b89ff564e71$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';

parcelRegister("hWEkS", function(module, exports) {
$parcel$export(module.exports, "incidentsInitialPageChecksResource", () => $c1167e8712e72bb4$export$b2b94ce8ba590cc8);
$parcel$export(module.exports, "incidentsCustomFieldIdResource", () => $c1167e8712e72bb4$export$e81d7afef87ae597);
$parcel$export(module.exports, "incidentExperimentTraitResource", () => $c1167e8712e72bb4$export$31c6945718067be3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
const $c1167e8712e72bb4$var$RESOURCE_TYPE_INCIDENTS_PAGE_INITIAL_CHECKS = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $c1167e8712e72bb4$var$RESOURCE_TYPE_INCIDENTS_PAGE_CUSTOM_FIELD_ID = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $c1167e8712e72bb4$var$RESOURCE_TYPE_INCIDENT_EXPERIMENT_TRAITS = 'INCIDENT_EXPERIMENT_TRAITS';

const $c1167e8712e72bb4$export$b2b94ce8ba590cc8 = (0, $7edbf.createResource)({
    type: $c1167e8712e72bb4$var$RESOURCE_TYPE_INCIDENTS_PAGE_INITIAL_CHECKS,
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("3ULYE"))
});

const $c1167e8712e72bb4$export$e81d7afef87ae597 = (0, $7edbf.createResource)({
    type: $c1167e8712e72bb4$var$RESOURCE_TYPE_INCIDENTS_PAGE_CUSTOM_FIELD_ID,
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("k51oD"))
});

const $c1167e8712e72bb4$export$31c6945718067be3 = (0, $7edbf.createResource)({
    type: $c1167e8712e72bb4$var$RESOURCE_TYPE_INCIDENT_EXPERIMENT_TRAITS,
    getKey: ()=>'incident_experiment_traits',
    getDataLoader: ()=>(parcelRequire("IH5QI")),
    maxAge: Number.MAX_SAFE_INTEGER
});

});
parcelRegister("3ULYE", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("fHVqC").then(()=>parcelRequire('5n23s'));

});

parcelRegister("k51oD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("tdvMA").then(()=>parcelRequire('4OA8l'));

});

parcelRegister("IH5QI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3qLak").then(()=>parcelRequire('3Odah'));

});


parcelRegister("g7VL7", function(module, exports) {
$parcel$export(module.exports, "legacyAllReportsRoute", () => $35a277fe1428279f$export$549d32fceee24980);
const $35a277fe1428279f$export$549d32fceee24980 = {
    name: 'legacy-all-reports',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=(.*report-page.*)'
    ]
};

});

parcelRegister("3KSG6", function(module, exports) {
$parcel$export(module.exports, "jiraHorizontalNavEntrypoint", () => $46ac1fe9a229c4f5$export$e9ee9fa1097f370e);

var $i0CFV = parcelRequire("i0CFV");

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

var $i8BNs = parcelRequire("i8BNs");

var $4afVU = parcelRequire("4afVU");
const $46ac1fe9a229c4f5$var$NAVIGATION_ITEMS_PAGE_SIZE = 75;

const $46ac1fe9a229c4f5$export$e9ee9fa1097f370e = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("g9qhn")), {
        moduleId: "ed1d84b7",
        moduleName: "HorizontalNavJiraInner",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true,
        includeInShellOnlySsrBundle: true
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { cloudId: cloudId } })=>{
        let boardId = match.params.boardId;
        const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
        const projectIdOrKey = projectId || projectKey;
        const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
        if (!boardId) {
            // If there is no boardId in the URL then we should check to see if it is provided as part of
            // the Connect app rapidView query param. This has been added to address JRACLOUD-94629
            const rapidViewBoard = query.rapidView ? query.rapidView : null;
            boardId = rapidViewBoard || boardId || null;
        }
        const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
        const projectAri = projectId ? (0, $i8BNs.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
        let containerNavigationInput;
        if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
            scopeId: boardAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        else containerNavigationInput = boardAri || projectAri ? {
            scopeId: boardAri || projectAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $4afVU.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        withProject: Boolean(projectIdOrKey),
                        boardId: boardAri,
                        withBoard: Boolean(boardAri),
                        containerNavigationInput: containerNavigationInput,
                        isTMPBoardRoute: isTMPBoardRoute,
                        first: $46ac1fe9a229c4f5$var$NAVIGATION_ITEMS_PAGE_SIZE
                    }
                }
            }
        };
    }
});

});
parcelRegister("4afVU", function(module, exports) {
$parcel$export(module.exports, "default", () => $adf699c972aa893b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<386aaaf98d056d41421209006019bba4>>
 * @relayHash 3448ae00dba97644b09e18ab41ec96ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e54d9a21cd3ef48edac524cad1086be41d8ebed797884db88134526be790d08

var $6MCoU = parcelRequire("6MCoU");

var $i0Pst = parcelRequire("i0Pst");
const $adf699c972aa893b$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8e54d9a21cd3ef48edac524cad1086be41d8ebed797884db88134526be790d08",
        "metadata": {},
        "name": "HorizontalNavJiraInnerQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $i0Pst.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider": (0, $6MCoU.default)
        }
    }
};
var $adf699c972aa893b$export$2e2bcd8739ae039 = $adf699c972aa893b$var$node;

});
parcelRegister("6MCoU", function(module, exports) {
$parcel$export(module.exports, "default", () => $fca5c30fc50196a8$export$2e2bcd8739ae039);

var $i860n = parcelRequire("i860n");

var $iXN50 = parcelRequire("iXN50");
const $fca5c30fc50196a8$var$GUEST_AWARENESS_STORAGE_NAMESPACE = 'jira-guest-awareness';
const $fca5c30fc50196a8$var$GUEST_AWARENESS_DISMISSED_VALUE = false;
const $fca5c30fc50196a8$var$getProjectKeyFromUrl = ()=>{
    const match = /\/projects\/([^/]+)/.exec(typeof window !== 'undefined' ? window.location.pathname : '');
    return match?.[1] ?? null;
};
const $fca5c30fc50196a8$var$guestAwarenessStorage = (0, $iXN50.createLocalStorageProvider)($fca5c30fc50196a8$var$GUEST_AWARENESS_STORAGE_NAMESPACE);
const $fca5c30fc50196a8$var$hasGuestFlagBeenDismissed = (projectKey)=>$fca5c30fc50196a8$var$guestAwarenessStorage.get(projectKey) === $fca5c30fc50196a8$var$GUEST_AWARENESS_DISMISSED_VALUE;
const $fca5c30fc50196a8$var$JiraExternalGuestsSpaceFlagRelayprovider = {
    get () {
        if (!(0, $i860n.fg)('jira_external_guests_space_flag')) return false;
        if ((0, $i860n.fg)('jira-guest-flag-cache')) {
            const projectKey = $fca5c30fc50196a8$var$getProjectKeyFromUrl();
            if (projectKey !== null && $fca5c30fc50196a8$var$hasGuestFlagBeenDismissed(projectKey)) return false;
        }
        return true;
    }
};
var $fca5c30fc50196a8$export$2e2bcd8739ae039 = $fca5c30fc50196a8$var$JiraExternalGuestsSpaceFlagRelayprovider;

});

parcelRegister("i0Pst", function(module, exports) {
$parcel$export(module.exports, "default", () => $5600361b9419e355$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $5600361b9419e355$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('jira_custom_templates_ux');
    }
};

});


parcelRegister("g9qhn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");

module.exports = Promise.all([
    (parcelRequire("gZgW8"))('jira_amplitude_sr', function() {
        return Promise.all([
            $4cvLQ("93SsA"),
            $4cvLQ("5qC72")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("2PzkC")
        ]);
    }),
    $4cvLQ("a36Wj"),
    $4cvLQ("elvlF"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iwpwq")
]).then(()=>parcelRequire('ghZiw'));

});


parcelRegister("aBfKq", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $611a984d57d1d132$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $611a984d57d1d132$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $611a984d57d1d132$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});
parcelRegister("4l4qP", function(module, exports) {
$parcel$export(module.exports, "devOpsReportPreconditionResource", () => $1d1855fc3c6e6cba$export$96cb0eae1b3413f4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");


const $1d1855fc3c6e6cba$export$96cb0eae1b3413f4 = (0, $7edbf.createResource)({
    type: (0, $21fa2470c5a45da5$export$14c5ce449424c281),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("he1hn")),
    maxAge: 60000
});
const $1d1855fc3c6e6cba$export$e9adc6103e9ed514 = ()=>(0, $k6ufm.useResource)($1d1855fc3c6e6cba$export$96cb0eae1b3413f4);

});
/* eslint-disable jira/filename-case */ const $21fa2470c5a45da5$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $21fa2470c5a45da5$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $21fa2470c5a45da5$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';

parcelRegister("he1hn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("8wMHS").then(()=>parcelRequire('eL1tw'));

});


parcelRegister("5ivqw", function(module, exports) {
$parcel$export(module.exports, "staticSidebarJSWReportsResource", () => $20f244809b35a5af$export$5910307042ab3f6f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $8S1Gc = parcelRequire("8S1Gc");

var $7edbf = parcelRequire("7edbf");

var $byDdk = parcelRequire("byDdk");
const $20f244809b35a5af$export$5910307042ab3f6f = (0, $7edbf.createResource)({
    type: 'JIRA_SOFTWARE_REPORTS',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $8S1Gc.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $8S1Gc.getBoardId)(match, query);
        if (boardId == null) return null;
        const response = await (0, $byDdk.fetchJSWReports)(boardId);
        return response?.reports;
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("byDdk", function(module, exports) {
$parcel$export(module.exports, "fetchJSWReports", () => $91c22a2498834411$export$a93a577d6971da2c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $91c22a2498834411$export$a93a577d6971da2c = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $h2wCv.performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
};

});




parcelRegister("lFlms", function(module, exports) {
$parcel$export(module.exports, "legacyBacklogRouteEntry", () => $5c8e0e39a728d407$export$e64dbc2432a0bfba);
/* eslint-disable import/order */ 

var $jgKgn = parcelRequire("jgKgn");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $ifxww = parcelRequire("ifxww");

var $75Njg = parcelRequire("75Njg");
const $5c8e0e39a728d407$export$e64dbc2432a0bfba = (0, $g1GqA.createLegacyEntry)((0, $ifxww.legacyBacklogRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jgKgn.LegacyPage),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource)
        ]
    }));

});
parcelRegister("7tgMD", function(module, exports) {
$parcel$export(module.exports, "horizontalNavJiraResource", () => $362d155fbc7f6957$export$faeb8c89315e20da);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $kK0Kk = parcelRequire("kK0Kk");

var $htsFl = parcelRequire("htsFl");

var $i8BNs = parcelRequire("i8BNs");

var $c4rhk = parcelRequire("c4rhk");
const $362d155fbc7f6957$var$NAVIGATION_ITEMS_PAGE_SIZE = 75;
const $362d155fbc7f6957$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
    const boardId = match.params.boardId;
    let { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
    const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
    const projectAri = projectId ? (0, $i8BNs.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    }).toString() : '';
    let containerNavigationInput;
    if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
        scopeId: boardAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    else containerNavigationInput = boardAri || projectAri ? {
        scopeId: boardAri || projectAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: (0, $kK0Kk.default),
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            withProject: Boolean(projectIdOrKey),
            boardId: boardAri,
            withBoard: Boolean(boardAri),
            containerNavigationInput: containerNavigationInput,
            isTMPBoardRoute: isTMPBoardRoute,
            first: $362d155fbc7f6957$var$NAVIGATION_ITEMS_PAGE_SIZE
        }
    };
};
const $362d155fbc7f6957$var$horizontalNavJiraResourceActual = (0, $c4rhk.withGiraAggAnonSsrFix)((0, $htsFl.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_JIRA_QUERY',
    getQuery: $362d155fbc7f6957$export$71eec30d9db46a56
}));
const $362d155fbc7f6957$export$faeb8c89315e20da = $362d155fbc7f6957$var$horizontalNavJiraResourceActual;

});
parcelRegister("kK0Kk", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2529c1a6d2ac242$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bdf2d72ba9fb3f38807d814539ef4b9e>>
 * @relayHash 3448ae00dba97644b09e18ab41ec96ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e54d9a21cd3ef48edac524cad1086be41d8ebed797884db88134526be790d08

var $6MCoU = parcelRequire("6MCoU");

var $i0Pst = parcelRequire("i0Pst");

var $lIGkE = parcelRequire("lIGkE");
const $a2529c1a6d2ac242$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTMPBoardRoute"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withBoard"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withProject"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "name"
    }, v20 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v21 = {
        "kind": "ScalarField",
        "name": "boardType"
    }, v22 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContent_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "containerNavigationInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraContainerNavigationResult"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "first"
                                                }
                                            ],
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault"
                                                                },
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canSetAsDefault"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": "scopedUrl",
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNavigationItem",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v15 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeUrl"
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v15 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v18 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "withBoard",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "withProject",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "idOrKey",
                                    "variableName": "projectIdOrKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v9 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                v19 /*: any*/ ,
                                {
                                    "alias": "projectKey",
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                {
                                    "condition": "isTMPBoardRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "mostRecentlyViewedBoard",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLiveTemplate"
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8e54d9a21cd3ef48edac524cad1086be41d8ebed797884db88134526be790d08",
            "metadata": {},
            "name": "HorizontalNavJiraInnerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $i0Pst.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider": (0, $6MCoU.default)
            }
        }
    };
}();
$a2529c1a6d2ac242$var$node.hash = "62ed47ad7a5418872aad653ddecdd984";
(0, $lIGkE.PreloadableQueryRegistry).set($a2529c1a6d2ac242$var$node.params.id, $a2529c1a6d2ac242$var$node);
var $a2529c1a6d2ac242$export$2e2bcd8739ae039 = $a2529c1a6d2ac242$var$node;

});

parcelRegister("c4rhk", function(module, exports) {
$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $9656216ca152d3e3$export$f4b29e78f4c0a526);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $9656216ca152d3e3$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});


parcelRegister("ifxww", function(module, exports) {
$parcel$export(module.exports, "legacyBacklogRoute", () => $85394c132abb2dc1$export$c51fda014ab27b5d);
const $85394c132abb2dc1$export$c51fda014ab27b5d = {
    name: 'legacy-backlog',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=(.*planning.*)'
    ]
};

});

parcelRegister("75Njg", function(module, exports) {
$parcel$export(module.exports, "AsyncHorizontalNavJira", () => $29aaa24d6cf5f173$export$ea83697d960a1a23);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $l8G1z = parcelRequire("l8G1z");

var $6yDzo = parcelRequire("6yDzo");

var $a8EUd = parcelRequire("a8EUd");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $29aaa24d6cf5f173$var$LazyHorizontalNavJira = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("eSQ8b")).then((HorizontalNavJira)=>HorizontalNavJira), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/horizontal-nav-jira/src/ui/HorizontalNavJira.tsx"
});
const $29aaa24d6cf5f173$var$AsyncHorizontalNav = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "horizontal-nav-jira",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6yDzo.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($29aaa24d6cf5f173$var$LazyHorizontalNavJira, null));
$29aaa24d6cf5f173$var$AsyncHorizontalNav.displayName = "AsyncHorizontalNav";
const $29aaa24d6cf5f173$export$ea83697d960a1a23 = $29aaa24d6cf5f173$var$AsyncHorizontalNav;

});
parcelRegister("6yDzo", function(module, exports) {
$parcel$export(module.exports, "TabsSkeleton", () => $8b5a92ba5e4159b0$export$807fef2beb9debc2);
$parcel$export(module.exports, "HorizontalNavSkeleton", () => $8b5a92ba5e4159b0$export$e29d51df5420bf39);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");
var $6Elhl = parcelRequire("6Elhl");
var $2BUXh = parcelRequire("2BUXh");
var $5BP41 = parcelRequire("5BP41");
var $fbAgj = parcelRequire("fbAgj");
const $8b5a92ba5e4159b0$export$807fef2beb9debc2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6Elhl.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$tabsWrapperSkeletonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$tabSkeletonStyles
    }));
$8b5a92ba5e4159b0$export$807fef2beb9debc2.displayName = "TabsSkeleton";
const $8b5a92ba5e4159b0$export$e29d51df5420bf39 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5BP41.default), {
        space: "space.050",
        alignBlock: "end",
        xcss: $8b5a92ba5e4159b0$var$horizontalNavWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$baseSkeletonStyles,
            $8b5a92ba5e4159b0$var$breadcrumbStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
        spread: "space-between",
        xcss: $8b5a92ba5e4159b0$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $8b5a92ba5e4159b0$var$primaryContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$baseSkeletonStyles,
            $8b5a92ba5e4159b0$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$baseSkeletonStyles,
            $8b5a92ba5e4159b0$var$projectTitleStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$baseSkeletonStyles,
            $8b5a92ba5e4159b0$var$squareStyles
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2BUXh.default), {
        space: "space.150",
        xcss: $8b5a92ba5e4159b0$var$actionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$baseSkeletonStyles,
            $8b5a92ba5e4159b0$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: [
            $8b5a92ba5e4159b0$var$baseSkeletonStyles,
            $8b5a92ba5e4159b0$var$squareStyles
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($8b5a92ba5e4159b0$export$807fef2beb9debc2, null));
$8b5a92ba5e4159b0$export$e29d51df5420bf39.displayName = "HorizontalNavSkeleton";
const $8b5a92ba5e4159b0$var$tabsWrapperSkeletonStyles = (0, $fbAgj.xcss)({
    gap: 'space.150',
    height: '32px',
    paddingInlineStart: 'space.300',
    paddingInlineEnd: 'space.300',
    paddingBlockEnd: 'space.150',
    marginBlockStart: 'space.100',
    position: 'relative',
    '::after': {
        content: '""',
        position: 'absolute',
        bottom: '0',
        backgroundColor: 'color.skeleton',
        height: '2px',
        left: '0',
        right: '0'
    }
});
const $8b5a92ba5e4159b0$var$tabSkeletonStyles = (0, $fbAgj.xcss)({
    minWidth: "var(--ds-space-1000, 80px)",
    backgroundColor: 'color.skeleton',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $8b5a92ba5e4159b0$var$horizontalNavWrapperStyles = (0, $fbAgj.xcss)({
    paddingBlockStart: 'space.150',
    blockSize: '104px'
});
const $8b5a92ba5e4159b0$var$baseSkeletonStyles = (0, $fbAgj.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'radius.small'
});
const $8b5a92ba5e4159b0$var$breadcrumbStyles = (0, $fbAgj.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '60px',
    marginInlineStart: 'space.300',
    marginBlockEnd: 'space.025'
});
const $8b5a92ba5e4159b0$var$primaryContainerStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    gap: 'space.100',
    marginInlineStart: 'space.300'
});
const $8b5a92ba5e4159b0$var$squareStyles = (0, $fbAgj.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: "var(--ds-space-300, 24px)"
});
const $8b5a92ba5e4159b0$var$headerWrapperStyles = (0, $fbAgj.xcss)({
    marginBlockStart: 'space.050'
});
const $8b5a92ba5e4159b0$var$projectTitleStyles = (0, $fbAgj.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '180px'
});
const $8b5a92ba5e4159b0$var$actionStyles = (0, $fbAgj.xcss)({
    marginInlineEnd: 'space.300'
});

});
parcelRegister("2BUXh", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6c2f4b7feac11ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $fbAgj = parcelRequire("fbAgj");

var $6Elhl = parcelRequire("6Elhl");
const $a6c2f4b7feac11ea$var$flexGrowMap = {
    hug: (0, $fbAgj.xcss)({
        flexGrow: 0
    }),
    fill: (0, $fbAgj.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $a6c2f4b7feac11ea$var$separatorStyles = /*#__PURE__*/ (0, $hStPE.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $a6c2f4b7feac11ea$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $hStPE.jsx)("span", {
        css: $a6c2f4b7feac11ea$var$separatorStyles
    }, children);
$a6c2f4b7feac11ea$var$Separator.displayName = "Separator";
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $a6c2f4b7feac11ea$var$Inline = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, id: id, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $hStPE.jsx)($a6c2f4b7feac11ea$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $euxye.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $hStPE.jsx)((0, $euxye.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $a6c2f4b7feac11ea$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $hStPE.jsx)((0, $6Elhl.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$a6c2f4b7feac11ea$var$Inline.displayName = 'Inline';
var $a6c2f4b7feac11ea$export$2e2bcd8739ae039 = $a6c2f4b7feac11ea$var$Inline;

});


parcelRegister("eSQ8b", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");

module.exports = Promise.all([
    (parcelRequire("gZgW8"))('jira_amplitude_sr', function() {
        return Promise.all([
            $4cvLQ("93SsA"),
            $4cvLQ("5qC72")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("2PzkC")
        ]);
    }),
    $4cvLQ("a36Wj"),
    $4cvLQ("elvlF"),
    $4cvLQ("hc93Z"),
    $4cvLQ("4Smn9"),
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("lxPzZ")
]).then(()=>parcelRequire('746V9'));

});



parcelRegister("ajwdo", function(module, exports) {
$parcel$export(module.exports, "legacyBoardRapidViewRouteEntry", () => $bf0e06f398d70f80$export$36cfd1ed8d73fe4e);
/* eslint-disable import/order */ 

var $jgKgn = parcelRequire("jgKgn");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $kjMEB = parcelRequire("kjMEB");

var $75Njg = parcelRequire("75Njg");
const $bf0e06f398d70f80$export$36cfd1ed8d73fe4e = (0, $g1GqA.createLegacyEntry)((0, $kjMEB.legacyBoardRapidViewRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jgKgn.LegacyPage),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource)
        ]
    }));

});
parcelRegister("kjMEB", function(module, exports) {
$parcel$export(module.exports, "legacyBoardRapidViewRoute", () => $4320143d3cd8a33b$export$4c8472ef2f57845f);
const $4320143d3cd8a33b$export$4c8472ef2f57845f = {
    name: 'legacy-board',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView'
    ]
};

});


parcelRegister("auoLG", function(module, exports) {
$parcel$export(module.exports, "legacyBoardRouteEntry", () => $b7f970c91a8a5adf$export$e3d172b0d9fd0d47);
/* eslint-disable import/order */ 

var $jgKgn = parcelRequire("jgKgn");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $lSIwq = parcelRequire("lSIwq");

var $75Njg = parcelRequire("75Njg");
const $b7f970c91a8a5adf$export$e3d172b0d9fd0d47 = (0, $g1GqA.createLegacyEntry)((0, $lSIwq.legacyBoardRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $75Njg.AsyncHorizontalNavJira)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jgKgn.LegacyPage),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource)
        ]
    }));

});
parcelRegister("lSIwq", function(module, exports) {
$parcel$export(module.exports, "legacyBoardRoute", () => $6291e08a4ae17a29$export$9259d0f05fc27139);
const $6291e08a4ae17a29$export$9259d0f05fc27139 = {
    name: 'legacy-board',
    path: '/secure/RapidBoard.jspa'
};

});


parcelRegister("8O1VY", function(module, exports) {
$parcel$export(module.exports, "legacyConnectGeneralRouteEntry", () => $adde6cda4c7a19f8$export$5f816cf76ff922b8);
/* eslint-disable import/order */ 
var $6RSCO = parcelRequire("6RSCO");

var $efbPr = parcelRequire("efbPr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $QhQu4 = parcelRequire("QhQu4");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $8h3Mz = parcelRequire("8h3Mz");
const $adde6cda4c7a19f8$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $adde6cda4c7a19f8$export$5f816cf76ff922b8 = (0, $g1GqA.createLegacyEntry)((0, $8h3Mz.legacyConnectGeneralRoute), ()=>({
        layout: (0, $QhQu4.createLayout)(),
        navigation: {},
        resources: [
            (0, $efbPr.connectGeneralResources),
            (0, $45Itd.navigationSidebarGlobalResource),
            ...(0, $hFYSn.getNavigationSidebarGlobalSettingsResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$adde6cda4c7a19f8$var$pageEntryPoint
    }));

});
parcelRegister("efbPr", function(module, exports) {
$parcel$export(module.exports, "connectGeneralResources", () => $0ab8c2274feecda9$export$f34ab0d904621847);
$parcel$export(module.exports, "useConnectGeneralResource", () => $0ab8c2274feecda9$export$53479840ec6d4024);

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $0ab8c2274feecda9$var$RESOURCE_TYPE_CONNECT_GENERAL = 'CONNECT_GENERAL';

const $0ab8c2274feecda9$export$f34ab0d904621847 = (0, $7edbf.createResource)({
    type: $0ab8c2274feecda9$var$RESOURCE_TYPE_CONNECT_GENERAL,
    getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
        // spa-router/src/common/types.js:
        /** TODO we are supporting `undefined` here because we are currently using both
		 * this version of the `Match` type, and react-routers version (which allows for `undefined`)
		 * To fix this we should move `matchPath` to our own util so we can apply our own types, then
		 * decide if we want to support undefined types.
		 */ if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("c4d3X"))
});
const $0ab8c2274feecda9$export$53479840ec6d4024 = ()=>(0, $k6ufm.useResource)($0ab8c2274feecda9$export$f34ab0d904621847);

});
parcelRegister("c4d3X", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5mJ2M").then(()=>parcelRequire('iFZAj'));

});


parcelRegister("8h3Mz", function(module, exports) {
$parcel$export(module.exports, "legacyConnectGeneralRoute", () => $6469dabc4a29beef$export$837edad42702a8e5);
const $6469dabc4a29beef$export$837edad42702a8e5 = {
    name: 'legacy-connect-general',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey'
};

});


parcelRegister("78ijD", function(module, exports) {
$parcel$export(module.exports, "legacyConnectProjectRouteEntry", () => $edda1a1456956bdb$export$c7f411b1904e5c2a);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $lIcLg = parcelRequire("lIcLg");

var $3KSG6 = parcelRequire("3KSG6");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $lbxXL = parcelRequire("lbxXL");

var $hWEkS = parcelRequire("hWEkS");

var $gVfFx = parcelRequire("gVfFx");
const $edda1a1456956bdb$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $edda1a1456956bdb$export$c7f411b1904e5c2a = (0, $g1GqA.createLegacyEntry)((0, $gVfFx.legacyConnectProjectRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        resources: [
            (0, $lIcLg.connectProjectResources),
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $lbxXL.getServiceDeskSharedNavigationSingleResources)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$edda1a1456956bdb$var$pageEntryPoint
    }));

});
parcelRegister("lIcLg", function(module, exports) {
$parcel$export(module.exports, "connectProjectResources", () => $25c665d0f0e23279$export$7d2d082a4b91a6c7);
// eslint-disable-next-line jira/import-whitelist

var $i06nY = parcelRequire("i06nY");

var $idDnR = parcelRequire("idDnR");

var $7edbf = parcelRequire("7edbf");
const $25c665d0f0e23279$var$RESOURCE_TYPE_CONNECT_PROJECT = 'CONNECT_PROJECT';

const $25c665d0f0e23279$export$7d2d082a4b91a6c7 = (0, $7edbf.createResource)({
    type: $25c665d0f0e23279$var$RESOURCE_TYPE_CONNECT_PROJECT,
    getKey: ({ query: query })=>{
        const { addonKey: addonKey, moduleKey: moduleKey } = (0, $i06nY.transformUrlToAddonAndModuleKeys)(query);
        if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    depends: [
        (0, $idDnR.staticProjectSidebarNavigationResource).type
    ],
    getDataLoader: ()=>(parcelRequire("JaDbR"))
});

});
parcelRegister("i06nY", function(module, exports) {
$parcel$export(module.exports, "transformResponse", () => $35917c5aa0ac1a8b$export$3361e9be8093ddcc);
$parcel$export(module.exports, "extractContext", () => $35917c5aa0ac1a8b$export$efdbd45f3e77a161);
$parcel$export(module.exports, "transformQueryParams", () => $35917c5aa0ac1a8b$export$9e3c3f47fc3ab3d0);
$parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", () => $35917c5aa0ac1a8b$export$752ef5ab3d7ab15f);
$parcel$export(module.exports, "buildNotFoundUrl", () => $35917c5aa0ac1a8b$export$f1f213454f5d81b9);
$parcel$export(module.exports, "transformContextToFromUrl", () => $35917c5aa0ac1a8b$export$ca4c8c0a45099ac);
/* eslint-disable jira/filename-case */ 
var $6CfY5 = parcelRequire("6CfY5");

var $aehBZ = parcelRequire("aehBZ");

var $4bRaD = parcelRequire("4bRaD");
const $35917c5aa0ac1a8b$export$3361e9be8093ddcc = (response)=>{
    try {
        const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
        let structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
        structuredContext = {
            ...structuredContext,
            jira: {
                ...structuredContext.jira,
                horizontalNavigation: true
            }
        };
        const context = {
            productContext: productContext,
            structuredContext: structuredContext,
            productCtx: productContext
        };
        return {
            ...response,
            ...context,
            isFullPage: response.general === '1',
            user: {
                timeZone: response.timeZone,
                uid: response.uid || undefined,
                ukey: response.ukey || undefined,
                fullName: response.fullName || undefined
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            history: {
                state: ''
            },
            autoresize: true,
            ns: response.uniqueKey,
            containerId: `embedded-${response.uniqueKey}`,
            contextPath: response.cp,
            width: response.w || response.width,
            height: response.h || response.height,
            type: 'MODULE'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const location = 'connect-iframe.transformer';
        (0, $6CfY5.default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
        return {
            autoresize: true,
            productCtx: undefined,
            structuredContext: undefined,
            isFullPage: true,
            history: {
                state: ''
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            type: 'MODULE'
        };
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $35917c5aa0ac1a8b$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
    const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
    return newValue !== null ? {
        [newName]: newValue
    } : null;
};
const $35917c5aa0ac1a8b$export$1f8eea5a5a32169f = (contextData)=>{
    const scope = contextData && contextData.scope || null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const project = contextData && contextData.project || null;
    const projectId = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
    const boardId = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $35917c5aa0ac1a8b$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
    const project = projectSidebarNavInfo && (0, $4bRaD.extractData)(projectSidebarNavInfo) || null;
    const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, $aehBZ.extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
    const projectId = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(board, 'type', 'board.type');
    const boardId = $35917c5aa0ac1a8b$var$checkValueAndMapToNewName(board, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $35917c5aa0ac1a8b$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
    const context = $35917c5aa0ac1a8b$export$1f8eea5a5a32169f(contextData);
    return {
        ...query,
        ...context
    };
};
const $35917c5aa0ac1a8b$export$752ef5ab3d7ab15f = (query)=>{
    const { selectedItem: selectedItem } = query;
    let addonKey = '';
    let moduleKey = '';
    if (selectedItem) {
        const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
        [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
    }
    return {
        addonKey: addonKey,
        moduleKey: moduleKey
    };
};
const $35917c5aa0ac1a8b$export$f1f213454f5d81b9 = (containerContext)=>{
    if (!containerContext) return null;
    if (containerContext.contextType !== 'project') return null;
    const project = containerContext.project;
    const scope = containerContext.scope;
    const projectKey = project.key;
    const projectType = project.type;
    const scopeId = scope?.id;
    if (projectType === 'business') return `/jira/core/projects/${projectKey}/not-found`;
    if (projectType === 'software' && scopeId) return `/jira/software/projects/${projectKey}/boards/${scopeId}/not-found`;
    return null;
};
const $35917c5aa0ac1a8b$export$ca4c8c0a45099ac = (match, query, hash)=>{
    const queryString = new URLSearchParams(query);
    const originalUrl = new URL(`${globalThis.location.origin}${match.url}`);
    queryString.forEach((value, key)=>{
        originalUrl.searchParams.append(key, value);
    });
    originalUrl.hash = hash;
    return originalUrl.href;
};

});
parcelRegister("aehBZ", function(module, exports) {
$parcel$export(module.exports, "extractData", () => $6a13c8f05f6bf6bb$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $6a13c8f05f6bf6bb$export$67db9e2d1b6ed865);
/* eslint-disable jira/filename-case */ const $6a13c8f05f6bf6bb$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $6a13c8f05f6bf6bb$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


parcelRegister("JaDbR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9Z4IB").then(()=>parcelRequire('43s2S'));

});


parcelRegister("lbxXL", function(module, exports) {
$parcel$export(module.exports, "getServiceDeskNavigationResources", () => $64facb858b050d93$export$bc0bd65e6da57c1f);
$parcel$export(module.exports, "getServiceDeskNavigationSingleResources", () => $64facb858b050d93$export$41a9145ddbba28e5);
$parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", () => $64facb858b050d93$export$2c543d6accc1eb9b);
$parcel$export(module.exports, "getServiceDeskSettingsResources", () => $64facb858b050d93$export$7bb3c4a2f6b127fb);
$parcel$export(module.exports, "getServicedeskPageContextResources", () => $64facb858b050d93$export$a8b852f03a310dc0);
$parcel$export(module.exports, "getQueuesResources", () => $64facb858b050d93$export$70b97995f4d5ef9f);
$parcel$export(module.exports, "getTriageButtonPermissionResource", () => $64facb858b050d93$export$425007869b82cef8);
$parcel$export(module.exports, "getKnowledgeBaseResources", () => $64facb858b050d93$export$ed87d3b71544c4ef);
$parcel$export(module.exports, "getInsightResources", () => $64facb858b050d93$export$9e0cf1fab0581096);
$parcel$export(module.exports, "getQueueConfigResource", () => $64facb858b050d93$export$5f7bcaa978a3e51);
$parcel$export(module.exports, "getQueueViewConfigResource", () => $64facb858b050d93$export$54079077c6768752);
$parcel$export(module.exports, "getIssueViewResources", () => $64facb858b050d93$export$590e911b4187f266);
/* eslint-disable jira/restricted/fedramp-isolated-cloud */ 
var $41FAq = parcelRequire("41FAq");

var $8ycTI = parcelRequire("8ycTI");

var $6RSCO = parcelRequire("6RSCO");

var $34Jgy = parcelRequire("34Jgy");

var $4TFaG = parcelRequire("4TFaG");

var $5adCU = parcelRequire("5adCU");

var $hRSPo = parcelRequire("hRSPo");

var $cDLVA = parcelRequire("cDLVA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $koA6h = parcelRequire("koA6h");

var $iyqMX = parcelRequire("iyqMX");

var $ble5H = parcelRequire("ble5H");

var $j0qHc = parcelRequire("j0qHc");

var $dkOZx = parcelRequire("dkOZx");

var $cpnl1 = parcelRequire("cpnl1");

var $c6i4p = parcelRequire("c6i4p");

var $kqhKu = parcelRequire("kqhKu");

var $lEPfS = parcelRequire("lEPfS");

var $hWEkS = parcelRequire("hWEkS");

var $8HUuJ = parcelRequire("8HUuJ");

var $2DCyG = parcelRequire("2DCyG");

var $4pLi9 = parcelRequire("4pLi9");

var $35eqr = parcelRequire("35eqr");

var $53xPq = parcelRequire("53xPq");

var $dk0Ly = parcelRequire("dk0Ly");

var $9MeJD = parcelRequire("9MeJD");

var $862Zj = parcelRequire("862Zj");

var $idDnR = parcelRequire("idDnR");

var $ihrBs = parcelRequire("ihrBs");

var $4Rvd7 = parcelRequire("4Rvd7");

var $aS6zs = parcelRequire("aS6zs");

var $g1yQ7 = parcelRequire("g1yQ7");

var $hFYSn = parcelRequire("hFYSn");

var $2700E = parcelRequire("2700E");

var $i860n = parcelRequire("i860n");

var $l1vE2 = parcelRequire("l1vE2");
const $64facb858b050d93$export$bc0bd65e6da57c1f = ()=>[
        ...(0, $dUAVJ.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
        // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
        (0, $hWEkS.incidentExperimentTraitResource),
        (0, $edf7u.projectContextResource),
        (0, $hFYSn.forgeProjectModuleResource),
        (0, $862Zj.staticSidebarShortcutsResource),
        (0, $idDnR.staticProjectSidebarNavigationResource),
        (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...$64facb858b050d93$export$41a9145ddbba28e5(),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_gp_announcements_banner'), (0, $4pLi9.jsmGracePeriodAnnouncementDisplayStateResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_gp_announcements_banner'), (0, $4pLi9.jsmGracePeriodAnnouncementGpEndDateResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('sqa-2098-assets-nav-upsell-jsm-free-nav'), (0, $35eqr.postOfficeAssetsMenuItemFreeUsersPlacementResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('grw-214_jsm_jpd_simplified_nav_bar_killswitch'), (0, $dkOZx.isSimplifiedNavResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>// eslint-disable-next-line jira/ff/no-preconditioning -- Main WFO gate must block status-control feature resource preloading when the parent feature is off.
            (0, $i860n.fg)('jsm_workforce_optimization_main') && (0, $2700E.expVal)('jsm_workforce_optimization_status_control', 'isEnabled', false), (0, $dk0Ly.jsmFeaturesEnabledResource))
    ];
const $64facb858b050d93$export$41a9145ddbba28e5 = ()=>[
        // projectContextResource is a dependency to the priorityGroupsResource
        (0, $edf7u.projectContextResource),
        (0, $cpnl1.queueNav4SidebarSelectionResource),
        (0, $cpnl1.queueSidebarQueuesCategoryStateResource),
        ...$64facb858b050d93$export$9c1c5e389bd00e56(),
        ...$64facb858b050d93$export$2c543d6accc1eb9b()
    ];
const $64facb858b050d93$export$9c1c5e389bd00e56 = ()=>[
        (0, $cpnl1.priorityGroupByProjectIdResourceSsr),
        (0, $lEPfS.featuresResource),
        (0, $aS6zs.staticSidebarJsmReportsResource),
        (0, $6RSCO.getConsolidationStateResource)(),
        (0, $ble5H.servicedeskIsItsmProjectResource),
        (0, $c6i4p.nav3QueueGroupsStateResource)
    ];
const $64facb858b050d93$export$2c543d6accc1eb9b = ()=>[
        (0, $cpnl1.queuesNavigationItems),
        (0, $dkOZx.requiredProjectProperties),
        (0, $dkOZx.requiredFrontendProperties),
        (0, $hFYSn.forgeServiceDeskQueueModuleResource),
        (0, $g1yQ7.staticJSMProjectConnectAddonsNavigationResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        // for Getting Started menu item
        // resourceWithCondition(isNav4ResourcesFixEnabled, requiredFrontendProperties),
        (0, $edf7u.projectContextResourceWithCache),
        (0, $dkOZx.firstProjectResource),
        (0, $9MeJD.jsmProjectMenuContentSidebarResource)
    ];
const $64facb858b050d93$export$7bb3c4a2f6b127fb = ()=>[
        ...(0, $dUAVJ.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
        // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
        (0, $hWEkS.incidentExperimentTraitResource),
        (0, $edf7u.projectContextResource),
        (0, $hFYSn.forgeProjectModuleResource),
        (0, $862Zj.staticSidebarShortcutsResource),
        (0, $idDnR.staticProjectSidebarNavigationResource),
        (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
        (0, $j0qHc.servicedeskPracticesResource),
        (0, $iyqMX.serviceDeskContextResource),
        (0, $koA6h.serviceDeskAnalyticsContextResource),
        (0, $dkOZx.firstProjectResource),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('grw-214_jsm_jpd_simplified_nav_bar_killswitch'), (0, $dkOZx.isSimplifiedNavResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('aem_migration_jira') ? (0, $41FAq.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent') : !(0, $l1vE2.isFedRamp)(), (0, $kqhKu.virtualAgentOnboardingResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>// eslint-disable-next-line jira/ff/no-preconditioning -- Main WFO gate must block status-control feature resource preloading when the parent feature is off.
            (0, $i860n.fg)('jsm_workforce_optimization_main') && (0, $2700E.expVal)('jsm_workforce_optimization_status_control', 'isEnabled', false) || (0, $i860n.fg)('jsm_wfo_agent_presence'), (0, $dk0Ly.jsmFeaturesEnabledResource))
    ];
const $64facb858b050d93$export$a8b852f03a310dc0 = ()=>[
        (0, $edf7u.projectContextResourceWithCache),
        (0, $iyqMX.serviceDeskContextResource),
        (0, $koA6h.serviceDeskAnalyticsContextResource),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_gp_announcements_banner'), (0, $4pLi9.jsmGracePeriodAnnouncementDisplayStateResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_gp_announcements_banner'), (0, $4pLi9.jsmGracePeriodAnnouncementGpEndDateResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('sqa-2098-assets-nav-upsell-jsm-free-nav'), (0, $35eqr.postOfficeAssetsMenuItemFreeUsersPlacementResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>// eslint-disable-next-line jira/ff/no-preconditioning -- Main WFO gate must block status-control feature resource preloading when the parent feature is off.
            (0, $i860n.fg)('jsm_workforce_optimization_main') && (0, $2700E.expVal)('jsm_workforce_optimization_status_control', 'isEnabled', false) || (0, $i860n.fg)('jsm_wfo_agent_presence'), (0, $dk0Ly.jsmFeaturesEnabledResource))
    ];
const $64facb858b050d93$export$70b97995f4d5ef9f = ()=>[
        ...$64facb858b050d93$export$a8b852f03a310dc0(),
        ...$64facb858b050d93$export$bc0bd65e6da57c1f(),
        (0, $cDLVA.getCalendarFilterFieldsResource)()
    ];
const $64facb858b050d93$export$425007869b82cef8 = ()=>[
        (0, $cpnl1.triageButtonPermissionResource)
    ];
const $64facb858b050d93$export$ed87d3b71544c4ef = ()=>[
        (0, $34Jgy.kbConfluenceContextResource)
    ];
const $64facb858b050d93$export$9e0cf1fab0581096 = ()=>[
        (0, $8ycTI.workspaceResource)
    ];
const $64facb858b050d93$export$5f7bcaa978a3e51 = ()=>[
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $edf7u.projectContextResource))
    ];
const $64facb858b050d93$export$54079077c6768752 = ()=>[
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $hRSPo.getEditModelResource)()),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $4TFaG.getBoardDetailsResource)()),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $edf7u.projectContextResource)),
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), (0, $2DCyG.uifBoardResource)),
        ...(0, $5adCU.getRapidboardResources)().map((resource)=>(0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jsm_views_inside_queues_-_main_flag'), resource))
    ];
const $64facb858b050d93$export$590e911b4187f266 = ()=>[
        (0, $8HUuJ.resourceWithCondition)(()=>(0, $i860n.fg)('jfp-magma-ssr-iv-collapse-group'), (0, $53xPq.issueCollapsibleGroupDataResource))
    ];

});
parcelRegister("8ycTI", function(module, exports) {
$parcel$export(module.exports, "workspaceResource", () => $ccd5616b1e2a7c59$export$2f02c3f971168d17);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $bOYO0 = parcelRequire("bOYO0");
const $ccd5616b1e2a7c59$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $ccd5616b1e2a7c59$export$2f02c3f971168d17 = (0, $7edbf.createResource)({
    type: $ccd5616b1e2a7c59$export$9b3a4d71d46e5ee7,
    getKey: ()=>'state',
    getData: async (_, routerContext)=>{
        const workspaceId = await (0, $bOYO0.default)(_, routerContext);
        return workspaceId;
    },
    maxAge: Infinity
});

});
parcelRegister("bOYO0", function(module, exports) {
$parcel$export(module.exports, "getUserJsmLicenceState", () => $ab62535975dc2e60$export$65bf73aad2afa39);
$parcel$export(module.exports, "hasAssetsEntitlement", () => $ab62535975dc2e60$export$7bb18d2d90127035);
$parcel$export(module.exports, "isPremiumInstance", () => $ab62535975dc2e60$export$abb609d3bcbb74f6);
$parcel$export(module.exports, "isPremiumAssetsInstance", () => $ab62535975dc2e60$export$9e950299c4afea2c);
$parcel$export(module.exports, "isLicensedPremiumUser", () => $ab62535975dc2e60$export$d7b4c32773b1c643);
$parcel$export(module.exports, "isAssetsUser", () => $ab62535975dc2e60$export$752303d076a5ceed);
$parcel$export(module.exports, "useCheckAssetsUser", () => $ab62535975dc2e60$export$c18e70f2beb75f);
$parcel$export(module.exports, "default", () => $ab62535975dc2e60$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $d8LhJ = parcelRequire("d8LhJ");


var $hFtK7 = parcelRequire("hFtK7");

var $eh7eP = parcelRequire("eh7eP");

var $eBpdw = parcelRequire("eBpdw");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");

var $bVqQI = parcelRequire("bVqQI");
const $ab62535975dc2e60$export$530f260cc76f04ff = ()=>'/rest/servicedesk/cmdb/latest/workspace';
const $ab62535975dc2e60$export$65bf73aad2afa39 = (tenantContext)=>{
    const { licensedProducts: licensedProducts, appPermissions: appPermissions } = tenantContext;
    const hasJsmLicence = licensedProducts && licensedProducts[0, $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61];
    const isJsmLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    if ($ab62535975dc2e60$export$7bb18d2d90127035(tenantContext) && (0, $i860n.fg)('aurum-997-license-kill-switch')) return {
        userLicensed: tenantContext?.isLicensedAssetsUser === true,
        siteHasJsmInstalled: true,
        siteIsPremium: true
    };
    if (!hasJsmLicence) return {
        siteHasJsmInstalled: false
    };
    return {
        siteHasJsmInstalled: true,
        siteIsPremium: $ab62535975dc2e60$export$abb609d3bcbb74f6(tenantContext),
        userLicensed: isJsmLicensedUser
    };
};
const $ab62535975dc2e60$export$7bb18d2d90127035 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const containsAssetsEntitlement = licensedProducts && licensedProducts[0, $eb8cfa569eede1a9$export$a310f85340477585];
    return containsAssetsEntitlement;
};
const $ab62535975dc2e60$export$abb609d3bcbb74f6 = (tenantContext)=>{
    const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
    const isPremiumInstanceEdition = serviceDeskAppEdition === (0, $d8LhJ.PREMIUM_EDITION);
    return isPremiumInstanceEdition;
};
const $ab62535975dc2e60$export$9e950299c4afea2c = (tenantContext)=>{
    const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
    const isPremiumInstanceEdition = serviceDeskAppEdition === (0, $d8LhJ.PREMIUM_EDITION);
    if ($ab62535975dc2e60$export$7bb18d2d90127035(tenantContext) && (0, $i860n.fg)('aurum-997-license-kill-switch')) return true;
    return isPremiumInstanceEdition;
};
const $ab62535975dc2e60$export$d7b4c32773b1c643 = (tenantContext)=>{
    const { appPermissions: appPermissions } = tenantContext;
    const isPremium = $ab62535975dc2e60$export$abb609d3bcbb74f6(tenantContext);
    const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    return isPremium && isLicensedUser;
};
const $ab62535975dc2e60$export$752303d076a5ceed = (tenantContext)=>{
    const { appPermissions: appPermissions } = tenantContext;
    const isPremium = $ab62535975dc2e60$export$abb609d3bcbb74f6(tenantContext);
    const isLicensedJsmUser = appPermissions && appPermissions.hasServiceDeskAccess;
    if ($ab62535975dc2e60$export$7bb18d2d90127035(tenantContext) && (0, $i860n.fg)('aurum-997-license-kill-switch')) return tenantContext?.isLicensedAssetsUser === true;
    return isPremium && isLicensedJsmUser;
};
const $ab62535975dc2e60$var$transformResponse = (response)=>{
    const ids = response.results ?? [];
    return ids.length ? ids[0].id : null;
};
const $ab62535975dc2e60$var$ERROR_META = {
    id: 'checkIfAssetsUser',
    packageName: 'jiraServicedeskInsightCommonWorkspaceContext',
    teamName: 'astral'
};
const $ab62535975dc2e60$var$INITIAL_LOADING_STATE = {
    isLoading: true,
    isAssetsAdmin: false,
    error: null,
    isValidAssetsUser: null
};
const $ab62535975dc2e60$var$getPermissionSource = (tenantContext, unitAwareWorkspaceId)=>{
    // Units path is controlled directly by the workspace-host resolver gate and
    // must not be blocked by legacy JSM kill-switch branching.
    if (unitAwareWorkspaceId && (0, $i860n.fg)('astral_units_workspace_host_resolver')) return 'units';
    if (!(0, $i860n.fg)('aurum-997-license-kill-switch')) return 'jsm';
    if ($ab62535975dc2e60$export$7bb18d2d90127035(tenantContext) && (0, $i860n.fg)('jsm_assets_use_assets_resource_for_permissions')) return 'assets';
    if ($ab62535975dc2e60$export$7bb18d2d90127035(tenantContext) && (0, $i860n.fg)('aaap_use_assets_and_jsm_roles')) return 'combined';
    return 'jsm';
};
const $ab62535975dc2e60$var$getJSMPermissions = (tenantContext)=>({
        isLoading: false,
        isAssetsAdmin: tenantContext.isAdmin,
        error: null,
        isValidAssetsUser: $ab62535975dc2e60$export$d7b4c32773b1c643(tenantContext)
    });
const $ab62535975dc2e60$export$e16b096a3b46294d = async (tenantContext, unitAwareWorkspaceId)=>{
    const validation = (0, $bVqQI.validateTenantContext)(tenantContext);
    if (!validation.isValid) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: $ab62535975dc2e60$var$ERROR_META,
            error: validation.error
        });
        return (0, $bVqQI.createDefaultResponse)(validation?.error ?? null);
    }
    const permissionSource = $ab62535975dc2e60$var$getPermissionSource(tenantContext, unitAwareWorkspaceId);
    if (permissionSource === 'jsm') return (0, $bVqQI.createSuccessResponse)(false, false);
    try {
        const { isValidAssetsUser: isValidAssetsUser, isAssetsAdmin: isAssetsAdmin } = await (0, $bVqQI.fetchUserPermissions)(tenantContext);
        return (0, $bVqQI.createSuccessResponse)(isValidAssetsUser, isAssetsAdmin);
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            meta: $ab62535975dc2e60$var$ERROR_META,
            error: error instanceof Error ? error : new Error(String(error))
        });
        return (0, $bVqQI.createDefaultResponse)(new Error('Error while fetching user permissions'));
    }
};
const $ab62535975dc2e60$export$c18e70f2beb75f = (tenantContext, unitAwareWorkspaceId)=>{
    const permissionSource = $ab62535975dc2e60$var$getPermissionSource(tenantContext, unitAwareWorkspaceId);
    const shouldFetchFromAPI = permissionSource !== 'jsm';
    const [permissions, setPermissions] = (0, $euxye.useState)($ab62535975dc2e60$var$INITIAL_LOADING_STATE);
    (0, $euxye.useEffect)(()=>{
        if (!shouldFetchFromAPI) return;
        // Stale closure flag - prevents setState on unmounted component or stale requests
        // See: https://react.dev/learn/synchronizing-with-effects#fetching-data
        let isStale = false;
        $ab62535975dc2e60$export$e16b096a3b46294d(tenantContext, unitAwareWorkspaceId).then((result)=>{
            if (isStale) return;
            if (permissionSource === 'assets' || permissionSource === 'units') setPermissions(result);
            else {
                const jsmPermissions = $ab62535975dc2e60$var$getJSMPermissions(tenantContext);
                setPermissions({
                    ...result,
                    isValidAssetsUser: jsmPermissions.isValidAssetsUser || result.isValidAssetsUser,
                    isAssetsAdmin: jsmPermissions.isAssetsAdmin || result.isAssetsAdmin
                });
            }
        }).catch((error)=>{
            if (isStale) return;
            setPermissions({
                isLoading: false,
                isAssetsAdmin: false,
                error: error instanceof Error ? error : new Error('Unknown error'),
                isValidAssetsUser: null
            });
        });
        return ()=>{
            isStale = true;
        };
    }, [
        shouldFetchFromAPI,
        permissionSource,
        tenantContext,
        unitAwareWorkspaceId
    ]);
    if (!shouldFetchFromAPI) return $ab62535975dc2e60$var$getJSMPermissions(tenantContext);
    return permissions;
};
const $ab62535975dc2e60$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
    const isNotLicensedAssetsUser = (0, $i860n.fg)('aurum-997-license-kill-switch') ? $ab62535975dc2e60$export$7bb18d2d90127035(tenantContext) === false : $ab62535975dc2e60$export$d7b4c32773b1c643(tenantContext) === false;
    if (isNotLicensedAssetsUser || !(0, $eBpdw.isCMDBEnabledInEnvironment)()) return null;
    return (0, $eh7eP.performCmdbGetRequest)($ab62535975dc2e60$export$530f260cc76f04ff()).then($ab62535975dc2e60$var$transformResponse).catch((error)=>{
        (0, $6CfY5.default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
        return null;
    });
};
var $ab62535975dc2e60$export$2e2bcd8739ae039 = $ab62535975dc2e60$export$e1d718dfe6dad973;

});
/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';

parcelRegister("eh7eP", function(module, exports) {
$parcel$export(module.exports, "performCmdbGetRequest", () => $2dcbf58202cde5a1$export$a252413f43ec7247);
$parcel$export(module.exports, "performCmdbPostRequest", () => $2dcbf58202cde5a1$export$d68a9f67166d25a2);
$parcel$export(module.exports, "performCmdbPutRequest", () => $2dcbf58202cde5a1$export$326b7407f501f98b);
$parcel$export(module.exports, "performCmdbDeleteRequest", () => $2dcbf58202cde5a1$export$b198eb14f22c12e6);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");

var $ff8AH = parcelRequire("ff8AH");

var $h2wCv = parcelRequire("h2wCv");
const $2dcbf58202cde5a1$export$d5e211a0106aa636 = {
    'X-Request-Source': 'cmdb-frontend'
};
const $2dcbf58202cde5a1$export$a252413f43ec7247 = (url, options)=>(0, $h2wCv.performGetRequest)(url, $2dcbf58202cde5a1$export$235b7fc70b9fc359(url, options));
const $2dcbf58202cde5a1$export$d68a9f67166d25a2 = (url, options)=>(0, $h2wCv.performPostRequest)(url, $2dcbf58202cde5a1$export$235b7fc70b9fc359(url, options));
const $2dcbf58202cde5a1$export$326b7407f501f98b = (url, options)=>(0, $h2wCv.performPutRequest)(url, $2dcbf58202cde5a1$export$235b7fc70b9fc359(url, options));
const $2dcbf58202cde5a1$export$b198eb14f22c12e6 = (url, options)=>(0, $h2wCv.performDeleteRequest)(url, $2dcbf58202cde5a1$export$235b7fc70b9fc359(url, options));
const $2dcbf58202cde5a1$export$235b7fc70b9fc359 = (url, options)=>{
    const defaultOptions = (0, $ff8AH.getDefaultOptions)(url);
    return (0, $i860n.fg)('fly-2529-cmdb-client-send-request-source-header') ? {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options?.headers,
            ...$2dcbf58202cde5a1$export$d5e211a0106aa636
        }
    } : options;
};

});

parcelRegister("eBpdw", function(module, exports) {
$parcel$export(module.exports, "isCMDBEnabledInEnvironment", () => $565c236a412fbde8$export$6dbfb62369f79a64);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $565c236a412fbde8$export$6dbfb62369f79a64 = ()=>true;

});

parcelRegister("bVqQI", function(module, exports) {
$parcel$export(module.exports, "validateTenantContext", () => $39124c3aa5c640b7$export$798f02752f5df48d);
$parcel$export(module.exports, "createDefaultResponse", () => $39124c3aa5c640b7$export$aea1b9db44368b56);
$parcel$export(module.exports, "createSuccessResponse", () => $39124c3aa5c640b7$export$58e6f0371860b4f0);
$parcel$export(module.exports, "fetchUserPermissions", () => $39124c3aa5c640b7$export$9a9b8ec4992a97eb);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");
const $39124c3aa5c640b7$var$PERMISSIONS_BULK_PERMITTED_URL = '/gateway/api/permissions/bulk/permitted';
const $39124c3aa5c640b7$var$ERROR_META = {
    packageName: 'jiraServicedeskInsightCommonWorkspaceContext',
    teamName: 'astral'
};
const $39124c3aa5c640b7$export$3edf18358e7f92f5 = (userId, cloudId)=>{
    if (!userId || !cloudId) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: new Error('User ID or cloud ID is missing in getPermissionsRequestPayload'),
            meta: {
                ...$39124c3aa5c640b7$var$ERROR_META,
                id: 'getPermissionsRequestPayload'
            }
        });
        return [];
    }
    return [
        {
            resourceId: `ari:cloud:cmdb::site/${cloudId}`,
            principalId: `ari:cloud:identity::user/${userId}`,
            permissionId: 'write'
        },
        {
            resourceId: `ari:cloud:cmdb::site/${cloudId}`,
            principalId: `ari:cloud:identity::user/${userId}`,
            permissionId: 'manage'
        }
    ];
};
const $39124c3aa5c640b7$export$873112f149f60559 = (response)=>{
    return {
        isValidAssetsUser: response.some((permission)=>permission.permissionId === 'write' && permission.permitted),
        isAssetsAdmin: response.some((permission)=>permission.permissionId === 'manage' && permission.permitted)
    };
};
const $39124c3aa5c640b7$export$798f02752f5df48d = (tenantContext)=>{
    if (!tenantContext) return {
        isValid: false,
        error: new Error('Tenant context is missing')
    };
    if (!tenantContext.atlassianAccountId || !tenantContext.cloudId) return {
        isValid: false,
        error: new Error('Tenant context is missing required fields (atlassianAccountId or cloudId)')
    };
    return {
        isValid: true
    };
};
const $39124c3aa5c640b7$export$aea1b9db44368b56 = (error)=>{
    return {
        isValidAssetsUser: null,
        isAssetsAdmin: false,
        error: error ?? new Error('Error while fetching user permissions'),
        isLoading: false
    };
};
const $39124c3aa5c640b7$export$58e6f0371860b4f0 = (isValidAssetsUser, isAssetsAdmin)=>{
    return {
        isValidAssetsUser: isValidAssetsUser,
        isAssetsAdmin: isAssetsAdmin,
        error: null,
        isLoading: false
    };
};
const $39124c3aa5c640b7$export$9a9b8ec4992a97eb = async (tenantContext)=>{
    const payload = $39124c3aa5c640b7$export$3edf18358e7f92f5(tenantContext.atlassianAccountId ?? '', tenantContext.cloudId ?? '');
    if (payload.length === 0) throw new Error('Failed to create permissions request payload');
    const response = await (0, $h2wCv.performPostRequest)($39124c3aa5c640b7$var$PERMISSIONS_BULK_PERMITTED_URL, {
        body: JSON.stringify(payload)
    });
    if (!Array.isArray(response)) throw new Error('Invalid response format from permissions API');
    return $39124c3aa5c640b7$export$873112f149f60559(response);
};

});



parcelRegister("34Jgy", function(module, exports) {
$parcel$export(module.exports, "kbConfluenceContextResource", () => $300c6488016ddc3c$export$8b58be1423986d17);

var $7edbf = parcelRequire("7edbf");
const $300c6488016ddc3c$var$RESOURCE_TYPE_KB_CONFLUENCE_CONTEXT = 'KB_CONFLUENCE_CONTEXT';

const $300c6488016ddc3c$export$8b58be1423986d17 = (0, $7edbf.createResource)({
    type: $300c6488016ddc3c$var$RESOURCE_TYPE_KB_CONFLUENCE_CONTEXT,
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: ()=>(parcelRequire("gawmn")),
    maxAge: Infinity
});

});
parcelRegister("gawmn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("dTcpy").then(()=>parcelRequire('2cLFW'));

});


parcelRegister("4TFaG", function(module, exports) {
$parcel$export(module.exports, "boardDetailsResource", () => $b92da9ff748cae7e$export$6c6984c55b171c5d);
$parcel$export(module.exports, "getBoardDetailsResource", () => $b92da9ff748cae7e$export$b67eabcfc08e7c62);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $4fhEY = parcelRequire("4fhEY");

var $7edbf = parcelRequire("7edbf");

var $5hHWs = parcelRequire("5hHWs");
const $b92da9ff748cae7e$export$90ce361a5838e31e = async (boardId)=>{
    try {
        return await (0, $4fhEY.default)(`/rest/agile/1.0/board/${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getBoardDetailsRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $b92da9ff748cae7e$export$6c6984c55b171c5d = (0, $7edbf.createResource)({
    type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
    getKey: (routerContext)=>(0, $5hHWs.getConfigFromRouterContext)(routerContext) ? 'cmp-board-settings' : 'not-cmp-board-setting',
    getData: async (routerContext)=>{
        const boardId = routerContext.match.params?.boardId ?? '';
        if ((0, $5hHWs.getConfigFromRouterContext)(routerContext)) return $b92da9ff748cae7e$export$90ce361a5838e31e(boardId);
        return null;
    }
});
const $b92da9ff748cae7e$export$b67eabcfc08e7c62 = ()=>$b92da9ff748cae7e$export$6c6984c55b171c5d;

});
parcelRegister("5hHWs", function(module, exports) {
$parcel$export(module.exports, "buildAllDataQueryParams", () => $bb4fb1cba6fa8636$export$487708debaea6de3);
$parcel$export(module.exports, "getInlineScriptData", () => $bb4fb1cba6fa8636$export$7bd4b867b9305f97);
$parcel$export(module.exports, "getRapidViewConfigFromRouteName", () => $bb4fb1cba6fa8636$export$62c86c4062215346);
$parcel$export(module.exports, "getRequiredResourceList", () => $bb4fb1cba6fa8636$export$7bff98a3d459b1b8);
$parcel$export(module.exports, "getConfigFromRouterContext", () => $bb4fb1cba6fa8636$export$1705c550e5b835bf);

var $RX0OA = parcelRequire("RX0OA");
const $bb4fb1cba6fa8636$var$RAPID_VIEW_ROUTE_CONFIG = {
    BOARD: {
        routes: [
            'rapidboard-board',
            'rapidboard-board-embed',
            'rapidboard-user-board',
            'servicedesk-boards',
            'servicedesk-queues-custom-board',
            'servicedesk-queues-practice-custom-board'
        ],
        resources: (0, $RX0OA.WRM_BOARD_RESOURCES_FHD_ARRAY),
        stateKey: 'board-state'
    },
    BACKLOG: {
        routes: [
            'rapidboard-backlog',
            'rapidboard-user-backlog',
            'rapidboard-backlog-embed'
        ],
        resources: (0, $RX0OA.WRM_BACKLOG_RESOURCES_FHD_ARRAY),
        stateKey: 'backlog-state'
    },
    DEFAULT: {
        resources: (0, $RX0OA.WRM_RESOURCES_ARRAY),
        stateKey: 'report-state'
    }
};
const $bb4fb1cba6fa8636$export$487708debaea6de3 = (query, match)=>{
    const { rapidView: rapidView, quickFilter: quickFilter, projectKey: queryProjectKey, etag: etag } = query;
    const boardId = match.params.boardId || rapidView;
    const projectKey = match.params.projectKey || queryProjectKey;
    let activeQuickFilters = '';
    if (quickFilter) activeQuickFilters = Array.isArray(quickFilter) ? quickFilter.reduce((prevFilter, nextFilter)=>`${prevFilter}&activeQuickFilters=${nextFilter}`, activeQuickFilters) : `&activeQuickFilters=${quickFilter}`;
    const etagParam = etag ? `&etag=${etag}` : '';
    const projectKeyParam = projectKey ? `&selectedProjectKey=${projectKey}` : '';
    const { GH: GH } = window;
    const forceConsistency = '&forceConsistency=true';
    GH?.RapidBoard?.State?.setRapidViewIdForEventuallyConsistentBoard(undefined);
    return `rapidViewId=${boardId}${projectKeyParam}${activeQuickFilters}${etagParam}${forceConsistency}`;
};
const $bb4fb1cba6fa8636$var$cleanUpInlineScript = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window[dataName];
};
const $bb4fb1cba6fa8636$export$7bd4b867b9305f97 = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const req = window[dataName];
    if (!req) return null;
    if (req.readyState === req.DONE && req.status !== 200) {
        $bb4fb1cba6fa8636$var$cleanUpInlineScript(dataName);
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((r)=>{
        if (req.readyState === req.DONE && req.status === 200) {
            $bb4fb1cba6fa8636$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        } else req.addEventListener('load', ()=>{
            $bb4fb1cba6fa8636$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        });
    });
};
const $bb4fb1cba6fa8636$export$62c86c4062215346 = (routeName)=>{
    for (const routeConfig of Object.values($bb4fb1cba6fa8636$var$RAPID_VIEW_ROUTE_CONFIG)){
        if (routeConfig.routes?.includes(routeName)) return routeConfig;
    }
    return $bb4fb1cba6fa8636$var$RAPID_VIEW_ROUTE_CONFIG.DEFAULT;
};
const $bb4fb1cba6fa8636$export$7bff98a3d459b1b8 = (view)=>{
    if (view) {
        const routeConfig = $bb4fb1cba6fa8636$export$62c86c4062215346(view);
        return [
            ...(0, $RX0OA.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
            ...routeConfig.resources
        ];
    }
    return [
        ...(0, $RX0OA.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
        ...$bb4fb1cba6fa8636$var$RAPID_VIEW_ROUTE_CONFIG.DEFAULT.resources
    ];
};
function $bb4fb1cba6fa8636$export$1705c550e5b835bf(routerContext) {
    return routerContext.match?.params.config || routerContext.query?.config || '';
}

});
parcelRegister("RX0OA", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", () => $b233c81a617d544c$export$88e2a0b89be042c1);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", () => $b233c81a617d544c$export$ba075d0985968d1c);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", () => $b233c81a617d544c$export$4f7c4e3508fd2a07);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", () => $b233c81a617d544c$export$3328c8e71fda97bb);
$parcel$export(module.exports, "WRM_RESOURCES_ARRAY", () => $b233c81a617d544c$export$ef21257df3d71188);
$parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", () => $b233c81a617d544c$export$ccd0929652c235de);
$parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", () => $b233c81a617d544c$export$1d16bdcc94a40107);
$parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", () => $b233c81a617d544c$export$1f599d2eef0a7281);
/* eslint-disable jira/filename-case */ const $b233c81a617d544c$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
const $b233c81a617d544c$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
const $b233c81a617d544c$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
const $b233c81a617d544c$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
const $b233c81a617d544c$export$ef21257df3d71188 = [
    '_super',
    'wrc!greenhopper-rapid-non-gadget',
    'wrc!gh-rapid',
    'wrc!jira.global',
    'wrc!jira.general',
    'wrc!atl.global',
    // Required to prevent an error on initial loading of reports
    'wrc!jira.webresources:header',
    // Required for Control Chart report page
    'wrc!jira.webresources:calendar',
    'wrc!jira.webresources:calendar-en',
    'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
    // Required for explicit usage of jQuery
    'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
    // Required for the styles of the toggle button when transitioning from reports to board settings
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
    // Required for the profile card in board settings, that doesn't really render because it has wrong
    // parameters and it has been broken for ages, but at least prevents noisy errors
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
    'wrc!gh-rapid-config',
    'wrc!gh-rapid-analytics',
    'wrc!gh-rapid-charts',
    'wrc!jira.webresources:mentions-feature',
    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
];
const $b233c81a617d544c$export$ccd0929652c235de = [];
const $b233c81a617d544c$export$1d16bdcc94a40107 = [
    'wrc!gh-rapid-lwf-board-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];
const $b233c81a617d544c$export$1f599d2eef0a7281 = [
    'wrc!gh-rapid-backlog-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:header',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];

});



parcelRegister("5adCU", function(module, exports) {
$parcel$export(module.exports, "shouldLoadUIFBoardResources", () => $222c9dc31eea423b$export$d8d4641986a9ac7f);
$parcel$export(module.exports, "getRapidboardResources", () => $222c9dc31eea423b$export$3a5e56bd5231a56b);
$parcel$export(module.exports, "getRapidBoardDataResource", () => $222c9dc31eea423b$export$1c63de7f548f965f);
$parcel$export(module.exports, "getUIFBacklogDataResource", () => $222c9dc31eea423b$export$ee826506b3baa13a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5zPGY = parcelRequire("5zPGY");

var $8HUuJ = parcelRequire("8HUuJ");

var $i860n = parcelRequire("i860n");

var $lWWxm = parcelRequire("lWWxm");

var $lTx7u = parcelRequire("lTx7u");

var $gUW7f = parcelRequire("gUW7f");
const $222c9dc31eea423b$export$d8d4641986a9ac7f = ()=>!false;
const $222c9dc31eea423b$export$462ca08d6ce67848 = ()=>!$222c9dc31eea423b$export$d8d4641986a9ac7f();
const $222c9dc31eea423b$export$3a5e56bd5231a56b = ()=>[
        (0, $gUW7f.wrmBundleResource),
        (0, $8HUuJ.resourceWithCondition)($222c9dc31eea423b$export$462ca08d6ce67848, (0, $lTx7u.rapidboardResource))
    ];
const $222c9dc31eea423b$export$1c63de7f548f965f = ()=>(0, $lWWxm.boardDataResource);
const $222c9dc31eea423b$export$ee826506b3baa13a = ()=>[
        (0, $8HUuJ.resourceWithCondition)(()=>!(0, $i860n.fg)('jira_backlog_use_agg_data') && ($222c9dc31eea423b$export$d8d4641986a9ac7f() || (0, $i860n.fg)('enable_ssr_for_cmp_backlog')), (0, $5zPGY.uifBacklogResource))
    ];

});
parcelRegister("5zPGY", function(module, exports) {
$parcel$export(module.exports, "uifBacklogResource", () => $550d684f0cbd80fe$export$c182dffb98985208);
$parcel$export(module.exports, "backlogCMPViewSettingsResource", () => $550d684f0cbd80fe$export$c55e28f9f40a34b6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* eslint-disable jira/import-whitelist */ 
var $kHZIC = parcelRequire("kHZIC");

var $7edbf = parcelRequire("7edbf");

var $htsFl = parcelRequire("htsFl");

var $hOmct = parcelRequire("hOmct");


const $550d684f0cbd80fe$export$c182dffb98985208 = (0, $7edbf.createResource)({
    type: (0, $905d27e2ee248454$export$9e8bdcc0a845183c),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("hJ3D1")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});
const $550d684f0cbd80fe$var$getQuery = ({ match: match }, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
    const viewId = (0, $hOmct.JiraViewAri).create({
        activationId: activationId,
        siteId: cloudId,
        scopeId: `${Number(match.params.boardId)}/backlog`,
        scopeType: 'board'
    }).toString();
    return {
        options: {
            fetchPolicy: 'network-only'
        },
        parameters: $kHZIC.default,
        variables: {
            input: {
                jiraBacklogViewQueryInput: {
                    viewId: viewId
                }
            }
        }
    };
};
const $550d684f0cbd80fe$export$c55e28f9f40a34b6 = (0, $htsFl.createRelayResource)({
    type: 'BACKLOG_CMP_VIEW_SETTINGS_RESOURCE',
    getQuery: $550d684f0cbd80fe$var$getQuery
});

});
parcelRegister("kHZIC", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a87507dccfaed9e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b686725359e6473097e7aaa93b5bcda>>
 * @relayHash d81b863e337bab456d5583fcb5186c7c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52f63102e665a99d7b9761662b5902255ab4f3a7c4b177db295a3c0d8f178b54
const $4a87507dccfaed9e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "52f63102e665a99d7b9761662b5902255ab4f3a7c4b177db295a3c0d8f178b54",
        "metadata": {},
        "name": "ViewSettingsDataResolverQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4a87507dccfaed9e$export$2e2bcd8739ae039 = $4a87507dccfaed9e$var$node;

});

parcelRegister("hOmct", function(module, exports) {
$parcel$export(module.exports, "JiraViewAri", () => $cf7853b109db3a1d$export$259cce321cdbcc);

var $6yms7 = parcelRequire("6yms7");

var $8FnTo = parcelRequire("8FnTo");

var $aDthf = parcelRequire("aDthf");
// src/jira/view/manifest.ts
var $cf7853b109db3a1d$var$jiraViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $6yms7.JiraViewAriResourceOwner),
    resourceType: (0, $6yms7.JiraViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{scopeType}/{scopeId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        scopeType: /(global|project|board|subcontainer)/,
        scopeId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/view/index.ts
var $cf7853b109db3a1d$export$259cce321cdbcc = class _JiraViewAri extends (0, $8FnTo.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._scopeType = opts.resourceIdSegmentValues.scopeType, this._scopeId = opts.resourceIdSegmentValues.scopeId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get scopeType() {
        return this._scopeType;
    }
    get scopeId() {
        return this._scopeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $cf7853b109db3a1d$var$jiraViewAriStaticOpts.qualifier,
            platformQualifier: $cf7853b109db3a1d$var$jiraViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $cf7853b109db3a1d$var$jiraViewAriStaticOpts.resourceOwner,
            resourceType: $cf7853b109db3a1d$var$jiraViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.scopeType}/${opts.scopeId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                scopeType: opts.scopeType,
                scopeId: opts.scopeId
            }
        }, ariOpts = (0, $aDthf.AriParser).fromOpts(derivedOpts, $cf7853b109db3a1d$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $aDthf.AriParser).fromString(maybeAri, $cf7853b109db3a1d$var$jiraViewAriStaticOpts);
        return new _JiraViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            scopeType: this.scopeType,
            scopeId: this.scopeId
        };
    }
};

});
parcelRegister("6yms7", function(module, exports) {
$parcel$export(module.exports, "JiraViewAriResourceOwner", () => $4c5755a48e69ab9a$export$c63cbf12e88f62b6);
$parcel$export(module.exports, "JiraViewAriResourceType", () => $4c5755a48e69ab9a$export$4b456bf9436bd47e);
// src/jira/view/types.ts
var $4c5755a48e69ab9a$export$c63cbf12e88f62b6 = "jira", $4c5755a48e69ab9a$export$4b456bf9436bd47e = "view";

});


/* eslint-disable jira/filename-case */ const $905d27e2ee248454$export$9e8bdcc0a845183c = 'NEXTGEN_BACKLOG_REST';

parcelRegister("hJ3D1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1fhD9").then(()=>parcelRequire('jVUT1'));

});


parcelRegister("lWWxm", function(module, exports) {
$parcel$export(module.exports, "boardDataResource", () => $5a48fa90b00fc065$export$138fa635416978f7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $RX0OA = parcelRequire("RX0OA");

var $2ch02 = parcelRequire("2ch02");

const $5a48fa90b00fc065$export$138fa635416978f7 = (0, $7edbf.createResource)({
    type: (0, $RX0OA.RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
    getKey: ({ match: match, query: query, route: route })=>{
        const { name: name = '' } = route || {};
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        const { config: config } = query;
        const hasConfig = Boolean(config);
        let key = 'rapidBoardData';
        if ((0, $2ch02.isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
        else if ((0, $2ch02.isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
        return key;
    },
    getDataLoader: ()=>(parcelRequire("d0KZV")),
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("2ch02", function(module, exports) {
$parcel$export(module.exports, "isBoardRoute", () => $856113e2bdd02c3c$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $856113e2bdd02c3c$export$bcb853db5e3e8054);
/* eslint-disable jira/filename-case */ const $856113e2bdd02c3c$export$437d4d6e25681588 = (routeName)=>routeName === 'rapidboard-board' || routeName === 'rapidboard-board-embed' || routeName === 'rapidboard-board-settings' || routeName === 'rapidboard-user-board' || routeName === 'rapidboard-user-board-settings' || routeName === 'servicedesk-boards' || routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-practice-custom-board';
const $856113e2bdd02c3c$export$bcb853db5e3e8054 = (routeName)=>routeName === 'rapidboard-backlog' || routeName === 'rapidboard-user-backlog' || routeName === 'rapidboard-backlog-embed';

});

parcelRegister("d0KZV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("exhQO").then(()=>parcelRequire('4YDvZ'));

});


parcelRegister("lTx7u", function(module, exports) {
$parcel$export(module.exports, "rapidboardResource", () => $6a78f08fbabc4d0d$export$d0f42a55e7c5752c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $RX0OA = parcelRequire("RX0OA");

const $6a78f08fbabc4d0d$export$d0f42a55e7c5752c = (0, $7edbf.createResource)({
    type: (0, $RX0OA.RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
    getKey: ({ match: match })=>match.query.rapidView || '',
    getDataLoader: ()=>(parcelRequire("k0Mx1")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("k0Mx1", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7n8kc").then(()=>parcelRequire('iSNNe'));

});


parcelRegister("gUW7f", function(module, exports) {
$parcel$export(module.exports, "wrmBundleResource", () => $f65c7e4505601184$export$f199d15b7cd18df1);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");

var $RX0OA = parcelRequire("RX0OA");

var $5hHWs = parcelRequire("5hHWs");

const $f65c7e4505601184$export$f199d15b7cd18df1 = (0, $7edbf.createResource)({
    type: (0, $RX0OA.RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
    getKey: ({ route: route })=>(0, $5hHWs.getRapidViewConfigFromRouteName)(route.name).stateKey,
    getDataLoader: ()=>(parcelRequire("eKqgA")),
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("eKqgA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gB0Sj").then(()=>parcelRequire('hC2wB'));

});



parcelRegister("hRSPo", function(module, exports) {
$parcel$export(module.exports, "editModelResource", () => $45f37c70ca8c3966$export$ab9a4786826fd2d);
$parcel$export(module.exports, "getEditModelResource", () => $45f37c70ca8c3966$export$5b9bac2cc4bf4511);
// eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $4fhEY = parcelRequire("4fhEY");

var $7edbf = parcelRequire("7edbf");

var $5hHWs = parcelRequire("5hHWs");
const $45f37c70ca8c3966$export$ddbb511f9111736a = async (boardId)=>{
    try {
        return await (0, $4fhEY.default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getEditModelRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $45f37c70ca8c3966$export$ab9a4786826fd2d = (0, $7edbf.createResource)({
    type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
    getKey: (routerContext)=>(0, $5hHWs.getConfigFromRouterContext)(routerContext) ? 'edit-model' : 'not-edit-model',
    getData: async (routerContext)=>{
        if ((0, $5hHWs.getConfigFromRouterContext)(routerContext)) {
            const boardId = routerContext.match.params?.boardId ?? '';
            return $45f37c70ca8c3966$export$ddbb511f9111736a(boardId);
        }
        return null;
    }
});
const $45f37c70ca8c3966$export$5b9bac2cc4bf4511 = ()=>$45f37c70ca8c3966$export$ab9a4786826fd2d;

});

parcelRegister("cDLVA", function(module, exports) {
$parcel$export(module.exports, "getCalendarFilterFieldsResource", () => $75e9ce1b7278a590$export$5f02bf5f04197ed7);
$parcel$export(module.exports, "useCalendarFilterResource", () => $75e9ce1b7278a590$export$70361b748d216408);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $i0CFV = parcelRequire("i0CFV");

var $lCetP = parcelRequire("lCetP");

var $h2wCv = parcelRequire("h2wCv");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $i860n = parcelRequire("i860n");

var $gZTDI = parcelRequire("gZTDI");


var $7EAfq = parcelRequire("7EAfq");
const $75e9ce1b7278a590$var$fetchFilterFields = async (cloudId)=>{
    try {
        const requestTypeFieldResponse = await (0, $h2wCv.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $408078b2e2b06241$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        const requestTypeField = requestTypeFieldResponse.data?.jira?.requestTypeField;
        if (!requestTypeField) return 0, $gZTDI.DEFAULT_CALENDAR_FILTER_FIELDS;
        return [
            {
                ...requestTypeField,
                searchTemplate: requestTypeField.searchTemplate.key,
                fieldType: requestTypeField.type
            },
            ...(0, $gZTDI.DEFAULT_CALENDAR_FILTER_FIELDS)
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $lCetP.isHttpClientErrorResponse)(error)) (0, $7EAfq.reportError)(error);
        return 0, $gZTDI.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $75e9ce1b7278a590$var$filterFieldsResource = (0, $7edbf.createResource)({
    type: (0, $gZTDI.RESOURCE_TYPE_FILTER_FIELD),
    getKey: ({ match: match, query: query })=>{
        if ((0, $i860n.fg)('jsm_views_inside_queues_-_main_flag')) {
            const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            return (0, $gZTDI.RESOURCE_TYPE_FILTER_FIELD) + projectIdOrKey;
        }
        return 0, $gZTDI.RESOURCE_TYPE_FILTER_FIELD;
    },
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$75e9ce1b7278a590$var$fetchFilterFields(cloudId),
    maxAge: Infinity
});
const $75e9ce1b7278a590$export$5f02bf5f04197ed7 = ()=>$75e9ce1b7278a590$var$filterFieldsResource;
const $75e9ce1b7278a590$export$70361b748d216408 = ({ isSimplified: isSimplified })=>{
    const resource = (0, $k6ufm.useResource)($75e9ce1b7278a590$var$filterFieldsResource);
    (0, $euxye.useEffect)(()=>{
        if (!isSimplified && !resource.loading && !resource.error && !resource.data?.find((field)=>typeof field === 'object' && Object.values(field).includes((0, $7EAfq.TARGET_FILTER_TYPE)))) (0, $7EAfq.reportError)(new Error('Unable to prefetch request type'));
    }, [
        isSimplified,
        resource.data,
        resource.error,
        resource.loading
    ]);
    return resource;
};

});
parcelRegister("gZTDI", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_NAME", () => $ae29b70ba5b511f0$export$186e93e8ef3f9358);
$parcel$export(module.exports, "PACKAGE_NAME", () => $ae29b70ba5b511f0$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $ae29b70ba5b511f0$export$d57b6b390e78d90f);
$parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", () => $ae29b70ba5b511f0$export$2019de80301f1da);
$parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", () => $ae29b70ba5b511f0$export$2912f30d4328fc00);
/* eslint-disable jira/filename-case */ const $ae29b70ba5b511f0$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
const $ae29b70ba5b511f0$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
const $ae29b70ba5b511f0$export$d57b6b390e78d90f = 'jsd-shield';
const $ae29b70ba5b511f0$export$2c388650eabddf5e = 'request type';
const $ae29b70ba5b511f0$export$2fcf90614ee15858 = 'service desk origin';
const $ae29b70ba5b511f0$export$43482ff574598f59 = 'cf[10010]';
const $ae29b70ba5b511f0$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
const $ae29b70ba5b511f0$export$2912f30d4328fc00 = [
    'status',
    'assignee'
];

});

/* eslint-disable jira/filename-case */ const $408078b2e2b06241$export$2b91517d6d5b4365 = `
query requestTypeFieldQuery($cloudId: ID!) {
  jira {
    requestTypeField(cloudId: $cloudId) {
      displayName
      jqlTerm
      operators
      searchTemplate {
        key
      }
      type
    }
  }
}
`;

parcelRegister("7EAfq", function(module, exports) {
$parcel$export(module.exports, "TARGET_FILTER_TYPE", () => $a3e2de59b921b526$export$64f54b13b7aea793);
$parcel$export(module.exports, "reportError", () => $a3e2de59b921b526$export$b33b857ad1d9900e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $gZTDI = parcelRequire("gZTDI");
const $a3e2de59b921b526$export$64f54b13b7aea793 = 'com.atlassian.servicedesk:vp-origin';
const $a3e2de59b921b526$export$b33b857ad1d9900e = (error)=>{
    (0, $hFtK7.fireErrorAnalytics)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: (0, $gZTDI.RESOURCE_TYPE_NAME),
            packageName: (0, $gZTDI.PACKAGE_NAME),
            teamName: (0, $gZTDI.TEAM_NAME)
        }
    });
};

});


parcelRegister("koA6h", function(module, exports) {
$parcel$export(module.exports, "serviceDeskAnalyticsContextResource", () => $8c7bb5af7a76d850$export$d6f4f0483916919f);
$parcel$export(module.exports, "useServiceDeskAnalyticsContext", () => $8c7bb5af7a76d850$export$bc2de1c42df30b10);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $fLTsc = parcelRequire("fLTsc");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $8c7bb5af7a76d850$var$RESOURCE_TYPE_SERVICEDESK_ANALYTICS_CONTEXT = 'SERVICEDESK_ANALYTICS_CONTEXT';
const $8c7bb5af7a76d850$var$ONE_DAY_IN_MILLIS = 86400000;

const $8c7bb5af7a76d850$export$d6f4f0483916919f = (0, $7edbf.createResource)({
    type: $8c7bb5af7a76d850$var$RESOURCE_TYPE_SERVICEDESK_ANALYTICS_CONTEXT,
    getKey: ({ match: match })=>(0, $fLTsc.getProjectKeyOrId)(match),
    getDataLoader: ()=>(parcelRequire("herA5")),
    maxAge: $8c7bb5af7a76d850$var$ONE_DAY_IN_MILLIS
});
const $8c7bb5af7a76d850$export$bc2de1c42df30b10 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $k6ufm.useResource)($8c7bb5af7a76d850$export$d6f4f0483916919f);
    (0, $euxye.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $euxye.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("herA5", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jLvTw").then(()=>parcelRequire('dScyL'));

});


parcelRegister("iyqMX", function(module, exports) {
$parcel$export(module.exports, "serviceDeskContextResource", () => $635b5a7dad57b894$export$5eaaf465969a9171);

var $fLTsc = parcelRequire("fLTsc");

var $7edbf = parcelRequire("7edbf");


const $635b5a7dad57b894$export$5eaaf465969a9171 = (0, $7edbf.createResource)({
    type: (0, $6fa60b97ba7ac716$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $fLTsc.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: ()=>(parcelRequire("hFe6F")),
    maxAge: Infinity
});

});
/* eslint-disable jira/filename-case */ const $6fa60b97ba7ac716$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("hFe6F", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("63yvi").then(()=>parcelRequire('jeR8Z'));

});


parcelRegister("ble5H", function(module, exports) {
$parcel$export(module.exports, "servicedeskIsItsmProjectResource", () => $20cf5a8b9c0403fa$export$920308cef4e291b1);
$parcel$export(module.exports, "useIsItsmTemplateProject", () => $20cf5a8b9c0403fa$export$7bb46948fb84f164);

var $euxye = parcelRequire("euxye");

var $fLTsc = parcelRequire("fLTsc");

var $d7dm3 = parcelRequire("d7dm3");

var $7edbf = parcelRequire("7edbf");
const $20cf5a8b9c0403fa$var$RESOURCE_TYPE_SERVICEDESK_IS_ITSM_PROJECT = 'SERVICEDESK_IS_ITSM_PROJECT';
const $20cf5a8b9c0403fa$var$ONE_DAY_IN_MILLIS = 86400000;

const $20cf5a8b9c0403fa$export$920308cef4e291b1 = (0, $7edbf.createResource)({
    type: $20cf5a8b9c0403fa$var$RESOURCE_TYPE_SERVICEDESK_IS_ITSM_PROJECT,
    getKey: ({ match: match })=>(0, $fLTsc.getProjectKeyOrId)(match),
    getDataLoader: ()=>(parcelRequire("7Zw1N")),
    maxAge: $20cf5a8b9c0403fa$var$ONE_DAY_IN_MILLIS
});
const $20cf5a8b9c0403fa$export$7bb46948fb84f164 = (projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $d7dm3.useResourceWithCustomRouterContext)($20cf5a8b9c0403fa$export$920308cef4e291b1, projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined, {
        shouldPrefetch: true
    });
    return (0, $euxye.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
parcelRegister("7Zw1N", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3q3gW").then(()=>parcelRequire('htsLT'));

});


parcelRegister("j0qHc", function(module, exports) {
$parcel$export(module.exports, "servicedeskPracticesResource", () => $9633aed328faaa05$export$2ae319305481e7de);
$parcel$export(module.exports, "useWorkCategoriesQueueSupported", () => $9633aed328faaa05$export$a86ac771006f14b3);
$parcel$export(module.exports, "useWorkCategoriesAllSupported", () => $9633aed328faaa05$export$fe081b1a59d3c818);
$parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", () => $9633aed328faaa05$export$4d46346ef0bdc6b9);

var $euxye = parcelRequire("euxye");

var $fLTsc = parcelRequire("fLTsc");

var $fqOOj = parcelRequire("fqOOj");

var $i860n = parcelRequire("i860n");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");
const $9633aed328faaa05$var$RESOURCE_TYPE_SERVICEDESK_PRACTICES = 'SERVICEDESK_PRACTICES';
const $9633aed328faaa05$var$ONE_DAY_IN_MILLIS = 86400000;

const $9633aed328faaa05$export$2ae319305481e7de = (0, $7edbf.createResource)({
    type: $9633aed328faaa05$var$RESOURCE_TYPE_SERVICEDESK_PRACTICES,
    getKey: ({ match: match })=>(0, $fLTsc.getProjectKeyOrId)(match),
    getDataLoader: ()=>(parcelRequire("9nTzD")),
    maxAge: $9633aed328faaa05$var$ONE_DAY_IN_MILLIS
});
const $9633aed328faaa05$var$getQueuesOrder = ()=>{
    return (0, $i860n.fg)('jsm-case-management') ? (0, $fqOOj.WORK_CATEGORIES_QUEUE_SUPPORTED) : (0, $fqOOj.WORK_CATEGORIES_QUEUE_SUPPORTED).filter((p)=>p !== (0, $fqOOj.CASES));
};
const $9633aed328faaa05$var$getWorkCategoryOrder = ()=>[
        ...$9633aed328faaa05$var$getQueuesOrder(),
        (0, $fqOOj.DEVELOPER_ESCALATION)
    ];
const $9633aed328faaa05$var$transformItsmPracticesList = (data)=>{
    if (!data?.practices) return null;
    const queuesOrder = $9633aed328faaa05$var$getQueuesOrder();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9633aed328faaa05$var$transformServiceDeskPracticesList = (data)=>{
    if (!data?.practices) return null;
    const workCategoryOrder = $9633aed328faaa05$var$getWorkCategoryOrder();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $9633aed328faaa05$export$a86ac771006f14b3 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $k6ufm.useResource)($9633aed328faaa05$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $euxye.useMemo)(()=>({
            data: $9633aed328faaa05$var$transformItsmPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9633aed328faaa05$export$fe081b1a59d3c818 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $k6ufm.useResource)($9633aed328faaa05$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $euxye.useMemo)(()=>({
            data: $9633aed328faaa05$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $9633aed328faaa05$export$4d46346ef0bdc6b9 = ()=>{
    const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $k6ufm.useResource)($9633aed328faaa05$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    (0, $euxye.useEffect)(()=>{
        if (!loading && !data && !error) refreshPractices();
    }, [
        data,
        error,
        loading,
        refreshPractices
    ]);
    return (0, $euxye.useMemo)(()=>({
            data: $9633aed328faaa05$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};

});
parcelRegister("fqOOj", function(module, exports) {
$parcel$export(module.exports, "CHANGES", () => $67682c415f41e977$export$8598196f74460271);
$parcel$export(module.exports, "INCIDENTS", () => $67682c415f41e977$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "PROBLEMS", () => $67682c415f41e977$export$ceba70db1edb1def);
$parcel$export(module.exports, "SERVICE_REQUEST", () => $67682c415f41e977$export$3d1cda9bd50505e8);
$parcel$export(module.exports, "POST_INCIDENT_REVIEWS", () => $67682c415f41e977$export$6ebf7b6bf1c580f);
$parcel$export(module.exports, "DEVELOPER_ESCALATION", () => $67682c415f41e977$export$81e62964cc725098);
$parcel$export(module.exports, "CASES", () => $67682c415f41e977$export$ddbef7dfaa374d2d);
$parcel$export(module.exports, "NO_CATEGORY", () => $67682c415f41e977$export$485b1216c42d8d4);
$parcel$export(module.exports, "NO_PRACTICE", () => $67682c415f41e977$export$52bf3f16b7812704);
$parcel$export(module.exports, "SHORT_FORM_CHANGES", () => $67682c415f41e977$export$a50185c8e9fb007e);
$parcel$export(module.exports, "SHORT_FORM_INCIDENTS", () => $67682c415f41e977$export$a54a30a3c3cce634);
$parcel$export(module.exports, "SHORT_FORM_PROBLEMS", () => $67682c415f41e977$export$354f3a4c6ac0c903);
$parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", () => $67682c415f41e977$export$335d3ac0c367f03f);
$parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", () => $67682c415f41e977$export$7ffd7f2c2ae96b6f);
$parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", () => $67682c415f41e977$export$cb41b99ca54e6bd);
$parcel$export(module.exports, "SHORT_FORM_CASES", () => $67682c415f41e977$export$2863e7d432d9b3f5);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED", () => $67682c415f41e977$export$a2b1f8f055150f02);
$parcel$export(module.exports, "ItsmPracticeToShortForm", () => $67682c415f41e977$export$56c57f7ad650c45c);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP", () => $67682c415f41e977$export$fbf0dfd01228e38d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", () => $67682c415f41e977$export$45ba5f49e9509c4d);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS", () => $67682c415f41e977$export$45952424a7f29b99);
$parcel$export(module.exports, "CHANGES_JQL_NAME", () => $67682c415f41e977$export$6c24c440228eac9c);
$parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", () => $67682c415f41e977$export$3f757c5e00588ffd);
$parcel$export(module.exports, "practiceKeyJqlNameMapping", () => $67682c415f41e977$export$b78213db77524b5b);
/* eslint-disable jira/filename-case */ 
var $7eNDO = parcelRequire("7eNDO");

var $8ENSY = parcelRequire("8ENSY");
const $67682c415f41e977$var$queues = (0, $7eNDO.defineMessage)({
    id: "work-category.common.queues",
    defaultMessage: "Queues"
});
const $67682c415f41e977$var$serviceRequests = (0, $7eNDO.defineMessage)({
    id: "work-category.common.service-requests",
    defaultMessage: "Service requests"
});
const $67682c415f41e977$var$incidents = (0, $7eNDO.defineMessage)({
    id: "work-category.common.incidents",
    defaultMessage: "Incidents"
});
const $67682c415f41e977$var$changes = (0, $7eNDO.defineMessage)({
    id: "work-category.common.changes",
    defaultMessage: "Changes"
});
const $67682c415f41e977$var$problems = (0, $7eNDO.defineMessage)({
    id: "work-category.common.problems",
    defaultMessage: "Problems"
});
const $67682c415f41e977$var$postIncidentReviews = (0, $7eNDO.defineMessage)({
    id: "work-category.common.post-incident-reviews",
    defaultMessage: "Post-incident reviews"
});
const $67682c415f41e977$var$developerEscalation = (0, $7eNDO.defineMessage)({
    id: "work-category.common.developer-escalation",
    defaultMessage: "Developer escalations"
});
const $67682c415f41e977$var$cases = (0, $7eNDO.defineMessage)({
    id: "work-category.common.cases",
    defaultMessage: "Cases"
});
const $67682c415f41e977$var$noCategory = (0, $7eNDO.defineMessage)({
    id: "work-category.common.no-category",
    defaultMessage: "General"
});
const $67682c415f41e977$var$queuesLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.queues-lower",
    defaultMessage: "queues"
});
const $67682c415f41e977$var$serviceRequestsLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.service-requests-lower",
    defaultMessage: "service requests"
});
const $67682c415f41e977$var$incidentsLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.incidents-lower",
    defaultMessage: "incidents"
});
const $67682c415f41e977$var$changesLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.changes-lower",
    defaultMessage: "changes"
});
const $67682c415f41e977$var$problemsLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.problems-lower",
    defaultMessage: "problems"
});
const $67682c415f41e977$var$postIncidentReviewsLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.post-incident-reviews-lower",
    defaultMessage: "post-incident reviews"
});
const $67682c415f41e977$var$noCategoryLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.no-category-lower",
    defaultMessage: "general"
});
const $67682c415f41e977$var$developerEscalationLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.developer-escalation-lower",
    defaultMessage: "developer escalations"
});
const $67682c415f41e977$var$casesLower = (0, $7eNDO.defineMessage)({
    id: "work-category.common.cases-lower",
    defaultMessage: "cases"
});
const $67682c415f41e977$export$8598196f74460271 = 'change-management';
const $67682c415f41e977$export$a50b49a533b5f7bc = 'incident-management';
const $67682c415f41e977$export$ceba70db1edb1def = 'problem-management';
const $67682c415f41e977$export$3d1cda9bd50505e8 = 'service-request';
const $67682c415f41e977$export$6ebf7b6bf1c580f = 'post-incident-review';
const $67682c415f41e977$export$81e62964cc725098 = 'developer-escalation';
const $67682c415f41e977$export$ddbef7dfaa374d2d = 'case-management';
const $67682c415f41e977$export$485b1216c42d8d4 = 'no-category';
const $67682c415f41e977$var$NO_CATEGORY_NEW = 'no-category-new';
const $67682c415f41e977$export$52bf3f16b7812704 = 'no-practice'; // BERRY-1358 should consolidate into NO_CATEGORY
const $67682c415f41e977$export$a50185c8e9fb007e = 'changes';
const $67682c415f41e977$export$a54a30a3c3cce634 = 'incidents';
const $67682c415f41e977$export$354f3a4c6ac0c903 = 'problems';
const $67682c415f41e977$export$335d3ac0c367f03f = 'service-requests';
const $67682c415f41e977$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
const $67682c415f41e977$export$cb41b99ca54e6bd = 'developer-escalations';
const $67682c415f41e977$export$2863e7d432d9b3f5 = 'cases';
const $67682c415f41e977$export$a613d808168c7b25 = [
    $67682c415f41e977$export$8598196f74460271,
    $67682c415f41e977$export$a50b49a533b5f7bc,
    $67682c415f41e977$export$ceba70db1edb1def,
    $67682c415f41e977$export$3d1cda9bd50505e8,
    $67682c415f41e977$export$6ebf7b6bf1c580f,
    $67682c415f41e977$export$81e62964cc725098,
    $67682c415f41e977$export$ddbef7dfaa374d2d
]; // /!\ defines WorkCategoryApiResource type
const $67682c415f41e977$export$a2b1f8f055150f02 = [
    $67682c415f41e977$export$3d1cda9bd50505e8,
    $67682c415f41e977$export$a50b49a533b5f7bc,
    $67682c415f41e977$export$ceba70db1edb1def,
    $67682c415f41e977$export$8598196f74460271,
    $67682c415f41e977$export$6ebf7b6bf1c580f,
    $67682c415f41e977$export$ddbef7dfaa374d2d
]; // /!\ defines WorkCategoryQueueSupported type
const $67682c415f41e977$export$5a9122a4028fb8ef = [
    ...$67682c415f41e977$export$a2b1f8f055150f02,
    $67682c415f41e977$export$485b1216c42d8d4
];
const $67682c415f41e977$export$f1b813cd23817ade = [
    $67682c415f41e977$export$a50185c8e9fb007e,
    $67682c415f41e977$export$a54a30a3c3cce634,
    $67682c415f41e977$export$354f3a4c6ac0c903,
    $67682c415f41e977$export$335d3ac0c367f03f,
    $67682c415f41e977$export$7ffd7f2c2ae96b6f,
    $67682c415f41e977$export$cb41b99ca54e6bd,
    $67682c415f41e977$export$2863e7d432d9b3f5
]; // /!\ defines WorkCategoryShortForm type
const $67682c415f41e977$export$56c57f7ad650c45c = {
    [$67682c415f41e977$export$8598196f74460271]: $67682c415f41e977$export$a50185c8e9fb007e,
    [$67682c415f41e977$export$a50b49a533b5f7bc]: $67682c415f41e977$export$a54a30a3c3cce634,
    [$67682c415f41e977$export$ceba70db1edb1def]: $67682c415f41e977$export$354f3a4c6ac0c903,
    [$67682c415f41e977$export$3d1cda9bd50505e8]: $67682c415f41e977$export$335d3ac0c367f03f,
    [$67682c415f41e977$export$6ebf7b6bf1c580f]: $67682c415f41e977$export$7ffd7f2c2ae96b6f,
    [$67682c415f41e977$export$ddbef7dfaa374d2d]: $67682c415f41e977$export$2863e7d432d9b3f5,
    [$67682c415f41e977$export$485b1216c42d8d4]: $67682c415f41e977$var$NO_CATEGORY_NEW
};
const $67682c415f41e977$export$fbf0dfd01228e38d = {
    [$67682c415f41e977$export$8598196f74460271]: $67682c415f41e977$var$changes,
    [$67682c415f41e977$export$3d1cda9bd50505e8]: $67682c415f41e977$var$serviceRequests,
    [$67682c415f41e977$export$ceba70db1edb1def]: $67682c415f41e977$var$problems,
    [$67682c415f41e977$export$a50b49a533b5f7bc]: $67682c415f41e977$var$incidents,
    [$67682c415f41e977$export$6ebf7b6bf1c580f]: $67682c415f41e977$var$postIncidentReviews,
    [$67682c415f41e977$export$485b1216c42d8d4]: $67682c415f41e977$var$queues,
    [$67682c415f41e977$export$81e62964cc725098]: $67682c415f41e977$var$developerEscalation,
    [$67682c415f41e977$export$ddbef7dfaa374d2d]: $67682c415f41e977$var$cases,
    [$67682c415f41e977$export$52bf3f16b7812704]: $67682c415f41e977$var$noCategory
};
const $67682c415f41e977$export$45ba5f49e9509c4d = {
    [$67682c415f41e977$export$8598196f74460271]: $67682c415f41e977$var$changesLower,
    [$67682c415f41e977$export$3d1cda9bd50505e8]: $67682c415f41e977$var$serviceRequestsLower,
    [$67682c415f41e977$export$ceba70db1edb1def]: $67682c415f41e977$var$problemsLower,
    [$67682c415f41e977$export$a50b49a533b5f7bc]: $67682c415f41e977$var$incidentsLower,
    [$67682c415f41e977$export$6ebf7b6bf1c580f]: $67682c415f41e977$var$postIncidentReviewsLower,
    [$67682c415f41e977$export$485b1216c42d8d4]: $67682c415f41e977$var$queuesLower,
    [$67682c415f41e977$export$81e62964cc725098]: $67682c415f41e977$var$developerEscalationLower,
    [$67682c415f41e977$export$ddbef7dfaa374d2d]: $67682c415f41e977$var$casesLower,
    [$67682c415f41e977$export$52bf3f16b7812704]: $67682c415f41e977$var$noCategoryLower
};
const $67682c415f41e977$export$45952424a7f29b99 = (0, $8ENSY.getTypedKeys)($67682c415f41e977$export$fbf0dfd01228e38d).reduce((acc, labelMapKey)=>{
    // cannot type .indexOf() as not-string in Ts, therefore need to use .find(). And shows error if `key` in acc[key] being of wider type than the result (than ItsmPracticeCategory), therefore, need to use different keys in the `acc[queueKey] =` line
    const queueKey = $67682c415f41e977$export$a2b1f8f055150f02.find((key)=>key === labelMapKey);
    if (queueKey) acc[queueKey] = $67682c415f41e977$export$fbf0dfd01228e38d[labelMapKey];
    return acc;
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
}, {});
const $67682c415f41e977$export$6c24c440228eac9c = 'Changes';
const $67682c415f41e977$export$5b65d27ec2d28d18 = 'Incidents';
const $67682c415f41e977$var$PROBLEMS_JQL_NAME = 'Problems';
const $67682c415f41e977$var$SERVICE_REQUEST_JQL_NAME = 'Service requests';
const $67682c415f41e977$var$POST_INCIDENT_REVIEWS_JQL_NAME = 'Post-incident reviews';
const $67682c415f41e977$export$3f757c5e00588ffd = 'Developer escalation';
const $67682c415f41e977$export$66e62df67c842469 = 'Cases';
const $67682c415f41e977$export$b78213db77524b5b = {
    [$67682c415f41e977$export$8598196f74460271]: $67682c415f41e977$export$6c24c440228eac9c,
    [$67682c415f41e977$export$a50b49a533b5f7bc]: $67682c415f41e977$export$5b65d27ec2d28d18,
    [$67682c415f41e977$export$ceba70db1edb1def]: $67682c415f41e977$var$PROBLEMS_JQL_NAME,
    [$67682c415f41e977$export$3d1cda9bd50505e8]: $67682c415f41e977$var$SERVICE_REQUEST_JQL_NAME,
    [$67682c415f41e977$export$6ebf7b6bf1c580f]: $67682c415f41e977$var$POST_INCIDENT_REVIEWS_JQL_NAME,
    [$67682c415f41e977$export$81e62964cc725098]: $67682c415f41e977$export$3f757c5e00588ffd,
    [$67682c415f41e977$export$ddbef7dfaa374d2d]: $67682c415f41e977$export$66e62df67c842469
};

});
parcelRegister("8ENSY", function(module, exports) {
$parcel$export(module.exports, "hasProp", () => $7d9fa4bc3da3da6f$export$dd642ef726dcde21);
$parcel$export(module.exports, "getTypedKeys", () => $7d9fa4bc3da3da6f$export$5206d47972fefe20);
/* eslint-disable jira/filename-case */ /**
 * Use to remove `TS2339: Property 'id' does not exist on type 'object'` errors, e.g. when checking/refining variable of `unknown' type
 */ const $7d9fa4bc3da3da6f$export$dd642ef726dcde21 = (data, prop)=>prop in data;
const $7d9fa4bc3da3da6f$export$5206d47972fefe20 = (obj)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(obj);
};

});


parcelRegister("9nTzD", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("3Zizf").then(()=>parcelRequire('bGyEV'));

});


parcelRegister("dkOZx", function(module, exports) {
$parcel$export(module.exports, "requiredProjectProperties", () => $d62e2c1b9979d4b2$export$fbeae45a65f4a5a6);
$parcel$export(module.exports, "requiredFrontendProperties", () => $d62e2c1b9979d4b2$export$47241956725e3029);
$parcel$export(module.exports, "firstProjectResource", () => $d62e2c1b9979d4b2$export$f620cebb7e8eeeae);
$parcel$export(module.exports, "isSimplifiedNavResource", () => $d62e2c1b9979d4b2$export$dd8a962d5821a6f0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cY22M = parcelRequire("cY22M");

var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");
const $d62e2c1b9979d4b2$var$getKey = ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
    (0, $i0CFV.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(match, 'params.issueKey', '').split('-')[0];

const $d62e2c1b9979d4b2$export$fbeae45a65f4a5a6 = (0, $7edbf.createResource)({
    type: 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES',
    getKey: $d62e2c1b9979d4b2$var$getKey,
    getDataLoader: ()=>(parcelRequire("hj5lJ")),
    maxAge: 300000
});
const $d62e2c1b9979d4b2$var$ONE_DAY_IN_MILLIS = 86400000;

const $d62e2c1b9979d4b2$export$47241956725e3029 = (0, $7edbf.createResource)({
    type: 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES',
    getKey: $d62e2c1b9979d4b2$var$getKey,
    getDataLoader: ()=>(parcelRequire("i9gyI")),
    maxAge: $d62e2c1b9979d4b2$var$ONE_DAY_IN_MILLIS
});
const $d62e2c1b9979d4b2$var$TWELVE_HOURS_IN_MILLIS = 43200000;

const $d62e2c1b9979d4b2$export$f620cebb7e8eeeae = (0, $7edbf.createResource)({
    type: 'JSM_FIRST_PROJECT_RESOURCE',
    // first project is the same for the tenantId (there is also no per-project arg in request url). Therefore, only 1 key value is used.
    getKey: ()=>'none',
    getDataLoader: ()=>(parcelRequire("gxQNy")),
    maxAge: $d62e2c1b9979d4b2$var$TWELVE_HOURS_IN_MILLIS
});
const $d62e2c1b9979d4b2$var$TWENTY_FOUR_HOURS_IN_MILLIS = 86400000;
const $d62e2c1b9979d4b2$var$SIMPLIFIED_NAV_PROPERTY_KEY = 'jsm.isSimplifiedNav';

const $d62e2c1b9979d4b2$export$dd8a962d5821a6f0 = (0, $7edbf.createResource)({
    type: 'JSM_IS_SIMPLIFIED_NAV_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $i0CFV.getProjectKeyId)(match, query);
        return `${projectKey}___${$d62e2c1b9979d4b2$var$SIMPLIFIED_NAV_PROPERTY_KEY}`;
    },
    getDataLoader: ()=>(parcelRequire("8APw8")),
    maxAge: $d62e2c1b9979d4b2$var$TWENTY_FOUR_HOURS_IN_MILLIS
});

});
parcelRegister("hj5lJ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("i9ARW").then(()=>parcelRequire('dXxfd'));

});

parcelRegister("i9gyI", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("jn9xT").then(()=>parcelRequire('5WcYM'));

});

parcelRegister("gxQNy", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("1jSQ2").then(()=>parcelRequire('68WxG'));

});

parcelRegister("8APw8", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9yjJE").then(()=>parcelRequire('joVKB'));

});


parcelRegister("cpnl1", function(module, exports) {
$parcel$export(module.exports, "queuesNavigationItems", () => $4376fb9968d89e9c$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $4376fb9968d89e9c$export$1f9ab301771fe42e);
$parcel$export(module.exports, "priorityGroupByProjectIdResourceSsr", () => $4376fb9968d89e9c$export$b55fde45b61f13f4);
$parcel$export(module.exports, "priorityGroupCrossProjectResource", () => $4376fb9968d89e9c$export$ce17a222de842d7c);
$parcel$export(module.exports, "issueListSsrResource", () => $4376fb9968d89e9c$export$3d03cbaac8581e65);
$parcel$export(module.exports, "queueNav4SidebarSelectionResource", () => $4376fb9968d89e9c$export$dead630ba04fdfe4);
$parcel$export(module.exports, "queueSidebarQueuesCategoryStateResource", () => $4376fb9968d89e9c$export$9e9033d678058efa);
$parcel$export(module.exports, "triageButtonPermissionResource", () => $4376fb9968d89e9c$export$11d6dc3c9b9c69ec);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cY22M = parcelRequire("cY22M");

var $hFtK7 = parcelRequire("hFtK7");

var $i0CFV = parcelRequire("i0CFV");

var $kM0go = parcelRequire("kM0go");

var $7edbf = parcelRequire("7edbf");

var $5PVNo = parcelRequire("5PVNo");

var $e6DgO = parcelRequire("e6DgO");

var $cqRR9 = parcelRequire("cqRR9");
const $4376fb9968d89e9c$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $i0CFV.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(match, 'params.queueId', '')}`;
const $4376fb9968d89e9c$var$getResourceKeyFromProjectKey = ({ match: match, query: query })=>`${(0, $i0CFV.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(match, 'params.issueKey', '').split('-')[0]}`;

const $4376fb9968d89e9c$export$4fed8be571897bef = (0, $7edbf.createResource)({
    type: (0, $5PVNo.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getDataLoader: ()=>(parcelRequire("1BkmR")),
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS)
});

const $4376fb9968d89e9c$export$1f9ab301771fe42e = (0, $7edbf.createResource)({
    type: (0, $5PVNo.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getDataLoader: ()=>(parcelRequire("8CQWr")),
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS),
    /**
		 * This resource will not load in SSR. Because priority group data resides in the JSM Kukama microservice.
		 * If we wanna fetch this resource during SSR, the request we're making from Tesseract -> Kukama is S2S, where Tesseract needs to know cookies information.
		 * We initially skipped SSR for fetching this resource, because we couldn’t retrieve the request cookie from JFE.
		 * Iiuc, the Jira team doesnt doesnt support this due to security concerns (the info is from JSM Queues team).
		 */ isBrowserOnly: true
});
const $4376fb9968d89e9c$var$priorityGroupByProjectIdResourcePayload = {
    type: (0, $5PVNo.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query })=>{
        (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdStart',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        const { projectKey: projectKey } = (0, $i0CFV.getProjectKeyId)(match, query);
        if (!projectKey) (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectKey',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return (0, $e6DgO.getPriorityGroupDataByProjectId)(undefined, projectKey);
    },
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS)
};
const $4376fb9968d89e9c$export$b55fde45b61f13f4 = (0, $7edbf.createResource)($4376fb9968d89e9c$var$priorityGroupByProjectIdResourcePayload);
const $4376fb9968d89e9c$export$ce17a222de842d7c = (0, $7edbf.createResource)({
    type: (0, $5PVNo.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query })=>{
        const projectKey = (0, $i0CFV.getProjectKeyId)(match, query).projectKey;
        try {
            const projectId = match.params.projectId ? +match.params.projectId : undefined;
            return (0, $e6DgO.getPriorityGroupDataByProjectId)(projectId, projectKey);
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'priorityGroupCrossProjectNoProjectId',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $e6DgO.getPriorityGroupDataByProjectId)(undefined, projectKey);
        }
    },
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS),
    isBrowserOnly: true
});


const $4376fb9968d89e9c$export$3d03cbaac8581e65 = (0, $7edbf.createResource)({
    type: (0, $5PVNo.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $4376fb9968d89e9c$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: ()=>Promise.resolve((parcelRequire("2QxLf"))),
    // getData below is deliberately set up to load in a sync'd way only in SSR in hope it will execute faster without any delays
    // In CSR we use async data loader above, to not increase jira-spa bundle size for every route
    // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
    getData: false ? (parcelRequire("2QxLf")).default : null,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});
const $4376fb9968d89e9c$export$5b6f88b653545aa1 = (0, $7edbf.createResource)({
    type: (0, $5PVNo.SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        const projectKey = $4376fb9968d89e9c$var$getResourceKeyFromProjectKey({
            match: match,
            query: query
        });
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $kM0go.getUserProperty)(atlassianAccountId, `jsm-all-queues-state_is-open-${projectKey}`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'fetchJsmQueueSidebarViewAllQueuesResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS)
});
const $4376fb9968d89e9c$export$dead630ba04fdfe4 = (0, $7edbf.createResource)({
    type: (0, $5PVNo.SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $kM0go.getUserProperty)(atlassianAccountId, (0, $5PVNo.LOCAL_STORAGE_KEY_NAV_LOCATION));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'fetchQueueNav4SidebarSelectionResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS)
});
const $4376fb9968d89e9c$export$9e9033d678058efa = (0, $7edbf.createResource)({
    type: (0, $5PVNo.SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY),
    getKey: $4376fb9968d89e9c$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $kM0go.getUserProperty)(atlassianAccountId, (0, $5PVNo.LOCAL_STORAGE_KEY_CATEGORY));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'fetchJsmQueueSidebarQueuesCategoryStateResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS)
});
const $4376fb9968d89e9c$export$11d6dc3c9b9c69ec = (0, $7edbf.createResource)({
    type: (0, $cqRR9.RESOURCE_TYPE_TRIAGE_BUTTON_PERMISSION),
    getKey: ()=>(0, $cqRR9.RESOURCE_TYPE_TRIAGE_BUTTON_PERMISSION),
    getData: async ()=>{
        return (0, $cqRR9.getTriageButtonPermission)();
    },
    maxAge: (0, $5PVNo.ONE_HOUR_IN_MILLIS)
});

});
parcelRegister("5PVNo", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $d73d2906133d5d50$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $d73d2906133d5d50$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $d73d2906133d5d50$export$2733615da5b906f0);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE", () => $d73d2906133d5d50$export$f510a6e9fec0630a);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES", () => $d73d2906133d5d50$export$94bda82b7db2173c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION", () => $d73d2906133d5d50$export$7e07da72de89b61c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY", () => $d73d2906133d5d50$export$5b3a0c7c3b3456f);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_NAV_LOCATION", () => $d73d2906133d5d50$export$3c59a089fdd2614a);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_CATEGORY", () => $d73d2906133d5d50$export$9b99689db482a6bb);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $d73d2906133d5d50$export$5a00268156ea5027);
$parcel$export(module.exports, "ONE_HOUR_IN_MILLIS", () => $d73d2906133d5d50$export$86e172ab3db1a556);
/* eslint-disable jira/filename-case */ const $d73d2906133d5d50$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $d73d2906133d5d50$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $d73d2906133d5d50$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $d73d2906133d5d50$export$f510a6e9fec0630a = 'SERVICEDESK_NAV3_QUEUE_GROUPS_STATE';
const $d73d2906133d5d50$export$94bda82b7db2173c = 'SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES';
const $d73d2906133d5d50$export$7e07da72de89b61c = 'SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION';
const $d73d2906133d5d50$export$5b3a0c7c3b3456f = 'SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY';
const $d73d2906133d5d50$export$3c59a089fdd2614a = 'queue-groups-nav-state';
const $d73d2906133d5d50$export$9b99689db482a6bb = 'queues-category-state';
const $d73d2906133d5d50$export$5a00268156ea5027 = 86400000;
const $d73d2906133d5d50$export$86e172ab3db1a556 = 3600000;

});

parcelRegister("e6DgO", function(module, exports) {
$parcel$export(module.exports, "getPriorityGroupDataByProjectId", () => $7e8cafe60a525750$export$cf2bd2ec601ed920);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i4emW = parcelRequire("i4emW");

var $4fhEY = parcelRequire("4fhEY");
const $7e8cafe60a525750$var$fetchGroupByKeyViaJira = async (projectKey, projectId)=>{
    const queryParams = projectId ? `projectId=${projectId}` : `projectKey=${projectKey}`;
    return (0, $4fhEY.default)(`/rest/servicedesk/latest/servicedesk/queue-group/groups?${queryParams}&operation=fetchPriorityGroups`);
};
const $7e8cafe60a525750$export$cf2bd2ec601ed920 = async (projectId, projectKey)=>{
    const data = await $7e8cafe60a525750$var$fetchGroupByKeyViaJira(projectKey, projectId);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($i4emW)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return processedData;
};

});
parcelRegister("i4emW", function(module, exports) {

var $fOh92 = parcelRequire("fOh92");

var $4cz3P = parcelRequire("4cz3P");
/** Used for built-in method references. */ var $d273bf1e16d87cd5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d273bf1e16d87cd5$var$hasOwnProperty = $d273bf1e16d87cd5$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $d273bf1e16d87cd5$var$groupBy = $4cz3P(function(result, value, key) {
    if ($d273bf1e16d87cd5$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $fOh92(result, key, [
        value
    ]);
});
module.exports = $d273bf1e16d87cd5$var$groupBy;

});


parcelRegister("cqRR9", function(module, exports) {
$parcel$export(module.exports, "RESOURCE_TYPE_TRIAGE_BUTTON_PERMISSION", () => $9e582d8b880be49f$export$e79aee80d521b352);
$parcel$export(module.exports, "getTriageButtonPermission", () => $9e582d8b880be49f$export$6a9c765d370d71c8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $h2wCv = parcelRequire("h2wCv");

var $lCetP = parcelRequire("lCetP");
const $9e582d8b880be49f$export$e79aee80d521b352 = 'triage-button-permission';
const $9e582d8b880be49f$export$6a9c765d370d71c8 = async ()=>{
    const permissionsUrl = '/rest/api/3/mypermissions?permissions=MOVE_ISSUES%2CEDIT_ISSUES%2CBULK_CHANGE';
    const aiStatusUrl = '/rest/latest/aiconfig/optin/jira-servicedesk';
    try {
        const [permissions, aiStatus] = await Promise.all([
            (0, $h2wCv.performGetRequest)(permissionsUrl),
            (0, $h2wCv.performGetRequest)(aiStatusUrl)
        ]);
        return {
            hasPermission: permissions.permissions.MOVE_ISSUES?.havePermission && permissions.permissions.EDIT_ISSUES?.havePermission && permissions.permissions.BULK_CHANGE?.havePermission,
            hasAiEnabled: aiStatus.isEnabled
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $lCetP.isHttpClientErrorResponse)(error)) (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'fetchTriageButtonPermissionError',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        // Return default values on error
        return {
            hasPermission: false,
            hasAiEnabled: false
        };
    }
};

});

parcelRegister("1BkmR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("l5nB1").then(()=>parcelRequire('luTQQ'));

});

parcelRegister("8CQWr", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gTIkZ").then(()=>parcelRequire('eIwyV'));

});

parcelRegister("2QxLf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d8b4c8f0e2b44565$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* eslint-disable jira/import-whitelist */ 
var $bdEst = parcelRequire("bdEst");

var $i0CFV = parcelRequire("i0CFV");

var $siTdT = parcelRequire("siTdT");

var $h2wCv = parcelRequire("h2wCv");

var $cDZzl = parcelRequire("cDZzl");

var $9dxuE = parcelRequire("9dxuE");
const $d8b4c8f0e2b44565$var$fetchIssueListData = async ({ match: match, query: query })=>{
    const projectKeyOrId = (0, $i0CFV.getProjectKeyId)(match, query).projectKey;
    const queueId = match.params && match.params.queueId || undefined;
    const category = match.params && match.params.practiceType || 'no-category';
    if (!queueId) throw (0, $bdEst.createResourceError)({
        component: 'spa.view.routes.servicedesk.queues.fetchIssueListSsrData',
        message: 'QueueId is undefined',
        name: 'ResourceError',
        skipSentry: false
    });
    const bodyWithCategory = {
        columnTypesAsJson: (0, $9dxuE.getFieldTypesEligibleForJsonData)(),
        issuesPerPage: (0, $cDZzl.FETCH_SIZE_IN_INITIAL_LOAD),
        category: category
    };
    const url = `/rest/servicedesk/1/servicedesk/${projectKeyOrId}/issuelist/ssr/${queueId}/jis?operation=fetchIssueListSsr`;
    const fetchStartTime = performance.now();
    const data = await (0, $h2wCv.performPostRequest)(url, {
        body: JSON.stringify(bodyWithCategory)
    }).catch(()=>undefined);
    (0, $siTdT.addSpanToAll)('fetch', '/rest/servicedesk/1/servicedesk/projectKey/issuelist/ssr/queueId/jis', [
        {
            name: 'network'
        }
    ], fetchStartTime, performance.now());
    return data;
};
var $d8b4c8f0e2b44565$export$2e2bcd8739ae039 = $d8b4c8f0e2b44565$var$fetchIssueListData;

});
parcelRegister("bdEst", function(module, exports) {
$parcel$export(module.exports, "createResourceError", () => $cec0bd4f375e6b3e$export$13487d18466bc8a5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6CfY5 = parcelRequire("6CfY5");
class $cec0bd4f375e6b3e$var$ResourceErrorClass extends Error {
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
$cec0bd4f375e6b3e$var$ResourceErrorClass.displayName = "ResourceErrorClass";
const $cec0bd4f375e6b3e$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $6CfY5.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $cec0bd4f375e6b3e$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});

parcelRegister("cDZzl", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_COLUMNS", () => $2d774bff2465a9d8$export$50c19f60b9c144f7);
$parcel$export(module.exports, "DEFAULT_QUEUE_ID", () => $2d774bff2465a9d8$export$e78379cc32bff512);
$parcel$export(module.exports, "FETCH_BATCH_SIZE_OLD", () => $2d774bff2465a9d8$export$987477cbd7054df);
$parcel$export(module.exports, "FETCH_SIZE_IN_INITIAL_LOAD", () => $2d774bff2465a9d8$export$4ee65d92b7b81b6b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $2d774bff2465a9d8$export$50c19f60b9c144f7 = [
    'issuetype',
    'issuekey',
    'summary',
    'reporter',
    'assignee',
    'status',
    'created'
];
const $2d774bff2465a9d8$export$e78379cc32bff512 = Number.MIN_VALUE;
const $2d774bff2465a9d8$export$987477cbd7054df = 100;
const $2d774bff2465a9d8$export$4ee65d92b7b81b6b = 30;

});

parcelRegister("9dxuE", function(module, exports) {
$parcel$export(module.exports, "getFieldTypesEligibleForJsonData", () => $e89f51d5e7758dfd$export$e2bd4328395b4df7);
$parcel$export(module.exports, "getFieldTypesEligibleForJsonDataAsSet", () => $e89f51d5e7758dfd$export$740140e54d80c734);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $k4FO8 = parcelRequire("k4FO8");

var $dAmGh = parcelRequire("dAmGh");

var $emCaV = parcelRequire("emCaV");

var $i860n = parcelRequire("i860n");
const $e89f51d5e7758dfd$var$getFieldTypesFromFeatureFlagMap = (featureFlagMap)=>(0, (/*@__PURE__*/$parcel$interopDefault($k4FO8)))((0, (/*@__PURE__*/$parcel$interopDefault($dAmGh)))(featureFlagMap, (isAlwaysJsonOrFFKey)=>{
        if (typeof isAlwaysJsonOrFFKey === 'boolean') return isAlwaysJsonOrFFKey;
        // eslint-disable-next-line jira/ff/static-feature-flags
        return (0, $i860n.fg)(isAlwaysJsonOrFFKey);
    }));
const $e89f51d5e7758dfd$export$c394db035bb5cf7d = {
    assignee: true,
    'com.atlassian.servicedesk:sd-sla-field': true,
    status: true,
    issuetype: true,
    reporter: true,
    priority: true,
    summary: true,
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype': true,
    labels: true,
    'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team': 'jsm_queue_inline_team_update',
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': true,
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': true,
    'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype': 'jsm_unscreenable_field_phase_2_fg',
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker': true,
    'com.atlassian.servicedesk:sd-request-participants': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker': true,
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement': true,
    'com.atlassian.servicedesk.sentiment:sd-sentiment': true,
    'com.atlassian.servicedesk.customer-context:sd-csm-organization': 'jcs_master_flag',
    'com.atlassian.servicedesk.customer-context:sd-csm-source-channel': 'csm_omni_source_channel_cf_fe',
    // Queue view: request additional REST-aware columns as JSON when enabled.
    created: true,
    updated: true,
    duedate: true,
    lastViewed: true,
    resolutiondate: true,
    // Queue view: next set of columns to request as JSON when enabled.
    timespent: true,
    aggregatetimespent: true,
    timeoriginalestimate: true,
    resolution: true,
    'com.atlassian.jira.plugin.system.customfieldtypes:select': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:datepicker': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:userpicker': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:labels': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:url': true,
    'com.atlassian.servicedesk:vp-origin': true,
    'com.atlassian.servicedesk:sd-customer-organizations': true,
    issuelinks: true,
    components: true,
    creator: true,
    security: true,
    subtasks: true,
    parent: true
};
const $e89f51d5e7758dfd$export$e2bd4328395b4df7 = (0, $emCaV.default)(()=>$e89f51d5e7758dfd$var$getFieldTypesFromFeatureFlagMap($e89f51d5e7758dfd$export$c394db035bb5cf7d));
const $e89f51d5e7758dfd$export$740140e54d80c734 = (0, $emCaV.default)(()=>new Set($e89f51d5e7758dfd$export$e2bd4328395b4df7()));
const $e89f51d5e7758dfd$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS = {
    issuekey: true,
    statusCategory: true
};
const $e89f51d5e7758dfd$export$8e81e0bb2e4fc09e = (0, $emCaV.default)(()=>$e89f51d5e7758dfd$var$getFieldTypesFromFeatureFlagMap($e89f51d5e7758dfd$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS));
const $e89f51d5e7758dfd$export$dacb9fc482fbe93 = (0, $emCaV.default)(()=>new Set($e89f51d5e7758dfd$export$8e81e0bb2e4fc09e()));

});



parcelRegister("c6i4p", function(module, exports) {
$parcel$export(module.exports, "nav3QueueGroupsStateResource", () => $2932efda711816d6$export$53d0e5294221581);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cY22M = parcelRequire("cY22M");

var $hFtK7 = parcelRequire("hFtK7");

var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $5PVNo = parcelRequire("5PVNo");

var $asIGs = parcelRequire("asIGs");
const $2932efda711816d6$var$getProjectKey = ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
    (0, $i0CFV.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(match, 'params.issueKey', '').split('-')[0];
const $2932efda711816d6$export$53d0e5294221581 = (0, $7edbf.createResource)({
    type: (0, $5PVNo.RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE),
    getKey: $2932efda711816d6$var$getProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        if (!atlassianAccountId) return undefined;
        const projectKey = $2932efda711816d6$var$getProjectKey({
            match: match,
            query: query
        });
        try {
            return await (0, $asIGs.getQueueGroupsStateFromUserProperty)(projectKey, atlassianAccountId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $hFtK7.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'getQueueGroupsStateInUserPropertyResourceError'
                }
            });
            return undefined;
        }
    },
    maxAge: (0, $5PVNo.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("asIGs", function(module, exports) {
$parcel$export(module.exports, "setQueueGroupsStateInUserProperty", () => $a65ddd85a962a1bd$export$e316bbc9b5e5100d);
$parcel$export(module.exports, "getQueueGroupsStateFromUserProperty", () => $a65ddd85a962a1bd$export$87bc602eb5671315);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");
const $a65ddd85a962a1bd$export$bb10a02fc2feb574 = 'jsm-queue-groups-state-selected-group-id';
const $a65ddd85a962a1bd$export$e316bbc9b5e5100d = async (projectKey, value, accountId)=>{
    try {
        (0, $kM0go.setUserProperties)(accountId, `${$a65ddd85a962a1bd$export$bb10a02fc2feb574}_${projectKey}`, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'setQueueGroupsStateInUserPropertyError'
            }
        });
        throw error;
    }
};
const $a65ddd85a962a1bd$export$87bc602eb5671315 = async (projectKey, accountId)=>{
    try {
        return await (0, $kM0go.getUserProperty)(accountId, `${$a65ddd85a962a1bd$export$bb10a02fc2feb574}_${projectKey}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'getQueueGroupsStateFromUserPropertyError'
            }
        });
        throw error;
    }
};

});


parcelRegister("kqhKu", function(module, exports) {
$parcel$export(module.exports, "virtualAgentOnboardingResource", () => $6218fceba85bb85d$export$d39827c053fda3aa);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i860n = parcelRequire("i860n");

var $htsFl = parcelRequire("htsFl");

var $3gyu0 = parcelRequire("3gyu0");
const $6218fceba85bb85d$export$d39827c053fda3aa = (0, $htsFl.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $3gyu0.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $i860n.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("3gyu0", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9a981f8371a3643$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b9b2b5e8b99e05cc5ed4d2f22d07d90>>
 * @relayHash 3279cb796ca15f5627d629f70f5f37ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f8d8b9eec1994f8c7411bb76dc10be0eab8514a591963f4d58e52f323d48b997

var $k5oaC = parcelRequire("k5oaC");
const $c9a981f8371a3643$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f8d8b9eec1994f8c7411bb76dc10be0eab8514a591963f4d58e52f323d48b997",
        "metadata": {},
        "name": "VirtualAgentSidebarQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $k5oaC.default)
        }
    }
};
var $c9a981f8371a3643$export$2e2bcd8739ae039 = $c9a981f8371a3643$var$node;

});
parcelRegister("k5oaC", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbefbb0b7b5daa7c$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");
var $fbefbb0b7b5daa7c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $i860n.fg)('require_ai_enabled_for_jsm_virtual_agent');
    }
};

});



parcelRegister("lEPfS", function(module, exports) {
$parcel$export(module.exports, "featuresResource", () => $31fe7140dff95848$export$16f81cc9da2c6c47);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $cY22M = parcelRequire("cY22M");

var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");
const $31fe7140dff95848$var$RESOURCE_TYPE_SERVICEDESK_FEATURES = 'SERVICEDESK_FEATURES';
const $31fe7140dff95848$var$ONE_DAY_IN_MILLIS = 86400000;

const $31fe7140dff95848$export$16f81cc9da2c6c47 = (0, $7edbf.createResource)({
    type: $31fe7140dff95848$var$RESOURCE_TYPE_SERVICEDESK_FEATURES,
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $i0CFV.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: ()=>(parcelRequire("3Yjff")),
    maxAge: $31fe7140dff95848$var$ONE_DAY_IN_MILLIS
});

});
parcelRegister("3Yjff", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("hXVRn").then(()=>parcelRequire('6jMUS'));

});


parcelRegister("2DCyG", function(module, exports) {
$parcel$export(module.exports, "uifBoardResource", () => $6000f176d5258e3f$export$b65bcbbccad354ac);
$parcel$export(module.exports, "boardViewSettingsResource", () => $6000f176d5258e3f$export$e44870e1afdd6b0a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /* eslint-disable jira/import-whitelist */ 
var $4dWKQ = parcelRequire("4dWKQ");

var $7edbf = parcelRequire("7edbf");

var $htsFl = parcelRequire("htsFl");

var $hOmct = parcelRequire("hOmct");
const $6000f176d5258e3f$var$RESOURCE_TYPE_UIF_BOARD = 'UIF_BOARD';

const $6000f176d5258e3f$export$b65bcbbccad354ac = (0, $7edbf.createResource)({
    type: $6000f176d5258e3f$var$RESOURCE_TYPE_UIF_BOARD,
    getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
        if (config) return `uif-board::${routeName}::config`;
        if (boardId == null) return `uif-board::${routeName}::not-found`;
        return `uif-board::${routeName}::${boardId}`;
    },
    getDataLoader: ()=>(parcelRequire("7uolo")),
    maxAge: 0
});
const $6000f176d5258e3f$var$getQuery = ({ match: match }, { tenantContext: { activationId: activationId, cloudId: cloudId } })=>{
    const viewId = (0, $hOmct.JiraViewAri).create({
        activationId: activationId,
        siteId: cloudId,
        scopeId: `${Number(match.params.boardId)}/board`,
        scopeType: 'board'
    }).toString();
    return {
        options: {
            fetchPolicy: 'network-only'
        },
        parameters: $4dWKQ.default,
        variables: {
            input: {
                viewId: viewId
            }
        }
    };
};
const $6000f176d5258e3f$export$e44870e1afdd6b0a = (0, $htsFl.createRelayResource)({
    type: 'BOARD_CMP_VIEW_SETTINGS_RESOURCE',
    getQuery: $6000f176d5258e3f$var$getQuery
});

});
parcelRegister("4dWKQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ff4cad4fb1d5ff9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<baf0b0742d6d8408de9e0e05064029ba>>
 * @relayHash 2eec6b3ac944870a7beffe63dd43e213
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID edefa586383073d18e29ae310cfd9d8eec687f473b49547ddb5d562c5012fdec
const $7ff4cad4fb1d5ff9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "edefa586383073d18e29ae310cfd9d8eec687f473b49547ddb5d562c5012fdec",
        "metadata": {},
        "name": "BoardViewSettingsDataResolverQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7ff4cad4fb1d5ff9$export$2e2bcd8739ae039 = $7ff4cad4fb1d5ff9$var$node;

});

parcelRegister("7uolo", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("tsfSo").then(()=>parcelRequire('3qRBz'));

});


parcelRegister("4pLi9", function(module, exports) {
$parcel$export(module.exports, "jsmGracePeriodAnnouncementDisplayStateResource", () => $d221fdaca3820e2c$export$9c4218ae35fac02e);
$parcel$export(module.exports, "useJsmGracePeriodAnnouncementDisplayStateResource", () => $d221fdaca3820e2c$export$fed541e4e6eb934c);
$parcel$export(module.exports, "jsmGracePeriodAnnouncementGpEndDateResource", () => $d221fdaca3820e2c$export$ee26341514033dab);
$parcel$export(module.exports, "useJsmGracePeriodAnnouncementGpEndDateResource", () => $d221fdaca3820e2c$export$6b1dcceb1bcecc4c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $hFtK7 = parcelRequire("hFtK7");

var $kM0go = parcelRequire("kM0go");

var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");

var $aJ81Y = parcelRequire("aJ81Y");

var $kEKdX = parcelRequire("kEKdX");

const $d221fdaca3820e2c$export$9c4218ae35fac02e = (0, $7edbf.createResource)({
    type: 'JSM_GRACE_PERIOD_ANNOUNCEMENT_DISPLAY_STATE',
    getKey: ()=>'JSM_GRACE_PERIOD_ANNOUNCEMENT_DISPLAY_STATE',
    getDataLoader: ()=>(parcelRequire("6D5AT")),
    maxAge: Infinity,
    isCritical: true
});
const $d221fdaca3820e2c$var$getNewAnnouncementDismissState = (bannerType, baseDisplayState, useNewT90State)=>{
    const getHideBannerKey = (warning, T90State)=>{
        if (warning === 'T90' && T90State) return 'hideT90BannerNew';
        return `hide${warning}Banner`;
    };
    const updatedState = {
        ...baseDisplayState,
        [getHideBannerKey(bannerType, useNewT90State)]: true
    };
    return updatedState;
};
const $d221fdaca3820e2c$export$fed541e4e6eb934c = (accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $k6ufm.useResource)($d221fdaca3820e2c$export$9c4218ae35fac02e);
    const loadingRef = (0, $euxye.useRef)(false);
    const errorRef = (0, $euxye.useRef)();
    const [userPropertiesError, setUserPropertiesError] = (0, $euxye.useState)();
    errorRef.current = userPropertiesError || error;
    const dismissAnnouncement = (0, $euxye.useCallback)((baseState, bannerType, analyticsEvent, useNewT90State)=>{
        update(()=>$d221fdaca3820e2c$var$getNewAnnouncementDismissState(bannerType, baseState, useNewT90State));
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'useJsmGracePeriodAnnouncementResource-update',
                        packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
                        teamName: 'Seqouia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $kM0go.setUserProperties)(accountId, (0, $kEKdX.JSM_GRACE_PERIOD_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify($d221fdaca3820e2c$var$getNewAnnouncementDismissState(bannerType, baseState, useNewT90State))).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: 'useJsmGracePeriodAnnouncementResource-update',
                        packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
                        teamName: 'Sequoia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                // SQA-804: Add more typeOfUserEngagement attributes when we release the banner to low engaged GPC
                (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'dismissJsmGracePeriodBanner', {
                    source: 'jsmGracePeriodBanner',
                    bannerType: bannerType,
                    typeOfUserEngagement: 'high'
                });
                loadingRef.current = false;
            });
        }
    }, [
        update,
        accountId
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $euxye.useMemo)(()=>{
        if (errorRef.current || loading || !data || !accountId) return {
            loading: loading,
            displayState: {
                hideT7Banner: true,
                hideT30Banner: true,
                hideT90Banner: true,
                hideT90BannerNew: true
            },
            dismissAnnouncement: dismissAnnouncement
        };
        return {
            displayState: data,
            loading: loading,
            dismissAnnouncement: dismissAnnouncement
        };
    }, [
        loading,
        data,
        accountId,
        dismissAnnouncement
    ]);
};

const $d221fdaca3820e2c$export$ee26341514033dab = (0, $7edbf.createResource)({
    type: 'JSM_GRACE_PERIOD_ANNOUNCEMENT_GP_END_DATE',
    getKey: ()=>'JSM_GRACE_PERIOD_ANNOUNCEMENT_GP_END_DATE',
    getDataLoader: ()=>(parcelRequire("85yJH")),
    maxAge: Infinity,
    isCritical: true,
    isBrowserOnly: true
});
const $d221fdaca3820e2c$export$6b1dcceb1bcecc4c = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $k6ufm.useResource)($d221fdaca3820e2c$export$ee26341514033dab);
    const errorRef = (0, $euxye.useRef)();
    errorRef.current = error;
    (0, $euxye.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $euxye.useMemo)(()=>{
        if (errorRef.current || loading) return {
            loading: loading
        };
        return {
            gpEndDateDetails: data?.gpEndDateDetails,
            gpEndDate: data?.gracePeriodEndDate,
            loading: loading
        };
    }, [
        loading,
        data
    ]);
};

});
parcelRegister("kEKdX", function(module, exports) {
$parcel$export(module.exports, "JSM_GRACE_PERIOD_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", () => $ca8565d09f8f1ce5$export$7d5b09dea0d101b7);
$parcel$export(module.exports, "DEFAULT_ANNOUNCEMENT_BANNER_DISPLAY_STATE", () => $ca8565d09f8f1ce5$export$3751c4ee78cb739a);
$parcel$export(module.exports, "FALLBACK_GP_END_DATE", () => $ca8565d09f8f1ce5$export$a50854eacfeb5c82);
/* eslint-disable jira/filename-case */ const $ca8565d09f8f1ce5$export$7d5b09dea0d101b7 = 'jsm-grace-period-announcement-dismiss-state';
const $ca8565d09f8f1ce5$export$3751c4ee78cb739a = {};
const $ca8565d09f8f1ce5$export$a50854eacfeb5c82 = new Date('10/16/2025');

});

parcelRegister("6D5AT", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("bdtKN").then(()=>parcelRequire('hjL1f'));

});

parcelRegister("85yJH", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("7d0ZI").then(()=>parcelRequire('kkyev'));

});


parcelRegister("53xPq", function(module, exports) {
$parcel$export(module.exports, "issueCollapsibleGroupDataResource", () => $81e85875ae392d60$export$36e5daae4cc63ce1);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/import-whitelist


var $i0CFV = parcelRequire("i0CFV");

var $bdEst = parcelRequire("bdEst");

var $7edbf = parcelRequire("7edbf");

var $h2wCv = parcelRequire("h2wCv");
const $81e85875ae392d60$var$getKey = ({ match: match, query: query })=>{
    const projectKey = (0, $i0CFV.getProjectKey)(match, query);
    return `issue.collapsible-group.${projectKey}`;
};
const $81e85875ae392d60$export$36e5daae4cc63ce1 = (0, $7edbf.createResource)({
    type: 'ISSUE_COLLAPSIBLE_GROUP_DATA',
    getKey: $81e85875ae392d60$var$getKey,
    getData: async ({ match: match, query: query })=>{
        const key = $81e85875ae392d60$var$getKey({
            match: match,
            query: query
        });
        const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
        try {
            return await (0, $h2wCv.performGetRequest)(requestUrl);
        } catch (error) {
            if (!!error && typeof error === 'object' && 'statusCode' in error && error.statusCode === (0, $8f860a533cc71fca$export$8bca792d963eb0ef)) return;
            throw (0, $bdEst.createResourceError)({
                component: 'spa.view.routes.issue-view.collapsible-group.getData',
                message: 'An error was thrown while prefetching issue collapsible group data'
            }, error);
        }
    }
});

});

parcelRegister("dk0Ly", function(module, exports) {
$parcel$export(module.exports, "jsmFeaturesEnabledResource", () => $518a3042f2e08002$export$c0dc1da2e81e91b4);

var $7edbf = parcelRequire("7edbf");

const $518a3042f2e08002$var$ONE_HOUR_MS = 3600000;

const $518a3042f2e08002$export$c0dc1da2e81e91b4 = (0, $7edbf.createResource)({
    type: (0, $0ec5a7f900257a97$export$72b898553bf6a17d),
    // Cross-project / site-wide — projectKey not required
    getKey: ()=>'jsm-features-enabled',
    getDataLoader: ()=>(parcelRequire("geXZg")),
    maxAge: $518a3042f2e08002$var$ONE_HOUR_MS
});

});
const $0ec5a7f900257a97$export$72b898553bf6a17d = 'JSM_FEATURES_ENABLED';

parcelRegister("geXZg", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("9I8z7").then(()=>parcelRequire('4coGV'));

});


parcelRegister("9MeJD", function(module, exports) {
$parcel$export(module.exports, "jsmProjectMenuContentSidebarResource", () => $75f85dce1fbb1bba$export$c7d29d5f00e667f5);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $htsFl = parcelRequire("htsFl");

var $3mbAZ = parcelRequire("3mbAZ");

var $i860n = parcelRequire("i860n");

var $c4rhk = parcelRequire("c4rhk");
const $75f85dce1fbb1bba$export$71eec30d9db46a56 = ({ match: match, query: query }, resourceContext)=>{
    const cloudId = resourceContext?.tenantContext?.cloudId ?? '';
    let { projectKey: projectKey } = (0, $i0CFV.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: (0, $3mbAZ.default),
        variables: {
            cloudId: cloudId,
            projectKey: projectKey,
            isRenamingEnabled: (0, $i860n.fg)('jsm_project_nav_rename_hr')
        }
    };
};
const $75f85dce1fbb1bba$export$c7d29d5f00e667f5 = (0, $c4rhk.withGiraAggAnonSsrFix)((0, $htsFl.createRelayResource)({
    type: 'JSM_PROJECT_MENU_CONTENT_SIDEBAR_QUERY',
    getQuery: $75f85dce1fbb1bba$export$71eec30d9db46a56
}));

});
parcelRegister("3mbAZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $92cc07f255fbbd03$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d0d187cc02289f15762fa32bb4e2164f>>
 * @relayHash 30c2a89460070692193c3257a69f6973
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2298927a4ea816a29ee9dc52b84b9608a9ee125aaf2e273a63a05895a85b4825
const $92cc07f255fbbd03$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRenamingEnabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "itemId"
    }, v6 = {
        "concreteType": "JiraProjectLevelSidebarMenuItemConnection",
        "kind": "LinkedField",
        "name": "hiddenMenuItems",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraProjectLevelSidebarMenuItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraProjectLevelSidebarMenuItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v5 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "JsmProjectMenuWrapper_SidebarQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "jira_projectLevelSidebarMenuCustomization",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "isRenamingEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectLevelSidebarRenamedMenuItemConnection",
                                            "kind": "LinkedField",
                                            "name": "renamedMenuItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "JsmProjectMenuContent_renamedMenuItems"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraProjectLevelSidebarMenuCustomization"
                        },
                        v7 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "JsmProjectMenuWrapper_SidebarQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "jira_projectLevelSidebarMenuCustomization",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "isRenamingEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectLevelSidebarRenamedMenuItemConnection",
                                            "kind": "LinkedField",
                                            "name": "renamedMenuItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectLevelSidebarRenamedMenuItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProjectLevelSidebarRenamedMenuItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "renamedMenuItemName"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ],
                            "type": "JiraProjectLevelSidebarMenuCustomization"
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "2298927a4ea816a29ee9dc52b84b9608a9ee125aaf2e273a63a05895a85b4825",
            "metadata": {},
            "name": "JsmProjectMenuWrapper_SidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$92cc07f255fbbd03$var$node.hash = "b2e346bf89908f8dbaf1941dbed37620";
var $92cc07f255fbbd03$export$2e2bcd8739ae039 = $92cc07f255fbbd03$var$node;

});


parcelRegister("862Zj", function(module, exports) {
$parcel$export(module.exports, "staticSidebarShortcutsResource", () => $843f6f02eaf41eb8$export$4847c29b4786b3b4);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $cjlpE = parcelRequire("cjlpE");
const $843f6f02eaf41eb8$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $843f6f02eaf41eb8$export$4847c29b4786b3b4 = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
    getKey: ({ match: match, query: query })=>$843f6f02eaf41eb8$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $843f6f02eaf41eb8$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const shortcuts = await (0, $cjlpE.fetchShortcuts)(projectKeyOrId);
        return shortcuts;
    },
    maxAge: 300000,
    isCritical: true
});

});
parcelRegister("cjlpE", function(module, exports) {
$parcel$export(module.exports, "fetchShortcuts", () => $bb861d5f782e4a97$export$49d696bf2525d700);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");

var $4fhEY = parcelRequire("4fhEY");
const $bb861d5f782e4a97$export$49d696bf2525d700 = (projectKeyOrId)=>{
    try {
        return (0, $4fhEY.default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $hFtK7.trackFetchErrors)({
            error: error,
            id: 'fetchProjectShortcuts',
            packageName: 'jiraNavigationAppsResources'
        });
        throw error;
    }
};

});


parcelRegister("aS6zs", function(module, exports) {
$parcel$export(module.exports, "staticSidebarJsmReportsResource", () => $7a3bd88a1eea5a02$export$ec28065a31cce4ce);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $i0CFV = parcelRequire("i0CFV");

var $7edbf = parcelRequire("7edbf");

var $fAjxN = parcelRequire("fAjxN");
const $7a3bd88a1eea5a02$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $i0CFV.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $7a3bd88a1eea5a02$export$ec28065a31cce4ce = (0, $7edbf.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
    getKey: ({ match: match, query: query })=>$7a3bd88a1eea5a02$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $7a3bd88a1eea5a02$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        return (0, $fAjxN.fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
    },
    maxAge: 300000
});

});
parcelRegister("fAjxN", function(module, exports) {
$parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", () => $059cddf34e8fb97f$export$c1dd51127051647d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h2wCv = parcelRequire("h2wCv");
const $059cddf34e8fb97f$export$c1dd51127051647d = (projectIdOrKey)=>{
    if (projectIdOrKey == null) throw new Error('invalid project id or key');
    return (0, $h2wCv.performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
};

});



parcelRegister("gVfFx", function(module, exports) {
$parcel$export(module.exports, "legacyConnectProjectRoute", () => $f263d97bf2ee770d$export$dfdf98c5b58cfa04);
const $f263d97bf2ee770d$export$dfdf98c5b58cfa04 = {
    name: 'legacy-connect-project',
    path: '/projects/:projectKey',
    query: [
        'selectedItem'
    ]
};

});


parcelRegister("1qUc0", function(module, exports) {
$parcel$export(module.exports, "legacyCustomReportRouteEntry", () => $575ff8db72f70223$export$12938ba85bf5fe54);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $aj03u = parcelRequire("aj03u");

var $etJ8c = parcelRequire("etJ8c");
const $575ff8db72f70223$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $575ff8db72f70223$export$12938ba85bf5fe54 = (0, $g1GqA.createLegacyEntry)((0, $aj03u.legacyCustomReportRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $etJ8c.getReportsCommonResource)()
        ],
        entryPoint: ()=>$575ff8db72f70223$var$pageEntryPoint
    }));

});
parcelRegister("aj03u", function(module, exports) {
$parcel$export(module.exports, "legacyCustomReportRoute", () => $042c3af064340dd0$export$6f4b8901e7772b05);
const $042c3af064340dd0$export$6f4b8901e7772b05 = {
    name: 'legacy-custom-report',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=reporting',
        'chart'
    ]
};

});

parcelRegister("etJ8c", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $b42d55d8ec0a6250$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $b42d55d8ec0a6250$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $b42d55d8ec0a6250$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("1opJ9", function(module, exports) {
$parcel$export(module.exports, "legacyDashboardsAddRouteEntry", () => $31e87603fbff1c5d$export$6cc9527a3f96c0a5);


var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $3JZnL = parcelRequire("3JZnL");
const $31e87603fbff1c5d$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $31e87603fbff1c5d$export$6cc9527a3f96c0a5 = (0, $g1GqA.createLegacyEntry)((0, $3JZnL.legacyDashboardsAddRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $21119304508db966$export$171f31ae1a6b7762)
        },
        entryPoint: ()=>$31e87603fbff1c5d$var$pageEntryPoint
    }));

});
const $21119304508db966$export$171f31ae1a6b7762 = 'DASHBOARDS';

parcelRegister("3JZnL", function(module, exports) {
$parcel$export(module.exports, "legacyDashboardsAddRoute", () => $9ae506711eafe0f1$export$1e88394d2d12a4bc);
const $9ae506711eafe0f1$export$1e88394d2d12a4bc = {
    name: 'legacy-dashboards-add',
    path: '(/secure/|/)AddPortalPage([!%]?[\\w]*).jspa'
};

});


parcelRegister("hrL3w", function(module, exports) {
$parcel$export(module.exports, "legacyDashboardsConfigureRouteEntry", () => $d36231a27f49bafd$export$18ff609f147595cc);


var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $89uTd = parcelRequire("89uTd");
const $d36231a27f49bafd$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d36231a27f49bafd$export$18ff609f147595cc = (0, $g1GqA.createLegacyEntry)((0, $89uTd.legacyDashboardsConfigureRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $21119304508db966$export$171f31ae1a6b7762)
        },
        entryPoint: ()=>$d36231a27f49bafd$var$pageEntryPoint
    }));

});
parcelRegister("89uTd", function(module, exports) {
$parcel$export(module.exports, "legacyDashboardsConfigureRoute", () => $1b6b998b2158569a$export$549a0bcc3a0017a7);
const $1b6b998b2158569a$export$549a0bcc3a0017a7 = {
    name: 'legacy-dashboards-configure',
    path: '(/secure/|/)ConfigurePortalPages([!%]?[\\w]*).jspa'
};

});


parcelRegister("7fPuI", function(module, exports) {
$parcel$export(module.exports, "legacyDashboardsDeleteRouteEntry", () => $84cd7961b40ae6dc$export$4f59d0a9276c0c9b);


var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $V40rU = parcelRequire("V40rU");
const $84cd7961b40ae6dc$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $84cd7961b40ae6dc$export$4f59d0a9276c0c9b = (0, $g1GqA.createLegacyEntry)((0, $V40rU.legacyDashboardsDeleteRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $21119304508db966$export$171f31ae1a6b7762)
        },
        entryPoint: ()=>$84cd7961b40ae6dc$var$pageEntryPoint
    }));

});
parcelRegister("V40rU", function(module, exports) {
$parcel$export(module.exports, "legacyDashboardsDeleteRoute", () => $561497fd496acc88$export$dfa5dcc35e497330);
const $561497fd496acc88$export$dfa5dcc35e497330 = {
    name: 'legacy-dashboards-delete',
    path: '(/secure/|/)DeletePortalPage([!%]?[\\w]*).jspa'
};

});


parcelRegister("eJtkZ", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryRouteEntry", () => $7dae5a98a58412d5$export$748e329bd0c282a);


var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $4if31 = parcelRequire("4if31");
const $7dae5a98a58412d5$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $7dae5a98a58412d5$export$748e329bd0c282a = (0, $g1GqA.createLegacyEntry)((0, $4if31.dashboardsDirectoryRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $21119304508db966$export$171f31ae1a6b7762)
        },
        entryPoint: ()=>$7dae5a98a58412d5$var$pageEntryPoint
    }));

});
parcelRegister("4if31", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $ceba57f3d0cdb3af$export$41bba408475cab16);
const $ceba57f3d0cdb3af$export$41bba408475cab16 = {
    name: 'dashboards-directory',
    path: '/jira/dashboards'
};

});


parcelRegister("5Naso", function(module, exports) {
$parcel$export(module.exports, "legacyDashboardsEditRouteEntry", () => $4c88f83a5f41e7cf$export$60414c63c9cd3646);


var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $4XUoW = parcelRequire("4XUoW");
const $4c88f83a5f41e7cf$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $4c88f83a5f41e7cf$export$60414c63c9cd3646 = (0, $g1GqA.createLegacyEntry)((0, $4XUoW.legacyDashboardsEditRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $21119304508db966$export$171f31ae1a6b7762)
        },
        entryPoint: ()=>$4c88f83a5f41e7cf$var$pageEntryPoint
    }));

});
parcelRegister("4XUoW", function(module, exports) {
$parcel$export(module.exports, "legacyDashboardsEditRoute", () => $bf1c26ca1020c0b7$export$4f028eb17334a195);
const $bf1c26ca1020c0b7$export$4f028eb17334a195 = {
    name: 'legacy-dashboards-edit',
    path: '(/secure/|/)EditPortalPage([!%]?[\\w]*).jspa'
};

});


parcelRegister("fY8eK", function(module, exports) {
$parcel$export(module.exports, "legacyDashboardsRestoreRouteEntry", () => $1f697e48be4dc18c$export$4bf748e39cc28644);


var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $5pEn3 = parcelRequire("5pEn3");
const $1f697e48be4dc18c$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $1f697e48be4dc18c$export$4bf748e39cc28644 = (0, $g1GqA.createLegacyEntry)((0, $5pEn3.legacyDashboardsRestoreRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $21119304508db966$export$171f31ae1a6b7762)
        },
        entryPoint: ()=>$1f697e48be4dc18c$var$pageEntryPoint
    }));

});
parcelRegister("5pEn3", function(module, exports) {
$parcel$export(module.exports, "legacyDashboardsRestoreRoute", () => $3b7d854dc79da8fe$export$110af57b4332630d);
const $3b7d854dc79da8fe$export$110af57b4332630d = {
    name: 'legacy-dashboards-restore',
    path: '/secure/RestoreDefaultDashboard([!%]?[\\w]*).jspa'
};

});


parcelRegister("kTa4D", function(module, exports) {
$parcel$export(module.exports, "legacyFallbackRouteEntry", () => $c5de0063a022dea2$export$1af0a6dff57e40e7);

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $ksV2V = parcelRequire("ksV2V");
const $c5de0063a022dea2$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $c5de0063a022dea2$export$1af0a6dff57e40e7 = (0, $g1GqA.createLegacyEntry)((0, $ksV2V.legacyFallbackRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        entryPoint: ()=>$c5de0063a022dea2$var$pageEntryPoint
    }));

});
parcelRegister("ksV2V", function(module, exports) {
$parcel$export(module.exports, "legacyFallbackRoute", () => $1f9a4a16d86e5f2b$export$27cd5ba2ad569682);
const $1f9a4a16d86e5f2b$export$27cd5ba2ad569682 = {
    name: 'legacy-fallback',
    path: '/:any'
};

});


parcelRegister("f1oFM", function(module, exports) {
$parcel$export(module.exports, "legacyGinActionRouteEntry", () => $c12c1c22894971ac$export$8d542f975e38405d);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $fD0YF = parcelRequire("fD0YF");
const $c12c1c22894971ac$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $c12c1c22894971ac$export$8d542f975e38405d = (0, $g1GqA.createLegacyEntry)((0, $fD0YF.legacyGinActionRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $bf8b595cdc630add$export$8b2ce873c5336522)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$c12c1c22894971ac$var$pageEntryPoint
    }));

});
const $bf8b595cdc630add$export$8b2ce873c5336522 = 'FILTERS';

parcelRegister("fD0YF", function(module, exports) {
$parcel$export(module.exports, "legacyGinActionRoute", () => $88a4283997e765e6$export$796a8e79b017f80d);
const $88a4283997e765e6$export$796a8e79b017f80d = {
    name: 'legacy-gin-action',
    path: '/secure/IssueNavAction!default.jspa',
    query: [
        'filter|jql|issueKey'
    ]
};

});


parcelRegister("fLdFG", function(module, exports) {
$parcel$export(module.exports, "legacyGinBulkRouteEntry", () => $df057eca8757cb2a$export$fa36e59125fc7266);

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $6YBQ0 = parcelRequire("6YBQ0");
const $df057eca8757cb2a$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $df057eca8757cb2a$export$fa36e59125fc7266 = (0, $g1GqA.createLegacyEntry)((0, $6YBQ0.legacyGinBulkRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        entryPoint: ()=>$df057eca8757cb2a$var$pageEntryPoint
    }));

});
parcelRegister("6YBQ0", function(module, exports) {
$parcel$export(module.exports, "legacyGinBulkRoute", () => $5ec8b5321aaf0e59$export$73e4833202a78627);
const $5ec8b5321aaf0e59$export$73e4833202a78627 = {
    name: 'legacy-gin-bulk',
    path: '/secure/Bulk(\\w+)([!%]?[\\w]*).jspa'
};

});


parcelRegister("cD61N", function(module, exports) {
$parcel$export(module.exports, "legacyGinBulkeditRouteEntry", () => $b12eb6d3321e77a5$export$f591688aa6cd2d3);

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $6U0h1 = parcelRequire("6U0h1");
const $b12eb6d3321e77a5$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $b12eb6d3321e77a5$export$f591688aa6cd2d3 = (0, $g1GqA.createLegacyEntry)((0, $6U0h1.legacyGinBulkeditRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        entryPoint: ()=>$b12eb6d3321e77a5$var$pageEntryPoint
    }));

});
parcelRegister("6U0h1", function(module, exports) {
$parcel$export(module.exports, "legacyGinBulkeditRoute", () => $23d337839a4116e0$export$7c8f48fad7f31e42);
const $23d337839a4116e0$export$7c8f48fad7f31e42 = {
    name: 'legacy-gin-bulkedit',
    path: '/(secure/views|issue)/bulkedit/Bulk(\\w+)([!%]?[\\w]*).jspa'
};

});


parcelRegister("ckOZs", function(module, exports) {
$parcel$export(module.exports, "legacyGinIssueAssignRouteEntry", () => $0693f43ca061fc36$export$b7bc71c8e27d96);

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $bOc8F = parcelRequire("bOc8F");
const $0693f43ca061fc36$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $0693f43ca061fc36$export$b7bc71c8e27d96 = (0, $g1GqA.createLegacyEntry)((0, $bOc8F.legacyGinIssueAssignRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        entryPoint: ()=>$0693f43ca061fc36$var$pageEntryPoint
    }));

});
parcelRegister("bOc8F", function(module, exports) {
$parcel$export(module.exports, "legacyGinIssueAssignRoute", () => $2c385bb15e756c93$export$6cc1fcd71b2e06ad);
const $2c385bb15e756c93$export$6cc1fcd71b2e06ad = {
    name: 'legacy-gin-issue-assign',
    path: '/secure/(\\w*)AssignIssue([!%]?[\\w]*).jspa'
};

});


parcelRegister("jzdNk", function(module, exports) {
$parcel$export(module.exports, "legacyGinIssueCloneRouteEntry", () => $91659be4bd7dcf41$export$b54f23b666808992);

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $djB95 = parcelRequire("djB95");
const $91659be4bd7dcf41$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $91659be4bd7dcf41$export$b54f23b666808992 = (0, $g1GqA.createLegacyEntry)((0, $djB95.legacyGinIssueCloneRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        entryPoint: ()=>$91659be4bd7dcf41$var$pageEntryPoint
    }));

});
parcelRegister("djB95", function(module, exports) {
$parcel$export(module.exports, "legacyGinIssueCloneRoute", () => $fc24675d398044d7$export$55ba9c8834c09ade);
const $fc24675d398044d7$export$55ba9c8834c09ade = {
    name: 'legacy-gin-issue-clone',
    path: '/(secure|issue)/CloneIssue(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("3v29r", function(module, exports) {
$parcel$export(module.exports, "legacyGinIssueConvertRouteEntry", () => $b776ccde74bbe955$export$45f0108fe367a800);

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $ciGP9 = parcelRequire("ciGP9");
const $b776ccde74bbe955$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $b776ccde74bbe955$export$45f0108fe367a800 = (0, $g1GqA.createLegacyEntry)((0, $ciGP9.legacyGinIssueConvertRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        entryPoint: ()=>$b776ccde74bbe955$var$pageEntryPoint
    }));

});
parcelRegister("ciGP9", function(module, exports) {
$parcel$export(module.exports, "legacyGinIssueConvertRoute", () => $ad1ca9efdd26e7d6$export$338f229cb5c21a79);
const $ad1ca9efdd26e7d6$export$338f229cb5c21a79 = {
    name: 'legacy-gin-issue-convert',
    path: '/secure/ConvertIssue(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("doQ2O", function(module, exports) {
$parcel$export(module.exports, "legacyGinIssueCreateRouteEntry", () => $d36ef40b42c8c49d$export$86ab2339e662875a);

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $c7hIM = parcelRequire("c7hIM");
const $d36ef40b42c8c49d$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d36ef40b42c8c49d$export$86ab2339e662875a = (0, $g1GqA.createLegacyEntry)((0, $c7hIM.legacyGinIssueCreateRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        entryPoint: ()=>$d36ef40b42c8c49d$var$pageEntryPoint
    }));

});
parcelRegister("c7hIM", function(module, exports) {
$parcel$export(module.exports, "legacyGinIssueCreateRoute", () => $bed1fc634d26375e$export$f27db894d3724085);
const $bed1fc634d26375e$export$f27db894d3724085 = {
    name: 'legacy-gin-issue-create',
    path: '(/secure/|/)CreateIssue(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("caU9k", function(module, exports) {
$parcel$export(module.exports, "legacyGinIssueEditRouteEntry", () => $6c258106d98d225a$export$944b36cf4b5cef62);

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $1MVbI = parcelRequire("1MVbI");
const $6c258106d98d225a$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $6c258106d98d225a$export$944b36cf4b5cef62 = (0, $g1GqA.createLegacyEntry)((0, $1MVbI.legacyGinIssueEditRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        entryPoint: ()=>$6c258106d98d225a$var$pageEntryPoint
    }));

});
parcelRegister("1MVbI", function(module, exports) {
$parcel$export(module.exports, "legacyGinIssueEditRoute", () => $c992befca97731b5$export$5286735392e527fb);
const $c992befca97731b5$export$5286735392e527fb = {
    name: 'legacy-gin-issue-edit',
    path: '/secure/EditIssue([!%]?[\\w]*).jspaa'
};

});


parcelRegister("3LYK3", function(module, exports) {
$parcel$export(module.exports, "legacyGinIssueMoveRouteEntry", () => $1a60979e81fe2918$export$9c2ab973bb46413b);

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $88TFo = parcelRequire("88TFo");
const $1a60979e81fe2918$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $1a60979e81fe2918$export$9c2ab973bb46413b = (0, $g1GqA.createLegacyEntry)((0, $88TFo.legacyGinIssueMoveRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        entryPoint: ()=>$1a60979e81fe2918$var$pageEntryPoint
    }));

});
parcelRegister("88TFo", function(module, exports) {
$parcel$export(module.exports, "legacyGinIssueMoveRoute", () => $45de9c4b74ccf196$export$338e257c93d678f9);
const $45de9c4b74ccf196$export$338e257c93d678f9 = {
    name: 'legacy-gin-issue-move',
    path: '/secure/MoveIssue(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("htiWf", function(module, exports) {
$parcel$export(module.exports, "legacyGinManageRouteEntry", () => $e523567231fc26ff$export$2b56a5623615dd47);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $8vW5X = parcelRequire("8vW5X");
const $e523567231fc26ff$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $e523567231fc26ff$export$2b56a5623615dd47 = (0, $g1GqA.createLegacyEntry)((0, $8vW5X.legacyGinManageRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $bf8b595cdc630add$export$8b2ce873c5336522)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$e523567231fc26ff$var$pageEntryPoint
    }));

});
parcelRegister("8vW5X", function(module, exports) {
$parcel$export(module.exports, "legacyGinManageRoute", () => $d51d0f529a9b92d3$export$e6c509778313a0c1);
const $d51d0f529a9b92d3$export$e6c509778313a0c1 = {
    name: 'legacy-gin-manage',
    path: '(/secure/|/)ManageFilters.jspa'
};

});


parcelRegister("6ID3Q", function(module, exports) {
$parcel$export(module.exports, "legacyGinSubscriptionEditRouteEntry", () => $448046250c781e69$export$5255243cc56f26c3);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $82XI6 = parcelRequire("82XI6");
const $448046250c781e69$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $448046250c781e69$export$5255243cc56f26c3 = (0, $g1GqA.createLegacyEntry)((0, $82XI6.legacyGinSubscriptionEditRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $bf8b595cdc630add$export$8b2ce873c5336522)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$448046250c781e69$var$pageEntryPoint
    }));

});
parcelRegister("82XI6", function(module, exports) {
$parcel$export(module.exports, "legacyGinSubscriptionEditRoute", () => $f495348759e64470$export$20e6c550a55cf8f4);
const $f495348759e64470$export$20e6c550a55cf8f4 = {
    name: 'legacy-gin-subscription-edit',
    path: '(/secure/|/)EditSubscription([!%]?[\\w]*).jspa'
};

});


parcelRegister("5bE97", function(module, exports) {
$parcel$export(module.exports, "legacyGinSubscriptionsRouteEntry", () => $b5680ff5279a115b$export$e739dd8af3aee54a);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $eBTz1 = parcelRequire("eBTz1");
const $b5680ff5279a115b$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $b5680ff5279a115b$export$e739dd8af3aee54a = (0, $g1GqA.createLegacyEntry)((0, $eBTz1.legacyGinSubscriptionsRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $bf8b595cdc630add$export$8b2ce873c5336522)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$b5680ff5279a115b$var$pageEntryPoint
    }));

});
parcelRegister("eBTz1", function(module, exports) {
$parcel$export(module.exports, "legacyGinSubscriptionsRoute", () => $ee2be8a7956796d5$export$cbcaf00bd4f92b0);
const $ee2be8a7956796d5$export$cbcaf00bd4f92b0 = {
    name: 'legacy-gin-subscriptions',
    path: '(/secure/|/)ViewSubscriptions([!%]?[\\w]*).jspa'
};

});


parcelRegister("6gNBE", function(module, exports) {
$parcel$export(module.exports, "legacyGinSubtaskActionRouteEntry", () => $e624d2c320909ea6$export$31f29cb95c5903fc);

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $4u3s1 = parcelRequire("4u3s1");
const $e624d2c320909ea6$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $e624d2c320909ea6$export$31f29cb95c5903fc = (0, $g1GqA.createLegacyEntry)((0, $4u3s1.legacyGinSubtaskActionRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        entryPoint: ()=>$e624d2c320909ea6$var$pageEntryPoint
    }));

});
parcelRegister("4u3s1", function(module, exports) {
$parcel$export(module.exports, "legacyGinSubtaskActionRoute", () => $d981a2af4374adbe$export$d9c87b9b27d73f7c);
const $d981a2af4374adbe$export$d9c87b9b27d73f7c = {
    name: 'legacy-gin-subtask-action',
    path: '/secure/(Move|Convert)SubTask(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("3zWky", function(module, exports) {
$parcel$export(module.exports, "legacyGinWatchersIssueRouteEntry", () => $a54861947290e7a0$export$97a124d7b834ca82);

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $a1nei = parcelRequire("a1nei");
const $a54861947290e7a0$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $a54861947290e7a0$export$97a124d7b834ca82 = (0, $g1GqA.createLegacyEntry)((0, $a1nei.legacyGinWatchersIssueRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        entryPoint: ()=>$a54861947290e7a0$var$pageEntryPoint
    }));

});
parcelRegister("a1nei", function(module, exports) {
$parcel$export(module.exports, "legacyGinWatchersIssueRoute", () => $817410e96fce2de5$export$b3198e66bf5d49ae);
const $817410e96fce2de5$export$b3198e66bf5d49ae = {
    name: 'legacy-gin-watchers-issue',
    path: '/secure/ManageWatchers!default.jspa'
};

});


parcelRegister("30rWu", function(module, exports) {
$parcel$export(module.exports, "globalAutomationRouteEntry", () => $4cf57eafeafa8918$export$652cb0c5f80823c0);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $eVSOY = parcelRequire("eVSOY");
const $4cf57eafeafa8918$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $4cf57eafeafa8918$export$652cb0c5f80823c0 = (0, $g1GqA.createLegacyEntry)((0, $eVSOY.globalAutomationRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$4cf57eafeafa8918$var$pageEntryPoint
    }));

});
const $1b7637cabf39cd90$export$e03d9e7e646baacb = 'GLOBAL_SYSTEM_SETTINGS';

parcelRegister("eVSOY", function(module, exports) {
$parcel$export(module.exports, "globalAutomationRoute", () => $4ebd79676d5176e5$export$5276d514cac1db59);
const $4ebd79676d5176e5$export$5276d514cac1db59 = {
    name: 'global-automation',
    path: '/secure/Automation([!%]?[\\w]*).jspa'
};

});


parcelRegister("dTFMY", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorBrowseRouteEntry", () => $f153636fc426008c$export$b1b791616cdb9491);
/* eslint-disable import/order */ 

var $jgKgn = parcelRequire("jgKgn");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $Svgtf = parcelRequire("Svgtf");
const $f153636fc426008c$export$b1b791616cdb9491 = (0, $g1GqA.createLegacyEntry)((0, $Svgtf.globalIssueNavigatorBrowseRoute), ()=>({
        canTransitionIn: ()=>false,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jgKgn.LegacyPage),
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $bf8b595cdc630add$export$8b2ce873c5336522)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ]
    }));

});
parcelRegister("Svgtf", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorBrowseRoute", () => $217a3bbc4a9d72e4$export$c1b37e392499fccf);
const $217a3bbc4a9d72e4$export$c1b37e392499fccf = {
    name: 'legacy-gin-issue',
    path: '/browse/:issueKey?',
    query: [
        'jql|filter'
    ]
};

});


parcelRegister("gJID9", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorRedirectRouteEntry", () => $5fdbb5eb71f83bd0$export$8cbe781346b8b4a2);
/* eslint-disable import/order */ 

var $jgKgn = parcelRequire("jgKgn");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $ahDBG = parcelRequire("ahDBG");
const $5fdbb5eb71f83bd0$export$8cbe781346b8b4a2 = (0, $g1GqA.createLegacyEntry)((0, $ahDBG.globalIssueNavigatorRedirectRoute), ()=>({
        canTransitionIn: ()=>false,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jgKgn.LegacyPage),
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $bf8b595cdc630add$export$8b2ce873c5336522)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ]
    }));

});
parcelRegister("ahDBG", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorRedirectRoute", () => $ace145fa1fa03bfc$export$b2cd2888fd62d62e);
const $ace145fa1fa03bfc$export$b2cd2888fd62d62e = {
    name: 'legacy-gin-quicksearch',
    path: '/secure/QuickSearch.jspa',
    query: [
        'searchString'
    ]
};

});


parcelRegister("efN9m", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorRouteEntry", () => $eedb76548b89b59a$export$690b5fd7062ce607);
/* eslint-disable import/order */ 

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $emvlX = parcelRequire("emvlX");

var $f8Osq = parcelRequire("f8Osq");
const $eedb76548b89b59a$export$690b5fd7062ce607 = (0, $g1GqA.createLegacyEntry)((0, $emvlX.globalIssueNavigatorRoute), ()=>({
        apdexIgnoreParams: [
            'issueKey'
        ],
        canTransitionIn: ()=>false,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $f8Osq.LegacyPageWithTeamProfileCardView),
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $bf8b595cdc630add$export$8b2ce873c5336522)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource)
        ]
    }));

});
parcelRegister("emvlX", function(module, exports) {
$parcel$export(module.exports, "globalIssueNavigatorRoute", () => $5be771500caab14f$export$f4c8e8bc55cd2008);
const $5be771500caab14f$export$f4c8e8bc55cd2008 = {
    name: 'legacy-gin',
    path: '/issues/:issueKey(.*)?'
};

});

parcelRegister("f8Osq", function(module, exports) {
$parcel$export(module.exports, "LegacyPageWithTeamProfileCardView", () => $c42df60ec2f932c4$export$bc3f01ea4ac19d59);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jgKgn = parcelRequire("jgKgn");

var $gj88x = parcelRequire("gj88x");

var $JWotZ = parcelRequire("JWotZ");
const $c42df60ec2f932c4$export$bc3f01ea4ac19d59 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jgKgn.LegacyPage), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gj88x.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $JWotZ.default), null));
$c42df60ec2f932c4$export$bc3f01ea4ac19d59.displayName = "LegacyPageWithTeamProfileCardView";

});
parcelRegister("gj88x", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a9b02da700ec6dd$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2a9b02da700ec6dd$var$OpenHelpPanelLinkThroughEventListener = (0, $l8G1z.lazy)(()=>(parcelRequire("dddkm")), {
    ssr: false,
    moduleId: "./src/packages/platform/help-panel-button/src/services/open-help-panel-link-through-event-listener/index.tsx"
});
const $2a9b02da700ec6dd$export$9b28d5c0f56030a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "open-help-panel-link-through-event-listener",
        packageName: "jira-help-panel-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-open-help-panel-link-through-event-listener",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($2a9b02da700ec6dd$var$OpenHelpPanelLinkThroughEventListener, null)));
$2a9b02da700ec6dd$export$9b28d5c0f56030a7.displayName = "AsyncOpenHelpPanelLinkThroughEventListener";
var $2a9b02da700ec6dd$export$2e2bcd8739ae039 = $2a9b02da700ec6dd$export$9b28d5c0f56030a7;

});
parcelRegister("dddkm", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("lPmLi")
]).then(()=>parcelRequire('adoG2'));

});


parcelRegister("JWotZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0dbc92feb704f5e$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $h8QGu = parcelRequire("h8QGu");

var $a8EUd = parcelRequire("a8EUd");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d0dbc92feb704f5e$var$LegacyTeamProfileCard = (0, $l8G1z.lazy)(()=>(parcelRequire("9P1UR")), {
    moduleId: "./src/packages/platform/profilecard-next/src/ui/team-profilecard-legacy/index.tsx"
});
const $d0dbc92feb704f5e$export$c8a3662e461b7707 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "legacy-team-profile-card",
        packageName: "profilecard-next"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.default), {
        name: "async-legacy-team-profile-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d0dbc92feb704f5e$var$LegacyTeamProfileCard, props)));
$d0dbc92feb704f5e$export$c8a3662e461b7707.displayName = "AsyncLegacyTeamProfileCard";
var $d0dbc92feb704f5e$export$2e2bcd8739ae039 = $d0dbc92feb704f5e$export$c8a3662e461b7707;

});
parcelRegister("9P1UR", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("1h08q")
]).then(()=>parcelRequire('bL548'));

});




parcelRegister("kBLya", function(module, exports) {
$parcel$export(module.exports, "globalSettingsAddonsOauthRouteEntry", () => $749ac3c8c0c4e375$export$b674e2feb3ded4d1);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $hFYSn = parcelRequire("hFYSn");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $4Txum = parcelRequire("4Txum");
const $749ac3c8c0c4e375$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $749ac3c8c0c4e375$export$b674e2feb3ded4d1 = (0, $g1GqA.createLegacyEntry)((0, $4Txum.globalSettingsAddonsOauthRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            ...(0, $hFYSn.getNavigationSidebarGlobalSettingsResources)()
        ],
        entryPoint: ()=>$749ac3c8c0c4e375$var$pageEntryPoint
    }));

});
parcelRegister("4Txum", function(module, exports) {
$parcel$export(module.exports, "globalSettingsAddonsOauthRoute", () => $b5d62aa4477ce06b$export$13884c00b567e541);
const $b5d62aa4477ce06b$export$13884c00b567e541 = {
    name: 'global-settings-addons-oauth',
    path: '/secure/oauth-credentials'
};

});


parcelRegister("cMINT", function(module, exports) {
$parcel$export(module.exports, "emceeAppRouteEntry", () => $f6d059ce3be1c111$export$881c7d683ab02802);
/* eslint-disable import/order */ 


var $jgKgn = parcelRequire("jgKgn");

var $ju22D = parcelRequire("ju22D");

var $hFYSn = parcelRequire("hFYSn");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $7dxv9 = parcelRequire("7dxv9");
const $f6d059ce3be1c111$export$881c7d683ab02802 = (0, $g1GqA.createLegacyEntry)((0, $7dxv9.emceeAppRoute), ()=>({
        canTransitionIn: ()=>false,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jgKgn.LegacyPage),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0),
            menuId: (0, $2ab82cb6568ef9ea$export$e20d1bc819761c4c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            ...(0, $hFYSn.getNavigationSidebarGlobalSettingsResources)()
        ]
    }));

});
parcelRegister("7dxv9", function(module, exports) {
$parcel$export(module.exports, "emceeAppRoute", () => $6636c42641be75d9$export$5149e7851c6c4f53);
const $6636c42641be75d9$export$5149e7851c6c4f53 = {
    name: 'global-settings-addons-emcee',
    path: '/plugins/servlet/ac/com.atlassian.jira.emcee:environment(.?[\\w.]*)?/:page'
};

});


parcelRegister("3sRzJ", function(module, exports) {
$parcel$export(module.exports, "manageAppsRouteEntry", () => $367ac2f9863c985d$export$4ce557e11b5e9d68);
/* eslint-disable import/order */ 


var $jgKgn = parcelRequire("jgKgn");

var $ju22D = parcelRequire("ju22D");

var $hFYSn = parcelRequire("hFYSn");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $163VU = parcelRequire("163VU");
const $367ac2f9863c985d$export$4ce557e11b5e9d68 = (0, $g1GqA.createLegacyEntry)((0, $163VU.manageAppsRoute), ()=>({
        canTransitionIn: ()=>false,
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jgKgn.LegacyPage),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b0cb2d93dc70c89$export$d8f2d88b5bd966d0),
            menuId: (0, $2ab82cb6568ef9ea$export$e20d1bc819761c4c)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            ...(0, $hFYSn.getNavigationSidebarGlobalSettingsResources)()
        ]
    }));

});
parcelRegister("163VU", function(module, exports) {
$parcel$export(module.exports, "manageAppsRoute", () => $b5612c03d0ca8a53$export$d5409be3b4016aab);
const $b5612c03d0ca8a53$export$d5409be3b4016aab = {
    name: 'global-settings-addons-upm',
    path: '/plugins/servlet/upm'
};

});


parcelRegister("1ltG6", function(module, exports) {
$parcel$export(module.exports, "globalSettingsCustomFieldsRouteEntry", () => $cb19432dcb30c54d$export$d83c2e469d070766);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $8724D = parcelRequire("8724D");

var $35eqr = parcelRequire("35eqr");
const $cb19432dcb30c54d$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $cb19432dcb30c54d$export$d83c2e469d070766 = (0, $g1GqA.createLegacyEntry)((0, $8724D.globalSettingsCustomFieldsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$cb19432dcb30c54d$var$pageEntryPoint
    }));

});
parcelRegister("8724D", function(module, exports) {
$parcel$export(module.exports, "globalSettingsCustomFieldsRoute", () => $c84eced55e703a54$export$45e7d93edcc9507f);
const $c84eced55e703a54$export$45e7d93edcc9507f = {
    name: 'global-settings-issues-custom-fields-view',
    path: '/secure/admin/ViewCustomFields.jspa'
};

});


parcelRegister("7u3Zl", function(module, exports) {
$parcel$export(module.exports, "globalSettingsFieldLayoutSchemesRouteEntry", () => $64a66b8ab1d49319$export$c493b601f2512cdb);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $1419r = parcelRequire("1419r");

var $35eqr = parcelRequire("35eqr");
const $64a66b8ab1d49319$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $64a66b8ab1d49319$export$c493b601f2512cdb = (0, $g1GqA.createLegacyEntry)((0, $1419r.globalSettingsFieldLayoutSchemesRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$64a66b8ab1d49319$var$pageEntryPoint
    }));

});
parcelRegister("1419r", function(module, exports) {
$parcel$export(module.exports, "globalSettingsFieldLayoutSchemesRoute", () => $a5ff68ebc37238a4$export$6e04f01d8f54ad08);
const $a5ff68ebc37238a4$export$6e04f01d8f54ad08 = {
    name: 'global-settings-issues-fieldlayouts-schemes-view',
    path: '/secure/admin/ViewFieldLayoutSchemes.jspa'
};

});


parcelRegister("hu3le", function(module, exports) {
$parcel$export(module.exports, "globalSettingsFieldLayoutsRouteEntry", () => $d6d19fc6091cdc39$export$9988358457e7d230);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $80Q6k = parcelRequire("80Q6k");

var $35eqr = parcelRequire("35eqr");
const $d6d19fc6091cdc39$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d6d19fc6091cdc39$export$9988358457e7d230 = (0, $g1GqA.createLegacyEntry)((0, $80Q6k.globalSettingsFieldLayoutsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$d6d19fc6091cdc39$var$pageEntryPoint
    }));

});
parcelRegister("80Q6k", function(module, exports) {
$parcel$export(module.exports, "globalSettingsFieldLayoutsRoute", () => $af089929e3b65070$export$ead41dd3ea1da5b3);
const $af089929e3b65070$export$ead41dd3ea1da5b3 = {
    name: 'global-settings-issues-fieldlayouts-view',
    path: '/secure/admin/ViewFieldLayouts.jspa'
};

});


parcelRegister("ifpKr", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueSubtasksRouteEntry", () => $da6586d3b5bfc4c7$export$625e23490e28fdb5);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $4XO4t = parcelRequire("4XO4t");

var $35eqr = parcelRequire("35eqr");
const $da6586d3b5bfc4c7$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $da6586d3b5bfc4c7$export$625e23490e28fdb5 = (0, $g1GqA.createLegacyEntry)((0, $4XO4t.globalSettingsIssueSubtasksRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$da6586d3b5bfc4c7$var$pageEntryPoint
    }));

});
parcelRegister("4XO4t", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueSubtasksRoute", () => $fd199a9bdf7e4116$export$1327adfb7eea6607);
const $fd199a9bdf7e4116$export$1327adfb7eea6607 = {
    name: 'global-settings-issues-subtasks-manage',
    path: '/secure/admin/subtasks/ManageSubTasks.jspa'
};

});


parcelRegister("U4h2T", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTimeTrackingRouteEntry", () => $fe5f8a7f01439643$export$ad6c1602c9fe5020);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $juDWm = parcelRequire("juDWm");

var $35eqr = parcelRequire("35eqr");
const $fe5f8a7f01439643$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $fe5f8a7f01439643$export$ad6c1602c9fe5020 = (0, $g1GqA.createLegacyEntry)((0, $juDWm.globalSettingsIssueTimeTrackingRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$fe5f8a7f01439643$var$pageEntryPoint
    }));

});
parcelRegister("juDWm", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueTimeTrackingRoute", () => $81fa0fa729f70fb6$export$8596beec8543d958);
// like !default / !edit / %21viewLogs
const $81fa0fa729f70fb6$export$8596beec8543d958 = {
    name: 'global-settings-issues-time-tracking',
    path: '/secure/admin/TimeTrackingAdmin([!%]?[\\w]*).jspa'
};

});


parcelRegister("2HqSW", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueWorkflowRouteEntry", () => $53b4eabdbaa44987$export$460b4d1709d73a2e);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $k0etj = parcelRequire("k0etj");

var $35eqr = parcelRequire("35eqr");
const $53b4eabdbaa44987$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $53b4eabdbaa44987$export$460b4d1709d73a2e = (0, $g1GqA.createLegacyEntry)((0, $k0etj.globalSettingsIssueWorkflowRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$53b4eabdbaa44987$var$pageEntryPoint
    }));

});
parcelRegister("k0etj", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueWorkflowRoute", () => $83f9e78f44b1540c$export$83c76a9f38e044d2);
const $83f9e78f44b1540c$export$83c76a9f38e044d2 = {
    name: 'global-settings-issues-workflows-pages',
    path: '/secure/admin/workflows/:page'
};

});


parcelRegister("loTvH", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueWorkflowSchemesRouteEntry", () => $f7cbe041a81880af$export$cfc4572fe7838d46);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $jkH2J = parcelRequire("jkH2J");

var $35eqr = parcelRequire("35eqr");
const $f7cbe041a81880af$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $f7cbe041a81880af$export$cfc4572fe7838d46 = (0, $g1GqA.createLegacyEntry)((0, $jkH2J.globalSettingsIssueWorkflowSchemesRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$f7cbe041a81880af$var$pageEntryPoint
    }));

});
parcelRegister("jkH2J", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssueWorkflowSchemesRoute", () => $4bd5e08a891967d1$export$fabaf6e717c3f1b6);
const $4bd5e08a891967d1$export$fabaf6e717c3f1b6 = {
    name: 'global-settings-issues-workflows-schemes-view',
    path: '/secure/admin/ViewWorkflowSchemes.jspa'
};

});


parcelRegister("lUAuS", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsAssociateRouteEntry", () => $5b7b8c81d6b43788$export$580990afd7fb8505);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $biQ8h = parcelRequire("biQ8h");
const $5b7b8c81d6b43788$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $5b7b8c81d6b43788$export$580990afd7fb8505 = (0, $g1GqA.createLegacyEntry)((0, $biQ8h.globalSettingsIssuesCustomFieldsAssociateRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$5b7b8c81d6b43788$var$pageEntryPoint
    }));

});
parcelRegister("biQ8h", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsAssociateRoute", () => $e9028979835ba03d$export$4e17e29838928fe7);
const $e9028979835ba03d$export$4e17e29838928fe7 = {
    name: 'global-settings-issues-custom-fields-associate',
    path: '/secure/admin/AssociateFieldToScreens!default.jspa'
};

});


parcelRegister("eBZvu", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsConfigRouteEntry", () => $9768e4ff8d99cebc$export$f2078b26bfdef553);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $356xP = parcelRequire("356xP");
const $9768e4ff8d99cebc$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $9768e4ff8d99cebc$export$f2078b26bfdef553 = (0, $g1GqA.createLegacyEntry)((0, $356xP.globalSettingsIssuesCustomFieldsConfigRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$9768e4ff8d99cebc$var$pageEntryPoint
    }));

});
parcelRegister("356xP", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsConfigRoute", () => $3fbf69b14d16e067$export$db330236178a2eb2);
const $3fbf69b14d16e067$export$db330236178a2eb2 = {
    name: 'global-settings-issues-custom-fields-config',
    path: '/secure/admin/ConfigureCustomField!default.jspa'
};

});


parcelRegister("jbRqn", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsDeleteRouteEntry", () => $121f4098ec0e10fa$export$504c6fb2862492a1);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $5Yf0J = parcelRequire("5Yf0J");
const $121f4098ec0e10fa$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $121f4098ec0e10fa$export$504c6fb2862492a1 = (0, $g1GqA.createLegacyEntry)((0, $5Yf0J.globalSettingsIssuesCustomFieldsDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$121f4098ec0e10fa$var$pageEntryPoint
    }));

});
parcelRegister("5Yf0J", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsDeleteRoute", () => $5db261e8995f432a$export$36f7f639e35c6980);
const $5db261e8995f432a$export$36f7f639e35c6980 = {
    name: 'global-settings-issues-custom-fields-delete',
    path: '/secure/admin/DeleteCustomField!default.jspa'
};

});


parcelRegister("1ZysQ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsEditRouteEntry", () => $8201f818fc246cec$export$68ff9a44323b27ca);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $5KZQU = parcelRequire("5KZQU");
const $8201f818fc246cec$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $8201f818fc246cec$export$68ff9a44323b27ca = (0, $g1GqA.createLegacyEntry)((0, $5KZQU.globalSettingsIssuesCustomFieldsEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8201f818fc246cec$var$pageEntryPoint
    }));

});
parcelRegister("5KZQU", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsEditRoute", () => $f32194e8ccc83e23$export$ca7a3fa1760c59bf);
const $f32194e8ccc83e23$export$ca7a3fa1760c59bf = {
    name: 'global-settings-issues-custom-fields-edit',
    path: '/secure/admin/EditCustomField(\\w*)!default.jspa'
};

});


parcelRegister("co3sd", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsManageRouteEntry", () => $069f2c72e7a0bc63$export$12970e70b4c77f98);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $dMvlU = parcelRequire("dMvlU");
const $069f2c72e7a0bc63$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $069f2c72e7a0bc63$export$12970e70b4c77f98 = (0, $g1GqA.createLegacyEntry)((0, $dMvlU.globalSettingsIssuesCustomFieldsManageRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$069f2c72e7a0bc63$var$pageEntryPoint
    }));

});
parcelRegister("dMvlU", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsManageRoute", () => $8fa30b2c70d3b180$export$441ab7e26eb9710);
const $8fa30b2c70d3b180$export$441ab7e26eb9710 = {
    name: 'global-settings-issues-custom-fields-manage',
    path: '/secure/admin/ManageConfigurationScheme!default.jspa'
};

});


parcelRegister("eI6YQ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsTranslateRouteEntry", () => $ad261aa38cd42a6c$export$df186d4a4dcc70d6);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $7XMyZ = parcelRequire("7XMyZ");
const $ad261aa38cd42a6c$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $ad261aa38cd42a6c$export$df186d4a4dcc70d6 = (0, $g1GqA.createLegacyEntry)((0, $7XMyZ.globalSettingsIssuesCustomFieldsTranslateRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ad261aa38cd42a6c$var$pageEntryPoint
    }));

});
parcelRegister("7XMyZ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsTranslateRoute", () => $7fa719496587466e$export$13f985d12cff8c13);
const $7fa719496587466e$export$13f985d12cff8c13 = {
    name: 'global-settings-issues-custom-fields-translate',
    path: '/secure/admin/TranslateCustomField!default.jspa'
};

});


parcelRegister("cGjN7", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldAddRouteEntry", () => $08f7fdcbdc2fbc56$export$a0f9d2aa72494978);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $4NC7n = parcelRequire("4NC7n");
const $08f7fdcbdc2fbc56$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $08f7fdcbdc2fbc56$export$a0f9d2aa72494978 = (0, $g1GqA.createLegacyEntry)((0, $4NC7n.globalSettingsIssuesFieldAddRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$08f7fdcbdc2fbc56$var$pageEntryPoint
    }));

});
parcelRegister("4NC7n", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldAddRoute", () => $c86df3b6cf020cfc$export$7bb3a869061a8016);
const $c86df3b6cf020cfc$export$7bb3a869061a8016 = {
    name: 'global-settings-issues-field-add',
    path: '/secure/admin/AddNewFieldScreen.jspa'
};

});


parcelRegister("kemwP", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureEditRouteEntry", () => $52f0e4dab09fb833$export$26b162cdb704f0a0);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $f1MgX = parcelRequire("f1MgX");
const $52f0e4dab09fb833$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $52f0e4dab09fb833$export$26b162cdb704f0a0 = (0, $g1GqA.createLegacyEntry)((0, $f1MgX.globalSettingsIssuesFieldConfigureEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        entryPoint: ()=>$52f0e4dab09fb833$var$pageEntryPoint
    }));

});
parcelRegister("f1MgX", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureEditRoute", () => $c6f47fa5c64723a8$export$37908ebd0fc6f94c);
const $c6f47fa5c64723a8$export$37908ebd0fc6f94c = {
    name: 'global-settings-issues-field-configure-edit',
    path: '/secure/admin/EditDefaultFieldLayoutItem!default.jspa'
};

});


parcelRegister("hTsSv", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureRouteEntry", () => $a317aae4c473bef3$export$ce20a01bf6cc22e8);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $9iDbc = parcelRequire("9iDbc");
const $a317aae4c473bef3$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $a317aae4c473bef3$export$ce20a01bf6cc22e8 = (0, $g1GqA.createLegacyEntry)((0, $9iDbc.globalSettingsIssuesFieldConfigureRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$a317aae4c473bef3$var$pageEntryPoint
    }));

});
parcelRegister("9iDbc", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureRoute", () => $bce6bb836296d43b$export$47585e3c198123be);
const $bce6bb836296d43b$export$47585e3c198123be = {
    name: 'global-settings-issues-field-configure',
    path: '/secure/admin/ConfigureFieldScreen.jspa'
};

});


parcelRegister("eGsYp", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldCopyRouteEntry", () => $9e57f0251916de93$export$4d899a20474ade0);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $l97iC = parcelRequire("l97iC");
const $9e57f0251916de93$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $9e57f0251916de93$export$4d899a20474ade0 = (0, $g1GqA.createLegacyEntry)((0, $l97iC.globalSettingsIssuesFieldCopyRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$9e57f0251916de93$var$pageEntryPoint
    }));

});
parcelRegister("l97iC", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldCopyRoute", () => $7ffe5dca210d72f1$export$ec5bbfc3593b01b7);
const $7ffe5dca210d72f1$export$ec5bbfc3593b01b7 = {
    name: 'global-settings-issues-field-copy',
    path: '/secure/admin/ViewCopyFieldScreen.jspa'
};

});


parcelRegister("g1dQr", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldDeleteRouteEntry", () => $6d714a9b28d162a0$export$9170e2ce6999793e);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $i82K6 = parcelRequire("i82K6");
const $6d714a9b28d162a0$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $6d714a9b28d162a0$export$9170e2ce6999793e = (0, $g1GqA.createLegacyEntry)((0, $i82K6.globalSettingsIssuesFieldDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$6d714a9b28d162a0$var$pageEntryPoint
    }));

});
parcelRegister("i82K6", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldDeleteRoute", () => $f428979c9c5e89e7$export$9a0bc2a1c24ad312);
const $f428979c9c5e89e7$export$9a0bc2a1c24ad312 = {
    name: 'global-settings-issues-field-delete',
    path: '/secure/admin/ViewDeleteFieldScreen.jspa'
};

});


parcelRegister("fUhId", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldEditRouteEntry", () => $7e35d9f854c48a0b$export$4f6f7197ee5fbd88);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $eYMw3 = parcelRequire("eYMw3");
const $7e35d9f854c48a0b$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $7e35d9f854c48a0b$export$4f6f7197ee5fbd88 = (0, $g1GqA.createLegacyEntry)((0, $eYMw3.globalSettingsIssuesFieldEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$7e35d9f854c48a0b$var$pageEntryPoint
    }));

});
parcelRegister("eYMw3", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldEditRoute", () => $c91803441d347d5d$export$e41329d1f04b5b51);
const $c91803441d347d5d$export$e41329d1f04b5b51 = {
    name: 'global-settings-issues-field-edit',
    path: '/secure/admin/EditFieldScreen!default.jspa'
};

});


parcelRegister("kykBP", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesAddRouteEntry", () => $845e6e4d09a6aac4$export$3a842eb59e795637);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $9YBe5 = parcelRequire("9YBe5");
const $845e6e4d09a6aac4$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $845e6e4d09a6aac4$export$3a842eb59e795637 = (0, $g1GqA.createLegacyEntry)((0, $9YBe5.globalSettingsIssuesFieldSchemesAddRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        entryPoint: ()=>$845e6e4d09a6aac4$var$pageEntryPoint
    }));

});
parcelRegister("9YBe5", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesAddRoute", () => $eafde0f017136262$export$8b20e975ade5b676);
const $eafde0f017136262$export$8b20e975ade5b676 = {
    name: 'global-settings-issues-field-schemes-add',
    path: '/secure/admin/AddFieldConfigurationScheme!default.jspa'
};

});


parcelRegister("aReKf", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesConfigureRouteEntry", () => $df8d46db332df8ec$export$5f5a8b65a56acfea);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $gyVGx = parcelRequire("gyVGx");
const $df8d46db332df8ec$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $df8d46db332df8ec$export$5f5a8b65a56acfea = (0, $g1GqA.createLegacyEntry)((0, $gyVGx.globalSettingsIssuesFieldSchemesConfigureRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$df8d46db332df8ec$var$pageEntryPoint
    }));

});
parcelRegister("gyVGx", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesConfigureRoute", () => $c0e4adb804915534$export$6401bf37dfa17226);
const $c0e4adb804915534$export$6401bf37dfa17226 = {
    name: 'global-settings-issues-field-schemes-configure',
    path: '/secure/admin/ConfigureFieldScreenScheme.jspa'
};

});


parcelRegister("fTKsQ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesCopyRouteEntry", () => $37fbe62c5bc17f30$export$4c126f203951bdce);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $cJurs = parcelRequire("cJurs");
const $37fbe62c5bc17f30$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $37fbe62c5bc17f30$export$4c126f203951bdce = (0, $g1GqA.createLegacyEntry)((0, $cJurs.globalSettingsIssuesFieldSchemesCopyRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$37fbe62c5bc17f30$var$pageEntryPoint
    }));

});
parcelRegister("cJurs", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesCopyRoute", () => $d1af093657b2e019$export$195423dd1ef4cf0a);
const $d1af093657b2e019$export$195423dd1ef4cf0a = {
    name: 'global-settings-issues-field-schemes-copy',
    path: '/secure/admin/ViewCopyFieldScreenScheme.jspa'
};

});


parcelRegister("laSUo", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesDeleteRouteEntry", () => $91831d5eeca3aae9$export$a4609f789aeed81f);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $ceICl = parcelRequire("ceICl");
const $91831d5eeca3aae9$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $91831d5eeca3aae9$export$a4609f789aeed81f = (0, $g1GqA.createLegacyEntry)((0, $ceICl.globalSettingsIssuesFieldSchemesDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$91831d5eeca3aae9$var$pageEntryPoint
    }));

});
parcelRegister("ceICl", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesDeleteRoute", () => $93dd93559b7a5a07$export$998546ee0d8d0995);
const $93dd93559b7a5a07$export$998546ee0d8d0995 = {
    name: 'global-settings-issues-field-schemes-delete',
    path: '/secure/admin/ViewDeleteFieldScreenScheme.jspa'
};

});


parcelRegister("bPBIG", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditRouteEntry", () => $aa83fd3c3e960502$export$aabed4f53fb4f921);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $bOD00 = parcelRequire("bOD00");
const $aa83fd3c3e960502$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $aa83fd3c3e960502$export$aabed4f53fb4f921 = (0, $g1GqA.createLegacyEntry)((0, $bOD00.globalSettingsIssuesFieldSchemesEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$aa83fd3c3e960502$var$pageEntryPoint
    }));

});
parcelRegister("bOD00", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditRoute", () => $51044c1d1f66ba3f$export$c7b713e1fe2e026f);
const $51044c1d1f66ba3f$export$c7b713e1fe2e026f = {
    name: 'global-settings-issues-field-schemes-edit',
    path: '/secure/admin/EditFieldScreenScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("2AMNJ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditItemRouteEntry", () => $fe88175a3ef64fa8$export$e38b78ff4a960db6);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $bc7Dj = parcelRequire("bc7Dj");
const $fe88175a3ef64fa8$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $fe88175a3ef64fa8$export$e38b78ff4a960db6 = (0, $g1GqA.createLegacyEntry)((0, $bc7Dj.globalSettingsIssuesFieldSchemesEditItemRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$fe88175a3ef64fa8$var$pageEntryPoint
    }));

});
parcelRegister("bc7Dj", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditItemRoute", () => $d0eb3365a3aa139d$export$4606c3f78e4ec3db);
const $d0eb3365a3aa139d$export$4606c3f78e4ec3db = {
    name: 'global-settings-issues-field-schemes-edit-item',
    path: '/secure/admin/EditFieldScreenSchemeItem([!%]?[\\w]*).jspa'
};

});


parcelRegister("i2RxH", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldViewRouteEntry", () => $1961c22c3d86557e$export$25331ec7b1b8ebfb);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $04HLL = parcelRequire("04HLL");
const $1961c22c3d86557e$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $1961c22c3d86557e$export$25331ec7b1b8ebfb = (0, $g1GqA.createLegacyEntry)((0, $04HLL.globalSettingsIssuesFieldViewRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$1961c22c3d86557e$var$pageEntryPoint
    }));

});
parcelRegister("04HLL", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldViewRoute", () => $b081f25f7f8a74b1$export$1a32944e52a128e5);
const $b081f25f7f8a74b1$export$1a32944e52a128e5 = {
    name: 'global-settings-issues-field-view',
    path: '/secure/admin/ViewFieldsScreen.jspa'
};

});


parcelRegister("hNa9g", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsConfigRouteEntry", () => $df97196532c40172$export$8946e190202a15c7);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $gh8VJ = parcelRequire("gh8VJ");
const $df97196532c40172$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $df97196532c40172$export$8946e190202a15c7 = (0, $g1GqA.createLegacyEntry)((0, $gh8VJ.globalSettingsIssuesFieldlayoutsConfigRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$df97196532c40172$var$pageEntryPoint
    }));

});
parcelRegister("gh8VJ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsConfigRoute", () => $c7920aea813aff6d$export$b469488e0c133a32);
const $c7920aea813aff6d$export$b469488e0c133a32 = {
    name: 'global-settings-issues-fieldlayouts-config',
    path: '/secure/admin/ConfigureFieldLayout([!%]?[\\w]*).jspa'
};

});


parcelRegister("2grim", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsCopyRouteEntry", () => $17df4df91bdee8f2$export$c4d25de70db36bde);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $1iF51 = parcelRequire("1iF51");
const $17df4df91bdee8f2$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $17df4df91bdee8f2$export$c4d25de70db36bde = (0, $g1GqA.createLegacyEntry)((0, $1iF51.globalSettingsIssuesFieldlayoutsCopyRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$17df4df91bdee8f2$var$pageEntryPoint
    }));

});
parcelRegister("1iF51", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsCopyRoute", () => $1be70de0ec2e7694$export$3a9552d4b0f71408);
const $1be70de0ec2e7694$export$3a9552d4b0f71408 = {
    name: 'global-settings-issues-fieldlayouts-copy',
    path: '/secure/admin/CopyFieldLayout!default.jspa'
};

});


parcelRegister("5AfrI", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsDeleteRouteEntry", () => $50b3b95d1608358d$export$f2dfb8808ab4e2f2);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $9ZZAl = parcelRequire("9ZZAl");
const $50b3b95d1608358d$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $50b3b95d1608358d$export$f2dfb8808ab4e2f2 = (0, $g1GqA.createLegacyEntry)((0, $9ZZAl.globalSettingsIssuesFieldlayoutsDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$50b3b95d1608358d$var$pageEntryPoint
    }));

});
parcelRegister("9ZZAl", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsDeleteRoute", () => $cef4b8c1071c9b39$export$3ef4c145c5aa96b6);
const $cef4b8c1071c9b39$export$3ef4c145c5aa96b6 = {
    name: 'global-settings-issues-fieldlayouts-delete',
    path: '/secure/admin/DeleteFieldLayout!default.jspa'
};

});


parcelRegister("1wNrH", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsEditRouteEntry", () => $59985f5aa2282449$export$10710e2f7971e271);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $dflzM = parcelRequire("dflzM");
const $59985f5aa2282449$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $59985f5aa2282449$export$10710e2f7971e271 = (0, $g1GqA.createLegacyEntry)((0, $dflzM.globalSettingsIssuesFieldlayoutsEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$59985f5aa2282449$var$pageEntryPoint
    }));

});
parcelRegister("dflzM", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsEditRoute", () => $6a7e2735fa436538$export$3a0534b35ee08e33);
const $6a7e2735fa436538$export$3a0534b35ee08e33 = {
    name: 'global-settings-issues-fieldlayouts-edit',
    path: '/secure/admin/EditFieldLayout!default.jspa'
};

});


parcelRegister("hYZCI", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesConfigRouteEntry", () => $72d870eae8458875$export$5b791b0a90dab069);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $4vrAx = parcelRequire("4vrAx");
const $72d870eae8458875$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $72d870eae8458875$export$5b791b0a90dab069 = (0, $g1GqA.createLegacyEntry)((0, $4vrAx.globalSettingsIssuesFieldlayoutsSchemesConfigRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$72d870eae8458875$var$pageEntryPoint
    }));

});
parcelRegister("4vrAx", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesConfigRoute", () => $c9c942fc55292eab$export$97921be5feed3adf);
const $c9c942fc55292eab$export$97921be5feed3adf = {
    name: 'global-settings-issues-fieldlayouts-schemes-config',
    path: '/secure/admin/ConfigureFieldLayoutScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("jAJHa", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesCopyRouteEntry", () => $d26238057209b39d$export$e5d2e7b8b7eb3bf5);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $e1ufR = parcelRequire("e1ufR");
const $d26238057209b39d$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d26238057209b39d$export$e5d2e7b8b7eb3bf5 = (0, $g1GqA.createLegacyEntry)((0, $e1ufR.globalSettingsIssuesFieldlayoutsSchemesCopyRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$d26238057209b39d$var$pageEntryPoint
    }));

});
parcelRegister("e1ufR", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesCopyRoute", () => $40c87a065fea723e$export$71563f57601b0e2);
const $40c87a065fea723e$export$71563f57601b0e2 = {
    name: 'global-settings-issues-fieldlayouts-schemes-copy',
    path: '/secure/admin/CopyFieldLayoutScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("3y2tU", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesDeleteRouteEntry", () => $153e2192fbb5bbcf$export$c1e57f90dca7eb4c);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $7MhOv = parcelRequire("7MhOv");
const $153e2192fbb5bbcf$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $153e2192fbb5bbcf$export$c1e57f90dca7eb4c = (0, $g1GqA.createLegacyEntry)((0, $7MhOv.globalSettingsIssuesFieldlayoutsSchemesDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$153e2192fbb5bbcf$var$pageEntryPoint
    }));

});
parcelRegister("7MhOv", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesDeleteRoute", () => $387378f8072bb389$export$e1a49cd1071690c4);
const $387378f8072bb389$export$e1a49cd1071690c4 = {
    name: 'global-settings-issues-fieldlayouts-schemes-delete',
    path: '/secure/admin/DeleteFieldLayoutScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("3t2Qp", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEditRouteEntry", () => $ce3d5e20662cce65$export$99138c4ced2f05f7);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $6ci2C = parcelRequire("6ci2C");
const $ce3d5e20662cce65$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $ce3d5e20662cce65$export$99138c4ced2f05f7 = (0, $g1GqA.createLegacyEntry)((0, $6ci2C.globalSettingsIssuesFieldlayoutsSchemesEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ce3d5e20662cce65$var$pageEntryPoint
    }));

});
parcelRegister("6ci2C", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEditRoute", () => $d6ffbb1f10b8f4e5$export$a14fc516b4846e63);
const $d6ffbb1f10b8f4e5$export$a14fc516b4846e63 = {
    name: 'global-settings-issues-fieldlayouts-schemes-edit',
    path: '/secure/admin/EditFieldLayoutScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("cZVSE", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEntityRouteEntry", () => $d6de72ef149b12c6$export$a860d5fef4b2c724);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $dap4d = parcelRequire("dap4d");
const $d6de72ef149b12c6$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d6de72ef149b12c6$export$a860d5fef4b2c724 = (0, $g1GqA.createLegacyEntry)((0, $dap4d.globalSettingsIssuesFieldlayoutsSchemesEntityRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$d6de72ef149b12c6$var$pageEntryPoint
    }));

});
parcelRegister("dap4d", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEntityRoute", () => $fa65f2fdbcaa150f$export$54dfcbcea4cc773c);
const $fa65f2fdbcaa150f$export$54dfcbcea4cc773c = {
    name: 'global-settings-issues-fieldlayouts-schemes-entity',
    path: '/secure/admin/ViewEditFieldLayoutSchemeEntity([!%]?[\\w]*).jspa'
};

});


parcelRegister("baP9D", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldviewRouteEntry", () => $580c4ad1d6eb6df5$export$1258f6b3b3168b6a);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $kA0m2 = parcelRequire("kA0m2");
const $580c4ad1d6eb6df5$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $580c4ad1d6eb6df5$export$1258f6b3b3168b6a = (0, $g1GqA.createLegacyEntry)((0, $kA0m2.globalSettingsIssuesFieldviewRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$580c4ad1d6eb6df5$var$pageEntryPoint
    }));

});
parcelRegister("kA0m2", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesFieldviewRoute", () => $38eb85bed668475c$export$4e15d6f42067a40d);
const $38eb85bed668475c$export$4e15d6f42067a40d = {
    name: 'global-settings-issues-fieldview',
    path: '/secure/admin/ViewIssueFields.jspa'
};

});


parcelRegister("6PNEb", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesGeneralTranslationsRouteEntry", () => $2538e974b5dbc093$export$611de8afc4baaba5);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $aMrSh = parcelRequire("aMrSh");
const $2538e974b5dbc093$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $2538e974b5dbc093$export$611de8afc4baaba5 = (0, $g1GqA.createLegacyEntry)((0, $aMrSh.globalSettingsIssuesGeneralTranslationsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$2538e974b5dbc093$var$pageEntryPoint
    }));

});
parcelRegister("aMrSh", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesGeneralTranslationsRoute", () => $00e7f075e651aa28$export$82d4e60692b6b82);
const $00e7f075e651aa28$export$82d4e60692b6b82 = {
    name: 'global-settings-issues-general-translations',
    path: '/secure/admin/ViewTranslations!default.jspa'
};

});


parcelRegister("jiZlp", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesLinkTypesActivateRouteEntry", () => $c6771246bf55c7b2$export$a7de28edcb387644);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $2h2GD = parcelRequire("2h2GD");
const $c6771246bf55c7b2$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $c6771246bf55c7b2$export$a7de28edcb387644 = (0, $g1GqA.createLegacyEntry)((0, $2h2GD.globalSettingsIssuesLinkTypesActivateRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        entryPoint: ()=>$c6771246bf55c7b2$var$pageEntryPoint
    }));

});
parcelRegister("2h2GD", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesLinkTypesActivateRoute", () => $ac39adb976986ce0$export$3669b743a852443d);
const $ac39adb976986ce0$export$3669b743a852443d = {
    name: 'global-settings-issues-linktypes-activate',
    path: '/secure/admin/IssueLinkingActivate.jspa'
};

});


parcelRegister("5fmu9", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesLinkTypesDeactivateRouteEntry", () => $828aeb84a179982e$export$bcae6091ca248a97);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $cU3TY = parcelRequire("cU3TY");
const $828aeb84a179982e$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $828aeb84a179982e$export$bcae6091ca248a97 = (0, $g1GqA.createLegacyEntry)((0, $cU3TY.globalSettingsIssuesLinkTypesDeactivateRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        entryPoint: ()=>$828aeb84a179982e$var$pageEntryPoint
    }));

});
parcelRegister("cU3TY", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesLinkTypesDeactivateRoute", () => $90fc1f15023dd59e$export$3b168b9635205cc2);
const $90fc1f15023dd59e$export$3b168b9635205cc2 = {
    name: 'global-settings-issues-linktypes-deactivate',
    path: '/secure/admin/IssueLinkingDeActivate.jspa'
};

});


parcelRegister("9B1Cv", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesLinkTypesRouteEntry", () => $a52c337e0f1832bd$export$a96d582e6ce3db7f);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $gjvln = parcelRequire("gjvln");

var $35eqr = parcelRequire("35eqr");
const $a52c337e0f1832bd$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $a52c337e0f1832bd$export$a96d582e6ce3db7f = (0, $g1GqA.createLegacyEntry)((0, $gjvln.globalSettingsIssuesLinkTypesRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$a52c337e0f1832bd$var$pageEntryPoint
    }));

});
parcelRegister("gjvln", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesLinkTypesRoute", () => $a0a6419a8e70277c$export$ee4b5d966d77c912);
const $a0a6419a8e70277c$export$ee4b5d966d77c912 = {
    name: 'global-settings-issues-linktypes-view',
    path: '/secure/admin/ViewLinkTypes!default.jspa'
};

});


parcelRegister("geED8", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesLinktypesDeleteRouteEntry", () => $aa55407cabae6c19$export$5fed41168399db0a);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $50FfO = parcelRequire("50FfO");
const $aa55407cabae6c19$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $aa55407cabae6c19$export$5fed41168399db0a = (0, $g1GqA.createLegacyEntry)((0, $50FfO.globalSettingsIssuesLinktypesDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$aa55407cabae6c19$var$pageEntryPoint
    }));

});
parcelRegister("50FfO", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesLinktypesDeleteRoute", () => $70f26b5a607027b9$export$da95e063618de37b);
const $70f26b5a607027b9$export$da95e063618de37b = {
    name: 'global-settings-issues-linktypes-delete',
    path: '/secure/admin/DeleteLinkType!default.jspa'
};

});


parcelRegister("iNCEc", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesLinktypesEditRouteEntry", () => $b51cc9a89b4e82be$export$58d36c7fbe66c9af);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $cQ9ix = parcelRequire("cQ9ix");
const $b51cc9a89b4e82be$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $b51cc9a89b4e82be$export$58d36c7fbe66c9af = (0, $g1GqA.createLegacyEntry)((0, $cQ9ix.globalSettingsIssuesLinktypesEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$b51cc9a89b4e82be$var$pageEntryPoint
    }));

});
parcelRegister("cQ9ix", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesLinktypesEditRoute", () => $1dfc0447cb7de080$export$670f7372491286fd);
const $1dfc0447cb7de080$export$670f7372491286fd = {
    name: 'global-settings-issues-linktypes-edit',
    path: '/secure/admin/EditLinkType!default.jspa'
};

});


parcelRegister("iXdWk", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationAddRouteEntry", () => $71f88661f419d9bc$export$d52d95e2669ccb14);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $1jsTC = parcelRequire("1jsTC");
const $71f88661f419d9bc$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $71f88661f419d9bc$export$d52d95e2669ccb14 = (0, $g1GqA.createLegacyEntry)((0, $1jsTC.globalSettingsIssuesNotificationAddRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$71f88661f419d9bc$var$pageEntryPoint
    }));

});
parcelRegister("1jsTC", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationAddRoute", () => $922fc08dff4eaae4$export$493378d37b4f830);
const $922fc08dff4eaae4$export$493378d37b4f830 = {
    name: 'global-settings-issues-notification-add',
    path: '/secure/admin/AddNotification([!%]?[\\w]*).jspa'
};

});


parcelRegister("hbUuC", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationDeleteRouteEntry", () => $47148ec9e44a994c$export$e3ff68e9ac0a92e2);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $lRmt1 = parcelRequire("lRmt1");
const $47148ec9e44a994c$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $47148ec9e44a994c$export$e3ff68e9ac0a92e2 = (0, $g1GqA.createLegacyEntry)((0, $lRmt1.globalSettingsIssuesNotificationDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$47148ec9e44a994c$var$pageEntryPoint
    }));

});
parcelRegister("lRmt1", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationDeleteRoute", () => $919a067b556c88fc$export$7497920ead69d08f);
const $919a067b556c88fc$export$7497920ead69d08f = {
    name: 'global-settings-issues-notification-delete',
    path: '/secure/admin/DeleteNotification([!%]?[\\w]*).jspa'
};

});


parcelRegister("9P9Xc", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationEditRouteEntry", () => $6ed99647f2941776$export$256c34b63a2221ee);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $4mKnq = parcelRequire("4mKnq");
const $6ed99647f2941776$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $6ed99647f2941776$export$256c34b63a2221ee = (0, $g1GqA.createLegacyEntry)((0, $4mKnq.globalSettingsIssuesNotificationEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$6ed99647f2941776$var$pageEntryPoint
    }));

});
parcelRegister("4mKnq", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationEditRoute", () => $9a3dc0470148fcda$export$715522cf2d547eaf);
const $9a3dc0470148fcda$export$715522cf2d547eaf = {
    name: 'global-settings-issues-notification-edit',
    path: '/secure/admin/EditNotifications([!%]?[\\w]*).jspa'
};

});


parcelRegister("joziY", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeAddRouteEntry", () => $dff6f9a63f50e32d$export$f1f02571fc623886);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $93DzX = parcelRequire("93DzX");
const $dff6f9a63f50e32d$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $dff6f9a63f50e32d$export$f1f02571fc623886 = (0, $g1GqA.createLegacyEntry)((0, $93DzX.globalSettingsIssuesNotificationSchemeAddRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$dff6f9a63f50e32d$var$pageEntryPoint
    }));

});
parcelRegister("93DzX", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeAddRoute", () => $5af21c36e425a649$export$629ba048f31d2c0f);
const $5af21c36e425a649$export$629ba048f31d2c0f = {
    name: 'global-settings-issues-notification-scheme-add',
    path: '/secure/admin/AddNotificationScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("3rsEg", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeDeleteRouteEntry", () => $c791e5a5faf3c502$export$40145c5de888865f);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $3LXRU = parcelRequire("3LXRU");
const $c791e5a5faf3c502$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $c791e5a5faf3c502$export$40145c5de888865f = (0, $g1GqA.createLegacyEntry)((0, $3LXRU.globalSettingsIssuesNotificationSchemeDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$c791e5a5faf3c502$var$pageEntryPoint
    }));

});
parcelRegister("3LXRU", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeDeleteRoute", () => $24ddc5f1f55a17de$export$64a190266a30ffd6);
const $24ddc5f1f55a17de$export$64a190266a30ffd6 = {
    name: 'global-settings-issues-notification-scheme-delete',
    path: '/secure/admin/DeleteNotificationScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("9GNI6", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeEditRouteEntry", () => $2f2b22773a1ad952$export$856d15be55b1a791);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $3Pwt5 = parcelRequire("3Pwt5");
const $2f2b22773a1ad952$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $2f2b22773a1ad952$export$856d15be55b1a791 = (0, $g1GqA.createLegacyEntry)((0, $3Pwt5.globalSettingsIssuesNotificationSchemeEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$2f2b22773a1ad952$var$pageEntryPoint
    }));

});
parcelRegister("3Pwt5", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeEditRoute", () => $44f87140cf80a583$export$a7f8c6170a6db933);
const $44f87140cf80a583$export$a7f8c6170a6db933 = {
    name: 'global-settings-issues-notification-scheme-edit',
    path: '/secure/admin/EditNotificationScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("exF2p", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationViewRouteEntry", () => $f45d75516dc9514d$export$45dd8c9548b0054e);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $eoR7p = parcelRequire("eoR7p");

var $35eqr = parcelRequire("35eqr");
const $f45d75516dc9514d$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $f45d75516dc9514d$export$45dd8c9548b0054e = (0, $g1GqA.createLegacyEntry)((0, $eoR7p.globalSettingsIssuesNotificationViewRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$f45d75516dc9514d$var$pageEntryPoint
    }));

});
parcelRegister("eoR7p", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesNotificationViewRoute", () => $229b6c1c04a58516$export$bc2109e7325d1a16);
// like !default / !edit / %21viewLogs
const $229b6c1c04a58516$export$bc2109e7325d1a16 = {
    name: 'global-settings-issues-notification-view',
    path: '/secure/admin/ViewNotificationSchemes([!%]?[\\w]*).jspa'
};

});


parcelRegister("39LMV", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPermissionsEditRouteEntry", () => $e95e84aab860bd63$export$f49580b73c3ba83);
/* eslint-disable import/order */ 

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $9OQpQ = parcelRequire("9OQpQ");

var $leWXF = parcelRequire("leWXF");
const $e95e84aab860bd63$export$f49580b73c3ba83 = (0, $g1GqA.createLegacyEntry)((0, $9OQpQ.globalSettingsIssuesPermissionsEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $leWXF.LegacyEditPermissionsPage),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ]
    }));

});
parcelRegister("9OQpQ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPermissionsEditRoute", () => $065db67bdcde6e63$export$c7d87b3baf9e9a67);
const $065db67bdcde6e63$export$c7d87b3baf9e9a67 = {
    name: 'global-settings-issues-permissions-edit',
    path: '/secure/admin/EditPermissions([!%]?[\\w]*).jspa'
};

});

parcelRegister("leWXF", function(module, exports) {
$parcel$export(module.exports, "LegacyEditPermissionsPage", () => $c64bdc9ba7b90d0e$export$fb0bf0e5f8e439b9);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jgKgn = parcelRequire("jgKgn");
const $c64bdc9ba7b90d0e$export$fb0bf0e5f8e439b9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jgKgn.LegacyPage), props));
$c64bdc9ba7b90d0e$export$fb0bf0e5f8e439b9.displayName = "LegacyEditPermissionsPage";
var $c64bdc9ba7b90d0e$export$2e2bcd8739ae039 = $c64bdc9ba7b90d0e$export$fb0bf0e5f8e439b9;

});


parcelRegister("4sZGX", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesAddRouteEntry", () => $d2e6c28e7d0f2246$export$d475751e96368b33);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $6qQnu = parcelRequire("6qQnu");
const $d2e6c28e7d0f2246$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d2e6c28e7d0f2246$export$d475751e96368b33 = (0, $g1GqA.createLegacyEntry)((0, $6qQnu.globalSettingsIssuesPermissionsSchemesAddRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$d2e6c28e7d0f2246$var$pageEntryPoint
    }));

});
parcelRegister("6qQnu", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesAddRoute", () => $dce0d77a6dfa6591$export$f9c900df1268958);
const $dce0d77a6dfa6591$export$f9c900df1268958 = {
    name: 'global-settings-issues-permissions-schemes-add',
    path: '/secure/admin/AddPermissionScheme!default.jspa'
};

});


parcelRegister("95Slt", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesDeleteRouteEntry", () => $e4511ff343ff9a0a$export$af3ca420f50b74f8);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $f3iaF = parcelRequire("f3iaF");
const $e4511ff343ff9a0a$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $e4511ff343ff9a0a$export$af3ca420f50b74f8 = (0, $g1GqA.createLegacyEntry)((0, $f3iaF.globalSettingsIssuesPermissionsSchemesDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$e4511ff343ff9a0a$var$pageEntryPoint
    }));

});
parcelRegister("f3iaF", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesDeleteRoute", () => $7ef2dfa7344f2cc7$export$9cbf97d551da6de6);
const $7ef2dfa7344f2cc7$export$9cbf97d551da6de6 = {
    name: 'global-settings-issues-permissions-schemes-delete',
    path: '/secure/admin/DeletePermissionScheme!default.jspa'
};

});


parcelRegister("1ZCfi", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesEditRouteEntry", () => $13f29eaf8d69484f$export$a1aace45fc58c0c0);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $ikMbd = parcelRequire("ikMbd");
const $13f29eaf8d69484f$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $13f29eaf8d69484f$export$a1aace45fc58c0c0 = (0, $g1GqA.createLegacyEntry)((0, $ikMbd.globalSettingsIssuesPermissionsSchemesEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$13f29eaf8d69484f$var$pageEntryPoint
    }));

});
parcelRegister("ikMbd", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesEditRoute", () => $a7a9c2b7698b7383$export$baed669ce740350d);
const $a7a9c2b7698b7383$export$baed669ce740350d = {
    name: 'global-settings-issues-permissions-schemes-edit',
    path: '/secure/admin/EditPermissionScheme!default.jspa'
};

});


parcelRegister("asNKg", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesRouteEntry", () => $2533f3ef247045c8$export$92306855354418dd);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $d4TDf = parcelRequire("d4TDf");

var $35eqr = parcelRequire("35eqr");
const $2533f3ef247045c8$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $2533f3ef247045c8$export$92306855354418dd = (0, $g1GqA.createLegacyEntry)((0, $d4TDf.globalSettingsIssuesPermissionsSchemesRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$2533f3ef247045c8$var$pageEntryPoint
    }));

});
parcelRegister("d4TDf", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesRoute", () => $016b4ae4fe3c1ea6$export$152abbb6f806c87);
// like !default / !edit / %21viewLogs
const $016b4ae4fe3c1ea6$export$152abbb6f806c87 = {
    name: 'global-settings-issues-permissions-schemes-view',
    path: '/secure/admin/ViewPermissionSchemes([!%]?[\\w]*).jspa'
};

});


parcelRegister("b41Q3", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesProjectRouteEntry", () => $ab3664c17659b410$export$79f7bd4999f40475);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $2vUJ6 = parcelRequire("2vUJ6");
const $ab3664c17659b410$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $ab3664c17659b410$export$79f7bd4999f40475 = (0, $g1GqA.createLegacyEntry)((0, $2vUJ6.globalSettingsIssuesPermissionsSchemesProjectRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$ab3664c17659b410$var$pageEntryPoint
    }));

});
const $28266b9d90f7c617$export$624732ab55954dd9 = 'PROJECT_SETTINGS';

parcelRegister("i1PT6", function(module, exports) {
$parcel$export(module.exports, "licenseDetailsResource_DEPRECATED_DO_NOT_USE", () => $8bfba0fbd1bc2cba$export$92c4069b5349d086);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $8bfba0fbd1bc2cba$export$90749419e9042370);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $7edbf = parcelRequire("7edbf");
var $k6ufm = parcelRequire("k6ufm");


var $1UgtU = parcelRequire("1UgtU");
const $8bfba0fbd1bc2cba$export$92c4069b5349d086 = (0, $7edbf.createResource)({
    type: 'BUSINESS_LICENSE_DETAILS',
    getKey: ()=>'BUSINESS_LICENSE_DETAILS',
    getData: async (_routerContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        return (0, $1UgtU.fetchLicenseDetails)((0, $be8e573b9be9cc14$export$2b91517d6d5b4365), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity,
    isCritical: true
});
const $8bfba0fbd1bc2cba$export$90749419e9042370 = ()=>{
    const { data: data } = (0, $k6ufm.useResource)($8bfba0fbd1bc2cba$export$92c4069b5349d086);
    return Boolean(data?.isPremiumUserSeat);
};

});
/* eslint-disable jira/filename-case */ const $be8e573b9be9cc14$export$2b91517d6d5b4365 = `
query JiraBusinessLicenseDetails($cloudId:ID!) {
  jira {
    jwmLicensing(cloudId: $cloudId) {
      currentUserSeatEdition
    }
  }
}
`;

parcelRegister("1UgtU", function(module, exports) {
$parcel$export(module.exports, "fetchLicenseDetails", () => $de22e8b1ae29122c$export$ec058a82eccb31e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/import-whitelist

var $hFtK7 = parcelRequire("hFtK7");

var $6CfY5 = parcelRequire("6CfY5");

var $h2wCv = parcelRequire("h2wCv");
const $de22e8b1ae29122c$var$EMPTY_RESPONSE = {
    isPremiumUserSeat: false
};
const $de22e8b1ae29122c$export$ec058a82eccb31e = async (query, { cloudId: cloudId })=>{
    try {
        const response = await (0, $h2wCv.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        return {
            isPremiumUserSeat: response.data?.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $6CfY5.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessLicenseDetails', 'Something went wrong while fetching the license details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $hFtK7.fireErrorAnalytics)({
            meta: {
                id: 'licenseDetailsResource',
                packageName: 'jiraRouterResourcesBusinessLicenseDetails',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $de22e8b1ae29122c$var$EMPTY_RESPONSE;
};

});


parcelRegister("2vUJ6", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesProjectRoute", () => $95eb34d5067bd5ea$export$c29ffdea8ba3226d);
const $95eb34d5067bd5ea$export$c29ffdea8ba3226d = {
    name: 'legacy-project-settings-permissions-associate',
    path: '/secure/project/SelectProjectPermissionScheme!default.jspa'
};

});


parcelRegister("evO77", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDefaultRouteEntry", () => $5413306dda89bb1c$export$88a39202914c5905);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $5Vr78 = parcelRequire("5Vr78");
const $5413306dda89bb1c$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $5413306dda89bb1c$export$88a39202914c5905 = (0, $g1GqA.createLegacyEntry)((0, $5Vr78.globalSettingsIssuesPrioritiesDefaultRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$5413306dda89bb1c$var$pageEntryPoint
    }));

});
parcelRegister("5Vr78", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDefaultRoute", () => $fc19e5ba6b1e6623$export$83a29d1cc0270f5a);
const $fc19e5ba6b1e6623$export$83a29d1cc0270f5a = {
    name: 'global-settings-issues-priorities-default',
    path: '/secure/admin/MakeDefaultPriority([!%]?[\\w]*).jspa'
};

});


parcelRegister("kSZwk", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDeleteRouteEntry", () => $a96b73cad33ae896$export$e13fff0f49e2648b);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $5rRtY = parcelRequire("5rRtY");
const $a96b73cad33ae896$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $a96b73cad33ae896$export$e13fff0f49e2648b = (0, $g1GqA.createLegacyEntry)((0, $5rRtY.globalSettingsIssuesPrioritiesDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$a96b73cad33ae896$var$pageEntryPoint
    }));

});
parcelRegister("5rRtY", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDeleteRoute", () => $17c27e911ccf79cb$export$1092268c69e42aa4);
const $17c27e911ccf79cb$export$1092268c69e42aa4 = {
    name: 'global-settings-issues-priorities-delete',
    path: '/secure/admin/DeletePriority!default.jspa'
};

});


parcelRegister("cqiXy", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesEditRouteEntry", () => $3d7af3ea0b0a1558$export$cd447ff81bd82138);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $9AxZv = parcelRequire("9AxZv");
const $3d7af3ea0b0a1558$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $3d7af3ea0b0a1558$export$cd447ff81bd82138 = (0, $g1GqA.createLegacyEntry)((0, $9AxZv.globalSettingsIssuesPrioritiesEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$3d7af3ea0b0a1558$var$pageEntryPoint
    }));

});
parcelRegister("9AxZv", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesEditRoute", () => $c34c1dcedd9b502d$export$c0f633caf37ba40d);
const $c34c1dcedd9b502d$export$c0f633caf37ba40d = {
    name: 'global-settings-issues-priorities-edit',
    path: '/secure/admin/EditPriority!default.jspa'
};

});


parcelRegister("aRDx7", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRouteEntry", () => $fe36d69f3ee12c04$export$63a56a096ab0d260);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $kj6As = parcelRequire("kj6As");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $1418O = parcelRequire("1418O");
const $fe36d69f3ee12c04$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $fe36d69f3ee12c04$export$63a56a096ab0d260 = (0, $g1GqA.createLegacyEntry)((0, $1418O.globalSettingsIssuesPrioritiesRoute), ()=>({
        layout: (0, $kj6As.priorityMappingGlobalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$fe36d69f3ee12c04$var$pageEntryPoint
    }));

});
parcelRegister("kj6As", function(module, exports) {
$parcel$export(module.exports, "priorityMappingGlobalSettingsLayout", () => $da6dd8851e7bd51b$export$233c4c28b2b79294);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $ju22D = parcelRequire("ju22D");

var $QhQu4 = parcelRequire("QhQu4");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $da6dd8851e7bd51b$var$LegacyAsyncModals = (0, $l8G1z.lazyAfterPaint)(()=>(parcelRequire("gD4EA")), {
    ssr: false,
    moduleId: "./src/packages/platform/layouts-jira-priorities-mapping-global-settings-layout/src/ui/legacy-async-modals/index.tsx"
});
const $da6dd8851e7bd51b$export$4219cc7dcaa1716c = [
    $da6dd8851e7bd51b$var$LegacyAsyncModals
];
const $da6dd8851e7bd51b$export$233c4c28b2b79294 = (0, $QhQu4.composeLayouts)((0, $ju22D.globalSettingsLayout), {
    globalComponents: $da6dd8851e7bd51b$export$4219cc7dcaa1716c
});

});
parcelRegister("gD4EA", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("gtk4h").then(()=>parcelRequire('aLflk'));

});


parcelRegister("1418O", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", () => $e4b72fae49e3c386$export$518516cdf6b7cd83);
const $e4b72fae49e3c386$export$518516cdf6b7cd83 = {
    name: 'global-settings-issues-priorities',
    path: '/secure/admin/ViewPriorities.jspa'
};

});


parcelRegister("3lXoH", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesTranslationsRouteEntry", () => $25ca7fb2bbdf5ad2$export$3dd9e223f9189ad8);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $42gvr = parcelRequire("42gvr");
const $25ca7fb2bbdf5ad2$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $25ca7fb2bbdf5ad2$export$3dd9e223f9189ad8 = (0, $g1GqA.createLegacyEntry)((0, $42gvr.globalSettingsIssuesPrioritiesTranslationsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$25ca7fb2bbdf5ad2$var$pageEntryPoint
    }));

});
parcelRegister("42gvr", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesPrioritiesTranslationsRoute", () => $86ea19d5f2cbdde2$export$ac50c32d38c2abe0);
const $86ea19d5f2cbdde2$export$ac50c32d38c2abe0 = {
    name: 'global-settings-issues-priorities-translations',
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=priority'
    ]
};

});


parcelRegister("2g3Yz", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesResolutionsDefaultRouteEntry", () => $07448e34b614e2ef$export$48a6536027e4aff8);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $d8qXy = parcelRequire("d8qXy");
const $07448e34b614e2ef$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $07448e34b614e2ef$export$48a6536027e4aff8 = (0, $g1GqA.createLegacyEntry)((0, $d8qXy.globalSettingsIssuesResolutionsDefaultRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$07448e34b614e2ef$var$pageEntryPoint
    }));

});
parcelRegister("d8qXy", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesResolutionsDefaultRoute", () => $9a9fb7bb05e2a22b$export$3069447d64064849);
const $9a9fb7bb05e2a22b$export$3069447d64064849 = {
    name: 'global-settings-issues-resolutions-default',
    path: '/secure/admin/MakeDefaultResolution([!%]?[\\w]*).jspa'
};

});


parcelRegister("8f6PB", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesResolutionsDeleteRouteEntry", () => $2923039b7805b8f2$export$e4f8ecf8d9862ad4);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $6HOcT = parcelRequire("6HOcT");
const $2923039b7805b8f2$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $2923039b7805b8f2$export$e4f8ecf8d9862ad4 = (0, $g1GqA.createLegacyEntry)((0, $6HOcT.globalSettingsIssuesResolutionsDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$2923039b7805b8f2$var$pageEntryPoint
    }));

});
parcelRegister("6HOcT", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesResolutionsDeleteRoute", () => $77fae495b0b5f954$export$cef4d5289f287690);
const $77fae495b0b5f954$export$cef4d5289f287690 = {
    name: 'global-settings-issues-resolutions-delete',
    path: '/secure/admin/DeleteResolution!default.jspa'
};

});


parcelRegister("29YCR", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesResolutionsEditRouteEntry", () => $84102c3caf7f6c28$export$abc7d0979f67b53f);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $kBjxW = parcelRequire("kBjxW");
const $84102c3caf7f6c28$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $84102c3caf7f6c28$export$abc7d0979f67b53f = (0, $g1GqA.createLegacyEntry)((0, $kBjxW.globalSettingsIssuesResolutionsEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$84102c3caf7f6c28$var$pageEntryPoint
    }));

});
parcelRegister("kBjxW", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesResolutionsEditRoute", () => $69f8d8ef2219bc4a$export$92b7f2cef28676);
const $69f8d8ef2219bc4a$export$92b7f2cef28676 = {
    name: 'global-settings-issues-resolutions-edit',
    path: '/secure/admin/EditResolution!default.jspa'
};

});


parcelRegister("n1WJ6", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesResolutionsRouteEntry", () => $14fe944a727e9428$export$2fc29b05ae7ea40);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $4bn12 = parcelRequire("4bn12");

var $35eqr = parcelRequire("35eqr");
const $14fe944a727e9428$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $14fe944a727e9428$export$2fc29b05ae7ea40 = (0, $g1GqA.createLegacyEntry)((0, $4bn12.globalSettingsIssuesResolutionsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$14fe944a727e9428$var$pageEntryPoint
    }));

});
parcelRegister("4bn12", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesResolutionsRoute", () => $bcf69019d9ac4e72$export$7ad0e4697ed2a3ec);
const $bcf69019d9ac4e72$export$7ad0e4697ed2a3ec = {
    name: 'global-settings-issues-resolutions',
    path: '/secure/admin/ViewResolutions.jspa'
};

});


parcelRegister("5BBN1", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesResolutionsTranslationsRouteEntry", () => $0691084a84fb17e3$export$93bb5b2fc4a9a739);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $3SSyL = parcelRequire("3SSyL");
const $0691084a84fb17e3$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $0691084a84fb17e3$export$93bb5b2fc4a9a739 = (0, $g1GqA.createLegacyEntry)((0, $3SSyL.globalSettingsIssuesResolutionsTranslationsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$0691084a84fb17e3$var$pageEntryPoint
    }));

});
parcelRegister("3SSyL", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesResolutionsTranslationsRoute", () => $4e278a82add9620c$export$c84118fcbe41734c);
const $4e278a82add9620c$export$c84118fcbe41734c = {
    name: 'global-settings-issues-resolutions-translations',
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=resolution'
    ]
};

});


parcelRegister("7rO2n", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecurityEditRouteEntry", () => $f5cb2af5115e0fa3$export$fe5197eff63a479c);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $22JXX = parcelRequire("22JXX");
const $f5cb2af5115e0fa3$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $f5cb2af5115e0fa3$export$fe5197eff63a479c = (0, $g1GqA.createLegacyEntry)((0, $22JXX.globalSettingsIssuesSecurityEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$f5cb2af5115e0fa3$var$pageEntryPoint
    }));

});
parcelRegister("22JXX", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecurityEditRoute", () => $a88e560794368b5e$export$5f1d8fd298c25945);
const $a88e560794368b5e$export$5f1d8fd298c25945 = {
    name: 'global-settings-issues-security-edit',
    path: '/secure/admin/EditIssueSecurities([!%]?[\\w]*).jspa'
};

});


parcelRegister("4jrXk", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelAddRouteEntry", () => $1398f7c2baf3bd0a$export$32a0f47c80094c8a);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $cZBwS = parcelRequire("cZBwS");
const $1398f7c2baf3bd0a$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $1398f7c2baf3bd0a$export$32a0f47c80094c8a = (0, $g1GqA.createLegacyEntry)((0, $cZBwS.globalSettingsIssuesSecurityLevelAddRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        entryPoint: ()=>$1398f7c2baf3bd0a$var$pageEntryPoint
    }));

});
parcelRegister("cZBwS", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelAddRoute", () => $9c63072159a412a3$export$27fd05d5eac2b88);
const $9c63072159a412a3$export$27fd05d5eac2b88 = {
    name: 'global-settings-issues-security-level-add',
    path: '/secure/admin/AddIssueSecurity!default.jspa'
};

});


parcelRegister("esz7A", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelDeleteRouteEntry", () => $3c8fcd88ea2f6c26$export$566f3107971a2203);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $j8aPb = parcelRequire("j8aPb");
const $3c8fcd88ea2f6c26$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $3c8fcd88ea2f6c26$export$566f3107971a2203 = (0, $g1GqA.createLegacyEntry)((0, $j8aPb.globalSettingsIssuesSecurityLevelDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        entryPoint: ()=>$3c8fcd88ea2f6c26$var$pageEntryPoint
    }));

});
parcelRegister("j8aPb", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelDeleteRoute", () => $41d6d1c229b0b23c$export$9d60d6418ce002aa);
const $41d6d1c229b0b23c$export$9d60d6418ce002aa = {
    name: 'global-settings-issues-security-level-delete',
    path: '/secure/admin/DeleteIssueSecurityLevel!default.jspa'
};

});


parcelRegister("jY3PM", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelEditRouteEntry", () => $6dc7f816154dd39a$export$d5da255e04fa662f);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $59yso = parcelRequire("59yso");
const $6dc7f816154dd39a$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $6dc7f816154dd39a$export$d5da255e04fa662f = (0, $g1GqA.createLegacyEntry)((0, $59yso.globalSettingsIssuesSecurityLevelEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        entryPoint: ()=>$6dc7f816154dd39a$var$pageEntryPoint
    }));

});
parcelRegister("59yso", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelEditRoute", () => $fd0905a91ed42237$export$882588e58b7b7aa4);
const $fd0905a91ed42237$export$882588e58b7b7aa4 = {
    name: 'global-settings-issues-security-level-edit',
    path: '/secure/admin/EditSecurityLevel!default.jspa'
};

});


parcelRegister("eQs3z", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesAddRouteEntry", () => $8af72b3316991faf$export$a0157f60ff5930b1);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $3og15 = parcelRequire("3og15");
const $8af72b3316991faf$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $8af72b3316991faf$export$a0157f60ff5930b1 = (0, $g1GqA.createLegacyEntry)((0, $3og15.globalSettingsIssuesSecuritySchemesAddRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8af72b3316991faf$var$pageEntryPoint
    }));

});
parcelRegister("3og15", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesAddRoute", () => $e6c73bb3ff8334f1$export$1f38848b5541a84a);
const $e6c73bb3ff8334f1$export$1f38848b5541a84a = {
    name: 'global-settings-issues-security-schemes-add',
    path: '/secure/admin/AddIssueSecurityScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("9YCF1", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesDeleteRouteEntry", () => $c6c01ab74d73631b$export$9a262260e12c79c8);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $fOSxv = parcelRequire("fOSxv");
const $c6c01ab74d73631b$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $c6c01ab74d73631b$export$9a262260e12c79c8 = (0, $g1GqA.createLegacyEntry)((0, $fOSxv.globalSettingsIssuesSecuritySchemesDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$c6c01ab74d73631b$var$pageEntryPoint
    }));

});
parcelRegister("fOSxv", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesDeleteRoute", () => $a6c9b0eafde5774f$export$c653091a64df0f25);
const $a6c9b0eafde5774f$export$c653091a64df0f25 = {
    name: 'global-settings-issues-security-schemes-delete',
    path: '/secure/admin/DeleteIssueSecurityScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("dq2pp", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesEditRouteEntry", () => $efd71ba785840092$export$fd9e3acdd660a584);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $4oarL = parcelRequire("4oarL");
const $efd71ba785840092$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $efd71ba785840092$export$fd9e3acdd660a584 = (0, $g1GqA.createLegacyEntry)((0, $4oarL.globalSettingsIssuesSecuritySchemesEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$efd71ba785840092$var$pageEntryPoint
    }));

});
parcelRegister("4oarL", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesEditRoute", () => $fead75c51c824b63$export$bea68ab25bef976c);
const $fead75c51c824b63$export$bea68ab25bef976c = {
    name: 'global-settings-issues-security-schemes-edit',
    path: '/secure/admin/EditIssueSecurityScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("fyGsD", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesRouteEntry", () => $88613daab4fbc412$export$97cc0de5c7b8411a);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $4xmVl = parcelRequire("4xmVl");

var $35eqr = parcelRequire("35eqr");
const $88613daab4fbc412$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $88613daab4fbc412$export$97cc0de5c7b8411a = (0, $g1GqA.createLegacyEntry)((0, $4xmVl.globalSettingsIssuesSecuritySchemesRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$88613daab4fbc412$var$pageEntryPoint
    }));

});
parcelRegister("4xmVl", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesRoute", () => $c1fe257871d6bcd8$export$35f866ec59eb6111);
// like !default / !edit / %21viewLogs
const $c1fe257871d6bcd8$export$35f866ec59eb6111 = {
    name: 'global-settings-issues-security-schemes',
    path: '/secure/admin/ViewIssueSecuritySchemes([!%]?[\\w]*).jspa'
};

});


parcelRegister("768jg", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesStatusesRouteEntry", () => $d9c449f6f4ef5d7c$export$f736a667e7868236);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $fEE1C = parcelRequire("fEE1C");

var $35eqr = parcelRequire("35eqr");
const $d9c449f6f4ef5d7c$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d9c449f6f4ef5d7c$export$f736a667e7868236 = (0, $g1GqA.createLegacyEntry)((0, $fEE1C.globalSettingsIssuesStatusesRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$d9c449f6f4ef5d7c$var$pageEntryPoint
    }));

});
parcelRegister("fEE1C", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesStatusesRoute", () => $644a8cc4b3e7bb30$export$4f249f1de6014aa8);
const $644a8cc4b3e7bb30$export$4f249f1de6014aa8 = {
    name: 'global-settings-issues-statuses',
    path: '/secure/admin/ViewStatuses.jspa'
};

});


parcelRegister("lezMn", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesStatusesTranslationsRouteEntry", () => $70e29ef09c57e26e$export$6ae705ef4b0a0174);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $5PadE = parcelRequire("5PadE");
const $70e29ef09c57e26e$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $70e29ef09c57e26e$export$6ae705ef4b0a0174 = (0, $g1GqA.createLegacyEntry)((0, $5PadE.globalSettingsIssuesStatusesTranslationsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$70e29ef09c57e26e$var$pageEntryPoint
    }));

});
parcelRegister("5PadE", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesStatusesTranslationsRoute", () => $f5039007025fcbce$export$1766642f43dd1413);
const $f5039007025fcbce$export$1766642f43dd1413 = {
    name: 'global-settings-issues-statuses-translations',
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=status'
    ]
};

});


parcelRegister("9mbEK", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSubtasksDisableRouteEntry", () => $eb91f5bd4df0637f$export$62334310a9f11802);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $1y3wB = parcelRequire("1y3wB");
const $eb91f5bd4df0637f$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $eb91f5bd4df0637f$export$62334310a9f11802 = (0, $g1GqA.createLegacyEntry)((0, $1y3wB.globalSettingsIssuesSubtasksDisableRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        entryPoint: ()=>$eb91f5bd4df0637f$var$pageEntryPoint
    }));

});
parcelRegister("1y3wB", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSubtasksDisableRoute", () => $03e0355ced5554b2$export$d2a6ab37bbab7a2d);
const $03e0355ced5554b2$export$d2a6ab37bbab7a2d = {
    name: 'global-settings-issues-subtasks-disable',
    path: '/secure/admin/subtasks/DisableSubTasks!default.jspa'
};

});


parcelRegister("cciGB", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSubtasksEditRouteEntry", () => $ba77bafd46618063$export$ffc845bbb3fd5a36);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $cG2Fo = parcelRequire("cG2Fo");
const $ba77bafd46618063$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $ba77bafd46618063$export$ffc845bbb3fd5a36 = (0, $g1GqA.createLegacyEntry)((0, $cG2Fo.globalSettingsIssuesSubtasksEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ba77bafd46618063$var$pageEntryPoint
    }));

});
parcelRegister("cG2Fo", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSubtasksEditRoute", () => $1500e21560e31e11$export$6ab3581cc7d5f524);
const $1500e21560e31e11$export$6ab3581cc7d5f524 = {
    name: 'global-settings-issues-subtasks-edit',
    path: '/secure/admin/subtasks/EditSubTaskIssueTypes!default.jspa'
};

});


parcelRegister("jZqzF", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSubtasksTranlationsRouteEntry", () => $5d59888cdaacba1e$export$e03cf52d50503939);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $4krem = parcelRequire("4krem");
const $5d59888cdaacba1e$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $5d59888cdaacba1e$export$e03cf52d50503939 = (0, $g1GqA.createLegacyEntry)((0, $4krem.globalSettingsIssuesSubtasksTranlationsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$5d59888cdaacba1e$var$pageEntryPoint
    }));

});
parcelRegister("4krem", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesSubtasksTranlationsRoute", () => $83733ec2c7327e1d$export$5ebaadfa47e727e6);
const $83733ec2c7327e1d$export$5ebaadfa47e727e6 = {
    name: 'global-settings-issues-subtasks-tranlations',
    path: '/secure/admin/subtasks/ViewTranslations!default.jspa'
};

});


parcelRegister("kUjbH", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesDeleteRouteEntry", () => $d9f2aa67d78e19ac$export$5d0300325c3e456c);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $lqbn6 = parcelRequire("lqbn6");
const $d9f2aa67d78e19ac$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d9f2aa67d78e19ac$export$5d0300325c3e456c = (0, $g1GqA.createLegacyEntry)((0, $lqbn6.globalSettingsIssuesTypesDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$d9f2aa67d78e19ac$var$pageEntryPoint
    }));

});
parcelRegister("lqbn6", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesDeleteRoute", () => $86f3c07cf0a5f186$export$53c2f4353355a41b);
const $86f3c07cf0a5f186$export$53c2f4353355a41b = {
    name: 'global-settings-issues-types-delete',
    path: '/secure/admin/DeleteIssueType!default.jspa'
};

});


parcelRegister("elDq0", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesEditRouteEntry", () => $ac50952c7890d257$export$7e3e6487b18f13dd);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $j1MSm = parcelRequire("j1MSm");
const $ac50952c7890d257$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $ac50952c7890d257$export$7e3e6487b18f13dd = (0, $g1GqA.createLegacyEntry)((0, $j1MSm.globalSettingsIssuesTypesEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ac50952c7890d257$var$pageEntryPoint
    }));

});
parcelRegister("j1MSm", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesEditRoute", () => $02568e228628752e$export$26b7c50d91022a7);
const $02568e228628752e$export$26b7c50d91022a7 = {
    name: 'global-settings-issues-types-edit',
    path: '/secure/admin/EditIssueType!default.jspa'
};

});


parcelRegister("eaR7Y", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesMigrateRouteEntry", () => $b9d88631a72fd31a$export$5d1defdba7aabb03);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $dJbol = parcelRequire("dJbol");
const $b9d88631a72fd31a$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $b9d88631a72fd31a$export$5d1defdba7aabb03 = (0, $g1GqA.createLegacyEntry)((0, $dJbol.globalSettingsIssuesTypesMigrateRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$b9d88631a72fd31a$var$pageEntryPoint
    }));

});
parcelRegister("dJbol", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesMigrateRoute", () => $ce68607722f68950$export$6f6923c45a7c3d7d);
const $ce68607722f68950$export$6f6923c45a7c3d7d = {
    name: 'global-settings-issues-types-migrate',
    path: '/secure/admin/MigrateIssueTypes([!%]?[\\w]*).jspa'
};

});


parcelRegister("ebPIX", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateDefaultRouteEntry", () => $541d061515c5ecd3$export$7c04fddca02bf5e5);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $d0aYK = parcelRequire("d0aYK");
const $541d061515c5ecd3$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $541d061515c5ecd3$export$7c04fddca02bf5e5 = (0, $g1GqA.createLegacyEntry)((0, $d0aYK.globalSettingsIssuesTypesSchemesAssociateDefaultRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$541d061515c5ecd3$var$pageEntryPoint
    }));

});
parcelRegister("d0aYK", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateDefaultRoute", () => $2f7ef0b90f317f29$export$ce555a4492eeb41);
const $2f7ef0b90f317f29$export$ce555a4492eeb41 = {
    name: 'global-settings-issues-types-schemes-associate-default',
    path: '/secure/admin/AssociateIssueTypeSchemesWithDefault!default.jspa'
};

});


parcelRegister("aY5o9", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateRouteEntry", () => $c101747fda76d1ef$export$a4322d0977a716ec);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $h2hwd = parcelRequire("h2hwd");
const $c101747fda76d1ef$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $c101747fda76d1ef$export$a4322d0977a716ec = (0, $g1GqA.createLegacyEntry)((0, $h2hwd.globalSettingsIssuesTypesSchemesAssociateRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$c101747fda76d1ef$var$pageEntryPoint
    }));

});
parcelRegister("h2hwd", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateRoute", () => $a2b1490024cb0b43$export$695947f4bf787b08);
const $a2b1490024cb0b43$export$695947f4bf787b08 = {
    name: 'global-settings-issues-types-schemes-associate',
    path: '/secure/admin/AssociateIssueTypeSchemes!default.jspa'
};

});


parcelRegister("hP5Qs", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionDeleteRouteEntry", () => $4742b7a7c6cba98b$export$2486d5cbf90be36f);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $h8Raa = parcelRequire("h8Raa");
const $4742b7a7c6cba98b$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $4742b7a7c6cba98b$export$2486d5cbf90be36f = (0, $g1GqA.createLegacyEntry)((0, $h8Raa.globalSettingsIssuesTypesSchemesOptionDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$4742b7a7c6cba98b$var$pageEntryPoint
    }));

});
parcelRegister("h8Raa", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionDeleteRoute", () => $5501726af5de1c89$export$c6dca032125109f7);
const $5501726af5de1c89$export$c6dca032125109f7 = {
    name: 'global-settings-issues-types-schemes-option-delete',
    path: '/secure/admin/DeleteOptionScheme!default.jspa'
};

});


parcelRegister("e9m2Q", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionRouteEntry", () => $251a8911384b14e5$export$c604bf31fc1ec79f);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $tnRNp = parcelRequire("tnRNp");
const $251a8911384b14e5$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $251a8911384b14e5$export$c604bf31fc1ec79f = (0, $g1GqA.createLegacyEntry)((0, $tnRNp.globalSettingsIssuesTypesSchemesOptionRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$251a8911384b14e5$var$pageEntryPoint
    }));

});
parcelRegister("tnRNp", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionRoute", () => $dd1d408e01512b9f$export$e77dd31f52063355);
const $dd1d408e01512b9f$export$e77dd31f52063355 = {
    name: 'global-settings-issues-types-schemes-option',
    path: '/secure/admin/ConfigureOptionSchemes([!%]?[\\w]*).jspa'
};

});


parcelRegister("io0Bj", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesConfigureRouteEntry", () => $d8a4dee8cb0ac129$export$953b618d4334efe8);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $j7e6d = parcelRequire("j7e6d");
const $d8a4dee8cb0ac129$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d8a4dee8cb0ac129$export$953b618d4334efe8 = (0, $g1GqA.createLegacyEntry)((0, $j7e6d.globalSettingsIssuesTypesScreenSchemesConfigureRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$d8a4dee8cb0ac129$var$pageEntryPoint
    }));

});
parcelRegister("j7e6d", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesConfigureRoute", () => $a5d4fc4ef04bb19f$export$35a08f15e9b959ee);
const $a5d4fc4ef04bb19f$export$35a08f15e9b959ee = {
    name: 'global-settings-issues-types-screen-schemes-configure',
    path: '/secure/admin/ConfigureIssueTypeScreenScheme.jspa'
};

});


parcelRegister("hDa1Q", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesCopyRouteEntry", () => $e359ec148f974796$export$7f2d678246700c2);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $jKaJr = parcelRequire("jKaJr");
const $e359ec148f974796$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $e359ec148f974796$export$7f2d678246700c2 = (0, $g1GqA.createLegacyEntry)((0, $jKaJr.globalSettingsIssuesTypesScreenSchemesCopyRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$e359ec148f974796$var$pageEntryPoint
    }));

});
parcelRegister("jKaJr", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesCopyRoute", () => $5ed114bc75f2cd6b$export$56cacc1b264d8eec);
const $5ed114bc75f2cd6b$export$56cacc1b264d8eec = {
    name: 'global-settings-issues-types-screen-schemes-copy',
    path: '/secure/admin/ViewCopyIssueTypeScreenScheme.jspa'
};

});


parcelRegister("dmLxe", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesDeleteRouteEntry", () => $55a27a004f9243ba$export$5776296a4d01ebfc);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $6BHxN = parcelRequire("6BHxN");
const $55a27a004f9243ba$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $55a27a004f9243ba$export$5776296a4d01ebfc = (0, $g1GqA.createLegacyEntry)((0, $6BHxN.globalSettingsIssuesTypesScreenSchemesDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$55a27a004f9243ba$var$pageEntryPoint
    }));

});
parcelRegister("6BHxN", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesDeleteRoute", () => $536268fe762bf07e$export$3e0cfa858e2af787);
const $536268fe762bf07e$export$3e0cfa858e2af787 = {
    name: 'global-settings-issues-types-screen-schemes-delete',
    path: '/secure/admin/ViewDeleteIssueTypeScreenScheme.jspa'
};

});


parcelRegister("9XJ7h", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEditRouteEntry", () => $2c49f0f5c39db23b$export$c4d5ef3d480983a7);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $aYTc5 = parcelRequire("aYTc5");
const $2c49f0f5c39db23b$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $2c49f0f5c39db23b$export$c4d5ef3d480983a7 = (0, $g1GqA.createLegacyEntry)((0, $aYTc5.globalSettingsIssuesTypesScreenSchemesEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$2c49f0f5c39db23b$var$pageEntryPoint
    }));

});
parcelRegister("aYTc5", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEditRoute", () => $49f9e0494aa4f583$export$1ddbfff8d0b6f652);
const $49f9e0494aa4f583$export$1ddbfff8d0b6f652 = {
    name: 'global-settings-issues-types-screen-schemes-edit',
    path: '/secure/admin/EditIssueTypeScreenScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("3jgZv", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEntityRouteEntry", () => $45b672db8fab762b$export$13bfbf88a9e3596d);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $f5va4 = parcelRequire("f5va4");
const $45b672db8fab762b$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $45b672db8fab762b$export$13bfbf88a9e3596d = (0, $g1GqA.createLegacyEntry)((0, $f5va4.globalSettingsIssuesTypesScreenSchemesEntityRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$45b672db8fab762b$var$pageEntryPoint
    }));

});
parcelRegister("f5va4", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEntityRoute", () => $3ed47bada6cea483$export$dbd4ba90dd0ca938);
const $3ed47bada6cea483$export$dbd4ba90dd0ca938 = {
    name: 'global-settings-issues-types-screen-schemes-entity',
    path: '/secure/admin/ViewEditIssueTypeScreenSchemeEntity.jspa'
};

});


parcelRegister("8P2o9", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesTranslationsRouteEntry", () => $9a6c9f7100f1c172$export$4f9686f0681ca4ae);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $hAYlg = parcelRequire("hAYlg");
const $9a6c9f7100f1c172$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $9a6c9f7100f1c172$export$4f9686f0681ca4ae = (0, $g1GqA.createLegacyEntry)((0, $hAYlg.globalSettingsIssuesTypesTranslationsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$9a6c9f7100f1c172$var$pageEntryPoint
    }));

});
parcelRegister("hAYlg", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesTypesTranslationsRoute", () => $4ecfd50d6bcc1ce6$export$58b39a591d56ebd2);
const $4ecfd50d6bcc1ce6$export$58b39a591d56ebd2 = {
    name: 'global-settings-issues-types-translations',
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=issuetype'
    ]
};

});


parcelRegister("asISc", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionMetaAttributesRouteEntry", () => $6b45aeaa0abf3eb8$export$bf03c0c6f11d43ea);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $kdVCC = parcelRequire("kdVCC");
const $6b45aeaa0abf3eb8$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $6b45aeaa0abf3eb8$export$bf03c0c6f11d43ea = (0, $g1GqA.createLegacyEntry)((0, $kdVCC.globalSettingsIssuesWorkflowTransitionMetaAttributesRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        entryPoint: ()=>$6b45aeaa0abf3eb8$var$pageEntryPoint
    }));

});
parcelRegister("kdVCC", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionMetaAttributesRoute", () => $e838531bf8fb33e1$export$bc1d4dae621df0c5);
const $e838531bf8fb33e1$export$bc1d4dae621df0c5 = {
    name: 'global-settings-issues-workflow-transition-meta-attributes',
    path: '/secure/admin/ViewWorkflowTransitionMetaAttributes.jspa'
};

});


parcelRegister("8ITOT", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionRouteEntry", () => $81e1771c18cee0e3$export$fc7a930108b9d172);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $3EzMi = parcelRequire("3EzMi");
const $81e1771c18cee0e3$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $81e1771c18cee0e3$export$fc7a930108b9d172 = (0, $g1GqA.createLegacyEntry)((0, $3EzMi.globalSettingsIssuesWorkflowTransitionRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        entryPoint: ()=>$81e1771c18cee0e3$var$pageEntryPoint
    }));

});
parcelRegister("3EzMi", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionRoute", () => $57499ed8f986580d$export$1579038a55dade21);
const $57499ed8f986580d$export$1579038a55dade21 = {
    name: 'global-settings-issues-workflow-transition',
    path: '/secure/admin/ViewWorkflowTransition.jspa'
};

});


parcelRegister("7HddY", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesWorkflowsImportRouteEntry", () => $476a5b5d7668ee6b$export$3c5fdd60ca22958d);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $9fam2 = parcelRequire("9fam2");
const $476a5b5d7668ee6b$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $476a5b5d7668ee6b$export$3c5fdd60ca22958d = (0, $g1GqA.createLegacyEntry)((0, $9fam2.globalSettingsIssuesWorkflowsImportRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$476a5b5d7668ee6b$var$pageEntryPoint
    }));

});
parcelRegister("9fam2", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesWorkflowsImportRoute", () => $956d93d64784a18b$export$81f075f719f41037);
const $956d93d64784a18b$export$81f075f719f41037 = {
    name: 'global-settings-issues-workflows-import',
    path: '/plugins/servlet/wfshare-(import|export)'
};

});


parcelRegister("2pSk9", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesWorkflowsSchemesEditRouteEntry", () => $c2d177170070588d$export$22172eb9e4a9e4ae);
/* eslint-disable import/order */ 

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $1YB5q = parcelRequire("1YB5q");

var $baQu2 = parcelRequire("baQu2");
const $c2d177170070588d$export$22172eb9e4a9e4ae = (0, $g1GqA.createLegacyEntry)((0, $1YB5q.globalSettingsIssuesWorkflowsSchemesEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $baQu2.ProjectSettingsWorkflowsSchemesEdit)
    }));

});
parcelRegister("1YB5q", function(module, exports) {
$parcel$export(module.exports, "globalSettingsIssuesWorkflowsSchemesEditRoute", () => $eb8f6ba179f3c9f8$export$51a0d34ef3d00da8);
const $eb8f6ba179f3c9f8$export$51a0d34ef3d00da8 = {
    name: 'global-settings-issues-workflows-schemes-edit',
    path: '/secure/admin/EditWorkflowScheme.jspa'
};

});

parcelRegister("baQu2", function(module, exports) {
$parcel$export(module.exports, "ProjectSettingsWorkflowsSchemesEdit", () => $d281d58099b15a3d$export$46534748d4965ee9);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8dMdZ = parcelRequire("8dMdZ");

var $h8QGu = parcelRequire("h8QGu");

var $jgKgn = parcelRequire("jgKgn");

var $9imxF = parcelRequire("9imxF");

var $dWg4n = parcelRequire("dWg4n");
const $d281d58099b15a3d$var$LEGACY_WORKFLOW_DIAGRAM_LINKS_CLASS = 'workflow-diagram-view';
// This id is the main entry point for the project settings workflows schemes page that can be found in:
// `jira-domains/infrastructure/webapp/jira-webapp-resources/src/main/webapp/secure/admin/views/workflow/editworkflowscheme.jsp#lines-16`
const $d281d58099b15a3d$var$LEGACY_WORKFLOW_SCHEMES_EDITOR_ID = 'workflowscheme-editor';
const $d281d58099b15a3d$var$getLegacyWorkflowDiagramLinks = ()=>{
    const workflowDiagramLinksElem = globalThis.document?.getElementsByClassName($d281d58099b15a3d$var$LEGACY_WORKFLOW_DIAGRAM_LINKS_CLASS);
    return [
        ...workflowDiagramLinksElem ?? []
    ];
};
const $d281d58099b15a3d$var$getLegacyWorkflowsSchemeEditorElement = ()=>{
    return globalThis.document?.getElementById($d281d58099b15a3d$var$LEGACY_WORKFLOW_SCHEMES_EDITOR_ID);
};
const $d281d58099b15a3d$var$getLegacyWorkflowsPanelBody = ()=>{
    const workflowsPanel = globalThis.document?.getElementsByClassName('workflows-list');
    const workflowsPanelArray = [
        ...workflowsPanel ?? []
    ];
    return workflowsPanelArray.length > 0 ? workflowsPanelArray[0] : undefined;
};
const $d281d58099b15a3d$export$46534748d4965ee9 = (props)=>{
    const [selectedWorkflow, setSelectedWorkflow] = (0, $euxye.useState)(undefined);
    const handleOnClose = (0, $euxye.useCallback)(()=>{
        setSelectedWorkflow(undefined);
    }, [
        setSelectedWorkflow
    ]);
    (0, $euxye.useEffect)(()=>{
        let observer = null;
        const handleClicksOnWorkflowDiagramLinks = ()=>{
            const workflowsTable = $d281d58099b15a3d$var$getLegacyWorkflowsPanelBody();
            if (!workflowsTable) return;
            // Register click handlers to all legacy workflow diagram links
            workflowsTable.addEventListener('click', (event)=>{
                // We only want to handle clicks on the legacy workflow diagram links.
                // by checking the closest ancestor element with the class 'project-config-workflow-designer-link'
                // since the `event.target`can be any element inside the link (span for example)
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const diagramLinkElement = event.target.closest(`.${$d281d58099b15a3d$var$LEGACY_WORKFLOW_DIAGRAM_LINKS_CLASS}`);
                if (diagramLinkElement) {
                    event.preventDefault();
                    // We are missing the data attribute with the workflow name in the link element,
                    // so we need to find the closest ancestor row and get the workflow name from there
                    const workflowName = diagramLinkElement.closest('tr')?.getAttribute('data-workflow-name');
                    if (workflowName) setSelectedWorkflow(workflowName);
                }
            });
        };
        // If there are already legacy workflow diagram links, we register the click handler immediately.
        if ($d281d58099b15a3d$var$getLegacyWorkflowDiagramLinks().length > 0) handleClicksOnWorkflowDiagramLinks();
        else {
            // We only execute this once, when the `#workflowscheme-editor` is populated
            // This is because the workflows schemes page is rendered server-side and the links are
            // dynamically added to the DOM after the initial render.
            observer = new MutationObserver(()=>{
                handleClicksOnWorkflowDiagramLinks();
                observer && observer.disconnect();
            });
            const workflowsSchemeEditorElement = $d281d58099b15a3d$var$getLegacyWorkflowsSchemeEditorElement();
            if (workflowsSchemeEditorElement) observer.observe(workflowsSchemeEditorElement, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            $d281d58099b15a3d$var$getLegacyWorkflowsPanelBody()?.removeEventListener('click', handleClicksOnWorkflowDiagramLinks);
            observer && observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "read-only-workflow-schemes-diagram-error-boundary",
        packageName: "jiraRouterRoutesLegacyGlobalSettingsWorkflowsSchemesEditRouteEntries",
        teamName: "helix",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jgKgn.LegacyPage), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dWg4n.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9imxF.default), null, selectedWorkflow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8dMdZ.default), {
        workflowIdentifier: {
            workflowName: selectedWorkflow
        },
        onClose: handleOnClose
    })));
};
$d281d58099b15a3d$export$46534748d4965ee9.displayName = "ProjectSettingsWorkflowsSchemesEdit";

});
parcelRegister("8dMdZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b307db6241dc58a$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $aZMdt = parcelRequire("aZMdt");

var $gDAmF = parcelRequire("gDAmF");
const $0b307db6241dc58a$var$WorkflowViewDiagramModalApp = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceName: "workflowViewDiagram",
        sourceType: (0, $46f069e6c968f461$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gDAmF.WorkflowViewDiagramModal), props));
};
$0b307db6241dc58a$var$WorkflowViewDiagramModalApp.displayName = "WorkflowViewDiagramModalApp";
var $0b307db6241dc58a$export$2e2bcd8739ae039 = $0b307db6241dc58a$var$WorkflowViewDiagramModalApp;

});
parcelRegister("gDAmF", function(module, exports) {
$parcel$export(module.exports, "WorkflowViewDiagramModal", () => $780774eac7f74b5d$export$9d1d2bb6d6964541);

var $euxye = parcelRequire("euxye");

var $1q31W = parcelRequire("1q31W");

var $2700E = parcelRequire("2700E");

var $2v3yi = parcelRequire("2v3yi");

var $dNPnD = parcelRequire("dNPnD");

var $gpyJM = parcelRequire("gpyJM");

var $4vluQ = parcelRequire("4vluQ");

var $4qNCE = parcelRequire("4qNCE");

var $c69sa = parcelRequire("c69sa");
var $fbAgj = parcelRequire("fbAgj");

var $abhF2 = parcelRequire("abhF2");

var $j26jU = parcelRequire("j26jU");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $DIqjH = parcelRequire("DIqjH");

var $kt86l = parcelRequire("kt86l");


var $ccsIE = parcelRequire("ccsIE");

var $l8Dej = parcelRequire("l8Dej");

var $aqPkH = parcelRequire("aqPkH");

var $ioPOL = parcelRequire("ioPOL");

var $6Yoad = parcelRequire("6Yoad");
const $780774eac7f74b5d$var$closeButton = (0, $7eNDO.defineMessage)({
    id: "workflow-view-diagram-modal.close-button",
    defaultMessage: "Close"
});
const $780774eac7f74b5d$var$errorMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "We couldn\u2019t load the workflow.",
    id: "workflow-view-diagram-modal.error-message"
});
const $780774eac7f74b5d$var$INITIAL_ZOOM = 1;
const $780774eac7f74b5d$var$ERROR_IMAGE_MAX_HEIGHT = 212;
// Workflow Diagram Content Component
const $780774eac7f74b5d$var$WorkflowDiagramContent = ({ workflow: workflow, zoom: zoom, onZoomChange: onZoomChange, onZoomUpdate: onZoomUpdate })=>{
    const statuses = workflow.visibleStatuses.map(({ ref: statusId })=>workflow.allStatuses[statusId]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $780774eac7f74b5d$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $780774eac7f74b5d$var$diagramContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1q31W.default), {
        startNodeLayout: workflow.startNodeLayout,
        statuses: statuses,
        transitions: Object.values(workflow.transitions),
        zoom: zoom,
        isImmutable: true,
        onZoomUpdate: onZoomUpdate,
        collapseTransitionLabels: true,
        shouldShowGlobalLoops: true,
        ...(0, $2700E.expVal)('sprt_hix_9246_wfe_diagram_complete_workflowscope', 'isEnabled', false) && {
            workflowScope: workflow.scope.type
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ioPOL.ZoomControls), {
        zoom: zoom,
        onZoomChange: onZoomChange
    }));
};
$780774eac7f74b5d$var$WorkflowDiagramContent.displayName = "WorkflowDiagramContent";
const $780774eac7f74b5d$export$9d1d2bb6d6964541 = ({ projectId: projectId, workflowIdentifier: workflowIdentifier, onClose: onClose })=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [zoom, setZoom] = (0, $euxye.useState)($780774eac7f74b5d$var$INITIAL_ZOOM);
    const { data: workflow, isLoading: isLoading, hasError: hasError, customErrorMessage: customErrorMessage } = (0, $6Yoad.useWorkflowData)(cloudId, workflowIdentifier, projectId);
    const onZoomChange = (0, $euxye.useCallback)((newZoomValue)=>{
        setZoom(newZoomValue);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $DIqjH.JiraModal), {
        messageId: "workflow-view-diagram-modal.modal-dialog.workflow-diagram-view-modal",
        messageType: "transactional",
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true,
        onClose: onClose,
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $780774eac7f74b5d$var$modalContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gpyJM.default), {
        hasCloseButton: true
    }, workflow && !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dNPnD.default), {
        testId: "workflow-view-diagram-modal.modal-title"
    }, workflow.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2v3yi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $780774eac7f74b5d$var$contentStyles
    }, (()=>{
        if (!hasError && isLoading && !workflow) return(// Loading state
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
            xcss: $780774eac7f74b5d$var$centerWrapperStyles,
            testId: "workflow-view-diagram-modal.loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
            size: "large"
        })));
        if (hasError && !isLoading || !workflow) return(// Error state
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j26jU.default), {
            header: formatMessage($780774eac7f74b5d$var$errorMessage),
            maxImageHeight: $780774eac7f74b5d$var$ERROR_IMAGE_MAX_HEIGHT,
            renderImage: (0, $l8Dej.getAkEmptyStateRenderImageFn)((0, $ccsIE.default)),
            description: customErrorMessage || undefined
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($780774eac7f74b5d$var$WorkflowDiagramContent, {
            workflow: workflow,
            zoom: zoom,
            onZoomChange: onZoomChange,
            onZoomUpdate: setZoom
        });
    })())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4vluQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
        onClick: onClose,
        appearance: "subtle"
    }, formatMessage($780774eac7f74b5d$var$closeButton))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), null));
};
$780774eac7f74b5d$export$9d1d2bb6d6964541.displayName = "WorkflowViewDiagramModal";
const $780774eac7f74b5d$var$centerWrapperStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    height: '100%'
});
const $780774eac7f74b5d$var$wrapperStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    flexGrow: '1',
    minHeight: '352px',
    boxShadow: 'elevation.shadow.raised'
});
const $780774eac7f74b5d$var$diagramContentWrapperStyles = (0, $fbAgj.xcss)({
    width: '100%',
    height: 'auto'
});
const $780774eac7f74b5d$var$contentStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    height: '100%'
});
const $780774eac7f74b5d$var$getmodalcontentwrapperheight = ()=>`calc(100vh - ${0, $8d2c01fb745e4772$export$d60454526e2281af} - ${0, $8d2c01fb745e4772$export$d60454526e2281af})`;
const $780774eac7f74b5d$var$modalContentWrapperStyles = (0, $fbAgj.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    height: $780774eac7f74b5d$var$getmodalcontentwrapperheight(),
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: 'radius.small'
});

});
parcelRegister("1q31W", function(module, exports) {
$parcel$export(module.exports, "default", () => $48b83c07101b55b2$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $dCJKF = parcelRequire("dCJKF");

var $ink49 = parcelRequire("ink49");
const $48b83c07101b55b2$var$WrappedDiagram = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dCJKF.ReportErrors), {
        id: "unhandled",
        packageName: "jiraAccessibleWorkflowDiagram",
        teamName: "helix",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ink49.default), props));
$48b83c07101b55b2$var$WrappedDiagram.displayName = "WrappedDiagram";
var $48b83c07101b55b2$export$2e2bcd8739ae039 = $48b83c07101b55b2$var$WrappedDiagram;

});
parcelRegister("ink49", function(module, exports) {
$parcel$export(module.exports, "default", () => $659571add63a8536$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $1DCdt = parcelRequire("1DCdt");

var $i5aNJ = parcelRequire("i5aNJ");

var $aLlWy = parcelRequire("aLlWy");

var $9Mw1N = parcelRequire("9Mw1N");

var $as09W = parcelRequire("as09W");

var $gmYAN = parcelRequire("gmYAN");

var $kCbh0 = parcelRequire("kCbh0");

var $j4eLJ = parcelRequire("j4eLJ");
const $659571add63a8536$var$AccessibleDiagram = ({ statuses: statuses, transitions: transitions, errors: errors, startNodeLayout: startNodeLayout, globalLoopsContainerLayout: globalLoopsContainerLayout, zoom: zoom, panOffset: panOffset, isImmutable: isImmutable = false, selectedItem: selectedItem, onSelect: onSelect, onDrawCompleted: onDrawCompleted, onNodeUpdate: onNodeUpdate, onViewBoxChanged: onViewBoxChanged, onZoomUpdate: onZoomUpdate, onTransitionUpdate: onTransitionUpdate, onTransitionCreate: onTransitionCreate, onPanUpdate: onPanUpdate, onGlobalLoopsContainerMove: onGlobalLoopsContainerMove, onTargetChange: onTargetChange, onMinZoomChange: onMinZoomChange, collapseTransitionLabels: collapseTransitionLabels = false, shouldShowGlobalLoops: shouldShowGlobalLoops = false, workflowScope: workflowScope, minimumZoom: minimumZoom })=>{
    const [targetedItem, setTargetedItem] = (0, $euxye.useState)();
    const [movingItem, setMovingItem] = (0, $euxye.useState)(undefined);
    const [expandedItem, setExpandedItem] = (0, $euxye.useState)(undefined);
    const latestOnSelect = (0, $i5aNJ.useLatest)(onSelect);
    const latestOnDrawCompleted = (0, $i5aNJ.useLatest)(onDrawCompleted);
    const latestOnNodeUpdate = (0, $i5aNJ.useLatest)(onNodeUpdate);
    const latestOnViewBoxChanged = (0, $i5aNJ.useLatest)(onViewBoxChanged);
    const latestOnTransitionUpdate = (0, $i5aNJ.useLatest)(onTransitionUpdate);
    const latestOnTransitionCreate = (0, $i5aNJ.useLatest)(onTransitionCreate);
    const latestOnGlobalLoopsContainerMove = (0, $i5aNJ.useLatest)(onGlobalLoopsContainerMove);
    const latestOnTargetChange = (0, $i5aNJ.useLatest)(onTargetChange);
    const handleTargetChange = (0, $euxye.useCallback)((target)=>{
        setTargetedItem(target);
        latestOnTargetChange.current?.(target);
    }, [
        latestOnTargetChange
    ]);
    const diagramTransitions = (0, $euxye.useMemo)(()=>(0, $j4eLJ.toDiagramTransitions)(transitions, errors, statuses), [
        errors,
        statuses,
        transitions
    ]);
    const initialStatusId = diagramTransitions.find((transition)=>transition.type === 'direct' && transition.source === (0, $1DCdt.START_NODE_ID))?.target;
    const diagramStatuses = (0, $euxye.useMemo)(()=>(0, $j4eLJ.toDiagramStatuses)(statuses, workflowScope, initialStatusId, errors), [
        errors,
        initialStatusId,
        statuses,
        workflowScope
    ]);
    const startNodePosition = (0, $euxye.useMemo)(()=>(0, $j4eLJ.toDiagramStartNodePosition)(startNodeLayout), [
        startNodeLayout
    ]);
    const globalLoopsContainerPosition = (0, $euxye.useMemo)(()=>{
        return (0, $j4eLJ.toDiagramGlobalLoopsContainerPosition)(globalLoopsContainerLayout);
    }, [
        globalLoopsContainerLayout
    ]);
    const onRenderComplete = (0, $euxye.useCallback)(()=>{
        latestOnDrawCompleted.current?.('INITIAL');
    }, [
        latestOnDrawCompleted
    ]);
    const onSelectItem = (0, $euxye.useCallback)((item)=>{
        if (!item) {
            latestOnSelect.current?.(undefined);
            return;
        }
        latestOnSelect.current?.({
            id: item.id,
            type: item.type
        });
    }, [
        latestOnSelect
    ]);
    const onItemMove = (0, $euxye.useCallback)((payload)=>{
        if (payload.type === (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE)) latestOnGlobalLoopsContainerMove.current?.(payload.position);
        else latestOnNodeUpdate.current?.({
            id: payload.id,
            layout: payload.position
        });
    }, [
        latestOnGlobalLoopsContainerMove,
        latestOnNodeUpdate
    ]);
    const clearGlobalLoopsContainerPosition = (0, $euxye.useCallback)(()=>{
        latestOnGlobalLoopsContainerMove.current?.({});
    }, [
        latestOnGlobalLoopsContainerMove
    ]);
    const handleTransitionCreateNew = (0, $euxye.useCallback)((transition)=>{
        latestOnTransitionCreate.current?.((0, $j4eLJ.getTransitionConnectionInfo)(transition));
    }, [
        latestOnTransitionCreate
    ]);
    const handleTransitionPortChangeNew = (0, $euxye.useCallback)((transition)=>{
        latestOnTransitionUpdate.current?.({
            id: transition.id,
            ...(0, $j4eLJ.getTransitionConnectionInfo)(transition)
        });
    }, [
        latestOnTransitionUpdate
    ]);
    const [currentPan, updatePan] = (0, $9Mw1N.useControllable)(panOffset, onPanUpdate, (0, $as09W.DEFAULT_PAN));
    const [currentZoom, updateZoom] = (0, $9Mw1N.useControllable)(zoom, onZoomUpdate, (0, $as09W.DEFAULT_ZOOM_LEVEL));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $kCbh0.default), {
        onExpandedChange: setExpandedItem,
        expandedItem: expandedItem,
        startNodePosition: startNodePosition,
        globalLoopsContainerPosition: globalLoopsContainerPosition,
        statuses: statuses,
        transitions: transitions,
        errors: errors,
        isImmutable: isImmutable,
        movingItem: movingItem,
        selectedItem: selectedItem,
        zoom: currentZoom,
        pan: currentPan,
        minZoom: minimumZoom,
        workflowScope: workflowScope,
        onSelect: latestOnSelect.current,
        onTargetChange: handleTargetChange,
        setMovingItem: setMovingItem,
        onItemMove: onItemMove,
        onZoomChange: updateZoom,
        onPanChange: updatePan
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gmYAN.default), {
        isImmutable: isImmutable,
        transitions: diagramTransitions,
        startNodePosition: startNodePosition,
        globalLoopsContainerPosition: globalLoopsContainerPosition,
        onClearGlobalLoopsContainerPosition: clearGlobalLoopsContainerPosition,
        statuses: diagramStatuses,
        selectedItem: selectedItem ?? undefined,
        targetedItem: targetedItem,
        movingItem: movingItem,
        zoom: currentZoom,
        pan: currentPan,
        onViewBoxChange: latestOnViewBoxChanged.current,
        onZoomChange: updateZoom,
        onPanChange: updatePan,
        onRenderComplete: onRenderComplete,
        onItemMove: onItemMove,
        onMinZoomChange: onMinZoomChange,
        minimumZoom: minimumZoom,
        onTransitionCreate: handleTransitionCreateNew,
        onTransitionPortChange: handleTransitionPortChangeNew,
        onSelect: onSelectItem,
        collapseTransitionLabels: collapseTransitionLabels,
        shouldShowGlobalLoops: shouldShowGlobalLoops,
        expandedItem: expandedItem,
        onExpandedChange: setExpandedItem
    }));
};
$659571add63a8536$var$AccessibleDiagram.displayName = "AccessibleDiagram";
var $659571add63a8536$export$2e2bcd8739ae039 = $659571add63a8536$var$AccessibleDiagram;

});
parcelRegister("1DCdt", function(module, exports) {
$parcel$export(module.exports, "START_NODE_ID", () => $ce752d9b23587666$export$e117396b0784c7cc);
$parcel$export(module.exports, "transitionType", () => $ce752d9b23587666$export$331d6399b2e33350);
$parcel$export(module.exports, "SCOPE_GLOBAL", () => $ce752d9b23587666$export$9bb188cec3fcc43d);
$parcel$export(module.exports, "SCOPE_PROJECT", () => $ce752d9b23587666$export$54c3a1cc8eb1bc43);
$parcel$export(module.exports, "ALL_OPERATION", () => $ce752d9b23587666$export$d3dc8e33b7258fc5);
$parcel$export(module.exports, "STATUS_CATEGORY_WEIGHTS", () => $ce752d9b23587666$export$8fc40e3c53b7f30e);
$parcel$export(module.exports, "ANY_OPERATION", () => $ce752d9b23587666$export$804f62993e553350);
$parcel$export(module.exports, "errorSeverity", () => $ce752d9b23587666$export$927c560a42a52ce0);
$parcel$export(module.exports, "ruleErrorCodes", () => $ce752d9b23587666$export$64e068df1759c7c4);
/* eslint-disable jira/filename-case */ 
var $10Vo7 = parcelRequire("10Vo7");
const $ce752d9b23587666$export$e117396b0784c7cc = 'START';
const $ce752d9b23587666$export$331d6399b2e33350 = {
    INITIAL: 'INITIAL',
    GLOBAL: 'GLOBAL',
    DIRECTED: 'DIRECTED'
};
const $ce752d9b23587666$export$9bb188cec3fcc43d = 'GLOBAL';
const $ce752d9b23587666$export$54c3a1cc8eb1bc43 = 'PROJECT';
const $ce752d9b23587666$export$d3dc8e33b7258fc5 = 'ALL';
const $ce752d9b23587666$export$8fc40e3c53b7f30e = {
    [(0, $10Vo7.TODO)]: 1,
    [(0, $10Vo7.IN_PROGRESS)]: 2,
    [(0, $10Vo7.DONE)]: 3,
    [(0, $10Vo7.UNDEFINED)]: 4
};
const $ce752d9b23587666$export$804f62993e553350 = 'ANY';
const $ce752d9b23587666$export$927c560a42a52ce0 = {
    WARNING: 'WARNING',
    ERROR: 'ERROR'
};
const $ce752d9b23587666$export$64e068df1759c7c4 = {
    FIELD_NOT_FOUND: 'FIELD_NOT_FOUND',
    TRANSITION_SCREEN_FIELD_NOT_FOUND: 'TRANSITION_SCREEN_FIELD_NOT_FOUND',
    FIELD_NOT_PRESENT_IN_ALL_ISSUE_TYPES: 'FIELD_NOT_PRESENT_IN_ALL_ISSUE_TYPES',
    TRANSITION_SCREEN_FIELD_NOT_PRESENT_IN_ALL_ISSUE_TYPES: 'TRANSITION_SCREEN_FIELD_NOT_PRESENT_IN_ALL_ISSUE_TYPES',
    MISSING_RULE_PARAMETER: 'MISSING_RULE_PARAMETER',
    PREVIOUS_STATUS_NOT_FOUND: 'PREVIOUS_STATUS_NOT_FOUND',
    FIELD_VALUE_NOT_FOUND: 'FIELD_VALUE_NOT_FOUND',
    UNSUPPORTED_RULE: 'UNSUPPORTED_RULE',
    ASSIGNEE_NOT_FOUND: 'ASSIGNEE_NOT_FOUND',
    PROJECT_ROLE_NOT_FOUND: 'PROJECT_ROLE_NOT_FOUND',
    UNSUPPORTED_FIELD_TYPE_FOR_RULE: 'UNSUPPORTED_FIELD_TYPE_FOR_RULE',
    WORKFLOW_NAME_CONFLICT: 'WORKFLOW_NAME_CONFLICT',
    RESERVED_WORKFLOW_NAME: 'RESERVED_WORKFLOW_NAME'
};

});
parcelRegister("10Vo7", function(module, exports) {
$parcel$export(module.exports, "UNDEFINED", () => $e950bdb0fb2f6aca$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e950bdb0fb2f6aca$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e950bdb0fb2f6aca$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e950bdb0fb2f6aca$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e950bdb0fb2f6aca$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e950bdb0fb2f6aca$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e950bdb0fb2f6aca$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e950bdb0fb2f6aca$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e950bdb0fb2f6aca$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e950bdb0fb2f6aca$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e950bdb0fb2f6aca$export$d928f247c903643a);
/* eslint-disable jira/filename-case */ const $e950bdb0fb2f6aca$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e950bdb0fb2f6aca$export$aa456a5030160740 = 'TODO';
const $e950bdb0fb2f6aca$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e950bdb0fb2f6aca$export$71efb3495f6084f2 = 'DONE';
const $e950bdb0fb2f6aca$export$d9119300f9d9a815 = [
    $e950bdb0fb2f6aca$export$6db089fe7b26f5b6,
    $e950bdb0fb2f6aca$export$aa456a5030160740,
    $e950bdb0fb2f6aca$export$5a9ac66c2785cc13,
    $e950bdb0fb2f6aca$export$71efb3495f6084f2
];
const $e950bdb0fb2f6aca$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e950bdb0fb2f6aca$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e950bdb0fb2f6aca$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e950bdb0fb2f6aca$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e950bdb0fb2f6aca$export$71efb3495f6084f2
    }
];
const $e950bdb0fb2f6aca$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e950bdb0fb2f6aca$export$3f42f49c284d5b58 = Object.freeze({
    [$e950bdb0fb2f6aca$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e950bdb0fb2f6aca$export$5d42a08d46cffe7.NEW]: 2,
    [$e950bdb0fb2f6aca$export$5d42a08d46cffe7.DONE]: 3,
    [$e950bdb0fb2f6aca$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e950bdb0fb2f6aca$export$f3f919dc0f56d9eb = Object.values($e950bdb0fb2f6aca$export$5d42a08d46cffe7);
const $e950bdb0fb2f6aca$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e950bdb0fb2f6aca$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e950bdb0fb2f6aca$export$6db089fe7b26f5b6;
};
const $e950bdb0fb2f6aca$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e950bdb0fb2f6aca$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e950bdb0fb2f6aca$export$d928f247c903643a = (key)=>$e950bdb0fb2f6aca$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("i5aNJ", function(module, exports) {
$parcel$export(module.exports, "useLatest", () => $8556b41fd55d3111$export$d4b699e2c1148419);

var $euxye = parcelRequire("euxye");
const $8556b41fd55d3111$export$d4b699e2c1148419 = (value)=>{
    const latestValueRef = (0, $euxye.useRef)(value);
    latestValueRef.current = value;
    return latestValueRef;
};

});

parcelRegister("aLlWy", function(module, exports) {
$parcel$export(module.exports, "NODE_TYPE", () => $7b4cf6f2868f49ef$export$accaa52ddae3fe58);
$parcel$export(module.exports, "EDGE_TYPE", () => $7b4cf6f2868f49ef$export$97a9b8cddf240cf5);
$parcel$export(module.exports, "GLOBAL_LOOPS_CONTAINER_TYPE", () => $7b4cf6f2868f49ef$export$7d4b2f678780aa0e);
$parcel$export(module.exports, "DIAGRAM_CONTAINER_TYPE", () => $7b4cf6f2868f49ef$export$7404c17aa85d8d13);
$parcel$export(module.exports, "STATUS_GLOBAL_TRANSITIONS_TYPE", () => $7b4cf6f2868f49ef$export$efa56fe3f3360934);
$parcel$export(module.exports, "DIRECTION_KEYS", () => $7b4cf6f2868f49ef$export$7a24a077d7a1fcef);
$parcel$export(module.exports, "ZOOM_KEYS", () => $7b4cf6f2868f49ef$export$f9f0f7b18f298734);
/* eslint-disable jira/filename-case */ const $7b4cf6f2868f49ef$export$accaa52ddae3fe58 = 'node';
const $7b4cf6f2868f49ef$export$97a9b8cddf240cf5 = 'edge';
const $7b4cf6f2868f49ef$export$7d4b2f678780aa0e = 'global-loops-container';
const $7b4cf6f2868f49ef$export$7404c17aa85d8d13 = 'diagram-container';
const $7b4cf6f2868f49ef$export$efa56fe3f3360934 = 'status-global-transitions';
const $7b4cf6f2868f49ef$export$7a24a077d7a1fcef = {
    ArrowUp: 'up',
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right'
};
const $7b4cf6f2868f49ef$export$f9f0f7b18f298734 = {
    '+': 'IN',
    '=': 'IN',
    '-': 'OUT',
    _: 'OUT'
};

});

parcelRegister("9Mw1N", function(module, exports) {
$parcel$export(module.exports, "useControllable", () => $cd5dafafef224715$export$454217e89aea72b);
/**
 * Use in scenarios where you want an optionally controlled prop.
 * If the prop is defined its value will be used otherwise local state will be used.
 * Using the provided update function ensures that the state is updated and change callback function is called (if given).
 */ 
var $euxye = parcelRequire("euxye");

var $i5aNJ = parcelRequire("i5aNJ");
function $cd5dafafef224715$export$454217e89aea72b(propValue, changeCallback, defaultValue) {
    const [stateValue, setStateValue] = (0, $euxye.useState)(defaultValue);
    const latestChangeCallback = (0, $i5aNJ.useLatest)(changeCallback);
    const value = propValue === undefined ? stateValue : propValue;
    const updateValue = (0, $euxye.useCallback)((newValue)=>{
        setStateValue(newValue);
        latestChangeCallback.current?.(newValue);
    }, [
        latestChangeCallback
    ]);
    return [
        value,
        updateValue
    ];
}

});

parcelRegister("as09W", function(module, exports) {
$parcel$export(module.exports, "MINIMUM_ZOOM_LEVEL", () => $2e41954e669f7cf0$export$eadcd7bcf388da50);
$parcel$export(module.exports, "MAXIMUM_ZOOM_LEVEL", () => $2e41954e669f7cf0$export$212e080fc48fe6c9);
$parcel$export(module.exports, "DEFAULT_ZOOM_LEVEL", () => $2e41954e669f7cf0$export$314df2ab1d1b768f);
$parcel$export(module.exports, "LINEAR_ZOOM_STEP", () => $2e41954e669f7cf0$export$242961008b66e9eb);
$parcel$export(module.exports, "DEFAULT_PAN", () => $2e41954e669f7cf0$export$bce6d504eee086c2);
$parcel$export(module.exports, "STATUS_HEIGHT", () => $2e41954e669f7cf0$export$2dcb44527ea5ccd4);
$parcel$export(module.exports, "TRANSITION_STROKE_WIDTH", () => $2e41954e669f7cf0$export$2a3643000478f19c);
$parcel$export(module.exports, "START_NODE_RADIUS", () => $2e41954e669f7cf0$export$bc1449a84350d176);
$parcel$export(module.exports, "PORT_RADIUS", () => $2e41954e669f7cf0$export$7a3df93415c22959);
$parcel$export(module.exports, "GLOBAL_TRANSITION_PORT_OFFSET", () => $2e41954e669f7cf0$export$3b4ba534bacfcbd1);
$parcel$export(module.exports, "ARROW_PORT_OFFSET", () => $2e41954e669f7cf0$export$87d6ef7590617cc6);
$parcel$export(module.exports, "ARROW_WING_LENGTH", () => $2e41954e669f7cf0$export$694048c54f729ecb);
$parcel$export(module.exports, "GLOBAL_TRANSITION_PORT", () => $2e41954e669f7cf0$export$da538e9c3b4bc32f);
$parcel$export(module.exports, "STATE_COLOURS", () => $2e41954e669f7cf0$export$add05b3c7c2c5f8f);
$parcel$export(module.exports, "MAX_LABEL_LENGTH", () => $2e41954e669f7cf0$export$8bedd3d485c3d02f);
$parcel$export(module.exports, "ELLIPSIS", () => $2e41954e669f7cf0$export$dc26c440c68f2c2a);
/* eslint-disable jira/filename-case */ 
var $k9d6y = parcelRequire("k9d6y");
const $2e41954e669f7cf0$export$eadcd7bcf388da50 = 0.5;
const $2e41954e669f7cf0$export$212e080fc48fe6c9 = 2;
const $2e41954e669f7cf0$export$314df2ab1d1b768f = 1;
const $2e41954e669f7cf0$export$242961008b66e9eb = 0.1;
const $2e41954e669f7cf0$export$bce6d504eee086c2 = (0, $k9d6y.toPoint)(600, 80);
const $2e41954e669f7cf0$export$2dcb44527ea5ccd4 = 32;
const $2e41954e669f7cf0$export$2a3643000478f19c = 2;
const $2e41954e669f7cf0$export$bc1449a84350d176 = 20;
const $2e41954e669f7cf0$export$7a3df93415c22959 = 5;
const $2e41954e669f7cf0$export$3b4ba534bacfcbd1 = 2;
const $2e41954e669f7cf0$export$87d6ef7590617cc6 = $2e41954e669f7cf0$export$7a3df93415c22959 / 2;
const $2e41954e669f7cf0$export$694048c54f729ecb = 5;
const $2e41954e669f7cf0$export$da538e9c3b4bc32f = 3;
const $2e41954e669f7cf0$export$add05b3c7c2c5f8f = {
    focused: "var(--ds-border-focused, #4688EC)",
    selected: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)",
    error: "var(--ds-border-danger, #E2483D)"
};
const $2e41954e669f7cf0$export$8bedd3d485c3d02f = 40;
const $2e41954e669f7cf0$export$dc26c440c68f2c2a = '\u2026';

});
parcelRegister("k9d6y", function(module, exports) {
$parcel$export(module.exports, "TransitionIcons", () => $d56533a96f5096b3$export$ce448d88de6ac43e);
$parcel$export(module.exports, "PortIndex", () => $d56533a96f5096b3$export$4549e552522d6540);
$parcel$export(module.exports, "allStatusPorts", () => $d56533a96f5096b3$export$c39dd9d2b04f8803);
$parcel$export(module.exports, "ValidationFlag", () => $d56533a96f5096b3$export$4edd599884789108);
$parcel$export(module.exports, "toPortInfo", () => $d56533a96f5096b3$export$b0c629e479719649);
$parcel$export(module.exports, "toPortKey", () => $d56533a96f5096b3$export$e86e2262732e6179);
$parcel$export(module.exports, "toPoint", () => $d56533a96f5096b3$export$b63cca88ddc558a9);
$parcel$export(module.exports, "LayerIndex", () => $d56533a96f5096b3$export$e44e4947d8392b61);

var $1DCdt = parcelRequire("1DCdt");
var $d56533a96f5096b3$export$ce448d88de6ac43e = /*#__PURE__*/ function(TransitionIcons) {
    TransitionIcons["Bolt"] = "bolt";
    TransitionIcons["Error"] = "error";
    TransitionIcons["Check"] = "check";
    TransitionIcons["CheckInactive"] = "check_inactive";
    TransitionIcons["Cross"] = "cross";
    TransitionIcons["CrossInactive"] = "cross_inactive";
    TransitionIcons["SharedTransition"] = "shared_transition";
    TransitionIcons["TriggerAgent"] = "trigger_agent";
    return TransitionIcons;
}({});
var $d56533a96f5096b3$export$4549e552522d6540 = /*#__PURE__*/ function(PortIndex) {
    /**
	 * ```txt
	 *  ╭-⭐️-----------╮
	 *  |    Status    |
	 *  ╰--------------╯
	 * ``` */ PortIndex[PortIndex["TopLeft"] = 0] = "TopLeft";
    /**
	 * ```txt
	 *  ╭------⭐️------╮
	 *  |    Status    |
	 *  ╰--------------╯
	 * ``` */ PortIndex[PortIndex["Top"] = 1] = "Top";
    /**
	 * ```txt
	 *  ╭-----------⭐️-╮
	 *  |    Status    |
	 *  ╰--------------╯
	 * ``` */ PortIndex[PortIndex["TopRight"] = 2] = "TopRight";
    /**
	 * ```txt
	 *  ╭--------------╮
	 *  |    Status    ⭐️
	 *  ╰--------------╯
	 * ``` */ PortIndex[PortIndex["Right"] = 3] = "Right";
    /**
	 * ```txt
	 *  ╭--------------╮
	 *  |    Status    |
	 *  ╰-----------⭐️-╯
	 * ``` */ PortIndex[PortIndex["BottomRight"] = 4] = "BottomRight";
    /**
	 * ```txt
	 *  ╭--------------╮
	 *  |    Status    |
	 *  ╰------⭐️------╯
	 * ``` */ PortIndex[PortIndex["Bottom"] = 5] = "Bottom";
    /**
	 * ```txt
	 *  ╭--------------╮
	 *  |    Status    |
	 *  ╰--⭐️----------╯
	 * ``` */ PortIndex[PortIndex["BottomLeft"] = 6] = "BottomLeft";
    /**
	 * ```txt
	 *  ╭--------------╮
	 *  ⭐️   Status    |
	 *  ╰--------------╯
	 * ``` */ PortIndex[PortIndex["Left"] = 7] = "Left";
    return PortIndex;
}({});
const $d56533a96f5096b3$export$c39dd9d2b04f8803 = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7
];
var $d56533a96f5096b3$export$4edd599884789108 = /*#__PURE__*/ function(ValidationFlag) {
    ValidationFlag["Warn"] = "warn";
    ValidationFlag["Error"] = "error";
    return ValidationFlag;
}({});
const $d56533a96f5096b3$export$b0c629e479719649 = (statusId, portIndex, position, isVisible, isGlowing)=>{
    const key = statusId === (0, $1DCdt.START_NODE_ID) ? (0, $1DCdt.START_NODE_ID) : `${statusId}:${portIndex}`;
    return {
        key: key,
        position: position,
        statusId: statusId,
        portIndex: portIndex,
        isVisible: isVisible,
        isGlowing: isGlowing
    };
};
function $d56533a96f5096b3$export$e86e2262732e6179(statusId, portIndex) {
    return `${statusId}:${portIndex}`;
}
const $d56533a96f5096b3$export$b63cca88ddc558a9 = (x, y)=>({
        x: x,
        y: y
    });
var $d56533a96f5096b3$export$e44e4947d8392b61 = /*#__PURE__*/ function(LayerIndex) {
    /** Layer for most elements in default state */ LayerIndex[LayerIndex["Default"] = 0] = "Default";
    /** Layer for labels when in default state */ LayerIndex[LayerIndex["TransitionsDefault"] = 1] = "TransitionsDefault";
    /** Layer for statuses that are selected, targeted etc */ LayerIndex[LayerIndex["PrioritisedStatuses"] = 2] = "PrioritisedStatuses";
    /** Layer for transitions that are selected, rerouting, highlighted etc */ LayerIndex[LayerIndex["PrioritisedTransitions"] = 3] = "PrioritisedTransitions";
    /** Layer for overlay */ LayerIndex[LayerIndex["Overlay"] = 4] = "Overlay";
    /** Layer for all hovered elements */ LayerIndex[LayerIndex["Hover"] = 5] = "Hover";
    /** Layer for elements that exist during the editing process */ LayerIndex[LayerIndex["Proposals"] = 6] = "Proposals";
    /** Layer for all Ports */ LayerIndex[LayerIndex["Ports"] = 7] = "Ports";
    /** Layer for Global Loops container that sits above all other elements */ LayerIndex[LayerIndex["GlobalLoopsContainer"] = 8] = "GlobalLoopsContainer";
    return LayerIndex;
}({});

});


parcelRegister("gmYAN", function(module, exports) {
$parcel$export(module.exports, "default", () => $62613f96aa3c462b$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $1DCdt = parcelRequire("1DCdt");

var $c69sa = parcelRequire("c69sa");
var $fbAgj = parcelRequire("fbAgj");

var $2700E = parcelRequire("2700E");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $as09W = parcelRequire("as09W");

var $k9d6y = parcelRequire("k9d6y");

var $jpgRl = parcelRequire("jpgRl");

var $6Uuik = parcelRequire("6Uuik");

var $3lbM4 = parcelRequire("3lbM4");

var $gMsnF = parcelRequire("gMsnF");

var $9Mw1N = parcelRequire("9Mw1N");

var $8Rgow = parcelRequire("8Rgow");

var $i5aNJ = parcelRequire("i5aNJ");

var $ga6R2 = parcelRequire("ga6R2");

var $gNk7E = parcelRequire("gNk7E");

var $cx2ag = parcelRequire("cx2ag");

var $fy7V9 = parcelRequire("fy7V9");

var $h17Oj = parcelRequire("h17Oj");

var $6DIsc = parcelRequire("6DIsc");

var $8zmMo = parcelRequire("8zmMo");

var $1dkUt = parcelRequire("1dkUt");

var $bJcYH = parcelRequire("bJcYH");

var $d4owm = parcelRequire("d4owm");

var $fZjOA = parcelRequire("fZjOA");

var $i7feo = parcelRequire("i7feo");

var $019UD = parcelRequire("019UD");

var $aLlWy = parcelRequire("aLlWy");

var $4xvFx = parcelRequire("4xvFx");

var $27YFZ = parcelRequire("27YFZ");

var $7MVro = parcelRequire("7MVro");

var $31Oxr = parcelRequire("31Oxr");

var $8SchK = parcelRequire("8SchK");

var $etq4z = parcelRequire("etq4z");

var $cXsGc = parcelRequire("cXsGc");

var $a4WqC = parcelRequire("a4WqC");

var $iphYU = parcelRequire("iphYU");

var $ijRar = parcelRequire("ijRar");

var $grf3J = parcelRequire("grf3J");

var $2lVCV = parcelRequire("2lVCV");

var $2R4YJ = parcelRequire("2R4YJ");

var $16z7O = parcelRequire("16z7O");
const $62613f96aa3c462b$var$useStatusWidthsWithReadinessCheck = (statuses)=>{
    const [statusWidths, setStatusWidths, setStatusWidthEntry] = (0, $fy7V9.useRecordState)();
    return (0, $euxye.useMemo)(()=>{
        const isReady = statuses.length === Object.keys(statusWidths).length;
        return [
            statusWidths,
            setStatusWidths,
            setStatusWidthEntry,
            isReady
        ];
    }, [
        setStatusWidthEntry,
        setStatusWidths,
        statusWidths,
        statuses.length
    ]);
};
const $62613f96aa3c462b$var$WorkflowDiagram = ({ isImmutable: isImmutable = false, pan: controlledPan, zoom: controlledZoom, startNodePosition: startNodePosition, globalLoopsContainerPosition: providedGlobalLoopsContainerPosition, onClearGlobalLoopsContainerPosition: onClearGlobalLoopsContainerPosition, transitions: transitions, statuses: statuses, selectedItem: selectedItem, targetedItem: targetedItem, expandedItem: expandedItem, movingItem: movingItem, onExpandedChange: onExpandedChange, onSelect: onSelect, onItemMove: onItemMove, onTransitionCreate: onTransitionCreate, onTransitionPortChange: onTransitionPortChange, onZoomChange: onZoomChange, onPanChange: onPanChange, onViewBoxChange: onViewBoxChange, onRenderComplete: onRenderComplete, onMinZoomChange: onMinZoomChange, collapseTransitionLabels: collapseTransitionLabels = false, shouldShowGlobalLoops: shouldShowGlobalLoops = false, minimumZoom: minimumZoom = (0, $as09W.MINIMUM_ZOOM_LEVEL) })=>{
    const rootSvgRef = (0, $euxye.useRef)(null);
    const [hoveredItem, setHoveredItem] = (0, $euxye.useState)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [statusWidths, , setStatusWidthEntry, isStatusWidthsReady] = $62613f96aa3c462b$var$useStatusWidthsWithReadinessCheck(statuses);
    const [pan, updatePan] = (0, $9Mw1N.useControllable)(controlledPan, onPanChange, (0, $as09W.DEFAULT_PAN));
    const [zoom, updateZoom] = (0, $9Mw1N.useControllable)(controlledZoom, onZoomChange, (0, $as09W.DEFAULT_ZOOM_LEVEL));
    const { canvasContainerRef: canvasContainerRef, diagramSize: diagramSize, viewBox: viewBox } = (0, $gMsnF.useCanvasView)(zoom, pan, onViewBoxChange);
    const [reroutingTransition, { onTransitionReroutingCancel: onTransitionReroutingCancel, onTransitionReroutingClose: onTransitionReroutingClose, onTransitionReroutingMove: onTransitionReroutingMove }] = (0, $fZjOA.useTransitionRerouting)();
    const [proposedTransition, { onTransitionProposalCancel: onTransitionProposalCancel, onTransitionProposalMove: onTransitionProposalMove, onTransitionProposalClose: onTransitionProposalClose }] = (0, $d4owm.useTransitionProposals)();
    const globalLoopedTransitions = (0, $euxye.useMemo)(()=>transitions.filter((t)=>t.type === 'global-looped'), [
        transitions
    ]);
    const { isLayoutStable: isLayoutStable, defaultPositions: defaultPositions, defaultGlobalLoopsContainerPosition: defaultGlobalLoopsContainerPosition, transitionsWithDefaultPorts: transitionsWithDefaultPorts, contentBounds: contentBounds } = (0, $6Uuik.useAutoLayout)({
        rootSvgRef: rootSvgRef,
        canvasContainerRef: canvasContainerRef,
        startNodePosition: startNodePosition,
        transitions: transitions,
        statuses: statuses,
        statusWidths: statusWidths,
        isStatusWidthsReady: isStatusWidthsReady,
        providedGlobalLoopsContainerPosition: providedGlobalLoopsContainerPosition,
        onClearGlobalLoopsContainerPosition: onClearGlobalLoopsContainerPosition,
        onItemMove: onItemMove,
        onTransitionPortChange: onTransitionPortChange,
        onPan: updatePan,
        onZoom: updateZoom,
        globalLoopedTransitions: globalLoopedTransitions
    });
    const latestOnRenderComplete = (0, $i5aNJ.useLatest)(onRenderComplete);
    (0, $euxye.useEffect)(()=>{
        if (isLayoutStable) latestOnRenderComplete.current?.();
    }, [
        isLayoutStable,
        latestOnRenderComplete
    ]);
    const dynamicMinZoom = (0, $019UD.useAutoFitZoom)(contentBounds, canvasContainerRef, isLayoutStable, minimumZoom, (0, $2700E.expVal)('hix-8229-dynamic-zoom-experiment', 'isEnabled', false));
    const effectiveMinZoom = (0, $2700E.expVal)('hix-8229-dynamic-zoom-experiment', 'isEnabled', false) ? dynamicMinZoom : minimumZoom;
    const effectiveContentBounds = (0, $2700E.expVal)('hix-8229-dynamic-zoom-experiment', 'isEnabled', false) ? contentBounds : undefined;
    const { dragDropState: dragDropState, temporaryPan: temporaryPan } = (0, $3lbM4.useCanvasDragDropEvents)({
        rootSvgRef: rootSvgRef,
        zoom: zoom,
        pan: pan,
        viewBox: viewBox,
        isImmutable: isImmutable,
        updatePan: updatePan,
        onSelect: onSelect,
        contentBounds: effectiveContentBounds
    });
    const latestOnMinZoomChange = (0, $i5aNJ.useLatest)(onMinZoomChange);
    (0, $euxye.useEffect)(()=>{
        latestOnMinZoomChange.current?.(effectiveMinZoom);
    }, [
        effectiveMinZoom,
        latestOnMinZoomChange
    ]);
    const { snapLines: snapLines, snappedSubjectPosition: snappedSubjectPosition } = (0, $h17Oj.useSnapLines)({
        isImmutable: isImmutable,
        startNodePosition: startNodePosition,
        globalLoopsContainerPosition: providedGlobalLoopsContainerPosition,
        statuses: statuses,
        transitions: transitions,
        statusWidths: statusWidths,
        movingItem: movingItem,
        dragDropState: dragDropState
    });
    const { draggingItem: draggingItem } = (0, $8Rgow.useItemDragDrop)({
        isImmutable: isImmutable,
        dragDropState: dragDropState,
        snappedSubjectPosition: snappedSubjectPosition,
        onItemMove: onItemMove
    });
    const globalLoopsContainer = (0, $i7feo.useGlobalLoopsContainer)({
        providedGlobalLoopsContainerPosition: providedGlobalLoopsContainerPosition,
        defaultGlobalLoopsContainerPosition: defaultGlobalLoopsContainerPosition,
        targetedItem: targetedItem,
        draggingItem: draggingItem,
        movingItem: movingItem
    });
    const startNode = (0, $6DIsc.useStartNode)({
        startNodePosition: startNodePosition,
        targetedItem: targetedItem,
        hoveredItem: hoveredItem,
        movingItem: movingItem,
        draggingItem: draggingItem,
        defaultPositions: defaultPositions
    });
    const statefulStatuses = (0, $8zmMo.useStatefulStatuses)({
        statuses: statuses,
        selectedItem: selectedItem,
        targetedItem: targetedItem,
        hoveredItem: hoveredItem,
        draggingItem: draggingItem,
        movingItem: movingItem,
        defaultPositions: defaultPositions
    });
    const { ports: ports, visiblePorts: visiblePorts } = (0, $cx2ag.usePorts)({
        hoveredItem: hoveredItem,
        selectedItem: selectedItem,
        startNodePosition: startNode.position,
        transitions: transitions,
        statuses: statefulStatuses,
        statusWidths: statusWidths,
        defaultPositions: defaultPositions,
        dragDropState: dragDropState,
        reroutingTransition: reroutingTransition,
        proposedTransition: proposedTransition,
        isImmutable: isImmutable
    });
    const statefulTransitions = (0, $1dkUt.useStatefulTransitions)({
        transitions: transitions,
        selectedItem: selectedItem,
        targetedItem: targetedItem,
        hoveredItem: hoveredItem,
        ports: ports,
        reroutingTransition: reroutingTransition,
        transitionsWithDefaultPorts: transitionsWithDefaultPorts
    });
    const statefulGlobalTransitionsPerStatus = (0, $euxye.useMemo)(()=>{
        const globals = statefulTransitions.filter((transition)=>transition.type === 'global');
        const globalsPerStatus = globals.reduce((acc, transition)=>{
            const statusId = transition.targetPort?.statusId;
            if (statusId) {
                acc[statusId] = acc[statusId] || [];
                acc[statusId].push(transition);
            }
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        return globalsPerStatus;
    }, [
        statefulTransitions
    ]);
    const statefulDirectTransitions = (0, $euxye.useMemo)(()=>{
        return statefulTransitions.filter((transition)=>transition.type === 'direct');
    }, [
        statefulTransitions
    ]);
    const statefulSharedTransitions = (0, $euxye.useMemo)(()=>{
        return statefulTransitions.filter((transition)=>transition.type === 'shared');
    }, [
        statefulTransitions
    ]);
    const onWheel = (0, $ga6R2.useOnWheel)({
        pan: pan,
        zoom: zoom,
        updateZoom: updateZoom,
        updatePan: updatePan,
        minZoom: effectiveMinZoom,
        contentBounds: effectiveContentBounds,
        viewBox: viewBox
    });
    (0, $gNk7E.usePortDragAndDrop)({
        ports: ports,
        isImmutable: isImmutable,
        selectedItem: selectedItem,
        transitions: transitions,
        dragDropState: dragDropState,
        onTransitionReroutingMove: onTransitionReroutingMove,
        onTransitionProposalMove: onTransitionProposalMove
    });
    (0, $bJcYH.useTransitionDragDrop)({
        ports: ports,
        dragDropState: dragDropState,
        proposedTransition: proposedTransition,
        reroutingTransition: reroutingTransition,
        transitions: transitions,
        onTransitionProposalCancel: onTransitionProposalCancel,
        onTransitionReroutingCancel: onTransitionReroutingCancel,
        onTransitionCreate: onTransitionCreate,
        onTransitionPortChange: onTransitionPortChange
    });
    (0, $euxye.useEffect)(()=>{
        const containerRef = canvasContainerRef?.current;
        if (containerRef) // @ts-expect-error - WheelEvent is the correct value
        containerRef.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>{
            if (containerRef) // @ts-expect-error - WheelEvent is the correct value
            containerRef.removeEventListener('wheel', onWheel);
        };
    }, [
        canvasContainerRef,
        onWheel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($62613f96aa3c462b$var$DiagramContainer, {
        ref: canvasContainerRef,
        isContentHidden: !isLayoutStable,
        isTargeted: targetedItem?.type === (0, $aLlWy.DIAGRAM_CONTAINER_TYPE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4xvFx.CanvasSvg), {
        rootSvgRef: rootSvgRef,
        pan: temporaryPan || pan,
        zoom: zoom,
        diagramSize: diagramSize
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerGroup), null, shouldShowGlobalLoops && globalLoopsContainer.position && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerItem), {
        layer: (0, $k9d6y.LayerIndex).GlobalLoopsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7MVro.default), {
        isImmutable: isImmutable,
        position: globalLoopsContainer.position,
        transitions: statefulTransitions.filter((x)=>x.type === 'global-looped'),
        onSelect: onSelect,
        onHover: setHoveredItem,
        isMoving: globalLoopsContainer.isMoving,
        isTargeted: globalLoopsContainer.isTargeted
    })), (0, $2700E.expVal)('hix-8796_wfe_multi_global_transitions_support', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, Object.entries(statefulGlobalTransitionsPerStatus).map(([statusId, globalTransitions])=>globalTransitions.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerItem), {
            key: `transitionPath_${globalTransitions[0].id}`,
            layer: (0, $2lVCV.getTransitionLayer)(globalTransitions[0])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $31Oxr.default), {
            id: globalTransitions[0].id,
            flag: globalTransitions[0].flag,
            isHovered: globalTransitions[0].isHovered,
            isImmutable: isImmutable,
            isSelected: globalTransitions[0].isSelected,
            isTargeted: globalTransitions[0].isTargeted,
            isHighlighted: globalTransitions[0].isHighlighted,
            portPosition: globalTransitions[0].targetPort?.position,
            onSelect: onSelect,
            onHover: setHoveredItem,
            icons: (0, $2lVCV.applyTransitionIconConditions)(globalTransitions[0].icons, undefined)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerItem), {
            key: `transitionPath_${statusId}`,
            layer: (0, $k9d6y.LayerIndex).TransitionsDefault
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $16z7O.default), {
            statusId: statusId,
            portPosition: globalTransitions[0].targetPort?.position,
            transitions: globalTransitions,
            expandedItem: expandedItem,
            targetedItem: targetedItem,
            hoveredItem: hoveredItem,
            isImmutable: isImmutable,
            onExpandedChange: onExpandedChange,
            onSelect: onSelect,
            onHover: setHoveredItem
        }))), statefulDirectTransitions.map((transition)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerItem), {
            key: `transitionPath_${transition.id}`,
            layer: (0, $2lVCV.getTransitionLayer)(transition)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $27YFZ.default), {
            id: transition.id,
            path: transition.path,
            flag: transition.flag,
            isImmutable: isImmutable,
            isSelected: transition.isSelected,
            isTargeted: transition.isTargeted,
            isHighlighted: transition.isHighlighted,
            isHovered: transition.isHovered,
            start: transition.sourcePort,
            end: transition.targetPort,
            onSelect: onSelect,
            onHover: setHoveredItem
        }))), statefulSharedTransitions.map((transition)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerItem), {
            key: `transitionPath_${transition.id}`,
            layer: (0, $2lVCV.getTransitionLayer)(transition)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a4WqC.default), {
            id: transition.id,
            flag: transition.flag,
            isHovered: transition.isHovered,
            isImmutable: isImmutable,
            isSelected: transition.isSelected,
            isTargeted: transition.isTargeted,
            isHighlighted: transition.isHighlighted,
            connections: transition.connections,
            onSelect: onSelect,
            onHover: setHoveredItem
        })))) : statefulTransitions.map((transition)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerItem), {
            key: `transitionPath_${transition.id}`,
            layer: (0, $2lVCV.getTransitionLayer)(transition)
        }, transition.type === 'global' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $31Oxr.default), {
            id: transition.id,
            flag: transition.flag,
            isHovered: transition.isHovered,
            isImmutable: isImmutable,
            isSelected: transition.isSelected,
            isTargeted: transition.isTargeted,
            isHighlighted: transition.isHighlighted,
            portPosition: transition.targetPort?.position,
            onSelect: onSelect,
            onHover: setHoveredItem,
            icons: (0, $2lVCV.applyTransitionIconConditions)(transition.icons, undefined)
        }), transition.type === 'direct' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $27YFZ.default), {
            id: transition.id,
            path: transition.path,
            flag: transition.flag,
            isImmutable: isImmutable,
            isSelected: transition.isSelected,
            isTargeted: transition.isTargeted,
            isHighlighted: transition.isHighlighted,
            isHovered: transition.isHovered,
            start: transition.sourcePort,
            end: transition.targetPort,
            onSelect: onSelect,
            onHover: setHoveredItem
        }), transition.type === 'shared' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a4WqC.default), {
            id: transition.id,
            flag: transition.flag,
            isHovered: transition.isHovered,
            isImmutable: isImmutable,
            isSelected: transition.isSelected,
            isTargeted: transition.isTargeted,
            isHighlighted: transition.isHighlighted,
            connections: transition.connections,
            onSelect: onSelect,
            onHover: setHoveredItem
        }))), statefulTransitions.filter((transition)=>{
        if (transition.type === 'global') return false;
        if (transition.type === 'global-looped') return false;
        return true;
    }).map((transition)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerItem), {
            key: `transitionLabel_${transition.id}`,
            layer: (0, $2lVCV.getTransitionLayer)(transition)
        }, transition.type === 'shared' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, transition.connections?.map((connection, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jpgRl.default), {
                id: transition.id,
                key: i,
                label: transition.label,
                icons: (0, $2lVCV.applyTransitionIconConditions)(transition.icons, connection.sourcePort.statusId).concat((0, $k9d6y.TransitionIcons).SharedTransition),
                flag: transition.flag,
                position: connection.labelPosition,
                isImmutable: isImmutable,
                isHovered: transition.isHovered,
                isSelected: transition.isSelected,
                isTargeted: transition.isTargeted,
                isHighlighted: transition.isHighlighted,
                isOverlapping: transition.isOverlapping,
                isOverlapHovered: transition.isOverlapHovered,
                onSelect: onSelect,
                onHover: setHoveredItem,
                collapseTransitionLabels: collapseTransitionLabels,
                connection: connection,
                hoveredItem: hoveredItem
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jpgRl.default), {
            id: transition.id,
            label: transition.label,
            icons: (0, $2lVCV.applyTransitionIconConditions)(transition.icons, (0, $2lVCV.getTransitionSource)(transition)),
            flag: transition.flag,
            position: transition.labelPosition,
            isImmutable: isImmutable,
            isHovered: transition.isHovered,
            isSelected: transition.isSelected,
            isTargeted: transition.isTargeted,
            isHighlighted: transition.isHighlighted,
            isOverlapping: transition.isOverlapping,
            isOverlapHovered: transition.isOverlapHovered,
            onSelect: onSelect,
            onHover: setHoveredItem,
            collapseTransitionLabels: collapseTransitionLabels,
            connection: {
                sourcePort: transition.sourcePort,
                targetPort: transition.targetPort
            },
            hoveredItem: hoveredItem
        }))), statefulStatuses.map((status)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerItem), {
            key: `status_${status.id}`,
            layer: (0, $2lVCV.getStatusLayer)(status)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $grf3J.default), {
            id: status.id,
            label: status.label || formatMessage($62613f96aa3c462b$export$37b713573cbaf590),
            position: status.position,
            category: status.category,
            flag: status.flag,
            isImmutable: isImmutable,
            isSelected: status.isSelected,
            isTargeted: status.isTargeted,
            isMoving: status.isMoving,
            showGlobalScopeIndicator: status.showGlobalScopeIndicator,
            onHover: setHoveredItem,
            onStatusResize: setStatusWidthEntry,
            onSelect: onSelect
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerItem), {
        key: (0, $1DCdt.START_NODE_ID),
        layer: (0, $2lVCV.getStartNodeLayer)(startNode)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ijRar.default), {
        id: (0, $1DCdt.START_NODE_ID),
        position: startNode.position,
        isImmutable: isImmutable,
        isTargeted: startNode.isTargeted,
        isMoving: startNode.isMoving,
        onHover: setHoveredItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerItem), {
        layer: (0, $k9d6y.LayerIndex).Proposals
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iphYU.default), {
        lines: snapLines
    })), visiblePorts.map((port)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerItem), {
            key: `port_${port.key}`,
            layer: (0, $k9d6y.LayerIndex).Ports
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $etq4z.default), {
            portKey: port.key,
            isImmutable: isImmutable,
            position: port.position,
            isGlowing: port.isGlowing,
            parentStatusId: port.statusId,
            portIndex: port.portIndex,
            onHover: setHoveredItem,
            isProposingTransition: proposedTransition.stage !== 'none',
            isRerouting: reroutingTransition.stage !== 'none',
            onTransitionReroutingClose: onTransitionReroutingClose,
            onTransitionProposalClose: onTransitionProposalClose
        }))), proposedTransition.stage !== 'none' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerItem), {
        layer: (0, $k9d6y.LayerIndex).Proposals
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cXsGc.default), {
        start: proposedTransition.line.start,
        end: proposedTransition.line.end
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $etq4z.default), {
        isImmutable: true,
        position: proposedTransition.line.end
    })), (movingItem || draggingItem) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8SchK.LayerItem), {
        layer: (0, $k9d6y.LayerIndex).PrioritisedTransitions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2R4YJ.default), {
        viewBox: viewBox
    })))));
};
$62613f96aa3c462b$var$WorkflowDiagram.displayName = "WorkflowDiagram";
var $62613f96aa3c462b$export$2e2bcd8739ae039 = $62613f96aa3c462b$var$WorkflowDiagram;
const $62613f96aa3c462b$var$DiagramContainer = /*#__PURE__*/ (0, $euxye.forwardRef)(({ isContentHidden: isContentHidden, isTargeted: isTargeted, children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        ref: ref,
        xcss: [
            $62613f96aa3c462b$var$containerBaseStyles,
            isContentHidden && $62613f96aa3c462b$var$containerHiddenStyles,
            isTargeted && $62613f96aa3c462b$var$containerTargetedStyles
        ]
    }, children));
const $62613f96aa3c462b$var$containerBaseStyles = (0, $fbAgj.xcss)({
    height: '100%',
    minHeight: '336px',
    width: '100%',
    // disables browser handling of all touch events, giving us full control
    touchAction: 'none'
});
const $62613f96aa3c462b$var$containerHiddenStyles = (0, $fbAgj.xcss)({
    opacity: '0'
});
const $62613f96aa3c462b$var$containerTargetedStyles = (0, $fbAgj.xcss)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid`,
    outlineColor: 'color.border.focused'
});
const $62613f96aa3c462b$export$37b713573cbaf590 = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.workflow-diagram.unknown-status-label",
    defaultMessage: "Unknown"
});

});
parcelRegister("jpgRl", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ba5924d8a2cdfb3$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $6OFDk = parcelRequire("6OFDk");

var $as09W = parcelRequire("as09W");

var $aLlWy = parcelRequire("aLlWy");

var $k9d6y = parcelRequire("k9d6y");

var $38YZm = parcelRequire("38YZm");

var $dI9CN = parcelRequire("dI9CN");

var $6wPRl = parcelRequire("6wPRl");

var $iXhO6 = parcelRequire("iXhO6");

var $6KUoo = parcelRequire("6KUoo");
const $4ba5924d8a2cdfb3$var$TEXT_Y_OFFSET = 16;
const $4ba5924d8a2cdfb3$var$ICON_LABEL_GAP = 2;
const $4ba5924d8a2cdfb3$var$ICON_PADDING = 2;
const $4ba5924d8a2cdfb3$var$ICON_ONLY_LABEL_PADDING = 16;
const $4ba5924d8a2cdfb3$var$LABEL_PADDING = 20;
const $4ba5924d8a2cdfb3$var$TEXT_X_IF_NO_ICONS = 20;
const $4ba5924d8a2cdfb3$var$LABEL_HEIGHT = 24;
const $4ba5924d8a2cdfb3$var$TEXT_OFFSET = 6;
const $4ba5924d8a2cdfb3$var$ERROR_RING_DASH_ARRAY = '3,2';
const $4ba5924d8a2cdfb3$var$FOCUS_RING_WIDTH = 4;
const $4ba5924d8a2cdfb3$var$TransitionLabel = ({ id: id, label: label = '', flag: flag, icons: icons = (0, $i860n.fg)('jfp_magma_jira-stable-defaultprops') ? (0, $6OFDk.defaultProps).emptyArray : [], isHovered: isHovered = false, isHighlighted: isHighlighted = false, isImmutable: isImmutable = false, isSelected: isSelected = false, isTargeted: isTargeted = false, position: position, maxLabelLength: maxLabelLength = (0, $as09W.MAX_LABEL_LENGTH), onSelect: onSelect, onHover: onHover, collapseTransitionLabels: collapseTransitionLabels = false, connection: connection, hoveredItem: hoveredItem })=>{
    const textRef = (0, $euxye.useRef)(null);
    const iconGroupRef = (0, $euxye.useRef)(null);
    const textWidth = (0, $6wPRl.useLayoutWidth)(textRef, [
        label,
        icons,
        position
    ]);
    const iconsWidth = (0, $6wPRl.useLayoutWidth)(iconGroupRef, [
        label,
        icons,
        position
    ]);
    const labelWidth = label === '' ? textWidth + iconsWidth + $4ba5924d8a2cdfb3$var$ICON_ONLY_LABEL_PADDING : textWidth + iconsWidth + $4ba5924d8a2cdfb3$var$LABEL_PADDING;
    const textTransformX = iconsWidth ? $4ba5924d8a2cdfb3$var$TEXT_X_IF_NO_ICONS : (labelWidth - textWidth) / 2;
    const textX = iconsWidth && iconsWidth - $4ba5924d8a2cdfb3$var$TEXT_OFFSET;
    const stroke = (0, $iXhO6.useStrokeColor)({
        flag: flag,
        isHighlighted: isHighlighted,
        isHovered: isHovered,
        isSelected: isSelected
    });
    const onGroupClick = (0, $euxye.useCallback)(()=>{
        if (!isImmutable) onSelect?.({
            type: (0, $aLlWy.EDGE_TYPE),
            id: id
        });
    }, [
        isImmutable,
        onSelect,
        id
    ]);
    const onMouseEnter = (0, $euxye.useCallback)(()=>{
        onHover?.({
            id: id,
            type: (0, $aLlWy.EDGE_TYPE),
            connection: connection
        });
    }, [
        id,
        onHover,
        connection
    ]);
    const onMouseLeave = (0, $euxye.useCallback)(()=>{
        onHover?.(undefined);
    }, [
        onHover
    ]);
    const isVisible = (0, $euxye.useMemo)(()=>{
        if (!collapseTransitionLabels || isSelected || isTargeted) return true;
        const isConnectionHovered = hoveredItem?.type === (0, $aLlWy.EDGE_TYPE) && (0, $38YZm.areConnectionsEqual)(connection, hoveredItem?.connection);
        return isConnectionHovered;
    }, [
        collapseTransitionLabels,
        isSelected,
        isTargeted,
        hoveredItem,
        connection
    ]);
    if (icons.length === 0 && label === '') return null;
    const truncatedLabel = (0, $38YZm.truncateLabel)(label, maxLabelLength);
    if (!position) return null;
    const labelX = position.x - labelWidth / 2;
    const labelY = position.y - $4ba5924d8a2cdfb3$var$LABEL_HEIGHT / 2;
    const hasLabelText = label !== '';
    const hasError = flag === (0, $k9d6y.ValidationFlag).Error;
    const hasWarning = flag === (0, $k9d6y.ValidationFlag).Warn;
    const hasValidationFlag = hasError || hasWarning;
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        "data-testid": "accessible-workflow-diagram.transition-label",
        onClick: onGroupClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ...!label && (0, $dI9CN.DATA_ATTRIBUTE_IGNORE_AUTOFIT)
    }, hasLabelText && isTargeted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: labelX,
        y: labelY,
        width: labelWidth,
        height: $4ba5924d8a2cdfb3$var$LABEL_HEIGHT,
        rx: $4ba5924d8a2cdfb3$var$LABEL_HEIGHT / 2,
        ry: $4ba5924d8a2cdfb3$var$LABEL_HEIGHT / 2,
        stroke: (0, $as09W.STATE_COLOURS).focused,
        strokeWidth: $4ba5924d8a2cdfb3$var$FOCUS_RING_WIDTH * 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: labelX,
        y: labelY,
        width: labelWidth,
        height: $4ba5924d8a2cdfb3$var$LABEL_HEIGHT,
        rx: $4ba5924d8a2cdfb3$var$LABEL_HEIGHT / 2,
        ry: $4ba5924d8a2cdfb3$var$LABEL_HEIGHT / 2,
        fill: "var(--ds-background-input, #FFFFFF)",
        stroke: stroke,
        strokeWidth: (0, $as09W.TRANSITION_STROKE_WIDTH),
        strokeDasharray: !isSelected && hasValidationFlag ? $4ba5924d8a2cdfb3$var$ERROR_RING_DASH_ARRAY : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        ref: iconGroupRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6KUoo.IconSet), {
        icons: icons,
        anchor: (0, $k9d6y.toPoint)(labelX + $4ba5924d8a2cdfb3$var$ICON_LABEL_GAP + $4ba5924d8a2cdfb3$var$ICON_PADDING, labelY + $4ba5924d8a2cdfb3$var$ICON_PADDING)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("text", {
        ref: textRef,
        x: textX + labelX + textTransformX,
        y: labelY + $4ba5924d8a2cdfb3$var$TEXT_Y_OFFSET,
        textAnchor: "start",
        fontSize: "12px",
        fill: "var(--ds-text, #292A2E)"
    }, truncatedLabel));
};
$4ba5924d8a2cdfb3$var$TransitionLabel.displayName = "TransitionLabel";
var $4ba5924d8a2cdfb3$export$2e2bcd8739ae039 = $4ba5924d8a2cdfb3$var$TransitionLabel;

});
parcelRegister("6OFDk", function(module, exports) {
$parcel$export(module.exports, "defaultProps", () => $9df83057432d9c07$export$9c21a3269931e1e6);
/**
 * Freezes the given value in non-production environments to catch accidental
 * mutation of shared default values during development and testing.
 */ const $9df83057432d9c07$var$freezeInDev = (value)=>{
    return value;
};
const $9df83057432d9c07$var$defaultPropsResolvedPromise = Promise.resolve();
const $9df83057432d9c07$var$EMPTY_ARRAY = $9df83057432d9c07$var$freezeInDev([]);
const $9df83057432d9c07$var$EMPTY_OBJECT = $9df83057432d9c07$var$freezeInDev({});
const $9df83057432d9c07$var$NOOP = $9df83057432d9c07$var$freezeInDev(()=>undefined);
const $9df83057432d9c07$var$RETURN_NULL = $9df83057432d9c07$var$freezeInDev(()=>null);
const $9df83057432d9c07$var$RETURN_RESOLVED_PROMISE = $9df83057432d9c07$var$freezeInDev(()=>$9df83057432d9c07$var$defaultPropsResolvedPromise);
const $9df83057432d9c07$export$9c21a3269931e1e6 = $9df83057432d9c07$var$freezeInDev({
    emptyArray: $9df83057432d9c07$var$EMPTY_ARRAY,
    emptyObject: $9df83057432d9c07$var$EMPTY_OBJECT,
    noop: $9df83057432d9c07$var$NOOP,
    returnNull: $9df83057432d9c07$var$RETURN_NULL,
    returnResolvedPromise: $9df83057432d9c07$var$RETURN_RESOLVED_PROMISE
});

});

parcelRegister("38YZm", function(module, exports) {
$parcel$export(module.exports, "isStartNodeReference", () => $c5f53e6f4b99959a$export$1eb9ae9959295d59);
$parcel$export(module.exports, "statusMatchesReference", () => $c5f53e6f4b99959a$export$967ac6fef7f5c262);
$parcel$export(module.exports, "transitionMatchesReference", () => $c5f53e6f4b99959a$export$c064b7cf73e916fe);
$parcel$export(module.exports, "isHighlightedTransition", () => $c5f53e6f4b99959a$export$c3b1e67c2831ddf8);
$parcel$export(module.exports, "findPort", () => $c5f53e6f4b99959a$export$93f100df314912d6);
$parcel$export(module.exports, "isEveryPropertyDefined", () => $c5f53e6f4b99959a$export$1943a591a215fa66);
$parcel$export(module.exports, "isTransitionRerouting", () => $c5f53e6f4b99959a$export$ecbe6c678814dd28);
$parcel$export(module.exports, "isPortMovingForReroutingTransition", () => $c5f53e6f4b99959a$export$e14dc45af0365967);
$parcel$export(module.exports, "updateTransitionPortIfRerouting", () => $c5f53e6f4b99959a$export$c64f7962d1fe4f1e);
$parcel$export(module.exports, "calculateViewBox", () => $c5f53e6f4b99959a$export$7e29f973febe72ad);
$parcel$export(module.exports, "truncateLabel", () => $c5f53e6f4b99959a$export$e70af1df4a68fcd7);
$parcel$export(module.exports, "getBBox", () => $c5f53e6f4b99959a$export$9cafdf24ffa90680);
$parcel$export(module.exports, "getBoundingClientRect", () => $c5f53e6f4b99959a$export$84fe60b31769e95f);
$parcel$export(module.exports, "isDirectOrSharedTransitionWithDefinedPorts", () => $c5f53e6f4b99959a$export$287d3c398c47405c);
$parcel$export(module.exports, "isTransitionOverlapping", () => $c5f53e6f4b99959a$export$725a66fefe9cab0f);
$parcel$export(module.exports, "isAnyOverlappingTransitionHovered", () => $c5f53e6f4b99959a$export$5ece72e373d74d4e);
$parcel$export(module.exports, "isNilOrEmpty", () => $c5f53e6f4b99959a$export$5e81610d3310ece7);
$parcel$export(module.exports, "areConnectionsEqual", () => $c5f53e6f4b99959a$export$8cf33fc5c91c388b);

var $1udxg = parcelRequire("1udxg");

var $6jLTU = parcelRequire("6jLTU");

var $WqSvO = parcelRequire("WqSvO");

var $1DCdt = parcelRequire("1DCdt");

var $as09W = parcelRequire("as09W");

var $aLlWy = parcelRequire("aLlWy");

var $k9d6y = parcelRequire("k9d6y");
const $c5f53e6f4b99959a$export$1eb9ae9959295d59 = (reference)=>{
    if (!reference || reference.type !== (0, $aLlWy.NODE_TYPE)) return false;
    return (0, $1DCdt.START_NODE_ID) === reference.id;
};
const $c5f53e6f4b99959a$export$967ac6fef7f5c262 = (status, reference)=>{
    if (!reference || reference.type !== (0, $aLlWy.NODE_TYPE)) return false;
    return status.id === reference.id;
};
const $c5f53e6f4b99959a$export$c064b7cf73e916fe = (transition, reference)=>{
    if (!reference || reference.type !== (0, $aLlWy.EDGE_TYPE)) return false;
    return transition.id === reference.id;
};
const $c5f53e6f4b99959a$var$isTransitionConnectedToStatus = (transition, statusId)=>{
    if (transition.type === 'global-looped') return false;
    if (transition.target === statusId) return true;
    if (transition.type === 'direct' && transition.source === statusId) return true;
    if (transition.type === 'shared' && transition.links.some((link)=>link.source === statusId)) return true;
    return false;
};
const $c5f53e6f4b99959a$export$c3b1e67c2831ddf8 = (transition, selectedItem, hoveredItem)=>{
    if (hoveredItem && hoveredItem.type === (0, $aLlWy.NODE_TYPE)) return $c5f53e6f4b99959a$var$isTransitionConnectedToStatus(transition, hoveredItem.id);
    if (selectedItem && selectedItem.type === (0, $aLlWy.NODE_TYPE)) return $c5f53e6f4b99959a$var$isTransitionConnectedToStatus(transition, selectedItem.id);
    return false;
};
const $c5f53e6f4b99959a$export$93f100df314912d6 = (ports, source, sourceIndex)=>{
    if (sourceIndex === undefined) return undefined;
    if (source === (0, $1DCdt.START_NODE_ID)) return ports[0, $1DCdt.START_NODE_ID];
    return ports[(0, $k9d6y.toPortKey)(source, sourceIndex)];
};
const $c5f53e6f4b99959a$export$62fd8532fd9c9b36 = (ports, statusPortPairs)=>{
    if (!$c5f53e6f4b99959a$export$1943a591a215fa66(statusPortPairs, 'portIndex')) return undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1udxg)))(statusPortPairs.map(({ statusId: statusId, portIndex: portIndex })=>ports[(0, $k9d6y.toPortKey)(statusId, portIndex)]));
};
const $c5f53e6f4b99959a$export$ecbe6c678814dd28 = (transition, reroutingTransition)=>reroutingTransition.stage !== 'none' && reroutingTransition?.transition.id === transition.id;
const $c5f53e6f4b99959a$export$e14dc45af0365967 = (port, side, transitionId, reroutingTransition)=>port !== undefined && reroutingTransition.stage !== 'none' && reroutingTransition?.transition.id === transitionId && reroutingTransition.side === side && port.key === reroutingTransition.originalPortKey;
const $c5f53e6f4b99959a$export$c64f7962d1fe4f1e = (port, side, transition, reroutingTransition)=>{
    if (!port || reroutingTransition.stage === 'none' || reroutingTransition?.transition.id !== transition.id || reroutingTransition.side !== side || port.key !== reroutingTransition.originalPortKey) return port;
    return {
        ...port,
        position: reroutingTransition.currentPosition
    };
};
const $c5f53e6f4b99959a$export$7e29f973febe72ad = (diagramSize, pan, zoom)=>{
    const viewBoxWidth = diagramSize.width / zoom;
    const viewBoxHeight = diagramSize.height / zoom;
    return {
        width: viewBoxWidth,
        height: viewBoxHeight,
        top: pan.y - viewBoxHeight / 2,
        left: pan.x - viewBoxWidth / 2
    };
};
const $c5f53e6f4b99959a$export$e70af1df4a68fcd7 = (text, maxLength = (0, $as09W.MAX_LABEL_LENGTH))=>text.length <= maxLength ? text : text.substring(0, maxLength - (0, $as09W.ELLIPSIS).length) + (0, $as09W.ELLIPSIS);
function $c5f53e6f4b99959a$export$9cafdf24ffa90680(element) {
    return 'getBBox' in element && typeof element.getBBox === 'function' && element.getBBox();
}
function $c5f53e6f4b99959a$export$84fe60b31769e95f(element) {
    return element.getBoundingClientRect();
}
function $c5f53e6f4b99959a$export$287d3c398c47405c(transition) {
    if (transition.type === 'global') return false;
    if (transition.type === 'global-looped') return false;
    if (transition.type === 'direct') return transition.sourceIndex !== undefined && transition.targetIndex !== undefined;
    // else shared
    return transition.links.every((link)=>link.sourceIndex !== undefined && link.targetIndex !== undefined);
}
function $c5f53e6f4b99959a$export$1943a591a215fa66(collection, ...properties) {
    return collection.every((item)=>properties.every((property)=>item[property] !== undefined));
}
const $c5f53e6f4b99959a$export$725a66fefe9cab0f = (transitionId, transitionLabelPlacements)=>transitionLabelPlacements.some((x)=>x.transitionId === transitionId);
const $c5f53e6f4b99959a$export$5ece72e373d74d4e = (transitionId, hoveredTransitionId, transitionLabelPlacements)=>{
    if (!hoveredTransitionId) return false;
    // find overlap info if transition overlaps another
    const overlapInfo = transitionLabelPlacements.find((x)=>x.transitionId === transitionId);
    if (!overlapInfo) return false;
    // check if hovered item overlaps given transition
    return transitionLabelPlacements.some((x)=>x.transitionId === hoveredTransitionId && x.overlapKey === overlapInfo.overlapKey);
};
const $c5f53e6f4b99959a$export$5e81610d3310ece7 = (value)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(value) || (0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(value);
};
const $c5f53e6f4b99959a$export$8cf33fc5c91c388b = (conn1, conn2)=>{
    if (!conn1 || !conn2) return false;
    // Check if connections match in either direction (A→B or B→A)
    const forwardMatch = conn1.sourcePort?.portIndex === conn2.sourcePort?.portIndex && conn1.sourcePort?.statusId === conn2.sourcePort?.statusId && conn1.targetPort?.portIndex === conn2.targetPort?.portIndex && conn1.targetPort?.statusId === conn2.targetPort?.statusId;
    const reverseMatch = conn1.sourcePort?.portIndex === conn2.targetPort?.portIndex && conn1.sourcePort?.statusId === conn2.targetPort?.statusId && conn1.targetPort?.portIndex === conn2.sourcePort?.portIndex && conn1.targetPort?.statusId === conn2.sourcePort?.statusId;
    return forwardMatch || reverseMatch;
};

});
parcelRegister("1udxg", function(module, exports) {
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function $115317a9655addd1$var$compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
module.exports = $115317a9655addd1$var$compact;

});


parcelRegister("dI9CN", function(module, exports) {
$parcel$export(module.exports, "findDefaultPositions", () => $6f6f2656bb6dafcd$export$b9760a6c42a85e06);
$parcel$export(module.exports, "calculateFitZoom", () => $6f6f2656bb6dafcd$export$467ab0a299478e00);
$parcel$export(module.exports, "autoFitCanvas", () => $6f6f2656bb6dafcd$export$38064ff1e4b4c0dd);
$parcel$export(module.exports, "DATA_ATTRIBUTE_IGNORE_AUTOFIT", () => $6f6f2656bb6dafcd$export$25a8ca882c171176);
$parcel$export(module.exports, "deferredExecute", () => $6f6f2656bb6dafcd$export$4c1e07610eea88e9);
$parcel$export(module.exports, "definePortsOnSharedTransition", () => $6f6f2656bb6dafcd$export$b4e613cf530b1d0);
$parcel$export(module.exports, "definePortsOnDirectTransition", () => $6f6f2656bb6dafcd$export$783b19e064f6f596);

var $Mez5L = parcelRequire("Mez5L");

var $1udxg = parcelRequire("1udxg");

var $1DCdt = parcelRequire("1DCdt");

var $as09W = parcelRequire("as09W");

var $k9d6y = parcelRequire("k9d6y");

var $2iYvg = parcelRequire("2iYvg");

var $38YZm = parcelRequire("38YZm");

var $6I3Lv = parcelRequire("6I3Lv");
const $6f6f2656bb6dafcd$var$STATUSES_PADDING_RIGHT = 60;
const $6f6f2656bb6dafcd$export$d5f8d30d5f0f009a = 50;
const $6f6f2656bb6dafcd$export$eb14e0fdcc559489 = 80;
const $6f6f2656bb6dafcd$var$DEFAULT_LOOP_SOURCE_INDEX = (0, $k9d6y.PortIndex).Bottom;
const $6f6f2656bb6dafcd$var$DEFAULT_LOOP_TARGET_INDEX = (0, $k9d6y.PortIndex).Left;
const $6f6f2656bb6dafcd$export$9b6499ea936d492a = (statuses, sourceStatusId, targetStatusId, sourceOrTarget)=>{
    const sourceStatus = statuses.find(({ id: id })=>id === sourceStatusId);
    const targetStatus = statuses.find(({ id: id })=>id === targetStatusId);
    if (sourceStatus?.position === undefined || targetStatus?.position === undefined) return 0;
    const angle = sourceOrTarget === 'source' ? (0, $2iYvg.angleBetween)(sourceStatus.position, targetStatus.position) : (0, $2iYvg.angleBetween)(targetStatus.position, sourceStatus.position);
    if (angle >= 22.5 && angle < 67.5) return (0, $k9d6y.PortIndex).BottomRight;
    if (angle >= 67.5 && angle < 112.5) return (0, $k9d6y.PortIndex).Bottom;
    if (angle >= 112.5 && angle < 157.5) return (0, $k9d6y.PortIndex).BottomLeft;
    if (angle >= 157.5 && angle < 202.5) return (0, $k9d6y.PortIndex).Left;
    if (angle >= 202.5 && angle < 247.5) return (0, $k9d6y.PortIndex).TopLeft;
    if (angle >= 247.5 && angle < 292.5) return (0, $k9d6y.PortIndex).Top;
    if (angle >= 292.5 && angle < 337.5) return (0, $k9d6y.PortIndex).TopRight;
    // between 337.5º to 22.5º
    return (0, $k9d6y.PortIndex).Right;
};
const $6f6f2656bb6dafcd$export$666bbaa8fbaa0b18 = (positionable, statusWidths)=>positionable.type === 'start-node' ? (0, $as09W.START_NODE_RADIUS) * 2 : statusWidths[positionable.id] || 0;
const $6f6f2656bb6dafcd$export$b9760a6c42a85e06 = (statusWidths, startNodePosition, statuses, defaultPositions)=>{
    const positioned = [];
    if (!Object.keys(statusWidths).length) return positioned;
    const positionables = [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            type: 'start-node',
            id: (0, $1DCdt.START_NODE_ID),
            position: startNodePosition || defaultPositions[0, $1DCdt.START_NODE_ID]
        },
        ...statuses.sort((statusA, statusB)=>1 - Number(statusA.isInitial) - (1 - Number(statusB.isInitial))).map(({ id: id, position: position })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ({
                type: 'status',
                id: id,
                position: position || defaultPositions[id]
            }))
    ];
    const positionablesWithUndefinedPositions = positionables.filter(({ position: position })=>position === undefined);
    if (positionablesWithUndefinedPositions.length > 0) {
        let maxY;
        let minY;
        let maxX;
        positionables.forEach((positionable)=>{
            if (!positionable.position) return;
            const statusWidth = $6f6f2656bb6dafcd$export$666bbaa8fbaa0b18(positionable, statusWidths);
            if (maxX === undefined || positionable.position.x + statusWidth > maxX) maxX = positionable.position.x + statusWidth;
            if (maxY === undefined || positionable.position.y + (0, $as09W.STATUS_HEIGHT) > maxY) maxY = positionable.position.y + (0, $as09W.STATUS_HEIGHT);
            if (minY === undefined || positionable.position.y < minY) minY = positionable.position.y;
        });
        let x = (maxX || 0) + $6f6f2656bb6dafcd$var$STATUSES_PADDING_RIGHT;
        const centerY = ((maxY || 0) + (minY || 0)) / 2;
        positionablesWithUndefinedPositions.forEach((positionable)=>{
            const y = centerY - $6f6f2656bb6dafcd$export$c7ca8986ba140884(positionable);
            positioned.push({
                ...positionable,
                position: {
                    x: x,
                    y: y
                }
            });
            x = x + $6f6f2656bb6dafcd$export$666bbaa8fbaa0b18(positionable, statusWidths) + $6f6f2656bb6dafcd$export$e1f70992c451c246(positionable);
        });
    }
    return positioned;
};
const $6f6f2656bb6dafcd$export$e1f70992c451c246 = (positionable)=>positionable.type === 'start-node' ? $6f6f2656bb6dafcd$export$eb14e0fdcc559489 : $6f6f2656bb6dafcd$var$STATUSES_PADDING_RIGHT;
const $6f6f2656bb6dafcd$export$c7ca8986ba140884 = (positionable)=>positionable.type === 'start-node' ? $6f6f2656bb6dafcd$export$d5f8d30d5f0f009a + (0, $as09W.START_NODE_RADIUS) : (0, $as09W.STATUS_HEIGHT) / 2;
const $6f6f2656bb6dafcd$export$467ab0a299478e00 = (contentBounds, containerSize, padding = 20)=>{
    const paddedWidth = contentBounds.width + padding * 2;
    const paddedHeight = contentBounds.height + padding * 2;
    if (paddedWidth <= 0 || paddedHeight <= 0) return 0, $as09W.DEFAULT_ZOOM_LEVEL;
    return Math.min(containerSize.height / paddedHeight, containerSize.width / paddedWidth);
};
const $6f6f2656bb6dafcd$export$38064ff1e4b4c0dd = (rootSvgRef, canvasContainerRef, onPan, onZoom, contentBounds)=>{
    if (!canvasContainerRef.current) return;
    const containerRect = canvasContainerRef.current.getBoundingClientRect();
    // Use state-based content bounds if provided, otherwise fall back to DOM measurement
    let boundingBox = contentBounds;
    if (!boundingBox && rootSvgRef.current) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const children = Array.from(rootSvgRef.current.children);
        const childBounds = (0, (/*@__PURE__*/$parcel$interopDefault($1udxg)))(children.filter((child)=>// Filter out elements with ignore auto fit boolean attribute
            // Note that this checks existence of attribute not value as
            // per definition of boolean attributes https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes#boolean_attributes
            !child.hasAttribute($6f6f2656bb6dafcd$export$a2a7c5ecd86d2098)).map((0, $38YZm.getBBox)));
        boundingBox = (0, $6I3Lv.getCanvasBoundingBox)(childBounds);
    }
    if (!boundingBox) return;
    if (containerRect.width <= 0 || containerRect.height <= 0) return;
    const boundingBoxCenter = (0, $6I3Lv.getBBoxCenter)(boundingBox);
    onPan((0, $k9d6y.toPoint)(boundingBoxCenter.x, boundingBoxCenter.y));
    const zoomLevel = $6f6f2656bb6dafcd$export$467ab0a299478e00(boundingBox, containerRect);
    // When contentBounds is provided (experiment), allow any zoom level
    onZoom(contentBounds ? Math.min(zoomLevel, (0, $as09W.DEFAULT_ZOOM_LEVEL)) : (0, (/*@__PURE__*/$parcel$interopDefault($Mez5L)))(zoomLevel, (0, $as09W.MINIMUM_ZOOM_LEVEL), (0, $as09W.DEFAULT_ZOOM_LEVEL)));
};
const $6f6f2656bb6dafcd$export$a2a7c5ecd86d2098 = 'data-ignore-autofit';
const $6f6f2656bb6dafcd$export$25a8ca882c171176 = {
    [$6f6f2656bb6dafcd$export$a2a7c5ecd86d2098]: true
};
const $6f6f2656bb6dafcd$export$4c1e07610eea88e9 = (callback)=>setTimeout(callback, 0);
const $6f6f2656bb6dafcd$export$b4e613cf530b1d0 = (transition, statuses)=>({
        ...transition,
        links: transition.links.map((link)=>{
            if (link.source === transition.target) return {
                ...link,
                sourceIndex: $6f6f2656bb6dafcd$var$DEFAULT_LOOP_SOURCE_INDEX,
                targetIndex: $6f6f2656bb6dafcd$var$DEFAULT_LOOP_TARGET_INDEX
            };
            return {
                ...link,
                sourceIndex: link.sourceIndex ?? $6f6f2656bb6dafcd$export$9b6499ea936d492a(statuses, link.source, transition.target, 'source'),
                targetIndex: link.targetIndex ?? $6f6f2656bb6dafcd$export$9b6499ea936d492a(statuses, link.source, transition.target, 'target')
            };
        })
    });
const $6f6f2656bb6dafcd$export$783b19e064f6f596 = (transition, statuses)=>{
    if (transition.source === transition.target) return {
        ...transition,
        sourceIndex: $6f6f2656bb6dafcd$var$DEFAULT_LOOP_SOURCE_INDEX,
        targetIndex: $6f6f2656bb6dafcd$var$DEFAULT_LOOP_TARGET_INDEX
    };
    return {
        ...transition,
        sourceIndex: transition.sourceIndex ?? $6f6f2656bb6dafcd$export$9b6499ea936d492a(statuses, transition.source, transition.target, 'source'),
        targetIndex: transition.targetIndex ?? $6f6f2656bb6dafcd$export$9b6499ea936d492a(statuses, transition.source, transition.target, 'target')
    };
};

});
parcelRegister("Mez5L", function(module, exports) {

var $9KHOh = parcelRequire("9KHOh");

var $2LC8B = parcelRequire("2LC8B");
/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $090fc81d68dca248$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $2LC8B(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $2LC8B(lower);
        lower = lower === lower ? lower : 0;
    }
    return $9KHOh($2LC8B(number), lower, upper);
}
module.exports = $090fc81d68dca248$var$clamp;

});
parcelRegister("9KHOh", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $719a64adde6b833d$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $719a64adde6b833d$var$baseClamp;

});


parcelRegister("2iYvg", function(module, exports) {
$parcel$export(module.exports, "add", () => $88ae55ddf67aefae$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $88ae55ddf67aefae$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiply", () => $88ae55ddf67aefae$export$2060d2db72cce88f);
$parcel$export(module.exports, "divide", () => $88ae55ddf67aefae$export$cd007d971a5a2143);
$parcel$export(module.exports, "midpoint", () => $88ae55ddf67aefae$export$f2e8a19be46147af);
$parcel$export(module.exports, "invert", () => $88ae55ddf67aefae$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "distance", () => $88ae55ddf67aefae$export$9f17032d917177de);
$parcel$export(module.exports, "angleBetween", () => $88ae55ddf67aefae$export$47cb7eb79666608a);
$parcel$export(module.exports, "unitDirectionAngle", () => $88ae55ddf67aefae$export$e8d8309fbd338973);

var $k9d6y = parcelRequire("k9d6y");
const $88ae55ddf67aefae$export$e16d8520af44a096 = (point, other)=>(0, $k9d6y.toPoint)(point.x + other.x, point.y + other.y);
const $88ae55ddf67aefae$export$4e2d2ead65e5f7e3 = (point, other)=>(0, $k9d6y.toPoint)(point.x - other.x, point.y - other.y);
const $88ae55ddf67aefae$export$2060d2db72cce88f = (point, scalar)=>(0, $k9d6y.toPoint)(point.x * scalar, point.y * scalar);
const $88ae55ddf67aefae$export$cd007d971a5a2143 = (point, scalar)=>(0, $k9d6y.toPoint)(point.x / scalar, point.y / scalar);
const $88ae55ddf67aefae$export$7319af7d4cf5a6ca = (start, end, percent)=>(0, $k9d6y.toPoint)((start.x + end.x) * percent, (start.y + end.y) * percent);
const $88ae55ddf67aefae$export$f2e8a19be46147af = (start, end)=>$88ae55ddf67aefae$export$7319af7d4cf5a6ca(start, end, 0.5);
const $88ae55ddf67aefae$export$6897c284b6f9f4dc = (point)=>$88ae55ddf67aefae$export$2060d2db72cce88f(point, -1);
const $88ae55ddf67aefae$export$9f17032d917177de = (p, q)=>{
    const a = q.x - p.x;
    const b = q.y - p.y;
    return Math.sqrt(a * a + b * b);
};
const $88ae55ddf67aefae$export$47cb7eb79666608a = (p, q)=>{
    const degrees = Math.atan2(q.y - p.y, q.x - p.x) * 180 / Math.PI;
    const angleClampedBetween0And360 = (degrees + 360) % 360;
    return angleClampedBetween0And360;
};
const $88ae55ddf67aefae$export$e8d8309fbd338973 = (unitDirection)=>Math.atan2(unitDirection.x, unitDirection.y) * 180 / Math.PI;

});

parcelRegister("6I3Lv", function(module, exports) {
$parcel$export(module.exports, "getBBoxCenter", () => $336e61294534d5c5$export$eccd94b26d0a3f4e);
$parcel$export(module.exports, "getCanvasBoundingBox", () => $336e61294534d5c5$export$550eedf6c679837d);
$parcel$export(module.exports, "expandBoundingBox", () => $336e61294534d5c5$export$2db36c07d90aafd0);
$parcel$export(module.exports, "getInitialSize", () => $336e61294534d5c5$export$70d7abb12b759ef9);
const $336e61294534d5c5$export$eccd94b26d0a3f4e = (bBox)=>{
    const { x: x, y: y, width: width, height: height } = bBox;
    return {
        x: x + width / 2,
        y: y + height / 2
    };
};
const $336e61294534d5c5$export$f3eab0b38a6a1a03 = (canvasBoundingBox, bBox)=>{
    if (!canvasBoundingBox) return {
        x: bBox.x,
        y: bBox.y,
        width: bBox.width,
        height: bBox.height
    };
    const bottomRight = {
        x: Math.max(bBox.x + bBox.width, canvasBoundingBox.x + canvasBoundingBox.width),
        y: Math.max(bBox.y + bBox.height, canvasBoundingBox.y + canvasBoundingBox.height)
    };
    const topLeft = {
        x: Math.min(bBox.x, canvasBoundingBox.x),
        y: Math.min(bBox.y, canvasBoundingBox.y)
    };
    return {
        x: topLeft.x,
        y: topLeft.y,
        width: bottomRight.x - topLeft.x,
        height: bottomRight.y - topLeft.y
    };
};
const $336e61294534d5c5$export$550eedf6c679837d = (bBoxes)=>{
    if (bBoxes.length < 1) return undefined;
    return bBoxes.reduce((acc, item)=>$336e61294534d5c5$export$f3eab0b38a6a1a03(acc, item), undefined);
};
const $336e61294534d5c5$export$2db36c07d90aafd0 = ({ x: x, y: y, width: width, height: height }, padding)=>({
        x: x - padding,
        y: y - padding,
        width: width + 2 * padding,
        height: height + 2 * padding
    });
const $336e61294534d5c5$export$70d7abb12b759ef9 = ()=>({
        width: 0,
        height: 0
    });

});


parcelRegister("6wPRl", function(module, exports) {
$parcel$export(module.exports, "useLayoutWidth", () => $885bfb00546c5913$export$5e90136528d56d69);
$parcel$export(module.exports, "default", () => $885bfb00546c5913$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $6OFDk = parcelRequire("6OFDk");

var $38YZm = parcelRequire("38YZm");
const $885bfb00546c5913$export$5e90136528d56d69 = (ref, // eslint-disable-next-line @typescript-eslint/no-explicit-any
dependancies = (0, $i860n.fg)('jfp_magma_jira-stable-defaultprops') ? (0, $6OFDk.defaultProps).emptyArray : [])=>{
    const [width, setWidth] = (0, $euxye.useState)(0);
    (0, $euxye.useLayoutEffect)(()=>{
        if (!ref.current) {
            setWidth(0);
            return;
        }
        const bBox = (0, $38YZm.getBBox)(ref.current);
        if (!bBox) {
            setWidth(0);
            return;
        }
        setWidth(Math.max(0, bBox.width));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        ...dependancies
    ]);
    return width;
};
var $885bfb00546c5913$export$2e2bcd8739ae039 = $885bfb00546c5913$export$5e90136528d56d69;

});

parcelRegister("iXhO6", function(module, exports) {
$parcel$export(module.exports, "useStrokeColor", () => $14f927d8496e5b59$export$d361b13df0887ca8);

var $euxye = parcelRequire("euxye");

var $as09W = parcelRequire("as09W");

var $k9d6y = parcelRequire("k9d6y");
const $14f927d8496e5b59$export$d361b13df0887ca8 = ({ flag: flag, isSelected: isSelected, isHighlighted: isHighlighted, isHovered: isHovered })=>{
    const stroke = (0, $euxye.useMemo)(()=>{
        if (flag === (0, $k9d6y.ValidationFlag).Error) return (0, $as09W.STATE_COLOURS).error;
        if (flag === (0, $k9d6y.ValidationFlag).Warn) return (0, $as09W.STATE_COLOURS).warning;
        if (isSelected) return (0, $as09W.STATE_COLOURS).selected;
        if (isHighlighted || isHovered) return "var(--ds-chart-gray-boldest-hovered, #3B3D42)";
        return "var(--ds-chart-gray-bold, #8C8F97)";
    }, [
        flag,
        isHighlighted,
        isHovered,
        isSelected
    ]);
    return stroke;
};

});

parcelRegister("6KUoo", function(module, exports) {
$parcel$export(module.exports, "IconSet", () => $d98ab47df6e11503$export$c0faf18b76ac5204);

var $euxye = parcelRequire("euxye");

var $k9d6y = parcelRequire("k9d6y");

var $2iYvg = parcelRequire("2iYvg");
const $d98ab47df6e11503$var$ICON_PADDING = 18;
const $d98ab47df6e11503$var$BoltIcon = ({ anchor: anchor, inverse: inverse = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.bolt-icon",
        fill: inverse ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #292A2E)",
        stroke: "none",
        d: "M10.339854,4L15.1874898,4C15.4636322,4,15.6874898,4.22385763,15.6874898,4.5C15.6874898,4.57818367,15.6691551,4.65527785,15.6339583,4.72509094L13.5848909,8.78942131C13.4605766,9.03599902,13.5596907,9.3366664,13.8062684,9.46098069C13.8760815,9.49617756,13.9531756,9.51451225,14.0313593,9.51451225L17.65813,9.51451225C17.9342724,9.51451225,18.15813,9.73836987,18.15813,10.0145122C18.15813,10.1589731,18.0956491,10.2963739,17.9867788,10.3913278L7.71485013,19.3502415C7.50674068,19.5317492,7.19089352,19.5101843,7.00938577,19.3020748C6.88345852,19.1576918,6.85110443,18.9540478,6.92608257,18.7777457L8.97708607,13.9550573C9.08515731,13.7009408,8.9667642,13.4073296,8.71264766,13.2992583C8.65076634,13.2729413,8.58421231,13.259377,8.51696736,13.259377L6.12950524,13.259377C5.85336286,13.259377,5.62950524,13.0355194,5.62950524,12.759377C5.62950524,12.6804396,5.64819503,12.6026237,5.68404531,12.5322967L9.8943941,4.27291972C9.97976952,4.10544006,10.1518689,4,10.339854,4Z",
        transform: `matrix(0.7982,0,0,0.8617,${anchor.x},${anchor.y})`
    });
$d98ab47df6e11503$var$BoltIcon.displayName = "BoltIcon";
const $d98ab47df6e11503$var$CheckIcon = ({ anchor: anchor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.check-icon",
        fill: "var(--ds-icon-success, #6A9A23)",
        stroke: "none",
        d: "M18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z M22.5857864,12.5857864 L16,19.1715729 L13.4142136,16.5857864 C12.633165,15.8047379 11.366835,15.8047379 10.5857864,16.5857864 C9.8047379,17.366835 9.8047379,18.633165 10.5857864,19.4142136 L14.5857864,23.4142136 C15.366835,24.1952621 16.633165,24.1952621 17.4142136,23.4142136 L25.4142136,15.4142136 C26.1952621,14.633165 26.1952621,13.366835 25.4142136,12.5857864 C24.633165,11.8047379 23.366835,11.8047379 22.5857864,12.5857864 Z",
        transform: `matrix(0.4,0,0,0.4,${anchor.x + 1.5},${anchor.y + 3})`
    });
$d98ab47df6e11503$var$CheckIcon.displayName = "CheckIcon";
const $d98ab47df6e11503$var$CheckInactiveIcon = ({ anchor: anchor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.check-inactive-icon",
        fill: "var(--ds-text-subtlest, #6B6E76)",
        stroke: "none",
        d: "M18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z M22.5857864,12.5857864 L16,19.1715729 L13.4142136,16.5857864 C12.633165,15.8047379 11.366835,15.8047379 10.5857864,16.5857864 C9.8047379,17.366835 9.8047379,18.633165 10.5857864,19.4142136 L14.5857864,23.4142136 C15.366835,24.1952621 16.633165,24.1952621 17.4142136,23.4142136 L25.4142136,15.4142136 C26.1952621,14.633165 26.1952621,13.366835 25.4142136,12.5857864 C24.633165,11.8047379 23.366835,11.8047379 22.5857864,12.5857864 Z",
        transform: `matrix(0.4,0,0,0.4,${anchor.x + 1.5},${anchor.y + 3})`
    });
$d98ab47df6e11503$var$CheckInactiveIcon.displayName = "CheckInactiveIcon";
const $d98ab47df6e11503$var$CrossIcon = ({ anchor: anchor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.cross-icon",
        fill: "var(--ds-icon-danger, #C9372C)",
        stroke: "none",
        d: "M18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z M12.1745714,12.1742923 C11.3918678,12.9536824 11.3891818,14.2200095 12.1685719,15.0027131 L15.183,18.03 L12.2338602,20.9972333 C11.4551613,21.7806245 11.458965,23.0469487 12.2423561,23.8256477 C13.0257473,24.6043467 14.2920715,24.6005429 15.0707705,23.8171518 L18.005,20.864 L20.8848942,23.7560915 C21.6642843,24.538795 22.9306114,24.5414811 23.7133149,23.762091 C24.4960185,22.9827009 24.4987046,21.7163738 23.7193145,20.9336703 L20.825,18.027 L23.7899828,15.0454007 C24.5686818,14.2620096 24.564878,12.9956853 23.7814869,12.2169863 C22.9980957,11.4382874 21.7317715,11.4420911 20.9530725,12.2254822 L18.003,15.193 L15.0029922,12.1802919 C14.2236021,11.3975883 12.957275,11.3949022 12.1745714,12.1742923 Z",
        transform: `matrix(0.4,0,0,0.4,${anchor.x + 1.5},${anchor.y + 3})`
    });
$d98ab47df6e11503$var$CrossIcon.displayName = "CrossIcon";
const $d98ab47df6e11503$var$CrossInactiveIcon = ({ anchor: anchor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.cross-inactive-icon",
        fill: "var(--ds-text-subtlest, #6B6E76)",
        stroke: "none",
        d: "M18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z M12.1745714,12.1742923 C11.3918678,12.9536824 11.3891818,14.2200095 12.1685719,15.0027131 L15.183,18.03 L12.2338602,20.9972333 C11.4551613,21.7806245 11.458965,23.0469487 12.2423561,23.8256477 C13.0257473,24.6043467 14.2920715,24.6005429 15.0707705,23.8171518 L18.005,20.864 L20.8848942,23.7560915 C21.6642843,24.538795 22.9306114,24.5414811 23.7133149,23.762091 C24.4960185,22.9827009 24.4987046,21.7163738 23.7193145,20.9336703 L20.825,18.027 L23.7899828,15.0454007 C24.5686818,14.2620096 24.564878,12.9956853 23.7814869,12.2169863 C22.9980957,11.4382874 21.7317715,11.4420911 20.9530725,12.2254822 L18.003,15.193 L15.0029922,12.1802919 C14.2236021,11.3975883 12.957275,11.3949022 12.1745714,12.1742923 Z",
        transform: `matrix(0.4,0,0,0.4,${anchor.x + 1.5},${anchor.y + 3})`
    });
$d98ab47df6e11503$var$CrossInactiveIcon.displayName = "CrossInactiveIcon";
const $d98ab47df6e11503$var$ErrorIcon = ({ anchor: anchor, inverse: inverse = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.error-icon",
        fill: inverse ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #292A2E)",
        stroke: "none",
        d: "M7.28711356,1.29771564 L7.4143185,1.41458101 L10.5856815,4.58607097 C11.3279955,5.32841471 11.3648683,6.50189375 10.7025422,7.28746336 L10.5856815,7.41465944 L7.4143185,10.5857867 C6.67200448,11.3280455 5.49850741,11.3649156 4.71288644,10.7026387 L4.5856815,10.5857867 L1.4143185,7.41465944 C0.67200448,6.67240061 0.63513165,5.49892578 1.29745781,4.71328041 L1.4143185,4.58607097 L4.5856815,1.41458101 C5.32799552,0.67223727 6.50149259,0.63536297 7.28711356,1.29771564 Z M6,8 L5.90152767,8.0072327 C5.58016529,8.054876 5.33333333,8.3321212 5.33333333,8.6666667 L5.33333333,8.6666667 L5.34056599,8.765139 C5.38820937,9.0865014 5.66545455,9.3333333 6,9.3333333 L6,9.3333333 L6.09847233,9.3261007 C6.41983471,9.2784573 6.66666667,9.0012121 6.66666667,8.6666667 L6.66666667,8.6666667 L6.65943401,8.5681943 C6.61179063,8.246832 6.33454545,8 6,8 L6,8 Z M6,2.66666667 L5.90152767,2.67389932 C5.61230153,2.71677836 5.38344503,2.94563486 5.34056599,3.23486101 L5.33333333,3.33333333 L5.33333333,6.66666667 C5.33333333,7.00121212 5.58016529,7.2784573 5.90152767,7.32610068 L6,7.33333333 L6.09847233,7.32610068 C6.38769847,7.28322164 6.61655497,7.05436514 6.65943401,6.76513899 L6.66666667,6.66666667 L6.66666667,3.33333333 C6.66666667,2.96533333 6.368,2.66666667 6,2.66666667 Z",
        transform: `matrix(1.3,0,0,1.3,${anchor.x + 1.5},${anchor.y + 2})`
    });
$d98ab47df6e11503$var$ErrorIcon.displayName = "ErrorIcon";
const $d98ab47df6e11503$var$SharedTransitionIcon = ({ anchor: anchor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.shared-transition-icon",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.48039 0.214666L3.52772 2.18467C3.40318 2.3106 3.33333 2.48056 3.33333 2.65767C3.33333 2.83478 3.40318 3.00474 3.52772 3.13067C3.58888 3.19277 3.66179 3.24209 3.74219 3.27575C3.82259 3.30941 3.90889 3.32675 3.99605 3.32675C4.08322 3.32675 4.16951 3.30941 4.24992 3.27575C4.33032 3.24209 4.40322 3.19277 4.46439 3.13067L5.33333 2.25454V4.66667H2C1.63181 4.66667 1.33333 4.96514 1.33333 5.33333V8.1138C0.556539 8.38836 0 9.12919 0 10C0 11.1046 0.895431 12 2 12C3.10457 12 4 11.1046 4 10C4 9.12919 3.44346 8.38836 2.66667 8.1138V6H5.33333L6 6L6.66667 6L9.33333 6V8.1138C8.55654 8.38836 8 9.12919 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 9.12919 11.4435 8.38836 10.6667 8.1138V5.33333C10.6667 4.96514 10.3682 4.66667 10 4.66667H6.66667V2.26209L7.53439 3.13733C7.59571 3.1994 7.66874 3.24867 7.74925 3.2823C7.82976 3.31593 7.91614 3.33325 8.00339 3.33325C8.09064 3.33325 8.17702 3.31593 8.25752 3.2823C8.33803 3.24867 8.41106 3.1994 8.47239 3.13733C8.59676 3.01132 8.6665 2.84139 8.6665 2.66433C8.6665 2.48728 8.59676 2.31735 8.47239 2.19133L6.51239 0.214666C6.37456 0.077525 6.18815 0.000372232 5.99372 0C5.80772 0 5.62239 0.071333 5.48039 0.214666ZM1.33333 10C1.33333 9.63181 1.63181 9.33333 2 9.33333C2.36819 9.33333 2.66667 9.63181 2.66667 10C2.66667 10.3682 2.36819 10.6667 2 10.6667C1.63181 10.6667 1.33333 10.3682 1.33333 10ZM9.33333 10C9.33333 9.63181 9.63181 9.33333 10 9.33333C10.3682 9.33333 10.6667 9.63181 10.6667 10C10.6667 10.3682 10.3682 10.6667 10 10.6667C9.63181 10.6667 9.33333 10.3682 9.33333 10Z",
        fill: "var(--ds-icon, #292A2E)",
        transform: `matrix(1.1,0,0,1.1,${anchor.x + 1.2},${anchor.y + 3})`
    });
$d98ab47df6e11503$var$SharedTransitionIcon.displayName = "SharedTransitionIcon";
// Subject to change based on design review, see https://jplat.atlassian.net/browse/CRCS-2854
const $d98ab47df6e11503$var$TriggerAgentIcon = ({ anchor: anchor, inverse: inverse = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.trigger-agent-icon",
        clipRule: "evenodd",
        fillRule: "evenodd",
        stroke: "none",
        d: "M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5",
        fill: inverse ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #292A2E)",
        transform: `matrix(0.9,0,0,0.9,${anchor.x + 1.5},${anchor.y + 2.5})`
    });
$d98ab47df6e11503$var$TriggerAgentIcon.displayName = "TriggerAgentIcon";
const $d98ab47df6e11503$export$c0faf18b76ac5204 = ({ setRef: setRef, anchor: anchor, icons: icons, inverse: inverse = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        ref: setRef
    }, icons.map((iconType, index)=>{
        switch(iconType){
            case (0, $k9d6y.TransitionIcons).TriggerAgent:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d98ab47df6e11503$var$TriggerAgentIcon, {
                    key: "agent",
                    inverse: inverse,
                    anchor: (0, $2iYvg.add)(anchor, (0, $k9d6y.toPoint)(index * $d98ab47df6e11503$var$ICON_PADDING, 0))
                });
            case (0, $k9d6y.TransitionIcons).Bolt:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d98ab47df6e11503$var$BoltIcon, {
                    key: "bolt",
                    inverse: inverse,
                    anchor: (0, $2iYvg.add)(anchor, (0, $k9d6y.toPoint)(index * $d98ab47df6e11503$var$ICON_PADDING, 0))
                });
            case (0, $k9d6y.TransitionIcons).Error:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d98ab47df6e11503$var$ErrorIcon, {
                    key: "error",
                    inverse: inverse,
                    anchor: (0, $2iYvg.add)(anchor, (0, $k9d6y.toPoint)(index * $d98ab47df6e11503$var$ICON_PADDING, 0))
                });
            case (0, $k9d6y.TransitionIcons).Check:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d98ab47df6e11503$var$CheckIcon, {
                    key: "check",
                    anchor: (0, $2iYvg.add)(anchor, (0, $k9d6y.toPoint)(index * $d98ab47df6e11503$var$ICON_PADDING, 0))
                });
            case (0, $k9d6y.TransitionIcons).CheckInactive:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d98ab47df6e11503$var$CheckInactiveIcon, {
                    key: "check-inactive",
                    anchor: (0, $2iYvg.add)(anchor, (0, $k9d6y.toPoint)(index * $d98ab47df6e11503$var$ICON_PADDING, 0))
                });
            case (0, $k9d6y.TransitionIcons).Cross:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d98ab47df6e11503$var$CrossIcon, {
                    key: "cross",
                    anchor: (0, $2iYvg.add)(anchor, (0, $k9d6y.toPoint)(index * $d98ab47df6e11503$var$ICON_PADDING, 0))
                });
            case (0, $k9d6y.TransitionIcons).CrossInactive:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d98ab47df6e11503$var$CrossInactiveIcon, {
                    key: "cross-inactive",
                    anchor: (0, $2iYvg.add)(anchor, (0, $k9d6y.toPoint)(index * $d98ab47df6e11503$var$ICON_PADDING, 0))
                });
            case (0, $k9d6y.TransitionIcons).SharedTransition:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($d98ab47df6e11503$var$SharedTransitionIcon, {
                    key: iconType,
                    anchor: (0, $2iYvg.add)(anchor, (0, $k9d6y.toPoint)(index * $d98ab47df6e11503$var$ICON_PADDING, 0))
                });
            default:
                return null;
        }
    }));
$d98ab47df6e11503$export$c0faf18b76ac5204.displayName = "IconSet";

});


parcelRegister("6Uuik", function(module, exports) {
$parcel$export(module.exports, "useAutoLayout", () => $eb17e8fc5a15e322$export$1f798865516ae65f);

var $euxye = parcelRequire("euxye");

var $2700E = parcelRequire("2700E");

var $33SjG = parcelRequire("33SjG");

var $38YZm = parcelRequire("38YZm");

var $i5aNJ = parcelRequire("i5aNJ");

var $2lVCV = parcelRequire("2lVCV");

var $aLlWy = parcelRequire("aLlWy");

var $dI9CN = parcelRequire("dI9CN");

var $8E1Pl = parcelRequire("8E1Pl");
const $eb17e8fc5a15e322$export$1f798865516ae65f = ({ transitions: transitions, startNodePosition: startNodePosition, statuses: statuses, statusWidths: statusWidths, isStatusWidthsReady: isStatusWidthsReady, rootSvgRef: rootSvgRef, canvasContainerRef: canvasContainerRef, providedGlobalLoopsContainerPosition: providedGlobalLoopsContainerPosition, onClearGlobalLoopsContainerPosition: onClearGlobalLoopsContainerPosition, onTransitionPortChange: onTransitionPortChange, onItemMove: onItemMove, onPan: onPan, onZoom: onZoom, globalLoopedTransitions: globalLoopedTransitions })=>{
    const latestStatuses = (0, $i5aNJ.useLatest)(statuses);
    const latestStatusWidths = (0, $i5aNJ.useLatest)(statusWidths);
    const hasInitialised = (0, $euxye.useRef)('pending');
    const [isLayoutStable, setIsLayoutStable] = (0, $euxye.useState)(false);
    const doesDiagramContainGlobalLoops = transitions.some((x)=>x.type === 'global-looped');
    const previousDoesDiagramContainGlobalLoops = (0, $33SjG.usePrevious)(doesDiagramContainGlobalLoops);
    const [defaultPositions, setDefaultPositions] = (0, $euxye.useState)({});
    const [defaultGlobalLoopsContainerPosition, setDefaultGlobalLoopsContainerPosition] = (0, $euxye.useState)();
    const [shouldAutoFit, setShouldAutoFit] = (0, $euxye.useState)(false);
    const [transitionsWithDefaultPorts, setTransitionsWithDefaultPorts] = (0, $euxye.useState)({});
    const latestDefaultPositions = (0, $i5aNJ.useLatest)(defaultPositions);
    const latestDefaultGlobalLoopsContainerPosition = (0, $i5aNJ.useLatest)(defaultGlobalLoopsContainerPosition);
    const latestStartNodePosition = (0, $i5aNJ.useLatest)(startNodePosition);
    const latestOnItemMove = (0, $i5aNJ.useLatest)(onItemMove);
    const contentBounds = (0, $2700E.expVal)('hix-8229-dynamic-zoom-experiment', 'isEnabled', false) ? (0, $8E1Pl.calculateContentBounds)({
        statuses: statuses,
        statusWidths: statusWidths,
        startNodePosition: startNodePosition,
        globalLoopsContainerPosition: providedGlobalLoopsContainerPosition ?? defaultGlobalLoopsContainerPosition,
        globalLoopedTransitionsCount: globalLoopedTransitions.length,
        padding: 100,
        defaultPositions: defaultPositions
    }) : undefined;
    const latestContentBounds = (0, $i5aNJ.useLatest)(contentBounds);
    const autoFit = (0, $euxye.useCallback)(()=>{
        // Only use state-based content bounds when experiment is enabled;
        // control group falls back to DOM measurement (old behavior)
        const boundsForAutoFit = (0, $2700E.expVal)('hix-8229-dynamic-zoom-experiment', 'isEnabled', false) ? latestContentBounds.current : undefined;
        (0, $dI9CN.autoFitCanvas)(rootSvgRef, canvasContainerRef, onPan, onZoom, boundsForAutoFit);
        (0, $dI9CN.deferredExecute)(()=>{
            setIsLayoutStable(true);
        });
    }, [
        canvasContainerRef,
        onPan,
        onZoom,
        rootSvgRef,
        latestContentBounds
    ]);
    const autoPositionStatuses = (0, $euxye.useCallback)(()=>{
        const positioned = (0, $dI9CN.findDefaultPositions)(latestStatusWidths.current, latestStartNodePosition.current, statuses, latestDefaultPositions.current);
        if (positioned.length) {
            const newPositions = positioned.reduce((acc, positionable)=>{
                acc[positionable.id] = positionable.position;
                return acc;
            }, {});
            setDefaultPositions((prev)=>({
                    ...prev,
                    ...newPositions
                }));
            positioned.forEach((positionable)=>{
                latestOnItemMove.current?.(positionable);
            });
        }
        return positioned;
    }, [
        latestDefaultPositions,
        latestOnItemMove,
        latestStatusWidths,
        latestStartNodePosition,
        statuses
    ]);
    (0, $euxye.useEffect)(()=>{
        // Effect to handle auto positioning of global loops container when global loop container is added or removed from diagram
        if (doesDiagramContainGlobalLoops) {
            if (!(0, $38YZm.isNilOrEmpty)(latestDefaultGlobalLoopsContainerPosition.current)) // Exit early if global loops container already has a default position set
            return;
            const defaultPosition = !(0, $38YZm.isNilOrEmpty)(providedGlobalLoopsContainerPosition) ? providedGlobalLoopsContainerPosition : (0, $2lVCV.calculateDefaultGlobalLoopsContainerPosition)(startNodePosition, statuses, defaultPositions);
            setDefaultGlobalLoopsContainerPosition(defaultPosition);
            // Call container move callback to save the calculated default back to the component that mounts the accessible diagram
            defaultPosition && latestOnItemMove.current?.({
                id: (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE),
                type: (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE),
                position: defaultPosition
            });
        } else if (previousDoesDiagramContainGlobalLoops) {
            // When global loops are removed from the diagram, clear out the global loops position so a new auto position can be calculated when it is added back
            setDefaultGlobalLoopsContainerPosition(undefined);
            onClearGlobalLoopsContainerPosition();
        }
    }, [
        doesDiagramContainGlobalLoops,
        previousDoesDiagramContainGlobalLoops,
        latestDefaultGlobalLoopsContainerPosition,
        providedGlobalLoopsContainerPosition,
        startNodePosition,
        statuses,
        defaultPositions,
        latestOnItemMove,
        onClearGlobalLoopsContainerPosition
    ]);
    (0, $euxye.useEffect)(()=>{
        // On initialisation - auto position statuses after timeout so that status widths are available and always autofit
        if (hasInitialised.current === 'pending') hasInitialised.current = 'started';
        if (hasInitialised.current === 'started' && isStatusWidthsReady) {
            autoPositionStatuses();
            setShouldAutoFit(true);
            hasInitialised.current = 'finished';
        }
        // Subsequent additional statuses - auto position statuses and auto fit if status has been positioned
        if (hasInitialised.current === 'finished') {
            const positioned = autoPositionStatuses();
            if (positioned.length) setShouldAutoFit(true);
        }
    }, [
        autoPositionStatuses,
        latestDefaultPositions,
        latestOnItemMove,
        latestStatusWidths,
        startNodePosition,
        statuses,
        isStatusWidthsReady
    ]);
    (0, $euxye.useEffect)(()=>{
        // autofit after next render so that auto positioned statuses are in place
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        if (shouldAutoFit) {
            autoFit();
            setShouldAutoFit(false);
        }
    }, [
        autoFit,
        shouldAutoFit
    ]);
    /** Update transitions with undefined ports */ (0, $euxye.useEffect)(()=>{
        const updatedTransitions = {};
        const updateTransition = (transition)=>{
            updatedTransitions[transition.id] = transition;
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onTransitionPortChange?.(transition);
        };
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        transitions.forEach((transition)=>{
            if (transition.type === 'global-looped' || transition.type === 'global' || (0, $38YZm.isDirectOrSharedTransitionWithDefinedPorts)(transition)) return;
            if (transition.type === 'shared') {
                const positioned = (0, $dI9CN.definePortsOnSharedTransition)(transition, latestStatuses.current);
                updateTransition(positioned);
                return;
            }
            const positioned = (0, $dI9CN.definePortsOnDirectTransition)(transition, latestStatuses.current);
            updateTransition(positioned);
        });
        setTransitionsWithDefaultPorts(updatedTransitions);
    }, [
        transitions,
        latestStatuses,
        onTransitionPortChange
    ]);
    return {
        isLayoutStable: isLayoutStable,
        defaultPositions: defaultPositions,
        defaultGlobalLoopsContainerPosition: defaultGlobalLoopsContainerPosition,
        transitionsWithDefaultPorts: transitionsWithDefaultPorts,
        contentBounds: contentBounds
    };
};

});
parcelRegister("33SjG", function(module, exports) {
$parcel$export(module.exports, "usePrevious", () => $16dde21f554ca6e2$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousPersistent", () => $16dde21f554ca6e2$export$9c42f2690cfe6963);
$parcel$export(module.exports, "usePreviousWithInitial", () => $16dde21f554ca6e2$export$23fbbb2e62c4a911);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $16dde21f554ca6e2$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $euxye.useRef)();
    (0, $euxye.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $16dde21f554ca6e2$export$9c42f2690cfe6963 = (value)=>{
    // initialise the ref with previous and current values
    const ref = (0, $euxye.useRef)({
        value: value,
        prev: undefined
    });
    const current = ref.current.value;
    // if the value passed into hook doesn't match what we store as "current"
    // move the "current" to the "previous"
    // and store the passed value as "current"
    if (value !== current) ref.current = {
        value: value,
        prev: current
    };
    // return the previous value only
    return ref.current.prev;
};
const $16dde21f554ca6e2$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $euxye.useRef)(value);
    (0, $euxye.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});

parcelRegister("2lVCV", function(module, exports) {
$parcel$export(module.exports, "getTransitionLayer", () => $08f92c4b8a4c4541$export$933f49990d445c70);
$parcel$export(module.exports, "getStatusLayer", () => $08f92c4b8a4c4541$export$4bd193df4d34f0d7);
$parcel$export(module.exports, "getStartNodeLayer", () => $08f92c4b8a4c4541$export$ee6042e13e13003b);
$parcel$export(module.exports, "applyTransitionIconConditions", () => $08f92c4b8a4c4541$export$18f06647e1a06eb1);
$parcel$export(module.exports, "getTransitionSource", () => $08f92c4b8a4c4541$export$7e1664cbb47ef0e1);
$parcel$export(module.exports, "calculateDefaultGlobalLoopsContainerPosition", () => $08f92c4b8a4c4541$export$b8436f1af7483e1c);

var $1DCdt = parcelRequire("1DCdt");

var $as09W = parcelRequire("as09W");

var $k9d6y = parcelRequire("k9d6y");
function $08f92c4b8a4c4541$export$933f49990d445c70(transition) {
    if (transition.isHovered) return (0, $k9d6y.LayerIndex).Hover;
    if (transition.isRerouting) return (0, $k9d6y.LayerIndex).Proposals;
    if (transition.isSelected || transition.isTargeted || transition.isHighlighted) return (0, $k9d6y.LayerIndex).PrioritisedTransitions;
    return (0, $k9d6y.LayerIndex).TransitionsDefault;
}
function $08f92c4b8a4c4541$export$4bd193df4d34f0d7(status) {
    if (status.isHovered) return (0, $k9d6y.LayerIndex).Hover;
    if (status.isDragging || status.isMoving) return (0, $k9d6y.LayerIndex).Proposals;
    if (status.isSelected || status.isTargeted) return (0, $k9d6y.LayerIndex).PrioritisedStatuses;
    return (0, $k9d6y.LayerIndex).Default;
}
function $08f92c4b8a4c4541$export$ee6042e13e13003b(startNode) {
    if (startNode.isHovered) return (0, $k9d6y.LayerIndex).Hover;
    if (startNode.isDragging || startNode.isMoving) return (0, $k9d6y.LayerIndex).Proposals;
    if (startNode.isTargeted) return (0, $k9d6y.LayerIndex).PrioritisedStatuses;
    return (0, $k9d6y.LayerIndex).Default;
}
const $08f92c4b8a4c4541$export$18f06647e1a06eb1 = (icons, from)=>{
    switch(true){
        case typeof from === 'string':
            return icons.filter(({ fromStatuses: fromStatuses })=>!Array.isArray(fromStatuses) || fromStatuses.includes(from)).map(({ type: type })=>type);
        case Array.isArray(from):
            return icons.filter(({ fromStatuses: fromStatuses })=>!Array.isArray(fromStatuses) || fromStatuses.some((id)=>from.includes(id))).map(({ type: type })=>type);
        default:
            return icons.map(({ type: type })=>type);
    }
};
const $08f92c4b8a4c4541$export$7e1664cbb47ef0e1 = (transition)=>{
    if (transition.type === 'global-looped') return undefined;
    if (transition.type === 'global') return undefined;
    if (transition.type === 'shared') return transition.links.map((link)=>link.source);
    return transition.source;
};
const $08f92c4b8a4c4541$var$GLOBAL_LOOPS_CONTAINER_OFFSET_X = -250;
const $08f92c4b8a4c4541$var$GLOBAL_LOOPS_CONTAINER_OFFSET_Y = -50;
const $08f92c4b8a4c4541$export$b8436f1af7483e1c = (startNodePosition, statuses, defaultPositions)=>{
    const positionables = [
        startNodePosition || defaultPositions[0, $1DCdt.START_NODE_ID],
        ...statuses.map(({ id: id, position: position })=>position || defaultPositions[id])
    ];
    const areAllPositionablesStable = !positionables.some((position)=>!position);
    if (!areAllPositionablesStable) return undefined;
    let minY;
    let maxY;
    let minX;
    positionables.forEach((position)=>{
        if (!position) return;
        if (maxY === undefined || position.y + (0, $as09W.STATUS_HEIGHT) > maxY) maxY = position.y + (0, $as09W.STATUS_HEIGHT);
        if (minY === undefined || position.y < minY) minY = position.y;
        if (minX === undefined || position.x < minX) minX = position.x;
    });
    const x = (minX || 0) + $08f92c4b8a4c4541$var$GLOBAL_LOOPS_CONTAINER_OFFSET_X;
    const centerY = ((maxY || 0) + (minY || 0)) / 2 + $08f92c4b8a4c4541$var$GLOBAL_LOOPS_CONTAINER_OFFSET_Y;
    return {
        x: x,
        y: centerY
    };
};

});

parcelRegister("8E1Pl", function(module, exports) {
$parcel$export(module.exports, "calculateContentBounds", () => $e8a6c868e62a274d$export$cc8863e6a253805f);

var $as09W = parcelRequire("as09W");

var $6I3Lv = parcelRequire("6I3Lv");

var $a1HlX = parcelRequire("a1HlX");
const $e8a6c868e62a274d$export$fa8b3c44acbff40c = 100;
const $e8a6c868e62a274d$export$cc8863e6a253805f = ({ statuses: statuses, statusWidths: statusWidths = {}, startNodePosition: startNodePosition, globalLoopsContainerPosition: globalLoopsContainerPosition, globalLoopedTransitionsCount: globalLoopedTransitionsCount = 0, padding: padding = 100, defaultPositions: defaultPositions })=>{
    const bounds = [];
    for (const status of statuses){
        const position = status.position ?? defaultPositions?.[status.id];
        if (position) {
            const width = statusWidths[status.id] ?? $e8a6c868e62a274d$export$fa8b3c44acbff40c;
            bounds.push({
                x: position.x,
                y: position.y,
                width: width,
                height: (0, $as09W.STATUS_HEIGHT)
            });
        }
    }
    if (startNodePosition) bounds.push({
        x: startNodePosition.x - (0, $as09W.START_NODE_RADIUS),
        y: startNodePosition.y - (0, $as09W.START_NODE_RADIUS),
        width: (0, $as09W.START_NODE_RADIUS) * 2,
        height: (0, $as09W.START_NODE_RADIUS) * 2
    });
    if (globalLoopsContainerPosition && globalLoopedTransitionsCount > 0) bounds.push({
        x: globalLoopsContainerPosition.x,
        y: globalLoopsContainerPosition.y,
        width: (0, $a1HlX.CONTAINER_WIDTH),
        height: (0, $a1HlX.getContainerHeight)(globalLoopedTransitionsCount)
    });
    if (bounds.length === 0) return undefined;
    const contentBounds = (0, $6I3Lv.getCanvasBoundingBox)(bounds.map((b)=>new DOMRect(b.x, b.y, b.width, b.height)));
    return contentBounds ? (0, $6I3Lv.expandBoundingBox)(contentBounds, padding) : undefined;
};

});
parcelRegister("a1HlX", function(module, exports) {
$parcel$export(module.exports, "CONTAINER_WIDTH", () => $c8f3c1d8f58ce4c9$export$51aec347ac39078);
$parcel$export(module.exports, "LOZENGE_HEIGHT", () => $c8f3c1d8f58ce4c9$export$ec1acf08b99151bb);
$parcel$export(module.exports, "LOZENGE_BORDER_RADIUS", () => $c8f3c1d8f58ce4c9$export$7aa25920b550c80e);
$parcel$export(module.exports, "getGlobalLoopTransitionPosition", () => $c8f3c1d8f58ce4c9$export$cc25202f879fd2c5);
$parcel$export(module.exports, "getContainerHeight", () => $c8f3c1d8f58ce4c9$export$cf6292b4985d86a5);
$parcel$export(module.exports, "getLozengePosition", () => $c8f3c1d8f58ce4c9$export$36425df40d6710c4);
$parcel$export(module.exports, "getLozengeTextPosition", () => $c8f3c1d8f58ce4c9$export$7854da71fb30db7);
$parcel$export(module.exports, "globalLoopedTransitionRoute", () => $c8f3c1d8f58ce4c9$export$18cc9cc7ce4c58b9);
$parcel$export(module.exports, "getLozengeWidth", () => $c8f3c1d8f58ce4c9$export$985458f07240fb0b);
$parcel$export(module.exports, "getLabelPosition", () => $c8f3c1d8f58ce4c9$export$bd7634e2250a2a2c);
$parcel$export(module.exports, "getArrowPosition", () => $c8f3c1d8f58ce4c9$export$54d73b6175e7c49d);

var $as09W = parcelRequire("as09W");

var $k9d6y = parcelRequire("k9d6y");

var $2iYvg = parcelRequire("2iYvg");

var $dNy4O = parcelRequire("dNy4O");
const $c8f3c1d8f58ce4c9$var$CONTENT_PADDING_LEFT = 12;
const $c8f3c1d8f58ce4c9$var$CONTENT_PADDING = 12;
const $c8f3c1d8f58ce4c9$var$TRANSITION_PATH_WIDTH = 90;
const $c8f3c1d8f58ce4c9$var$TRANSITION_PATH_HEIGHT = 50;
const $c8f3c1d8f58ce4c9$var$TRANSITIONS_GAP = 30;
const $c8f3c1d8f58ce4c9$export$51aec347ac39078 = 160;
const $c8f3c1d8f58ce4c9$var$MIN_LOZENGE_WIDTH = 40;
const $c8f3c1d8f58ce4c9$export$ec1acf08b99151bb = 24;
const $c8f3c1d8f58ce4c9$export$7aa25920b550c80e = $c8f3c1d8f58ce4c9$export$ec1acf08b99151bb / 2;
const $c8f3c1d8f58ce4c9$var$LOZENGE_PADDING = 10; // total padding around left and right of lozenge, L + R value
const $c8f3c1d8f58ce4c9$var$LABEL_HEIGHT = 24;
const $c8f3c1d8f58ce4c9$export$cc25202f879fd2c5 = (position, index)=>(0, $2iYvg.add)(position, (0, $k9d6y.toPoint)($c8f3c1d8f58ce4c9$var$CONTENT_PADDING_LEFT, $c8f3c1d8f58ce4c9$var$CONTENT_PADDING + index * ($c8f3c1d8f58ce4c9$var$TRANSITION_PATH_HEIGHT + $c8f3c1d8f58ce4c9$var$TRANSITIONS_GAP)));
const $c8f3c1d8f58ce4c9$export$cf6292b4985d86a5 = (transitionsCount)=>$c8f3c1d8f58ce4c9$var$CONTENT_PADDING * 2 + transitionsCount * ($c8f3c1d8f58ce4c9$var$TRANSITION_PATH_HEIGHT + $c8f3c1d8f58ce4c9$var$TRANSITIONS_GAP);
const $c8f3c1d8f58ce4c9$export$36425df40d6710c4 = (position)=>({
        x: position.x,
        y: position.y + $c8f3c1d8f58ce4c9$var$TRANSITION_PATH_HEIGHT
    });
const $c8f3c1d8f58ce4c9$export$7854da71fb30db7 = (lozengePosition, lozengeWidth)=>(0, $2iYvg.add)(lozengePosition, (0, $k9d6y.toPoint)(lozengeWidth / 2, $c8f3c1d8f58ce4c9$export$ec1acf08b99151bb / 2 + 4));
const $c8f3c1d8f58ce4c9$export$18cc9cc7ce4c58b9 = (lozengePosition, lozengeWidth)=>{
    const lozengeMiddleRight = (0, $2iYvg.add)(lozengePosition, (0, $k9d6y.toPoint)(lozengeWidth, $c8f3c1d8f58ce4c9$export$ec1acf08b99151bb / 2));
    return (0, $dNy4O.combinePath)((0, $dNy4O.move)(lozengeMiddleRight), (0, $dNy4O.lineRight)($c8f3c1d8f58ce4c9$var$TRANSITION_PATH_WIDTH - lozengeWidth / 2), (0, $dNy4O.lineUp)($c8f3c1d8f58ce4c9$var$TRANSITION_PATH_HEIGHT), (0, $dNy4O.lineLeft)($c8f3c1d8f58ce4c9$var$TRANSITION_PATH_WIDTH), (0, $dNy4O.lineDown)($c8f3c1d8f58ce4c9$var$TRANSITION_PATH_HEIGHT - $c8f3c1d8f58ce4c9$export$ec1acf08b99151bb / 2 - (0, $as09W.PORT_RADIUS)));
};
const $c8f3c1d8f58ce4c9$export$985458f07240fb0b = (textWidth)=>Math.max($c8f3c1d8f58ce4c9$var$MIN_LOZENGE_WIDTH, textWidth + $c8f3c1d8f58ce4c9$var$LOZENGE_PADDING);
const $c8f3c1d8f58ce4c9$export$bd7634e2250a2a2c = (position)=>(0, $2iYvg.add)(position, (0, $k9d6y.toPoint)($c8f3c1d8f58ce4c9$var$TRANSITION_PATH_WIDTH - 5, $c8f3c1d8f58ce4c9$var$LABEL_HEIGHT / 2));
const $c8f3c1d8f58ce4c9$export$54d73b6175e7c49d = (lozengePosition, lozengeWidth)=>(0, $2iYvg.add)(lozengePosition, (0, $k9d6y.toPoint)(lozengeWidth / 2, 0));

});
parcelRegister("dNy4O", function(module, exports) {
$parcel$export(module.exports, "move", () => $63f82361c627a3e7$export$d947e5f4f4c48d48);
$parcel$export(module.exports, "line", () => $63f82361c627a3e7$export$53f1d5ea8de3d7c);
$parcel$export(module.exports, "lineUp", () => $63f82361c627a3e7$export$9df76f8840ecca30);
$parcel$export(module.exports, "lineDown", () => $63f82361c627a3e7$export$dd6c925082c620b);
$parcel$export(module.exports, "lineLeft", () => $63f82361c627a3e7$export$b285e852656515c);
$parcel$export(module.exports, "lineRight", () => $63f82361c627a3e7$export$f6a982dcdc83dc);
$parcel$export(module.exports, "combinePath", () => $63f82361c627a3e7$export$fba1874d3b3435ea);
const $63f82361c627a3e7$export$d947e5f4f4c48d48 = ({ x: x, y: y })=>`M${x},${y}`;
const $63f82361c627a3e7$export$53f1d5ea8de3d7c = ({ x: x, y: y })=>`L${x},${y}`;
const $63f82361c627a3e7$export$9df76f8840ecca30 = (amount)=>`l0,${-amount}`;
const $63f82361c627a3e7$export$dd6c925082c620b = (amount)=>`l0,${amount}`;
const $63f82361c627a3e7$export$b285e852656515c = (amount)=>`l${-amount},0`;
const $63f82361c627a3e7$export$f6a982dcdc83dc = (amount)=>`l${amount},0`;
const $63f82361c627a3e7$export$fba1874d3b3435ea = (...components)=>components.join('');

});




parcelRegister("3lbM4", function(module, exports) {
$parcel$export(module.exports, "useCanvasDragDropEvents", () => $8a53d3f95ae4c1a3$export$a53c45ebda9df7e2);
$parcel$export(module.exports, "useDraggableDataAttributes", () => $8a53d3f95ae4c1a3$export$5d8cee90f1863f3a);

var $euxye = parcelRequire("euxye");

var $k9d6y = parcelRequire("k9d6y");

var $2iYvg = parcelRequire("2iYvg");

var $38YZm = parcelRequire("38YZm");

var $i5aNJ = parcelRequire("i5aNJ");


var $5o476 = parcelRequire("5o476");

var $27qQj = parcelRequire("27qQj");
const $8a53d3f95ae4c1a3$export$a53c45ebda9df7e2 = ({ rootSvgRef: rootSvgRef, zoom: zoom, viewBox: viewBox, pan: pan, updatePan: updatePan, onSelect: onSelect, isImmutable: isImmutable, contentBounds: contentBounds })=>{
    const [dragSubject, setDragSubject] = (0, $euxye.useState)(undefined);
    const [dragDropState, setDragDropState] = (0, $euxye.useState)({
        isDragging: false
    });
    const [dragStartPosition, setDragStartPosition] = (0, $euxye.useState)();
    const [temporaryPan, setTemporaryPan] = (0, $euxye.useState)();
    const latestPan = (0, $i5aNJ.useLatest)(pan);
    const latestZoom = (0, $i5aNJ.useLatest)(zoom);
    const latestDragSubject = (0, $i5aNJ.useLatest)(dragSubject);
    const latestDragDropState = (0, $i5aNJ.useLatest)(dragDropState);
    const latestViewBox = (0, $i5aNJ.useLatest)(viewBox);
    const latestDragStartPosition = (0, $i5aNJ.useLatest)(dragStartPosition);
    const latestTemporaryPan = (0, $i5aNJ.useLatest)(temporaryPan);
    const latestContentBounds = (0, $i5aNJ.useLatest)(contentBounds);
    (0, $euxye.useEffect)(()=>{
        const handlePointerDown = (e)=>{
            const ancestor = (0, $5o476.findClosestDraggableAncestor)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            e.target, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            rootSvgRef.current);
            if (!ancestor) return;
            const dragType = ancestor.getAttribute((0, $3603c4e2c191682b$export$83f968f8e731fa74));
            const dragTargetId = ancestor.getAttribute((0, $3603c4e2c191682b$export$eb0a5100f29d97bb)) || undefined;
            if (dragType) {
                (0, $5o476.releasePointerCaptureIfHeld)(e);
                const ancestorBounds = (0, $38YZm.getBoundingClientRect)(ancestor);
                setDragSubject({
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                    type: dragType,
                    id: dragTargetId,
                    offset: (0, $2iYvg.divide)((0, $k9d6y.toPoint)(e.clientX - ancestorBounds.left, e.clientY - ancestorBounds.top), latestZoom.current)
                });
                setDragStartPosition((0, $k9d6y.toPoint)(e.clientX, e.clientY));
            }
        };
        const handlePointerMove = (e)=>{
            if (!latestDragSubject.current || !latestDragStartPosition.current) return;
            // Check if a drag has been started or it is a standard click
            const hasDragged = latestDragDropState.current.isDragging || e.clientX !== latestDragStartPosition.current.x || e.clientY !== latestDragStartPosition.current.y;
            if (!hasDragged) return;
            setDragDropState({
                isDragging: true,
                dragSubject: latestDragSubject.current,
                currentPosition: (0, $5o476.toDiagramPosition)(e.clientX, e.clientY, rootSvgRef.current, latestZoom.current, latestViewBox.current)
            });
            if (latestDragSubject.current.type === 'pan' && latestDragStartPosition.current) {
                const movement = (0, $k9d6y.toPoint)(e.clientX - latestDragStartPosition.current.x, e.clientY - latestDragStartPosition.current.y);
                const zoomedMovement = (0, $2iYvg.divide)(movement, latestZoom.current);
                const rawPan = (0, $2iYvg.subtract)(latestPan.current, zoomedMovement);
                const newPan = (0, $27qQj.clampPan)(rawPan, latestContentBounds.current, latestViewBox.current);
                setTemporaryPan(newPan);
            }
        };
        const handlePointerUp = (e)=>{
            // unselect current selected item if canvas background is clicked
            if (e.target === rootSvgRef.current && !isImmutable && !latestDragDropState.current.isDragging) onSelect?.(undefined);
            if (latestDragSubject.current) {
                if (latestTemporaryPan.current) {
                    updatePan(latestTemporaryPan.current);
                    setTemporaryPan(undefined);
                }
                setDragSubject(undefined);
                setDragDropState({
                    isDragging: false
                });
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('pointerdown', handlePointerDown);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('pointermove', handlePointerMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('pointerup', handlePointerUp);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('pointerdown', handlePointerDown);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('pointermove', handlePointerMove);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('pointerup', handlePointerUp);
        };
    }, [
        isImmutable,
        latestDragSubject,
        latestViewBox,
        latestZoom,
        onSelect,
        rootSvgRef,
        latestDragDropState,
        latestPan,
        updatePan,
        latestDragStartPosition,
        latestTemporaryPan,
        latestContentBounds
    ]);
    return {
        dragDropState: dragDropState,
        temporaryPan: temporaryPan
    };
};
const $8a53d3f95ae4c1a3$export$5d8cee90f1863f3a = (type, id)=>(0, $euxye.useMemo)(()=>({
            [(0, $3603c4e2c191682b$export$83f968f8e731fa74)]: type,
            [(0, $3603c4e2c191682b$export$eb0a5100f29d97bb)]: id
        }), [
        id,
        type
    ]);

});
/** Data attribute key for which the value is DragSubject's type */ const $3603c4e2c191682b$export$83f968f8e731fa74 = 'data-drag-type';
const $3603c4e2c191682b$export$eb0a5100f29d97bb = 'data-drag-id';

parcelRegister("5o476", function(module, exports) {
$parcel$export(module.exports, "toDiagramPosition", () => $7ce848675602c2c8$export$d9473476f2fff27f);
$parcel$export(module.exports, "findClosestDraggableAncestor", () => $7ce848675602c2c8$export$784ae781ab5d3c6);
$parcel$export(module.exports, "releasePointerCaptureIfHeld", () => $7ce848675602c2c8$export$3072b9c3ca4d3798);

var $k9d6y = parcelRequire("k9d6y");

const $7ce848675602c2c8$export$d9473476f2fff27f = (x, y, svgElement, zoom, viewBox)=>{
    const bound = svgElement?.getBoundingClientRect();
    const boundLeft = bound?.left || 0;
    const boundTop = bound?.top || 0;
    return (0, $k9d6y.toPoint)((x - boundLeft) / zoom + viewBox.left, (y - boundTop) / zoom + viewBox.top);
};
const $7ce848675602c2c8$export$784ae781ab5d3c6 = (target, stopAtAncestor)=>{
    let current = target;
    if (!stopAtAncestor.contains(target)) return null;
    while(current){
        if (current == null || current === stopAtAncestor) return stopAtAncestor;
        if (current.getAttribute((0, $3603c4e2c191682b$export$83f968f8e731fa74))) return current;
        current = current.parentElement;
    }
    return stopAtAncestor;
};
function $7ce848675602c2c8$export$3072b9c3ca4d3798(e) {
    if (e.target && e.target instanceof Element && e.target.hasPointerCapture(e.pointerId)) e.target.releasePointerCapture(e.pointerId);
}

});

parcelRegister("27qQj", function(module, exports) {
$parcel$export(module.exports, "clampPan", () => $cdc93e8f87bc0bb8$export$96b6e0edf0004ed3);
const $cdc93e8f87bc0bb8$export$96b6e0edf0004ed3 = (pan, contentBounds, viewBox, marginFactor = 0.25)=>{
    if (!contentBounds) return pan;
    const marginX = viewBox.width * marginFactor;
    const marginY = viewBox.height * marginFactor;
    const minX = contentBounds.x - marginX;
    const maxX = contentBounds.x + contentBounds.width + marginX;
    const minY = contentBounds.y - marginY;
    const maxY = contentBounds.y + contentBounds.height + marginY;
    return {
        x: Math.max(minX, Math.min(maxX, pan.x)),
        y: Math.max(minY, Math.min(maxY, pan.y))
    };
};

});


parcelRegister("gMsnF", function(module, exports) {
$parcel$export(module.exports, "useCanvasView", () => $7770853134440a36$export$da041b3c789750d);

var $euxye = parcelRequire("euxye");

var $38YZm = parcelRequire("38YZm");

var $i5aNJ = parcelRequire("i5aNJ");

var $a40OY = parcelRequire("a40OY");

var $6I3Lv = parcelRequire("6I3Lv");
const $7770853134440a36$export$da041b3c789750d = (zoom, pan, onViewBoxChange)=>{
    const canvasContainerRef = (0, $euxye.useRef)(null);
    const [diagramSize, setDiagramSize] = (0, $euxye.useState)((0, $6I3Lv.getInitialSize)());
    const [viewBox, setViewBox] = (0, $euxye.useState)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const onViewBoxChangeLatest = (0, $i5aNJ.useLatest)(onViewBoxChange);
    const updateViewBox = (0, $euxye.useCallback)((box)=>{
        setViewBox(box);
        onViewBoxChangeLatest.current?.(box);
    }, [
        onViewBoxChangeLatest
    ]);
    const observerCanvasSize = (0, $euxye.useCallback)((entry)=>{
        const { contentRect: { width: width, height: height } } = entry;
        setDiagramSize({
            width: width,
            height: height
        });
        updateViewBox((0, $38YZm.calculateViewBox)({
            width: width,
            height: height
        }, pan, zoom));
    }, [
        pan,
        updateViewBox,
        zoom
    ]);
    const { setRef: setCanvasContainerRef } = (0, $a40OY.default)(observerCanvasSize);
    (0, $euxye.useEffect)(()=>{
        setCanvasContainerRef(canvasContainerRef.current);
    }, [
        setCanvasContainerRef
    ]);
    return {
        canvasContainerRef: canvasContainerRef,
        diagramSize: diagramSize,
        viewBox: viewBox
    };
};

});
parcelRegister("a40OY", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bee6590517b1f63$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
const $4bee6590517b1f63$var$useResizeObserver = (cb)=>{
    const [ref, setRef] = (0, $euxye.useState)(null);
    (0, $euxye.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (!ref || !window.ResizeObserver) return undefined;
        const observer = new ResizeObserver((entries)=>{
            cb(entries[0]);
        });
        observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        cb
    ]);
    return {
        setRef: setRef
    };
};
var $4bee6590517b1f63$export$2e2bcd8739ae039 = $4bee6590517b1f63$var$useResizeObserver;

});


parcelRegister("8Rgow", function(module, exports) {
$parcel$export(module.exports, "useItemDragDrop", () => $f42236ee9aaf0b53$export$4fd28756cf7c7448);

var $euxye = parcelRequire("euxye");

var $e01Yt = parcelRequire("e01Yt");
const $f42236ee9aaf0b53$export$4fd28756cf7c7448 = ({ isImmutable: isImmutable, dragDropState: dragDropState, snappedSubjectPosition: snappedSubjectPosition, onItemMove: onItemMove })=>{
    const previousDraggingItem = (0, $euxye.useRef)(undefined);
    const draggingItem = isImmutable ? undefined : (0, $e01Yt.getDraggingItem)(dragDropState, snappedSubjectPosition);
    (0, $euxye.useEffect)(()=>{
        if (!draggingItem && previousDraggingItem.current) // item has been dropped
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        onItemMove?.(previousDraggingItem.current);
        previousDraggingItem.current = draggingItem;
    }, [
        draggingItem,
        onItemMove
    ]);
    return {
        draggingItem: draggingItem
    };
};

});
parcelRegister("e01Yt", function(module, exports) {
$parcel$export(module.exports, "getDraggingItem", () => $014d4bb387b35073$export$a5e4fe6aa18c1281);

var $2iYvg = parcelRequire("2iYvg");
const $014d4bb387b35073$export$a5e4fe6aa18c1281 = (dragDropState, positionOverride)=>{
    if (!dragDropState || !dragDropState.isDragging || dragDropState.dragSubject.type !== 'status' && dragDropState.dragSubject.type !== 'start-node' && dragDropState.dragSubject.type !== 'global-loops-container') return;
    return {
        type: dragDropState.dragSubject.type,
        id: dragDropState.dragSubject.id,
        position: positionOverride || (0, $2iYvg.subtract)(dragDropState.currentPosition, dragDropState.dragSubject.offset)
    };
};

});


parcelRegister("ga6R2", function(module, exports) {
$parcel$export(module.exports, "useOnWheel", () => $08a22bf9263e463f$export$b6b63f7ee81c9f36);

var $euxye = parcelRequire("euxye");

var $k9d6y = parcelRequire("k9d6y");

var $2iYvg = parcelRequire("2iYvg");

var $i5aNJ = parcelRequire("i5aNJ");

var $5G7fB = parcelRequire("5G7fB");

var $27qQj = parcelRequire("27qQj");
const $08a22bf9263e463f$export$b6b63f7ee81c9f36 = ({ pan: pan, zoom: zoom, updateZoom: updateZoom, updatePan: updatePan, minZoom: minZoom, contentBounds: contentBounds, viewBox: viewBox })=>{
    const latestPan = (0, $i5aNJ.useLatest)(pan);
    const latestContentBounds = (0, $i5aNJ.useLatest)(contentBounds);
    const latestViewBox = (0, $i5aNJ.useLatest)(viewBox);
    return (0, $euxye.useCallback)((e)=>{
        e.preventDefault();
        // Mac style zoom, two finger = pan, pinch to zoom
        const shouldZoom = e.ctrlKey;
        const shouldPan = !shouldZoom;
        if (shouldZoom) updateZoom((0, $5G7fB.getZoomFromDeltaY)(e.deltaY, zoom, minZoom));
        else if (shouldPan) {
            if (!e.target) return;
            const rawPan = (0, $2iYvg.add)(latestPan.current, (0, $k9d6y.toPoint)(e.deltaX, e.deltaY));
            const newPan = latestViewBox.current ? (0, $27qQj.clampPan)(rawPan, latestContentBounds.current, latestViewBox.current) : rawPan;
            updatePan(newPan);
        }
    }, [
        latestPan,
        latestContentBounds,
        latestViewBox,
        updatePan,
        updateZoom,
        zoom,
        minZoom
    ]);
};
var $08a22bf9263e463f$export$2e2bcd8739ae039 = $08a22bf9263e463f$export$b6b63f7ee81c9f36;

});
parcelRegister("5G7fB", function(module, exports) {
$parcel$export(module.exports, "getZoomFromDeltaY", () => $08fcbf7a414d6d0e$export$b802864ad072f2fa);

var $Mez5L = parcelRequire("Mez5L");

var $as09W = parcelRequire("as09W");

var $10IKr = parcelRequire("10IKr");
const $08fcbf7a414d6d0e$export$b802864ad072f2fa = (deltaY, currentZoom, minZoom = (0, $as09W.MINIMUM_ZOOM_LEVEL), maxZoom = (0, $as09W.MAXIMUM_ZOOM_LEVEL))=>{
    const delta = (0, (/*@__PURE__*/$parcel$interopDefault($Mez5L)))(deltaY, -0.1, 0.1);
    const newLinearZoom = (0, $10IKr.getLinearZoom)(currentZoom) - delta;
    const newZoom = (0, $10IKr.getExponentialZoom)(newLinearZoom);
    return (0, $10IKr.clampZoom)(newZoom, minZoom, maxZoom);
};

});
parcelRegister("10IKr", function(module, exports) {
$parcel$export(module.exports, "getLinearZoom", () => $6f1128836f37bedc$export$92ad4ab75b1348d7);
$parcel$export(module.exports, "getExponentialZoom", () => $6f1128836f37bedc$export$1c090fe1906100fd);
$parcel$export(module.exports, "clampZoom", () => $6f1128836f37bedc$export$80ff5834dba7d796);
$parcel$export(module.exports, "getNextZoomStep", () => $6f1128836f37bedc$export$6217ce1eaa5c65a);

var $Mez5L = parcelRequire("Mez5L");

var $as09W = parcelRequire("as09W");
const $6f1128836f37bedc$var$EXPONENTIAL_ZOOM_BASE = 2;
const $6f1128836f37bedc$var$LOGARITHMIC_ZOOM_BASE = Math.log(2);
const $6f1128836f37bedc$export$92ad4ab75b1348d7 = (exponentialZoom)=>Math.log(exponentialZoom) / $6f1128836f37bedc$var$LOGARITHMIC_ZOOM_BASE;
const $6f1128836f37bedc$export$1c090fe1906100fd = (linearZoom)=>$6f1128836f37bedc$var$EXPONENTIAL_ZOOM_BASE ** linearZoom;
const $6f1128836f37bedc$export$80ff5834dba7d796 = (zoom, minZoom = (0, $as09W.MINIMUM_ZOOM_LEVEL), maxZoom = (0, $as09W.MAXIMUM_ZOOM_LEVEL))=>(0, (/*@__PURE__*/$parcel$interopDefault($Mez5L)))(zoom, minZoom, maxZoom);
const $6f1128836f37bedc$export$6217ce1eaa5c65a = (zoom, direction, minZoom = (0, $as09W.MINIMUM_ZOOM_LEVEL), maxZoom = (0, $as09W.MAXIMUM_ZOOM_LEVEL))=>{
    const step = direction === 'IN' ? (0, $as09W.LINEAR_ZOOM_STEP) : -(0, $as09W.LINEAR_ZOOM_STEP);
    const nextLinearZoom = $6f1128836f37bedc$export$92ad4ab75b1348d7(zoom) + step;
    const nextZoom = $6f1128836f37bedc$export$1c090fe1906100fd(nextLinearZoom);
    return $6f1128836f37bedc$export$80ff5834dba7d796(nextZoom, minZoom, maxZoom);
};

});



parcelRegister("gNk7E", function(module, exports) {
$parcel$export(module.exports, "usePortDragAndDrop", () => $4be7cf651a4b98b5$export$49de3ac734cf9d9a);

var $euxye = parcelRequire("euxye");

var $i5aNJ = parcelRequire("i5aNJ");

var $3UZbu = parcelRequire("3UZbu");
const $4be7cf651a4b98b5$export$49de3ac734cf9d9a = ({ ports: ports, isImmutable: isImmutable, selectedItem: selectedItem, transitions: transitions, dragDropState: dragDropState, onTransitionReroutingMove: onTransitionReroutingMove, onTransitionProposalMove: onTransitionProposalMove })=>{
    const latestPortByStatusAndIndex = (0, $i5aNJ.useLatest)(ports);
    const selectedTransitionInfo = (0, $3UZbu.useSelectedTransitionInfo)({
        transitions: transitions,
        selectedItem: selectedItem
    });
    const latestSelectedTransitionInfo = (0, $i5aNJ.useLatest)(selectedTransitionInfo);
    (0, $euxye.useEffect)(()=>{
        if (isImmutable || !dragDropState.isDragging || dragDropState.dragSubject.type !== 'port') // no port being dragged, nothing to do
        return;
        const portBeingDragged = latestPortByStatusAndIndex.current[dragDropState.dragSubject.id];
        const latestSelectedTransition = latestSelectedTransitionInfo.current;
        const isSourcePortMoving = latestSelectedTransition?.sourcePortIndexKeys.some((portKey)=>portKey === portBeingDragged.key);
        const isTargetPortMoving = latestSelectedTransition?.targetPortIndexKeys.some((portKey)=>portKey === portBeingDragged.key);
        if (latestSelectedTransition && latestSelectedTransition.transition.type !== 'global' && !(latestSelectedTransition.transition.type === 'global-looped') && (isSourcePortMoving || isTargetPortMoving)) onTransitionReroutingMove({
            transition: latestSelectedTransition.transition,
            side: isSourcePortMoving ? 'source' : 'target',
            originalStatusId: portBeingDragged.statusId,
            originalPortKey: portBeingDragged.key,
            originalPortIndex: portBeingDragged.portIndex,
            currentPosition: dragDropState.currentPosition
        });
        else onTransitionProposalMove(dragDropState.dragSubject.id, {
            start: portBeingDragged.position,
            end: dragDropState.currentPosition
        });
    }, [
        dragDropState,
        isImmutable,
        latestPortByStatusAndIndex,
        latestSelectedTransitionInfo,
        onTransitionProposalMove,
        onTransitionReroutingMove
    ]);
};

});
parcelRegister("3UZbu", function(module, exports) {
$parcel$export(module.exports, "useSelectedTransitionInfo", () => $feea14121f52aed7$export$311b92958e309675);

var $euxye = parcelRequire("euxye");

var $1udxg = parcelRequire("1udxg");

var $aLlWy = parcelRequire("aLlWy");

var $k9d6y = parcelRequire("k9d6y");

var $38YZm = parcelRequire("38YZm");
const $feea14121f52aed7$export$311b92958e309675 = ({ transitions: transitions, selectedItem: selectedItem })=>{
    const selectedTransitionInfo = (0, $euxye.useMemo)(()=>{
        if (!selectedItem || selectedItem.type !== (0, $aLlWy.EDGE_TYPE)) return undefined;
        const selectedTransition = transitions.find((x)=>x.id === selectedItem.id);
        if (!selectedTransition) return undefined;
        let sourcePortIndexKeys = [];
        if ((0, $38YZm.isDirectOrSharedTransitionWithDefinedPorts)(selectedTransition)) {
            if (selectedTransition.type === 'direct') sourcePortIndexKeys = (0, (/*@__PURE__*/$parcel$interopDefault($1udxg)))([
                (0, $k9d6y.toPortKey)(selectedTransition.source, selectedTransition.sourceIndex)
            ]);
            else if (selectedTransition.type === 'shared') sourcePortIndexKeys = (0, (/*@__PURE__*/$parcel$interopDefault($1udxg)))(selectedTransition.links.map(({ source: source, sourceIndex: sourceIndex })=>(0, $k9d6y.toPortKey)(source, sourceIndex)));
        }
        let targetPortIndexKeys = [];
        if ((0, $38YZm.isDirectOrSharedTransitionWithDefinedPorts)(selectedTransition)) {
            if (selectedTransition.type === 'direct') targetPortIndexKeys = [
                (0, $k9d6y.toPortKey)(selectedTransition.target, selectedTransition.targetIndex)
            ];
            else if (selectedTransition.type === 'shared') targetPortIndexKeys = selectedTransition.links.map((x)=>(0, $k9d6y.toPortKey)(selectedTransition.target, x.targetIndex));
        }
        return {
            transition: selectedTransition,
            sourcePortIndexKeys: sourcePortIndexKeys,
            targetPortIndexKeys: targetPortIndexKeys
        };
    }, [
        selectedItem,
        transitions
    ]);
    return selectedTransitionInfo;
};
var $feea14121f52aed7$export$2e2bcd8739ae039 = $feea14121f52aed7$export$311b92958e309675;

});


parcelRegister("cx2ag", function(module, exports) {
$parcel$export(module.exports, "usePorts", () => $2ee57e4bf32f1309$export$655248e226a08400);
$parcel$export(module.exports, "toSquareUnitDirection", () => $2ee57e4bf32f1309$export$b25e3332b7e56531);

var $euxye = parcelRequire("euxye");

var $1udxg = parcelRequire("1udxg");

var $jkY0k = parcelRequire("jkY0k");

var $6jLTU = parcelRequire("6jLTU");

var $1DCdt = parcelRequire("1DCdt");

var $as09W = parcelRequire("as09W");

var $k9d6y = parcelRequire("k9d6y");

var $lhwEO = parcelRequire("lhwEO");

var $i5aNJ = parcelRequire("i5aNJ");

var $3UZbu = parcelRequire("3UZbu");

var $F6Cpy = parcelRequire("F6Cpy");
/** Distance between Status boundary and Port's center */ const $2ee57e4bf32f1309$var$PORT_STATUS_OFFSET = 3;
/** Fraction of a Status' width where PortIndeces `Top` and `Bottom` appear */ const $2ee57e4bf32f1309$var$PORT_TOP_OR_BOTTOM_X_FRACTION = 0.5;
/** Fraction of a Status' width where PortIndeces `TopLeft` and `BottomLeft` appear */ const $2ee57e4bf32f1309$var$PORT_TOPLEFT_OR_BOTTOMLEFT_X_FRACTION = 1 / 4.5;
/** Fraction of a Status' width where PortIndeces `TopRight` and `BottomRight` appear */ const $2ee57e4bf32f1309$var$PORT_TOPRIGHT_OR_BOTTOMRIGHT_X_FRACTION = 1 / 1.28;
function $2ee57e4bf32f1309$export$f006e34fa35e5c56(portIndex, statusPosition, statusWidth) {
    switch(portIndex){
        case (0, $k9d6y.PortIndex).Left:
            return (0, $k9d6y.toPoint)(statusPosition.x - $2ee57e4bf32f1309$var$PORT_STATUS_OFFSET, statusPosition.y + (0, $as09W.STATUS_HEIGHT) / 2);
        case (0, $k9d6y.PortIndex).TopLeft:
            return (0, $k9d6y.toPoint)(statusPosition.x + statusWidth * $2ee57e4bf32f1309$var$PORT_TOPLEFT_OR_BOTTOMLEFT_X_FRACTION, statusPosition.y - $2ee57e4bf32f1309$var$PORT_STATUS_OFFSET);
        case (0, $k9d6y.PortIndex).Top:
            return (0, $k9d6y.toPoint)(statusPosition.x + statusWidth * $2ee57e4bf32f1309$var$PORT_TOP_OR_BOTTOM_X_FRACTION, statusPosition.y - $2ee57e4bf32f1309$var$PORT_STATUS_OFFSET);
        case (0, $k9d6y.PortIndex).TopRight:
            return (0, $k9d6y.toPoint)(statusPosition.x + statusWidth * $2ee57e4bf32f1309$var$PORT_TOPRIGHT_OR_BOTTOMRIGHT_X_FRACTION, statusPosition.y - $2ee57e4bf32f1309$var$PORT_STATUS_OFFSET);
        case (0, $k9d6y.PortIndex).Right:
            return (0, $k9d6y.toPoint)(statusPosition.x + statusWidth + $2ee57e4bf32f1309$var$PORT_STATUS_OFFSET, statusPosition.y + (0, $as09W.STATUS_HEIGHT) * $2ee57e4bf32f1309$var$PORT_TOP_OR_BOTTOM_X_FRACTION);
        case (0, $k9d6y.PortIndex).BottomRight:
            return (0, $k9d6y.toPoint)(statusPosition.x + statusWidth * $2ee57e4bf32f1309$var$PORT_TOPRIGHT_OR_BOTTOMRIGHT_X_FRACTION, statusPosition.y + (0, $as09W.STATUS_HEIGHT) + $2ee57e4bf32f1309$var$PORT_STATUS_OFFSET);
        case (0, $k9d6y.PortIndex).Bottom:
            return (0, $k9d6y.toPoint)(statusPosition.x + statusWidth * $2ee57e4bf32f1309$var$PORT_TOP_OR_BOTTOM_X_FRACTION, statusPosition.y + (0, $as09W.STATUS_HEIGHT) + $2ee57e4bf32f1309$var$PORT_STATUS_OFFSET);
        case (0, $k9d6y.PortIndex).BottomLeft:
            return (0, $k9d6y.toPoint)(statusPosition.x + statusWidth * $2ee57e4bf32f1309$var$PORT_TOPLEFT_OR_BOTTOMLEFT_X_FRACTION, statusPosition.y + (0, $as09W.STATUS_HEIGHT) + $2ee57e4bf32f1309$var$PORT_STATUS_OFFSET);
        default:
            (0, $lhwEO.fireError)('PortIndex given does not match any known PortIndexes.', 'use-ports.utils.get-port-position', {
                portIndex: portIndex
            });
            return (0, $k9d6y.toPoint)(0, 0);
    }
}
const $2ee57e4bf32f1309$export$e3dd17f2878a4154 = ({ selectedItem: selectedItem, transitions: transitions })=>{
    const selectedTransitionInfo = (0, $3UZbu.useSelectedTransitionInfo)({
        selectedItem: selectedItem,
        transitions: transitions
    });
    const focusedPortKeys = (0, $euxye.useMemo)(()=>{
        if (!selectedTransitionInfo) return [];
        return (0, (/*@__PURE__*/$parcel$interopDefault($1udxg)))([
            ...selectedTransitionInfo.sourcePortIndexKeys,
            ...selectedTransitionInfo.targetPortIndexKeys
        ]);
    }, [
        selectedTransitionInfo
    ]);
    return focusedPortKeys;
};
const $2ee57e4bf32f1309$export$655248e226a08400 = ({ hoveredItem: hoveredItem, selectedItem: selectedItem, transitions: transitions, statusWidths: statusWidths, startNodePosition: startNodePosition, statuses: statuses, defaultPositions: defaultPositions, dragDropState: dragDropState, proposedTransition: proposedTransition, reroutingTransition: reroutingTransition, isImmutable: isImmutable })=>{
    const isProposingTransition = proposedTransition.stage !== 'none';
    let glowingPortKey;
    if (proposedTransition.stage === 'valid') glowingPortKey = proposedTransition.endPortKey;
    else if (reroutingTransition.stage === 'valid') glowingPortKey = reroutingTransition.proposedPortKey;
    const proposedTransitionStartPort = proposedTransition.stage === 'none' ? undefined : proposedTransition.startPortKey;
    const statusesThatShouldShowPorts = (0, $F6Cpy.useStatusesThatShouldShowPorts)({
        hoveredItem: hoveredItem,
        statuses: statuses,
        dragDropState: dragDropState,
        isProposingTransition: isProposingTransition,
        reroutingTransition: reroutingTransition
    });
    const portsConnectedToSelectedTransition = $2ee57e4bf32f1309$export$e3dd17f2878a4154({
        selectedItem: selectedItem,
        transitions: transitions
    });
    const latestStatuses = (0, $i5aNJ.useLatest)(statuses);
    const portsByPortKey = (0, $euxye.useMemo)(()=>{
        const ports = {};
        if (latestStatuses.current.length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(statusWidths)) return ports;
        const startNodePositionOrDefault = startNodePosition || defaultPositions[0, $1DCdt.START_NODE_ID];
        if (startNodePositionOrDefault) ports[0, $1DCdt.START_NODE_ID] = (0, $k9d6y.toPortInfo)((0, $1DCdt.START_NODE_ID), (0, $k9d6y.PortIndex).Bottom, {
            x: startNodePositionOrDefault.x + (0, $as09W.START_NODE_RADIUS),
            y: startNodePositionOrDefault.y + (0, $as09W.START_NODE_RADIUS) * 2 - (0, $as09W.PORT_RADIUS)
        }, false, false);
        return latestStatuses.current.reduce((acc, status)=>{
            const statusPosition = status.position || defaultPositions[status.id];
            if (statusPosition === undefined) return acc;
            const isVisibleForStatus = statusesThatShouldShowPorts.includes(status.id);
            (0, $k9d6y.allStatusPorts).forEach((portIndex)=>{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const portKey = (0, $k9d6y.toPortKey)(status.id, portIndex);
                acc[portKey] = {
                    key: portKey,
                    isVisible: (isVisibleForStatus || portsConnectedToSelectedTransition.includes(portKey)) && proposedTransitionStartPort !== portKey,
                    statusId: status.id,
                    portIndex: portIndex,
                    position: $2ee57e4bf32f1309$export$f006e34fa35e5c56(portIndex, statusPosition, statusWidths[status.id]),
                    isGlowing: glowingPortKey === portKey
                };
            });
            return acc;
        }, ports);
    }, [
        latestStatuses,
        statusWidths,
        startNodePosition,
        defaultPositions,
        statusesThatShouldShowPorts,
        portsConnectedToSelectedTransition,
        proposedTransitionStartPort,
        glowingPortKey
    ]);
    const visiblePorts = (0, $euxye.useMemo)(()=>{
        if (isImmutable) return [];
        return (0, (/*@__PURE__*/$parcel$interopDefault($jkY0k)))(portsByPortKey, (x)=>x.isVisible);
    }, [
        isImmutable,
        portsByPortKey
    ]);
    return {
        ports: portsByPortKey,
        visiblePorts: visiblePorts
    };
};
function $2ee57e4bf32f1309$export$b25e3332b7e56531(portIndex) {
    switch(portIndex){
        case (0, $k9d6y.PortIndex).Top:
        case (0, $k9d6y.PortIndex).TopRight:
        case (0, $k9d6y.PortIndex).TopLeft:
            return (0, $k9d6y.toPoint)(0, 1);
        case (0, $k9d6y.PortIndex).Bottom:
        case (0, $k9d6y.PortIndex).BottomRight:
        case (0, $k9d6y.PortIndex).BottomLeft:
            return (0, $k9d6y.toPoint)(0, -1);
        case (0, $k9d6y.PortIndex).Right:
            return (0, $k9d6y.toPoint)(-1, 0);
        case (0, $k9d6y.PortIndex).Left:
            return (0, $k9d6y.toPoint)(1, 0);
        default:
            return (0, $k9d6y.toPoint)(0, 0);
    }
}

});
parcelRegister("jkY0k", function(module, exports) {

var $cyoUD = parcelRequire("cyoUD");

var $kkBly = parcelRequire("kkBly");

var $9JUaE = parcelRequire("9JUaE");

var $jOlpf = parcelRequire("jOlpf");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $e13e6e2f37c8ee30$var$filter(collection, predicate) {
    var func = $jOlpf(collection) ? $cyoUD : $kkBly;
    return func(collection, $9JUaE(predicate, 3));
}
module.exports = $e13e6e2f37c8ee30$var$filter;

});
parcelRegister("kkBly", function(module, exports) {

var $73ZOi = parcelRequire("73ZOi");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $ecd2a5297630e8f4$var$baseFilter(collection, predicate) {
    var result = [];
    $73ZOi(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $ecd2a5297630e8f4$var$baseFilter;

});


parcelRegister("lhwEO", function(module, exports) {
$parcel$export(module.exports, "fireError", () => $78165a5866a6f3d1$export$ee6e888f68fd8ba1);

var $hFtK7 = parcelRequire("hFtK7");
const $78165a5866a6f3d1$export$ee6e888f68fd8ba1 = (messageOrError, location, attributes)=>{
    const errorObject = messageOrError instanceof Error ? messageOrError : new Error(messageOrError);
    (0, $hFtK7.fireErrorAnalytics)({
        error: errorObject,
        meta: {
            id: location,
            packageName: 'jiraAccessibleWorkflowDiagram',
            teamName: 'helix'
        },
        skipSentry: false,
        attributes: attributes
    });
};

});

parcelRegister("F6Cpy", function(module, exports) {
$parcel$export(module.exports, "useStatusesThatShouldShowPorts", () => $ca27b41239f52585$export$6a8b70aa5f9821f);

var $euxye = parcelRequire("euxye");

var $38YZm = parcelRequire("38YZm");
const $ca27b41239f52585$export$6a8b70aa5f9821f = ({ hoveredItem: hoveredItem, statuses: statuses, dragDropState: dragDropState, isProposingTransition: isProposingTransition, reroutingTransition: reroutingTransition })=>{
    const statusesThatShouldShowPorts = (0, $euxye.useMemo)(()=>{
        if (dragDropState.isDragging && dragDropState.dragSubject.type === 'status') return [];
        const isReroutingDirectTransition = reroutingTransition.stage !== 'none' && reroutingTransition.transition.type === 'direct';
        if (isProposingTransition || isReroutingDirectTransition) return statuses.map(({ id: id })=>id);
        if (reroutingTransition.stage !== 'none') {
            if (reroutingTransition.side === 'target') return statuses.map(({ id: id })=>id);
            // ignore ports from statuses that are already in the source list from showing,
            // except the one we're moving from already
            const reroutingSharedTransition = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            reroutingTransition.transition;
            const otherSourceStatusIds = reroutingSharedTransition.links.filter((link)=>link.source !== reroutingTransition.originalStatusId).map(({ source: source })=>source);
            return statuses.filter(({ id: id })=>!otherSourceStatusIds.includes(id)).map(({ id: id })=>id);
        }
        return statuses.filter((n)=>(0, $38YZm.statusMatchesReference)(n, hoveredItem)).map(({ id: id })=>id);
    }, [
        dragDropState,
        reroutingTransition,
        isProposingTransition,
        statuses,
        hoveredItem
    ]);
    return statusesThatShouldShowPorts;
};
var $ca27b41239f52585$export$2e2bcd8739ae039 = $ca27b41239f52585$export$6a8b70aa5f9821f;

});


parcelRegister("fy7V9", function(module, exports) {
$parcel$export(module.exports, "useRecordState", () => $e42291cbde1be3fe$export$8d6124146484a634);

var $euxye = parcelRequire("euxye");
const $e42291cbde1be3fe$export$8d6124146484a634 = (// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
initialValue = {})=>{
    const [state, setState] = (0, $euxye.useState)(initialValue);
    const setItem = (0, $euxye.useCallback)((key, value)=>{
        setState((prev)=>({
                ...prev,
                [key]: value
            }));
    }, []);
    return [
        state,
        setState,
        setItem
    ];
};

});

parcelRegister("h17Oj", function(module, exports) {
$parcel$export(module.exports, "useSnapLines", () => $71e8030691b1dff1$export$b69c21835c582cef);

var $as09W = parcelRequire("as09W");

var $e01Yt = parcelRequire("e01Yt");

var $grLYA = parcelRequire("grLYA");
const $71e8030691b1dff1$export$b69c21835c582cef = ({ isImmutable: isImmutable, statuses: statuses, transitions: transitions, statusWidths: statusWidths, startNodePosition: startNodePosition, globalLoopsContainerPosition: globalLoopsContainerPosition, movingItem: movingItem, dragDropState: dragDropState })=>{
    const subject = movingItem || (0, $e01Yt.getDraggingItem)(dragDropState);
    const globalLoopedTransitions = transitions.filter((transition)=>transition.type === 'global-looped');
    if (isImmutable || !subject) return {
        snapLines: []
    };
    const subjectBounds = (0, $grLYA.getSubjectBounds)(subject, statusWidths, globalLoopedTransitions.length);
    const othersOld = statuses.filter((status)=>status.id !== subject.id && status.position)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .map((status)=>(0, $grLYA.getBounds)(status.position, statusWidths[status.id], (0, $as09W.STATUS_HEIGHT)));
    if (subject.type !== 'start-node' && startNodePosition) othersOld.push((0, $grLYA.getBounds)(startNodePosition, (0, $as09W.START_NODE_RADIUS) * 2, (0, $as09W.START_NODE_RADIUS) * 2));
    const otherBounds = (0, $grLYA.getOtherBounds)(statuses, statusWidths, subject, startNodePosition, globalLoopsContainerPosition, globalLoopedTransitions.length);
    const snappables = (0, $grLYA.findAllSnappableLines)(subjectBounds, otherBounds);
    const snapLines = (0, $grLYA.aggregateSnapLines)(subjectBounds, snappables);
    const snappedSubjectPosition = (0, $grLYA.snapSubject)(subjectBounds, snapLines);
    return {
        snapLines: (0, $grLYA.toLines)(snapLines),
        snappedSubjectPosition: snappedSubjectPosition
    };
};

});
parcelRegister("grLYA", function(module, exports) {
$parcel$export(module.exports, "findAllSnappableLines", () => $0c002fa13763fca4$export$7fb4059c463d0a63);
$parcel$export(module.exports, "aggregateSnapLines", () => $0c002fa13763fca4$export$bf23497f1a2c32a9);
$parcel$export(module.exports, "snapSubject", () => $0c002fa13763fca4$export$ea2163b0ecb21cd2);
$parcel$export(module.exports, "toLines", () => $0c002fa13763fca4$export$d614ee83a8a0f115);
$parcel$export(module.exports, "getOtherBounds", () => $0c002fa13763fca4$export$d8ab6d98959ac338);
$parcel$export(module.exports, "getBounds", () => $0c002fa13763fca4$export$becd1e645219fa23);
$parcel$export(module.exports, "getSubjectBounds", () => $0c002fa13763fca4$export$ed0676213054c996);

var $3ViT3 = parcelRequire("3ViT3");

var $k9d6y = parcelRequire("k9d6y");

var $a1HlX = parcelRequire("a1HlX");

var $as09W = parcelRequire("as09W");

var $e8PEl = parcelRequire("e8PEl");
const $0c002fa13763fca4$var$SNAP_THRESHOLD = 3;
/** Returns true if two values are within the {@link SNAP_THRESHOLD} */ function $0c002fa13763fca4$var$isInSnapDistance(a, b) {
    return Math.abs(a - b) < $0c002fa13763fca4$var$SNAP_THRESHOLD;
}
/** Key used to merge snappables to snap lines. Uniqueness determined by alignment and axis value */ const $0c002fa13763fca4$var$toSnappableKey = (snappable)=>`${snappable.alignment}:${snappable.type === 'horizontal' ? snappable.x : snappable.y} `;
const $0c002fa13763fca4$var$horizontalAlignmentCombinations = [
    [
        (0, $e8PEl.HorizontalAlignment).left,
        (0, $e8PEl.HorizontalAlignment).left
    ],
    [
        (0, $e8PEl.HorizontalAlignment).left,
        (0, $e8PEl.HorizontalAlignment).right
    ],
    [
        (0, $e8PEl.HorizontalAlignment).left,
        (0, $e8PEl.HorizontalAlignment).middle
    ],
    [
        (0, $e8PEl.HorizontalAlignment).middle,
        (0, $e8PEl.HorizontalAlignment).left
    ],
    [
        (0, $e8PEl.HorizontalAlignment).middle,
        (0, $e8PEl.HorizontalAlignment).right
    ],
    [
        (0, $e8PEl.HorizontalAlignment).middle,
        (0, $e8PEl.HorizontalAlignment).middle
    ],
    [
        (0, $e8PEl.HorizontalAlignment).right,
        (0, $e8PEl.HorizontalAlignment).left
    ],
    [
        (0, $e8PEl.HorizontalAlignment).right,
        (0, $e8PEl.HorizontalAlignment).right
    ],
    [
        (0, $e8PEl.HorizontalAlignment).right,
        (0, $e8PEl.HorizontalAlignment).middle
    ]
];
const $0c002fa13763fca4$var$verticalAlignmentCombinations = [
    [
        (0, $e8PEl.VerticalAlignment).top,
        (0, $e8PEl.VerticalAlignment).top
    ],
    [
        (0, $e8PEl.VerticalAlignment).top,
        (0, $e8PEl.VerticalAlignment).bottom
    ],
    [
        (0, $e8PEl.VerticalAlignment).bottom,
        (0, $e8PEl.VerticalAlignment).top
    ],
    [
        (0, $e8PEl.VerticalAlignment).bottom,
        (0, $e8PEl.VerticalAlignment).bottom
    ]
];
const $0c002fa13763fca4$export$7fb4059c463d0a63 = (subject, others)=>{
    if (others.length === 0) return [];
    // find closest horizontal rays of same x value
    let closestDistanceX = Number.POSITIVE_INFINITY;
    let horizontalSnappables = [];
    $0c002fa13763fca4$var$horizontalAlignmentCombinations.forEach(([subjectAlignment, otherAlignment])=>{
        others.forEach((other)=>{
            if ($0c002fa13763fca4$var$isInSnapDistance(subject[subjectAlignment], other[otherAlignment])) {
                const distance = Math.abs(subject[subjectAlignment] - other[otherAlignment]);
                if (distance < closestDistanceX) {
                    // closer snappable exists on this axis, clear list
                    closestDistanceX = distance;
                    horizontalSnappables = [];
                }
                horizontalSnappables.push({
                    type: 'horizontal',
                    x: other[otherAlignment],
                    alignment: subjectAlignment,
                    top: other.top,
                    bottom: other.bottom
                });
            }
        });
    });
    // find closest verticals rays of same y value
    let closestDistanceY = Number.POSITIVE_INFINITY;
    let verticalSnappables = [];
    $0c002fa13763fca4$var$verticalAlignmentCombinations.forEach(([subjectAlignment, otherAlignment])=>{
        others.forEach((other)=>{
            if ($0c002fa13763fca4$var$isInSnapDistance(subject[subjectAlignment], other[otherAlignment])) {
                const distance = Math.abs(subject[subjectAlignment] - other[otherAlignment]);
                if (distance < closestDistanceY) {
                    // closer snappable exists on this axis, clear list
                    closestDistanceY = distance;
                    verticalSnappables = [];
                }
                verticalSnappables.push({
                    type: 'vertical',
                    y: other[otherAlignment],
                    alignment: subjectAlignment,
                    left: other.left,
                    right: other.right
                });
            }
        });
    });
    return [
        ...horizontalSnappables,
        ...verticalSnappables
    ];
};
const $0c002fa13763fca4$export$bf23497f1a2c32a9 = (subject, snappables)=>{
    if (snappables.length === 0) return [];
    const mapped = snappables.reduce((acc, snappable)=>{
        if (snappable.type === 'horizontal') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const existingSnapLine = acc[$0c002fa13763fca4$var$toSnappableKey(snappable)];
            if (existingSnapLine) {
                // if exists, just update the top-most/bottom-most values
                existingSnapLine.top = Math.min(existingSnapLine.top, snappable.top, subject.top);
                existingSnapLine.bottom = Math.max(existingSnapLine.bottom, snappable.bottom, subject.bottom);
            } else {
                const newSnapLine = {
                    type: 'horizontal',
                    x: snappable.x,
                    alignment: snappable.alignment,
                    top: Math.min(snappable.top, subject.top),
                    bottom: Math.max(snappable.bottom, subject.bottom)
                };
                acc[$0c002fa13763fca4$var$toSnappableKey(snappable)] = newSnapLine;
            }
        } else if (snappable.type === 'vertical') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const existingSnapLine = acc[$0c002fa13763fca4$var$toSnappableKey(snappable)];
            if (existingSnapLine) {
                // if exists, just update the left-most/right-most values
                existingSnapLine.left = Math.min(existingSnapLine.left, snappable.left, subject.left);
                existingSnapLine.right = Math.max(existingSnapLine.right, snappable.right, subject.right);
            } else {
                const newSnapLine = {
                    type: 'vertical',
                    y: snappable.y,
                    alignment: snappable.alignment,
                    left: Math.min(snappable.left, subject.left),
                    right: Math.max(snappable.right, subject.right)
                };
                acc[$0c002fa13763fca4$var$toSnappableKey(snappable)] = newSnapLine;
            }
        }
        return acc;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ViT3)))(mapped);
};
const $0c002fa13763fca4$export$ea2163b0ecb21cd2 = (subject, snapLines)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const firstHorizontal = snapLines.find((snapLine)=>snapLine.type === 'horizontal');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const firstVertical = snapLines.find((snapLine)=>snapLine.type === 'vertical');
    let x = subject.left;
    let y = subject.top;
    const subjectWidth = subject.right - subject.left;
    if (firstHorizontal?.alignment === 'left') x = firstHorizontal.x;
    else if (firstHorizontal?.alignment === 'middle') x = firstHorizontal.x - subjectWidth / 2;
    else if (firstHorizontal?.alignment === 'right') x = firstHorizontal.x - subjectWidth;
    const subjectHeight = subject.bottom - subject.top;
    if (firstVertical?.alignment === 'top') y = firstVertical.y;
    else if (firstVertical?.alignment === 'bottom') y = firstVertical.y - subjectHeight;
    return (0, $k9d6y.toPoint)(x, y);
};
const $0c002fa13763fca4$export$d614ee83a8a0f115 = (snapLines)=>snapLines.map((snapLine)=>{
        if (snapLine.type === 'horizontal') return {
            start: (0, $k9d6y.toPoint)(snapLine.x, snapLine.top),
            end: (0, $k9d6y.toPoint)(snapLine.x, snapLine.bottom)
        };
        return {
            start: (0, $k9d6y.toPoint)(snapLine.left, snapLine.y),
            end: (0, $k9d6y.toPoint)(snapLine.right, snapLine.y)
        };
    });
const $0c002fa13763fca4$export$d8ab6d98959ac338 = (statuses, statusWidths, subject, startNodePosition, globalLoopsContainerPosition, globalLoopedTransitionsCount)=>{
    // Status bounds that exclude the currently moving status (if any)
    const statusBounds = statuses.filter((status)=>status.id !== subject.id && status.position)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .map((status)=>$0c002fa13763fca4$export$becd1e645219fa23(status.position, statusWidths[status.id], (0, $as09W.STATUS_HEIGHT)));
    const containerHeight = (0, $a1HlX.getContainerHeight)(globalLoopedTransitionsCount);
    if (subject.type === 'status') {
        startNodePosition && statusBounds.push($0c002fa13763fca4$export$becd1e645219fa23(startNodePosition, (0, $as09W.START_NODE_RADIUS) * 2, (0, $as09W.START_NODE_RADIUS) * 2));
        globalLoopsContainerPosition && statusBounds.push($0c002fa13763fca4$export$becd1e645219fa23(globalLoopsContainerPosition, (0, $a1HlX.CONTAINER_WIDTH), containerHeight));
    } else if (subject.type === 'start-node') globalLoopsContainerPosition && statusBounds.push($0c002fa13763fca4$export$becd1e645219fa23(globalLoopsContainerPosition, (0, $a1HlX.CONTAINER_WIDTH), containerHeight));
    else if (subject.type === 'global-loops-container') startNodePosition && statusBounds.push($0c002fa13763fca4$export$becd1e645219fa23(startNodePosition, (0, $as09W.START_NODE_RADIUS) * 2, (0, $as09W.START_NODE_RADIUS) * 2));
    return statusBounds;
};
const $0c002fa13763fca4$export$ed0676213054c996 = (subject, statusWidths, globalLoopedTransitionsCount)=>{
    if (subject.type === 'status') return $0c002fa13763fca4$export$becd1e645219fa23(subject.position, statusWidths[subject.id], (0, $as09W.STATUS_HEIGHT));
    if (subject.type === 'global-loops-container') {
        const containerHeight = (0, $a1HlX.getContainerHeight)(globalLoopedTransitionsCount);
        return $0c002fa13763fca4$export$becd1e645219fa23(subject.position, (0, $a1HlX.CONTAINER_WIDTH), containerHeight);
    }
    return $0c002fa13763fca4$export$becd1e645219fa23(subject.position, (0, $as09W.START_NODE_RADIUS) * 2, (0, $as09W.START_NODE_RADIUS) * 2);
};
const $0c002fa13763fca4$export$becd1e645219fa23 = (position, width, height)=>({
        left: position.x,
        middle: position.x + width / 2,
        right: position.x + width,
        top: position.y,
        bottom: position.y + height
    });

});
parcelRegister("3ViT3", function(module, exports) {

var $74lYM = parcelRequire("74lYM");

var $k4FO8 = parcelRequire("k4FO8");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $2db5588cf5bf4dcf$var$values(object) {
    return object == null ? [] : $74lYM(object, $k4FO8(object));
}
module.exports = $2db5588cf5bf4dcf$var$values;

});
parcelRegister("74lYM", function(module, exports) {

var $bTATB = parcelRequire("bTATB");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $5259f4c148d74f06$var$baseValues(object, props) {
    return $bTATB(props, function(key) {
        return object[key];
    });
}
module.exports = $5259f4c148d74f06$var$baseValues;

});


parcelRegister("e8PEl", function(module, exports) {
$parcel$export(module.exports, "HorizontalAlignment", () => $e60f245b70739a98$export$d94dcb5bec64086e);
$parcel$export(module.exports, "VerticalAlignment", () => $e60f245b70739a98$export$c12e835f91722ef8);
/**
 * Alignable parts of a status across both horizontal and vertical axes
 *
 * ```
 * ┄┄╭――――――――――――――――╮┄┄┄┄┄ top
 *   |                |
 * ┄┄╰――――――――――――――――╯┄┄┄┄┄ bottom
 *
 * left   middle   right
 * ┆        ┆        ┆
 * ╭――――――――┆――――――――╮
 * |        ┆        |
 * ╰――――――――┆――――――――╯
 * ┆        ┆        ┆
 * ```
 */ var $e60f245b70739a98$export$d94dcb5bec64086e = /*#__PURE__*/ function(HorizontalAlignment) {
    HorizontalAlignment["left"] = "left";
    HorizontalAlignment["middle"] = "middle";
    HorizontalAlignment["right"] = "right";
    return HorizontalAlignment;
}({});
var $e60f245b70739a98$export$c12e835f91722ef8 = /*#__PURE__*/ function(VerticalAlignment) {
    VerticalAlignment["top"] = "top";
    VerticalAlignment["bottom"] = "bottom";
    return VerticalAlignment;
}({});

});



parcelRegister("6DIsc", function(module, exports) {
$parcel$export(module.exports, "useStartNode", () => $169fcbb7844c4540$export$b67102238a108f96);

var $1DCdt = parcelRequire("1DCdt");

var $38YZm = parcelRequire("38YZm");
const $169fcbb7844c4540$export$b67102238a108f96 = ({ startNodePosition: startNodePosition, targetedItem: targetedItem, hoveredItem: hoveredItem, draggingItem: draggingItem, movingItem: movingItem, defaultPositions: defaultPositions })=>{
    let position = startNodePosition || defaultPositions[0, $1DCdt.START_NODE_ID];
    const isDragging = draggingItem?.type === 'start-node';
    const isMoving = movingItem?.type === 'start-node';
    if (isDragging) position = draggingItem.position;
    if (isMoving) position = movingItem.position;
    return {
        id: (0, $1DCdt.START_NODE_ID),
        position: position,
        isTargeted: (0, $38YZm.isStartNodeReference)(targetedItem),
        isHovered: (0, $38YZm.isStartNodeReference)(hoveredItem),
        isDragging: isDragging,
        isMoving: isMoving
    };
};

});

parcelRegister("8zmMo", function(module, exports) {
$parcel$export(module.exports, "useStatefulStatuses", () => $57d51757193fc198$export$ab9803bd767942da);

var $38YZm = parcelRequire("38YZm");
const $57d51757193fc198$export$ab9803bd767942da = ({ statuses: statuses, selectedItem: selectedItem, targetedItem: targetedItem, hoveredItem: hoveredItem, draggingItem: draggingItem, movingItem: movingItem, defaultPositions: defaultPositions })=>statuses.map((status)=>{
        let position = status.position || defaultPositions[status.id];
        const isDragging = draggingItem?.type === 'status' && draggingItem?.id === status.id;
        const isMoving = movingItem?.type === 'status' && movingItem?.id === status.id;
        if (isDragging) position = draggingItem.position;
        if (isMoving) position = movingItem.position;
        return {
            ...status,
            position: position,
            isSelected: (0, $38YZm.statusMatchesReference)(status, selectedItem),
            isTargeted: (0, $38YZm.statusMatchesReference)(status, targetedItem),
            isHovered: (0, $38YZm.statusMatchesReference)(status, hoveredItem),
            isDragging: isDragging,
            isMoving: isMoving
        };
    });

});

parcelRegister("1dkUt", function(module, exports) {
$parcel$export(module.exports, "useStatefulTransitions", () => $602e6a134b9b9cab$export$8659463c3cf31448);

var $euxye = parcelRequire("euxye");

var $as09W = parcelRequire("as09W");

var $k9d6y = parcelRequire("k9d6y");

var $38YZm = parcelRequire("38YZm");

var $gc3g9 = parcelRequire("gc3g9");

var $ebAeq = parcelRequire("ebAeq");

var $5oiip = parcelRequire("5oiip");

var $geemr = parcelRequire("geemr");
const $602e6a134b9b9cab$export$6054b5d3597b4f98 = 35;
const $602e6a134b9b9cab$export$8659463c3cf31448 = ({ transitions: transitions, selectedItem: selectedItem, targetedItem: targetedItem, hoveredItem: hoveredItem, ports: ports, reroutingTransition: reroutingTransition, transitionsWithDefaultPorts: transitionsWithDefaultPorts })=>{
    const transitionLabelPlacementsNew = (0, $euxye.useMemo)(()=>(0, $ebAeq.calculateOverlappingLabelPlacement)(transitions), [
        transitions
    ]);
    const statefulTransitions = transitions.map((baseTransition)=>{
        let isOverlapping = false;
        let isOverlapHovered = false;
        // use default transition data if it exists and the base transition is missing ports
        const transition = (baseTransition.type === 'shared' || baseTransition.type === 'direct') && !(0, $38YZm.isDirectOrSharedTransitionWithDefinedPorts)(baseTransition) && transitionsWithDefaultPorts[baseTransition.id] ? transitionsWithDefaultPorts[baseTransition.id] : baseTransition;
        isOverlapping = (0, $38YZm.isTransitionOverlapping)(transition.id, transitionLabelPlacementsNew);
        isOverlapHovered = (0, $38YZm.isAnyOverlappingTransitionHovered)(transition.id, hoveredItem?.id, transitionLabelPlacementsNew);
        const transitionFlags = {
            isSelected: (0, $38YZm.transitionMatchesReference)(transition, selectedItem),
            isTargeted: (0, $38YZm.transitionMatchesReference)(transition, targetedItem),
            isHovered: (0, $38YZm.transitionMatchesReference)(transition, hoveredItem),
            isHighlighted: (0, $38YZm.isHighlightedTransition)(transition, selectedItem, hoveredItem),
            isRerouting: (0, $38YZm.isTransitionRerouting)(transition, reroutingTransition),
            isOverlapping: isOverlapping,
            isOverlapHovered: isOverlapHovered
        };
        if (transition.type === 'global-looped') {
            // TODO HIX-5551 implement label positions
            let labelPosition;
            return {
                ...transition,
                ...transitionFlags,
                labelPosition: labelPosition
            };
        }
        if (transition.type === 'global') {
            const targetPort = ports[(0, $k9d6y.toPortKey)(transition.target, (0, $as09W.GLOBAL_TRANSITION_PORT))];
            let labelPosition;
            if (targetPort?.position) labelPosition = (0, $k9d6y.toPoint)(targetPort.position.x, targetPort.position.y + $602e6a134b9b9cab$export$6054b5d3597b4f98);
            return {
                ...transition,
                ...transitionFlags,
                labelPosition: labelPosition,
                targetPort: targetPort
            };
        }
        if (transition.type === 'shared') return {
            ...transition,
            ...transitionFlags,
            ...(0, $geemr.getSharedTransitionLayout)(transition, ports, transitionLabelPlacementsNew, reroutingTransition)
        };
        // direct transition
        let sourcePort = (0, $38YZm.findPort)(ports, transition.source, transition.sourceIndex);
        sourcePort = (0, $38YZm.updateTransitionPortIfRerouting)(sourcePort, 'source', transition, reroutingTransition);
        let targetPort = (0, $38YZm.findPort)(ports, transition.target, transition.targetIndex);
        targetPort = (0, $38YZm.updateTransitionPortIfRerouting)(targetPort, 'target', transition, reroutingTransition);
        const labelPlacement = (0, $5oiip.getLabelPlacement)(transition.id, transitionLabelPlacementsNew);
        if (sourcePort && targetPort) {
            const { path: path, labelPosition: labelPosition } = (0, $gc3g9.manhattanPathAndLabelPosition)(sourcePort, targetPort, {
                fractionOfPath: labelPlacement,
                endsPadding: 0.25
            });
            return {
                ...transition,
                ...transitionFlags,
                sourcePort: sourcePort,
                targetPort: targetPort,
                path: path,
                labelPosition: labelPosition
            };
        }
        return {
            ...transition,
            ...transitionFlags,
            sourcePort: sourcePort,
            targetPort: targetPort,
            path: undefined,
            labelPosition: undefined
        };
    });
    return statefulTransitions;
};

});
parcelRegister("gc3g9", function(module, exports) {
$parcel$export(module.exports, "manhattanPathAndLabelPosition", () => $2c0bf49d8491f82b$export$ae89ccf025923e8);
/* eslint-disable no-param-reassign */ 
var $Mez5L = parcelRequire("Mez5L");

var $as09W = parcelRequire("as09W");

var $dNy4O = parcelRequire("dNy4O");

var $6fP87 = parcelRequire("6fP87");

var $6eksN = parcelRequire("6eksN");
/**
 * To prevent routing getting stuck in an infinite loop for whatever reason, we only perform this many iterations of each step.
 */ const $2c0bf49d8491f82b$var$MAX_ITERATIONS = 4;
const $2c0bf49d8491f82b$var$analyzeVectors = (subject, other)=>{
    const doesSubjectFaceOther = (0, $6eksN.inFrontOf)(subject, other);
    const doesOtherFaceSubject = (0, $6eksN.inFrontOf)(other, subject);
    const subjectAxis = (0, $6fP87.axisOf)(subject);
    const otherAxis = (0, $6fP87.axisOf)(other);
    const distanceBetween = (0, $6eksN.distanceAll)((0, $6fP87.extractPoint)(subject), (0, $6fP87.extractPoint)(other));
    const isFacingEachOtherOnSameLine = doesSubjectFaceOther && doesOtherFaceSubject && (0, $6eksN.hasSharedAxis)(subject, other);
    const isFacingEachOtherInParallel = doesSubjectFaceOther && doesOtherFaceSubject && subjectAxis === otherAxis;
    return {
        doesSubjectFaceOther: doesSubjectFaceOther,
        doesOtherFaceSubject: doesOtherFaceSubject,
        distanceBetween: distanceBetween,
        subjectAxis: subjectAxis,
        otherAxis: otherAxis,
        isFacingEachOtherOnSameLine: isFacingEachOtherOnSameLine,
        isFacingEachOtherInParallel: isFacingEachOtherInParallel
    };
};
/**
 * Performs a step in the manhattan routing given a 'subject' vector and 'other' vector to go towards.
 *
 * Logic is as follows
 * 1. if both facing each 'other' on same line, they can meet
 * 2. otherwise if both facing each 'other' but in parallel, they walk half way on that axis
 * 3. otherwise if subject faces 'other', move subject closest to 'other' in one axis
 * 4. otherwise subject has to turn towards 'other'
 *
 * See the [visualization of the steps](https://hello.atlassian.net/wiki/spaces/HELIX/pages/2821877619/Manhattan+Algorithm+-+React+Workflow+Diagram) for more info
 * @param subject the current 'subject' vector being considered
 * @param other the other vector (i.e. not the 'subject')
 * @returns
 */ function $2c0bf49d8491f82b$var$mutativelyPlotTo(subject, other) {
    const { doesSubjectFaceOther: doesSubjectFaceOther, doesOtherFaceSubject: doesOtherFaceSubject, subjectAxis: subjectAxis, otherAxis: otherAxis, isFacingEachOtherOnSameLine: isFacingEachOtherOnSameLine, isFacingEachOtherInParallel: isFacingEachOtherInParallel } = $2c0bf49d8491f82b$var$analyzeVectors(subject, other);
    // subject →      ← other
    if (isFacingEachOtherOnSameLine) {
        subject[otherAxis] = other[otherAxis];
        return (0, $6fP87.extractPoint)(subject);
    }
    // subject →
    //            ← other
    if (isFacingEachOtherInParallel) {
        const middle = (other[otherAxis] - subject[subjectAxis]) / 2;
        const updatedSubject = (0, $6eksN.displace)(subject, middle);
        subject.x = updatedSubject.x;
        subject.y = updatedSubject.y;
        const updatedOther = (0, $6eksN.displace)(other, middle);
        other.x = updatedOther.x;
        other.y = updatedOther.y;
        return undefined;
    }
    // subject →
    //             •
    //           other
    if (doesSubjectFaceOther) {
        // subject →
        //           other
        //             ↓
        if (!doesOtherFaceSubject) return undefined;
        // subject →
        //             ↑
        //           other
        subject[subjectAxis] = other[subjectAxis];
        return (0, $6fP87.extractPoint)(subject);
    }
    // ← subject
    //             •
    //           other
    const direction = (0, $6eksN.turnDirection)(subject, other);
    if (!direction) return undefined;
    subject.direction = direction;
    return (0, $6fP87.extractPoint)(subject);
}
function $2c0bf49d8491f82b$export$17b864d0fee42306(start, end) {
    const alice = start;
    const fiona = end;
    // points starting at `start` and continuing to middle
    const leadingPoints = [
        (0, $6fP87.extractPoint)(alice)
    ];
    // points starting at middle and ending at `end`
    const trailingPoints = [
        (0, $6fP87.extractPoint)(fiona)
    ];
    // keep moving until both meet, but break after MAX_ITERATIONS
    // times to avoid infinite loop
    for(let i = 0; i < $2c0bf49d8491f82b$var$MAX_ITERATIONS; i += 1){
        if ((0, $6eksN.coincides)(alice, fiona)) break;
        const leadingPoint = $2c0bf49d8491f82b$var$mutativelyPlotTo(alice, fiona);
        if (leadingPoint) leadingPoints.push(leadingPoint);
        const trailingPoint = $2c0bf49d8491f82b$var$mutativelyPlotTo(fiona, alice);
        if (trailingPoint) trailingPoints.unshift(trailingPoint);
    }
    return [
        ...leadingPoints,
        ...trailingPoints
    ];
}
const $2c0bf49d8491f82b$var$interpolate = (min, max, ratio)=>min + ratio * (max - min);
const $2c0bf49d8491f82b$export$d14d80f7b2661b77 = (start, end)=>{
    const { isFacingEachOtherInParallel: isFacingEachOtherInParallel, distanceBetween: distanceBetween } = $2c0bf49d8491f82b$var$analyzeVectors(start, end);
    // Move away from ports
    const a = (0, $6eksN.displace)(start, (0, $as09W.ARROW_PORT_OFFSET));
    const f = (0, $6eksN.displace)(end, (0, $as09W.ARROW_PORT_OFFSET));
    // Move a further 'padding' distance away depending on distance between points
    let padding = (0, $6eksN.CONNECTION_ENDS_PADDING);
    if (isFacingEachOtherInParallel) {
        const ratio = (0, (/*@__PURE__*/$parcel$interopDefault($Mez5L)))(distanceBetween, 0, 100) / 100;
        padding = $2c0bf49d8491f82b$var$interpolate(0, (0, $6eksN.CONNECTION_ENDS_PADDING), ratio);
    }
    const b = (0, $6eksN.displace)(a, padding);
    const e = (0, $6eksN.displace)(f, padding);
    return [
        a,
        ...$2c0bf49d8491f82b$export$17b864d0fee42306(b, e),
        f
    ];
};
const $2c0bf49d8491f82b$export$4b8d4fb9b6922cc = (path, fractionOfPath = 0.5, padding = 0.2)=>{
    const totalDistance = (0, $6eksN.distanceAll)(...path);
    const normalisedLabelPositionBias = fractionOfPath * (1 - padding * 2) + padding;
    return (0, $6eksN.pointOnPathByDistance)(path, totalDistance * normalisedLabelPositionBias);
};
const $2c0bf49d8491f82b$export$ae89ccf025923e8 = (startPort, endPort, labelPositionOptions = {
    fractionOfPath: 0.5,
    endsPadding: 0.2
})=>{
    const start = (0, $6eksN.portIndexToVector)(startPort);
    const end = (0, $6eksN.portIndexToVector)(endPort);
    const points = $2c0bf49d8491f82b$export$d14d80f7b2661b77(start, end);
    let labelPosition = (0, $6fP87.extractPoint)(start);
    if (!('skipLabelPosition' in labelPositionOptions)) labelPosition = $2c0bf49d8491f82b$export$4b8d4fb9b6922cc(points, labelPositionOptions.fractionOfPath, labelPositionOptions.endsPadding);
    const [firstPoint, ...restOfPoints] = points;
    const path = (0, $dNy4O.combinePath)((0, $dNy4O.move)(firstPoint), ...restOfPoints.map((point)=>(0, $dNy4O.line)(point)));
    return {
        path: /**
		 * SVG path data of the final route
		 */ path,
        labelPosition: /**
		 * Point on the route that would be a transition label's center given `labelPositionOptions`. If none provided, returns the midpoint.
		 */ labelPosition
    };
};

});
parcelRegister("6fP87", function(module, exports) {
$parcel$export(module.exports, "Axis", () => $695ae35a6a800750$export$d06866a9fb0606da);
$parcel$export(module.exports, "Direction", () => $695ae35a6a800750$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "extractPoint", () => $695ae35a6a800750$export$4717e065ef5ccb62);
$parcel$export(module.exports, "axisOf", () => $695ae35a6a800750$export$1e719f8c82cad46f);
/* eslint-disable jira/filename-case */ var $695ae35a6a800750$export$d06866a9fb0606da = /*#__PURE__*/ function(Axis) {
    /** Horizontal axis spanning left and right */ Axis["x"] = "x";
    /** Vertical axis spanning top and bottom */ Axis["y"] = "y";
    return Axis;
}({});
var $695ae35a6a800750$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    /** Points ↑ indicating negative Y value */ Direction["up"] = "up";
    /** Points ↓ indicating positive Y value */ Direction["down"] = "down";
    /** Points ← indicating negative X value */ Direction["left"] = "left";
    /** Points → indicating positive X value */ Direction["right"] = "right";
    return Direction;
}({});
const $695ae35a6a800750$export$4717e065ef5ccb62 = ({ x: x, y: y })=>({
        x: x,
        y: y
    });
const $695ae35a6a800750$export$1e719f8c82cad46f = (vector)=>{
    switch(vector.direction){
        case "up":
            return "y";
        case "down":
            return "y";
        case "left":
            return "x";
        default:
            return "x";
    }
};

});

parcelRegister("6eksN", function(module, exports) {
$parcel$export(module.exports, "CONNECTION_ENDS_PADDING", () => $708c87762c63f62b$export$6ace81a7dc830449);
$parcel$export(module.exports, "coincides", () => $708c87762c63f62b$export$e4f16d0d9cf560c0);
$parcel$export(module.exports, "displace", () => $708c87762c63f62b$export$cc68d5a7d2892656);
$parcel$export(module.exports, "portIndexToVector", () => $708c87762c63f62b$export$195ba35ec30e4539);
$parcel$export(module.exports, "inFrontOf", () => $708c87762c63f62b$export$5bd4d41460c34242);
$parcel$export(module.exports, "turnDirection", () => $708c87762c63f62b$export$f58f386b5545b3f5);
$parcel$export(module.exports, "hasSharedAxis", () => $708c87762c63f62b$export$c20988d716f90868);
$parcel$export(module.exports, "distanceAll", () => $708c87762c63f62b$export$c380aff58b95f144);
$parcel$export(module.exports, "pointOnPathByDistance", () => $708c87762c63f62b$export$58edb8b4e32a1277);

var $k9d6y = parcelRequire("k9d6y");

var $2iYvg = parcelRequire("2iYvg");

var $lhwEO = parcelRequire("lhwEO");

var $6fP87 = parcelRequire("6fP87");
const $708c87762c63f62b$export$6ace81a7dc830449 = 20;
const $708c87762c63f62b$export$bc86dfbf7795668c = (a, b)=>{
    if ($708c87762c63f62b$export$e4f16d0d9cf560c0(a, b)) return (0, $6fP87.extractPoint)(a);
    if (a.direction === (0, $6fP87.Direction).up || a.direction === (0, $6fP87.Direction).down) return (0, $k9d6y.toPoint)(a.x, b.y);
    if (b.direction === (0, $6fP87.Direction).up || b.direction === (0, $6fP87.Direction).down) return (0, $k9d6y.toPoint)(b.x, a.y);
    return undefined;
};
const $708c87762c63f62b$export$cc68d5a7d2892656 = (vector, amount)=>{
    switch(vector.direction){
        case (0, $6fP87.Direction).up:
            return {
                ...vector,
                y: vector.y - amount
            };
        case (0, $6fP87.Direction).down:
            return {
                ...vector,
                y: vector.y + amount
            };
        case (0, $6fP87.Direction).left:
            return {
                ...vector,
                x: vector.x - amount
            };
        case (0, $6fP87.Direction).right:
            return {
                ...vector,
                x: vector.x + amount
            };
        default:
            return vector;
    }
};
const $708c87762c63f62b$export$798c8192f05c1676 = (vector, other)=>{
    const vectorAxis = (0, $6fP87.axisOf)(vector);
    const otherAxis = (0, $6fP87.axisOf)(other);
    if (vectorAxis === (0, $6fP87.Axis).y && otherAxis === (0, $6fP87.Axis).y) return (0, $6fP87.Axis).y;
    if (vectorAxis === (0, $6fP87.Axis).x && otherAxis === (0, $6fP87.Axis).x) return (0, $6fP87.Axis).x;
    // perpendicular
    return undefined;
};
const $708c87762c63f62b$export$195ba35ec30e4539 = ({ portIndex: portIndex, position: { x: x, y: y } })=>{
    switch(portIndex){
        case (0, $k9d6y.PortIndex).TopLeft:
        case (0, $k9d6y.PortIndex).Top:
        case (0, $k9d6y.PortIndex).TopRight:
            return {
                x: x,
                y: y,
                direction: (0, $6fP87.Direction).up
            };
        case (0, $k9d6y.PortIndex).BottomLeft:
        case (0, $k9d6y.PortIndex).Bottom:
        case (0, $k9d6y.PortIndex).BottomRight:
            return {
                x: x,
                y: y,
                direction: (0, $6fP87.Direction).down
            };
        case (0, $k9d6y.PortIndex).Right:
            return {
                x: x,
                y: y,
                direction: (0, $6fP87.Direction).right
            };
        default:
            return {
                x: x,
                y: y,
                direction: (0, $6fP87.Direction).left
            };
    }
};
const $708c87762c63f62b$export$5bd4d41460c34242 = (vector, other)=>{
    switch(vector.direction){
        case (0, $6fP87.Direction).up:
            return other.y < vector.y;
        case (0, $6fP87.Direction).down:
            return other.y > vector.y;
        case (0, $6fP87.Direction).left:
            return other.x < vector.x;
        case (0, $6fP87.Direction).right:
            return other.x > vector.x;
        default:
            return false;
    }
};
const $708c87762c63f62b$export$e4f16d0d9cf560c0 = (point, other)=>point.x === other.x && point.y === other.y;
const $708c87762c63f62b$export$f58f386b5545b3f5 = (vector, point)=>{
    const dx = point.x - vector.x;
    const dy = point.y - vector.y;
    if (dx === 0 && dy === 0) return undefined;
    if ((0, $6fP87.axisOf)(vector) === (0, $6fP87.Axis).y) {
        if (dx < 0) return (0, $6fP87.Direction).left;
        if (dx > 0) return (0, $6fP87.Direction).right;
        if (dy > 0) return (0, $6fP87.Direction).down;
        if (dy < 0) return (0, $6fP87.Direction).up;
        // must be in front, don't turn
        return vector.direction;
    }
    if ((0, $6fP87.axisOf)(vector) === (0, $6fP87.Axis).x) {
        if (dy < 0) return (0, $6fP87.Direction).up;
        if (dy > 0) return (0, $6fP87.Direction).down;
        if (dx > 0) return (0, $6fP87.Direction).right;
        if (dx < 0) return (0, $6fP87.Direction).left;
        // must be in front, don't turn
        return vector.direction;
    }
    return undefined;
};
const $708c87762c63f62b$export$c20988d716f90868 = (subject, other)=>subject.x === other.x || subject.y === other.y;
const $708c87762c63f62b$export$c380aff58b95f144 = (...points)=>{
    const [firstPoint, ...remainingPoints] = points;
    let total = 0;
    remainingPoints.reduce((prev, curr)=>{
        total += (0, $2iYvg.distance)(prev, curr);
        return curr;
    }, firstPoint);
    return total;
};
const $708c87762c63f62b$export$58edb8b4e32a1277 = (points, stopAtDistance)=>{
    if (points.length === 0) {
        (0, $lhwEO.fireError)('Unexepcted empty points array. Cannot determine point on path.', 'manhattan-routing.point-on-path-by-distance');
        return (0, $k9d6y.toPoint)(0, 0);
    }
    let distanceTravelled = 0;
    for(let i = 1; i < points.length; i += 1){
        const prev = points[i - 1];
        const curr = points[i];
        const segmentLength = (0, $2iYvg.distance)(prev, curr);
        distanceTravelled += segmentLength;
        if (distanceTravelled >= stopAtDistance) {
            const perc = (distanceTravelled - stopAtDistance) / segmentLength;
            return (0, $2iYvg.add)(curr, (0, $2iYvg.multiply)((0, $2iYvg.subtract)(prev, curr), perc));
        }
    }
    const endPoint = points[points.length - 1];
    return endPoint;
};

});


parcelRegister("ebAeq", function(module, exports) {
$parcel$export(module.exports, "calculateOverlappingLabelPlacement", () => $3245cc8e4bdf19c8$export$97ec3454f8ebbeff);

var $l28YB = parcelRequire("l28YB");

var $k9d6y = parcelRequire("k9d6y");

var $38YZm = parcelRequire("38YZm");

var $5oiip = parcelRequire("5oiip");
const $3245cc8e4bdf19c8$export$97ec3454f8ebbeff = (transitions)=>{
    const groupedByOverlapKey = new Map();
    // group transitions by 'overlap key' which is a string comparable represenation of overlap criteria
    transitions.forEach((transition)=>{
        if (!(0, $38YZm.isDirectOrSharedTransitionWithDefinedPorts)(transition)) return;
        const isSharedTransition = transition.type === 'shared';
        if (isSharedTransition) transition.links.forEach((link, linkIndex)=>{
            const startPortKey = (0, $k9d6y.toPortKey)(link.source, link.sourceIndex);
            const endPortKey = (0, $k9d6y.toPortKey)(transition.target, link.targetIndex);
            const { overlapKey: overlapKey, isReversed: isReversed } = (0, $5oiip.overlapKeyByPorts)(startPortKey, endPortKey);
            (0, $5oiip.addToOverlapsGroup)(groupedByOverlapKey, overlapKey, {
                type: 'shared-transition',
                transitionId: transition.id,
                linkIndex: linkIndex,
                isReversed: isReversed
            });
        });
        else if (transition.type === 'direct') {
            const startPortKey = (0, $k9d6y.toPortKey)(transition.source, transition.sourceIndex);
            const endPortKey = (0, $k9d6y.toPortKey)(transition.target, transition.targetIndex);
            const { overlapKey: overlapKey, isReversed: isReversed } = (0, $5oiip.overlapKeyByPorts)(startPortKey, endPortKey);
            (0, $5oiip.addToOverlapsGroup)(groupedByOverlapKey, overlapKey, {
                type: 'direct-transition',
                transitionId: transition.id,
                isReversed: isReversed
            });
        }
    // }
    }, {});
    const result = [];
    // calculate placements for each transition in a group while considering if reversed
    groupedByOverlapKey.forEach((overlaps, overlapKey)=>{
        overlaps.forEach((overlap, position)=>{
            // by definition a single item in a group has no overlaps, hence '- 1'
            // we only care about overlaps so we ignore all non-overlapping transitions
            const totalOverlapping = overlaps.length - 1;
            if (totalOverlapping === 0) return;
            let placement = position / totalOverlapping;
            if ('isReversed' in overlap && overlap.isReversed) // place transition label in the opposite direction
            placement = 1 - placement;
            result.push({
                ...(0, (/*@__PURE__*/$parcel$interopDefault($l28YB)))(overlap, 'isReversed'),
                placement: placement,
                overlapKey: overlapKey
            });
        });
    });
    return result;
};

});
parcelRegister("5oiip", function(module, exports) {
$parcel$export(module.exports, "addToOverlapsGroup", () => $ca918b28dfd2fd1f$export$b4b1c9fe32f0e076);
$parcel$export(module.exports, "overlapKeyByPorts", () => $ca918b28dfd2fd1f$export$dad46676c954236b);
$parcel$export(module.exports, "getLabelPlacement", () => $ca918b28dfd2fd1f$export$330bb965f61fa4fe);
/** A string key used to group transitions by a overlap criteria depending on the type of transition */ const $ca918b28dfd2fd1f$export$87f647dcd0870d73 = 0.5;
function $ca918b28dfd2fd1f$export$b4b1c9fe32f0e076(overlaps, overlapKey, overlapItem) {
    const previousValue = overlaps.get(overlapKey) ?? [];
    if ('isReversed' in overlapItem && overlapItem.isReversed) overlaps.set(overlapKey, [
        overlapItem,
        ...previousValue
    ]);
    else overlaps.set(overlapKey, [
        ...previousValue,
        overlapItem
    ]);
}
function $ca918b28dfd2fd1f$export$dad46676c954236b(startPortKey, endPortKey) {
    // start and end port key order is ignored to determine if route between two ports is overlapping
    // however we need to if its reversed or not, to do a cheap order-insensitive check for overlaps
    // we can simply use a string alphabetic comparison
    const isReversed = startPortKey > endPortKey;
    return {
        overlapKey: isReversed ? $ca918b28dfd2fd1f$export$9776532a71c8b981('by-ports', endPortKey, startPortKey) : $ca918b28dfd2fd1f$export$9776532a71c8b981('by-ports', startPortKey, endPortKey),
        isReversed: isReversed
    };
}
function $ca918b28dfd2fd1f$export$9776532a71c8b981(...strings) {
    return `overlap[${strings.join(';')}]`;
}
function $ca918b28dfd2fd1f$export$330bb965f61fa4fe(transitionId, transitionLabelPlacements, /** Additionally filter on linkIndex for shared transitions */ linkIndex) {
    const match = transitionLabelPlacements.find((x)=>{
        if (x.transitionId !== transitionId) return false;
        if ('linkIndex' in x && x.linkIndex !== linkIndex) return false;
        return true;
    });
    return match?.placement ?? $ca918b28dfd2fd1f$export$87f647dcd0870d73;
}

});


parcelRegister("geemr", function(module, exports) {
$parcel$export(module.exports, "getSharedTransitionLayout", () => $04187aa865c85e41$export$a13185bc8db9ec97);

var $k9d6y = parcelRequire("k9d6y");

var $38YZm = parcelRequire("38YZm");

var $gc3g9 = parcelRequire("gc3g9");

var $5oiip = parcelRequire("5oiip");
const $04187aa865c85e41$export$d1d8ca5010332ec1 = 80;
const $04187aa865c85e41$export$dd2963ab5ca60569 = (port)=>{
    const newPosition = {
        ...port.position
    };
    switch(port.portIndex){
        case (0, $k9d6y.PortIndex).TopLeft:
        case (0, $k9d6y.PortIndex).Top:
        case (0, $k9d6y.PortIndex).TopRight:
            newPosition.y = port.position.y - $04187aa865c85e41$export$d1d8ca5010332ec1;
            break;
        case (0, $k9d6y.PortIndex).Right:
            newPosition.x = port.position.x + $04187aa865c85e41$export$d1d8ca5010332ec1;
            break;
        case (0, $k9d6y.PortIndex).BottomRight:
        case (0, $k9d6y.PortIndex).Bottom:
        case (0, $k9d6y.PortIndex).BottomLeft:
            newPosition.y = port.position.y + $04187aa865c85e41$export$d1d8ca5010332ec1;
            break;
        // case PortIndex.Left
        default:
            newPosition.x = port.position.x - $04187aa865c85e41$export$d1d8ca5010332ec1;
            break;
    }
    return {
        position: newPosition,
        portIndex: port.portIndex
    };
};
const $04187aa865c85e41$export$a13185bc8db9ec97 = (transition, ports, transitionLabelPlacements, reroutingTransition)=>{
    const emptyLayout = {
        connections: undefined
    };
    if (transition.links.length === 0 || !(0, $38YZm.isEveryPropertyDefined)(transition.links, 'sourceIndex', 'targetIndex')) return emptyLayout;
    const connections = [];
    let didAlreadyMoveTargetPort = false;
    let linkIndex = 0;
    for (const link of transition.links){
        const source = link.source;
        const sourceIndex = link.sourceIndex;
        const targetIndex = link.targetIndex;
        let sourcePort = (0, $38YZm.findPort)(ports, source, sourceIndex);
        const isSourcePortMoving = (0, $38YZm.isPortMovingForReroutingTransition)(sourcePort, 'source', transition.id, reroutingTransition);
        if (!sourcePort) return emptyLayout;
        if (isSourcePortMoving) sourcePort = {
            ...sourcePort,
            position: reroutingTransition.currentPosition
        };
        let targetPort = (0, $38YZm.findPort)(ports, transition.target, targetIndex);
        if (!targetPort) return emptyLayout;
        const isTargetPortMoving = (0, $38YZm.isPortMovingForReroutingTransition)(targetPort, 'target', transition.id, reroutingTransition);
        // if there are multiple links touching the same port, we only move the first one
        if (isTargetPortMoving && !didAlreadyMoveTargetPort) {
            targetPort = {
                ...targetPort,
                position: reroutingTransition.currentPosition
            };
            didAlreadyMoveTargetPort = true;
        }
        // Paths and labels between each source and target
        const { path: path, labelPosition: labelPosition } = (0, $gc3g9.manhattanPathAndLabelPosition)(sourcePort, targetPort, {
            fractionOfPath: (0, $5oiip.getLabelPlacement)(transition.id, transitionLabelPlacements, linkIndex),
            endsPadding: 0.25
        });
        connections.push({
            path: path,
            sourcePort: sourcePort,
            targetPort: targetPort,
            labelPosition: labelPosition
        });
        ++linkIndex;
    }
    return {
        connections: connections
    };
};

});


parcelRegister("bJcYH", function(module, exports) {
$parcel$export(module.exports, "useTransitionDragDrop", () => $a6abff13e7e9af37$export$1acd582b1912a987);

var $euxye = parcelRequire("euxye");

var $i5aNJ = parcelRequire("i5aNJ");

var $2FFzx = parcelRequire("2FFzx");
const $a6abff13e7e9af37$export$1acd582b1912a987 = ({ ports: ports, transitions: transitions, dragDropState: dragDropState, reroutingTransition: reroutingTransition, proposedTransition: proposedTransition, onTransitionCreate: onTransitionCreate, onTransitionPortChange: onTransitionPortChange, onTransitionReroutingCancel: onTransitionReroutingCancel, onTransitionProposalCancel: onTransitionProposalCancel })=>{
    const latestPorts = (0, $i5aNJ.useLatest)(ports);
    const latestTransitions = (0, $i5aNJ.useLatest)(transitions);
    const latestReroutingTransition = (0, $i5aNJ.useLatest)(reroutingTransition);
    const latestProposedTransition = (0, $i5aNJ.useLatest)(proposedTransition);
    (0, $euxye.useEffect)(()=>{
        if (dragDropState.isDragging) return;
        if (latestProposedTransition.current.stage === 'started') {
            // dragging ended without finishing creation of new transition
            onTransitionProposalCancel();
            return;
        }
        if (latestProposedTransition.current.stage === 'valid') {
            // dragging ended while finishing creation of new transition
            const transition = (0, $2FFzx.createTransitionFromProposed)(latestProposedTransition.current, latestPorts.current);
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onTransitionCreate?.(transition);
            onTransitionProposalCancel();
            return;
        }
        if (latestReroutingTransition.current.stage === 'started') {
            // dragging ended without finishing change of ports of existing transition
            onTransitionReroutingCancel();
            return;
        }
        if (latestReroutingTransition.current.stage === 'valid') {
            // dragging ended while finishing change of ports of existing transition
            const updatedTransition = (0, $2FFzx.updateTransitionAfterReroute)(latestReroutingTransition.current, latestPorts.current);
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            onTransitionPortChange?.(updatedTransition);
            onTransitionReroutingCancel();
        }
    }, [
        onTransitionProposalCancel,
        dragDropState,
        proposedTransition,
        latestReroutingTransition,
        latestTransitions,
        onTransitionCreate,
        onTransitionPortChange,
        latestProposedTransition,
        onTransitionReroutingCancel,
        latestPorts
    ]);
};

});
parcelRegister("2FFzx", function(module, exports) {
$parcel$export(module.exports, "createTransitionFromProposed", () => $4b4c8cd755b12ab2$export$175a587f328a01d2);
$parcel$export(module.exports, "updateTransitionAfterReroute", () => $4b4c8cd755b12ab2$export$ea55afc0963f677b);

var $7TA2J = parcelRequire("7TA2J");
function $4b4c8cd755b12ab2$export$175a587f328a01d2(validProposedTransition, ports) {
    const { startPortKey: startPortKey, endPortKey: endPortKey } = validProposedTransition;
    const startPort = ports[startPortKey];
    const endPort = ports[endPortKey];
    return {
        id: (0, $7TA2J.v4)(),
        type: 'direct',
        icons: [],
        label: '',
        source: startPort.statusId,
        sourceIndex: startPort.portIndex,
        target: endPort.statusId,
        targetIndex: endPort.portIndex
    };
}
function $4b4c8cd755b12ab2$export$ea55afc0963f677b(reroutingTransition, ports) {
    const { transition: transition, side: side, originalPortKey: originalPortKey, proposedPortKey: proposedPortKey } = reroutingTransition;
    const proposedPort = ports[proposedPortKey];
    if (transition.type === 'direct') return {
        ...transition,
        [side]: proposedPort.statusId,
        [`${side}Index`]: proposedPort.portIndex
    };
    // transition.type === 'shared'
    if (side === 'source') {
        const originalPort = ports[originalPortKey];
        const updatedLinks = transition.links.map((link)=>link.source === originalPort.statusId && link.sourceIndex === originalPort.portIndex ? {
                ...link,
                source: proposedPort.statusId,
                sourceIndex: proposedPort.portIndex
            } : link);
        return {
            ...transition,
            links: updatedLinks
        };
    }
    // side === 'target'
    const originalPort = ports[originalPortKey];
    let didRerouteTarget = false;
    const updatedLinks = transition.links.map((link)=>{
        if (proposedPort.statusId !== originalPort.statusId) {
            if (link.targetIndex === originalPort.portIndex) return {
                ...link,
                targetIndex: proposedPort.portIndex
            };
            // trigger best guess
            return {
                ...link,
                targetIndex: undefined
            };
        }
        if (link.targetIndex === originalPort.portIndex && !didRerouteTarget) {
            // reroute only the first matching link
            didRerouteTarget = true;
            return {
                ...link,
                targetIndex: proposedPort.portIndex
            };
        }
        return link;
    });
    return {
        ...transition,
        target: proposedPort.statusId,
        links: updatedLinks
    };
}

});


parcelRegister("d4owm", function(module, exports) {
$parcel$export(module.exports, "useTransitionProposals", () => $10923523cc9b6276$export$ad7bb463e2681cc1);

var $euxye = parcelRequire("euxye");
const $10923523cc9b6276$export$ad7bb463e2681cc1 = ()=>{
    const [transitionProposal, setTransitionProposal] = (0, $euxye.useState)({
        stage: 'none'
    });
    const onTransitionProposalCancel = (0, $euxye.useCallback)(()=>{
        setTransitionProposal({
            stage: 'none'
        });
    }, []);
    const onTransitionProposalMove = (0, $euxye.useCallback)((startPortKey, line)=>{
        setTransitionProposal((prev)=>{
            if (prev.stage === 'none') return {
                ...prev,
                stage: 'started',
                startPortKey: startPortKey,
                line: line
            };
            return {
                ...prev,
                startPortKey: startPortKey,
                line: line
            };
        });
    }, []);
    const onTransitionProposalClose = (0, $euxye.useCallback)((endPortKey)=>{
        setTransitionProposal((prev)=>{
            if (prev.stage === 'none') return prev;
            if (endPortKey === undefined) return {
                stage: 'started',
                line: prev.line,
                startPortKey: prev.startPortKey
            };
            return {
                ...prev,
                stage: 'valid',
                endPortKey: endPortKey
            };
        });
    }, []);
    return [
        transitionProposal,
        {
            onTransitionProposalCancel: onTransitionProposalCancel,
            onTransitionProposalClose: onTransitionProposalClose,
            onTransitionProposalMove: onTransitionProposalMove
        }
    ];
};

});

parcelRegister("fZjOA", function(module, exports) {
$parcel$export(module.exports, "useTransitionRerouting", () => $5ae56af2332e6bc3$export$6bb143efd1a1161b);

var $euxye = parcelRequire("euxye");

var $k9d6y = parcelRequire("k9d6y");

var $38YZm = parcelRequire("38YZm");
const $5ae56af2332e6bc3$var$initialState = {
    stage: 'none'
};
const $5ae56af2332e6bc3$export$66f9ac6aeebf5298 = ({ transition: transition, proposedPortKey: proposedPortKey, originalStatusId: originalStatusId, proposedStatusId: proposedStatusId, side: side })=>{
    if (side === 'source' && (0, $38YZm.isDirectOrSharedTransitionWithDefinedPorts)(transition)) {
        if (transition.type === 'shared') return(// TODO HIX-4369 Handle multiple targetIndices
        transition.links.some((links)=>links.source !== originalStatusId && links.source === proposedStatusId) || proposedPortKey === (0, $k9d6y.toPortKey)(transition.target, transition.links[0].targetIndex));
        return proposedPortKey === (0, $k9d6y.toPortKey)(transition.target, transition.targetIndex);
    }
    if (side === 'target' && (0, $38YZm.isDirectOrSharedTransitionWithDefinedPorts)(transition)) {
        if (transition.type === 'shared') {
            const portKeys = transition.links.map((link)=>(0, $k9d6y.toPortKey)(link.source, link.sourceIndex));
            return portKeys.includes(proposedPortKey);
        }
        return proposedPortKey === (0, $k9d6y.toPortKey)(transition.source, transition.sourceIndex);
    }
    return false;
};
const $5ae56af2332e6bc3$export$6bb143efd1a1161b = ()=>{
    const [reroutingTransition, setReroutingTransition] = (0, $euxye.useState)($5ae56af2332e6bc3$var$initialState);
    const onTransitionReroutingCancel = (0, $euxye.useCallback)(()=>{
        setReroutingTransition({
            stage: 'none'
        });
    }, []);
    const onTransitionReroutingMove = (0, $euxye.useCallback)((value)=>{
        setReroutingTransition((prev)=>{
            if (prev.stage === 'none') {
                const startingState = {
                    stage: 'started',
                    ...value
                };
                return startingState;
            }
            const movingState = {
                ...prev,
                ...value
            };
            return movingState;
        });
    }, []);
    const onTransitionReroutingClose = (0, $euxye.useCallback)(({ proposedPortKey: proposedPortKey, proposedStatusId: proposedStatusId })=>{
        setReroutingTransition((prev)=>{
            if (prev.stage === 'none') return prev;
            if (proposedPortKey === undefined || $5ae56af2332e6bc3$export$66f9ac6aeebf5298({
                transition: prev.transition,
                proposedPortKey: proposedPortKey,
                proposedStatusId: proposedStatusId,
                originalStatusId: prev.originalStatusId,
                side: prev.side
            })) {
                const startingState = {
                    stage: 'started',
                    transition: prev.transition,
                    side: prev.side,
                    currentPosition: prev.currentPosition,
                    originalStatusId: prev.originalStatusId,
                    originalPortIndex: prev.originalPortIndex,
                    originalPortKey: prev.originalPortKey
                };
                return startingState;
            }
            const completedState = {
                stage: 'valid',
                transition: prev.transition,
                side: prev.side,
                currentPosition: prev.currentPosition,
                originalStatusId: prev.originalStatusId,
                originalPortIndex: prev.originalPortIndex,
                originalPortKey: prev.originalPortKey,
                proposedPortKey: proposedPortKey
            };
            return completedState;
        });
    }, []);
    return [
        reroutingTransition,
        {
            onTransitionReroutingMove: onTransitionReroutingMove,
            onTransitionReroutingClose: onTransitionReroutingClose,
            onTransitionReroutingCancel: onTransitionReroutingCancel
        }
    ];
};

});

parcelRegister("i7feo", function(module, exports) {
$parcel$export(module.exports, "useGlobalLoopsContainer", () => $0e1a63d692a507f8$export$4c621f3f7c99f1c6);

var $aLlWy = parcelRequire("aLlWy");
const $0e1a63d692a507f8$export$4c621f3f7c99f1c6 = ({ providedGlobalLoopsContainerPosition: providedGlobalLoopsContainerPosition, defaultGlobalLoopsContainerPosition: defaultGlobalLoopsContainerPosition, targetedItem: targetedItem, draggingItem: draggingItem, movingItem: movingItem })=>{
    let position = providedGlobalLoopsContainerPosition || defaultGlobalLoopsContainerPosition;
    const isDragging = draggingItem?.type === (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE);
    const isMoving = movingItem?.type === (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE);
    const isTargeted = targetedItem?.type === (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE);
    if (isDragging) position = draggingItem.position;
    if (isMoving) position = movingItem.position;
    return {
        position: position,
        isTargeted: isTargeted,
        isDragging: isDragging,
        isMoving: isMoving
    };
};

});

parcelRegister("019UD", function(module, exports) {
$parcel$export(module.exports, "useAutoFitZoom", () => $f2e6b8da0c47b5ae$export$6d3040097df60ff3);

var $euxye = parcelRequire("euxye");

var $as09W = parcelRequire("as09W");

var $a40OY = parcelRequire("a40OY");

var $dI9CN = parcelRequire("dI9CN");
const $f2e6b8da0c47b5ae$export$6d3040097df60ff3 = (contentBounds, canvasContainerRef, isLayoutStable, fallbackMinimum = (0, $as09W.MINIMUM_ZOOM_LEVEL), enabled = true)=>{
    const [containerSize, setContainerSize] = (0, $euxye.useState)();
    const handleResize = (0, $euxye.useCallback)((entry)=>{
        const { width: width, height: height } = entry.contentRect;
        setContainerSize({
            width: width,
            height: height
        });
    }, []);
    const { setRef: setResizeObserverRef } = (0, $a40OY.default)(handleResize);
    (0, $euxye.useEffect)(()=>{
        setResizeObserverRef(enabled ? canvasContainerRef.current : null);
    }, [
        setResizeObserverRef,
        canvasContainerRef,
        enabled
    ]);
    const dynamicMinZoom = (0, $euxye.useMemo)(()=>{
        if (!enabled || !isLayoutStable || !contentBounds || !containerSize) return fallbackMinimum;
        const { width: containerWidth, height: containerHeight } = containerSize;
        if (containerWidth <= 0 || containerHeight <= 0) return fallbackMinimum;
        const fitZoom = (0, $dI9CN.calculateFitZoom)(contentBounds, containerSize);
        return Math.min(fitZoom, fallbackMinimum, (0, $as09W.DEFAULT_ZOOM_LEVEL));
    }, [
        contentBounds,
        containerSize,
        isLayoutStable,
        fallbackMinimum,
        enabled
    ]);
    return dynamicMinZoom;
};
var $f2e6b8da0c47b5ae$export$2e2bcd8739ae039 = $f2e6b8da0c47b5ae$export$6d3040097df60ff3;

});

parcelRegister("4xvFx", function(module, exports) {
$parcel$export(module.exports, "CanvasSvg", () => $7c972bb58ddc6607$export$6801d6d4bd9b9cd4);
/* CanvasSvg.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $38YZm = parcelRequire("38YZm");

var $3lbM4 = parcelRequire("3lbM4");
const $7c972bb58ddc6607$export$6801d6d4bd9b9cd4 = ({ rootSvgRef: rootSvgRef, children: children, diagramSize: diagramSize, pan: pan, zoom: zoom })=>{
    const dataAttributes = (0, $3lbM4.useDraggableDataAttributes)('pan');
    const viewBox = (0, $38YZm.calculateViewBox)(diagramSize, pan, zoom);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($7c972bb58ddc6607$var$StyledSvg, {
        ref: rootSvgRef,
        ...dataAttributes,
        width: diagramSize.width,
        height: diagramSize.height,
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: `${viewBox.left} ${viewBox.top} ${viewBox.width} ${viewBox.height}`,
        preserveAspectRatio: "xMinYMin",
        "data-testid": "accessible-workflow-diagram.svg-root"
    }, children);
};
$7c972bb58ddc6607$export$6801d6d4bd9b9cd4.displayName = "CanvasSvg";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c972bb58ddc6607$var$StyledSvg = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_1reo15vq _18m915vq _s7n4nkob _bfhkvuon _uiztglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("27YFZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $87912b39ed98aaa4$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $as09W = parcelRequire("as09W");

var $aLlWy = parcelRequire("aLlWy");

var $g3Okq = parcelRequire("g3Okq");

var $iXhO6 = parcelRequire("iXhO6");
const $87912b39ed98aaa4$var$DirectTransition = ({ id: id, flag: flag, isHighlighted: isHighlighted = false, isHovered: isHovered = false, isImmutable: isImmutable = false, isSelected: isSelected = false, end: end, start: start, path: path, onSelect: onSelect, onHover: onHover })=>{
    const stroke = (0, $iXhO6.useStrokeColor)({
        flag: flag,
        isHighlighted: isHighlighted,
        isHovered: isHovered,
        isSelected: isSelected
    });
    const onGroupClick = (0, $euxye.useCallback)(()=>{
        if (!isImmutable) onSelect?.({
            type: (0, $aLlWy.EDGE_TYPE),
            id: id
        });
    }, [
        isImmutable,
        onSelect,
        id
    ]);
    const onMouseEnter = (0, $euxye.useCallback)(()=>{
        onHover?.({
            id: id,
            type: (0, $aLlWy.EDGE_TYPE),
            connection: {
                sourcePort: start,
                targetPort: end
            }
        });
    }, [
        end,
        id,
        onHover,
        start
    ]);
    const onMouseLeave = (0, $euxye.useCallback)(()=>{
        onHover?.(undefined);
    }, [
        onHover
    ]);
    if (!start || !end) return null;
    if (start.portIndex === undefined || end.portIndex === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        onClick: onGroupClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "none",
        stroke: "transparent",
        d: path,
        strokeLinejoin: "round",
        strokeWidth: "15"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "none",
        stroke: stroke,
        d: path,
        strokeLinejoin: "round",
        strokeWidth: (0, $as09W.TRANSITION_STROKE_WIDTH)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g3Okq.DiagramArrow), {
        portIndex: end.portIndex,
        portPosition: end.position,
        stroke: stroke
    }));
};
$87912b39ed98aaa4$var$DirectTransition.displayName = "DirectTransition";
var $87912b39ed98aaa4$export$2e2bcd8739ae039 = $87912b39ed98aaa4$var$DirectTransition;

});
parcelRegister("g3Okq", function(module, exports) {
$parcel$export(module.exports, "DiagramArrow", () => $fb50fa8977204df8$export$7259882ded3cd5be);

var $euxye = parcelRequire("euxye");

var $as09W = parcelRequire("as09W");

var $k9d6y = parcelRequire("k9d6y");

var $2iYvg = parcelRequire("2iYvg");

var $dNy4O = parcelRequire("dNy4O");

var $cx2ag = parcelRequire("cx2ag");
const $fb50fa8977204df8$export$7259882ded3cd5be = ({ stroke: stroke, portPosition: portPosition, portIndex: portIndex, portOffset: portOffset })=>{
    const unitDirection = (0, $2iYvg.invert)((0, $cx2ag.toSquareUnitDirection)(portIndex));
    const tip = (0, $2iYvg.add)(portPosition, (0, $2iYvg.multiply)(unitDirection, portOffset ?? (0, $as09W.ARROW_PORT_OFFSET)));
    const rotation = (0, $2iYvg.unitDirectionAngle)(unitDirection);
    const leftWing = (0, $2iYvg.add)(tip, (0, $k9d6y.toPoint)(-(0, $as09W.ARROW_WING_LENGTH), +(0, $as09W.ARROW_WING_LENGTH)));
    const rightWing = (0, $2iYvg.add)(tip, (0, $k9d6y.toPoint)((0, $as09W.ARROW_WING_LENGTH), (0, $as09W.ARROW_WING_LENGTH)));
    const arrowPath = (0, $dNy4O.combinePath)((0, $dNy4O.move)(leftWing), (0, $dNy4O.line)(tip), (0, $dNy4O.line)(rightWing));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "none",
        stroke: stroke,
        d: arrowPath,
        strokeWidth: "2",
        transform: `rotate(${-rotation} ${tip.x} ${tip.y})`
    });
};
$fb50fa8977204df8$export$7259882ded3cd5be.displayName = "DiagramArrow";

});


parcelRegister("7MVro", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b48a85253f6d49d$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $1M6Og = parcelRequire("1M6Og");

var $2lVCV = parcelRequire("2lVCV");

var $3lbM4 = parcelRequire("3lbM4");

var $132zH = parcelRequire("132zH");

var $as09W = parcelRequire("as09W");

var $a1HlX = parcelRequire("a1HlX");
const $0b48a85253f6d49d$var$OUTLINE_PADDING = 3;
const $0b48a85253f6d49d$var$FOCUS_RING_WIDTH = 4;
const $0b48a85253f6d49d$var$ARROW_PADDING = $0b48a85253f6d49d$var$OUTLINE_PADDING + $0b48a85253f6d49d$var$FOCUS_RING_WIDTH + (0, $132zH.ARROW_RADIUS);
const $0b48a85253f6d49d$export$108a2aec753e2c50 = ({ position: position, isMoving: isMoving, isTargeted: isTargeted, transitions: transitions, isImmutable: isImmutable, onSelect: onSelect, onHover: onHover })=>{
    const dataAttributes = (0, $3lbM4.useDraggableDataAttributes)('global-loops-container', 'global-loops-container');
    const containerHeight = (0, $a1HlX.getContainerHeight)(transitions.length);
    if (transitions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        "data-testid": "accessible-workflow-diagram.global-loops-container",
        ...dataAttributes
    }, isTargeted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: position.x - $0b48a85253f6d49d$var$OUTLINE_PADDING - $0b48a85253f6d49d$var$FOCUS_RING_WIDTH / 4,
        y: position.y - $0b48a85253f6d49d$var$OUTLINE_PADDING - $0b48a85253f6d49d$var$FOCUS_RING_WIDTH / 4,
        width: (0, $a1HlX.CONTAINER_WIDTH) + $0b48a85253f6d49d$var$OUTLINE_PADDING * 2 + $0b48a85253f6d49d$var$FOCUS_RING_WIDTH / 2,
        height: containerHeight + $0b48a85253f6d49d$var$OUTLINE_PADDING * 2 + $0b48a85253f6d49d$var$FOCUS_RING_WIDTH / 2,
        rx: "3.5",
        ry: "3.5",
        stroke: (0, $as09W.STATE_COLOURS).focused,
        fillOpacity: "0",
        strokeWidth: $0b48a85253f6d49d$var$FOCUS_RING_WIDTH
    }), isMoving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $132zH.default), {
        x: position.x + (0, $a1HlX.CONTAINER_WIDTH) / 2,
        y: position.y - $0b48a85253f6d49d$var$ARROW_PADDING,
        direction: "up"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $132zH.default), {
        x: position.x + (0, $a1HlX.CONTAINER_WIDTH) / 2,
        y: position.y + containerHeight + $0b48a85253f6d49d$var$ARROW_PADDING,
        direction: "down"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $132zH.default), {
        x: position.x - $0b48a85253f6d49d$var$ARROW_PADDING,
        y: position.y + containerHeight / 2,
        direction: "left"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $132zH.default), {
        x: position.x + (0, $a1HlX.CONTAINER_WIDTH) + $0b48a85253f6d49d$var$ARROW_PADDING,
        y: position.y + containerHeight / 2,
        direction: "right"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: position.x,
        y: position.y,
        width: (0, $a1HlX.CONTAINER_WIDTH),
        height: containerHeight,
        rx: "3.5",
        fill: "var(--ds-surface, #FFFFFF)",
        fillOpacity: "0.8",
        stroke: "var(--ds-border, #0B120E24)",
        cursor: isImmutable ? undefined : 'move'
    }), transitions.map((transition, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1M6Og.GlobalLoopedTransition), {
            id: transition.id,
            key: transition.id,
            position: (0, $a1HlX.getGlobalLoopTransitionPosition)(position, index),
            label: transition.label,
            flag: transition.flag,
            isHovered: transition.isHovered,
            isImmutable: isImmutable,
            isSelected: transition.isSelected,
            isTargeted: transition.isTargeted,
            onSelect: onSelect,
            onHover: onHover,
            icons: (0, $2lVCV.applyTransitionIconConditions)(transition.icons, undefined)
        })));
};
$0b48a85253f6d49d$export$108a2aec753e2c50.displayName = "GlobalLoopsContainer";
var $0b48a85253f6d49d$export$2e2bcd8739ae039 = $0b48a85253f6d49d$export$108a2aec753e2c50;

});
parcelRegister("1M6Og", function(module, exports) {
$parcel$export(module.exports, "GlobalLoopedTransition", () => $56aa9667191f6cf2$export$b5d79cea29b5d080);
/* eslint-disable jira/i18n/no-export-define-message */ 
var $euxye = parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $6OFDk = parcelRequire("6OFDk");

var $as09W = parcelRequire("as09W");

var $aLlWy = parcelRequire("aLlWy");

var $k9d6y = parcelRequire("k9d6y");

var $g3Okq = parcelRequire("g3Okq");

var $jpgRl = parcelRequire("jpgRl");

var $38YZm = parcelRequire("38YZm");

var $iXhO6 = parcelRequire("iXhO6");

var $a1HlX = parcelRequire("a1HlX");
const $56aa9667191f6cf2$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    anyLozengeText: {
        id: "accessible-workflow-diagram.diagram.global-loop-transition.any-lozenge-text",
        defaultMessage: "Any"
    }
});
const $56aa9667191f6cf2$var$GLOBAL_LOOP_LABEL_MAX_LENGTH = 13; // as per Workflow Designer
const $56aa9667191f6cf2$export$b5d79cea29b5d080 = ({ id: id, flag: flag, isHovered: isHovered = false, isImmutable: isImmutable, position: containerPosition, isSelected: isSelected = false, isTargeted: isTargeted = false, label: label, onSelect: onSelect, onHover: onHover, icons: icons = (0, $i860n.fg)('jfp_magma_jira-stable-defaultprops') ? (0, $6OFDk.defaultProps).emptyArray : [] })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const stroke = (0, $iXhO6.useStrokeColor)({
        flag: flag,
        isHighlighted: false,
        isSelected: isSelected,
        isHovered: isHovered
    });
    const [textRef, setTextRef] = (0, $euxye.useState)(null);
    const lozengeText = (0, $38YZm.truncateLabel)(formatMessage($56aa9667191f6cf2$export$defe85febe8b728c.anyLozengeText));
    const textWidth = textRef?.getBBox?.().width || 0;
    const lozengeWidth = (0, $a1HlX.getLozengeWidth)(textWidth);
    const onGroupClick = (0, $euxye.useCallback)(()=>{
        if (!isImmutable) onSelect?.({
            type: (0, $aLlWy.EDGE_TYPE),
            id: id
        });
    }, [
        id,
        isImmutable,
        onSelect
    ]);
    const onMouseEnter = (0, $euxye.useCallback)(()=>{
        onHover?.({
            id: id,
            type: (0, $aLlWy.EDGE_TYPE)
        });
    }, [
        id,
        onHover
    ]);
    const onMouseLeave = (0, $euxye.useCallback)(()=>{
        onHover?.(undefined);
    }, [
        onHover
    ]);
    const onTextRef = (0, $euxye.useCallback)((ref)=>{
        if (ref) setTextRef(ref);
    }, []);
    if (!containerPosition) return null;
    const lozengePosition = (0, $a1HlX.getLozengePosition)(containerPosition);
    const lozengeTextPosition = (0, $a1HlX.getLozengeTextPosition)(lozengePosition, lozengeWidth);
    const path = (0, $a1HlX.globalLoopedTransitionRoute)(lozengePosition, lozengeWidth);
    const arrowPosition = (0, $a1HlX.getArrowPosition)(lozengePosition, lozengeWidth);
    const labelPosition = (0, $a1HlX.getLabelPosition)(containerPosition);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        onClick: onGroupClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.interactable-path",
        fill: "none",
        stroke: "transparent",
        d: path,
        strokeWidth: "15"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.visible-path",
        fill: "none",
        stroke: stroke,
        strokeLinejoin: "round",
        d: path,
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g3Okq.DiagramArrow), {
        portPosition: arrowPosition,
        stroke: stroke,
        portIndex: (0, $k9d6y.PortIndex).Top,
        portOffset: (0, $as09W.PORT_RADIUS)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        ...lozengePosition,
        width: lozengeWidth,
        height: (0, $a1HlX.LOZENGE_HEIGHT),
        rx: (0, $a1HlX.LOZENGE_BORDER_RADIUS),
        ry: (0, $a1HlX.LOZENGE_BORDER_RADIUS),
        fill: "var(--ds-background-neutral-bold, #292A2E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("text", {
        ...lozengeTextPosition,
        ref: onTextRef,
        textAnchor: "middle",
        fontSize: "11px",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("tspan", null, lozengeText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jpgRl.default), {
        id: id,
        position: labelPosition,
        label: label,
        flag: flag,
        icons: icons,
        isTargeted: isTargeted,
        isSelected: isSelected,
        isHovered: isHovered,
        isImmutable: isImmutable,
        maxLabelLength: $56aa9667191f6cf2$var$GLOBAL_LOOP_LABEL_MAX_LENGTH,
        onSelect: onSelect
    }));
};
$56aa9667191f6cf2$export$b5d79cea29b5d080.displayName = "GlobalLoopedTransition";

});

parcelRegister("132zH", function(module, exports) {
$parcel$export(module.exports, "ARROW_RADIUS", () => $ad1d6ab5b4a0cbdb$export$fa53c1d9d4c86cc2);
$parcel$export(module.exports, "default", () => $ad1d6ab5b4a0cbdb$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
const $ad1d6ab5b4a0cbdb$var$ROTATIONS = {
    up: 0,
    right: 90,
    down: 180,
    left: 270
};
const $ad1d6ab5b4a0cbdb$export$fa53c1d9d4c86cc2 = 8;
const $ad1d6ab5b4a0cbdb$var$MoveArrow = ({ x: x, y: y, direction: direction })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("svg", {
        x: x - $ad1d6ab5b4a0cbdb$export$fa53c1d9d4c86cc2,
        y: y - $ad1d6ab5b4a0cbdb$export$fa53c1d9d4c86cc2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("circle", {
        cx: $ad1d6ab5b4a0cbdb$export$fa53c1d9d4c86cc2,
        cy: $ad1d6ab5b4a0cbdb$export$fa53c1d9d4c86cc2,
        r: $ad1d6ab5b4a0cbdb$export$fa53c1d9d4c86cc2,
        fill: "var(--ds-surface, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        d: "M5.61317 8.79009C5.22098 9.09525 4.65374 9.06771 4.29313 8.70735C3.90248 8.31696 3.90226 7.68379 4.29265 7.29313L7.29061 4.29313L7.38478 4.20991C7.40593 4.19346 7.42759 4.17797 7.45041 4.16443C7.45646 4.16044 7.46257 4.15651 7.46788 4.15179C7.49043 4.13766 7.51343 4.12453 7.5368 4.11352C7.54775 4.10778 7.55883 4.10224 7.57017 4.09582C7.59257 4.08522 7.61528 4.0755 7.6381 4.06749C7.65076 4.06258 7.66354 4.05791 7.67639 4.05288C7.69947 4.04506 7.72278 4.03811 7.74628 4.03247C7.76084 4.02866 7.77552 4.02518 7.7901 4.02172C7.81167 4.01716 7.83337 4.01331 7.85506 4.01043C7.87192 4.00798 7.8889 4.00595 7.90635 4.00418C7.93138 4.00189 7.95648 4.00054 7.98082 4.00018L8 4C8.05202 4 8.10311 4.00397 8.15227 4.01191C8.16598 4.01404 8.17966 4.01645 8.19387 4.01878C8.2213 4.02417 8.24832 4.03068 8.27458 4.03883C8.2833 4.04133 8.29199 4.04395 8.30085 4.04605C8.3292 4.05498 8.35701 4.06514 8.38384 4.07717C8.39319 4.08108 8.4025 4.08513 8.41222 4.08865C8.5338 4.14373 8.64241 4.22242 8.73218 4.31888L11.7069 7.29265L11.7901 7.38683C12.0952 7.77902 12.0677 8.34626 11.7073 8.70687L11.6132 8.79009C11.221 9.09525 10.6537 9.06771 10.2931 8.70735L9 7.415L9 12C9 12.5523 8.55228 13 8 13C7.48716 13 7.06449 12.614 7.00673 12.1166L7 12L7 7.413L5.70735 8.70687L5.61317 8.79009Z",
        fill: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        transform: `rotate(${$ad1d6ab5b4a0cbdb$var$ROTATIONS[direction]}, ${$ad1d6ab5b4a0cbdb$export$fa53c1d9d4c86cc2}, ${$ad1d6ab5b4a0cbdb$export$fa53c1d9d4c86cc2})`
    }));
$ad1d6ab5b4a0cbdb$var$MoveArrow.displayName = "MoveArrow";
var $ad1d6ab5b4a0cbdb$export$2e2bcd8739ae039 = $ad1d6ab5b4a0cbdb$var$MoveArrow;

});


parcelRegister("31Oxr", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f0feb5fc664fedf$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $i860n = parcelRequire("i860n");

var $6OFDk = parcelRequire("6OFDk");

var $as09W = parcelRequire("as09W");

var $aLlWy = parcelRequire("aLlWy");

var $k9d6y = parcelRequire("k9d6y");

var $g3Okq = parcelRequire("g3Okq");

var $6KUoo = parcelRequire("6KUoo");

var $38YZm = parcelRequire("38YZm");

var $leb1Y = parcelRequire("leb1Y");

var $iXhO6 = parcelRequire("iXhO6");

var $6wPRl = parcelRequire("6wPRl");
const $6f0feb5fc664fedf$var$anyTransitionLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.diagram.global-transition.any-transition-label",
    defaultMessage: "Any"
});
const $6f0feb5fc664fedf$var$MIN_LOZENGE_WIDTH = 40;
const $6f0feb5fc664fedf$var$LOZENGE_HEIGHT = 24;
const $6f0feb5fc664fedf$var$LOZENGE_BORDER_RADIUS = $6f0feb5fc664fedf$var$LOZENGE_HEIGHT / 2;
const $6f0feb5fc664fedf$var$ERROR_RING_DASH_ARRAY = '3,2';
const $6f0feb5fc664fedf$var$FOCUS_RING_WIDTH = 4;
const $6f0feb5fc664fedf$var$TEXT_ICON_BUFFER = 8;
const $6f0feb5fc664fedf$var$LOZENGE_PADDING = 10; // total padding around left and right of lozenge, L + R value
const $6f0feb5fc664fedf$var$GlobalTransition = ({ id: id, flag: flag, isHovered: isHovered = false, isImmutable: isImmutable, isHighlighted: isHighlighted, portPosition: portPosition, isSelected: isSelected = false, isTargeted: isTargeted = false, onSelect: onSelect, onHover: onHover, icons: icons = (0, $i860n.fg)('jfp_magma_jira-stable-defaultprops') ? (0, $6OFDk.defaultProps).emptyArray : [] })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const stroke = (0, $iXhO6.useStrokeColor)({
        flag: flag,
        isHighlighted: isHighlighted,
        isSelected: isSelected,
        isHovered: isHovered
    });
    const textRef = (0, $euxye.useRef)(null);
    const iconsRef = (0, $euxye.useRef)(null);
    const lozengeText = (0, $38YZm.truncateLabel)(formatMessage($6f0feb5fc664fedf$var$anyTransitionLabel));
    const textWidth = (0, $6wPRl.default)(textRef, [
        icons
    ]);
    const iconsWidth = (0, $6wPRl.default)(iconsRef, [
        icons
    ]);
    const lozengeWidth = Math.max($6f0feb5fc664fedf$var$MIN_LOZENGE_WIDTH + iconsWidth, textWidth + iconsWidth + (iconsWidth > 0 ? $6f0feb5fc664fedf$var$TEXT_ICON_BUFFER : 0) + $6f0feb5fc664fedf$var$LOZENGE_PADDING);
    const routeWidth = lozengeWidth / 2;
    const onGroupClick = (0, $euxye.useCallback)(()=>{
        if (!isImmutable) onSelect?.({
            type: (0, $aLlWy.EDGE_TYPE),
            id: id
        });
    }, [
        id,
        isImmutable,
        onSelect
    ]);
    const onMouseEnter = (0, $euxye.useCallback)(()=>{
        onHover?.({
            id: id,
            type: (0, $aLlWy.EDGE_TYPE)
        });
    }, [
        id,
        onHover
    ]);
    const onMouseLeave = (0, $euxye.useCallback)(()=>{
        onHover?.(undefined);
    }, [
        onHover
    ]);
    if (!portPosition) return null;
    const path = (0, $leb1Y.globalTransitionRoute)(portPosition, (0, $as09W.GLOBAL_TRANSITION_PORT_OFFSET), lozengeWidth / 2);
    const textX = iconsWidth > 0 ? portPosition.x + iconsWidth + $6f0feb5fc664fedf$var$TEXT_ICON_BUFFER + $6f0feb5fc664fedf$var$LOZENGE_PADDING / 2 : portPosition.x + (lozengeWidth - textWidth) / 2;
    const textY = portPosition.y - (0, $leb1Y.GLOBAL_TRANSITION_ROUTE_HEIGHT_DISTANCE) - 8;
    const lozengeX = portPosition.x + routeWidth - lozengeWidth / 2;
    const lozengeY = portPosition.y - (0, $leb1Y.GLOBAL_TRANSITION_ROUTE_HEIGHT_DISTANCE) - $6f0feb5fc664fedf$var$LOZENGE_HEIGHT;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        onClick: onGroupClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "none",
        stroke: "transparent",
        d: path,
        strokeWidth: "15"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "none",
        stroke: stroke,
        strokeLinejoin: "round",
        d: path,
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g3Okq.DiagramArrow), {
        stroke: stroke,
        portIndex: (0, $as09W.GLOBAL_TRANSITION_PORT),
        portPosition: portPosition,
        portOffset: (0, $as09W.GLOBAL_TRANSITION_PORT_OFFSET)
    }), isTargeted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: lozengeX,
        y: lozengeY,
        width: lozengeWidth,
        height: $6f0feb5fc664fedf$var$LOZENGE_HEIGHT,
        rx: $6f0feb5fc664fedf$var$LOZENGE_BORDER_RADIUS,
        ry: $6f0feb5fc664fedf$var$LOZENGE_BORDER_RADIUS,
        stroke: (0, $as09W.STATE_COLOURS).focused,
        strokeWidth: $6f0feb5fc664fedf$var$FOCUS_RING_WIDTH * 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: lozengeX,
        y: lozengeY,
        width: lozengeWidth,
        height: $6f0feb5fc664fedf$var$LOZENGE_HEIGHT,
        rx: $6f0feb5fc664fedf$var$LOZENGE_BORDER_RADIUS,
        ry: $6f0feb5fc664fedf$var$LOZENGE_BORDER_RADIUS,
        fill: "var(--ds-background-neutral-bold, #292A2E)",
        strokeWidth: (0, $as09W.TRANSITION_STROKE_WIDTH),
        stroke: isSelected || flag ? stroke : undefined,
        strokeDasharray: flag && !isSelected ? $6f0feb5fc664fedf$var$ERROR_RING_DASH_ARRAY : undefined
    }), icons.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6KUoo.IconSet), {
        setRef: (ref)=>{
            iconsRef.current = ref;
        },
        icons: icons,
        inverse: true,
        anchor: (0, $k9d6y.toPoint)(portPosition.x + $6f0feb5fc664fedf$var$LOZENGE_PADDING / 2, textY - $6f0feb5fc664fedf$var$LOZENGE_HEIGHT / 2 - 2)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("text", {
        ref: textRef,
        // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
        textAnchor: "left",
        fontSize: "11px",
        fill: "var(--ds-text-inverse, #FFFFFF)",
        x: textX,
        y: textY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("tspan", null, lozengeText)));
};
$6f0feb5fc664fedf$var$GlobalTransition.displayName = "GlobalTransition";
var $6f0feb5fc664fedf$export$2e2bcd8739ae039 = $6f0feb5fc664fedf$var$GlobalTransition;

});
parcelRegister("leb1Y", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_TRANSITION_ROUTE_HEIGHT_DISTANCE", () => $dba9a4787a2ef966$export$749823dbfef429ad);
$parcel$export(module.exports, "globalTransitionRoute", () => $dba9a4787a2ef966$export$63f557e78cc90426);

var $2iYvg = parcelRequire("2iYvg");

var $dNy4O = parcelRequire("dNy4O");
const $dba9a4787a2ef966$export$d7ea5b7fe202bfa1 = (start, end)=>({
        path: (0, $dNy4O.move)(start.position) + (0, $dNy4O.line)(end.position),
        midpoint: (0, $2iYvg.midpoint)(start.position, end.position)
    });
const $dba9a4787a2ef966$export$749823dbfef429ad = 10;
const $dba9a4787a2ef966$export$63f557e78cc90426 = (portPosition, portOffset, width)=>`M${portPosition.x + portOffset},${portPosition.y}L${portPosition.x + width},${portPosition.y}L${portPosition.x + width},${portPosition.y - $dba9a4787a2ef966$export$749823dbfef429ad}`;

});


parcelRegister("8SchK", function(module, exports) {
$parcel$export(module.exports, "LayerGroup", () => $0844b93bff9d31fd$export$829212b9319961ea);
$parcel$export(module.exports, "LayerItem", () => $0844b93bff9d31fd$export$a8b53972628ea76c);

var $euxye = parcelRequire("euxye");

var $cY22M = parcelRequire("cY22M");

var $4vBIl = parcelRequire("4vBIl");

var $k9d6y = parcelRequire("k9d6y");
const $0844b93bff9d31fd$export$829212b9319961ea = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($4vBIl)))(children.flatMap((child)=>Array.isArray(child) ? child : [
            child
        ]), (child)=>Number((0, (/*@__PURE__*/$parcel$interopDefault($cY22M)))(child, 'props.layer', (0, $k9d6y.LayerIndex).Default))));
$0844b93bff9d31fd$export$829212b9319961ea.displayName = "LayerGroup";
const $0844b93bff9d31fd$export$a8b53972628ea76c = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
$0844b93bff9d31fd$export$a8b53972628ea76c.displayName = "LayerItem";

});
parcelRegister("4vBIl", function(module, exports) {

var $bCc8n = parcelRequire("bCc8n");

var $gWn8V = parcelRequire("gWn8V");

var $citK5 = parcelRequire("citK5");

var $4qbYM = parcelRequire("4qbYM");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $34874ff03e63f15e$var$sortBy = $citK5(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $4qbYM(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $4qbYM(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $gWn8V(collection, $bCc8n(iteratees, 1), []);
});
module.exports = $34874ff03e63f15e$var$sortBy;

});
parcelRegister("gWn8V", function(module, exports) {

var $bTATB = parcelRequire("bTATB");

var $70631 = parcelRequire("70631");

var $9JUaE = parcelRequire("9JUaE");

var $fQg47 = parcelRequire("fQg47");

var $gDPyU = parcelRequire("gDPyU");

var $8UK9T = parcelRequire("8UK9T");

var $1S033 = parcelRequire("1S033");

var $eSVkV = parcelRequire("eSVkV");

var $jOlpf = parcelRequire("jOlpf");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $c55403d9b5ba7cf1$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $bTATB(iteratees, function(iteratee) {
        if ($jOlpf(iteratee)) return function(value) {
            return $70631(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $eSVkV
    ];
    var index = -1;
    iteratees = $bTATB(iteratees, $8UK9T($9JUaE));
    var result = $fQg47(collection, function(value, key, collection) {
        var criteria = $bTATB(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $gDPyU(result, function(object, other) {
        return $1S033(object, other, orders);
    });
}
module.exports = $c55403d9b5ba7cf1$var$baseOrderBy;

});
parcelRegister("fQg47", function(module, exports) {

var $73ZOi = parcelRequire("73ZOi");

var $dWb9x = parcelRequire("dWb9x");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b8882c9c1eef481f$var$baseMap(collection, iteratee) {
    var index = -1, result = $dWb9x(collection) ? Array(collection.length) : [];
    $73ZOi(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $b8882c9c1eef481f$var$baseMap;

});

parcelRegister("gDPyU", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $c1d8490317621892$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $c1d8490317621892$var$baseSortBy;

});

parcelRegister("1S033", function(module, exports) {

var $3NYUZ = parcelRequire("3NYUZ");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $15cadf29e8b1ca59$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $3NYUZ(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $15cadf29e8b1ca59$var$compareMultiple;

});
parcelRegister("3NYUZ", function(module, exports) {

var $6SfBs = parcelRequire("6SfBs");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $2c5533ce96379354$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $6SfBs(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $6SfBs(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $2c5533ce96379354$var$compareAscending;

});





parcelRegister("etq4z", function(module, exports) {
$parcel$export(module.exports, "default", () => $909b453855f45903$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $as09W = parcelRequire("as09W");

var $aLlWy = parcelRequire("aLlWy");

var $k9d6y = parcelRequire("k9d6y");

var $3lbM4 = parcelRequire("3lbM4");
const $909b453855f45903$var$CORONA_GLOW_OPACITY = 0.45;
const $909b453855f45903$var$DiagramPort = ({ position: position, portKey: portKey, isImmutable: isImmutable, isGlowing: isGlowing = false, parentStatusId: parentStatusId, portIndex: portIndex, isRerouting: isRerouting = false, isProposingTransition: isProposingTransition = false, onHover: onHover, onTransitionProposalClose: onTransitionProposalClose, onTransitionReroutingClose: onTransitionReroutingClose })=>{
    const dataAttributes = (0, $3lbM4.useDraggableDataAttributes)('port', portKey);
    const onHoverChange = (isHovered)=>{
        if (isProposingTransition && parentStatusId && portIndex !== undefined) {
            onTransitionProposalClose?.(isHovered ? (0, $k9d6y.toPortKey)(parentStatusId, portIndex) : undefined);
            return;
        }
        if (isRerouting && parentStatusId && portIndex !== undefined) {
            onTransitionReroutingClose?.({
                proposedStatusId: parentStatusId,
                proposedPortKey: isHovered ? (0, $k9d6y.toPortKey)(parentStatusId, portIndex) : undefined
            });
            return;
        }
        if (isHovered && parentStatusId) {
            onHover?.({
                id: parentStatusId,
                type: (0, $aLlWy.NODE_TYPE)
            });
            return;
        }
        onHover?.(undefined);
    };
    const onPointerEnter = ()=>{
        onHoverChange(true);
    };
    const onPointerLeave = ()=>onHoverChange(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        pointerEvents: isImmutable ? 'none' : undefined,
        cursor: isImmutable ? undefined : 'crosshair',
        "data-testid": "accessible-workflow-diagram.port",
        ...dataAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("ellipse", {
        cx: position.x,
        cy: position.y,
        rx: "10",
        ry: "10",
        fill: (0, $as09W.STATE_COLOURS).focused,
        fillOpacity: isGlowing ? $909b453855f45903$var$CORONA_GLOW_OPACITY : 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("ellipse", {
        x: position.x,
        y: position.y,
        cx: position.x,
        cy: position.y,
        rx: "4",
        ry: "4",
        fill: "var(--ds-background-input, #FFFFFF)",
        stroke: (0, $as09W.STATE_COLOURS).focused,
        strokeWidth: "2"
    }));
};
$909b453855f45903$var$DiagramPort.displayName = "DiagramPort";
var $909b453855f45903$export$2e2bcd8739ae039 = $909b453855f45903$var$DiagramPort;

});

parcelRegister("cXsGc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1f3ca677d5f3dc9$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
const $b1f3ca677d5f3dc9$var$ProposedTransition = ({ start: start, end: end })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("line", {
        x1: start.x,
        y1: start.y,
        x2: end.x,
        y2: end.y,
        strokeDasharray: "4",
        stroke: "var(--ds-border-accent-blue, #357DE8)",
        pointerEvents: "none"
    });
$b1f3ca677d5f3dc9$var$ProposedTransition.displayName = "ProposedTransition";
var $b1f3ca677d5f3dc9$export$2e2bcd8739ae039 = $b1f3ca677d5f3dc9$var$ProposedTransition;

});

parcelRegister("a4WqC", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5130e83342a4ffa$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $as09W = parcelRequire("as09W");

var $aLlWy = parcelRequire("aLlWy");

var $g3Okq = parcelRequire("g3Okq");

var $iXhO6 = parcelRequire("iXhO6");
const $a5130e83342a4ffa$var$SharedTransition = ({ id: id, flag: flag, isHovered: isHovered = false, isHighlighted: isHighlighted = false, isImmutable: isImmutable = false, isSelected: isSelected = false, connections: connections, onSelect: onSelect, onHover: onHover })=>{
    const stroke = (0, $iXhO6.useStrokeColor)({
        flag: flag,
        isHighlighted: isHighlighted,
        isHovered: isHovered,
        isSelected: isSelected
    });
    const onGroupClick = (0, $euxye.useCallback)(()=>{
        if (!isImmutable) onSelect?.({
            type: (0, $aLlWy.EDGE_TYPE),
            id: id
        });
    }, [
        isImmutable,
        onSelect,
        id
    ]);
    const onMouseEnter = (0, $euxye.useCallback)((connection)=>()=>{
            onHover?.({
                id: id,
                type: (0, $aLlWy.EDGE_TYPE),
                connection: connection
            });
        }, [
        id,
        onHover
    ]);
    const onMouseLeave = (0, $euxye.useCallback)(()=>{
        onHover?.(undefined);
    }, [
        onHover
    ]);
    if (!connections) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, connections.map(({ path: path, targetPort: targetPort }, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
            onClick: onGroupClick,
            onMouseEnter: onMouseEnter(connections[i]),
            onMouseLeave: onMouseLeave,
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
            fill: "none",
            stroke: "transparent",
            d: path,
            strokeLinejoin: "round",
            strokeWidth: "15"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
            fill: "none",
            stroke: stroke,
            d: path,
            strokeLinejoin: "round",
            strokeWidth: (0, $as09W.TRANSITION_STROKE_WIDTH)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g3Okq.DiagramArrow), {
            portIndex: targetPort.portIndex,
            portPosition: targetPort.position,
            stroke: stroke
        }))));
};
$a5130e83342a4ffa$var$SharedTransition.displayName = "SharedTransition";
var $a5130e83342a4ffa$export$2e2bcd8739ae039 = $a5130e83342a4ffa$var$SharedTransition;

});

parcelRegister("iphYU", function(module, exports) {
$parcel$export(module.exports, "default", () => $edad32182470a13c$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $dNy4O = parcelRequire("dNy4O");
/**
 * Alignment lines that appear when dragging a status and allow aligning with other statuses
 */ const $edad32182470a13c$var$SnapLines = ({ lines: lines })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, lines.map(({ start: start, end: end }, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
            key: i,
            fill: "none",
            stroke: "var(--ds-border-accent-orange, #E06C00)",
            d: (0, $dNy4O.move)(start) + (0, $dNy4O.line)(end)
        })));
$edad32182470a13c$var$SnapLines.displayName = "SnapLines";
var $edad32182470a13c$export$2e2bcd8739ae039 = $edad32182470a13c$var$SnapLines;

});

parcelRegister("ijRar", function(module, exports) {
$parcel$export(module.exports, "default", () => $75684d50fb5a871c$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $as09W = parcelRequire("as09W");

var $aLlWy = parcelRequire("aLlWy");

var $132zH = parcelRequire("132zH");

var $3lbM4 = parcelRequire("3lbM4");
const $75684d50fb5a871c$var$startNodeLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.diagram.start-node.start-node-label",
    defaultMessage: "START"
});
const $75684d50fb5a871c$var$TEXT_LINE_HEIGHT_OFFSET = 2.75;
const $75684d50fb5a871c$var$FOCUS_RING_WIDTH = 4;
const $75684d50fb5a871c$var$ARROW_PADDING = $75684d50fb5a871c$var$FOCUS_RING_WIDTH + (0, $132zH.ARROW_RADIUS);
const $75684d50fb5a871c$var$StartNode = ({ position: position = {
    x: 0,
    y: 0
}, id: id, isImmutable: isImmutable, isTargeted: isTargeted, isMoving: isMoving, onHover: onHover })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const dataAttributes = (0, $3lbM4.useDraggableDataAttributes)('start-node', id);
    const onMouseEnter = ()=>{
        onHover({
            id: id,
            type: (0, $aLlWy.NODE_TYPE)
        });
    };
    const onMouseLeave = ()=>{
        onHover(undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, isTargeted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("ellipse", {
        cx: position.x + (0, $as09W.START_NODE_RADIUS),
        cy: position.y + (0, $as09W.START_NODE_RADIUS),
        rx: (0, $as09W.START_NODE_RADIUS) + $75684d50fb5a871c$var$FOCUS_RING_WIDTH / 2,
        ry: (0, $as09W.START_NODE_RADIUS) + $75684d50fb5a871c$var$FOCUS_RING_WIDTH / 2,
        stroke: (0, $as09W.STATE_COLOURS).focused,
        fillOpacity: "0",
        strokeWidth: $75684d50fb5a871c$var$FOCUS_RING_WIDTH
    }), isMoving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $132zH.default), {
        x: position.x + (0, $as09W.START_NODE_RADIUS),
        y: position.y - $75684d50fb5a871c$var$ARROW_PADDING,
        direction: "up"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $132zH.default), {
        x: position.x + (0, $as09W.START_NODE_RADIUS),
        y: position.y + (0, $as09W.START_NODE_RADIUS) * 2 + $75684d50fb5a871c$var$ARROW_PADDING,
        direction: "down"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $132zH.default), {
        x: position.x - $75684d50fb5a871c$var$ARROW_PADDING,
        y: position.y + (0, $as09W.START_NODE_RADIUS),
        direction: "left"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $132zH.default), {
        x: position.x + (0, $as09W.START_NODE_RADIUS) * 2 + $75684d50fb5a871c$var$ARROW_PADDING,
        y: position.y + (0, $as09W.START_NODE_RADIUS),
        direction: "right"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        cursor: isImmutable ? undefined : 'move',
        ...dataAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("ellipse", {
        cx: position.x + (0, $as09W.START_NODE_RADIUS),
        cy: position.y + (0, $as09W.START_NODE_RADIUS) - (0, $as09W.TRANSITION_STROKE_WIDTH),
        rx: (0, $as09W.START_NODE_RADIUS),
        ry: (0, $as09W.START_NODE_RADIUS),
        fill: "var(--ds-background-neutral-bold, #292A2E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("text", {
        x: position.x + (0, $as09W.START_NODE_RADIUS),
        y: position.y + (0, $as09W.START_NODE_RADIUS) - (0, $as09W.TRANSITION_STROKE_WIDTH),
        textAnchor: "middle",
        fontSize: "8px",
        fill: "var(--ds-text-inverse, #FFFFFF)",
        fontWeight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("tspan", {
        dy: $75684d50fb5a871c$var$TEXT_LINE_HEIGHT_OFFSET
    }, formatMessage($75684d50fb5a871c$var$startNodeLabel)))));
};
$75684d50fb5a871c$var$StartNode.displayName = "StartNode";
var $75684d50fb5a871c$export$2e2bcd8739ae039 = $75684d50fb5a871c$var$StartNode;

});

parcelRegister("grf3J", function(module, exports) {
$parcel$export(module.exports, "default", () => $724e6ba445b436bf$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $cdF7h = parcelRequire("cdF7h");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $as09W = parcelRequire("as09W");

var $aLlWy = parcelRequire("aLlWy");

var $k9d6y = parcelRequire("k9d6y");

var $132zH = parcelRequire("132zH");

var $38YZm = parcelRequire("38YZm");

var $3lbM4 = parcelRequire("3lbM4");

var $6wPRl = parcelRequire("6wPRl");
const $724e6ba445b436bf$var$STATUS_TEXT_OFFSET_Y = 3.25;
const $724e6ba445b436bf$var$STATUS_TEXT_HORIZONTAL_PADDING = 50;
const $724e6ba445b436bf$var$OUTLINE_PADDING = 3;
const $724e6ba445b436bf$var$DEFAULT_BORDER_WIDTH = 2;
const $724e6ba445b436bf$var$FOCUS_RING_WIDTH = 4;
const $724e6ba445b436bf$var$SELECTION_RING_RADIUS = 6;
const $724e6ba445b436bf$var$BORDER_RADIUS = 4;
const $724e6ba445b436bf$var$ERROR_RING_DASH_ARRAY = '6,3';
const $724e6ba445b436bf$var$ARROW_PADDING = $724e6ba445b436bf$var$OUTLINE_PADDING + $724e6ba445b436bf$var$FOCUS_RING_WIDTH + (0, $132zH.ARROW_RADIUS);
/**
 * Icon size "small" is 16px
 */ const $724e6ba445b436bf$var$GLOBE_ICON_SIZE = 16;
const $724e6ba445b436bf$var$GLOBE_ICON_GAP = 4;
const $724e6ba445b436bf$var$GLOBE_INDICATOR_WIDTH = $724e6ba445b436bf$var$GLOBE_ICON_SIZE + $724e6ba445b436bf$var$GLOBE_ICON_GAP;
/**
 * Used to vertically centre the icon with the status label.
 */ const $724e6ba445b436bf$var$GLOBE_TEXT_BASELINE_TO_OPTICAL_CENTER = 6;
const $724e6ba445b436bf$var$statusCategoryThemes = {
    UNDEFINED: {
        border: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        background: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        text: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        icon: "var(--ds-icon-accent-gray, #7D818A)"
    },
    TODO: {
        border: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        background: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        text: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        icon: "var(--ds-icon-accent-gray, #7D818A)"
    },
    IN_PROGRESS: {
        border: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        background: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
        text: "var(--ds-text-accent-blue-bolder, #123263)",
        icon: "var(--ds-icon-accent-blue, #357DE8)"
    },
    DONE: {
        border: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        background: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        text: "var(--ds-text-accent-green-bolder, #164B35)",
        icon: "var(--ds-icon-accent-green, #22A06B)"
    }
};
const $724e6ba445b436bf$var$DiagramStatus = ({ id: id, position: position = {
    x: 0,
    y: 0
}, label: label, category: category = 'UNDEFINED', flag: flag, isImmutable: isImmutable, isSelected: isSelected = false, isTargeted: isTargeted = false, isMoving: isMoving = false, showGlobalScopeIndicator: showGlobalScopeIndicator = false, onStatusResize: onStatusResize, onHover: onHover, onSelect: onSelect })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const textRef = (0, $euxye.useRef)(null);
    const lastReportedWidthRef = (0, $euxye.useRef)();
    const labelWidth = (0, $6wPRl.useLayoutWidth)(textRef, [
        label
    ]);
    const width = labelWidth + $724e6ba445b436bf$var$STATUS_TEXT_HORIZONTAL_PADDING + (showGlobalScopeIndicator ? $724e6ba445b436bf$var$GLOBE_INDICATOR_WIDTH : 0);
    // Track last reported width to prevent infinite loops when Strict Mode is enabled
    // Only notify parent when width actually changes, not on every render
    (0, $euxye.useLayoutEffect)(()=>{
        if (width > $724e6ba445b436bf$var$STATUS_TEXT_HORIZONTAL_PADDING && lastReportedWidthRef.current !== width) {
            lastReportedWidthRef.current = width;
            onStatusResize?.(id, width);
        }
    }, [
        id,
        width,
        onStatusResize
    ]);
    const dataAttributes = (0, $3lbM4.useDraggableDataAttributes)('status', id);
    const onPointerEnter = ()=>onHover?.({
            id: id,
            type: (0, $aLlWy.NODE_TYPE)
        });
    const onPointerLeave = ()=>onHover?.(undefined);
    const onGroupClick = ()=>{
        if (!isImmutable) onSelect?.({
            type: (0, $aLlWy.NODE_TYPE),
            id: id
        });
    };
    const truncatedLabel = (0, $38YZm.truncateLabel)(label);
    const hasError = flag === (0, $k9d6y.ValidationFlag).Error;
    const hasWarning = flag === (0, $k9d6y.ValidationFlag).Warn;
    const hasValidationFlag = hasError || hasWarning;
    const theme = $724e6ba445b436bf$var$statusCategoryThemes[category];
    const statusLeft = position.x;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", null, isTargeted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: statusLeft - $724e6ba445b436bf$var$OUTLINE_PADDING - $724e6ba445b436bf$var$FOCUS_RING_WIDTH / 4,
        y: position.y - $724e6ba445b436bf$var$OUTLINE_PADDING - $724e6ba445b436bf$var$FOCUS_RING_WIDTH / 4,
        width: width + $724e6ba445b436bf$var$OUTLINE_PADDING * 2 + $724e6ba445b436bf$var$FOCUS_RING_WIDTH / 2,
        height: (0, $as09W.STATUS_HEIGHT) + $724e6ba445b436bf$var$OUTLINE_PADDING * 2 + $724e6ba445b436bf$var$FOCUS_RING_WIDTH / 2,
        rx: $724e6ba445b436bf$var$SELECTION_RING_RADIUS,
        ry: $724e6ba445b436bf$var$SELECTION_RING_RADIUS,
        stroke: (0, $as09W.STATE_COLOURS).focused,
        fillOpacity: "0",
        strokeWidth: $724e6ba445b436bf$var$FOCUS_RING_WIDTH
    }), isMoving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $132zH.default), {
        x: statusLeft + width / 2,
        y: position.y - $724e6ba445b436bf$var$ARROW_PADDING,
        direction: "up"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $132zH.default), {
        x: statusLeft + width / 2,
        y: position.y + (0, $as09W.STATUS_HEIGHT) + $724e6ba445b436bf$var$ARROW_PADDING,
        direction: "down"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $132zH.default), {
        x: statusLeft - $724e6ba445b436bf$var$ARROW_PADDING,
        y: position.y + (0, $as09W.STATUS_HEIGHT) / 2,
        direction: "left"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $132zH.default), {
        x: statusLeft + width + $724e6ba445b436bf$var$ARROW_PADDING,
        y: position.y + (0, $as09W.STATUS_HEIGHT) / 2,
        direction: "right"
    })), hasValidationFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: statusLeft - $724e6ba445b436bf$var$OUTLINE_PADDING,
        y: position.y - $724e6ba445b436bf$var$OUTLINE_PADDING,
        width: width + $724e6ba445b436bf$var$OUTLINE_PADDING * 2,
        height: (0, $as09W.STATUS_HEIGHT) + $724e6ba445b436bf$var$OUTLINE_PADDING * 2,
        rx: $724e6ba445b436bf$var$SELECTION_RING_RADIUS,
        ry: $724e6ba445b436bf$var$SELECTION_RING_RADIUS,
        stroke: hasError ? (0, $as09W.STATE_COLOURS).error : (0, $as09W.STATE_COLOURS).warning,
        fillOpacity: "0",
        strokeDasharray: !isSelected ? $724e6ba445b436bf$var$ERROR_RING_DASH_ARRAY : undefined,
        strokeWidth: $724e6ba445b436bf$var$DEFAULT_BORDER_WIDTH
    }), isSelected && !hasValidationFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: statusLeft - $724e6ba445b436bf$var$OUTLINE_PADDING,
        y: position.y - $724e6ba445b436bf$var$OUTLINE_PADDING,
        width: width + $724e6ba445b436bf$var$OUTLINE_PADDING * 2,
        height: (0, $as09W.STATUS_HEIGHT) + $724e6ba445b436bf$var$OUTLINE_PADDING * 2,
        rx: $724e6ba445b436bf$var$SELECTION_RING_RADIUS,
        ry: $724e6ba445b436bf$var$SELECTION_RING_RADIUS,
        stroke: (0, $as09W.STATE_COLOURS).selected,
        fillOpacity: "0",
        strokeWidth: $724e6ba445b436bf$var$DEFAULT_BORDER_WIDTH
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        ...dataAttributes,
        cursor: !isImmutable ? 'move' : undefined,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onClick: onGroupClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: statusLeft,
        y: position.y,
        width: width,
        height: (0, $as09W.STATUS_HEIGHT),
        rx: $724e6ba445b436bf$var$BORDER_RADIUS,
        ry: $724e6ba445b436bf$var$BORDER_RADIUS,
        fill: theme.background,
        stroke: theme.border,
        strokeWidth: $724e6ba445b436bf$var$DEFAULT_BORDER_WIDTH
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("text", {
        x: statusLeft + width / 2 - (showGlobalScopeIndicator ? $724e6ba445b436bf$var$GLOBE_INDICATOR_WIDTH / 2 : 0),
        y: position.y + (0, $as09W.STATUS_HEIGHT) / 2 + $724e6ba445b436bf$var$STATUS_TEXT_OFFSET_Y,
        fontSize: "11px",
        stroke: "none",
        fill: theme.text,
        textAnchor: "middle",
        fontWeight: "bold",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("tspan", {
        ref: textRef
    }, truncatedLabel.toLocaleUpperCase())), showGlobalScopeIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("foreignObject", {
        x: statusLeft + width / 2 + labelWidth / 2 - $724e6ba445b436bf$var$GLOBE_INDICATOR_WIDTH / 2 + $724e6ba445b436bf$var$GLOBE_ICON_GAP,
        y: position.y + (0, $as09W.STATUS_HEIGHT) / 2 + $724e6ba445b436bf$var$STATUS_TEXT_OFFSET_Y - $724e6ba445b436bf$var$GLOBE_TEXT_BASELINE_TO_OPTICAL_CENTER - $724e6ba445b436bf$var$GLOBE_ICON_SIZE / 2,
        width: $724e6ba445b436bf$var$GLOBE_ICON_SIZE,
        height: $724e6ba445b436bf$var$GLOBE_ICON_SIZE,
        "data-testid": "accessible-workflow-diagram.global-indicator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cdF7h))), {
        label: formatMessage($724e6ba445b436bf$var$globalStatusIconLabel),
        color: theme.icon,
        size: "small"
    })))));
};
$724e6ba445b436bf$var$DiagramStatus.displayName = "DiagramStatus";
const $724e6ba445b436bf$var$globalStatusIconLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.diagram-status.global-status-icon-label",
    defaultMessage: "Global status"
});
var $724e6ba445b436bf$export$2e2bcd8739ae039 = $724e6ba445b436bf$var$DiagramStatus;

});
parcelRegister("cdF7h", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4a75f30383a815136b76433b9d7ec6c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e5697ce5234b218$var$_react = $8e5697ce5234b218$var$_interopRequireDefault((parcelRequire("euxye")));

var $8e5697ce5234b218$var$_baseNew = $8e5697ce5234b218$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $8e5697ce5234b218$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e5697ce5234b218$var$GlobeIcon = (props)=>/*#__PURE__*/ $8e5697ce5234b218$var$_react.default.createElement($8e5697ce5234b218$var$_baseNew.default, Object.assign({
        name: "GlobeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229" clip-rule="evenodd"/>`
    }, props));
$8e5697ce5234b218$var$GlobeIcon.displayName = 'GlobeIcon';
var $8e5697ce5234b218$var$_default = module.exports.default = $8e5697ce5234b218$var$GlobeIcon;

});


parcelRegister("2R4YJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $32135ebcb5218771$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $dI9CN = parcelRequire("dI9CN");
const $32135ebcb5218771$var$ViewOverlay = ({ viewBox: viewBox })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        ...(0, $dI9CN.DATA_ATTRIBUTE_IGNORE_AUTOFIT),
        x: viewBox.left,
        y: viewBox.top,
        width: viewBox.width,
        height: viewBox.height,
        fill: "var(--ds-surface, #FFFFFF)",
        fillOpacity: "0.5"
    });
$32135ebcb5218771$var$ViewOverlay.displayName = "ViewOverlay";
var $32135ebcb5218771$export$2e2bcd8739ae039 = $32135ebcb5218771$var$ViewOverlay;

});

parcelRegister("16z7O", function(module, exports) {
$parcel$export(module.exports, "default", () => $33593aa598deb6cd$export$2e2bcd8739ae039);
/* GlobalTransitionMulti.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $jaPl6 = parcelRequire("jaPl6");
var $2YPKP = parcelRequire("2YPKP");
var $2Xkyn = parcelRequire("2Xkyn");

var $1i1gd = parcelRequire("1i1gd");

var $8Qvei = parcelRequire("8Qvei");

var $9qT28 = parcelRequire("9qT28");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $as09W = parcelRequire("as09W");

var $aLlWy = parcelRequire("aLlWy");

var $g3Okq = parcelRequire("g3Okq");

var $38YZm = parcelRequire("38YZm");

var $leb1Y = parcelRequire("leb1Y");

var $iXhO6 = parcelRequire("iXhO6");

var $6wPRl = parcelRequire("6wPRl");

var $2700E = parcelRequire("2700E");
const $33593aa598deb6cd$var$anyTransitionLabelWithCount = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.diagram.global-transition.any-transition-label-with-count",
    defaultMessage: "Any ({count})"
});
const $33593aa598deb6cd$var$iconLabelHasRules = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.diagram.global-transition.icon-label-has-rules",
    defaultMessage: "Has workflow rules"
});
const $33593aa598deb6cd$var$iconLabelApproved = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.diagram.global-transition.icon-label-approved",
    defaultMessage: "Used when approval is approved"
});
const $33593aa598deb6cd$var$iconLabelApprovedInactive = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.diagram.global-transition.icon-label-approved-inactive",
    defaultMessage: "Used when approval is approved (inactive)"
});
const $33593aa598deb6cd$var$iconLabelDeclined = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.diagram.global-transition.icon-label-declined",
    defaultMessage: "Used when approval is declined"
});
const $33593aa598deb6cd$var$iconLabelDeclinedInactive = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.diagram.global-transition.icon-label-declined-inactive",
    defaultMessage: "Used when approval is declined (inactive)"
});
const $33593aa598deb6cd$var$MIN_LOZENGE_WIDTH = 40;
const $33593aa598deb6cd$var$LOZENGE_HEIGHT = 24;
const $33593aa598deb6cd$var$LOZENGE_BORDER_RADIUS = $33593aa598deb6cd$var$LOZENGE_HEIGHT / 2;
const $33593aa598deb6cd$var$FOCUS_RING_WIDTH = 4;
const $33593aa598deb6cd$var$LOZENGE_PADDING = 10; // total padding around left and right of lozenge, L + R value
const $33593aa598deb6cd$var$renderTransitionIcon = (icon, formatMessage)=>{
    const { type: type } = icon;
    switch(type){
        case 'bolt':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1i1gd))), {
                label: formatMessage($33593aa598deb6cd$var$iconLabelHasRules)
            });
        case 'check':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))), {
                label: formatMessage($33593aa598deb6cd$var$iconLabelApproved),
                color: "var(--ds-icon-success, #6A9A23)"
            });
        case 'check_inactive':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))), {
                label: formatMessage($33593aa598deb6cd$var$iconLabelApprovedInactive),
                color: "var(--ds-icon-disabled, #080F214A)"
            });
        case 'cross':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qT28))), {
                label: formatMessage($33593aa598deb6cd$var$iconLabelDeclined),
                color: "var(--ds-icon-danger, #C9372C)"
            });
        case 'cross_inactive':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qT28))), {
                label: formatMessage($33593aa598deb6cd$var$iconLabelDeclinedInactive),
                color: "var(--ds-icon-disabled, #080F214A)"
            });
        default:
            return null;
    }
};
const $33593aa598deb6cd$var$GlobalTransitionMulti = ({ statusId: statusId, portPosition: portPosition, transitions: transitions, isImmutable: isImmutable, expandedItem: expandedItem, targetedItem: targetedItem, hoveredItem: hoveredItem, onExpandedChange: onExpandedChange, onSelect: onSelect, onHover: onHover })=>{
    const isCurrentlyHovered = hoveredItem?.type === (0, $aLlWy.STATUS_GLOBAL_TRANSITIONS_TYPE) && statusId === hoveredItem.id;
    const hasSelectedTransition = (0, $euxye.useMemo)(()=>transitions.some((transition)=>transition.isSelected), [
        transitions
    ]);
    const isHighlighted = (0, $euxye.useMemo)(()=>transitions.some((transition)=>transition.isHighlighted), [
        transitions
    ]);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const stroke = (0, $iXhO6.useStrokeColor)({
        flag: undefined,
        isHighlighted: isHighlighted,
        isSelected: hasSelectedTransition,
        isHovered: isCurrentlyHovered
    });
    const textRef = (0, $euxye.useRef)(null);
    const textWidth = (0, $6wPRl.default)(textRef);
    const handleMenuToggle = (0, $euxye.useCallback)(({ isOpen: isOpen })=>{
        if (isImmutable) return;
        if (isOpen) onExpandedChange?.({
            type: (0, $aLlWy.STATUS_GLOBAL_TRANSITIONS_TYPE),
            id: statusId
        });
        else onExpandedChange?.(undefined);
    }, [
        isImmutable,
        onExpandedChange,
        statusId
    ]);
    const onMouseEnter = (0, $euxye.useCallback)(()=>{
        if (isImmutable) return;
        onHover?.({
            type: (0, $aLlWy.STATUS_GLOBAL_TRANSITIONS_TYPE),
            id: statusId
        });
    }, [
        isImmutable,
        onHover,
        statusId
    ]);
    const onMouseLeave = (0, $euxye.useCallback)(()=>{
        if (isImmutable) return;
        onHover?.(undefined);
    }, [
        isImmutable,
        onHover
    ]);
    if (!portPosition) return null;
    const isExpanded = expandedItem?.type === (0, $aLlWy.STATUS_GLOBAL_TRANSITIONS_TYPE) && statusId === expandedItem.id;
    const isMenuOpen = isExpanded && !isImmutable;
    const isTargeted = targetedItem?.type === (0, $aLlWy.STATUS_GLOBAL_TRANSITIONS_TYPE) && statusId === targetedItem.id;
    const lozengeWidth = Math.max($33593aa598deb6cd$var$MIN_LOZENGE_WIDTH, textWidth + $33593aa598deb6cd$var$LOZENGE_PADDING);
    const routeWidth = lozengeWidth / 2;
    const path = (0, $leb1Y.globalTransitionRoute)(portPosition, (0, $as09W.GLOBAL_TRANSITION_PORT_OFFSET), lozengeWidth / 2);
    const textX = portPosition.x + (lozengeWidth - textWidth) / 2;
    const textY = portPosition.y - (0, $leb1Y.GLOBAL_TRANSITION_ROUTE_HEIGHT_DISTANCE) - 8;
    const lozengeX = portPosition.x + routeWidth - lozengeWidth / 2;
    const lozengeY = portPosition.y - (0, $leb1Y.GLOBAL_TRANSITION_ROUTE_HEIGHT_DISTANCE) - $33593aa598deb6cd$var$LOZENGE_HEIGHT;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("g", {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "none",
        stroke: "transparent",
        d: path,
        strokeWidth: "15"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("path", {
        fill: "none",
        stroke: stroke,
        strokeLinejoin: "round",
        d: path,
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $g3Okq.DiagramArrow), {
        stroke: stroke,
        portIndex: (0, $as09W.GLOBAL_TRANSITION_PORT),
        portPosition: portPosition,
        portOffset: (0, $as09W.GLOBAL_TRANSITION_PORT_OFFSET)
    }), isTargeted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: lozengeX,
        y: lozengeY,
        width: lozengeWidth,
        height: $33593aa598deb6cd$var$LOZENGE_HEIGHT,
        rx: $33593aa598deb6cd$var$LOZENGE_BORDER_RADIUS,
        ry: $33593aa598deb6cd$var$LOZENGE_BORDER_RADIUS,
        stroke: (0, $as09W.STATE_COLOURS).focused,
        strokeWidth: $33593aa598deb6cd$var$FOCUS_RING_WIDTH * 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("rect", {
        x: lozengeX,
        y: lozengeY,
        width: lozengeWidth,
        height: $33593aa598deb6cd$var$LOZENGE_HEIGHT,
        rx: $33593aa598deb6cd$var$LOZENGE_BORDER_RADIUS,
        ry: $33593aa598deb6cd$var$LOZENGE_BORDER_RADIUS,
        fill: "var(--ds-background-neutral-bold, #292A2E)",
        strokeWidth: (0, $as09W.TRANSITION_STROKE_WIDTH),
        stroke: hasSelectedTransition || isExpanded ? stroke : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("text", {
        ref: textRef,
        textAnchor: "start",
        fontSize: "11px",
        fill: "var(--ds-text-inverse, #FFFFFF)",
        x: textX,
        y: textY,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("tspan", null, (0, $38YZm.truncateLabel)(formatMessage($33593aa598deb6cd$var$anyTransitionLabelWithCount, {
        count: transitions.length
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("foreignObject", {
        x: lozengeX,
        y: lozengeY,
        width: lozengeWidth,
        height: $33593aa598deb6cd$var$LOZENGE_HEIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jaPl6.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isDropdownOpen, testId: testId, ...providedProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
                ...providedProps,
                ref: triggerRef,
                "aria-hidden": "true",
                "data-testid": testId,
                className: (0, $4jQY2.default)([
                    "_1bsb1osq _4t3i1osq _tzy4idpf"
                ])
            }),
        placement: "right-start",
        isOpen: isMenuOpen,
        onOpenChange: handleMenuToggle,
        testId: "accessible-workflow-diagram.global-transitions-menu",
        ...(0, $2700E.expVal)('hix-9182_sprt_a11y_global_transition', 'isEnabled', false) && {
            autoFocus: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2Xkyn.default), null, transitions.map((transition)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2YPKP.default), {
            key: transition.id,
            isSelected: transition.isSelected,
            onClick: ()=>onSelect?.({
                    id: transition.id,
                    type: (0, $aLlWy.EDGE_TYPE)
                }),
            elemAfter: transition.icons.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
                className: (0, $4jQY2.default)([
                    "_zulp1b66 _1reoewfl _18m9ewfl _1e0c1txw _4cvr1h6o _1o9zidpf _1ul91ns9 _1bsb1ris _18u0u2gc"
                ])
            }, transition.icons.map((icon)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, {
                    key: icon.type
                }, $33593aa598deb6cd$var$renderTransitionIcon(icon, formatMessage)))) : undefined
        }, transition.label);
    })))));
};
$33593aa598deb6cd$var$GlobalTransitionMulti.displayName = "GlobalTransitionMulti";
const $33593aa598deb6cd$var$buttonStyles = null;
const $33593aa598deb6cd$var$iconWrapperStyles = null;
var $33593aa598deb6cd$export$2e2bcd8739ae039 = $33593aa598deb6cd$var$GlobalTransitionMulti;

});
parcelRegister("1i1gd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ee248cff197501222c434364c4f923a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f087332725fe54e$var$_react = $0f087332725fe54e$var$_interopRequireDefault((parcelRequire("euxye")));

var $0f087332725fe54e$var$_baseNew = $0f087332725fe54e$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $0f087332725fe54e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f087332725fe54e$var$AutomationIcon = (props)=>/*#__PURE__*/ $0f087332725fe54e$var$_react.default.createElement($0f087332725fe54e$var$_baseNew.default, Object.assign({
        name: "AutomationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$0f087332725fe54e$var$AutomationIcon.displayName = 'AutomationIcon';
var $0f087332725fe54e$var$_default = module.exports.default = $0f087332725fe54e$var$AutomationIcon;

});



parcelRegister("kCbh0", function(module, exports) {
$parcel$export(module.exports, "default", () => $79835bd510b34216$export$2e2bcd8739ae039);
/* ListNavigation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $eVMQF = parcelRequire("eVMQF");

var $1DCdt = parcelRequire("1DCdt");

var $apUrw = parcelRequire("apUrw");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $2700E = parcelRequire("2700E");

var $aLlWy = parcelRequire("aLlWy");

var $as09W = parcelRequire("as09W");

var $10IKr = parcelRequire("10IKr");

var $eS49a = parcelRequire("eS49a");

var $8muti = parcelRequire("8muti");

var $lHUhH = parcelRequire("lHUhH");

var $4UeCT = parcelRequire("4UeCT");
const $79835bd510b34216$var$navigationListLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.navigation-list-label",
    defaultMessage: "Navigate statuses and transitions in the workflow."
});
const $79835bd510b34216$var$navigationListDescription = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.navigation-list-description",
    defaultMessage: "Use direction keys to pan diagram. Use plus and minus keys to zoom the diagram."
});
const $79835bd510b34216$var$initialTransitionListLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.initial-transition-list-label",
    defaultMessage: "First transition."
});
const $79835bd510b34216$var$statusTransitionsListLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.status-transitions-list-label",
    defaultMessage: "Transitions for {statusName}."
});
const $79835bd510b34216$var$startNodeMoveStartAnnouncement = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.start-node-move-start-announcement",
    defaultMessage: "Moving start node. Current position x: {x} y: {y}. Change position with arrow keys. Hold \u201Cshift\u201C to make greater movements or \u201Calt\u201C to make finer movements. Confirm with \u201Center\u201C or cancel with \u201Cescape\u201C."
});
const $79835bd510b34216$var$statusMoveStartAnnouncement = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.status-move-start-announcement",
    defaultMessage: "Moving {statusName} status. Current position x: {x} y: {y}. Change position with arrow keys. Hold \u201Cshift\u201C to make greater movements or \u201Calt\u201C to make finer movements. Confirm with \u201Center\u201C or cancel with \u201Cescape\u201C."
});
const $79835bd510b34216$var$globalLoopsContainerMoveStartAnnouncement = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.global-looped-transitions-container-move-start-announcement",
    defaultMessage: "Moving global looped transitions container. Current position x: {x} y: {y}. Change position with arrow keys. Hold \u201Cshift\u201C to make greater movements or \u201Calt\u201C to make finer movements. Confirm with \u201Center\u201C or cancel with \u201Cescape\u201C."
});
const $79835bd510b34216$var$moveUpdateAnnouncement = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.move-update-announcement",
    defaultMessage: "x: {x}, y: {y}"
});
const $79835bd510b34216$var$moveCompleteAnnouncement = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.move-complete-announcement",
    defaultMessage: "Move completed. New position x: {x} y: {y}"
});
const $79835bd510b34216$var$moveCancelAnnouncement = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.move-cancel-announcement",
    defaultMessage: "Move canceled."
});
const $79835bd510b34216$var$editHelpText = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.edit-help-text",
    defaultMessage: "Select to edit details."
});
const $79835bd510b34216$var$moveHelpText = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.move-help-text",
    defaultMessage: "Press \u201Cm\u201D to enter move mode."
});
const $79835bd510b34216$var$deleteHelpText = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.delete-help-text",
    defaultMessage: "Select and press \u201Cdelete\u201D to delete."
});
const $79835bd510b34216$var$globalLoopedTransitionsList = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.global-looped-transitions-list",
    defaultMessage: "Global looped transitions"
});
const $79835bd510b34216$var$globalTransitionsButtonLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.global-transitions-button-label",
    defaultMessage: "Any {count}, transitions from any status to {statusName}"
});
const $79835bd510b34216$var$EDIT_HELP_ID = 'accessible-workflow-list.edit-help';
const $79835bd510b34216$var$MOVE_HELP_ID = 'accessible-workflow-list.move-help';
const $79835bd510b34216$var$DELETE_HELP_ID = 'accessible-workflow-list.delete-help';
const $79835bd510b34216$export$39d7113f2dbf2b71 = 10;
const $79835bd510b34216$export$90d9ca2a443f323d = 20;
const $79835bd510b34216$export$3be9fb6f5ac33422 = 5;
const $79835bd510b34216$var$ListNavigation = ({ onExpandedChange: onExpandedChange, globalLoopsContainerPosition: globalLoopsContainerPosition, startNodePosition: startNodePosition, statuses: statuses, transitions: transitions, isImmutable: isImmutable = false, movingItem: movingItem, errors: errors, selectedItem: selectedItem, expandedItem: expandedItem, pan: pan = (0, $as09W.DEFAULT_PAN), zoom: zoom = (0, $as09W.DEFAULT_ZOOM_LEVEL), minZoom: minZoom, workflowScope: workflowScope, onSelect: onSelect, onTargetChange: onTargetChange, setMovingItem: setMovingItem, onItemMove: onItemMove, onZoomChange: onZoomChange, onPanChange: onPanChange })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const listRef = (0, $euxye.useRef)(null);
    const [moveAnnouncement, setMoveAnnouncement] = (0, $euxye.useState)('');
    const { nodes: nodes, globalLoops: globalLoops } = (0, $4UeCT.getFlattenedStructure)(statuses, transitions, startNodePosition, errors, movingItem);
    const handleBlur = (event)=>{
        if (!listRef || !listRef.current) return; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!event.relatedTarget || !listRef.current.contains(event.relatedTarget)) {
            // focus moving outside of diagram
            onTargetChange?.(undefined);
            handleMoveCancel();
        }
    };
    const handleFocus = (event)=>{
        if (!listRef || !listRef.current) return;
        if (event.target === listRef.current) // list itself is targeted
        onTargetChange?.({
            type: (0, $aLlWy.DIAGRAM_CONTAINER_TYPE),
            id: (0, $aLlWy.DIAGRAM_CONTAINER_TYPE)
        });
    };
    const handleNodeFocus = (id)=>{
        onTargetChange?.({
            type: (0, $aLlWy.NODE_TYPE),
            id: id
        });
    };
    const handleEdgeFocus = (id)=>{
        onTargetChange?.({
            type: (0, $aLlWy.EDGE_TYPE),
            id: id
        });
        handleMoveCancel();
    };
    const handleGlobalStatusContainerFocus = (id)=>{
        onTargetChange?.({
            type: (0, $aLlWy.STATUS_GLOBAL_TRANSITIONS_TYPE),
            id: id
        });
    };
    const handleContainerFocus = ()=>{
        onTargetChange?.({
            type: (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE),
            id: (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE)
        });
    };
    const handleMoveStart = (updatedMoveState)=>{
        if (updatedMoveState.type === 'start-node') updateMoveAnnouncement(formatMessage($79835bd510b34216$var$startNodeMoveStartAnnouncement, {
            ...updatedMoveState.position
        }));
        else if (updatedMoveState.type === (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE)) updateMoveAnnouncement(formatMessage($79835bd510b34216$var$globalLoopsContainerMoveStartAnnouncement, {
            ...updatedMoveState.position
        }));
        else {
            const movingStatus = statuses.find((status)=>status.id === updatedMoveState.id);
            if (movingStatus) updateMoveAnnouncement(formatMessage($79835bd510b34216$var$statusMoveStartAnnouncement, {
                statusName: movingStatus.name,
                ...updatedMoveState.position
            }));
        }
        setMovingItem?.(updatedMoveState);
    };
    const handleMoveUpdate = (updatedMoveState)=>{
        updateMoveAnnouncement(formatMessage($79835bd510b34216$var$moveUpdateAnnouncement, {
            ...updatedMoveState.position
        }));
        setMovingItem?.(updatedMoveState);
    };
    const handleMoveComplete = ()=>{
        if (movingItem) {
            updateMoveAnnouncement(formatMessage($79835bd510b34216$var$moveCompleteAnnouncement, {
                ...movingItem.position
            }));
            onItemMove?.(movingItem);
            setMovingItem?.(undefined);
        }
    };
    const handleMoveCancel = ()=>{
        if (movingItem) {
            updateMoveAnnouncement(formatMessage($79835bd510b34216$var$moveCancelAnnouncement));
            setMovingItem?.(undefined);
        }
    };
    const handleKeyDown = (e)=>{
        const panDirection = (0, $aLlWy.DIRECTION_KEYS)[e.key];
        const zoomDirection = (0, $aLlWy.ZOOM_KEYS)[e.key];
        if (panDirection && !movingItem && pan) {
            let moveDistance = $79835bd510b34216$export$39d7113f2dbf2b71;
            if (e.shiftKey) moveDistance = $79835bd510b34216$export$90d9ca2a443f323d;
            else if (e.altKey) moveDistance = $79835bd510b34216$export$3be9fb6f5ac33422;
            const updatedPan = (0, $4UeCT.getMovedPoint)(pan, panDirection, moveDistance);
            onPanChange?.(updatedPan);
        }
        if (zoomDirection) {
            const nextZoom = (0, $10IKr.getNextZoomStep)(zoom, zoomDirection, minZoom);
            onZoomChange?.(nextZoom);
        }
    };
    const updateMoveAnnouncement = (0, $euxye.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))((message)=>setMoveAnnouncement(message), 500), []); // Cancel debounced function when component unmounts
    (0, $euxye.useEffect)(()=>()=>{
            updateMoveAnnouncement.cancel();
        }, [
        updateMoveAnnouncement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($79835bd510b34216$var$HiddenWrapper, null, !isImmutable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        id: $79835bd510b34216$var$EDIT_HELP_ID
    }, formatMessage($79835bd510b34216$var$editHelpText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        id: $79835bd510b34216$var$MOVE_HELP_ID
    }, formatMessage($79835bd510b34216$var$moveHelpText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        id: $79835bd510b34216$var$DELETE_HELP_ID
    }, formatMessage($79835bd510b34216$var$deleteHelpText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $apUrw.default), {
        id: "accessible-workflow-diagram.navigationList-description"
    }, formatMessage($79835bd510b34216$var$navigationListDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "aria-live": "assertive",
        "data-testid": "accessible-workflow-diagram.move-announcement"
    }, moveAnnouncement), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($79835bd510b34216$var$List, {
        ref: listRef,
        onBlur: handleBlur,
        onFocus: handleFocus,
        "aria-label": formatMessage($79835bd510b34216$var$navigationListLabel),
        "aria-describedby": "accessible-workflow-diagram.navigationList-description",
        onKeyDown: handleKeyDown,
        tabIndex: 0
    }, nodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("li", {
            key: node.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8muti.default), {
            node: node,
            isImmutable: isImmutable,
            selectedItem: selectedItem,
            describedBy: $79835bd510b34216$var$getNodeDescribedBy(isImmutable, node),
            workflowScope: workflowScope,
            onSelect: onSelect,
            onFocus: handleNodeFocus,
            onMoveStart: handleMoveStart,
            onMoveUpdate: handleMoveUpdate,
            onMoveComplete: handleMoveComplete,
            onMoveCancel: handleMoveCancel
        }), node.children && node.children.length > 0 && !(0, $2700E.expVal)('hix-8796_wfe_multi_global_transitions_support', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($79835bd510b34216$var$List, {
            "aria-label": node.status ? formatMessage($79835bd510b34216$var$statusTransitionsListLabel, {
                statusName: node.status.name
            }) : formatMessage($79835bd510b34216$var$initialTransitionListLabel)
        }, node.children.map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("li", {
                key: edge.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eS49a.default), {
                edge: edge,
                statuses: statuses,
                isImmutable: isImmutable,
                selectedItem: selectedItem,
                describedBy: $79835bd510b34216$var$getTransitionDescribedBy(isImmutable, edge),
                onSelect: onSelect,
                onFocus: handleEdgeFocus
            })))), (0, $2700E.expVal)('hix-8796_wfe_multi_global_transitions_support', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($79835bd510b34216$var$NodeChildren, {
            node: node,
            statuses: statuses,
            isImmutable: isImmutable,
            selectedItem: selectedItem,
            expandedItem: expandedItem,
            onSelect: onSelect,
            onFocus: handleEdgeFocus,
            onExpandedChange: onExpandedChange,
            handleGlobalStatusContainerFocus: handleGlobalStatusContainerFocus
        }))), globalLoops && globalLoops.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($79835bd510b34216$var$List, {
        "aria-label": formatMessage($79835bd510b34216$var$globalLoopedTransitionsList)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("li", {
        key: "global-loops-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $lHUhH.default), {
        position: movingItem?.type === 'global-loops-container' ? movingItem.position : globalLoopsContainerPosition,
        isImmutable: isImmutable,
        isMoving: movingItem?.type === (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE),
        onFocus: handleContainerFocus,
        onMoveStart: handleMoveStart,
        onMoveUpdate: handleMoveUpdate,
        onMoveComplete: handleMoveComplete,
        onMoveCancel: handleMoveCancel
    })), globalLoops.map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("li", {
            key: edge.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eS49a.default), {
            edge: edge,
            statuses: statuses,
            isImmutable: isImmutable,
            selectedItem: selectedItem,
            onSelect: onSelect,
            onFocus: handleEdgeFocus
        })))))));
};
$79835bd510b34216$var$ListNavigation.displayName = "ListNavigation";
const $79835bd510b34216$var$NodeChildren = ({ node: node, statuses: statuses, isImmutable: isImmutable, selectedItem: selectedItem, expandedItem: expandedItem, onSelect: onSelect, onFocus: onFocus, onExpandedChange: onExpandedChange, handleGlobalStatusContainerFocus: handleGlobalStatusContainerFocus })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (!node.children || node.children.length === 0) return null;
    const globalEdges = node.children.filter((edge)=>edge.type === (0, $1DCdt.transitionType).GLOBAL);
    const otherEdges = node.children.filter((edge)=>edge.type !== (0, $1DCdt.transitionType).GLOBAL);
    const handleButtonClick = ()=>{
        if (node.status?.id) onExpandedChange?.({
            type: (0, $aLlWy.STATUS_GLOBAL_TRANSITIONS_TYPE),
            id: node.status.id
        });
    };
    const handleButtonFocus = ()=>{
        if (node.status?.id) handleGlobalStatusContainerFocus?.(node.status.id);
    };
    const isExpanded = expandedItem?.type === (0, $aLlWy.STATUS_GLOBAL_TRANSITIONS_TYPE) && expandedItem?.id === node.status?.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($79835bd510b34216$var$List, {
        "aria-label": node.status ? formatMessage($79835bd510b34216$var$statusTransitionsListLabel, {
            statusName: node.status.name
        }) : formatMessage($79835bd510b34216$var$initialTransitionListLabel)
    }, globalEdges.length > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("button", {
        onClick: handleButtonClick,
        onFocus: handleButtonFocus,
        type: "button",
        "aria-haspopup": "menu",
        "aria-expanded": isExpanded
    }, formatMessage($79835bd510b34216$var$globalTransitionsButtonLabel, {
        statusName: node.status?.name,
        count: globalEdges.length
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, globalEdges.map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("li", {
            key: edge.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eS49a.default), {
            edge: edge,
            statuses: statuses,
            isImmutable: isImmutable,
            selectedItem: selectedItem,
            describedBy: $79835bd510b34216$var$getTransitionDescribedBy(isImmutable, edge),
            onSelect: onSelect,
            onFocus: onFocus
        })))), otherEdges.map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("li", {
            key: edge.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eS49a.default), {
            edge: edge,
            statuses: statuses,
            isImmutable: isImmutable,
            selectedItem: selectedItem,
            describedBy: $79835bd510b34216$var$getTransitionDescribedBy(isImmutable, edge),
            onSelect: onSelect,
            onFocus: onFocus
        }))));
};
$79835bd510b34216$var$NodeChildren.displayName = "NodeChildren";
const $79835bd510b34216$var$getNodeDescribedBy = (isImmutable, node)=>{
    if (isImmutable) return undefined;
    if (node.isInitial) return $79835bd510b34216$var$MOVE_HELP_ID;
    if (node.canDelete) return `${$79835bd510b34216$var$EDIT_HELP_ID} ${$79835bd510b34216$var$MOVE_HELP_ID} ${$79835bd510b34216$var$DELETE_HELP_ID}`;
    return `${$79835bd510b34216$var$EDIT_HELP_ID} ${$79835bd510b34216$var$MOVE_HELP_ID}`;
};
const $79835bd510b34216$var$getTransitionDescribedBy = (isImmutable, edge)=>{
    if (isImmutable) return undefined;
    if (edge.canDelete) return `${$79835bd510b34216$var$EDIT_HELP_ID} ${$79835bd510b34216$var$DELETE_HELP_ID}`;
    return $79835bd510b34216$var$EDIT_HELP_ID;
};
var $79835bd510b34216$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $79835bd510b34216$var$ListNavigation;
const $79835bd510b34216$var$List = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_qtt8glyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $79835bd510b34216$var$HiddenWrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eS49a", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d757dcbcd861c48$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $8Sdzy = parcelRequire("8Sdzy");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aLlWy = parcelRequire("aLlWy");

var $jVI3h = parcelRequire("jVI3h");

var $8i5U9 = parcelRequire("8i5U9");
const $6d757dcbcd861c48$var$globalTransitionLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.list-edge.global-transition-label",
    defaultMessage: "Transition from any status to {parentName}."
});
const $6d757dcbcd861c48$var$loopedTransitionLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.list-edge.looped-transition-label",
    defaultMessage: "{transitionName} transition - move issue from {parentName} back to itself."
});
const $6d757dcbcd861c48$var$globalLoopedTransitionLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation-list-edge.global-looped-transition-label",
    defaultMessage: "{transitionName} transition - move issue from any status back to itself."
});
const $6d757dcbcd861c48$var$initialTransitionLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.list-edge.initial-transition-label",
    defaultMessage: "{transitionName} transition - move issue to {targetName}."
});
const $6d757dcbcd861c48$var$directedTransitionLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.list-edge.directed-transition-label",
    defaultMessage: "{transitionName} transition - move issue from {sourceNames} to {targetName}."
});
const $6d757dcbcd861c48$var$loopedTransitionLabelIssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.list-edge.looped-transition-label-issue-term-refresh",
    defaultMessage: "{transitionName} transition - move work item from {parentName} back to itself."
});
const $6d757dcbcd861c48$var$globalLoopedTransitionLabelIssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation-list-edge.global-looped-transition-label-issue-term-refresh",
    defaultMessage: "{transitionName} transition - move work item from any status back to itself."
});
const $6d757dcbcd861c48$var$initialTransitionLabelIssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.list-edge.initial-transition-label-issue-term-refresh",
    defaultMessage: "{transitionName} transition - move work item to {targetName}."
});
const $6d757dcbcd861c48$var$directedTransitionLabelIssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.list-edge.directed-transition-label-issue-term-refresh",
    defaultMessage: "{transitionName} transition - move work item from {sourceNames} to {targetName}."
});
const $6d757dcbcd861c48$var$ListEdge = ({ edge: edge, statuses: statuses, isImmutable: isImmutable = false, describedBy: describedBy, selectedItem: selectedItem, onSelect: onSelect, onFocus: onFocus })=>{
    const isSelected = !!selectedItem && selectedItem.type === (0, $aLlWy.EDGE_TYPE) && selectedItem.id === edge.id;
    const handleClick = ()=>{
        onSelect?.({
            type: 'edge',
            id: edge.id
        });
    };
    const handleFocus = ()=>{
        onFocus?.(edge.id);
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($6d757dcbcd861c48$var$EdgeLabel, {
        edge: edge,
        statuses: statuses
    }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jVI3h.default), {
        rulesCount: edge.rulesCount
    }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8i5U9.default), {
        validationFlag: edge.validationFlag
    }));
    if (isImmutable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "aria-current": isSelected
    }, content);
    return(// We are using a primitive here to support accessible navigation of complex diagram,
    // this will never be visible to the user
    // eslint-disable-next-line @atlaskit/design-system/no-html-button
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("button", {
        type: "button",
        "aria-current": isSelected,
        onClick: handleClick,
        onFocus: handleFocus,
        "aria-describedby": describedBy
    }, content));
};
$6d757dcbcd861c48$var$ListEdge.displayName = "ListEdge";
const $6d757dcbcd861c48$var$EdgeLabel = ({ edge: { type: type, transition: transition, parentId: parentId }, statuses: statuses })=>{
    const { formatMessage: formatMessage, formatList: formatList } = (0, $1YIbA.default)();
    const parentStatus = statuses.find((status)=>status.id === parentId);
    if (type === 'GLOBAL_LOOPED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage((0, $i860n.fg)('jira-issue-terminology-refresh-m3') ? $6d757dcbcd861c48$var$globalLoopedTransitionLabelIssueTermRefresh : $6d757dcbcd861c48$var$globalLoopedTransitionLabel, {
        transitionName: transition.name
    }));
    if (type === 'GLOBAL') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($6d757dcbcd861c48$var$globalTransitionLabel, {
        parentName: parentStatus?.name
    }));
    if (type === 'LOOPED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage((0, $i860n.fg)('jira-issue-terminology-refresh-m3') ? $6d757dcbcd861c48$var$loopedTransitionLabelIssueTermRefresh : $6d757dcbcd861c48$var$loopedTransitionLabel, {
        transitionName: transition.name,
        parentName: parentStatus?.name
    }));
    const target = statuses.find((status)=>status.id === transition.toRef);
    if (type === 'INITIAL') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage((0, $i860n.fg)('jira-issue-terminology-refresh-m3') ? $6d757dcbcd861c48$var$initialTransitionLabelIssueTermRefresh : $6d757dcbcd861c48$var$initialTransitionLabel, {
        transitionName: transition.name,
        targetName: target?.name
    }));
    const sourceIds = transition.links.map((source)=>source.fromRef);
    const otherSourcesNames = statuses.filter((status)=>status.id !== parentId && sourceIds.includes(status.id)).map((status)=>status.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage((0, $i860n.fg)('jira-issue-terminology-refresh-m3') ? $6d757dcbcd861c48$var$directedTransitionLabelIssueTermRefresh : $6d757dcbcd861c48$var$directedTransitionLabel, {
        transitionName: transition.name,
        sourceNames: formatList([
            parentStatus?.name,
            ...otherSourcesNames
        ]),
        targetName: target?.name
    }));
};
$6d757dcbcd861c48$var$EdgeLabel.displayName = "EdgeLabel";
var $6d757dcbcd861c48$export$2e2bcd8739ae039 = $6d757dcbcd861c48$var$ListEdge;

});
parcelRegister("jVI3h", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e23d648523aac4d$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $4e23d648523aac4d$var$hasRulesIndicator = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.common.rules-indicator.has-rules-indicator",
    defaultMessage: "Has {rulesCount, plural, one {# rule} other {# rules}}."
});
const $4e23d648523aac4d$var$RulesIndicator = ({ rulesCount: rulesCount })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (rulesCount <= 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($4e23d648523aac4d$var$hasRulesIndicator, {
        rulesCount: rulesCount
    }));
};
$4e23d648523aac4d$var$RulesIndicator.displayName = "RulesIndicator";
var $4e23d648523aac4d$export$2e2bcd8739ae039 = $4e23d648523aac4d$var$RulesIndicator;

});

parcelRegister("8i5U9", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd69bc6c059124c7$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $fd69bc6c059124c7$var$hasErrorIndicator = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.common.validation-indicator.has-error-indicator",
    defaultMessage: "Has error."
});
const $fd69bc6c059124c7$var$hasWarningIndicator = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.common.validation-indicator.has-warning-indicator",
    defaultMessage: "Has warning."
});
const $fd69bc6c059124c7$var$ValidationIndicator = ({ validationFlag: validationFlag })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (!validationFlag) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage(validationFlag === 'error' ? $fd69bc6c059124c7$var$hasErrorIndicator : $fd69bc6c059124c7$var$hasWarningIndicator));
};
$fd69bc6c059124c7$var$ValidationIndicator.displayName = "ValidationIndicator";
var $fd69bc6c059124c7$export$2e2bcd8739ae039 = $fd69bc6c059124c7$var$ValidationIndicator;

});


parcelRegister("8muti", function(module, exports) {
$parcel$export(module.exports, "default", () => $58bcc80e73333edf$export$2e2bcd8739ae039);
// primitive buttons are used here for native level screen reader support
/* eslint-disable @atlaskit/design-system/no-html-button */ 
var $euxye = parcelRequire("euxye");

var $1DCdt = parcelRequire("1DCdt");

var $8Sdzy = parcelRequire("8Sdzy");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aLlWy = parcelRequire("aLlWy");

var $8i5U9 = parcelRequire("8i5U9");
const $58bcc80e73333edf$export$c0ac0a5c7f93677c = 5;
const $58bcc80e73333edf$export$367adc66518209f7 = 10;
const $58bcc80e73333edf$export$8586a781d0daf2c1 = 1;
const $58bcc80e73333edf$var$NodeLabel = ({ node: node, workflowScope: workflowScope })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (node.status) {
        if (!node.status.name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($58bcc80e73333edf$var$unknownStatusNodeLabel));
        const shouldAnnounceGlobalStatus = workflowScope === (0, $1DCdt.SCOPE_PROJECT) && node.status.scope === (0, $1DCdt.SCOPE_GLOBAL);
        if (shouldAnnounceGlobalStatus) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($58bcc80e73333edf$var$globalStatusNodeLabel, {
            statusName: node.status.name
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($58bcc80e73333edf$var$statusNodeLabel, {
            statusName: node.status.name
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage((0, $i860n.fg)('jira-issue-terminology-refresh-m3') ? $58bcc80e73333edf$var$startNodeLabelIssueTermRefresh : $58bcc80e73333edf$var$startNodeLabel));
};
$58bcc80e73333edf$var$NodeLabel.displayName = "NodeLabel";
const $58bcc80e73333edf$var$ListNode = ({ node: node, selectedItem: selectedItem, isImmutable: isImmutable = false, describedBy: describedBy, workflowScope: workflowScope, onSelect: onSelect, onFocus: onFocus, onMoveStart: onMoveStart, onMoveUpdate: onMoveUpdate, onMoveComplete: onMoveComplete, onMoveCancel: onMoveCancel })=>{
    const isSelected = !!selectedItem && selectedItem.type === (0, $aLlWy.NODE_TYPE) && selectedItem.id === node.id;
    const handleClick = ()=>{
        if (!node.isMoving && !node.isInitial) onSelect?.({
            type: 'node',
            id: node.id
        });
    };
    const handleFocus = ()=>{
        onFocus?.(node.id);
    };
    const handleKeyDown = (e)=>{
        const direction = (0, $aLlWy.DIRECTION_KEYS)[e.key];
        if (node.isMoving && direction && node.position) {
            const updatedPosition = {
                ...node.position
            };
            let moveDistance = $58bcc80e73333edf$export$c0ac0a5c7f93677c;
            if (e.shiftKey) moveDistance = $58bcc80e73333edf$export$367adc66518209f7;
            else if (e.altKey) moveDistance = $58bcc80e73333edf$export$8586a781d0daf2c1;
            if (direction === 'up') updatedPosition.y -= moveDistance;
            if (direction === 'down') updatedPosition.y += moveDistance;
            if (direction === 'left') updatedPosition.x -= moveDistance;
            if (direction === 'right') updatedPosition.x += moveDistance;
            onMoveUpdate?.({
                id: node.id,
                type: node.isInitial ? 'start-node' : 'status',
                position: updatedPosition
            });
        }
    };
    const handleKeyUp = (e)=>{
        if (e.key === 'm' && !node.isMoving && node.position) onMoveStart?.({
            id: node.id,
            type: node.isInitial ? 'start-node' : 'status',
            position: node.position
        });
        if ((e.key === 'Enter' || e.key === ' ') && node.isMoving) onMoveComplete?.();
        if (e.key === 'Escape' && node.isMoving) onMoveCancel?.();
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($58bcc80e73333edf$var$NodeLabel, {
        node: node,
        workflowScope: workflowScope
    }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8i5U9.default), {
        validationFlag: node.validationFlag
    }));
    if (isImmutable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("div", {
        "aria-current": isSelected
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("button", {
        type: "button",
        "aria-current": isSelected,
        onClick: handleClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        "aria-describedby": describedBy
    }, content);
};
$58bcc80e73333edf$var$ListNode.displayName = "ListNode";
var $58bcc80e73333edf$export$2e2bcd8739ae039 = $58bcc80e73333edf$var$ListNode;
const $58bcc80e73333edf$var$startNodeLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.list-node.start-node-label",
    defaultMessage: "Start - work items transition from here when they're created."
});
const $58bcc80e73333edf$var$startNodeLabelIssueTermRefresh = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.list-node.start-node-label-issue-term-refresh",
    defaultMessage: "Start - transition from here once created."
});
const $58bcc80e73333edf$var$statusNodeLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.list-node.status-node-label",
    defaultMessage: "{statusName} status."
});
const $58bcc80e73333edf$var$globalStatusNodeLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.list-node.global-status-node-label",
    defaultMessage: "{statusName} status. Global status."
});
const $58bcc80e73333edf$var$unknownStatusNodeLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.list-node.unknown-status-node-label",
    defaultMessage: "Unknown status."
});

});

parcelRegister("lHUhH", function(module, exports) {
$parcel$export(module.exports, "default", () => $bacbbbfddb26eea0$export$2e2bcd8739ae039);
// primitive buttons are used here for native level screen reader support
/* eslint-disable @atlaskit/design-system/no-html-button */ 
var $euxye = parcelRequire("euxye");

var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aLlWy = parcelRequire("aLlWy");
const $bacbbbfddb26eea0$var$containerLabel = (0, $7eNDO.defineMessage)({
    id: "accessible-workflow-diagram.list-navigation.list-container.container-label",
    defaultMessage: "Global looped transition container"
});
const $bacbbbfddb26eea0$export$c0ac0a5c7f93677c = 5;
const $bacbbbfddb26eea0$export$367adc66518209f7 = 10;
const $bacbbbfddb26eea0$export$8586a781d0daf2c1 = 1;
const $bacbbbfddb26eea0$var$ListContainer = ({ position: position, isImmutable: isImmutable = false, describedBy: describedBy, isMoving: isMoving, onFocus: onFocus, onMoveStart: onMoveStart, onMoveUpdate: onMoveUpdate, onMoveComplete: onMoveComplete, onMoveCancel: onMoveCancel })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const handleKeyDown = (e)=>{
        const direction = (0, $aLlWy.DIRECTION_KEYS)[e.key];
        if (isMoving && direction && position) {
            const updatedPosition = {
                ...position
            };
            let moveDistance = $bacbbbfddb26eea0$export$c0ac0a5c7f93677c;
            if (e.shiftKey) moveDistance = $bacbbbfddb26eea0$export$367adc66518209f7;
            else if (e.altKey) moveDistance = $bacbbbfddb26eea0$export$8586a781d0daf2c1;
            if (direction === 'up') updatedPosition.y -= moveDistance;
            if (direction === 'down') updatedPosition.y += moveDistance;
            if (direction === 'left') updatedPosition.x -= moveDistance;
            if (direction === 'right') updatedPosition.x += moveDistance;
            onMoveUpdate({
                id: (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE),
                type: (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE),
                position: updatedPosition
            });
        }
    };
    const handleKeyUp = (e)=>{
        if (e.key === 'm' && !isMoving && position) onMoveStart({
            id: (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE),
            type: (0, $aLlWy.GLOBAL_LOOPS_CONTAINER_TYPE),
            position: position
        });
        if ((e.key === 'Enter' || e.key === ' ') && isMoving) onMoveComplete();
        if (e.key === 'Escape' && isMoving) onMoveCancel();
    };
    if (isImmutable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($bacbbbfddb26eea0$var$containerLabel));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("button", {
        type: "button",
        onFocus: onFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        "aria-describedby": describedBy
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($bacbbbfddb26eea0$var$containerLabel)));
};
$bacbbbfddb26eea0$var$ListContainer.displayName = "ListContainer";
var $bacbbbfddb26eea0$export$2e2bcd8739ae039 = $bacbbbfddb26eea0$var$ListContainer;

});

parcelRegister("4UeCT", function(module, exports) {
$parcel$export(module.exports, "getFlattenedStructure", () => $f659e43d83893858$export$320bc7471675c215);
$parcel$export(module.exports, "getMovedPoint", () => $f659e43d83893858$export$68d7f09cf1f03476);

var $WqSvO = parcelRequire("WqSvO");

var $1DCdt = parcelRequire("1DCdt");

var $k9d6y = parcelRequire("k9d6y");
const $f659e43d83893858$var$orderStatuses = (statuses)=>[
        ...statuses
    ].sort((a, b)=>{
        if (a.layout === undefined || b.layout === undefined) return 0;
        if (a.layout.x !== b.layout.x) return a.layout.x - b.layout.x;
        return a.layout.y - b.layout.y;
    });
const $f659e43d83893858$var$getEdge = (transition, type, parentId, errors)=>{
    let validationFlag;
    const allErrors = (errors[transition.id] ?? []).concat(...transition.rules.filter((rule)=>!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(errors[rule.id])).map((rule)=>errors[rule.id]));
    if (allErrors.length) validationFlag = allErrors.some((error)=>error.severity === (0, $1DCdt.errorSeverity).ERROR) ? (0, $k9d6y.ValidationFlag).Error : (0, $k9d6y.ValidationFlag).Warn;
    return {
        id: transition.id,
        transition: transition,
        type: type,
        parentId: parentId,
        rulesCount: transition.rules.length,
        ...validationFlag ? {
            validationFlag: validationFlag
        } : {},
        canDelete: type !== 'INITIAL'
    };
};
const $f659e43d83893858$var$getNestedEdges = (parentId, transitions, errors)=>{
    const directedTransitions = transitions.filter((transition)=>transition.toRef !== parentId && transition.links && transition.links.some((target)=>target.fromRef === parentId)).map((transition)=>$f659e43d83893858$var$getEdge(transition, transition.type === 'INITIAL' ? 'INITIAL' : 'DIRECTED', parentId, errors));
    const loopedTransitions = transitions.filter((transition)=>transition.toRef === parentId && transition.links && transition.links.some((target)=>target.fromRef === parentId)).map((transition)=>$f659e43d83893858$var$getEdge(transition, 'LOOPED', parentId, errors));
    const globalTransitions = transitions.filter((transition)=>!transition.links.length && transition.toRef === parentId).map((transition)=>$f659e43d83893858$var$getEdge(transition, 'GLOBAL', parentId, errors));
    return [
        ...directedTransitions,
        ...loopedTransitions,
        ...globalTransitions
    ];
};
const $f659e43d83893858$var$getGlobalLoops = (transitions, errors)=>transitions.filter((transition)=>!transition.links.length && transition.toRef === undefined).map((transition)=>$f659e43d83893858$var$getEdge(transition, 'GLOBAL_LOOPED', undefined, errors));
const $f659e43d83893858$export$320bc7471675c215 = (statuses, transitions, startNodePosition, errors = {}, movingItem)=>{
    const initialTransition = transitions.find((transition)=>transition.type === 'INITIAL');
    const initialTransitionTarget = initialTransition?.toRef;
    const startItem = {
        id: (0, $1DCdt.START_NODE_ID),
        isInitial: true,
        children: $f659e43d83893858$var$getNestedEdges((0, $1DCdt.START_NODE_ID), transitions, errors),
        isMoving: movingItem?.id === (0, $1DCdt.START_NODE_ID),
        position: movingItem?.id === (0, $1DCdt.START_NODE_ID) ? movingItem.position : startNodePosition,
        canDelete: false
    };
    const statusItems = $f659e43d83893858$var$orderStatuses(statuses).map((status)=>{
        const statusErrors = errors?.[status.id] || [];
        const isMoving = movingItem?.id === status.id;
        const canDelete = status.id !== initialTransitionTarget;
        let validationFlag;
        if (statusErrors.length) validationFlag = statusErrors.some((error)=>error.severity === (0, $1DCdt.errorSeverity).ERROR) ? (0, $k9d6y.ValidationFlag).Error : (0, $k9d6y.ValidationFlag).Warn;
        return {
            id: status.id,
            status: status,
            children: $f659e43d83893858$var$getNestedEdges(status.id, transitions, errors),
            validationFlag: validationFlag,
            isMoving: isMoving,
            position: isMoving ? movingItem.position : status.layout,
            canDelete: canDelete
        };
    });
    const globalLoops = $f659e43d83893858$var$getGlobalLoops(transitions, errors);
    return {
        nodes: [
            startItem,
            ...statusItems
        ],
        globalLoops: globalLoops
    };
};
const $f659e43d83893858$export$68d7f09cf1f03476 = (point, direction, distance)=>{
    const updated = {
        ...point
    };
    if (direction === 'up') updated.y -= distance;
    if (direction === 'down') updated.y += distance;
    if (direction === 'left') updated.x -= distance;
    if (direction === 'right') updated.x += distance;
    return updated;
};

});


parcelRegister("j4eLJ", function(module, exports) {
$parcel$export(module.exports, "toDiagramStartNodePosition", () => $b6d2eb4129e1d7ff$export$dda2237b70238711);
$parcel$export(module.exports, "toDiagramGlobalLoopsContainerPosition", () => $b6d2eb4129e1d7ff$export$38d5df80e5fbbe05);
$parcel$export(module.exports, "toDiagramStatuses", () => $b6d2eb4129e1d7ff$export$a68083484778dd7f);
$parcel$export(module.exports, "toDiagramTransitions", () => $b6d2eb4129e1d7ff$export$5c6df39babffa5d6);
$parcel$export(module.exports, "getTransitionConnectionInfo", () => $b6d2eb4129e1d7ff$export$49150f61646e15b7);

var $WqSvO = parcelRequire("WqSvO");

var $iNSkg = parcelRequire("iNSkg");

var $1DCdt = parcelRequire("1DCdt");

var $k9d6y = parcelRequire("k9d6y");
const $b6d2eb4129e1d7ff$var$CMP_APPROVAL_RULE_KEY = 'system:block-in-progress-approval';
const $b6d2eb4129e1d7ff$var$TMP_APPROVAL_APPROVE_RULE_KEY = 'system:jsd-approvals-block-until-approved';
const $b6d2eb4129e1d7ff$var$TMP_APPROVAL_DECLINE_RULE_KEY = 'system:jsd-approvals-block-until-rejected';
const $b6d2eb4129e1d7ff$var$TRIGGER_AGENT_RULE_KEY = 'system:trigger-agent';
// Helper functions
// ------------------------------------------------------------------------------------------------
const $b6d2eb4129e1d7ff$var$CMP_ICON_CONFIG = [
    [
        (0, $k9d6y.TransitionIcons).Check,
        (t)=>({ approvalConfiguration: approvalConfiguration })=>!!approvalConfiguration && approvalConfiguration.active === 'true' && approvalConfiguration.transitionApproved === t.id
    ],
    [
        (0, $k9d6y.TransitionIcons).Cross,
        (t)=>({ approvalConfiguration: approvalConfiguration })=>!!approvalConfiguration && approvalConfiguration.active === 'true' && approvalConfiguration.transitionRejected === t.id
    ],
    [
        (0, $k9d6y.TransitionIcons).CheckInactive,
        (t)=>({ approvalConfiguration: approvalConfiguration })=>!!approvalConfiguration && !(approvalConfiguration.active === 'true') && approvalConfiguration.transitionApproved === t.id
    ],
    [
        (0, $k9d6y.TransitionIcons).CrossInactive,
        (t)=>({ approvalConfiguration: approvalConfiguration })=>!!approvalConfiguration && !(approvalConfiguration.active === 'true') && approvalConfiguration.transitionRejected === t.id
    ]
];
const $b6d2eb4129e1d7ff$var$TMP_ICON_CONFIG = [
    [
        (0, $k9d6y.TransitionIcons).Check,
        ({ config: config, ruleKey: ruleKey })=>ruleKey === $b6d2eb4129e1d7ff$var$TMP_APPROVAL_APPROVE_RULE_KEY && !!config?.approvalConfigurationJson && typeof config.approvalConfigurationJson === 'string' && JSON.parse(config.approvalConfigurationJson).active
    ],
    [
        (0, $k9d6y.TransitionIcons).Cross,
        ({ config: config, ruleKey: ruleKey })=>ruleKey === $b6d2eb4129e1d7ff$var$TMP_APPROVAL_DECLINE_RULE_KEY && !!config?.approvalConfigurationJson && typeof config.approvalConfigurationJson === 'string' && JSON.parse(config.approvalConfigurationJson).active
    ],
    [
        (0, $k9d6y.TransitionIcons).CheckInactive,
        ({ config: config, ruleKey: ruleKey })=>ruleKey === $b6d2eb4129e1d7ff$var$TMP_APPROVAL_APPROVE_RULE_KEY && !!config?.approvalConfigurationJson && typeof config.approvalConfigurationJson === 'string' && !JSON.parse(config.approvalConfigurationJson).active
    ],
    [
        (0, $k9d6y.TransitionIcons).CrossInactive,
        ({ config: config, ruleKey: ruleKey })=>ruleKey === $b6d2eb4129e1d7ff$var$TMP_APPROVAL_DECLINE_RULE_KEY && !!config?.approvalConfigurationJson && typeof config.approvalConfigurationJson === 'string' && !JSON.parse(config.approvalConfigurationJson).active
    ]
];
const $b6d2eb4129e1d7ff$var$getCMPApprovalIcons = (statuses, transition)=>$b6d2eb4129e1d7ff$var$CMP_ICON_CONFIG.map(([type, statusFilter])=>({
            type: type,
            fromStatuses: statuses.filter(statusFilter(transition)).map(({ id: id })=>id)
        })).filter(({ fromStatuses: fromStatuses })=>(fromStatuses ?? []).length > 0);
const $b6d2eb4129e1d7ff$var$getTMPApprovalIcons = (statuses, { links: links }, rule)=>$b6d2eb4129e1d7ff$var$TMP_ICON_CONFIG.map(([type, ruleFilter])=>({
            type: type,
            fromStatuses: ruleFilter(rule) ? (links ?? []).map(({ fromRef: fromRef })=>fromRef) : []
        })).filter(({ fromStatuses: fromStatuses })=>(fromStatuses ?? []).length > 0);
const $b6d2eb4129e1d7ff$var$getApprovalIcons = (statuses, transition)=>(rule)=>{
        switch(rule.ruleKey){
            case $b6d2eb4129e1d7ff$var$CMP_APPROVAL_RULE_KEY:
                return $b6d2eb4129e1d7ff$var$getCMPApprovalIcons(statuses, transition, rule);
            case $b6d2eb4129e1d7ff$var$TMP_APPROVAL_APPROVE_RULE_KEY:
            case $b6d2eb4129e1d7ff$var$TMP_APPROVAL_DECLINE_RULE_KEY:
                return $b6d2eb4129e1d7ff$var$getTMPApprovalIcons(statuses, transition, rule);
            default:
                return [];
        }
    };
const $b6d2eb4129e1d7ff$var$isAnApprovalRule = ({ ruleKey: ruleKey })=>{
    const approvalRuleKeys = [
        $b6d2eb4129e1d7ff$var$CMP_APPROVAL_RULE_KEY,
        $b6d2eb4129e1d7ff$var$TMP_APPROVAL_APPROVE_RULE_KEY,
        $b6d2eb4129e1d7ff$var$TMP_APPROVAL_DECLINE_RULE_KEY
    ];
    return approvalRuleKeys.some((approvalKey)=>ruleKey === approvalKey);
};
const $b6d2eb4129e1d7ff$var$isAnAgentRule = ({ ruleKey: ruleKey })=>{
    const agentRuleKeys = [
        $b6d2eb4129e1d7ff$var$TRIGGER_AGENT_RULE_KEY
    ];
    return agentRuleKeys.some((approvalKey)=>ruleKey === approvalKey);
};
/**
 * Merge icons.
 *
 * @param unmerged A list of conditional transition icons that may contain duplicate icons.
 * @returns A merged list of icons with only one entry per icon type.
 */ const $b6d2eb4129e1d7ff$var$mergeIcons = (unmerged)=>{
    // Take each icon and use its key as an index to a Map. Add each of its fromStatuses entries
    // to a Set to remove duplicates.
    const mergedMap = unmerged.reduce((iconMap, { type: type, fromStatuses: fromStatuses })=>{
        // If this icon key isn't in the Map yet, add it along with an empty set as the value.
        if (!iconMap.has(type)) iconMap.set(type, new Set());
        // Add each of the fromStatuses entries to the set.
        fromStatuses?.forEach((statusId)=>iconMap.get(type)?.add(statusId));
        // Return the Map we just updated.
        return iconMap;
    }, new Map());
    // Convert the map back to an array of ConditionalTransitionIcon objects.
    return [
        ...mergedMap.entries()
    ].map(([type, fromStatuses])=>({
            type: type,
            ...fromStatuses.size > 0 ? {
                fromStatuses: [
                    ...fromStatuses.values()
                ]
            } : {}
        }));
};
const $b6d2eb4129e1d7ff$export$dda2237b70238711 = (startNodeLayout)=>!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(startNodeLayout.x) && !(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(startNodeLayout.y) ? {
        x: startNodeLayout.x,
        y: startNodeLayout.y
    } : undefined;
const $b6d2eb4129e1d7ff$export$38d5df80e5fbbe05 = (globalLoopsContainerLayout)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(globalLoopsContainerLayout)) return undefined;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(globalLoopsContainerLayout.x) || (0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(globalLoopsContainerLayout.y)) return undefined;
    return (0, $k9d6y.toPoint)(globalLoopsContainerLayout.x, globalLoopsContainerLayout.y);
};
const $b6d2eb4129e1d7ff$export$a68083484778dd7f = (statuses, /**
	 * Make this a required prop when clean up sprt_hix_9246_wfe_diagram_complete_workflowscope
	 */ workflowScope, initialStatusId, errors)=>statuses.map((status)=>{
        const diagramStatus = {
            id: status.id,
            label: status.name,
            flag: $b6d2eb4129e1d7ff$var$getStatusValidationFlag(status, errors),
            position: status.layout,
            category: status.statusCategory,
            isInitial: status.id === initialStatusId,
            showGlobalScopeIndicator: workflowScope === (0, $1DCdt.SCOPE_PROJECT) && status.scope === (0, $1DCdt.SCOPE_GLOBAL)
        };
        return diagramStatus;
    });
const $b6d2eb4129e1d7ff$var$getStatusValidationFlag = (status, errors = {})=>{
    const statusErrors = errors?.[status.id]?.filter((e)=>e.node === 'STATUS') || [];
    if (!statusErrors.length) return undefined;
    return statusErrors.some((error)=>error.severity === (0, $1DCdt.errorSeverity).ERROR) ? (0, $k9d6y.ValidationFlag).Error : (0, $k9d6y.ValidationFlag).Warn;
};
const $b6d2eb4129e1d7ff$var$getTransitionValidationFlag = (transition, errors = {})=>{
    const transitionsErrors = (errors[transition.id]?.filter((e)=>e.node === 'TRANSITION') || []).concat(...transition.rules.filter((rule)=>!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(errors[rule.id])).map((rule)=>errors[rule.id]));
    if (transitionsErrors.length) return transitionsErrors.some((error)=>error.severity === (0, $1DCdt.errorSeverity).ERROR) ? (0, $k9d6y.ValidationFlag).Error : (0, $k9d6y.ValidationFlag).Warn;
};
/**
 * To Diagram Transition Icons.
 *
 * Determine what icons should display on the transition label. Transition icons display under the
 * following conditions:
 *
 * | Icon                           | Reason                                |
 * | -------------------------------|---------------------------------------|
 * | **Error**                      | if there is an error or warning flag. |
 * | **Tick/Cross**                 | for an active approval                |
 * | **TickInactive/CrossInactive** | for an inactive approval              |
 * | **Bolt**                       | for any other transition rules        |
 * @param transition The transition.
 * @param availableRules A list of known rules that we consider valid.
 * @param flag Are there any warnings or errors on this transition?
 * @param statuses A list of statuses used in the Workflow (needed to look up approval
 *                 configuration)
 * @returns A list of icons to display on this transition label.
 */ const $b6d2eb4129e1d7ff$var$toDiagramTransitionIcons = (transition, flag, statuses)=>{
    const errorIcons = flag ? [
        {
            type: (0, $k9d6y.TransitionIcons).Error
        }
    ] : [];
    const approvalIcons = transition.rules.filter($b6d2eb4129e1d7ff$var$isAnApprovalRule).flatMap($b6d2eb4129e1d7ff$var$getApprovalIcons(statuses, transition));
    const agentIcons = transition.rules.some($b6d2eb4129e1d7ff$var$isAnAgentRule) ? [
        {
            type: (0, $k9d6y.TransitionIcons).TriggerAgent
        }
    ] : [];
    // If the fg is on, we want to show the bolt icon for any rule that is not an
    // approval or agent rule
    const isNotAnApprovalRule = (0, (/*@__PURE__*/$parcel$interopDefault($iNSkg)))($b6d2eb4129e1d7ff$var$isAnApprovalRule);
    const isNotAnAgentRule = (0, (/*@__PURE__*/$parcel$interopDefault($iNSkg)))($b6d2eb4129e1d7ff$var$isAnAgentRule);
    const negateRules = (rule)=>isNotAnApprovalRule(rule) && isNotAnAgentRule(rule);
    const otherIcons = transition.rules.some(negateRules) ? [
        {
            type: (0, $k9d6y.TransitionIcons).Bolt
        }
    ] : [];
    return $b6d2eb4129e1d7ff$var$mergeIcons([
        ...errorIcons,
        ...otherIcons,
        ...approvalIcons,
        ...agentIcons
    ]);
};
const $b6d2eb4129e1d7ff$export$5c6df39babffa5d6 = (transitions, errors = {}, statuses = [])=>transitions.filter((transition)=>{
        return transition.type !== (0, $1DCdt.transitionType).DIRECTED || transition.links.length > 0;
    }).map((transition)=>{
        const { id: id, type: type, links: links, name: name, toRef: toRef } = transition;
        const flag = $b6d2eb4129e1d7ff$var$getTransitionValidationFlag(transition, errors);
        const icons = $b6d2eb4129e1d7ff$var$toDiagramTransitionIcons(transition, flag, statuses);
        if (toRef == null) {
            const globalLoopedTransition = {
                id: id,
                type: 'global-looped',
                flag: flag,
                icons: icons,
                label: name
            };
            return globalLoopedTransition;
        }
        if (type === (0, $1DCdt.transitionType).GLOBAL) {
            const globalTransition = {
                id: id,
                type: 'global',
                label: name,
                flag: flag,
                icons: icons,
                target: toRef
            };
            return globalTransition;
        }
        if (links.length > 1) {
            const sharedTransition = {
                id: id,
                type: 'shared',
                label: name,
                flag: flag,
                icons: icons,
                target: toRef,
                links: links.map((link)=>({
                        source: link.fromRef,
                        sourceIndex: link.fromPort,
                        targetIndex: link.toPort
                    }))
            };
            return sharedTransition;
        }
        const directTransition = {
            id: id,
            type: 'direct',
            label: name,
            flag: flag,
            icons: icons,
            target: toRef,
            targetIndex: links[0].toPort,
            source: links[0].fromRef,
            sourceIndex: links[0].fromPort
        };
        return directTransition;
    });
const $b6d2eb4129e1d7ff$export$49150f61646e15b7 = (transition)=>{
    if (transition.type === 'shared') return {
        toRef: transition.target,
        links: transition.links.map((link)=>({
                fromRef: link.source,
                fromPort: link.sourceIndex,
                toPort: link.targetIndex
            }))
    };
    if (transition.type === 'direct') return {
        toRef: transition.target,
        links: [
            {
                fromRef: transition.source,
                fromPort: transition.sourceIndex,
                toPort: transition.targetIndex
            }
        ]
    };
    if (transition.type === 'global-looped') return {
        links: []
    };
    return {
        toRef: transition.target,
        links: []
    };
};

});



parcelRegister("DIqjH", function(module, exports) {
$parcel$export(module.exports, "JiraModal", () => $ec9c8252741dc248$export$3782fcca1f68992e);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $7tY81 = parcelRequire("7tY81");

var $gu6Rp = parcelRequire("gu6Rp");

var $7Odw0 = parcelRequire("7Odw0");

var $33qBb = parcelRequire("33qBb");
const $ec9c8252741dc248$export$3782fcca1f68992e = (props)=>{
    if ((0, $gu6Rp.shouldBeChoreographed)(props)) {
        if ((0, $7Odw0.isSupportedUserAgent)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $33qBb.ChoreographerModal), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7tY81.default), rest);
};
$ec9c8252741dc248$export$3782fcca1f68992e.displayName = "JiraModal";
$ec9c8252741dc248$export$3782fcca1f68992e.displayName = 'JiraModal';

});
parcelRegister("gu6Rp", function(module, exports) {
$parcel$export(module.exports, "shouldBeChoreographed", () => $af37ef6e011470be$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "environmentToEnvType", () => $af37ef6e011470be$export$e2cf19200849be9e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hIipg = parcelRequire("hIipg");

var $aAuB6 = parcelRequire("aAuB6");
function $af37ef6e011470be$export$a8ba9111c7eec9ac(props) {
    return (0, $aAuB6.shouldBeChoreographed)(props);
}
function $af37ef6e011470be$export$e2cf19200849be9e(environment) {
    switch(environment){
        case 'dev':
            return (0, $hIipg.envType).DEV;
        case 'staging':
            return (0, $hIipg.envType).STAGING;
        case 'prod':
            return (0, $hIipg.envType).PROD;
        default:
            return (0, $hIipg.envType).LOCAL;
    }
}

});
parcelRegister("aAuB6", function(module, exports) {
$parcel$export(module.exports, "getPendoPlugin", () => $d8d1a80215906590$export$3d3a86b2d636214b);
$parcel$export(module.exports, "useChoreographer", () => $d8d1a80215906590$export$9f0e2488ffd90f11);
$parcel$export(module.exports, "shouldBeChoreographed", () => $d8d1a80215906590$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "withChoreographedToggle", () => $d8d1a80215906590$export$a646002207b915ac);
$parcel$export(module.exports, "useChoreographedRender", () => $d8d1a80215906590$export$2cfd68294be82811);
$parcel$export(module.exports, "useDisableInAppMessagesForIframe", () => $d8d1a80215906590$export$a60a99a250d6a89c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $5EbfN = parcelRequire("5EbfN");

var $ilQ8n = parcelRequire("ilQ8n");
var $8ndFS = parcelRequire("8ndFS");
var $kNBjd = parcelRequire("kNBjd");
var $4KFYC = parcelRequire("4KFYC");

var $i860n = parcelRequire("i860n");

var $6bEm8 = parcelRequire("6bEm8");

var $1or3J = parcelRequire("1or3J");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $d8d1a80215906590$var$environment = (0, $5EbfN.toEnvironment)((0, $6bEm8.default)('ajs-environment')) ?? 'prod';
const $d8d1a80215906590$var$createChoreographerFactory = ()=>{
    if (false) return {
        useChoreographer: (..._)=>({
                startMessage: ()=>Promise.resolve((0, $kNBjd.MessageDeliveryStatus).STARTED),
                stopMessage: ()=>Promise.resolve((0, $kNBjd.MessageDeliveryStatus).STOPPED),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                toggleMessage: ()=>Promise.resolve('')
            }),
        withChoreographedToggle: (Component)=>Component,
        shouldBeChoreographed: (_props)=>false
    };
    return (0, $8ndFS.choreographerFactory)((0, $kNBjd.ProductIds).JIRA, $d8d1a80215906590$var$environment);
};
let $d8d1a80215906590$var$pendoPlugin;
function $d8d1a80215906590$export$3d3a86b2d636214b(env) {
    if (!$d8d1a80215906590$var$pendoPlugin) $d8d1a80215906590$var$pendoPlugin = new (0, $4KFYC.PendoChoreographerPlugin)(env, {
        sourceProductId: (0, $kNBjd.ProductIds).JIRA
    });
    return $d8d1a80215906590$var$pendoPlugin;
}
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ const $d8d1a80215906590$var$dest = $d8d1a80215906590$var$createChoreographerFactory();
const $d8d1a80215906590$export$9f0e2488ffd90f11 = $d8d1a80215906590$var$dest.useChoreographer;
const $d8d1a80215906590$var$withChoreographedToggleFromFactory = $d8d1a80215906590$var$dest.withChoreographedToggle;
const $d8d1a80215906590$export$a8ba9111c7eec9ac = $d8d1a80215906590$var$dest.shouldBeChoreographed;
const $d8d1a80215906590$export$a646002207b915ac = (Component, toggleableProp, toggleableContentProp)=>{
    const WithChoreographedToggleComponent = (props)=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $1or3J.useChoreographedStatusContext)();
        const ChoreographedComponent = (0, $euxye.useMemo)(()=>$d8d1a80215906590$var$withChoreographedToggleFromFactory(Component, toggleableProp), []);
        if (isAlreadyChoreographedAtAncestor || !(0, $i860n.fg)('jira_with_choreographed_toggle_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, props);
        const propsWithContextProviderWrapper = {
            ...props
        };
        if (toggleableContentProp) {
            const { [toggleableContentProp]: toggleableContentPropValue } = propsWithContextProviderWrapper;
            if (typeof toggleableContentPropValue === 'function') // @ts-expect-error TS doesn't know this is a callback with variable params that returns ReactNode, but we do
            propsWithContextProviderWrapper[toggleableContentProp] = (...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1or3J.ChoreographerContextProvider), {
                    isChoreographed: true
                }, toggleableContentPropValue(...args));
            else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const content = toggleableContentPropValue;
                // @ts-expect-error TS doesn't know this is a ReactNode, but we do
                propsWithContextProviderWrapper[toggleableContentProp] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1or3J.ChoreographerContextProvider), {
                    isChoreographed: true
                }, content);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ChoreographedComponent, propsWithContextProviderWrapper);
    };
    WithChoreographedToggleComponent.displayName = `WithChoreographedToggle(${Component.displayName ?? Component.name ?? 'Component'})`;
    return WithChoreographedToggleComponent;
};
const $d8d1a80215906590$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $1or3J.useChoreographedStatusContext)();
    const [shouldRender, setShouldRender] = (0, $euxye.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $d8d1a80215906590$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $euxye.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};
const $d8d1a80215906590$export$a60a99a250d6a89c = ()=>{
    const cleanup = (0, $euxye.useRef)();
    const disabled = (0, $euxye.useRef)(false);
    if (!disabled.current) {
        cleanup.current = (0, $ilQ8n.Choreographer).getInstance().disableChoreographerForIframe();
        disabled.current = true;
    }
    (0, $euxye.useEffect)(()=>()=>cleanup.current?.(), []);
};

});
parcelRegister("1or3J", function(module, exports) {
$parcel$export(module.exports, "ChoreographerContextProvider", () => $5fa71657b34b0a57$export$c3226151caaf2fbf);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $5fa71657b34b0a57$export$2eb1efa814fe4a);

var $euxye = parcelRequire("euxye");
const $5fa71657b34b0a57$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $5fa71657b34b0a57$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $5fa71657b34b0a57$export$2eb1efa814fe4a();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5fa71657b34b0a57$export$3ff96dbefca6b00d.Provider, {
        value: $5fa71657b34b0a57$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children);
};
$5fa71657b34b0a57$export$c3226151caaf2fbf.displayName = "ChoreographerContextProvider";
const $5fa71657b34b0a57$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $euxye.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $5fa71657b34b0a57$export$2eb1efa814fe4a = ()=>(0, $euxye.useContext)($5fa71657b34b0a57$export$3ff96dbefca6b00d);

});



parcelRegister("33qBb", function(module, exports) {
$parcel$export(module.exports, "ChoreographerModal", () => $08690ae685adb2be$export$3f5d627caa6fc630);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line @typescript-eslint/no-restricted-imports

var $7tY81 = parcelRequire("7tY81");

var $l6b8t = parcelRequire("l6b8t");
const $08690ae685adb2be$export$3f5d627caa6fc630 = (0, $l6b8t.withChoreographedRender)((0, $7tY81.default));

});
parcelRegister("l6b8t", function(module, exports) {
$parcel$export(module.exports, "withChoreographedRender", () => $ed662011ea2e0ae7$export$c1160fdac17030e);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $1or3J = parcelRequire("1or3J");

var $aAuB6 = parcelRequire("aAuB6");
function $ed662011ea2e0ae7$export$c1160fdac17030e(Component) {
    function ChoreographedComponent(props) {
        const { messageId: messageId, onMessageDisposition: onMessageDisposition } = props;
        const shouldRender = (0, $aAuB6.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1or3J.ChoreographerContextProvider), {
            isChoreographed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, props));
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    function WithChoreographedRenderComponent(props) {
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $1or3J.useChoreographedStatusContext)();
        if (isAlreadyChoreographedAtAncestor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(ChoreographedComponent, props);
    }
    WithChoreographedRenderComponent.displayName = `WithChoreographedRender${Component.displayName ?? 'Component'}`;
    return WithChoreographedRenderComponent;
}

});



/* eslint-disable jira/filename-case */ // We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// These variables are inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $8d2c01fb745e4772$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT = 'var(--bannerHeight, 0px)';
const $8d2c01fb745e4772$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT = 'var(--topNavigationHeight, 0px)';
const $8d2c01fb745e4772$export$638757b621fbf475 = `${$8d2c01fb745e4772$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT} + ${$8d2c01fb745e4772$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT}`;
const $8d2c01fb745e4772$export$d60454526e2281af = `(${$8d2c01fb745e4772$export$638757b621fbf475})`;

parcelRegister("ccsIE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c36919487905f41d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $c36919487905f41d$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("YizKh")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("gkkMX")))));
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $gboXr = parcelRequire("gboXr");

var $gkkMX = parcelRequire("gkkMX");

var $YizKh = parcelRequire("YizKh");
const $c36919487905f41d$var$Illustration = (0, $gboXr.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($YizKh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gkkMX))
});
var $c36919487905f41d$export$2e2bcd8739ae039 = $c36919487905f41d$var$Illustration;
// for advanced use only
const $c36919487905f41d$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("gboXr", function(module, exports) {
$parcel$export(module.exports, "Illustration", () => $fb47eccb8a624dcd$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $fb47eccb8a624dcd$export$4d00e7be716a0093);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $2Puum = parcelRequire("2Puum");
function $fb47eccb8a624dcd$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2Puum.AsImg), props);
}
$fb47eccb8a624dcd$export$d43c2e2ca9b2c105.displayName = "Illustration";
function $fb47eccb8a624dcd$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($fb47eccb8a624dcd$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("2Puum", function(module, exports) {
$parcel$export(module.exports, "AsImg", () => $5b9c62be954f5950$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/naming/disallow-filenames */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $4C7HL = parcelRequire("4C7HL");
// Moved to src/packages/illustrations/illustration/src/ui/types.tsx to avoid circular dependency
// export interface AsImgProps extends IllustrationProps, ImgHTMLAttributes<HTMLImageElement>
// suggested defaults, the consumer is free to override
const $5b9c62be954f5950$var$defaultStyles = null;
const $5b9c62be954f5950$var$fillStyles = null;
const $5b9c62be954f5950$var$autoDarkModeStyles = null;
function $5b9c62be954f5950$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $4C7HL.default)();
    return /*#__PURE__*/ $euxye.createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $4jQY2.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}
$5b9c62be954f5950$export$75e378065cb7d6c0.displayName = "AsImg";

});


parcelRegister("gkkMX", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("YizKh", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("l8Dej", function(module, exports) {
$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $bbba4ff607b9e670$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
var $8w7Yz = parcelRequire("8w7Yz");

var $8Agip = parcelRequire("8Agip");
function $bbba4ff607b9e670$export$ebf64b9217c1b2a3(JiraIllustration = (0, $8Agip.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $8w7Yz.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $8w7Yz.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $4jQY2.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("8Agip", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6acedb2d5723b78$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3sUgu")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("kfedV")))));
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $gboXr = parcelRequire("gboXr");

var $kfedV = parcelRequire("kfedV");

var $3sUgu = parcelRequire("3sUgu");
const $a6acedb2d5723b78$var$Illustration = (0, $gboXr.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3sUgu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kfedV))
});
var $a6acedb2d5723b78$export$2e2bcd8739ae039 = $a6acedb2d5723b78$var$Illustration;
// for advanced use only
const $a6acedb2d5723b78$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("kfedV", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("3sUgu", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("aqPkH", function(module, exports) {
$parcel$export(module.exports, "FireUiAnalytics", () => $0aaea35909df1115$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $0aaea35909df1115$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $0aaea35909df1115$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $0aaea35909df1115$export$2ccf161b817b43b);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $kTviw = parcelRequire("kTviw");


var $aJ81Y = parcelRequire("aJ81Y");
// eslint-disable-next-line jira/react/no-class-components
class $0aaea35909df1115$var$FireComponent extends (0, $euxye.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $aJ81Y.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
$0aaea35909df1115$var$FireComponent.displayName = "FireComponent";
const $0aaea35909df1115$export$64eb47d7b94ba089 = (0, $kTviw.default)()($0aaea35909df1115$var$FireComponent);
const $0aaea35909df1115$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0aaea35909df1115$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $46f069e6c968f461$export$a1562d08625f5d7e)
    });
$0aaea35909df1115$export$5a67e7291fd4569e.displayName = "FireUiAnalytics";
const $0aaea35909df1115$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0aaea35909df1115$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $46f069e6c968f461$export$947dac6c72b26f81)
    });
$0aaea35909df1115$export$5f0d7aae8dfa8b86.displayName = "FireTrackAnalytics";
const $0aaea35909df1115$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0aaea35909df1115$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $46f069e6c968f461$export$12346a674644c156)
    });
$0aaea35909df1115$export$b71c3ada5d4ec5da.displayName = "FireOperationalAnalytics";
const $0aaea35909df1115$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($0aaea35909df1115$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $46f069e6c968f461$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });
$0aaea35909df1115$export$2ccf161b817b43b.displayName = "FireScreenAnalytics";

});

parcelRegister("ioPOL", function(module, exports) {
$parcel$export(module.exports, "ZoomControls", () => $a8c4f6eb53e0800b$export$782627f418f61db3);

var $euxye = parcelRequire("euxye");

var $c69sa = parcelRequire("c69sa");
var $fbAgj = parcelRequire("fbAgj");

var $4qNCE = parcelRequire("4qNCE");

var $c02KP = parcelRequire("c02KP");

var $fgo5I = parcelRequire("fgo5I");

var $1o59u = parcelRequire("1o59u");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");

var $hrM6x = parcelRequire("hrM6x");
const $a8c4f6eb53e0800b$var$zoomIn = (0, $7eNDO.defineMessage)({
    id: "workflow-view-diagram-modal.zoom-controls.zoom-in",
    defaultMessage: "Zoom in"
});
const $a8c4f6eb53e0800b$var$zoomOut = (0, $7eNDO.defineMessage)({
    id: "workflow-view-diagram-modal.zoom-controls.zoom-out",
    defaultMessage: "Zoom out"
});
const $a8c4f6eb53e0800b$var$zoomSlider = (0, $7eNDO.defineMessage)({
    id: "workflow-view-diagram-modal.zoom-controls.zoom-slider",
    defaultMessage: "Zoom level"
});
const $a8c4f6eb53e0800b$export$782627f418f61db3 = ({ onZoomChange: onZoomChange, zoom: zoom, minimumLinearZoom: minimumLinearZoom = (0, $hrM6x.MINIMUM_LINEAR_ZOOM), maximumLinearZoom: maximumLinearZoom = (0, $hrM6x.MAXIMUM_LINEAR_ZOOM) })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const changeZoom = (0, $euxye.useCallback)((linearZoom)=>{
        const snappedLinearZoom = (0, $hrM6x.snapLinearZoom)(linearZoom, minimumLinearZoom, maximumLinearZoom);
        const exponentialZoom = (0, $hrM6x.getExponentialZoom)(snappedLinearZoom);
        onZoomChange(exponentialZoom);
    }, [
        onZoomChange,
        minimumLinearZoom,
        maximumLinearZoom
    ]);
    const onZoomIn = (0, $euxye.useCallback)((e, analyticsEvent)=>{
        const linearZoom = (0, $hrM6x.getLinearZoom)(zoom) + (0, $hrM6x.LINEAR_ZOOM_STEP);
        changeZoom(linearZoom);
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'zoomIn');
    }, [
        changeZoom,
        zoom
    ]);
    const onZoomOut = (0, $euxye.useCallback)((e, analyticsEvent)=>{
        const linearZoom = (0, $hrM6x.getLinearZoom)(zoom) - (0, $hrM6x.LINEAR_ZOOM_STEP);
        changeZoom(linearZoom);
        (0, $aJ81Y.fireUIAnalytics)(analyticsEvent, 'zoomOut');
    }, [
        changeZoom,
        zoom
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $a8c4f6eb53e0800b$var$zoomControlContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $a8c4f6eb53e0800b$var$zoomControlsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
        isDisabled: (0, $hrM6x.isMinimumZoom)((0, $hrM6x.getLinearZoom)(zoom), minimumLinearZoom),
        testId: "workflow-view-diagram-modal.zoom-out-button",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgo5I))), {
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)",
            label: ""
        }),
        onClick: onZoomOut,
        "aria-label": formatMessage($a8c4f6eb53e0800b$var$zoomOut),
        interactionName: "auto-generated.workflow-readonly-modal.ui.diagram.zoom-out-button.button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1o59u.default), {
        min: minimumLinearZoom,
        max: maximumLinearZoom,
        step: (0, $hrM6x.LINEAR_ZOOM_STEP),
        value: (0, $hrM6x.getLinearZoom)(zoom),
        onChange: changeZoom,
        "aria-label": formatMessage($a8c4f6eb53e0800b$var$zoomSlider)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
        testId: "workflow-view-diagram-modal.zoom-in-button",
        isDisabled: (0, $hrM6x.isMaximumZoom)((0, $hrM6x.getLinearZoom)(zoom), maximumLinearZoom),
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c02KP))), {
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)",
            label: ""
        }),
        onClick: onZoomIn,
        "aria-label": formatMessage($a8c4f6eb53e0800b$var$zoomIn),
        interactionName: "auto-generated.workflow-readonly-modal.ui.diagram.zoom-in-button.button1"
    })));
};
$a8c4f6eb53e0800b$export$782627f418f61db3.displayName = "ZoomControls";
const $a8c4f6eb53e0800b$var$zoomControlContainerStyles = (0, $fbAgj.xcss)({
    position: 'relative'
});
const $a8c4f6eb53e0800b$var$zoomControlsStyles = (0, $fbAgj.xcss)({
    position: 'absolute',
    bottom: 'space.100',
    right: 'space.100',
    width: '200px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'color.background.neutral',
    height: '40px',
    justifyContent: 'space-evenly',
    paddingTop: 'space.0',
    paddingRight: 'space.050',
    paddingBottom: 'space.0',
    paddingLeft: 'space.050'
});

});
parcelRegister("c02KP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9c8ff141bb3ac6f3d3c142a83802bd7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bc79f1725ff8e7f$var$_react = $8bc79f1725ff8e7f$var$_interopRequireDefault((parcelRequire("euxye")));

var $8bc79f1725ff8e7f$var$_baseNew = $8bc79f1725ff8e7f$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $8bc79f1725ff8e7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ZoomIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming in of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bc79f1725ff8e7f$var$ZoomInIcon = (props)=>/*#__PURE__*/ $8bc79f1725ff8e7f$var$_react.default.createElement($8bc79f1725ff8e7f$var$_baseNew.default, Object.assign({
        name: "ZoomInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7m5.25.75V10h1.5V7.75H10v-1.5H7.75V4h-1.5v2.25H4v1.5z" clip-rule="evenodd"/>`
    }, props));
$8bc79f1725ff8e7f$var$ZoomInIcon.displayName = 'ZoomInIcon';
var $8bc79f1725ff8e7f$var$_default = module.exports.default = $8bc79f1725ff8e7f$var$ZoomInIcon;

});

parcelRegister("fgo5I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::38d4bb9285a504664d94867606cdaddc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1cb09a7cc33b03e$var$_react = $b1cb09a7cc33b03e$var$_interopRequireDefault((parcelRequire("euxye")));

var $b1cb09a7cc33b03e$var$_baseNew = $b1cb09a7cc33b03e$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $b1cb09a7cc33b03e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ZoomOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming out of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1cb09a7cc33b03e$var$ZoomOutIcon = (props)=>/*#__PURE__*/ $b1cb09a7cc33b03e$var$_react.default.createElement($b1cb09a7cc33b03e$var$_baseNew.default, Object.assign({
        name: "ZoomOutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7m9 .75H4v-1.5h6z" clip-rule="evenodd"/>`
    }, props));
$b1cb09a7cc33b03e$var$ZoomOutIcon.displayName = 'ZoomOutIcon';
var $b1cb09a7cc33b03e$var$_default = module.exports.default = $b1cb09a7cc33b03e$var$ZoomOutIcon;

});

parcelRegister("1o59u", function(module, exports) {
$parcel$export(module.exports, "default", () => $662771d6b4da114d$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");

var $E1ntg = parcelRequire("E1ntg");
const $662771d6b4da114d$var$snapToStep = (value, min, step)=>{
    // Normalise the value to allow for division properly with different min values
    const adjustedValue = value - min;
    // Find the number of steps the value covers
    const numSteps = Math.round(adjustedValue / step);
    // Convert numSteps back into original range
    return numSteps * step + min;
};
const $662771d6b4da114d$var$getRoundedPercentValue = (value, min, max, step)=>{
    let percent = '0';
    if (min < max && value > min) {
        const snappedValue = $662771d6b4da114d$var$snapToStep(value, min, step);
        percent = ((snappedValue - min) / (max - min) * 100).toFixed(2);
    }
    return percent;
};
const $662771d6b4da114d$var$noop = (0, $2oRWW.default);
/**
 * __Range__
 *
 * A range lets users choose an approximate value on a slider.
 *
 * - [Examples](https://atlassian.design/components/range/examples)
 * - [Code](https://atlassian.design/components/range/code)
 * - [Usage](https://atlassian.design/components/range/usage)
 */ const $662771d6b4da114d$var$Range = /*#__PURE__*/ (0, $euxye.forwardRef)(function Range(props, ref) {
    const { isDisabled: isDisabled = false, defaultValue: defaultValue = 50, max: max = 100, min: min = 0, onChange: onChange = $662771d6b4da114d$var$noop, step: step = 1, value: propsValue, testId: testId, ...rest } = props;
    const spreadProps = {
        max: max,
        min: min,
        step: step,
        ref: ref,
        ...rest
    };
    const [value, setValue] = (0, $euxye.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const handleChange = (0, $euxye.useCallback)((e)=>{
        const newValue = Number(e.target.value);
        setValue(newValue);
        // Note use of newValue to ensure up=to-date value is used
        onChange(newValue);
    }, [
        onChange
    ]);
    const renderValue = propsValue !== undefined ? propsValue : value;
    const valuePercent = $662771d6b4da114d$var$getRoundedPercentValue(renderValue, min, max, step);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $E1ntg.Input), {
        type: "range",
        disabled: isDisabled,
        onChange: handleChange,
        value: renderValue,
        valuePercent: valuePercent,
        "data-testid": testId,
        ...spreadProps
    });
});
var $662771d6b4da114d$export$2e2bcd8739ae039 = $662771d6b4da114d$var$Range;

});
parcelRegister("E1ntg", function(module, exports) {
$parcel$export(module.exports, "Input", () => $8837d63733517b0b$export$f5b8910cec6cf069);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $egspI = parcelRequire("egspI");
const $8837d63733517b0b$var$rangeHeight = 40; // Height of the range input, used for the track and thumb
const $8837d63733517b0b$var$trackHeight = 6; // Height of the track, used for the track and thumb
const $8837d63733517b0b$var$thumbSize = "var(--ds-space-200, 16px)"; // Size of the thumb, used for the thumb styles
// Styles are split up to avoid edge-cases with TS implementations between `css` and `cssMap` with some
// of these edge-case pseudo-selectors.
// Previously, in Emotion, these selectors weren't consolidated, eg. `&::webkit-thumb, &::moz-thumb`
// would not be parsed by either browser, but this may no longer be the case in Compiled
const $8837d63733517b0b$var$webkitStyles = null;
const $8837d63733517b0b$var$firefoxStyles = null;
const $8837d63733517b0b$var$baseStyles = null;
const $8837d63733517b0b$var$themeStyles = null;
const $8837d63733517b0b$var$trackStyles = {
    root: "_1bsb1osq _4t3i1ylp _kqswh2mm _14mj1qll _1ywu1ule _z0ai1y44 _1qdg1y44 _18postnw _1hfkof27 _aetrb3bt _19nq1ssb _g0nfo1yi",
    disabled: "_1peq2wxo"
};
const $8837d63733517b0b$var$rangeA11yStyles = null;
const $8837d63733517b0b$var$stylesT26Shape = null;
const $8837d63733517b0b$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $euxye.forwardRef)((props, ref)=>{
    const { valuePercent: valuePercent, style: style, ...strippedProps } = props;
    const input = /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
        ...strippedProps,
        style: {
            // We are creating a css variable to control the "progress" portion of the range input
            // This avoids us needing to create a new css class for each new percentage value
            '--track-fg-width': `${valuePercent}%`
        },
        ref: ref,
        className: (0, $4jQY2.default)([
            "_1bsb1osq _4t3i1ylp _bfhk18uv _j5dh13gf _1j552wxo _nt751r31 _49pcglyw _1hvw1o36",
            "_wstuglyw _h2ksglyw _1kdl1qll _m8f8bpmo _1yz62hjt _1bdkusvi _u98zpxbi _1j70pxbi _1esf1w0t _4w431ik2 _yfyntlke _1sdc196n _18k7v77o _1cdcglyw _10lridpf _g6tdlb4i _vi4t2hjt _1g2h1osq _168l1y44 _9u3f2hce _1g741hsc _1d8tmgnk _np53xlkz _18tdtlke _1p201osq _1yte13gf _5i7a13gf",
            "_1yq0glyw _108m1qll _1rf3bpmo _1yeu2hjt _g4ppusvi _r763pxbi _1mn5pxbi _12el1w0t _1oqe1ik2 _10o7tlke _1kzev77o _15raidpf _e8hnidpf _37ywlb4i _1tcb2hjt _aoww1osq _1kd2i2wt _vt2s1w6o _1ssqtlke _ru37idpf _1gvolb4i _1nx42hjt _1f5t1osq _142y1y44 _d7w62hce _b3fmtlke _1vq313gf _1fov13gf _34m613gf",
            "_14h11km6 _15dpi8nm _18lx1aqn _jxar1ibz _ydqgplhp _1jhc1ibz _1rucof27 _164c1v1w",
            "_1drqof27 _15dp1vck _18lxof27 _g6tdfajl _168li2wt _37ywfajl _1kd2i2wt _1sdc1lpd _ydqgmpja",
            (0, $egspI.fg)('platform-dst-shape-theme-default') && "_g6td1rr0 _37yw1rr0 _1gvo1rr0"
        ])
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $8837d63733517b0b$var$trackStyles.root,
            strippedProps.disabled && $8837d63733517b0b$var$trackStyles.disabled
        ]),
        children: input
    });
});
$8837d63733517b0b$export$f5b8910cec6cf069.displayName = 'InputRange';

});


parcelRegister("hrM6x", function(module, exports) {
$parcel$export(module.exports, "LOGRAITHMIC_ZOOM_BASE", () => $efe9ad69dd123137$export$e861c8011f7fb97a);
$parcel$export(module.exports, "LINEAR_ZOOM_STEP", () => $efe9ad69dd123137$export$242961008b66e9eb);
$parcel$export(module.exports, "MAXIMUM_LINEAR_ZOOM", () => $efe9ad69dd123137$export$a03183ee488d90a1);
$parcel$export(module.exports, "MINIMUM_LINEAR_ZOOM", () => $efe9ad69dd123137$export$7a22dde642b71bba);
$parcel$export(module.exports, "getLinearZoom", () => $efe9ad69dd123137$export$92ad4ab75b1348d7);
$parcel$export(module.exports, "getExponentialZoom", () => $efe9ad69dd123137$export$1c090fe1906100fd);
$parcel$export(module.exports, "snapLinearZoom", () => $efe9ad69dd123137$export$6524a314bde1d4c);
$parcel$export(module.exports, "isMinimumZoom", () => $efe9ad69dd123137$export$5927d9e97896a612);
$parcel$export(module.exports, "isMaximumZoom", () => $efe9ad69dd123137$export$57b05d706f3e3c4b);

var $6wkxp = parcelRequire("6wkxp");
const $efe9ad69dd123137$var$EXPONENTIAL_ZOOM_BASE = 2;
const $efe9ad69dd123137$export$e861c8011f7fb97a = Math.log(2);
const $efe9ad69dd123137$export$242961008b66e9eb = 0.1;
const $efe9ad69dd123137$export$a03183ee488d90a1 = 1;
const $efe9ad69dd123137$export$7a22dde642b71bba = -1;
const $efe9ad69dd123137$var$ZOOM_COMPARISON_PRECISION = 5;
const $efe9ad69dd123137$export$92ad4ab75b1348d7 = (exponentialZoom)=>Math.log(exponentialZoom) / $efe9ad69dd123137$export$e861c8011f7fb97a;
const $efe9ad69dd123137$export$1c090fe1906100fd = (linearZoom)=>$efe9ad69dd123137$var$EXPONENTIAL_ZOOM_BASE ** linearZoom;
const $efe9ad69dd123137$export$6524a314bde1d4c = (linearZoom, minimumLinearZoom, maximumLinearZoom)=>{
    const snappedZoom = (0, (/*@__PURE__*/$parcel$interopDefault($6wkxp)))(linearZoom, $efe9ad69dd123137$var$ZOOM_COMPARISON_PRECISION);
    // Snap to max if very close (handles non-aligned step boundaries)
    if (Math.abs(snappedZoom - maximumLinearZoom) < $efe9ad69dd123137$export$242961008b66e9eb / 2) return maximumLinearZoom;
    // Snap to min if very close
    if (Math.abs(snappedZoom - minimumLinearZoom) < $efe9ad69dd123137$export$242961008b66e9eb / 2) return minimumLinearZoom;
    return snappedZoom;
};
const $efe9ad69dd123137$export$5927d9e97896a612 = (linearZoom, minimumLinearZoom)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($6wkxp)))(linearZoom, $efe9ad69dd123137$var$ZOOM_COMPARISON_PRECISION) <= (0, (/*@__PURE__*/$parcel$interopDefault($6wkxp)))(minimumLinearZoom, $efe9ad69dd123137$var$ZOOM_COMPARISON_PRECISION);
};
const $efe9ad69dd123137$export$57b05d706f3e3c4b = (linearZoom, maximumLinearZoom)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($6wkxp)))(linearZoom, $efe9ad69dd123137$var$ZOOM_COMPARISON_PRECISION) >= (0, (/*@__PURE__*/$parcel$interopDefault($6wkxp)))(maximumLinearZoom, $efe9ad69dd123137$var$ZOOM_COMPARISON_PRECISION);
};

});
parcelRegister("6wkxp", function(module, exports) {

var $8aEkm = parcelRequire("8aEkm");
/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */ var $4bf5a99ee499f2aa$var$round = $8aEkm('round');
module.exports = $4bf5a99ee499f2aa$var$round;

});
parcelRegister("8aEkm", function(module, exports) {

var $eqXyn = parcelRequire("eqXyn");

var $4NLnC = parcelRequire("4NLnC");

var $2LC8B = parcelRequire("2LC8B");

var $lyiHY = parcelRequire("lyiHY");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5f2e8a1282dcc45c$var$nativeIsFinite = $eqXyn.isFinite, $5f2e8a1282dcc45c$var$nativeMin = Math.min;
/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */ function $5f2e8a1282dcc45c$var$createRound(methodName) {
    var func = Math[methodName];
    return function(number, precision) {
        number = $2LC8B(number);
        precision = precision == null ? 0 : $5f2e8a1282dcc45c$var$nativeMin($4NLnC(precision), 292);
        if (precision && $5f2e8a1282dcc45c$var$nativeIsFinite(number)) {
            // Shift with exponential notation to avoid floating-point issues.
            // See [MDN](https://mdn.io/round#Examples) for more details.
            var pair = ($lyiHY(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
            pair = ($lyiHY(value) + 'e').split('e');
            return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
    };
}
module.exports = $5f2e8a1282dcc45c$var$createRound;

});




parcelRegister("6Yoad", function(module, exports) {
$parcel$export(module.exports, "useWorkflowData", () => $00f8f04fbce206ac$export$3f1d8b65dadd977d);

var $euxye = parcelRequire("euxye");

var $9ha7J = parcelRequire("9ha7J");

var $j93Pj = parcelRequire("j93Pj");

var $hFtK7 = parcelRequire("hFtK7");

var $fNgVF = parcelRequire("fNgVF");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $hYI7R = parcelRequire("hYI7R");

var $6CfY5 = parcelRequire("6CfY5");

var $75sVW = parcelRequire("75sVW");
const $00f8f04fbce206ac$var$noPermissionToViewThisWorkflow = (0, $7eNDO.defineMessage)({
    defaultMessage: "You do not have permission to view this workflow.",
    id: "workflow-view-diagram-modal.no-permission-to-view-this-workflow"
});
const $00f8f04fbce206ac$var$ERROR_LOGGER_PATTERN = '#workflow-view-diagram-modal#';
const $00f8f04fbce206ac$export$3f1d8b65dadd977d = (cloudId, workflowIdentifier, projectId)=>{
    const [state, setState] = (0, $euxye.useState)({
        data: undefined,
        isLoading: true,
        hasError: false,
        customErrorMessage: ''
    });
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    (0, $hYI7R.useEffectWithoutConcurrency)(()=>{
        const fetchWorkflow = async ()=>{
            setState((prev)=>({
                    ...prev,
                    isLoading: true,
                    hasError: false
                }));
            try {
                if (isAdmin) {
                    const workflowResponse = await (0, $9ha7J.default)(cloudId, workflowIdentifier);
                    setState({
                        data: workflowResponse,
                        isLoading: false,
                        hasError: false
                    });
                    return;
                }
                if (!projectId) {
                    (0, $hFtK7.fireErrorAnalytics)({
                        meta: {
                            id: `${$00f8f04fbce206ac$var$ERROR_LOGGER_PATTERN}.missing.project.id`,
                            packageName: 'jiraWorkflowViewDiagramModal',
                            teamName: 'helix'
                        },
                        error: new Error('Missing projectId for non-admin user')
                    });
                    setState((prev)=>({
                            ...prev,
                            hasError: true,
                            isLoading: false,
                            customErrorMessage: formatMessage($00f8f04fbce206ac$var$noPermissionToViewThisWorkflow)
                        }));
                    return;
                }
                const workflowResponse = await (0, $j93Pj.getReadViewWorkflow)({
                    cloudId: cloudId,
                    projectId: projectId,
                    ...workflowIdentifier
                });
                setState({
                    data: workflowResponse,
                    isLoading: false,
                    hasError: false
                });
            } catch (error) {
                if (error instanceof (0, $75sVW.default) && error.statusCode) (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$00f8f04fbce206ac$var$ERROR_LOGGER_PATTERN}.fetch.failure.${error.statusCode}`, error.message || 'Fetch failure with empty error message', error);
                else if (error instanceof TypeError) (0, $6CfY5.default).safeErrorWithoutCustomerData(`${$00f8f04fbce206ac$var$ERROR_LOGGER_PATTERN}.fetch.failure`, error.message, error);
                (0, $hFtK7.fireErrorAnalytics)({
                    meta: {
                        id: `${$00f8f04fbce206ac$var$ERROR_LOGGER_PATTERN}.fetch.error`,
                        packageName: 'jiraWorkflowViewDiagramModal',
                        teamName: 'helix'
                    },
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    error: error
                });
                setState((prev)=>({
                        ...prev,
                        hasError: true,
                        isLoading: false
                    }));
            }
        };
        fetchWorkflow();
    }, [
        cloudId,
        workflowIdentifier
    ]);
    return state;
};

});
parcelRegister("9ha7J", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b6244bd84c55025$export$2e2bcd8739ae039);

var $gkOMk = parcelRequire("gkOMk");

var $3gouG = parcelRequire("3gouG");
const $8b6244bd84c55025$var$getWorkflow = async (cloudId, workflowIdentifier, config)=>{
    const result = await (0, $gkOMk.getWorkflow)(cloudId, workflowIdentifier, config);
    return (0, $3gouG.transformAPIToMetaDocument)(result);
};
var $8b6244bd84c55025$export$2e2bcd8739ae039 = $8b6244bd84c55025$var$getWorkflow;

});
parcelRegister("gkOMk", function(module, exports) {
$parcel$export(module.exports, "getWorkflow", () => $e13598c9ba023b81$export$f927248b35ee72a7);

var $WqSvO = parcelRequire("WqSvO");

var $h2wCv = parcelRequire("h2wCv");
const $e13598c9ba023b81$export$c1b7f62a96ae605b = ()=>'gateway/api/jira/project-configuration';
const $e13598c9ba023b81$export$a5b7a8c3b1c6e775 = (cloudId)=>`/${$e13598c9ba023b81$export$c1b7f62a96ae605b()}/query/${cloudId}/3/workflow`;
const $e13598c9ba023b81$export$f927248b35ee72a7 = (cloudId, workflowIdentifier, config)=>{
    const url = $e13598c9ba023b81$export$a5b7a8c3b1c6e775(cloudId);
    const { workflowId: workflowId, workflowName: workflowName, projectAndIssueType: projectAndIssueType, projectKeyAndIssueType: projectKeyAndIssueType } = workflowIdentifier;
    const payload = {
        skipUsageLookup: false
    };
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(workflowId)) payload.workflowIds = [
        workflowId
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(workflowName)) payload.workflowNames = [
        workflowName
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(projectAndIssueType)) payload.projectAndIssueTypes = [
        projectAndIssueType
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($WqSvO)))(projectKeyAndIssueType)) payload.projectKeyAndIssueTypes = [
        projectKeyAndIssueType
    ];
    if (config?.checkForDrafts) payload.checkForDrafts = true;
    if (config?.getDrafts) payload.getDrafts = true;
    return (0, $h2wCv.performPostRequest)(url, {
        body: JSON.stringify(payload)
    });
};

});

parcelRegister("3gouG", function(module, exports) {
$parcel$export(module.exports, "transform", () => $8c8f388f20690f59$export$51186ad6e864892a);
$parcel$export(module.exports, "transformAPIToMetaDocument", () => $8c8f388f20690f59$export$d8b89067fc7ab9b2);

var $7TA2J = parcelRequire("7TA2J");


var $1DCdt = parcelRequire("1DCdt");

var $6CfY5 = parcelRequire("6CfY5");

var $3tDid = parcelRequire("3tDid");

var $bTi9g = parcelRequire("bTi9g");
const $8c8f388f20690f59$var$flattenConditionsRecursively = (conditionGroup)=>{
    if (!conditionGroup) return [];
    return conditionGroup.conditions.concat(conditionGroup.conditionGroups.flatMap($8c8f388f20690f59$var$flattenConditionsRecursively));
};
const $8c8f388f20690f59$var$transformConditionGroupRecursively = (conditionGroup)=>({
        id: (0, $7TA2J.v4)(),
        operation: conditionGroup.operation,
        conditionGroups: conditionGroup.conditionGroups.map($8c8f388f20690f59$var$transformConditionGroupRecursively),
        conditionIds: conditionGroup.conditions.map(({ id: id })=>id)
    });
const $8c8f388f20690f59$var$transformRule = (rule)=>({
        id: rule.id,
        displayText: '',
        ruleKey: rule.ruleKey,
        config: rule.parameters,
        ...rule.type ? {
            type: rule.type
        } : {}
    });
const $8c8f388f20690f59$var$transformRules = (transition)=>{
    const actions = (transition.actions || []).map((action)=>({
            ...action,
            type: (0, $cdb05afe7af0efb7$export$3502294f79d19760)
        }));
    const conditions = $8c8f388f20690f59$var$flattenConditionsRecursively(transition.conditions).map((condition)=>({
            ...condition,
            type: (0, $cdb05afe7af0efb7$export$80aa97bba188b58d)
        }));
    const validators = (transition.validators || []).map((validator)=>({
            ...validator,
            type: (0, $cdb05afe7af0efb7$export$693dd3cc66111a25)
        }));
    const triggers = (transition.triggers || []).map((trigger)=>({
            ...trigger,
            type: (0, $cdb05afe7af0efb7$export$3ba72f070d7e1f8)
        }));
    const screens = transition.transitionScreen ? [
        {
            ...transition.transitionScreen,
            type: (0, $cdb05afe7af0efb7$export$f2806a4bb8fad62e)
        }
    ] : [];
    const rules = [
        ...actions,
        ...conditions,
        ...validators,
        ...triggers,
        ...screens
    ];
    let conditionTree;
    if (transition.conditions) conditionTree = $8c8f388f20690f59$var$transformConditionGroupRecursively(transition.conditions);
    return {
        rules: rules.map($8c8f388f20690f59$var$transformRule),
        conditionTree: conditionTree
    };
};
const $8c8f388f20690f59$var$getTransitionLinks = (transition)=>{
    const { links: links } = transition;
    if (transition.type === (0, $1DCdt.transitionType).INITIAL) return [
        {
            fromRef: (0, $1DCdt.START_NODE_ID),
            fromPort: 0,
            toPort: links[0]?.toPort || 0
        }
    ];
    if (transition.type === (0, $1DCdt.transitionType).GLOBAL) return [];
    return links.reduce((acc, link)=>{
        if (link.fromStatusReference !== undefined) acc.push({
            fromRef: link.fromStatusReference,
            fromPort: link.fromPort,
            toPort: link.toPort
        });
        return acc;
    }, []);
};
const $8c8f388f20690f59$var$transformTransitions = (transitions)=>{
    const transformed = {};
    transitions.forEach((transition)=>{
        transformed[transition.id] = {
            id: transition.id,
            type: (0, $1DCdt.transitionType)[transition.type],
            name: transition.name,
            description: transition.description || '',
            toRef: transition.toStatusReference,
            links: $8c8f388f20690f59$var$getTransitionLinks(transition),
            properties: transition.properties ?? {},
            ...$8c8f388f20690f59$var$transformRules(transition),
            ...transition.customIssueEventId ? {
                customIssueEventId: transition.customIssueEventId
            } : {}
        };
    });
    return transformed;
};
const $8c8f388f20690f59$export$51186ad6e864892a = (response)=>{
    const [workflow] = response.workflows;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allStatuses = {};
    const visibleStatuses = [];
    const getAssociatedIssueTypes = (associations)=>associations?.length ? associations[0].issueTypes.map((id)=>id) : [];
    response.statuses.forEach((status)=>{
        const workflowStatus = workflow.statuses.find((candidate)=>candidate.statusReference === status.id);
        allStatuses[status.statusReference] = {
            id: status.id,
            name: status.name,
            description: status.description,
            isNew: false,
            statusCategory: status.statusCategory,
            scope: status.scope.type,
            layout: workflowStatus?.layout && workflowStatus.layout.x && workflowStatus.layout.y ? workflowStatus.layout : undefined,
            properties: workflowStatus?.properties ?? {},
            ...workflowStatus?.approvalConfiguration && {
                approvalConfiguration: workflowStatus.approvalConfiguration
            }
        };
    });
    workflow.statuses.forEach((workflowStatus)=>{
        if (allStatuses[workflowStatus.statusReference]) visibleStatuses.push({
            ref: workflowStatus.statusReference
        });
    });
    return {
        id: workflow.id,
        name: workflow.name,
        description: workflow.description,
        versionNumber: workflow.version.versionNumber,
        versionId: workflow.version.id,
        scope: workflow.scope,
        allStatuses: allStatuses,
        visibleStatuses: visibleStatuses,
        transitions: $8c8f388f20690f59$var$transformTransitions(workflow.transitions),
        startNodeLayout: workflow.startPointLayout || {},
        loopedTransitionContainerLayout: workflow.loopedTransitionContainerLayout || {},
        associatedIssueTypeIds: getAssociatedIssueTypes(workflow.associatedWith),
        associatedEntityIds: workflow.associatedWith.map(({ project: project, issueTypes: issueTypes })=>({
                project: {
                    id: project.id
                },
                issueTypes: issueTypes.map((id)=>id)
            })),
        migrationId: workflow.migrationId,
        isEditable: workflow.isEditable,
        hasDraft: workflow.hasDraft
    };
};
function $8c8f388f20690f59$export$d8b89067fc7ab9b2(apiResponse) {
    try {
        (0, $bTi9g.validateLogicalDocumentIntegrity)(apiResponse);
    } catch (err) {
        // an error here will not block the user experience, but it triggers
        // a priority alarm for us to investigate and understand the occurrence.
        (0, $6CfY5.default).safeErrorWithoutCustomerData('workflow.render.integrity.checker', err instanceof Error ? err.message : String(err));
    }
    return (0, $3tDid.transformWithUsages)(apiResponse);
}

});
const $cdb05afe7af0efb7$export$3502294f79d19760 = 'action';
const $cdb05afe7af0efb7$export$693dd3cc66111a25 = 'validator';
const $cdb05afe7af0efb7$export$3ba72f070d7e1f8 = 'trigger';
const $cdb05afe7af0efb7$export$80aa97bba188b58d = 'condition';
const $cdb05afe7af0efb7$export$f2806a4bb8fad62e = 'screen';
const $cdb05afe7af0efb7$export$3376a0f7af04519d = 'Condition';
const $cdb05afe7af0efb7$export$2de5623c1b523a0e = 'Validator';
const $cdb05afe7af0efb7$export$409e451098fe718a = 'Function';
const $cdb05afe7af0efb7$export$fb9c85bcc2b7f87f = 'Screen';
const $cdb05afe7af0efb7$export$17227441e89ee693 = 'INITIAL';
const $cdb05afe7af0efb7$export$17ff3f7e02c6ac22 = 'GLOBAL';
const $cdb05afe7af0efb7$export$ecdc381371b8557 = 'DIRECTED';

parcelRegister("3tDid", function(module, exports) {
$parcel$export(module.exports, "transformWorkflowVersion", () => $5e7437e10142357e$export$4352b1da59306a24);
$parcel$export(module.exports, "transformWithUsages", () => $5e7437e10142357e$export$2fa43feeb8801e0b);

var $7TA2J = parcelRequire("7TA2J");


var $1DCdt = parcelRequire("1DCdt");

var $10Vo7 = parcelRequire("10Vo7");
const $5e7437e10142357e$var$flattenConditionsRecursively = (conditionGroup)=>{
    if (!conditionGroup) return [];
    return conditionGroup.conditions.concat(conditionGroup.conditionGroups.flatMap($5e7437e10142357e$var$flattenConditionsRecursively));
};
const $5e7437e10142357e$var$transformConditionGroupRecursively = (conditionGroup)=>({
        id: (0, $7TA2J.v4)(),
        operation: conditionGroup.operation,
        conditionGroups: conditionGroup.conditionGroups.map($5e7437e10142357e$var$transformConditionGroupRecursively),
        conditionIds: conditionGroup.conditions.map(({ id: id })=>id)
    });
const $5e7437e10142357e$var$transformRule = (rule)=>({
        id: rule.id,
        displayText: '',
        ruleKey: rule.ruleKey,
        config: rule.parameters,
        ...rule.type ? {
            type: rule.type
        } : {}
    });
const $5e7437e10142357e$var$transformRules = (transition)=>{
    const actions = (transition.actions || []).map((action)=>({
            ...action,
            type: (0, $cdb05afe7af0efb7$export$3502294f79d19760)
        }));
    const conditions = $5e7437e10142357e$var$flattenConditionsRecursively(transition.conditions).map((condition)=>({
            ...condition,
            type: (0, $cdb05afe7af0efb7$export$80aa97bba188b58d)
        }));
    const validators = (transition.validators || []).map((validator)=>({
            ...validator,
            type: (0, $cdb05afe7af0efb7$export$693dd3cc66111a25)
        }));
    const triggers = (transition.triggers || []).map((trigger)=>({
            ...trigger,
            type: (0, $cdb05afe7af0efb7$export$3ba72f070d7e1f8)
        }));
    const screens = transition.transitionScreen ? [
        {
            ...transition.transitionScreen,
            type: (0, $cdb05afe7af0efb7$export$f2806a4bb8fad62e)
        }
    ] : [];
    const rules = [
        ...actions,
        ...conditions,
        ...validators,
        ...triggers,
        ...screens
    ];
    let conditionTree;
    if (transition.conditions) conditionTree = $5e7437e10142357e$var$transformConditionGroupRecursively(transition.conditions);
    return {
        rules: rules.map($5e7437e10142357e$var$transformRule),
        conditionTree: conditionTree
    };
};
const $5e7437e10142357e$var$getTransitionLinks = (transition)=>{
    const { links: links } = transition;
    if (transition.type === (0, $1DCdt.transitionType).INITIAL) return [
        {
            fromRef: (0, $1DCdt.START_NODE_ID),
            fromPort: 0,
            toPort: links[0]?.toPort || 0
        }
    ];
    if (transition.type === (0, $1DCdt.transitionType).GLOBAL) return [];
    return links.reduce((acc, link)=>{
        if (link.fromStatusReference !== undefined) acc.push({
            fromRef: link.fromStatusReference,
            fromPort: link.fromPort,
            toPort: link.toPort
        });
        return acc;
    }, []);
};
const $5e7437e10142357e$var$transformTransitions = (transitions)=>{
    const transformed = {};
    transitions.forEach((transition)=>{
        transformed[transition.id] = {
            id: transition.id,
            type: (0, $1DCdt.transitionType)[transition.type],
            name: transition.name,
            description: transition.description || '',
            toRef: transition.toStatusReference,
            links: $5e7437e10142357e$var$getTransitionLinks(transition),
            properties: transition.properties ?? {},
            ...$5e7437e10142357e$var$transformRules(transition),
            ...transition.customIssueEventId ? {
                customIssueEventId: transition.customIssueEventId
            } : {}
        };
    });
    return transformed;
};
const $5e7437e10142357e$var$transformStatuses = (responseStatuses, workflow)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allStatuses = {};
    const visibleStatuses = [];
    const missingStatusIdToPlaceholderId = {};
    responseStatuses.forEach((status)=>{
        const workflowStatus = workflow.statuses.find((candidate)=>candidate.statusReference === status.id);
        allStatuses[status.statusReference] = {
            id: status.id,
            name: status.name,
            description: status.description,
            isNew: false,
            statusCategory: status.statusCategory,
            scope: status.scope.type,
            layout: workflowStatus?.layout && workflowStatus.layout.x && workflowStatus.layout.y ? workflowStatus.layout : undefined,
            properties: workflowStatus?.properties ?? {},
            ...workflowStatus?.approvalConfiguration && {
                approvalConfiguration: workflowStatus.approvalConfiguration
            }
        };
    });
    workflow.statuses.forEach((workflowStatus)=>{
        if (allStatuses[workflowStatus.statusReference]) visibleStatuses.push({
            ref: workflowStatus.statusReference
        });
        else {
            const placeholderStatus = {
                id: (0, $7TA2J.v4)(),
                name: '',
                description: '',
                statusCategory: (0, $10Vo7.TODO),
                scope: workflow.scope.type,
                isNew: true,
                layout: workflowStatus?.layout && workflowStatus.layout.x && workflowStatus.layout.y ? {
                    x: workflowStatus.layout.x,
                    y: workflowStatus.layout.y
                } : undefined,
                properties: workflowStatus?.properties ?? {},
                ...workflowStatus?.approvalConfiguration && {
                    approvalConfiguration: workflowStatus.approvalConfiguration
                },
                isMissingStatusPlaceholder: true
            };
            missingStatusIdToPlaceholderId[workflowStatus.statusReference] = placeholderStatus.id;
            allStatuses[placeholderStatus.id] = placeholderStatus;
            visibleStatuses.push({
                ref: placeholderStatus.id
            });
        }
    });
    return {
        allStatuses: allStatuses,
        visibleStatuses: visibleStatuses,
        missingStatusIdToPlaceholderId: missingStatusIdToPlaceholderId
    };
};
const $5e7437e10142357e$export$51186ad6e864892a = (response)=>{
    const [workflow] = response.workflows;
    const { allStatuses: allStatuses, visibleStatuses: visibleStatuses, missingStatusIdToPlaceholderId: missingStatusIdToPlaceholderId } = $5e7437e10142357e$var$transformStatuses(response.statuses, workflow);
    const remappedTransitions = workflow.transitions.map((transition)=>{
        const mapMissingStatusRef = (statusReference)=>{
            if (statusReference && missingStatusIdToPlaceholderId[statusReference]) return missingStatusIdToPlaceholderId[statusReference];
            return statusReference;
        };
        return {
            ...transition,
            toStatusReference: mapMissingStatusRef(transition.toStatusReference),
            links: transition.links.map((link)=>({
                    ...link,
                    fromStatusReference: mapMissingStatusRef(link.fromStatusReference)
                }))
        };
    });
    return {
        id: workflow.id,
        name: workflow.name,
        description: workflow.description,
        versionNumber: workflow.version.versionNumber,
        versionId: workflow.version.id,
        scope: workflow.scope,
        allStatuses: allStatuses,
        visibleStatuses: visibleStatuses,
        transitions: $5e7437e10142357e$var$transformTransitions(remappedTransitions),
        startNodeLayout: workflow.startPointLayout || {},
        loopedTransitionContainerLayout: workflow.loopedTransitionContainerLayout || {},
        migrationId: workflow.migrationId,
        isEditable: workflow.isEditable,
        hasDraft: workflow.hasDraft
    };
};
const $5e7437e10142357e$export$4352b1da59306a24 = (response)=>{
    const [workflow] = response.workflows;
    const { allStatuses: allStatuses, visibleStatuses: visibleStatuses } = $5e7437e10142357e$var$transformStatuses(response.statuses, workflow);
    return {
        id: workflow.id,
        name: workflow.name,
        description: workflow.description,
        versionNumber: workflow.version.versionNumber,
        versionId: workflow.version.id,
        scope: workflow.scope,
        allStatuses: allStatuses,
        visibleStatuses: visibleStatuses,
        transitions: $5e7437e10142357e$var$transformTransitions(workflow.transitions),
        startNodeLayout: workflow.startPointLayout || {},
        loopedTransitionContainerLayout: workflow.loopedTransitionContainerLayout || {}
    };
};
const $5e7437e10142357e$export$2fa43feeb8801e0b = (response)=>{
    const [workflow] = response.workflows;
    const transformedWorkflow = $5e7437e10142357e$export$51186ad6e864892a(response);
    const getAssociatedIssueTypes = (associations)=>associations?.length ? associations[0].issueTypes.map((id)=>id) : [];
    return {
        ...transformedWorkflow,
        associatedIssueTypeIds: getAssociatedIssueTypes(workflow.associatedWith),
        associatedEntityIds: workflow.associatedWith.map(({ project: project, issueTypes: issueTypes })=>({
                project: {
                    id: project.id
                },
                issueTypes: issueTypes.map((id)=>id)
            }))
    };
};

});

parcelRegister("bTi9g", function(module, exports) {
$parcel$export(module.exports, "validateLogicalDocumentIntegrity", () => $a193b6d8b2336a44$export$f2d04b42cf39668b);

var $10Vo7 = parcelRequire("10Vo7");

class $a193b6d8b2336a44$export$627388fd8033c742 extends Error {
}
$a193b6d8b2336a44$export$627388fd8033c742.displayName = "WorkflowIntegrityError";
const $a193b6d8b2336a44$var$assertStatusesHaveValidNames = (statuses)=>{
    statuses.forEach((status)=>{
        if (status.name.length === 0) throw new $a193b6d8b2336a44$export$627388fd8033c742('Detected invalid empty status name.');
    });
};
const $a193b6d8b2336a44$var$assertStatusesHaveValidCategories = (statuses)=>{
    statuses.forEach((status)=>{
        if (!(0, $10Vo7.STATUS_CATEGORIES).includes(status.statusCategory)) throw new $a193b6d8b2336a44$export$627388fd8033c742(`Detected unexpected status category: ${status.statusCategory}.`);
    });
};
const $a193b6d8b2336a44$var$assertTransitionsHaveValidNames = (transitions)=>{
    transitions.forEach((transition)=>{
        if (transition.name.length === 0) throw new $a193b6d8b2336a44$export$627388fd8033c742('Detected invalid empty transition name.');
    });
};
const $a193b6d8b2336a44$var$assertInitialTransitionExists = (transitions)=>{
    const countInitialTransitions = transitions.filter((t)=>t.type === (0, $cdb05afe7af0efb7$export$17227441e89ee693)).length;
    if (countInitialTransitions !== 1) throw new $a193b6d8b2336a44$export$627388fd8033c742(`Detected workflow with ${countInitialTransitions} INITIAL transitions. Expected a single one.`);
};
const $a193b6d8b2336a44$var$assertTransitionsAreCorrectlyConnected = (transitions, statuses)=>{
    const validStatusReferences = statuses.map((status)=>status.statusReference);
    transitions.filter((t)=>t.type === (0, $cdb05afe7af0efb7$export$ecdc381371b8557)).forEach((transition)=>{
        const { toStatusReference: toStatusReference, links: [{ fromStatusReference: fromStatusReference }] } = transition;
        // DIRECTED transitions have to have valid `from` and `to` references
        if (!fromStatusReference || !validStatusReferences.includes(fromStatusReference) || !toStatusReference || !validStatusReferences.includes(toStatusReference)) throw new $a193b6d8b2336a44$export$627388fd8033c742('Detected DIRECTED transition with invalid from and to references (either or both).');
    });
    transitions.filter((t)=>t.type === (0, $cdb05afe7af0efb7$export$17227441e89ee693)).forEach((transition)=>{
        const { toStatusReference: toStatusReference, links: links } = transition;
        const fromRefs = links.map((link)=>link.fromStatusReference).filter((ref)=>ref !== undefined);
        // INITIAL transitions only need to have a valid `to` reference
        if (!toStatusReference || !validStatusReferences.includes(toStatusReference) || fromRefs.length) throw new $a193b6d8b2336a44$export$627388fd8033c742(`Detected ${transition.type} transition without a valid destination or with a defined "from".`);
    });
    const unknownType = transitions.find((t)=>t.type !== (0, $cdb05afe7af0efb7$export$ecdc381371b8557) && t.type !== (0, $cdb05afe7af0efb7$export$17ff3f7e02c6ac22) && t.type !== (0, $cdb05afe7af0efb7$export$17227441e89ee693));
    if (unknownType) throw new $a193b6d8b2336a44$export$627388fd8033c742(`Detected unexpected transition type: ${unknownType.type}.`);
};
const $a193b6d8b2336a44$export$f2d04b42cf39668b = (result)=>{
    const { statuses: statuses } = result;
    const [workflow] = result.workflows;
    const { transitions: transitions } = workflow;
    $a193b6d8b2336a44$var$assertStatusesHaveValidNames(statuses);
    $a193b6d8b2336a44$var$assertStatusesHaveValidCategories(statuses);
    $a193b6d8b2336a44$var$assertTransitionsHaveValidNames(transitions);
    $a193b6d8b2336a44$var$assertTransitionsAreCorrectlyConnected(transitions, statuses);
    $a193b6d8b2336a44$var$assertInitialTransitionExists(transitions);
    return result;
};

});



parcelRegister("j93Pj", function(module, exports) {
$parcel$export(module.exports, "getReadViewWorkflow", () => $84c6c341fd916d08$export$3b8d678652c06644);
$parcel$export(module.exports, "getMultiReadViewWorkflow", () => $84c6c341fd916d08$export$eafd9c113ccae659);

var $6CfY5 = parcelRequire("6CfY5");

var $h2wCv = parcelRequire("h2wCv");

var $2FfnB = parcelRequire("2FfnB");

var $6lSOC = parcelRequire("6lSOC");
const $84c6c341fd916d08$var$getApiPrefix = ()=>'gateway/api/jira/project-configuration';
const $84c6c341fd916d08$var$getPayload = (workflowIdentifier)=>{
    const { workflowId: workflowId, workflowIds: workflowIds, workflowName: workflowName, issueTypeId: issueTypeId, projectId: projectId } = workflowIdentifier;
    const payload = {
        projectId: projectId
    };
    if (workflowId != null) payload.workflowIds = [
        workflowId
    ];
    if (workflowIds != null) payload.workflowIds = workflowIds;
    if (workflowName != null) payload.workflowNames = [
        workflowName
    ];
    if (issueTypeId != null) payload.issueTypeIds = [
        issueTypeId
    ];
    return payload;
};
const $84c6c341fd916d08$export$3b8d678652c06644 = async (requestData)=>{
    const { cloudId: cloudId, ...workflowIdentifier } = requestData;
    const url = `/${$84c6c341fd916d08$var$getApiPrefix()}/query/${cloudId}/2/workflow/read-view`;
    const payload = $84c6c341fd916d08$var$getPayload(workflowIdentifier);
    const result = await (0, $h2wCv.performPostRequest)(url, {
        body: JSON.stringify(payload)
    });
    try {
        (0, $6lSOC.validateLogicalDocumentIntegrity)(result);
    } catch (err) {
        const message = err instanceof Error ? err.message : String(err);
        // an error here will not block the user experience, but it triggers
        // a priority alarm for us to investigate and understand the occurrence.
        (0, $6CfY5.default).safeErrorWithoutCustomerData('workflow.render.integrity.checker', message);
    }
    return (0, $2FfnB.transform)(result);
};
const $84c6c341fd916d08$var$fetchReadViewWorkflow = async (requestData, signal)=>{
    const { cloudId: cloudId, ...workflowIdentifier } = requestData;
    const url = `/${$84c6c341fd916d08$var$getApiPrefix()}/query/${cloudId}/2/workflow/read-view`;
    const payload = $84c6c341fd916d08$var$getPayload(workflowIdentifier);
    const result = await (0, $h2wCv.performPostRequest)(url, {
        body: JSON.stringify(payload),
        signal: signal
    });
    try {
        (0, $6lSOC.validateLogicalDocumentIntegrity)(result);
    } catch (err) {
        const message = err instanceof Error ? err.message : String(err);
        // an error here will not block the user experience, but it triggers
        // a priority alarm for us to investigate and understand the occurrence.
        (0, $6CfY5.default).safeErrorWithoutCustomerData('workflow.render.integrity.checker', message);
    }
    return result;
};
const $84c6c341fd916d08$export$40b993e03fe8aa4f = async (requestData)=>{
    const result = await $84c6c341fd916d08$var$fetchReadViewWorkflow(requestData);
    return (0, $2FfnB.transform)(result);
};
const $84c6c341fd916d08$export$eafd9c113ccae659 = async (requestData, signal)=>{
    const result = await $84c6c341fd916d08$var$fetchReadViewWorkflow(requestData, signal);
    return (0, $2FfnB.transformMultipleWorkflows)(result);
};
var $84c6c341fd916d08$export$2e2bcd8739ae039 = $84c6c341fd916d08$export$40b993e03fe8aa4f;

});
parcelRegister("2FfnB", function(module, exports) {
$parcel$export(module.exports, "transform", () => $71b22d58d880151d$export$51186ad6e864892a);
$parcel$export(module.exports, "transformMultipleWorkflows", () => $71b22d58d880151d$export$84f872018349e7ec);
/* eslint-disable jira/filename-case */ 
var $7TA2J = parcelRequire("7TA2J");


var $1DCdt = parcelRequire("1DCdt");
const $71b22d58d880151d$var$flattenConditionsRecursively = (conditionGroup)=>{
    if (!conditionGroup) return [];
    return conditionGroup.conditions.concat(conditionGroup.conditionGroups.flatMap($71b22d58d880151d$var$flattenConditionsRecursively));
};
const $71b22d58d880151d$var$transformConditionGroupRecursively = (conditionGroup)=>({
        id: (0, $7TA2J.v4)(),
        operation: conditionGroup.operation,
        conditionGroups: conditionGroup.conditionGroups.map($71b22d58d880151d$var$transformConditionGroupRecursively),
        conditionIds: conditionGroup.conditions.map(({ id: id })=>id)
    });
const $71b22d58d880151d$var$transformRule = (rule)=>({
        id: rule.id,
        displayText: '',
        ruleKey: rule.ruleKey,
        config: rule.parameters || {}
    });
const $71b22d58d880151d$var$transformRules = (transition)=>{
    const actions = (transition.actions || []).map((action)=>({
            ...action,
            type: (0, $cdb05afe7af0efb7$export$3502294f79d19760)
        }));
    const conditions = $71b22d58d880151d$var$flattenConditionsRecursively(transition.conditions).map((condition)=>({
            ...condition,
            type: (0, $cdb05afe7af0efb7$export$80aa97bba188b58d)
        }));
    const validators = (transition.validators || []).map((validator)=>({
            ...validator,
            type: (0, $cdb05afe7af0efb7$export$693dd3cc66111a25)
        }));
    const triggers = (transition.triggers || []).map((trigger)=>({
            ...trigger,
            type: (0, $cdb05afe7af0efb7$export$3ba72f070d7e1f8)
        }));
    const screens = transition.transitionScreen ? [
        {
            ...transition.transitionScreen,
            type: (0, $cdb05afe7af0efb7$export$f2806a4bb8fad62e)
        }
    ] : [];
    const rules = [
        ...actions,
        ...conditions,
        ...validators,
        ...triggers,
        ...screens
    ];
    let conditionTree;
    if (transition.conditions) conditionTree = $71b22d58d880151d$var$transformConditionGroupRecursively(transition.conditions);
    return {
        rules: rules.map($71b22d58d880151d$var$transformRule),
        conditionTree: conditionTree
    };
};
const $71b22d58d880151d$export$4c7eb174bf1f84f2 = (transition)=>{
    const { links: links } = transition;
    if (transition.type === (0, $1DCdt.transitionType).INITIAL) return [
        {
            fromRef: (0, $1DCdt.START_NODE_ID),
            fromPort: 0,
            toPort: links[0]?.toPort ?? 0
        }
    ];
    if (transition.type === (0, $1DCdt.transitionType).GLOBAL) return [];
    return links.reduce((acc, link)=>{
        if (link.fromStatusReference != null) acc.push({
            fromRef: link.fromStatusReference,
            fromPort: link.fromPort ?? undefined,
            toPort: link.toPort ?? undefined
        });
        return acc;
    }, []);
};
const $71b22d58d880151d$var$transformTransitions = (transitions)=>{
    const transformed = {};
    transitions.forEach((transition)=>{
        transformed[transition.id] = {
            id: transition.id,
            type: (0, $1DCdt.transitionType)[transition.type],
            name: transition.name,
            description: transition.description || '',
            toRef: transition.toStatusReference || undefined,
            links: $71b22d58d880151d$export$4c7eb174bf1f84f2(transition),
            properties: transition.properties || {},
            ...$71b22d58d880151d$var$transformRules(transition)
        };
    });
    return transformed;
};
const $71b22d58d880151d$var$transformSingleWorkflow = (response, workflow)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allStatuses = {};
    const visibleStatuses = [];
    response.statuses.forEach((status)=>{
        const workflowStatus = workflow.statuses.find((candidate)=>candidate.statusReference === status.id);
        allStatuses[status.statusReference] = {
            id: status.id,
            name: status.name,
            description: status.description,
            isNew: false,
            statusCategory: status.statusCategory,
            scope: status.scope.type,
            layout: workflowStatus?.layout && workflowStatus.layout.x && workflowStatus.layout.y ? workflowStatus.layout : undefined,
            ...workflowStatus?.approvalConfiguration && {
                approvalConfiguration: workflowStatus.approvalConfiguration
            },
            properties: workflowStatus?.properties
        };
        if (workflowStatus?.statusReference) visibleStatuses.push({
            ref: workflowStatus.statusReference
        });
    });
    return {
        id: workflow.id,
        name: workflow.name,
        description: workflow.description,
        versionNumber: workflow.version.versionNumber,
        versionId: workflow.version.id,
        scope: workflow.scope,
        allStatuses: allStatuses,
        visibleStatuses: visibleStatuses,
        transitions: $71b22d58d880151d$var$transformTransitions(workflow.transitions),
        startNodeLayout: workflow.startPointLayout || {},
        loopedTransitionContainerLayout: workflow.loopedTransitionContainerLayout || {},
        isEditable: false,
        associatedIssueTypeIds: [],
        associatedEntityIds: []
    };
};
const $71b22d58d880151d$export$51186ad6e864892a = (response)=>{
    const [workflow] = response.workflows;
    return $71b22d58d880151d$var$transformSingleWorkflow(response, workflow);
};
const $71b22d58d880151d$export$84f872018349e7ec = (response)=>{
    return response.workflows.map((workflow)=>{
        return $71b22d58d880151d$var$transformSingleWorkflow(response, workflow);
    });
};

});

parcelRegister("6lSOC", function(module, exports) {
$parcel$export(module.exports, "validateLogicalDocumentIntegrity", () => $21fac235b5db2b6c$export$f2d04b42cf39668b);

var $10Vo7 = parcelRequire("10Vo7");

class $21fac235b5db2b6c$export$627388fd8033c742 extends Error {
}
$21fac235b5db2b6c$export$627388fd8033c742.displayName = "WorkflowIntegrityError";
const $21fac235b5db2b6c$var$assertStatusesHaveValidNames = (statuses)=>{
    statuses.forEach((status)=>{
        if (status.name.length === 0) throw new $21fac235b5db2b6c$export$627388fd8033c742('Detected invalid empty status name.');
    });
};
const $21fac235b5db2b6c$var$assertStatusesHaveValidCategories = (statuses)=>{
    statuses.forEach((status)=>{
        if (!(0, $10Vo7.STATUS_CATEGORIES).includes(status.statusCategory)) throw new $21fac235b5db2b6c$export$627388fd8033c742(`Detected unexpected status category: ${status.statusCategory}.`);
    });
};
const $21fac235b5db2b6c$var$assertTransitionsHaveValidNames = (transitions)=>{
    transitions.forEach((transition)=>{
        if (transition.name.length === 0) throw new $21fac235b5db2b6c$export$627388fd8033c742('Detected invalid empty transition name.');
    });
};
const $21fac235b5db2b6c$var$assertInitialTransitionExists = (transitions)=>{
    const countInitialTransitions = transitions.filter((t)=>t.type === (0, $376bde324e19cce1$export$17227441e89ee693)).length;
    if (countInitialTransitions !== 1) throw new $21fac235b5db2b6c$export$627388fd8033c742(`Detected workflow with ${countInitialTransitions} INITIAL transitions. Expected a single one.`);
};
const $21fac235b5db2b6c$var$assertTransitionsAreCorrectlyConnected = (transitions, statuses)=>{
    const validStatusReferences = statuses.map((status)=>status.statusReference);
    transitions.filter((t)=>t.type === (0, $376bde324e19cce1$export$ecdc381371b8557)).forEach((transition)=>{
        const { toStatusReference: toStatusReference, links: [{ fromStatusReference: fromStatusReference }] } = transition;
        // DIRECTED transitions have to have valid `from` and `to` references
        if (!fromStatusReference || !validStatusReferences.includes(fromStatusReference) || !toStatusReference || !validStatusReferences.includes(toStatusReference)) throw new $21fac235b5db2b6c$export$627388fd8033c742('Detected DIRECTED transition with invalid from and to references (either or both).');
    });
    transitions.filter((t)=>t.type === (0, $376bde324e19cce1$export$17227441e89ee693)).forEach((transition)=>{
        const { toStatusReference: toStatusReference, links: links } = transition;
        const fromRefs = links.map((link)=>link.fromStatusReference).filter((ref)=>ref !== undefined);
        // INITIAL transitions only need to have a valid `to` reference
        if (!toStatusReference || !validStatusReferences.includes(toStatusReference) || fromRefs.length) throw new $21fac235b5db2b6c$export$627388fd8033c742(`Detected ${transition.type} transition without a valid destination or with a defined "from".`);
    });
    const unknownType = transitions.find((t)=>t.type !== (0, $376bde324e19cce1$export$ecdc381371b8557) && t.type !== (0, $376bde324e19cce1$export$17ff3f7e02c6ac22) && t.type !== (0, $376bde324e19cce1$export$17227441e89ee693));
    if (unknownType) throw new $21fac235b5db2b6c$export$627388fd8033c742(`Detected unexpected transition type: ${unknownType.type}.`);
};
const $21fac235b5db2b6c$export$f2d04b42cf39668b = (result)=>{
    const { statuses: statuses } = result;
    const workFlowTransitions = result.workflows.map((workflow)=>workflow.transitions);
    $21fac235b5db2b6c$var$assertStatusesHaveValidNames(statuses);
    $21fac235b5db2b6c$var$assertStatusesHaveValidCategories(statuses);
    workFlowTransitions.forEach((transitions)=>{
        $21fac235b5db2b6c$var$assertTransitionsHaveValidNames(transitions);
        $21fac235b5db2b6c$var$assertTransitionsAreCorrectlyConnected(transitions, statuses);
        $21fac235b5db2b6c$var$assertInitialTransitionExists(transitions);
    });
    return result;
};

});
const $376bde324e19cce1$export$17227441e89ee693 = 'INITIAL';
const $376bde324e19cce1$export$17ff3f7e02c6ac22 = 'GLOBAL';
const $376bde324e19cce1$export$ecdc381371b8557 = 'DIRECTED';



parcelRegister("hYI7R", function(module, exports) {
$parcel$export(module.exports, "useEffectWithoutConcurrency", () => $8e1c17f889077a08$export$e44126cd87ea434);

var $euxye = parcelRequire("euxye");

var $bxhpq = parcelRequire("bxhpq");

var $jiTLE = parcelRequire("jiTLE");
function $8e1c17f889077a08$export$e44126cd87ea434(effect, dependencies) {
    const effectCalledRef = (0, $euxye.useRef)(false);
    const depsRef = (0, $euxye.useRef)(dependencies);
    (0, $euxye.useEffect)(()=>{
        // If the dependencies have changed, reset the state of the ref.
        // This is how we catch the strict-mode execution.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxhpq)))(depsRef.current, dependencies)) {
            depsRef.current = dependencies;
            effectCalledRef.current = false;
        }
        // If the effect has already executed, we shouldn't be executing again unless we do a cleanup first.
        // This is the code that ignores the strict-mode update
        if (effectCalledRef.current) return;
        // Set this immediately
        effectCalledRef.current = true;
        const cleanup = effect();
        // If we do get a cleanup function, throw an error
        (0, $jiTLE.default)(typeof cleanup !== 'function', 'useEffectWithoutConcurrency() cannot be used with cleanup functions');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

});




parcelRegister("dWg4n", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dbe7d1253848a13$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $jBG83 = parcelRequire("jBG83");

var $u9iDa = parcelRequire("u9iDa");
const $9dbe7d1253848a13$var$WORKFLOW_PREVIEW_PLACEHOLDER_ID = 'workflow-modern-preview-placeholder';
const $9dbe7d1253848a13$var$AddExistingWorkflowPreview = ()=>{
    const [selectedWorkflow, setSelectedWorkflow] = (0, $euxye.useState)(undefined);
    (0, $euxye.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            const selectedWorkflowToPreview = (0, $u9iDa.getDocument)()?.querySelector('#add-workflow-dialog .project-config-workflow-add-dialog-list .selected');
            if (selectedWorkflowToPreview) {
                const workflowName = selectedWorkflowToPreview.getAttribute('data-workflowname');
                setSelectedWorkflow(workflowName);
            } else setSelectedWorkflow(undefined);
        });
        const body = (0, $u9iDa.getDocument)()?.body;
        if (body) observer.observe(body, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer && observer.disconnect();
        };
    }, []);
    const elm = (0, $u9iDa.getDocument)()?.getElementById($9dbe7d1253848a13$var$WORKFLOW_PREVIEW_PLACEHOLDER_ID);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, selectedWorkflow && elm ? /*#__PURE__*/ (0, $85XPu.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jBG83.default), {
        workflowIdentifier: {
            workflowName: selectedWorkflow
        }
    }), elm) : null);
};
$9dbe7d1253848a13$var$AddExistingWorkflowPreview.displayName = "AddExistingWorkflowPreview";
var $9dbe7d1253848a13$export$2e2bcd8739ae039 = $9dbe7d1253848a13$var$AddExistingWorkflowPreview;

});
parcelRegister("jBG83", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a8046f7d79019f6$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $aZMdt = parcelRequire("aZMdt");

var $5Mr2m = parcelRequire("5Mr2m");
const $2a8046f7d79019f6$var$WorkflowViewDiagramApp = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aZMdt.ContextualAnalyticsData), {
        sourceName: "workflowViewDiagram",
        sourceType: (0, $46f069e6c968f461$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5Mr2m.WorkflowViewDiagram), props));
};
$2a8046f7d79019f6$var$WorkflowViewDiagramApp.displayName = "WorkflowViewDiagramApp";
var $2a8046f7d79019f6$export$2e2bcd8739ae039 = $2a8046f7d79019f6$var$WorkflowViewDiagramApp;

});
parcelRegister("5Mr2m", function(module, exports) {
$parcel$export(module.exports, "WorkflowViewDiagram", () => $5c54a1c0607624b6$export$60f48d80efea621c);

var $euxye = parcelRequire("euxye");

var $1q31W = parcelRequire("1q31W");

var $2700E = parcelRequire("2700E");

var $c69sa = parcelRequire("c69sa");
var $fbAgj = parcelRequire("fbAgj");

var $abhF2 = parcelRequire("abhF2");

var $j26jU = parcelRequire("j26jU");

var $aqPkH = parcelRequire("aqPkH");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $kt86l = parcelRequire("kt86l");

var $l8Dej = parcelRequire("l8Dej");

var $ccsIE = parcelRequire("ccsIE");

var $6Yoad = parcelRequire("6Yoad");

var $ioPOL = parcelRequire("ioPOL");

var $hrM6x = parcelRequire("hrM6x");
const $5c54a1c0607624b6$var$errorMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "We couldn\u2019t load the workflow.",
    id: "workflow-view-diagram-modal.error-message"
});
const $5c54a1c0607624b6$var$INITIAL_ZOOM = 1;
const $5c54a1c0607624b6$var$MINIMUM_ZOOM_LEVEL_EXTENDED = 0.1;
// Convert new minimum from exponential to linear zoom: log₂(0.1) ≈ -3.32
// Uses change-of-base formula: log₂(x) = ln(x) / ln(2) = Math.log(x) / Math.log(2)
const $5c54a1c0607624b6$var$MINIMUM_LINEAR_ZOOM_EXTENDED = Math.log($5c54a1c0607624b6$var$MINIMUM_ZOOM_LEVEL_EXTENDED) / (0, $hrM6x.LOGRAITHMIC_ZOOM_BASE);
const $5c54a1c0607624b6$var$ERROR_IMAGE_MAX_HEIGHT = 212;
const $5c54a1c0607624b6$export$60f48d80efea621c = ({ projectId: projectId, workflowIdentifier: workflowIdentifier })=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [zoom, setZoom] = (0, $euxye.useState)($5c54a1c0607624b6$var$INITIAL_ZOOM);
    const { data: workflow, isLoading: isLoading, hasError: hasError, customErrorMessage: customErrorMessage } = (0, $6Yoad.useWorkflowData)(cloudId, workflowIdentifier, projectId);
    const onZoomChange = (0, $euxye.useCallback)((newZoomValue)=>{
        setZoom(newZoomValue);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
        xcss: $5c54a1c0607624b6$var$contentStyles
    }, (()=>{
        if (!hasError && isLoading && !workflow) return(// Loading state
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
            xcss: $5c54a1c0607624b6$var$centerWrapperStyles,
            testId: "workflow-view-diagram-modal.loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
            size: "large"
        })));
        if (hasError && !isLoading || !workflow) return(// Error state
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $j26jU.default), {
            header: formatMessage($5c54a1c0607624b6$var$errorMessage),
            maxImageHeight: $5c54a1c0607624b6$var$ERROR_IMAGE_MAX_HEIGHT,
            renderImage: (0, $l8Dej.getAkEmptyStateRenderImageFn)((0, $ccsIE.default)),
            description: customErrorMessage || undefined
        }));
        const statuses = workflow.visibleStatuses.map(({ ref: statusId })=>workflow.allStatuses[statusId]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
            xcss: $5c54a1c0607624b6$var$wrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $c69sa.default), {
            xcss: $5c54a1c0607624b6$var$diagramContentWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1q31W.default), {
            startNodeLayout: workflow.startNodeLayout,
            statuses: statuses,
            transitions: Object.values(workflow.transitions),
            zoom: zoom,
            isImmutable: true,
            onZoomUpdate: onZoomChange,
            collapseTransitionLabels: true,
            shouldShowGlobalLoops: true,
            minimumZoom: $5c54a1c0607624b6$var$MINIMUM_ZOOM_LEVEL_EXTENDED,
            ...(0, $2700E.expVal)('sprt_hix_9246_wfe_diagram_complete_workflowscope', 'isEnabled', false) && {
                workflowScope: workflow.scope.type
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ioPOL.ZoomControls), {
            zoom: zoom,
            onZoomChange: onZoomChange,
            minimumLinearZoom: $5c54a1c0607624b6$var$MINIMUM_LINEAR_ZOOM_EXTENDED
        }));
    })()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aqPkH.FireScreenAnalytics), null));
};
$5c54a1c0607624b6$export$60f48d80efea621c.displayName = "WorkflowViewDiagram";
const $5c54a1c0607624b6$var$centerWrapperStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    height: '100%'
});
const $5c54a1c0607624b6$var$wrapperStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    flexGrow: '1',
    minHeight: '352px',
    boxShadow: 'elevation.shadow.raised'
});
const $5c54a1c0607624b6$var$diagramContentWrapperStyles = (0, $fbAgj.xcss)({
    width: '100%',
    height: 'auto'
});
const $5c54a1c0607624b6$var$contentStyles = (0, $fbAgj.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    height: '100%'
});

});





parcelRegister("fabUY", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsAccessRouteEntry", () => $0b2522ec922ba650$export$1a764e0ec9764809);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $bQC0h = parcelRequire("bQC0h");
const $0b2522ec922ba650$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $0b2522ec922ba650$export$1a764e0ec9764809 = (0, $g1GqA.createLegacyEntry)((0, $bQC0h.globalSettingsProductsAccessRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: (0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$0b2522ec922ba650$var$pageEntryPoint
    }));

});
const $92d0e44258fe76a3$export$e8aa2912a0792727 = 'GLOBAL_PRODUCTS_SETTINGS';

parcelRegister("bQC0h", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsAccessRoute", () => $3ac61b8cfdaf7ab1$export$622d63534e0526a7);
const $3ac61b8cfdaf7ab1$export$622d63534e0526a7 = {
    name: 'global-settings-products-access',
    path: '/secure/admin/ApplicationAccess.jspa'
};

});


parcelRegister("kocek", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsAdvancedRoadmapsHierarchyRouteEntry", () => $d95284918e262bcf$export$c3b9f18ebde289c);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $cBl67 = parcelRequire("cBl67");
const $d95284918e262bcf$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d95284918e262bcf$export$c3b9f18ebde289c = (0, $g1GqA.createLegacyEntry)((0, $cBl67.globalSettingsProductsAdvancedRoadmapsHierarchyRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: (0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$d95284918e262bcf$var$pageEntryPoint
    }));

});
parcelRegister("cBl67", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsAdvancedRoadmapsHierarchyRoute", () => $4524be9222c8fb0e$export$40d4fd2626eca72c);
const $4524be9222c8fb0e$export$40d4fd2626eca72c = {
    name: 'global-settings-products-advanced-roadmaps-hierarchy',
    path: '/secure/PortfolioHierarchy.jspa'
};

});


parcelRegister("6j327", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsApplinksRouteEntry", () => $242e1729d8df5a0f$export$3dcc4ef9452eebbe);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $8jivR = parcelRequire("8jivR");

var $8yPTV = parcelRequire("8yPTV");
const $242e1729d8df5a0f$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $242e1729d8df5a0f$export$3dcc4ef9452eebbe = (0, $g1GqA.createLegacyEntry)((0, $8jivR.globalSettingsProductsApplinksRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $8yPTV.default),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: (0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$242e1729d8df5a0f$var$pageEntryPoint
    }));

});
parcelRegister("8jivR", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsApplinksRoute", () => $132bdf3d6b4452c5$export$8ff9863beab5519d);
const $132bdf3d6b4452c5$export$8ff9863beab5519d = {
    name: 'global-settings-products-applinks',
    path: '/plugins/servlet/applinks/listApplicationLinks'
};

});

parcelRegister("8yPTV", function(module, exports) {
$parcel$export(module.exports, "default", () => $57bffb1c3842d0be$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $jgKgn = parcelRequire("jgKgn");

var $6NrkU = parcelRequire("6NrkU");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");
const $57bffb1c3842d0be$var$PARENT_ELEMENT_SELECTOR = '.applinks-tunnel-header';
const $57bffb1c3842d0be$var$PORTAL_ELEMENT_KEY = 'react-applinks-button';
const $57bffb1c3842d0be$export$25a759e49d5049db = 'applinks.administration.legacy';
const $57bffb1c3842d0be$var$refreshLegacyPageState = ()=>{
    globalThis.window.refreshApplinksInitiatedFromReact?.();
    globalThis.window.AppLinks.Creation.Process.doOAuth2FinalizationInitiatedFromReact?.();
};
/**
 * React portal containing the drawer.
 */ const $57bffb1c3842d0be$var$PortalledElement = ()=>{
    const [drawerContext, setDrawerContext] = (0, $euxye.useState)(null);
    const [isDrawerOpen, setIsDrawerOpen] = (0, $euxye.useState)(false);
    const openOAuth2Drawer = (0, $euxye.useCallback)((targetUrl)=>{
        setDrawerContext(targetUrl);
        setIsDrawerOpen(true);
    }, []);
    const closeOAuth2Drawer = (0, $euxye.useCallback)(()=>{
        setIsDrawerOpen(false);
    }, []);
    (0, $euxye.useEffect)(()=>{
        globalThis.window.initiateApplinksOAuth2Creation = openOAuth2Drawer;
        globalThis.window.AppLinks.Creation.Process.onAppLinkOAuth2CreationReady?.();
    }, [
        openOAuth2Drawer
    ]);
    const availableOutboundConnections = globalThis.window.AppLinks?.Creation?.Process?.outboundConnections;
    const { localApplication: localApplication, remoteApplication: remoteApplication } = (0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs') ? globalThis.window.AppLinks?.Creation?.getCreationState() : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, drawerContext !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6NrkU.default), {
        ...(0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs') && {
            key: drawerContext
        },
        isOpen: isDrawerOpen,
        onClose: closeOAuth2Drawer,
        onCloseComplete: $57bffb1c3842d0be$var$refreshLegacyPageState,
        targetUrl: drawerContext,
        availableConnections: availableOutboundConnections,
        localManifest: localApplication,
        remoteManifest: remoteApplication
    }));
};
$57bffb1c3842d0be$var$PortalledElement.displayName = "PortalledElement";
/**
 * Creates a portal in the Applinks header (i.e. where the "Create link" button is)
 */ const $57bffb1c3842d0be$var$Portal = (_)=>{
    const linkElement = globalThis?.document.querySelector($57bffb1c3842d0be$var$PARENT_ELEMENT_SELECTOR);
    if (linkElement) return /*#__PURE__*/ (0, $85XPu.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($57bffb1c3842d0be$var$PortalledElement, null), linkElement, $57bffb1c3842d0be$var$PORTAL_ELEMENT_KEY);
    (0, $6CfY5.default).safeErrorWithoutCustomerData($57bffb1c3842d0be$export$25a759e49d5049db, `No link element found in the DOM (with selector \`${$57bffb1c3842d0be$var$PARENT_ELEMENT_SELECTOR}\`)`, undefined);
    return null;
};
$57bffb1c3842d0be$var$Portal.displayName = "Portal";
/**
 * Inject React into the Legacy frontend
 */ const $57bffb1c3842d0be$var$ModernApplinksCreateDrawer = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jgKgn.LegacyPage), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($57bffb1c3842d0be$var$Portal, null));
};
$57bffb1c3842d0be$var$ModernApplinksCreateDrawer.displayName = "ModernApplinksCreateDrawer";
var $57bffb1c3842d0be$export$2e2bcd8739ae039 = $57bffb1c3842d0be$var$ModernApplinksCreateDrawer;

});
parcelRegister("6NrkU", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e0d2ba2dd982dad$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $6CfY5 = parcelRequire("6CfY5");

var $5Ol6o = parcelRequire("5Ol6o");

var $drATu = parcelRequire("drATu");
const $1e0d2ba2dd982dad$var$CreateOAuth2Drawer = (props)=>{
    const fetchManifestsPromise = (0, $euxye.useCallback)(async ()=>{
        try {
            const localManifest = props.localManifest ?? await (0, $drATu.fetchThisManifest)();
            const remoteManifest = props.remoteManifest ?? await (0, $drATu.fetchApplinkManifestForUrl)(props.targetUrl);
            const newProps = {
                kind: 'review',
                variant: 'OAUTH2.0',
                localManifest: localManifest,
                remoteManifest: remoteManifest,
                rpcUrl: props.targetUrl
            };
            return newProps;
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            (0, $6CfY5.default).unsafeErrorWithCustomerData('applinks.administration.hybrid.create-oauth2-drawer.fetchManifests', 'Failed to retrieve manifests (as part of portalled modal load)', maybeError);
            throw err;
        }
    }, [
        props.targetUrl,
        props.localManifest,
        props.remoteManifest
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5Ol6o.CreateFlowDialog), {
        isOpen: props.isOpen,
        onExit: props.onClose,
        onCloseComplete: props.onCloseComplete,
        availableConnections: props.availableConnections,
        startingStage: {
            kind: 'loading',
            promise: fetchManifestsPromise()
        }
    });
};
$1e0d2ba2dd982dad$var$CreateOAuth2Drawer.displayName = "CreateOAuth2Drawer";
var $1e0d2ba2dd982dad$export$2e2bcd8739ae039 = $1e0d2ba2dd982dad$var$CreateOAuth2Drawer;

});
parcelRegister("5Ol6o", function(module, exports) {
$parcel$export(module.exports, "CreateFlowDialog", () => $200ca586220b410e$export$79c286a92b7787f2);
/* CreateFlowDialog.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $l6OQo = parcelRequire("l6OQo");
var $fyJ3d = parcelRequire("fyJ3d");

var $defJG = parcelRequire("defJG");

var $abhF2 = parcelRequire("abhF2");

var $3mYdc = parcelRequire("3mYdc");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $5KOJz = parcelRequire("5KOJz");

var $aKKFI = parcelRequire("aKKFI");

var $d58Bx = parcelRequire("d58Bx");

var $gjyKl = parcelRequire("gjyKl");

var $7kc1Y = parcelRequire("7kc1Y");
const $200ca586220b410e$var$errorFlagTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Failed to configure application link",
    id: "applinks.administration.ui.creation-flow-dialog.error-flag-title="
});
const $200ca586220b410e$var$DEFAULT_CREATE_STAGE = {
    kind: 'create'
};
const $200ca586220b410e$var$StateMachine = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    switch(props.state.kind){
        case 'create':
        case 'manual-create':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $5KOJz.default), {
                onError: props.onDisplayError,
                onSuccess: props.onStateChange,
                onCancel: props.onCancel
            });
        case 'review':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aKKFI.default), {
                state: props.state,
                onSuccess: props.onStateChange,
                onError: props.onDisplayError,
                onCancel: props.onCancel,
                availableConnections: props.availableConnections
            });
        case 'reciprocal-prompt':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $d58Bx.default), {
                state: props.state
            });
        case 'connect':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7kc1Y.default), {
                state: props.state,
                onSuccess: props.onCancel,
                onError: props.onDisplayError,
                onCancel: props.onCancel
            });
        case 'confirmation':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gjyKl.default), {
                state: props.state
            });
        case 'loading':
            props.state.promise.then((newState)=>{
                props.onStateChange(newState);
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
                alignBlock: "center",
                alignInline: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), null));
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null);
    }
});
const $200ca586220b410e$export$79c286a92b7787f2 = (props)=>{
    // Use the provided starting stage or default to the create stage
    const [flowState, setFlowState] = (0, $euxye.useState)(props.startingStage || $200ca586220b410e$var$DEFAULT_CREATE_STAGE);
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const onCancel = ()=>{
        props.onExit();
        const defaultStage = props.startingStage || $200ca586220b410e$var$DEFAULT_CREATE_STAGE;
        setFlowState(defaultStage);
    };
    const [errorFlags, setErrorFlags] = (0, $euxye.useState)([]);
    const addFlag = (0, $euxye.useCallback)((err)=>{
        const newFlags = errorFlags.slice();
        newFlags.splice(0, 0, err);
        setErrorFlags(newFlags);
    }, [
        errorFlags
    ]);
    const handleDismiss = ()=>{
        setErrorFlags(errorFlags.slice(1));
    };
    (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $l6OQo.Drawer), {
        testId: "applinks-administration.ui.list.creation-flow-dialog.drawer",
        width: "full",
        onClose: ()=>onCancel(),
        onCloseComplete: props.onCloseComplete,
        isOpen: props.isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fyJ3d.DrawerContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($200ca586220b410e$var$StateMachine, {
        state: flowState,
        onStateChange: setFlowState,
        onCancel: onCancel,
        onDisplayError: addFlag,
        availableConnections: props.availableConnections
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mYdc.FlagGroup), {
        onDismissed: handleDismiss
    }, errorFlags.map((err, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3mYdc.ErrorFlag), {
            id: `flag-${idx}`,
            key: `flag-${idx}`,
            title: formatMessage($200ca586220b410e$var$errorFlagTitleMessage),
            description: err
        });
    })));
};
$200ca586220b410e$export$79c286a92b7787f2.displayName = "CreateFlowDialog";

});
parcelRegister("l6OQo", function(module, exports) {
$parcel$export(module.exports, "Drawer", () => $22be6b11ab43e2f8$export$4071300121a182f5);
/// <reference types="node" />
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $kt9Lz = parcelRequire("kt9Lz");

var $aZBDA = parcelRequire("aZBDA");

var $fLi8o = parcelRequire("fLi8o");
var $g54uT = parcelRequire("g54uT");

var $5PG2M = parcelRequire("5PG2M");

var $4oqVa = parcelRequire("4oqVa");

var $1EOHp = parcelRequire("1EOHp");
// escape close manager for layering
const $22be6b11ab43e2f8$var$EscapeCloseManager = ({ onClose: onClose })=>{
    // wrap so that we can cast the event to a React.KeyboardEvent
    const handleClose = (0, $euxye.useCallback)((evt)=>{
        onClose && onClose(evt);
    }, [
        onClose
    ]);
    (0, $g54uT.useCloseOnEscapePress)({
        onClose: handleClose
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {});
};
$22be6b11ab43e2f8$var$EscapeCloseManager.displayName = "EscapeCloseManager";
const $22be6b11ab43e2f8$export$4071300121a182f5 = ({ width: width = 'narrow', isOpen: isOpen, isFocusLockEnabled: isFocusLockEnabled = true, shouldReturnFocus: shouldReturnFocus = true, autoFocusFirstElem: autoFocusFirstElem = true, onKeyDown: onKeyDown, testId: testId, children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, zIndex: zIndex = 'unset', label: label, titleId: titleId, enterFrom: enterFrom })=>{
    const handleClose = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'escKey'
        }
    });
    const handleKeyDown = (0, $euxye.useCallback)((evt)=>{
        onKeyDown && onKeyDown(evt);
    }, [
        onKeyDown
    ]);
    (0, $euxye.useEffect)(()=>{
        if (isOpen) window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleKeyDown,
        isOpen
    ]);
    const handleBlanketClick = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'blanket'
        }
    });
    const handleBackButtonClick = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose?.(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'backButton'
        }
    });
    const body = (0, $kt9Lz.canUseDOM) ? document.querySelector('body') : undefined;
    if (!body) return null;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $5PG2M.default), {
        zIndex: zIndex,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $4oqVa.default), {
                isOpen: isOpen,
                onBlanketClicked: handleBlanketClick,
                testId: testId && `${testId}--blanket`
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1EOHp.DrawerPanel), {
                testId: testId,
                isOpen: isOpen,
                onClose: handleBackButtonClick,
                onCloseComplete: onCloseComplete,
                onOpenComplete: onOpenComplete,
                width: width,
                enterFrom: enterFrom,
                label: label,
                titleId: titleId,
                autoFocusFirstElem: autoFocusFirstElem,
                isFocusLockEnabled: isFocusLockEnabled,
                shouldReturnFocus: shouldReturnFocus,
                children: isOpen ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $fLi8o.Layering), {
                    isDisabled: false,
                    children: [
                        children,
                        /*#__PURE__*/ (0, $e79Pd.jsx)($22be6b11ab43e2f8$var$EscapeCloseManager, {
                            onClose: handleClose
                        })
                    ]
                }) : children
            })
        ]
    });
};
$22be6b11ab43e2f8$export$4071300121a182f5.displayName = "Drawer";

});
parcelRegister("4oqVa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f9bcdd54fee8283$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");
parcelRequire("euxye");

var $zLbDw = parcelRequire("zLbDw");

var $8L2z6 = parcelRequire("8L2z6");
var $eCdE8 = parcelRequire("eCdE8");
const $3f9bcdd54fee8283$var$styles = {
    blanket: "_kqswh2mm"
};
/**
 * A wrapper around `@atlaskit/blanket` that adds a fade in/out transition.
 */ const $3f9bcdd54fee8283$var$Blanket = ({ isOpen: isOpen, onBlanketClicked: onBlanketClicked, testId: testId })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $eCdE8.default), {
            /*
     * The fade out animation uses half the passed duration so it evens out.
     */ duration: "large",
            /**
     * We don't expose this on `FadeIn` but it does get passed down.
     * TODO: figure out how we want to handle this...
     */ // @ts-ignore
            animationTimingFunction: "ease-out",
            children: ({ className: className })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $3f9bcdd54fee8283$var$styles.blanket,
                        className
                    ]),
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $zLbDw.default), {
                        isTinted: true,
                        onBlanketClicked: onBlanketClicked,
                        testId: testId && testId
                    })
                })
        })
    });
};
$3f9bcdd54fee8283$var$Blanket.displayName = "Blanket";
var $3f9bcdd54fee8283$export$2e2bcd8739ae039 = $3f9bcdd54fee8283$var$Blanket;

});

parcelRegister("1EOHp", function(module, exports) {
$parcel$export(module.exports, "DrawerPanel", () => $fa7ef3c0645aee73$export$96114a266f19b4d0);
/* drawer-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $8L2z6 = parcelRequire("8L2z6");
var $5kyyj = parcelRequire("5kyyj");

var $3TZRG = parcelRequire("3TZRG");

var $1u2qL = parcelRequire("1u2qL");

var $8Pzuw = parcelRequire("8Pzuw");
const $fa7ef3c0645aee73$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $fa7ef3c0645aee73$var$styles = {
    root: "_1reo15vq _18m915vq _1e0c1txw _4t3i1kxc _kqsw1n9t _1pbybfng _bfhk1bhr _1q1l1bhr _152tze3t _1e02ze3t _ect4ttxp",
    full: "_1bsbauwl",
    extended: "_1bsb1mwr",
    narrow: "_1bsb1gwv",
    medium: "_1bsb1y37",
    wide: "_1bsb1ogm"
}; /**
    * This wrapper is used to specify separate durations for enter and exit.
    */ 
const $fa7ef3c0645aee73$var$CustomSlideIn = ({ children: children, onFinish: onFinish, enterFrom: enterFrom })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5kyyj.default), {
        animationTimingFunction: "ease-out",
        duration: "small",
        enterFrom: enterFrom,
        exitTo: enterFrom,
        fade: "none",
        onFinish: onFinish,
        children: children
    });
}; /**
    * __Drawer panel__
    */ 
$fa7ef3c0645aee73$var$CustomSlideIn.displayName = "CustomSlideIn";
const $fa7ef3c0645aee73$export$96114a266f19b4d0 = ({ children: children, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, testId: testId, isOpen: isOpen, shouldReturnFocus: shouldReturnFocus, autoFocusFirstElem: autoFocusFirstElem, isFocusLockEnabled: isFocusLockEnabled, width: width = 'narrow', label: label, titleId: titleId, enterFrom: enterFrom = 'left' })=>{
    /**
   * A ref to point to our wrapper, passed to `onCloseComplete` and `onOpenComplete` callbacks.
   */ const drawerRef = (0, $euxye.useRef)(null);
    const onFinish = (0, $euxye.useCallback)((state)=>{
        if (state === 'entering') onOpenComplete?.(drawerRef.current);
        else if (state === 'exiting') onCloseComplete?.(drawerRef.current);
    }, [
        onCloseComplete,
        onOpenComplete
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
        appear: true,
        children: isOpen && /*#__PURE__*/ (0, $e79Pd.jsx)($fa7ef3c0645aee73$var$CustomSlideIn, {
            onFinish: onFinish,
            enterFrom: enterFrom,
            children: ({ className: className })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Pzuw.default), {
                    autoFocusFirstElem: autoFocusFirstElem,
                    isFocusLockEnabled: isFocusLockEnabled,
                    shouldReturnFocus: shouldReturnFocus,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    , {
                        className: (0, $4jQY2.default)([
                            $fa7ef3c0645aee73$var$styles.root,
                            $fa7ef3c0645aee73$var$styles[width],
                            className
                        ]),
                        "data-testid": testId,
                        ref: drawerRef,
                        "aria-modal": true,
                        role: "dialog",
                        "aria-label": label,
                        "aria-labelledby": titleId,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3TZRG.EnsureIsInsideDrawerContext).Provider, {
                            value: true,
                            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1u2qL.OnCloseContext).Provider, {
                                value: onClose,
                                children: children
                            })
                        })
                    })
                })
        })
    });
};
$fa7ef3c0645aee73$export$96114a266f19b4d0.displayName = "DrawerPanel";

});
parcelRegister("3TZRG", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsideDrawerContext", () => $83bace1627bcfb65$export$e3662b8677049786);

var $euxye = parcelRequire("euxye");
const $83bace1627bcfb65$export$e3662b8677049786 = /*#__PURE__*/ (0, $euxye.createContext)(false);

});

parcelRegister("1u2qL", function(module, exports) {
$parcel$export(module.exports, "OnCloseContext", () => $9c3a2c0b3408e9cc$export$7376ab1fc7707bdd);

var $euxye = parcelRequire("euxye");
const $9c3a2c0b3408e9cc$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});

parcelRegister("8Pzuw", function(module, exports) {
$parcel$export(module.exports, "default", () => $3aa7794a9d82fd9e$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $g6TgS = parcelRequire("g6TgS");
/**
 * __Focus lock__
 *
 * Thin wrapper around react-focus-lock.
 */ const $3aa7794a9d82fd9e$var$FocusLock = ({ isFocusLockEnabled: isFocusLockEnabled = true, autoFocusFirstElem: autoFocusFirstElem = true, shouldReturnFocus: shouldReturnFocus = true, children: children })=>{
    const getFocusTarget = ()=>{
        if (typeof shouldReturnFocus === 'boolean') return shouldReturnFocus;
        return false;
    };
    const onDeactivation = ()=>{
        if (typeof shouldReturnFocus !== 'boolean') window.setTimeout(()=>{
            shouldReturnFocus?.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $g6TgS.default), {
        disabled: !isFocusLockEnabled,
        autoFocus: autoFocusFirstElem,
        returnFocus: getFocusTarget(),
        onDeactivation: onDeactivation,
        children: children
    });
};
$3aa7794a9d82fd9e$var$FocusLock.displayName = "FocusLock";
var $3aa7794a9d82fd9e$export$2e2bcd8739ae039 = $3aa7794a9d82fd9e$var$FocusLock;

});



parcelRegister("fyJ3d", function(module, exports) {
$parcel$export(module.exports, "DrawerContent", () => $236d03e4326b5c61$export$57ca055474bc0056);
/* drawer-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $jr1Vl = parcelRequire("jr1Vl");

var $50OIz = parcelRequire("50OIz");

var $eYpfY = parcelRequire("eYpfY");

var $lcARw = parcelRequire("lcARw");
const $236d03e4326b5c61$var$styles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug _19pk1ejb"
};
const $236d03e4326b5c61$var$DrawerContentBase = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, scrollContentLabel: scrollContentLabel = 'Scrollable content', xcss: xcss }, scrollableRef)=>{
    const [showContentFocus, setContentFocus] = (0, $euxye.useState)(false);
    const ref = (0, $euxye.useRef)(null);
    (0, $euxye.useEffect)(()=>{
        const setLazyContentFocus = ()=>{
            const target = ref.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        };
        setLazyContentFocus();
    }, []);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            $236d03e4326b5c61$var$styles.default,
            xcss
        ]),
        ref: (0, $50OIz.mergeRefs)([
            ref,
            scrollableRef
        ]),
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? scrollContentLabel : undefined,
        "data-testid": "drawer-contents",
        children: children
    });
});
const $236d03e4326b5c61$export$57ca055474bc0056 = ({ children: children, scrollContentLabel: scrollContentLabel, xcss: xcss })=>{
    (0, $eYpfY.useEnsureIsInsideDrawer)();
    (0, $lcARw.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jr1Vl))), {
        children: /*#__PURE__*/ (0, $e79Pd.jsx)($236d03e4326b5c61$var$DrawerContentBase, {
            scrollContentLabel: scrollContentLabel,
            xcss: xcss,
            children: children
        })
    });
};
$236d03e4326b5c61$export$57ca055474bc0056.displayName = "DrawerContent";

});
parcelRegister("eYpfY", function(module, exports) {
$parcel$export(module.exports, "useEnsureIsInsideDrawer", () => $4df8de78c9a1d407$export$780b9799f6bfecd8);

var $euxye = parcelRequire("euxye");

var $jiTLE = parcelRequire("jiTLE");

var $3TZRG = parcelRequire("3TZRG");
const $4df8de78c9a1d407$export$780b9799f6bfecd8 = ()=>{
    const context = (0, $euxye.useContext)((0, $3TZRG.EnsureIsInsideDrawerContext));
    (0, $jiTLE.default)(context, 'Drawer sub-components must be used within a Drawer component.');
};

});

parcelRegister("lcARw", function(module, exports) {
$parcel$export(module.exports, "default", () => $be4c93ddac53d205$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $glbdM = parcelRequire("glbdM");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 * ⚠️ This is copied from `packages/design-system/modal-dialog/src/internal/hooks/use-prevent-programmatic-scroll.tsx`
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $be4c93ddac53d205$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $be4c93ddac53d205$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $euxye.useState)(0);
    (0, $euxye.useLayoutEffect)(()=>{
        setScrollTopOffset($be4c93ddac53d205$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $euxye.useCallback)(()=>{
        if ($be4c93ddac53d205$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $euxye.useEffect)(()=>{
        return (0, $glbdM.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("3mYdc", function(module, exports) {
$parcel$export(module.exports, "CommonFlag", () => $9ecfb55d7f5c8e8b$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $9ecfb55d7f5c8e8b$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $9ecfb55d7f5c8e8b$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $9ecfb55d7f5c8e8b$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $9ecfb55d7f5c8e8b$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $9ecfb55d7f5c8e8b$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $9ecfb55d7f5c8e8b$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $9ecfb55d7f5c8e8b$export$a2c3479950310d7d);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $bafqJ = parcelRequire("bafqJ");

var $l8G1z = parcelRequire("l8G1z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9ecfb55d7f5c8e8b$var$ForPaintJiraCommonFlag = (0, $l8G1z.lazyForPaint)(()=>(parcelRequire("2Twak")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9ecfb55d7f5c8e8b$var$AfterPaintJiraCommonFlag = (0, $l8G1z.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("2Twak")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $9ecfb55d7f5c8e8b$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$ForPaintJiraCommonFlag, props);
$9ecfb55d7f5c8e8b$var$CommonFlagImpl.displayName = "CommonFlagImpl";

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9ecfb55d7f5c8e8b$var$ForPaintFlagGroup = (0, $l8G1z.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aGnrh")), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9ecfb55d7f5c8e8b$var$AfterPaintFlagGroup = (0, $l8G1z.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aGnrh")), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $9ecfb55d7f5c8e8b$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$ForPaintFlagGroup, props);
$9ecfb55d7f5c8e8b$var$FlagGroupImpl.displayName = "FlagGroupImpl";
const $9ecfb55d7f5c8e8b$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, props));
$9ecfb55d7f5c8e8b$export$13d73238a031436b.displayName = "CommonFlag";
const $9ecfb55d7f5c8e8b$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
$9ecfb55d7f5c8e8b$export$518ba8e0e60f145f.displayName = "ErrorFlag";
const $9ecfb55d7f5c8e8b$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
$9ecfb55d7f5c8e8b$export$3f75672bb90a4431.displayName = "ErrorAutoDismissFlag";
const $9ecfb55d7f5c8e8b$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
$9ecfb55d7f5c8e8b$export$6a55b52e74c1e48e.displayName = "InfoFlag";
const $9ecfb55d7f5c8e8b$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
$9ecfb55d7f5c8e8b$export$74a3c0748aa31355.displayName = "SuccessAutoDismissFlag";
const $9ecfb55d7f5c8e8b$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
$9ecfb55d7f5c8e8b$export$93bd4963a1d00fd5.displayName = "SuccessFlag";
const $9ecfb55d7f5c8e8b$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
$9ecfb55d7f5c8e8b$export$23695d8281998f27.displayName = "WarningFlag";
const $9ecfb55d7f5c8e8b$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bafqJ.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($9ecfb55d7f5c8e8b$var$FlagGroupImpl, props));
$9ecfb55d7f5c8e8b$export$a2c3479950310d7d.displayName = "FlagGroup";

});
parcelRegister("2Twak", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("k0TqB")
]).then(()=>parcelRequire('498Ku'));

});

parcelRegister("aGnrh", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("4FwAF").then(()=>parcelRequire('f9iDp'));

});


parcelRegister("5KOJz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9414f4189dbcbb3b$export$2e2bcd8739ae039);
/* CreateSubpage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $hzWaA = parcelRequire("hzWaA");

var $a9o4s = parcelRequire("a9o4s");

var $iOfms = parcelRequire("iOfms");

var $fWb5q = parcelRequire("fWb5q");

var $hO3zy = parcelRequire("hO3zy");
var $bEwPd = parcelRequire("bEwPd");

var $1W2Av = parcelRequire("1W2Av");

var $7mtMc = parcelRequire("7mtMc");

var $2kZKn = parcelRequire("2kZKn");

var $dIqcw = parcelRequire("dIqcw");

var $7aCqr = parcelRequire("7aCqr");

var $2AAUS = parcelRequire("2AAUS");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");

var $drATu = parcelRequire("drATu");

var $1b6Nh = parcelRequire("1b6Nh");

var $eiO6t = parcelRequire("eiO6t");

var $kjKdI = parcelRequire("kjKdI");
const $9414f4189dbcbb3b$var$styles = {
    fullContainer: "_4t3i1osq"
};
const $9414f4189dbcbb3b$var$unknownErrorTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "We encountered an unknown error.",
    id: "applinks.administration.ui.unknown-error"
});
const $9414f4189dbcbb3b$var$createLinkTypeOAuth2NonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Atlassian product via OAuth 2.0",
    id: "applinks.administration.ui.creation-flow-dialog.create-link-type-oauth2-nonfinal"
});
const $9414f4189dbcbb3b$var$createLinkTypeOAuth1NonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Direct application link via OAuth 1.0",
    id: "applinks.administration.ui.creation-flow-dialog.create-link-type-oauth1-nonfinal"
});
const $9414f4189dbcbb3b$var$createLinkTypeTunnelNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Existing application tunnel",
    id: "applinks.administration.ui.creation-flow-dialog.create-link-type-tunnel-nonfinal"
});
const $9414f4189dbcbb3b$var$requiredFieldsTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Required fields are marked with an asterisk",
    id: "applinks.administration.ui.creation-flow-dialog.required-fields-text"
});
const $9414f4189dbcbb3b$var$cancelButtonTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Cancel",
    id: "applinks.administration.ui.creation-flow-dialog.cancel-form-button-text-nonfinal"
});
const $9414f4189dbcbb3b$var$nextButtonTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Next",
    id: "applinks.administration.ui.creation-flow-dialog.next-form-button-text-nonfinal"
});
const $9414f4189dbcbb3b$var$createApplicationLinkInformationTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "An application link requires an existing application tunnel or the application's URL. We use either one to connect the application to Jira.",
    id: "applinks.administration.ui.creation-flow-dialog.create-application-link-information-text-nonfinal"
});
const $9414f4189dbcbb3b$var$createApplicationLinkHowToLinkTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "How to create an application link",
    id: "appinks.administration.ui.creation-flow-dialog.create-application-link-how-to-text-nonfinal"
});
const $9414f4189dbcbb3b$var$createHeaderTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create an application link",
    id: "applinks.administration.ui.creation-flow-dialog.create-header-text-nonfinal"
});
const $9414f4189dbcbb3b$var$createSupportedLinkTypesHelperMessageNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Check the application's documentation for supported link types",
    id: "applinks.administration.ui.creation-flow-dialog.create-supported-link-types-helper-message-nonfinal"
});
const $9414f4189dbcbb3b$var$createUrlEntryHelperMessageNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Enter the URL for the Atlassian product",
    id: "applinks.administration.ui.creation-flow-dialog.create-url-entry-helper-message-nonfinal"
});
const $9414f4189dbcbb3b$var$createInvalidUrlErrorMessageNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "You must enter a valid URL",
    id: "applinks.administration.ui.creation-flow-dialog.create-invalid-url-error-message-nonfinal"
});
const $9414f4189dbcbb3b$var$CreateSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const createLocalisedRadioOptions = (0, $euxye.useCallback)(()=>{
        const linkTypeRadioOptions = [
            {
                name: 'linkType',
                value: 'OAUTH2.0',
                label: formatMessage($9414f4189dbcbb3b$var$createLinkTypeOAuth2NonfinalMessage)
            },
            {
                name: 'linkType',
                value: 'OAUTH1.0',
                label: formatMessage($9414f4189dbcbb3b$var$createLinkTypeOAuth1NonfinalMessage)
            },
            {
                name: 'linkType',
                value: 'TUNNEL',
                label: formatMessage($9414f4189dbcbb3b$var$createLinkTypeTunnelNonfinalMessage)
            }
        ];
        return linkTypeRadioOptions;
    }, [
        formatMessage
    ]);
    const onFormSubmit = async (data)=>{
        try {
            const remoteManifestPromise = (0, $drATu.fetchApplinkManifestForUrl)(data.remoteUrl);
            const localManifestPromise = (0, $drATu.fetchThisManifest)();
            const remoteManifest = await remoteManifestPromise;
            const localManifest = await localManifestPromise; // Check the remote application supports the selected variant type
            if (data.linkType === 'OAUTH2.0' && !remoteManifest.inboundAuthenticationTypes.includes((0, $1b6Nh.APPLINKS_IS_OAUTH2_SUPPORTED_PROVIDER_CHECK))) // TODO: Better error message - maybe a custom dialogue?
            throw new Error('The remote application does not support OAuth 2.0 authentication. Please select a different link type.');
            props.onSuccess({
                kind: 'review',
                variant: data.linkType,
                localManifest: localManifest,
                remoteManifest: remoteManifest,
                rpcUrl: data.remoteUrl
            });
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            if (data.linkType === 'OAUTH1.0') {
                if ((0, $i860n.fg)('applinks-1093-redirect-error-fix')) props.onSuccess({
                    kind: 'manual-create',
                    variant: 'OAUTH1.0',
                    error: (0, $kjKdI.formatBackendError)(maybeError, formatMessage($9414f4189dbcbb3b$var$unknownErrorTextMessage))
                });
                else props.onSuccess({
                    kind: 'manual-create',
                    variant: 'OAUTH1.0',
                    error: maybeError ? maybeError.message : formatMessage($9414f4189dbcbb3b$var$unknownErrorTextMessage)
                });
            } else {
                (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.list.creation-flow-dialog.create.submitCreateForm', 'Failed to submit create form', maybeError);
                if ((0, $i860n.fg)('applinks-1093-redirect-error-fix')) props.onError((0, $kjKdI.formatBackendError)(maybeError, formatMessage($9414f4189dbcbb3b$var$unknownErrorTextMessage)));
                else props.onError(maybeError ? maybeError.message : formatMessage($9414f4189dbcbb3b$var$unknownErrorTextMessage));
            }
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fWb5q.default), {
        onSubmit: onFormSubmit,
        xcss: $9414f4189dbcbb3b$var$styles.fullContainer
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eiO6t.SubpageTemplate), {
            variant: null,
            kind: "create",
            buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), {
                label: "Form submit options"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
                appearance: "subtle",
                onClick: props.onCancel
            }, formatMessage($9414f4189dbcbb3b$var$cancelButtonTextNonfinalMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
                type: "submit",
                appearance: "primary",
                isLoading: submitting
            }, formatMessage($9414f4189dbcbb3b$var$nextButtonTextNonfinalMessage))),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7mtMc.default), {
                title: formatMessage($9414f4189dbcbb3b$var$createHeaderTextNonfinalMessage)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), null, `${formatMessage($9414f4189dbcbb3b$var$createApplicationLinkInformationTextNonfinalMessage)} `, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                href: "https://support.atlassian.com/jira-cloud-administration/docs/use-applinks-to-link-to-atlassian-products/",
                target: "_blank"
            }, ' ', formatMessage($9414f4189dbcbb3b$var$createApplicationLinkHowToLinkTextNonfinalMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
                size: "small"
            }, formatMessage($9414f4189dbcbb3b$var$requiredFieldsTextMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dIqcw.default), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2kZKn.default), {
                title: "Application link type"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
                label: "Link type",
                name: "linkType",
                defaultValue: "OAUTH2.0",
                isRequired: true
            }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2AAUS.default), {
                    ...fieldProps,
                    options: createLocalisedRadioOptions()
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEwPd.HelperMessage), null, formatMessage($9414f4189dbcbb3b$var$createSupportedLinkTypesHelperMessageNonfinalMessage))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2kZKn.default), {
                title: "External application details"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
                name: "remoteUrl",
                label: "Application URL",
                isRequired: true
            }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
                    autoComplete: "off",
                    placeholder: "https://example.atlassian.net",
                    ...fieldProps
                }), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEwPd.HelperMessage), null, formatMessage($9414f4189dbcbb3b$var$createUrlEntryHelperMessageNonfinalMessage)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO3zy.ErrorMessage), null, formatMessage($9414f4189dbcbb3b$var$createInvalidUrlErrorMessageNonfinalMessage))))))
        })));
};
$9414f4189dbcbb3b$var$CreateSubpage.displayName = "CreateSubpage";
var $9414f4189dbcbb3b$export$2e2bcd8739ae039 = $9414f4189dbcbb3b$var$CreateSubpage;

});
parcelRegister("fWb5q", function(module, exports) {
$parcel$export(module.exports, "default", () => $7076ccab54f0973c$export$2e2bcd8739ae039);
/* form.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $bnT8S = parcelRequire("bnT8S");

var $5fdMm = parcelRequire("5fdMm");

var $lGUEP = parcelRequire("lGUEP");

var $lpQqY = parcelRequire("lpQqY");

var $ljVHR = parcelRequire("ljVHR");

var $edeJn = parcelRequire("edeJn");

var $iV868 = parcelRequire("iV868");

var $k5Y8Z = parcelRequire("k5Y8Z");
const $7076ccab54f0973c$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $euxye.useRef)(null);
    const onSubmitRef = (0, $euxye.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $euxye.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $bnT8S.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($lGUEP)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($lGUEP)))(values, name, value);
                    }
                }
            }
        });
        (0, $5fdMm.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $k5Y8Z.getFirstErrorField))(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $euxye.useState)({
        dirty: false,
        submitting: false
    });
    (0, $euxye.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $euxye.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ const getCurrentValue = (0, $euxye.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $euxye.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    };
    // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $ljVHR.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                resetFieldState: form.resetFieldState
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, $e79Pd.jsx)("form", {
            ...formProps,
            ...userProvidedFormProps,
            children: children
        });
    })();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $edeJn.FormContext).Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $iV868.IsDisabledContext).Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
};
$7076ccab54f0973c$var$FormBase.displayName = "FormBase";
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $7076ccab54f0973c$var$Form = (0, $lpQqY.default)($7076ccab54f0973c$var$FormBase);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$7076ccab54f0973c$export$2e2bcd8739ae039 = $7076ccab54f0973c$var$Form;

});
parcelRegister("bnT8S", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $849c9dc486c6c0b4$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $849c9dc486c6c0b4$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $849c9dc486c6c0b4$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $849c9dc486c6c0b4$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $849c9dc486c6c0b4$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $849c9dc486c6c0b4$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $849c9dc486c6c0b4$export$f681a8129d2e9d28);

var $jimAf = parcelRequire("jimAf");

var $2rVEs = parcelRequire("2rVEs");
//      
var $849c9dc486c6c0b4$var$charCodeOfDot = ".".charCodeAt(0);
var $849c9dc486c6c0b4$var$reEscapeChar = /\\(\\)?/g;
var $849c9dc486c6c0b4$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $849c9dc486c6c0b4$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $849c9dc486c6c0b4$var$charCodeOfDot) result.push("");
    string.replace($849c9dc486c6c0b4$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($849c9dc486c6c0b4$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $849c9dc486c6c0b4$var$keysCache = {};
var $849c9dc486c6c0b4$var$keysRegex = /[.[\]]+/;
var $849c9dc486c6c0b4$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($849c9dc486c6c0b4$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $849c9dc486c6c0b4$var$keysCache[key] = key.split($849c9dc486c6c0b4$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $849c9dc486c6c0b4$var$keysCache[key] = $849c9dc486c6c0b4$var$stringToPath(key);
    }
    return $849c9dc486c6c0b4$var$keysCache[key];
};
//      
var $849c9dc486c6c0b4$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $849c9dc486c6c0b4$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $849c9dc486c6c0b4$var$_toPropertyKey(arg) {
    var key = $849c9dc486c6c0b4$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $849c9dc486c6c0b4$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $849c9dc486c6c0b4$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $2rVEs.default)(current, [
                key
            ].map($849c9dc486c6c0b4$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $jimAf.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $849c9dc486c6c0b4$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $849c9dc486c6c0b4$var$setInRecursor(state, 0, $849c9dc486c6c0b4$var$toPath(key), value1, destroyArrays);
};
var $849c9dc486c6c0b4$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $849c9dc486c6c0b4$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $849c9dc486c6c0b4$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $849c9dc486c6c0b4$export$c52e5867d5879e24(values, name);
    var error = $849c9dc486c6c0b4$export$c52e5867d5879e24(errors, name);
    if (error && error[$849c9dc486c6c0b4$export$735bebc8ffabf28a]) error = error[$849c9dc486c6c0b4$export$735bebc8ffabf28a];
    var submitError = submitErrors && $849c9dc486c6c0b4$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $849c9dc486c6c0b4$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($849c9dc486c6c0b4$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $849c9dc486c6c0b4$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $849c9dc486c6c0b4$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $849c9dc486c6c0b4$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$849c9dc486c6c0b4$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $849c9dc486c6c0b4$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $849c9dc486c6c0b4$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $849c9dc486c6c0b4$var$subscriptionFilter(result, state, previousState, subscription, $849c9dc486c6c0b4$export$41e855cb628c1b55, $849c9dc486c6c0b4$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $849c9dc486c6c0b4$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $849c9dc486c6c0b4$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $849c9dc486c6c0b4$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $849c9dc486c6c0b4$var$subscriptionFilter(result, state, previousState, subscription, $849c9dc486c6c0b4$export$f1ff97b9d1c7a3c3, $849c9dc486c6c0b4$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $849c9dc486c6c0b4$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$849c9dc486c6c0b4$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $849c9dc486c6c0b4$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $849c9dc486c6c0b4$export$83d89fbfd8236492 = "4.20.10";
var $849c9dc486c6c0b4$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $849c9dc486c6c0b4$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $849c9dc486c6c0b4$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $849c9dc486c6c0b4$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $849c9dc486c6c0b4$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $849c9dc486c6c0b4$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $849c9dc486c6c0b4$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $849c9dc486c6c0b4$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($849c9dc486c6c0b4$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $849c9dc486c6c0b4$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $jimAf.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $jimAf.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $jimAf.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $jimAf.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $jimAf.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $849c9dc486c6c0b4$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $849c9dc486c6c0b4$export$e6bdf135a54e021b,
                    shallowEqual: $849c9dc486c6c0b4$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $jimAf.default)({}, state.formState.values)); // clone to avoid writing
            if ($849c9dc486c6c0b4$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $849c9dc486c6c0b4$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $849c9dc486c6c0b4$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $jimAf.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $jimAf.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $849c9dc486c6c0b4$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $849c9dc486c6c0b4$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $849c9dc486c6c0b4$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$849c9dc486c6c0b4$export$735bebc8ffabf28a]) {
                    var existing = $849c9dc486c6c0b4$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$849c9dc486c6c0b4$export$735bebc8ffabf28a] = error[$849c9dc486c6c0b4$export$735bebc8ffabf28a];
                    merged = $849c9dc486c6c0b4$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$849c9dc486c6c0b4$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$849c9dc486c6c0b4$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $jimAf.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $849c9dc486c6c0b4$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $849c9dc486c6c0b4$var$notify(fieldSubscriber, fieldState, lastFieldState, $849c9dc486c6c0b4$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $849c9dc486c6c0b4$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $jimAf.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($849c9dc486c6c0b4$export$c52e5867d5879e24(formState.values, key), $849c9dc486c6c0b4$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($849c9dc486c6c0b4$export$c52e5867d5879e24(formState.values, key), $849c9dc486c6c0b4$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$849c9dc486c6c0b4$var$hasAnyError(formState.errors) && !(formState.submitErrors && $849c9dc486c6c0b4$var$hasAnyError(formState.submitErrors));
        var nextFormState = $849c9dc486c6c0b4$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $849c9dc486c6c0b4$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $849c9dc486c6c0b4$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $849c9dc486c6c0b4$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $849c9dc486c6c0b4$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $849c9dc486c6c0b4$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $849c9dc486c6c0b4$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $849c9dc486c6c0b4$var$notify(state.subscribers, nextFormState, lastFormState, $849c9dc486c6c0b4$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $jimAf.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($849c9dc486c6c0b4$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $jimAf.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $jimAf.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($849c9dc486c6c0b4$export$c52e5867d5879e24(formState.values, key), $849c9dc486c6c0b4$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $849c9dc486c6c0b4$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $849c9dc486c6c0b4$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $849c9dc486c6c0b4$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.values, name) === $849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $849c9dc486c6c0b4$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $849c9dc486c6c0b4$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $jimAf.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $jimAf.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $jimAf.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $849c9dc486c6c0b4$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$849c9dc486c6c0b4$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $jimAf.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $849c9dc486c6c0b4$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $849c9dc486c6c0b4$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $849c9dc486c6c0b4$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $849c9dc486c6c0b4$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("5fdMm", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d190aab65da16cf$export$2e2bcd8739ae039);

var $bnT8S = parcelRequire("bnT8S");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3d190aab65da16cf$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3d190aab65da16cf$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3d190aab65da16cf$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3d190aab65da16cf$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $bnT8S.getIn)(errors, input.name);
    });
};
//      
var $3d190aab65da16cf$var$noop = function noop() {};
var $3d190aab65da16cf$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3d190aab65da16cf$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3d190aab65da16cf$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3d190aab65da16cf$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3d190aab65da16cf$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3d190aab65da16cf$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3d190aab65da16cf$export$2e2bcd8739ae039 = $3d190aab65da16cf$var$createDecorator;

});

parcelRegister("lGUEP", function(module, exports) {

var $9QIfm = parcelRequire("9QIfm");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $fca978341a2a3489$var$set(object, path, value) {
    return object == null ? object : $9QIfm(object, path, value);
}
module.exports = $fca978341a2a3489$var$set;

});

parcelRegister("edeJn", function(module, exports) {
$parcel$export(module.exports, "FormContext", () => $c43813f70010d7c1$export$c24727297075ec6a);

var $euxye = parcelRequire("euxye");
const $c43813f70010d7c1$export$c24727297075ec6a = /*#__PURE__*/ (0, $euxye.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});

});

parcelRegister("iV868", function(module, exports) {
$parcel$export(module.exports, "IsDisabledContext", () => $eb347834e1ddd675$export$c17cf6b332a82dbc);

var $euxye = parcelRequire("euxye");
const $eb347834e1ddd675$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $euxye.createContext)(false);

});

parcelRegister("k5Y8Z", function(module, exports) {
$parcel$export(module.exports, "getFirstErrorField", () => $e3c82af3a57208e4$export$fc06342dc8588d3b);

var $bnT8S = parcelRequire("bnT8S");
const $e3c82af3a57208e4$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $bnT8S.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $bnT8S.getIn)(errors, input.name);
    });
};

});


parcelRegister("hO3zy", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", () => $47c6f25278256f63$export$915e9e7bd4f0f96d);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $77m19 = parcelRequire("77m19");

var $h6Szh = parcelRequire("h6Szh");
const $47c6f25278256f63$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $77m19.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $h6Szh.default), {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
$47c6f25278256f63$export$915e9e7bd4f0f96d.displayName = "ErrorMessage";

});
parcelRegister("77m19", function(module, exports) {
$parcel$export(module.exports, "FieldId", () => $f65efbba82082874$export$3c4232819458a302);

var $euxye = parcelRequire("euxye");
const $f65efbba82082874$export$3c4232819458a302 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});

parcelRegister("h6Szh", function(module, exports) {
$parcel$export(module.exports, "default", () => $6688ec9f1e2016e0$export$2e2bcd8739ae039);
/* message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $ah9qo = parcelRequire("ah9qo");

var $8Qvei = parcelRequire("8Qvei");

var $bGCD7 = parcelRequire("bGCD7");
const $6688ec9f1e2016e0$var$messageStyles = null;
const $6688ec9f1e2016e0$var$messageAppearanceStyles = {
    default: "_syaz1rpy",
    error: "_syaz1tmw",
    valid: "_syazgsak"
};
const $6688ec9f1e2016e0$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $6688ec9f1e2016e0$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            $6688ec9f1e2016e0$var$iconWrapperStyles.root
        ]),
        children: children
    });
$6688ec9f1e2016e0$var$IconWrapper.displayName = "IconWrapper";
const $6688ec9f1e2016e0$var$messageIcons = {
    error: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ah9qo))), {
        color: "currentColor",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Qvei))), {
        color: "currentColor",
        label: "success",
        size: "small"
    })
};
/**
 * __Message__
 *
 * A message component for displaying messages in a form.
 */ const $6688ec9f1e2016e0$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $6688ec9f1e2016e0$var$messageIcons[appearance];
    const messageRef = (0, $euxye.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $euxye.useState)(false);
    const { isWrapper: isWrapper } = (0, $euxye.useContext)((0, $bGCD7.MessageWrapperContext));
    (0, $euxye.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $4jQY2.default)([
            "_zulp12x7 _11c8wadc _1e0c1txw _1bah1q9y _1pfh1b66",
            $6688ec9f1e2016e0$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $e79Pd.jsx)($6688ec9f1e2016e0$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
$6688ec9f1e2016e0$var$Message.displayName = "Message";
var $6688ec9f1e2016e0$export$2e2bcd8739ae039 = $6688ec9f1e2016e0$var$Message;

});
parcelRegister("bGCD7", function(module, exports) {
$parcel$export(module.exports, "MessageWrapperContext", () => $a6c189033ee3c435$export$579aef2c392a54d4);

var $euxye = parcelRequire("euxye");
const $a6c189033ee3c435$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $euxye.createContext)({
    isWrapper: false
});

});



parcelRegister("bEwPd", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", () => $82314cebc02df24a$export$8fbe3c7d0ed2c683);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $77m19 = parcelRequire("77m19");

var $h6Szh = parcelRequire("h6Szh");
const $82314cebc02df24a$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $77m19.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $h6Szh.default), {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
$82314cebc02df24a$export$8fbe3c7d0ed2c683.displayName = "HelperMessage";

});

parcelRegister("1W2Av", function(module, exports) {
$parcel$export(module.exports, "default", () => $7aec763f8417c8d8$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $gUxVT = parcelRequire("gUxVT");

var $hO3zy = parcelRequire("hO3zy");

var $77m19 = parcelRequire("77m19");

var $edeJn = parcelRequire("edeJn");

var $bEwPd = parcelRequire("bEwPd");

var $iV868 = parcelRequire("iV868");

var $ezcIL = parcelRequire("ezcIL");

var $ej7cp = parcelRequire("ej7cp");

var $dIqcw = parcelRequire("dIqcw");

var $fIwNV = parcelRequire("fIwNV");
const $7aec763f8417c8d8$var$fieldWrapperStyles = null;
function $7aec763f8417c8d8$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $7aec763f8417c8d8$var$isFunction(x) {
    return typeof x === 'function';
}
function $7aec763f8417c8d8$var$usePreviousRef(current) {
    const ref = (0, $euxye.useRef)(current);
    // will be updated on the next render
    (0, $euxye.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $7aec763f8417c8d8$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $7aec763f8417c8d8$export$2e2bcd8739ae039(props) {
    const { children: children = ()=>null, component: component } = props;
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $euxye.useContext)((0, $edeJn.FormContext));
    const isDisabled = (0, $euxye.useContext)((0, $iV868.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $7aec763f8417c8d8$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $7aec763f8417c8d8$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$7aec763f8417c8d8$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $euxye.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $7aec763f8417c8d8$var$usePreviousRef(state);
    (0, $euxye.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $7aec763f8417c8d8$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($7aec763f8417c8d8$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        props.isRequired,
        isDefaultValueChanged
    ]);
    const uid = (0, $gUxVT.useId)();
    const fieldId = (0, $euxye.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-required': String(Boolean(props.isRequired)),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $4jQY2.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ezcIL.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dIqcw.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $77m19.FieldId).Provider, {
                value: fieldId,
                children: component ? /*#__PURE__*/ (0, $e79Pd.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, {
                    children: [
                        component({
                            fieldProps: extendedFieldProps
                        }),
                        /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ej7cp.MessageWrapper), {
                            children: [
                                props.helperMessage && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bEwPd.HelperMessage), {
                                    children: props.helperMessage
                                }),
                                state.error && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $hO3zy.ErrorMessage), {
                                    children: props.errorMessage || state.error
                                }),
                                state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $fIwNV.ValidMessage), {
                                    children: props.validMessage
                                })
                            ]
                        })
                    ]
                }) : children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}
$7aec763f8417c8d8$export$2e2bcd8739ae039.displayName = "Field";

});
parcelRegister("ezcIL", function(module, exports) {
$parcel$export(module.exports, "Label", () => $dc9a4c530423281d$export$b04be29aa201d4f5);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $dc9a4c530423281d$var$fieldsetLabelStyles = null;
const $dc9a4c530423281d$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
$dc9a4c530423281d$export$b04be29aa201d4f5.displayName = "Label";

});

parcelRegister("ej7cp", function(module, exports) {
$parcel$export(module.exports, "MessageWrapper", () => $2982e572658bc45a$export$ec445f12f63100a5);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $bGCD7 = parcelRequire("bGCD7");
const $2982e572658bc45a$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $bGCD7.MessageWrapperContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};
$2982e572658bc45a$export$ec445f12f63100a5.displayName = "MessageWrapper";

});

parcelRegister("dIqcw", function(module, exports) {
$parcel$export(module.exports, "default", () => $06ba5f63b58a65ea$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $06ba5f63b58a65ea$var$requiredIndicatorStyles = null;
function $06ba5f63b58a65ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $4jQY2.default)([
            "_syaz1tmw _ect4ttxp _bozgv77o"
        ]),
        children: "*"
    });
}
$06ba5f63b58a65ea$export$2e2bcd8739ae039.displayName = "RequiredAsterisk";

});

parcelRegister("fIwNV", function(module, exports) {
$parcel$export(module.exports, "ValidMessage", () => $c589a24263be832e$export$5505afb209a532c8);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $77m19 = parcelRequire("77m19");

var $h6Szh = parcelRequire("h6Szh");
const $c589a24263be832e$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $77m19.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $h6Szh.default), {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
$c589a24263be832e$export$5505afb209a532c8.displayName = "ValidMessage";

});


parcelRegister("7mtMc", function(module, exports) {
$parcel$export(module.exports, "default", () => $c08823a811af7de4$export$2e2bcd8739ae039);
/* form-header.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-primitives */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2iotI = parcelRequire("2iotI");
const $c08823a811af7de4$var$formHeaderContentStyles = null;
const $c08823a811af7de4$var$formHeaderDescriptionStyles = null;
/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $c08823a811af7de4$var$FormHeader = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        children: [
            title && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                size: "large",
                children: title
            }),
            description && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    "_1pfhu2gc"
                ]),
                children: description
            }),
            children && /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    "_1ul91osq _1pfhu2gc"
                ]),
                children: children
            })
        ]
    });
};
$c08823a811af7de4$var$FormHeader.displayName = "FormHeader";
var $c08823a811af7de4$export$2e2bcd8739ae039 = $c08823a811af7de4$var$FormHeader;

});

parcelRegister("2kZKn", function(module, exports) {
$parcel$export(module.exports, "default", () => $def0b751cc8285bf$export$2e2bcd8739ae039);
/* form-section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2iotI = parcelRequire("2iotI");
const $def0b751cc8285bf$var$formSectionDescriptionStyles = null;
const $def0b751cc8285bf$var$formSectionWrapperStyles = null;
const $def0b751cc8285bf$var$FormSectionWrapper = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_1pfh1ejb"
        ]),
        children: children
    });
};
$def0b751cc8285bf$var$FormSectionWrapper.displayName = "FormSectionWrapper";
const $def0b751cc8285bf$var$FormSectionDescription = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        className: (0, $4jQY2.default)([
            "_1pfhu2gc"
        ]),
        children: children
    });
};
$def0b751cc8285bf$var$FormSectionDescription.displayName = "FormSectionDescription";
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $def0b751cc8285bf$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsxs)($def0b751cc8285bf$var$FormSectionWrapper, {
        children: [
            title && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2iotI.default), {
                size: "medium",
                children: title
            }),
            description && /*#__PURE__*/ (0, $e79Pd.jsx)($def0b751cc8285bf$var$FormSectionDescription, {
                children: description
            }),
            children
        ]
    });
};
$def0b751cc8285bf$var$FormSection.displayName = "FormSection";
var $def0b751cc8285bf$export$2e2bcd8739ae039 = $def0b751cc8285bf$var$FormSection;

});

parcelRegister("2AAUS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5696788832bf7c3$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");

var $gUxVT = parcelRequire("gUxVT");

var $jIAwl = parcelRequire("jIAwl");
const $e5696788832bf7c3$var$noOptions = [];
function $e5696788832bf7c3$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $e5696788832bf7c3$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, labelId: labelId, onInvalid: onInvalid = (0, $2oRWW.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $gUxVT.useId)();
    const [selectedValue, setSelectedValue] = (0, $euxye.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $euxye.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        role: "radiogroup",
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $euxye.createElement)((0, $jIAwl.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}
$e5696788832bf7c3$export$2e2bcd8739ae039.displayName = "RadioGroup";

});
parcelRegister("jIAwl", function(module, exports) {
$parcel$export(module.exports, "default", () => $92be7ae6f137f34a$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $aZBDA = parcelRequire("aZBDA");

var $2oRWW = parcelRequire("2oRWW");
const $92be7ae6f137f34a$var$packageName = "platform-pkg";
const $92be7ae6f137f34a$var$packageVersion = "0.0.0-use.local";
const $92be7ae6f137f34a$var$noop = (0, $2oRWW.default);
const $92be7ae6f137f34a$var$labelPaddingStyles = null;
const $92be7ae6f137f34a$var$labelStyles = null;
const $92be7ae6f137f34a$var$labelDisabledStyles = null;
const $92be7ae6f137f34a$var$radioBaseStyles = null;
const $92be7ae6f137f34a$var$radioInteractiveStyles = null;
const $92be7ae6f137f34a$var$radioDisabledStyles = null;
const $92be7ae6f137f34a$var$radioDisabledCheckedStyles = null;
const $92be7ae6f137f34a$var$radioInvalidStyles = null;
const $92be7ae6f137f34a$var$InnerRadio = /*#__PURE__*/ (0, $euxye.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $92be7ae6f137f34a$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $aZBDA.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $92be7ae6f137f34a$var$packageName,
        packageVersion: $92be7ae6f137f34a$var$packageVersion
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $4jQY2.default)([
            "_11c8fhey _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazi7uo",
            isDisabled && "_syaz1gmx _80om13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $4jQY2.default)([
                    "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _1151rsbi _1s6w5w2r _tqbwidpf _t9ec1soj _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai120g _1qdg120g _18postnw _aetrb3bt _1peq1xmd",
                    !isDisabled && "_iosijmqp _11jyjmqp _f3ett94y _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r",
                    isDisabled && "_80om13gf _1q6q187o _1151bk0g _1s6w2sac",
                    isDisabled && isChecked && "_tqbwt94y",
                    isInvalid && !isDisabled && "_1151s4qr _11jys4qr"
                ])
            }),
            label ? /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $92be7ae6f137f34a$var$Radio = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)($92be7ae6f137f34a$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $92be7ae6f137f34a$export$2e2bcd8739ae039 = $92be7ae6f137f34a$var$Radio;

});


parcelRegister("drATu", function(module, exports) {
$parcel$export(module.exports, "fetchApplinks", () => $80ed225ce4ec1d7c$export$7d33a91e6040b0be);
$parcel$export(module.exports, "fetchApplink", () => $80ed225ce4ec1d7c$export$83c7eee86d1c94d8);
$parcel$export(module.exports, "putApplinkOAuthOne3LOProvider", () => $80ed225ce4ec1d7c$export$3dacb27b68ab90a0);
$parcel$export(module.exports, "putApplinkOAuthOne2LOProvider", () => $80ed225ce4ec1d7c$export$5c11b39b43a73f24);
$parcel$export(module.exports, "fetchApplinkStatus", () => $80ed225ce4ec1d7c$export$c2ced85273a49248);
$parcel$export(module.exports, "putApplinkOAuth1Config", () => $80ed225ce4ec1d7c$export$6d608f63c710962a);
$parcel$export(module.exports, "fetchApplinkManifestForUrl", () => $80ed225ce4ec1d7c$export$5c23e2a46ea336ab);
$parcel$export(module.exports, "fetchThisManifest", () => $80ed225ce4ec1d7c$export$48b19736241944be);
$parcel$export(module.exports, "putApplink", () => $80ed225ce4ec1d7c$export$a125e209bab7ab22);
$parcel$export(module.exports, "deleteApplink", () => $80ed225ce4ec1d7c$export$feb8ae153e366f15);
$parcel$export(module.exports, "createOAuth2Applink", () => $80ed225ce4ec1d7c$export$66ba448fdbc72aae);
$parcel$export(module.exports, "updateApplinkV3", () => $80ed225ce4ec1d7c$export$56336a061718f25b);
$parcel$export(module.exports, "getOAuth2ConfigInfo", () => $80ed225ce4ec1d7c$export$5647ab3ff2444637);
$parcel$export(module.exports, "putOAuth2ConfigInfo", () => $80ed225ce4ec1d7c$export$d1898e36341527c0);
$parcel$export(module.exports, "autoConfigureApplinkConsumer", () => $80ed225ce4ec1d7c$export$9e76392093878436);

var $4fhEY = parcelRequire("4fhEY");

var $h2wCv = parcelRequire("h2wCv");

var $i860n = parcelRequire("i860n");

var $1b6Nh = parcelRequire("1b6Nh");
const $80ed225ce4ec1d7c$export$7d33a91e6040b0be = ()=>(0, $4fhEY.default)((0, $1b6Nh.APPLINKS_V3_QUERY_URL));
const $80ed225ce4ec1d7c$export$83c7eee86d1c94d8 = (id)=>(0, $4fhEY.default)((0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs') ? (0, $1b6Nh.APPLINKS_V3_CLOUD_CONNECTOR_QUERY_SINGULAR_URL)(id) : (0, $1b6Nh.APPLINKS_V3_QUERY_SINGULAR_URL)(id));
const $80ed225ce4ec1d7c$var$putApplinkProvider = (id, provider)=>(0, $4fhEY.default)(`/rest/applinks/3.0/applicationlink/${id}/authentication/provider`, {
        method: 'PUT',
        body: JSON.stringify({
            config: {},
            provider: provider
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$3dacb27b68ab90a0 = (id)=>$80ed225ce4ec1d7c$var$putApplinkProvider(id, 'com.atlassian.applinks.api.auth.types.OAuthAuthenticationProvider');
const $80ed225ce4ec1d7c$export$5c11b39b43a73f24 = (id)=>$80ed225ce4ec1d7c$var$putApplinkProvider(id, 'com.atlassian.applinks.api.auth.types.TwoLeggedOAuthAuthenticationProvider');
const $80ed225ce4ec1d7c$export$c2ced85273a49248 = (id)=>(0, $4fhEY.default)(`/rest/applinks/3.0/status/${id}`);
const $80ed225ce4ec1d7c$export$6d608f63c710962a = (id, oauthStatus)=>(0, $h2wCv.performPutRequest)(`/rest/applinks/3.0/status/${id}/oauth`, {
        body: JSON.stringify(oauthStatus),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$5c23e2a46ea336ab = (url)=>(0, $4fhEY.default)(`/rest/applinks/3.0/applicationlinkForm/manifest.json?url=${encodeURIComponent(url)}`);
const $80ed225ce4ec1d7c$export$48b19736241944be = ()=>(0, $4fhEY.default)('/rest/applinks/3.0/manifest.json');
const $80ed225ce4ec1d7c$export$a125e209bab7ab22 = (entity)=>(0, $4fhEY.default)('/rest/applinks/3.0/applicationlink', {
        method: 'PUT',
        body: JSON.stringify(entity),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$feb8ae153e366f15 = (id)=>(0, $4fhEY.default)(`/rest/applinks/3.0/applicationlink/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$66ba448fdbc72aae = (entity)=>(0, $4fhEY.default)('/rest/applinks/3.0/applinks', {
        method: 'POST',
        body: JSON.stringify(entity),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$56336a061718f25b = (id, entity)=>(0, $h2wCv.performPutRequest)(`/rest/applinks/3.0/applinks/${id}`, {
        body: JSON.stringify(entity),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$5647ab3ff2444637 = (id)=>(0, $4fhEY.default)(`/rest/applinks/3.0/applinks/${id}/oAuth2ConfigInfo`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$d1898e36341527c0 = (id, config)=>(0, $h2wCv.performPutRequest)(`/rest/applinks/3.0/applinks/${id}/oAuth2ConfigInfo`, {
        body: JSON.stringify(config),
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $80ed225ce4ec1d7c$export$9e76392093878436 = (id)=>(0, $4fhEY.default)(`/rest/applinks-oauth/1.0/applicationlink/${id}/authentication/consumer?autoConfigure=true`, {
        method: 'PUT',
        body: JSON.stringify({
            twoLOAllowed: true,
            executingTwoLOUser: null,
            twoLOImpersonationAllowed: false
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });

});
parcelRegister("1b6Nh", function(module, exports) {
$parcel$export(module.exports, "THIS_PRODUCT_NAME_STRING", () => $50e72a457c8c13e5$export$cb011d75c76c2448);
$parcel$export(module.exports, "APPLINKS_V3_QUERY_URL", () => $50e72a457c8c13e5$export$cb3573e4866c43b5);
$parcel$export(module.exports, "APPLINKS_V3_QUERY_SINGULAR_URL", () => $50e72a457c8c13e5$export$1f3cdd5be8767e2d);
$parcel$export(module.exports, "APPLINKS_V3_CLOUD_CONNECTOR_QUERY_SINGULAR_URL", () => $50e72a457c8c13e5$export$2927ddab97d46c37);
$parcel$export(module.exports, "APPLINKS_LIST_PAGE_URL_LEGACY", () => $50e72a457c8c13e5$export$2802d3ce755ebd3d);
$parcel$export(module.exports, "APPLINKS_LIST_PAGE_URL", () => $50e72a457c8c13e5$export$4b42a32ba8ad826e);
$parcel$export(module.exports, "APPLINKS_EDIT_PAGE_URL_FOR_ID", () => $50e72a457c8c13e5$export$d55239c5fe633298);
$parcel$export(module.exports, "APPLINKS_IS_OAUTH2_SUPPORTED_PROVIDER_CHECK", () => $50e72a457c8c13e5$export$2b004bc5d3a0b021);
const $50e72a457c8c13e5$export$cb011d75c76c2448 = 'Jira';
const $50e72a457c8c13e5$export$cb3573e4866c43b5 = '/rest/applinks/3.0/applinks?data=applicationVersion&data=atlassian&data=configUrl&data=iconUri&data=editable&data=v3Editable&data=webItems';
const $50e72a457c8c13e5$export$1f3cdd5be8767e2d = (id)=>`/rest/applinks/3.0/applinks/${id}?data=applicationVersion&data=atlassian&data=configUrl&data=iconUri&data=editable&data=v3Editable&data=webItems`;
const $50e72a457c8c13e5$export$2927ddab97d46c37 = (id)=>`${$50e72a457c8c13e5$export$1f3cdd5be8767e2d(id)}&property=CLOUD_CONNECTOR_PRODUCT_CONNECTION_ID`;
const $50e72a457c8c13e5$export$2802d3ce755ebd3d = '/plugins/servlet/applinks/listApplicationLinks';
const $50e72a457c8c13e5$export$4b42a32ba8ad826e = '/jira/settings/applinks';
const $50e72a457c8c13e5$export$d55239c5fe633298 = (id)=>`/jira/settings/applinks/${id}/edit`;
const $50e72a457c8c13e5$export$2b004bc5d3a0b021 = 'com.atlassian.applinks.api.auth.types.ThreeLeggedOAuth2AuthenticationProvider';

});


parcelRegister("eiO6t", function(module, exports) {
$parcel$export(module.exports, "SubpageTemplate", () => $09290548e7b73bb7$export$10a563abcf67156);
/* SubpageTemplate.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");

var $4CTxE = parcelRequire("4CTxE");

var $ihEDU = parcelRequire("ihEDU");
var $2XXtG = parcelRequire("2XXtG");
var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");

var $7hCmd = parcelRequire("7hCmd");

var $i68tN = parcelRequire("i68tN");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $09290548e7b73bb7$var$styles = {
    container: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _4t3i1osq",
    mainContentInner: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1c3h",
    mainContent: "_16jlkb7n _1o9zidpf _i0dl1wug _ca0qxy5q _u5f3pxbi _n3tdxy5q _19bvpxbi",
    footerContent: "_1o9zidpf",
    footerContentInner: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1c3h",
    dividerStyle: "_189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq _19pkpxbi"
};
const $09290548e7b73bb7$var$UNKNOWN_STEP_ORDER = [
    'create',
    'unknown'
];
const $09290548e7b73bb7$var$OAUTH1_STEP_ORDER = [
    'create',
    'review',
    'reciprocal-prompt',
    'confirmation'
];
const $09290548e7b73bb7$var$OAUTH2_STEP_ORDER = [
    'create',
    'review',
    'connect'
];
const $09290548e7b73bb7$var$createStepNameMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create link",
    id: "applinks.administration.ui.creation-flow-dialog.create-step-name"
});
const $09290548e7b73bb7$var$reviewStepNameMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Review link",
    id: "applinks.administration.ui.creation-flow-dialog.review-step-name"
});
const $09290548e7b73bb7$var$reciprocalPromptStepNameNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create reciprocal link",
    id: "applinks.administration.ui.creation-flow-dialog.reciprocal-prompt-name"
});
const $09290548e7b73bb7$var$connectStepNameMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Configure link",
    id: "applinks.administration.ui.creation-flow-dialog.connect-step-name"
});
const $09290548e7b73bb7$var$confirmationStepNameNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Confirmation",
    id: "applinks.administration.ui.creation-flow-dialog.confirmation-step-name"
});
const $09290548e7b73bb7$var$unknownStepNameNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Configure link",
    id: "applinks.administration.ui.creation-flow-dialog.unknown-step-name"
});
const $09290548e7b73bb7$var$stepNames = {
    create: $09290548e7b73bb7$var$createStepNameMessage,
    review: $09290548e7b73bb7$var$reviewStepNameMessage,
    'reciprocal-prompt': $09290548e7b73bb7$var$reciprocalPromptStepNameNonfinalMessage,
    connect: $09290548e7b73bb7$var$connectStepNameMessage,
    confirmation: $09290548e7b73bb7$var$confirmationStepNameNonfinalMessage,
    unknown: $09290548e7b73bb7$var$unknownStepNameNonfinalMessage
};
const $09290548e7b73bb7$var$determineStepPercentage = (currentStep, targetStep, sequence)=>{
    if (currentStep === 'manual-create' && targetStep === 'create') return 50; // Special case for manual create step
    const currentIndex = sequence.indexOf(currentStep);
    const targetIndex = sequence.indexOf(targetStep);
    if (currentIndex > targetIndex) return 100;
    if (currentIndex === targetIndex) return 0;
    return 0;
};
const $09290548e7b73bb7$var$determineStepStatus = (currentStep, targetStep, sequence)=>{
    if (currentStep === 'manual-create' && targetStep === 'create') return 'current'; // Special case for manual create step
    const currentIndex = sequence.indexOf(currentStep);
    const targetIndex = sequence.indexOf(targetStep);
    if (currentIndex > targetIndex) return 'disabled';
    if (currentIndex === targetIndex) return 'current';
    return 'unvisited';
};
const $09290548e7b73bb7$var$buildSteps = (step, sequence, formatMessage)=>{
    return sequence.map((s)=>({
            id: s,
            label: formatMessage($09290548e7b73bb7$var$stepNames[s]),
            percentageComplete: $09290548e7b73bb7$var$determineStepPercentage(step, s, sequence),
            status: $09290548e7b73bb7$var$determineStepStatus(step, s, sequence),
            href: '#'
        }));
};
const $09290548e7b73bb7$var$buildProgressTrackerItems = (step, variant, formatMessage)=>{
    if (variant === null) return $09290548e7b73bb7$var$buildSteps(step, $09290548e7b73bb7$var$UNKNOWN_STEP_ORDER, formatMessage);
    switch(variant){
        case 'OAUTH1.0':
            return $09290548e7b73bb7$var$buildSteps(step, $09290548e7b73bb7$var$OAUTH1_STEP_ORDER, formatMessage);
        case 'TUNNEL':
            return $09290548e7b73bb7$var$buildSteps(step, $09290548e7b73bb7$var$OAUTH1_STEP_ORDER, formatMessage);
        // Tunnel uses the same steps as OAUTH1.0
        case 'OAUTH2.0':
            return $09290548e7b73bb7$var$buildSteps(step, $09290548e7b73bb7$var$OAUTH2_STEP_ORDER, formatMessage);
        default:
            return [];
    }
};
const $09290548e7b73bb7$export$8b251419efc915eb = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const getItems = (0, $euxye.useCallback)(()=>{
        return $09290548e7b73bb7$var$buildProgressTrackerItems(props.kind, props.variant, formatMessage);
    }, [
        formatMessage,
        props.kind,
        props.variant
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4CTxE.DrawerCloseButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i68tN)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7hCmd.default), {
        items: getItems(),
        spacing: "comfortable"
    }));
};
$09290548e7b73bb7$export$8b251419efc915eb.displayName = "Header";
const $09290548e7b73bb7$export$a06f1c675e846f6f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        xcss: $09290548e7b73bb7$var$styles.footerContentInner,
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        alignInline: "end",
        space: "space.050"
    }, props.buttons));
};
$09290548e7b73bb7$export$a06f1c675e846f6f.displayName = "Footer";
const $09290548e7b73bb7$export$10a563abcf67156 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2XXtG.default), {
        xcss: $09290548e7b73bb7$var$styles.container,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($09290548e7b73bb7$export$8b251419efc915eb, {
        variant: props.variant,
        kind: props.kind
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("hr", {
        role: "presentation",
        className: (0, $4jQY2.default)([
            $09290548e7b73bb7$var$styles.dividerStyle
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $09290548e7b73bb7$var$styles.mainContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ihEDU.default), {
        xcss: $09290548e7b73bb7$var$styles.mainContentInner
    }, props.content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        xcss: $09290548e7b73bb7$var$styles.footerContent,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("hr", {
        role: "presentation",
        className: (0, $4jQY2.default)([
            $09290548e7b73bb7$var$styles.dividerStyle
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($09290548e7b73bb7$export$a06f1c675e846f6f, {
        buttons: props.buttons
    })));
$09290548e7b73bb7$export$10a563abcf67156.displayName = "SubpageTemplate";

});
parcelRegister("4CTxE", function(module, exports) {
$parcel$export(module.exports, "DrawerCloseButton", () => $e640051cc21f6b1b$export$d0c3a75c17ac0cab);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $6JMJ2 = parcelRequire("6JMJ2");

var $eYpfY = parcelRequire("eYpfY");

var $8JVZz = parcelRequire("8JVZz");
const $e640051cc21f6b1b$export$d0c3a75c17ac0cab = ({ icon: Icon, label: label = 'Close drawer', testId: testId = 'DrawerCloseButton' })=>{
    (0, $eYpfY.useEnsureIsInsideDrawer)();
    const onClose = (0, $8JVZz.useOnClose)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $m9iwH.default), {
        onClick: onClose,
        testId: testId,
        icon: Icon ? (iconProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
                ...iconProps,
                size: "large"
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($6JMJ2))),
        label: label,
        shape: "circle",
        appearance: "subtle"
    });
};
$e640051cc21f6b1b$export$d0c3a75c17ac0cab.displayName = "DrawerCloseButton";

});
parcelRegister("8JVZz", function(module, exports) {
$parcel$export(module.exports, "useOnClose", () => $fed5ed966a5d1fa7$export$c2b12c82f332a6fb);

var $euxye = parcelRequire("euxye");

var $1u2qL = parcelRequire("1u2qL");
const $fed5ed966a5d1fa7$export$c2b12c82f332a6fb = ()=>(0, $euxye.useContext)((0, $1u2qL.OnCloseContext));

});


parcelRegister("7hCmd", function(module, exports) {
$parcel$export(module.exports, "default", () => $885ff51302bb8888$export$2e2bcd8739ae039);
/* progress-tracker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $gR4FD = parcelRequire("gR4FD");

var $kenDo = parcelRequire("kenDo");
const $885ff51302bb8888$var$containerStyles = null;
const $885ff51302bb8888$var$spacingOptions = {
    comfortable: "var(--ds-space-500, 40px)",
    cozy: "var(--ds-space-200, 16px)",
    // @deprecated left for backwards compatibility
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
/**
 * __Progress tracker__
 *
 * A progress tracker displays the steps and progress through a journey.
 *
 * - [Examples](https://atlassian.design/components/progress-tracker/examples)
 * - [Code](https://atlassian.design/components/progress-tracker/code)
 * - [Usage](https://atlassian.design/components/progress-tracker/usage)
 */ const $885ff51302bb8888$var$ProgressTracker = ({ items: items = [], spacing: spacing = 'cozy', render: render = {
    link: ({ item: item })=>// Anchor content is coming from another location
        // eslint-disable-next-line @atlassian/a11y/anchor-has-content
        /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gR4FD.default), {
            ...item
        })
}, animated: animated = true, testId: testId, label: label = 'Progress' })=>{
    const prevItems = (0, $euxye.useRef)(items.map((stage)=>({
            ...stage,
            percentageComplete: 0
        })));
    const previousStages = items.map((stage)=>{
        const oldStage = prevItems.current?.find((st)=>st.id === stage.id);
        return !!oldStage ? oldStage : stage;
    });
    (0, $euxye.useEffect)(()=>{
        prevItems.current = items;
    }, [
        items
    ]);
    const progressChanges = items.filter((stage, index)=>stage.percentageComplete !== previousStages[index].percentageComplete).length;
    const totalStepsForward = items.filter((stage, index)=>stage.percentageComplete > previousStages[index].percentageComplete).length;
    const totalStepsBack = items.filter((stage, index)=>stage.percentageComplete < previousStages[index].percentageComplete).length;
    let stepsForward = totalStepsForward;
    let stepsBack = totalStepsBack;
    const progressItems = items.map((stage, index)=>{
        let transitionSpeed = 0;
        let transitionDelay = 0;
        const transitionEasing = progressChanges > 1 ? 'linear' : 'cubic-bezier(0.15,1,0.3,1)';
        if (animated) {
            transitionSpeed = progressChanges > 1 ? 50 : 300;
            if (stage.percentageComplete < previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially in reverse.
         */ transitionDelay = (stepsBack - 1) * transitionSpeed;
                stepsBack -= 1;
            } else if (stage.percentageComplete > previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially.
         */ transitionDelay = (totalStepsForward - stepsForward) * transitionSpeed;
                stepsForward -= 1;
            }
        }
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $kenDo.default), {
            transitionSpeed: transitionSpeed,
            transitionDelay: transitionDelay,
            transitionEasing: transitionEasing,
            item: stage,
            render: render
        }, stage.id);
    });
    const listInlineStyles = {
        gridTemplateColumns: `repeat(${items.length}, 1fr)`,
        ['--ds--pt--sp']: $885ff51302bb8888$var$spacingOptions[spacing],
        maxWidth: 80 * items.length * 2
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)("ol", {
        "data-testid": testId,
        style: listInlineStyles,
        "aria-label": label,
        className: (0, $4jQY2.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _zulp6odm _1e0c11p5 _1bsb1osq _2mzuglyw _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _rxvc1jfw"
        ]),
        children: progressItems
    });
};
$885ff51302bb8888$var$ProgressTracker.displayName = "ProgressTracker";
var $885ff51302bb8888$export$2e2bcd8739ae039 = $885ff51302bb8888$var$ProgressTracker;

});
parcelRegister("gR4FD", function(module, exports) {
$parcel$export(module.exports, "default", () => $97a9475842818275$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $9MWap = parcelRequire("9MWap");
const $97a9475842818275$var$styles = {
    anchor: "_4bfu18uv _1hmsglyw _ajmmnqa1 _11c81kw7 _2rko12b0 _syazi7uo _1e0c1ule _9oik18uv _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
/**
 * __Progress tracker link__
 */ const $97a9475842818275$var$Link = ({ href: href, onClick: onClick, label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $9MWap.default), {
        xcss: $97a9475842818275$var$styles.anchor,
        // TODO: We should not be rendering empty hrefs on anchors. This should be plain text or a button/pressable if `onClick` is provided.
        href: href || '',
        onClick: onClick,
        testId: testId,
        children: label
    });
};
$97a9475842818275$var$Link.displayName = "Link";
var $97a9475842818275$export$2e2bcd8739ae039 = $97a9475842818275$var$Link;

});

parcelRegister("kenDo", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e7372e08fb3393d$export$2e2bcd8739ae039);
/* stage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $ihEDU = parcelRequire("ihEDU");

var $cpHkc = parcelRequire("cpHkc");

var $d0SJu = parcelRequire("d0SJu");
const $0e7372e08fb3393d$var$styles = {
    listItemContent: "_1bsb1osq _kqswh2mm"
};
const $0e7372e08fb3393d$var$textColor = {
    unvisited: "_syaz1rpy",
    current: "_syaz1oa5",
    visited: "_syazi7uo",
    disabled: "_syaz1gmx"
};
const $0e7372e08fb3393d$var$fontWeight = {
    unvisited: "_k48pi7a9",
    current: "_k48pwu06",
    visited: "_k48pwu06",
    disabled: "_k48pwu06"
};
const $0e7372e08fb3393d$var$listItemStyles = null;
const $0e7372e08fb3393d$var$fadeAnimationBase = null;
const $0e7372e08fb3393d$var$fadeIn = null;
const $0e7372e08fb3393d$var$fadeAnimationActive = null;
const $0e7372e08fb3393d$var$titleStyles = null;
class $0e7372e08fb3393d$export$2e2bcd8739ae039 extends (0, $euxye.PureComponent) {
    constructor(props){
        super(props), this.onEntered = ()=>{
            this.setState({
                transitioning: false,
                oldPercentageComplete: this.props.item.percentageComplete
            });
        };
        this.state = {
            transitioning: false,
            oldPercentageComplete: 0
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.item.status !== this.props.item.status || prevProps.item.percentageComplete !== this.props.item.percentageComplete) this.startTransition();
    }
    componentWillUnmount() {
        if (this.animationTimeoutId) clearTimeout(this.animationTimeoutId);
    }
    startTransition() {
        if (this.animationTimeoutId) clearTimeout(this.animationTimeoutId);
        this.setState({
            ...this.state,
            transitioning: true
        });
        const timeout = this.props.transitionDelay + this.props.transitionSpeed;
        this.animationTimeoutId = setTimeout(()=>{
            this.onEntered();
        }, timeout);
    }
    shouldShowLink() {
        return this.props.item.status === 'visited' && // TODO: `noLink` is unnecessary as we should just be detecting if the `href` is set...
        !this.props.item.noLink;
    }
    render() {
        const { item: item, render: render, transitionDelay: transitionDelay, transitionSpeed: transitionSpeed, transitionEasing: transitionEasing, testId: testId } = this.props;
        const ariaCurrent = item.status === 'current' ? 'step' : 'false';
        const listInlineStyles = {
            ['--ds--pt--ts']: `${transitionSpeed}ms`,
            ['--ds--pt--td']: `${transitionDelay}ms`,
            ['--ds--pt--te']: transitionEasing
        };
        return /*#__PURE__*/ (0, $e79Pd.jsx)("li", {
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: listInlineStyles,
            "aria-current": ariaCurrent,
            className: (0, $4jQY2.default)([
                "_2mzuglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1i4q1hna"
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
                xcss: $0e7372e08fb3393d$var$styles.listItemContent,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $d0SJu.default), {
                        testId: testId && `${testId}-marker`,
                        status: item.percentageComplete > 0 ? 'visited' : item.status
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        style: {
                            animationPlayState: this.state.transitioning ? 'running' : 'paused',
                            animationDuration: [
                                'visited',
                                'disabled'
                            ].includes(this.props.item.status) ? '0ms' : undefined
                        },
                        className: (0, $4jQY2.default)([
                            "_tzy4kb7n",
                            "_y44v18do _ju251oqq _1y0ctrqk"
                        ]),
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cpHkc.default), {
                            testId: testId && `${testId}-bar`,
                            percentageComplete: item.percentageComplete
                        })
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                        "data-testid": testId && `${testId}-title`,
                        className: (0, $4jQY2.default)([
                            "_tzy4kb7n",
                            "_11c8fhey _1pfhv47k _y3gn1h6o",
                            $0e7372e08fb3393d$var$textColor[item.status],
                            $0e7372e08fb3393d$var$fontWeight[item.status]
                        ]),
                        children: this.shouldShowLink() ? render.link({
                            item: item
                        }) : item.label
                    })
                ]
            })
        });
    }
}
$0e7372e08fb3393d$export$2e2bcd8739ae039.displayName = "ProgressTrackerStage";

});
parcelRegister("cpHkc", function(module, exports) {
$parcel$export(module.exports, "default", () => $0480631d63a08cb2$export$2e2bcd8739ae039);
/* bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $0480631d63a08cb2$var$spacing = {
    comfortable: "var(--ds-space-500, 40px)",
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
const $0480631d63a08cb2$var$progressBarStyles = null;
/**
 * __Progress bar__
 *
 * A progress bar describes the horizontal tracking bar that traverses each individual step.
 *
 */ const $0480631d63a08cb2$var$ProgressBar = ({ percentageComplete: percentageComplete, testId: testId })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        style: {
            width: `calc(${percentageComplete}% + ${percentageComplete / 100} * calc(var(--ds--pt--sp, ${$0480631d63a08cb2$var$spacing.cosy}) + ${"var(--ds-space-050, 4px)"}))`
        },
        className: (0, $4jQY2.default)([
            "_v564d86a _4t3iu2gc _kqswstnw _bfhk1856 _1ein1cuf _5fbc1cuf _1e021ssb _t9ecymk3 _1lww1oqq"
        ])
    });
$0480631d63a08cb2$var$ProgressBar.displayName = "ProgressBar";
var $0480631d63a08cb2$export$2e2bcd8739ae039 = $0480631d63a08cb2$var$ProgressBar;

});

parcelRegister("d0SJu", function(module, exports) {
$parcel$export(module.exports, "default", () => $f455f93dc395f620$export$2e2bcd8739ae039);
/* marker.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $f455f93dc395f620$var$progressMarkerStyles = null;
const $f455f93dc395f620$var$markerColor = {
    unvisited: "_bfhk1aqn",
    current: "_bfhk1856",
    visited: "_bfhk1856",
    disabled: "_bfhk187o"
};
/**
 * __Progress marker__
 *
 * Similar to `@atlaskit/progress-indicator`, a small visual circle marker
 */ const $f455f93dc395f620$var$ProgressMarker = ({ testId: testId, status: status = 'unvisited' })=>/*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            "_2rkou2gc _v564vc7x _1bsbu2gc _4t3iu2gc _kqswstnw _1e021ssb _t9ec157a",
            $f455f93dc395f620$var$markerColor[status]
        ])
    });
$f455f93dc395f620$var$ProgressMarker.displayName = "ProgressMarker";
var $f455f93dc395f620$export$2e2bcd8739ae039 = $f455f93dc395f620$var$ProgressMarker;

});




parcelRegister("kjKdI", function(module, exports) {
$parcel$export(module.exports, "formatBackendError", () => $b4bf3ca082c58923$export$8a8af50676b40846);
$parcel$export(module.exports, "validateURLField", () => $b4bf3ca082c58923$export$2ad6818b3d68393f);
$parcel$export(module.exports, "validateSupportedScopes", () => $b4bf3ca082c58923$export$7abf746ed63ce29a);

var $6jLTU = parcelRequire("6jLTU");

var $28XKx = parcelRequire("28XKx");

var $75sVW = parcelRequire("75sVW");
const $b4bf3ca082c58923$export$7cc6bb943616cddf = [
    'http:',
    'https:'
];
const $b4bf3ca082c58923$export$8a8af50676b40846 = (maybeError, fallback)=>{
    if (maybeError && (0, $75sVW.isValidationError)(maybeError)) {
        // Show the first validation error message
        if (maybeError.errors.length > 0) try {
            const firstError = maybeError.errors[0].error;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return firstError.summary || fallback;
        } catch (e) {
            return fallback;
        }
    }
    if (maybeError instanceof Error) return maybeError.message || fallback;
    return fallback;
};
const $b4bf3ca082c58923$export$2ad6818b3d68393f = (value, isRequired, checkScheme)=>{
    if (!value) return isRequired ? $b4bf3ca082c58923$export$af1e14e964849c8c.empty : undefined;
    const trimmedValue = value?.trim();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(trimmedValue) && isRequired) return $b4bf3ca082c58923$export$af1e14e964849c8c.empty;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6jLTU)))(trimmedValue) && !(0, $28XKx.isValidUrl)(value)) return $b4bf3ca082c58923$export$af1e14e964849c8c.urlInvalid;
    if (checkScheme && !$b4bf3ca082c58923$export$7cc6bb943616cddf.some((scheme)=>value.startsWith(scheme))) return $b4bf3ca082c58923$export$af1e14e964849c8c.urlSchemeInvalid;
    return undefined;
};
const $b4bf3ca082c58923$export$7abf746ed63ce29a = (chosenScopes, supportedScopes)=>{
    const invalidScopes = chosenScopes.filter((scope)=>!supportedScopes.includes(scope));
    if (invalidScopes.length > 0) return $b4bf3ca082c58923$export$af1e14e964849c8c.unsupportedScope;
    return undefined;
};
const $b4bf3ca082c58923$export$af1e14e964849c8c = {
    empty: 'This field is required.',
    urlInvalid: 'Enter a valid URL.',
    urlSchemeInvalid: 'The URL must start with http:// or https://.',
    authTypeInvalid: 'Select a valid authentication type.',
    impersonationNotAllowed: '2LO (impersonation) is deprecated. Please choose another authentication type.',
    unsupportedScope: 'One or more selected scopes are not supported.'
};

});
parcelRegister("28XKx", function(module, exports) {
$parcel$export(module.exports, "isValidUrl", () => $08e64bf3c3a28e48$export$bef94a5618bf18bf);
$parcel$export(module.exports, "default", () => $08e64bf3c3a28e48$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * The URL standard regex for spec.: RFC 3986
 * https://tools.ietf.org/html/rfc3986#page-51
 */ const $08e64bf3c3a28e48$var$URLStandardRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?');
/**
 * Full Domain name limits as per RFC is 256 characters
 * TLD limit as per RFC 1035 is 63 characters. Although, TLDs can contain numbers, since none of the existing popular TLDs are numbers, we are not allowing numbers in TLD.
 * Any characters allowed in protocol and query string. Domain name needs to be alphanumeric with hyphens allowed.
 */ const $08e64bf3c3a28e48$var$stricterURLRegex = new RegExp('^(([^:/?#]+):)?(//([^/?#]*))?[-a-zA-Z0-9@:.]{2,256}.[a-z]{2,63}\\b([-a-zA-Z0-9@:%_+.~#?&//=]*)');
const $08e64bf3c3a28e48$var$protocolRegex = new RegExp('^(http|https|ftp)://.*|^//[^/]*?');
function $08e64bf3c3a28e48$export$bef94a5618bf18bf(string, strict = false) {
    // Have to be string
    if (!string || typeof string !== 'string') return false;
    // Exit early if there is a space, no need to regex that
    if (string.indexOf(' ') >= 0 || string.length === 0) return false;
    // Localhost is bit different, doesn't need a dot but others likely should
    if (string.indexOf('localhost') === -1 && string.indexOf('.') === -1) return false;
    if (strict === true) return $08e64bf3c3a28e48$var$stricterURLRegex.test(string) || $08e64bf3c3a28e48$var$protocolRegex.test(string);
    return $08e64bf3c3a28e48$var$URLStandardRegex.test(string);
}
var $08e64bf3c3a28e48$export$2e2bcd8739ae039 = $08e64bf3c3a28e48$export$bef94a5618bf18bf;

});



parcelRegister("aKKFI", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd0b8a3fbded0234$export$2e2bcd8739ae039);
/* ReviewSubpage.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $a9o4s = parcelRequire("a9o4s");

var $iOfms = parcelRequire("iOfms");

var $fWb5q = parcelRequire("fWb5q");

var $7mtMc = parcelRequire("7mtMc");

var $67bq1 = parcelRequire("67bq1");

var $cdF7h = parcelRequire("cdF7h");

var $fXX7T = parcelRequire("fXX7T");

var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $01dJR = parcelRequire("01dJR");

var $2ffUK = parcelRequire("2ffUK");
var $55BnK = parcelRequire("55BnK");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");

var $5T7Xn = parcelRequire("5T7Xn");

var $cFFXQ = parcelRequire("cFFXQ");

var $drATu = parcelRequire("drATu");

var $l7m8P = parcelRequire("l7m8P");

var $1b6Nh = parcelRequire("1b6Nh");

var $6bB9L = parcelRequire("6bB9L");

var $9xWqG = parcelRequire("9xWqG");

var $eiO6t = parcelRequire("eiO6t");

var $kjKdI = parcelRequire("kjKdI");
const $fd0b8a3fbded0234$var$styles = {
    linkDisplay: "_19pkpxbi _otyrpxbi",
    fullContainer: "_4t3i1osq"
};
const $fd0b8a3fbded0234$var$unknownErrorTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "We encountered an unknown error.",
    id: "applinks.administration.ui.unknown-error"
});
const $fd0b8a3fbded0234$var$unknownConnectionTypeErrorMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Unknown connection type selected.",
    id: "applinks.administration.ui.creation-flow-dialog.unknown-connection-type-error"
});
const $fd0b8a3fbded0234$var$localProductCardHeaderMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "This application",
    id: "applinks.administration.ui.creation-flow-dialog.local-product-card-header"
});
const $fd0b8a3fbded0234$var$remoteProductCardHeaderMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Remote application",
    id: "applinks.administration.ui.creation-flow-dialog.remote-product-card-header"
});
const $fd0b8a3fbded0234$var$formCancelButtonTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Cancel",
    id: "applinks.administration.ui.creation-flow-dialog.form-cancel-button-text"
});
const $fd0b8a3fbded0234$var$reviewOAuth1HeaderNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Review OAuth 1.0 link",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-1-header-nonfinal"
});
const $fd0b8a3fbded0234$var$reviewOAuth2HeaderMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Review OAuth 2.0 link",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-2-header"
});
const $fd0b8a3fbded0234$var$reviewTunneledHeaderNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Review tunneled link",
    id: "applinks.administration.ui.creation-flow-dialog.review-tunneled-header-nonfinal"
});
const $fd0b8a3fbded0234$var$reviewIncomingLinkHeaderNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Review incoming link",
    id: "applinks.administration.ui.creation-flow-dialog.review-incoming-link-header-nonfinal"
});
const $fd0b8a3fbded0234$var$reviewOAuth1DescriptionNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Confirm the details of the application link you are creating. This will allow the remote <strong>{nameOfRemoteProduct}</strong> to access this {nameOfThisProduct} site. You will later be redirected to {nameOfRemoteProduct} to complete the other side of the link.",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-1-description-nonfinal"
});
const $fd0b8a3fbded0234$var$reviewOAuth2DescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Confirm the details of the application link you're creating. In the next step, you'll exchange credentials to allow the remote <strong>{nameOfRemoteProduct}</strong> to communicate with this {nameOfThisProduct} site.",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-2-description"
});
const $fd0b8a3fbded0234$var$reviewOAuth2SelectConnectionLabelMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Available connections",
    id: "applinks.administration.ui.creation-flow-dialog.select-connection-label"
});
const $fd0b8a3fbded0234$var$reviewOAuth2PublicConnectionTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Public connection",
    id: "applinks.administration.ui.creation-flow-dialog.public-connection-label"
});
const $fd0b8a3fbded0234$var$reviewOAuth2TunnelConnectionDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Connect securely via application tunnel",
    id: "applinks.administration.ui.creation-flow-dialog.tunnel-connection-description"
});
const $fd0b8a3fbded0234$var$reviewOAuth2PublicConnectionDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Connect directly via public internet",
    id: "applinks.administration.ui.creation-flow-dialog.public-connection-description"
});
const $fd0b8a3fbded0234$var$reviewOAuth1ReciprocalDescriptionNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "The remote <strong>{nameOfRemoteProduct}</strong> application has requested to create a link to this {nameOfThisProduct} site. Review the details below before completing the link. This will allow the remote {nameOfRemoteProduct} to access this site.",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-1-reciprocal-description-nonfinal"
});
const $fd0b8a3fbded0234$var$reviewFormCompleteLinkButtonNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Complete link",
    id: "applinks.administration.ui.creation-flow-dialog.review-form-complete-link-button-nonfinal"
});
const $fd0b8a3fbded0234$var$reviewFormCreateLinkButtonMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Create link",
    id: "applinks.administration.ui.creation-flow-dialog.review-form-create-link-button"
});
const $fd0b8a3fbded0234$var$ReviewSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { push: push } = (0, $55BnK.useRouterActions)();
    const [_, setCloudConnectorQueryParam] = (0, $2ffUK.useQueryParam)('cloudConnectorId');
    const reciprocalMode = props.state.kind === 'reciprocal-review';
    const thisApplicationManifest = props.state.localManifest;
    const targetApplicationManifest = props.state.remoteManifest;
    const [targetApplicationRpcUrl, setTargetApplicationRpcUrl] = (0, $euxye.useState)(()=>{
        if ((0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs')) {
            const connections = props.availableConnections?.filter((conn)=>!conn.isDisabled) ?? []; // Favour tunneled connection
            const defaultConnection = connections.find((conn)=>conn.isTunnel) ?? connections[0];
            return defaultConnection?.url ?? props.state.rpcUrl;
        }
        return props.state.rpcUrl;
    }); // TODO: Determine if the type is DC or Cloud
    const thisApplicationType = (0, $5T7Xn.lookupTypeByTypeId)(thisApplicationManifest.typeId, false);
    const targetApplicationType = (0, $5T7Xn.lookupTypeByTypeId)(targetApplicationManifest.typeId, false);
    const onFormSubmitOAuth1 = async ()=>{
        const applinkCreationEntity = {
            id: targetApplicationManifest.id,
            name: targetApplicationManifest.name,
            displayUrl: targetApplicationManifest.url,
            rpcUrl: targetApplicationRpcUrl,
            typeId: targetApplicationManifest.typeId,
            isPrimary: false,
            isSystem: false,
            isOAuth2ThreeLoEnabled: false,
            isCloud: targetApplicationManifest.isCloud ?? false,
            productVersion: targetApplicationManifest.version
        };
        try {
            await (0, $drATu.putApplink)(applinkCreationEntity);
            if (props.state.kind === 'reciprocal-review' && props.state.inboundCreationState.applinkOriginalCreatedId) {
                // Configure OAuth
                await (0, $drATu.putApplinkOAuthOne3LOProvider)(targetApplicationManifest.id);
                await (0, $drATu.autoConfigureApplinkConsumer)(targetApplicationManifest.id);
                await (0, $drATu.putApplinkOAuthOne2LOProvider)(targetApplicationManifest.id); // Update status log
                const updatedApplinkCreationStatusLog = (0, $l7m8P.updateStatusLog)(props.state.inboundCreationState.applinkCreationStatusLog, {
                    status: (0, $l7m8P.STATUS_RECIPROCAL_SUCCESS)
                });
                const newCreationState = {
                    applinkCreationStatusLog: updatedApplinkCreationStatusLog,
                    applinkOriginalCreatedId: props.state.inboundCreationState.applinkOriginalCreatedId,
                    sharedUserbase: props.state.inboundCreationState.sharedUserbase,
                    applinkConfigInPreAuth: true,
                    applinkConfigInServerAuth: true,
                    applinkConfigInUserAuth: true,
                    applinkConfigOutPreAuth: true,
                    applinkConfigOutServerAuth: true,
                    applinkConfigOutUserAuth: true
                };
                const newRedirectionUrl = (0, $l7m8P.generateApplinksCreationRedirectionUrl)(targetApplicationManifest.url, targetApplicationManifest.typeId, newCreationState);
                push(newRedirectionUrl);
                return;
            }
            props.onSuccess({
                kind: 'reciprocal-prompt',
                variant: props.state.variant,
                remoteManifest: targetApplicationManifest,
                localManifest: thisApplicationManifest
            });
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.list.creation-flow-dialog.review.submitOAuth1ReviewForm', 'Failed to create an OAuth 1.0 link after reviewing', maybeError);
            if ((0, $i860n.fg)('applinks-1093-redirect-error-fix')) props.onError((0, $kjKdI.formatBackendError)(maybeError, formatMessage($fd0b8a3fbded0234$var$unknownErrorTextMessage)));
            else props.onError(maybeError ? maybeError.message : formatMessage($fd0b8a3fbded0234$var$unknownErrorTextMessage));
            return err;
        }
    };
    const onFormSubmitOAuth2 = async ()=>{
        const applinkCreationEntity = {
            id: targetApplicationManifest.id,
            name: targetApplicationManifest.name,
            displayUrl: targetApplicationManifest.url,
            rpcUrl: targetApplicationRpcUrl,
            typeId: targetApplicationManifest.typeId,
            isPrimary: false,
            isSystem: false,
            isOAuth2ThreeLoEnabled: true,
            isCloud: targetApplicationManifest.isCloud ?? false,
            productVersion: targetApplicationManifest.version
        };
        try {
            await (0, $drATu.createOAuth2Applink)(applinkCreationEntity);
            const oauth2ConfigInfo = await (0, $drATu.getOAuth2ConfigInfo)(targetApplicationManifest.id);
            const newlyCreatedApplink = await (0, $drATu.fetchApplink)(targetApplicationManifest.id);
            setCloudConnectorQueryParam(undefined, 'replace');
            props.onSuccess({
                kind: 'connect',
                variant: props.state.variant,
                applink: newlyCreatedApplink,
                oauth2ConfigInfo: oauth2ConfigInfo
            });
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.list.creation-flow-dialog.review.submitOAuth2ReviewForm', 'Failed to create an OAuth 2.0 link after reviewing', maybeError);
            if ((0, $i860n.fg)('applinks-1093-redirect-error-fix')) props.onError((0, $kjKdI.formatBackendError)(maybeError, formatMessage($fd0b8a3fbded0234$var$unknownErrorTextMessage)));
            else props.onError(maybeError ? maybeError.message : formatMessage($fd0b8a3fbded0234$var$unknownErrorTextMessage));
            return err;
        }
    };
    const onFormSubmit = async ()=>{
        switch(props.state.variant){
            case 'OAUTH1.0':
            case 'TUNNEL':
                return onFormSubmitOAuth1();
            case 'OAUTH2.0':
                return onFormSubmitOAuth2();
            default:
                props.onError(formatMessage($fd0b8a3fbded0234$var$unknownConnectionTypeErrorMessage));
        }
    };
    const getVariantProperName = (0, $euxye.useCallback)(()=>{
        switch(props.state.variant){
            case 'OAUTH1.0':
                return formatMessage($fd0b8a3fbded0234$var$reviewOAuth1HeaderNonfinalMessage);
            case 'OAUTH2.0':
                return formatMessage($fd0b8a3fbded0234$var$reviewOAuth2HeaderMessage);
            case 'TUNNEL':
            default:
                return formatMessage($fd0b8a3fbded0234$var$reviewTunneledHeaderNonfinalMessage);
        }
    }, [
        formatMessage,
        props.state.variant
    ]);
    const connectionGroups = (0, $euxye.useMemo)(()=>[
            {
                groupId: 'connections',
                testId: 'connections-list',
                groupAriaLabel: formatMessage($fd0b8a3fbded0234$var$reviewOAuth2SelectConnectionLabelMessage),
                items: (0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs') ? props.availableConnections?.map((conn)=>{
                    const isTunnel = conn.isTunnel;
                    return {
                        id: conn.url,
                        title: isTunnel ? conn.name : formatMessage($fd0b8a3fbded0234$var$reviewOAuth2PublicConnectionTitleMessage),
                        description: isTunnel ? formatMessage($fd0b8a3fbded0234$var$reviewOAuth2TunnelConnectionDescriptionMessage) : formatMessage($fd0b8a3fbded0234$var$reviewOAuth2PublicConnectionDescriptionMessage),
                        ariaLabel: isTunnel ? conn.name : formatMessage($fd0b8a3fbded0234$var$reviewOAuth2PublicConnectionTitleMessage),
                        icon: isTunnel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fXX7T))), {
                            label: ""
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cdF7h))), {
                            label: ""
                        }),
                        isDisabled: conn.isDisabled,
                        isRecommended: isTunnel
                    };
                }) ?? [] : []
            }
        ], [
        formatMessage,
        props.availableConnections
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fWb5q.default), {
        onSubmit: onFormSubmit,
        xcss: $fd0b8a3fbded0234$var$styles.fullContainer
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eiO6t.SubpageTemplate), {
            variant: props.state.variant,
            kind: props.state.kind,
            buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
                appearance: "subtle",
                onClick: props.onCancel
            }, formatMessage($fd0b8a3fbded0234$var$formCancelButtonTextMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
                testId: "applinks-administration.ui.list.creation-flow-dialog.review.submit-button",
                type: "submit",
                appearance: "primary",
                isLoading: submitting
            }, reciprocalMode ? formatMessage($fd0b8a3fbded0234$var$reviewFormCompleteLinkButtonNonfinalMessage) : formatMessage($fd0b8a3fbded0234$var$reviewFormCreateLinkButtonMessage))),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7mtMc.default), {
                title: reciprocalMode ? formatMessage($fd0b8a3fbded0234$var$reviewIncomingLinkHeaderNonfinalMessage) : getVariantProperName()
            }, !reciprocalMode && (props.state.variant === 'OAUTH1.0' || props.state.variant === 'TUNNEL') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($fd0b8a3fbded0234$var$reviewOAuth1DescriptionNonfinalMessage, {
                nameOfThisProduct: (0, $1b6Nh.THIS_PRODUCT_NAME_STRING),
                nameOfRemoteProduct: targetApplicationType.name,
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
                        as: "strong"
                    }, chunks)
            })), !reciprocalMode && props.state.variant === 'OAUTH2.0' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($fd0b8a3fbded0234$var$reviewOAuth2DescriptionMessage, {
                nameOfThisProduct: (0, $1b6Nh.THIS_PRODUCT_NAME_STRING),
                nameOfRemoteProduct: targetApplicationType.name,
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
                        as: "strong"
                    }, chunks)
            })), reciprocalMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($fd0b8a3fbded0234$var$reviewOAuth1ReciprocalDescriptionNonfinalMessage, {
                nameOfThisProduct: (0, $1b6Nh.THIS_PRODUCT_NAME_STRING),
                nameOfRemoteProduct: targetApplicationType.name,
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
                        as: "strong"
                    }, chunks)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                xcss: $fd0b8a3fbded0234$var$styles.linkDisplay,
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cFFXQ.default), {
                applicationType: thisApplicationType,
                displayUrl: thisApplicationManifest.url,
                heading: formatMessage($fd0b8a3fbded0234$var$localProductCardHeaderMessage)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
                space: "space.100",
                alignBlock: "center",
                alignInline: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($67bq1))), {
                label: ""
            }), reciprocalMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6bB9L.StatusLozenge), {
                kind: "error",
                err: (0, $9xWqG.ERRORS).CONFIGURATION_COMPLETE
            }), !reciprocalMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6bB9L.StatusLozenge), {
                kind: "not-connected"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cFFXQ.default), {
                applicationType: targetApplicationType,
                displayUrl: targetApplicationManifest.url,
                heading: formatMessage($fd0b8a3fbded0234$var$remoteProductCardHeaderMessage)
            })), (0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $01dJR.default), {
                testId: "applinks-administration.ui.list.creation-flow-dialog.review.connections-list",
                onChange: (e, url)=>setTargetApplicationRpcUrl(url),
                selectedValue: targetApplicationRpcUrl,
                groups: connectionGroups
            })))
        })));
};
$fd0b8a3fbded0234$var$ReviewSubpage.displayName = "ReviewSubpage";
var $fd0b8a3fbded0234$export$2e2bcd8739ae039 = $fd0b8a3fbded0234$var$ReviewSubpage;

});
parcelRegister("67bq1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f51e3026bdf0966f56fca36d1a42e0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $473c41060d98e515$var$_react = $473c41060d98e515$var$_interopRequireDefault((parcelRequire("euxye")));

var $473c41060d98e515$var$_baseNew = $473c41060d98e515$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $473c41060d98e515$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $473c41060d98e515$var$LinkIcon = (props)=>/*#__PURE__*/ $473c41060d98e515$var$_react.default.createElement($473c41060d98e515$var$_baseNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$473c41060d98e515$var$LinkIcon.displayName = 'LinkIcon';
var $473c41060d98e515$var$_default = module.exports.default = $473c41060d98e515$var$LinkIcon;

});

parcelRegister("fXX7T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b469831fd3ad0d6dbbee24964a60682>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9fa3af568015ca8$var$_react = $b9fa3af568015ca8$var$_interopRequireDefault((parcelRequire("euxye")));

var $b9fa3af568015ca8$var$_baseNew = $b9fa3af568015ca8$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $b9fa3af568015ca8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shield".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: classifications in Enterprise Trust, security in Jira (Spork)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b9fa3af568015ca8$var$ShieldIcon = (props)=>/*#__PURE__*/ $b9fa3af568015ca8$var$_react.default.createElement($b9fa3af568015ca8$var$_baseNew.default, Object.assign({
        name: "ShieldIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.53.22a.75.75 0 0 0-1.06 0C6.172 1.518 4.686 2.41 3.515 2.982a16 16 0 0 1-1.434.615 11 11 0 0 1-.51.174l-.023.007-.005.001A.75.75 0 0 0 1 4.5c0 4.338 1.651 7.176 3.334 8.926.836.87 1.672 1.463 2.304 1.842a9 9 0 0 0 .999.519l.066.027.02.008.006.002.003.001a.76.76 0 0 0 .535 0h.004l.006-.003.02-.008.066-.027q.083-.035.227-.103c.19-.09.456-.226.772-.416a11.3 11.3 0 0 0 2.304-1.842C13.349 11.676 15 8.838 15 4.5a.75.75 0 0 0-.544-.721l-.004-.001-.024-.007-.103-.033a11 11 0 0 1-.406-.141c-.35-.13-.85-.33-1.434-.615C11.314 2.412 9.828 1.518 8.53.22M8 1.783C6.69 2.963 5.286 3.788 4.172 4.33a17 17 0 0 1-1.663.707c.128 3.604 1.532 5.92 2.907 7.35a9.8 9.8 0 0 0 1.993 1.595c.24.144.443.25.591.322.148-.072.35-.178.59-.322a9.8 9.8 0 0 0 1.994-1.596c1.375-1.43 2.779-3.745 2.907-7.349l-.09-.032a17 17 0 0 1-1.573-.675C10.714 3.788 9.31 2.963 8 1.783" clip-rule="evenodd"/>`
    }, props));
$b9fa3af568015ca8$var$ShieldIcon.displayName = 'ShieldIcon';
var $b9fa3af568015ca8$var$_default = module.exports.default = $b9fa3af568015ca8$var$ShieldIcon;

});

parcelRegister("01dJR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee3d04c20faec92c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");

var $jFb8V = parcelRequire("jFb8V");

var $cj3ZG = parcelRequire("cj3ZG");
const $ee3d04c20faec92c$var$styles = {
    groupContainer: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1ul9idpf",
    itemsMargin: "_19pkutpp",
    rowContainer: "_1n261g80 _zkhy1q9c",
    gridContainer: "_zulputpp _1e0c11p5"
};
const $ee3d04c20faec92c$var$SelectListItemsContainer = ({ direction: direction, children: children, gridColumns: gridColumns })=>{
    switch(direction){
        case 'row':
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $defJG.default), {
                space: "space.150",
                alignBlock: "stretch",
                xcss: $ee3d04c20faec92c$var$styles.rowContainer,
                children: children
            });
        case 'column':
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.default), {
                space: "space.150",
                children: children
            });
        case 'grid':
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic grid columns require inline style
            return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                xcss: $ee3d04c20faec92c$var$styles.gridContainer,
                style: {
                    gridTemplateColumns: gridColumns ? `repeat(${gridColumns}, 1fr)` : 'repeat(auto-fill, minmax(200px, 1fr))'
                },
                children: children
            });
    }
};
$ee3d04c20faec92c$var$SelectListItemsContainer.displayName = "SelectListItemsContainer";
const $ee3d04c20faec92c$var$SelectList = (props)=>{
    const { groups: groups, testId: testId = 'select-list', direction: direction = 'column' } = props;
    // Single-select state
    const defaultSelected = !props.isMulti ? props.selectedValue || props.defaultValue : undefined;
    const [selected, setSelected] = (0, $euxye.useState)(defaultSelected);
    // Multi-select state
    const defaultSelectedMulti = props.isMulti ? props.defaultValues || [] : [];
    const [selectedMulti, setSelectedMulti] = (0, $euxye.useState)(defaultSelectedMulti);
    const handleChange = (event, newSelection)=>{
        if (props.isMulti) {
            // props is narrowed to SelectListMultiProps here — no cast needed
            const currentlySelected = selectedMulti.includes(newSelection) ? selectedMulti.filter((v)=>v !== newSelection) : [
                ...selectedMulti,
                newSelection
            ];
            setSelectedMulti(currentlySelected);
            props.onChange(event, currentlySelected);
        } else {
            // props is narrowed to SelectListSingleProps here — no cast needed
            setSelected(newSelection);
            props.onChange(event, newSelection);
        }
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3PC9r.default), {
        space: "space.200",
        testId: testId,
        children: groups.map(({ items: items, groupId: groupId, groupName: groupName, groupDescriptionIcon: groupDescriptionIcon, groupDescription: groupDescription, groupDescriptionInfoLink: groupDescriptionInfoLink, groupDescriptionInfoLinkMessage: groupDescriptionInfoLinkMessage, groupAriaLabel: groupAriaLabel })=>{
            return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $ihEDU.default), {
                as: "fieldset",
                "aria-label": groupAriaLabel,
                xcss: $ee3d04c20faec92c$var$styles.groupContainer,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $cj3ZG.GroupHeading), {
                        testId: testId,
                        groupId: groupId,
                        groupName: groupName,
                        groupDescriptionIcon: groupDescriptionIcon,
                        groupDescription: groupDescription,
                        groupDescriptionInfoLink: groupDescriptionInfoLink,
                        groupDescriptionInfoLinkMessage: groupDescriptionInfoLinkMessage
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
                        xcss: $ee3d04c20faec92c$var$styles.itemsMargin,
                        children: /*#__PURE__*/ (0, $e79Pd.jsx)($ee3d04c20faec92c$var$SelectListItemsContainer, {
                            direction: direction,
                            gridColumns: props.columns,
                            children: items.map((itemProps, index)=>{
                                return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jFb8V.SelectCard), {
                                    testId: `${testId}-card-${index}`,
                                    handleChange: handleChange,
                                    selected: selected,
                                    selectedMulti: props.isMulti ? selectedMulti : undefined,
                                    isMulti: props.isMulti,
                                    direction: direction,
                                    radioGroupName: !props.isMulti ? props.radioGroupName : undefined,
                                    ...itemProps
                                }, itemProps.id);
                            })
                        })
                    })
                ]
            }, groupId);
        })
    });
};
$ee3d04c20faec92c$var$SelectList.displayName = "SelectList";
var $ee3d04c20faec92c$export$2e2bcd8739ae039 = $ee3d04c20faec92c$var$SelectList;

});
parcelRegister("jFb8V", function(module, exports) {
$parcel$export(module.exports, "SelectCard", () => $4440c6912e5d1d71$export$2587035f1fd37910);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $apqVV = parcelRequire("apqVV");

var $6Elhl = parcelRequire("6Elhl");
var $fbAgj = parcelRequire("fbAgj");

var $jIAwl = parcelRequire("jIAwl");

var $9q0zj = parcelRequire("9q0zj");

var $9XEKX = parcelRequire("9XEKX");

var $aBLn9 = parcelRequire("aBLn9");
function $4440c6912e5d1d71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4440c6912e5d1d71$var$styles = (0, $fbAgj.xcss)({
    marginLeft: 'space.200'
});
const $4440c6912e5d1d71$var$contentBaseStyles = {
    name: "rzk3s2",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:var(--ds-text-subtlest, #6B6E76);margin-left:var(--ds-space-500, 40px);margin-top:var(--ds-space-200, 16px)"
};
const $4440c6912e5d1d71$var$columnContentExpandedStyles = {
    name: "1siebwf",
    styles: "margin-top:var(--ds-space-400, 32px)"
};
const $4440c6912e5d1d71$var$rowContentStyles = /*#__PURE__*/ (0, $hStPE.css)({
    margin: `${"var(--ds-space-100, 8px)"} 0 0 36px`
});
const $4440c6912e5d1d71$export$2587035f1fd37910 = (props)=>{
    const [isContentExpanded, setIsContentExpanded] = (0, $euxye.useState)(false);
    const { icon: icon, testId: testId, id: id, handleChange: handleChange, selected: selected, selectedMulti: selectedMulti, isMulti: isMulti, title: title, description: description, content: content, contentType: contentType = 'default', contentExpandableLabel: contentExpandableLabel, direction: direction = 'column', image: image, isRecommended: isRecommended = false, radioGroupName: radioGroupName, isDisabled: isDisabled, ariaLabel: ariaLabel } = props;
    const isSelected = isMulti ? selectedMulti?.includes(id) ?? false : selected === id;
    const handleDropdownClicked = ()=>{
        setIsContentExpanded(!isContentExpanded);
    };
    const control = isMulti ? /*#__PURE__*/ (0, $hStPE.jsx)((0, $apqVV.default), {
        value: `${id}`,
        testId: `${testId}-checkbox`,
        isChecked: isSelected,
        onChange: (e)=>{
            handleChange(e, id);
        },
        onClick: (e)=>{
            e.stopPropagation();
        },
        isDisabled: isDisabled,
        "aria-label": ariaLabel || id
    }) : /*#__PURE__*/ (0, $hStPE.jsx)((0, $jIAwl.default), {
        key: id,
        value: `${id}`,
        name: radioGroupName ? radioGroupName : 'radio-default',
        testId: `${testId}-radio-default`,
        isChecked: isSelected,
        tabIndex: 0,
        onChange: (e)=>{
            handleChange(e, id);
        },
        onClick: (e)=>{
            e.stopPropagation();
        },
        isDisabled: isDisabled,
        ariaLabel: ariaLabel || id
    });
    const handleCardContainerClick = (e, id)=>{
        if (isDisabled) {
            e.stopPropagation();
            return;
        }
        handleChange(e, id);
    };
    const columnVariant = /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.ColumnContainer), null, /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.ColumnLeftContainer), null, /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.ColumnTopContainer), null, /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.ColumnTopLeftContainer), null, control, icon && /*#__PURE__*/ (0, $hStPE.jsx)((0, $6Elhl.default), {
        xcss: $4440c6912e5d1d71$var$styles
    }, icon), /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.TitleAndDescriptionContainer), null, /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.Title), {
        "data-testid": `${testId}-title`
    }, title), description && /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.Description), {
        "data-testid": `${testId}-description`
    }, description))), /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.ColumnTopRightContainer), null, contentType === 'expandable' && /*#__PURE__*/ (0, $hStPE.jsx)((0, $9q0zj.ContentDropdown), {
        testId: testId,
        isExpanded: isContentExpanded,
        onClick: handleDropdownClicked,
        contentExpandableLabel: contentExpandableLabel
    }))), /*#__PURE__*/ (0, $hStPE.jsx)((0, $euxye.Fragment), null, contentType === 'expandable' && isContentExpanded && content && /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: [
            $4440c6912e5d1d71$var$contentBaseStyles,
            $4440c6912e5d1d71$var$columnContentExpandedStyles
        ]
    }, content), contentType === 'default' && content && /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: [
            $4440c6912e5d1d71$var$contentBaseStyles
        ]
    }, content))), image && /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.ColumnRightContainer), null, image));
    const rowVariant = /*#__PURE__*/ (0, $hStPE.jsx)((0, $euxye.Fragment), null, image && /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.RowTopContainer), null, /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.RowImage), null, image)), /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.RowMidContainer), null, /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.RowRadioContainer), null, control), icon && /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.RowIcon), null, icon), /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.Title), null, title)), content && /*#__PURE__*/ (0, $hStPE.jsx)("div", {
        css: [
            $4440c6912e5d1d71$var$contentBaseStyles,
            $4440c6912e5d1d71$var$rowContentStyles
        ]
    }, content));
    return /*#__PURE__*/ (0, $hStPE.jsx)((0, $aBLn9.CardContainer), {
        "data-testid": testId,
        key: id,
        isSelected: isSelected,
        onClick: (e)=>handleCardContainerClick(e, id),
        direction: direction,
        isDisabled: isDisabled
    }, isRecommended && /*#__PURE__*/ (0, $hStPE.jsx)((0, $9XEKX.RecommendedBadge), {
        testId: `${testId}-recommended-badge`,
        isSelected: isSelected
    }), direction === 'column' || direction === 'grid' ? columnVariant : rowVariant);
};
$4440c6912e5d1d71$export$2587035f1fd37910.displayName = "SelectCard";

});
parcelRegister("9q0zj", function(module, exports) {
$parcel$export(module.exports, "ContentDropdown", () => $edb8bca8c45bf806$export$90094d804b0e3756);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $ld25x = parcelRequire("ld25x");

var $aFpts = parcelRequire("aFpts");

var $jYEcG = parcelRequire("jYEcG");
var $fbAgj = parcelRequire("fbAgj");

var $dsh3V = parcelRequire("dsh3V");
const $edb8bca8c45bf806$var$DROPDOWN_LABEL_LIMIT = 20;
const $edb8bca8c45bf806$var$messages = (0, $7eNDO.defineMessages)({
    showDetails: {
        defaultMessage: 'SHOW DETAILS',
        description: 'the default title of the select list dropdown label',
        id: 'selectList.card.cardDropdown.showDetails'
    },
    expand: {
        defaultMessage: 'Expand {contentExpandableLabel, select, undefined {DETAILS} other {{contentExpandableLabel}}}',
        description: 'The accessible label for the expand dropdown icon, will use the contentExpandableLabel if it is provided',
        id: 'selectList.card.cardDropdown.expand'
    },
    collapse: {
        defaultMessage: 'Collapse {contentExpandableLabel, select, undefined {DETAILS} other {{contentExpandableLabel}}}',
        description: 'The accessible label for the collapse dropdown icon, will use the contentExpandableLabel if it is provided',
        id: 'selectList.card.cardDropdown.collapse'
    }
});
const $edb8bca8c45bf806$var$buttonStyles = (0, $fbAgj.xcss)({
    font: 'font.body.small',
    fontWeight: 'font.weight.semibold',
    paddingInline: 'space.0',
    color: 'color.text.subtle',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050'
});
const $edb8bca8c45bf806$export$90094d804b0e3756 = (props)=>{
    const intl = (0, $1YIbA.default)();
    const { testId: testId, isExpanded: isExpanded, onClick: onClick, contentExpandableLabel: contentExpandableLabel } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $jYEcG.default), {
        onClick: onClick,
        testId: `${testId}-show-expanded-card`,
        backgroundColor: "elevation.surface.overlay",
        xcss: $edb8bca8c45bf806$var$buttonStyles,
        "aria-expanded": isExpanded,
        children: [
            (0, $dsh3V.stringLimiter)($edb8bca8c45bf806$var$DROPDOWN_LABEL_LIMIT, contentExpandableLabel).value || intl.formatMessage($edb8bca8c45bf806$var$messages.showDetails),
            isExpanded ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFpts))), {
                color: "currentColor",
                spacing: "spacious",
                label: intl.formatMessage($edb8bca8c45bf806$var$messages.collapse, {
                    contentExpandableLabel: contentExpandableLabel
                }),
                size: "small"
            }) : /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                color: "currentColor",
                spacing: "spacious",
                label: intl.formatMessage($edb8bca8c45bf806$var$messages.expand, {
                    contentExpandableLabel: contentExpandableLabel
                }),
                size: "small"
            })
        ]
    });
};
$edb8bca8c45bf806$export$90094d804b0e3756.displayName = "ContentDropdown";

});
parcelRegister("dsh3V", function(module, exports) {
$parcel$export(module.exports, "stringLimiter", () => $c9e58f0d2e753dd7$export$344e89a8b62fe515);
const $c9e58f0d2e753dd7$export$344e89a8b62fe515 = (limit, input)=>{
    if (input && input.length > limit) return {
        value: `${input.substring(0, limit)}...`,
        limit: true
    };
    return {
        value: input,
        limit: false
    };
};

});


parcelRegister("9XEKX", function(module, exports) {
$parcel$export(module.exports, "RecommendedBadge", () => $3e31c2e21b054f80$export$baff9a765d5af60f);

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $ai66O = parcelRequire("ai66O");
const $3e31c2e21b054f80$var$messages = (0, $7eNDO.defineMessages)({
    label: {
        defaultMessage: 'Recommended',
        description: 'The default label to show that an option is recommended',
        id: 'selectList.card.recommendedLabel'
    }
});
const $3e31c2e21b054f80$export$baff9a765d5af60f = ({ testId: testId, isSelected: isSelected = false })=>{
    const intl = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ai66O.Container), {
        "data-testid": testId,
        isSelected: isSelected,
        children: intl.formatMessage($3e31c2e21b054f80$var$messages.label)
    });
};
$3e31c2e21b054f80$export$baff9a765d5af60f.displayName = "RecommendedBadge";

});
parcelRegister("ai66O", function(module, exports) {
$parcel$export(module.exports, "Container", () => $61456a149be116b6$export$42a852a2b6b56249);

var $3kknN = parcelRequire("3kknN");
const $61456a149be116b6$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "ebjcgwg0"
})((props)=>({
        position: 'absolute',
        top: 0,
        right: 0,
        font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 653)",
        userSelect: 'none',
        borderBottomLeftRadius: '18px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isSelected ? "var(--ds-text-inverse, #FFFFFF)" : "var(--ds-text-subtle, #44546F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.isSelected ? "var(--ds-border-selected, #0C66E4)" : "var(--ds-border, rgba(9, 30, 66, 0.14))",
        transition: 'color 0.1s ease-out 0s, background-color 0.1s ease-out 0s'
    }));

});


parcelRegister("aBLn9", function(module, exports) {
$parcel$export(module.exports, "CardContainer", () => $4317479ef1b094af$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "ColumnContainer", () => $4317479ef1b094af$export$2194471aa3d52446);
$parcel$export(module.exports, "ColumnLeftContainer", () => $4317479ef1b094af$export$6afcc5f02c032bb);
$parcel$export(module.exports, "ColumnRightContainer", () => $4317479ef1b094af$export$176bfb11d924801a);
$parcel$export(module.exports, "ColumnTopContainer", () => $4317479ef1b094af$export$57369bea2c2848c8);
$parcel$export(module.exports, "ColumnTopLeftContainer", () => $4317479ef1b094af$export$8c74f281d6cdd16c);
$parcel$export(module.exports, "ColumnTopRightContainer", () => $4317479ef1b094af$export$b6543c2ab50162f2);
$parcel$export(module.exports, "Title", () => $4317479ef1b094af$export$f99233281efd08a0);
$parcel$export(module.exports, "Description", () => $4317479ef1b094af$export$393edc798c47379d);
$parcel$export(module.exports, "TitleAndDescriptionContainer", () => $4317479ef1b094af$export$864963732df5f68d);
$parcel$export(module.exports, "RowTopContainer", () => $4317479ef1b094af$export$25c6e2e31b0882eb);
$parcel$export(module.exports, "RowMidContainer", () => $4317479ef1b094af$export$23808f5c27ea7690);
$parcel$export(module.exports, "RowRadioContainer", () => $4317479ef1b094af$export$cfa5b3384fac2ab);
$parcel$export(module.exports, "RowImage", () => $4317479ef1b094af$export$270aca14f81154c3);
$parcel$export(module.exports, "RowIcon", () => $4317479ef1b094af$export$7b5f2021d5a86d4a);

var $3kknN = parcelRequire("3kknN");
function $4317479ef1b094af$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4317479ef1b094af$export$8a23e74e5cf3ca41 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa15"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.direction === 'row' ? 'width: 100%;' : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        cursor: 'pointer',
        position: 'relative',
        maxWidth: '100%',
        overflow: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.isDisabled ? "var(--ds-text-disabled, #080F214A)" : "var(--ds-text, #292A2E)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.isDisabled ? "var(--ds-background-disabled, #0515240F)" : "var(--ds-surface-overlay, #FFFFFF)",
        padding: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.direction === 'row' ? `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-250, 20px)"}` : "var(--ds-space-300, 24px)",
        borderRadius: "var(--ds-radius-small, 4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        border: props.isDisabled ? `1px solid ${"var(--ds-border-disabled, #0515240F)"}` : props.isSelected ? `1px solid ${"var(--ds-border-selected, #0C66E4)"}` : `1px solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"}`,
        transition: 'box-shadow 0.1s ease-out 0s',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:focus-visible': {
            outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #388BFF)"}`,
            outlineOffset: "var(--ds-space-025, 2px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            input: {
                outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #388BFF)"}`,
                outlineOffset: "var(--ds-space-025, 2px)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':hover': {
            boxShadow: `var(--ds-shadow-overlay, ${`0px 8px 12px #091E4226, 0px 0px 1px #091E424F`})`
        }
    }));
const $4317479ef1b094af$export$2194471aa3d52446 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa14"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const $4317479ef1b094af$export$6afcc5f02c032bb = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa13"
})({
    name: "1d3w5wq",
    styles: "width:100%"
});
const $4317479ef1b094af$export$176bfb11d924801a = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa12"
})({
    name: "pbds0y",
    styles: "margin-left:var(--ds-space-200, 16px)"
});
const $4317479ef1b094af$export$57369bea2c2848c8 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa11"
})({
    name: "1f3egm3",
    styles: "display:flex;flex-wrap:wrap;justify-content:space-between"
});
const $4317479ef1b094af$export$8c74f281d6cdd16c = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa10"
})({
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
});
const $4317479ef1b094af$export$b6543c2ab50162f2 = /*#__PURE__*/ (0, $3kknN.default)($4317479ef1b094af$export$8c74f281d6cdd16c, {
    target: "eovabpa9"
})({
    name: "0",
    styles: ""
});
const $4317479ef1b094af$export$f4ffbb233b3ad8b3 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa8"
})({
    name: "1rdkewm",
    styles: "min-width:48px;min-height:48px;background:#F4F5F7;color:#2684FF;display:flex;justify-content:center;align-items:center;margin-left:var(--ds-space-200, 16px);> span > svg{width:36px;height:36px;}"
});
const $4317479ef1b094af$export$f99233281efd08a0 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa7"
})({
    name: "67me99",
    styles: "font:var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-medium, 500);color:var(--ds-text, #292A2E);white-space:normal;overflow-wrap:anywhere"
});
const $4317479ef1b094af$export$393edc798c47379d = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa6"
})({
    name: "dtw2t0",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:var(--ds-text-subtlest, #6B6E76)"
});
const $4317479ef1b094af$export$864963732df5f68d = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa5"
})({
    name: "pbds0y",
    styles: "margin-left:var(--ds-space-200, 16px)"
});
const $4317479ef1b094af$export$25c6e2e31b0882eb = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa4"
})({
    name: "4tky7f",
    styles: "margin-bottom:var(--ds-space-400, 32px)"
});
const $4317479ef1b094af$export$23808f5c27ea7690 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa3"
})({
    name: "ql53ha",
    styles: "display:flex;align-items:center;gap:var(--ds-space-150, 12px)"
});
const $4317479ef1b094af$export$cfa5b3384fac2ab = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa2"
})({
    name: "1llo5fb",
    styles: "width:24px"
});
const $4317479ef1b094af$export$270aca14f81154c3 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "eovabpa1"
})({
    name: "1vkhuup",
    styles: "margin-left:var(--ds-space-500, 36px)"
});
const $4317479ef1b094af$export$7b5f2021d5a86d4a = /*#__PURE__*/ (0, $3kknN.default)($4317479ef1b094af$export$f4ffbb233b3ad8b3, {
    target: "eovabpa0"
})({
    name: "1gz4j9a",
    styles: "margin-left:0"
});

});


parcelRegister("cj3ZG", function(module, exports) {
$parcel$export(module.exports, "GroupHeading", () => $701d7dac92338a8c$export$85c8b41a3cd87edc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $euxye = parcelRequire("euxye");

var $hStPE = parcelRequire("hStPE");

var $hVEiN = parcelRequire("hVEiN");
function $701d7dac92338a8c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $701d7dac92338a8c$var$cardHeadingContainerStyles = {
    name: "14406a7",
    styles: "font-style:normal;font:var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:var(--ds-text, #292A2E);display:flex;gap:var(--ds-space-050, 4px)"
};
const $701d7dac92338a8c$export$85c8b41a3cd87edc = (props)=>{
    const { testId: testId, groupId: groupId, groupName: groupName, groupDescription: groupDescription, groupDescriptionIcon: groupDescriptionIcon, groupDescriptionInfoLink: groupDescriptionInfoLink, groupDescriptionInfoLinkMessage: groupDescriptionInfoLinkMessage } = props;
    if (!groupName) return null;
    return /*#__PURE__*/ (0, $hStPE.jsx)("legend", {
        css: [
            $701d7dac92338a8c$var$cardHeadingContainerStyles
        ],
        "data-testid": `${testId}-${groupId}-title`
    }, groupName, /*#__PURE__*/ (0, $hStPE.jsx)((0, $hVEiN.SelectListCardHeadingInfo), {
        testId: `${testId}-${groupId}-popup-card`,
        groupDescription: groupDescription,
        groupDescriptionInfoLink: groupDescriptionInfoLink,
        groupDescriptionIcon: groupDescriptionIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).cloneElement(groupDescriptionIcon, {
            size: 'small'
        }),
        groupDescriptionInfoLinkMessage: groupDescriptionInfoLinkMessage,
        groupName: groupName
    }));
};
$701d7dac92338a8c$export$85c8b41a3cd87edc.displayName = "GroupHeading";

});
parcelRegister("hVEiN", function(module, exports) {
$parcel$export(module.exports, "SelectListCardHeadingInfo", () => $f2a6dc93cb7c22e8$export$fda6232e318f7915);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $1YIbA = parcelRequire("1YIbA");

var $1CdDx = parcelRequire("1CdDx");

var $akMu8 = parcelRequire("akMu8");

var $cGixm = parcelRequire("cGixm");

var $3EPP0 = parcelRequire("3EPP0");
const $f2a6dc93cb7c22e8$export$fda6232e318f7915 = ({ testId: testId, groupDescription: groupDescription, groupDescriptionInfoLink: groupDescriptionInfoLink, groupDescriptionIcon: groupDescriptionIcon, groupDescriptionInfoLinkMessage: groupDescriptionInfoLinkMessage, groupName: groupName })=>{
    const [isOpen, setIsOpen] = (0, $euxye.useState)(false);
    const intl = (0, $1YIbA.default)();
    const handleTogglePopup = ()=>setIsOpen(!isOpen);
    const handleClosePopup = ()=>setIsOpen(false);
    const popUpContent = ()=>/*#__PURE__*/ (0, $e79Pd.jsxs)((0, $3EPP0.PopupContentWrapper), {
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    "data-testid": `${testId}-popup-description`,
                    children: groupDescription
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)("a", {
                    href: groupDescriptionInfoLink,
                    target: "_blank",
                    "data-testid": `${testId}-info-link`,
                    children: groupDescriptionInfoLinkMessage
                })
            ]
        });
    const popUpTrigger = (triggerProps)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $3EPP0.PopupButton), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "none",
            onClick: handleTogglePopup,
            testId: `${testId}-description-icon`,
            "aria-label": intl.formatMessage((0, $cGixm.messages).groupInfoButton, {
                groupName: groupName
            }),
            children: groupDescriptionIcon
        });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $1CdDx.default), {
        zIndex: (0, $akMu8.layers).modal(),
        placement: "right",
        isOpen: isOpen,
        onClose: handleClosePopup,
        content: popUpContent,
        trigger: popUpTrigger
    });
};
$f2a6dc93cb7c22e8$export$fda6232e318f7915.displayName = "SelectListCardHeadingInfo";

});
parcelRegister("akMu8", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $6E45X = parcelRequire("6E45X");
module.exports = Object.assign({}, $6E45X, {
    gridSize: ()=>8,
    borderRadius: ()=>3,
    fontSize: ()=>14,
    fontSizeSmall: ()=>11
});
if ($6E45X.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("cGixm", function(module, exports) {
$parcel$export(module.exports, "messages", () => $5038d3fc2e0c66bb$export$defe85febe8b728c);

var $7eNDO = parcelRequire("7eNDO");
const $5038d3fc2e0c66bb$export$defe85febe8b728c = (0, $7eNDO.defineMessages)({
    groupInfoButton: {
        id: 'admin-hub-select-list.group-info-button',
        defaultMessage: 'Info button for {groupName}',
        description: 'Accessible label for the info button associated with a select list group. The placeholder {groupName} is substituted with the name of the group.'
    }
});

});

parcelRegister("3EPP0", function(module, exports) {
$parcel$export(module.exports, "PopupContentWrapper", () => $b1fc3e3af4c9e6ae$export$31d58a3bc8fb5d66);
$parcel$export(module.exports, "PopupButton", () => $b1fc3e3af4c9e6ae$export$d39b0d24481757e7);

var $4qNCE = parcelRequire("4qNCE");

var $3kknN = parcelRequire("3kknN");
function $b1fc3e3af4c9e6ae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b1fc3e3af4c9e6ae$export$31d58a3bc8fb5d66 = /*#__PURE__*/ (0, $3kknN.default)("div", {
    target: "e1v6vov31"
})({
    name: "1srmvwn",
    styles: "width:400px;padding:var(--ds-space-300, 24px);display:flex;flex-direction:column;gap:var(--ds-space-100, 8px)"
});
const $b1fc3e3af4c9e6ae$export$d39b0d24481757e7 = /*#__PURE__*/ (0, $3kknN.default)((0, $4qNCE.default), {
    target: "e1v6vov30"
})({
    name: "1uk15if",
    styles: "background:var(--ds-background-neutral-subtle, #00000000);:hover{background:none;}"
});

});




parcelRegister("5T7Xn", function(module, exports) {
$parcel$export(module.exports, "TypeIdMap", () => $961361b165f32887$export$7b493295b4541cf7);
$parcel$export(module.exports, "lookupType", () => $961361b165f32887$export$dd5c4190ef79bf3f);
$parcel$export(module.exports, "lookupTypeByTypeId", () => $961361b165f32887$export$2d290ec50c4200c5);
$parcel$export(module.exports, "lookupTypeFromV3Data", () => $961361b165f32887$export$2e1f91665918e370);
// eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $eprc4 = parcelRequire("eprc4");

var $kHMXB = parcelRequire("kHMXB");
const $961361b165f32887$export$7b493295b4541cf7 = {
    jira: {
        name: 'Jira',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.JiraIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Jira Cloud"
        }),
        category: 'cloud'
    },
    confluence: {
        name: 'Confluence',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.ConfluenceIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Confluence Cloud"
        }),
        category: 'cloud'
    },
    'jira-dc': {
        name: 'Jira DC',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.JiraDataCenterIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Jira DC"
        }),
        category: 'dc'
    },
    'confluence-dc': {
        name: 'Confluence DC',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.ConfluenceDataCenterIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Confluence DC"
        }),
        category: 'dc'
    },
    bitbucket: {
        name: 'Bitbucket DC',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.BitbucketDataCenterIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Bitbucket DC"
        }),
        category: 'dc'
    },
    bamboo: {
        name: 'Bamboo',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eprc4.BambooIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true,
            label: "Bamboo"
        }),
        category: 'dc'
    },
    generic: {
        name: 'External Application',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kHMXB))), {
            label: "External Application"
        }),
        category: 'generic'
    }
};
const $961361b165f32887$export$dd5c4190ef79bf3f = (dcAwareTypeId)=>{
    return $961361b165f32887$export$7b493295b4541cf7[dcAwareTypeId] || $961361b165f32887$export$7b493295b4541cf7.generic;
};
const $961361b165f32887$export$2d290ec50c4200c5 = (typeid, isDataCenter)=>{
    // Handle stash=bitbucket alias
    if (typeid === 'stash') return $961361b165f32887$export$dd5c4190ef79bf3f('bitbucket');
    // Handle DC types
    if ((typeid === 'jira' || typeid === 'confluence') && isDataCenter) return $961361b165f32887$export$dd5c4190ef79bf3f(`${typeid}-dc`);
    return $961361b165f32887$export$dd5c4190ef79bf3f(typeid);
};
const $961361b165f32887$export$2e1f91665918e370 = (link)=>{
    const type = link.type;
    // TODO: We can determine if it's DC, but how?
    // if (link.data.applicationVersion !== undefined) {
    // 	type += '-dc';
    // }
    return $961361b165f32887$export$2d290ec50c4200c5(type, false);
};

});
parcelRegister("kHMXB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc410b5a6f105623fd92b95efc5298a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f12dcd5274151988$var$_react = $f12dcd5274151988$var$_interopRequireDefault((parcelRequire("euxye")));

var $f12dcd5274151988$var$_baseNew = $f12dcd5274151988$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $f12dcd5274151988$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f12dcd5274151988$var$AppIcon = (props)=>/*#__PURE__*/ $f12dcd5274151988$var$_react.default.createElement($f12dcd5274151988$var$_baseNew.default, Object.assign({
        name: "AppIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 5.208a.5.5 0 0 0-.243-.429l-5-3a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.43v5.583a.5.5 0 0 0 .243.429l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.429zm1.5 5.584a2 2 0 0 1-.97 1.715l-5 3a2 2 0 0 1-2.06 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .97-1.715l5-3a2 2 0 0 1 2.06 0l5 3A2 2 0 0 1 15 5.208z"/><path fill="currentcolor" d="M9.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>`
    }, props));
$f12dcd5274151988$var$AppIcon.displayName = 'AppIcon';
var $f12dcd5274151988$var$_default = module.exports.default = $f12dcd5274151988$var$AppIcon;

});


parcelRegister("cFFXQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f1c1dc01a89e8a6$export$2e2bcd8739ae039);
/* ProductCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $euxye = parcelRequire("euxye");

var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $2iotI = parcelRequire("2iotI");
const $9f1c1dc01a89e8a6$var$styles = {
    productCard: "_2rko12b0 _1h6d1l7x _1dqonqa1 _189ee4h9 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $9f1c1dc01a89e8a6$var$ProductCard = (props)=>{
    const { applicationType: applicationType, displayUrl: displayUrl, heading: heading } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
        xcss: $9f1c1dc01a89e8a6$var$styles.productCard,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2iotI.default), {
        size: "xxsmall",
        as: "h2"
    }, heading), props.statusLozenge), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $defJG.default), {
        space: "space.100",
        alignBlock: "center"
    }, applicationType.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, displayUrl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
        color: "color.text.subtle",
        size: "small"
    }, applicationType.name))));
};
$9f1c1dc01a89e8a6$var$ProductCard.displayName = "ProductCard";
var $9f1c1dc01a89e8a6$export$2e2bcd8739ae039 = $9f1c1dc01a89e8a6$var$ProductCard;

});

parcelRegister("l7m8P", function(module, exports) {
$parcel$export(module.exports, "STATUS_RECIPROCAL_SUCCESS", () => $9359cac0ee435131$export$657b6c684cdb0f25);
$parcel$export(module.exports, "STATUS_RECIPROCAL_INPROGRESS", () => $9359cac0ee435131$export$ebb855fc01c4dac8);
$parcel$export(module.exports, "updateStatusLog", () => $9359cac0ee435131$export$9f0778ce9e00d11);
$parcel$export(module.exports, "getApplinksAdminUrl", () => $9359cac0ee435131$export$78ab2fbb731a208e);
$parcel$export(module.exports, "getDefaultCreationState", () => $9359cac0ee435131$export$c97322013e85b0a3);
$parcel$export(module.exports, "generateApplinksCreationRedirectionUrl", () => $9359cac0ee435131$export$a227964e32a1613e);
$parcel$export(module.exports, "parseCreationStateFromUrl", () => $9359cac0ee435131$export$a3c0d7af5d0c8b3);
// The Applinks Status Log format
// We use this to interchange between the various products
// Refer to `AppLinks.Creation.generateApplinksCreationRedirectionUrl` in
// legacy frontend for more details

var $1b6Nh = parcelRequire("1b6Nh");
const $9359cac0ee435131$export$83a5ccd32faf0509 = 'completed.creation';
const $9359cac0ee435131$export$46ec94e31f2d2bee = 'failed.creation';
const $9359cac0ee435131$export$9c895fb851e899e2 = 'inprogress.creation';
const $9359cac0ee435131$export$4ef4887476a06719 = 'completed.creation.local';
const $9359cac0ee435131$export$657b6c684cdb0f25 = 'completed.creation.reciprocal';
const $9359cac0ee435131$export$ebb855fc01c4dac8 = 'inprogress.creation.reciprocal';
const $9359cac0ee435131$export$a5b9f0b29d12c743 = 'failed.creation.local';
const $9359cac0ee435131$export$151e8c78ee009a44 = 'failed.creation.reciprocal';
const $9359cac0ee435131$export$ce29b766ff657ea1 = 'failed.registerprovider.2loi';
const $9359cac0ee435131$export$a38352a15fd9f0ce = (entries)=>{
    return entries;
};
const $9359cac0ee435131$export$9f0778ce9e00d11 = (statusLog, newEntry)=>{
    return [
        ...statusLog,
        newEntry
    ];
};
const $9359cac0ee435131$export$78ab2fbb731a208e = (remoteBaseUrl, typeId)=>{
    const suffix = typeId === 'confluence' ? '/admin/listapplicationlinks.action' : (0, $1b6Nh.APPLINKS_LIST_PAGE_URL_LEGACY);
    return remoteBaseUrl + suffix;
};
const $9359cac0ee435131$export$c97322013e85b0a3 = (startingUrl, startingTypeId, originalCreatedId)=>{
    return {
        applinkCreationStatusLog: $9359cac0ee435131$export$a38352a15fd9f0ce([
            {
                status: $9359cac0ee435131$export$9c895fb851e899e2
            },
            {
                status: $9359cac0ee435131$export$4ef4887476a06719
            },
            {
                status: $9359cac0ee435131$export$ebb855fc01c4dac8
            }
        ]),
        applinkOriginalCreatedId: originalCreatedId,
        sharedUserbase: false,
        applinkConfigInUserAuth: true,
        applinkConfigInServerAuth: true,
        applinkConfigInPreAuth: true,
        applinkConfigOutUserAuth: true,
        applinkConfigOutServerAuth: true,
        applinkConfigOutPreAuth: true,
        applinkStartingUrl: startingUrl,
        applinkStartingType: startingTypeId,
        creatingReciprocal: true
    };
};
const $9359cac0ee435131$var$generateUrl = (remoteUrl, parametersMap)=>{
    if (!parametersMap || Object.keys(parametersMap).length === 0) return remoteUrl;
    const params = Object.entries(parametersMap).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
    return remoteUrl.includes('?') ? `${remoteUrl}&${params}` : `${remoteUrl}?${params}`;
};
const $9359cac0ee435131$export$a227964e32a1613e = (remoteBaseUrl, remoteTypeId, creationState)=>{
    // In the original applinks frontend, the status log was stored as a string. This means in the final URL,
    // the status log is double stringified. This is a hack to maintain compatibility with the legacy frontend.
    const parameterMap = Object.fromEntries(Object.entries(creationState).map(([key, value])=>{
        if (key === 'applinkCreationStatusLog') // Yes, I know it's awful
        return [
            key,
            JSON.stringify(JSON.stringify(creationState.applinkCreationStatusLog))
        ];
        return [
            key,
            JSON.stringify(value)
        ];
    }));
    return $9359cac0ee435131$var$generateUrl($9359cac0ee435131$export$78ab2fbb731a208e(remoteBaseUrl, remoteTypeId), parameterMap);
};
const $9359cac0ee435131$var$getAndDecode = (url, param)=>{
    const value = url.searchParams.get(param);
    if (value !== null) {
        const decodedFieldValue = decodeURIComponent(value);
        try {
            // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
            return value ? JSON.parse(decodedFieldValue) : null;
        } catch  {
            // If parsing fails, we return the decoded value as-is
            return decodedFieldValue;
        }
    }
    return undefined;
};
const $9359cac0ee435131$export$a3c0d7af5d0c8b3 = (url)=>{
    const applinkCreationStatusLog = $9359cac0ee435131$var$getAndDecode(url, 'applinkCreationStatusLog');
    if (!applinkCreationStatusLog) return null; // No creation state found
    const applinkStartingUrl = $9359cac0ee435131$var$getAndDecode(url, 'applinkStartingUrl');
    const applinkStartingType = $9359cac0ee435131$var$getAndDecode(url, 'applinkStartingType');
    const applinkOriginalCreatedId = $9359cac0ee435131$var$getAndDecode(url, 'applinkOriginalCreatedId');
    const sharedUserbase = $9359cac0ee435131$var$getAndDecode(url, 'sharedUserbase') === 'true';
    const applinkConfigInUserAuth = $9359cac0ee435131$var$getAndDecode(url, 'applinkConfigInUserAuth') === 'true';
    const applinkConfigInServerAuth = $9359cac0ee435131$var$getAndDecode(url, 'applinkConfigInServerAuth') === 'true';
    const applinkConfigInPreAuth = $9359cac0ee435131$var$getAndDecode(url, 'applinkConfigInPreAuth') === 'true';
    const applinkConfigOutUserAuth = $9359cac0ee435131$var$getAndDecode(url, 'applinkConfigOutUserAuth') === 'true';
    const applinkConfigOutServerAuth = $9359cac0ee435131$var$getAndDecode(url, 'applinkConfigOutServerAuth') === 'true';
    const applinkConfigOutPreAuth = $9359cac0ee435131$var$getAndDecode(url, 'applinkConfigOutPreAuth') === 'true';
    const creatingReciprocal = $9359cac0ee435131$var$getAndDecode(url, 'creatingReciprocal') === 'true';
    const statusLog = JSON.parse(applinkCreationStatusLog);
    return {
        applinkCreationStatusLog: statusLog,
        applinkOriginalCreatedId: applinkOriginalCreatedId || '',
        sharedUserbase: sharedUserbase,
        applinkConfigInUserAuth: applinkConfigInUserAuth,
        applinkConfigInServerAuth: applinkConfigInServerAuth,
        applinkConfigInPreAuth: applinkConfigInPreAuth,
        applinkConfigOutUserAuth: applinkConfigOutUserAuth,
        applinkConfigOutServerAuth: applinkConfigOutServerAuth,
        applinkConfigOutPreAuth: applinkConfigOutPreAuth,
        applinkStartingUrl: applinkStartingUrl || '',
        applinkStartingType: applinkStartingType || '',
        creatingReciprocal: creatingReciprocal
    };
};

});

parcelRegister("6bB9L", function(module, exports) {
$parcel$export(module.exports, "StatusLozenge", () => $446311e5e8f2d1c6$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeV3", () => $446311e5e8f2d1c6$export$e8df9076d0ccd87c);

var $euxye = parcelRequire("euxye");

var $2EFuW = parcelRequire("2EFuW");

var $abhF2 = parcelRequire("abhF2");

var $hzWaA = parcelRequire("hzWaA");

var $i860n = parcelRequire("i860n");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $9xWqG = parcelRequire("9xWqG");
const $446311e5e8f2d1c6$var$connectedStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.connected-status",
    defaultMessage: "Connected"
});
const $446311e5e8f2d1c6$var$notConnectedStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.not-connected-status",
    defaultMessage: "Not Connected"
});
const $446311e5e8f2d1c6$var$accessDeniedStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.access-denied-status",
    defaultMessage: "Access denied"
});
const $446311e5e8f2d1c6$var$authTokenRequiredMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.auth-token-required-title",
    defaultMessage: "Authenticate to see status"
});
const $446311e5e8f2d1c6$var$cloudConnectorAwaitingDcResponseStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.cloud-connector-awaiting-dc-response-status",
    defaultMessage: "Awaiting DC response"
});
const $446311e5e8f2d1c6$var$incompatibleStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.incompatible-status",
    defaultMessage: "Status unavailable"
});
const $446311e5e8f2d1c6$var$nonAtlassianStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.non-atlassian-status",
    defaultMessage: "Non-Atlassian"
});
const $446311e5e8f2d1c6$var$systemStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.system-status",
    defaultMessage: "System"
});
const $446311e5e8f2d1c6$var$networkErrorStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.network-error-status",
    defaultMessage: "Network error"
});
const $446311e5e8f2d1c6$var$creationFailedStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.creation-failed-status",
    defaultMessage: "Creation failed"
});
const $446311e5e8f2d1c6$var$configurationIncompleteStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.configuration-incomplete-status",
    defaultMessage: "Configuration incomplete"
});
const $446311e5e8f2d1c6$var$inProgressStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.in-progress-status",
    defaultMessage: "In progress"
});
const $446311e5e8f2d1c6$var$configurationCompleteMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.configuration-complete-status",
    defaultMessage: "Configuration complete"
});
const $446311e5e8f2d1c6$var$submissionFailedMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.submission-failed-status",
    defaultMessage: "Submission failed"
});
const $446311e5e8f2d1c6$var$deprecatedStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.deprecated-status",
    defaultMessage: "Deprecated"
});
const $446311e5e8f2d1c6$var$disabledStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.disabled-status",
    defaultMessage: "Disabled"
});
const $446311e5e8f2d1c6$var$configErrorStatusMessage = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.ui.common.status.config-error-status",
    defaultMessage: "Config error"
});
const $446311e5e8f2d1c6$var$messages = {
    connectedStatus: $446311e5e8f2d1c6$var$connectedStatusMessage,
    notConnectedStatus: $446311e5e8f2d1c6$var$notConnectedStatusMessage,
    accessDeniedStatus: $446311e5e8f2d1c6$var$accessDeniedStatusMessage,
    authTokenRequired: $446311e5e8f2d1c6$var$authTokenRequiredMessage,
    cloudConnectorAwaitingDcResponseStatus: $446311e5e8f2d1c6$var$cloudConnectorAwaitingDcResponseStatusMessage,
    incompatibleStatus: $446311e5e8f2d1c6$var$incompatibleStatusMessage,
    nonAtlassianStatus: $446311e5e8f2d1c6$var$nonAtlassianStatusMessage,
    systemStatus: $446311e5e8f2d1c6$var$systemStatusMessage,
    networkErrorStatus: $446311e5e8f2d1c6$var$networkErrorStatusMessage,
    creationFailedStatus: $446311e5e8f2d1c6$var$creationFailedStatusMessage,
    configurationIncompleteStatus: $446311e5e8f2d1c6$var$configurationIncompleteStatusMessage,
    inProgressStatus: $446311e5e8f2d1c6$var$inProgressStatusMessage,
    configurationComplete: $446311e5e8f2d1c6$var$configurationCompleteMessage,
    submissionFailed: $446311e5e8f2d1c6$var$submissionFailedMessage,
    deprecatedStatus: $446311e5e8f2d1c6$var$deprecatedStatusMessage,
    disabledStatus: $446311e5e8f2d1c6$var$disabledStatusMessage,
    configErrorStatus: $446311e5e8f2d1c6$var$configErrorStatusMessage
};
const $446311e5e8f2d1c6$export$f72db4ad1e9b3e6d = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    if (props.kind === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
        size: "small"
    });
    if (props.kind === 'working') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
        appearance: "success",
        isBold: true
    }, formatMessage($446311e5e8f2d1c6$var$messages.connectedStatus));
    if (props.kind === 'not-connected') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
        isBold: true
    }, formatMessage($446311e5e8f2d1c6$var$messages.notConnectedStatus));
    if (props.kind === 'error') {
        const { err: err } = props;
        if (err.category === 'ACCESS_ERROR') {
            if (err.type === 'INSUFFICIENT_REMOTE_PERMISSION') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                appearance: "moved",
                isBold: true
            }, formatMessage($446311e5e8f2d1c6$var$messages.accessDeniedStatus));
            // Authenticated status API -> prompt user to do OAuth dance
            if (props.authorisationUri) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hzWaA.default), {
                href: props.authorisationUri
            }, formatMessage($446311e5e8f2d1c6$var$messages.authTokenRequired));
            // Fallback for ACCESS_ERROR cases that don't match above conditions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                appearance: "removed",
                isBold: true
            }, formatMessage($446311e5e8f2d1c6$var$messages.accessDeniedStatus));
        }
        if ((0, $i860n.fg)('cloud-connector-applinks-migration-m1-jira-srs')) // FG tidy note: merge it to the main switch clause below
        switch(err.type){
            case 'CLOUD_CONNECTOR_AWAITING_DC_RESPONSE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.cloudConnectorAwaitingDcResponseStatus));
            default:
        }
        switch(err.type){
            case 'INCOMPATIBLE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "default",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.incompatibleStatus));
            case 'NON_ATLASSIAN':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "default",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.nonAtlassianStatus));
            case 'SYSTEM':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "default",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.systemStatus));
            case 'NETWORK_ERROR':
            case 'UNKNOWN':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.networkErrorStatus));
            case 'CREATION_FAILED':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.creationFailedStatus));
            case 'CONFIGURATION_INCOMPLETE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.configurationIncompleteStatus));
            case 'IN_PROGRESS':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "moved",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.inProgressStatus));
            case 'CONFIGURATION_COMPLETE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "inprogress",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.configurationComplete));
            case 'SUBMISSION_FAILED':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.submissionFailed));
            case 'DEPRECATED':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "inprogress",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.deprecatedStatus));
            case 'DISABLED':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "default",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.disabledStatus));
            case 'CONFIG_ERROR':
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2EFuW.default), {
                    appearance: "removed",
                    isBold: true
                }, formatMessage($446311e5e8f2d1c6$var$messages.configErrorStatus));
        }
    }
};
$446311e5e8f2d1c6$export$f72db4ad1e9b3e6d.displayName = "StatusLozenge";
const $446311e5e8f2d1c6$export$e8df9076d0ccd87c = (props)=>{
    const wrapWithV3Status = (0, $euxye.useCallback)(()=>{
        if (!props.status) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($446311e5e8f2d1c6$export$f72db4ad1e9b3e6d, {
            kind: "loading"
        });
        if (props.status.working) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($446311e5e8f2d1c6$export$f72db4ad1e9b3e6d, {
            kind: "working"
        });
        const err = props.status.error ?? (0, $9xWqG.ERRORS).UNKNOWN;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($446311e5e8f2d1c6$export$f72db4ad1e9b3e6d, {
            kind: "error",
            err: err
        });
    }, [
        props.status
    ]);
    return wrapWithV3Status();
};
$446311e5e8f2d1c6$export$e8df9076d0ccd87c.displayName = "StatusLozengeV3";

});
parcelRegister("2EFuW", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8b8592b101d1a34$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $egspI = parcelRequire("egspI");

var $3nvjS = parcelRequire("3nvjS");
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ const $d8b8592b101d1a34$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhk1w7a",
    'bg.subtle.inprogress': "_bfhk1w7a",
    'bg.subtle.moved': "_bfhk1w7a",
    'bg.subtle.new': "_bfhk1w7a",
    'bg.subtle.removed': "_bfhk1w7a",
    'bg.subtle.success': "_bfhk1w7a",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
const $d8b8592b101d1a34$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
const $d8b8592b101d1a34$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
const $d8b8592b101d1a34$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $d8b8592b101d1a34$var$LegacyLozenge = /*#__PURE__*/ (0, $euxye.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $euxye.useMemo)(()=>$d8b8592b101d1a34$var$appearanceTypes.includes(appearance) || $d8b8592b101d1a34$var$newSemanticColors.includes(appearance) ? $d8b8592b101d1a34$var$appearanceMapping[appearance] : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            $d8b8592b101d1a34$var$styles.container,
            $d8b8592b101d1a34$var$styles[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && $d8b8592b101d1a34$var$styles[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && $d8b8592b101d1a34$var$styles.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $4jQY2.default)([
                $d8b8592b101d1a34$var$styles.text,
                (0, $egspI.fg)('platform-lozenge-custom-letterspacing') && $d8b8592b101d1a34$var$styles.customLetterspacing,
                $d8b8592b101d1a34$var$styles[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
});
$d8b8592b101d1a34$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ const $d8b8592b101d1a34$var$LozengeWrapper = /*#__PURE__*/ (0, $euxye.memo)((props)=>{
    if ((0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3nvjS.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)($d8b8592b101d1a34$var$LegacyLozenge, {
        ...props
    });
});
$d8b8592b101d1a34$var$LozengeWrapper.displayName = 'Lozenge';
var $d8b8592b101d1a34$export$2e2bcd8739ae039 = $d8b8592b101d1a34$var$LozengeWrapper;

});
parcelRegister("3nvjS", function(module, exports) {
$parcel$export(module.exports, "default", () => $67b40f7b3829f7ce$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $klhLt = parcelRequire("klhLt");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $67b40f7b3829f7ce$var$Lozenge = ({ appearance: appearance = 'neutral', spacing: spacing = 'default', maxWidth: maxWidth = 200, style: style, testId: testId, children: children, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance })=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $klhLt.default), {
        ...baseProps,
        children: children
    });
};
$67b40f7b3829f7ce$var$Lozenge.displayName = "Lozenge";
$67b40f7b3829f7ce$var$Lozenge.displayName = 'Lozenge';
var $67b40f7b3829f7ce$export$2e2bcd8739ae039 = $67b40f7b3829f7ce$var$Lozenge;

});
parcelRegister("klhLt", function(module, exports) {
$parcel$export(module.exports, "default", () => $3faaeb4e176c8744$export$2e2bcd8739ae039);
/* lozenge-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $e3neg = parcelRequire("e3neg");

var $1MNmN = parcelRequire("1MNmN");

var $ld25x = parcelRequire("ld25x");

var $92a3Y = parcelRequire("92a3Y");

var $egspI = parcelRequire("egspI");

var $jYEcG = parcelRequire("jYEcG");

var $abhF2 = parcelRequire("abhF2");

var $gGNug = parcelRequire("gGNug");

var $50oxN = parcelRequire("50oxN");

var $gPZy0 = parcelRequire("gPZy0");
// Get the pressed background color for the selected lozenge dropdown trigger
const $3faaeb4e176c8744$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
const $3faaeb4e176c8744$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d3acm _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ const $3faaeb4e176c8744$var$LozengeBase = /*#__PURE__*/ (0, $euxye.memo)(/*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, testId: testId, appearance: appearance, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, maxWidth: maxWidth = 200, spacing: spacing = 'default', isSelected: isSelected, isLoading: // for dropdown trigger
isLoading = false, onClick: // for dropdown trigger
onClick, style: // for dropdown trigger
style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const [resizing, setResizing] = (0, $euxye.useState)(false);
    const onFinishMotion = ()=>setResizing(false);
    const resizingWidth = (0, $92a3Y.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    const isInitialRender = (0, $euxye.useRef)(true);
    const isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    const resolvedColor = (0, $gPZy0.resolveLozengeColor)(appearance) || 'neutral';
    const { category: category, key: key } = (0, $gGNug.getThemeStyles)(resolvedColor);
    const colorStyleKey = `${category}.${key}`;
    const interactiveStyleKey = `interactive.${category}.${key}`;
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    const resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $gPZy0.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    const metricBadgeAppearance = (()=>{
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    })();
    const commonStyleOverrides = {
        backgroundColor: style?.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : `min(${maxWidthValue}, 100%)`
    };
    const hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    const childrenKey = typeof children === 'string' ? children : undefined;
    (0, $euxye.useLayoutEffect)(()=>{
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    const enableMotionFG = (0, $egspI.fg)('platform-dst-motion-uplift');
    const innerContent = /*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
        ...enableMotionFG ? resizingWidth : undefined,
        className: (0, $4jQY2.default)([
            $3faaeb4e176c8744$var$styles.content,
            spacing === 'spacious' && $3faaeb4e176c8744$var$styles.contentSpacious,
            isLoading && $3faaeb4e176c8744$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $3faaeb4e176c8744$var$styles.maxWidth
        ]),
        children: [
            iconBefore && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $50oxN.default), {
                size: spacing === 'spacious' ? 'medium' : 'small',
                icon: iconBefore,
                color: resolvedColor,
                testId: testId && `${testId}--icon`
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                style: {
                    // The text fills 100% of the inner content wrapper. The container's
                    // own max-width (set on the container via commonStyleOverrides) handles
                    // the actual size constraint, so the text just needs to fill the available
                    // space and truncate when it overflows.
                    maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`,
                    color: style?.color
                },
                "data-testid": testId && `${testId}--text`,
                className: (0, $4jQY2.default)([
                    $3faaeb4e176c8744$var$styles.text,
                    enableMotionFG && resizing && !maxWidth ? $3faaeb4e176c8744$var$styles.textClip : $3faaeb4e176c8744$var$styles.textEllipsis,
                    spacing === 'spacious' && $3faaeb4e176c8744$var$styles.textSpacious
                ]),
                children: children
            }),
            hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                "data-lozenge-metric-wrapper": true,
                "data-testid": testId && `${testId}--metric`,
                className: (0, $4jQY2.default)([
                    $3faaeb4e176c8744$var$styles.metricBadgeWrapper
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e3neg.default), {
                    appearance: metricBadgeAppearance,
                    children: trailingMetric
                })
            }),
            isInteractive && /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                label: "",
                size: "small",
                color: 'currentColor',
                testId: testId && `${testId}--chevron`
            })
        ]
    });
    if (isInteractive) return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $jYEcG.default), {
        ref: ref,
        xcss: (0, $1MNmN.cx)($3faaeb4e176c8744$var$styles.container, (0, $egspI.fg)('platform-dst-motion-uplift') && $3faaeb4e176c8744$var$styles.motionContainer, spacing === 'spacious' && $3faaeb4e176c8744$var$styles.containerSpacious, !isSelected && $3faaeb4e176c8744$var$styles.iconBorderFilter, $3faaeb4e176c8744$var$styles[colorStyleKey], !isLoading && $3faaeb4e176c8744$var$styles[interactiveStyleKey], hasTrailingMetric && $3faaeb4e176c8744$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $3faaeb4e176c8744$var$styles.containerBadgeNeutralAppearance),
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...commonStyleOverrides,
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? 'var(--border-color) !important' : 'transparent'}`,
            backgroundColor: isSelected ? $3faaeb4e176c8744$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        },
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger",
        ...isSelected && {
            'data-selected': 'true'
        },
        children: [
            innerContent,
            isLoading && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    $3faaeb4e176c8744$var$styles.loadingOverlay
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {
                    size: spacing === 'spacious' ? 'small' : 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $4jQY2.default)([
            $3faaeb4e176c8744$var$styles.container,
            spacing === 'spacious' && $3faaeb4e176c8744$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $3faaeb4e176c8744$var$styles.containerBadgePadding,
            $3faaeb4e176c8744$var$styles[colorStyleKey],
            $3faaeb4e176c8744$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $3faaeb4e176c8744$var$styles.containerBadgeNeutralAppearance
        ]),
        children: innerContent
    });
}));
var $3faaeb4e176c8744$export$2e2bcd8739ae039 = $3faaeb4e176c8744$var$LozengeBase;

});
parcelRegister("92a3Y", function(module, exports) {
$parcel$export(module.exports, "useResizing", () => $118e3e559949fdce$export$a300664a1a230956);

var $euxye = parcelRequire("euxye");

var $bG844 = parcelRequire("bG844");

var $DxsCA = parcelRequire("DxsCA");

var $dxDNV = parcelRequire("dxDNV");

var $23KBv = parcelRequire("23KBv");

var $3bcsJ = parcelRequire("3bcsJ");

var $8SBzz = parcelRequire("8SBzz");
/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $118e3e559949fdce$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $118e3e559949fdce$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $118e3e559949fdce$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $118e3e559949fdce$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $euxye.useRef)();
    const [element, setElementRef] = (0, $DxsCA.useElementRef)();
    const setTimeout = (0, $3bcsJ.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $23KBv.useRequestAnimationFrame)();
    (0, $8SBzz.useSnapshotBeforeUpdate)(()=>{
        if ((0, $bG844.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $dxDNV.useLayoutEffect)(()=>{
        if ((0, $bG844.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$118e3e559949fdce$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $118e3e559949fdce$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $118e3e559949fdce$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

});
parcelRegister("DxsCA", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $958f86e68cfa7424$export$ff879f35a69d56b7);

var $euxye = parcelRequire("euxye");
const $958f86e68cfa7424$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $euxye.useRef)(null);
    const setRef = (0, $euxye.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("23KBv", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $f0c1db887ba444d9$export$1775f27e7c8051ca);

var $euxye = parcelRequire("euxye");
const $f0c1db887ba444d9$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f0c1db887ba444d9$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $euxye.useRef)([]);
    (0, $euxye.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f0c1db887ba444d9$var$getHookDeps(opts));
    return (0, $euxye.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};

});

parcelRegister("8SBzz", function(module, exports) {
$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $96af143d05808ac5$export$9e95200239cd148b);

var $euxye = parcelRequire("euxye");

var $dxDNV = parcelRequire("dxDNV");
const $96af143d05808ac5$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $euxye.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dxDNV.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("gGNug", function(module, exports) {
$parcel$export(module.exports, "getThemeStyles", () => $d4c8d18968527ec3$export$a3fc04b8551e006a);
const $d4c8d18968527ec3$export$a3fc04b8551e006a = (resolvedColor)=>{
    const isAccent = resolvedColor.startsWith('accent-');
    const category = isAccent ? 'accent' : 'semantic';
    const key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

});

parcelRegister("50oxN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e718e55264f9758e$export$2e2bcd8739ae039);
/* icon-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $egspI = parcelRequire("egspI");

var $ihEDU = parcelRequire("ihEDU");
// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
const $e718e55264f9758e$var$getIconColor = (color)=>{
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
const $e718e55264f9758e$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
}; /**
    * Icon renderer for lozenge components
    * Handles proper sizing and color theming for icons
    */ 
const $e718e55264f9758e$var$IconRenderer = ({ icon: Icon, color: color, testId: testId, size: size })=>{
    const iconColor = $e718e55264f9758e$var$getIconColor(color);
    return (0, $egspI.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $ihEDU.default), {
        xcss: $e718e55264f9758e$var$styles.motion,
        style: {
            color: iconColor
        },
        children: /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
            label: "",
            size: size,
            testId: testId
        })
    }) : // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
$e718e55264f9758e$var$IconRenderer.displayName = "IconRenderer";
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$e718e55264f9758e$export$2e2bcd8739ae039 = $e718e55264f9758e$var$IconRenderer;

});

parcelRegister("gPZy0", function(module, exports) {
$parcel$export(module.exports, "resolveLozengeColor", () => $0cbf84f8cb80cf72$export$acf5d2b7dc999bda);

// Map legacy appearance to new color values
const $0cbf84f8cb80cf72$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
const $0cbf84f8cb80cf72$export$acf5d2b7dc999bda = (appearance = 'neutral')=>{
    if (appearance.startsWith('accent-')) return appearance;
    return $0cbf84f8cb80cf72$var$legacyAppearanceMap[appearance] ?? appearance;
};

});




parcelRegister("9xWqG", function(module, exports) {
$parcel$export(module.exports, "ERRORS", () => $f21763ad558f7970$export$4fd720569787ab6f);
/* eslint-disable jira/filename-case */ const $f21763ad558f7970$export$4fd720569787ab6f = {
    // Network errors
    CONNECTION_REFUSED: {
        type: 'CONNECTION_REFUSED',
        category: 'NETWORK_ERROR'
    },
    UNKNOWN_HOST: {
        type: 'UNKNOWN_HOST',
        category: 'NETWORK_ERROR'
    },
    SSL_UNTRUSTED: {
        type: 'SSL_UNTRUSTED',
        category: 'NETWORK_ERROR'
    },
    SSL_HOSTNAME_UNMATCHED: {
        type: 'SSL_HOSTNAME_UNMATCHED',
        category: 'NETWORK_ERROR'
    },
    SSL_UNMATCHED: {
        type: 'SSL_UNMATCHED',
        category: 'NETWORK_ERROR'
    },
    OAUTH_PROBLEM: {
        type: 'OAUTH_PROBLEM',
        category: 'NETWORK_ERROR'
    },
    OAUTH_TIMESTAMP_REFUSED: {
        type: 'OAUTH_TIMESTAMP_REFUSED',
        category: 'NETWORK_ERROR'
    },
    OAUTH_SIGNATURE_INVALID: {
        type: 'OAUTH_SIGNATURE_INVALID',
        category: 'NETWORK_ERROR'
    },
    UNEXPECTED_RESPONSE: {
        type: 'UNEXPECTED_RESPONSE',
        category: 'NETWORK_ERROR'
    },
    UNEXPECTED_RESPONSE_STATUS: {
        type: 'UNEXPECTED_RESPONSE_STATUS',
        category: 'NETWORK_ERROR'
    },
    // Configuration state errors
    CREATION_FAILED: {
        type: 'CREATION_FAILED',
        category: 'CREATION_FAILED'
    },
    CONFIGURATION_INCOMPLETE: {
        type: 'CONFIGURATION_INCOMPLETE',
        category: 'CONFIGURATION_INCOMPLETE'
    },
    CLOUD_CONNECTOR_AWAITING_DC_RESPONSE: {
        type: 'CLOUD_CONNECTOR_AWAITING_DC_RESPONSE',
        category: 'CONFIGURATION_INCOMPLETE'
    },
    IN_PROGRESS: {
        type: 'IN_PROGRESS',
        category: 'IN_PROGRESS'
    },
    SUBMISSION_FAILED: {
        type: 'SUBMISSION_FAILED',
        category: 'SUBMISSION_FAILED'
    },
    CONFIGURATION_COMPLETE: {
        type: 'CONFIGURATION_COMPLETE',
        category: 'CONFIGURATION_COMPLETE'
    },
    // Configuration errors
    AUTH_LEVEL_MISMATCH: {
        type: 'AUTH_LEVEL_MISMATCH',
        category: 'CONFIG_ERROR'
    },
    NO_REMOTE_APPLINK: {
        type: 'NO_REMOTE_APPLINK',
        category: 'CONFIG_ERROR'
    },
    // Access errors
    LOCAL_AUTH_TOKEN_REQUIRED: {
        type: 'LOCAL_AUTH_TOKEN_REQUIRED',
        category: 'ACCESS_ERROR'
    },
    REMOTE_AUTH_TOKEN_REQUIRED: {
        type: 'REMOTE_AUTH_TOKEN_REQUIRED',
        category: 'ACCESS_ERROR'
    },
    INSUFFICIENT_REMOTE_PERMISSION: {
        type: 'INSUFFICIENT_REMOTE_PERMISSION',
        category: 'ACCESS_ERROR'
    },
    // Incompatibility errors
    REMOTE_VERSION_INCOMPATIBLE: {
        type: 'REMOTE_VERSION_INCOMPATIBLE',
        category: 'INCOMPATIBLE'
    },
    NO_OUTGOING_AUTH: {
        type: 'NO_OUTGOING_AUTH',
        category: 'INCOMPATIBLE'
    },
    // Non-Atlassian errors
    GENERIC_LINK: {
        type: 'GENERIC_LINK',
        category: 'NON_ATLASSIAN'
    },
    NON_ATLASSIAN: {
        type: 'NON_ATLASSIAN',
        category: 'NON_ATLASSIAN'
    },
    // System errors
    SYSTEM_LINK: {
        type: 'SYSTEM_LINK',
        category: 'SYSTEM'
    },
    // Disabled errors
    DISABLED: {
        type: 'DISABLED',
        category: 'DISABLED'
    },
    // Deprecated functionality errors
    AUTH_LEVEL_UNSUPPORTED: {
        type: 'AUTH_LEVEL_UNSUPPORTED',
        category: 'DEPRECATED'
    },
    LEGACY_UPDATE: {
        type: 'LEGACY_UPDATE',
        category: 'DEPRECATED'
    },
    LEGACY_REMOVAL: {
        type: 'LEGACY_REMOVAL',
        category: 'DEPRECATED'
    },
    MANUAL_LEGACY_UPDATE: {
        type: 'MANUAL_LEGACY_UPDATE',
        category: 'DEPRECATED'
    },
    MANUAL_LEGACY_REMOVAL: {
        type: 'MANUAL_LEGACY_REMOVAL',
        category: 'DEPRECATED'
    },
    // Unknown errors
    UNKNOWN: {
        type: 'UNKNOWN',
        category: 'UNKNOWN'
    }
};

});



parcelRegister("d58Bx", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f0e61614c7e3588$export$2e2bcd8739ae039);
/* ReciprocalPromptSubpage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $a9o4s = parcelRequire("a9o4s");

var $iOfms = parcelRequire("iOfms");
var $9ufM9 = parcelRequire("9ufM9");

var $fWb5q = parcelRequire("fWb5q");

var $7mtMc = parcelRequire("7mtMc");

var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $5T7Xn = parcelRequire("5T7Xn");

var $cFFXQ = parcelRequire("cFFXQ");

var $l7m8P = parcelRequire("l7m8P");

var $6bB9L = parcelRequire("6bB9L");

var $9xWqG = parcelRequire("9xWqG");

var $eiO6t = parcelRequire("eiO6t");
const $9f0e61614c7e3588$var$styles = {
    linkDisplay: "_19pkpxbi _otyrpxbi",
    fullContainer: "_4t3i1osq"
};
const $9f0e61614c7e3588$var$cancelButtonTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Cancel",
    id: "applinks.administration.ui.creation-flow-dialog.cancel-form-button-text-nonfinal"
});
const $9f0e61614c7e3588$var$reciprocalPromptContinueOnButtonTextNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Continue on {targetApplicationName}",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-1-reciprocal-description-nonfinal"
});
const $9f0e61614c7e3588$var$reciprocalPromptDescriptionNonfinalMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "A link from Jira to {targetApplicationName} has been established. You will need to navigate to {targetApplicationName} to complete the link.",
    id: "applinks.administration.ui.creation-flow-dialog.review-oauth-1-reciprocal-description-nonfinal"
});
const $9f0e61614c7e3588$var$ReciprocalPromptSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const thisApplicationManifest = props.state.localManifest;
    const targetApplicationManifest = props.state.remoteManifest;
    const targetCloudId = props.state.remoteManifest.id;
    const thisBaseUrl = thisApplicationManifest.url;
    const thisBaseTypeId = thisApplicationManifest.typeId;
    const creationState = (0, $l7m8P.getDefaultCreationState)(thisBaseUrl, thisBaseTypeId, targetCloudId);
    const reciprocalLinkUrl = (0, $l7m8P.generateApplinksCreationRedirectionUrl)(targetApplicationManifest.url, targetApplicationManifest.typeId, creationState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fWb5q.default), {
        onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
        xcss: $9f0e61614c7e3588$var$styles.fullContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eiO6t.SubpageTemplate), {
        variant: props.state.variant,
        kind: props.state.kind,
        buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), {
            label: "Form submit options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
            appearance: "subtle"
        }, formatMessage($9f0e61614c7e3588$var$cancelButtonTextNonfinalMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9ufM9.default), {
            href: reciprocalLinkUrl,
            appearance: "primary"
        }, formatMessage($9f0e61614c7e3588$var$reciprocalPromptContinueOnButtonTextNonfinalMessage, {
            targetApplicationName: targetApplicationManifest.name
        }))),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7mtMc.default), {
            title: "Create reciprocal link"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($9f0e61614c7e3588$var$reciprocalPromptDescriptionNonfinalMessage, {
            targetApplicationName: targetApplicationManifest.name
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            xcss: $9f0e61614c7e3588$var$styles.linkDisplay,
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cFFXQ.default // TODO: Determine if the type is DC or Cloud
        ), {
            applicationType: (0, $5T7Xn.lookupTypeByTypeId)(targetApplicationManifest.typeId, false),
            displayUrl: targetApplicationManifest.url,
            heading: "Application Link",
            statusLozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6bB9L.StatusLozenge), {
                kind: "error",
                err: (0, $9xWqG.ERRORS).CONFIGURATION_COMPLETE
            })
        })))
    }));
};
$9f0e61614c7e3588$var$ReciprocalPromptSubpage.displayName = "ReciprocalPromptSubpage";
var $9f0e61614c7e3588$export$2e2bcd8739ae039 = $9f0e61614c7e3588$var$ReciprocalPromptSubpage;

});

parcelRegister("gjyKl", function(module, exports) {
$parcel$export(module.exports, "default", () => $459c319cb390f56f$export$2e2bcd8739ae039);
/* ConfirmationSubpage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $euxye = parcelRequire("euxye");

var $a9o4s = parcelRequire("a9o4s");

var $iOfms = parcelRequire("iOfms");

var $fWb5q = parcelRequire("fWb5q");

var $7mtMc = parcelRequire("7mtMc");

var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $abhF2 = parcelRequire("abhF2");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $5T7Xn = parcelRequire("5T7Xn");

var $cFFXQ = parcelRequire("cFFXQ");

var $drATu = parcelRequire("drATu");

var $1b6Nh = parcelRequire("1b6Nh");

var $6bB9L = parcelRequire("6bB9L");

var $eiO6t = parcelRequire("eiO6t");
const $459c319cb390f56f$var$styles = {
    linkDisplay: "_19pkpxbi _otyrpxbi",
    fullContainer: "_4t3i1osq"
};
const $459c319cb390f56f$var$doneButton = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.creation-flow-dialog.confirmation.done-button.non-final-ai",
    defaultMessage: "Done"
});
const $459c319cb390f56f$var$applicationLinkCreated = (0, $7eNDO.defineMessage)({
    id: "applinks.administration.list.creation-flow-dialog.confirmation.application-link-created.non-final-ai",
    defaultMessage: "The application link has been created."
});
const $459c319cb390f56f$var$ConfirmationSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [status, setStatus] = (0, $euxye.useState)(null);
    const finaliseOAuth1Link = async (confirmationApplinkId)=>{
        await (0, $drATu.putApplinkOAuthOne3LOProvider)(confirmationApplinkId);
        await (0, $drATu.autoConfigureApplinkConsumer)(confirmationApplinkId);
        await (0, $drATu.putApplinkOAuthOne2LOProvider)(confirmationApplinkId);
        setStatus(await (0, $drATu.fetchApplinkStatus)(confirmationApplinkId));
    }; // eslint-disable-next-line react-you-might-not-need-an-effect/no-reset-all-state-on-prop-change
    (0, $euxye.useEffect)(()=>{
        // TODO: Enforce this using discriminated union types
        if (props.state.variant === 'OAUTH2.0') {
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
            setStatus(null);
            return;
        }
        finaliseOAuth1Link(props.state.confirmationApplinkId);
    }, [
        props.state.confirmationApplinkId,
        props.state.variant
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fWb5q.default), {
        onSubmit: ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.href = (0, $1b6Nh.APPLINKS_LIST_PAGE_URL);
        },
        xcss: $459c319cb390f56f$var$styles.fullContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eiO6t.SubpageTemplate), {
        variant: props.state.variant,
        kind: props.state.kind,
        buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), {
            label: "Form submit options"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
            type: "submit",
            appearance: "primary",
            isLoading: status === null
        }, formatMessage($459c319cb390f56f$var$doneButton))),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7mtMc.default), {
            title: "Confirmation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage($459c319cb390f56f$var$applicationLinkCreated))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
            xcss: $459c319cb390f56f$var$styles.linkDisplay,
            space: "space.200"
        }, status && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $cFFXQ.default // TODO: Determine if the type is DC or Cloud
        ), {
            applicationType: (0, $5T7Xn.lookupTypeByTypeId)(status.link.type, false),
            displayUrl: status.link.displayUrl,
            heading: "Application Link",
            statusLozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6bB9L.StatusLozengeV3), {
                status: status
            })
        }), status === null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $abhF2.default), {
            size: "medium"
        })))
    }));
};
$459c319cb390f56f$var$ConfirmationSubpage.displayName = "ConfirmationSubpage";
var $459c319cb390f56f$export$2e2bcd8739ae039 = $459c319cb390f56f$var$ConfirmationSubpage;

});

parcelRegister("7kc1Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $44c937e4f29c5dd4$export$2e2bcd8739ae039);
/* ConnectSubpage.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $a9o4s = parcelRequire("a9o4s");

var $iOfms = parcelRequire("iOfms");

var $fWb5q = parcelRequire("fWb5q");

var $7mtMc = parcelRequire("7mtMc");

var $dIqcw = parcelRequire("dIqcw");

var $3PC9r = parcelRequire("3PC9r");
var $8Sdzy = parcelRequire("8Sdzy");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $6CfY5 = parcelRequire("6CfY5");

var $i860n = parcelRequire("i860n");

var $drATu = parcelRequire("drATu");

var $aRJMv = parcelRequire("aRJMv");

var $eiO6t = parcelRequire("eiO6t");

var $kjKdI = parcelRequire("kjKdI");
const $44c937e4f29c5dd4$var$styles = {
    fullContainer: "_4t3i1osq"
};
const $44c937e4f29c5dd4$var$connectHeaderMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Connect to the application",
    id: "applinks.administration.ui.creation-flow-dialog.connect-header"
});
const $44c937e4f29c5dd4$var$connectHeaderCloudConnectorMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Choose scopes",
    id: "applinks.administration.ui.creation-flow-dialog.connect-header-cloud-connector"
});
const $44c937e4f29c5dd4$var$connectDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Copy and paste the details below between this page and the settings page of the external application where you configure application links. This creates a secure connection.",
    id: "applinks.administration.ui.creation-flow-dialog.connect-description"
});
const $44c937e4f29c5dd4$var$connectDescriptionCloudConnectorMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Select the permission scopes that control how your app can interact with the remote DC app.",
    id: "applinks.administration.ui.creation-flow-dialog.connect-description-cloud-connector"
});
const $44c937e4f29c5dd4$var$connectContinueButtonMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Connect",
    id: "applinks.administration.ui.creation-flow-dialog.connect-continue-button"
});
const $44c937e4f29c5dd4$var$connectContinueButtonCloudConnectorMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Save",
    id: "applinks.administration.ui.creation-flow-dialog.connect-continue-button-cloud-connector"
});
const $44c937e4f29c5dd4$var$connectDoLaterButtonMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Do this later",
    id: "applinks.administration.ui.creation-flow-dialog.connect-do-later-button"
});
const $44c937e4f29c5dd4$var$requiredFieldsTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Required fields are marked with an asterisk",
    id: "applinks.administration.ui.creation-flow-dialog.required-fields-text"
});
const $44c937e4f29c5dd4$var$unknownErrorTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "We encountered an unknown error.",
    id: "applinks.administration.ui.unknown-error"
});
const $44c937e4f29c5dd4$var$ConnectSubpage = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const isCloudConnector = !!props.state.applink.properties?.CLOUD_CONNECTOR_PRODUCT_CONNECTION_ID;
    const onFormSubmit = async (data)=>{
        const scopes = data.remoteApplicationSupportedScopes ? data.remoteApplicationSupportedScopes.map((scope)=>scope.value) : [];
        const oauth2Config = {
            remoteClientId: data.applicationClientId,
            remoteClientSecret: data.applicationClientSecret,
            remoteRedirectUrl: data.redirectUrl,
            outboundScopes: scopes
        };
        try {
            await (0, $drATu.putOAuth2ConfigInfo)(props.state.applink.id, oauth2Config);
            props.onSuccess(); // Success = close the drawer
        } catch (err) {
            const maybeError = err instanceof Error ? err : undefined;
            (0, $6CfY5.default).safeErrorWithoutCustomerData('applinks.administration.list.creation-flow-dialog.connect.submitConnectForm', 'Failed to submit credentials form for newly created OAuth 2.0 applink', maybeError);
            if ((0, $i860n.fg)('applinks-1093-redirect-error-fix')) props.onError((0, $kjKdI.formatBackendError)(maybeError, formatMessage($44c937e4f29c5dd4$var$unknownErrorTextMessage)));
            else props.onError(maybeError ? maybeError.message : formatMessage($44c937e4f29c5dd4$var$unknownErrorTextMessage));
            return err;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fWb5q.default), {
        onSubmit: onFormSubmit,
        xcss: $44c937e4f29c5dd4$var$styles.fullContainer
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $eiO6t.SubpageTemplate), {
            variant: props.state.variant,
            kind: props.state.kind,
            buttons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a9o4s.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
                appearance: "subtle",
                onClick: props.onCancel
            }, formatMessage($44c937e4f29c5dd4$var$connectDoLaterButtonMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
                testId: "applinks-administration.ui.list.creation-flow-dialog.connect.submit-button",
                type: "submit",
                appearance: "primary",
                isLoading: submitting
            }, formatMessage(isCloudConnector ? $44c937e4f29c5dd4$var$connectContinueButtonCloudConnectorMessage : $44c937e4f29c5dd4$var$connectContinueButtonMessage))),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7mtMc.default), {
                title: formatMessage(isCloudConnector ? $44c937e4f29c5dd4$var$connectHeaderCloudConnectorMessage : $44c937e4f29c5dd4$var$connectHeaderMessage)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), {
                space: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), null, formatMessage(isCloudConnector ? $44c937e4f29c5dd4$var$connectDescriptionCloudConnectorMessage : $44c937e4f29c5dd4$var$connectDescriptionMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8Sdzy.default), {
                "aria-hidden": "true",
                size: "small"
            }, formatMessage($44c937e4f29c5dd4$var$requiredFieldsTextMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dIqcw.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $aRJMv.default), {
                applink: props.state.applink,
                oauth2ConfigInfo: props.state.oauth2ConfigInfo,
                onDisplayError: props.onError,
                onRequestStatusRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
                partiallyLinkedMode: true
            }))
        })));
};
$44c937e4f29c5dd4$var$ConnectSubpage.displayName = "ConnectSubpage";
var $44c937e4f29c5dd4$export$2e2bcd8739ae039 = $44c937e4f29c5dd4$var$ConnectSubpage;

});
parcelRegister("aRJMv", function(module, exports) {
$parcel$export(module.exports, "default", () => $5db588841a44d350$export$2e2bcd8739ae039);
/* CredentialsForm.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $ihEDU = parcelRequire("ihEDU");
var $defJG = parcelRequire("defJG");
var $3PC9r = parcelRequire("3PC9r");

var $2kZKn = parcelRequire("2kZKn");

var $hzWaA = parcelRequire("hzWaA");

var $d8bZ5 = parcelRequire("d8bZ5");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $8nfKz = parcelRequire("8nfKz");

var $fhcP0 = parcelRequire("fhcP0");

var $l7m8P = parcelRequire("l7m8P");

var $eGbwi = parcelRequire("eGbwi");
const $5db588841a44d350$var$outgoingCredentialsButtonTextMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Update outgoing link credentials",
    id: "applinks.administration.ui.edit.outgoing-credentials-button-text"
});
const $5db588841a44d350$var$outgoingLinkTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Outgoing link",
    id: "applinks.administration.ui.edit.outgoing-link.title"
});
const $5db588841a44d350$var$outgoingLinkDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Find these details in the external application and enter them below. You may need to ask an admin of the external application for these details.",
    id: "applinks.administration.ui.edit.outgoing-link.description"
});
const $5db588841a44d350$var$incomingLinkTitleMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Incoming link",
    id: "applinks.administration.ui.edit.incoming-link.title"
});
const $5db588841a44d350$var$incomingLinkDescriptionMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Copy these details to the external application. If you're not an admin of the application, ask an existing admin to make the updates for you.",
    id: "applinks.administration.ui.edit.incoming-link.description"
});
const $5db588841a44d350$var$goToRemoteSiteLinkMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Go to {displayUrl}",
    id: "applinks.administration.ui.edit.go-to-remote-site-link"
});
const $5db588841a44d350$var$styles = {
    growField: "_16jlkb7n",
    formSectionInner: "_19pkpxbi"
};
const $5db588841a44d350$var$OutgoingCredentialsModalButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const entryPointProps = (0, $euxye.useMemo)(()=>({
            applink: props.applink,
            onDisplayError: props.onDisplayError,
            onClose: props.onRequestStatusRefresh
        }), [
        props.applink,
        props.onDisplayError,
        props.onRequestStatusRefresh
    ]);
    return /*#__PURE__*/ $euxye.createElement((0, $8nfKz.ModalButtonTrigger), {
        testId: "applinks-administration.ui.edit.oauth2.credentials-form.outgoing-credentials-modal-button",
        name: "updateOutgoingLinkCredentials",
        entryPoint: (0, $eGbwi.outgoingCredentialsModalEntryPoint),
        entryPointProps: entryPointProps,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($d8bZ5)))
    }, formatMessage($5db588841a44d350$var$outgoingCredentialsButtonTextMessage));
};
$5db588841a44d350$var$OutgoingCredentialsModalButton.displayName = "OutgoingCredentialsModalButton";
const $5db588841a44d350$var$OutgoingScopes = (props)=>{
    if (props.oauth2ConfigInfo.isRemoteApplicationCloud) return null;
    return /*#__PURE__*/ $euxye.createElement((0, $fhcP0.RemoteApplicationScopeMultiSelect), {
        name: "remoteApplicationSupportedScopes",
        supportedScopes: props.oauth2ConfigInfo.remoteApplicationSupportedScopes || [],
        defaultSelected: props.oauth2ConfigInfo.outboundScopes?.map((scope)=>({
                label: scope,
                value: scope
            })) || []
    });
};
$5db588841a44d350$var$OutgoingScopes.displayName = "OutgoingScopes";
const $5db588841a44d350$var$CloudConnectorCredentialsForm = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), null, /*#__PURE__*/ $euxye.createElement((0, $2kZKn.default), {
        title: formatMessage($5db588841a44d350$var$outgoingLinkTitleMessage)
    }, /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), {
        space: "space.200",
        xcss: $5db588841a44d350$var$styles.formSectionInner
    }, /*#__PURE__*/ $euxye.createElement($5db588841a44d350$var$OutgoingScopes, {
        oauth2ConfigInfo: props.oauth2ConfigInfo
    }))));
};
$5db588841a44d350$var$CloudConnectorCredentialsForm.displayName = "CloudConnectorCredentialsForm";
const $5db588841a44d350$var$StandardCredentialsForm = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), null, /*#__PURE__*/ $euxye.createElement((0, $2kZKn.default), {
        title: formatMessage($5db588841a44d350$var$incomingLinkTitleMessage),
        description: formatMessage($5db588841a44d350$var$incomingLinkDescriptionMessage)
    }, /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), {
        space: "space.200",
        xcss: $5db588841a44d350$var$styles.formSectionInner
    }, /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        space: "space.200"
    }, /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $5db588841a44d350$var$styles.growField
    }, /*#__PURE__*/ $euxye.createElement((0, $fhcP0.CopyableApplicationClientID), {
        name: "copyableApplicationClientId",
        clientId: props.oauth2ConfigInfo.inboundOAuthClientId
    })), /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $5db588841a44d350$var$styles.growField
    }, /*#__PURE__*/ $euxye.createElement((0, $fhcP0.CopyableApplicationClientSecret), {
        name: "copyableApplicationClientSecret",
        clientSecret: props.oauth2ConfigInfo.inboundOAuthClientSecret
    }))))), /*#__PURE__*/ $euxye.createElement((0, $2kZKn.default), {
        title: formatMessage($5db588841a44d350$var$outgoingLinkTitleMessage),
        description: formatMessage($5db588841a44d350$var$outgoingLinkDescriptionMessage)
    }, /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), {
        space: "space.200",
        xcss: $5db588841a44d350$var$styles.formSectionInner
    }, props.partiallyLinkedMode && /*#__PURE__*/ $euxye.createElement((0, $3PC9r.default), {
        space: "space.200"
    }, /*#__PURE__*/ $euxye.createElement((0, $defJG.default), {
        space: "space.200"
    }, /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $5db588841a44d350$var$styles.growField
    }, /*#__PURE__*/ $euxye.createElement((0, $fhcP0.ApplicationClientId), {
        name: "applicationClientId"
    })), /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), {
        xcss: $5db588841a44d350$var$styles.growField
    }, /*#__PURE__*/ $euxye.createElement((0, $fhcP0.ApplicationClientSecret), {
        name: "applicationClientSecret"
    })))), !props.oauth2ConfigInfo.isRemoteApplicationCloud && /*#__PURE__*/ $euxye.createElement((0, $fhcP0.RedirectUrl), {
        name: "redirectUrl",
        defaultRedirectUrl: props.oauth2ConfigInfo?.inboundRedirectUrl || ''
    }), /*#__PURE__*/ $euxye.createElement($5db588841a44d350$var$OutgoingScopes, {
        oauth2ConfigInfo: props.oauth2ConfigInfo
    }), !props.partiallyLinkedMode && /*#__PURE__*/ $euxye.createElement((0, $ihEDU.default), null, /*#__PURE__*/ $euxye.createElement($5db588841a44d350$var$OutgoingCredentialsModalButton, {
        applink: props.applink,
        onDisplayError: props.onDisplayError,
        onRequestStatusRefresh: props.onRequestStatusRefresh
    })), /*#__PURE__*/ $euxye.createElement((0, $hzWaA.default), {
        href: (0, $l7m8P.getApplinksAdminUrl)(props.applink.displayUrl, props.applink.type),
        target: "_blank"
    }, formatMessage($5db588841a44d350$var$goToRemoteSiteLinkMessage, {
        displayUrl: props.applink.displayUrl
    })))));
};
$5db588841a44d350$var$StandardCredentialsForm.displayName = "StandardCredentialsForm";
const $5db588841a44d350$var$CredentialsForm = (props)=>{
    const isCloudConnector = !!props.applink.properties?.CLOUD_CONNECTOR_PRODUCT_CONNECTION_ID;
    if (isCloudConnector) return /*#__PURE__*/ $euxye.createElement($5db588841a44d350$var$CloudConnectorCredentialsForm, {
        oauth2ConfigInfo: props.oauth2ConfigInfo
    });
    return /*#__PURE__*/ $euxye.createElement($5db588841a44d350$var$StandardCredentialsForm, props);
};
$5db588841a44d350$var$CredentialsForm.displayName = "CredentialsForm";
var $5db588841a44d350$export$2e2bcd8739ae039 = $5db588841a44d350$var$CredentialsForm;

});
parcelRegister("d8bZ5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63ac376f9836d1894f72051899adf679>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98f551873407a443$var$_react = $98f551873407a443$var$_interopRequireDefault((parcelRequire("euxye")));

var $98f551873407a443$var$_baseNew = $98f551873407a443$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $98f551873407a443$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98f551873407a443$var$EditIcon = (props)=>/*#__PURE__*/ $98f551873407a443$var$_react.default.createElement($98f551873407a443$var$_baseNew.default, Object.assign({
        name: "EditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$98f551873407a443$var$EditIcon.displayName = 'EditIcon';
var $98f551873407a443$var$_default = module.exports.default = $98f551873407a443$var$EditIcon;

});

parcelRegister("8nfKz", function(module, exports) {
$parcel$export(module.exports, "ModalButtonTrigger", () => $b0cd71e2bdf6ca70$export$156b5756ed7a09ad);

var $euxye = parcelRequire("euxye");

var $iOfms = parcelRequire("iOfms");

var $ikm5U = parcelRequire("ikm5U");
function $b0cd71e2bdf6ca70$export$156b5756ed7a09ad({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: preloadOnFocus, ...buttonProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ikm5U.ModalTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        Fallback: Fallback,
        title: modalTitle,
        modalProps: modalProps,
        onError: onError,
        preloadOnFocus: preloadOnFocus
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $iOfms.default), {
            ref: ref,
            ...buttonProps
        }, children));
}
$b0cd71e2bdf6ca70$export$156b5756ed7a09ad.displayName = "ModalButtonTrigger";

});

parcelRegister("fhcP0", function(module, exports) {
$parcel$export(module.exports, "CopyableApplicationClientID", () => $753a107deadb6590$export$933c655d375093bb);
$parcel$export(module.exports, "CopyableApplicationClientSecret", () => $753a107deadb6590$export$eeaa05b78b5f2773);
$parcel$export(module.exports, "RemoteApplicationScopeMultiSelect", () => $753a107deadb6590$export$e6ea1c895768a29c);
$parcel$export(module.exports, "ApplicationClientId", () => $753a107deadb6590$export$c8399aae3a726af3);
$parcel$export(module.exports, "ApplicationClientSecret", () => $753a107deadb6590$export$f137c4dc8b585189);
$parcel$export(module.exports, "RedirectUrl", () => $753a107deadb6590$export$e0ad63dba68d8cca);
$parcel$export(module.exports, "DisplayName", () => $753a107deadb6590$export$101fbca3a406e1fd);
$parcel$export(module.exports, "DisplayUrl", () => $753a107deadb6590$export$b07e64a5c70fbd11);
$parcel$export(module.exports, "ApplicationUrl", () => $753a107deadb6590$export$5c4f409b6c929d7a);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $euxye = parcelRequire("euxye");

var $3PC9r = parcelRequire("3PC9r");

var $hO3zy = parcelRequire("hO3zy");
var $bEwPd = parcelRequire("bEwPd");

var $1W2Av = parcelRequire("1W2Av");

var $7aCqr = parcelRequire("7aCqr");

var $ioVrz = parcelRequire("ioVrz");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $kjKdI = parcelRequire("kjKdI");

var $1b6Nh = parcelRequire("1b6Nh");

var $8RhC5 = parcelRequire("8RhC5");
const $753a107deadb6590$var$clientIdLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "App client ID",
    id: "applinks.administration.ui.common.fields.client-id.label"
});
const $753a107deadb6590$var$clientSecretLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "App client secret",
    id: "applinks.administration.ui.common.fields.client-secret.label"
});
const $753a107deadb6590$var$remoteApplicationScopesLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "Remote app scopes",
    id: "applinks.administration.ui.common.fields.remote-application-scopes.label"
});
const $753a107deadb6590$var$remoteApplicationScopesPlaceholder = (0, $7eNDO.defineMessage)({
    defaultMessage: "Use the same scopes as the remote app",
    id: "applinks.administration.ui.common.fields.remote-application-scopes.placeholder"
});
const $753a107deadb6590$var$redirectUrlLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "Redirect URL",
    id: "applinks.administration.ui.common.fields.redirect-url.label"
});
const $753a107deadb6590$var$displayNameLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "Display name",
    id: "applinks.administration.ui.common.fields.display-name.label"
});
const $753a107deadb6590$var$displayNamePlaceholder = (0, $7eNDO.defineMessage)({
    defaultMessage: "Name for the application link",
    id: "applinks.administration.ui.common.fields.display-name.placeholder"
});
const $753a107deadb6590$var$displayNameHelperMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "Enter a unique name for the link, for example the name of your external app.",
    id: "applinks.administration.ui.common.fields.display-name.helper-message"
});
const $753a107deadb6590$var$displayUrlLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "Display URL",
    id: "applinks.administration.ui.common.fields.display-url.label"
});
const $753a107deadb6590$var$displayUrlPlaceholder = (0, $7eNDO.defineMessage)({
    defaultMessage: "URL for the application link",
    id: "applinks.administration.ui.common.fields.display-url.placeholder"
});
const $753a107deadb6590$var$displayUrlHelperMessage = (0, $7eNDO.defineMessage)({
    // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
    defaultMessage: "This is the URL that we'll display to users in  {productName}.",
    id: "applinks.administration.ui.common.fields.display-url.helper-message"
});
const $753a107deadb6590$var$applicationUrlLabel = (0, $7eNDO.defineMessage)({
    defaultMessage: "Application URL",
    id: "applinks.administration.ui.common.fields.application-url.label"
});
const $753a107deadb6590$var$applicationUrlPlaceholder = (0, $7eNDO.defineMessage)({
    defaultMessage: "Application URL for the application link",
    id: "applinks.administration.ui.common.fields.application-url.placeholder"
});
const $753a107deadb6590$var$applicationUrlHelperMessage = (0, $7eNDO.defineMessage)({
    defaultMessage: "This is the URL that {productName} will use to communicate with the external app.",
    id: "applinks.administration.ui.common.fields.application-url.helper-message"
});
const $753a107deadb6590$export$933c655d375093bb = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        defaultValue: props.clientId,
        label: formatMessage($753a107deadb6590$var$clientIdLabel),
        isDisabled: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.copyable-application-client-id",
            isReadOnly: true,
            type: "password",
            ...fieldProps,
            elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8RhC5.default), {
                label: formatMessage($753a107deadb6590$var$clientIdLabel),
                value: props.clientId
            })
        }));
};
$753a107deadb6590$export$933c655d375093bb.displayName = "CopyableApplicationClientID";
const $753a107deadb6590$export$eeaa05b78b5f2773 = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        defaultValue: props.clientSecret,
        label: formatMessage($753a107deadb6590$var$clientSecretLabel),
        isDisabled: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.copyable-application-client-secret",
            isReadOnly: true,
            type: "password",
            ...fieldProps,
            elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8RhC5.default), {
                label: formatMessage($753a107deadb6590$var$clientSecretLabel),
                value: props.clientSecret
            })
        }));
};
$753a107deadb6590$export$eeaa05b78b5f2773.displayName = "CopyableApplicationClientSecret";
const $753a107deadb6590$export$e6ea1c895768a29c = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        label: formatMessage($753a107deadb6590$var$remoteApplicationScopesLabel),
        defaultValue: props.defaultSelected,
        validate: (chosenScopes)=>(0, $kjKdI.validateSupportedScopes)(chosenScopes ? chosenScopes.map((scope)=>scope.value) : [], props.supportedScopes),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ioVrz.default), {
            testId: "applinks-administration.ui.common.fields.remote-application-scope-multi-select",
            placeholder: formatMessage($753a107deadb6590$var$remoteApplicationScopesPlaceholder),
            ...fieldProps,
            options: props.supportedScopes.map((scope)=>({
                    label: scope,
                    value: scope
                }))
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO3zy.ErrorMessage), null, error)));
};
$753a107deadb6590$export$e6ea1c895768a29c.displayName = "RemoteApplicationScopeMultiSelect";
const $753a107deadb6590$export$c8399aae3a726af3 = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        label: formatMessage($753a107deadb6590$var$clientIdLabel),
        isRequired: props.isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.application-client-id",
            type: "password",
            placeholder: formatMessage($753a107deadb6590$var$clientIdLabel),
            ...fieldProps
        }));
};
$753a107deadb6590$export$c8399aae3a726af3.displayName = "ApplicationClientId";
const $753a107deadb6590$export$f137c4dc8b585189 = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        label: formatMessage($753a107deadb6590$var$clientSecretLabel),
        isRequired: props.isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.application-client-secret",
            type: "password",
            placeholder: formatMessage($753a107deadb6590$var$clientSecretLabel),
            ...fieldProps
        }));
};
$753a107deadb6590$export$f137c4dc8b585189.displayName = "ApplicationClientSecret";
const $753a107deadb6590$export$e0ad63dba68d8cca = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        defaultValue: props.defaultRedirectUrl,
        label: formatMessage($753a107deadb6590$var$redirectUrlLabel),
        validate: (redirectUrl)=>(0, $kjKdI.validateURLField)(redirectUrl, true, true),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.redirect-url",
            placeholder: formatMessage($753a107deadb6590$var$redirectUrlLabel),
            ...fieldProps
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO3zy.ErrorMessage), null, error)));
};
$753a107deadb6590$export$e0ad63dba68d8cca.displayName = "RedirectUrl";
const $753a107deadb6590$export$101fbca3a406e1fd = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        defaultValue: props.defaultName,
        label: formatMessage($753a107deadb6590$var$displayNameLabel),
        isRequired: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.display-name",
            placeholder: formatMessage($753a107deadb6590$var$displayNamePlaceholder),
            ...fieldProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEwPd.HelperMessage), null, formatMessage($753a107deadb6590$var$displayNameHelperMessage))));
};
$753a107deadb6590$export$101fbca3a406e1fd.displayName = "DisplayName";
const $753a107deadb6590$export$b07e64a5c70fbd11 = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        defaultValue: props.defaultUrl,
        label: formatMessage($753a107deadb6590$var$displayUrlLabel),
        isRequired: true,
        validate: (defaultUrl)=>(0, $kjKdI.validateURLField)(defaultUrl, true, false)
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.display-url",
            placeholder: formatMessage($753a107deadb6590$var$displayUrlPlaceholder),
            ...fieldProps
        }), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEwPd.HelperMessage), null, formatMessage($753a107deadb6590$var$displayUrlHelperMessage, {
            productName: (0, $1b6Nh.THIS_PRODUCT_NAME_STRING)
        })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO3zy.ErrorMessage), null, error)));
};
$753a107deadb6590$export$b07e64a5c70fbd11.displayName = "DisplayUrl";
const $753a107deadb6590$export$5c4f409b6c929d7a = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $1W2Av.default), {
        name: props.name,
        defaultValue: props.defaultUrl,
        label: formatMessage($753a107deadb6590$var$applicationUrlLabel),
        isDisabled: props.disabled,
        isRequired: !props.disabled,
        validate: (redirectUrl)=>(0, $kjKdI.validateURLField)(redirectUrl, true, true)
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $3PC9r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $7aCqr.default), {
            testId: "applinks-administration.ui.common.fields.application-url",
            placeholder: formatMessage($753a107deadb6590$var$applicationUrlPlaceholder),
            ...fieldProps
        }), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bEwPd.HelperMessage), null, formatMessage($753a107deadb6590$var$applicationUrlHelperMessage, {
            productName: (0, $1b6Nh.THIS_PRODUCT_NAME_STRING)
        })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hO3zy.ErrorMessage), null, error)));
};
$753a107deadb6590$export$5c4f409b6c929d7a.displayName = "ApplicationUrl";

});
parcelRegister("ioVrz", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fd4b8baed5098b7$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $3AZnn = parcelRequire("3AZnn");

var $baIdH = parcelRequire("baIdH");
const $3fd4b8baed5098b7$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $euxye.useMemo)(()=>({
            ...components,
            Option: (0, $3AZnn.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $baIdH.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
$3fd4b8baed5098b7$var$CheckboxSelectInternal.displayName = "CheckboxSelectInternal";
const $3fd4b8baed5098b7$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).memo($3fd4b8baed5098b7$var$CheckboxSelectInternal);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3fd4b8baed5098b7$export$2e2bcd8739ae039 = $3fd4b8baed5098b7$var$CheckboxSelect;

});
parcelRegister("3AZnn", function(module, exports) {
$parcel$export(module.exports, "CheckboxOption", () => $34fd87ec406bdfca$export$d40cc97ecda916f9);
/* checkbox-option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $kFp4L = parcelRequire("kFp4L");
const $34fd87ec406bdfca$var$svgStyles = null;
const $34fd87ec406bdfca$var$CheckboxIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $4jQY2.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
$34fd87ec406bdfca$var$CheckboxIcon.displayName = "CheckboxIcon";
const $34fd87ec406bdfca$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)((0, $kFp4L.ControlOption), {
        Icon: $34fd87ec406bdfca$var$CheckboxIcon,
        ...props
    });
$34fd87ec406bdfca$export$d40cc97ecda916f9.displayName = "CheckboxOption";

});
parcelRegister("kFp4L", function(module, exports) {
$parcel$export(module.exports, "ControlOption", () => $cea4c71a2e68be4f$export$e41f7c07e51665da);
/* control-option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $cea4c71a2e68be4f$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e126o",
    disabled: "_syaz1gmx"
};
// the primary color represents the outer or background element
const $cea4c71a2e68be4f$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #0515240F)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
};
// the secondary color represents the radio dot or checkmark
const $cea4c71a2e68be4f$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $cea4c71a2e68be4f$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1ihb _1gqp1ihb"
};
const $cea4c71a2e68be4f$var$baseIconStyles = null;
const $cea4c71a2e68be4f$var$baseOptionStyles = null;
const $cea4c71a2e68be4f$export$e41f7c07e51665da = (props)=>{
    const [isActive, setIsActive] = (0, $euxye.useState)(false);
    const onMouseDown = (0, $euxye.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $euxye.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $euxye.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $4jQY2.default)([
            $cea4c71a2e68be4f$var$optionStyles.default,
            isFocused && $cea4c71a2e68be4f$var$optionStyles.focused,
            isDisabled && $cea4c71a2e68be4f$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $cea4c71a2e68be4f$var$iconStyles.inherit : $cea4c71a2e68be4f$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $e79Pd.jsx)(Icon, {
                    label: "",
                    primaryColor: $cea4c71a2e68be4f$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $cea4c71a2e68be4f$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                className: (0, $4jQY2.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
$cea4c71a2e68be4f$export$e41f7c07e51665da.displayName = "ControlOption";

});


parcelRegister("baIdH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f90e0e93b375b93$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $flpE4 = parcelRequire("flpE4");
var $kY2zM = parcelRequire("kY2zM");
var $kTviw = parcelRequire("kTviw");

var $cpyLF = parcelRequire("cpyLF");
const $0f90e0e93b375b93$var$packageName = "platform-pkg";
const $0f90e0e93b375b93$var$packageVersion = "0.0.0-use.local";
const $0f90e0e93b375b93$var$createAndFireEventOnAtlaskit = (0, $flpE4.default)('atlaskit');
const $0f90e0e93b375b93$var$Select = (0, $kY2zM.default)({
    componentName: 'select',
    packageName: $0f90e0e93b375b93$var$packageName,
    packageVersion: $0f90e0e93b375b93$var$packageVersion
})((0, $kTviw.default)({
    onChange: $0f90e0e93b375b93$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $0f90e0e93b375b93$var$packageName,
            packageVersion: $0f90e0e93b375b93$var$packageVersion
        }
    })
})((0, $cpyLF.SelectWithoutAnalytics)));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0f90e0e93b375b93$export$2e2bcd8739ae039 = $0f90e0e93b375b93$var$Select;

});
parcelRegister("cpyLF", function(module, exports) {
$parcel$export(module.exports, "SelectWithoutAnalytics", () => $7ff48a6d83abaad9$export$d1de3b251ccaa8a3);

var $36lJ8 = parcelRequire("36lJ8");

var $c0vzW = parcelRequire("c0vzW");
const $7ff48a6d83abaad9$export$d1de3b251ccaa8a3 = (0, $c0vzW.default)((0, $36lJ8.default));

});
parcelRegister("36lJ8", function(module, exports) {
$parcel$export(module.exports, "default", () => $03a7fd0dcadaa381$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $e2muV = parcelRequire("e2muV");

var $8k7pc = parcelRequire("8k7pc");

var $8LfFe = parcelRequire("8LfFe");
const $03a7fd0dcadaa381$var$AsyncSelect = /*#__PURE__*/ (0, $euxye.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
(props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $8k7pc.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $8LfFe.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $e2muV.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$03a7fd0dcadaa381$export$2e2bcd8739ae039 = $03a7fd0dcadaa381$var$AsyncSelect;

});
parcelRegister("e2muV", function(module, exports) {
$parcel$export(module.exports, "default", () => $6609dcf7cd81add0$export$2e2bcd8739ae039);
/* select.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $j4xZq = parcelRequire("j4xZq");

var $bWvjc = parcelRequire("bWvjc");

var $2oRWW = parcelRequire("2oRWW");

var $egspI = parcelRequire("egspI");

var $25GTd = parcelRequire("25GTd");
var $eRXjC = parcelRequire("eRXjC");
var $bk0jE = parcelRequire("bk0jE");
var $crta0 = parcelRequire("crta0");

var $3xX0E = parcelRequire("3xX0E");

var $12siX = parcelRequire("12siX");

var $5sF5y = parcelRequire("5sF5y");

var $jgG0E = parcelRequire("jgG0E");

var $87lhX = parcelRequire("87lhX");

var $hbudu = parcelRequire("hbudu");

var $369bp = parcelRequire("369bp");

var $8fbe0 = parcelRequire("8fbe0");

var $FKmXz = parcelRequire("FKmXz");

var $dxId9 = parcelRequire("dxId9");

var $BytXA = parcelRequire("BytXA");

var $8Sn9q = parcelRequire("8Sn9q");

var $6q2Ac = parcelRequire("6q2Ac");

var $2dGma = parcelRequire("2dGma");

var $hjDA7 = parcelRequire("hjDA7");

var $dC0e5 = parcelRequire("dC0e5");
const $6609dcf7cd81add0$var$noop = (0, $2oRWW.default);
function $6609dcf7cd81add0$var$notNullish(item) {
    return item != null;
}
function $6609dcf7cd81add0$var$scrollIntoView(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $6q2Ac.scrollTo)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $6q2Ac.scrollTo)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $6609dcf7cd81add0$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch  {
        return false;
    }
}
function $6609dcf7cd81add0$var$isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ const $6609dcf7cd81add0$var$filterUnsupportedSelectors = (styles)=>{
    const unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
const $6609dcf7cd81add0$var$elemBeforeCSS = null;
const $6609dcf7cd81add0$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $6609dcf7cd81add0$var$isTouchCapable(),
    captureMenuScroll: !$6609dcf7cd81add0$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $87lhX.createFilter)(),
    formatGroupLabel: (0, $25GTd.formatGroupLabel),
    getOptionLabel: (0, $eRXjC.getOptionLabel),
    getOptionValue: (0, $bk0jE.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $crta0.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$6609dcf7cd81add0$var$isMobileDevice(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $6609dcf7cd81add0$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $6609dcf7cd81add0$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $6609dcf7cd81add0$var$isOptionSelected(props, option, selectValue);
    const label = $6609dcf7cd81add0$var$getOptionLabel(props, option);
    const value = $6609dcf7cd81add0$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $6609dcf7cd81add0$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$6609dcf7cd81add0$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$6609dcf7cd81add0$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $6609dcf7cd81add0$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $6609dcf7cd81add0$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($6609dcf7cd81add0$var$notNullish);
}
function $6609dcf7cd81add0$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $6609dcf7cd81add0$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $6609dcf7cd81add0$var$buildFocusableOptions(props, selectValue) {
    return $6609dcf7cd81add0$var$buildFocusableOptionsFromCategorizedOptions($6609dcf7cd81add0$var$buildCategorizedOptions(props, selectValue));
}
function $6609dcf7cd81add0$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$6609dcf7cd81add0$var$shouldHideSelectedOptions(props) || !isSelected) && $6609dcf7cd81add0$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $6609dcf7cd81add0$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $6609dcf7cd81add0$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $6609dcf7cd81add0$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $6609dcf7cd81add0$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $6609dcf7cd81add0$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $6609dcf7cd81add0$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $6609dcf7cd81add0$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $6609dcf7cd81add0$var$getOptionValue(props, option);
    return selectValue.some((i)=>$6609dcf7cd81add0$var$getOptionValue(props, i) === candidate);
}
function $6609dcf7cd81add0$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $6609dcf7cd81add0$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $6609dcf7cd81add0$var$instanceId = 1;
class $6609dcf7cd81add0$export$2e2bcd8739ae039 extends (0, $euxye.Component) {
    static{
        this.defaultProps = $6609dcf7cd81add0$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $FKmXz.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $FKmXz.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $hjDA7.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $hjDA7.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $dC0e5.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $dC0e5.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $dC0e5.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $6609dcf7cd81add0$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $6609dcf7cd81add0$var$buildFocusableOptionsWithIds($6609dcf7cd81add0$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $hbudu.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $6609dcf7cd81add0$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $6609dcf7cd81add0$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = {
                boxSizing: 'border-box'
            };
            const custom = this.props.styles[key];
            if (custom) return $6609dcf7cd81add0$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $3xX0E.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$6609dcf7cd81add0$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$6609dcf7cd81add0$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (_)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $8fbe0.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $egspI.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            this.props.menuIsOpen && this.onMenuClose();
            else this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $6609dcf7cd81add0$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus, shouldPreventEscapePropagation: shouldPreventEscapePropagation } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$6609dcf7cd81add0$var$instanceId);
        this.state.selectValue = (0, $369bp.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $6609dcf7cd81add0$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $369bp.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $6609dcf7cd81add0$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $6609dcf7cd81add0$var$buildFocusableOptionsWithIds($6609dcf7cd81add0$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $6609dcf7cd81add0$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $6609dcf7cd81add0$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $6609dcf7cd81add0$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $dC0e5.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $6609dcf7cd81add0$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            $6609dcf7cd81add0$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, $bWvjc.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            this.inputRef?.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) this.inputRef?.setAttribute('aria-label', normalizedLabel);
                else this.inputRef?.removeAttribute('aria-label');
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options: options } = this.props;
        const isOptionsGrouped = options?.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options?.find((option)=>{
            const groupCandidate = option;
            return groupCandidate.options?.some(isOptionFocused) ?? false;
        });
        if (isOptionsGrouped) {
            const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
            const totalLength = options?.reduce((acc, currentGroup)=>{
                const group = currentGroup;
                acc += group?.options?.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData?.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options?.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $6609dcf7cd81add0$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $6609dcf7cd81add0$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $6609dcf7cd81add0$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        }
        // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
        // and no custom Option component is provided (custom Option components may already
        // render elemBefore themselves, causing it to appear twice)
        if (context === 'menu' && !this.props.formatOptionLabel && !this.props.components?.Option && (0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const elemBefore = data.elemBefore;
            if (elemBefore) {
                const label = this.getOptionLabel(data);
                return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
                    className: (0, $4jQY2.default)([
                        "_zulpu2gc _1e0c1txw _4cvr1h6o"
                    ]),
                    children: [
                        elemBefore,
                        /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                            children: label
                        })
                    ]
                });
            }
        }
        return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti: isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            ...!this.props.isSearchable && (0, $egspI.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                'aria-autocomplete': 'both'
            },
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && !(0, $egspI.fg)('select_issearchable_aria-readonly_fix') && {
                'aria-readonly': true
            },
            ...this.calculateDescription()
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $12siX.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: $6609dcf7cd81add0$var$noop,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
        // Adding `name` to this Input will cause unexpected behavior.
        return /*#__PURE__*/ (0, $e79Pd.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $euxye.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $euxye.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $e79Pd.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: {
                id: this.getElementId('single-value')
            },
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $e79Pd.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $e79Pd.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $e79Pd.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $euxye.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $euxye.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
                return undefined;
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $e79Pd.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $e79Pd.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...this.props['UNSAFE_is_experimental_generic'] && {
                        role: 'listitem'
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $jgG0E.default), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $e79Pd.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sn9q.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $e79Pd.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    ...this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-labelledby': this.inputRef?.id || this.getElementId('input')
                                    },
                                    'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox for safari to announce first option
                                    ...(0, $bWvjc.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-describedby': this.inputRef?.id || this.getElementId('input')
                                    }
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $e79Pd.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $BytXA.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $5sF5y.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        });
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: msg
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2dGma.SelectGetStylesContext).Provider, {
            value: this.getStyles,
            children: /*#__PURE__*/ (0, $e79Pd.jsxs)(SelectContainer, {
                ...commonProps,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown,
                    ...testId && {
                        'data-testid': testId && `${testId}-select--container`
                    }
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                children: [
                    this.renderLiveRegion(),
                    commonProps.isMulti && this.renderMultiselectMessage(),
                    /*#__PURE__*/ (0, $e79Pd.jsxs)(Control, {
                        ...commonProps,
                        innerRef: this.getControlRef,
                        innerProps: {
                            onMouseDown: this.onControlMouseDown,
                            onTouchEnd: this.onControlTouchEnd,
                            ...testId && {
                                'data-testid': `${testId}-select--control`
                            }
                        },
                        appearance: appearance,
                        isInvalid: isInvalid,
                        isDisabled: isDisabled,
                        isFocused: isFocused,
                        menuIsOpen: menuIsOpen,
                        isCompact: isCompact,
                        children: [
                            /*#__PURE__*/ (0, $e79Pd.jsxs)(ValueContainer, {
                                ...commonProps,
                                isDisabled: isDisabled,
                                isCompact: isCompact,
                                innerProps: {
                                    ...testId && {
                                        'data-testid': `${testId}-select--value-container`
                                    },
                                    ...commonProps.isMulti && commonProps.hasValue && !(0, $j4xZq.isAppleDevice)() && {
                                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                        // DST Accessibility.
                                        role: 'application'
                                    }
                                },
                                children: [
                                    this.renderPlaceholderOrValue(),
                                    this.renderInput()
                                ]
                            }),
                            /*#__PURE__*/ (0, $e79Pd.jsxs)(IndicatorsContainer, {
                                ...commonProps,
                                isDisabled: isDisabled,
                                innerProps: {
                                    ...testId && {
                                        'data-testid': `${testId}-select--indicators-container`
                                    }
                                },
                                children: [
                                    this.renderClearIndicator(),
                                    this.renderLoadingIndicator(),
                                    this.renderDropdownIndicator()
                                ]
                            })
                        ]
                    }),
                    this.renderMenu(),
                    this.renderFormField(),
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dxId9.NotifyOpenLayerObserver), {
                        isOpen: this.props.menuIsOpen,
                        onClose: this.handleOpenLayerObserverCloseSignal
                    })
                ]
            })
        });
    }
}
$6609dcf7cd81add0$export$2e2bcd8739ae039.displayName = "Select";

});
parcelRegister("j4xZq", function(module, exports) {
$parcel$export(module.exports, "isAppleDevice", () => $9c1c33c2f4cc9f1c$export$e1865c3bedcd822b);
function $9c1c33c2f4cc9f1c$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $9c1c33c2f4cc9f1c$var$isIPhone() {
    return $9c1c33c2f4cc9f1c$var$testPlatform(/^iPhone/i);
}
function $9c1c33c2f4cc9f1c$var$isIPad() {
    return $9c1c33c2f4cc9f1c$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $9c1c33c2f4cc9f1c$var$isMac() && navigator.maxTouchPoints > 1;
}
function $9c1c33c2f4cc9f1c$var$isMac() {
    return $9c1c33c2f4cc9f1c$var$testPlatform(/^Mac/i);
}
function $9c1c33c2f4cc9f1c$var$isIOS() {
    return $9c1c33c2f4cc9f1c$var$isIPhone() || $9c1c33c2f4cc9f1c$var$isIPad();
}
function $9c1c33c2f4cc9f1c$export$e1865c3bedcd822b() {
    return $9c1c33c2f4cc9f1c$var$isMac() || $9c1c33c2f4cc9f1c$var$isIOS();
}

});

parcelRegister("25GTd", function(module, exports) {
$parcel$export(module.exports, "formatGroupLabel", () => $5c027cb24e24aaf7$export$f4da216a6ca54656);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $5c027cb24e24aaf7$export$f4da216a6ca54656 = (group)=>group.label;

});

parcelRegister("eRXjC", function(module, exports) {
$parcel$export(module.exports, "getOptionLabel", () => $d41fb02be616e05e$export$dac6ace3020563ca);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $d41fb02be616e05e$export$dac6ace3020563ca = (option)=>option.label;

});

parcelRegister("bk0jE", function(module, exports) {
$parcel$export(module.exports, "getOptionValue", () => $a2a8d322af395130$export$40be908210c5a79c);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $a2a8d322af395130$export$40be908210c5a79c = (option)=>option.value;

});

parcelRegister("crta0", function(module, exports) {
$parcel$export(module.exports, "isOptionDisabled", () => $af6c1be5081bf754$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $af6c1be5081bf754$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("3xX0E", function(module, exports) {
$parcel$export(module.exports, "components", () => $c290426c61766514$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $c290426c61766514$export$71abc632aa29e6fe);

var $i9ANO = parcelRequire("i9ANO");

var $i9Bbv = parcelRequire("i9Bbv");

var $2lBHp = parcelRequire("2lBHp");

var $51GPB = parcelRequire("51GPB");

var $ciPuz = parcelRequire("ciPuz");

var $5I9wI = parcelRequire("5I9wI");

var $hiRDE = parcelRequire("hiRDE");

var $5QfBS = parcelRequire("5QfBS");

var $6cU1U = parcelRequire("6cU1U");

var $3sanG = parcelRequire("3sanG");

var $aLA2f = parcelRequire("aLA2f");

var $3af9u = parcelRequire("3af9u");

var $9tUjk = parcelRequire("9tUjk");

var $7kJy5 = parcelRequire("7kJy5");

var $d1Wul = parcelRequire("d1Wul");

var $jvVlo = parcelRequire("jvVlo");

var $6PGkv = parcelRequire("6PGkv");

var $9FFa6 = parcelRequire("9FFa6");

var $hvkNV = parcelRequire("hvkNV");

var $gaXx9 = parcelRequire("gaXx9");

var $03ZGj = parcelRequire("03ZGj");

var $80vrn = parcelRequire("80vrn");
const $c290426c61766514$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $5QfBS.ClearIndicator),
    Control: (0, $ciPuz.default),
    DropdownIndicator: (0, $6cU1U.DropdownIndicator),
    Group: (0, $5I9wI.default),
    GroupHeading: (0, $hiRDE.GroupHeading),
    IndicatorsContainer: (0, $i9ANO.IndicatorsContainer),
    Input: (0, $aLA2f.default),
    LoadingIndicator: (0, $3sanG.LoadingIndicator),
    Menu: (0, $3af9u.default),
    MenuList: (0, $9tUjk.MenuList),
    MenuPortal: (0, $jvVlo.MenuPortal),
    LoadingMessage: (0, $7kJy5.LoadingMessage),
    NoOptionsMessage: (0, $d1Wul.NoOptionsMessage),
    MultiValue: (0, $6PGkv.default),
    MultiValueContainer: (0, $i9Bbv.MultiValueContainer),
    MultiValueLabel: (0, $9FFa6.MultiValueLabel),
    MultiValueRemove: (0, $hvkNV.MultiValueRemove),
    Option: (0, $gaXx9.default),
    Placeholder: (0, $03ZGj.default),
    SelectContainer: (0, $2lBHp.SelectContainer),
    SingleValue: (0, $80vrn.default),
    ValueContainer: (0, $51GPB.ValueContainer)
};
const $c290426c61766514$export$71abc632aa29e6fe = (props)=>({
        ...$c290426c61766514$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("i9ANO", function(module, exports) {
$parcel$export(module.exports, "IndicatorsContainer", () => $59f7516fd4ecc183$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");
const $59f7516fd4ecc183$var$indicatorContainerStyles = null;
const $59f7516fd4ecc183$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $9S1b6.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};
$59f7516fd4ecc183$export$d0ffd7e649cab6f.displayName = "IndicatorsContainer";

});
parcelRegister("fnGzU", function(module, exports) {
$parcel$export(module.exports, "getStyleProps", () => $db45b67db8b2d20c$export$26417cabd806a658);
const $db45b67db8b2d20c$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};

});


parcelRegister("i9Bbv", function(module, exports) {
$parcel$export(module.exports, "MultiValueContainer", () => $b90e13612fd49799$export$cf9cf2a30a59265c);
/* multi-value-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");
const $b90e13612fd49799$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up53acm _1xdnnqa1"
};
const $b90e13612fd49799$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $b90e13612fd49799$var$multiValueStyles.root,
            isDisabled && $b90e13612fd49799$var$multiValueStyles.disabled,
            isFocused && $b90e13612fd49799$var$multiValueStyles.focused,
            (0, $9S1b6.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
};
$b90e13612fd49799$export$cf9cf2a30a59265c.displayName = "MultiValueContainer";

});

parcelRegister("2lBHp", function(module, exports) {
$parcel$export(module.exports, "SelectContainer", () => $1ef5ecd52502323d$export$446eebadefe1123b);
/* select-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");
const $1ef5ecd52502323d$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
const $1ef5ecd52502323d$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $fnGzU.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $1ef5ecd52502323d$var$containerStyles.default,
            isRtl && $1ef5ecd52502323d$var$containerStyles.rtl,
            isDisabled && $1ef5ecd52502323d$var$containerStyles.disabled,
            (0, $9S1b6.cx)(className, xcss, '-container')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
$1ef5ecd52502323d$export$446eebadefe1123b.displayName = "SelectContainer";

});

parcelRegister("51GPB", function(module, exports) {
$parcel$export(module.exports, "ValueContainer", () => $2418c4bb85caea65$export$4dc9f58ad9a1a000);
/* value-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $egspI = parcelRequire("egspI");

var $fnGzU = parcelRequire("fnGzU");
const $2418c4bb85caea65$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
const $2418c4bb85caea65$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    const ffTagUplifts = (0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const tagUpliftMultiVertical = ffTagUplifts && isMulti;
    const tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $2418c4bb85caea65$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $2418c4bb85caea65$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $2418c4bb85caea65$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $2418c4bb85caea65$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $2418c4bb85caea65$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $2418c4bb85caea65$var$valueContainerStyles.flex,
            tagUpliftChipRow && $2418c4bb85caea65$var$valueContainerStyles.flexWithGap,
            (0, $9S1b6.cx)(className, xcss, '-ValueContainer')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
$2418c4bb85caea65$export$4dc9f58ad9a1a000.displayName = "ValueContainer";

});

parcelRegister("ciPuz", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2fc32bd72c2d779$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $egspI = parcelRequire("egspI");

var $fnGzU = parcelRequire("fnGzU");
const $e2fc32bd72c2d779$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123b1h4p _d0altlke _irr3l4ek _1oglgxqn",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6d187o _lcxvglyw _bfhk187o _1u6lfrlt",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d3acm _bfhk18uv _1u6lnruj",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d3acm _bfhk18uv _1u6lnruj _4cvx3acm _irr318uv"
};
const $e2fc32bd72c2d779$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $e2fc32bd72c2d779$var$styles.default,
            (0, $egspI.fg)('platform-dst-shape-theme-default') && $e2fc32bd72c2d779$var$styles.defaultT26Shape,
            isDisabled && $e2fc32bd72c2d779$var$styles.disabled,
            isInvalid && $e2fc32bd72c2d779$var$styles.invalid,
            isCompact && $e2fc32bd72c2d779$var$styles.compact,
            appearance === 'subtle' && $e2fc32bd72c2d779$var$styles.subtle,
            appearance === 'subtle' && isFocused && $e2fc32bd72c2d779$var$styles.subtleFocused,
            isFocused && $e2fc32bd72c2d779$var$styles.focused,
            appearance === 'none' && $e2fc32bd72c2d779$var$styles.none,
            (0, $9S1b6.cx)(className, xcss, '-control')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        "aria-disabled": isDisabled || undefined,
        children: children
    });
};
$e2fc32bd72c2d779$var$Control.displayName = "Control";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e2fc32bd72c2d779$export$2e2bcd8739ae039 = $e2fc32bd72c2d779$var$Control;

});

parcelRegister("5I9wI", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cd439e1a7d4e0e3$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");
const $7cd439e1a7d4e0e3$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
const $7cd439e1a7d4e0e3$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $7cd439e1a7d4e0e3$var$styles.root,
            (0, $9S1b6.cx)(className, xcss, innerProps?.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $e79Pd.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                children: children
            })
        ]
    });
};
$7cd439e1a7d4e0e3$var$Group.displayName = "Group";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7cd439e1a7d4e0e3$export$2e2bcd8739ae039 = $7cd439e1a7d4e0e3$var$Group;

});

parcelRegister("hiRDE", function(module, exports) {
$parcel$export(module.exports, "GroupHeading", () => $a6c6d115389052f5$export$85c8b41a3cd87edc);
/* group-heading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");

var $vndoX = parcelRequire("vndoX");
const $a6c6d115389052f5$var$headingStyles = null;
const $a6c6d115389052f5$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $vndoX.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $9S1b6.cx)(className, xcss, '-group')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    });
};
$a6c6d115389052f5$export$85c8b41a3cd87edc.displayName = "GroupHeading";

});
parcelRegister("vndoX", function(module, exports) {
$parcel$export(module.exports, "cleanCommonProps", () => $accead48f11d2927$export$8e9fd4287627890c);
// Clean Common Props
// ==============================
const $accead48f11d2927$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};

});


parcelRegister("5QfBS", function(module, exports) {
$parcel$export(module.exports, "ClearIndicator", () => $0da1934925ba673e$export$ecf9cf59142dd54a);
/* clear-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $9qT28 = parcelRequire("9qT28");

var $6mEZn = parcelRequire("6mEZn");

var $fnGzU = parcelRequire("fnGzU");
const $0da1934925ba673e$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
const $0da1934925ba673e$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
const $0da1934925ba673e$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $0da1934925ba673e$var$clearIndicatorStyles.default,
            isCompact && $0da1934925ba673e$var$clearIndicatorStyles.compact,
            (0, $9S1b6.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
            xcss: $0da1934925ba673e$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9qT28))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
};
$0da1934925ba673e$export$ecf9cf59142dd54a.displayName = "ClearIndicator";

});

parcelRegister("6cU1U", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicator", () => $f114c35a40074cce$export$ec98719d3db7f2e4);
/* dropdown-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $ld25x = parcelRequire("ld25x");

var $defJG = parcelRequire("defJG");

var $fnGzU = parcelRequire("fnGzU");
const $f114c35a40074cce$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
const $f114c35a40074cce$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
const $f114c35a40074cce$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $f114c35a40074cce$var$dropdownStyles.default,
            isDisabled && $f114c35a40074cce$var$dropdownStyles.disabled,
            isCompact && $f114c35a40074cce$var$dropdownStyles.compact,
            (0, $9S1b6.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: children ? children : /*#__PURE__*/ (0, $e79Pd.jsx)((0, $defJG.default), {
            as: "span",
            xcss: $f114c35a40074cce$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
};
$f114c35a40074cce$export$ec98719d3db7f2e4.displayName = "DropdownIndicator";

});

parcelRegister("3sanG", function(module, exports) {
$parcel$export(module.exports, "LoadingIndicator", () => $3878b2fe38501b4a$export$7c20be4c1d342248);
/* loading-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $abhF2 = parcelRequire("abhF2");

var $fnGzU = parcelRequire("fnGzU");
const $3878b2fe38501b4a$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
const $3878b2fe38501b4a$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $3878b2fe38501b4a$var$loadingIndicatorStyles.default,
            isCompact && $3878b2fe38501b4a$var$loadingIndicatorStyles.compact,
            (0, $9S1b6.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {
            size: "small"
        })
    });
};
$3878b2fe38501b4a$export$7c20be4c1d342248.displayName = "LoadingIndicator";

});

parcelRegister("aLA2f", function(module, exports) {
$parcel$export(module.exports, "default", () => $cfe319ebdcdf95aa$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $egspI = parcelRequire("egspI");

var $fnGzU = parcelRequire("fnGzU");

var $vndoX = parcelRequire("vndoX");
const $cfe319ebdcdf95aa$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const $cfe319ebdcdf95aa$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const $cfe319ebdcdf95aa$var$nativeInputStylesOld = null;
const $cfe319ebdcdf95aa$var$nativeInputStyles = null;
const $cfe319ebdcdf95aa$var$hidden = null;
const $cfe319ebdcdf95aa$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss, isMulti: isMulti } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $vndoX.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'input', {
        'input-container': true
    });
    const ffTagUplifts = (0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $egspI.fg)('platform_fix_input_component_styling')) return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $cfe319ebdcdf95aa$var$inputStyles.root,
            isMulti && ffTagUplifts && $cfe319ebdcdf95aa$var$inputStyles.labellingFFStyles,
            isDisabled && $cfe319ebdcdf95aa$var$inputStyles.disabled,
            (0, $9S1b6.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $4jQY2.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $cfe319ebdcdf95aa$var$inputStylesOld.root,
            isMulti && ffTagUplifts && $cfe319ebdcdf95aa$var$inputStylesOld.labellingFFStyles,
            isDisabled && $cfe319ebdcdf95aa$var$inputStylesOld.disabled,
            (0, $9S1b6.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $4jQY2.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
};
$cfe319ebdcdf95aa$var$Input.displayName = "Input";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cfe319ebdcdf95aa$export$2e2bcd8739ae039 = $cfe319ebdcdf95aa$var$Input;

});

parcelRegister("3af9u", function(module, exports) {
$parcel$export(module.exports, "default", () => $69bc1725a5de5040$export$2e2bcd8739ae039);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $egspI = parcelRequire("egspI");

var $fnGzU = parcelRequire("fnGzU");
const $69bc1725a5de5040$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
const $69bc1725a5de5040$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $69bc1725a5de5040$var$menuStyles.root,
            $69bc1725a5de5040$var$menuStyles[placement],
            (0, $egspI.fg)('platform-dst-shape-theme-default') && $69bc1725a5de5040$var$menuStyles.rootT26Shape,
            (0, $9S1b6.cx)(xcss, className, '-menu')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
};
$69bc1725a5de5040$var$Menu.displayName = "Menu";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$69bc1725a5de5040$export$2e2bcd8739ae039 = $69bc1725a5de5040$var$Menu;

});

parcelRegister("9tUjk", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $d193525ad3b791cf$export$d4c4e98c5044dc8);
/* menu-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");
const $d193525ad3b791cf$var$menuListStyles = null;
const $d193525ad3b791cf$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $9S1b6.cx)(className, xcss, '-MenuList')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
$d193525ad3b791cf$export$d4c4e98c5044dc8.displayName = "MenuList";

});

parcelRegister("7kJy5", function(module, exports) {
$parcel$export(module.exports, "LoadingMessage", () => $1a42f929bda241bd$export$e928a71d039d3102);
/* menu-loading-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $8Sdzy = parcelRequire("8Sdzy");

var $fnGzU = parcelRequire("fnGzU");
const $1a42f929bda241bd$var$noticeStyles = null;
const $1a42f929bda241bd$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $9S1b6.cx)(className, xcss, '-LoadingMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
$1a42f929bda241bd$export$e928a71d039d3102.displayName = "LoadingMessage";

});

parcelRegister("d1Wul", function(module, exports) {
$parcel$export(module.exports, "NoOptionsMessage", () => $ee2d14b752c2adcb$export$d58b72b7d3c4072c);
/* menu-no-options-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $8Sdzy = parcelRequire("8Sdzy");

var $fnGzU = parcelRequire("fnGzU");
const $ee2d14b752c2adcb$var$noticeStyles = null;
const $ee2d14b752c2adcb$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $9S1b6.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8Sdzy.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
$ee2d14b752c2adcb$export$d58b72b7d3c4072c.displayName = "NoOptionsMessage";

});

parcelRegister("jvVlo", function(module, exports) {
$parcel$export(module.exports, "MenuPortal", () => $ffd0be9055a7fa14$export$793392f970497feb);
/* menu-portal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $6XNU4 = parcelRequire("6XNU4");

var $85XPu = parcelRequire("85XPu");

var $fnGzU = parcelRequire("fnGzU");

var $25rLP = parcelRequire("25rLP");
function $ffd0be9055a7fa14$var$getBoundingClientObj(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
const $ffd0be9055a7fa14$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $ffd0be9055a7fa14$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
const $ffd0be9055a7fa14$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $euxye.useRef)(null);
    const cleanupRef = (0, $euxye.useRef)(null);
    const [placement, setPortalPlacement] = (0, $euxye.useState)($ffd0be9055a7fa14$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $euxye.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $euxye.useState)(null);
    const updateComputedPosition = (0, $euxye.useCallback)(()=>{
        if (!controlElement) return;
        const rect = $ffd0be9055a7fa14$var$getBoundingClientObj(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $euxye.useLayoutEffect)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $euxye.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $6XNU4.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $euxye.useLayoutEffect)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $euxye.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $ffd0be9055a7fa14$var$menuPortalStyles.root,
            (0, $9S1b6.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $25rLP.PortalPlacementContext).Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $85XPu.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
};
$ffd0be9055a7fa14$export$793392f970497feb.displayName = "MenuPortal";

});
parcelRegister("6XNU4", function(module, exports) {
$parcel$export(module.exports, "autoUpdate", () => $511ef68320147845$export$deee3a793edee05f);

var $6p5gj = parcelRequire("6p5gj");
var $a9vMD = parcelRequire("a9vMD");

var $a9vMD = parcelRequire("a9vMD");

var $dmWla = parcelRequire("dmWla");
function $511ef68320147845$var$getCssDimensions(element) {
    const css = (0, $dmWla.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $dmWla.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $a9vMD.round)(width) !== offsetWidth || (0, $a9vMD.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $511ef68320147845$var$unwrapElement(element) {
    return !(0, $dmWla.isElement)(element) ? element.contextElement : element;
}
function $511ef68320147845$var$getScale(element) {
    const domElement = $511ef68320147845$var$unwrapElement(element);
    if (!(0, $dmWla.isHTMLElement)(domElement)) return (0, $a9vMD.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $511ef68320147845$var$getCssDimensions(domElement);
    let x = ($ ? (0, $a9vMD.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $a9vMD.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $511ef68320147845$var$noOffsets = /*#__PURE__*/ (0, $a9vMD.createCoords)(0);
function $511ef68320147845$var$getVisualOffsets(element) {
    const win = (0, $dmWla.getWindow)(element);
    if (!(0, $dmWla.isWebKit)() || !win.visualViewport) return $511ef68320147845$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $511ef68320147845$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $dmWla.getWindow)(element)) return false;
    return isFixed;
}
function $511ef68320147845$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $511ef68320147845$var$unwrapElement(element);
    let scale = (0, $a9vMD.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $dmWla.isElement)(offsetParent)) scale = $511ef68320147845$var$getScale(offsetParent);
        } else scale = $511ef68320147845$var$getScale(element);
    }
    const visualOffsets = $511ef68320147845$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $511ef68320147845$var$getVisualOffsets(domElement) : (0, $a9vMD.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $dmWla.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $dmWla.isElement)(offsetParent) ? (0, $dmWla.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $dmWla.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $511ef68320147845$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $dmWla.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $dmWla.getWindow)(currentIFrame);
            currentIFrame = (0, $dmWla.getFrameElement)(currentWin);
        }
    }
    return (0, $a9vMD.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $511ef68320147845$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $dmWla.getNodeScroll)(element).scrollLeft;
    if (!rect) return $511ef68320147845$var$getBoundingClientRect((0, $dmWla.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $511ef68320147845$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $511ef68320147845$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $511ef68320147845$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $dmWla.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $dmWla.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $a9vMD.createCoords)(1);
    const offsets = (0, $a9vMD.createCoords)(0);
    const isOffsetParentAnElement = (0, $dmWla.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $dmWla.getNodeName)(offsetParent) !== 'body' || (0, $dmWla.isOverflowElement)(documentElement)) scroll = (0, $dmWla.getNodeScroll)(offsetParent);
        if ((0, $dmWla.isHTMLElement)(offsetParent)) {
            const offsetRect = $511ef68320147845$var$getBoundingClientRect(offsetParent);
            scale = $511ef68320147845$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $511ef68320147845$var$getHTMLOffset(documentElement, scroll, true) : (0, $a9vMD.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $511ef68320147845$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $511ef68320147845$var$getDocumentRect(element) {
    const html = (0, $dmWla.getDocumentElement)(element);
    const scroll = (0, $dmWla.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $a9vMD.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $a9vMD.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $511ef68320147845$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $dmWla.getComputedStyle)(body).direction === 'rtl') x += (0, $a9vMD.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $511ef68320147845$var$getViewportRect(element, strategy) {
    const win = (0, $dmWla.getWindow)(element);
    const html = (0, $dmWla.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $dmWla.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $511ef68320147845$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $511ef68320147845$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $dmWla.isHTMLElement)(element) ? $511ef68320147845$var$getScale(element) : (0, $a9vMD.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $511ef68320147845$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $511ef68320147845$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $511ef68320147845$var$getDocumentRect((0, $dmWla.getDocumentElement)(element));
    else if ((0, $dmWla.isElement)(clippingAncestor)) rect = $511ef68320147845$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $511ef68320147845$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $a9vMD.rectToClientRect)(rect);
}
function $511ef68320147845$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $dmWla.getParentNode)(element);
    if (parentNode === stopNode || !(0, $dmWla.isElement)(parentNode) || (0, $dmWla.isLastTraversableNode)(parentNode)) return false;
    return (0, $dmWla.getComputedStyle)(parentNode).position === 'fixed' || $511ef68320147845$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $511ef68320147845$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $dmWla.getOverflowAncestors)(element, [], false).filter((el)=>(0, $dmWla.isElement)(el) && (0, $dmWla.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $dmWla.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $dmWla.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $dmWla.isElement)(currentNode) && !(0, $dmWla.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $dmWla.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $dmWla.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $dmWla.isOverflowElement)(currentNode) && !currentNodeIsContaining && $511ef68320147845$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $dmWla.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $511ef68320147845$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $dmWla.isTopLayer)(element) ? [] : $511ef68320147845$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $511ef68320147845$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $a9vMD.max)(rect.top, accRect.top);
        accRect.right = (0, $a9vMD.min)(rect.right, accRect.right);
        accRect.bottom = (0, $a9vMD.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $a9vMD.max)(rect.left, accRect.left);
        return accRect;
    }, $511ef68320147845$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $511ef68320147845$var$getDimensions(element) {
    const { width: width, height: height } = $511ef68320147845$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $511ef68320147845$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $dmWla.isHTMLElement)(offsetParent);
    const documentElement = (0, $dmWla.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $511ef68320147845$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $a9vMD.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $dmWla.getNodeName)(offsetParent) !== 'body' || (0, $dmWla.isOverflowElement)(documentElement)) scroll = (0, $dmWla.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $511ef68320147845$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $511ef68320147845$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $511ef68320147845$var$getHTMLOffset(documentElement, scroll) : (0, $a9vMD.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $511ef68320147845$var$isStaticPositioned(element) {
    return (0, $dmWla.getComputedStyle)(element).position === 'static';
}
function $511ef68320147845$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $dmWla.isHTMLElement)(element) || (0, $dmWla.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $dmWla.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $511ef68320147845$var$getOffsetParent(element, polyfill) {
    const win = (0, $dmWla.getWindow)(element);
    if ((0, $dmWla.isTopLayer)(element)) return win;
    if (!(0, $dmWla.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $dmWla.getParentNode)(element);
        while(svgOffsetParent && !(0, $dmWla.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $dmWla.isElement)(svgOffsetParent) && !$511ef68320147845$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $dmWla.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $511ef68320147845$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $dmWla.isTableElement)(offsetParent) && $511ef68320147845$var$isStaticPositioned(offsetParent))offsetParent = $511ef68320147845$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $dmWla.isLastTraversableNode)(offsetParent) && $511ef68320147845$var$isStaticPositioned(offsetParent) && !(0, $dmWla.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $dmWla.getContainingBlock)(element) || win;
}
const $511ef68320147845$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $511ef68320147845$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $511ef68320147845$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $511ef68320147845$var$isRTL(element) {
    return (0, $dmWla.getComputedStyle)(element).direction === 'rtl';
}
const $511ef68320147845$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $511ef68320147845$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $dmWla.getDocumentElement,
    getClippingRect: $511ef68320147845$var$getClippingRect,
    getOffsetParent: $511ef68320147845$var$getOffsetParent,
    getElementRects: $511ef68320147845$var$getElementRects,
    getClientRects: $511ef68320147845$var$getClientRects,
    getDimensions: $511ef68320147845$var$getDimensions,
    getScale: $511ef68320147845$var$getScale,
    isElement: $dmWla.isElement,
    isRTL: $511ef68320147845$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $511ef68320147845$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $dmWla.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $a9vMD.floor)(top);
        const insetRight = (0, $a9vMD.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $a9vMD.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $a9vMD.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $a9vMD.max)(0, (0, $a9vMD.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $511ef68320147845$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $511ef68320147845$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $dmWla.getOverflowAncestors)(referenceEl) : [],
        ...(0, $dmWla.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $511ef68320147845$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $511ef68320147845$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $511ef68320147845$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $511ef68320147845$export$37b6bde19b108ecc = (0, $6p5gj.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $511ef68320147845$export$cc800923e997bb8 = (0, $6p5gj.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $511ef68320147845$export$91fb6ecbd551914 = (0, $6p5gj.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $511ef68320147845$export$fba63a578e423eb = (0, $6p5gj.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $511ef68320147845$export$8a83211c878a3f1f = (0, $6p5gj.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $511ef68320147845$export$346677f925de839c = (0, $6p5gj.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $511ef68320147845$export$fe8985bb6374093c = (0, $6p5gj.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $511ef68320147845$export$f2120bbfa5450bd2 = (0, $6p5gj.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $511ef68320147845$export$18c8ad048e32c7d5 = (0, $6p5gj.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $511ef68320147845$export$7bf07e38f3dc4b69 = (0, $6p5gj.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $511ef68320147845$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $511ef68320147845$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $6p5gj.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("6p5gj", function(module, exports) {
$parcel$export(module.exports, "computePosition", () => $4a9928d31988e649$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $4a9928d31988e649$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $4a9928d31988e649$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $4a9928d31988e649$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $4a9928d31988e649$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $4a9928d31988e649$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $4a9928d31988e649$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $4a9928d31988e649$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $4a9928d31988e649$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $4a9928d31988e649$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $4a9928d31988e649$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("a9vMD")).rectToClientRect);

var $a9vMD = parcelRequire("a9vMD");
function $4a9928d31988e649$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $a9vMD.getSideAxis)(placement);
    const alignmentAxis = (0, $a9vMD.getAlignmentAxis)(placement);
    const alignLength = (0, $a9vMD.getAxisLength)(alignmentAxis);
    const side = (0, $a9vMD.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $a9vMD.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $4a9928d31988e649$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $4a9928d31988e649$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $4a9928d31988e649$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $4a9928d31988e649$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $a9vMD.evaluate)(options, state);
    const paddingObject = (0, $a9vMD.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $a9vMD.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $a9vMD.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $4a9928d31988e649$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $a9vMD.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $a9vMD.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $a9vMD.getAlignmentAxis)(placement);
            const length = (0, $a9vMD.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $a9vMD.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $a9vMD.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $a9vMD.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $a9vMD.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $4a9928d31988e649$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $a9vMD.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $a9vMD.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $a9vMD.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $a9vMD.getAlignment)(placement) === alignment || (autoAlignment ? (0, $a9vMD.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $4a9928d31988e649$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $a9vMD.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $a9vMD.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $a9vMD.placements) ? $4a9928d31988e649$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $4a9928d31988e649$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $a9vMD.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $a9vMD.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $a9vMD.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $a9vMD.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $4a9928d31988e649$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $a9vMD.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $a9vMD.getSide)(placement);
            const initialSideAxis = (0, $a9vMD.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $a9vMD.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $a9vMD.getOppositePlacement)(initialPlacement)
            ] : (0, $a9vMD.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $a9vMD.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $4a9928d31988e649$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $a9vMD.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $a9vMD.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $4a9928d31988e649$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $4a9928d31988e649$var$isAnySideFullyClipped(overflow) {
    return (0, $a9vMD.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $4a9928d31988e649$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $a9vMD.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $4a9928d31988e649$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $4a9928d31988e649$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $4a9928d31988e649$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $4a9928d31988e649$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $4a9928d31988e649$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $4a9928d31988e649$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4a9928d31988e649$var$getBoundingRect(rects) {
    const minX = (0, $a9vMD.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $a9vMD.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $a9vMD.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $a9vMD.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $4a9928d31988e649$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $a9vMD.rectToClientRect)($4a9928d31988e649$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $4a9928d31988e649$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $a9vMD.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $4a9928d31988e649$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $a9vMD.rectToClientRect)($4a9928d31988e649$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $a9vMD.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $a9vMD.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $a9vMD.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $a9vMD.getSide)(placement) === 'left';
                    const maxRight = (0, $a9vMD.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $a9vMD.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $4a9928d31988e649$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $a9vMD.getSide)(placement);
    const alignment = (0, $a9vMD.getAlignment)(placement);
    const isVertical = (0, $a9vMD.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $a9vMD.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $4a9928d31988e649$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $4a9928d31988e649$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $4a9928d31988e649$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $a9vMD.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $4a9928d31988e649$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $a9vMD.getSideAxis)((0, $a9vMD.getSide)(placement));
            const mainAxis = (0, $a9vMD.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $a9vMD.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $a9vMD.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $4a9928d31988e649$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $a9vMD.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $a9vMD.getSideAxis)(placement);
            const mainAxis = (0, $a9vMD.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $a9vMD.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $a9vMD.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $4a9928d31988e649$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $a9vMD.evaluate)(options, state);
            const overflow = await $4a9928d31988e649$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $a9vMD.getSide)(placement);
            const alignment = (0, $a9vMD.getAlignment)(placement);
            const isYAxis = (0, $a9vMD.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $a9vMD.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $a9vMD.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $a9vMD.max)(overflow.left, 0);
                const xMax = (0, $a9vMD.max)(overflow.right, 0);
                const yMin = (0, $a9vMD.max)(overflow.top, 0);
                const yMax = (0, $a9vMD.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $a9vMD.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $a9vMD.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("a9vMD", function(module, exports) {
$parcel$export(module.exports, "sides", () => $7643662995a7351a$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $7643662995a7351a$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $7643662995a7351a$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $7643662995a7351a$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $7643662995a7351a$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $7643662995a7351a$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $7643662995a7351a$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $7643662995a7351a$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $7643662995a7351a$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $7643662995a7351a$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $7643662995a7351a$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $7643662995a7351a$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $7643662995a7351a$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $7643662995a7351a$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $7643662995a7351a$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $7643662995a7351a$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $7643662995a7351a$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $7643662995a7351a$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $7643662995a7351a$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $7643662995a7351a$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $7643662995a7351a$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $7643662995a7351a$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $7643662995a7351a$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $7643662995a7351a$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $7643662995a7351a$export$803cd8101b6c182b = /*#__PURE__*/ $7643662995a7351a$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $7643662995a7351a$export$27b07d8a310ed8b5[0], side + "-" + $7643662995a7351a$export$27b07d8a310ed8b5[1]), []);
const $7643662995a7351a$export$96ec731ed4dcb222 = Math.min;
const $7643662995a7351a$export$8960430cfd85939f = Math.max;
const $7643662995a7351a$export$2077e0241d6afd3c = Math.round;
const $7643662995a7351a$export$a3fe094919f356fd = Math.floor;
const $7643662995a7351a$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $7643662995a7351a$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $7643662995a7351a$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $7643662995a7351a$export$7d15b64cf5a3a4c4(start, value, end) {
    return $7643662995a7351a$export$8960430cfd85939f(start, $7643662995a7351a$export$96ec731ed4dcb222(value, end));
}
function $7643662995a7351a$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $7643662995a7351a$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $7643662995a7351a$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $7643662995a7351a$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $7643662995a7351a$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $7643662995a7351a$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($7643662995a7351a$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $7643662995a7351a$export$2b57e0052a6d6d4c(placement) {
    return $7643662995a7351a$export$8a000a963141ac32($7643662995a7351a$export$f28e8f882010718a(placement));
}
function $7643662995a7351a$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $7643662995a7351a$export$f0989780f32bfcda(placement);
    const alignmentAxis = $7643662995a7351a$export$2b57e0052a6d6d4c(placement);
    const length = $7643662995a7351a$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $7643662995a7351a$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $7643662995a7351a$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $7643662995a7351a$export$496432a3699e50b1(placement) {
    const oppositePlacement = $7643662995a7351a$export$9c5e28bad23365fa(placement);
    return [
        $7643662995a7351a$export$2b182c584985588b(placement),
        oppositePlacement,
        $7643662995a7351a$export$2b182c584985588b(oppositePlacement)
    ];
}
function $7643662995a7351a$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$7643662995a7351a$var$oppositeAlignmentMap[alignment]);
}
function $7643662995a7351a$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $7643662995a7351a$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $7643662995a7351a$export$f0989780f32bfcda(placement);
    let list = $7643662995a7351a$var$getSideList($7643662995a7351a$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($7643662995a7351a$export$2b182c584985588b));
    }
    return list;
}
function $7643662995a7351a$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$7643662995a7351a$var$oppositeSideMap[side]);
}
function $7643662995a7351a$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $7643662995a7351a$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $7643662995a7351a$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $7643662995a7351a$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("dmWla", function(module, exports) {
$parcel$export(module.exports, "getNodeName", () => $9bba959dc6b189e2$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $9bba959dc6b189e2$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $9bba959dc6b189e2$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $9bba959dc6b189e2$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $9bba959dc6b189e2$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $9bba959dc6b189e2$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $9bba959dc6b189e2$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $9bba959dc6b189e2$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $9bba959dc6b189e2$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $9bba959dc6b189e2$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $9bba959dc6b189e2$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $9bba959dc6b189e2$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $9bba959dc6b189e2$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $9bba959dc6b189e2$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $9bba959dc6b189e2$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $9bba959dc6b189e2$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $9bba959dc6b189e2$export$7bf1f8740e3e34af);
function $9bba959dc6b189e2$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $9bba959dc6b189e2$export$651544f548703224(node) {
    if ($9bba959dc6b189e2$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $9bba959dc6b189e2$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $9bba959dc6b189e2$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($9bba959dc6b189e2$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $9bba959dc6b189e2$export$8ee0fc9ee280b4ee(value) {
    if (!$9bba959dc6b189e2$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $9bba959dc6b189e2$export$38b2d434cce3ea22(value).Node;
}
function $9bba959dc6b189e2$export$45a5e7f76e0caa8d(value) {
    if (!$9bba959dc6b189e2$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $9bba959dc6b189e2$export$38b2d434cce3ea22(value).Element;
}
function $9bba959dc6b189e2$export$1b3bfaa9684536aa(value) {
    if (!$9bba959dc6b189e2$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $9bba959dc6b189e2$export$38b2d434cce3ea22(value).HTMLElement;
}
function $9bba959dc6b189e2$export$af51f0f06c0f328a(value) {
    if (!$9bba959dc6b189e2$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $9bba959dc6b189e2$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $9bba959dc6b189e2$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $9bba959dc6b189e2$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $9bba959dc6b189e2$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($9bba959dc6b189e2$export$651544f548703224(element));
}
function $9bba959dc6b189e2$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $9bba959dc6b189e2$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $9bba959dc6b189e2$export$78551043582a6a98();
    const css = $9bba959dc6b189e2$export$45a5e7f76e0caa8d(elementOrCss) ? $9bba959dc6b189e2$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $9bba959dc6b189e2$export$940d8225183e1404(element) {
    let currentNode = $9bba959dc6b189e2$export$4e12058fc4d51d56(element);
    while($9bba959dc6b189e2$export$1b3bfaa9684536aa(currentNode) && !$9bba959dc6b189e2$export$d1162fb0b6d4cd51(currentNode)){
        if ($9bba959dc6b189e2$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($9bba959dc6b189e2$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $9bba959dc6b189e2$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $9bba959dc6b189e2$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $9bba959dc6b189e2$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($9bba959dc6b189e2$export$651544f548703224(node));
}
function $9bba959dc6b189e2$export$3735103072e4a80(element) {
    return $9bba959dc6b189e2$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $9bba959dc6b189e2$export$dc8fc79fa2800137(element) {
    if ($9bba959dc6b189e2$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $9bba959dc6b189e2$export$4e12058fc4d51d56(node) {
    if ($9bba959dc6b189e2$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $9bba959dc6b189e2$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $9bba959dc6b189e2$export$e495491855dc5418(node);
    return $9bba959dc6b189e2$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $9bba959dc6b189e2$export$7cd01a57c8ca906c(node) {
    const parentNode = $9bba959dc6b189e2$export$4e12058fc4d51d56(node);
    if ($9bba959dc6b189e2$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($9bba959dc6b189e2$export$1b3bfaa9684536aa(parentNode) && $9bba959dc6b189e2$export$989e911fa9af580a(parentNode)) return parentNode;
    return $9bba959dc6b189e2$export$7cd01a57c8ca906c(parentNode);
}
function $9bba959dc6b189e2$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $9bba959dc6b189e2$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $9bba959dc6b189e2$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $9bba959dc6b189e2$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $9bba959dc6b189e2$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $9bba959dc6b189e2$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $9bba959dc6b189e2$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $9bba959dc6b189e2$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("25rLP", function(module, exports) {
$parcel$export(module.exports, "PortalPlacementContext", () => $7e25d9966f01409c$export$e001f626511a0ead);

var $euxye = parcelRequire("euxye");
const $7e25d9966f01409c$export$e001f626511a0ead = /*#__PURE__*/ (0, $euxye.createContext)(null);

});


parcelRegister("6PGkv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bf4bae41707f246$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $egspI = parcelRequire("egspI");

var $d0F9p = parcelRequire("d0F9p");

var $fnGzU = parcelRequire("fnGzU");

var $eamWe = parcelRequire("eamWe");

var $i9Bbv = parcelRequire("i9Bbv");

var $9FFa6 = parcelRequire("9FFa6");
const $2bf4bae41707f246$var$multiValueTagWrapperStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1mouze3t _195gze3t _4cvr1h6o _1e0c1txw _1ul9ze3t _zdxokb7n _v5ynkb7n _13lsf1ug _3pxh1h6o _d0dz1txw _1ouwze3t"
};
// Tag-like color styles
const $2bf4bae41707f246$var$tagLikeColorStyles = {
    gray: "_119b8yml",
    blue: "_119b1w55",
    green: "_119b1crs",
    red: "_119b16y8",
    yellow: "_119bfeiv",
    purple: "_119b1hqq",
    lime: "_119bnf89",
    magenta: "_119buwd0",
    orange: "_119b1b2s",
    teal: "_119b1h3o"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- match TagNew border color logic
const $2bf4bae41707f246$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
const $2bf4bae41707f246$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhk1w7a _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up53acm _1xdnnqa1"
};
const $2bf4bae41707f246$var$getMultiValueLabelText = (children, data)=>{
    if (typeof children === 'string') return children;
    const label = data?.label;
    return typeof label === 'string' ? label : '';
};
const $2bf4bae41707f246$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const labelText = $2bf4bae41707f246$var$getMultiValueLabelText(children, data);
    const isPlainLabel = typeof children === 'string';
    const ffTagUplifts = (0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const { css: containerCss, className: containerClassName } = (0, $fnGzU.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $fnGzU.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $fnGzU.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    const hasCustomLabel = Label !== (0, $9FFa6.MultiValueLabel);
    const hasCustomContainer = Container !== (0, $i9Bbv.MultiValueContainer);
    const selectStyles = selectProps.styles;
    const hasCustomMultiValueStyles = Boolean(selectStyles?.multiValue || selectStyles?.multiValueLabel || selectStyles?.multiValueRemove);
    const selectClassNames = selectProps.classNames;
    const hasCustomMultiValueClassNames = Boolean(selectClassNames?.multiValue || selectClassNames?.multiValueLabel || selectClassNames?.multiValueRemove);
    // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    const selectGetStyles = (0, $eamWe.useSelectGetStyles)();
    const hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    const hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel && !hasCustomContainer && !hasCustomContainerStyles) {
        const { elemBefore: elemBefore, color: tagColor } = data ?? {};
        return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            ...innerProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $4jQY2.default)([
                $2bf4bae41707f246$var$multiValueTagWrapperStyles.root,
                (0, $9S1b6.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $d0F9p.default), {
                text: labelText,
                isRemovable: !isDisabled,
                removeButtonLabel: `${labelText}, remove`,
                onBeforeRemoveAction: ()=>{
                    removeProps.onClick?.({});
                    return false;
                },
                color: tagColor ?? 'gray',
                elemBefore: elemBefore,
                hasMargin: false
            })
        });
    }
    // FF on + custom content → tag-like path
    if (ffTagUplifts && !hasCustomContainer) {
        const colorKey = data?.color;
        return /*#__PURE__*/ (0, $e79Pd.jsxs)("div", {
            "data-multi-value-tag-like": "true",
            ...innerProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- custom styles.multiValue overrides (e.g. colored borders) must be preserved
            style: containerCss,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $4jQY2.default)([
                $2bf4bae41707f246$var$multiValueTagLikeStyles.root,
                $2bf4bae41707f246$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $2bf4bae41707f246$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $2bf4bae41707f246$var$tagLikeColorStyles.green,
                colorKey === 'red' && $2bf4bae41707f246$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $2bf4bae41707f246$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $2bf4bae41707f246$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $2bf4bae41707f246$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $2bf4bae41707f246$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $2bf4bae41707f246$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $2bf4bae41707f246$var$tagLikeColorStyles.teal,
                "_1h6dpryq _1k671038 _13muu67f _oe6mmko7 _u8p61h4e _hg5mr3uz _1easrqqc",
                isDisabled && $2bf4bae41707f246$var$multiValueTagLikeStyles.disabled,
                isFocused && $2bf4bae41707f246$var$multiValueTagLikeStyles.focused,
                (0, $9S1b6.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ]),
            children: [
                /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                    className: (0, $4jQY2.default)([
                        $2bf4bae41707f246$var$multiValueTagLikeStyles.labelWrapper
                    ]),
                    children: /*#__PURE__*/ (0, $e79Pd.jsx)(Label, {
                        data: data,
                        innerProps: {
                            style: labelCss,
                            className: labelClassName
                        },
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: labelClassName,
                        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                        selectProps: selectProps,
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, $e79Pd.jsx)(Remove, {
                    data: data,
                    innerProps: {
                        style: removeCss,
                        className: removeClassName,
                        role: 'button',
                        tabIndex: -1,
                        'aria-label': `${labelText || 'option'}, remove`,
                        ...removeProps
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: removeClassName,
                    isDisabled: isDisabled,
                    selectProps: selectProps
                })
            ]
        });
    }
    // FF off → default styles
    return /*#__PURE__*/ (0, $e79Pd.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${labelText || 'option'}, remove`,
                    ...removeProps
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
$2bf4bae41707f246$var$MultiValue.displayName = "MultiValue";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2bf4bae41707f246$export$2e2bcd8739ae039 = $2bf4bae41707f246$var$MultiValue;

});
parcelRegister("d0F9p", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5a3e95da952baa7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $fgfJr = parcelRequire("fgfJr");

var $ljVHR = parcelRequire("ljVHR");

var $2oRWW = parcelRequire("2oRWW");

var $2EFuW = parcelRequire("2EFuW");

var $8L2z6 = parcelRequire("8L2z6");
var $3Yz9F = parcelRequire("3Yz9F");

var $egspI = parcelRequire("egspI");
parcelRequire("la3d7");
var $9vn1I = parcelRequire("9vn1I");
var $la3d7 = parcelRequire("la3d7");

var $jSAa8 = parcelRequire("jSAa8");

var $dFqSD = parcelRequire("dFqSD");

var $3cgD8 = parcelRequire("3cgD8");

var $7LsQQ = parcelRequire("7LsQQ");

var $6mgpN = parcelRequire("6mgpN");

var $7Qoad = parcelRequire("7Qoad");
const $a5a3e95da952baa7$var$textLinkCssVar = '--ds-ctl';
const $a5a3e95da952baa7$var$textDefaultCssVar = '--ds-ct';
const $a5a3e95da952baa7$var$textActiveCssVar = '--ds-ctp';
const $a5a3e95da952baa7$var$backgroundHoverCssVar = '--ds-cbh';
const $a5a3e95da952baa7$var$backgroundActiveCssVar = '--ds-cba';
var $a5a3e95da952baa7$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($a5a3e95da952baa7$var$TagStatus || {});
const $a5a3e95da952baa7$var$packageName = "platform-pkg";
const $a5a3e95da952baa7$var$packageVersion = "0.0.0-use.local";
const $a5a3e95da952baa7$var$defaultBeforeRemoveAction = ()=>true; /**
                                               * These hide the focus ring for the tag when its remove button is focused,
                                               * preventing a double focus ring.
                                               */ 
const $a5a3e95da952baa7$var$removingStyles = null;
const $a5a3e95da952baa7$var$RemovableTagComponent = /*#__PURE__*/ (0, $euxye.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $a5a3e95da952baa7$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $2oRWW.default), linkComponent: linkComponent, migration_fallback: migration_fallback, maxWidth: maxWidth, hasMargin: hasMargin = true, swatchBefore: swatchBefore, ...rest }, ref)=>{
    const [status, setStatus] = (0, $euxye.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $euxye.useState)(false);
    const normalizedText = (0, $jSAa8.getTagText)(text);
    const onAfterRemoveActionWithAnalytics = (0, $fgfJr.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $a5a3e95da952baa7$var$packageName,
            packageVersion: $a5a3e95da952baa7$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $euxye.useCallback)(()=>{
        setStatus("removed");
    }, []);
    const handleRemoveRequest = (0, $euxye.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(normalizedText);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        normalizedText,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics
    ]);
    const onKeyPress = (0, $euxye.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $euxye.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $euxye.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $euxye.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $euxye.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7Qoad.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${normalizedText}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined; // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const lozengeAppearance = (0, $7LsQQ.getLozengeAppearance)(color);
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $2EFuW.default), {
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId,
            ...rest,
            children: normalizedText
        });
    } // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const newColor = (0, $9vn1I.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $la3d7.default), {
            ref: ref,
            color: newColor,
            text: normalizedText,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore
        });
    } // Original implementation
    const content = /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mgpN.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: normalizedText,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        // Tag background color on hover
        [$a5a3e95da952baa7$var$backgroundHoverCssVar]: undefined,
        // Tag background color on press
        [$a5a3e95da952baa7$var$backgroundActiveCssVar]: undefined,
        // The tag text on hover of remove button
        [$a5a3e95da952baa7$var$textDefaultCssVar]: undefined,
        // 'elemBefore' text on press of remove button
        [$a5a3e95da952baa7$var$textActiveCssVar]: undefined,
        // The tag link text on hover of remove button
        [$a5a3e95da952baa7$var$textLinkCssVar]: undefined
    };
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3Yz9F.default), {
            onFinish: handleRemoveComplete,
            children: (motion)=>{
                return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $dFqSD.default), {
                    ref: (0, $ljVHR.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3cgD8.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, $4jQY2.default)([
                        status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqht1nip"
                    ])
                });
            }
        }, "atlaskit-removable-tag-legacy-shrink-out")
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $a5a3e95da952baa7$var$RemovableTag = /*#__PURE__*/ (0, $euxye.memo)($a5a3e95da952baa7$var$RemovableTagComponent);
var $a5a3e95da952baa7$export$2e2bcd8739ae039 = $a5a3e95da952baa7$var$RemovableTag;

});
parcelRegister("3Yz9F", function(module, exports) {
$parcel$export(module.exports, "default", () => $4542881332362b9b$export$2e2bcd8739ae039);

var $9VFAH = parcelRequire("9VFAH");

var $bG844 = parcelRequire("bG844");

var $DxsCA = parcelRequire("DxsCA");

var $dxDNV = parcelRequire("dxDNV");

var $23KBv = parcelRequire("23KBv");

var $3bcsJ = parcelRequire("3bcsJ");

var $8L2z6 = parcelRequire("8L2z6");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $4542881332362b9b$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $DxsCA.useElementRef)();
    const exiting = (0, $8L2z6.useExitingPersistence)();
    const requestAnimationFrame = (0, $23KBv.useRequestAnimationFrame)();
    const setTimeout = (0, $3bcsJ.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $dxDNV.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            if ((0, $bG844.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $9VFAH.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $9VFAH.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
$4542881332362b9b$var$ShrinkOut.displayName = "ShrinkOut";
var $4542881332362b9b$export$2e2bcd8739ae039 = $4542881332362b9b$var$ShrinkOut;

});

parcelRegister("la3d7", function(module, exports) {
$parcel$export(module.exports, "TagDropdownTriggerComponent", () => $64ef0c5e1a9fd431$export$aba6bd1190e79361);
$parcel$export(module.exports, "default", () => $64ef0c5e1a9fd431$export$2e2bcd8739ae039);
$parcel$export(module.exports, "colorMapping", () => (parcelRequire("9vn1I")).colorMapping);
/* tag-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $ld25x = parcelRequire("ld25x");

var $6mEZn = parcelRequire("6mEZn");

var $abhF2 = parcelRequire("abhF2");

var $9vn1I = parcelRequire("9vn1I");

var $jSAa8 = parcelRequire("jSAa8");

var $cBgWk = parcelRequire("cBgWk");

var $l6ERj = parcelRequire("l6ERj");

var $j0Sen = parcelRequire("j0Sen");

var $7jp8W = parcelRequire("7jp8W");

var $8cVIY = parcelRequire("8cVIY");

var $2M8pZ = parcelRequire("2M8pZ");

var $33N7D = parcelRequire("33N7D");
const $64ef0c5e1a9fd431$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhk1w7a",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1r81 _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj18uv _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj18uv _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_175018uv _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
const $64ef0c5e1a9fd431$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
const $64ef0c5e1a9fd431$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
const $64ef0c5e1a9fd431$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
const $64ef0c5e1a9fd431$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ const $64ef0c5e1a9fd431$var$TagNewComponent = /*#__PURE__*/ (0, $euxye.forwardRef)(function TagNew({ color: color = 'gray', text: text, elemBefore: elemBefore, href: href, linkComponent: linkComponent, isRemovable: isRemovable = true, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, swatchBefore: swatchBefore, trailingMetric: trailingMetric, ...other }, ref) {
    const normalizedText = (0, $jSAa8.getTagText)(text);
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $33N7D.useTagRemoval)(onBeforeRemoveAction);
    const onShrinkOutExitComplete = (0, $euxye.useCallback)(()=>{
        onAfterRemoveAction?.(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $8cVIY.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $7jp8W.useButtonInteraction)();
    const removeButton = (0, $2M8pZ.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    const tagContent = /*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
        ...other,
        ref: ref,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, $4jQY2.default)([
            $64ef0c5e1a9fd431$var$styles.baseStyles,
            !hasMargin && $64ef0c5e1a9fd431$var$styles.noMarginStyles,
            $64ef0c5e1a9fd431$var$colorStyles[color],
            $64ef0c5e1a9fd431$var$borderIconFilterStyles.root,
            isLink && $64ef0c5e1a9fd431$var$styles.interactiveBaseStyles,
            isLink && $64ef0c5e1a9fd431$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $64ef0c5e1a9fd431$var$borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && $64ef0c5e1a9fd431$var$styles.interactiveHoverStyles,
            isRemovable && $64ef0c5e1a9fd431$var$styles.removableStyles,
            isLinkFocused && !isButtonFocused && $64ef0c5e1a9fd431$var$styles.childFocusRingStyles,
            !isRemovable && trailingMetric != null && trailingMetric !== '' && $64ef0c5e1a9fd431$var$styles.trailingMetricEndPadding
        ]),
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $cBgWk.LinkWrapper), {
                isLink: isLink,
                href: href,
                LinkComponent: LinkComponent,
                testId: testId,
                linkHandlers: linkHandlers,
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $j0Sen.default), {
                        colorKey: color,
                        swatchBefore: swatchBefore
                    }),
                    elemBefore && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        className: (0, $4jQY2.default)([
                            $64ef0c5e1a9fd431$var$styles.beforeStyles
                        ]),
                        children: elemBefore
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        "data-tag-text": true,
                        className: (0, $4jQY2.default)([
                            $64ef0c5e1a9fd431$var$styles.textStyles
                        ]),
                        children: normalizedText
                    }),
                    trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        "data-testid": testId && `${testId}--metric`,
                        className: (0, $4jQY2.default)([
                            $64ef0c5e1a9fd431$var$styles.trailingMetric
                        ]),
                        children: trailingMetric
                    })
                ]
            }),
            removeButton && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    $64ef0c5e1a9fd431$var$styles.afterStyles
                ]),
                children: removeButton
            })
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $l6ERj.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined,
        children: tagContent
    });
});
const $64ef0c5e1a9fd431$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $euxye.forwardRef)(function TagDropdownTrigger({ color: color = 'gray', text: text, elemBefore: elemBefore, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, isSelected: isSelected = false, isLoading: isLoading = false, analyticsContext: _analyticsContext, hasChevron: hasChevron = true, swatchBefore: swatchBefore, trailingMetric: trailingMetric, ...other }, ref) {
    const resolvedColor = (0, $9vn1I.colorMapping)[color] || 'gray';
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $6mEZn.default), {
        ref: ref,
        // @ts-expect-error paddingInline is 0.1875rem
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $9S1b6.cx)($64ef0c5e1a9fd431$var$styles.baseStyles, !hasMargin && $64ef0c5e1a9fd431$var$styles.noMarginStyles, $64ef0c5e1a9fd431$var$colorStyles[resolvedColor], $64ef0c5e1a9fd431$var$borderIconFilterStyles.root, $64ef0c5e1a9fd431$var$dropdownStyles.interactive, $64ef0c5e1a9fd431$var$styles.focusRingStyles, $64ef0c5e1a9fd431$var$borderIconInteractiveFilterStyles.root, isSelected && $64ef0c5e1a9fd431$var$dropdownStyles.selected, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $64ef0c5e1a9fd431$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        },
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        testId: testId,
        ...other,
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
                className: (0, $4jQY2.default)([
                    $64ef0c5e1a9fd431$var$dropdownStyles.content,
                    isLoading && $64ef0c5e1a9fd431$var$dropdownStyles.loadingContent
                ]),
                children: [
                    /*#__PURE__*/ (0, $e79Pd.jsx)((0, $j0Sen.default), {
                        colorKey: resolvedColor,
                        swatchBefore: swatchBefore
                    }),
                    elemBefore && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        className: (0, $4jQY2.default)([
                            $64ef0c5e1a9fd431$var$styles.beforeStyles,
                            isSelected && $64ef0c5e1a9fd431$var$styles.beforeStylesSelected
                        ]),
                        children: elemBefore
                    }),
                    /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        "data-tag-text": true,
                        className: (0, $4jQY2.default)([
                            $64ef0c5e1a9fd431$var$styles.textStyles,
                            isSelected && $64ef0c5e1a9fd431$var$styles.textStylesSelected
                        ]),
                        children: (0, $jSAa8.getTagText)(text)
                    }),
                    trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                        "data-testid": testId && `${testId}--metric`,
                        className: (0, $4jQY2.default)([
                            $64ef0c5e1a9fd431$var$styles.trailingMetric
                        ]),
                        children: trailingMetric
                    }),
                    hasChevron && /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                        label: "",
                        size: "small",
                        color: 'currentColor',
                        testId: testId && `${testId}--chevron`
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                className: (0, $4jQY2.default)([
                    $64ef0c5e1a9fd431$var$dropdownStyles.loadingOverlay
                ]),
                children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, $abhF2.default), {
                    size: 'xsmall',
                    label: ", Loading",
                    testId: testId ? `${testId}--loading-spinner` : undefined
                })
            })
        ]
    });
});
/**
 * __Tag new__
 */ const $64ef0c5e1a9fd431$var$TagNew = /*#__PURE__*/ (0, $euxye.memo)($64ef0c5e1a9fd431$var$TagNewComponent);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$64ef0c5e1a9fd431$export$2e2bcd8739ae039 = $64ef0c5e1a9fd431$var$TagNew;

});
parcelRegister("9vn1I", function(module, exports) {
$parcel$export(module.exports, "colorMapping", () => $16f60e789105a82b$export$3351a8d90bcc13aa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $16f60e789105a82b$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};

});

parcelRegister("jSAa8", function(module, exports) {
$parcel$export(module.exports, "getTagText", () => $156259ed412b526a$export$7d100de1166870f6);
// Intentionally scoped to the UI-uplifted TagNew implementation.
const $156259ed412b526a$export$7d100de1166870f6 = (text)=>Array.isArray(text) ? text.join('') : text;

});

parcelRegister("cBgWk", function(module, exports) {
$parcel$export(module.exports, "LinkWrapper", () => $cdf2db0ef62f0311$export$ce4b6a469c26f53f);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
function $cdf2db0ef62f0311$export$ce4b6a469c26f53f({ isLink: isLink, href: href, LinkComponent: LinkComponent, testId: testId, children: children, onClick: onClick, linkHandlers: linkHandlers }) {
    if (isLink && href) return /*#__PURE__*/ (0, $e79Pd.jsx)(LinkComponent, {
        href: href,
        testId: testId ? `${testId}--link` : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers?.onMouseEnter,
        onMouseLeave: linkHandlers?.onMouseLeave,
        onMouseDown: linkHandlers?.onMouseDown,
        onFocus: linkHandlers?.onFocus,
        onBlur: linkHandlers?.onBlur,
        children: children
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $euxye.Fragment), {
        children: children
    });
}
$cdf2db0ef62f0311$export$ce4b6a469c26f53f.displayName = "LinkWrapper";

});

parcelRegister("l6ERj", function(module, exports) {
$parcel$export(module.exports, "RemovableWrapper", () => $a693ff33d060de5b$export$898a500849bb5cf4);
/* removable-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $8L2z6 = parcelRequire("8L2z6");
var $3Yz9F = parcelRequire("3Yz9F");

var $5eeJV = parcelRequire("5eeJV");
/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ const $a693ff33d060de5b$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
const $a693ff33d060de5b$var$motionWrapperStyles = null;
function $a693ff33d060de5b$export$898a500849bb5cf4({ isRemovable: isRemovable, status: status, onShrinkOutExitComplete: onShrinkOutExitComplete, children: children }) {
    if (isRemovable) return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $8L2z6.default), {
        children: !(status === (0, $5eeJV.TagStatus).Removed) && /*#__PURE__*/ (0, $e79Pd.jsx)((0, $3Yz9F.default), {
            onFinish: onShrinkOutExitComplete ? (phase)=>{
                if (phase === 'exiting') onShrinkOutExitComplete();
            } : undefined,
            children: (motion)=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                    ref: motion.ref,
                    className: (0, $4jQY2.default)([
                        "_1e0c116y"
                    ]),
                    children: children
                })
        }, $a693ff33d060de5b$var$removableShrinkOutChildKey)
    });
    return children;
}
$a693ff33d060de5b$export$898a500849bb5cf4.displayName = "RemovableWrapper";

});
parcelRegister("5eeJV", function(module, exports) {
$parcel$export(module.exports, "TagStatus", () => $aca759d9f34e091b$export$74452314b63acabc);
// Tag status enum
var $aca759d9f34e091b$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});

});


parcelRegister("j0Sen", function(module, exports) {
$parcel$export(module.exports, "default", () => $91c684da65a78c91$export$2e2bcd8739ae039);
/* swatch-before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $91c684da65a78c91$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
const $91c684da65a78c91$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $91c684da65a78c91$export$2e2bcd8739ae039({ colorKey: colorKey, swatchBefore: swatchBefore }) {
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            $91c684da65a78c91$var$tagSwatchBeforeStyles.swatch,
            $91c684da65a78c91$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $4jQY2.default)([
            $91c684da65a78c91$var$tagSwatchBeforeStyles.swatch
        ])
    });
}
$91c684da65a78c91$export$2e2bcd8739ae039.displayName = "SwatchBefore";

});

parcelRegister("7jp8W", function(module, exports) {
$parcel$export(module.exports, "useButtonInteraction", () => $cf5751754f5053aa$export$84acd183858d8235);

var $euxye = parcelRequire("euxye");
function $cf5751754f5053aa$export$84acd183858d8235() {
    const [isLinkHovered, setIsLinkHovered] = (0, $euxye.useState)(false);
    const [isOverButton, setIsOverButton] = (0, $euxye.useState)(false);
    const [isButtonFocused, setIsButtonFocused] = (0, $euxye.useState)(false);
    const [isLinkFocused, setIsLinkFocused] = (0, $euxye.useState)(false);
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    const hadMouseDownRef = (0, $euxye.useRef)(false);
    // Button handlers
    const buttonHandlers = (0, $euxye.useMemo)(()=>({
            onMouseEnter: ()=>setIsOverButton(true),
            onMouseLeave: ()=>setIsOverButton(false),
            onMouseDown: (e)=>{
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e?.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsButtonFocused(false)
        }), []);
    // Link handlers - includes hover tracking
    const linkHandlers = (0, $euxye.useMemo)(()=>({
            onMouseEnter: ()=>setIsLinkHovered(true),
            onMouseLeave: ()=>setIsLinkHovered(false),
            onMouseDown: ()=>{
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsLinkFocused(false)
        }), []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}

});

parcelRegister("8cVIY", function(module, exports) {
$parcel$export(module.exports, "useLink", () => $0e9110f704a6f810$export$dcf14c9974fe2767);

var $hzWaA = parcelRequire("hzWaA");
function $0e9110f704a6f810$export$dcf14c9974fe2767(href, linkComponent) {
    const isLink = Boolean(href);
    const LinkComponent = linkComponent ?? (0, $hzWaA.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}

});

parcelRegister("2M8pZ", function(module, exports) {
$parcel$export(module.exports, "useRemoveButton", () => $29c97f963b62271a$export$97d8be09cd53869b);
/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $7Qoad = parcelRequire("7Qoad");
function $29c97f963b62271a$export$97d8be09cd53869b({ isRemovable: isRemovable, tagText: tagText, removeButtonLabel: removeButtonLabel, testId: testId, handleRemoveRequest: handleRemoveRequest, removingTag: removingTag, showingTag: showingTag, onKeyPress: onKeyPress, shape: shape = 'default', buttonHandlers: buttonHandlers }) {
    const handleFocus = (0, $euxye.useCallback)(()=>{
        removingTag();
        buttonHandlers?.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    const handleBlur = (0, $euxye.useCallback)(()=>{
        showingTag();
        buttonHandlers?.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $euxye.useMemo)(()=>{
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $7Qoad.default), {
            "aria-label": `${removeButtonLabel || 'Remove'} ${tagText}`,
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers?.onMouseEnter,
            onMouseLeave: buttonHandlers?.onMouseLeave,
            onMouseDown: buttonHandlers?.onMouseDown,
            testId: testId ? `close-button-${testId}` : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}

});
parcelRegister("7Qoad", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4f1e0beeada2028$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $1MNmN = parcelRequire("1MNmN");

var $i68tN = parcelRequire("i68tN");

var $egspI = parcelRequire("egspI");

var $6mEZn = parcelRequire("6mEZn");
const $e4f1e0beeada2028$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
const $e4f1e0beeada2028$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, testId: testId, shape: shape = 'default' })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)((0, $6mEZn.default), {
        xcss: (0, $1MNmN.cx)($e4f1e0beeada2028$var$removeButtonStyles.root, shape === 'circle' && $e4f1e0beeada2028$var$removeButtonStyles.circle, $e4f1e0beeada2028$var$removeButtonStyles.newIcon, (0, $egspI.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && $e4f1e0beeada2028$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId,
        children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i68tN))), {
            color: "currentColor",
            label: "",
            size: "small"
        })
    });
};
$e4f1e0beeada2028$var$RemoveButton.displayName = "RemoveButton";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e4f1e0beeada2028$export$2e2bcd8739ae039 = $e4f1e0beeada2028$var$RemoveButton;

});


parcelRegister("33N7D", function(module, exports) {
$parcel$export(module.exports, "useTagRemoval", () => $4c1848fea025727b$export$f26019543e9f862f);

var $euxye = parcelRequire("euxye");

var $gbRME = parcelRequire("gbRME");

var $5eeJV = parcelRequire("5eeJV");
function $4c1848fea025727b$export$f26019543e9f862f(onBeforeRemoveAction) {
    const [status, setStatus] = (0, $euxye.useState)((0, $5eeJV.TagStatus).Showing);
    const handleRemoveRequest = (0, $euxye.useCallback)(()=>{
        const beforeAction = onBeforeRemoveAction ?? (0, $gbRME.defaultBeforeRemoveAction);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $5eeJV.TagStatus).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $euxye.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $euxye.useCallback)(()=>setStatus((0, $5eeJV.TagStatus).Removing), []);
    const showingTag = (0, $euxye.useCallback)(()=>setStatus((0, $5eeJV.TagStatus).Showing), []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}

});
parcelRegister("gbRME", function(module, exports) {
$parcel$export(module.exports, "defaultBeforeRemoveAction", () => $ba03e3d1e3f0a7cc$export$279e7025ed114474);
const $ba03e3d1e3f0a7cc$export$279e7025ed114474 = ()=>true;

});



parcelRegister("dFqSD", function(module, exports) {
$parcel$export(module.exports, "default", () => $814df91cde2dc5e7$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");

var $4jQY2 = parcelRequire("4jQY2");

var $euxye = parcelRequire("euxye");
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
const $814df91cde2dc5e7$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
const $814df91cde2dc5e7$var$baseStyles = null;
const $814df91cde2dc5e7$var$interactiveStyles = null;
const $814df91cde2dc5e7$var$focusRingStyles = null;
const $814df91cde2dc5e7$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, $e79Pd.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $4jQY2.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhk1w7a _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $814df91cde2dc5e7$var$borderColors[color],
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$814df91cde2dc5e7$export$2e2bcd8739ae039 = $814df91cde2dc5e7$var$BaseTag;

});

parcelRegister("3cgD8", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcb0d169ae3c0576$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $fcb0d169ae3c0576$var$beforeElementStyles = null;
const $fcb0d169ae3c0576$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
$fcb0d169ae3c0576$var$Before.displayName = "Before";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fcb0d169ae3c0576$export$2e2bcd8739ae039 = $fcb0d169ae3c0576$var$Before;

});

parcelRegister("7LsQQ", function(module, exports) {
$parcel$export(module.exports, "getLozengeAppearance", () => $440942323f24cbd6$export$4d9e331cafeacb9d);
/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ const $440942323f24cbd6$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $440942323f24cbd6$export$4d9e331cafeacb9d(color) {
    return $440942323f24cbd6$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}

});

parcelRegister("6mgpN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0dc42a9a546a1d8$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $jSAa8 = parcelRequire("jSAa8");
const $d0dc42a9a546a1d8$var$baseStyles = null;
const $d0dc42a9a546a1d8$var$linkStyles = null;
const $d0dc42a9a546a1d8$var$hasAfterStyles = null;
const $d0dc42a9a546a1d8$var$Content = ({ isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent, testId: testId })=>{
    const Link = linkComponent ?? 'a';
    const normalizedText = (0, $jSAa8.getTagText)(text);
    if (href) return /*#__PURE__*/ (0, $e79Pd.jsx)(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? `${testId}--link` : undefined,
        className: (0, $4jQY2.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm18uv _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ]),
        children: normalizedText
    });
    else return /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        className: (0, $4jQY2.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ]),
        children: normalizedText
    });
};
$d0dc42a9a546a1d8$var$Content.displayName = "Content";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d0dc42a9a546a1d8$export$2e2bcd8739ae039 = $d0dc42a9a546a1d8$var$Content;

});


parcelRegister("eamWe", function(module, exports) {
$parcel$export(module.exports, "useSelectGetStyles", () => $546c826ef5bf3d5a$export$2a533455c10aa11f);
/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ 
var $euxye = parcelRequire("euxye");

var $2dGma = parcelRequire("2dGma");
const $546c826ef5bf3d5a$export$2a533455c10aa11f = ()=>(0, $euxye.useContext)((0, $2dGma.SelectGetStylesContext));

});
parcelRegister("2dGma", function(module, exports) {
$parcel$export(module.exports, "SelectGetStylesContext", () => $c6a14a5d5000558b$export$50727c0a52da4015);
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ 
var $euxye = parcelRequire("euxye");
const $c6a14a5d5000558b$export$50727c0a52da4015 = /*#__PURE__*/ (0, $euxye.createContext)(undefined);

});


parcelRegister("9FFa6", function(module, exports) {
$parcel$export(module.exports, "MultiValueLabel", () => $363cb80f354e8e2d$export$544aeea2a5ce08ee);
/* multi-value-label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");
const $363cb80f354e8e2d$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
const $363cb80f354e8e2d$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $363cb80f354e8e2d$var$multiValueLabelStyles.root,
            isDisabled && $363cb80f354e8e2d$var$multiValueLabelStyles.disabled,
            hasEllipsis && $363cb80f354e8e2d$var$multiValueLabelStyles.ellipsis,
            (0, $9S1b6.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};
$363cb80f354e8e2d$export$544aeea2a5ce08ee.displayName = "MultiValueLabel";

});


parcelRegister("hvkNV", function(module, exports) {
$parcel$export(module.exports, "MultiValueRemove", () => $a42c4a691c83fe87$export$8e1fd1a40e7a2f4a);
/* multi-value-remove.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $i68tN = parcelRequire("i68tN");
const $a42c4a691c83fe87$var$disabledStyles = null;
const $a42c4a691c83fe87$var$enabledStyles = null;
const $a42c4a691c83fe87$var$multiValueRemoveStyles = {
    focused: "_bfhk1km6 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function $a42c4a691c83fe87$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $a42c4a691c83fe87$var$multiValueRemoveStyles.root,
            isFocused && $a42c4a691c83fe87$var$multiValueRemoveStyles.focused,
            (0, $9S1b6.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $4jQY2.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, $e79Pd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i68tN))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
}
$a42c4a691c83fe87$export$8e1fd1a40e7a2f4a.displayName = "MultiValueRemove";

});

parcelRegister("gaXx9", function(module, exports) {
$parcel$export(module.exports, "default", () => $11f5619184c5272b$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");
const $11f5619184c5272b$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk18uv _16qsglyw _1di618uv _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e126o",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e126o",
    focusedSelected: "_bfhkufnl"
};
const $11f5619184c5272b$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $11f5619184c5272b$var$optionStyles.root,
            isFocused && $11f5619184c5272b$var$optionStyles.focused,
            isSelected && $11f5619184c5272b$var$optionStyles.selected,
            isFocused && isSelected && $11f5619184c5272b$var$optionStyles.focusedSelected,
            isDisabled && $11f5619184c5272b$var$optionStyles.disabled,
            (0, $9S1b6.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
$11f5619184c5272b$var$Option.displayName = "Option";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$11f5619184c5272b$export$2e2bcd8739ae039 = $11f5619184c5272b$var$Option;

});

parcelRegister("03ZGj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e752787424d1302$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");
const $2e752787424d1302$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
const $2e752787424d1302$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $2e752787424d1302$var$placeholderStyles.root,
            isDisabled && $2e752787424d1302$var$placeholderStyles.disabled,
            (0, $9S1b6.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
};
$2e752787424d1302$var$Placeholder.displayName = "Placeholder";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2e752787424d1302$export$2e2bcd8739ae039 = $2e752787424d1302$var$Placeholder;

});

parcelRegister("80vrn", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd03f6992cacf471$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $9S1b6 = parcelRequire("9S1b6");

var $fnGzU = parcelRequire("fnGzU");
const $fd03f6992cacf471$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
const $fd03f6992cacf471$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $fnGzU.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $4jQY2.default)([
            $fd03f6992cacf471$var$styles.root,
            isDisabled && $fd03f6992cacf471$var$styles.disalbed,
            (0, $9S1b6.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
};
$fd03f6992cacf471$var$SingleValue.displayName = "SingleValue";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd03f6992cacf471$export$2e2bcd8739ae039 = $fd03f6992cacf471$var$SingleValue;

});


parcelRegister("12siX", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5cf3b4e57e78f87$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $a5cf3b4e57e78f87$var$removeProps = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $a5cf3b4e57e78f87$var$dummyInputStyles = null;
function $a5cf3b4e57e78f87$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = $a5cf3b4e57e78f87$var$removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $e79Pd.jsx)("input", {
        ref: innerRef,
        className: (0, $4jQY2.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d3acm _syaz3acm _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}
$a5cf3b4e57e78f87$export$2e2bcd8739ae039.displayName = "DummyInput";

});

parcelRegister("5sF5y", function(module, exports) {
$parcel$export(module.exports, "default", () => $d99dbdaf149eee59$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $43oeN = parcelRequire("43oeN");

var $gfpJJ = parcelRequire("gfpJJ");
const $d99dbdaf149eee59$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $euxye.useMemo)(()=>({
            ...(0, $43oeN.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $euxye.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $euxye.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gfpJJ.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $e79Pd.jsx)((0, $gfpJJ.default), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
$d99dbdaf149eee59$var$LiveRegion.displayName = "LiveRegion";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d99dbdaf149eee59$export$2e2bcd8739ae039 = $d99dbdaf149eee59$var$LiveRegion;

});
parcelRegister("43oeN", function(module, exports) {
$parcel$export(module.exports, "defaultAriaLiveMessages", () => $fc187912ade9a293$export$a7265767c78f9bae);
const $fc187912ade9a293$export$a7265767c78f9bae = {
    onChange: (props)=>{
        const { action: action, label: label = '', isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};

});

parcelRegister("gfpJJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e36b4aa4950150b6$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v0.36.1 */ // Assistive text to describe visual elements. Hidden for sighted users.

var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");
const $e36b4aa4950150b6$var$styles = null;
const $e36b4aa4950150b6$var$A11yText = (props)=>/*#__PURE__*/ (0, $e79Pd.jsx)("span", {
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $4jQY2.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ]),
        ...props
    });
$e36b4aa4950150b6$var$A11yText.displayName = "A11yText";
var $e36b4aa4950150b6$export$2e2bcd8739ae039 = $e36b4aa4950150b6$var$A11yText;

});


parcelRegister("jgG0E", function(module, exports) {
$parcel$export(module.exports, "default", () => $1058914072f3e09a$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $2oRWW = parcelRequire("2oRWW");

var $25rLP = parcelRequire("25rLP");
const $1058914072f3e09a$var$noop = (0, $2oRWW.default);
function $1058914072f3e09a$var$getScrollParent(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $1058914072f3e09a$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $1058914072f3e09a$var$normalizedHeight(el) {
    if ($1058914072f3e09a$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $1058914072f3e09a$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($1058914072f3e09a$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $1058914072f3e09a$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $1058914072f3e09a$var$getScrollTop(el) {
    if ($1058914072f3e09a$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $1058914072f3e09a$var$animatedScrollTo(element, to, duration = 200, callback = $1058914072f3e09a$var$noop) {
    const start = $1058914072f3e09a$var$getScrollTop(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $1058914072f3e09a$var$easeOutCubic(currentTime, start, change, duration);
        $1058914072f3e09a$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $1058914072f3e09a$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = $1058914072f3e09a$var$getScrollParent(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : $1058914072f3e09a$var$normalizedHeight(scrollParent);
    const scrollTop = $1058914072f3e09a$var$getScrollTop(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $1058914072f3e09a$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $1058914072f3e09a$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $1058914072f3e09a$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $1058914072f3e09a$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $1058914072f3e09a$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $1058914072f3e09a$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $1058914072f3e09a$var$MenuPlacer = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $euxye.useContext)((0, $25rLP.PortalPlacementContext)) || {};
    const ref = (0, $euxye.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $euxye.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $euxye.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $euxye.useLayoutEffect)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $1058914072f3e09a$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $1058914072f3e09a$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
$1058914072f3e09a$var$MenuPlacer.displayName = "MenuPlacer";
var $1058914072f3e09a$export$2e2bcd8739ae039 = $1058914072f3e09a$var$MenuPlacer;

});

parcelRegister("87lhX", function(module, exports) {
$parcel$export(module.exports, "createFilter", () => $c2ab91d201547b95$export$5d81789ff4aeccdf);

var $emCaV = parcelRequire("emCaV");

var $ii2Vi = parcelRequire("ii2Vi");
const $c2ab91d201547b95$var$memoizedStripDiacriticsForInput = (0, $emCaV.default)((0, $ii2Vi.stripDiacritics));
const $c2ab91d201547b95$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $c2ab91d201547b95$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $c2ab91d201547b95$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $c2ab91d201547b95$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $c2ab91d201547b95$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $c2ab91d201547b95$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $c2ab91d201547b95$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $ii2Vi.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("ii2Vi", function(module, exports) {
$parcel$export(module.exports, "stripDiacritics", () => $9b377e65d9e4c92e$export$b5bee4b27048330b);
const $9b377e65d9e4c92e$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $9b377e65d9e4c92e$var$anyDiacritic = new RegExp('[' + $9b377e65d9e4c92e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $9b377e65d9e4c92e$var$diacriticToBase = {};
for(let i = 0; i < $9b377e65d9e4c92e$var$diacritics.length; i++){
    let diacritic = $9b377e65d9e4c92e$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$9b377e65d9e4c92e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $9b377e65d9e4c92e$export$b5bee4b27048330b = (str)=>{
    return str.replace($9b377e65d9e4c92e$var$anyDiacritic, (match)=>$9b377e65d9e4c92e$var$diacriticToBase[match]);
};

});


parcelRegister("hbudu", function(module, exports) {
$parcel$export(module.exports, "classNames", () => $fdee712e6698ef88$export$ce4ab0c55987d1ff);
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $fdee712e6698ef88$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $fdee712e6698ef88$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$fdee712e6698ef88$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}

});

parcelRegister("369bp", function(module, exports) {
$parcel$export(module.exports, "cleanValue", () => $e64289349e707ce4$export$33f062f47f21a01);
const $e64289349e707ce4$export$33f062f47f21a01 = (value)=>{
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};

});

parcelRegister("8fbe0", function(module, exports) {
$parcel$export(module.exports, "isDocumentElement", () => $85dc30786f7c7973$export$d8a62a489b442872);
function $85dc30786f7c7973$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}

});

parcelRegister("FKmXz", function(module, exports) {
$parcel$export(module.exports, "multiValueAsValue", () => $f5ae85341aad2f8b$export$d1ca752ec761b95b);
function $f5ae85341aad2f8b$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}

});

parcelRegister("dxId9", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $7b4450fe6757040d$export$17baa7c95b6ba1b8);

var $9fOPQ = parcelRequire("9fOPQ");
function $7b4450fe6757040d$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $9fOPQ.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}
$7b4450fe6757040d$export$17baa7c95b6ba1b8.displayName = "NotifyOpenLayerObserver";

});

parcelRegister("BytXA", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4e96fc16072d65f$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $e79Pd = parcelRequire("e79Pd");
parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $2oRWW = parcelRequire("2oRWW");
const $d4e96fc16072d65f$var$styles = null;
const $d4e96fc16072d65f$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $e79Pd.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $4jQY2.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $2oRWW.default)
    });
$d4e96fc16072d65f$var$RequiredInput.displayName = "RequiredInput";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d4e96fc16072d65f$export$2e2bcd8739ae039 = $d4e96fc16072d65f$var$RequiredInput;

});

parcelRegister("8Sn9q", function(module, exports) {
$parcel$export(module.exports, "default", () => $17a32e25579e47e7$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");

var $79i7l = parcelRequire("79i7l");

var $h0Vtm = parcelRequire("h0Vtm");
const $17a32e25579e47e7$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $17a32e25579e47e7$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $79i7l.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $h0Vtm.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $e79Pd.jsxs)((0, $euxye.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, $e79Pd.jsx)("div", {
                onClick: $17a32e25579e47e7$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}
$17a32e25579e47e7$export$2e2bcd8739ae039.displayName = "ScrollManager";

});
parcelRegister("79i7l", function(module, exports) {
$parcel$export(module.exports, "default", () => $88140c9a87a6bb65$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $bY3A7 = parcelRequire("bY3A7");
const $88140c9a87a6bb65$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $88140c9a87a6bb65$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $euxye.useRef)(false);
    const isTop = (0, $euxye.useRef)(false);
    const touchStart = (0, $euxye.useRef)(0);
    const scrollTarget = (0, $euxye.useRef)(null);
    const handleEventDelta = (0, $euxye.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $88140c9a87a6bb65$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $euxye.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $euxye.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $euxye.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $euxye.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $bY3A7.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $euxye.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});
parcelRegister("bY3A7", function(module, exports) {
$parcel$export(module.exports, "supportsPassiveEvents", () => $ee96e2f3e39aacaa$export$b0622a6911dbeaf5);
// ==============================
// Passive Event Detector
// ==============================

var $2oRWW = parcelRequire("2oRWW");
const $ee96e2f3e39aacaa$var$noop = (0, $2oRWW.default);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $ee96e2f3e39aacaa$var$passiveOptionAccessed = false;
const $ee96e2f3e39aacaa$var$options = {
    get passive () {
        return $ee96e2f3e39aacaa$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $ee96e2f3e39aacaa$var$w = typeof window !== 'undefined' ? window : {};
if ($ee96e2f3e39aacaa$var$w.addEventListener && $ee96e2f3e39aacaa$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $ee96e2f3e39aacaa$var$w.addEventListener('p', $ee96e2f3e39aacaa$var$noop, $ee96e2f3e39aacaa$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $ee96e2f3e39aacaa$var$w.removeEventListener('p', $ee96e2f3e39aacaa$var$noop, false);
}
const $ee96e2f3e39aacaa$export$b0622a6911dbeaf5 = $ee96e2f3e39aacaa$var$passiveOptionAccessed;

});


parcelRegister("h0Vtm", function(module, exports) {
$parcel$export(module.exports, "default", () => $09aba0b9289f6e63$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
const $09aba0b9289f6e63$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $09aba0b9289f6e63$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $09aba0b9289f6e63$var$preventTouchMove(e) {
    e.preventDefault();
}
function $09aba0b9289f6e63$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $09aba0b9289f6e63$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $09aba0b9289f6e63$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $09aba0b9289f6e63$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $09aba0b9289f6e63$var$activeScrollLocks = 0;
const $09aba0b9289f6e63$var$listenerOptions = {
    capture: false,
    passive: false
};
function $09aba0b9289f6e63$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $euxye.useRef)({});
    const scrollTarget = (0, $euxye.useRef)(null);
    const addScrollLock = (0, $euxye.useCallback)((touchScrollTarget)=>{
        if (!$09aba0b9289f6e63$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $09aba0b9289f6e63$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $09aba0b9289f6e63$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($09aba0b9289f6e63$var$LOCK_STYLES).forEach((key)=>{
                const val = $09aba0b9289f6e63$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $09aba0b9289f6e63$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $09aba0b9289f6e63$var$preventTouchMove, $09aba0b9289f6e63$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $09aba0b9289f6e63$var$preventInertiaScroll, $09aba0b9289f6e63$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $09aba0b9289f6e63$var$allowTouchMove, $09aba0b9289f6e63$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $09aba0b9289f6e63$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $euxye.useCallback)((touchScrollTarget)=>{
        if (!$09aba0b9289f6e63$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $09aba0b9289f6e63$var$activeScrollLocks = Math.max($09aba0b9289f6e63$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $09aba0b9289f6e63$var$activeScrollLocks < 1) $09aba0b9289f6e63$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $09aba0b9289f6e63$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $09aba0b9289f6e63$var$preventTouchMove, $09aba0b9289f6e63$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $09aba0b9289f6e63$var$preventInertiaScroll, $09aba0b9289f6e63$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $09aba0b9289f6e63$var$allowTouchMove, $09aba0b9289f6e63$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $euxye.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("6q2Ac", function(module, exports) {
$parcel$export(module.exports, "scrollTo", () => $fe6f5fbdeaaa5ef5$export$3f99968195accfaf);

var $8fbe0 = parcelRequire("8fbe0");
function $fe6f5fbdeaaa5ef5$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $8fbe0.isDocumentElement)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}

});

parcelRegister("hjDA7", function(module, exports) {
$parcel$export(module.exports, "singleValueAsValue", () => $6a9daebd2af397b8$export$dea4763e29237f4c);
function $6a9daebd2af397b8$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}

});

parcelRegister("dC0e5", function(module, exports) {
$parcel$export(module.exports, "valueTernary", () => $7425f67f20493559$export$40fb9515c784cc3b);
function $7425f67f20493559$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}

});


parcelRegister("8k7pc", function(module, exports) {
$parcel$export(module.exports, "default", () => $232bd27fd81cdbed$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $232bd27fd81cdbed$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $232bd27fd81cdbed$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $euxye.useRef)(undefined);
    const mounted = (0, $euxye.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $euxye.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $euxye.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $euxye.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $euxye.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $euxye.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $euxye.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $euxye.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $euxye.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $euxye.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $euxye.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $euxye.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $euxye.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $euxye.useCallback)((newValue, actionMeta)=>{
        const inputValue = $232bd27fd81cdbed$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("8LfFe", function(module, exports) {
$parcel$export(module.exports, "default", () => $52747f11ed96716b$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");
function $52747f11ed96716b$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $euxye.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $euxye.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $euxye.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $euxye.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $euxye.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $euxye.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $euxye.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("c0vzW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8639ea713f9daf6b$export$2e2bcd8739ae039);

var $e79Pd = parcelRequire("e79Pd");

var $euxye = parcelRequire("euxye");
function $8639ea713f9daf6b$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $euxye.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $euxye.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $euxye.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $e79Pd.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});




parcelRegister("8RhC5", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cfd580372744a5f$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $m9iwH = parcelRequire("m9iwH");

var $hZDXn = parcelRequire("hZDXn");

var $1Unjk = parcelRequire("1Unjk");

var $kJKna = parcelRequire("kJKna");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $5cfd580372744a5f$var$copyTooltipHover = (0, $7eNDO.defineMessage)({
    defaultMessage: "Copy {itemToCopy}",
    id: "applinks.administration.ui.common.fields.copy-button.copy-tooltip-hover"
});
const $5cfd580372744a5f$var$copyTooltipFeedback = (0, $7eNDO.defineMessage)({
    defaultMessage: "Copied",
    id: "applinks.administration.ui.common.fields.copy-button.copy-tooltip-feedback"
});
const $5cfd580372744a5f$var$TOOLTIP_CONTENT_REFRESH_INTERVAL = 2500;
const $5cfd580372744a5f$var$CopyButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const [linkCopied, setLinkCopied] = (0, $euxye.useState)(false);
    const [message, setMessage] = (0, $euxye.useState)(formatMessage($5cfd580372744a5f$var$copyTooltipHover, {
        itemToCopy: props.label
    }));
    const updateTooltip = (0, $euxye.useRef)();
    (0, $euxye.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        message
    ]);
    const copyLink = (0, $euxye.useCallback)(async ()=>{
        if (typeof globalThis !== 'undefined' && globalThis.navigator?.clipboard) try {
            await globalThis.navigator.clipboard.writeText(props.value);
            setLinkCopied(true);
            setMessage(formatMessage($5cfd580372744a5f$var$copyTooltipFeedback));
            setTimeout(()=>{
                setLinkCopied(false);
                setMessage(formatMessage($5cfd580372744a5f$var$copyTooltipHover, {
                    itemToCopy: props.label
                }));
            }, $5cfd580372744a5f$var$TOOLTIP_CONTENT_REFRESH_INTERVAL);
        } catch (error) {
        // TODO: Handle error case where clipboard write fails
        }
    }, [
        formatMessage,
        props.label,
        props.value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $hZDXn.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return message;
        },
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $m9iwH.default), {
        appearance: "subtle",
        icon: linkCopied ? (0, (/*@__PURE__*/$parcel$interopDefault($kJKna))) : (0, (/*@__PURE__*/$parcel$interopDefault($1Unjk))),
        label: formatMessage($5cfd580372744a5f$var$copyTooltipHover, {
            itemToCopy: props.label
        }),
        isTooltipDisabled: true,
        onClick: copyLink
    }));
};
$5cfd580372744a5f$var$CopyButton.displayName = "CopyButton";
var $5cfd580372744a5f$export$2e2bcd8739ae039 = $5cfd580372744a5f$var$CopyButton;

});
parcelRegister("1Unjk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d46d77f8084efb8562fee77ec5d30fd2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $163d1a70b689d0d2$var$_react = $163d1a70b689d0d2$var$_interopRequireDefault((parcelRequire("euxye")));

var $163d1a70b689d0d2$var$_baseNew = $163d1a70b689d0d2$var$_interopRequireDefault((parcelRequire("6tEFs")));
function $163d1a70b689d0d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $163d1a70b689d0d2$var$CopyIcon = (props)=>/*#__PURE__*/ $163d1a70b689d0d2$var$_react.default.createElement($163d1a70b689d0d2$var$_baseNew.default, Object.assign({
        name: "CopyIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$163d1a70b689d0d2$var$CopyIcon.displayName = 'CopyIcon';
var $163d1a70b689d0d2$var$_default = module.exports.default = $163d1a70b689d0d2$var$CopyIcon;

});



parcelRegister("eGbwi", function(module, exports) {
$parcel$export(module.exports, "outgoingCredentialsModalEntryPoint", () => $fe2f911d045dd4f3$export$3db8bdfccb0f1ca5);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

const $fe2f911d045dd4f3$export$3db8bdfccb0f1ca5 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("8XzsZ")), {
        moduleId: "5a92c865",
        moduleName: "OutgoingCredentialsModal",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8XzsZ", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = $4cvLQ("5P8vn").then(()=>parcelRequire('a8FCq'));

});








parcelRegister("1jjv8", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsDvcsBitbucketRouteEntry", () => $cef3239355247b22$export$8d7fb911e3ad15ce);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $dARWN = parcelRequire("dARWN");
const $cef3239355247b22$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $cef3239355247b22$export$8d7fb911e3ad15ce = (0, $g1GqA.createLegacyEntry)((0, $dARWN.globalSettingsProductsDvcsBitbucketRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: (0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$cef3239355247b22$var$pageEntryPoint
    }));

});
parcelRegister("dARWN", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsDvcsBitbucketRoute", () => $7a1383bd9657d107$export$463d647a53bdebee);
const $7a1383bd9657d107$export$463d647a53bdebee = {
    name: 'global-settings-products-dvcs-bitbucket',
    path: '/secure/BitbucketPostInstallApprovalAction.jspa'
};

});


parcelRegister("aL1PW", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsDvcsRouteEntry", () => $fadc8f51286f708a$export$7970dfc3b824c864);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $gwNRX = parcelRequire("gwNRX");
const $fadc8f51286f708a$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $fadc8f51286f708a$export$7970dfc3b824c864 = (0, $g1GqA.createLegacyEntry)((0, $gwNRX.globalSettingsProductsDvcsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: (0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$fadc8f51286f708a$var$pageEntryPoint
    }));

});
parcelRegister("gwNRX", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsDvcsRoute", () => $c226e1f98171855f$export$75d086bb3dd16edc);
const $c226e1f98171855f$export$75d086bb3dd16edc = {
    name: 'global-settings-products-dvcs',
    path: '/secure/admin/ConfigureDvcsOrganizations!default.jspa'
};

});


parcelRegister("1QN9p", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsJsdStatusRouteEntry", () => $91de463e6c65c47c$export$5f4b9c737cade2ac);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $2RMny = parcelRequire("2RMny");
const $91de463e6c65c47c$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $91de463e6c65c47c$export$5f4b9c737cade2ac = (0, $g1GqA.createLegacyEntry)((0, $2RMny.globalSettingsProductsJsdStatusRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: (0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$91de463e6c65c47c$var$pageEntryPoint
    }));

});
parcelRegister("2RMny", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsJsdStatusRoute", () => $a9bc811b00e9583b$export$a0292a772bf703a0);
const $a9bc811b00e9583b$export$a0292a772bf703a0 = {
    name: 'global-settings-products-jsd-status',
    path: '/plugins/servlet/ac/jsd-status-page'
};

});


parcelRegister("95uPH", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsSdconfigRouteEntry", () => $67bb6d10f6c9b72e$export$cb6362a400fffb25);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $4WFif = parcelRequire("4WFif");
const $67bb6d10f6c9b72e$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $67bb6d10f6c9b72e$export$cb6362a400fffb25 = (0, $g1GqA.createLegacyEntry)((0, $4WFif.globalSettingsProductsSdconfigRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: (0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$67bb6d10f6c9b72e$var$pageEntryPoint
    }));

});
parcelRegister("4WFif", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsSdconfigRoute", () => $94f70a6c79090d6d$export$846e5cd0d5151fde);
const $94f70a6c79090d6d$export$846e5cd0d5151fde = {
    name: 'global-settings-products-sdconfig',
    path: '/secure/admin/SDConfiguration.jspa'
};

});


parcelRegister("2tcJe", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsSdmailRouteEntry", () => $4afe829610ec0329$export$e296aae86525a621);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $lJFSh = parcelRequire("lJFSh");
const $4afe829610ec0329$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $4afe829610ec0329$export$e296aae86525a621 = (0, $g1GqA.createLegacyEntry)((0, $lJFSh.globalSettingsProductsSdmailRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: (0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$4afe829610ec0329$var$pageEntryPoint
    }));

});
parcelRegister("lJFSh", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsSdmailRoute", () => $6813cfd27738a76d$export$e35c6c6fbfbb5111);
const $6813cfd27738a76d$export$e35c6c6fbfbb5111 = {
    name: 'global-settings-products-sdmail',
    path: '/secure/admin/SDMailInfo.jspa'
};

});


parcelRegister("bFG83", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsSoftwareConfigRouteEntry", () => $acd06f680c98291f$export$3e9459c1e240d138);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $hab94 = parcelRequire("hab94");
const $acd06f680c98291f$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $acd06f680c98291f$export$3e9459c1e240d138 = (0, $g1GqA.createLegacyEntry)((0, $hab94.globalSettingsProductsSoftwareConfigRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $92d0e44258fe76a3$export$e8aa2912a0792727)
        },
        resources: (0, $dUAVJ.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$acd06f680c98291f$var$pageEntryPoint
    }));

});
parcelRegister("hab94", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProductsSoftwareConfigRoute", () => $9578f93d77035d31$export$5b270f25cf4ae11c);
const $9578f93d77035d31$export$5b270f25cf4ae11c = {
    name: 'global-settings-products-software-config',
    path: '/secure/SoftwareConfig.jspa',
    query: [
        'decorator=admin'
    ]
};

});


parcelRegister("5Mdex", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProjectsCategoriesDeleteRouteEntry", () => $7310f9446aa22aea$export$ecfb2cc5a7593980);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $1bkZ8 = parcelRequire("1bkZ8");
const $7310f9446aa22aea$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $7310f9446aa22aea$export$ecfb2cc5a7593980 = (0, $g1GqA.createLegacyEntry)((0, $1bkZ8.globalSettingsProjectsCategoriesDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $3be6781b85030612$export$e3e768cbcc0eeacd)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$7310f9446aa22aea$var$pageEntryPoint
    }));

});
const $3be6781b85030612$export$e3e768cbcc0eeacd = 'GLOBAL_PROJECTS_SETTINGS';

parcelRegister("1bkZ8", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProjectsCategoriesDeleteRoute", () => $5af6f0503c78aac8$export$f155c76657570a56);
const $5af6f0503c78aac8$export$f155c76657570a56 = {
    name: 'global-settings-projects-categories-delete',
    path: '/secure/admin/projectcategories/DeleteProjectCategory([!%]?[\\w]*).jspa'
};

});


parcelRegister("2O9uH", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProjectsCategoriesEditRouteEntry", () => $289e121b9fdd7b5b$export$8364dd961ae6c494);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $4V7xR = parcelRequire("4V7xR");
const $289e121b9fdd7b5b$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $289e121b9fdd7b5b$export$8364dd961ae6c494 = (0, $g1GqA.createLegacyEntry)((0, $4V7xR.globalSettingsProjectsCategoriesEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $3be6781b85030612$export$e3e768cbcc0eeacd)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$289e121b9fdd7b5b$var$pageEntryPoint
    }));

});
parcelRegister("4V7xR", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProjectsCategoriesEditRoute", () => $2416908bf04e919c$export$53d7a3e6e69ec873);
const $2416908bf04e919c$export$53d7a3e6e69ec873 = {
    name: 'global-settings-projects-categories-edit',
    path: '/secure/admin/projectcategories/EditProjectCategory([!%]?[\\w]*).jspa'
};

});


parcelRegister("11URR", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProjectsCategoriesViewRouteEntry", () => $b1ed6456e3964b04$export$f53b9ac05cdf2fe8);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $kUh7b = parcelRequire("kUh7b");
const $b1ed6456e3964b04$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $b1ed6456e3964b04$export$f53b9ac05cdf2fe8 = (0, $g1GqA.createLegacyEntry)((0, $kUh7b.globalSettingsProjectsCategoriesViewRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $3be6781b85030612$export$e3e768cbcc0eeacd)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$b1ed6456e3964b04$var$pageEntryPoint
    }));

});
parcelRegister("kUh7b", function(module, exports) {
$parcel$export(module.exports, "globalSettingsProjectsCategoriesViewRoute", () => $84dfeeda261e1570$export$17ada00b0bde9ebc);
const $84dfeeda261e1570$export$17ada00b0bde9ebc = {
    name: 'global-settings-projects-categories-view',
    path: '/secure/admin/projectcategories/ViewProjectCategories([!%]?[\\w]*).jspa'
};

});


parcelRegister("bFK7A", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemApplicationAdvancedRouteEntry", () => $cc0b6e734b39cd32$export$48579ce5caedb688);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $7Gzzy = parcelRequire("7Gzzy");
const $cc0b6e734b39cd32$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $cc0b6e734b39cd32$export$48579ce5caedb688 = (0, $g1GqA.createLegacyEntry)((0, $7Gzzy.globalSettingsSystemApplicationAdvancedRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$cc0b6e734b39cd32$var$pageEntryPoint
    }));

});
parcelRegister("7Gzzy", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemApplicationAdvancedRoute", () => $e9238fd290142213$export$e79dd086a8ca16b7);
const $e9238fd290142213$export$e79dd086a8ca16b7 = {
    name: 'global-settings-system-application-advanced',
    path: '/secure/admin/AdvancedApplicationProperties.jspa'
};

});


parcelRegister("2Au8F", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemApplicationEditRouteEntry", () => $fba73e8fcfd694d7$export$cb756194922d59f5);
/* eslint-disable import/order */ 

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $45Itd = parcelRequire("45Itd");

var $kczDS = parcelRequire("kczDS");
const $fba73e8fcfd694d7$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $fba73e8fcfd694d7$export$cb756194922d59f5 = (0, $g1GqA.createLegacyEntry)((0, $kczDS.globalSettingsSystemApplicationEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$fba73e8fcfd694d7$var$pageEntryPoint
    }));

});
parcelRegister("kczDS", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemApplicationEditRoute", () => $68eb8a4e6f3fb20c$export$3cfb7004aee9915c);
const $68eb8a4e6f3fb20c$export$3cfb7004aee9915c = {
    name: 'global-settings-system-application-edit',
    path: '/secure/admin/EditApplicationProperties([!%]?[\\w]*).jspa'
};

});


parcelRegister("d4mwq", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemApplicationViewRouteEntry", () => $2c1552a5c1ae18db$export$c97a0463677004d2);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $7o5yC = parcelRequire("7o5yC");
const $2c1552a5c1ae18db$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $2c1552a5c1ae18db$export$c97a0463677004d2 = (0, $g1GqA.createLegacyEntry)((0, $7o5yC.globalSettingsSystemApplicationViewRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$2c1552a5c1ae18db$var$pageEntryPoint
    }));

});
parcelRegister("7o5yC", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemApplicationViewRoute", () => $32dc46f39f0dae82$export$5ddf1dd9c57a9326);
const $32dc46f39f0dae82$export$5ddf1dd9c57a9326 = {
    name: 'global-settings-system-application-view',
    path: '/secure/admin/ViewApplicationProperties.jspa'
};

});


parcelRegister("jTFD9", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemAttachmentsRouteEntry", () => $708845117c534fb8$export$a692196c89a01817);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $1AMYN = parcelRequire("1AMYN");
const $708845117c534fb8$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $708845117c534fb8$export$a692196c89a01817 = (0, $g1GqA.createLegacyEntry)((0, $1AMYN.globalSettingsSystemAttachmentsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$708845117c534fb8$var$pageEntryPoint
    }));

});
parcelRegister("1AMYN", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemAttachmentsRoute", () => $476bbd43616b58d4$export$717d7ab74cb9ce91);
const $476bbd43616b58d4$export$717d7ab74cb9ce91 = {
    name: 'global-settings-system-attachments',
    path: '/secure/admin/ViewAttachmentSettings.jspa'
};

});


parcelRegister("9fUdF", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemAuditingRouteEntry", () => $d104c15faef3efdb$export$7484cb4db3cfbf3f);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $gwLun = parcelRequire("gwLun");
const $d104c15faef3efdb$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d104c15faef3efdb$export$7484cb4db3cfbf3f = (0, $g1GqA.createLegacyEntry)((0, $gwLun.globalSettingsSystemAuditingRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$d104c15faef3efdb$var$pageEntryPoint
    }));

});
parcelRegister("gwLun", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemAuditingRoute", () => $92f29d9f665bf6c9$export$b8241cf6a8335186);
const $92f29d9f665bf6c9$export$b8241cf6a8335186 = {
    name: 'global-settings-system-auditing',
    path: '/auditing/:page'
};

});


parcelRegister("cv4YG", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemCollectorsRouteEntry", () => $b18f29aecdb0c7aa$export$a46b2c4865857bde);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $aEURF = parcelRequire("aEURF");
const $b18f29aecdb0c7aa$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $b18f29aecdb0c7aa$export$a46b2c4865857bde = (0, $g1GqA.createLegacyEntry)((0, $aEURF.globalSettingsSystemCollectorsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$b18f29aecdb0c7aa$var$pageEntryPoint
    }));

});
parcelRegister("aEURF", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemCollectorsRoute", () => $d886e988eb1753a7$export$69ef22f1d54c39dc);
const $d886e988eb1753a7$export$69ef22f1d54c39dc = {
    name: 'global-settings-system-collectors',
    path: '/secure/admin/ViewGlobalCollectors([!%]?[\\w]*).jspa'
};

});


parcelRegister("8XBBM", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemDefaultSettingsRouteEntry", () => $1e8974a8723360b9$export$3ba7ed3247e0da7);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $kAaoR = parcelRequire("kAaoR");
const $1e8974a8723360b9$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $1e8974a8723360b9$export$3ba7ed3247e0da7 = (0, $g1GqA.createLegacyEntry)((0, $kAaoR.globalSettingsSystemDefaultSettingsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$1e8974a8723360b9$var$pageEntryPoint
    }));

});
parcelRegister("kAaoR", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemDefaultSettingsRoute", () => $8d5ae92fc1320fb5$export$d8f4254e5ee116aa);
const $8d5ae92fc1320fb5$export$d8f4254e5ee116aa = {
    name: 'global-settings-system-default-settings',
    path: '/secure/admin/ViewUserDefaultSettings([!%]?[\\w]*).jspa'
};

});


parcelRegister("8EnHk", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemEventsAddRouteEntry", () => $ff8e5551c58f406f$export$18dc7c450d001255);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $jmewx = parcelRequire("jmewx");
const $ff8e5551c58f406f$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $ff8e5551c58f406f$export$18dc7c450d001255 = (0, $g1GqA.createLegacyEntry)((0, $jmewx.globalSettingsSystemEventsAddRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        entryPoint: ()=>$ff8e5551c58f406f$var$pageEntryPoint
    }));

});
parcelRegister("jmewx", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemEventsAddRoute", () => $d9fdabca7f41c6e4$export$3bafc84a5f76a507);
const $d9fdabca7f41c6e4$export$3bafc84a5f76a507 = {
    name: 'global-settings-system-events-add',
    path: '/secure/admin/AddEventType.jspa'
};

});


parcelRegister("7RK2U", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemEventsDeleteRouteEntry", () => $fd4d512c40f65a2c$export$82ec56d45583ff5a);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $73Iku = parcelRequire("73Iku");
const $fd4d512c40f65a2c$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $fd4d512c40f65a2c$export$82ec56d45583ff5a = (0, $g1GqA.createLegacyEntry)((0, $73Iku.globalSettingsSystemEventsDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        entryPoint: ()=>$fd4d512c40f65a2c$var$pageEntryPoint
    }));

});
parcelRegister("73Iku", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemEventsDeleteRoute", () => $f3fa2fd0c5512a92$export$cf0c62e05603f7e1);
const $f3fa2fd0c5512a92$export$cf0c62e05603f7e1 = {
    name: 'global-settings-system-events-delete',
    path: '/secure/admin/DeleteEventType.jspa'
};

});


parcelRegister("55mKT", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemEventsEditRouteEntry", () => $30eb2a150de3e181$export$5700f7202370e9c4);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $esxWF = parcelRequire("esxWF");
const $30eb2a150de3e181$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $30eb2a150de3e181$export$5700f7202370e9c4 = (0, $g1GqA.createLegacyEntry)((0, $esxWF.globalSettingsSystemEventsEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        entryPoint: ()=>$30eb2a150de3e181$var$pageEntryPoint
    }));

});
parcelRegister("esxWF", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemEventsEditRoute", () => $70f5c671145aba70$export$9bf98baef9abe3eb);
const $70f5c671145aba70$export$9bf98baef9abe3eb = {
    name: 'global-settings-system-events-edit',
    path: '/secure/admin/EditEventType.jspa'
};

});


parcelRegister("2GqiU", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemEventsRouteEntry", () => $3a58ac2c032b938c$export$431e68e0ed553cca);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $bSroL = parcelRequire("bSroL");
const $3a58ac2c032b938c$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $3a58ac2c032b938c$export$431e68e0ed553cca = (0, $g1GqA.createLegacyEntry)((0, $bSroL.globalSettingsSystemEventsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$3a58ac2c032b938c$var$pageEntryPoint
    }));

});
parcelRegister("bSroL", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemEventsRoute", () => $9e9fd23a894b7d5c$export$c294ba50eb736e7b);
const $9e9fd23a894b7d5c$export$c294ba50eb736e7b = {
    name: 'global-settings-system-events',
    path: '/secure/admin/ListEventTypes.jspa'
};

});


parcelRegister("e6oMB", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemExportRouteEntry", () => $ddc0b3a11c8cf83b$export$78effb39671690ca);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $edMUQ = parcelRequire("edMUQ");
const $ddc0b3a11c8cf83b$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $ddc0b3a11c8cf83b$export$78effb39671690ca = (0, $g1GqA.createLegacyEntry)((0, $edMUQ.globalSettingsSystemExportRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$ddc0b3a11c8cf83b$var$pageEntryPoint
    }));

});
parcelRegister("edMUQ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemExportRoute", () => $9d56a2d0a39f71f8$export$e398684ea718a2e7);
const $9d56a2d0a39f71f8$export$e398684ea718a2e7 = {
    name: 'global-settings-system-export',
    path: '/secure/admin/CloudExport.jspa'
};

});


parcelRegister("eG5Le", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemGlobalPermissionsRouteEntry", () => $b7e55ed4312ef61e$export$ebb311f9ff3b5efb);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $7xRgo = parcelRequire("7xRgo");
const $b7e55ed4312ef61e$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $b7e55ed4312ef61e$export$ebb311f9ff3b5efb = (0, $g1GqA.createLegacyEntry)((0, $7xRgo.globalSettingsSystemGlobalPermissionsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        entryPoint: ()=>$b7e55ed4312ef61e$var$pageEntryPoint
    }));

});
parcelRegister("7xRgo", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemGlobalPermissionsRoute", () => $8515247f32d090e4$export$38ac3717b046eb26);
const $8515247f32d090e4$export$38ac3717b046eb26 = {
    name: 'global-settings-system-global-permissions',
    path: '/secure/admin/jira/GlobalPermissions!default.jspa'
};

});


parcelRegister("dYuJK", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemHelperNotificationRouteEntry", () => $69cebfead1fca905$export$e2befb3c6371d2f2);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $k9ptT = parcelRequire("k9ptT");
const $69cebfead1fca905$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $69cebfead1fca905$export$e2befb3c6371d2f2 = (0, $g1GqA.createLegacyEntry)((0, $k9ptT.globalSettingsSystemHelperNotificationRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$69cebfead1fca905$var$pageEntryPoint
    }));

});
parcelRegister("k9ptT", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemHelperNotificationRoute", () => $23fcc81e64693672$export$7dab38c28c574395);
const $23fcc81e64693672$export$7dab38c28c574395 = {
    name: 'global-settings-system-helper-notification',
    path: '/secure/admin/NotificationHelperAdmin.jspa'
};

});


parcelRegister("aaX32", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemHelperPermissionRouteEntry", () => $fa3b6f637369b483$export$b7f8ebfe77163756);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $cT55c = parcelRequire("cT55c");
const $fa3b6f637369b483$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $fa3b6f637369b483$export$b7f8ebfe77163756 = (0, $g1GqA.createLegacyEntry)((0, $cT55c.globalSettingsSystemHelperPermissionRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$fa3b6f637369b483$var$pageEntryPoint
    }));

});
parcelRegister("cT55c", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemHelperPermissionRoute", () => $9a8b690ce909bb62$export$5c1770f1a1797fa5);
const $9a8b690ce909bb62$export$5c1770f1a1797fa5 = {
    name: 'global-settings-system-helper-permission',
    path: '/secure/admin/PermissionHelperAdmin.jspa'
};

});


parcelRegister("gdNuu", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportBulkRouteEntry", () => $70979c61473f7fd6$export$dd20078389577d29);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $1Q6Dj = parcelRequire("1Q6Dj");
const $70979c61473f7fd6$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $70979c61473f7fd6$export$dd20078389577d29 = (0, $g1GqA.createLegacyEntry)((0, $1Q6Dj.globalSettingsSystemImportBulkRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$70979c61473f7fd6$var$pageEntryPoint
    }));

});
parcelRegister("1Q6Dj", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportBulkRoute", () => $be58a5e9757cdfb0$export$9de82cbc931fb7d0);
const $be58a5e9757cdfb0$export$9de82cbc931fb7d0 = {
    name: 'global-settings-system-import-bulk',
    path: '/secure/admin/BulkCreate(\\w+)([!%]?[\\w]*).jspa'
};

});


parcelRegister("8Kxny", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportCloudRouteEntry", () => $fc79932ba0d5585a$export$9d598c957e5bddde);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $2CTqn = parcelRequire("2CTqn");
const $fc79932ba0d5585a$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $fc79932ba0d5585a$export$9d598c957e5bddde = (0, $g1GqA.createLegacyEntry)((0, $2CTqn.globalSettingsSystemImportCloudRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$fc79932ba0d5585a$var$pageEntryPoint
    }));

});
parcelRegister("2CTqn", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportCloudRoute", () => $0b7ba3c141271b2e$export$9953342c4b995f8);
const $0b7ba3c141271b2e$export$9953342c4b995f8 = {
    name: 'global-settings-system-import-cloud',
    path: '/secure/admin/CloudImport([!%]?[\\w]*).jspa'
};

});


parcelRegister("aPF7E", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportCsvRouteEntry", () => $7094b2d355ec8d97$export$9e23dd51b331426c);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $UFF90 = parcelRequire("UFF90");
const $7094b2d355ec8d97$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $7094b2d355ec8d97$export$9e23dd51b331426c = (0, $g1GqA.createLegacyEntry)((0, $UFF90.globalSettingsSystemImportCsvRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$7094b2d355ec8d97$var$pageEntryPoint
    }));

});
parcelRegister("UFF90", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportCsvRoute", () => $031551c60c7c11dc$export$49f0cc3d88107d6b);
const $031551c60c7c11dc$export$49f0cc3d88107d6b = {
    name: 'global-settings-system-import-csv',
    path: '/(secure|secure/admin)/Csv(\\w+)Page([!%]?[\\w]*).jspa'
};

});


parcelRegister("fMd2L", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportExternalRouteEntry", () => $ed52a7f528f2c415$export$bf4a85badc8c82c9);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $6Xyuf = parcelRequire("6Xyuf");
const $ed52a7f528f2c415$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $ed52a7f528f2c415$export$bf4a85badc8c82c9 = (0, $g1GqA.createLegacyEntry)((0, $6Xyuf.globalSettingsSystemImportExternalRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ed52a7f528f2c415$var$pageEntryPoint
    }));

});
parcelRegister("6Xyuf", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportExternalRoute", () => $665b863837b98412$export$afcc884cbc873f9f);
const $665b863837b98412$export$afcc884cbc873f9f = {
    name: 'global-settings-system-import-external',
    path: '/secure/admin/ExternalImport1.jspa'
};

});


parcelRegister("lMDYc", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportExternalPagesRouteEntry", () => $1594a23aa33a69a4$export$7ca884816be2470a);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $fiaDV = parcelRequire("fiaDV");
const $1594a23aa33a69a4$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $1594a23aa33a69a4$export$7ca884816be2470a = (0, $g1GqA.createLegacyEntry)((0, $fiaDV.globalSettingsSystemImportExternalPagesRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$1594a23aa33a69a4$var$pageEntryPoint
    }));

});
parcelRegister("fiaDV", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportExternalPagesRoute", () => $27247d3238ff1302$export$dffab00ceab69eb2);
const $27247d3238ff1302$export$dffab00ceab69eb2 = {
    name: 'global-settings-system-import-external-pages',
    path: '/secure/admin/Importer(\\w+)Page([!%]?[\\w]*).jspa'
};

});


parcelRegister("i2zMv", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportJsonRouteEntry", () => $67fb9389e02f0126$export$fbac3139112fe654);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $6zev5 = parcelRequire("6zev5");
const $67fb9389e02f0126$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $67fb9389e02f0126$export$fbac3139112fe654 = (0, $g1GqA.createLegacyEntry)((0, $6zev5.globalSettingsSystemImportJsonRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$67fb9389e02f0126$var$pageEntryPoint
    }));

});
parcelRegister("6zev5", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportJsonRoute", () => $ac84efe1aae5e488$export$169bd8bcabed089d);
const $ac84efe1aae5e488$export$169bd8bcabed089d = {
    name: 'global-settings-system-import-json',
    path: '/secure/admin/Json(\\w+)Page([!%]?[\\w]*).jspa'
};

});


parcelRegister("aRQu2", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportTrelloRouteEntry", () => $771ee563d47eeffb$export$19f57ac143eecd95);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $6t9Nf = parcelRequire("6t9Nf");
const $771ee563d47eeffb$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $771ee563d47eeffb$export$19f57ac143eecd95 = (0, $g1GqA.createLegacyEntry)((0, $6t9Nf.globalSettingsSystemImportTrelloRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$771ee563d47eeffb$var$pageEntryPoint
    }));

});
parcelRegister("6t9Nf", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemImportTrelloRoute", () => $328f2c9499eab639$export$b6753e755954098b);
const $328f2c9499eab639$export$b6753e755954098b = {
    name: 'global-settings-system-import-trello',
    path: '/secure/admin/Trello(\\w+)Page([!%]?[\\w]*).jspa'
};

});


parcelRegister("iYaRr", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemLexorankRouteEntry", () => $fe31ed4d21a9cc54$export$5163204c27a4b60f);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $2HSXH = parcelRequire("2HSXH");
const $fe31ed4d21a9cc54$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $fe31ed4d21a9cc54$export$5163204c27a4b60f = (0, $g1GqA.createLegacyEntry)((0, $2HSXH.globalSettingsSystemLexorankRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$fe31ed4d21a9cc54$var$pageEntryPoint
    }));

});
parcelRegister("2HSXH", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemLexorankRoute", () => $79fbf5daea1e91a2$export$d4ce3155385fd8cf);
const $79fbf5daea1e91a2$export$d4ce3155385fd8cf = {
    name: 'global-settings-system-lexorank',
    path: '/secure/GHLexoRankManage.jspa',
    query: [
        'decorator=admin'
    ]
};

});


parcelRegister("laFWx", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemLookRouteEntry", () => $8db70e51fb0926e4$export$bf366af006cda74e);


var $iSoIx = parcelRequire("iSoIx");

var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $jfuMA = parcelRequire("jfuMA");

var $2700E = parcelRequire("2700E");
const $8db70e51fb0926e4$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $8db70e51fb0926e4$export$bf366af006cda74e = (0, $g1GqA.createLegacyEntry)((0, $jfuMA.globalSettingsSystemLookRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>(0, $2700E.expValEquals)('migrate_look_and_feel_page', 'isEnabled', true, false) ? (0, $iSoIx.notFoundPageEntrypoint) : $8db70e51fb0926e4$var$pageEntryPoint
    }));

});
parcelRegister("iSoIx", function(module, exports) {
$parcel$export(module.exports, "notFoundPageEntrypoint", () => $bf9d31cbc4b999a0$export$eb748b014da0ac9a);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4lWtN = parcelRequire("4lWtN");

var $dTa0V = parcelRequire("dTa0V");
const $bf9d31cbc4b999a0$export$eb748b014da0ac9a = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $4lWtN.notFoundEntrypoint)
});

});
parcelRegister("4lWtN", function(module, exports) {
$parcel$export(module.exports, "notFoundEntrypoint", () => $87bcdebf6bebb970$export$7fdee4826a30b643);

var $b3tU7 = parcelRequire("b3tU7");

var $fiVog = parcelRequire("fiVog");

const $87bcdebf6bebb970$export$7fdee4826a30b643 = (0, $fiVog.createEntryPoint)({
    root: (0, $b3tU7.JSResourceForUserVisible)(()=>(parcelRequire("eFaFV")), {
        moduleId: "65f95f24",
        moduleName: "notFoundRelayRoot",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eFaFV", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("iZe2c"),
    $4cvLQ("dM3Dq")
]).then(()=>parcelRequire('hNz2l'));

});



parcelRegister("jfuMA", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemLookRoute", () => $ca11d96d205f5080$export$61f7b12ec2ac6aa1);
const $ca11d96d205f5080$export$61f7b12ec2ac6aa1 = {
    name: 'global-settings-system-look',
    path: '/secure/admin/LookAndFeel!default.jspa'
};

});


parcelRegister("duH5l", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailAddRouteEntry", () => $fb91ca57f17dcf0e$export$c48daf66fa2bb3e);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $9YekZ = parcelRequire("9YekZ");
const $fb91ca57f17dcf0e$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $fb91ca57f17dcf0e$export$c48daf66fa2bb3e = (0, $g1GqA.createLegacyEntry)((0, $9YekZ.globalSettingsSystemMailAddRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$fb91ca57f17dcf0e$var$pageEntryPoint
    }));

});
parcelRegister("9YekZ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailAddRoute", () => $9ca9c0f2d21b1a21$export$2874a3735d7cb330);
const $9ca9c0f2d21b1a21$export$2874a3735d7cb330 = {
    name: 'global-settings-system-mail-add',
    path: '/secure/admin/(Add|Update)PopMailServer!default.jspa'
};

});


parcelRegister("2ukJV", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailDeleteMailHandlerRouteEntry", () => $830ed007f8ec707e$export$a14468794f1b5c83);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $3JEpt = parcelRequire("3JEpt");
const $830ed007f8ec707e$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $830ed007f8ec707e$export$a14468794f1b5c83 = (0, $g1GqA.createLegacyEntry)((0, $3JEpt.globalSettingsSystemMailDeleteMailHandlerRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        entryPoint: ()=>$830ed007f8ec707e$var$pageEntryPoint
    }));

});
parcelRegister("3JEpt", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailDeleteMailHandlerRoute", () => $d0fbfb06db8cb9f8$export$140403398c884f90);
const $d0fbfb06db8cb9f8$export$140403398c884f90 = {
    name: 'global-settings-system-delete-mail-handler',
    path: '/secure/admin/DeleteMailHandler.jspa'
};

});


parcelRegister("gaJih", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailIncomingRouteEntry", () => $5d592a1f04765cc7$export$3ae66df5766592ef);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $dqQGF = parcelRequire("dqQGF");
const $5d592a1f04765cc7$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $5d592a1f04765cc7$export$3ae66df5766592ef = (0, $g1GqA.createLegacyEntry)((0, $dqQGF.globalSettingsSystemMailIncomingRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$5d592a1f04765cc7$var$pageEntryPoint
    }));

});
parcelRegister("dqQGF", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailIncomingRoute", () => $462d4a85a3c7bc29$export$90c9c127e433d888);
const $462d4a85a3c7bc29$export$90c9c127e433d888 = {
    name: 'global-settings-system-mail-incoming',
    path: '/secure/admin/IncomingMailServers.jspa'
};

});


parcelRegister("kLjoD", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailOutgoingRouteEntry", () => $2dcba39338f0a7a2$export$cb267b8986031cb7);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $cJK7l = parcelRequire("cJK7l");
const $2dcba39338f0a7a2$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $2dcba39338f0a7a2$export$cb267b8986031cb7 = (0, $g1GqA.createLegacyEntry)((0, $cJK7l.globalSettingsSystemMailOutgoingRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$2dcba39338f0a7a2$var$pageEntryPoint
    }));

});
parcelRegister("cJK7l", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailOutgoingRoute", () => $5be77f1118c3bffd$export$6da120a8b84a7872);
const $5be77f1118c3bffd$export$6da120a8b84a7872 = {
    name: 'global-settings-system-mail-outgoing',
    path: '/secure/admin/OutgoingMailServers.jspa'
};

});


parcelRegister("cUhcT", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailSendRouteEntry", () => $172a4c2c3750f8fe$export$bff9c3c6b0aba389);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $abFxd = parcelRequire("abFxd");
const $172a4c2c3750f8fe$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $172a4c2c3750f8fe$export$bff9c3c6b0aba389 = (0, $g1GqA.createLegacyEntry)((0, $abFxd.globalSettingsSystemMailSendRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$172a4c2c3750f8fe$var$pageEntryPoint
    }));

});
parcelRegister("abFxd", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailSendRoute", () => $309a1afe34089122$export$a2ae5fa2accd6e5f);
const $309a1afe34089122$export$a2ae5fa2accd6e5f = {
    name: 'global-settings-system-mail-send',
    path: '/secure/admin/SendBulkMail!default.jspa'
};

});


parcelRegister("4tNmK", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailSettingsRouteEntry", () => $dda116490a848654$export$3c0d52a24b499e7c);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $fVW1Z = parcelRequire("fVW1Z");
const $dda116490a848654$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $dda116490a848654$export$3c0d52a24b499e7c = (0, $g1GqA.createLegacyEntry)((0, $fVW1Z.globalSettingsSystemMailSettingsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$dda116490a848654$var$pageEntryPoint
    }));

});
parcelRegister("fVW1Z", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailSettingsRoute", () => $c484baa19aa7f95a$export$8423ad7a1177552);
const $c484baa19aa7f95a$export$8423ad7a1177552 = {
    name: 'global-settings-system-mail-settings',
    path: '/secure/admin/GlobalMailSettings([!%]?[\\w]*).jspa'
};

});


parcelRegister("h8xRL", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailVerifyRouteEntry", () => $777d2a1218805a26$export$2fd491752a9501a2);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $aXMIv = parcelRequire("aXMIv");
const $777d2a1218805a26$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $777d2a1218805a26$export$2fd491752a9501a2 = (0, $g1GqA.createLegacyEntry)((0, $aXMIv.globalSettingsSystemMailVerifyRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$777d2a1218805a26$var$pageEntryPoint
    }));

});
parcelRegister("aXMIv", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemMailVerifyRoute", () => $12ea4c9091313cf4$export$51b4ff8214b9fd7f);
const $12ea4c9091313cf4$export$51b4ff8214b9fd7f = {
    name: 'global-settings-system-mail-verify',
    path: '/secure/admin/VerifyPopServerConnection([!%]?[\\w]*).jspa'
};

});


parcelRegister("1ucf9", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemPermissionsRouteEntry", () => $fb6ada6581650ee2$export$9fe6a3bc70d75bae);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $b3LOM = parcelRequire("b3LOM");
const $fb6ada6581650ee2$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $fb6ada6581650ee2$export$9fe6a3bc70d75bae = (0, $g1GqA.createLegacyEntry)((0, $b3LOM.globalSettingsSystemPermissionsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$fb6ada6581650ee2$var$pageEntryPoint
    }));

});
parcelRegister("b3LOM", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemPermissionsRoute", () => $98fce39e3b27c895$export$1382458fd6826787);
const $98fce39e3b27c895$export$1382458fd6826787 = {
    name: 'global-settings-system-permissions',
    path: '/secure/admin/GlobalPermissions([!%]?[\\w]*).jspa'
};

});


parcelRegister("eARLQ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemProjectAssignSecurityRouteEntry", () => $a095efd844e2a943$export$b78eddbedd30951d);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $d7ZpK = parcelRequire("d7ZpK");
const $a095efd844e2a943$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $a095efd844e2a943$export$b78eddbedd30951d = (0, $g1GqA.createLegacyEntry)((0, $d7ZpK.globalSettingsSystemProjectAssignSecurityRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$a095efd844e2a943$var$pageEntryPoint
    }));

});
parcelRegister("d7ZpK", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemProjectAssignSecurityRoute", () => $d6d2fe8fb1a4e86e$export$f53750f3a4fc2fde);
const $d6d2fe8fb1a4e86e$export$f53750f3a4fc2fde = {
    name: 'global-settings-system-project-assign-security',
    path: '/secure/project/AssignIssueSecuritySchemeProgress.jspa'
};

});


parcelRegister("YOorc", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemProjectDeleteRouteEntry", () => $54cd350989d04534$export$849f3666529d049e);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $eYUmg = parcelRequire("eYUmg");
const $54cd350989d04534$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $54cd350989d04534$export$849f3666529d049e = (0, $g1GqA.createLegacyEntry)((0, $eYUmg.globalSettingsSystemProjectDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$54cd350989d04534$var$pageEntryPoint
    }));

});
parcelRegister("eYUmg", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemProjectDeleteRoute", () => $89a79f108727cafb$export$f31d8748a56aa638);
const $89a79f108727cafb$export$f31d8748a56aa638 = {
    name: 'global-settings-system-project-delete',
    path: '/secure/project/DeleteProject.jspa'
};

});


parcelRegister("adSUz", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemProjectSelectRouteEntry", () => $74fb22e7268c3e8b$export$a1869de90837dac8);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $3EJuv = parcelRequire("3EJuv");
const $74fb22e7268c3e8b$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $74fb22e7268c3e8b$export$a1869de90837dac8 = (0, $g1GqA.createLegacyEntry)((0, $3EJuv.globalSettingsSystemProjectSelectRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$74fb22e7268c3e8b$var$pageEntryPoint
    }));

});
parcelRegister("3EJuv", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemProjectSelectRoute", () => $9098276c46f16752$export$8f44b9e5553dccec);
const $9098276c46f16752$export$8f44b9e5553dccec = {
    name: 'global-settings-system-project-select',
    path: '/secure/project/SelectProject(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("fvZgQ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesActorsRouteEntry", () => $f8d6aec5d1d0d76e$export$7dc567ad40905890);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $62QGe = parcelRequire("62QGe");
const $f8d6aec5d1d0d76e$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $f8d6aec5d1d0d76e$export$7dc567ad40905890 = (0, $g1GqA.createLegacyEntry)((0, $62QGe.globalSettingsSystemRolesActorsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$f8d6aec5d1d0d76e$var$pageEntryPoint
    }));

});
parcelRegister("62QGe", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesActorsRoute", () => $4d5510937cfce6c2$export$3dca5fcf3b98db1e);
const $4d5510937cfce6c2$export$3dca5fcf3b98db1e = {
    name: 'global-settings-system-roles-actors',
    path: '/secure/project/ViewDefaultProjectRoleActors([!%]?[\\w]*).jspa'
};

});


parcelRegister("7jqZS", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesActorsGroupsRouteEntry", () => $81fb95f773dc0a2f$export$ac1028baf6d1bd60);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $6Io3u = parcelRequire("6Io3u");
const $81fb95f773dc0a2f$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $81fb95f773dc0a2f$export$ac1028baf6d1bd60 = (0, $g1GqA.createLegacyEntry)((0, $6Io3u.globalSettingsSystemRolesActorsGroupsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        entryPoint: ()=>$81fb95f773dc0a2f$var$pageEntryPoint
    }));

});
parcelRegister("6Io3u", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesActorsGroupsRoute", () => $d721de2c41d8a169$export$836f3cdea3e238a4);
const $d721de2c41d8a169$export$836f3cdea3e238a4 = {
    name: 'global-settings-system-roles-actors-groups',
    path: '/secure/project/GroupRoleActorAction.jspa'
};

});


parcelRegister("8s72u", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesActorsUsersRouteEntry", () => $362743dae8176ccd$export$3186176f09045f35);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $1qLQf = parcelRequire("1qLQf");
const $362743dae8176ccd$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $362743dae8176ccd$export$3186176f09045f35 = (0, $g1GqA.createLegacyEntry)((0, $1qLQf.globalSettingsSystemRolesActorsUsersRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        entryPoint: ()=>$362743dae8176ccd$var$pageEntryPoint
    }));

});
parcelRegister("1qLQf", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesActorsUsersRoute", () => $7c725610757261d3$export$119e823548eefd4f);
const $7c725610757261d3$export$119e823548eefd4f = {
    name: 'global-settings-system-roles-actors-users',
    path: '/secure/project/UserRoleActorAction.jspa'
};

});


parcelRegister("ubzD2", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesDeleteRouteEntry", () => $94766a68694c184f$export$4f2756ef0230f213);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $jK59j = parcelRequire("jK59j");
const $94766a68694c184f$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $94766a68694c184f$export$4f2756ef0230f213 = (0, $g1GqA.createLegacyEntry)((0, $jK59j.globalSettingsSystemRolesDeleteRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$94766a68694c184f$var$pageEntryPoint
    }));

});
parcelRegister("jK59j", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesDeleteRoute", () => $02e42171d4553949$export$c4b2dba31a4a29c8);
const $02e42171d4553949$export$c4b2dba31a4a29c8 = {
    name: 'global-settings-system-roles-delete',
    path: '/secure/project/DeleteProjectRole([!%]?[\\w]*).jspa'
};

});


parcelRegister("db4nQ", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesEditRouteEntry", () => $5e9901357cd9954c$export$18cfabcb0c0c21e5);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $7ulIl = parcelRequire("7ulIl");
const $5e9901357cd9954c$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $5e9901357cd9954c$export$18cfabcb0c0c21e5 = (0, $g1GqA.createLegacyEntry)((0, $7ulIl.globalSettingsSystemRolesEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$5e9901357cd9954c$var$pageEntryPoint
    }));

});
parcelRegister("7ulIl", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesEditRoute", () => $df93a301a7b4772b$export$88917fe447558e55);
const $df93a301a7b4772b$export$88917fe447558e55 = {
    name: 'global-settings-system-roles-edit',
    path: '/secure/project/EditProjectRole([!%]?[\\w]*).jspa'
};

});


parcelRegister("fF15b", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesUsageRouteEntry", () => $27e8e9cb68e93cea$export$d9f7c60572f36835);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $j64Gm = parcelRequire("j64Gm");
const $27e8e9cb68e93cea$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $27e8e9cb68e93cea$export$d9f7c60572f36835 = (0, $g1GqA.createLegacyEntry)((0, $j64Gm.globalSettingsSystemRolesUsageRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$27e8e9cb68e93cea$var$pageEntryPoint
    }));

});
parcelRegister("j64Gm", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesUsageRoute", () => $47a0e6f930444e3e$export$91305e5cb99eb005);
const $47a0e6f930444e3e$export$91305e5cb99eb005 = {
    name: 'global-settings-system-roles-usage',
    path: '/secure/project/ViewProjectRoleUsage([!%]?[\\w]*).jspa'
};

});


parcelRegister("3QYIv", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesViewRouteEntry", () => $a92aaef5dcbe28f4$export$47efc3b9a4cedfba);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $fhLKv = parcelRequire("fhLKv");
const $a92aaef5dcbe28f4$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $a92aaef5dcbe28f4$export$47efc3b9a4cedfba = (0, $g1GqA.createLegacyEntry)((0, $fhLKv.globalSettingsSystemRolesViewRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$a92aaef5dcbe28f4$var$pageEntryPoint
    }));

});
parcelRegister("fhLKv", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemRolesViewRoute", () => $5d80c216cff8b5f9$export$81d6a9112f47a229);
const $5d80c216cff8b5f9$export$81d6a9112f47a229 = {
    name: 'global-settings-system-roles-view',
    path: '/secure/project/ViewProjectRoles([!%]?[\\w]*).jspa'
};

});


parcelRegister("9uPfN", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemServicesRouteEntry", () => $4244de7791222454$export$f08661656eef7ad1);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $5jhX0 = parcelRequire("5jhX0");
const $4244de7791222454$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $4244de7791222454$export$f08661656eef7ad1 = (0, $g1GqA.createLegacyEntry)((0, $5jhX0.globalSettingsSystemServicesRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$4244de7791222454$var$pageEntryPoint
    }));

});
parcelRegister("5jhX0", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemServicesRoute", () => $7c7d138d07a4a97c$export$a176af71f8d6d872);
const $7c7d138d07a4a97c$export$a176af71f8d6d872 = {
    name: 'global-settings-system-services',
    path: '/secure/admin/ViewServices!default.jspa'
};

});


parcelRegister("45iTN", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemSharedDashboardsRouteEntry", () => $3001d08bcd4294e0$export$48cce4d971c37598);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $l08D3 = parcelRequire("l08D3");
const $3001d08bcd4294e0$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $3001d08bcd4294e0$export$48cce4d971c37598 = (0, $g1GqA.createLegacyEntry)((0, $l08D3.globalSettingsSystemSharedDashboardsRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$3001d08bcd4294e0$var$pageEntryPoint
    }));

});
parcelRegister("l08D3", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemSharedDashboardsRoute", () => $40fcff541326164c$export$64739c332d5146ba);
const $40fcff541326164c$export$64739c332d5146ba = {
    name: 'global-settings-system-shared-dashboards',
    path: '/secure/admin/dashboards/ViewSharedDashboards.jspa'
};

});


parcelRegister("JzqF5", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemSharedFiltersRouteEntry", () => $538087fe5d0c31e2$export$6777672075f7d618);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $jiRZl = parcelRequire("jiRZl");
const $538087fe5d0c31e2$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $538087fe5d0c31e2$export$6777672075f7d618 = (0, $g1GqA.createLegacyEntry)((0, $jiRZl.globalSettingsSystemSharedFiltersRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$538087fe5d0c31e2$var$pageEntryPoint
    }));

});
parcelRegister("jiRZl", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemSharedFiltersRoute", () => $77ba1e9745a404a3$export$684d93e5438fcd69);
const $77ba1e9745a404a3$export$684d93e5438fcd69 = {
    name: 'global-settings-system-shared-filters',
    path: '/secure/admin/filters/ViewSharedFilters.jspa'
};

});


parcelRegister("94CbD", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemUserInterfaceDashboardEditRouteEntry", () => $218e3fdb3714f8ba$export$dbe314c372e965d4);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $5WrEP = parcelRequire("5WrEP");
const $218e3fdb3714f8ba$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $218e3fdb3714f8ba$export$dbe314c372e965d4 = (0, $g1GqA.createLegacyEntry)((0, $5WrEP.globalSettingsSystemUserInterfaceDashboardEditRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        entryPoint: ()=>$218e3fdb3714f8ba$var$pageEntryPoint
    }));

});
parcelRegister("5WrEP", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemUserInterfaceDashboardEditRoute", () => $6d1122e7d031c37d$export$78c9a0475c2f9cd0);
const $6d1122e7d031c37d$export$78c9a0475c2f9cd0 = {
    name: 'global-settings-system-ui-dashboard-edit',
    path: '/secure/admin/jira/EditApplicationProperties!default.jspa'
};

});


parcelRegister("6bddx", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemUserInterfacePreferencesRouteEntry", () => $ad4a51dd17e1538c$export$7025983c5e996386);


var $45Itd = parcelRequire("45Itd");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $1We8X = parcelRequire("1We8X");
const $ad4a51dd17e1538c$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $ad4a51dd17e1538c$export$7025983c5e996386 = (0, $g1GqA.createLegacyEntry)((0, $1We8X.globalSettingsSystemUserInterfacePreferencesRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        entryPoint: ()=>$ad4a51dd17e1538c$var$pageEntryPoint
    }));

});
parcelRegister("1We8X", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemUserInterfacePreferencesRoute", () => $9a98ab6634f38f91$export$6f46032e4fc13ea0);
const $9a98ab6634f38f91$export$6f46032e4fc13ea0 = {
    name: 'global-settings-system-ui-default-user-preferences-apply',
    path: '/secure/admin/SetGlobalEmailPreference!default.jspa'
};

});


parcelRegister("j8wld", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemWebhooksRouteEntry", () => $d54f701b47278166$export$aff2563c719af2aa);


var $45Itd = parcelRequire("45Itd");

var $35eqr = parcelRequire("35eqr");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $ju22D = parcelRequire("ju22D");

var $g1GqA = parcelRequire("g1GqA");

var $cnF6T = parcelRequire("cnF6T");
const $d54f701b47278166$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d54f701b47278166$export$aff2563c719af2aa = (0, $g1GqA.createLegacyEntry)((0, $cnF6T.globalSettingsSystemWebhooksRoute), ()=>({
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $1b7637cabf39cd90$export$e03d9e7e646baacb)
        },
        resources: [
            (0, $45Itd.navigationSidebarGlobalResource),
            (0, $35eqr.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$d54f701b47278166$var$pageEntryPoint
    }));

});
parcelRegister("cnF6T", function(module, exports) {
$parcel$export(module.exports, "globalSettingsSystemWebhooksRoute", () => $ee449146aaf8d27b$export$2c20f3aef4ea16aa);
const $ee449146aaf8d27b$export$2c20f3aef4ea16aa = {
    name: 'global-settings-system-webhooks',
    path: '/plugins/servlet/webhooks'
};

});


parcelRegister("2FaMe", function(module, exports) {
$parcel$export(module.exports, "legacyIssueRouteEntry", () => $a6f13e5a85575656$export$e8ba55056b4fde20);


var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $cpnl1 = parcelRequire("cpnl1");

var $hWEkS = parcelRequire("hWEkS");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $eENns = parcelRequire("eENns");

var $98e40 = parcelRequire("98e40");
const $a6f13e5a85575656$export$e8ba55056b4fde20 = (0, $g1GqA.createLegacyEntry)((0, $eENns.legacyIssueRoute), ()=>({
        group: 'legacy',
        layout: (0, $dvtoW.genericProjectLayout),
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $98e40.LegacyIssueView),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $cpnl1.queuesNavigationItems),
            (0, $6RSCO.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("eENns", function(module, exports) {
$parcel$export(module.exports, "legacyIssueRoute", () => $4eec6ac1c0e58a0a$export$71da6fcc13745fba);
const $4eec6ac1c0e58a0a$export$71da6fcc13745fba = {
    name: 'legacy-issue',
    path: '/browse/:issueKey(\\w+-\\d+)(.*)',
    query: [
        'jql!=(.+)',
        'filter!=(.+)'
    ]
};

});

parcelRegister("98e40", function(module, exports) {
$parcel$export(module.exports, "LegacyIssueView", () => $dc481194ff5d5148$export$34dc6596952b042c);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $jgKgn = parcelRequire("jgKgn");
const $dc481194ff5d5148$export$34dc6596952b042c = (props)=>{
    const { route: route } = props;
    if (!route) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jgKgn.LegacyPage), props));
};
$dc481194ff5d5148$export$34dc6596952b042c.displayName = "LegacyIssueView";

});


parcelRegister("k1iFS", function(module, exports) {
$parcel$export(module.exports, "legacyJsdCustomersRouteEntry", () => $04bc84529f56220b$export$f458747db287136e);


var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $esAdo = parcelRequire("esAdo");

var $74h93 = parcelRequire("74h93");
const $04bc84529f56220b$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $04bc84529f56220b$export$f458747db287136e = (0, $g1GqA.createLegacyEntry)((0, $esAdo.legacyJsdCustomersRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$04bc84529f56220b$var$pageEntryPoint
    }));

});
parcelRegister("esAdo", function(module, exports) {
$parcel$export(module.exports, "legacyJsdCustomersRoute", () => $9d568410c11a059f$export$3af39e70a286821c);
const $9d568410c11a059f$export$3af39e70a286821c = {
    name: 'legacy-jsd-customers',
    path: '/projects/:projectKey/customers'
};

});


parcelRegister("61E30", function(module, exports) {
$parcel$export(module.exports, "legacyJsdGettingStartedRouteEntry", () => $f7baa50b74f51693$export$3c4b4abb062b10e3);


var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $gab70 = parcelRequire("gab70");

var $74h93 = parcelRequire("74h93");
const $f7baa50b74f51693$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $f7baa50b74f51693$export$3c4b4abb062b10e3 = (0, $g1GqA.createLegacyEntry)((0, $gab70.legacyJsdGettingStartedRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$f7baa50b74f51693$var$pageEntryPoint
    }));

});
parcelRegister("gab70", function(module, exports) {
$parcel$export(module.exports, "legacyJsdGettingStartedRoute", () => $74821e825a279c55$export$71b946ee427d710);
const $74821e825a279c55$export$71b946ee427d710 = {
    name: 'legacy-jsd-getting-started',
    path: '/projects/:projectKey/getting-started'
};

});


parcelRegister("hs0xZ", function(module, exports) {
$parcel$export(module.exports, "legacyJsdJiraAutomationRouteEntry", () => $810971f9d7c562d5$export$d2d1cb3e56d9ba93);


var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $9IBBv = parcelRequire("9IBBv");

var $74h93 = parcelRequire("74h93");
const $810971f9d7c562d5$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $810971f9d7c562d5$export$d2d1cb3e56d9ba93 = (0, $g1GqA.createLegacyEntry)((0, $9IBBv.legacyJsdJiraAutomationRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$810971f9d7c562d5$var$pageEntryPoint
    }));

});
parcelRegister("9IBBv", function(module, exports) {
$parcel$export(module.exports, "legacyJsdJiraAutomationRoute", () => $8ee848cfdffde4e6$export$7d38596d701d5776);
const $8ee848cfdffde4e6$export$7d38596d701d5776 = {
    name: 'legacy-jsd-jira-automation',
    path: '/servicedesk/admin/:projectKey/automation'
};

});


parcelRegister("aAm2A", function(module, exports) {
$parcel$export(module.exports, "legacyJsdKnowledgeRouteEntry", () => $b75b5331372a38cf$export$352579e39711e17);


var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $gacGS = parcelRequire("gacGS");

var $74h93 = parcelRequire("74h93");
const $b75b5331372a38cf$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $b75b5331372a38cf$export$352579e39711e17 = (0, $g1GqA.createLegacyEntry)((0, $gacGS.legacyJsdKnowledgeRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$b75b5331372a38cf$var$pageEntryPoint
    }));

});
parcelRegister("gacGS", function(module, exports) {
$parcel$export(module.exports, "legacyJsdKnowledgeRoute", () => $27be1acf9556e763$export$7c7fc282c0c143d);
const $27be1acf9556e763$export$7c7fc282c0c143d = {
    name: 'legacy-jsd-knowledge',
    path: '/projects/:projectKey/knowledge/:page?'
};

});


parcelRegister("7qJ0o", function(module, exports) {
$parcel$export(module.exports, "legacyJsdQueuesRouteEntry", () => $649e8182717c43a8$export$7c006e8310e2641a);


var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $hEbrt = parcelRequire("hEbrt");

var $74h93 = parcelRequire("74h93");
const $649e8182717c43a8$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $649e8182717c43a8$export$7c006e8310e2641a = (0, $g1GqA.createLegacyEntry)((0, $hEbrt.legacyJsdQueuesRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$649e8182717c43a8$var$pageEntryPoint
    }));

});
parcelRegister("hEbrt", function(module, exports) {
$parcel$export(module.exports, "legacyJsdQueuesRoute", () => $d2bb3d1c85da7238$export$2d08dc2a8c573cf3);
const $d2bb3d1c85da7238$export$2d08dc2a8c573cf3 = {
    name: 'legacy-jsd-queues',
    path: '/projects/:projectKey/queues/:custom(custom)?/:id?'
};

});


parcelRegister("7f3Kh", function(module, exports) {
$parcel$export(module.exports, "legacyJsdQueuesManageRouteEntry", () => $4d02e2503714e326$export$cdabf798cd8727fd);


var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $g2UvS = parcelRequire("g2UvS");

var $74h93 = parcelRequire("74h93");
const $4d02e2503714e326$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $4d02e2503714e326$export$cdabf798cd8727fd = (0, $g1GqA.createLegacyEntry)((0, $g2UvS.legacyJsdQueuesManageRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$4d02e2503714e326$var$pageEntryPoint
    }));

});
parcelRegister("g2UvS", function(module, exports) {
$parcel$export(module.exports, "legacyJsdQueuesManageRoute", () => $070393f4550d0eb7$export$af365e550fae80);
const $070393f4550d0eb7$export$af365e550fae80 = {
    name: 'legacy-jsd-queues-manage',
    path: '/projects/:projectKey/queues/manage'
};

});


parcelRegister("6aBi2", function(module, exports) {
$parcel$export(module.exports, "legacyJsdReportsCustomRouteEntry", () => $53264e6c6d3b8756$export$e133645c1a4bdfe7);


var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $kHRqW = parcelRequire("kHRqW");

var $74h93 = parcelRequire("74h93");
const $53264e6c6d3b8756$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $53264e6c6d3b8756$export$e133645c1a4bdfe7 = (0, $g1GqA.createLegacyEntry)((0, $kHRqW.legacyJsdReportsCustomRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$53264e6c6d3b8756$var$pageEntryPoint
    }));

});
parcelRegister("kHRqW", function(module, exports) {
$parcel$export(module.exports, "legacyJsdReportsCustomRoute", () => $f534a6548f7cea99$export$e5d83d06029b0f71);
const $f534a6548f7cea99$export$e5d83d06029b0f71 = {
    name: 'legacy-jsd-reports-custom',
    path: '/projects/:projectKey/reports/custom/:id?'
};

});


parcelRegister("aDxZo", function(module, exports) {
$parcel$export(module.exports, "legacyJsdReportsRouteEntry", () => $8a43c4534f316097$export$893692ad278d4aa2);


var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $eUHR4 = parcelRequire("eUHR4");

var $74h93 = parcelRequire("74h93");
const $8a43c4534f316097$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $8a43c4534f316097$export$893692ad278d4aa2 = (0, $g1GqA.createLegacyEntry)((0, $eUHR4.legacyJsdReportsRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$8a43c4534f316097$var$pageEntryPoint
    }));

});
parcelRegister("eUHR4", function(module, exports) {
$parcel$export(module.exports, "legacyJsdReportsRoute", () => $8024d4f8e3db16eb$export$253418b9005ff89e);
const $8024d4f8e3db16eb$export$253418b9005ff89e = {
    name: 'legacy-jsd-reports',
    path: '/projects/:projectKey/reports/:reportType'
};

});


parcelRegister("eEZR5", function(module, exports) {
$parcel$export(module.exports, "legacyJsdSettingsFallbackRouteEntry", () => $5a3554be332b2749$export$f0bcff1cea783147);


var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $cgro0 = parcelRequire("cgro0");

var $74h93 = parcelRequire("74h93");
const $5a3554be332b2749$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $5a3554be332b2749$export$f0bcff1cea783147 = (0, $g1GqA.createLegacyEntry)((0, $cgro0.legacyJsdSettingsFallbackRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$5a3554be332b2749$var$pageEntryPoint
    }));

});
parcelRegister("cgro0", function(module, exports) {
$parcel$export(module.exports, "legacyJsdSettingsFallbackRoute", () => $8a6be038e8a3be4b$export$831971c91fbdcd5b);
const $8a6be038e8a3be4b$export$831971c91fbdcd5b = {
    name: 'legacy-jsd-settings-fallback',
    path: '/servicedesk/admin/:projectKey/:adminOption'
};

});


parcelRegister("cP32J", function(module, exports) {
$parcel$export(module.exports, "legacyJsdSettingsLanguageRouteEntry", () => $1c7543cf75309718$export$d9063e63677bfd5d);


var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $61QCA = parcelRequire("61QCA");

var $74h93 = parcelRequire("74h93");
const $1c7543cf75309718$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $1c7543cf75309718$export$d9063e63677bfd5d = (0, $g1GqA.createLegacyEntry)((0, $61QCA.legacyJsdSettingsLanguageRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$1c7543cf75309718$var$pageEntryPoint
    }));

});
parcelRegister("61QCA", function(module, exports) {
$parcel$export(module.exports, "legacyJsdSettingsLanguageRoute", () => $9e55a99b05447e3c$export$453ac1bfce2eb20e);
const $9e55a99b05447e3c$export$453ac1bfce2eb20e = {
    name: 'legacy-jsd-settings-language',
    path: '/servicedesk/admin/:projectKey/language',
    exact: true
};

});


parcelRegister("6uqex", function(module, exports) {
$parcel$export(module.exports, "legacyJsdSettingsLanguagePagesRouteEntry", () => $7084612749de7c44$export$492207df7adc0823);


var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $87S0A = parcelRequire("87S0A");

var $74h93 = parcelRequire("74h93");
const $7084612749de7c44$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $7084612749de7c44$export$492207df7adc0823 = (0, $g1GqA.createLegacyEntry)((0, $87S0A.legacyJsdSettingsLanguagePagesRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$7084612749de7c44$var$pageEntryPoint
    }));

});
parcelRegister("87S0A", function(module, exports) {
$parcel$export(module.exports, "legacyJsdSettingsLanguagePagesRoute", () => $188a293c5489bb16$export$2fd783c1d45b1a9f);
const $188a293c5489bb16$export$2fd783c1d45b1a9f = {
    name: 'legacy-jsd-settings-language-pages',
    path: '/servicedesk/admin/:projectKey/language/:languageKey/:sidebarItemKey?'
};

});


parcelRegister("dpTws", function(module, exports) {
$parcel$export(module.exports, "legacyJsdWidgetsRouteEntry", () => $102e9c8590867380$export$8b6c493f34b243fb);


var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $2imUo = parcelRequire("2imUo");

var $74h93 = parcelRequire("74h93");
const $102e9c8590867380$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $102e9c8590867380$export$8b6c493f34b243fb = (0, $g1GqA.createLegacyEntry)((0, $2imUo.legacyJsdWidgetsRoute), ()=>({
        layout: (0, $74h93.serviceProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$102e9c8590867380$var$pageEntryPoint
    }));

});
parcelRegister("2imUo", function(module, exports) {
$parcel$export(module.exports, "legacyJsdWidgetsRoute", () => $b325288cf3c1db24$export$ecfee0d843d9f28a);
const $b325288cf3c1db24$export$ecfee0d843d9f28a = {
    name: 'legacy-jsd-widgets',
    path: '/servicedesk/admin/:projectKey/addon/:addonName',
    exact: true
};

});


parcelRegister("73adx", function(module, exports) {
$parcel$export(module.exports, "legacyPersonalSettingsAccessTokensRouteEntry", () => $d48f76e2c4d60f96$export$30ce3fd3c9377561);

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $fNEX1 = parcelRequire("fNEX1");
const $d48f76e2c4d60f96$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d48f76e2c4d60f96$export$30ce3fd3c9377561 = (0, $g1GqA.createLegacyEntry)((0, $fNEX1.legacyPersonalSettingsAccessTokensRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        entryPoint: ()=>$d48f76e2c4d60f96$var$pageEntryPoint
    }));

});
parcelRegister("fNEX1", function(module, exports) {
$parcel$export(module.exports, "legacyPersonalSettingsAccessTokensRoute", () => $153b58a365f2701e$export$49a90c7c39db3dd3);
const $153b58a365f2701e$export$49a90c7c39db3dd3 = {
    name: 'legacy-personal-settings-access-tokens',
    path: '/plugins/servlet/oauth/users/access-tokens'
};

});


parcelRegister("83ssL", function(module, exports) {
$parcel$export(module.exports, "legacyPinRouteEntry", () => $d4c0a8bdce6d4070$export$2311541dfc64683c);


var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $3KSG6 = parcelRequire("3KSG6");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $3mGMY = parcelRequire("3mGMY");
const $d4c0a8bdce6d4070$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $d4c0a8bdce6d4070$export$2311541dfc64683c = (0, $g1GqA.createLegacyEntry)((0, $3mGMY.legacyPinRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$d4c0a8bdce6d4070$var$pageEntryPoint
    }));

});
parcelRegister("3mGMY", function(module, exports) {
$parcel$export(module.exports, "legacyPinRoute", () => $daeb8c5b6502ffea$export$5600fbce403620b6);
const $daeb8c5b6502ffea$export$5600fbce403620b6 = {
    name: 'legacy-pin',
    path: '/projects/:projectKey/issues/:issueKey?'
};

});


parcelRegister("bOoZ2", function(module, exports) {
$parcel$export(module.exports, "legacyPortfolioPagesRouteEntry", () => $ef34edb2c9d4deea$export$200d6f7de97d1e96);


var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $1v029 = parcelRequire("1v029");
const $ef34edb2c9d4deea$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $ef34edb2c9d4deea$export$200d6f7de97d1e96 = (0, $g1GqA.createLegacyEntry)((0, $1v029.legacyPortfolioPagesRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        entryPoint: ()=>$ef34edb2c9d4deea$var$pageEntryPoint
    }));

});
const $c269ad8423c234af$export$62f70d55c4a538b0 = 'PLANS';

parcelRegister("1v029", function(module, exports) {
$parcel$export(module.exports, "legacyPortfolioPagesRoute", () => $3828ab41acd136fb$export$c8591b40ac25c22d);
const $3828ab41acd136fb$export$c8591b40ac25c22d = {
    name: 'legacy-portfolio-pages',
    path: '/secure/PortfolioPlan(\\w+).jspa'
};

});


parcelRegister("7zjhm", function(module, exports) {
$parcel$export(module.exports, "legacyPortfolioTeamRouteEntry", () => $74ea2726263fc3e0$export$67d1a57e72c969e);


var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $h2tgz = parcelRequire("h2tgz");

var $g1GqA = parcelRequire("g1GqA");

var $hc7ou = parcelRequire("hc7ou");
const $74ea2726263fc3e0$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $74ea2726263fc3e0$export$67d1a57e72c969e = (0, $g1GqA.createLegacyEntry)((0, $hc7ou.legacyPortfolioTeamRoute), ()=>({
        layout: (0, $h2tgz.globalLayout),
        navigation: {
            menuId: (0, $c269ad8423c234af$export$62f70d55c4a538b0)
        },
        entryPoint: ()=>$74ea2726263fc3e0$var$pageEntryPoint
    }));

});
parcelRegister("hc7ou", function(module, exports) {
$parcel$export(module.exports, "legacyPortfolioTeamRoute", () => $b0f95fe322afddee$export$b61cebfbe2ae0da2);
const $b0f95fe322afddee$export$b61cebfbe2ae0da2 = {
    name: 'legacy-portfolio-team',
    path: '/secure/TeamManagement.jspa'
};

});


parcelRegister("idrEX", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesBambooRouteEntry", () => $cada181b28722f30$export$929a483dcf3c101d);


var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $3KSG6 = parcelRequire("3KSG6");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $6TA3o = parcelRequire("6TA3o");
const $cada181b28722f30$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $cada181b28722f30$export$929a483dcf3c101d = (0, $g1GqA.createLegacyEntry)((0, $6TA3o.legacyProjectReleasesBambooRoute), ()=>({
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        layout: (0, $dvtoW.genericProjectLayout),
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$cada181b28722f30$var$pageEntryPoint
    }));

});
parcelRegister("6TA3o", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesBambooRoute", () => $b7606e25365c9d48$export$df7f0213f2f22fc8);
const $b7606e25365c9d48$export$df7f0213f2f22fc8 = {
    name: 'legacy-project-releases-bamboo',
    path: '/secure/ConfigureBambooRelease([!%]?[\\w]*).jspa'
};

});


parcelRegister("8878Q", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesRouteEntry", () => $172727d3b6b03884$export$5d0e55986ed5e2c9);


var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $3KSG6 = parcelRequire("3KSG6");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $iFDYv = parcelRequire("iFDYv");
const $172727d3b6b03884$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $172727d3b6b03884$export$5d0e55986ed5e2c9 = (0, $g1GqA.createLegacyEntry)((0, $iFDYv.legacyProjectReleasesRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$172727d3b6b03884$var$pageEntryPoint
    }));

});
parcelRegister("iFDYv", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesRoute", () => $b5f54a657348b0e2$export$577b2cf03e294477);
const $b5f54a657348b0e2$export$577b2cf03e294477 = {
    name: 'legacy-project-releases',
    path: '/projects/:projectKey/versions/:id?'
};

});


parcelRegister("gyLf0", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRouteEntry", () => $06c4a236bc6707f5$export$836428e7b33b6c6c);


var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $3KSG6 = parcelRequire("3KSG6");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dIb6v = parcelRequire("dIb6v");
const $06c4a236bc6707f5$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $06c4a236bc6707f5$export$836428e7b33b6c6c = (0, $g1GqA.createLegacyEntry)((0, $dIb6v.legacyProjectReleasesNoteConfigRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$06c4a236bc6707f5$var$pageEntryPoint
    }));

});
parcelRegister("dIb6v", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRoute", () => $be303a1e6e4b5294$export$a9509017cabb1e30);
const $be303a1e6e4b5294$export$a9509017cabb1e30 = {
    name: 'legacy-project-releases-note-config',
    path: '/secure/ConfigureReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("c4S0u", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesNoteRouteEntry", () => $1ab3f7128c2470c1$export$781dd53d465d270d);


var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $3KSG6 = parcelRequire("3KSG6");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");


var $hFYSn = parcelRequire("hFYSn");

var $7tgMD = parcelRequire("7tgMD");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $45ZyR = parcelRequire("45ZyR");
const $1ab3f7128c2470c1$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint),
    horizontalNavigation: (0, $3KSG6.jiraHorizontalNavEntrypoint)
});
const $1ab3f7128c2470c1$export$781dd53d465d270d = (0, $g1GqA.createLegacyEntry)((0, $45ZyR.legacyProjectReleasesNoteRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            horizontal: (0, $156b0b89ff564e71$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $7tgMD.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$1ab3f7128c2470c1$var$pageEntryPoint
    }));

});
parcelRegister("45ZyR", function(module, exports) {
$parcel$export(module.exports, "legacyProjectReleasesNoteRoute", () => $55c8daa03ee78a74$export$6ef734887b6da0c8);
const $55c8daa03ee78a74$export$6ef734887b6da0c8 = {
    name: 'legacy-project-releases-note',
    path: '/secure/ReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("4sniJ", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsCollectorsAddRouteEntry", () => $21d63f056b46da68$export$256375c5bbf6166a);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $9jYv2 = parcelRequire("9jYv2");
const $21d63f056b46da68$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $21d63f056b46da68$export$256375c5bbf6166a = (0, $g1GqA.createLegacyEntry)((0, $9jYv2.legacyProjectSettingsCollectorsAddRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$21d63f056b46da68$var$pageEntryPoint
    }));

});
parcelRegister("9jYv2", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsCollectorsAddRoute", () => $f787f8aefa3bdf2b$export$a3909b9ad3f61ae6);
const $f787f8aefa3bdf2b$export$a3909b9ad3f61ae6 = {
    name: 'legacy-project-settings-collectors-add',
    path: '/secure/AddCollector([!%]?[\\w]*).jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("49rDJ", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsCollectorsRouteEntry", () => $9c9a432c835c4de2$export$e3a7328abebdc329);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $6jhq4 = parcelRequire("6jhq4");
const $9c9a432c835c4de2$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $9c9a432c835c4de2$export$e3a7328abebdc329 = (0, $g1GqA.createLegacyEntry)((0, $6jhq4.legacyProjectSettingsCollectorsRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$9c9a432c835c4de2$var$pageEntryPoint
    }));

});
parcelRegister("6jhq4", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsCollectorsRoute", () => $530e7ae6102d1235$export$956a041d0b6694e3);
const $530e7ae6102d1235$export$956a041d0b6694e3 = {
    name: 'legacy-project-settings-collectors',
    path: '/secure/ViewCollectors([!%]?[\\w]*).jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("cU02I", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsCollectorsHelpRouteEntry", () => $f4bcae81ab47da0d$export$10edcec0926752a6);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $3gX6v = parcelRequire("3gX6v");
const $f4bcae81ab47da0d$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $f4bcae81ab47da0d$export$10edcec0926752a6 = (0, $g1GqA.createLegacyEntry)((0, $3gX6v.legacyProjectSettingsCollectorsHelpRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$f4bcae81ab47da0d$var$pageEntryPoint
    }));

});
parcelRegister("3gX6v", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsCollectorsHelpRoute", () => $6e81a7f7f89cc08a$export$7433cef5cafafb17);
const $6e81a7f7f89cc08a$export$7433cef5cafafb17 = {
    name: 'legacy-project-settings-collectors-help',
    path: '/secure/InsertCollectorHelp([!%]?[\\w]*).jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("1mijV", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsCollectorsViewRouteEntry", () => $299c6c7f282918c1$export$7b10472641e87ea);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $l0ad8 = parcelRequire("l0ad8");
const $299c6c7f282918c1$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $299c6c7f282918c1$export$7b10472641e87ea = (0, $g1GqA.createLegacyEntry)((0, $l0ad8.legacyProjectSettingsCollectorsViewRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$299c6c7f282918c1$var$pageEntryPoint
    }));

});
parcelRegister("l0ad8", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsCollectorsViewRoute", () => $707465ed779c4762$export$c3f8831257e68c5a);
const $707465ed779c4762$export$c3f8831257e68c5a = {
    name: 'legacy-project-settings-collectors-view',
    path: '/secure/ViewCollector([!%]?[\\w]*).jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("1MtFP", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsConfigRouteEntry", () => $67440a972f42c78f$export$3c4ea5135028082);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $c388U = parcelRequire("c388U");
const $67440a972f42c78f$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $67440a972f42c78f$export$3c4ea5135028082 = (0, $g1GqA.createLegacyEntry)((0, $c388U.legacyProjectSettingsConfigRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$67440a972f42c78f$var$pageEntryPoint
    }));

});
parcelRegister("c388U", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsConfigRoute", () => $f321f43eb202b422$export$3403c95bb82037b2);
const $f321f43eb202b422$export$3403c95bb82037b2 = {
    name: 'legacy-project-settings-config',
    path: '/plugins/servlet/project-config/:projectKey/:adminOption'
};

});


parcelRegister("dLDM6", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsDeleteRouteEntry", () => $fc0a21eaf53a2de9$export$f5fadab402705bc4);


var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $1t86Q = parcelRequire("1t86Q");
const $fc0a21eaf53a2de9$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $fc0a21eaf53a2de9$export$f5fadab402705bc4 = (0, $g1GqA.createLegacyEntry)((0, $1t86Q.legacyProjectSettingsDeleteRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$fc0a21eaf53a2de9$var$pageEntryPoint
    }));

});
parcelRegister("1t86Q", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsDeleteRoute", () => $16d3370a687eb0d0$export$4e8f3a153f80bfa1);
const $16d3370a687eb0d0$export$4e8f3a153f80bfa1 = {
    name: 'legacy-project-settings-delete',
    path: '(/secure/|/)project/DeleteProject([!%]?[\\w]*).jspa',
    query: [
        'pid'
    ]
};

});


parcelRegister("61QLs", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsDevRouteEntry", () => $45c7e039e470a782$export$bb5131b6203b8f3a);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $j0BxQ = parcelRequire("j0BxQ");
const $45c7e039e470a782$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $45c7e039e470a782$export$bb5131b6203b8f3a = (0, $g1GqA.createLegacyEntry)((0, $j0BxQ.legacyProjectSettingsDevRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$45c7e039e470a782$var$pageEntryPoint
    }));

});
parcelRegister("j0BxQ", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsDevRoute", () => $6834c03a44f311f9$export$d3fca8ea951ff47f);
const $6834c03a44f311f9$export$d3fca8ea951ff47f = {
    name: 'legacy-project-settings-dev',
    path: '/secure/ConfigureDevStatus.jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("9t5jK", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsEditRouteEntry", () => $9f2ae9a9a93fceac$export$1b930b1155c7c95d);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $01zhE = parcelRequire("01zhE");
const $9f2ae9a9a93fceac$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $9f2ae9a9a93fceac$export$1b930b1155c7c95d = (0, $g1GqA.createLegacyEntry)((0, $01zhE.legacyProjectSettingsEditRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$9f2ae9a9a93fceac$var$pageEntryPoint
    }));

});
parcelRegister("01zhE", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsEditRoute", () => $5a7e9baf0205e633$export$69813bfb3aa0feb9);
const $5a7e9baf0205e633$export$69813bfb3aa0feb9 = {
    name: 'legacy-project-settings-edit',
    path: '(/secure/|/)project/EditProject([!%]?[\\w]*).jspa',
    query: [
        'pid'
    ]
};

});


parcelRegister("fk68B", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsFieldsAssociateRouteEntry", () => $d4ceb87e5bd5adce$export$c7cd1115d3e90593);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $kQL8N = parcelRequire("kQL8N");
const $d4ceb87e5bd5adce$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d4ceb87e5bd5adce$export$c7cd1115d3e90593 = (0, $g1GqA.createLegacyEntry)((0, $kQL8N.legacyProjectSettingsFieldsAssociateRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$d4ceb87e5bd5adce$var$pageEntryPoint
    }));

});
parcelRegister("kQL8N", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsFieldsAssociateRoute", () => $ec3aecfc41d5fedb$export$b45ad52ceda09b54);
const $ec3aecfc41d5fedb$export$b45ad52ceda09b54 = {
    name: 'legacy-project-settings-fields-associate',
    path: '/secure/admin/SelectFieldLayoutScheme!default.jspa'
};

});


parcelRegister("1AwwG", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsFieldsRouteEntry", () => $04c86f59c1181cd6$export$cf5230efac88ec18);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jgKgn = parcelRequire("jgKgn");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $eBk8L = parcelRequire("eBk8L");

var $aWliK = parcelRequire("aWliK");

var $i860n = parcelRequire("i860n");

var $1MiZz = parcelRequire("1MiZz");
const $04c86f59c1181cd6$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $04c86f59c1181cd6$export$cf5230efac88ec18 = (0, $g1GqA.createLegacyEntry)((0, $eBk8L.legacyProjectSettingsFieldsRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $aWliK.componentWithCondition)(()=>!(0, $i860n.fg)('mc-nfa-soft-rollback'), (0, $1MiZz.CmpProjectSettingsFieldsLegacyPage), (0, $jgKgn.LegacyPage)),
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$04c86f59c1181cd6$var$pageEntryPoint
    }));

});
parcelRegister("eBk8L", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsFieldsRoute", () => $95879eaf942af3f5$export$f8d801c531c09b6e);
const $95879eaf942af3f5$export$f8d801c531c09b6e = {
    name: 'legacy-project-settings-fields',
    path: '/plugins/servlet/project-config/:projectKey/fields'
};

});

parcelRegister("1MiZz", function(module, exports) {
$parcel$export(module.exports, "CmpProjectSettingsFieldsLegacyPage", () => $f7a6bf14b72640da$export$f9948bc793107c3e);

var $euxye = parcelRequire("euxye");

var $a8EUd = parcelRequire("a8EUd");

var $6DhA8 = parcelRequire("6DhA8");

var $jgKgn = parcelRequire("jgKgn");
const $f7a6bf14b72640da$export$f9948bc793107c3e = (props)=>{
    const { route: route } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jgKgn.LegacyPage), props), route.name === 'legacy-project-settings-fields' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $a8EUd.PlaceholderWithNativeSuspense), {
        name: "legacy-project-fields-page-mount-nfa-modal-menu-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $6DhA8.LegacyProjectFieldsPageMountEfaOptInMenuItem), null)));
};
$f7a6bf14b72640da$export$f9948bc793107c3e.displayName = "CmpProjectSettingsFieldsLegacyPage";

});
parcelRegister("6DhA8", function(module, exports) {
$parcel$export(module.exports, "LegacyProjectFieldsPageMountEfaOptInMenuItem", () => $03e9040a0332aaee$export$20020015a4973277);

var $baEUP = parcelRequire("baEUP");

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $n67Vb = parcelRequire("n67Vb");

var $i860n = parcelRequire("i860n");

var $kt86l = parcelRequire("kt86l");

var $gp75S = parcelRequire("gp75S");
const $03e9040a0332aaee$export$20020015a4973277 = ()=>{
    const [portal, setPortal] = (0, $euxye.useState)(null);
    const cloudId = (0, $kt86l.useCloudId)();
    const graphqlData = (0, $n67Vb.useLazyLoadQuery)((0, $baEUP.default), {
        cloudId: cloudId,
        isJiraEfaForCmpM2Experiment: !(0, $i860n.fg)('mc-nfa-soft-rollback')
    });
    // Remove possibility for errors due to graphqlData or jira_isTenantConvertedToNfa being null.
    const isTenantConvertedToNfa = graphqlData?.jira_isTenantConvertedToNfa ?? false;
    // Restrict visibility of new menu item
    const showNewOptInModal = (0, $euxye.useMemo)(()=>{
        return !(0, $i860n.fg)('mc-nfa-soft-rollback') && isTenantConvertedToNfa;
    }, [
        isTenantConvertedToNfa
    ]);
    // Apply useEffect() to avoid SSR + querying page for every render
    (0, $euxye.useEffect)(()=>{
        // Changes to legacy content in rootElement are permanent, so we do nothing
        // unless showNewOptInModal is confirmed and can't change back to false.
        if (!showNewOptInModal) return;
        if (!globalThis?.document?.querySelector) return;
        const linkElement = globalThis.document.querySelector('#project-config-fields-scheme-change');
        const projectId = linkElement?.dataset.id;
        const rootElement = linkElement?.parentElement; // from <a> to <li> in menu
        if (!rootElement || !projectId) {
            // eslint-disable-next-line no-console
            console.warn('LegacyProjectFieldsPageMountEfaOptInMenuItem: No root element or project ID found.');
            return;
        }
        // Empty existing contents from legacy page template
        rootElement.replaceChildren('');
        // Restore focus element
        const focusElement = globalThis.document.querySelector('#project-config-tab-actions') ?? undefined;
        setPortal(/*#__PURE__*/ (0, $85XPu.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $gp75S.ActionMenuItem), {
            projectId: projectId,
            restoreFocusElement: focusElement
        }), rootElement, projectId));
    }, [
        showNewOptInModal
    ]);
    // Hook React into the mount point inside the menu.
    // This will replace the legacy menu <li> item (a link to another page)
    // with our own React rendered component which opens a modal.
    return portal;
};
$03e9040a0332aaee$export$20020015a4973277.displayName = "LegacyProjectFieldsPageMountEfaOptInMenuItem";

});
parcelRegister("baEUP", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9fcdad701ad4dd9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11ccb38f6c2d8f63c8482a6d5f9dc9be>>
 * @relayHash d7ec16f632bb3e2651dd2f1109ec80bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9768ed6336faee0207750f0fe7e583b66542151bc1c79447c66bad6f75cabff
const $d9fcdad701ad4dd9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isJiraEfaForCmpM2Experiment"
        }
    ], v1 = [
        {
            "condition": "isJiraEfaForCmpM2Experiment",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "jira_isTenantConvertedToNfa"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LegacyProjectFieldsPageMountEfaOptInMenuItemQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LegacyProjectFieldsPageMountEfaOptInMenuItemQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "d9768ed6336faee0207750f0fe7e583b66542151bc1c79447c66bad6f75cabff",
            "metadata": {},
            "name": "LegacyProjectFieldsPageMountEfaOptInMenuItemQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d9fcdad701ad4dd9$var$node.hash = "a159efa8fe9932287e93aec00f2ba5fb";
var $d9fcdad701ad4dd9$export$2e2bcd8739ae039 = $d9fcdad701ad4dd9$var$node;

});

parcelRegister("gp75S", function(module, exports) {
$parcel$export(module.exports, "ActionMenuItem", () => $8ebb2205a8b86d8a$export$24feb92aa21c4329);

var $ikqVA = parcelRequire("ikqVA");

var $euxye = parcelRequire("euxye");

var $clfBX = parcelRequire("clfBX");

var $n67Vb = parcelRequire("n67Vb");

var $f99M0 = parcelRequire("f99M0");

var $fyhre = parcelRequire("fyhre");

var $kt86l = parcelRequire("kt86l");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");
const $8ebb2205a8b86d8a$var$menuItemLabel = (0, $7eNDO.defineMessage)({
    id: "admin-pages-field-schemes.ui.legacy-cmp-project.action-menu-item",
    defaultMessage: "Use a different scheme"
});
const $8ebb2205a8b86d8a$var$defaultRedirectHandler = (url)=>{
    globalThis.window.location.href = url;
};
const $8ebb2205a8b86d8a$var$defaultReloadHandler = ()=>{
    globalThis.window.location.reload();
};
const $8ebb2205a8b86d8a$export$24feb92aa21c4329 = (props)=>{
    const cloudId = (0, $kt86l.useCloudId)();
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { projectId: projectId, restoreFocusElement: restoreFocusElement, onRedirect: onRedirect = $8ebb2205a8b86d8a$var$defaultRedirectHandler, onReload: onReload = $8ebb2205a8b86d8a$var$defaultReloadHandler } = props;
    const projectData = (0, $n67Vb.useLazyLoadQuery)((0, $ikqVA.default), {
        cloudId: cloudId,
        projectId: projectId
    });
    const entrypointParams = (0, $euxye.useMemo)(()=>{
        return {
            cloudId: cloudId,
            projectId: projectId
        };
    }, [
        cloudId,
        projectId
    ]);
    const nfaProjectFieldSettingsUrl = (0, $euxye.useMemo)(()=>{
        const { key: key, projectType: projectType } = projectData?.jira_projectByIdOrKey ?? {};
        const projectTypeMap = {
            // /jira/software/c/projects/CKP/settings/fields
            [(0, $f99M0.JIRA_PROJECT_TYPES).SOFTWARE]: 'software',
            // /jira/core/c/projects/JWMCMPDTAR/settings/fields
            [(0, $f99M0.JIRA_PROJECT_TYPES).BUSINESS]: 'core',
            // /jira/servicedesk/c/projects/JSMCMPFR/settings/fields
            [(0, $f99M0.JIRA_PROJECT_TYPES).SERVICE_DESK]: 'servicedesk'
        };
        if (!key || !projectType || !projectTypeMap[projectType]) return undefined;
        return `/jira/${projectTypeMap[projectType]}/c/projects/${key}/settings/fields`;
    }, [
        projectData?.jira_projectByIdOrKey
    ]);
    const entrypointProps = (0, $euxye.useMemo)(()=>{
        return {
            onClose: ()=>{
                if (restoreFocusElement) // Give time for modal close animation to complete before focusing element
                // requestAnimationFrame() and requestIdleCallback() didn't seem to work here
                // so we fall back to the good old setTimeout().
                // This workaround will go away once we fully migrate the page to React.
                setTimeout(()=>{
                    restoreFocusElement.focus();
                }, 400);
            },
            onSaveComplete: (isUsingNfaScheme)=>{
                // Since we're on a legacy page...
                if (isUsingNfaScheme && nfaProjectFieldSettingsUrl) // redirect to the NFA scheme page
                onRedirect(nfaProjectFieldSettingsUrl);
                else // refresh the whole page to see updated heading and fields
                onReload();
            }
        };
    }, [
        nfaProjectFieldSettingsUrl,
        restoreFocusElement,
        onRedirect,
        onReload
    ]);
    // For some reason Modal does not seem to work when using it with `component={BasicLink}`
    // Due to this, we've kept it as a button
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fyhre.ModalDropdownItemTrigger), {
        entryPoint: (0, $clfBX.associateProjectToFieldSchemeModalEntryPoint),
        entryPointParams: entrypointParams,
        entryPointProps: entrypointProps
    }, formatMessage($8ebb2205a8b86d8a$var$menuItemLabel));
};
$8ebb2205a8b86d8a$export$24feb92aa21c4329.displayName = "ActionMenuItem";

});
parcelRegister("ikqVA", function(module, exports) {
$parcel$export(module.exports, "default", () => $318ae3283712b2a7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<171e8109e1d9d5c41f62e22bb19c2848>>
 * @relayHash fa44de6ed0abe8da3218a3c51ab1e781
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a7065661d3b06c38257ffce8ff7ca10cb3795fb23acd56f7b71bd9f314dd8538
const $318ae3283712b2a7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "projectType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ActionMenuItemLegacyPageOptInModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ActionMenuItemLegacyPageOptInModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a7065661d3b06c38257ffce8ff7ca10cb3795fb23acd56f7b71bd9f314dd8538",
            "metadata": {},
            "name": "ActionMenuItemLegacyPageOptInModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$318ae3283712b2a7$var$node.hash = "48d463ea76b5438b44762aae64bc4bcb";
var $318ae3283712b2a7$export$2e2bcd8739ae039 = $318ae3283712b2a7$var$node;

});

parcelRegister("clfBX", function(module, exports) {
$parcel$export(module.exports, "associateProjectToFieldSchemeModalEntryPoint", () => $292c8601bb9f8647$export$ca06bc9df52254a5);

var $7NTte = parcelRequire("7NTte");

var $fiVog = parcelRequire("fiVog");

var $i8BNs = parcelRequire("i8BNs");

var $8TEw7 = parcelRequire("8TEw7");

const $292c8601bb9f8647$export$ca06bc9df52254a5 = (0, $fiVog.createEntryPoint)({
    root: (0, $7NTte.JSResourceForInteraction)(()=>(parcelRequire("hgwPn")), {
        moduleId: "26416c63",
        moduleName: "AssociateProjectToFieldSchemeModal",
        priority: "interaction"
    }),
    getPreloadProps: (params)=>{
        return {
            queries: {
                associateProjectToFieldSchemeModalData: {
                    parameters: (0, $8TEw7.default),
                    variables: {
                        cloudId: params.cloudId,
                        projectAri: (0, $i8BNs.JiraProjectAri).create({
                            siteId: params.cloudId,
                            projectId: params.projectId
                        }).toString()
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("8TEw7", function(module, exports) {
$parcel$export(module.exports, "default", () => $be04dd6556f41d4d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d89100b352f3a1214371cba6b5213187>>
 * @relayHash a4a7d92a918ee5f8e30325e161ec20b3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cc852b83cd91027240167016d4cb1978110507d7da66d45f045c74dd113feaba

var $lIGkE = parcelRequire("lIGkE");
const $be04dd6556f41d4d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = {
        "args": v2 /*: any*/ ,
        "kind": "ScalarField",
        "name": "jira_isTenantConvertedToNfa"
    }, v4 = {
        "args": v2 /*: any*/ ,
        "kind": "ScalarField",
        "name": "jira_doesTenantHaveNonNfaProjects"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "ScalarField",
        "name": "schemeId"
    }, v9 = [
        v8 /*: any*/ ,
        v7 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = [
        v8 /*: any*/ ,
        v7 /*: any*/ ,
        v11 /*: any*/ 
    ], v13 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 40
        }
    ], v14 = [
        v8 /*: any*/ ,
        v7 /*: any*/ ,
        v11 /*: any*/ ,
        v10 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v16 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v17 = [
        "input"
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AssociateProjectToFieldSchemeModalQuery",
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "alias": "project",
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "JiraFieldConfigScheme",
                                    "kind": "LinkedField",
                                    "name": "associatedFieldConfigScheme",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraFieldScheme",
                                    "kind": "LinkedField",
                                    "name": "associatedFieldScheme",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "AssociateProjectToFieldSchemeModal"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "AssociateProjectToFieldSchemeModal_legacySchemes"
                                }
                            ],
                            "type": "JiraProject"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AssociateProjectToFieldSchemeModalQuery",
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "alias": "project",
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "JiraFieldConfigScheme",
                                    "kind": "LinkedField",
                                    "name": "associatedFieldConfigScheme",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                },
                                {
                                    "concreteType": "JiraFieldScheme",
                                    "kind": "LinkedField",
                                    "name": "associatedFieldScheme",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                },
                                {
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "JiraFieldSchemesConnection",
                                    "kind": "LinkedField",
                                    "name": "availableFieldSchemes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFieldSchemesEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldScheme",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": v14 /*: any*/ 
                                                },
                                                v15 /*: any*/ 
                                            ]
                                        },
                                        v16 /*: any*/ 
                                    ],
                                    "storageKey": "availableFieldSchemes(first:40)"
                                },
                                {
                                    "args": v13 /*: any*/ ,
                                    "filters": v17 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "AssociateProjectToFieldSchemeModal_adminPagesFieldSchemes__availableFieldSchemes",
                                    "kind": "LinkedHandle",
                                    "name": "availableFieldSchemes"
                                },
                                {
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "JiraFieldConfigSchemesConnection",
                                    "kind": "LinkedField",
                                    "name": "availableFieldConfigSchemes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFieldConfigSchemesEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFieldConfigScheme",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": v14 /*: any*/ 
                                                },
                                                v15 /*: any*/ 
                                            ]
                                        },
                                        v16 /*: any*/ 
                                    ],
                                    "storageKey": "availableFieldConfigSchemes(first:40)"
                                },
                                {
                                    "args": v13 /*: any*/ ,
                                    "filters": v17 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "AssociateProjectToFieldSchemeModal_adminPagesFieldSchemes__availableFieldConfigSchemes",
                                    "kind": "LinkedHandle",
                                    "name": "availableFieldConfigSchemes"
                                }
                            ],
                            "type": "JiraProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cc852b83cd91027240167016d4cb1978110507d7da66d45f045c74dd113feaba",
            "metadata": {},
            "name": "AssociateProjectToFieldSchemeModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$be04dd6556f41d4d$var$node.hash = "f8d48c304b52c9b1aaf9eb54b6ab00f9";
(0, $lIGkE.PreloadableQueryRegistry).set($be04dd6556f41d4d$var$node.params.id, $be04dd6556f41d4d$var$node);
var $be04dd6556f41d4d$export$2e2bcd8739ae039 = $be04dd6556f41d4d$var$node;

});

parcelRegister("hgwPn", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");
module.exports = Promise.all([
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("dYBUe")
]).then(()=>parcelRequire('fqtNi'));

});


parcelRegister("fyhre", function(module, exports) {
$parcel$export(module.exports, "ModalDropdownItemTrigger", () => $1d99c05dcdd0ad54$export$d24aab363378eba0);

var $euxye = parcelRequire("euxye");

var $2YPKP = parcelRequire("2YPKP");

var $ikm5U = parcelRequire("ikm5U");
const $1d99c05dcdd0ad54$export$d24aab363378eba0 = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, forwardedRef: forwardedRef, preloadOnFocus: preloadOnFocus, ...dropdownProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ikm5U.ModalTrigger), {
        forwardedRef: forwardedRef,
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        Fallback: Fallback,
        title: modalTitle,
        modalProps: modalProps,
        preloadOnFocus: preloadOnFocus
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2YPKP.default), {
            ref: ref,
            ...dropdownProps
        }, children));
};
$1d99c05dcdd0ad54$export$d24aab363378eba0.displayName = "ModalDropdownItemTrigger";

});





parcelRegister("04283", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsIssueLayoutRouteEntry", () => $84eb94eb3b0673a3$export$ba112336170e9374);



var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dLPhR = parcelRequire("dLPhR");
const $84eb94eb3b0673a3$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $84eb94eb3b0673a3$export$ba112336170e9374 = (0, $g1GqA.createLegacyEntry)((0, $dLPhR.legacyProjectSettingsIssueLayoutRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$84eb94eb3b0673a3$var$pageEntryPoint
    }));

});
parcelRegister("dLPhR", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsIssueLayoutRoute", () => $5c873e611a537c18$export$b9490f2a02690c81);
const $5c873e611a537c18$export$b9490f2a02690c81 = {
    name: 'legacy-project-settings-issue-layout',
    path: '/plugins/servlet/project-config/:projectKey/issuelayout'
};

});


parcelRegister("1reFg", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityAssociateRouteEntry", () => $b055184ea8bd83b3$export$31f276ec8affeb65);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $1OxY9 = parcelRequire("1OxY9");
const $b055184ea8bd83b3$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $b055184ea8bd83b3$export$31f276ec8affeb65 = (0, $g1GqA.createLegacyEntry)((0, $1OxY9.legacyProjectSettingsIssueSecurityAssociateRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$b055184ea8bd83b3$var$pageEntryPoint
    }));

});
parcelRegister("1OxY9", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityAssociateRoute", () => $7ed9074046ad3b16$export$8fb428d7ca4ce850);
const $7ed9074046ad3b16$export$8fb428d7ca4ce850 = {
    name: 'legacy-project-settings-issue-security-associate',
    path: '/secure/project/SelectProjectIssueSecurityScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("7ZJjr", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityRouteEntry", () => $e11a6fe18711fe4f$export$50c072825de9f7ec);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $cMo5d = parcelRequire("cMo5d");
const $e11a6fe18711fe4f$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $e11a6fe18711fe4f$export$50c072825de9f7ec = (0, $g1GqA.createLegacyEntry)((0, $cMo5d.legacyProjectSettingsIssueSecurityRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$e11a6fe18711fe4f$var$pageEntryPoint
    }));

});
parcelRegister("cMo5d", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityRoute", () => $2b84d99e4e993304$export$71aa1b769739b378);
const $2b84d99e4e993304$export$71aa1b769739b378 = {
    name: 'legacy-project-settings-issue-security',
    path: '/plugins/servlet/project-config/:projectKey/issuesecurity'
};

});


parcelRegister("c60M9", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsIssueTypesAssociateRouteEntry", () => $88da483d216d414c$export$997736bd2e54a14b);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $dCwgD = parcelRequire("dCwgD");
const $88da483d216d414c$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $88da483d216d414c$export$997736bd2e54a14b = (0, $g1GqA.createLegacyEntry)((0, $dCwgD.legacyProjectSettingsIssueTypesAssociateRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$88da483d216d414c$var$pageEntryPoint
    }));

});
parcelRegister("dCwgD", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsIssueTypesAssociateRoute", () => $da5e9d22ddf3f863$export$64a3a3a4a9e32ab2);
const $da5e9d22ddf3f863$export$64a3a3a4a9e32ab2 = {
    name: 'legacy-project-settings-issue-types-associate',
    path: '/secure/admin/SelectIssueTypeSchemeForProject!default.jspa'
};

});


parcelRegister("6IKVr", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsIssueTypesRouteEntry", () => $f365d843ca85be35$export$664d9bccf509eab1);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $8KK6R = parcelRequire("8KK6R");

var $dxmpW = parcelRequire("dxmpW");
const $f365d843ca85be35$export$664d9bccf509eab1 = (0, $g1GqA.createLegacyEntry)((0, $8KK6R.legacyProjectSettingsIssueTypesRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $dxmpW.ProjectSettingsIssueTypesTable)
    }));

});
parcelRegister("8KK6R", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsIssueTypesRoute", () => $5dc92863aef0a65c$export$f22d4a1fbe6ce2d);
const $5dc92863aef0a65c$export$f22d4a1fbe6ce2d = {
    name: 'legacy-project-settings-issue-types',
    path: '/plugins/servlet/project-config/:projectKey/issuetypes'
};

});

parcelRegister("dxmpW", function(module, exports) {
$parcel$export(module.exports, "ProjectSettingsIssueTypesTable", () => $6e6e5f73fc7fc134$export$d084fb5348b0698c);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8dMdZ = parcelRequire("8dMdZ");

var $h8QGu = parcelRequire("h8QGu");

var $jgKgn = parcelRequire("jgKgn");

var $9imxF = parcelRequire("9imxF");

var $hYI7R = parcelRequire("hYI7R");
const $6e6e5f73fc7fc134$export$d084fb5348b0698c = (props)=>{
    const [selectedWorkflow, setSelectedWorkflow] = (0, $euxye.useState)(undefined);
    const handleOnClose = (0, $euxye.useCallback)(()=>{
        setSelectedWorkflow(undefined);
    }, [
        setSelectedWorkflow
    ]);
    const getProjectId = ()=>{
        const elm = globalThis.document?.getElementById('project-config-panel-issuetypes');
        const projectId = elm?.getAttribute('data-project-id');
        return projectId !== null ? projectId : undefined;
    };
    (0, $hYI7R.useEffectWithoutConcurrency)(()=>{
        const workflowDiagramLinks = globalThis.document?.querySelectorAll('#project-config-issuetypes-table .project-config-issuetype-readonly-workflow');
        workflowDiagramLinks.forEach((diagramLink)=>{
            const workflowName = diagramLink.getAttribute('data-workflowname');
            if (workflowName) diagramLink.addEventListener('click', (event)=>{
                event.preventDefault();
                setSelectedWorkflow(workflowName);
            });
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "project-settings-issue-types-error-boundary",
        packageName: "jiraRouterRoutesLegacyProjectSettingsIssueTypes",
        teamName: "helix",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jgKgn.LegacyPage), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9imxF.default), null, selectedWorkflow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8dMdZ.default), {
        projectId: getProjectId(),
        workflowIdentifier: {
            workflowName: selectedWorkflow
        },
        onClose: handleOnClose
    })));
};
$6e6e5f73fc7fc134$export$d084fb5348b0698c.displayName = "ProjectSettingsIssueTypesTable";

});


parcelRegister("5cBHj", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsNotificationsAssociateRouteEntry", () => $58c964a20c6d3e2d$export$756ebd18bdb87829);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $jvpOy = parcelRequire("jvpOy");
const $58c964a20c6d3e2d$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $58c964a20c6d3e2d$export$756ebd18bdb87829 = (0, $g1GqA.createLegacyEntry)((0, $jvpOy.legacyProjectSettingsNotificationsAssociateRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$58c964a20c6d3e2d$var$pageEntryPoint
    }));

});
parcelRegister("jvpOy", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsNotificationsAssociateRoute", () => $a64cf33ed2e444ab$export$c3b586e70bfcdfe);
const $a64cf33ed2e444ab$export$c3b586e70bfcdfe = {
    name: 'legacy-project-settings-notifications-associate',
    path: '/secure/project/SelectProjectScheme!default.jspa'
};

});


parcelRegister("2FJmX", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsNotificationsRouteEntry", () => $4f4942f0ceae8042$export$ec9c71381b367931);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $5vjDr = parcelRequire("5vjDr");
const $4f4942f0ceae8042$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $4f4942f0ceae8042$export$ec9c71381b367931 = (0, $g1GqA.createLegacyEntry)((0, $5vjDr.legacyProjectSettingsNotificationsRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$4f4942f0ceae8042$var$pageEntryPoint
    }));

});
parcelRegister("5vjDr", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsNotificationsRoute", () => $e51375c836e02535$export$3053634181f5a1e4);
const $e51375c836e02535$export$3053634181f5a1e4 = {
    name: 'legacy-project-settings-notifications',
    path: '/plugins/servlet/project-config/:projectKey/notifications'
};

});


parcelRegister("dj99j", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsOpsgenieRouteEntry", () => $d1d0f9a7fd17b1ad$export$a0ee66fa0f02ab9a);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $bRyoc = parcelRequire("bRyoc");
const $d1d0f9a7fd17b1ad$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d1d0f9a7fd17b1ad$export$a0ee66fa0f02ab9a = (0, $g1GqA.createLegacyEntry)((0, $bRyoc.legacyProjectSettingsOpsgenieRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$d1d0f9a7fd17b1ad$var$pageEntryPoint
    }));

});
parcelRegister("bRyoc", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsOpsgenieRoute", () => $7a3a9dd1b5637684$export$9bc923c0dc9a3144);
const $7a3a9dd1b5637684$export$9bc923c0dc9a3144 = {
    name: 'legacy-project-settings-opsgenie',
    path: '/plugins/servlet/project-config/:projectKey/opsgenie'
};

});


parcelRegister("iGXIF", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsPeopleRouteEntry", () => $6319f8b05d8baef7$export$a3355a805216689d);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jgKgn = parcelRequire("jgKgn");

var $6RSCO = parcelRequire("6RSCO");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $bxf9N = parcelRequire("bxf9N");
const $6319f8b05d8baef7$export$a3355a805216689d = (0, $g1GqA.createLegacyEntry)((0, $bxf9N.legacyProjectSettingsPeopleRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jgKgn.LegacyPage),
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("bxf9N", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsPeopleRoute", () => $73c45ddefeaa1e8a$export$69b69c5831576686);
const $73c45ddefeaa1e8a$export$69b69c5831576686 = {
    name: 'legacy-project-settings-people',
    path: '/plugins/servlet/project-config/:projectKey/people'
};

});


parcelRegister("4qVxm", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsPermissionsRouteEntry", () => $0538899d0c4db140$export$f941d7668bb5b4b9);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $jgKgn = parcelRequire("jgKgn");

var $6RSCO = parcelRequire("6RSCO");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $i4NXB = parcelRequire("i4NXB");
const $0538899d0c4db140$export$f941d7668bb5b4b9 = (0, $g1GqA.createLegacyEntry)((0, $i4NXB.legacyProjectSettingsPermissionsRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $jgKgn.LegacyPage),
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("i4NXB", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsPermissionsRoute", () => $a6ba86efc340c97e$export$e5e3b10fbd5b967);
const $a6ba86efc340c97e$export$e5e3b10fbd5b967 = {
    name: 'legacy-project-settings-permissions',
    path: '/plugins/servlet/project-config/:projectKey/permissions'
};

});


parcelRegister("csmia", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsScreensAssociateRouteEntry", () => $4fab0d39d238b176$export$c4a7c46acad95724);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $8rckf = parcelRequire("8rckf");
const $4fab0d39d238b176$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $4fab0d39d238b176$export$c4a7c46acad95724 = (0, $g1GqA.createLegacyEntry)((0, $8rckf.legacyProjectSettingsScreensAssociateRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$4fab0d39d238b176$var$pageEntryPoint
    }));

});
parcelRegister("8rckf", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsScreensAssociateRoute", () => $29f11f1b0a325f75$export$e97df9c9d8af2495);
const $29f11f1b0a325f75$export$e97df9c9d8af2495 = {
    name: 'legacy-project-settings-screens-associate',
    path: '/secure/project/SelectIssueTypeScreenScheme!default.jspa'
};

});


parcelRegister("2yJmz", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsScreensRouteEntry", () => $79a0c3f0474adcbc$export$f0c4185be35123a4);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $e1TnG = parcelRequire("e1TnG");
const $79a0c3f0474adcbc$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $79a0c3f0474adcbc$export$f0c4185be35123a4 = (0, $g1GqA.createLegacyEntry)((0, $e1TnG.legacyProjectSettingsScreensRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$79a0c3f0474adcbc$var$pageEntryPoint
    }));

});
parcelRegister("e1TnG", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsScreensRoute", () => $f4ab0e9821fe40bc$export$a132d85f94cbc75c);
const $f4ab0e9821fe40bc$export$a132d85f94cbc75c = {
    name: 'legacy-project-settings-screens',
    path: '/plugins/servlet/project-config/:projectKey/screens'
};

});


parcelRegister("867Dv", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsSummaryRouteEntry", () => $78b68c00024dafcb$export$b79434e4cc24dab2);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $jOafN = parcelRequire("jOafN");
const $78b68c00024dafcb$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $78b68c00024dafcb$export$b79434e4cc24dab2 = (0, $g1GqA.createLegacyEntry)((0, $jOafN.legacyProjectSettingsSummaryRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$78b68c00024dafcb$var$pageEntryPoint
    }));

});
parcelRegister("jOafN", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsSummaryRoute", () => $1ad12cc5241a958d$export$2c4b88224ff6b238);
const $1ad12cc5241a958d$export$2c4b88224ff6b238 = {
    name: 'legacy-project-settings-summary',
    path: '/plugins/servlet/project-config/:projectKey/summary'
};

});


parcelRegister("irpl4", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsWorkflowsAssociateRouteEntry", () => $d0389a673e37c6e1$export$496170aba3d2c90a);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $7LXdp = parcelRequire("7LXdp");
const $d0389a673e37c6e1$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $d0389a673e37c6e1$export$496170aba3d2c90a = (0, $g1GqA.createLegacyEntry)((0, $7LXdp.legacyProjectSettingsWorkflowsAssociateRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$d0389a673e37c6e1$var$pageEntryPoint
    }));

});
parcelRegister("7LXdp", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsWorkflowsAssociateRoute", () => $e456631c1cdd1ebc$export$c70512e2d6fd53d);
const $e456631c1cdd1ebc$export$c70512e2d6fd53d = {
    name: 'legacy-project-settings-workflows-associate',
    path: '/secure/project/SelectProjectWorkflowScheme!default.jspa'
};

});


parcelRegister("4GDGP", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRouteEntry", () => $97e5e46571b40765$export$a69fefbe6504422d);
/* eslint-disable import/order */ 


var $hdZjx = parcelRequire("hdZjx");

var $i1PT6 = parcelRequire("i1PT6");

var $6RSCO = parcelRequire("6RSCO");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $dUAVJ = parcelRequire("dUAVJ");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $4P0Fw = parcelRequire("4P0Fw");

var $uLFK6 = parcelRequire("uLFK6");
const $97e5e46571b40765$export$a69fefbe6504422d = (0, $g1GqA.createLegacyEntry)((0, $4P0Fw.legacyProjectSettingsWorkflowsRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5),
            sidebarId: (0, $28266b9d90f7c617$export$624732ab55954dd9)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            (0, $i1PT6.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dUAVJ.getNavigationSidebarProjectSettingsResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $uLFK6.ProjectSettingsWorkflows)
    }));

});
parcelRegister("4P0Fw", function(module, exports) {
$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", () => $643899e8d9124880$export$b03606cedffdadf6);
const $643899e8d9124880$export$b03606cedffdadf6 = {
    name: 'legacy-project-settings-workflows',
    path: '/plugins/servlet/project-config/:projectKey/workflows'
};

});

parcelRegister("uLFK6", function(module, exports) {
$parcel$export(module.exports, "ProjectSettingsWorkflows", () => $01e9efc4e0ac5fa6$export$45cb38e9fa0bbddb);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8dMdZ = parcelRequire("8dMdZ");

var $h8QGu = parcelRequire("h8QGu");

var $jgKgn = parcelRequire("jgKgn");

var $9imxF = parcelRequire("9imxF");

var $bgs68 = parcelRequire("bgs68");
const $01e9efc4e0ac5fa6$var$LEGACY_WORKFLOW_DIAGRAM_LINKS_CLASS = 'project-config-workflow-designer-link';
const $01e9efc4e0ac5fa6$var$LEGACY_WORKFLOWS_PANEL_BODY_CLASS = 'project-config-workflow-panel-body';
// This id is the main entry point for the project settings workflows page that can be found in:
// `jira-components/jira-plugins/jira-project-config-plugin/plugin/src/main/resources/jira-project-config-plugin/workflows/templates/workflows-tab.vm#lines-23`
const $01e9efc4e0ac5fa6$var$LEGACY_PROJECT_CONFIG_PANEL_WORKFLOWS_ID = 'project-config-panel-workflows';
const $01e9efc4e0ac5fa6$var$getLegacyWorkflowDiagramLinks = ()=>{
    const workflowDiagramLinksElem = globalThis.document?.getElementsByClassName(`${$01e9efc4e0ac5fa6$var$LEGACY_WORKFLOW_DIAGRAM_LINKS_CLASS}`);
    return [
        ...workflowDiagramLinksElem ?? []
    ];
};
const $01e9efc4e0ac5fa6$var$getLegacyWorkflowsPanelBody = ()=>{
    const workflowsPanel = globalThis.document?.getElementsByClassName(`${$01e9efc4e0ac5fa6$var$LEGACY_WORKFLOWS_PANEL_BODY_CLASS}`);
    const workflowsPanelArray = [
        ...workflowsPanel ?? []
    ];
    return workflowsPanelArray.length > 0 ? workflowsPanelArray[0] : undefined;
};
const $01e9efc4e0ac5fa6$var$getLegacyProjectConfigPanelWorkflows = ()=>{
    return globalThis.document?.getElementById($01e9efc4e0ac5fa6$var$LEGACY_PROJECT_CONFIG_PANEL_WORKFLOWS_ID);
};
const $01e9efc4e0ac5fa6$export$45cb38e9fa0bbddb = (props)=>{
    const [selectedWorkflow, setSelectedWorkflow] = (0, $euxye.useState)(undefined);
    const handleOnClose = (0, $euxye.useCallback)(()=>{
        setSelectedWorkflow(undefined);
    }, [
        setSelectedWorkflow
    ]);
    const getProjectId = ()=>{
        const elm = globalThis.document?.getElementsByClassName('workflow-an-info-container')[0];
        const projectId = elm?.getAttribute('data-project-id');
        return projectId !== null ? projectId : undefined;
    };
    (0, $euxye.useEffect)(()=>{
        let observer = null;
        const handleClicksOnWorkflowDiagramLinks = ()=>{
            const workflowsTable = $01e9efc4e0ac5fa6$var$getLegacyWorkflowsPanelBody();
            if (!workflowsTable) return;
            // Register click handlers to all legacy workflow diagram links
            workflowsTable.addEventListener('click', (event)=>{
                // We only want to handle clicks on the legacy workflow diagram links.
                // by checking the closest ancestor element with the class 'project-config-workflow-designer-link'
                // since the `event.target`can be any element inside the link (span for example)
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const diagramLinkElement = event.target.closest(`.${$01e9efc4e0ac5fa6$var$LEGACY_WORKFLOW_DIAGRAM_LINKS_CLASS}`);
                if (diagramLinkElement) {
                    event.preventDefault();
                    const workflowName = diagramLinkElement?.getAttribute('data-workflowname');
                    if (workflowName) setSelectedWorkflow(workflowName);
                }
            });
        };
        // If there are already legacy workflow diagram links, we register the click handler immediately.
        if ($01e9efc4e0ac5fa6$var$getLegacyWorkflowDiagramLinks().length > 0) handleClicksOnWorkflowDiagramLinks();
        else {
            // We only execute this once, when the LEGACY_PROJECT_CONFIG_PANEL_WORKFLOWS_ID is populated
            // This is because the project settings workflows page is rendered server-side and the links are
            // dynamically added to the DOM after the initial render.
            observer = new MutationObserver(()=>{
                handleClicksOnWorkflowDiagramLinks();
                observer && observer.disconnect();
            });
            const projectConfigPanelWorkflows = $01e9efc4e0ac5fa6$var$getLegacyProjectConfigPanelWorkflows();
            if (projectConfigPanelWorkflows) observer.observe(projectConfigPanelWorkflows, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            $01e9efc4e0ac5fa6$var$getLegacyWorkflowsPanelBody()?.removeEventListener('click', handleClicksOnWorkflowDiagramLinks);
            observer && observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "read-only-workflow-diagram-error-boundary",
        packageName: "jiraRouterRoutesLegacyProjectSettingsWorkflowsEntries",
        teamName: "helix",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jgKgn.LegacyPage), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $bgs68.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $9imxF.default), null, selectedWorkflow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $8dMdZ.default), {
        projectId: getProjectId(),
        workflowIdentifier: {
            workflowName: selectedWorkflow
        },
        onClose: handleOnClose
    })));
};
$01e9efc4e0ac5fa6$export$45cb38e9fa0bbddb.displayName = "ProjectSettingsWorkflows";

});
parcelRegister("bgs68", function(module, exports) {
$parcel$export(module.exports, "default", () => $58f536ba2ba9c7fe$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $jBG83 = parcelRequire("jBG83");

var $u9iDa = parcelRequire("u9iDa");
const $58f536ba2ba9c7fe$var$WORKFLOW_PREVIEW_PLACEHOLDER_ID = 'workflow-modern-preview-placeholder';
const $58f536ba2ba9c7fe$var$AddExistingWorkflowPreview = ()=>{
    const [selectedWorkflow, setSelectedWorkflow] = (0, $euxye.useState)(undefined);
    const getProjectId = ()=>{
        const elm = (0, $u9iDa.getDocument)()?.getElementsByClassName('workflow-an-info-container')[0];
        const projectId = elm?.getAttribute('data-project-id');
        return projectId !== null ? projectId : undefined;
    };
    (0, $euxye.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            const selectedWorkflowToPreview = (0, $u9iDa.getDocument)()?.querySelector('#add-workflow-dialog .project-config-workflow-add-dialog-list .selected');
            if (selectedWorkflowToPreview) {
                const workflowName = selectedWorkflowToPreview.getAttribute('data-workflowname');
                setSelectedWorkflow(workflowName);
            } else setSelectedWorkflow(undefined);
        });
        const body = (0, $u9iDa.getDocument)()?.body;
        if (body) observer.observe(body, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer && observer.disconnect();
        };
    }, []);
    const elm = (0, $u9iDa.getDocument)()?.getElementById($58f536ba2ba9c7fe$var$WORKFLOW_PREVIEW_PLACEHOLDER_ID);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, selectedWorkflow && elm ? /*#__PURE__*/ (0, $85XPu.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jBG83.default), {
        projectId: getProjectId(),
        workflowIdentifier: {
            workflowName: selectedWorkflow
        }
    }), elm) : null);
};
$58f536ba2ba9c7fe$var$AddExistingWorkflowPreview.displayName = "AddExistingWorkflowPreview";
var $58f536ba2ba9c7fe$export$2e2bcd8739ae039 = $58f536ba2ba9c7fe$var$AddExistingWorkflowPreview;

});



parcelRegister("c6bw5", function(module, exports) {
$parcel$export(module.exports, "legacyReportsAverageAgeRouteEntry", () => $88b373ef33f2c8ec$export$dae04c73273ef29a);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $7QdxC = parcelRequire("7QdxC");

var $1RSoW = parcelRequire("1RSoW");
const $88b373ef33f2c8ec$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $88b373ef33f2c8ec$export$dae04c73273ef29a = (0, $g1GqA.createLegacyEntry)((0, $7QdxC.legacyReportsAverageAgeRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $1RSoW.getReportsCommonResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$88b373ef33f2c8ec$var$pageEntryPoint
    }));

});
parcelRegister("7QdxC", function(module, exports) {
$parcel$export(module.exports, "legacyReportsAverageAgeRoute", () => $01fd0a4a907a00b7$export$b40e93dd1042f869);
const $01fd0a4a907a00b7$export$b40e93dd1042f869 = {
    name: 'legacy-reports-average-age-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:averageage-report'
    ]
};

});

parcelRegister("1RSoW", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $32e22c4fb6f3540c$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $32e22c4fb6f3540c$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $32e22c4fb6f3540c$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("4gpLH", function(module, exports) {
$parcel$export(module.exports, "legacyReportsConfigRouteEntry", () => $fb420479ec984692$export$6dee3bbbe4ff04f);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $hto4H = parcelRequire("hto4H");

var $2DHks = parcelRequire("2DHks");
const $fb420479ec984692$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $fb420479ec984692$export$6dee3bbbe4ff04f = (0, $g1GqA.createLegacyEntry)((0, $hto4H.legacyReportsConfigRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $2DHks.getReportsCommonResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$fb420479ec984692$var$pageEntryPoint
    }));

});
parcelRegister("hto4H", function(module, exports) {
$parcel$export(module.exports, "legacyReportsConfigRoute", () => $b0897b38b6e6d754$export$b2ef61435fecef69);
const $b0897b38b6e6d754$export$b2ef61435fecef69 = {
    name: 'legacy-reports-configure',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey'
    ]
};

});

parcelRegister("2DHks", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $401d6546479363fd$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $401d6546479363fd$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $401d6546479363fd$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("ijqNS", function(module, exports) {
$parcel$export(module.exports, "legacyReportsCreatedVsResolvedRouteEntry", () => $b91ef9059e12da7f$export$b2ed165752bdb8e5);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $jwaWa = parcelRequire("jwaWa");

var $aXl05 = parcelRequire("aXl05");
const $b91ef9059e12da7f$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $b91ef9059e12da7f$export$b2ed165752bdb8e5 = (0, $g1GqA.createLegacyEntry)((0, $jwaWa.legacyReportsCreatedVsResolvedRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $aXl05.getReportsCommonResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$b91ef9059e12da7f$var$pageEntryPoint
    }));

});
parcelRegister("jwaWa", function(module, exports) {
$parcel$export(module.exports, "legacyReportsCreatedVsResolvedRoute", () => $ee19e42b71b80539$export$832846047e142646);
const $ee19e42b71b80539$export$832846047e142646 = {
    name: 'legacy-reports-created-vs-resolved-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:createdvsresolved-report'
    ]
};

});

parcelRegister("aXl05", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $8f589bd0262d8709$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $8f589bd0262d8709$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $8f589bd0262d8709$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("9T0hP", function(module, exports) {
$parcel$export(module.exports, "legacyReportsDeveloperWorkloadRouteEntry", () => $8df8c2196009b5bf$export$29e29cddbc430ebe);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $evYdd = parcelRequire("evYdd");

var $bm1Fz = parcelRequire("bm1Fz");
const $8df8c2196009b5bf$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $8df8c2196009b5bf$export$29e29cddbc430ebe = (0, $g1GqA.createLegacyEntry)((0, $evYdd.legacyReportsDeveloperWorkloadRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $bm1Fz.getReportsCommonResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$8df8c2196009b5bf$var$pageEntryPoint
    }));

});
parcelRegister("evYdd", function(module, exports) {
$parcel$export(module.exports, "legacyReportsDeveloperWorkloadRoute", () => $7fdbddf69668499d$export$a64e86bcf65b3432);
const $7fdbddf69668499d$export$a64e86bcf65b3432 = {
    name: 'legacy-reports-developer-workload-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:developer-workload'
    ]
};

});

parcelRegister("bm1Fz", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $79ba78f61449f92a$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $79ba78f61449f92a$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $79ba78f61449f92a$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("ejYph", function(module, exports) {
$parcel$export(module.exports, "legacyReportsPieRouteEntry", () => $ac548d5556ef4a79$export$fd3a1495328fefba);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $2v8GI = parcelRequire("2v8GI");

var $iRE5J = parcelRequire("iRE5J");
const $ac548d5556ef4a79$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $ac548d5556ef4a79$export$fd3a1495328fefba = (0, $g1GqA.createLegacyEntry)((0, $2v8GI.legacyReportsPieRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $iRE5J.getReportsCommonResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$ac548d5556ef4a79$var$pageEntryPoint
    }));

});
parcelRegister("2v8GI", function(module, exports) {
$parcel$export(module.exports, "legacyReportsPieRoute", () => $f3ec90b518b5c280$export$327da6ce208593c2);
const $f3ec90b518b5c280$export$327da6ce208593c2 = {
    name: 'legacy-reports-pie-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:pie-report'
    ]
};

});

parcelRegister("iRE5J", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $6eecb5e9b0af9d35$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $6eecb5e9b0af9d35$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $6eecb5e9b0af9d35$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("cZi34", function(module, exports) {
$parcel$export(module.exports, "legacyReportsRecentlyCreatedRouteEntry", () => $f7c85bf2b0f3498a$export$666b8efa07780ffb);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $jRrqt = parcelRequire("jRrqt");

var $jOUMq = parcelRequire("jOUMq");
const $f7c85bf2b0f3498a$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $f7c85bf2b0f3498a$export$666b8efa07780ffb = (0, $g1GqA.createLegacyEntry)((0, $jRrqt.legacyReportsRecentlyCreatedRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $jOUMq.getReportsCommonResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$f7c85bf2b0f3498a$var$pageEntryPoint
    }));

});
parcelRegister("jRrqt", function(module, exports) {
$parcel$export(module.exports, "legacyReportsRecentlyCreatedRoute", () => $ef38e9ce65583328$export$f81f42a6de9ebb5a);
const $ef38e9ce65583328$export$f81f42a6de9ebb5a = {
    name: 'legacy-reports-recently-created-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:recentlycreated-report'
    ]
};

});

parcelRegister("jOUMq", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $98c4f2dcdf1b3c51$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $98c4f2dcdf1b3c51$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $98c4f2dcdf1b3c51$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("gIdlD", function(module, exports) {
$parcel$export(module.exports, "legacyReportsResolutionTimeRouteEntry", () => $b3c4d98f4dc154bf$export$53c5b89c8f6f5d76);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $hVkVa = parcelRequire("hVkVa");

var $1zoPT = parcelRequire("1zoPT");
const $b3c4d98f4dc154bf$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $b3c4d98f4dc154bf$export$53c5b89c8f6f5d76 = (0, $g1GqA.createLegacyEntry)((0, $hVkVa.legacyReportsResolutionTimeRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $1zoPT.getReportsCommonResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$b3c4d98f4dc154bf$var$pageEntryPoint
    }));

});
parcelRegister("hVkVa", function(module, exports) {
$parcel$export(module.exports, "legacyReportsResolutionTimeRoute", () => $0bb1f100e63d8058$export$c27dcd4a756d7860);
const $0bb1f100e63d8058$export$c27dcd4a756d7860 = {
    name: 'legacy-reports-resolution-time-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:resolutiontime-report'
    ]
};

});

parcelRegister("1zoPT", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $b9d3a65fb38ed93f$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $b9d3a65fb38ed93f$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $b9d3a65fb38ed93f$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("l5KMO", function(module, exports) {
$parcel$export(module.exports, "legacyReportsSingleLevelGroupByRouteEntry", () => $77a127b6ea3ed034$export$80cd34d8b30c9fff);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $1xM8s = parcelRequire("1xM8s");

var $gl1ET = parcelRequire("gl1ET");
const $77a127b6ea3ed034$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $77a127b6ea3ed034$export$80cd34d8b30c9fff = (0, $g1GqA.createLegacyEntry)((0, $1xM8s.legacyReportsSingleLevelGroupByRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $gl1ET.getReportsCommonResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$77a127b6ea3ed034$var$pageEntryPoint
    }));

});
parcelRegister("1xM8s", function(module, exports) {
$parcel$export(module.exports, "legacyReportsSingleLevelGroupByRoute", () => $3de252175d8e63c5$export$4b7de6966d0318ae);
const $3de252175d8e63c5$export$4b7de6966d0318ae = {
    name: 'legacy-reports-single-level-group-by-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:singlelevelgroupby'
    ]
};

});

parcelRegister("gl1ET", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $2f721eb5fd86f154$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $2f721eb5fd86f154$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $2f721eb5fd86f154$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("2JHo8", function(module, exports) {
$parcel$export(module.exports, "legacyReportsTimeSinceRouteEntry", () => $9e6df3c70d0cd134$export$c0837717e37bba3b);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $fQBFi = parcelRequire("fQBFi");

var $ixx6A = parcelRequire("ixx6A");
const $9e6df3c70d0cd134$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $9e6df3c70d0cd134$export$c0837717e37bba3b = (0, $g1GqA.createLegacyEntry)((0, $fQBFi.legacyReportsTimeSinceRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $ixx6A.getReportsCommonResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$9e6df3c70d0cd134$var$pageEntryPoint
    }));

});
parcelRegister("fQBFi", function(module, exports) {
$parcel$export(module.exports, "legacyReportsTimeSinceRoute", () => $915cc2f643e380df$export$e9d8f7977a3e63a8);
const $915cc2f643e380df$export$e9d8f7977a3e63a8 = {
    name: 'legacy-reports-time-since-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:timesince-report'
    ]
};

});

parcelRegister("ixx6A", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $db8c7dcf77999305$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $db8c7dcf77999305$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $db8c7dcf77999305$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("dlYaD", function(module, exports) {
$parcel$export(module.exports, "legacyReportsTimeTrackingReportRouteEntry", () => $84f266339ddd5e9f$export$d911abc03d9aac0e);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $1bmP7 = parcelRequire("1bmP7");

var $7RO6H = parcelRequire("7RO6H");
const $84f266339ddd5e9f$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $84f266339ddd5e9f$export$d911abc03d9aac0e = (0, $g1GqA.createLegacyEntry)((0, $1bmP7.legacyReportsTimeTrackingReportRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $7RO6H.getReportsCommonResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$84f266339ddd5e9f$var$pageEntryPoint
    }));

});
parcelRegister("1bmP7", function(module, exports) {
$parcel$export(module.exports, "legacyReportsTimeTrackingReportRoute", () => $98a3fa2962a44f92$export$5c05df6c5a65a436);
const $98a3fa2962a44f92$export$5c05df6c5a65a436 = {
    name: 'legacy-reports-time-tracking-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:time-tracking'
    ]
};

});

parcelRegister("7RO6H", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $372756df34b9811e$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $372756df34b9811e$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $372756df34b9811e$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("1t5M5", function(module, exports) {
$parcel$export(module.exports, "legacyReportsVersionWorkloadRouteEntry", () => $bf0c7673ba3422fa$export$225a265884367582);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $9e9cs = parcelRequire("9e9cs");

var $cUMlV = parcelRequire("cUMlV");
const $bf0c7673ba3422fa$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $bf0c7673ba3422fa$export$225a265884367582 = (0, $g1GqA.createLegacyEntry)((0, $9e9cs.legacyReportsVersionWorkloadRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $cUMlV.getReportsCommonResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$bf0c7673ba3422fa$var$pageEntryPoint
    }));

});
parcelRegister("9e9cs", function(module, exports) {
$parcel$export(module.exports, "legacyReportsVersionWorkloadRoute", () => $91b7458ffad01945$export$b7a951738ffd54ac);
const $91b7458ffad01945$export$b7a951738ffd54ac = {
    name: 'legacy-reports-version-workload-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'
    ]
};

});

parcelRegister("cUMlV", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $a105d457a66fa4d5$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $a105d457a66fa4d5$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $a105d457a66fa4d5$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("jA4Aa", function(module, exports) {
$parcel$export(module.exports, "legacyReportsWorkloadPieRouteEntry", () => $91500ce5a77fda67$export$371af7520206fe98);
/* eslint-disable import/order */ 

var $hdZjx = parcelRequire("hdZjx");

var $6RSCO = parcelRequire("6RSCO");

var $l8oxB = parcelRequire("l8oxB");

var $dTa0V = parcelRequire("dTa0V");

var $dvtoW = parcelRequire("dvtoW");

var $hFYSn = parcelRequire("hFYSn");

var $4Rvd7 = parcelRequire("4Rvd7");

var $idDnR = parcelRequire("idDnR");

var $g1GqA = parcelRequire("g1GqA");

var $edf7u = parcelRequire("edf7u");

var $hWEkS = parcelRequire("hWEkS");

var $KKi11 = parcelRequire("KKi11");

var $dryZI = parcelRequire("dryZI");
const $91500ce5a77fda67$var$pageEntryPoint = (0, $dTa0V.createPageEntryPoint)({
    main: (0, $l8oxB.legacyPageEntrypoint)
});
const $91500ce5a77fda67$export$371af7520206fe98 = (0, $g1GqA.createLegacyEntry)((0, $KKi11.legacyReportsWorkloadPieRoute), ()=>({
        layout: (0, $dvtoW.genericProjectLayout),
        navigation: {
            menuId: (0, $0c5c27da6f710ef9$export$8f36d687159615f5)
        },
        resources: [
            ...(0, $hdZjx.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
            // A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
            (0, $hWEkS.incidentExperimentTraitResource),
            (0, $edf7u.projectContextResource),
            (0, $hFYSn.forgeProjectModuleResource),
            (0, $idDnR.staticProjectSidebarNavigationResource),
            (0, $4Rvd7.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $dryZI.getReportsCommonResource)(),
            (0, $6RSCO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$91500ce5a77fda67$var$pageEntryPoint
    }));

});
parcelRegister("KKi11", function(module, exports) {
$parcel$export(module.exports, "legacyReportsWorkloadPieRoute", () => $f5f056a658b1b099$export$e8a2e4a5ccbbeff6);
const $f5f056a658b1b099$export$e8a2e4a5ccbbeff6 = {
    name: 'legacy-reports-workload-pie-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.ext.charting:workloadpie-report'
    ]
};

});

parcelRegister("dryZI", function(module, exports) {
$parcel$export(module.exports, "getReportsCommonResource", () => $655966b87cf95b35$export$8cb713295e6b7204);
/* eslint-disable jira/naming/disallow-filenames */ 
var $4l4qP = parcelRequire("4l4qP");

var $5ivqw = parcelRequire("5ivqw");

var $ihrBs = parcelRequire("ihrBs");
const $655966b87cf95b35$export$8cb713295e6b7204 = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $655966b87cf95b35$export$f234446c23dc22a = ()=>[
        (0, $4l4qP.devOpsReportPreconditionResource),
        (0, $ihrBs.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $5ivqw.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("3AkRh", function(module, exports) {
$parcel$export(module.exports, "workflowDesignerRouteEntry", () => $c9b1ccf1319bdd75$export$5863c71049541219);
/* eslint-disable import/order */ 

var $ju22D = parcelRequire("ju22D");

var $hFYSn = parcelRequire("hFYSn");

var $fdS54 = parcelRequire("fdS54");

var $45Itd = parcelRequire("45Itd");

var $dUAVJ = parcelRequire("dUAVJ");

var $ksA2X = parcelRequire("ksA2X");

var $gX17K = parcelRequire("gX17K");
const $c9b1ccf1319bdd75$export$5863c71049541219 = (0, $fdS54.createEntry)((0, $ksA2X.workflowDesignerRoute), ()=>({
        // eslint-disable-next-line no-restricted-syntax
        component: (0, $gX17K.LegacyWorkflowDesigner),
        layout: (0, $ju22D.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $bffa4babd84e5355$export$f298f3c8b46adbeb)
        },
        resources: [
            ...(0, $dUAVJ.getNavigationResources)(),
            (0, $45Itd.navigationSidebarGlobalResource),
            ...(0, $hFYSn.getNavigationSidebarGlobalSettingsResources)()
        ],
        bifrost: {
            bifrostGroup: 'shell-only'
        }
    }));

});
parcelRegister("ksA2X", function(module, exports) {
$parcel$export(module.exports, "workflowDesignerRoute", () => $12034fb887416627$export$7cd61529f5fa5e43);
const $12034fb887416627$export$7cd61529f5fa5e43 = {
    name: 'global-settings-issues-workflows-pages',
    path: '/secure/admin/(workflows/|)(WorkflowDesigner|ViewWorkflowSteps).jspa'
};

});

parcelRegister("gX17K", function(module, exports) {
$parcel$export(module.exports, "LegacyWorkflowDesigner", () => $c3c79c318556f530$export$c264c6032a3fa865);
/* eslint-disable jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $85XPu = parcelRequire("85XPu");

var $fEa2W = parcelRequire("fEa2W");

var $FIgxA = parcelRequire("FIgxA");


var $ju3H4 = parcelRequire("ju3H4");

var $h8QGu = parcelRequire("h8QGu");

var $jgKgn = parcelRequire("jgKgn");

var $u9iDa = parcelRequire("u9iDa");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");

var $hYI7R = parcelRequire("hYI7R");

var $9481P = parcelRequire("9481P");
const $c3c79c318556f530$var$BLACKLISTED_PATHS_REGEX = [
    // This blacklist any URL within the same Legacy workflow editor containing `/secure/admin/workflows/*`
    '^/secure/admin/workflows/.*',
    // This blacklist redirects from the new workflow editor to the legacy workflow editor containing `/jira/settings/issues/workflows/<anyId>`
    '^/jira/settings/issues/workflows/[^/].*'
];
const $c3c79c318556f530$export$6df0153bc79f9d83 = (referrer, hostname)=>{
    if (referrer) {
        const referrerUrl = new URL(referrer);
        if (hostname === referrerUrl.hostname) {
            const referrerPath = referrerUrl.pathname;
            // Check if the referrer path matches any of the blacklisted paths
            const isBlacklisted = $c3c79c318556f530$var$BLACKLISTED_PATHS_REGEX.some((pathRegex)=>{
                const regex = new RegExp(pathRegex);
                return regex.test(referrerPath);
            });
            return !isBlacklisted;
        }
    }
    return false;
};
const $c3c79c318556f530$export$c264c6032a3fa865 = (props)=>{
    const elm = false ? null : globalThis.document?.getElementById('workflow-editor-preference-dropdown');
    const workflowId = elm?.getAttribute('data-workflow-id') ?? '';
    const workflowName = elm?.getAttribute('data-workflow-name') ?? '';
    const editMode = elm?.getAttribute('data-edit-mode') ?? undefined;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const { renderFeedbackDialog: renderFeedbackDialog } = (0, $9481P.useProvideFeedbackDialog)(props);
    (0, $euxye.useEffect)(()=>{
        const referrer = globalThis.document?.referrer || '';
        if ($c3c79c318556f530$export$6df0153bc79f9d83(referrer, globalThis.window.location.hostname)) (0, $FIgxA.getUserWorkflowEditorPreference)().then((preference)=>{
            const defaultEditorPreference = preference !== (0, $f0c9f951cad63fc7$export$83282786ca4b04f) && preference !== (0, $f0c9f951cad63fc7$export$e2f196e116d3fca2) ? 'NONE' : preference;
            (0, $aJ81Y.fireTrackAnalytics)(createAnalyticsEvent({}), 'defaultWorkflowEditor applied', {
                defaultEditor: (0, $f0c9f951cad63fc7$export$e2f196e116d3fca2),
                defaultEditorPreference: defaultEditorPreference
            });
        });
    }, [
        createAnalyticsEvent
    ]);
    (0, $hYI7R.useEffectWithoutConcurrency)(()=>{
        const document = (0, $u9iDa.getDocument)();
        const provideFeedbackElement = document?.getElementById('legacy-workflow-deprecation-banner-provide-feedback-action');
        const switchToNewEditorElement = document?.getElementById('legacy-workflow-deprecation-banner-switch-editor-action');
        if (provideFeedbackElement) provideFeedbackElement.addEventListener('click', (event)=>{
            event.preventDefault();
            renderFeedbackDialog();
        });
        if (switchToNewEditorElement) switchToNewEditorElement.addEventListener('click', (event)=>{
            event.preventDefault();
            if (workflowId) globalThis.window.location.assign((0, $ju3H4.getNewEditorLink)(workflowId));
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $h8QGu.JSErrorBoundary), {
        id: "jsm-dropdown-error-boundary",
        packageName: "jiraRouterRoutesLegacyWorkflowDesignerEntries",
        teamName: "jsd-shield",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jgKgn.LegacyPage), props), elm && /*#__PURE__*/ (0, $85XPu.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $fEa2W.WorkflowEditorPreferenceDropdown), {
        workflowId: workflowId,
        workflowName: workflowName,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        editMode: editMode
    }), elm));
};
$c3c79c318556f530$export$c264c6032a3fa865.displayName = "LegacyWorkflowDesigner";

});
parcelRegister("fEa2W", function(module, exports) {
$parcel$export(module.exports, "WorkflowEditorPreferenceDropdown", () => $5cef34b764ad7026$export$7194565c2a06a25d);
/* WorkflowEditorPreferenceDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $euxye = parcelRequire("euxye");

var $4jQY2 = parcelRequire("4jQY2");

var $ju3H4 = parcelRequire("ju3H4");

var $ld25x = parcelRequire("ld25x");

var $4qNCE = parcelRequire("4qNCE");

var $jaPl6 = parcelRequire("jaPl6");

var $2YPKP = parcelRequire("2YPKP");

var $2Xkyn = parcelRequire("2Xkyn");

var $7eNDO = parcelRequire("7eNDO");
var $1YIbA = parcelRequire("1YIbA");

var $aJ81Y = parcelRequire("aJ81Y");
var $inMxE = parcelRequire("inMxE");
const $5cef34b764ad7026$var$openInNewEditor = (0, $7eNDO.defineMessage)({
    id: "workflow-editor-preference-settings.open-in-new-editor",
    defaultMessage: "Open workflow in new editor"
});
const $5cef34b764ad7026$var$switchEditorButton = (0, $7eNDO.defineMessage)({
    id: "workflow-editor-preference-settings.switch-editor-button",
    defaultMessage: "Switch editor"
});
const $5cef34b764ad7026$export$7194565c2a06a25d = ({ workflowId: workflowId, editMode: editMode })=>{
    const { formatMessage: formatMessage } = (0, $1YIbA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inMxE.useAnalyticsEvents)();
    const fireTrackEvent = (0, $euxye.useCallback)((mode)=>{
        const dropdownItemClickEvent = createAnalyticsEvent({
            action: 'click',
            actionSubject: 'dropdownItem'
        });
        (0, $aJ81Y.fireUIAnalytics)(dropdownItemClickEvent, 'workflowEditorToolbarNewEditorLink', {
            workflowLegacyEditMode: mode === 'draft' ? 'Draft' : 'Live'
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jaPl6.default), {
        testId: "workflow-editor-preference-settings.dropdown-menu",
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $4qNCE.default), {
                ...props,
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ld25x))), {
                    label: "",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($5cef34b764ad7026$var$LegacyButtonText, null, formatMessage($5cef34b764ad7026$var$switchEditorButton))),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2Xkyn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $2YPKP.default), {
        href: (0, $ju3H4.getNewEditorLink)(workflowId),
        onClick: ()=>fireTrackEvent(editMode),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage($5cef34b764ad7026$var$openInNewEditor)))));
};
$5cef34b764ad7026$export$7194565c2a06a25d.displayName = "WorkflowEditorPreferenceDropdown";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5cef34b764ad7026$var$LegacyButtonText = /*#__PURE__*/ (0, $euxye.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $4jQY2.default)([
            "_k48pi7a9",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ju3H4", function(module, exports) {
$parcel$export(module.exports, "getLegacyEditorLink", () => $dc8aae621e3ed359$export$ff5bc033c9b0efb4);
$parcel$export(module.exports, "getNewEditorLink", () => $dc8aae621e3ed359$export$540456165b615498);
$parcel$export(module.exports, "findRuleDefinitionForConfiguredRule", () => $dc8aae621e3ed359$export$5abcac058edd2986);

var $bS1iz = parcelRequire("bS1iz");
const $dc8aae621e3ed359$export$ff5bc033c9b0efb4 = (workflowName)=>`/secure/admin/workflows/WorkflowDesigner.jspa?workflowMode=live&wfName=${encodeURIComponent(workflowName)}`;
const $dc8aae621e3ed359$export$b94e7e81739daa7e = (workflowName)=>`/secure/admin/workflows/WorkflowDesigner.jspa?${(0, (/*@__PURE__*/$parcel$interopDefault($bS1iz))).stringify({
        workflowMode: 'draft',
        wfName: workflowName
    })}`;
const $dc8aae621e3ed359$export$540456165b615498 = (workflowId)=>`/jira/settings/issues/workflows/${workflowId}`;
const $dc8aae621e3ed359$export$5abcac058edd2986 = (rule, availableRules)=>{
    const ruleKey = rule.ruleKey;
    if (ruleKey.startsWith('connect')) return availableRules.find((definition)=>definition.variety === 'connect' && definition.key === ruleKey && definition.id === rule.config.appKey);
    if (ruleKey.startsWith('forge')) return availableRules.find((definition)=>definition.variety === 'forge' && definition.key === ruleKey && definition.id === rule.config.key);
    return availableRules.find((definition)=>definition.key === ruleKey);
};

});
parcelRegister("bS1iz", function(module, exports) {
$parcel$export(module.exports, "extract", () => $8a45beb58c2751cb$export$f9380c9a627682d3, (v) => $8a45beb58c2751cb$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $8a45beb58c2751cb$export$98e6a39c04603d36, (v) => $8a45beb58c2751cb$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $8a45beb58c2751cb$export$fac44ee5b035f737, (v) => $8a45beb58c2751cb$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $8a45beb58c2751cb$export$7a5253c0f62e0150, (v) => $8a45beb58c2751cb$export$7a5253c0f62e0150 = v);
var $8a45beb58c2751cb$export$f9380c9a627682d3;
var $8a45beb58c2751cb$export$98e6a39c04603d36;
var $8a45beb58c2751cb$export$fac44ee5b035f737;
var $8a45beb58c2751cb$export$7a5253c0f62e0150;
'use strict';

var $cgILL = parcelRequire("cgILL");

var $gjoqw = parcelRequire("gjoqw");

var $e9Lvx = parcelRequire("e9Lvx");
function $8a45beb58c2751cb$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $8a45beb58c2751cb$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $8a45beb58c2751cb$var$encode(key, opts),
                    '[',
                    $8a45beb58c2751cb$var$encode(index, opts),
                    ']=',
                    $8a45beb58c2751cb$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $8a45beb58c2751cb$var$encode(key, opts) : [
                    $8a45beb58c2751cb$var$encode(key, opts),
                    '[]=',
                    $8a45beb58c2751cb$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $8a45beb58c2751cb$var$encode(key, opts) : [
                    $8a45beb58c2751cb$var$encode(key, opts),
                    '=',
                    $8a45beb58c2751cb$var$encode(value, opts)
                ].join('');
            };
    }
}
function $8a45beb58c2751cb$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $8a45beb58c2751cb$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $cgILL(value) : encodeURIComponent(value);
    return value;
}
function $8a45beb58c2751cb$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $8a45beb58c2751cb$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $8a45beb58c2751cb$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $8a45beb58c2751cb$var$parse(str, opts) {
    opts = $gjoqw({
        arrayFormat: 'none'
    }, opts);
    var formatter = $8a45beb58c2751cb$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $e9Lvx(val);
        formatter($e9Lvx(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $8a45beb58c2751cb$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$8a45beb58c2751cb$export$f9380c9a627682d3 = $8a45beb58c2751cb$var$extract;
$8a45beb58c2751cb$export$98e6a39c04603d36 = $8a45beb58c2751cb$var$parse;
$8a45beb58c2751cb$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $gjoqw(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $8a45beb58c2751cb$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $8a45beb58c2751cb$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $8a45beb58c2751cb$var$encode(key, opts) + '=' + $8a45beb58c2751cb$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$8a45beb58c2751cb$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $8a45beb58c2751cb$var$parse($8a45beb58c2751cb$var$extract(str), opts)
    };
};

});
parcelRegister("cgILL", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("gjoqw", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $be015e5147a1edd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $be015e5147a1edd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $be015e5147a1edd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $be015e5147a1edd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $be015e5147a1edd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $be015e5147a1edd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $be015e5147a1edd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($be015e5147a1edd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($be015e5147a1edd6$var$getOwnPropertySymbols) {
            symbols = $be015e5147a1edd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($be015e5147a1edd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});




parcelRegister("FIgxA", function(module, exports) {
$parcel$export(module.exports, "getUserWorkflowEditorPreference", () => $bc3a95cffbf12c2a$export$d9664e16e2fb1f27);

var $h2wCv = parcelRequire("h2wCv");
const $bc3a95cffbf12c2a$var$workflowEditorPreferenceKey = 'jira.user.workflow.editor.global.scope.enrolment';
const $bc3a95cffbf12c2a$var$WORKFLOW_EDITOR_PREFERENCE_QUERY = `
query WorkflowEditorPreferenceQuery {
    myPreferences(keys: [
        "${$bc3a95cffbf12c2a$var$workflowEditorPreferenceKey}"
    ])
}
`;
const $bc3a95cffbf12c2a$export$d9664e16e2fb1f27 = async ()=>{
    const apiResult = await (0, $h2wCv.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $bc3a95cffbf12c2a$var$WORKFLOW_EDITOR_PREFERENCE_QUERY
        })
    });
    const preferences = apiResult?.data?.myPreferences;
    if (preferences) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return preferences[`${$bc3a95cffbf12c2a$var$workflowEditorPreferenceKey}`];
    const errorResponse = apiResult?.errors;
    if (errorResponse) throw new Error(`Error getting user preference: ${$bc3a95cffbf12c2a$var$workflowEditorPreferenceKey}`, {
        cause: apiResult?.errors?.[0] ?? 'unknown'
    });
    return null;
};

});

const $f0c9f951cad63fc7$export$83282786ca4b04f = 'NEW';
const $f0c9f951cad63fc7$export$e2f196e116d3fca2 = 'LEGACY';

parcelRegister("9481P", function(module, exports) {
$parcel$export(module.exports, "useProvideFeedbackDialog", () => $ff1fe45fa588037b$export$49c741bba31b2dfa);

var $euxye = parcelRequire("euxye");

var $fcq2N = parcelRequire("fcq2N");

var $4vPP5 = parcelRequire("4vPP5");

var $kt86l = parcelRequire("kt86l");

var $fNgVF = parcelRequire("fNgVF");

var $15E7V = parcelRequire("15E7V");

var $7RVVN = parcelRequire("7RVVN");
const $ff1fe45fa588037b$var$unknownAttributeValue = 'unknown';
const $ff1fe45fa588037b$var$FEEDBACK_GROUP_ID = 'workflow-editor-opt-out';
const $ff1fe45fa588037b$export$b028e515f8f652e0 = ({ isAdmin: isAdmin, routeName: routeName, projectType: projectType, cloudId: cloudId })=>[
        {
            id: (0, $15E7V.EntryKeys).LOCATION,
            value: (0, $7RVVN.default)(globalThis.window?.location.href)
        },
        {
            id: (0, $15E7V.EntryKeys).REFERER,
            value: globalThis.document?.referrer ? (0, $7RVVN.default)(globalThis.document?.referrer) : ''
        },
        {
            id: (0, $15E7V.EntryKeys).USER_AGENT,
            value: globalThis.navigator?.userAgent
        },
        {
            id: (0, $15E7V.EntryKeys).SCREEN_RESOLUTION,
            value: `${globalThis.window?.screen?.width} x ${globalThis.window?.screen?.height}`
        },
        {
            id: (0, $15E7V.EntryKeys).ROUTE_NAME,
            value: routeName
        },
        {
            id: (0, $15E7V.EntryKeys).IS_ADMIN,
            value: isAdmin.toString()
        },
        {
            id: (0, $15E7V.EntryKeys).PROJECT_TYPE,
            value: projectType
        },
        {
            id: 'cloud-id',
            value: cloudId
        }
    ];
const $ff1fe45fa588037b$export$49c741bba31b2dfa = (routeContext)=>{
    const { openFeedbackCollector: openFeedbackCollector } = (0, $4vPP5.useFeedbackCollectorActions)();
    const cloudId = (0, $kt86l.useCloudId)();
    const isAdmin = (0, $fNgVF.useIsAdmin)();
    const routeName = routeContext.route.name ?? $ff1fe45fa588037b$var$unknownAttributeValue;
    const renderFeedbackDialog = (0, $euxye.useCallback)(()=>{
        openFeedbackCollector({
            entrypointId: (0, $15E7V.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: $ff1fe45fa588037b$var$FEEDBACK_GROUP_ID,
            onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
            feedbackContext: $ff1fe45fa588037b$export$b028e515f8f652e0({
                isAdmin: isAdmin,
                cloudId: cloudId,
                routeName: routeName,
                projectType: $ff1fe45fa588037b$var$unknownAttributeValue
            })
        });
    }, [
        openFeedbackCollector,
        isAdmin,
        cloudId,
        routeName
    ]);
    return {
        renderFeedbackDialog: renderFeedbackDialog
    };
};

});
parcelRegister("4vPP5", function(module, exports) {
$parcel$export(module.exports, "useFeedbackCollector", () => $b1330a514455a06a$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $b1330a514455a06a$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $b1330a514455a06a$export$c35dbf16ebe9df04);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $5QDqc = parcelRequire("5QDqc");
var $iGu4q = parcelRequire("iGu4q");
const $b1330a514455a06a$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    canBeContactedLink: undefined,
    enrolInResearchLink: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    onCancel: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined,
    customFeedbackOptions: []
};
const $b1330a514455a06a$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($b1330a514455a06a$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$b1330a514455a06a$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $b1330a514455a06a$var$Store = (0, $5QDqc.createStore)({
    name: 'feedback-collector',
    initialState: $b1330a514455a06a$export$d4c72bab9d6cc13a,
    actions: $b1330a514455a06a$export$e324594224ef24da
});
const $b1330a514455a06a$export$4be696be8a3bff13 = (0, $3h1FP.createHook)($b1330a514455a06a$var$Store);
const $b1330a514455a06a$export$dfb2ee2d9e73fa48 = (0, $3h1FP.createActionsHook)($b1330a514455a06a$var$Store);
const $b1330a514455a06a$export$c35dbf16ebe9df04 = (0, $iGu4q.createSubscriber)($b1330a514455a06a$var$Store, {
    selector: null
});

});

parcelRegister("15E7V", function(module, exports) {
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $5a20651f769fa2ff$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_GIC_AI_FIELD_SUGGESTIONS", () => $5a20651f769fa2ff$export$ef62c5d355c31b59);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $5a20651f769fa2ff$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $5a20651f769fa2ff$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $5a20651f769fa2ff$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $5a20651f769fa2ff$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $5a20651f769fa2ff$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $5a20651f769fa2ff$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $5a20651f769fa2ff$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_JIRA_SPACE_CREATE", () => $5a20651f769fa2ff$export$9bde170c20aeb12e);
$parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", () => $5a20651f769fa2ff$export$5bd148c13bb23f7a);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $5a20651f769fa2ff$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $5a20651f769fa2ff$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $5a20651f769fa2ff$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", () => $5a20651f769fa2ff$export$23f6d7b16d2210c1);
$parcel$export(module.exports, "ENTRYPOINT_ID_PROJECT_BACKGROUNDS", () => $5a20651f769fa2ff$export$9a234699f0515bf);
$parcel$export(module.exports, "ENTRY_POINT_ID_JOURNEY_BUILDER", () => $5a20651f769fa2ff$export$f24169c529e6c9b5);
$parcel$export(module.exports, "ENTRY_POINT_ID_PLAYBOOKS", () => $5a20651f769fa2ff$export$68dc647ed5ef59d9);
$parcel$export(module.exports, "ENTRY_POINT_ID_BULK_OPERATIONS", () => $5a20651f769fa2ff$export$f849b75576b691b);
$parcel$export(module.exports, "ENTRY_POINT_ID_BULK_OPERATIONS_MERGE_PANEL", () => $5a20651f769fa2ff$export$3f171ed85802673d);
$parcel$export(module.exports, "ENTRY_POINT_ID_ADMIN_ONBOARDING_HUB", () => $5a20651f769fa2ff$export$c0e3a1d9aa18e8eb);
$parcel$export(module.exports, "ENTRY_POINT_ID_AI_CONTEXT_RESOLUTION_PLAN_PANEL", () => $5a20651f769fa2ff$export$7f190c8f7bc2242);
$parcel$export(module.exports, "ENTRY_POINT_ID_INDIVIDUAL_CAPACITY_PLANNING", () => $5a20651f769fa2ff$export$8df25926ec47a767);
$parcel$export(module.exports, "ENTRY_POINT_ID_HORIZONTAL_NAV", () => $5a20651f769fa2ff$export$88efeb072ad93ff7);
$parcel$export(module.exports, "EntryKeys", () => $5a20651f769fa2ff$export$12d01b6c311a909a);
/* eslint-disable jira/filename-case */ // Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $5a20651f769fa2ff$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $5a20651f769fa2ff$export$ef62c5d355c31b59 = '5d198c09-f525-4eb1-8e33-f277c4050a8e';
const $5a20651f769fa2ff$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $5a20651f769fa2ff$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $5a20651f769fa2ff$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $5a20651f769fa2ff$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $5a20651f769fa2ff$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $5a20651f769fa2ff$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $5a20651f769fa2ff$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $5a20651f769fa2ff$export$9bde170c20aeb12e = '4cd73d76-ada3-4ecc-8060-ba3113b3e96c';
const $5a20651f769fa2ff$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
const $5a20651f769fa2ff$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $5a20651f769fa2ff$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $5a20651f769fa2ff$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $5a20651f769fa2ff$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $5a20651f769fa2ff$export$86e0eeb08f5b7ea6 = 'ee8a71e7-85aa-4121-b455-e6316922e894';
const $5a20651f769fa2ff$export$9a234699f0515bf = 'd0f0863a-fe78-4d40-b4f0-451c268594cc';
const $5a20651f769fa2ff$export$f24169c529e6c9b5 = 'd5f62dde-d505-413b-a417-c2dd6979cac2';
const $5a20651f769fa2ff$export$68dc647ed5ef59d9 = 'e578a125-130e-4762-9556-2acb236a12cc';
const $5a20651f769fa2ff$export$f849b75576b691b = '106df6fd-feed-4aa7-bbf7-5ca2bec6266b';
const $5a20651f769fa2ff$export$3f171ed85802673d = 'c1880d75-c7ba-40e6-850f-1355c8ac2b22';
const $5a20651f769fa2ff$export$c0e3a1d9aa18e8eb = '7620f432-f831-4711-8e09-3aa379bf2d96';
const $5a20651f769fa2ff$export$7f190c8f7bc2242 = 'a8c2aa57-6975-4ed7-80c6-42f46f0bdf91';
const $5a20651f769fa2ff$export$8df25926ec47a767 = 'aab1458f-e9f0-49e0-b86e-b191e9186a4a';
const $5a20651f769fa2ff$export$88efeb072ad93ff7 = '9c1d7477-03c3-4266-8f32-44c536b4d4b4';
const $5a20651f769fa2ff$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment',
    SMART_REPLIES: 'smart-replies',
    PROJECT_RECAP_FEEDBACK_GROUP_ID: 'jira-notifications-project-recap',
    STANDUPS: 'standups'
});

});




parcelRegister("5MNay", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7d9f9308b5ec621$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ const $a7d9f9308b5ec621$var$applyLazyOpts = (route)=>{
    if ('lazyOpts' in route && typeof route.lazyOpts === 'function') {
        const hydratedRoute = {
            ...route,
            ...route.lazyOpts()
        };
        delete hydratedRoute.lazyOpts;
        return hydratedRoute;
    }
    return route;
};
var $a7d9f9308b5ec621$export$2e2bcd8739ae039 = $a7d9f9308b5ec621$var$applyLazyOpts;

});


parcelRegister("6FMwd", function(module, exports) {
$parcel$export(module.exports, "getSpaRouterContext", () => $a03b7ddcb3c6e652$export$1f61c5e3f6410afa);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $a03b7ddcb3c6e652$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
        tenantContext: tenantContext
    });

});

parcelRegister("4yT7h", function(module, exports) {
$parcel$export(module.exports, "visualRefreshResolverOverride", () => $e0f517953b143f18$export$73a94df81a7c0f2c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $e0f517953b143f18$var$visualRefreshPlatformFlags = [
    'platform-component-visual-refresh'
];
const $e0f517953b143f18$export$73a94df81a7c0f2c = [
    (flagKey)=>$e0f517953b143f18$var$visualRefreshPlatformFlags.includes(flagKey),
    ()=>true
];

});

parcelRegister("6PkDY", function(module, exports) {

var $4cvLQ = parcelRequire("4cvLQ");




module.exports = Promise.all([
    (parcelRequire("gZgW8"))('navx_onboarding_universal_create_in_jira', function() {
        return Promise.all([
            $4cvLQ("27fFF")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("hJyTq")
        ]);
    }),
    (parcelRequire("gZgW8"))('navx-global-side-nav', function() {
        return Promise.all([
            $4cvLQ("7FBcr"),
            $4cvLQ("4Smn9"),
            $4cvLQ("hc93Z")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("54wGu"),
            $4cvLQ("4Smn9"),
            $4cvLQ("hc93Z")
        ]);
    }),
    (parcelRequire("gZgW8"))('dfo-snippet-renderer-sync', function() {
        return Promise.all([
            $4cvLQ("1bHwn")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("fN8aQ")
        ]);
    }),
    (parcelRequire("gZgW8"))('navx-global-side-nav', function() {
        return Promise.all([
            $4cvLQ("7FBcr"),
            $4cvLQ("4Smn9"),
            $4cvLQ("hc93Z")
        ]);
    }, function() {
        return Promise.all([
            $4cvLQ("54wGu"),
            $4cvLQ("4Smn9"),
            $4cvLQ("hc93Z")
        ]);
    }),
    $4cvLQ("a36Wj"),
    $4cvLQ("elvlF"),
    $4cvLQ("5qC72"),
    $4cvLQ("faPKS"),
    $4cvLQ("1aRRK"),
    $4cvLQ("iZe2c"),
    $4cvLQ("7yq2G")
]).then(()=>parcelRequire('6plLD'));

});



parcelRegister("d0GZJ", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $3MtiC = parcelRequire("3MtiC");
module.exports = Object.assign({}, $3MtiC, {
    themed: (propsToValues)=>(props)=>{
            const vals = typeof propsToValues === 'function' ? propsToValues(props) : propsToValues;
            return vals.light;
        }
});
if ($3MtiC.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

$parcel$global.rwr("jGfII", () => { /* eslint-disable jira/filename-case */ // eslint-disable-next-line jira/entry/add-jira-vendor-imports
parcelRequire("lzmuA");
parcelRequire("2IWJd");

var $iFcSu = parcelRequire("iFcSu");

var $1sMLb = parcelRequire("1sMLb");
(0, $1sMLb.default).install();
(0, $iFcSu.provideHealthcheck)();
 }, ["5qC72","elvlF","a36Wj","ay8Nt","f15cT","iDHjd","4Smn9","hc93Z","gCScl","15ZAZ","eAoL3","1aRRK","faPKS","iZe2c","hjlm9"]);

$parcel$global.rlb("jGfII")
//# sourceMappingURL=global-single-fragment.ef07707a.js.map
